/*
  LoadingScreen.js — hard-load overlay, mounted before main.js's
  orchestrator runs. Loops a metallic 9-card <-> skull flip
  (ported from a Meta-generated SVG build, path data preserved
  verbatim - only the wrapper/gating logic is new) until the site's
  real assets are ready, then fades out cleanly.

  Usage:
    import { showLoadingScreen, resolveLoad } from './components/LoadingScreen.js';
    showLoadingScreen(); // call first, before anything else paints
    // ... later, once hero image + fonts are ready:
    resolveLoad();

  Gating contract: resolveLoad() does NOT cut the animation off
  mid-flip - it sets a flag, and the currently-running CSS flip
  cycle is allowed to reach its next natural rest point before the
  overlay fades out. This avoids a jarring stop mid-rotation.
*/

const FRONT_SVG = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1600.000000pt" height="2400.000000pt" viewBox="0 0 1600.000000 2400.000000"
 preserveAspectRatio="xMidYMid meet">
<defs>
  <linearGradient id="metal9" x1="0%" y1="0%" x2="100%" y2="20%" gradientUnits="objectBoundingBox">
    <stop offset="0%" stop-color="#E9EBEE"/>
    <stop offset="18%" stop-color="#BFC4CC"/>
    <stop offset="38%" stop-color="#DDE0E5"/>
    <stop offset="56%" stop-color="#9AA0AA"/>
    <stop offset="74%" stop-color="#E6E8EB"/>
    <stop offset="88%" stop-color="#8A8F99"/>
    <stop offset="100%" stop-color="#C2C6CD"/>
  </linearGradient>
</defs>

<g transform="translate(0.000000,2400.000000) scale(0.100000,-0.100000)"
fill="url(#metal9)" stroke="none">
<path d="M3550 20683 c-20 -23 -20 -23 -308 -23 -276 0 -288 -1 -300 -20 -9
-16 -23 -20 -62 -20 -28 0 -50 -4 -50 -9 0 -11 -55 -31 -86 -31 -15 0 -40 -18
-70 -50 -26 -27 -61 -54 -78 -58 -37 -11 -136 -108 -136 -134 0 -10 -15 -35
-33 -55 -18 -21 -39 -53 -47 -71 -7 -18 -26 -43 -41 -57 -21 -17 -29 -33 -29
-57 0 -18 -9 -48 -20 -65 -11 -18 -17 -39 -14 -47 3 -7 -6 -23 -20 -34 -30
-23 -30 -24 -26 -276 2 -159 2 -159 31 -190 30 -32 36 -55 20 -71 -5 -6 -11
-86 -13 -180 -3 -135 -7 -177 -21 -204 -15 -31 -17 -96 -16 -770 0 -406 -3
-745 -6 -754 -4 -9 1 -23 14 -34 25 -21 27 -39 5 -51 -21 -12 -21 -62 0 -74
20 -11 21 -37 1 -44 -21 -8 -17 -884 4 -923 20 -36 16 -567 -4 -598 -20 -30
-22 -332 -2 -351 16 -17 26 -309 14 -412 -5 -41 -7 -119 -4 -172 4 -76 2 -100
-9 -109 -21 -17 -20 -274 2 -317 13 -28 15 -91 16 -456 0 -397 -1 -426 -18
-456 -14 -25 -16 -34 -6 -37 14 -6 16 -49 2 -58 -14 -9 -14 -1305 0 -1305 6 0
10 -11 10 -25 0 -14 -5 -25 -10 -25 -7 0 -10 -179 -10 -535 0 -295 -3 -541 -7
-548 -10 -16 -4 -577 7 -597 5 -8 5 -22 0 -30 -18 -33 -7 -904 12 -916 11 -7
10 -54 -2 -54 -14 0 -14 -737 0 -745 13 -8 13 -132 -1 -140 -5 -4 -11 -35 -11
-68 0 -48 -1 -673 -1 -742 0 -8 0 -111 0 -227 -2 -752 1 -881 23 -926 11 -23
25 -40 29 -38 16 11 30 123 26 211 -2 50 -7 147 -10 217 -3 69 -1 175 4 235
11 127 16 749 8 1043 -14 504 -18 1155 -7 1190 20 61 28 169 19 243 -13 105
-8 113 46 81 35 -20 48 -23 64 -15 32 18 41 13 41 -22 0 -32 26 -57 60 -57 21
0 9 37 -15 48 -29 13 -33 45 -10 69 29 28 1 43 -76 41 -76 -3 -87 3 -95 53 -4
26 0 43 20 72 31 45 32 53 6 67 -10 6 -25 28 -31 50 -11 35 -10 42 6 60 23 25
35 22 55 -16 10 -17 27 -30 40 -32 13 -2 42 -19 65 -37 22 -18 52 -36 68 -40
32 -8 42 -38 33 -90 -6 -29 -2 -44 21 -80 32 -51 48 -52 48 -4 0 46 12 62 42
55 43 -11 46 5 6 43 -21 20 -49 52 -62 72 -13 20 -39 46 -58 59 -19 13 -38 32
-44 42 -5 10 -16 18 -24 18 -8 0 -22 12 -32 28 -24 37 -34 43 -62 38 -21 -3
-77 10 -91 21 -3 3 -6 41 -8 86 -5 114 -5 124 -3 377 1 124 1 243 -1 265 -1
22 1 87 5 144 4 71 1 131 -8 185 -16 94 -16 78 -17 999 -1 468 2 711 9 718 13
13 27 -97 18 -144 -5 -24 -2 -37 9 -47 10 -8 14 -20 10 -32 -3 -11 1 -27 9
-36 9 -9 20 -29 26 -45 17 -43 26 -32 26 31 0 38 -6 65 -18 82 -26 37 -22 80
9 105 20 16 27 31 28 60 1 39 1 39 -43 47 -25 4 -48 13 -53 20 -15 22 2 140
27 185 21 38 21 43 7 57 -14 14 -14 22 -4 60 9 36 9 54 -3 93 -16 55 -19 107
-9 175 5 34 2 52 -9 69 -10 14 -14 33 -10 50 3 17 0 35 -7 44 -7 9 -14 52 -15
108 -2 50 -7 150 -10 220 -8 144 0 172 36 127 31 -38 61 -112 55 -134 -3 -11
2 -28 11 -38 10 -11 17 -43 20 -85 5 -71 13 -90 33 -78 7 5 10 20 6 40 -11 59
41 72 59 14 8 -25 42 -25 50 0 8 26 -4 71 -27 100 -10 13 -16 32 -13 42 4 10
-2 25 -14 36 -11 11 -34 48 -51 83 -17 36 -38 76 -45 90 -8 14 -15 44 -15 66
0 25 -6 47 -15 54 -8 7 -15 25 -15 41 0 15 -8 36 -19 46 -16 16 -18 39 -20
248 -2 127 -3 259 -4 295 -2 65 -2 65 38 70 38 5 40 7 46 45 3 22 10 50 17 62
7 12 12 30 12 41 0 32 27 48 48 28 31 -27 44 -20 40 22 -2 30 -7 38 -26 40
-13 2 -25 -3 -28 -12 -10 -26 -42 -18 -59 13 -8 17 -24 36 -34 43 -24 17 -47
65 -36 76 4 4 10 1 12 -5 6 -16 39 -17 48 -2 4 6 -2 13 -13 16 -50 13 -58 45
-66 247 -5 112 -13 207 -22 235 -17 55 -19 242 -3 258 8 8 8 13 0 17 -19 12
-13 74 8 86 30 15 41 12 41 -12 0 -13 7 -36 15 -51 9 -18 12 -43 9 -70 -5 -37
-2 -45 25 -71 34 -32 44 -86 16 -86 -8 0 -15 -2 -15 -4 0 -12 31 -76 40 -81 5
-3 10 -15 10 -26 0 -12 12 -27 30 -37 40 -23 37 -54 -7 -67 -36 -10 -45 -35
-14 -35 22 0 31 -18 31 -63 0 -18 7 -41 15 -51 8 -11 15 -33 15 -48 0 -16 17
-61 38 -100 72 -137 76 -142 102 -110 18 21 22 22 62 11 53 -14 58 -21 58 -85
0 -28 3 -54 7 -57 14 -14 33 17 33 54 0 58 -16 88 -54 104 -45 19 -93 79 -111
138 -8 28 -26 57 -43 72 -35 29 -62 109 -43 128 18 18 42 -2 75 -62 33 -62 45
-57 53 24 6 58 6 58 -45 105 -46 43 -52 52 -52 89 0 23 -4 49 -10 59 -5 9 -19
41 -31 70 -16 38 -33 60 -63 80 -40 27 -41 30 -52 107 -13 91 -31 146 -51 158
-10 6 -13 19 -8 46 5 32 2 43 -22 71 -28 34 -28 34 -26 184 1 83 2 167 2 186
-4 727 -3 940 7 950 15 15 60 -12 69 -41 4 -10 16 -24 27 -30 18 -10 20 -9 14
7 -4 11 -10 35 -13 54 -3 19 -12 39 -20 43 -8 5 -13 28 -13 66 0 41 -5 65 -18
82 -45 59 -66 207 -37 257 16 26 16 31 1 60 -18 35 -22 156 -7 210 7 24 6 51
-6 97 -14 59 -14 66 1 89 12 19 14 31 6 51 -6 15 -10 77 -11 138 0 62 -4 164
-8 227 -13 206 15 497 32 334 3 -33 14 -69 25 -84 29 -39 35 -65 17 -80 -13
-11 -14 -15 -2 -29 8 -9 18 -34 22 -55 4 -28 20 -53 50 -83 43 -44 43 -44 41
-192 -1 -107 -5 -152 -14 -164 -18 -21 -1 -76 38 -120 15 -18 33 -43 39 -56 7
-13 16 -19 21 -15 10 11 40 129 40 159 0 12 8 33 19 46 18 23 18 23 92 -3 41
-14 86 -29 101 -32 53 -12 78 -69 83 -187 5 -129 17 -217 33 -246 6 -12 17
-44 23 -72 6 -28 17 -58 26 -66 21 -21 53 -19 53 4 0 10 7 24 15 31 9 7 13 20
10 30 -5 15 -15 327 -15 473 0 70 -15 75 -23 7 -13 -108 -37 -83 -37 38 0 79
1 83 26 94 23 11 28 9 44 -12 25 -33 36 -19 43 56 9 89 11 88 -194 79 -197 -8
-223 -13 -227 -42 -2 -11 -16 -33 -33 -48 -16 -16 -29 -35 -29 -42 0 -18 -44
-37 -65 -29 -17 6 -13 60 6 80 12 14 11 70 -2 83 -11 11 -13 55 -4 124 10 70
-14 141 -51 151 -46 12 -64 44 -64 115 0 57 -3 65 -29 89 -16 14 -32 36 -35
49 -3 12 -15 25 -26 28 -37 9 -23 77 16 77 29 0 30 13 3 56 -11 19 -19 44 -18
56 2 13 -3 33 -10 46 -17 32 -4 182 20 230 11 20 19 45 19 56 0 63 122 244
205 303 22 15 52 43 68 61 16 17 34 32 40 32 6 0 29 8 51 19 129 59 187 68
543 76 218 5 285 3 357 -10 49 -8 91 -15 95 -15 3 0 -2 -5 -11 -11 -27 -15
-22 -37 12 -54 42 -22 55 -50 35 -77 -23 -34 -18 -53 20 -82 19 -15 35 -35 35
-44 0 -9 7 -28 15 -42 8 -14 18 -34 24 -46 12 -27 73 -36 156 -25 35 5 64 5
70 0 18 -17 40 -9 66 24 27 33 27 33 -1 64 -15 17 -41 37 -56 45 -25 12 -29
19 -28 51 1 34 -1 37 -28 37 -29 0 -29 0 -22 -60 6 -58 6 -60 -16 -60 -13 0
-38 11 -56 25 -18 14 -37 25 -42 25 -28 0 -104 92 -88 107 3 3 32 -4 64 -16
68 -24 122 -28 122 -8 0 15 -41 37 -70 37 -10 0 -38 18 -62 40 -23 22 -60 45
-80 52 -49 15 -48 25 4 39 40 10 71 9 199 -7 29 -4 58 -1 81 9 29 12 58 13
174 5 95 -7 172 -7 244 0 58 6 137 9 175 7 39 -3 338 -7 665 -10 528 -5 927
-9 1162 -14 78 -1 78 -1 104 -42 23 -37 24 -44 13 -72 -7 -16 -13 -44 -13 -61
-1 -24 -6 -32 -23 -34 -24 -4 -30 -16 -13 -27 18 -11 10 -25 -15 -25 -31 0
-34 -29 -6 -54 22 -20 41 -14 41 13 0 25 17 37 62 45 35 6 38 5 53 -26 38 -80
56 -107 73 -112 10 -4 28 -20 41 -36 12 -17 26 -28 32 -25 15 10 11 55 -6 61
-8 4 -15 18 -15 33 0 45 -79 145 -132 169 -17 7 -28 19 -28 31 0 83 86 62 136
-33 16 -30 38 -59 49 -64 49 -23 115 -94 125 -135 12 -50 40 -107 52 -107 4 0
8 13 8 29 0 15 5 42 11 60 9 26 8 35 -4 49 -8 9 -19 34 -22 55 -5 26 -19 50
-42 70 -80 72 -104 98 -112 120 -18 46 -80 77 -159 80 -48 1 -72 6 -72 14 0
31 47 36 345 36 106 0 129 0 240 -2 28 -1 181 -1 340 -1 944 -1 965 -2 965
-47 0 -24 44 -113 56 -113 6 0 17 7 24 15 18 21 47 19 60 -5 16 -30 28 -24 35
20 4 22 11 42 16 46 19 11 -4 25 -40 23 -41 -3 -131 19 -131 32 0 26 50 30
333 24 161 -3 301 -6 312 -6 11 -1 189 2 396 5 334 7 381 6 415 -9 21 -9 49
-13 61 -10 18 4 33 -5 69 -42 67 -70 78 -88 65 -112 -21 -38 -12 -59 51 -115
64 -58 73 -63 83 -46 11 17 61 11 80 -10 22 -24 63 -26 72 -4 3 8 23 22 44 31
46 18 48 25 14 43 -22 12 -27 11 -46 -6 -19 -17 -23 -17 -47 -3 -22 12 -29 25
-35 68 -7 43 -16 60 -49 92 -22 21 -49 39 -61 39 -11 0 -34 9 -51 19 -17 11
-50 24 -73 30 -30 8 -41 16 -37 26 9 23 24 24 309 25 149 0 333 1 410 1 77 1
228 -1 335 -5 244 -9 212 -9 459 -7 132 1 226 -2 253 -9 31 -9 65 -9 133 -1
49 6 113 14 140 17 81 10 683 4 765 -7 41 -6 85 -17 97 -25 12 -8 35 -14 50
-14 15 0 42 -9 58 -20 17 -11 36 -20 44 -20 13 0 101 -67 131 -100 8 -9 23
-21 32 -26 29 -16 148 -175 148 -197 0 -12 9 -37 20 -55 11 -18 20 -47 20 -64
0 -17 7 -39 15 -48 15 -16 39 -208 37 -295 -3 -167 -5 -374 -4 -500 1 -82 1
-168 0 -190 -1 -22 4 -122 12 -222 12 -165 12 -185 -3 -220 -9 -21 -17 -47
-19 -58 -4 -26 -42 -31 -73 -11 -13 9 -37 16 -53 16 -33 0 -102 26 -102 38 0
5 -13 22 -30 39 -16 16 -34 42 -39 56 -8 20 -18 27 -36 27 -26 0 -33 -18 -14
-37 18 -18 1 -33 -38 -33 -33 0 -35 2 -29 26 7 28 -14 53 -45 54 -30 0 -29
-28 1 -50 23 -16 30 -29 30 -54 0 -20 8 -40 19 -50 18 -16 21 -16 44 -1 41 27
94 5 157 -66 52 -57 80 -73 80 -45 0 7 -7 19 -15 26 -8 7 -12 16 -9 21 9 16
40 10 59 -11 10 -11 23 -20 29 -20 15 -1 60 -41 80 -73 15 -21 15 -32 6 -67
-13 -47 -14 -117 -5 -250 7 -95 7 -121 6 -195 0 -22 -1 -83 -1 -135 0 -52 -1
-131 -3 -175 -1 -44 3 -107 10 -139 8 -40 9 -66 2 -78 -14 -27 -55 -23 -76 8
-13 21 -22 25 -47 21 -73 -12 -121 -30 -142 -52 -13 -14 -30 -25 -38 -25 -8 0
-27 -7 -43 -14 -15 -8 -36 -17 -46 -21 -16 -4 -18 -11 -12 -48 9 -55 31 -79
49 -55 20 27 86 29 86 3 0 -8 -14 -17 -35 -21 -44 -8 -47 -34 -5 -64 46 -32
40 -79 -13 -99 -15 -6 -27 -14 -27 -18 0 -13 60 -41 101 -47 23 -4 46 -18 66
-41 35 -39 57 -44 73 -16 15 29 12 61 -5 61 -23 0 -18 28 10 54 35 33 34 74
-2 81 -45 10 -58 20 -61 50 -6 46 6 71 59 125 47 48 52 51 72 37 18 -12 23
-28 30 -93 4 -44 7 -86 6 -94 0 -8 -3 -82 -5 -165 -2 -82 -9 -159 -15 -171 -8
-15 -7 -33 1 -63 10 -36 9 -46 -5 -61 -14 -16 -14 -20 2 -47 15 -27 15 -35 3
-72 -10 -32 -11 -47 -1 -67 16 -35 7 -44 -43 -44 -25 0 -49 -6 -55 -14 -6 -7
-25 -16 -41 -20 -26 -5 -50 -30 -39 -40 21 -19 68 -14 93 9 15 14 38 25 51 25
28 0 31 -8 39 -116 5 -61 3 -75 -14 -97 -23 -29 -26 -53 -7 -60 8 -2 12 -32
12 -98 0 -52 4 -122 9 -156 8 -61 8 -63 -17 -72 -37 -14 -40 -27 -12 -45 14
-9 25 -25 25 -35 0 -52 -23 -62 -87 -39 -31 11 -45 28 -23 28 11 0 13 33 4 68
-9 33 -21 27 -49 -27 -13 -27 -29 -52 -34 -55 -14 -9 -41 22 -41 45 0 32 -19
59 -40 59 -13 0 -20 7 -20 19 0 17 10 21 80 27 94 8 109 21 85 76 -7 19 -21
40 -29 47 -8 7 -18 26 -21 42 -4 16 -11 31 -16 35 -5 3 -16 21 -24 40 -8 19
-21 34 -29 34 -8 0 -28 17 -43 38 -15 20 -34 43 -40 50 -7 7 -13 21 -13 29 0
9 -7 24 -15 33 -9 10 -17 30 -18 46 -2 25 2 29 25 32 62 7 55 42 -12 59 -30 7
-39 18 -64 66 -15 32 -30 77 -33 100 -3 23 -13 51 -22 62 -10 11 -22 32 -28
47 -7 14 -21 29 -32 33 -22 7 -29 35 -9 35 6 0 19 -7 29 -16 9 -8 27 -14 38
-12 20 3 20 3 1 47 -29 64 -26 96 9 111 24 9 34 9 57 -3 40 -21 105 -92 138
-149 23 -41 56 -64 56 -40 0 4 4 13 9 21 12 18 41 -2 41 -27 0 -8 11 -30 26
-49 31 -40 70 -44 96 -9 17 23 17 25 -7 40 -14 9 -48 52 -77 96 -53 82 -66 91
-88 65 -11 -13 -19 -10 -60 23 -47 36 -53 45 -84 110 -17 36 -43 41 -90 17
-40 -21 -45 -13 -28 52 10 41 12 66 5 84 -8 20 -6 33 5 52 14 23 14 27 -6 52
-12 15 -22 35 -22 43 0 23 -49 102 -63 102 -7 0 -19 5 -27 10 -13 9 -13 11 0
20 26 17 78 12 93 -10 18 -25 67 -45 67 -26 0 7 -9 21 -20 31 -25 22 -25 41
-2 54 16 10 16 12 -2 26 -21 16 -59 3 -85 -29 -12 -14 -16 -14 -43 2 -44 25
-51 45 -27 76 16 21 18 29 9 47 -9 17 -7 31 10 71 14 32 19 60 15 76 -6 25 -6
25 -123 18 -94 -5 -123 -3 -146 9 -39 21 -46 19 -46 -11 0 -34 45 -88 79 -94
30 -6 39 -43 40 -167 1 -39 6 -75 11 -78 6 -4 17 -21 24 -40 18 -42 35 -51
116 -59 104 -10 116 -52 18 -62 -24 -3 -59 -10 -78 -15 -33 -10 -39 -8 -68 19
-18 17 -32 37 -32 46 0 9 -8 24 -18 34 -10 10 -22 27 -26 38 -6 14 -10 15 -13
5 -8 -19 17 -93 37 -111 37 -34 50 -71 59 -165 8 -97 8 -97 57 -146 26 -27 56
-49 65 -49 9 0 24 -9 34 -20 10 -11 24 -20 31 -20 7 0 16 -5 19 -10 10 -16 -5
-50 -22 -50 -16 0 -99 35 -165 71 -21 11 -43 17 -49 13 -16 -10 -4 -82 18
-106 15 -16 18 -38 19 -112 1 -232 28 -316 101 -316 45 0 73 -16 73 -40 0 -17
-7 -20 -39 -20 -22 0 -46 -6 -53 -13 -13 -14 -52 -37 -61 -37 -16 0 -56 115
-61 175 -5 46 -13 77 -25 90 -10 11 -21 28 -25 38 -9 26 -30 15 -34 -17 -2
-18 3 -35 16 -46 14 -13 22 -38 26 -84 4 -35 13 -70 21 -76 7 -6 19 -46 26
-90 12 -77 29 -101 43 -64 5 12 10 14 19 5 25 -20 40 -95 39 -190 -1 -108 12
-145 55 -156 15 -3 35 -13 45 -22 9 -8 28 -13 45 -11 28 4 28 4 -3 17 -20 8
-34 23 -42 45 -18 49 -15 56 22 56 37 0 90 -37 101 -69 4 -12 19 -21 47 -25
57 -9 78 -23 78 -51 0 -36 11 -56 36 -65 17 -7 23 -18 26 -47 3 -36 5 -38 43
-41 22 -2 45 -8 52 -14 7 -6 20 -7 30 -4 11 5 24 -2 38 -20 22 -27 22 -27 33
4 13 39 45 43 67 8 12 -18 14 -30 6 -44 -7 -13 -7 -39 1 -84 12 -73 2 -135
-23 -151 -30 -19 -113 55 -124 111 -6 34 -45 68 -68 59 -8 -3 -24 -24 -35 -48
-23 -47 -15 -74 19 -64 27 9 57 -3 64 -25 4 -11 12 -17 20 -14 8 3 30 -10 51
-30 20 -20 42 -36 49 -36 35 0 56 -61 35 -101 -25 -45 -60 -9 -60 61 0 34 -3
41 -16 36 -9 -3 -29 -6 -45 -6 -32 0 -39 -19 -15 -40 12 -9 13 -17 4 -36 -10
-22 -8 -28 23 -54 22 -19 46 -29 66 -30 17 0 35 -6 40 -12 4 -7 8 -74 9 -148
0 -74 4 -159 8 -187 6 -36 5 -62 -4 -83 -10 -23 -10 -33 -1 -44 13 -15 18
-306 7 -325 -4 -6 -25 -8 -52 -4 -35 4 -49 2 -64 -12 -31 -28 -45 -7 -34 47 7
32 14 44 29 46 13 2 26 15 33 35 12 31 11 33 -39 80 -53 49 -65 55 -71 36 -2
-7 -16 -4 -38 8 -19 10 -36 19 -38 19 -2 1 0 13 4 28 7 31 21 32 63 9 29 -17
31 -17 50 2 19 19 20 23 5 72 -8 28 -22 57 -30 63 -8 7 -14 32 -15 59 -2 96
-23 119 -73 80 -21 -16 -26 -27 -22 -45 4 -14 2 -24 -4 -24 -5 0 -10 7 -10 15
0 8 -4 15 -10 15 -5 0 -26 18 -46 40 -39 42 -61 50 -70 25 -4 -9 -19 -15 -36
-15 -27 0 -29 2 -23 33 4 23 0 38 -15 56 -21 24 -21 24 -46 0 -21 -20 -28 -21
-44 -11 -11 7 -20 8 -20 3 0 -6 5 -13 10 -16 19 -12 10 -25 -19 -25 -24 0 -34
9 -66 60 -29 47 -41 58 -51 49 -7 -6 -28 -9 -46 -7 -29 3 -33 0 -33 -22 0 -20
5 -25 25 -24 14 1 28 -4 32 -10 11 -16 10 -100 -2 -112 -5 -5 -12 -35 -16 -66
-6 -52 -5 -57 17 -69 13 -7 40 -14 59 -15 19 0 42 -4 51 -8 26 -11 33 23 11
48 -23 25 -46 91 -37 106 17 27 97 -5 133 -52 7 -10 17 -18 22 -18 5 0 26 -10
47 -22 21 -13 64 -30 96 -39 56 -16 59 -16 70 2 12 20 52 26 61 10 4 -5 -10
-33 -29 -62 -19 -30 -35 -61 -35 -71 0 -42 -76 -31 -85 12 -5 21 -16 32 -52
45 -54 21 -65 11 -49 -40 9 -29 16 -35 39 -35 16 0 39 -11 57 -29 17 -16 46
-32 65 -35 43 -8 50 -19 30 -50 -24 -36 -16 -47 98 -139 24 -18 29 -30 29 -68
1 -62 -5 -69 -62 -69 -39 0 -52 -4 -60 -20 -7 -12 -21 -20 -38 -20 -22 0 -29
-6 -38 -35 -12 -39 2 -62 32 -51 9 3 29 -2 45 -11 28 -17 31 -17 65 2 36 19
36 19 54 -3 29 -35 33 -9 5 32 -24 35 -24 39 -10 66 18 35 15 34 61 15 35 -14
37 -14 74 17 22 17 38 38 37 47 -1 9 3 16 8 16 6 0 9 -8 8 -18 -2 -10 2 -27 7
-37 7 -14 6 -29 -7 -54 -13 -29 -14 -40 -5 -61 16 -35 16 -277 0 -293 -8 -8
-8 -15 -1 -24 7 -8 11 -120 12 -315 2 -351 1 -352 -81 -318 -15 6 -18 2 -18
-23 0 -36 15 -49 60 -54 35 -3 35 -3 41 -62 13 -120 -14 -203 -46 -140 -14 28
-36 54 -45 54 -16 0 -41 -51 -35 -71 4 -11 24 -31 46 -45 75 -47 79 -54 79
-152 0 -48 -5 -93 -10 -98 -7 -7 -6 -20 3 -40 11 -22 14 -84 13 -253 -1 -224
-1 -224 -41 -235 -46 -13 -55 -44 -17 -61 12 -5 22 -17 22 -25 0 -8 8 -28 17
-45 17 -30 20 -138 15 -680 0 -60 0 -168 0 -240 1 -211 -2 -475 -5 -475 -18 0
-90 47 -121 79 -38 39 -39 41 -33 94 6 44 3 59 -12 78 -10 13 -20 43 -23 65
-6 43 -43 104 -64 104 -6 0 -17 -7 -24 -15 -18 -22 -29 -18 -36 12 -4 15 -25
45 -46 68 -44 46 -56 79 -39 108 11 16 9 23 -13 46 -19 19 -26 38 -26 65 0 26
-8 48 -25 68 -16 19 -23 37 -20 49 4 10 3 39 -1 64 -7 49 -30 60 -69 31 -16
-12 -25 -10 -69 12 -71 35 -90 74 -43 91 17 6 22 16 22 42 0 31 3 34 31 37 27
3 40 -6 100 -68 38 -39 75 -85 82 -103 8 -18 15 -34 17 -35 7 -8 121 22 137
36 35 29 55 7 64 -71 13 -111 13 -110 -26 -121 -19 -5 -59 -10 -88 -10 -50 -1
-63 -8 -42 -21 6 -3 10 -28 10 -55 0 -46 3 -53 55 -105 30 -30 59 -55 64 -55
17 0 -1 39 -20 45 -14 5 -19 16 -19 41 0 53 15 74 54 74 22 0 39 8 55 26 17
20 28 24 48 19 20 -5 32 1 60 30 50 52 42 71 -30 67 -62 -4 -82 12 -59 49 19
30 14 49 -18 67 -21 12 -28 22 -24 35 6 20 -14 88 -30 100 -19 13 48 -5 71
-19 12 -8 29 -14 37 -14 20 0 30 38 15 56 -10 12 -9 17 6 28 20 14 18 40 -10
117 -15 43 -20 47 -56 53 -49 8 -49 14 0 64 31 31 36 42 24 46 -38 15 -98 -1
-116 -30 -12 -22 -27 -16 -27 9 0 13 -5 28 -11 34 -8 8 -8 17 0 31 6 11 11 36
11 55 0 30 -4 37 -31 46 -59 21 -107 8 -63 -17 24 -13 8 -32 -27 -32 -57 0
-21 -55 75 -112 38 -23 46 -33 46 -57 0 -20 8 -35 23 -46 20 -15 21 -17 5 -26
-10 -5 -18 -17 -18 -24 0 -11 -11 -15 -38 -15 -51 0 -81 -20 -58 -39 9 -8 16
-19 16 -26 0 -8 12 -28 27 -45 29 -35 19 -54 -24 -47 -15 3 -28 -3 -38 -19
-24 -37 -55 -32 -55 9 -1 17 -7 50 -15 72 -8 22 -15 48 -15 58 0 18 31 88 52
119 10 14 9 20 -4 30 -9 7 -19 34 -22 60 -6 42 -11 49 -51 72 -50 30 -65 32
-65 10 0 -23 -54 -14 -58 9 -3 16 1 18 27 12 27 -6 31 -4 31 14 0 11 -4 23
-10 26 -20 12 -10 35 15 35 28 0 31 4 40 74 6 47 7 48 35 42 42 -8 57 12 54
69 -1 26 -4 48 -6 49 -2 1 -31 20 -65 41 -46 30 -63 47 -67 68 -3 16 -14 36
-25 45 -20 18 -46 106 -36 123 10 16 35 10 35 -9 0 -10 15 -33 34 -51 19 -18
32 -40 29 -47 -8 -22 26 -28 47 -9 24 22 32 16 64 -49 34 -69 46 -79 80 -66
33 12 33 30 1 68 -14 17 -25 35 -25 40 0 6 -7 15 -16 20 -8 5 -20 28 -25 51
-7 33 -23 56 -65 97 -37 36 -54 59 -50 69 3 8 9 22 12 31 5 10 -10 31 -45 65
-28 27 -51 53 -51 58 0 5 -22 18 -49 30 -28 11 -52 25 -55 29 -3 5 -2 48 1 96
6 79 9 89 36 116 42 41 77 41 77 0 0 -19 7 -33 21 -40 31 -17 6 -38 -49 -42
-45 -3 -47 -4 -47 -33 0 -25 5 -31 25 -33 55 -6 71 -14 114 -55 25 -23 57 -50
71 -60 27 -19 33 -55 13 -76 -11 -11 -10 -13 1 -9 8 2 20 20 26 39 13 38 35
48 55 24 13 -15 16 -82 8 -150 -3 -26 1 -30 34 -40 55 -15 67 -31 35 -46 -46
-21 -44 -84 4 -110 12 -6 30 -31 41 -56 15 -34 23 -43 36 -38 9 4 25 10 35 12
23 7 28 34 23 108 -8 108 -23 178 -40 190 -9 7 -16 24 -16 39 0 38 -24 80 -54
94 -15 7 -26 20 -26 31 0 13 -11 23 -34 31 -48 15 -86 54 -86 85 0 15 -18 57
-40 95 -41 71 -53 130 -25 130 26 0 34 32 18 70 -12 30 -16 33 -24 18 -15 -28
-33 -21 -54 19 -11 20 -30 49 -42 64 -12 14 -27 38 -32 52 -9 23 -15 26 -41
21 -27 -6 -31 -3 -45 29 -20 48 -20 49 15 69 17 9 35 30 42 45 6 15 24 42 39
58 17 20 29 46 33 77 7 55 11 53 -112 63 -79 7 -95 -3 -73 -44 8 -14 8 -60 1
-163 -19 -239 -19 -236 21 -269 24 -20 45 -29 72 -29 48 0 77 -15 77 -40 0
-22 -2 -22 -100 -20 -49 1 -70 6 -86 21 -11 10 -25 19 -31 19 -14 0 -23 24
-23 58 0 19 -3 23 -11 15 -16 -16 -8 -348 9 -365 9 -10 12 -4 12 28 1 157 18
227 41 168 14 -38 8 -219 -9 -236 -16 -16 -15 -49 3 -72 10 -13 15 -43 15 -83
0 -76 19 -94 54 -50 24 29 69 37 83 13 4 -7 23 -21 41 -30 31 -16 33 -20 30
-64 -4 -62 -35 -71 -61 -17 -22 47 -51 46 -128 -2 -59 -38 -59 -38 -57 -82 4
-54 23 -65 33 -19 18 82 35 50 35 -67 0 -96 7 -135 21 -135 6 0 26 -8 47 -17
20 -9 60 -21 87 -27 48 -11 50 -12 50 -46 0 -26 -4 -34 -15 -30 -35 10 -150
11 -169 0 -20 -10 -21 -19 -21 -141 0 -80 5 -139 12 -152 18 -34 80 -98 108
-111 68 -32 101 -59 98 -80 -5 -33 -66 -34 -102 -1 -15 14 -33 25 -41 25 -7 0
-21 7 -29 15 -8 9 -32 22 -53 29 -29 10 -39 20 -46 46 -8 33 -8 33 -29 12 -30
-30 -37 -195 -7 -177 5 4 9 19 9 35 0 33 9 60 19 60 24 0 32 -62 30 -251 -2
-198 -2 -198 27 -233 25 -30 35 -35 74 -35 54 -1 73 -12 68 -37 -2 -14 -15
-21 -48 -25 -25 -3 -61 -9 -81 -13 -32 -7 -38 -4 -67 29 -29 32 -32 42 -33
103 0 55 -2 62 -10 42 -6 -13 -17 -33 -26 -42 -14 -16 -14 -20 -1 -35 8 -10
23 -48 32 -85 13 -47 28 -77 50 -100 31 -32 33 -39 45 -156 17 -154 31 -172
140 -170 58 2 74 -9 69 -43 -3 -24 -5 -24 -108 -24 -121 0 -113 12 -91 -140 7
-52 8 -112 2 -170 -8 -89 -1 -135 19 -135 6 0 23 -9 38 -19 15 -10 49 -22 77
-25 36 -5 55 -13 70 -31 15 -18 28 -24 50 -21 33 4 33 5 21 53 -9 37 -9 37
-38 22 -31 -17 -65 -3 -93 38 -33 49 -32 63 4 63 49 0 48 29 -3 75 -47 44 -61
80 -54 146 3 31 6 34 38 37 19 2 39 10 43 18 10 17 39 18 55 2 20 -20 14 -44
-15 -57 -28 -13 -28 -13 -5 -28 17 -12 22 -25 22 -62 0 -83 28 -121 90 -121
25 0 26 -13 1 -31 -36 -26 -36 -57 1 -73 47 -21 73 -46 97 -95 12 -23 37 -51
56 -62 53 -32 56 -89 5 -89 -10 0 -20 -6 -23 -13 -6 -17 -74 -38 -95 -30 -10
4 -30 17 -45 30 -51 42 -77 28 -77 -43 0 -23 9 -44 28 -66 28 -30 30 -31 53
-15 30 21 66 22 87 1 14 -15 17 -15 27 0 7 9 17 16 24 16 16 0 14 -25 -5 -40
-23 -20 -14 -63 19 -78 38 -18 39 -74 1 -98 -19 -13 -28 -14 -37 -5 -18 18
-29 13 -25 -11 2 -16 15 -27 48 -39 46 -17 65 -39 33 -39 -50 0 -86 -73 -52
-107 7 -7 15 -29 18 -50 6 -38 6 -38 71 -44 36 -3 72 -9 80 -12 9 -4 24 -1 34
6 18 13 17 15 -7 61 -14 26 -28 42 -32 37 -14 -24 -46 -11 -61 26 -21 49 -11
187 15 206 12 9 17 29 19 72 1 33 4 103 8 155 5 87 4 97 -15 122 -12 14 -21
35 -21 45 0 11 -11 34 -25 53 -14 19 -25 44 -25 56 0 12 -7 35 -15 50 -8 16
-15 36 -15 45 0 21 -41 128 -74 194 -30 60 -31 64 -7 93 19 22 19 22 73 -12
29 -19 63 -45 75 -57 12 -13 28 -19 37 -16 22 9 20 28 -4 34 -11 3 -20 9 -20
14 0 19 19 15 69 -15 47 -29 56 -40 74 -92 20 -56 21 -77 19 -414 0 -195 -5
-389 -9 -430 -6 -57 -5 -80 6 -98 7 -12 13 -41 13 -65 0 -23 -1 -119 -1 -214
0 -165 0 -172 -21 -183 -20 -11 -21 -13 -5 -36 25 -39 40 -206 22 -258 -9 -25
-11 -50 -6 -63 6 -17 13 -396 10 -544 -2 -58 -19 -73 -64 -54 -31 13 -37 20
-37 45 0 22 -5 30 -18 30 -27 0 -50 21 -58 53 -6 24 -4 27 21 27 46 0 68 18
61 51 -4 21 1 36 19 58 31 36 31 40 -5 75 -37 36 -60 29 -60 -19 0 -30 -5 -39
-33 -55 -39 -23 -64 -63 -73 -117 -5 -35 -3 -41 20 -57 21 -13 25 -22 20 -42
-5 -20 0 -31 29 -58 28 -25 34 -37 30 -59 -4 -20 2 -33 25 -57 43 -43 66 -40
81 11 24 81 33 27 36 -232 2 -140 2 -262 -1 -272 -5 -15 -13 -17 -53 -11 -34
4 -51 2 -56 -6 -10 -17 13 -30 52 -30 60 0 63 -14 63 -311 0 -145 3 -313 5
-374 7 -148 0 -166 -66 -158 -40 5 -49 3 -49 -9 0 -24 29 -42 68 -43 33 0 37
-3 44 -35 8 -35 0 -629 -9 -642 -2 -5 -17 -8 -32 -8 -29 0 -49 -17 -71 -59
-14 -28 2 -53 22 -33 19 19 66 15 77 -7 7 -11 12 -167 14 -392 3 -255 8 -383
16 -403 9 -23 9 -36 -1 -60 -16 -38 -16 -248 0 -395 6 -63 7 -111 2 -121 -6
-10 -5 -31 1 -53 11 -39 -19 -249 -38 -268 -11 -11 -113 79 -113 99 0 26 -45
42 -98 35 -62 -7 -72 -32 -21 -53 17 -7 37 -23 46 -36 8 -13 25 -26 36 -30 12
-4 33 -15 46 -25 13 -11 37 -19 52 -19 26 0 29 -4 29 -31 0 -27 -42 -115 -61
-129 -4 -3 -14 -21 -22 -41 -12 -30 -56 -80 -174 -202 -38 -38 -68 -57 -93
-57 -16 0 -33 -6 -37 -13 -9 -14 -70 -37 -101 -37 -11 0 -23 -4 -26 -8 -3 -5
-107 -9 -232 -10 -195 -1 -231 1 -255 15 -23 14 -30 14 -43 4 -10 -9 -43 -12
-101 -11 -100 3 -136 2 -268 -6 -77 -4 -103 -2 -121 9 -19 13 -26 13 -56 1
-26 -11 -41 -12 -67 -3 -19 6 -47 9 -61 6 -15 -3 -39 1 -54 9 -16 8 -42 21
-59 30 -28 15 -32 15 -51 -3 -25 -22 -133 -20 -160 4 -14 13 -19 13 -40 0 -23
-15 -105 -31 -143 -28 -11 1 -64 1 -117 0 -82 -1 -102 2 -125 19 -16 11 -38
23 -50 26 -13 4 -30 15 -39 23 -31 31 -104 34 -151 7 -25 -15 -57 -24 -82 -24
-31 0 -46 -6 -63 -25 -20 -23 -25 -24 -97 -18 -42 3 -83 12 -92 19 -22 19 -37
17 -44 -6 -8 -26 -29 -25 -47 1 -18 27 -55 18 -68 -17 -10 -25 -24 -31 -35
-14 -10 15 -36 12 -58 -8 -16 -14 -45 -18 -166 -22 -196 -7 -189 -24 11 -28
122 -2 154 -6 161 -17 11 -21 29 -19 50 5 22 26 49 25 73 -3 19 -22 25 -22
161 -20 137 2 142 3 167 28 14 14 26 37 26 50 0 14 3 25 8 26 4 0 42 2 84 5
78 3 78 3 105 -31 17 -21 37 -35 50 -35 13 0 28 -9 35 -20 12 -18 24 -20 120
-20 60 0 110 4 113 10 9 15 43 12 71 -7 21 -13 33 -15 63 -7 21 6 46 7 57 3
10 -4 33 -8 51 -8 17 -1 38 -8 47 -16 20 -21 112 -21 120 0 7 19 35 19 42 0 5
-13 81 -15 600 -15 346 0 594 4 594 9 0 14 58 31 106 31 31 0 50 6 64 20 11
11 30 20 41 20 12 0 27 7 34 16 6 9 24 18 39 19 15 2 33 11 40 20 7 10 32 19
59 22 37 4 56 14 81 39 19 19 43 34 54 34 25 0 92 66 92 91 0 10 15 36 33 56
51 58 121 207 114 242 -4 21 2 44 19 78 24 45 27 61 33 230 4 125 10 186 19
195 16 16 15 128 -2 151 -11 14 -14 161 -15 808 0 434 -4 795 -8 802 -4 7 -6
38 -5 70 2 34 -2 64 -8 73 -21 24 -25 140 -7 168 9 13 16 32 17 42 1 11 4 94
8 186 5 112 11 171 20 180 16 16 18 888 1 905 -17 17 -31 101 -28 178 2 74 2
179 -3 470 -3 170 -2 183 19 225 27 52 29 101 8 134 -14 21 -16 158 -16 1167
0 629 -1 1245 -2 1369 -1 124 1 268 5 320 3 52 2 129 -3 170 -12 87 -12 116
-1 262 4 63 12 112 20 120 20 20 17 441 -4 473 -14 21 -15 87 -10 602 2 321 1
623 -4 678 -18 195 -8 461 18 487 14 14 17 134 4 142 -5 3 -12 163 -16 357 -6
309 -5 354 8 375 21 30 21 132 1 158 -8 11 -15 34 -15 50 0 17 -9 45 -20 61
-24 36 -25 63 -6 91 18 25 16 -3 25 319 4 143 4 305 0 360 -4 55 -8 278 -8
496 0 335 -3 400 -16 425 -20 39 -19 71 2 83 17 9 18 47 18 568 0 307 -1 587
-3 623 -3 84 7 157 24 171 19 15 20 209 2 227 -10 10 -14 106 -15 400 -3 530
-7 613 -26 643 -8 13 -15 45 -16 71 0 31 -10 64 -30 101 -18 33 -28 63 -24 76
3 12 -2 27 -11 36 -9 9 -16 25 -16 35 0 11 -16 34 -35 52 -20 17 -39 44 -43
59 -8 31 -177 209 -198 209 -8 0 -14 9 -14 20 0 14 -10 22 -39 30 -21 5 -44
17 -51 25 -7 8 -21 15 -31 15 -9 0 -24 7 -33 15 -8 8 -25 15 -39 15 -32 0 -87
20 -87 31 0 5 -22 9 -50 9 -39 0 -53 4 -62 20 -12 19 -24 20 -281 20 -225 0
-271 -2 -283 -15 -17 -16 -43 -18 -282 -19 -136 -1 -153 1 -158 16 -5 16 -41
18 -507 20 -493 3 -502 3 -522 -17 -21 -21 -25 -21 -242 -16 -17 1 -38 8 -47
16 -17 17 -141 21 -151 5 -3 -5 -17 -10 -30 -10 -13 0 -27 5 -30 10 -8 13
-225 13 -225 1 0 -29 -158 -32 -168 -2 -6 18 -1727 15 -1756 -4 -20 -13 -25
-13 -42 0 -27 21 -180 21 -200 0 -20 -19 -58 -19 -78 0 -12 13 -54 15 -265 14
-138 0 -251 -4 -251 -9 0 -13 -59 -30 -105 -30 -44 0 -105 17 -105 29 0 4 -43
8 -95 9 -54 1 -95 -2 -95 -7 0 -24 -79 -34 -264 -32 -199 1 -298 11 -304 30
-6 18 -379 15 -397 -3 -32 -31 -607 -32 -639 -1 -15 15 -461 21 -470 6 -7 -11
-135 -11 -142 0 -7 12 -104 12 -104 0 0 -27 -78 -32 -570 -31 -505 0 -505 0
-522 22 -23 32 -81 32 -108 1z m6788 -345 c26 -26 14 -41 -29 -35 -45 6 -65
19 -55 36 10 15 69 14 84 -1z m2730 -3344 c-4 -23 -26 -30 -34 -10 -8 20 15
51 29 37 5 -5 7 -17 5 -27z m-40 -457 c24 4 32 2 32 -10 0 -15 -38 -87 -45
-87 -7 0 -55 94 -55 108 0 13 2 13 18 0 11 -10 28 -14 50 -11z m112 -263 c0
-16 -26 -19 -35 -4 -4 6 -4 18 -1 27 7 18 36 0 36 -23z m100 -206 c0 -12 -38
-10 -45 2 -4 6 -4 18 -1 26 5 12 9 12 26 -3 11 -10 20 -21 20 -25z m-121 -29
c62 18 69 15 76 -31 12 -72 33 -99 72 -92 28 5 34 3 44 -20 7 -14 16 -26 20
-26 4 0 11 -9 14 -20 8 -26 32 -26 40 0 4 11 11 18 16 15 12 -8 12 -50 0 -73
-5 -9 -12 -25 -15 -34 -7 -24 -43 -23 -51 2 -5 14 -15 20 -37 20 -23 0 -44 12
-79 45 -26 25 -53 45 -58 45 -14 0 -41 60 -38 85 2 16 -3 19 -24 17 -22 -3
-29 2 -38 29 -15 43 -14 54 4 39 12 -10 24 -10 54 -1z m-10772 -738 c42 -74
39 -191 -6 -191 -33 0 -42 25 -43 117 -2 122 11 141 49 74z m10953 -657 c0
-10 -7 -14 -22 -12 -32 5 -35 28 -4 28 17 0 26 -5 26 -16z m-104 -3735 c23
-21 23 -21 1 -65 -20 -43 -20 -44 -1 -65 18 -21 18 -21 -1 -35 -22 -17 -131
-19 -141 -3 -3 6 3 24 15 40 27 36 26 43 -4 67 -30 24 -31 25 -2 63 20 29 25
30 66 25 25 -3 55 -16 67 -27z m66 -271 c-2 -38 1 -75 8 -88 16 -30 -7 -55
-43 -46 -32 8 -46 59 -24 84 8 9 15 36 15 58 -1 49 8 66 30 62 14 -3 16 -14
14 -70z m123 -33 c15 -31 36 -60 46 -66 26 -13 25 -59 0 -59 -11 0 -29 -13
-41 -30 -21 -30 -62 -41 -75 -20 -8 12 -22 178 -17 202 2 9 13 19 25 21 12 2
25 5 28 6 3 0 18 -24 34 -54z m-107 -173 c39 -37 30 -56 -22 -46 -42 7 -53 23
-36 53 14 27 22 26 58 -7z m-2 -138 c24 -58 15 -74 -23 -39 -45 42 -53 75 -18
75 20 0 29 -8 41 -36z"/>
<path d="M13080 10878 c1 -23 29 -51 45 -45 21 9 19 34 -4 47 -26 13 -41 13
-41 -2z"/>
<path d="M4075 20460 c-10 -16 2 -27 35 -34 17 -3 51 -18 76 -32 43 -25 45
-29 43 -68 -1 -23 -1 -47 0 -54 1 -13 100 -62 125 -62 8 0 19 -12 24 -27 5
-16 26 -45 45 -66 20 -21 37 -45 39 -54 6 -34 28 -25 28 10 0 20 7 43 17 53
16 16 19 14 50 -22 18 -22 33 -44 33 -50 0 -10 68 -41 142 -64 21 -6 47 -24
59 -41 14 -21 29 -29 50 -29 29 0 29 1 29 55 0 46 3 55 18 55 26 0 52 -51 52
-102 0 -27 9 -59 25 -87 41 -71 25 -121 -25 -76 -16 14 -50 12 -50 -4 1 -12
36 -48 58 -60 14 -7 22 -21 22 -38 0 -22 -3 -24 -22 -17 -13 4 -43 7 -67 7
-43 -1 -43 -1 -37 38 5 32 3 40 -14 49 -11 6 -20 15 -20 21 0 9 6 12 49 25 29
9 -44 61 -93 66 -25 3 -63 15 -86 27 -22 11 -56 21 -75 21 -19 0 -35 4 -35 8
0 5 -19 24 -41 42 -35 28 -45 31 -60 22 -26 -16 -37 -15 -70 9 -29 20 -29 20
-55 0 -34 -27 -48 -26 -71 2 -22 28 -62 51 -71 42 -4 -4 -7 -26 -7 -48 0 -36
-3 -42 -22 -45 -24 -4 -32 -27 -11 -34 6 -2 8 -10 4 -16 -11 -18 -46 4 -46 30
0 11 -21 41 -49 68 -26 25 -52 53 -57 62 -15 25 -91 32 -103 10 -11 -21 2
-136 17 -155 5 -7 13 -23 17 -35 4 -13 21 -46 38 -73 30 -50 30 -50 141 -43
78 4 120 2 141 -6 17 -7 84 -14 150 -17 133 -6 145 -11 145 -70 0 -40 -15 -42
-136 -17 -86 18 -159 16 -409 -10 -148 -15 -169 -12 -178 26 -10 44 -14 394
-5 458 3 22 -5 29 -58 55 -75 37 -174 102 -195 128 -17 21 -39 16 -39 -9 0
-18 -11 -18 -49 1 -17 8 -45 22 -61 30 -24 11 -35 12 -49 3 -15 -9 -27 -6 -65
16 -43 25 -49 26 -88 15 -60 -18 -94 -60 -108 -137 -10 -50 -10 -65 1 -78 11
-13 10 -17 -4 -25 -9 -6 -17 -17 -17 -24 0 -18 -18 -19 -57 -5 -38 15 -55 38
-43 60 11 21 1 122 -11 114 -5 -3 -9 -16 -9 -30 0 -15 -6 -24 -16 -24 -11 0
-14 6 -9 20 9 30 -12 51 -43 43 -13 -3 -34 -6 -46 -7 -12 -1 -22 -9 -25 -21
-2 -11 -8 -23 -13 -26 -6 -4 -12 -31 -14 -61 -4 -51 -3 -56 28 -81 101 -83
208 -154 208 -137 0 4 -5 10 -10 12 -6 2 -11 21 -13 43 -2 45 24 61 48 28 11
-15 17 -16 33 -6 29 17 66 -34 52 -72 -5 -14 -13 -25 -17 -25 -5 0 -14 -4 -22
-9 -20 -13 35 -71 67 -71 12 0 25 -7 28 -15 7 -18 113 -67 131 -61 7 3 20 -6
29 -19 9 -14 33 -29 54 -35 54 -15 71 -39 79 -114 4 -35 12 -70 18 -77 5 -8
13 -25 16 -39 5 -16 25 -36 58 -55 51 -30 99 -73 99 -88 0 -4 11 -13 25 -19
20 -9 25 -18 25 -48 0 -27 9 -47 33 -76 19 -21 36 -47 40 -57 8 -22 50 -38 84
-31 26 4 30 0 61 -63 39 -81 130 -196 157 -201 19 -4 95 -79 95 -94 0 -13 108
-118 122 -118 37 0 50 58 23 94 -8 11 -15 30 -15 43 0 13 -9 32 -20 43 -25 25
-25 35 1 76 18 29 26 34 59 34 21 0 43 -6 50 -15 14 -16 70 -21 70 -5 0 5 -9
14 -21 20 -17 9 -18 14 -8 26 19 23 56 8 105 -42 40 -40 84 -58 84 -34 0 11
29 25 73 34 35 8 36 36 1 36 -20 0 -28 8 -41 38 -8 20 -19 39 -23 42 -11 7
-100 141 -100 151 0 15 58 39 95 39 33 0 35 -2 35 -32 1 -45 16 -110 29 -117
5 -4 14 -19 20 -34 13 -35 29 -35 36 1 17 82 26 102 50 108 37 9 152 -13 190
-36 30 -18 47 -21 112 -19 83 4 100 -6 64 -38 -12 -9 -21 -24 -21 -33 0 -17
48 -112 62 -121 21 -13 48 -83 35 -91 -17 -11 -75 -10 -82 2 -3 6 -13 10 -22
10 -9 0 -33 16 -55 36 -46 41 -63 40 -63 -4 0 -37 -35 -78 -59 -69 -9 4 -16
16 -16 27 0 26 -27 37 -51 21 -19 -11 -59 3 -59 21 0 20 -39 27 -68 13 -32
-16 -57 -12 -66 11 -8 21 -34 17 -46 -7 -16 -28 -5 -49 24 -49 13 0 26 -7 29
-15 4 -8 21 -21 39 -29 18 -9 40 -20 48 -25 72 -43 331 -40 382 5 10 10 41 19
73 22 30 2 60 11 66 18 6 8 22 14 34 14 12 0 33 8 46 19 13 10 39 22 57 26 18
4 36 13 38 20 3 7 16 16 30 19 16 4 24 14 24 27 0 33 72 23 80 -11 6 -27 40
-41 40 -17 0 17 -24 39 -69 62 -32 16 -36 16 -46 1 -14 -19 -39 -20 -80 -2
-26 11 -33 10 -64 -11 -18 -13 -39 -30 -45 -38 -13 -17 -39 1 -69 47 -10 17
-23 25 -32 22 -21 -8 -19 15 5 54 25 40 21 48 -29 62 -36 9 -39 14 -45 54 -5
30 -13 47 -29 55 -12 7 -40 23 -62 36 -22 14 -54 32 -72 40 -17 8 -34 19 -37
24 -3 5 -18 12 -33 16 -15 3 -40 17 -56 31 -38 32 -152 35 -210 4 -47 -26 -50
-25 -122 10 -60 29 -60 29 7 59 37 17 74 31 82 31 21 0 38 27 31 50 -3 11 -10
20 -15 20 -5 0 -14 16 -20 35 -6 19 -20 40 -31 45 -14 8 -19 22 -19 55 0 25
-4 45 -10 45 -5 0 -10 11 -10 24 0 15 -7 27 -19 31 -24 7 -29 21 -23 68 4 39
22 52 22 16 0 -14 11 -25 35 -35 34 -14 35 -16 20 -37 -24 -35 -20 -67 10 -67
14 0 29 -8 35 -21 22 -41 128 -149 146 -149 6 0 19 9 29 20 10 11 23 20 28 20
5 0 29 10 53 22 42 21 46 21 79 5 42 -20 63 -21 129 -3 59 15 67 29 28 45 -37
16 -58 54 -66 123 -4 31 -13 62 -21 68 -7 6 -16 26 -19 44 -5 26 -14 37 -35
44 -34 12 -49 58 -31 92 10 19 8 26 -22 51 -23 20 -39 26 -53 21 -44 -15 -94
-3 -141 33 -26 20 -60 39 -76 42 -17 3 -33 16 -41 32 -10 21 -20 27 -55 29
-30 2 -45 9 -53 23 -10 19 -12 20 -36 4 -26 -18 -73 -8 -73 14 0 5 -34 28 -75
51 -41 23 -75 45 -75 50 0 17 -54 90 -67 90 -8 0 -24 6 -36 14 -28 17 -144 29
-152 16z m-789 -230 c24 -22 48 -40 53 -40 5 0 13 -9 16 -21 6 -18 12 -20 43
-14 90 16 204 -13 210 -53 4 -24 30 -29 62 -12 31 17 66 -4 80 -46 13 -37 5
-54 -32 -66 -5 -2 -16 -34 -25 -72 -14 -58 -21 -70 -44 -78 -14 -5 -31 -20
-38 -34 -9 -21 -14 -23 -30 -14 -11 5 -29 10 -40 10 -24 0 -55 52 -46 79 3 9
-2 31 -10 48 -13 27 -23 32 -68 38 -58 8 -67 16 -67 62 0 28 -5 34 -49 54 -41
18 -54 31 -76 75 -19 37 -33 54 -46 54 -11 0 -19 5 -19 11 0 6 8 8 19 4 15 -5
24 1 36 24 20 39 19 39 71 -9z m-370 -48 c6 -4 16 -17 23 -30 10 -18 9 -23 -4
-28 -9 -4 -17 -5 -18 -3 -1 2 -10 19 -20 37 -18 32 -9 43 19 24z m314 -294 c0
-4 -5 -10 -11 -14 -18 -11 -39 19 -32 45 6 24 6 24 24 0 10 -13 19 -27 19 -31z
m108 -40 c5 -7 13 -23 16 -35 6 -20 4 -23 -17 -23 -18 0 -27 7 -31 25 -10 40
10 60 32 33z m380 -210 c2 -9 -12 -34 -32 -55 -34 -38 -34 -38 -73 -16 -47 27
-48 44 -3 56 19 4 42 15 50 23 19 19 54 14 58 -8z m120 -80 c7 -26 13 -32 30
-30 30 4 28 -19 -3 -66 -14 -20 -25 -50 -25 -66 0 -28 1 -28 18 -13 10 10 24
17 30 17 7 0 12 6 12 14 0 7 7 19 15 26 13 11 15 9 15 -13 0 -14 -7 -27 -15
-31 -10 -4 -15 -20 -15 -53 0 -68 17 -95 70 -113 25 -8 55 -21 67 -27 12 -7
31 -13 43 -13 19 0 21 4 14 32 -7 34 -50 98 -65 98 -15 0 -10 20 7 27 30 11
123 -52 124 -84 0 -18 54 -43 90 -43 17 0 41 -5 52 -11 18 -10 26 -6 60 28 39
39 39 39 18 84 -31 66 -44 86 -74 114 -32 30 -46 32 -46 6 0 -41 -89 -31 -90
10 0 4 20 10 44 13 36 6 45 11 51 33 10 42 61 26 131 -41 33 -31 78 -64 102
-72 23 -9 42 -19 42 -23 -1 -26 -16 -50 -36 -60 -13 -6 -24 -17 -24 -25 0 -18
75 -10 105 10 25 18 78 19 73 2 -3 -7 -19 -16 -38 -19 -18 -4 -37 -14 -42 -22
-4 -9 -21 -18 -37 -22 -16 -3 -35 -12 -41 -20 -6 -7 -29 -16 -50 -20 -21 -4
-44 -13 -50 -21 -7 -7 -27 -16 -46 -20 -18 -3 -38 -12 -45 -20 -6 -8 -19 -14
-29 -14 -9 0 -29 -11 -44 -25 -15 -14 -31 -25 -37 -25 -5 0 -9 -4 -9 -10 0 -5
13 -10 29 -10 17 0 33 5 36 10 3 6 23 10 44 10 22 0 44 6 51 15 14 17 43 19
70 5 15 -8 18 -19 15 -67 -3 -32 -4 -61 -5 -65 -1 -31 -82 21 -95 61 -9 30
-22 26 -62 -19 -33 -36 -41 -40 -85 -40 -50 0 -63 15 -33 40 21 18 9 30 -31
30 -53 0 -45 19 29 69 63 43 67 81 9 81 -21 0 -43 -5 -48 -10 -21 -21 -107
-22 -169 -2 -93 31 -143 82 -153 160 -6 44 -17 71 -38 97 -62 78 -61 70 -15
113 23 21 41 44 41 50 0 7 11 12 25 12 19 0 26 -7 33 -32z m897 -319 c17 -17
-8 -29 -34 -16 -37 19 -41 42 -5 33 16 -4 33 -12 39 -17z"/>
<path d="M5193 20463 c-22 -8 -14 -40 13 -62 17 -13 41 -21 66 -21 31 0 46 -6
68 -30 36 -39 67 -50 105 -37 37 12 55 33 55 64 0 25 -14 29 -56 13 -21 -8
-40 -6 -85 10 -33 11 -68 20 -78 20 -10 0 -24 7 -31 16 -18 21 -42 32 -57 27z"/>
<path d="M6070 20449 c0 -12 8 -23 20 -26 31 -8 23 -31 -17 -48 -36 -15 -37
-15 -64 14 -43 47 -114 53 -146 13 -12 -16 -14 -15 -32 8 -26 33 -77 19 -75
-20 1 -14 -5 -29 -12 -33 -20 -12 -17 -40 9 -78 21 -31 22 -38 11 -64 -31 -71
-6 -125 56 -125 36 0 50 18 50 62 0 39 6 43 47 32 17 -5 23 -17 30 -57 7 -43
12 -52 33 -57 17 -4 27 -15 31 -35 9 -41 10 -130 3 -138 -15 -15 -44 16 -50
53 -5 32 -11 40 -28 40 -12 0 -27 5 -33 11 -9 9 -19 6 -39 -10 -32 -25 -54
-27 -54 -5 0 19 -69 110 -90 118 -41 16 -127 69 -148 92 -30 31 -36 26 -37
-33 0 -45 -2 -48 -32 -57 -37 -10 -41 -23 -15 -57 30 -40 42 -94 26 -121 -7
-13 -16 -28 -19 -34 -3 -6 5 -35 18 -65 14 -30 27 -63 29 -74 3 -17 12 -21 58
-23 40 -2 58 -8 68 -23 16 -23 60 -25 88 -4 18 14 18 16 1 26 -23 13 -57 81
-57 113 0 14 -11 37 -25 52 -14 15 -25 33 -25 40 0 8 -9 14 -20 14 -29 0 -25
29 6 40 49 19 72 13 79 -22 9 -38 33 -73 96 -139 43 -46 47 -48 79 -39 18 5
40 16 49 23 9 8 37 17 63 19 26 3 54 13 63 22 9 9 21 16 27 16 19 0 97 55 103
72 8 22 70 58 101 58 37 0 34 -49 -6 -78 -16 -12 -34 -22 -39 -22 -6 0 -15 -9
-21 -20 -6 -11 -17 -20 -24 -20 -21 0 -43 -49 -27 -60 26 -16 109 -19 280 -11
175 8 175 8 205 44 72 83 77 94 74 144 -3 48 -3 48 -55 45 -59 -4 -59 -4 -73
74 -6 40 -9 45 -15 27 -9 -28 -34 -29 -68 -3 -14 11 -29 20 -35 20 -5 0 -17 9
-27 20 -10 11 -27 20 -39 20 -11 0 -31 11 -45 24 -47 42 -130 66 -161 46 -13
-9 -13 -12 3 -21 25 -15 22 -41 -5 -37 -18 2 -23 9 -21 30 2 33 -15 40 -97 36
-51 -3 -55 -1 -58 20 -5 35 25 75 53 70 45 -9 54 99 10 116 -27 10 -35 7 -35
-15z m-79 -155 c7 -73 11 -80 47 -87 15 -3 45 -20 66 -37 22 -17 50 -33 62
-36 26 -7 39 -34 29 -63 -3 -11 -1 -28 6 -39 34 -54 -34 -72 -75 -19 -14 17
-35 41 -46 52 -11 12 -20 30 -20 42 0 27 -25 37 -45 17 -20 -20 -38 -9 -23 15
15 24 4 51 -21 51 -11 0 -23 5 -26 10 -3 6 -26 10 -51 10 -77 0 -68 66 15 119
65 42 75 38 82 -35z m-323 -226 c4 -34 -13 -36 -45 -6 -32 30 -29 40 10 36 27
-2 33 -8 35 -30z m602 1 c13 -24 13 -24 -18 -33 -17 -6 -24 -3 -31 16 -5 13
-7 26 -4 31 9 15 43 6 53 -14z m184 -81 c8 -13 6 -22 -12 -41 -12 -13 -22 -29
-22 -35 0 -24 -26 -11 -42 21 -44 86 -46 78 13 75 36 -2 55 -8 63 -20z"/>
<path d="M7276 20461 c-3 -4 4 -26 15 -47 16 -31 19 -50 15 -91 -5 -44 -3 -53
12 -57 9 -3 39 -29 66 -56 70 -72 91 -68 151 34 6 10 16 15 25 11 23 -9 71
-76 77 -107 7 -38 37 -36 60 2 21 36 24 37 71 5 41 -28 83 -32 102 -10 10 12
9 16 -6 21 -11 4 -30 17 -44 29 -14 13 -34 25 -45 27 -11 2 -24 13 -30 25 -20
39 -37 53 -67 53 -20 0 -45 13 -77 39 -27 22 -63 42 -84 46 -21 4 -45 18 -56
31 -10 13 -26 24 -36 24 -9 0 -24 4 -33 9 -25 12 -110 22 -116 12z"/>
<path d="M9214 20455 c-8 -21 3 -48 19 -43 19 7 22 58 2 58 -8 0 -18 -7 -21
-15z"/>
<path d="M10698 20464 c-23 -22 32 -74 96 -90 35 -8 96 13 96 34 0 26 -173 76
-192 56z"/>
<path d="M12271 20459 c-11 -5 -21 -14 -21 -21 0 -8 -5 -6 -11 5 -12 21 -59
23 -59 2 0 -15 38 -40 47 -31 4 3 11 2 17 -3 6 -5 28 -14 49 -20 31 -11 37
-17 37 -41 0 -32 31 -50 55 -30 10 9 19 8 38 -4 22 -15 26 -15 61 9 59 40 128
4 112 -60 -4 -14 -2 -25 4 -25 5 0 10 21 10 46 0 64 13 84 55 84 42 0 55 -20
55 -84 0 -50 4 -54 26 -31 19 19 58 5 62 -23 4 -29 -23 -41 -105 -45 -82 -4
-95 -10 -91 -45 3 -24 -1 -27 -30 -30 -19 -2 -41 3 -50 11 -10 7 -35 19 -58
25 -27 8 -44 20 -52 37 -17 37 -43 42 -181 38 -120 -4 -125 -3 -161 22 -33 23
-41 24 -64 14 -52 -24 -26 -55 61 -73 48 -9 58 -15 56 -31 -1 -11 13 -38 31
-60 31 -38 32 -43 28 -112 -4 -66 10 -138 44 -228 26 -68 102 -125 165 -125
61 0 64 -11 23 -87 -33 -60 -43 -106 -25 -118 6 -3 14 2 20 12 8 15 25 18 106
19 96 1 96 1 90 -47 -5 -36 -3 -53 11 -73 13 -21 15 -39 11 -81 -3 -30 -3 -55
1 -55 19 1 99 33 114 47 9 8 29 13 44 11 24 -2 30 -9 34 -38 4 -20 17 -50 30
-68 24 -33 97 -82 122 -82 7 0 25 -6 39 -14 35 -18 163 -30 187 -17 16 8 18
17 12 48 -6 37 5 93 19 93 22 0 50 -35 56 -69 4 -22 18 -52 31 -68 45 -51 59
-85 40 -98 -28 -21 -18 -35 23 -35 76 0 100 -10 113 -46 14 -41 25 -43 38 -8
19 50 1 151 -29 161 -74 25 -120 55 -126 82 -3 16 -25 49 -48 73 -23 24 -53
63 -67 86 -24 40 -33 44 -90 46 -22 1 -25 5 -22 35 2 29 0 32 -15 26 -35 -16
-68 -11 -77 11 -6 12 -30 31 -54 43 -31 15 -42 26 -39 39 2 9 -3 29 -10 45
-12 24 -11 30 8 57 12 16 34 32 49 35 18 4 40 25 68 66 39 56 41 62 27 82 -19
27 -19 58 0 83 8 10 15 26 15 35 0 38 31 79 59 79 27 0 28 -3 27 -40 -1 -48
26 -87 81 -117 41 -21 41 -21 64 3 12 13 33 24 46 24 28 0 41 26 22 45 -8 7
-37 20 -66 29 -68 22 -81 38 -53 64 21 20 22 22 6 75 -21 72 -20 96 4 122 21
22 21 22 -14 49 -29 21 -39 24 -60 16 -28 -10 -65 1 -98 28 -53 44 -63 -47
-11 -99 36 -35 58 -61 67 -76 8 -14 -18 -83 -32 -83 -15 0 -126 -116 -152
-158 -14 -23 -28 -42 -33 -42 -15 0 -180 -160 -230 -222 -43 -53 -44 -58 -17
-58 10 0 31 -5 44 -12 29 -13 56 5 79 51 23 47 35 36 24 -21 -6 -29 -10 -79
-9 -112 1 -58 1 -58 -58 -52 -35 4 -67 3 -78 -3 -14 -7 -25 -6 -38 4 -18 13
-18 15 -1 43 28 49 23 81 -16 97 -19 8 -45 29 -59 47 -14 18 -39 47 -55 63
-32 32 -60 91 -49 103 4 3 23 5 42 3 20 -1 43 3 52 11 56 48 142 78 142 51 0
-20 -26 -91 -38 -106 -9 -9 -12 -20 -9 -24 4 -3 32 19 62 50 31 31 60 57 66
57 5 0 13 10 18 23 5 12 29 45 55 74 25 28 46 55 46 60 0 5 -15 23 -34 40 -34
30 -34 30 -53 7 -34 -43 -68 -42 -110 5 -21 23 -57 61 -80 85 -41 44 -41 44 7
75 26 17 56 31 66 31 18 0 117 -110 130 -144 8 -20 28 -20 44 -1 19 23 57 18
76 -10 21 -33 28 -32 69 10 42 41 43 48 10 63 -17 8 -25 20 -25 37 0 14 -15
41 -35 64 -22 24 -35 49 -35 65 0 35 -17 66 -35 66 -24 0 -83 59 -90 89 -3 17
-16 33 -31 40 -36 16 -44 14 -44 -13 0 -42 -26 -52 -54 -21 -28 30 -81 46
-112 35 -11 -5 -37 -2 -59 6 -69 24 -95 19 -95 -16 0 -53 -50 -49 -70 6 -10
24 -93 46 -129 33z m65 -310 c6 -5 14 -27 18 -48 7 -45 66 -93 128 -105 35 -6
68 10 68 35 0 13 38 11 49 -3 45 -55 57 -75 54 -85 -2 -6 5 -30 17 -53 21 -42
21 -42 -42 -35 -37 4 -73 15 -87 26 -13 11 -32 19 -43 19 -25 0 -36 -30 -15
-42 10 -5 17 -20 17 -33 0 -14 8 -29 20 -35 19 -10 27 -40 14 -53 -15 -15 -63
24 -74 60 -7 21 -20 47 -30 58 -9 11 -28 40 -41 64 -17 31 -38 50 -72 68 -40
20 -46 27 -37 38 8 10 11 38 8 80 -4 62 -3 65 17 59 11 -4 25 -10 31 -15z
m-26 -254 c10 -12 10 -19 2 -27 -15 -15 -48 14 -38 31 10 15 21 14 36 -4z
m885 -642 c7 -21 -9 -37 -30 -30 -21 9 -31 37 -15 47 17 11 37 3 45 -17z
m-141 -1 c9 -15 -19 -57 -41 -60 -11 -2 -28 4 -37 14 -16 15 -16 18 0 35 17
19 68 26 78 11z"/>
<path d="M4487 20451 c-17 -6 -16 -8 8 -19 14 -7 32 -12 39 -12 7 0 25 -9 39
-20 18 -14 34 -19 51 -14 20 5 28 2 33 -13 10 -23 96 -103 112 -103 6 0 23 7
37 16 23 16 26 16 47 -4 12 -11 34 -24 50 -27 18 -5 27 -14 27 -27 0 -38 33
-79 60 -76 21 3 25 9 28 40 3 31 -3 42 -36 75 -21 21 -41 45 -44 53 -4 12 -8
13 -19 3 -7 -7 -21 -13 -32 -13 -16 0 -18 6 -15 46 3 40 0 49 -23 66 -40 30
-104 39 -180 26 -50 -8 -75 -8 -99 1 -37 12 -56 13 -83 2z m328 -82 c14 -14
-9 -31 -36 -27 -16 2 -25 11 -27 27 -3 21 -1 23 25 17 15 -4 32 -12 38 -17z"/>
<path d="M10934 20449 c-3 -6 -1 -16 5 -22 18 -18 13 -36 -14 -43 -33 -8 -32
-20 4 -39 33 -17 74 -66 90 -107 12 -31 58 -65 70 -52 4 5 13 29 20 53 12 40
14 43 24 25 6 -10 22 -31 36 -45 14 -14 44 -52 66 -83 33 -48 77 -86 99 -86 2
0 9 14 15 30 14 40 21 38 65 -20 21 -27 43 -51 50 -52 30 -4 92 -8 204 -12
122 -4 122 -4 137 24 8 16 34 37 60 50 45 22 45 22 90 0 51 -25 51 -40 -1 -40
-42 0 -43 -10 -3 -54 45 -52 37 -71 -30 -71 -62 0 -78 -17 -31 -33 42 -15 45
-65 3 -60 -17 2 -32 12 -38 26 -12 27 -41 29 -55 2 -8 -15 -21 -20 -48 -20
-20 0 -56 -2 -78 -6 -39 -6 -43 -4 -74 35 -22 26 -41 41 -56 41 -25 0 -40 -15
-24 -25 18 -11 10 -33 -15 -39 -20 -5 -33 1 -62 29 -24 23 -45 35 -65 35 -44
0 -35 -28 18 -50 47 -20 55 -42 17 -48 -20 -3 -47 16 -55 38 -2 6 -34 18 -72
27 -80 20 -103 47 -71 83 18 20 18 21 -6 46 -13 14 -48 32 -81 41 -56 16 -57
16 -35 34 17 14 19 20 10 30 -10 10 -19 9 -46 -5 -40 -22 -69 -18 -82 11 -7
17 -15 20 -36 16 -20 -4 -30 0 -38 15 -11 21 -42 20 -68 -1 -18 -14 -17 -67 1
-67 25 0 30 -22 8 -39 -11 -9 -23 -31 -27 -48 -6 -31 -10 -33 -46 -33 -28 0
-47 7 -62 23 -31 30 -73 57 -90 57 -8 0 -22 9 -32 19 -17 20 -18 20 -52 1 -35
-19 -35 -19 -84 8 -42 23 -51 25 -69 14 -11 -7 -26 -9 -33 -5 -7 4 -33 8 -59
8 -48 0 -63 -11 -52 -39 9 -24 -15 -28 -42 -7 -15 12 -34 21 -42 21 -22 0 -92
32 -92 43 0 4 5 18 11 29 16 30 -52 89 -93 81 -22 -4 -30 1 -52 35 -33 52 -39
56 -81 41 -55 -20 -81 -3 -89 60 -12 93 -27 103 -63 46 -28 -42 -28 -43 -2
-71 17 -18 19 -26 9 -43 -18 -34 7 -76 45 -77 17 0 39 -5 51 -11 12 -7 26 -8
34 -3 11 7 20 -1 35 -33 18 -37 25 -42 57 -45 20 -2 47 2 59 9 20 10 26 8 58
-30 23 -26 44 -41 59 -41 41 0 27 -35 -21 -54 -52 -20 -76 -20 -101 -1 -12 9
-42 15 -74 15 -29 0 -61 4 -70 9 -28 14 -132 24 -132 12 0 -6 14 -11 30 -11
20 0 30 -5 30 -15 0 -8 12 -21 28 -29 15 -8 45 -30 67 -50 21 -20 43 -36 48
-36 5 0 20 -9 34 -20 15 -11 41 -20 62 -20 63 -1 136 -25 139 -46 7 -34 52
-72 94 -79 60 -10 68 7 24 48 -40 38 -43 49 -21 90 8 15 17 43 21 61 7 40 56
91 78 83 20 -8 21 -51 1 -67 -25 -20 -20 -109 8 -141 26 -31 131 -69 190 -69
70 0 149 -30 189 -71 20 -20 34 -40 31 -43 -11 -11 -64 -6 -86 8 -12 7 -41 16
-64 20 -39 6 -43 4 -43 -14 0 -17 7 -20 45 -20 33 0 50 -5 62 -20 12 -13 30
-20 55 -20 34 0 68 -20 68 -41 0 -13 68 -11 76 3 4 7 0 16 -10 22 -48 29 -51
33 -37 50 12 14 10 20 -13 41 -31 29 -36 87 -10 124 9 13 19 52 22 89 6 81 31
122 74 122 35 0 36 -16 8 -116 -20 -69 -20 -76 -5 -140 14 -62 46 -113 70
-114 6 0 23 -7 38 -15 15 -8 55 -22 88 -31 46 -13 63 -23 74 -44 32 -63 81
-68 64 -6 -8 28 -6 42 12 75 17 33 19 46 11 70 -6 16 -8 32 -5 35 11 10 91 6
118 -6 40 -18 28 -52 -20 -53 -21 0 -32 -30 -34 -95 -1 -51 66 -128 118 -136
54 -9 68 -19 52 -38 -22 -26 46 -107 101 -120 43 -10 43 12 -1 59 -23 25 -41
51 -41 60 0 20 47 95 60 95 6 0 10 6 10 13 0 21 54 67 77 67 12 0 24 -8 28
-19 6 -21 -3 -51 -16 -51 -5 0 -15 -15 -23 -34 -8 -18 -19 -37 -25 -40 -6 -4
-11 -26 -11 -48 0 -84 119 -143 170 -85 59 66 59 64 28 77 -19 7 -14 9 24 9
47 1 47 1 50 -61 3 -71 -2 -68 98 -48 30 7 67 23 83 36 52 44 106 23 77 -31
-28 -52 25 -78 57 -27 9 15 25 35 35 45 10 10 18 31 18 47 0 34 3 35 84 15 70
-17 76 -22 69 -58 -4 -19 -17 -34 -43 -47 -24 -12 -40 -29 -44 -45 -4 -15 -21
-35 -40 -46 -19 -11 -37 -26 -40 -34 -3 -8 -12 -15 -19 -15 -13 0 -22 -9 -61
-65 -7 -10 -35 -30 -61 -45 -35 -18 -54 -38 -74 -75 -14 -27 -69 -94 -121
-148 -135 -139 -246 -258 -343 -367 -96 -107 -211 -215 -230 -215 -22 0 -21
65 2 82 12 8 21 18 21 22 0 5 20 30 45 55 25 26 45 54 45 62 0 21 -62 18 -91
-5 -17 -12 -48 -20 -103 -24 -43 -3 -82 -9 -85 -14 -11 -16 -63 -45 -69 -38
-3 3 2 19 12 36 29 50 20 55 -106 63 -108 6 -148 3 -148 -13 0 -8 113 -57 153
-67 21 -5 30 -14 34 -35 7 -35 56 -79 87 -79 13 0 38 -5 55 -11 25 -9 38 -9
57 2 18 9 27 10 35 2 15 -15 3 -33 -20 -33 -33 0 -68 -78 -42 -94 4 -3 25 10
45 30 27 26 42 34 54 28 27 -12 79 -7 104 10 25 18 58 21 58 6 0 -6 -8 -14
-17 -17 -10 -4 -25 -14 -33 -23 -16 -18 -70 -41 -138 -60 -53 -14 -56 -43 -5
-48 36 -4 68 -32 131 -116 32 -43 48 -56 60 -51 33 13 36 9 44 -45 12 -88 61
-192 115 -247 13 -12 23 -27 23 -33 0 -5 11 -10 25 -10 14 0 29 -8 35 -21 6
-11 21 -24 32 -28 21 -7 44 -58 56 -120 10 -47 27 -49 67 -7 40 43 41 43 49
11 9 -35 26 -31 26 5 0 20 -5 30 -15 30 -9 0 -15 9 -15 25 0 14 -9 51 -20 82
-11 32 -20 75 -20 96 0 22 -7 85 -16 141 -14 89 -21 109 -59 166 -24 36 -46
75 -49 87 -4 11 -13 24 -21 27 -8 3 -15 12 -15 19 0 8 -8 25 -19 38 -10 13
-22 47 -25 74 -11 79 -17 82 -66 29 -43 -46 -43 -46 -38 -138 6 -105 41 -183
77 -171 24 7 37 -11 46 -61 5 -36 11 -43 35 -47 63 -13 111 -97 56 -97 -14 0
-31 7 -39 15 -24 24 -94 44 -107 31 -14 -14 -32 11 -26 36 2 10 -9 36 -25 58
-16 22 -29 46 -29 54 0 8 -9 21 -21 30 -41 29 -68 133 -39 151 6 3 10 37 10
76 0 39 -4 69 -10 69 -5 0 -10 9 -10 19 0 24 31 35 76 27 31 -6 34 -4 40 21
12 58 14 60 34 36 24 -30 27 -29 35 6 3 16 13 35 21 42 24 20 37 -4 43 -85 4
-50 12 -81 24 -93 9 -11 17 -34 17 -51 0 -23 8 -37 30 -54 25 -18 30 -29 30
-63 0 -45 24 -92 34 -65 3 8 7 42 8 75 2 48 7 60 20 63 30 6 41 -42 33 -148
-6 -96 -6 -96 46 -148 28 -29 56 -52 62 -52 6 0 26 -12 44 -26 56 -43 113 -4
62 42 -24 22 -49 70 -69 133 -16 49 -30 59 -66 42 -34 -15 -47 15 -16 39 37
30 39 66 3 84 -23 12 -31 25 -36 54 -3 20 -8 49 -10 64 -2 14 -18 48 -34 75
-35 57 -45 115 -20 120 8 2 33 -10 54 -27 56 -45 79 -38 83 24 2 27 1 59 -2
70 -14 51 -162 120 -196 92 -8 -7 -35 -20 -60 -30 -25 -10 -68 -28 -95 -42
-54 -26 -75 -30 -75 -14 0 6 6 10 13 10 6 0 27 17 45 38 60 69 65 72 96 71 55
-4 73 8 80 51 6 36 9 40 36 40 20 0 40 -11 64 -35 20 -19 43 -35 53 -35 10 0
36 -12 57 -26 32 -22 37 -30 33 -53 -3 -14 -1 -44 4 -66 5 -22 11 -52 14 -66
3 -15 13 -29 24 -32 13 -3 24 -20 31 -48 7 -24 14 -50 16 -58 3 -10 16 -12 46
-8 47 6 70 29 67 67 -3 60 10 65 53 22 32 -33 51 -109 24 -99 -11 5 -26 -2
-43 -21 -23 -25 -30 -27 -94 -25 -78 2 -79 0 -92 -79 -7 -45 14 -73 47 -63 55
17 61 13 59 -37 -2 -37 1 -48 12 -48 8 0 15 4 15 10 0 5 12 23 28 39 15 16 38
41 51 55 27 30 34 32 55 10 43 -43 21 -110 -42 -126 -18 -5 -32 -13 -32 -17 0
-5 -24 -17 -52 -26 -59 -19 -78 -37 -78 -72 0 -34 23 -38 73 -14 72 35 108 27
136 -28 22 -42 33 -89 33 -137 0 -28 6 -37 30 -50 18 -9 28 -22 26 -32 -3 -14
-18 -18 -85 -20 -78 -3 -81 -4 -86 -29 -3 -15 2 -45 9 -67 8 -22 12 -47 9 -55
-3 -7 1 -21 9 -30 8 -9 22 -42 31 -74 14 -50 20 -58 38 -55 20 3 22 8 18 66
-2 43 2 69 11 85 8 12 30 65 48 117 18 52 39 111 46 130 7 19 13 72 14 116 0
63 3 83 15 87 21 9 24 -1 29 -110 3 -54 8 -106 11 -115 4 -10 -2 -25 -16 -39
-15 -15 -25 -41 -30 -73 -4 -28 -21 -81 -38 -117 -37 -78 -37 -79 -11 -112 17
-22 20 -38 18 -89 -3 -58 -5 -63 -30 -72 -41 -14 -79 3 -102 47 -22 42 -31 46
-39 18 -3 -14 -15 -21 -43 -23 -39 -3 -62 -28 -25 -28 11 0 25 -9 31 -20 6
-11 19 -20 29 -20 10 0 29 -8 42 -18 14 -11 57 -23 104 -30 79 -11 80 -11 100
13 30 37 38 31 33 -25 -4 -42 -2 -53 18 -71 28 -26 39 -66 23 -86 -16 -19 -73
-9 -107 18 -14 10 -32 19 -41 19 -9 0 -36 14 -61 30 -25 16 -54 30 -66 30 -11
0 -31 11 -44 25 -13 14 -29 25 -37 25 -7 0 -13 9 -13 20 0 10 -9 24 -20 30
-11 6 -23 22 -26 35 -7 29 -39 34 -53 7 -6 -11 -5 -27 3 -47 7 -17 16 -51 20
-75 9 -65 37 -104 90 -130 26 -12 59 -38 74 -57 15 -19 44 -41 64 -50 64 -26
82 -69 82 -194 0 -73 -4 -112 -13 -122 -14 -17 -7 -37 12 -37 7 0 31 18 55 40
52 49 65 50 87 3 38 -81 12 -131 -45 -85 -23 18 -24 18 -69 -6 -25 -14 -62
-28 -81 -32 -19 -4 -42 -11 -51 -14 -13 -6 -25 8 -55 61 -22 37 -42 75 -46 84
-13 31 -59 30 -96 -3 -19 -16 -45 -35 -59 -41 -17 -7 -23 -16 -19 -29 3 -10 9
-27 12 -38 5 -14 0 -22 -19 -31 -22 -10 -24 -14 -16 -51 8 -33 6 -44 -11 -65
-11 -14 -20 -33 -20 -42 0 -27 -30 -61 -53 -61 -12 1 -35 12 -52 25 -30 24
-30 24 3 36 42 14 47 65 8 75 -17 4 -33 23 -51 59 -29 56 -27 75 6 75 24 0 24
6 -2 55 -21 40 -21 40 -2 75 12 22 29 36 44 38 25 4 59 29 59 44 0 15 -52 8
-65 -8 -18 -25 -55 -2 -55 34 0 36 17 52 52 52 16 0 31 6 34 14 6 15 -48 130
-66 141 -14 9 -4 74 17 117 25 49 29 119 8 134 -13 10 -16 21 -10 52 4 25 2
42 -4 47 -13 7 -15 45 -2 45 5 0 14 -7 21 -15 17 -20 94 -19 129 1 20 12 33
32 44 71 22 69 22 66 -9 103 -15 17 -24 33 -21 37 4 3 -15 23 -40 44 -26 21
-52 51 -59 66 -14 30 -48 73 -58 73 -12 0 -5 -78 8 -89 8 -7 17 -28 21 -47 3
-19 12 -37 20 -40 8 -3 17 -16 21 -27 4 -12 24 -43 45 -68 80 -97 28 -127 -60
-35 -28 30 -51 59 -51 64 0 18 -49 32 -74 20 -39 -17 -50 -57 -32 -112 9 -26
16 -57 16 -70 0 -13 9 -31 20 -41 11 -10 20 -26 20 -36 0 -11 9 -24 20 -31 25
-16 28 -76 4 -85 -19 -7 -62 32 -79 72 -16 36 -52 71 -63 61 -20 -21 -6 -95
26 -142 21 -30 32 -54 28 -67 -10 -38 15 -127 41 -144 12 -8 23 -20 23 -26 0
-6 8 -19 17 -29 21 -23 6 -42 -29 -33 -30 8 -84 57 -93 85 -10 32 -38 20 -53
-24 -15 -46 -8 -61 20 -42 19 14 23 12 49 -13 15 -15 30 -43 34 -62 3 -19 8
-905 10 -1969 3 -1064 6 -1944 7 -1955 0 -11 -2 -58 -6 -105 -4 -47 -3 -114 1
-150 5 -36 5 -144 1 -240 -10 -208 -1 -260 41 -260 52 0 102 20 111 46 5 13
12 24 14 24 9 0 55 -50 66 -70 11 -21 90 -30 90 -10 0 6 18 10 40 10 21 0 51
5 66 12 22 10 28 10 39 -5 15 -21 61 -22 73 -1 12 22 56 14 60 -11 12 -81 32
-83 32 -2 0 47 4 55 36 85 36 34 39 56 4 34 -22 -14 -25 -10 -34 43 -14 75
-63 103 -127 70 -32 -17 -45 -7 -37 31 4 23 84 84 109 84 24 0 99 -46 99 -62
0 -6 7 -16 16 -22 48 -36 41 -414 -9 -464 -36 -35 -97 23 -97 92 0 33 0 33
-52 33 -29 0 -64 2 -77 4 -22 4 -23 1 -27 -68 -2 -39 0 -75 6 -78 5 -3 38 -8
74 -12 45 -4 71 -12 82 -24 21 -24 47 -24 122 0 70 21 78 19 87 -30 5 -29 2
-41 -17 -63 -23 -27 -24 -27 -60 -12 -45 19 -151 21 -166 3 -31 -37 -26 -67
21 -110 72 -67 87 -99 87 -190 0 -47 -6 -92 -15 -115 -11 -25 -14 -52 -10 -87
5 -33 1 -72 -9 -110 -8 -32 -13 -61 -11 -63 2 -2 33 6 70 18 79 26 91 23 105
-31 18 -66 15 -68 -98 -62 -136 8 -152 3 -149 -44 3 -50 -18 -53 -67 -8 -21
19 -43 35 -48 35 -6 0 -8 10 -5 23 10 37 -7 54 -42 41 -22 -9 -44 -8 -95 3
-36 8 -73 13 -81 9 -22 -8 -18 -35 8 -45 44 -18 78 -60 71 -89 -13 -56 -55
-66 -103 -26 -17 14 -43 29 -58 33 -18 5 -26 13 -23 22 2 8 3 32 2 54 -2 22
-4 55 -5 73 -1 17 -7 32 -14 32 -6 0 -19 10 -27 22 -15 21 -14 24 10 43 22 18
24 24 15 48 -6 15 -17 27 -25 27 -22 0 -47 51 -35 72 7 13 18 15 44 11 27 -4
36 -2 41 11 10 25 -16 95 -37 101 -34 11 -33 85 1 115 28 24 16 188 -15 202
-21 9 -22 18 -28 141 -6 140 -17 196 -32 161 -4 -10 -9 -323 -10 -694 -3 -708
-2 -730 40 -730 19 0 25 -12 18 -39 -5 -20 -7 -21 -23 -6 -14 13 -20 14 -26 3
-4 -7 -9 -656 -10 -1443 -1 -786 -5 -1451 -9 -1477 -8 -52 2 -61 39 -33 11 8
28 15 38 15 26 0 23 35 -7 86 -33 57 -26 73 30 66 42 -4 44 -3 51 24 5 18 3
29 -4 32 -28 9 -55 40 -49 55 11 30 56 21 71 -13 13 -32 26 -30 26 2 0 46 -66
98 -85 67 -4 -5 -11 -9 -17 -7 -11 4 -38 74 -38 101 0 25 18 21 22 -5 4 -32
33 -30 33 2 0 17 -6 26 -20 28 -23 3 -48 60 -46 107 0 17 1 48 1 70 1 73 7 82
57 99 25 9 47 16 48 16 1 0 2 -46 1 -102 -1 -103 -1 -103 53 -108 34 -3 57
-11 62 -20 4 -8 16 -33 27 -55 21 -45 66 -74 91 -58 25 16 31 60 15 119 -21
82 -19 166 6 197 32 40 26 57 -19 57 -56 0 -85 32 -62 69 12 19 -7 59 -31 66
-10 4 -18 12 -18 20 0 8 -8 16 -17 19 -51 14 -82 16 -106 7 -39 -15 -57 -4
-57 33 0 39 7 49 47 69 28 15 36 15 74 2 46 -17 102 -68 114 -105 4 -13 14
-30 21 -38 9 -8 12 -23 8 -39 -6 -22 -4 -24 22 -21 29 3 29 3 26 93 -3 97 -15
184 -39 281 -9 38 -14 89 -11 132 4 70 4 70 -57 67 -33 -2 -62 -3 -65 -4 -2
-1 6 -8 18 -17 28 -20 28 -42 -4 -137 -31 -92 -57 -127 -99 -130 -28 -2 -31 1
-49 56 -19 58 -19 58 3 73 27 19 27 51 1 59 -23 7 -25 18 -7 34 16 13 27 5 27
-21 0 -13 6 -18 18 -16 25 5 18 105 -9 131 -10 10 -19 21 -20 25 -7 100 -3
127 16 124 11 -1 31 -2 45 -2 70 3 82 1 103 -17 12 -10 42 -29 67 -42 25 -12
60 -33 79 -46 40 -29 74 -19 69 20 -2 14 6 33 21 49 23 25 23 25 -13 32 -40 7
-72 43 -62 69 4 12 14 14 41 9 28 -5 35 -3 35 10 0 17 -6 18 -85 20 -39 1 -53
-3 -64 -17 -11 -16 -22 -18 -62 -14 -42 5 -50 3 -59 -13 -8 -14 -21 -20 -45
-20 -30 0 -35 4 -43 32 -7 27 -14 34 -42 38 -34 5 -34 5 -34 82 -1 54 3 79 12
83 18 7 15 30 -9 51 -16 14 -19 26 -14 49 3 16 9 54 14 84 6 44 13 58 41 81
33 27 33 28 12 39 -11 6 -24 21 -28 33 -3 13 -15 31 -25 41 -23 21 -25 33 -37
172 -10 125 -6 145 34 165 80 40 105 72 65 85 -25 7 -45 67 -37 107 3 16 2 37
-3 46 -27 53 -23 69 24 101 43 29 48 30 79 17 46 -19 101 -70 117 -108 7 -18
19 -37 26 -41 7 -4 13 -21 13 -36 0 -28 2 -29 49 -28 53 1 81 -14 81 -44 0
-24 -37 -33 -107 -26 -66 7 -87 21 -72 48 13 25 3 56 -22 69 -10 6 -19 17 -19
24 0 28 -85 45 -121 25 -19 -10 -19 -12 -5 -34 9 -14 16 -35 16 -47 0 -28 26
-77 61 -116 24 -26 36 -30 103 -37 75 -7 78 -6 102 20 24 26 24 26 50 6 26
-21 46 -19 77 8 26 22 50 3 58 -43 7 -44 14 -52 32 -37 16 13 32 154 20 174
-4 6 -6 22 -5 34 8 59 -56 102 -124 83 -68 -19 -84 4 -36 55 40 45 101 62 144
42 46 -22 81 -72 91 -132 4 -27 10 -65 14 -84 3 -19 0 -73 -7 -120 -8 -47 -13
-120 -12 -161 0 -41 -3 -86 -7 -100 -5 -14 -14 -44 -20 -66 -9 -34 -16 -43
-39 -47 -15 -3 -38 -9 -51 -13 -16 -5 -22 -4 -18 4 10 15 -3 42 -19 42 -8 0
-17 -7 -20 -15 -10 -25 42 -65 98 -75 27 -5 57 -14 66 -19 9 -5 26 -5 39 0 27
10 43 -12 43 -60 0 -72 -10 -74 -111 -22 -93 47 -141 58 -163 36 -24 -25 -20
-42 24 -97 31 -40 40 -59 40 -90 0 -27 14 -68 45 -129 51 -103 56 -134 21
-150 -18 -9 -31 -7 -56 6 -32 17 -34 16 -47 -1 -17 -23 -17 -64 0 -64 6 0 21
-3 33 -6 15 -4 23 1 32 22 11 23 17 26 45 20 18 -3 39 -15 49 -26 10 -12 28
-20 47 -20 34 0 36 -2 45 -53 8 -45 -13 -60 -44 -32 -31 28 -114 65 -124 55
-15 -15 12 -87 40 -109 45 -36 101 -280 75 -330 -16 -28 -29 -27 -43 7 -7 15
-23 40 -36 56 -34 42 -44 73 -48 136 -6 121 -2 117 -120 118 -113 2 -121 -3
-85 -49 10 -13 22 -40 26 -59 4 -19 13 -42 19 -50 7 -8 22 -40 34 -71 19 -54
20 -58 4 -87 -67 -120 -65 -114 -58 -168 4 -37 2 -54 -7 -58 -9 -5 -9 -7 0
-12 49 -22 59 -46 51 -114 -4 -31 34 -40 62 -15 31 28 55 16 58 -31 3 -38 1
-42 -29 -55 -41 -16 -77 -14 -101 8 -25 23 -30 14 -34 -67 -3 -57 0 -72 12
-77 17 -6 104 31 104 44 0 5 21 30 46 57 40 44 45 54 41 85 -3 27 3 49 24 87
29 51 29 51 10 90 -36 74 -90 103 -148 79 -45 -19 -49 -19 -57 1 -4 10 4 29
20 47 89 106 234 50 234 -89 0 -29 4 -55 9 -58 16 -10 22 -139 10 -216 -6 -41
-13 -93 -16 -115 -4 -27 -18 -54 -45 -84 -21 -24 -37 -49 -35 -54 5 -16 90
-37 125 -31 30 6 32 4 32 -21 0 -27 -18 -146 -26 -174 -6 -19 -34 5 -34 30 0
19 -90 119 -108 119 -5 0 -15 7 -22 15 -22 26 -34 16 -58 -45 -30 -77 -16
-134 41 -164 31 -17 67 -69 67 -99 0 -33 -23 -87 -49 -118 -17 -19 -41 -47
-54 -64 -22 -26 -32 -30 -70 -29 -37 1 -44 -2 -40 -16 2 -9 -3 -22 -11 -29
-27 -23 -18 -31 33 -31 30 0 53 5 60 14 7 8 27 18 44 22 36 7 70 28 104 61 43
44 110 12 101 -49 -3 -20 -8 -23 -36 -20 -26 3 -37 -2 -53 -22 -11 -14 -26
-26 -32 -26 -7 0 -34 -12 -62 -25 -27 -14 -57 -25 -65 -25 -8 0 -26 -9 -40
-20 -34 -27 -73 -25 -108 5 -37 31 -82 21 -82 -18 0 -13 -5 -28 -10 -33 -7 -7
-7 -33 0 -80 5 -38 10 -75 10 -81 0 -7 12 -19 28 -27 24 -13 30 -12 51 5 13
10 29 19 36 19 7 0 18 6 24 14 9 11 4 18 -24 35 -28 16 -35 27 -35 51 0 42 23
48 61 15 23 -19 38 -24 53 -20 64 21 92 18 119 -15 33 -39 38 -91 7 -83 -17 4
-20 0 -20 -24 0 -16 6 -37 14 -48 7 -11 17 -34 20 -52 4 -17 14 -37 22 -44 8
-6 14 -20 14 -30 0 -10 9 -27 20 -37 27 -25 35 -77 18 -127 -18 -54 -40 -52
-50 4 -4 24 -14 51 -22 60 -8 9 -19 27 -25 41 -6 14 -15 32 -19 40 -39 70 -54
108 -59 150 -9 78 -30 62 -51 -40 -15 -73 -21 -185 -12 -201 5 -7 32 -19 62
-26 52 -13 78 -33 78 -61 0 -15 -88 -9 -122 9 -41 22 -27 -75 22 -159 39 -65
18 -98 -52 -88 -103 15 -133 7 -149 -39 -14 -39 -48 -48 -75 -20 -9 8 -22 15
-30 15 -26 0 -14 -35 22 -64 31 -24 39 -27 60 -17 34 15 34 15 34 -21 0 -18
-11 -53 -25 -77 -14 -23 -25 -48 -25 -54 0 -6 -10 -21 -21 -34 -26 -26 -22
-28 60 -37 32 -3 63 -13 75 -24 28 -25 55 -36 91 -37 27 0 30 -4 33 -33 2 -20
-3 -41 -11 -50 -23 -26 -33 -92 -14 -92 28 0 46 11 74 48 27 36 28 40 28 167
0 130 0 130 30 144 40 19 45 27 45 89 0 37 4 54 15 58 21 8 19 26 -6 48 -16
14 -20 25 -15 48 10 49 23 60 51 42 22 -15 24 -14 35 21 7 22 10 67 6 120 -5
83 -5 86 18 95 15 5 25 20 29 40 4 17 11 29 17 25 13 -8 13 -62 0 -70 -16 -10
-12 -51 8 -67 27 -24 66 -43 57 -28 -5 7 -9 63 -11 125 -1 80 -7 122 -18 144
-13 24 -14 36 -6 52 12 22 10 101 -10 309 -15 159 -9 546 8 577 27 49 33 127
17 205 -8 40 -15 74 -15 76 0 1 11 7 24 12 23 8 24 12 15 42 -5 18 -18 45 -29
60 -14 19 -20 43 -20 77 0 28 -5 72 -11 100 -8 37 -7 55 1 71 8 14 12 84 11
201 0 98 4 181 9 184 12 8 22 -63 20 -147 -2 -40 2 -96 7 -125 6 -34 6 -89 0
-156 -11 -117 -5 -160 21 -155 31 6 45 59 53 198 5 74 11 153 14 175 5 26 1
56 -9 85 -9 25 -16 53 -16 63 0 10 -6 28 -14 40 -7 12 -17 42 -20 67 -4 24
-12 50 -18 57 -6 7 -15 34 -19 60 -5 26 -18 55 -30 66 -16 15 -19 26 -14 61 5
33 2 52 -15 84 -24 45 -23 75 0 80 20 4 60 -77 60 -121 0 -18 8 -44 18 -57 9
-14 22 -47 27 -74 17 -85 45 -64 45 34 -1 47 -44 186 -72 230 -9 14 -18 55
-21 93 -2 37 -11 75 -18 84 -21 24 -26 369 -6 432 16 53 15 112 -3 192 -13 53
-12 58 8 83 11 15 24 47 27 70 16 102 39 85 36 -25 -1 -72 0 -80 16 -77 32 6
47 54 33 106 -7 26 -18 56 -25 67 -7 11 -14 50 -17 87 -4 47 -12 75 -27 94
-11 15 -21 32 -21 39 0 7 -10 25 -22 40 -24 31 -28 93 -9 140 13 30 13 30 26
-7 7 -21 20 -50 30 -64 9 -14 19 -50 22 -80 4 -34 10 -54 19 -54 31 0 27 177
-4 213 -12 14 -17 43 -19 117 -1 70 -7 109 -19 132 -11 21 -19 68 -23 128 -4
69 -11 104 -24 124 -12 18 -16 37 -12 53 11 44 -6 171 -26 195 -23 26 -24 37
-3 67 32 45 55 127 65 231 5 58 14 125 20 149 35 156 34 425 -1 503 -11 24
-20 59 -20 79 0 20 -7 42 -15 49 -16 13 -21 75 -6 84 14 9 23 204 12 255 -6
25 -13 58 -16 73 -4 19 -16 32 -41 44 -52 25 -71 69 -54 128 7 25 16 46 20 46
11 0 20 -38 20 -85 0 -51 14 -75 32 -57 9 9 12 41 9 112 -2 73 1 106 12 127
14 27 37 168 37 229 0 16 -9 43 -20 59 -26 39 -26 102 -1 129 11 12 22 37 26
58 6 32 3 40 -24 69 -17 17 -31 41 -31 53 0 12 -9 35 -20 51 -23 35 -25 64 -7
90 13 17 15 16 26 -15 6 -18 20 -39 30 -47 11 -7 22 -26 26 -43 4 -16 11 -32
15 -35 16 -10 42 55 37 89 -22 138 -28 170 -41 208 -8 24 -19 70 -25 103 -5
33 -16 74 -25 90 -23 44 -23 178 1 173 10 -2 21 -20 27 -46 15 -59 31 -53 32
11 1 77 1 77 39 77 39 0 41 -4 53 -110 7 -65 7 -65 95 -65 66 0 90 -4 97 -15
5 -8 7 -17 5 -21 -8 -12 -110 -57 -150 -65 -49 -11 -55 -33 -28 -107 12 -37
18 -82 18 -157 1 -131 6 -146 50 -154 19 -4 38 -13 42 -21 5 -7 30 -17 58 -22
47 -8 50 -10 57 -46 13 -64 35 -97 64 -97 23 0 25 3 19 23 -3 12 -12 49 -19
82 -15 75 -36 107 -80 123 -39 14 -53 41 -36 72 14 27 24 25 48 -7 21 -28 21
-28 31 -1 5 14 15 29 20 33 15 9 14 38 -4 71 -8 16 -13 41 -10 55 14 62 -34
102 -76 63 -20 -18 -34 -13 -42 16 -6 24 40 53 76 48 17 -2 21 2 20 17 -10 83
-17 102 -52 140 -52 55 -81 99 -81 123 0 11 -7 22 -15 26 -19 7 -20 46 -1 46
30 0 46 -13 46 -36 0 -30 25 -32 40 -4 9 17 7 22 -15 30 -14 5 -25 17 -25 25
0 9 -7 18 -16 22 -8 3 -20 17 -25 31 -10 26 -10 26 -22 2 -10 -20 -23 -26 -58
-30 -50 -6 -93 -29 -109 -60 -19 -35 -37 -22 -61 43 -22 57 -24 77 -24 269 0
152 3 210 13 220 6 6 12 26 12 43 1 38 22 118 36 136 6 8 17 31 23 51 7 21 17
40 22 43 12 8 12 62 0 69 -5 3 -12 21 -15 40 -4 19 -14 37 -22 40 -13 5 -15
16 -11 59 11 95 35 190 50 199 21 11 12 194 -11 220 -9 11 -18 52 -23 110 -4
51 -13 107 -19 123 -7 17 -14 80 -17 140 -3 61 -11 121 -18 135 -12 24 -33
232 -27 275 1 11 2 155 2 320 0 282 -1 302 -20 340 -11 21 -20 56 -20 76 0 21
-8 47 -20 62 -24 30 -27 77 -5 77 8 0 21 -13 30 -30 9 -16 20 -30 25 -30 16 0
12 63 -5 88 -9 12 -19 45 -22 74 -3 29 -14 69 -25 88 -10 19 -18 40 -18 47 0
6 -11 25 -24 40 -14 16 -31 49 -38 72 -7 24 -21 47 -30 52 -21 12 -68 110 -68
144 0 15 -9 38 -20 52 -13 17 -20 41 -20 71 0 30 -5 49 -17 57 -10 7 -14 19
-10 29 9 22 27 11 27 -15 0 -14 6 -19 17 -17 38 7 21 38 -77 138 -55 56 -100
111 -100 121 0 10 -6 22 -13 26 -7 4 -20 20 -30 36 -10 15 -26 27 -39 27 -20
0 -118 67 -118 81 0 24 53 109 69 109 22 0 68 -34 132 -99 29 -28 56 -51 60
-51 5 0 20 -18 34 -40 34 -54 47 -57 108 -26 29 14 56 26 61 26 5 0 14 7 20
16 7 8 27 16 46 17 31 2 35 -1 38 -25 2 -16 -1 -28 -6 -28 -5 0 -21 -11 -36
-25 -15 -14 -32 -25 -37 -25 -6 0 -22 -9 -36 -20 -14 -11 -33 -20 -42 -20 -9
-1 -29 -11 -44 -24 -29 -23 -29 -23 16 -45 31 -15 49 -32 58 -54 16 -38 65
-113 82 -124 7 -5 41 -8 77 -8 55 0 65 -3 68 -19 6 -28 -12 -38 -79 -45 -61
-6 -62 -6 -44 -25 10 -10 24 -39 31 -65 20 -69 38 -117 53 -135 8 -9 16 -40
19 -68 4 -43 10 -56 44 -86 63 -57 107 -72 217 -74 105 -2 131 -9 131 -38 0
-28 28 -50 65 -50 44 0 65 47 34 76 -10 9 -19 21 -19 26 0 4 -9 17 -20 28 -11
11 -20 29 -20 41 0 32 -19 59 -40 59 -23 0 -27 -28 -5 -36 19 -8 20 -48 1 -63
-11 -9 -26 -6 -69 15 -60 30 -89 66 -69 86 29 29 14 41 -48 36 -57 -4 -60 -3
-60 19 0 16 6 23 20 23 30 0 37 28 11 46 -11 8 -21 26 -21 39 0 15 -10 31 -25
41 -14 9 -25 25 -25 35 0 11 -5 28 -12 38 -14 22 2 69 34 98 19 17 20 17 34
-2 24 -35 34 -45 48 -45 32 0 27 65 -5 75 -22 7 -25 28 -5 44 7 6 11 22 8 36
-2 14 -1 41 2 61 7 35 8 35 26 19 24 -22 47 -14 60 21 9 22 6 31 -15 56 -30
35 -35 74 -7 63 9 -4 30 -10 47 -14 32 -7 42 -29 44 -93 1 -26 7 -40 21 -48
11 -6 20 -21 20 -34 0 -34 11 -39 37 -14 24 23 24 23 43 -2 12 -16 21 -51 26
-98 5 -57 11 -76 27 -87 21 -15 21 -15 2 -29 -22 -16 -8 -27 30 -23 13 1 19
-3 17 -14 -1 -8 18 -36 42 -61 41 -43 44 -50 50 -119 5 -50 4 -75 -3 -77 -6
-2 -11 -8 -11 -13 0 -16 26 -10 45 11 10 11 27 20 37 20 16 0 19 5 13 29 -7
33 17 50 42 29 12 -10 13 -7 8 18 -7 33 -33 117 -46 152 -5 13 -9 35 -9 51 0
34 -49 81 -85 81 -18 0 -25 5 -25 20 0 11 5 20 10 20 19 0 10 19 -11 22 -16 2
-27 18 -41 58 -25 67 -32 76 -65 85 -17 4 -31 1 -43 -10 -24 -22 -64 -16 -69
10 -2 11 -9 24 -17 28 -18 10 -18 31 1 47 21 18 19 29 -10 42 -18 8 -27 22
-31 49 -4 23 -20 52 -40 75 -47 51 -46 88 3 131 42 38 42 38 90 18 68 -29 143
-13 143 29 0 39 -40 106 -69 117 -14 6 -113 12 -220 15 -142 3 -198 7 -210 17
-28 24 -135 92 -163 104 -25 11 -28 18 -28 56 0 30 -7 51 -20 67 -11 13 -20
34 -20 47 0 66 -62 132 -138 148 -18 4 -45 13 -60 21 -15 8 -37 14 -49 14 -31
0 -65 15 -85 36 -49 54 -58 65 -72 92 -8 16 -27 42 -43 59 -28 30 -28 30 -31
254 -2 123 -5 232 -8 242 -5 14 -15 17 -49 16 -24 -2 -49 2 -57 8 -21 17 -116
22 -136 7 -23 -18 -78 -17 -107 2 -13 9 -30 12 -36 8 -7 -4 -45 -8 -83 -9 -39
-1 -79 -5 -88 -9 -13 -6 -25 0 -45 23 -15 17 -31 31 -36 31 -4 0 -27 18 -49
40 -23 22 -60 50 -83 61 -22 11 -49 29 -60 39 -37 33 -62 41 -75 25 -14 -17
-40 -20 -40 -6 0 5 -33 34 -74 65 -74 55 -125 72 -142 45z m132 -484 c3 -8 14
-17 25 -20 23 -8 26 -35 4 -35 -18 0 -66 51 -58 62 7 13 23 9 29 -7z m-605
-35 c10 -6 19 -19 19 -30 0 -26 35 -34 105 -25 53 6 56 5 85 -27 36 -39 37
-41 4 -67 -27 -21 -56 -16 -96 17 -9 8 -25 11 -37 7 -25 -8 -102 35 -125 69
-29 45 -1 80 45 56z m703 -75 c8 -8 18 -24 21 -36 5 -16 12 -19 35 -14 47 10
77 -48 46 -90 -13 -18 -15 -18 -41 13 -19 22 -35 32 -55 32 -16 0 -32 5 -35
10 -3 6 -13 10 -21 10 -24 0 -74 42 -74 62 0 14 5 17 24 12 14 -3 33 -1 43 5
25 14 39 14 57 -4z m830 -124 c32 -20 76 -72 76 -90 0 -22 -56 -23 -162 -2
-98 20 -128 22 -267 16 -150 -7 -157 -7 -175 14 -27 30 -7 51 53 51 25 1 75 7
111 14 36 8 125 14 199 15 116 1 138 -2 165 -18z m-934 -5 c0 -8 -4 -18 -10
-21 -13 -8 -52 14 -45 26 10 15 55 11 55 -5z m124 -46 c39 -15 43 -33 8 -38
-32 -5 -86 51 -76 80 7 22 7 22 19 -3 8 -14 30 -31 49 -39z m355 -131 c42 -35
12 -44 -58 -18 -80 28 -85 39 -19 39 38 -1 60 -6 77 -21z m909 -415 c-5 -28
-28 -29 -28 -1 0 13 3 27 7 31 10 10 25 -10 21 -30z m120 -63 c27 -16 9 -45
-35 -56 -23 -5 -53 -21 -67 -34 -33 -31 -76 -104 -76 -129 0 -18 -49 -91 -62
-92 -3 0 -9 19 -13 43 -8 49 -20 75 -46 100 -23 22 -24 50 -4 67 12 10 19 10
27 2 7 -7 20 -12 30 -12 9 0 26 -9 37 -21 19 -21 19 -21 26 21 9 55 43 92 97
106 54 15 70 16 86 5z m332 -210 c55 -49 55 -49 58 -153 3 -70 -2 -134 -13
-194 -10 -49 -19 -114 -22 -144 -5 -67 -41 -149 -66 -150 -31 0 -39 44 -25
139 7 47 12 113 11 146 -7 194 -12 263 -22 288 -20 51 -10 117 19 117 3 0 30
-22 60 -49z m-770 -40 c0 -10 -18 -30 -40 -46 -22 -15 -40 -31 -40 -35 0 -4
-11 -15 -25 -24 -25 -16 -25 -16 -25 12 0 37 70 112 105 112 18 0 25 -5 25
-19z m415 -58 c37 -37 42 -94 8 -107 -26 -10 -83 5 -93 25 -36 67 33 134 85
82z m132 -305 c13 -17 25 -92 17 -112 -11 -29 -33 -17 -40 22 -4 20 -11 45
-15 54 -18 34 15 65 38 36z m-800 -395 c3 -7 -5 -17 -16 -23 -18 -9 -21 -8
-21 8 0 32 28 43 37 15z m-219 -99 c-2 -22 -7 -39 -13 -39 -12 0 -19 60 -10
83 10 28 27 -3 23 -44z m63 -344 c10 -6 19 -17 19 -25 0 -7 11 -26 24 -42 23
-27 25 -53 4 -53 -12 0 -108 97 -108 109 0 22 29 27 61 11z m985 -954 c15 -63
-27 -89 -52 -31 -20 48 -18 55 16 55 23 0 31 -5 36 -24z m-393 -436 c5 -19 15
-42 23 -51 8 -8 14 -22 14 -30 0 -8 9 -31 20 -52 36 -68 41 -120 15 -176 -13
-27 -28 -52 -34 -55 -18 -11 -13 -48 9 -71 31 -33 5 -76 -26 -45 -8 8 -15 6
-23 -4 -10 -12 -9 -17 8 -25 41 -22 84 -69 78 -85 -5 -12 -21 -16 -72 -16 -90
0 -105 10 -105 65 0 32 -6 50 -22 68 -13 13 -28 32 -34 43 -9 16 -23 19 -78
19 -75 1 -88 10 -79 60 8 38 18 45 67 45 44 0 111 -39 121 -70 3 -10 12 -21
20 -24 9 -3 15 -18 15 -35 0 -36 17 -49 37 -28 20 20 30 165 13 196 -13 25
-33 272 -23 297 11 28 46 12 56 -26z m303 -102 c2 -2 5 -35 6 -73 4 -82 -10
-92 -61 -49 -25 21 -31 33 -29 58 2 26 -1 32 -19 34 -22 3 -30 21 -16 35 6 7
112 2 119 -5z m164 -152 c0 -38 -17 -57 -31 -35 -17 27 -11 69 11 69 16 0 20
-7 20 -34z m-189 -87 c52 -68 68 -160 65 -376 -1 -146 -7 -168 -44 -168 -14 0
-16 -8 -14 -45 5 -67 25 -77 76 -36 41 33 78 56 92 56 12 0 -5 -123 -21 -146
-8 -13 -15 -40 -15 -60 0 -48 -13 -36 -15 13 -1 34 -5 39 -38 52 -33 12 -39
12 -63 -5 -14 -11 -43 -28 -63 -40 -48 -27 -54 -65 -15 -105 15 -16 33 -29 40
-29 7 0 17 -19 21 -42 8 -41 11 -43 46 -46 29 -3 37 -7 37 -23 0 -11 -8 -22
-17 -26 -10 -3 -27 -14 -38 -23 -40 -34 -126 -44 -134 -15 -16 54 -62 93 -74
62 -7 -18 2 -31 31 -46 27 -15 28 -37 2 -51 -33 -17 -25 -47 19 -70 22 -10 41
-25 43 -31 6 -17 67 -13 87 5 30 27 77 31 90 8 12 -23 14 -72 3 -87 -4 -6 -32
-11 -62 -12 -30 0 -84 -6 -120 -12 -36 -6 -80 -14 -97 -17 -30 -4 -49 -34 -23
-34 6 0 27 -11 48 -24 20 -13 53 -27 72 -31 91 -19 107 -41 115 -156 3 -46 8
-103 11 -126 6 -39 4 -43 -20 -54 -22 -11 -29 -9 -49 7 -12 11 -34 25 -49 32
-19 8 -31 23 -39 53 -12 39 -11 42 12 60 24 20 24 20 0 37 -47 34 -70 61 -77
88 -12 48 -46 98 -55 82 -5 -7 -9 -23 -9 -34 0 -31 -24 -48 -48 -35 -10 5 -28
7 -40 4 -25 -6 -27 -1 -10 26 15 24 4 51 -22 51 -13 0 -20 -7 -20 -19 0 -11
-4 -23 -10 -26 -5 -3 -15 -15 -20 -26 -9 -16 -7 -21 15 -29 30 -11 25 -30 -7
-30 -12 0 -30 -8 -40 -17 -14 -13 -21 -14 -30 -5 -7 7 -29 12 -49 12 -43 0
-54 11 -39 40 11 20 -5 65 -36 100 -8 10 -14 45 -15 90 -2 58 -7 80 -23 98
-19 22 -19 22 2 45 12 13 22 28 22 33 0 26 23 32 49 13 37 -27 91 -34 116 -16
20 15 20 16 -4 41 -14 14 -35 26 -47 26 -30 0 -48 31 -31 54 13 17 47 13 47
-6 0 -5 5 -6 10 -3 6 3 10 15 10 26 0 17 -5 19 -42 13 -64 -9 -68 -11 -68 -39
0 -20 -5 -25 -24 -25 -30 0 -42 16 -26 35 10 12 10 18 0 30 -16 20 -8 100 13
123 28 32 53 147 39 185 -7 18 -12 50 -12 71 0 26 -9 51 -29 79 -20 29 -32 60
-36 98 -9 76 -1 99 34 99 30 0 92 36 99 58 2 7 -6 12 -22 12 -19 0 -29 7 -36
26 -16 41 -12 94 6 101 23 8 40 -17 47 -70 8 -58 77 -137 119 -137 36 0 45
-22 24 -55 -25 -38 -76 -35 -111 6 -24 29 -28 31 -50 19 -31 -17 -39 -53 -20
-90 19 -36 42 -50 77 -43 35 7 68 -26 69 -69 0 -35 32 -68 76 -82 45 -14 83
96 46 137 -30 34 -43 73 -43 127 0 51 12 64 43 48 12 -6 23 -6 32 2 7 6 46 13
86 15 113 8 145 20 158 57 10 28 9 35 -8 48 -11 9 -21 33 -24 59 -3 24 -11 48
-19 52 -18 12 -95 11 -119 -1 -16 -9 -19 -7 -19 12 1 24 33 67 66 87 32 20
114 8 135 -20z m199 -215 c0 -12 -5 -26 -10 -29 -7 -4 -8 -24 -4 -50 8 -55 -7
-90 -25 -57 -9 17 -9 32 0 62 12 38 11 42 -14 68 -25 26 -35 61 -21 75 13 12
74 -45 74 -69z m-41 -651 c6 -12 5 -26 -6 -47 -15 -28 -16 -29 -29 -11 -15 21
-17 35 -8 59 8 21 31 20 43 -1z m-434 -645 c4 -13 22 -54 40 -93 45 -96 69
-170 61 -186 -9 -19 -27 -48 -51 -83 -10 -16 -19 -46 -19 -70 -1 -37 -4 -41
-28 -44 -32 -4 -32 -4 -18 88 8 56 7 70 -12 110 -17 36 -22 71 -26 173 -4 127
-4 127 21 127 18 0 28 -7 32 -22z m-278 -47 c9 -35 86 -43 103 -11 13 25 30
17 29 -13 -1 -36 -54 -122 -73 -119 -20 4 -21 -21 -1 -38 22 -18 9 -30 -34
-30 -20 0 -42 -5 -48 -11 -7 -7 -19 -9 -28 -5 -21 8 -13 52 16 81 19 19 19 20
-9 41 -27 22 -27 22 1 33 34 13 34 24 1 46 -20 13 -23 19 -13 31 17 20 50 17
56 -5z m86 -289 c51 -20 88 -56 112 -109 8 -18 21 -33 29 -33 10 0 16 -9 16
-25 0 -20 6 -25 38 -30 63 -10 84 -23 80 -48 -3 -21 -7 -22 -83 -19 -85 4
-121 20 -97 44 19 19 14 46 -13 64 -14 9 -25 22 -25 29 0 15 -51 35 -90 35
-35 0 -56 -23 -36 -39 7 -6 17 -30 20 -53 10 -61 77 -146 119 -150 44 -4 46
-30 6 -59 -32 -23 -32 -23 -68 -3 -22 12 -37 28 -39 42 -2 12 -9 22 -16 22
-14 0 -46 -73 -46 -105 0 -28 40 -65 70 -65 36 0 57 -18 88 -75 35 -62 51 -72
91 -55 40 16 48 48 27 103 -9 24 -16 53 -16 65 0 13 -4 31 -9 40 -4 9 -11 37
-14 63 -6 45 -6 45 51 57 48 10 58 10 65 -3 11 -20 63 -19 71 1 5 12 16 15 43
12 32 -4 43 0 70 27 37 36 43 65 14 65 -14 0 -20 10 -25 41 -11 71 -75 110
-122 74 -25 -19 -44 -19 -44 0 0 31 26 67 60 85 34 17 41 18 87 4 35 -10 53
-22 61 -39 7 -14 16 -25 21 -25 5 0 17 -29 26 -65 19 -69 19 -64 -15 -220 -6
-32 -7 -59 -1 -75 5 -14 12 -55 15 -91 4 -59 2 -70 -20 -102 -21 -32 -30 -37
-63 -37 -22 0 -44 6 -51 15 -17 21 -37 19 -50 -4 -19 -36 -12 -40 55 -39 54 1
70 -3 89 -21 18 -17 33 -21 71 -19 49 3 49 3 58 -40 15 -74 -12 -92 -77 -53
-17 10 -47 22 -66 26 -19 4 -50 16 -68 27 -41 25 -61 19 -55 -16 3 -14 0 -33
-7 -41 -23 -28 -3 -79 50 -128 65 -60 74 -95 68 -263 -4 -103 -9 -136 -23
-158 -16 -24 -16 -29 -4 -37 20 -13 24 -12 57 16 36 30 56 31 82 5 37 -37 21
-140 -17 -112 -10 6 -29 17 -42 22 -27 12 -189 11 -196 -1 -3 -3 2 -21 11 -38
24 -48 8 -51 -34 -6 -24 26 -36 48 -34 62 2 14 -3 23 -17 28 -16 5 -21 15 -21
45 0 32 -4 38 -24 42 -37 7 -48 -10 -29 -44 26 -43 8 -54 -64 -39 -32 7 -69
19 -83 26 -39 20 -49 10 -35 -33 7 -20 18 -38 24 -40 9 -3 9 -7 0 -18 -8 -10
-16 -11 -29 -4 -13 7 -21 7 -25 0 -9 -15 4 -30 26 -30 28 0 75 -26 83 -46 14
-37 -47 -193 -76 -194 -13 0 -18 8 -18 30 0 34 -15 40 -23 10 -7 -27 -33 -25
-63 5 -34 34 -26 51 20 47 52 -4 51 34 -4 81 -29 25 -40 42 -40 63 -1 16 -7
40 -15 54 -21 36 -19 40 19 40 46 0 51 12 30 70 -17 49 -17 50 2 64 19 14 18
15 -8 43 -47 50 -55 113 -13 113 25 0 28 21 6 44 -15 16 -21 35 -21 68 0 28
-5 48 -12 51 -19 6 -13 98 6 113 21 15 20 22 -5 42 -27 23 -39 99 -16 108 27
10 109 -77 105 -112 -2 -21 -9 -30 -25 -32 -12 -2 -26 -15 -33 -32 -15 -36 -6
-54 20 -40 10 5 40 10 65 10 47 0 47 0 41 38 -3 20 -8 63 -12 94 -6 54 -8 57
-38 64 -17 3 -44 20 -59 38 -30 32 -30 32 19 62 20 12 13 31 -45 124 -22 35
-30 62 -35 123 -7 77 -7 77 47 77 78 0 92 20 44 64 -36 33 -36 33 -36 124 0
87 1 92 27 111 33 25 27 25 85 3z m607 -98 c0 -54 -4 -83 -10 -79 -17 11 -11
165 6 165 2 0 4 -39 4 -86z m415 19 c0 -6 -22 -28 -49 -48 -52 -40 -69 -36
-64 15 3 25 16 29 51 15 14 -6 20 -2 24 14 6 23 38 26 38 4z m-865 -1403 c21
0 40 -28 40 -58 0 -11 7 -25 15 -32 8 -7 15 -20 15 -29 0 -9 11 -36 24 -61 45
-85 52 -123 27 -163 -11 -19 -21 -42 -21 -51 0 -9 -10 -30 -22 -46 -19 -26
-20 -35 -11 -75 9 -41 8 -45 -8 -45 -30 0 -39 33 -39 135 0 66 -5 105 -15 125
-12 24 -33 198 -35 288 0 9 -7 11 -20 7 -35 -11 -48 7 -15 21 25 10 31 10 38
-2 4 -8 17 -14 27 -14z m353 -180 c33 -122 8 -161 -65 -97 -50 43 -59 82 -24
98 16 8 26 20 26 34 0 26 9 37 29 33 10 -2 23 -28 34 -68z m-613 -127 c17 4
17 3 1 -24 -19 -35 -29 -33 -52 11 -22 41 -14 59 13 30 12 -12 28 -20 38 -17z
m118 -85 c44 -26 92 -78 92 -101 0 -26 11 -47 25 -47 8 0 15 -12 17 -27 3 -26
7 -28 53 -31 55 -4 75 -15 75 -43 0 -22 -7 -23 -105 -19 -79 2 -95 11 -77 40
18 30 15 43 -20 81 -46 49 -103 74 -135 60 -37 -17 -51 -13 -67 17 -14 27 -13
31 7 60 27 39 76 43 135 10z m-78 -157 c5 -11 10 -34 10 -51 0 -27 -3 -31 -22
-28 -18 2 -24 11 -26 36 -6 58 16 83 38 43z m703 -139 c25 -11 28 -17 25 -50
-6 -76 -65 -25 -67 58 0 14 3 20 7 15 4 -6 20 -16 35 -23z m-447 -1207 c3 -13
12 -29 20 -36 8 -6 14 -21 14 -33 0 -11 7 -32 15 -46 65 -112 67 -142 19 -222
-33 -53 -36 -65 -32 -114 4 -47 2 -54 -13 -54 -24 0 -33 32 -31 108 1 42 -6
85 -19 125 -20 59 -44 271 -33 289 12 19 54 8 60 -17z m248 -40 c67 -20 81
-43 72 -117 -4 -29 -8 -65 -8 -80 -1 -16 -7 -28 -14 -28 -19 0 -75 50 -68 61
3 5 -4 24 -15 43 -12 18 -21 39 -21 47 0 7 -12 23 -27 35 -17 14 -24 26 -20
37 8 21 34 21 101 2z m-504 -25 c6 -12 10 -35 8 -53 -4 -41 35 -48 41 -7 3 26
19 42 33 34 11 -7 10 -52 -1 -58 -5 -4 -12 -28 -16 -56 -7 -50 -7 -50 -66 -49
-32 1 -59 3 -59 5 0 3 7 20 15 40 16 38 4 53 -31 40 -12 -5 -15 -2 -10 10 3 8
1 24 -5 35 -14 28 -3 56 29 68 41 14 50 13 62 -9z m670 -471 c0 -24 -4 -38
-10 -34 -17 10 -11 75 7 75 2 0 3 -18 3 -41z m-99 -801 c23 -12 44 -30 47 -40
2 -10 7 -18 11 -18 4 0 17 -9 29 -20 24 -23 20 -54 -6 -41 -60 28 -112 58
-144 84 -65 52 -19 78 63 35z m-560 -1062 c4 -15 15 -36 24 -46 32 -36 -10
-55 -53 -24 -22 15 -32 81 -15 98 14 14 37 0 44 -28z m74 -130 c11 -17 29 -26
60 -31 25 -3 45 -8 45 -11 0 -8 -34 -59 -45 -66 -52 -38 -147 66 -106 116 18
22 28 20 46 -8z m215 -2016 c28 -27 56 -50 62 -50 17 0 78 -50 78 -63 0 -7
-13 -27 -28 -46 -28 -33 -28 -33 -116 53 -48 47 -94 86 -102 86 -20 0 -17 47
4 59 31 19 50 12 102 -39z"/>
<path d="M12348 15464 c-3 -75 0 -81 41 -59 17 8 41 15 54 15 29 0 67 38 67
67 0 20 -4 21 -53 16 -41 -4 -57 -2 -69 11 -28 28 -36 18 -40 -50z"/>
<path d="M12378 15215 c-17 -37 4 -55 63 -55 61 0 61 8 4 48 -55 38 -53 38
-67 7z"/>
<path d="M12170 15163 c1 -22 30 -44 49 -38 12 3 46 -1 76 -10 62 -18 75 -14
75 19 0 32 -83 46 -113 19 -18 -17 -19 -17 -32 0 -12 17 -55 24 -55 10z"/>
<path d="M12089 15131 c14 -25 61 -30 61 -6 0 8 -6 15 -12 15 -7 0 -24 3 -37
7 -21 5 -22 4 -12 -16z"/>
<path d="M12070 15041 c0 -33 57 -81 96 -81 13 0 25 -10 32 -25 6 -14 28 -33
48 -42 34 -17 37 -17 49 0 7 9 17 17 23 17 20 0 23 20 8 42 -9 12 -16 31 -16
41 0 9 -8 20 -17 24 -10 3 -25 12 -33 18 -8 7 -54 15 -102 18 -78 4 -88 3 -88
-12z"/>
<path d="M12190 14760 c-9 -16 -19 -20 -50 -18 -21 2 -40 -1 -42 -7 -2 -5 17
-11 41 -13 32 -2 54 -12 78 -33 19 -16 40 -29 48 -29 8 0 25 -11 38 -25 23
-26 23 -26 46 -1 36 38 25 59 -37 71 -43 8 -57 16 -73 43 -24 37 -34 40 -49
12z"/>
<path d="M12067 14623 c-28 -27 21 -73 82 -77 48 -4 51 -2 66 27 18 35 12 46
-15 29 -31 -19 -78 -15 -90 8 -11 20 -31 26 -43 13z"/>
<path d="M12526 13705 c-3 -9 -6 -25 -6 -35 0 -29 -99 -44 -124 -19 -6 5 -18
9 -27 9 -16 0 -19 -36 -10 -122 1 -4 18 -4 39 -1 41 7 108 53 117 83 3 10 15
22 26 25 15 5 19 14 17 38 -3 34 -22 47 -32 22z"/>
<path d="M12260 13305 c-18 -22 2 -63 36 -71 47 -12 54 54 8 75 -31 14 -29 14
-44 -4z"/>
<path d="M12231 13159 c-21 -8 -23 -12 -10 -24 8 -7 28 -15 44 -17 26 -3 30 0
33 25 4 30 -19 35 -67 16z"/>
<path d="M12320 13080 c0 -38 32 -99 66 -125 34 -26 34 -26 34 2 0 15 7 41 15
57 8 15 15 39 15 52 0 22 -3 23 -49 17 -31 -3 -51 -1 -55 6 -11 18 -26 13 -26
-9z"/>
<path d="M12183 12948 c-6 -30 -14 -42 -24 -39 -33 8 -42 4 -52 -23 -8 -25 -7
-32 13 -48 35 -28 64 -20 68 20 3 32 24 44 37 21 4 -6 21 -9 38 -7 25 2 34 -2
42 -19 10 -23 39 -31 49 -14 3 4 -6 19 -19 31 -14 13 -25 31 -25 41 0 21 -17
35 -52 44 -15 4 -29 13 -32 21 -11 28 -33 14 -43 -28z"/>
<path d="M12171 12784 c-18 -18 -20 -24 -8 -24 29 0 47 12 47 31 0 24 -9 23
-39 -7z"/>
<path d="M3122 20438 c3 -7 17 -15 33 -16 25 -3 27 -2 16 12 -16 19 -55 22
-49 4z"/>
<path d="M5702 20438 c-22 -22 -15 -37 13 -25 24 12 29 27 9 34 -5 2 -15 -2
-22 -9z"/>
<path d="M8042 20439 c-31 -12 -24 -30 18 -44 25 -8 40 -24 62 -66 16 -30 40
-65 53 -78 23 -24 25 -24 44 -7 39 36 34 66 -22 120 -83 79 -111 93 -155 75z"/>
<path d="M3346 20421 c-15 -17 -16 -23 -6 -36 17 -21 27 -19 33 7 10 36 -6 52
-27 29z"/>
<path d="M3475 20431 c-6 -11 45 -111 58 -111 4 0 7 10 7 23 0 13 6 32 14 42
21 29 3 55 -39 55 -18 0 -36 -4 -40 -9z"/>
<path d="M8786 20373 c5 -44 14 -65 35 -87 39 -40 36 -53 -13 -67 -24 -6 -71
-26 -105 -43 -57 -28 -63 -29 -80 -14 -10 9 -37 19 -60 23 -23 3 -47 13 -54
21 -16 20 -36 17 -42 -6 -7 -27 -19 -25 -58 11 -74 67 -132 88 -146 52 -5 -12
6 -27 34 -52 39 -35 64 -81 44 -81 -22 0 -66 22 -78 39 -19 28 -80 37 -104 15
-21 -19 -58 -13 -100 17 -15 10 -33 19 -41 19 -23 0 -38 22 -38 57 0 18 -4 33
-10 33 -5 0 -16 16 -25 36 -13 32 -17 35 -51 32 -42 -3 -56 -23 -25 -33 28 -9
26 -23 -4 -31 -28 -7 -33 -29 -10 -38 8 -3 24 -25 36 -49 23 -48 60 -72 123
-81 57 -8 131 -86 82 -86 -21 0 -30 -20 -17 -33 6 -6 11 -19 11 -29 0 -30 -39
-22 -58 12 -19 32 -57 47 -78 29 -21 -17 -42 -4 -52 33 -12 48 -27 40 -30 -17
-4 -66 -16 -78 -67 -72 -27 4 -47 14 -61 32 -21 26 -21 26 -63 9 -34 -13 -47
-26 -61 -58 -18 -41 -18 -41 -60 4 -23 25 -48 57 -56 72 -14 27 -14 27 -42 -1
-15 -15 -33 -30 -40 -32 -20 -7 14 -66 48 -84 15 -8 30 -22 34 -31 7 -19 -19
-54 -40 -54 -17 0 -37 -37 -28 -52 4 -6 -5 -21 -21 -34 -16 -13 -25 -27 -20
-33 9 -16 66 -4 82 16 7 8 32 18 57 20 46 6 46 6 40 43 -6 35 -4 38 44 73 63
47 93 46 161 -5 18 -13 27 -15 37 -7 7 6 28 9 46 7 35 -3 54 26 27 43 -7 4
-10 11 -6 16 4 4 17 2 27 -5 11 -7 27 -12 36 -12 9 0 39 -13 66 -30 26 -16 52
-30 57 -30 5 0 14 -7 21 -15 7 -8 23 -15 36 -15 20 0 24 -5 24 -30 0 -33 -8
-36 -57 -18 -29 11 -35 10 -58 -12 -32 -30 -32 -38 2 -42 19 -2 29 -11 37 -35
13 -37 74 -89 116 -98 32 -7 110 11 110 25 0 5 -13 16 -30 25 -16 9 -30 22
-30 30 0 8 -8 15 -18 15 -17 0 -72 48 -72 62 0 3 9 8 20 11 14 3 20 14 20 31
0 28 14 35 24 11 3 -8 14 -15 25 -15 25 0 47 -32 55 -81 8 -44 88 -106 148
-115 21 -4 48 -18 64 -35 25 -26 31 -28 83 -23 38 4 77 1 121 -11 36 -10 106
-18 155 -20 50 -1 102 -5 116 -9 29 -8 94 19 129 54 13 13 34 20 58 21 48 0
165 31 186 48 49 41 -3 69 -94 50 -30 -6 -99 -12 -152 -14 -54 -2 -123 -9
-155 -15 -67 -14 -235 -7 -363 16 -80 15 -99 20 -167 44 -16 5 -40 12 -55 15
-15 3 -29 14 -33 25 -3 11 -13 20 -21 20 -8 0 -14 9 -14 20 0 24 26 26 51 4
11 -10 25 -13 39 -9 22 7 22 7 1 22 -12 8 -21 20 -21 28 0 7 -12 27 -27 43
-16 17 -38 43 -50 59 -22 27 -24 27 -37 9 -18 -22 -36 -13 -29 14 4 15 -2 22
-21 30 -16 6 -31 22 -37 40 -7 19 -18 30 -30 30 -10 0 -19 5 -19 10 0 6 7 10
15 10 8 0 21 13 30 29 22 44 33 46 66 16 15 -16 56 -43 91 -60 34 -18 67 -41
72 -51 6 -10 20 -35 32 -55 13 -21 25 -62 29 -101 7 -61 10 -67 48 -97 38 -29
90 -41 101 -23 3 4 -11 25 -30 46 -32 35 -35 43 -29 77 4 22 10 39 15 39 13 0
60 -59 75 -96 10 -24 20 -34 36 -34 12 0 30 -6 38 -14 9 -7 49 -17 89 -20 74
-7 74 -7 68 21 -2 15 -8 47 -11 71 -4 23 -11 42 -16 42 -5 0 -29 18 -53 40
-44 40 -64 48 -82 30 -8 -8 -175 -32 -182 -26 -1 2 4 16 13 32 8 16 15 41 15
56 0 35 19 46 37 22 12 -16 16 -17 34 -6 18 12 24 11 43 -6 36 -32 46 -35 67
-16 25 22 24 34 -6 78 -34 50 -34 86 0 86 32 0 104 -36 112 -55 4 -11 15 -13
42 -10 27 4 49 -1 85 -20 27 -14 55 -25 62 -25 7 0 22 -14 34 -31 12 -16 40
-41 62 -55 35 -22 39 -29 33 -52 -12 -50 -87 -84 -102 -47 -5 14 -7 14 -24 -1
-22 -20 -39 -11 -39 20 0 35 -22 48 -77 44 -41 -3 -48 -6 -51 -25 -3 -17 3
-26 22 -33 21 -8 26 -16 26 -44 0 -25 8 -43 28 -61 25 -24 32 -26 82 -19 87
11 179 7 221 -10 42 -17 87 -20 138 -10 35 7 42 24 11 24 -62 0 -131 68 -177
173 -7 15 -19 27 -28 27 -25 0 -16 64 9 68 21 4 96 -70 122 -119 17 -34 64
-68 124 -91 39 -16 54 -16 126 -6 65 9 93 9 137 -1 76 -19 127 -3 127 39 0 19
-7 33 -21 40 -11 7 -29 19 -39 28 -56 51 -87 64 -112 48 -13 -8 -22 -6 -41 12
-30 28 -37 28 -37 -3 0 -35 -46 -58 -65 -32 -7 10 -26 17 -45 17 -36 0 -86 31
-95 59 -6 21 -45 41 -79 41 -14 0 -48 22 -85 55 -34 30 -65 55 -70 55 -4 0
-20 11 -35 25 -15 14 -31 25 -37 25 -15 0 -10 47 7 64 8 9 20 16 25 16 15 0
10 18 -14 46 -24 27 -24 27 -62 4 -35 -21 -37 -25 -31 -60 5 -30 2 -39 -10
-44 -27 -10 -77 26 -86 61 -5 17 -16 34 -26 37 -9 4 -28 31 -41 61 -32 76 -55
75 -45 -2z m-322 -316 c7 -27 6 -41 -3 -50 -16 -16 -41 16 -41 53 0 54 30 52
44 -3z m-305 -108 c35 -12 42 -39 11 -39 -11 0 -23 -7 -26 -15 -10 -25 -37
-18 -30 8 3 12 6 30 6 40 0 20 -1 20 39 6z"/>
<path d="M4945 20413 c-47 -12 -35 -39 37 -78 15 -8 28 -25 30 -37 2 -12 12
-27 23 -33 11 -5 30 -20 43 -32 12 -13 28 -23 35 -23 7 0 32 -25 56 -55 24
-30 52 -57 61 -60 10 -3 21 -12 24 -20 3 -8 12 -15 20 -15 7 0 21 -11 30 -25
11 -16 24 -24 39 -22 16 1 23 -4 25 -21 3 -21 1 -22 -17 -13 -11 6 -33 11 -50
11 -19 0 -43 11 -65 30 -28 25 -40 29 -62 24 -24 -6 -26 -5 -21 15 6 25 -8 27
-50 9 -58 -26 -57 -48 7 -87 46 -28 50 -34 50 -70 0 -22 6 -44 15 -51 8 -7 15
-18 15 -25 0 -28 53 -109 105 -160 30 -30 55 -60 55 -65 0 -6 19 -19 42 -29
42 -17 42 -17 -4 -43 -36 -20 -66 -27 -142 -32 -53 -4 -122 -14 -154 -22 -77
-20 -112 -21 -127 -1 -20 27 -55 22 -55 -8 0 -23 -4 -25 -35 -23 -41 3 -55 -7
-22 -16 14 -3 27 -15 30 -26 4 -17 13 -19 88 -17 104 2 116 -2 158 -56 35 -43
110 -97 136 -97 7 0 17 -9 20 -21 5 -15 12 -19 28 -15 12 3 28 6 35 6 9 0 8 7
-4 26 -9 14 -23 23 -30 20 -17 -6 -38 20 -30 39 7 19 32 19 48 0 7 -9 21 -24
31 -34 10 -10 15 -24 12 -32 -3 -9 10 -23 39 -38 35 -20 48 -35 66 -77 21 -53
47 -73 72 -57 7 4 20 6 29 5 9 -2 29 14 44 34 24 31 26 39 16 61 -16 36 -52
28 -63 -14 -14 -53 -61 -42 -78 17 -8 27 -6 37 6 51 17 19 9 44 -21 69 -9 7
-23 27 -31 44 -8 17 -21 42 -29 56 -20 34 -19 86 1 94 32 12 83 -42 99 -106 7
-27 25 -39 25 -18 0 23 36 6 95 -45 34 -30 72 -55 84 -55 16 0 23 -8 28 -30 3
-16 11 -30 18 -30 38 0 67 91 32 98 -10 2 -25 -5 -32 -15 -7 -10 -17 -14 -22
-10 -4 5 0 14 10 21 23 18 22 77 -2 107 -10 13 -21 33 -25 44 -9 31 -62 85
-83 85 -14 0 -12 5 12 25 24 19 42 24 86 25 57 0 57 0 57 -50 0 -28 6 -60 15
-74 9 -12 17 -38 19 -57 4 -46 22 -39 29 11 3 23 12 46 20 51 56 35 254 54
277 26 16 -19 -37 -127 -74 -155 -16 -12 -39 -32 -52 -44 -23 -23 -23 -23 5
-26 76 -7 114 -25 149 -70 32 -42 45 -97 28 -115 -11 -11 -41 11 -48 35 -6 24
-63 58 -95 58 -24 0 -34 -26 -21 -50 6 -10 10 -30 10 -44 0 -56 79 -156 124
-156 21 0 26 -5 26 -25 0 -47 -107 -47 -128 0 -6 14 -16 25 -22 25 -27 0 -53
-121 -30 -135 27 -16 9 -35 -34 -35 -34 0 -55 8 -95 35 -58 40 -67 42 -76 16
-8 -26 -39 -35 -66 -20 -12 6 -37 9 -56 6 -28 -5 -39 -1 -58 18 -25 28 -75 34
-95 10 -6 -8 -22 -17 -33 -21 -12 -4 -37 -18 -55 -32 -33 -25 -33 -25 -3 -43
16 -9 32 -22 35 -28 4 -6 29 -13 57 -17 27 -4 52 -11 55 -15 9 -15 45 -10 71
11 14 11 32 20 39 20 7 0 18 -9 24 -20 13 -25 48 -26 66 -2 12 16 66 17 853
19 840 3 840 3 885 -35 65 -54 116 -83 139 -80 37 5 29 25 -23 57 -33 20 -50
38 -50 51 0 10 -8 24 -19 29 -10 6 -21 23 -24 38 -3 16 -10 46 -14 68 -7 33
-13 41 -35 43 -24 3 -28 -1 -34 -32 -3 -20 -3 -47 0 -61 13 -52 -51 -39 -128
25 -61 51 -150 61 -144 16 10 -83 -84 -42 -145 64 -15 25 -36 51 -48 58 -20
13 -24 11 -51 -22 -43 -52 -59 -48 -56 15 3 50 3 50 -34 64 -21 7 -38 11 -38
9 0 -2 5 -14 11 -28 10 -20 9 -30 -5 -51 -34 -52 14 -122 59 -85 12 10 16 9
21 -3 8 -21 -3 -37 -25 -37 -10 0 -26 -12 -36 -26 -15 -23 -22 -25 -52 -21
-20 4 -45 15 -57 25 -34 31 -86 36 -104 11 -11 -16 -21 -19 -40 -14 -19 5 -30
1 -42 -15 -14 -18 -19 -19 -50 -9 -19 7 -38 17 -42 23 -14 20 -8 59 9 72 25
18 18 20 -69 27 -78 7 -78 7 -78 -32 0 -40 -10 -54 -46 -65 -29 -9 -44 33 -44
119 0 62 0 62 57 68 45 5 60 3 66 -8 10 -19 43 -19 51 0 7 18 57 20 74 3 7 -7
12 -25 12 -41 0 -19 9 -38 26 -53 25 -24 25 -24 18 21 -13 91 53 182 96 130
18 -22 35 -18 56 13 21 31 20 79 -1 102 -8 9 -15 36 -15 60 0 29 -6 47 -17 56
-13 9 -15 16 -8 23 8 8 21 4 45 -13 25 -17 44 -22 67 -19 24 4 34 1 39 -11 4
-10 18 -16 41 -16 19 0 59 -11 90 -25 57 -27 70 -27 60 0 -4 9 -19 15 -42 15
-19 0 -35 4 -35 10 0 5 -17 17 -37 25 -21 9 -50 28 -65 42 -26 25 -58 46 -88
58 -44 18 -45 21 -45 103 0 81 -17 122 -50 122 -7 0 -20 9 -30 20 -10 11 -23
20 -29 20 -6 0 -19 14 -28 30 -19 33 -52 50 -101 50 -18 1 -50 8 -72 16 -22 9
-84 19 -137 24 -108 8 -120 14 -148 76 -24 52 -36 61 -45 34 -3 -11 -12 -20
-19 -20 -8 0 -19 -7 -26 -15 -10 -12 -8 -16 15 -25 14 -5 37 -10 51 -10 35 0
33 -41 -3 -57 -16 -7 -48 -21 -73 -32 -53 -23 -127 -17 -96 8 16 13 23 71 9
71 -5 0 -26 -7 -48 -14 -31 -11 -41 -20 -43 -40 -3 -21 -10 -26 -40 -31 -20
-3 -59 -10 -87 -15 -27 -5 -71 -11 -97 -15 -26 -3 -50 -10 -53 -16 -11 -16
-61 -10 -80 11 -12 13 -31 20 -54 20 -31 0 -38 4 -48 29 -14 39 -1 51 57 51
25 0 54 6 64 13 20 15 13 44 -15 52 -10 3 -28 18 -39 33 -17 21 -31 27 -66 28
-57 2 -63 8 -34 39 21 22 24 23 35 9 6 -9 20 -14 31 -12 17 3 19 11 17 68 -5
120 -9 130 -49 130 -36 0 -47 8 -116 90 -37 43 -37 70 0 70 21 0 37 -11 62
-40 38 -45 51 -49 71 -20 14 19 15 19 61 3 46 -17 80 -11 45 8 -29 17 -22 50
11 47 24 -3 27 1 30 30 2 24 -1 32 -12 32 -9 0 -16 -4 -16 -9 0 -12 -96 -61
-119 -61 -10 0 -26 9 -36 20 -11 13 -31 20 -52 20 -20 0 -46 9 -60 20 -14 11
-35 20 -47 20 -19 0 -54 26 -134 98 -24 21 -67 27 -117 15z m1288 -770 c37
-29 45 -47 26 -59 -18 -11 -119 46 -119 67 0 29 50 24 93 -8z m88 -151 c14
-15 30 -38 34 -52 4 -14 15 -33 24 -44 12 -13 16 -38 16 -91 0 -67 -2 -75 -27
-99 -16 -14 -28 -31 -28 -39 0 -8 -7 -28 -16 -45 -20 -41 -12 -65 31 -85 40
-19 45 -44 13 -56 -28 -10 -134 1 -148 15 -12 12 4 50 33 78 10 11 18 35 19
64 3 69 2 76 -11 214 -16 166 0 204 60 140z m199 -65 c0 -14 -20 -37 -32 -37
-4 0 -8 11 -8 25 0 18 5 25 20 25 11 0 20 -6 20 -13z m68 -54 c26 -41 23 -63
-10 -63 -36 0 -54 15 -39 33 7 9 9 26 5 41 -9 39 16 32 44 -11z m-12 -141 c22
-15 54 -81 54 -111 0 -33 -29 -71 -55 -71 -16 0 -35 30 -35 56 0 32 -61 76
-97 70 -40 -6 -47 23 -11 48 23 17 124 22 144 8z m444 -471 c16 -31 12 -41
-15 -41 -27 0 -41 20 -31 45 8 21 33 19 46 -4z"/>
<path d="M8325 20410 c-9 -15 3 -47 21 -54 23 -9 34 2 34 35 0 24 -4 29 -24
29 -14 0 -28 -5 -31 -10z"/>
<path d="M11440 20410 c0 -6 4 -18 9 -28 6 -9 17 -38 27 -65 23 -65 70 -110
107 -103 16 3 50 -3 83 -15 45 -17 61 -19 80 -10 33 14 30 30 -7 43 -25 9 -30
15 -25 33 7 27 -13 38 -49 29 -30 -7 -94 13 -118 37 -10 11 -22 19 -27 19 -5
0 -12 9 -15 20 -3 11 -12 20 -20 20 -7 0 -15 7 -19 15 -6 17 -26 21 -26 5z"/>
<path d="M11813 20394 c-29 -33 -31 -80 -3 -89 11 -3 20 -11 20 -16 0 -5 4 -9
9 -9 5 0 7 18 4 40 -5 37 -4 40 18 39 13 0 33 -4 44 -8 27 -11 57 -2 53 16 -3
14 -54 38 -103 49 -13 3 -28 -5 -42 -22z"/>
<path d="M7740 20380 c24 -34 43 -35 48 -3 2 14 -4 22 -20 27 -45 12 -50 7
-28 -24z"/>
<path d="M9114 20384 c-5 -19 -2 -29 9 -36 10 -5 19 -29 23 -59 8 -56 18 -68
42 -45 30 26 61 10 73 -40 16 -61 47 -91 103 -99 31 -5 51 -3 61 5 17 14 55
-11 55 -35 0 -18 55 -75 72 -75 7 0 21 7 31 14 9 7 28 11 42 8 46 -8 26 40
-42 104 -58 54 -60 90 -5 100 39 7 72 29 72 49 0 27 -37 46 -74 40 -27 -6 -41
-2 -62 14 -39 31 -111 22 -157 -18 -17 -14 -22 -13 -60 7 -52 27 -63 27 -77 2
-18 -33 -30 -23 -30 25 0 40 -3 47 -26 55 -37 15 -43 13 -50 -16z m356 -128
c38 -5 40 -5 40 -16 0 -5 -12 -13 -27 -16 -16 -4 -36 -13 -45 -21 -24 -22 -62
-13 -66 15 -6 42 5 55 41 48 17 -3 43 -8 57 -10z"/>
<path d="M13136 20370 c9 -16 19 -30 24 -30 5 0 15 -3 24 -6 28 -11 18 21 -14
44 -40 30 -51 28 -34 -8z"/>
<path d="M9940 20376 c0 -22 -26 -31 -45 -16 -19 16 -35 4 -35 -24 0 -27 25
-53 35 -36 21 34 104 -7 105 -53 0 -13 7 -18 23 -17 40 4 47 0 47 -24 0 -32
39 -62 91 -71 22 -4 42 -5 45 -2 10 10 -10 37 -27 37 -24 0 -95 69 -83 80 5 4
26 13 47 20 20 6 37 13 37 16 0 16 -89 80 -119 85 -20 4 -55 10 -78 14 -36 6
-43 5 -43 -9z"/>
<path d="M7063 20351 c-22 -28 -22 -28 7 -56 17 -16 30 -34 30 -41 0 -7 17
-34 38 -61 53 -67 67 -118 39 -138 -19 -13 -19 -16 -5 -32 9 -10 19 -28 22
-40 7 -21 130 -133 147 -133 5 0 9 11 9 25 0 13 8 28 17 34 16 9 16 11 2 28
-43 49 -67 109 -72 183 -5 56 -10 78 -23 85 -43 25 -87 72 -109 115 -34 68
-66 77 -102 31z"/>
<path d="M6507 20353 c-16 -15 -7 -82 12 -93 28 -14 28 -14 36 26 8 45 -25 91
-48 67z"/>
<path d="M10546 20345 c-15 -40 29 -90 71 -81 35 7 66 -17 87 -68 31 -74 99
-22 81 61 -6 26 -96 73 -141 73 -16 0 -38 7 -48 15 -25 19 -42 19 -50 0z"/>
<path d="M6264 20335 c-8 -21 -4 -25 41 -32 34 -6 37 -4 33 18 -4 30 -64 41
-74 14z"/>
<path d="M8476 20342 c-10 -10 -6 -61 5 -68 6 -3 16 -1 22 5 18 18 31 13 50
-20 25 -44 47 -24 47 42 0 49 0 49 -59 48 -33 -1 -62 -4 -65 -7z"/>
<path d="M8701 20291 c-12 -8 -13 -14 -3 -35 16 -37 32 -32 32 9 0 36 -5 41
-29 26z"/>
<path d="M2671 20212 c-10 -20 -4 -62 9 -62 8 0 20 35 20 63 0 22 -17 22 -29
-1z"/>
<path d="M2627 20118 c-4 -12 -1 -28 5 -35 15 -18 38 2 38 33 0 32 -35 33 -43
2z"/>
<path d="M10151 20102 c-11 -21 2 -48 18 -38 14 9 15 56 1 56 -5 0 -14 -8 -19
-18z"/>
<path d="M4322 20074 c2 -15 9 -29 16 -32 10 -3 13 4 10 24 -2 15 -9 29 -16
32 -10 3 -13 -4 -10 -24z"/>
<path d="M10693 20072 c10 -10 17 -23 17 -29 0 -17 48 -55 66 -51 26 5 29 28
5 35 -12 3 -22 9 -22 14 -1 5 -2 14 -3 19 -2 16 -28 30 -55 30 -23 0 -23 -1
-8 -18z"/>
<path d="M2550 20014 c-6 -14 -10 -30 -10 -35 0 -5 -11 -9 -25 -9 -27 0 -35
-26 -13 -48 36 -36 138 7 110 46 -7 9 -17 29 -23 45 -14 34 -27 34 -39 1z"/>
<path d="M2702 20027 c-16 -19 -26 -67 -14 -67 6 0 14 5 17 10 11 18 37 10 70
-22 18 -18 41 -38 52 -44 25 -15 40 -61 27 -82 -16 -25 -37 -21 -44 8 -4 17
-16 27 -38 34 -30 8 -32 12 -30 45 3 31 0 36 -19 39 -18 3 -23 -2 -23 -18 0
-11 -7 -23 -15 -26 -25 -10 -17 -31 14 -37 33 -7 46 -45 28 -84 -8 -18 -6 -27
8 -43 25 -27 34 -25 46 10 6 17 14 30 19 30 9 0 20 -36 20 -70 0 -14 9 -42 20
-63 11 -20 20 -41 20 -47 0 -5 16 -32 35 -59 23 -31 35 -60 35 -81 0 -17 8
-44 19 -58 10 -15 22 -38 26 -52 4 -14 14 -35 21 -48 18 -28 5 -88 -32 -144
-19 -30 -30 -38 -55 -38 -22 0 -32 -5 -36 -19 -6 -22 -55 -43 -79 -34 -28 10
-94 136 -94 179 0 68 -47 123 -78 92 -19 -19 -14 -48 18 -108 21 -39 30 -69
30 -103 0 -26 7 -62 16 -79 14 -27 19 -29 52 -24 20 3 71 10 112 16 176 23
233 47 278 117 59 93 72 99 117 57 16 -15 44 -33 62 -40 18 -8 33 -20 33 -28
0 -18 60 -63 96 -72 16 -4 42 -20 57 -36 16 -15 39 -28 52 -28 29 0 47 -22 43
-52 -5 -36 -37 -35 -51 1 -9 25 -15 29 -34 25 -12 -3 -32 1 -45 10 -12 9 -30
16 -40 16 -10 0 -26 9 -35 20 -10 11 -26 20 -35 20 -26 0 -118 -71 -118 -91 0
-21 19 -29 42 -17 10 4 29 6 43 2 33 -8 33 -45 0 -99 -28 -45 -31 -79 -10
-115 32 -57 7 -90 -45 -58 -25 16 -31 8 -41 -49 -5 -27 -13 -68 -19 -93 -25
-118 -5 -285 35 -300 13 -5 26 -13 29 -18 13 -22 58 -23 103 -1 54 26 69 17
59 -35 -4 -20 -10 -36 -15 -36 -4 0 -13 -11 -19 -25 -15 -32 -39 -32 -54 1
-12 26 -15 26 -76 21 -34 -4 -67 -9 -72 -12 -6 -4 -10 -34 -11 -68 0 -74 -20
-175 -36 -185 -6 -4 -19 -27 -29 -52 -33 -85 -57 -91 -114 -31 -23 24 -49 41
-66 43 -20 2 -30 10 -35 30 -4 15 -12 33 -18 40 -6 7 -19 23 -29 35 -13 17
-24 21 -44 16 -31 -6 -37 -33 -13 -53 8 -7 15 -25 15 -41 0 -17 7 -32 19 -38
24 -13 51 -71 51 -109 0 -38 16 -42 127 -32 100 10 157 23 178 40 20 17 31 7
44 -42 9 -31 9 -51 2 -71 -11 -27 -11 -27 -108 -22 -54 3 -129 11 -168 19 -38
7 -75 11 -83 9 -21 -9 -9 -38 17 -41 19 -3 11 -8 -34 -24 -32 -11 -68 -17 -79
-13 -75 23 -86 23 -86 4 0 -12 13 -24 35 -33 41 -17 46 -36 10 -36 -33 0 -42
-25 -20 -50 20 -23 45 -11 45 21 0 28 14 30 56 8 21 -11 67 -23 102 -28 86
-10 97 -23 97 -115 0 -88 -17 -116 -72 -116 -27 0 -37 6 -51 30 -14 25 -23 30
-55 30 -21 0 -47 -4 -57 -10 -15 -8 -20 -4 -31 35 -15 50 -28 53 -42 12 -12
-36 -4 -55 28 -67 14 -5 25 -13 25 -18 0 -20 47 -31 69 -15 20 13 24 13 47 -2
13 -8 54 -19 89 -22 65 -6 69 -5 157 38 42 21 58 5 58 -57 0 -44 -12 -43 -34
4 -17 33 -19 35 -27 17 -12 -31 -10 -68 6 -89 16 -21 19 -63 9 -115 -8 -39
-24 -30 -24 13 0 65 -59 111 -157 122 -32 4 -63 11 -70 16 -9 7 -14 2 -19 -16
-10 -41 3 -73 52 -124 58 -60 65 -77 47 -127 -17 -48 -40 -75 -59 -68 -8 3
-17 -2 -20 -11 -8 -22 1 -30 23 -21 10 5 30 9 44 10 32 3 92 41 141 89 34 33
37 34 43 15 4 -11 1 -27 -5 -35 -8 -9 -10 -29 -6 -53 8 -51 -13 -75 -59 -67
-30 6 -168 -34 -189 -54 -12 -12 40 -90 60 -90 37 0 64 -46 64 -112 0 -105
-28 -172 -55 -135 -7 10 -21 17 -32 17 -18 0 -20 -5 -16 -52 6 -74 8 -76 48
-84 29 -5 43 -2 65 15 16 11 34 21 39 21 33 0 40 -116 9 -146 -12 -13 -19 -10
-46 21 -35 37 -68 51 -106 41 -44 -11 -44 -136 0 -136 8 0 14 -4 14 -10 0 -5
-5 -10 -11 -10 -7 0 -9 -10 -5 -27 31 -146 28 -208 -13 -256 -28 -34 31 -49
98 -26 51 18 68 -5 51 -66 -16 -55 -33 -65 -64 -36 -12 11 -30 21 -38 21 -37
0 -121 -25 -125 -38 -10 -25 28 -92 56 -98 14 -3 33 -8 43 -10 51 -14 52 -215
1 -235 -24 -9 -41 -35 -29 -46 10 -10 47 11 108 61 58 47 58 47 78 14 23 -39
23 -39 8 -73 -7 -17 -24 -29 -50 -35 -21 -6 -64 -26 -96 -44 -31 -19 -67 -37
-79 -40 -24 -8 -39 -45 -30 -70 5 -12 20 -14 74 -9 59 5 71 3 93 -15 24 -20
25 -23 25 -159 0 -118 -3 -143 -19 -170 -18 -30 -19 -33 -2 -58 22 -34 42 -41
71 -25 32 17 45 10 60 -34 20 -58 11 -70 -44 -61 -102 15 -106 14 -105 -25 1
-19 5 -46 9 -59 6 -18 5 -23 -6 -19 -8 2 -15 14 -17 27 -2 12 -14 28 -27 37
-12 8 -25 24 -28 34 -6 24 -34 37 -49 22 -7 -7 -5 -19 5 -39 9 -15 21 -39 27
-53 6 -14 29 -44 52 -66 48 -50 48 -78 0 -82 -35 -4 -43 -18 -14 -26 81 -22
125 -13 136 28 8 32 35 34 38 4 3 -49 -5 -124 -14 -135 -15 -19 -52 -16 -81 7
-30 24 -140 39 -151 21 -4 -6 2 -31 13 -54 12 -24 21 -57 21 -73 0 -50 18 -94
49 -123 40 -37 40 -73 1 -150 -34 -68 -38 -70 -102 -63 -43 4 -48 3 -48 -15 0
-36 137 -17 231 33 32 16 55 -2 65 -54 11 -54 -6 -63 -100 -56 -44 3 -99 2
-121 -3 -39 -9 -40 -10 -43 -56 -3 -44 -2 -47 25 -52 15 -3 48 -16 73 -28 40
-19 47 -28 63 -77 38 -121 32 -209 -20 -249 -25 -20 -25 -20 2 -27 18 -4 37
-1 55 10 16 9 40 16 55 16 25 0 26 -2 23 -52 -3 -60 16 -55 -155 -42 -57 4
-73 3 -73 -8 1 -14 68 -65 113 -85 42 -19 50 -52 42 -193 -4 -69 -10 -131 -15
-139 -7 -12 3 -52 18 -71 2 -3 20 -5 40 -5 37 0 37 0 40 -47 2 -26 -2 -57 -8
-69 -12 -21 -13 -20 -51 20 -22 23 -48 41 -59 41 -10 0 -23 8 -29 18 -9 16
-11 16 -25 -3 -14 -20 -15 -19 -25 8 -6 15 -15 27 -20 27 -28 0 -42 33 -36 82
6 45 5 51 -28 91 -19 23 -36 51 -38 62 -8 39 -47 30 -95 -20 -46 -47 -46 -53
-11 -92 16 -18 18 -28 10 -45 -7 -16 -6 -30 4 -48 7 -14 13 -35 13 -47 0 -12
7 -28 15 -37 8 -8 15 -23 15 -34 0 -24 41 -62 67 -62 14 0 24 10 32 30 12 37
56 43 66 9 5 -16 12 -19 30 -15 16 4 25 1 29 -10 12 -30 6 -139 -9 -167 -8
-15 -17 -43 -21 -62 -4 -25 -12 -35 -25 -35 -10 0 -21 -4 -24 -10 -8 -13 40
-24 73 -15 60 15 85 11 101 -16 33 -59 -21 -110 -78 -72 -28 19 -65 24 -118
16 -31 -5 -33 -8 -33 -47 0 -46 13 -66 45 -66 27 -1 49 -18 68 -57 34 -64 10
-214 -30 -198 -33 12 -37 10 -50 -29 -20 -59 -21 -59 116 13 18 10 38 25 43
34 30 54 80 -36 70 -123 -7 -54 -7 -54 -25 -27 -15 23 -24 27 -65 27 -26 0
-60 -7 -77 -16 -16 -9 -46 -20 -65 -23 -31 -6 -35 -10 -38 -40 -5 -48 9 -57
58 -37 50 20 82 13 115 -26 28 -33 35 -120 12 -152 -11 -16 -15 -15 -42 14
-30 31 -75 41 -75 16 0 -8 9 -18 20 -21 11 -4 27 -22 35 -41 15 -36 24 -41 43
-22 9 9 13 8 17 -5 9 -21 -33 -76 -62 -83 -28 -8 -29 -19 -3 -37 17 -12 29
-12 74 -2 30 7 59 16 64 19 33 20 51 -109 20 -140 -14 -14 -19 -13 -58 15 -32
23 -54 31 -84 31 -81 0 -83 -20 -11 -115 38 -49 38 -50 37 -138 0 -106 -13
-132 -69 -142 -57 -9 -73 -22 -40 -30 33 -9 134 3 142 16 10 16 44 10 55 -10
14 -27 13 -45 -5 -87 -15 -36 -15 -36 -41 -15 -23 18 -41 21 -115 21 -53 0
-89 -4 -89 -10 0 -5 4 -10 9 -10 18 0 104 -100 123 -142 35 -78 30 -185 -11
-227 -21 -21 -27 -36 -24 -55 9 -43 26 -50 79 -30 47 18 47 18 65 -5 11 -14
19 -39 19 -62 0 -34 -3 -39 -22 -39 -13 0 -32 7 -42 15 -12 9 -42 15 -72 15
-62 0 -104 14 -104 34 0 9 -20 38 -45 66 -24 27 -49 59 -55 70 -6 11 -15 18
-21 15 -15 -10 -10 -24 16 -47 15 -13 25 -32 25 -49 0 -14 6 -32 14 -38 8 -7
24 -32 35 -56 20 -43 89 -105 116 -105 28 0 45 -37 45 -98 0 -35 -4 -62 -10
-62 -19 0 -10 -29 11 -35 21 -7 52 14 90 59 26 30 46 14 54 -44 9 -65 -9 -91
-49 -72 -15 6 -46 9 -75 5 -45 -5 -52 -3 -75 22 -29 31 -61 118 -52 142 9 23
-12 43 -48 43 -63 0 -68 -24 -15 -81 16 -17 29 -39 29 -49 0 -10 11 -31 24
-47 13 -15 29 -46 35 -67 10 -40 84 -126 107 -126 19 0 24 -26 24 -123 0 -105
-9 -129 -40 -109 -27 16 -56 16 -43 0 15 -19 22 -105 10 -117 -5 -5 -31 -7
-58 -4 -33 4 -49 2 -49 -6 0 -6 4 -11 10 -11 5 0 19 -10 30 -22 16 -17 44 -27
107 -38 84 -15 87 -16 106 -54 29 -55 15 -92 -33 -88 -19 2 -40 10 -47 19 -13
16 -121 73 -140 73 -27 0 -65 25 -79 52 -13 25 -20 28 -65 28 -50 0 -51 -1
-45 -25 7 -28 113 -159 151 -188 14 -10 25 -23 25 -29 0 -6 13 -25 28 -43 42
-47 57 -198 17 -165 -10 8 -18 2 -33 -24 -12 -20 -30 -36 -43 -38 -12 -2 -24
-8 -26 -14 -5 -15 138 -38 183 -30 37 7 54 -11 54 -59 0 -55 -28 -79 -60 -50
-13 12 -148 45 -182 45 -13 0 -9 -35 7 -56 8 -10 15 -25 15 -32 0 -8 9 -26 21
-40 12 -16 18 -34 15 -47 -3 -13 2 -27 14 -37 26 -23 35 -97 20 -161 -7 -29
-13 -77 -14 -107 -1 -55 -1 -55 28 -53 33 2 60 24 93 76 21 34 28 37 60 35 34
-3 37 -1 45 31 6 22 5 65 -2 117 -17 129 -3 550 20 589 10 17 21 62 25 100 4
39 14 81 22 94 39 61 26 855 -15 869 -6 2 -8 38 -5 97 3 74 0 108 -15 162 -23
79 -36 295 -19 312 12 12 13 26 20 266 3 121 1 182 -8 212 -11 38 -11 46 4 65
65 87 72 111 62 217 -6 55 -18 118 -27 140 -11 28 -14 52 -9 74 18 81 -4 399
-35 493 -51 159 -50 157 -34 175 12 13 17 49 20 145 3 95 8 132 19 144 8 9 15
25 15 36 1 10 8 37 16 59 23 63 29 161 26 422 -3 215 -5 246 -23 279 -10 21
-19 59 -19 84 0 25 -6 55 -14 66 -9 12 -17 60 -22 118 -6 92 -6 98 15 112 28
20 29 143 1 270 -26 116 -26 222 -1 272 48 97 56 166 56 512 0 283 -2 331 -17
370 -13 33 -17 70 -15 135 2 85 3 90 25 93 17 3 22 -2 22 -17 0 -12 6 -21 15
-21 21 0 19 27 -4 39 -12 7 -20 26 -24 62 -4 28 -14 60 -22 69 -9 10 -20 45
-26 79 -5 34 -13 89 -19 124 -5 34 -10 124 -10 200 0 115 -3 139 -15 144 -29
11 -55 78 -55 143 0 73 14 78 30 10 7 -28 16 -52 20 -55 5 -3 11 -23 15 -45 8
-47 30 -53 46 -13 14 37 4 86 -22 109 -23 21 -20 80 5 119 7 11 16 54 20 95 4
41 14 86 22 101 7 15 17 73 20 129 7 97 6 102 -15 116 -31 22 -27 87 7 92 12
2 22 6 23 10 5 47 6 188 2 195 -10 17 -11 150 -1 176 19 47 14 238 -6 260 -14
15 -16 29 -11 61 5 27 3 46 -6 56 -10 12 -8 19 11 39 22 23 22 25 4 32 -28 10
-33 23 -22 54 6 17 21 31 38 38 19 6 34 22 44 45 18 43 31 46 40 10 7 -27 3
-67 -16 -185 -11 -68 -5 -125 12 -114 6 3 10 19 10 34 0 15 6 36 14 46 13 18
14 18 26 -4 13 -26 6 -102 -16 -165 -19 -54 -17 -94 6 -123 11 -14 20 -33 20
-43 0 -32 43 -57 118 -71 73 -12 73 -12 108 26 19 22 38 51 41 66 4 22 12 29
40 34 46 8 48 4 28 -49 -18 -46 -14 -66 11 -66 8 0 19 -11 24 -26 8 -20 13
-23 27 -16 13 8 17 26 18 87 1 83 -6 95 -59 95 -14 0 -27 4 -31 9 -3 5 -19 12
-35 16 -35 8 -39 29 -14 96 23 61 27 186 7 215 -19 30 -10 44 31 44 25 0 38
-7 51 -26 15 -23 19 -25 32 -11 22 22 8 51 -39 82 -23 15 -56 43 -74 63 -21
23 -37 33 -48 29 -23 -9 -20 -59 5 -91 28 -36 12 -54 -49 -58 -47 -3 -47 -3
-46 -38 2 -64 27 -165 46 -183 12 -12 18 -32 18 -62 0 -43 -1 -45 -30 -45 -18
0 -30 5 -30 13 0 7 -8 28 -18 47 -11 19 -22 49 -26 65 -4 17 -13 44 -20 60 -8
17 -23 51 -35 76 -12 25 -21 51 -21 58 0 6 -7 23 -17 37 -10 15 -18 54 -21 99
-3 56 -9 78 -23 91 -11 9 -19 24 -19 32 0 9 -8 25 -19 36 -42 47 -30 88 24 83
16 -2 21 7 26 52 5 37 14 60 27 70 20 16 44 69 57 125 3 16 17 43 31 59 15 18
24 41 24 62 0 38 12 51 29 32 19 -23 -8 -247 -33 -275 -17 -20 -18 -24 -6 -32
8 -5 18 -10 23 -10 13 0 8 -47 -7 -59 -7 -6 -16 -33 -20 -59 -3 -26 -13 -58
-22 -70 -13 -19 -15 -37 -9 -92 8 -83 32 -120 75 -120 56 0 77 53 43 110 -15
27 -15 30 1 54 14 22 20 25 37 15 29 -15 78 -3 112 26 31 28 35 51 10 59 -10
3 -38 29 -62 57 -24 28 -59 58 -78 65 -29 13 -33 18 -33 54 0 21 5 42 10 45 5
3 10 25 10 48 0 23 5 49 10 57 7 10 10 11 10 2 0 -6 11 -22 25 -34 14 -12 25
-31 25 -42 1 -36 51 -130 83 -154 9 -7 17 -19 17 -27 0 -7 14 -18 30 -24 29
-9 30 -9 30 18 0 15 -5 32 -12 39 -8 8 -8 15 1 26 7 9 10 24 6 36 -7 23 27 70
52 70 7 0 13 4 13 9 0 17 -31 41 -54 41 -12 0 -31 7 -42 15 -10 8 -30 15 -44
15 -39 0 -68 26 -76 68 -4 20 -9 41 -11 45 -8 14 -31 -13 -38 -44 -9 -40 -21
-29 -34 33 -6 28 -18 56 -25 62 -8 6 -17 26 -21 44 -5 26 -4 32 11 32 33 0 54
29 42 56 -6 13 -17 24 -24 24 -7 0 -20 7 -29 16 -19 20 -82 63 -105 73 -37 16
-90 54 -90 65 0 38 75 50 105 16 10 -11 23 -20 29 -20 6 0 25 -7 41 -16 22
-11 44 -14 81 -10 46 5 52 4 57 -14 7 -29 30 -25 56 11 23 31 23 31 1 46 -26
18 -23 56 5 61 11 2 39 19 62 38 53 44 74 43 107 -4 43 -63 28 -101 -57 -136
-30 -12 -43 -26 -62 -68 -16 -34 -32 -55 -46 -58 -33 -8 -65 -110 -34 -110 8
0 15 5 15 12 0 7 9 21 20 33 11 11 32 35 46 53 27 33 54 42 54 18 0 -7 -7 -19
-15 -26 -18 -15 -95 -164 -95 -184 0 -41 129 -74 155 -40 17 23 48 9 53 -24 2
-12 13 -29 25 -37 21 -14 22 -14 29 7 11 42 8 81 -9 100 -23 25 -53 119 -47
144 3 12 -2 36 -11 54 -20 38 -14 60 17 60 13 0 36 9 53 20 62 41 146 35 186
-13 38 -45 27 -57 -54 -57 -98 0 -121 -16 -114 -77 6 -53 12 -61 37 -45 46 29
115 0 146 -61 14 -26 15 -50 10 -138 -8 -124 0 -141 45 -91 27 31 34 63 42
202 2 43 4 45 31 45 27 0 32 -6 52 -58 14 -36 26 -98 32 -160 9 -103 4 -127
-24 -127 -16 0 -17 6 -15 75 3 90 -29 101 -46 15 -7 -37 -14 -47 -40 -59 -21
-9 -33 -23 -37 -42 -7 -37 -36 -39 -36 -4 0 15 -11 36 -25 49 -14 14 -25 34
-25 50 0 26 -13 35 -25 16 -17 -28 -6 -70 30 -115 36 -44 38 -48 27 -79 -13
-35 -15 -78 -6 -113 7 -26 48 -32 61 -9 4 8 21 16 37 18 44 5 52 26 32 88 -15
45 -15 55 -3 67 27 27 47 5 47 -52 0 -58 15 -79 36 -49 41 59 60 83 67 84 17
0 5 -53 -23 -105 -16 -30 -30 -62 -30 -69 0 -8 -11 -37 -25 -64 -14 -28 -25
-55 -25 -60 0 -6 -13 -20 -29 -31 -29 -21 -29 -21 -27 35 1 46 6 60 25 75 23
19 23 19 -4 29 -40 15 -63 12 -70 -10 -7 -21 -14 -24 -53 -20 -21 1 -23 -2
-22 -42 1 -24 -4 -68 -11 -98 -18 -83 3 -200 36 -200 24 0 35 -17 35 -55 0
-28 -16 -41 -33 -27 -7 5 -32 12 -57 16 -25 4 -54 16 -65 26 -21 20 -21 20
-60 -20 -23 -24 -52 -42 -72 -46 -36 -7 -83 -54 -83 -83 0 -18 38 -41 68 -41
34 0 92 -49 92 -78 0 -15 4 -33 9 -41 6 -9 4 -29 -5 -54 -18 -52 -18 -57 5
-57 38 0 51 -27 51 -106 0 -79 0 -80 29 -62 20 12 51 5 51 -12 0 -6 -11 -15
-25 -20 -14 -5 -28 -17 -31 -25 -8 -20 -30 -19 -44 3 -21 33 1 -48 23 -85 18
-31 19 -41 9 -82 -6 -25 -11 -84 -12 -131 -2 -140 -26 -202 -66 -169 -11 9
-14 23 -10 47 4 28 2 35 -13 39 -11 3 -21 17 -25 33 -3 17 -17 37 -33 47 -15
10 -34 26 -41 36 -9 11 -26 17 -50 17 -55 -1 -114 11 -140 28 -21 13 -79 88
-92 118 -6 14 -78 94 -84 94 -3 0 -6 -10 -8 -22 -2 -15 -10 -23 -23 -23 -30 0
-32 35 -3 60 14 11 34 34 46 52 28 40 72 57 100 37 26 -18 36 -4 27 35 -4 19
-1 32 9 40 8 7 18 26 21 42 5 22 14 31 38 37 17 4 32 13 35 20 5 17 -68 15
-92 -3 -11 -8 -36 -15 -55 -15 -20 0 -49 -9 -66 -20 -16 -11 -43 -20 -58 -20
-15 0 -41 -10 -57 -21 -23 -18 -36 -20 -73 -15 -35 5 -46 4 -50 -9 -10 -25 3
-44 37 -53 33 -9 35 -13 52 -149 6 -50 5 -53 -20 -64 -33 -15 -33 -38 1 -97
31 -53 65 -87 120 -121 44 -28 85 -84 77 -106 -4 -9 -1 -22 6 -29 19 -24 8
-80 -18 -91 -18 -8 -22 -16 -19 -34 6 -29 -11 -71 -29 -71 -7 0 -24 21 -38 47
-23 40 -25 51 -16 79 6 17 8 43 5 57 -5 18 -2 28 12 36 17 10 17 12 -3 28 -12
10 -42 35 -67 56 -34 28 -53 38 -73 35 -28 -3 -28 -3 -26 -488 2 -485 2 -485
69 -547 37 -35 72 -63 76 -63 16 0 67 -62 67 -82 0 -13 6 -18 18 -16 13 2 18
15 20 48 2 41 0 47 -28 62 -37 21 -57 66 -66 145 -4 32 -12 65 -19 73 -37 44
-56 135 -33 158 14 14 88 16 88 2 0 -5 -9 -27 -21 -49 -33 -64 -20 -106 41
-126 59 -20 76 -38 83 -94 6 -51 11 -57 54 -66 59 -12 122 79 79 114 -12 10
-29 77 -40 163 -6 44 4 52 75 63 41 6 48 4 62 -15 15 -21 15 -21 41 5 20 20
34 25 59 23 29 -3 33 -7 38 -43 4 -30 7 -36 13 -22 5 9 6 27 3 38 -3 12 -1 26
4 33 5 6 18 22 28 36 34 44 43 16 43 -136 -1 -610 -4 -770 -13 -844 -5 -47
-10 -96 -9 -110 0 -61 7 -140 17 -200 15 -82 -4 -211 -25 -173 -7 12 -12 31
-12 43 0 35 -19 60 -45 60 -16 0 -31 10 -42 28 -10 15 -23 31 -30 35 -18 11
-16 37 1 37 11 0 15 13 15 53 -1 47 -4 55 -37 82 -77 65 -126 73 -168 28 -26
-28 -26 -28 -47 -1 -21 25 -27 27 -102 27 -61 0 -89 5 -120 20 -21 12 -51 21
-66 21 -35 0 -55 25 -70 85 -25 106 -25 105 -39 55 -13 -47 -8 -178 9 -207 7
-14 10 -13 20 5 20 38 38 26 45 -30 11 -92 7 -139 -14 -172 -21 -35 -21 -34
-18 -441 0 -99 0 -260 0 -359 -1 -179 -1 -179 26 -212 32 -41 55 -42 104 -9
20 14 48 25 62 25 35 0 42 18 12 32 -22 9 -26 18 -26 51 0 34 -7 46 -50 89
-50 49 -64 89 -41 113 5 6 11 26 13 45 3 31 7 35 41 43 54 13 62 -1 27 -43
-46 -54 -33 -110 25 -110 29 0 70 -41 91 -90 31 -72 69 -93 128 -70 30 11 36
53 9 68 -32 19 -46 225 -15 240 33 18 93 22 98 7 10 -24 34 -25 65 -3 44 33
85 16 81 -32 -4 -45 -20 -60 -69 -67 -28 -4 -42 -1 -52 11 -7 9 -22 16 -32 16
-20 0 -19 3 -23 -132 -1 -16 6 -24 19 -26 18 -2 57 27 179 134 15 13 17 25 12
63 -6 42 -3 51 23 80 16 18 32 28 35 22 8 -12 1 -165 -8 -180 -4 -6 -2 -20 4
-31 6 -11 11 -50 11 -88 0 -37 -1 -141 -1 -232 0 -91 0 -222 0 -292 1 -70 -2
-162 -5 -205 -4 -46 -3 -94 3 -116 17 -62 3 -344 -19 -370 -14 -18 -20 -20
-31 -9 -11 11 -10 14 1 21 9 6 12 19 7 40 -3 17 -9 45 -12 62 -4 17 -28 52
-54 80 -41 42 -52 49 -81 47 -28 -3 -35 2 -47 25 -7 15 -20 27 -29 27 -9 0
-27 10 -39 21 -26 25 -54 19 -54 -10 0 -27 -18 -36 -38 -18 -9 7 -25 17 -34
20 -12 4 -18 17 -18 34 0 17 -8 33 -20 41 -11 7 -20 18 -20 25 0 8 -12 24 -26
38 -24 22 -25 28 -19 83 6 52 4 60 -14 73 -16 10 -21 25 -21 57 0 35 -5 48
-31 70 -37 33 -33 51 12 51 32 0 34 -2 37 -37 2 -21 7 -38 13 -38 17 0 14 56
-6 103 -21 51 9 117 63 138 23 9 27 30 16 88 -7 33 -34 43 -34 12 0 -26 -58
-68 -106 -77 -21 -3 -48 -11 -59 -17 -10 -5 -33 -10 -50 -11 -39 -1 -47 -43
-16 -82 12 -15 21 -32 21 -39 0 -7 9 -24 20 -38 16 -21 20 -40 20 -111 0 -95
-16 -148 -49 -166 -34 -18 -24 -45 35 -99 40 -36 67 -53 95 -57 40 -7 55 -27
43 -59 -5 -12 -14 -15 -33 -12 -81 17 -149 19 -157 6 -8 -13 -11 -164 -12
-643 0 -188 1 -213 19 -245 10 -20 19 -45 19 -56 0 -34 52 -65 108 -65 60 0
67 6 42 38 -11 13 -20 31 -20 38 0 21 35 17 56 -7 10 -12 33 -31 50 -43 18
-11 47 -33 67 -49 34 -27 35 -27 66 -10 17 10 31 26 31 36 0 10 12 22 28 28
15 6 36 19 47 29 11 10 30 20 43 22 16 2 33 21 57 65 34 62 34 62 -28 61 -34
-1 -71 0 -82 3 -17 3 -21 -3 -25 -41 -7 -59 -41 -131 -59 -127 -20 3 -41 118
-34 185 5 45 10 55 34 67 38 20 63 19 84 -5 10 -11 23 -20 30 -20 7 0 20 9 30
20 35 39 85 14 85 -41 0 -24 4 -30 18 -27 13 3 18 18 23 75 4 39 10 76 13 82
4 6 -2 19 -14 31 -11 11 -20 32 -20 48 0 54 -100 103 -126 61 -11 -19 -24 -8
-24 21 0 27 6 33 54 56 53 27 53 27 98 9 80 -30 78 -7 78 -670 1 -319 1 -589
1 -600 2 -96 -11 -444 -16 -457 -15 -38 -67 -10 -59 31 6 30 -21 70 -48 72 -7
0 -24 14 -37 30 -22 28 -22 31 -7 48 23 25 20 40 -9 47 -13 3 -29 12 -36 20
-6 8 -18 14 -26 14 -8 0 -37 23 -64 52 -45 48 -50 51 -74 40 -45 -21 -63 -14
-92 31 -15 23 -42 60 -60 81 -37 45 -40 61 -16 88 16 18 15 21 -20 56 -45 46
-45 52 -8 94 30 34 49 112 34 134 -4 6 -21 17 -38 25 -25 12 -31 21 -33 53 -3
39 -3 39 38 33 42 -5 42 -5 36 26 -10 50 -37 70 -108 78 -57 7 -66 11 -99 48
-20 23 -39 41 -43 41 -3 0 -6 -30 -6 -66 0 -51 5 -72 20 -91 11 -14 20 -31 20
-37 0 -6 15 -26 34 -44 29 -27 35 -40 40 -94 4 -35 9 -80 12 -100 5 -33 3 -39
-16 -46 -21 -8 -23 -15 -25 -111 -2 -98 -1 -103 24 -130 14 -15 34 -30 44 -34
9 -3 17 -11 17 -16 0 -5 20 -12 45 -15 36 -6 48 -13 65 -42 23 -35 55 -45 78
-22 20 20 24 2 12 -55 -8 -41 -18 -59 -40 -76 -27 -19 -29 -26 -24 -60 9 -56
-18 -101 -60 -101 -27 0 -86 48 -86 70 0 10 -4 22 -10 25 -14 9 -13 35 2 35 6
0 22 10 35 22 19 18 27 20 48 10 25 -12 25 -12 19 31 -11 81 -21 95 -73 103
-25 4 -54 11 -65 16 -13 7 -28 5 -52 -8 -34 -19 -34 -19 -27 -244 4 -124 7
-243 7 -265 -8 -587 -8 -579 39 -683 12 -26 36 -28 92 -7 61 22 122 19 135 -6
16 -29 -4 -49 -47 -49 -18 0 -44 -6 -56 -14 -12 -8 -50 -19 -85 -25 -34 -5
-67 -13 -72 -16 -20 -12 -10 -52 20 -80 28 -27 33 -28 63 -17 19 7 47 12 64
12 17 0 37 7 44 16 7 9 24 20 36 25 13 5 31 24 40 44 14 30 22 35 50 35 27 0
34 5 39 25 5 21 0 32 -32 60 -22 19 -44 34 -50 35 -26 1 -58 40 -78 95 -19 53
-25 60 -54 66 -42 9 -42 8 -57 74 -12 49 -11 62 4 107 10 29 23 54 29 56 16 5
32 -40 32 -87 0 -46 32 -91 64 -91 27 0 47 -22 66 -68 14 -37 45 -62 75 -62
23 0 75 44 75 64 0 7 14 16 32 20 17 3 39 13 47 22 9 8 30 24 48 34 18 11 44
37 58 60 14 22 30 40 35 40 6 0 19 9 31 21 18 18 19 22 6 37 -25 28 -32 71
-12 78 9 4 21 17 26 30 4 13 13 24 18 24 25 0 31 -41 23 -152 -6 -79 -5 -125
4 -153 9 -31 9 -62 0 -135 -11 -88 -12 -220 -6 -682 3 -176 3 -176 -29 -214
-37 -46 -39 -61 -9 -66 19 -2 24 -12 31 -58 8 -56 1 -140 -11 -140 -20 0 -104
99 -98 115 3 10 -8 60 -26 113 -27 81 -37 98 -65 115 -37 21 -39 30 -18 71 25
48 18 61 -15 26 -21 -23 -30 -42 -30 -66 0 -19 -5 -34 -12 -34 -29 0 -77 25
-83 44 -7 20 -7 20 -12 2 -3 -10 1 -22 8 -27 10 -6 7 -14 -14 -33 -15 -14 -27
-29 -27 -33 0 -4 -18 -27 -39 -51 -31 -34 -41 -53 -43 -85 -3 -42 -3 -42 -40
-39 -44 4 -51 -13 -13 -28 46 -17 24 -76 -24 -63 -15 4 -33 -2 -52 -16 -40
-30 -63 -24 -67 15 -2 25 1 33 17 37 25 6 27 29 6 47 -20 17 -20 60 0 60 9 0
31 6 50 14 34 15 34 15 20 50 -33 79 -9 156 50 156 16 0 25 6 25 16 0 27 -23
94 -32 94 -4 0 -8 12 -8 27 0 15 -12 44 -26 65 -27 38 -27 38 5 102 17 35 31
71 31 80 0 26 -57 20 -92 -9 -16 -14 -36 -25 -43 -25 -8 0 -26 -17 -40 -37
-30 -45 -36 -151 -10 -173 8 -7 17 -27 21 -46 7 -39 16 -42 51 -14 27 21 78
27 88 10 9 -15 -4 -50 -19 -50 -7 0 -30 -13 -51 -30 -21 -16 -42 -30 -48 -30
-6 0 -18 -7 -28 -16 -16 -15 -19 -14 -34 15 -8 17 -20 31 -25 31 -16 0 -11
-72 5 -90 13 -15 14 -25 4 -64 -9 -36 -9 -49 1 -61 9 -10 12 -122 11 -442 0
-505 1 -519 37 -537 33 -16 47 -12 89 30 38 38 38 40 18 61 -8 8 -13 19 -9 24
3 6 2 15 -4 22 -16 20 -42 114 -42 149 0 37 34 118 49 118 5 0 9 -30 8 -68 -1
-78 13 -109 51 -118 76 -16 118 -77 106 -152 -6 -40 -6 -40 45 -63 34 -14 57
-32 67 -50 8 -16 18 -29 22 -29 29 0 82 74 82 114 0 14 -8 15 -55 10 -67 -8
-69 -1 -18 73 39 57 89 93 129 93 20 0 29 10 50 55 29 60 27 75 -9 57 -44 -22
-68 -24 -92 -8 -36 23 -40 20 -40 -26 0 -24 -9 -62 -20 -85 -37 -82 -67 -43
-68 88 -1 77 2 92 22 119 27 37 25 40 -28 47 -51 7 -68 25 -46 47 9 9 25 16
35 16 10 0 21 3 23 8 10 15 9 180 -1 327 -12 169 -7 220 23 220 15 0 23 -11
31 -40 14 -52 42 -116 61 -137 12 -13 14 -34 11 -88 -3 -61 -7 -74 -31 -96
-15 -14 -27 -36 -27 -49 0 -13 -5 -27 -10 -30 -5 -3 -10 -28 -10 -54 0 -44 2
-48 34 -63 45 -22 57 -65 24 -89 -25 -19 -25 -20 13 -36 22 -10 29 -8 47 9 19
20 23 20 65 6 45 -15 45 -15 77 39 21 34 37 50 43 44 10 -10 11 -354 1 -629
-6 -163 -5 -182 9 -182 9 0 27 -12 41 -27 14 -15 29 -24 33 -20 8 8 11 977 14
4132 1 1128 6 1865 11 1872 6 7 7 17 3 23 -3 5 -6 175 -5 377 1 203 1 384 1
403 -4 223 1 1616 5 1633 7 22 27 22 48 -2 15 -16 17 -51 17 -312 0 -600 -2
-2831 -4 -5484 0 -22 1 -51 2 -65 2 -14 2 -407 2 -873 -1 -467 1 -853 5 -858
11 -18 24 -8 24 20 0 15 9 40 20 54 22 28 25 55 10 106 -5 19 -10 86 -10 150
0 609 0 1140 0 1159 0 12 0 32 -1 45 -1 51 9 1019 12 1037 1 8 -2 107 -6 220
-4 113 -6 212 -6 220 1 22 12 961 11 990 0 14 0 75 -1 135 0 61 0 160 -1 220
0 61 1 130 2 155 2 25 2 59 2 75 -8 280 -8 472 0 482 6 7 7 27 3 45 -7 32 -8
202 -5 538 1 91 -1 172 -5 182 -3 9 -2 31 3 50 5 20 5 82 0 156 -6 80 -5 129
2 141 7 14 5 29 -6 56 -9 23 -12 45 -7 58 7 20 13 244 12 452 0 44 0 96 0 115
2 91 0 197 -5 320 -3 76 -1 179 5 235 13 114 -5 209 -41 221 -10 3 -25 22 -34
42 -16 39 -34 31 -34 -15 0 -35 -17 -36 -23 0 -8 51 -9 659 -2 690 7 27 8 27
28 10 30 -27 47 -76 47 -135 1 -31 9 -69 20 -93 25 -52 25 -89 0 -123 -18 -25
-20 -40 -18 -127 2 -66 7 -100 15 -102 13 -5 43 57 43 88 0 10 10 34 21 54 19
31 22 57 27 173 4 137 4 137 -46 236 -28 54 -65 142 -83 197 -32 99 -32 99
-16 161 9 35 21 110 28 168 7 62 18 112 27 122 8 9 17 38 20 64 4 40 9 47 33
56 16 5 29 12 29 15 0 11 -25 51 -51 81 -33 38 -35 49 -12 74 16 18 17 18 38
-2 22 -21 22 -21 59 22 48 56 51 60 66 89 7 13 24 34 39 46 25 21 26 24 26
136 0 101 -2 118 -20 137 -16 18 -21 39 -23 116 -4 102 3 124 43 124 29 0 37
-10 23 -27 -16 -20 -2 -155 18 -170 9 -6 18 -34 21 -67 7 -65 18 -78 35 -42 6
14 15 26 19 26 4 0 10 9 14 20 8 27 60 50 111 50 43 0 43 0 26 -30 -9 -16 -28
-34 -42 -39 -14 -4 -45 -27 -70 -49 -40 -36 -44 -43 -33 -60 14 -24 1 -83 -22
-102 -29 -24 -17 -65 36 -129 28 -34 65 -69 82 -78 36 -18 87 -67 87 -82 0 -6
7 -11 15 -11 20 0 19 36 0 74 -18 34 -12 61 10 52 40 -15 60 30 30 70 -8 10
-15 28 -15 38 0 11 -12 33 -27 48 -15 16 -32 43 -38 61 -7 22 -21 37 -47 50
-21 9 -38 19 -38 22 0 18 27 55 51 69 16 9 29 21 29 27 0 16 39 10 48 -8 6
-10 13 -43 17 -73 9 -67 21 -100 36 -100 29 0 140 -63 192 -109 65 -57 87 -64
87 -26 0 18 5 25 20 25 22 0 25 -7 10 -30 -12 -20 25 -60 57 -60 30 0 30 22
-2 56 -14 15 -25 38 -25 50 0 19 -5 24 -24 24 -16 0 -33 13 -52 38 -51 66
-203 212 -223 212 -24 0 -45 25 -37 45 3 8 17 15 31 15 20 0 25 5 25 25 0 41
58 50 120 18 53 -28 58 -37 35 -67 -8 -11 -12 -29 -9 -39 9 -27 53 -91 70
-100 8 -4 14 -15 14 -22 0 -8 9 -15 20 -15 13 0 22 -9 26 -25 7 -27 22 -33 30
-11 8 21 61 -3 69 -31 4 -18 12 -23 39 -23 20 0 40 -8 51 -20 10 -11 23 -20
30 -20 7 0 20 9 30 20 24 27 44 25 55 -5 8 -20 14 -24 37 -19 23 4 35 -2 67
-35 22 -22 43 -38 49 -34 5 3 19 0 32 -7 18 -10 28 -9 53 4 43 22 57 20 94
-14 102 -92 108 -99 102 -114 -12 -30 11 -16 26 17 13 28 21 32 58 35 37 3 47
-1 73 -29 33 -35 59 -28 59 17 0 13 5 34 11 48 10 22 8 31 -15 66 -14 22 -32
40 -39 40 -7 0 -28 14 -45 31 -27 26 -35 29 -47 19 -21 -17 -29 -6 -27 34 2
33 -18 63 -36 52 -6 -3 -13 -26 -16 -51 -8 -50 -18 -62 -36 -40 -17 20 -33 19
-55 -5 -10 -12 -34 -30 -53 -42 -34 -21 -34 -21 -72 21 -42 45 -67 52 -72 19
-2 -12 -9 -24 -17 -26 -11 -4 -13 2 -8 27 6 27 3 32 -18 37 -26 6 -38 26 -29
48 3 8 -2 25 -11 39 -34 53 21 112 59 64 27 -33 37 -34 64 -2 12 14 31 25 42
25 15 0 20 7 20 25 0 14 -5 25 -11 25 -7 0 -22 11 -34 24 -23 25 -23 25 12 61
27 28 34 41 29 60 -7 26 15 45 53 45 18 0 21 -6 21 -37 0 -42 39 -89 64 -80
19 8 8 55 -15 68 -11 5 -19 19 -19 30 0 11 -7 22 -15 25 -16 6 -21 54 -6 54 5
0 15 -10 24 -22 15 -22 16 -22 34 -5 17 18 17 19 -4 34 -14 9 -23 26 -23 40 0
16 -7 27 -19 30 -12 3 -26 25 -40 62 -28 79 -27 97 9 116 49 26 60 20 60 -29
0 -25 5 -48 10 -51 6 -3 10 1 10 9 0 8 13 24 28 35 44 31 138 19 221 -28 147
-84 151 -84 151 -17 0 39 -4 47 -42 78 -24 19 -65 48 -93 63 -27 16 -54 35
-58 42 -11 18 -34 16 -46 -4 -8 -16 -13 -16 -48 -4 -21 8 -78 19 -128 25 -82
11 -90 14 -95 36 -8 35 -55 46 -138 32 -126 -22 -177 -35 -200 -53 -35 -27
-128 -36 -166 -15 -30 16 -33 16 -76 -7 -50 -27 -59 -47 -36 -82 24 -36 49
-31 100 20 48 47 60 53 72 34 9 -14 100 -5 121 13 8 7 44 15 79 19 37 4 72 13
83 23 22 20 81 22 81 2 0 -15 -21 -26 -52 -26 -10 0 -26 -6 -34 -14 -8 -8 -40
-18 -71 -22 -32 -4 -69 -15 -82 -25 -13 -11 -30 -19 -38 -19 -8 0 -26 -9 -40
-20 -14 -11 -33 -20 -43 -20 -9 0 -27 -11 -39 -24 -22 -23 -22 -23 16 -47 21
-13 46 -27 56 -31 9 -4 17 -13 17 -20 0 -7 9 -19 20 -26 26 -16 25 -28 -5 -68
-18 -23 -24 -43 -22 -71 2 -34 0 -38 -22 -38 -38 0 -57 55 -31 85 16 18 17 26
8 44 -13 25 -68 76 -82 76 -5 0 -20 10 -33 22 -20 19 -27 20 -43 10 -11 -7
-31 -12 -45 -12 -14 0 -25 -4 -25 -10 0 -5 -8 -10 -18 -10 -23 0 -42 -19 -42
-42 0 -23 -26 -34 -44 -19 -17 14 -29 2 -14 -16 16 -19 2 -28 -16 -10 -9 8
-21 18 -28 20 -9 4 -7 10 7 22 17 13 18 19 7 47 -16 42 -1 58 52 58 46 0 118
22 124 38 5 17 -94 45 -117 33 -11 -6 -50 -12 -86 -12 -47 -1 -65 -5 -65 -15
0 -7 5 -16 10 -19 6 -3 10 -17 10 -31 0 -32 -38 -33 -77 0 -21 17 -44 24 -90
28 -44 3 -69 10 -85 25 -13 11 -31 23 -41 26 -10 4 -15 11 -12 17 9 14 47 12
88 -5 46 -19 116 -19 136 -1 33 29 169 66 244 66 93 1 120 18 115 75 -3 44 -4
45 -148 66 -41 6 -82 17 -91 25 -9 8 -38 18 -65 23 -31 4 -68 21 -102 45 -51
35 -55 36 -72 21 -18 -16 -21 -15 -54 10 -20 15 -36 31 -36 36 0 5 -7 9 -15 9
-19 0 -19 -14 1 -66 12 -32 24 -45 52 -56 36 -14 72 -61 59 -75 -4 -3 -19 -1
-33 6 -15 6 -34 9 -44 6 -32 -10 -120 107 -120 160 0 8 12 20 26 25 42 16 23
35 -40 38 -72 4 -88 -7 -73 -51 14 -45 16 -49 32 -77 8 -14 15 -46 15 -72 0
-44 2 -48 46 -77 40 -28 54 -31 123 -33 43 0 84 3 92 7 7 5 29 11 48 15 30 4
36 10 42 38 9 45 11 46 52 20 34 -22 36 -26 37 -76 0 -53 0 -53 -176 -50 -157
3 -178 6 -190 22 -8 11 -19 16 -30 12 -21 -8 -11 -54 16 -78 11 -9 20 -25 20
-35 0 -20 30 -63 68 -96 12 -12 22 -27 22 -34 0 -21 21 -15 27 7 8 30 27 19
31 -17 2 -21 15 -40 42 -62 43 -35 62 -38 80 -16 26 31 83 15 74 -21 -5 -20
-3 -24 18 -24 13 0 30 6 36 12 10 10 17 10 34 -1 19 -12 23 -11 34 4 21 29 49
15 52 -28 3 -35 1 -39 -33 -53 -29 -12 -43 -12 -76 -3 -44 14 -44 14 -94 -63
-32 -48 -85 -64 -85 -25 0 15 -47 67 -61 67 -6 0 -20 21 -31 47 -11 26 -49 77
-84 113 -34 36 -82 90 -106 120 -55 70 -123 143 -269 289 -63 64 -147 152
-186 196 -39 44 -149 159 -244 256 -206 207 -217 221 -195 253 14 22 13 24
-10 35 -14 6 -34 11 -45 11 -45 0 -129 77 -129 118 0 6 -10 17 -22 23 -13 7
-41 30 -63 52 -343 342 -484 470 -533 485 -48 15 -47 15 -60 -1z m473 -552
c38 -38 79 -75 90 -80 11 -6 20 -19 20 -30 0 -17 -9 -19 -92 -20 -93 -1 -93
-1 -93 71 0 49 -5 82 -17 102 -10 18 -14 36 -9 48 8 19 8 19 19 -1 7 -11 43
-51 82 -90z m213 -222 c-3 -50 -6 -58 -23 -58 -13 0 -22 10 -28 30 -11 40 6
85 33 85 19 0 21 -5 18 -57z m310 -315 c17 -17 15 -64 -5 -94 -9 -14 -19 -42
-22 -62 -9 -52 -46 -58 -56 -10 -4 18 -12 38 -17 45 -13 16 1 100 19 118 18
18 64 20 81 3z m-163 -88 c3 -11 15 -25 25 -30 33 -18 13 -40 -35 -40 -46 0
-69 25 -42 45 7 5 16 18 20 28 9 23 24 22 32 -3z m-75 -137 c0 -32 -48 -71
-70 -58 -18 11 -10 35 15 45 14 5 25 14 25 20 0 5 7 10 15 10 8 0 15 -8 15
-17z m370 -232 c0 -21 -13 -41 -26 -41 -17 0 -17 5 -4 31 11 20 30 26 30 10z
m1889 -25 c9 -11 9 -16 -1 -23 -31 -19 -55 -33 -79 -45 -56 -28 -83 -75 -90
-157 -4 -44 -3 -94 3 -120 11 -43 11 -43 58 -38 70 8 92 -10 75 -60 -13 -38
-13 -38 -67 -34 -36 2 -59 9 -71 22 -10 10 -21 19 -26 19 -4 0 -20 19 -36 43
-27 39 -29 48 -26 126 1 59 8 95 21 121 21 40 106 120 128 120 8 0 25 9 39 20
30 23 56 26 72 6z m-19 -159 c0 -13 4 -27 8 -32 33 -38 49 -155 21 -155 -24 0
-56 25 -66 51 -8 19 -18 29 -32 29 -24 0 -26 17 -11 69 16 56 80 87 80 38z
m-545 -127 c9 -35 15 -44 29 -42 21 4 62 -31 83 -71 13 -26 19 -29 55 -25 36
3 42 0 71 -36 18 -22 32 -52 33 -68 2 -41 11 -58 32 -58 21 0 42 -38 42 -76 0
-34 -17 -64 -37 -64 -9 0 -27 -10 -40 -21 -22 -22 -22 -22 -32 2 -5 14 -16 31
-25 38 -9 7 -16 22 -16 33 0 22 -46 68 -67 68 -8 0 -17 -9 -20 -20 -6 -23 -33
-27 -33 -6 0 8 -11 28 -25 44 -14 17 -25 36 -25 43 0 7 -8 21 -17 31 -14 16
-15 23 -5 38 10 16 8 28 -13 67 -56 109 -57 114 -44 145 17 42 41 32 54 -22z
m-577 -90 c7 -21 -40 -6 -56 18 -14 22 -14 22 19 8 18 -8 35 -19 37 -26z
m-1240 -82 c-3 -34 -20 -42 -26 -13 -5 22 5 45 18 45 7 0 10 -14 8 -32z m810
-880 c4 -85 -12 -136 -45 -140 -21 -2 -29 -10 -35 -36 -7 -27 -13 -33 -31 -30
-34 5 -35 51 -3 82 14 13 26 33 26 45 0 12 12 48 27 82 35 78 57 77 61 -3z
m-149 28 c7 -8 11 -27 9 -43 -3 -25 -7 -28 -45 -31 -50 -4 -58 17 -22 62 23
29 41 33 58 12z m-860 -715 c17 -31 2 -153 -18 -149 -12 3 -17 18 -19 72 -2
38 -1 75 2 83 8 19 24 16 35 -6z m450 -32 c-14 -27 -39 -24 -39 5 0 27 18 39
37 24 9 -7 10 -16 2 -29z m29 -75 c4 -30 -47 -53 -65 -28 -26 36 -13 56 32 52
21 -2 31 -9 33 -24z m106 -98 c14 -25 26 -52 26 -62 0 -9 9 -31 19 -48 36 -59
46 -137 25 -192 -10 -27 -24 -54 -32 -60 -10 -7 -13 -25 -11 -55 4 -40 2 -45
-16 -45 -26 1 -32 -32 -7 -42 11 -4 32 -22 47 -41 50 -59 12 -78 -113 -56 -48
9 -59 19 -42 40 19 23 5 55 -44 108 -36 38 -52 47 -78 47 -49 0 -66 -14 -46
-37 9 -10 18 -40 20 -68 3 -48 2 -50 -23 -53 -32 -4 -48 29 -59 123 -12 96 36
148 120 130 34 -7 120 -90 120 -115 0 -10 6 -23 14 -29 40 -33 71 106 41 181
-23 59 -34 296 -14 309 22 14 26 12 53 -35z m276 -186 c0 -28 -2 -29 -20 -18
-23 14 -26 34 -7 41 23 10 27 7 27 -23z m-48 -129 c13 -5 35 -21 51 -36 49
-47 30 -165 -27 -165 -21 0 -24 6 -30 50 -6 45 -10 51 -41 64 -25 11 -44 12
-66 6 -18 -5 -36 -7 -40 -4 -16 10 -9 33 11 39 11 3 20 11 20 16 0 11 57 38
82 39 9 0 27 -4 40 -9z m-397 -323 c8 -13 26 -23 38 -23 15 0 23 -7 25 -21 4
-30 -21 -46 -65 -42 -33 3 -41 8 -56 41 -11 21 -16 44 -13 52 8 23 53 18 71
-7z m45 -1058 c6 -11 17 -20 26 -20 20 0 29 -27 14 -45 -6 -8 -9 -23 -6 -33 9
-28 -28 -59 -50 -41 -23 19 -48 -14 -33 -43 20 -38 7 -72 -33 -83 -49 -13 -55
-21 -33 -45 25 -27 13 -87 -20 -100 -47 -18 -123 31 -98 63 19 24 21 59 6 102
-10 30 -11 49 -5 62 6 10 8 29 6 43 -6 35 9 54 48 57 71 6 98 15 98 34 0 10
-5 21 -10 24 -14 8 -3 24 24 35 35 14 55 11 66 -10z m228 -62 c16 -16 15 -57
-2 -64 -15 -6 -86 33 -86 47 0 23 69 36 88 17z m-100 -113 c12 -25 22 -53 22
-62 0 -8 9 -30 19 -47 10 -17 22 -47 26 -66 4 -19 12 -42 18 -51 8 -13 6 -24
-6 -43 -9 -14 -17 -32 -17 -41 0 -8 -9 -23 -20 -32 -11 -10 -20 -26 -20 -36 0
-10 -9 -38 -20 -63 -24 -52 -22 -59 25 -74 30 -10 35 -16 35 -41 0 -30 0 -30
-72 -24 -125 11 -137 17 -102 56 15 17 13 21 -28 61 -60 59 -102 77 -128 53
-17 -15 -17 -20 -5 -39 7 -11 16 -45 20 -74 7 -52 6 -54 -16 -50 -42 6 -69 62
-69 140 0 82 9 102 51 117 52 18 113 -3 154 -54 19 -23 35 -51 35 -63 0 -11 5
-24 12 -28 34 -21 56 108 33 195 -7 29 -14 105 -15 169 -2 151 -4 142 23 142
17 0 28 -11 45 -45z m218 -136 c14 -12 10 -55 -7 -73 -12 -14 -55 8 -75 39
-31 47 34 74 82 34z m21 -185 c27 -7 63 -62 63 -95 0 -30 -41 -90 -60 -87 -8
2 -19 20 -25 41 -10 37 -56 87 -80 87 -7 0 -24 -9 -38 -20 -30 -24 -50 -9 -36
28 15 40 107 64 176 46z m-416 -305 c5 -11 20 -19 35 -19 36 0 41 -27 11 -57
-27 -28 -62 -27 -90 2 -20 20 -32 86 -17 95 18 11 49 0 61 -21z m-413 -1148
c-2 -19 -9 -36 -15 -39 -14 -4 -19 99 -6 112 11 11 24 -35 21 -73z m578 -99
c5 -17 15 -37 22 -44 7 -7 12 -19 12 -29 0 -9 8 -27 19 -40 39 -51 33 -190
-10 -232 -11 -10 -19 -25 -19 -35 0 -9 -7 -26 -15 -36 -8 -11 -15 -35 -15 -53
0 -28 6 -35 41 -53 31 -16 40 -26 37 -43 -3 -21 -7 -22 -78 -19 -41 2 -83 6
-92 8 -24 7 -22 29 4 46 24 16 18 38 -11 38 -10 0 -23 11 -29 25 -14 30 -92
71 -117 61 -13 -5 -16 -13 -11 -34 26 -105 15 -152 -26 -116 -40 37 -50 71
-43 145 6 60 11 72 35 89 35 25 56 25 107 1 46 -23 91 -77 105 -128 14 -50 30
-29 44 55 9 48 9 73 1 87 -11 20 -26 294 -18 328 6 30 44 17 57 -21z m-246 9
c5 -11 19 -23 30 -26 32 -10 41 -38 32 -104 -6 -42 -15 -66 -28 -76 -24 -18
-24 -19 -58 10 -28 22 -29 26 -16 50 12 22 11 30 -3 60 -20 42 -22 76 -5 93
18 18 36 15 48 -7z m378 -100 c12 -17 18 -33 13 -36 -11 -6 -61 40 -61 55 0
20 27 9 48 -19z m-300 -541 c7 -11 23 -20 37 -20 36 0 42 -26 15 -56 -27 -28
-56 -31 -87 -9 -27 19 -58 80 -48 94 11 19 69 13 83 -9z m-128 -37 c0 -93 -32
-113 -49 -33 -15 70 -15 70 19 70 28 0 30 -2 30 -37z m295 -1175 c4 -18 13
-40 20 -48 7 -8 16 -26 20 -40 4 -14 14 -33 22 -42 24 -27 14 -155 -15 -192
-12 -16 -22 -42 -22 -58 0 -16 -7 -36 -16 -45 -9 -10 -14 -29 -12 -51 3 -31 7
-37 34 -44 18 -4 35 -15 38 -24 7 -18 -10 -54 -25 -54 -6 0 -6 -7 1 -19 14
-28 48 -36 69 -17 21 19 62 21 79 4 7 -7 12 -26 12 -44 0 -30 -2 -32 -57 -43
-38 -7 -60 -8 -67 -1 -5 5 -20 10 -32 10 -20 0 -22 -4 -17 -36 4 -27 1 -42
-16 -64 -11 -16 -21 -36 -21 -45 0 -22 -27 -19 -40 5 -13 24 -18 154 -8 190 4
15 23 35 44 47 36 20 36 20 -22 27 -33 4 -67 9 -76 12 -29 9 -20 34 16 49 19
8 37 23 40 32 7 25 8 181 1 366 -6 157 -6 157 19 157 20 0 26 -6 31 -32z
m-345 -253 c22 -26 -12 -49 -37 -24 -14 14 -6 39 12 39 7 0 18 -7 25 -15z
m141 -59 c37 -16 89 -61 89 -77 0 -6 7 -17 16 -26 19 -19 15 -77 -6 -80 -8 -2
-24 12 -35 30 -24 37 -87 64 -128 53 -33 -8 -34 -20 -2 -58 17 -20 25 -42 25
-69 0 -35 -3 -39 -25 -39 -14 0 -25 6 -25 13 0 8 -8 22 -19 31 -15 14 -18 32
-19 99 -1 96 1 100 48 120 45 20 42 20 81 3z m430 -3 c32 -12 46 -26 60 -57
23 -51 23 -66 2 -111 -23 -48 -49 -47 -58 4 -5 29 -16 47 -42 67 -35 26 -36
26 -71 10 -72 -35 -61 39 13 81 48 27 45 27 96 6z m-409 -318 c20 -14 47 -24
60 -22 32 3 33 -23 2 -56 -30 -32 -50 -31 -108 6 -37 23 -48 61 -24 85 17 17
29 15 70 -13z m-402 -590 c0 -27 -15 -41 -25 -25 -10 16 4 62 15 55 6 -3 10
-17 10 -30z m2 -132 c1 -16 3 -55 6 -88 12 -164 7 -200 -23 -175 -17 14 -20
83 -9 213 7 75 22 105 26 50z m-42 -521 c0 -22 -45 -68 -54 -54 -3 6 -3 24 0
41 7 36 54 47 54 13z m421 -323 c80 -28 156 -165 102 -186 -10 -4 -19 -1 -21
6 -10 29 -64 79 -90 84 -61 12 -87 -9 -55 -45 22 -25 25 -111 3 -116 -33 -6
-62 54 -66 141 -4 94 -1 102 46 115 47 14 42 14 81 1z m459 -9 c23 -12 53 -95
46 -124 -8 -33 -41 -70 -54 -62 -6 4 -16 24 -21 44 -15 53 -95 96 -116 62 -3
-5 -14 -10 -25 -10 -11 0 -20 -10 -24 -25 -4 -14 -11 -25 -16 -25 -14 0 -12
26 3 42 8 7 17 24 20 38 10 37 18 46 57 64 36 16 96 14 130 -4z m-435 -305
c23 -16 44 -23 56 -20 30 10 34 -19 8 -54 -31 -42 -69 -42 -114 3 -37 35 -41
46 -25 77 14 25 30 24 75 -6z"/>
<path d="M3453 14414 c-6 -17 14 -44 33 -44 8 0 14 10 14 24 0 27 -38 44 -47
20z"/>
<path d="M6807 19973 c-4 -3 -7 -18 -7 -33 0 -14 -11 -41 -25 -60 -67 -90 17
-160 198 -163 82 -2 82 -2 85 56 3 53 5 58 24 55 16 -2 26 -16 37 -48 24 -68
25 -69 94 -68 81 1 127 19 127 51 0 20 -8 27 -51 40 -27 9 -69 32 -92 50 -55
43 -110 67 -136 60 -12 -3 -29 1 -39 10 -9 8 -37 18 -62 22 -25 4 -54 14 -65
21 -20 15 -77 19 -88 7z"/>
<path d="M11684 19891 c-13 -13 2 -19 51 -20 42 0 55 3 55 14 0 12 -12 14 -51
13 -27 -1 -52 -4 -55 -7z"/>
<path d="M2610 19835 c-8 -21 -6 -31 8 -50 27 -39 40 -31 37 23 -4 55 -28 70
-45 27z"/>
<path d="M13180 19773 c0 -94 12 -134 45 -151 18 -9 46 -33 63 -53 31 -36 32
-38 27 -118 -4 -72 -3 -83 15 -98 14 -12 20 -30 20 -59 0 -27 6 -47 19 -58 10
-9 21 -30 24 -46 5 -24 12 -30 44 -35 79 -12 98 -20 101 -42 4 -30 30 -50 38
-30 7 20 -13 57 -31 57 -8 0 -15 7 -15 15 0 9 -12 21 -27 27 -35 15 -113 88
-113 105 0 7 10 13 23 13 13 0 32 6 42 14 18 13 17 14 -8 31 -35 23 -34 28 10
42 31 9 41 9 54 -3 22 -20 59 -18 59 3 0 9 -18 33 -40 53 -38 35 -40 40 -34
76 5 33 2 44 -20 67 -14 15 -26 34 -26 40 0 31 -117 114 -146 103 -23 -9 -82
25 -88 51 -9 33 -36 30 -36 -4z"/>
<path d="M9910 19765 c0 -12 8 -16 33 -13 17 2 32 8 32 13 0 6 -15 11 -32 13
-25 3 -33 -1 -33 -13z"/>
<path d="M13470 19755 c-16 -20 -1 -38 23 -29 21 8 22 18 3 33 -10 9 -16 8
-26 -4z"/>
<path d="M6560 19743 c-56 -6 -69 -13 -42 -24 37 -14 145 -21 172 -11 25 9 25
9 -7 26 -31 16 -50 17 -123 9z"/>
<path d="M7696 19743 c-14 -15 -4 -39 24 -58 34 -23 39 -54 10 -62 -22 -6 -28
-23 -7 -23 7 0 18 -9 24 -19 17 -28 85 -37 117 -16 29 19 46 13 46 -17 0 -11
10 -53 22 -92 16 -50 22 -97 23 -161 0 -88 1 -90 28 -103 37 -18 36 -54 -3
-89 -40 -35 -43 -88 -5 -81 37 8 37 -48 -1 -62 -30 -12 -27 -34 5 -38 12 -2
29 -14 37 -28 9 -13 25 -24 35 -24 25 0 44 -46 28 -66 -6 -7 -19 -16 -30 -19
-14 -5 -19 -16 -19 -46 0 -49 19 -59 52 -26 21 21 49 32 168 66 35 10 38 39 6
47 -14 3 -26 10 -26 14 0 5 -16 14 -37 21 -32 10 -38 9 -49 -6 -38 -51 -66 30
-65 189 0 61 1 129 1 151 0 56 8 225 12 254 2 20 -8 32 -57 67 -33 24 -70 48
-83 54 -35 15 -25 44 17 48 33 3 33 4 28 45 -6 45 -23 62 -76 77 -47 13 -62
-2 -33 -33 12 -13 22 -31 22 -40 0 -21 -33 -22 -50 -2 -7 8 -25 15 -40 15 -21
0 -30 7 -40 30 -7 17 -15 31 -19 31 -32 6 -60 7 -65 2z"/>
<path d="M2566 19731 c-9 -14 23 -83 36 -79 26 9 32 36 15 62 -17 26 -41 34
-51 17z"/>
<path d="M7541 19686 c-7 -8 -34 -18 -59 -21 -63 -7 -228 -34 -276 -45 -23 -5
-50 -4 -63 1 -14 5 -66 9 -116 9 -51 0 -126 7 -167 16 -78 16 -204 26 -227 17
-22 -9 -15 -23 17 -34 17 -6 30 -15 30 -19 0 -5 17 -14 38 -20 20 -7 41 -16
46 -21 6 -5 29 -9 52 -9 31 0 47 -5 56 -19 8 -11 26 -23 41 -26 14 -4 31 -13
37 -20 6 -8 25 -17 41 -20 16 -4 32 -11 35 -16 3 -6 17 -14 30 -19 14 -6 24
-18 24 -29 0 -24 13 -33 34 -25 20 8 20 23 1 44 -38 42 30 75 182 86 79 6 91
9 84 22 -26 46 17 64 92 38 34 -13 40 -12 55 4 9 9 28 20 42 23 26 7 80 51 80
67 0 24 -91 38 -109 16z"/>
<path d="M9552 19690 c-32 -14 -18 -30 26 -30 36 -1 102 -43 89 -57 -3 -3 -41
7 -84 21 -103 34 -147 34 -112 -1 19 -19 0 -33 -44 -33 -79 0 -144 -111 -106
-182 11 -20 12 -19 42 10 45 44 113 72 173 72 71 0 83 -16 55 -73 -12 -24 -21
-48 -21 -53 0 -21 -48 -56 -68 -50 -24 8 -33 -3 -26 -31 4 -14 20 -25 48 -34
70 -21 150 -107 144 -156 -4 -39 -25 -39 -44 -1 -10 23 -29 40 -55 51 -49 21
-52 21 -72 0 -13 -16 -14 -20 -1 -37 8 -11 14 -33 14 -48 0 -35 25 -98 40 -98
5 0 20 -11 32 -25 17 -20 28 -24 50 -20 25 6 28 4 28 -19 0 -50 -80 -63 -126
-21 -43 40 -61 33 -69 -24 -8 -59 0 -90 29 -113 21 -17 20 -18 -30 -18 -85 0
-145 11 -151 29 -10 27 -36 52 -72 67 -44 18 -48 18 -56 -6 -9 -27 -29 -25
-60 6 -26 26 -26 26 -51 3 -30 -29 -30 -39 0 -39 49 0 73 -52 28 -58 -16 -3
-27 6 -43 32 -25 43 -44 50 -117 41 -48 -5 -62 -3 -82 13 -14 10 -33 22 -44
26 -18 6 -18 7 -1 26 16 18 16 21 -6 67 -13 26 -22 57 -21 69 4 30 -21 49 -38
29 -16 -19 -60 -19 -86 -1 -11 9 -30 12 -46 9 -25 -5 -29 -2 -34 26 -12 58
-27 38 -40 -53 -5 -36 -12 -50 -26 -54 -13 -3 -18 -12 -16 -26 3 -19 8 -21 68
-18 58 3 68 7 91 33 24 28 47 41 34 19 -11 -17 5 -70 28 -91 20 -19 61 -109
52 -117 -10 -11 -105 32 -120 54 -17 27 -35 24 -35 -6 0 -26 -5 -27 -97 -20
-59 5 -88 12 -103 25 -18 16 -20 16 -20 2 0 -10 7 -17 15 -17 8 0 15 -7 15
-15 0 -9 9 -34 20 -55 20 -40 20 -40 603 -41 1033 0 1275 -5 1320 -25 36 -17
41 -17 87 0 52 19 91 18 97 0 2 -7 -10 -17 -27 -22 -52 -19 -28 -42 45 -42 17
0 40 -6 51 -14 11 -8 36 -17 57 -21 37 -7 87 -58 87 -89 0 -31 23 -66 45 -66
38 0 64 51 31 63 -8 3 -20 18 -28 34 -8 15 -21 38 -29 51 -12 19 -12 24 0 31
15 10 72 -39 84 -71 6 -16 63 -38 99 -38 9 0 19 -4 22 -9 3 -5 50 -17 103 -27
54 -9 105 -23 114 -31 29 -24 129 -15 129 12 0 14 -28 25 -123 46 -49 11 -64
19 -93 54 -19 23 -34 47 -34 53 0 14 44 26 65 19 8 -4 21 0 29 8 22 22 39 19
33 -6 -4 -14 2 -30 19 -48 23 -25 29 -26 119 -25 60 1 101 7 111 15 12 10 18
9 31 -3 33 -34 -18 -82 -84 -78 -47 3 -64 0 -58 -10 4 -6 23 -7 44 -4 28 4 46
1 65 -12 28 -17 28 -17 61 20 29 33 34 48 46 131 8 58 19 102 29 113 9 9 19
25 23 35 3 9 11 17 17 17 6 0 13 -8 16 -17 3 -10 12 -30 19 -44 9 -16 12 -40
8 -62 -3 -23 -2 -37 5 -37 16 0 26 21 24 50 -3 35 55 119 98 143 19 10 37 23
38 28 2 5 17 16 33 24 16 9 29 24 29 34 0 16 -69 81 -85 81 -7 0 -53 35 -85
64 -8 7 -26 19 -38 25 -24 13 -24 13 -3 35 21 23 21 23 -16 39 -21 10 -63 31
-93 47 -30 16 -62 30 -71 30 -9 0 -22 6 -28 14 -7 8 -45 30 -84 49 -40 19 -81
44 -91 56 -23 25 -123 77 -169 87 -17 3 -43 15 -56 25 -13 11 -28 19 -33 19
-5 0 -22 10 -39 22 -26 20 -43 23 -137 24 -111 1 -228 23 -266 49 -11 8 -30
15 -42 15 -12 0 -27 7 -34 15 -7 8 -28 17 -49 21 -20 4 -50 15 -67 25 -17 11
-48 19 -68 19 -20 0 -51 6 -69 14 -43 18 -136 29 -224 27 -49 -1 -83 3 -110
15 -44 20 -360 31 -401 14z m308 -25 c19 -22 4 -45 -28 -45 -54 0 -61 35 -12
53 24 9 27 8 40 -8z m461 -121 c34 -17 27 -37 -16 -48 -15 -4 -31 -20 -40 -39
-8 -17 -19 -40 -25 -49 -5 -10 -14 -26 -19 -35 -11 -24 -61 -30 -61 -9 0 9 4
16 9 16 4 0 11 19 15 43 12 82 19 112 28 125 14 17 73 15 109 -4z m-563 -52
c6 -15 16 -34 21 -42 54 -85 70 -201 32 -237 -28 -27 -61 -98 -61 -133 0 -26
6 -32 40 -46 27 -11 40 -22 40 -35 0 -17 -8 -19 -83 -19 -98 0 -138 18 -103
45 11 8 25 15 32 15 24 0 47 151 34 221 -5 24 -11 90 -15 145 -7 92 -6 103 11
112 24 13 38 7 52 -26z m310 -41 c29 -15 35 -41 27 -116 -6 -51 -11 -65 -24
-65 -20 0 -111 57 -111 69 0 5 -9 11 -19 14 -26 7 -58 74 -44 96 19 30 117 31
171 2z m478 -22 c4 -7 7 -30 8 -53 1 -41 1 -41 72 -42 64 0 76 -4 115 -32 53
-39 49 -39 95 3 22 20 51 38 67 42 34 7 42 19 26 39 -19 23 -6 25 64 8 43 -11
67 -22 67 -31 0 -14 -6 -17 -52 -27 -20 -5 -28 -13 -28 -29 0 -18 -19 -31
-108 -74 -59 -29 -116 -53 -127 -53 -22 0 -95 -46 -95 -59 0 -37 106 -37 205
-1 28 9 82 21 120 24 39 4 79 10 90 12 27 7 112 -50 131 -88 13 -26 13 -35 -2
-91 -9 -34 -21 -66 -25 -71 -19 -21 -7 -35 33 -41 40 -7 44 -5 73 29 32 39
124 81 155 71 9 -3 25 -24 35 -46 29 -63 85 -81 107 -34 21 47 108 19 108 -34
0 -10 7 -21 15 -25 29 -11 15 -35 -27 -48 -35 -10 -42 -10 -46 2 -14 40 -48
58 -103 54 -80 -5 -106 -55 -54 -104 35 -33 33 -76 -7 -128 -43 -56 -84 -58
-122 -9 -30 40 -31 43 -11 64 23 22 1 43 -45 43 -38 0 -140 -43 -140 -60 0
-18 -96 -40 -179 -40 -75 0 -93 4 -146 30 -33 16 -71 30 -83 30 -13 0 -35 9
-49 20 -14 11 -41 20 -59 20 -20 0 -37 6 -42 16 -9 17 -34 32 -98 63 -23 11
-45 24 -48 30 -4 6 -14 11 -23 11 -9 0 -27 9 -39 21 -45 42 -51 -15 -7 -64 29
-31 1 -44 -41 -19 -48 28 -100 37 -135 23 -24 -11 -34 -9 -76 13 -67 36 -81
34 -97 -16 -15 -49 -51 -64 -75 -32 -16 22 -17 66 -1 82 17 17 10 20 -77 23
-80 4 -80 4 -83 -31 -4 -34 -45 -85 -62 -75 -20 12 -35 180 -17 192 23 14 115
12 121 -3 7 -18 36 -18 36 0 0 23 22 24 69 3 44 -19 44 -19 77 19 40 46 45 91
13 96 -24 3 -35 19 -43 60 -8 36 -89 77 -117 59 -22 -13 -26 6 -9 39 34 64
190 34 190 -36 0 -13 5 -26 10 -29 6 -3 10 -24 10 -46 0 -38 1 -39 36 -39 36
0 37 0 31 36 -4 25 0 49 13 76 16 33 16 40 4 45 -21 8 -17 30 7 47 12 8 29 26
38 40 10 14 45 41 80 59 58 31 68 33 114 26 38 -6 56 -16 72 -36 22 -27 22
-27 34 -6 6 12 11 32 11 45 0 37 31 61 46 37z m568 -135 c28 -11 17 -24 -18
-24 -38 0 -57 16 -29 23 28 7 30 7 47 1z m270 -119 c35 -36 30 -52 -38 -120
-68 -66 -116 -92 -116 -61 0 9 4 16 9 16 11 0 51 105 51 134 0 44 61 64 94 31z
m249 -139 c35 -28 34 -65 -3 -83 -32 -16 -46 -3 -54 48 -10 64 8 76 57 35z
m-2028 -305 c9 -15 -10 -21 -45 -15 -22 5 -28 9 -18 15 18 12 55 11 63 0z"/>
<path d="M10453 19312 c-6 -4 -17 -20 -23 -36 -21 -56 9 -75 49 -32 36 39 15
95 -26 68z"/>
<path d="M10214 19110 c-27 -11 -35 -32 -27 -70 7 -37 17 -44 42 -30 17 8 26
5 54 -20 19 -16 39 -30 43 -30 19 0 81 -39 124 -79 25 -22 55 -41 67 -41 12 0
27 -9 33 -19 6 -12 26 -22 49 -26 22 -4 45 -13 52 -21 6 -8 19 -14 28 -14 9 0
33 -8 54 -19 20 -10 58 -22 84 -26 27 -3 58 -13 70 -21 29 -18 145 -18 181 0
15 7 45 17 67 20 31 6 47 16 69 47 17 21 37 39 46 39 24 0 32 11 19 27 -19 22
-58 16 -71 -11 -16 -36 -32 -38 -69 -10 -42 30 -53 30 -67 -1 -10 -22 -15 -24
-31 -15 -11 5 -36 10 -55 10 -33 0 -36 3 -36 28 0 16 -8 36 -18 45 -21 19 -42
22 -42 7 0 -5 5 -10 10 -10 6 0 10 -13 10 -30 0 -27 -3 -30 -35 -32 -19 -1
-43 -2 -52 -2 -10 -1 -19 7 -21 18 -2 10 -20 34 -39 53 -36 36 -63 38 -63 5 0
-27 -46 -17 -67 15 -16 24 -16 24 -37 3 -17 -15 -25 -17 -34 -8 -6 6 -33 18
-59 27 -48 16 -48 16 -48 63 0 25 -2 48 -5 50 -35 29 -81 48 -97 39 -30 -15
-72 -2 -79 25 -7 25 -16 28 -50 14z"/>
<path d="M11007 19003 c-15 -15 -5 -32 24 -42 43 -15 69 -14 69 3 0 28 -74 59
-93 39z"/>
<path d="M2665 19613 c-18 -43 -15 -65 18 -114 31 -47 53 -48 73 -6 19 39 13
66 -15 74 -19 5 -41 42 -41 68 0 28 -20 15 -35 -22z"/>
<path d="M8242 19520 c-24 -29 -19 -219 6 -237 35 -26 41 -34 36 -48 -4 -9
-19 -15 -38 -15 -42 0 -50 -9 -29 -33 15 -16 18 -39 18 -139 0 -114 1 -121 23
-135 12 -9 22 -21 22 -27 1 -28 45 -64 73 -59 38 8 35 41 -8 93 -40 47 -39 45
-25 71 12 21 30 24 58 10 41 -21 107 -30 120 -17 18 17 -1 56 -26 56 -9 0 -25
14 -34 30 -17 30 -41 39 -53 20 -23 -37 -34 22 -14 79 9 26 8 35 -5 50 -20 22
-21 41 -2 41 24 0 28 18 11 43 -8 13 -13 31 -10 39 3 8 -1 28 -10 44 -8 16
-15 44 -15 62 0 78 -57 119 -98 72z"/>
<path d="M7666 19505 c-3 -9 3 -33 13 -53 15 -30 19 -65 23 -179 3 -140 3
-142 -19 -152 -51 -23 -13 -91 50 -91 39 0 88 -23 114 -54 24 -27 33 -30 71
-20 25 7 30 45 10 70 -57 68 -79 84 -131 101 -64 20 -67 26 -32 59 24 22 25
27 25 158 0 135 0 135 -30 149 -51 26 -87 30 -94 12z"/>
<path d="M8100 19508 c0 -16 9 -28 37 -51 21 -18 22 -18 33 4 11 19 9 25 -11
40 -28 21 -59 25 -59 7z"/>
<path d="M6745 19489 c-4 -5 0 -18 9 -28 9 -10 16 -32 16 -49 0 -30 2 -32 36
-32 19 0 54 -11 77 -24 52 -30 113 -41 133 -25 19 16 18 38 -3 46 -10 3 -26
13 -36 21 -18 16 -46 33 -87 54 -14 7 -36 20 -49 30 -26 20 -86 24 -96 7z"/>
<path d="M9155 19480 c-16 -11 -42 -20 -57 -20 -15 0 -31 -6 -35 -14 -11 -19
-103 -57 -122 -51 -26 8 -43 -10 -39 -41 3 -27 6 -29 41 -27 21 2 55 12 76 24
23 13 50 19 71 17 31 -3 35 -7 42 -41 5 -22 4 -46 -1 -55 -12 -21 27 -69 81
-99 52 -30 51 -31 43 25 -5 38 -3 51 9 62 15 11 14 17 -10 57 -22 39 -25 54
-22 111 3 65 2 67 -22 70 -14 1 -38 -7 -55 -18z"/>
<path d="M8554 19466 c-7 -19 3 -36 22 -36 10 0 14 8 12 22 -4 26 -26 36 -34
14z"/>
<path d="M2610 19441 c0 -28 21 -61 40 -61 23 0 28 38 8 58 -14 14 -48 16 -48
3z"/>
<path d="M7397 19414 c-4 -4 -7 -23 -7 -41 0 -27 4 -34 18 -31 12 2 17 13 17
37 0 33 -13 49 -28 35z"/>
<path d="M7207 19385 c10 -13 26 -27 36 -31 10 -3 23 -19 29 -35 13 -37 28
-37 28 -1 0 28 -22 54 -67 80 -35 19 -46 14 -26 -13z"/>
<path d="M13508 19303 c-19 -21 -24 -58 -9 -68 14 -8 33 32 29 62 -3 25 -3 25
-20 6z"/>
<path d="M8533 19264 c-25 -49 -22 -64 16 -98 20 -18 22 -18 40 -2 17 16 19
16 24 -4 8 -29 47 -27 47 3 0 13 -5 28 -12 35 -9 9 -9 15 0 24 30 30 -1 72
-64 83 -26 5 -31 1 -51 -41z"/>
<path d="M8760 19265 c0 -17 -8 -29 -25 -37 -33 -15 -32 -27 5 -39 17 -6 30
-15 30 -20 0 -4 10 -13 21 -20 35 -18 44 11 13 40 -22 20 -25 30 -21 62 4 29
2 39 -9 39 -8 0 -14 -10 -14 -25z"/>
<path d="M7400 19248 c0 -12 70 -68 84 -68 14 0 4 32 -16 55 -22 26 -68 34
-68 13z"/>
<path d="M7230 19206 c0 -30 15 -42 24 -20 10 27 7 44 -9 44 -9 0 -15 -9 -15
-24z"/>
<path d="M9373 19183 c-53 -120 -55 -164 -7 -215 23 -23 36 -28 75 -28 66 0
80 20 41 60 -20 20 -32 44 -37 72 -3 24 -10 57 -15 73 -4 17 -11 42 -14 58 -9
38 -18 34 -43 -20z"/>
<path d="M7315 19210 c-3 -5 1 -22 9 -37 8 -16 17 -36 20 -45 3 -10 13 -18 21
-18 14 0 15 8 9 48 -3 26 -8 50 -11 55 -6 10 -41 9 -48 -3z"/>
<path d="M7552 19198 c2 -13 8 -23 13 -23 6 0 11 10 13 23 2 15 -2 22 -13 22
-11 0 -15 -7 -13 -22z"/>
<path d="M5927 19148 c-15 -35 -30 -83 -33 -108 -5 -42 -3 -47 29 -78 30 -30
39 -33 82 -30 64 4 82 29 43 61 -35 28 -50 68 -53 138 -3 100 -30 107 -68 17z"/>
<path d="M11760 19172 c0 -5 37 -42 81 -83 53 -48 88 -89 100 -116 10 -24 22
-43 27 -43 9 0 42 75 56 125 6 22 54 55 79 55 9 0 19 -9 22 -21 9 -27 50 -22
50 6 0 15 -6 19 -24 17 -13 -1 -31 4 -40 12 -24 22 -88 33 -157 28 -39 -3 -81
2 -117 12 -62 18 -77 20 -77 8z"/>
<path d="M5715 19139 c-10 -15 2 -50 27 -82 21 -26 25 -27 51 -15 36 17 33 52
-5 56 -18 2 -28 11 -32 28 -7 25 -30 32 -41 13z"/>
<path d="M6796 19134 c-12 -30 16 -68 52 -71 41 -3 41 12 3 55 -33 36 -46 40
-55 16z"/>
<path d="M7145 19121 c-7 -23 12 -74 25 -66 16 10 12 85 -4 85 -8 0 -17 -8
-21 -19z"/>
<path d="M8980 19079 c0 -40 16 -69 39 -69 21 0 51 -40 51 -68 0 -11 5 -33 11
-51 13 -36 52 -43 69 -12 5 11 22 21 37 23 41 5 37 21 -16 61 -46 35 -49 41
-44 71 6 38 -15 62 -24 27 -7 -28 -10 -27 -49 14 -42 45 -74 47 -74 4z"/>
<path d="M7075 19058 c11 -49 23 -68 45 -68 24 0 28 38 4 47 -8 3 -20 16 -25
29 -13 37 -32 30 -24 -8z"/>
<path d="M7232 19070 c-7 -11 -19 -20 -28 -20 -28 0 -13 -54 16 -58 52 -8 56
-41 11 -95 -17 -20 -15 -23 21 -32 24 -6 29 -2 47 33 11 23 25 43 30 47 11 6
3 35 -10 35 -22 0 -59 49 -59 79 0 36 -10 40 -28 11z"/>
<path d="M8916 19061 c-9 -14 4 -41 21 -41 9 0 13 8 11 22 -3 23 -23 35 -32
19z"/>
<path d="M5540 19027 c0 -27 12 -47 27 -47 21 0 13 54 -9 58 -11 2 -18 -3 -18
-11z"/>
<path d="M7410 19003 c0 -6 5 -15 10 -18 6 -3 10 -21 10 -38 1 -41 44 -97 61
-80 9 9 8 18 -5 38 -10 15 -15 33 -12 41 4 9 -3 18 -18 24 -14 5 -29 17 -35
27 -6 10 -11 13 -11 6z"/>
<path d="M4880 18940 c0 -34 62 -55 74 -24 9 24 -12 44 -45 44 -22 0 -29 -5
-29 -20z"/>
<path d="M6745 18937 c-8 -29 9 -67 30 -67 19 0 31 48 18 69 -17 26 -42 25
-48 -2z"/>
<path d="M7760 18920 c-46 -46 -12 -54 40 -10 34 30 34 30 7 30 -15 0 -36 -9
-47 -20z"/>
<path d="M7161 18861 c-8 -5 -10 -14 -7 -20 9 -13 33 -15 40 -2 9 14 -18 31
-33 22z"/>
<path d="M7736 18805 c-11 -8 -28 -12 -38 -9 -33 10 -64 -96 -36 -124 18 -18
24 -15 47 23 38 64 128 42 208 -51 53 -61 73 -59 73 9 0 84 -95 167 -189 167
-25 0 -55 -7 -65 -15z"/>
<path d="M13385 18745 c-22 -25 -40 -51 -40 -57 0 -21 26 -20 32 1 6 25 40 28
69 6 19 -15 19 -15 -5 -35 -23 -20 -23 -20 3 -20 26 0 46 -16 79 -64 10 -14
27 -26 39 -26 19 0 20 4 16 70 -3 44 -11 77 -21 88 -9 9 -20 30 -26 45 -8 22
-16 27 -30 22 -11 -3 -22 -1 -26 5 -14 23 -51 9 -90 -35z"/>
<path d="M5300 18676 c-14 -7 -45 -16 -69 -20 -54 -8 -81 -22 -81 -41 0 -17
18 -19 39 -6 24 16 41 2 35 -29 -4 -15 -1 -30 4 -34 12 -7 101 12 118 25 6 5
39 12 73 15 34 4 64 10 66 15 7 10 -35 39 -55 39 -9 0 -27 11 -40 25 -26 28
-52 31 -90 11z"/>
<path d="M8401 18661 c-12 -8 -12 -12 -2 -25 21 -26 51 -20 51 9 0 26 -22 33
-49 16z"/>
<path d="M10082 18614 c-15 -11 -7 -17 63 -49 109 -49 110 -49 113 -74 3 -16
10 -21 36 -21 19 0 43 -9 56 -20 13 -11 29 -20 37 -20 21 0 121 -85 160 -135
19 -25 38 -45 43 -45 5 0 3 -21 -5 -47 -21 -67 -19 -109 5 -133 11 -11 24 -20
29 -20 18 0 41 31 41 54 0 13 7 29 15 36 20 16 102 -23 117 -56 7 -15 20 -24
34 -24 20 0 43 -27 79 -92 12 -22 43 -23 73 -2 41 28 102 -9 150 -90 36 -61
19 -87 -68 -100 -42 -6 -140 -62 -165 -94 -6 -7 -21 -11 -34 -10 -40 5 -93
-107 -61 -127 15 -9 65 21 77 47 7 15 26 29 50 36 22 7 66 26 97 43 80 42 108
37 118 -19 4 -23 10 -47 14 -53 6 -11 50 -8 104 6 40 10 71 -21 77 -78 7 -55
20 -59 70 -21 32 24 37 25 61 13 35 -18 42 -28 42 -64 0 -18 9 -37 24 -50 18
-15 25 -34 30 -78 6 -58 6 -58 -24 -35 -30 21 -36 35 -42 87 -5 39 -52 50 -84
20 -22 -20 -38 -24 -105 -28 -86 -3 -96 -12 -87 -72 3 -26 6 -26 128 -13 53 5
57 4 98 -31 77 -66 92 -133 47 -205 -31 -48 -31 -50 -2 -50 28 0 75 44 118
110 23 35 35 46 41 38 12 -20 9 -106 -4 -128 -10 -15 -9 -22 5 -38 9 -10 17
-27 17 -38 0 -11 9 -27 21 -37 24 -21 23 -80 -2 -85 -16 -3 -79 84 -79 110 0
25 -10 26 -72 7 -33 -10 -84 -21 -114 -25 -52 -6 -54 -5 -64 21 -11 28 -33 30
-38 3 -2 -9 6 -19 17 -23 13 -4 21 -15 21 -29 0 -42 32 -59 98 -51 66 7 120
-15 140 -59 30 -67 22 -218 -15 -258 -25 -28 -62 -23 -73 10 -21 56 -36 75
-86 108 -53 35 -82 41 -115 24 -30 -17 -23 -46 17 -69 29 -18 35 -26 30 -45
-3 -13 1 -31 8 -42 14 -18 15 -18 25 10 9 23 14 26 26 16 19 -16 19 -49 0 -56
-21 -8 -19 -15 10 -47 31 -32 67 -35 95 -7 11 11 28 20 39 20 10 0 24 7 31 15
7 8 16 15 21 15 33 0 104 116 119 195 5 22 16 60 25 85 32 85 4 321 -48 408
-29 48 -35 69 -39 132 -4 67 -10 84 -50 155 -43 74 -48 80 -76 78 -30 -3 -30
-2 -37 60 -8 66 -29 114 -55 122 -8 3 -25 24 -38 47 -37 69 -90 124 -104 110
-10 -10 -8 -22 11 -57 26 -49 22 -65 -15 -65 -15 0 -39 -14 -61 -35 -22 -22
-40 -32 -46 -26 -14 14 2 69 25 85 12 9 26 37 34 67 12 47 12 55 -3 71 -13 15
-14 23 -5 42 10 23 9 25 -21 28 -19 2 -35 11 -42 23 -5 11 -21 33 -35 48 -23
26 -29 28 -70 23 -66 -9 -83 7 -82 73 1 37 -2 53 -13 57 -8 4 -15 15 -15 25 0
11 -10 23 -22 28 -13 5 -32 18 -42 30 -11 11 -27 21 -37 21 -10 0 -20 4 -23 9
-3 4 -16 6 -29 4 -17 -3 -40 6 -74 31 -28 20 -57 36 -64 36 -8 0 -22 9 -32 20
-9 11 -25 20 -34 20 -10 0 -31 7 -48 16 -16 9 -52 20 -79 25 -27 4 -56 15 -66
24 -9 8 -24 15 -33 15 -8 0 -28 5 -44 11 -27 10 -27 11 -9 25 11 8 36 14 55
14 26 0 32 3 24 11 -7 7 -56 14 -110 17 -74 3 -103 9 -118 22 -26 23 -81 30
-103 14z m686 -326 c-5 -15 -58 -24 -58 -10 0 15 12 22 38 22 14 0 22 -5 20
-12z m-68 -42 c0 -26 -64 -37 -73 -12 -7 17 7 24 46 25 17 1 27 -4 27 -13z
m176 -48 c30 -29 30 -52 -1 -72 -33 -22 -33 -22 -46 23 -20 67 3 90 47 49z"/>
<path d="M5893 18603 c-30 -20 -29 -41 2 -49 31 -8 55 10 55 42 0 28 -23 31
-57 7z"/>
<path d="M5986 18611 c-4 -6 1 -14 11 -18 10 -3 27 -13 38 -22 28 -24 120 -54
142 -47 15 5 185 16 273 19 14 0 194 -1 400 -2 206 -1 422 -2 480 -2 140 0
181 -12 133 -38 -23 -12 -211 -17 -241 -7 -17 5 -29 3 -42 -9 -15 -13 -28 -16
-57 -10 -37 6 -63 7 -147 5 -22 0 -52 4 -68 11 -22 9 -31 9 -43 -1 -24 -20
-283 -24 -312 -5 -30 20 -56 19 -77 -4 -14 -15 -30 -19 -71 -18 -33 1 -60 -4
-71 -13 -16 -14 -17 -13 -12 8 8 29 -9 37 -57 28 -49 -10 -47 -38 4 -58 30
-12 40 -22 46 -47 4 -17 15 -36 26 -41 11 -6 19 -21 19 -35 0 -16 6 -25 16
-25 14 0 16 7 11 40 -7 56 27 84 96 77 65 -6 78 -22 86 -104 12 -118 48 -157
104 -113 51 40 63 28 73 -78 9 -94 15 -102 73 -102 41 0 52 -4 76 -32 28 -31
28 -31 49 -5 20 25 23 26 44 11 20 -14 24 -14 48 5 34 27 42 26 74 -4 27 -26
27 -26 52 -5 40 31 78 20 78 -22 0 -14 4 -16 18 -9 9 5 24 12 33 14 12 4 15
14 11 37 -4 27 -2 31 14 28 12 -2 20 -13 22 -31 2 -16 11 -31 20 -34 9 -3 32
-12 49 -21 31 -15 33 -15 46 2 9 12 20 17 31 13 23 -9 20 -44 -4 -52 -37 -12
-48 -52 -39 -140 6 -54 5 -94 -2 -123 -11 -39 -10 -46 10 -72 11 -16 21 -36
21 -45 0 -24 24 -13 28 12 2 12 -6 37 -16 57 -19 35 -19 76 -1 76 4 0 14 -12
21 -27 7 -14 19 -28 26 -31 18 -6 16 82 -2 97 -8 7 -18 27 -21 44 -4 18 -14
40 -23 50 -14 16 -13 17 14 17 22 0 41 -11 68 -39 36 -37 38 -42 28 -68 -14
-35 -17 -94 -7 -155 6 -42 5 -49 -19 -73 -31 -31 -32 -41 -6 -55 12 -6 25 -22
30 -36 8 -19 30 -35 30 -21 0 21 24 123 30 127 12 8 50 87 50 104 0 8 10 24
21 35 16 15 20 26 15 47 -7 25 -8 26 -26 9 -38 -35 -53 -13 -45 67 4 40 12 80
18 89 15 25 3 46 -44 71 -74 41 -82 46 -91 62 -6 10 -23 16 -43 16 -19 0 -35
4 -35 9 0 5 -14 14 -32 20 -17 6 -40 19 -51 29 -15 14 -38 17 -118 17 -119 0
-124 3 -125 93 -1 37 -2 73 -3 80 -1 15 -47 16 -57 1 -3 -6 -19 -16 -35 -23
-29 -12 -29 -12 15 -46 27 -19 47 -44 51 -59 12 -58 -33 -129 -56 -88 -16 28
-51 38 -71 20 -21 -19 -34 -11 -41 27 -4 18 -16 34 -29 40 -41 18 -91 60 -117
96 -22 30 -30 35 -54 30 -26 -5 -30 -2 -56 57 -15 34 -35 68 -44 76 -10 7 -17
22 -17 32 0 16 10 17 143 13 78 -2 158 -4 177 -4 19 1 116 3 215 5 99 1 185
-1 190 -5 6 -5 21 -8 35 -8 14 -1 77 -4 140 -7 83 -5 133 -3 180 7 47 11 121
13 270 11 113 -2 212 -3 220 -3 8 -1 62 1 120 4 66 2 110 0 118 -7 10 -8 21
-6 43 7 33 20 133 14 182 -11 25 -13 31 -12 62 7 21 13 42 19 54 15 26 -8 126
-17 176 -16 272 7 303 6 324 -13 12 -11 21 -25 21 -32 0 -7 11 -34 25 -60 14
-26 25 -53 25 -60 0 -18 -38 -18 -74 1 -34 18 -36 18 -36 5 0 -18 87 -100 105
-100 14 0 17 -6 12 -33 -5 -31 -1 -36 49 -75 30 -23 60 -54 66 -67 8 -18 19
-25 39 -25 15 0 41 -11 57 -25 17 -14 34 -25 40 -25 5 0 15 -7 22 -15 17 -21
47 -19 60 4 18 35 12 42 -89 101 -58 34 -81 53 -81 66 0 7 -6 17 -14 21 -14 9
-27 51 -30 100 -1 20 -12 43 -29 61 -19 20 -27 38 -27 64 0 23 -6 38 -15 42
-20 7 -20 62 1 70 37 14 82 4 139 -30 71 -43 76 -50 69 -90 -11 -59 11 -109
56 -127 47 -18 140 -77 140 -88 0 -5 18 -18 40 -29 39 -20 39 -20 56 5 15 23
15 27 -2 54 -31 49 -117 111 -154 111 -63 0 -114 84 -75 124 14 14 14 18 0 46
-8 16 -22 30 -30 30 -7 0 -20 8 -27 19 -7 10 -24 22 -38 26 -14 4 -32 13 -40
20 -37 30 -57 35 -87 20 -22 -12 -64 -15 -198 -14 -93 0 -178 -2 -188 -6 -10
-4 -43 -4 -75 -1 -85 10 -479 16 -892 13 -542 -3 -500 -4 -514 16 -7 9 -18 17
-24 17 -6 0 -16 9 -22 19 -5 11 -26 29 -45 41 -39 24 57 23 -970 18 -225 -1
-438 2 -471 6 -43 6 -63 5 -68 -3z m3407 -411 c17 -21 22 -40 10 -40 -12 0
-43 33 -43 47 0 19 13 16 33 -7z"/>
<path d="M8431 18593 c-15 -12 -20 -24 -16 -36 7 -16 33 -17 334 -18 836 -1
1146 -6 1168 -17 45 -25 93 -1 93 46 0 39 -32 45 -195 38 -82 -5 -159 -7 -170
-7 -11 1 -283 4 -605 7 -558 5 -587 5 -609 -13z"/>
<path d="M2733 18542 c-6 -4 -14 -19 -18 -33 -5 -21 -2 -27 20 -37 15 -7 31
-10 36 -7 16 10 11 72 -7 79 -19 7 -16 7 -31 -2z"/>
<path d="M2506 18515 c-9 -14 -24 -25 -34 -25 -14 0 -12 -4 8 -20 32 -25 35
-25 48 5 26 56 8 86 -22 40z"/>
<path d="M10430 18526 c0 -10 19 -16 65 -21 35 -4 70 -14 76 -21 6 -8 23 -14
37 -14 13 0 44 -10 68 -22 34 -17 48 -19 66 -11 22 11 22 11 3 17 -11 4 -37
16 -57 26 -20 11 -52 20 -70 20 -21 0 -40 7 -51 20 -21 25 -137 30 -137 6z"/>
<path d="M9990 18489 c-19 -9 -53 -19 -75 -23 -57 -11 -124 -45 -169 -88 -42
-40 -43 -57 -2 -83 25 -16 27 -16 57 9 17 14 36 26 43 26 7 0 27 11 46 25 66
48 167 14 207 -70 20 -41 30 -44 39 -10 3 13 12 29 20 36 15 13 6 38 -28 76
-19 21 -19 21 0 27 27 9 109 -30 115 -54 3 -11 16 -24 30 -29 14 -5 40 -26 59
-45 31 -32 36 -46 50 -131 9 -53 18 -98 21 -101 12 -13 56 18 66 47 41 119
-35 259 -176 323 -18 8 -33 20 -33 25 0 6 -10 20 -23 33 -21 21 -32 23 -117
23 -64 0 -105 -5 -130 -16z"/>
<path d="M3595 18471 c-8 -25 7 -47 24 -37 14 9 14 18 -3 41 -13 18 -14 18
-21 -4z"/>
<path d="M9696 18461 c9 -19 23 -31 35 -31 24 0 26 36 2 43 -10 2 -26 8 -35
12 -16 6 -16 5 -2 -24z"/>
<path d="M2598 18435 c-14 -31 7 -60 35 -49 19 7 22 27 7 55 -14 26 -28 24
-42 -6z"/>
<path d="M8470 18368 c0 -8 5 -19 12 -26 9 -9 8 -12 -3 -15 -82 -25 -102 -33
-114 -50 -11 -16 -11 -21 6 -38 18 -18 23 -43 19 -101 -2 -32 13 -43 30 -23 9
11 11 35 7 80 -6 64 -6 65 19 65 28 0 60 -29 86 -78 19 -36 51 -43 67 -15 9
17 11 16 30 -1 15 -14 25 -16 32 -9 14 14 0 62 -22 73 -10 6 -27 27 -39 48
-12 21 -42 51 -68 67 -61 39 -62 39 -62 23z"/>
<path d="M9020 18353 c0 -24 10 -38 37 -52 51 -26 62 12 13 47 -35 27 -50 28
-50 5z"/>
<path d="M7652 18338 c-20 -20 -14 -30 16 -26 16 2 27 9 27 18 0 19 -27 24
-43 8z"/>
<path d="M8034 18329 c-3 -5 -1 -16 6 -24 7 -8 9 -27 4 -49 -6 -37 10 -52 22
-21 4 8 12 15 20 15 19 0 18 25 -2 55 -18 27 -41 38 -50 24z"/>
<path d="M7203 18323 c-20 -4 -23 -10 -23 -57 0 -50 3 -56 45 -95 44 -41 46
-41 75 -26 16 8 38 15 50 15 28 0 26 5 -20 46 -22 20 -40 45 -40 56 0 11 -8
22 -20 25 -10 3 -22 14 -25 24 -4 10 -9 18 -13 18 -4 -1 -17 -4 -29 -6z"/>
<path d="M7737 18314 c-32 -18 -33 -21 -6 -50 17 -19 19 -26 9 -44 -7 -14 -8
-26 -3 -31 15 -15 38 -1 50 31 6 17 15 30 20 30 17 0 53 -86 53 -126 0 -22 6
-49 14 -60 15 -19 15 -19 30 1 8 11 16 31 16 44 0 14 7 32 16 42 15 17 15 20
-7 49 -13 18 -37 45 -54 61 -23 22 -27 31 -17 41 17 17 15 28 -7 28 -11 0 -21
-9 -24 -21 -6 -21 -6 -21 -34 -1 -26 18 -31 19 -56 6z"/>
<path d="M2593 18289 c-6 -6 -23 -11 -38 -11 -18 0 -30 -8 -37 -22 -5 -12 -23
-27 -39 -33 -30 -12 -30 -12 -3 -64 23 -46 25 -57 15 -84 -11 -33 -15 -78 -6
-87 3 -3 21 0 40 6 37 12 40 19 51 110 6 49 13 64 45 97 21 22 45 39 54 39 8
0 15 9 15 20 0 32 -73 53 -97 29z"/>
<path d="M8157 18294 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27
-31 17z"/>
<path d="M9087 18269 c-14 -8 -17 -18 -12 -39 4 -16 0 -43 -9 -65 -18 -41 -14
-55 14 -55 12 0 26 -16 41 -46 51 -107 121 -145 200 -111 25 11 29 16 14 16
-34 2 -61 27 -73 70 -12 39 -14 40 -60 43 -57 4 -76 35 -53 91 27 64 26 86 -4
97 -32 12 -35 12 -58 -1z"/>
<path d="M7940 18241 c0 -15 6 -21 21 -21 14 0 19 5 17 17 -5 26 -38 29 -38 4z"/>
<path d="M2787 18243 c-9 -8 -9 -76 -1 -97 7 -19 30 -21 37 -3 17 44 -13 124
-36 100z"/>
<path d="M13180 18238 c0 -16 19 -38 33 -38 4 0 7 10 5 22 -3 25 -38 39 -38
16z"/>
<path d="M6110 18209 c0 -32 -26 -42 -48 -19 -20 21 -20 21 -36 -1 -22 -32
-20 -49 7 -50 38 -1 122 -53 125 -79 2 -12 15 -32 30 -45 23 -20 28 -21 51 -9
36 19 48 17 62 -8 7 -13 17 -27 24 -33 6 -5 22 -37 35 -69 22 -57 23 -59 5
-73 -16 -11 -19 -27 -19 -92 -1 -44 -4 -82 -8 -86 -19 -19 -118 97 -118 138 0
12 -12 34 -27 49 -30 32 -59 38 -48 11 4 -10 11 -34 15 -53 5 -19 13 -52 20
-73 10 -33 9 -42 -5 -57 -16 -18 -16 -21 5 -49 13 -20 30 -31 45 -31 29 0 43
-18 21 -26 -18 -7 -21 -37 -5 -65 15 -29 31 -12 23 27 -5 29 -4 34 14 34 11 0
27 11 36 25 20 30 31 26 50 -20 8 -18 23 -38 34 -44 10 -6 35 -26 55 -46 44
-44 77 -47 77 -6 0 31 -27 51 -36 26 -4 -8 -10 -13 -14 -10 -5 3 -2 19 7 35
22 45 9 125 -28 170 -30 36 -36 59 -19 76 6 6 6 31 -1 72 -14 77 -7 110 26
118 27 7 32 23 14 41 -7 7 -10 36 -7 77 4 71 0 76 -41 47 -18 -13 -32 -17 -42
-10 -25 16 -31 10 -27 -28 3 -35 1 -38 -23 -41 -21 -2 -37 8 -73 45 -56 59
-57 70 -6 91 77 33 48 56 -68 57 -69 0 -82 -3 -82 -16z"/>
<path d="M8140 18213 c0 -10 4 -25 9 -32 6 -9 6 -22 1 -31 -11 -21 6 -40 37
-40 26 0 34 44 9 53 -8 3 -17 19 -21 36 -7 33 -35 43 -35 14z"/>
<path d="M9955 18219 c-4 -5 1 -19 11 -30 11 -12 17 -32 16 -49 -2 -15 4 -34
12 -43 9 -9 16 -24 16 -34 0 -25 35 -45 65 -37 19 5 36 -1 64 -21 33 -22 43
-25 60 -15 36 19 23 44 -15 30 -27 -11 -54 -4 -54 13 0 7 -17 27 -38 47 -21
19 -47 50 -57 68 -11 17 -23 32 -27 32 -5 0 -13 11 -18 25 -10 26 -24 32 -35
14z"/>
<path d="M13086 18189 c15 -17 16 -23 5 -41 -16 -25 -5 -37 41 -44 51 -9 57
17 17 67 -21 27 -38 39 -56 39 -26 0 -26 0 -7 -21z"/>
<path d="M8782 18178 c-23 -23 -13 -55 24 -77 47 -28 80 -28 42 0 -14 11 -29
33 -33 49 -8 35 -18 43 -33 28z"/>
<path d="M12515 18158 c-9 -23 -3 -50 13 -56 14 -4 16 36 2 58 -8 12 -10 12
-15 -2z"/>
<path d="M7495 18119 c-8 -25 21 -89 41 -89 8 0 24 16 35 35 12 19 25 35 30
35 5 0 9 9 9 20 0 30 -105 30 -115 -1z"/>
<path d="M7717 18124 c-13 -13 -7 -55 9 -61 11 -4 14 -14 11 -32 -6 -28 25
-66 71 -90 26 -14 30 -52 7 -71 -17 -14 -20 -40 -5 -40 6 0 10 -14 10 -31 0
-17 11 -45 25 -63 15 -20 25 -46 25 -67 0 -47 8 -55 63 -63 49 -7 49 -7 26 23
-13 17 -28 31 -35 31 -7 0 -16 5 -20 12 -10 15 23 37 46 31 17 -5 20 0 20 34
0 31 -7 46 -32 70 -45 42 -78 88 -78 106 0 9 -4 19 -10 22 -5 3 -10 20 -10 36
0 22 -7 32 -25 41 -14 6 -25 16 -25 23 0 6 -7 20 -15 30 -8 11 -23 30 -33 43
-9 13 -21 20 -25 16z"/>
<path d="M4717 18103 c-15 -14 -6 -32 23 -47 27 -13 32 -13 46 1 13 14 13 17
-2 34 -17 19 -54 25 -67 12z"/>
<path d="M12547 18094 c-21 -22 -1 -104 25 -104 18 0 19 5 13 43 -7 43 -26 73
-38 61z"/>
<path d="M8946 18081 c-10 -15 55 -64 68 -51 8 8 2 17 -19 35 -33 27 -41 29
-49 16z"/>
<path d="M8542 18051 c-27 -36 -27 -41 -4 -41 36 0 119 -51 191 -119 18 -17
38 -28 43 -25 9 6 8 20 -8 104 -9 49 -31 70 -72 70 -20 0 -43 6 -51 14 -9 8
-30 17 -46 20 -26 6 -34 2 -53 -23z"/>
<path d="M2630 18036 c-10 -31 -16 -36 -42 -36 -33 0 -32 8 -12 -89 3 -16 0
-39 -7 -52 -7 -13 -13 -40 -14 -59 0 -19 -2 -61 -3 -92 -2 -49 -5 -58 -21 -58
-10 0 -24 7 -31 15 -18 22 -37 18 -43 -7 -3 -13 -9 -34 -13 -47 -7 -22 -5 -23
19 -17 22 5 27 3 27 -11 0 -10 9 -24 20 -31 11 -7 20 -21 20 -32 0 -27 -45
-38 -69 -16 -10 9 -21 16 -24 16 -14 0 -6 -44 10 -63 14 -15 17 -34 15 -98 -6
-141 -4 -203 5 -257 9 -50 8 -55 -14 -69 -13 -8 -23 -20 -23 -27 0 -16 48 -66
64 -66 8 0 26 -7 42 -14 35 -19 49 -11 31 17 -8 12 -20 39 -26 60 -7 20 -21
42 -32 47 -23 13 -24 41 -3 87 13 25 14 37 5 46 -21 21 -13 79 17 110 23 25
27 35 25 82 -2 30 2 57 7 60 6 3 10 20 10 36 0 19 9 38 25 53 30 28 31 42 5
56 -33 18 -36 57 -8 88 31 33 48 82 48 137 0 29 6 47 20 60 11 10 19 29 18 44
-5 76 0 91 32 91 25 0 30 4 30 24 0 30 -5 33 -57 42 -40 6 -41 5 -53 -30z"/>
<path d="M8445 18054 c-19 -15 -18 -15 15 -12 19 2 34 8 33 13 -3 16 -26 16
-48 -1z"/>
<path d="M10482 18050 c-18 -11 -38 -20 -45 -20 -7 0 -18 -9 -25 -20 -13 -21
-56 -27 -67 -9 -4 5 -18 14 -31 19 -13 5 -24 16 -24 25 0 8 -4 15 -9 15 -16 0
-24 -21 -12 -33 6 -6 11 -25 11 -42 0 -56 32 -73 124 -69 86 3 126 25 125 68
0 12 3 36 7 54 8 38 -5 41 -54 12z"/>
<path d="M13140 18045 c-13 -33 -75 -37 -85 -4 -7 22 -32 20 -26 -2 2 -8 6
-25 8 -39 8 -47 35 -85 72 -103 30 -14 38 -15 46 -4 14 19 34 10 71 -29 37
-40 84 -47 84 -14 0 32 -37 98 -66 116 -13 9 -36 36 -50 60 -30 50 -41 54 -54
19z"/>
<path d="M6562 18023 c-5 -10 -12 -36 -15 -59 -4 -36 -1 -45 25 -73 34 -36 36
-36 66 -15 21 14 22 21 16 77 -7 62 -17 79 -40 70 -6 -2 -15 0 -19 6 -9 16
-23 13 -33 -6z"/>
<path d="M8223 18014 c-5 -14 11 -34 27 -34 3 0 11 4 19 9 19 12 6 41 -19 41
-11 0 -23 -7 -27 -16z"/>
<path d="M8870 18017 c-14 -7 -26 -20 -28 -30 -5 -23 47 -66 79 -67 36 0 62
-25 97 -92 16 -31 36 -64 43 -73 41 -50 52 -57 76 -52 15 3 27 -1 30 -8 5 -14
39 -29 86 -39 15 -4 27 -13 27 -22 0 -8 12 -30 27 -49 27 -33 27 -33 55 -7 35
34 35 38 -2 57 -25 13 -28 18 -19 34 18 28 2 107 -29 142 -27 30 -27 30 -69 7
-42 -23 -42 -23 -65 0 -30 28 -34 28 -42 -2 -6 -25 -6 -25 -33 2 -31 31 -77
112 -63 112 28 0 59 -22 68 -49 6 -17 18 -31 26 -31 26 0 18 27 -18 62 -19 18
-36 44 -37 57 -4 24 -7 25 -62 22 -45 -2 -62 2 -83 18 -31 24 -31 25 -64 8z
m428 -285 c4 -41 -13 -42 -27 -1 -14 41 -14 41 7 37 11 -2 18 -14 20 -36z"/>
<path d="M9754 18006 c-10 -25 24 -76 51 -76 22 0 55 -22 55 -38 1 -4 16 -25
34 -46 33 -38 35 -39 65 -26 35 14 41 36 11 45 -11 4 -27 21 -35 38 -21 47
-50 77 -75 77 -12 0 -33 9 -47 20 -30 23 -51 26 -59 6z"/>
<path d="M3977 17983 c-3 -10 -8 -44 -12 -75 -7 -62 -23 -83 -56 -75 -12 3
-36 -1 -53 -10 -30 -16 -30 -16 3 -27 38 -12 47 -25 56 -78 6 -37 7 -38 50
-38 41 0 45 -2 45 -24 0 -27 -21 -36 -87 -36 -75 0 -101 -59 -38 -86 30 -12
35 -19 35 -47 -1 -74 -19 -160 -39 -181 -23 -24 -29 -76 -8 -76 18 1 65 45 69
66 2 12 13 20 30 22 24 3 26 6 21 42 -4 26 0 46 11 61 9 13 16 36 16 52 0 16
7 53 16 82 19 67 16 321 -5 375 -27 70 -45 87 -54 53z"/>
<path d="M8319 17979 c-1 -2 -2 -26 -3 -52 -2 -47 -1 -48 24 -42 38 10 62 35
49 52 -6 7 -16 13 -22 13 -6 0 -19 7 -29 17 -10 9 -19 14 -19 12z"/>
<path d="M10755 17971 c-7 -12 31 -25 45 -16 5 3 10 10 10 16 0 12 -47 12 -55
0z"/>
<path d="M12590 17945 c0 -34 12 -46 25 -24 9 14 -3 59 -15 59 -6 0 -10 -16
-10 -35z"/>
<path d="M3911 17942 c-10 -18 2 -42 20 -42 11 0 19 29 13 45 -8 20 -21 19
-33 -3z"/>
<path d="M5909 17917 c-15 -58 -18 -61 -41 -41 -16 16 -21 16 -28 4 -24 -37
-5 -69 26 -45 30 23 58 18 82 -15 13 -16 28 -30 35 -30 7 0 28 -11 47 -25 40
-29 50 -25 43 18 -4 28 -1 36 21 50 27 18 28 32 4 96 -9 24 -9 24 -31 2 -27
-24 -59 -27 -76 -7 -7 8 -25 19 -41 25 -29 10 -30 9 -41 -32z"/>
<path d="M8117 17944 c-9 -9 2 -54 19 -78 9 -13 10 -26 3 -43 -12 -32 -12 -33
9 -33 10 0 31 -18 48 -41 16 -22 36 -49 44 -60 9 -11 36 -23 68 -29 68 -12 72
-15 72 -50 0 -42 -14 -44 -53 -10 -38 33 -52 37 -60 16 -10 -24 31 -66 63 -66
21 0 35 -9 51 -32 12 -18 27 -37 33 -43 16 -14 66 -93 66 -103 0 -5 12 -19 26
-33 25 -24 25 -24 44 1 20 25 20 25 20 2 0 -12 -5 -30 -11 -40 -9 -14 -7 -25
7 -51 11 -19 25 -45 33 -60 8 -14 27 -43 44 -64 20 -26 28 -45 24 -63 -3 -18
4 -33 25 -57 30 -31 30 -31 49 -8 28 35 23 64 -22 121 -33 41 -38 54 -28 66
15 18 39 18 67 -2 21 -14 22 -14 22 10 0 22 -5 26 -29 26 -23 0 -30 5 -36 27
-5 23 -23 50 -64 98 -4 6 -29 28 -55 49 -25 21 -46 44 -46 51 0 7 -8 23 -18
36 -10 13 -24 44 -32 68 -8 26 -22 46 -32 49 -22 5 -24 22 -3 22 24 0 18 55
-9 87 -19 22 -21 31 -12 45 8 14 8 21 -3 27 -18 12 -50 2 -61 -18 -7 -13 -21
-17 -61 -15 -48 3 -57 7 -98 48 -39 39 -45 51 -45 88 -1 51 -35 86 -59 62z"/>
<path d="M8420 17930 c0 -5 17 -17 38 -27 20 -9 40 -19 44 -21 4 -2 0 10 -8
27 -12 24 -22 31 -45 31 -16 0 -29 -4 -29 -10z"/>
<path d="M10881 17913 c-31 -13 -33 -16 -26 -49 4 -23 0 -53 -11 -86 -21 -63
-7 -84 31 -48 14 13 25 29 25 35 0 7 18 35 41 64 38 47 43 71 17 71 -6 0 -19
6 -27 14 -14 11 -21 11 -50 -1z"/>
<path d="M10050 17901 c0 -11 -9 -23 -20 -26 -26 -8 -26 -31 1 -45 17 -10 21
-8 26 9 3 11 14 23 24 26 22 7 25 25 7 43 -18 18 -38 14 -38 -7z"/>
<path d="M10590 17902 c0 -10 7 -28 16 -40 16 -23 16 -23 31 -2 13 19 13 23
-3 41 -21 24 -44 25 -44 1z"/>
<path d="M7984 17885 c-10 -42 3 -75 30 -75 37 0 50 55 20 84 -23 23 -43 20
-50 -9z"/>
<path d="M6814 17857 c-5 -8 -18 -16 -29 -18 -33 -7 -30 -44 4 -69 31 -21 42
-62 21 -75 -18 -11 -10 -20 49 -53 32 -18 62 -40 65 -48 5 -13 15 -15 41 -11
28 5 37 2 45 -14 7 -11 26 -21 50 -25 25 -4 40 -12 40 -21 0 -20 25 -26 50
-13 22 12 22 12 -1 36 -18 19 -20 26 -9 39 18 22 47 19 96 -10 51 -30 65 -26
87 22 19 42 14 57 -18 49 -15 -4 -28 1 -40 14 -24 27 -41 25 -61 -5 -28 -42
-69 -34 -92 18 -21 47 -45 71 -94 95 -23 12 -34 25 -36 44 -5 38 -24 50 -96
55 -50 4 -65 2 -72 -10z m137 -69 c5 -13 16 -34 24 -48 19 -32 19 -64 0 -80
-16 -14 -35 -5 -35 16 0 8 -13 20 -30 25 -37 13 -41 51 -8 86 27 29 36 29 49
1z"/>
<path d="M8636 17863 c-3 -4 -6 -32 -6 -63 0 -47 4 -60 25 -80 17 -16 25 -34
25 -57 0 -57 35 -113 70 -113 30 0 42 21 20 35 -13 8 -13 51 0 76 15 27 -7 94
-42 129 -15 16 -28 35 -28 43 0 15 -54 40 -64 30z"/>
<path d="M10119 17842 c-1 -4 -2 -16 -3 -27 -1 -15 -10 -21 -41 -25 -34 -4
-40 -9 -40 -29 0 -35 29 -50 53 -28 16 15 30 17 71 11 55 -7 76 10 54 45 -11
18 -92 64 -94 53z"/>
<path d="M7192 17828 c-17 -17 40 -68 76 -68 15 0 34 -4 41 -9 17 -11 51 3 51
20 0 6 -5 7 -11 4 -18 -12 -103 16 -124 41 -16 19 -23 22 -33 12z"/>
<path d="M8303 17814 c-5 -15 11 -33 30 -34 15 0 20 32 6 41 -20 13 -29 11
-36 -7z"/>
<path d="M9417 17804 c-11 -14 -17 -27 -15 -29 1 -1 37 -28 78 -59 63 -48 80
-56 104 -51 38 7 40 9 26 35 -9 17 -8 25 4 39 9 10 16 25 16 34 0 25 -41 22
-47 -3 -5 -21 -19 -25 -47 -14 -19 7 -21 30 -3 37 22 8 -6 24 -53 30 -40 5
-47 3 -63 -19z"/>
<path d="M10504 17793 c4 -16 18 -36 32 -46 13 -11 36 -39 50 -63 14 -24 32
-44 39 -44 22 0 72 -48 79 -76 8 -31 39 -29 44 2 3 21 -50 138 -68 149 -4 3
-3 18 3 35 9 24 8 32 -8 49 -23 27 -41 27 -48 0 -5 -19 -11 -21 -38 -15 -18 3
-40 13 -49 21 -27 25 -43 19 -36 -12z"/>
<path d="M13515 17810 c-11 -18 -80 -58 -106 -62 -13 -1 -25 -11 -27 -20 -4
-22 62 -36 89 -19 11 6 30 11 44 11 27 0 40 28 33 71 -3 25 -22 36 -33 19z"/>
<path d="M8040 17779 c1 -34 23 -59 76 -85 46 -22 46 -22 40 2 -16 62 -26 76
-48 70 -15 -3 -30 2 -45 16 -23 21 -23 21 -23 -3z"/>
<path d="M9736 17745 c4 -30 3 -45 -5 -45 -6 0 -11 -4 -11 -10 0 -5 6 -10 13
-10 8 0 19 -22 27 -51 10 -34 23 -57 42 -70 21 -16 28 -29 28 -55 0 -19 5 -34
10 -34 6 0 16 -11 22 -25 6 -14 19 -25 30 -25 15 0 18 8 18 50 0 48 -3 53 -60
112 -58 59 -69 88 -35 88 21 0 19 17 -5 30 -11 6 -20 20 -20 31 0 32 -19 59
-41 59 -18 0 -20 -4 -13 -45z"/>
<path d="M6548 17756 c-8 -18 -8 -37 1 -70 7 -31 8 -53 1 -71 -16 -41 -12 -65
9 -65 19 0 31 -18 31 -50 0 -17 99 -100 119 -100 16 0 61 46 61 61 0 8 -7 23
-15 33 -8 11 -15 30 -15 43 0 13 -9 31 -20 41 -65 56 -100 99 -100 124 0 68
-49 104 -72 54z m72 -146 c0 -6 12 -15 26 -20 29 -12 27 -34 -3 -38 -13 -2
-27 6 -37 20 -20 28 -20 48 -1 48 8 0 15 -5 15 -10z"/>
<path d="M10313 17763 c-23 -9 -14 -41 20 -67 17 -14 35 -30 39 -34 4 -4 20
-22 34 -39 23 -29 31 -33 76 -33 48 0 49 1 46 28 -3 25 -6 27 -46 24 -38 -3
-43 -2 -40 15 2 11 -11 36 -30 57 -17 20 -32 41 -32 46 0 10 -45 12 -67 3z"/>
<path d="M12715 17750 c-7 -23 2 -43 16 -35 12 8 12 55 0 55 -5 0 -12 -9 -16
-20z"/>
<path d="M8984 17729 c-3 -6 -1 -16 5 -22 6 -6 11 -19 11 -29 0 -10 5 -18 10
-18 6 0 10 18 10 40 0 39 -19 55 -36 29z"/>
<path d="M5780 17711 c0 -12 29 -41 41 -41 13 0 11 12 -5 33 -14 18 -36 23
-36 8z"/>
<path d="M8851 17671 c-23 -18 -25 -51 -2 -51 13 0 71 50 71 61 0 16 -44 9
-69 -10z"/>
<path d="M9610 17638 c-14 -17 -28 -39 -31 -47 -6 -16 25 -86 42 -97 5 -3 9
-12 9 -21 0 -9 16 -32 36 -51 20 -19 41 -48 46 -63 12 -36 26 -37 34 -4 7 27
23 32 42 13 10 -10 15 -10 22 2 16 25 11 59 -12 82 -40 39 -58 71 -51 96 4 18
1 24 -16 29 -11 3 -21 9 -21 13 0 9 -64 80 -71 79 -2 0 -15 -14 -29 -31z m125
-193 c0 -15 -6 -19 -24 -17 -31 3 -35 7 -27 27 9 24 51 15 51 -10z"/>
<path d="M9914 17645 c-6 -26 19 -76 56 -110 11 -10 23 -35 26 -56 4 -24 13
-41 24 -44 10 -3 21 -12 24 -20 3 -8 14 -15 25 -15 14 0 21 -9 25 -36 4 -19
16 -44 27 -55 10 -10 19 -28 19 -39 0 -12 11 -32 25 -46 14 -14 27 -35 31 -48
3 -15 20 -30 42 -40 66 -31 79 -47 76 -96 -1 -25 -5 -52 -8 -61 -5 -10 -1 -19
8 -22 21 -8 25 2 27 69 2 82 17 114 51 114 15 0 31 -6 35 -12 9 -15 38 -34 73
-48 14 -6 41 -28 60 -49 19 -21 68 -64 108 -96 103 -82 111 -126 21 -117 -41
4 -51 2 -47 -9 6 -17 101 -35 106 -19 11 32 35 41 91 34 31 -4 60 -13 64 -20
11 -20 77 -18 77 1 0 8 -6 15 -14 15 -8 0 -24 14 -36 31 -12 16 -37 40 -55 52
-82 55 -172 126 -216 170 -43 42 -55 49 -110 58 -71 11 -85 18 -118 53 -41 44
5 81 51 40 16 -16 18 -16 24 0 9 22 31 20 37 -4 7 -28 37 -26 36 3 -1 43 -33
82 -70 85 -28 2 -41 -5 -76 -39 -24 -22 -43 -46 -43 -54 0 -7 -6 -18 -14 -24
-17 -14 -50 13 -42 34 2 7 -2 21 -9 32 -8 10 -15 25 -15 34 0 9 -7 23 -17 30
-9 8 -29 40 -44 72 -40 86 -118 157 -171 157 -56 0 -112 42 -104 76 5 17 1 26
-13 34 -30 15 -40 12 -47 -15z"/>
<path d="M13547 17663 c-4 -3 -7 -19 -7 -34 0 -15 -12 -46 -27 -68 -27 -41
-27 -41 -55 -14 -15 15 -28 32 -28 37 -1 6 -17 21 -37 34 -43 28 -64 17 -43
-22 19 -36 7 -54 -37 -58 -51 -4 -68 -51 -34 -94 23 -29 27 -74 11 -104 -8
-15 -6 -21 9 -30 53 -28 107 6 62 39 -19 14 -22 25 -19 67 3 49 3 49 39 48 54
-1 89 -13 89 -29 0 -22 20 -28 39 -11 13 12 20 13 29 4 24 -24 37 7 18 45 -21
46 -20 54 9 89 27 32 31 58 15 89 -11 20 -22 24 -33 12z"/>
<path d="M8954 17635 c-8 -21 3 -48 19 -43 19 7 22 58 2 58 -8 0 -18 -7 -21
-15z"/>
<path d="M10042 17625 c2 -22 9 -31 26 -33 29 -4 28 9 -4 39 -26 24 -26 24
-22 -6z"/>
<path d="M10188 17626 c-23 -17 -23 -26 1 -26 11 0 29 -13 41 -30 27 -37 90
-44 90 -10 0 13 -7 20 -20 20 -11 0 -32 14 -47 30 -29 33 -40 36 -65 16z"/>
<path d="M11957 17623 c-9 -9 -9 -55 1 -69 17 -27 88 -37 138 -20 26 9 56 16
67 16 12 0 17 6 15 18 -3 14 -13 17 -51 15 -34 -2 -59 4 -93 22 -48 26 -66 30
-77 18z"/>
<path d="M5270 17563 c0 -10 5 -25 10 -33 12 -19 33 0 28 26 -4 25 -38 31 -38
7z"/>
<path d="M9110 17555 c-5 -14 -14 -25 -20 -25 -23 0 -7 -31 23 -44 18 -7 41
-25 50 -40 10 -14 24 -26 32 -26 8 0 29 -16 46 -35 37 -41 82 -47 99 -15 7 13
21 20 40 20 16 0 41 5 56 12 23 11 28 10 40 -7 13 -17 16 -18 24 -5 7 11 4 16
-13 20 -30 8 -35 46 -8 53 30 7 26 23 -9 36 -20 7 -30 17 -30 30 0 23 -15 26
-56 11 -26 -10 -26 -11 -9 -30 15 -16 15 -22 5 -35 -18 -21 -40 -19 -40 5 0
11 -7 20 -15 20 -8 0 -15 -7 -15 -15 0 -9 7 -18 15 -21 17 -7 21 -64 4 -64 -6
0 -23 13 -37 28 -15 15 -44 38 -64 51 -21 12 -38 26 -38 30 0 9 -57 71 -65 71
-3 0 -10 -11 -15 -25z"/>
<path d="M4416 17523 c-22 -44 -64 -155 -70 -188 -9 -42 10 -164 28 -184 8 -9
17 -28 21 -42 8 -33 73 -104 104 -114 52 -16 91 -49 88 -75 -3 -32 -33 -31
-121 4 -36 14 -67 26 -71 26 -14 0 -45 -92 -48 -141 -2 -29 -9 -55 -15 -57
-14 -4 -61 47 -62 67 0 16 35 77 63 108 24 27 18 100 -14 170 -11 24 -24 55
-30 70 -10 26 -12 27 -19 8 -5 -11 -9 -34 -9 -51 -1 -17 -8 -51 -16 -74 -16
-45 -19 -149 -9 -262 6 -55 10 -69 26 -74 23 -7 43 -51 52 -116 4 -26 13 -49
21 -52 8 -3 15 -12 15 -20 0 -16 91 -96 109 -96 7 0 22 -6 34 -14 12 -8 39
-17 61 -21 26 -4 40 -13 43 -26 7 -24 19 -24 33 0 14 28 6 43 -50 85 -57 44
-59 49 -25 64 14 6 25 19 25 27 0 24 -29 30 -45 9 -12 -17 -14 -16 -22 16 -7
25 -19 40 -45 55 -53 28 -85 104 -56 133 20 20 40 14 80 -25 50 -49 69 -35 39
28 -22 45 -22 45 23 70 13 8 21 8 29 0 18 -18 27 -13 27 15 0 14 11 45 25 70
23 41 24 47 11 73 -16 31 -83 86 -105 86 -14 0 -40 36 -61 84 -23 53 15 88
106 96 122 12 171 -55 161 -221 -3 -48 -12 -94 -22 -114 -12 -23 -16 -48 -13
-82 6 -55 11 -63 33 -54 13 5 14 15 9 56 -10 79 38 60 85 -34 24 -47 45 -65
58 -52 11 10 -49 116 -75 134 -55 37 -72 133 -26 154 22 10 25 16 20 42 -13
64 -12 71 12 74 13 2 30 -2 38 -8 16 -14 19 -72 4 -100 -16 -29 3 -102 34
-133 20 -20 37 -27 65 -27 37 0 66 -25 84 -72 3 -10 13 -18 20 -18 8 0 31 -13
52 -30 21 -16 43 -30 50 -30 7 0 36 -25 64 -56 48 -52 71 -61 71 -28 0 8 -11
24 -25 36 -14 12 -25 26 -25 31 0 16 -83 102 -104 107 -35 10 -43 36 -18 63
12 13 22 29 22 35 0 7 5 12 10 12 6 0 10 -4 10 -10 0 -17 39 -50 60 -50 15 0
20 7 20 28 0 38 -41 77 -71 69 -13 -4 -29 -1 -36 5 -10 8 -24 8 -52 -2 -38
-12 -40 -11 -95 29 -58 43 -64 55 -68 131 -3 40 -6 45 -28 48 -31 5 -66 36
-74 68 -4 15 -14 24 -26 24 -10 0 -22 5 -25 10 -3 6 -18 10 -33 10 -17 0 -39
12 -57 31 -16 16 -48 38 -70 48 -49 22 -96 67 -131 127 -30 51 -57 57 -78 17z
m94 -98 c0 -24 -6 -38 -20 -45 -11 -6 -20 -19 -20 -30 0 -28 -11 -50 -25 -50
-17 0 -25 23 -25 69 0 30 7 43 36 69 42 37 54 34 54 -13z"/>
<path d="M5434 17525 c-3 -8 -14 -17 -25 -20 -20 -7 -27 -35 -9 -35 6 0 15
-11 20 -25 12 -32 37 -42 57 -22 13 12 13 21 3 53 -7 22 -14 45 -16 52 -5 17
-23 15 -30 -3z"/>
<path d="M8098 17523 c-14 -14 -20 -14 -33 -3 -26 21 -39 -2 -17 -31 10 -13
33 -50 51 -81 37 -66 42 -68 70 -32 25 32 27 50 6 58 -8 3 -15 10 -15 15 0 19
28 -1 53 -37 54 -81 95 -115 127 -108 21 4 40 -1 63 -14 48 -30 71 -27 62 8
-3 15 -11 29 -17 31 -6 2 -29 21 -52 42 -61 57 -139 119 -151 119 -5 0 -32 12
-60 25 -59 29 -66 30 -87 8z"/>
<path d="M12215 17531 c-3 -6 -3 -28 1 -49 8 -48 49 -66 73 -31 7 10 20 19 27
19 8 0 14 5 14 10 0 6 -8 10 -18 10 -11 0 -24 11 -30 25 -12 25 -54 35 -67 16z"/>
<path d="M8934 17514 c3 -9 6 -38 6 -65 0 -34 4 -49 13 -49 21 0 47 -34 47
-60 0 -21 -3 -22 -40 -16 -46 7 -48 2 -20 -55 19 -36 23 -38 42 -28 19 10 25
8 43 -15 26 -33 30 -33 45 4 14 34 19 36 46 15 31 -23 69 -19 89 11 9 14 15
26 13 27 -2 1 -17 12 -35 24 -25 18 -37 20 -62 13 -34 -9 -40 -4 -15 14 14 11
14 15 -3 44 -10 18 -26 32 -36 32 -22 0 -49 29 -77 83 -21 38 -70 57 -56 21z"/>
<path d="M8664 17506 c-11 -28 4 -60 40 -89 36 -27 36 -27 42 -1 13 53 -64
137 -82 90z"/>
<path d="M10513 17504 c-9 -24 5 -44 31 -44 13 0 38 -13 56 -30 18 -16 36 -30
41 -30 17 0 9 32 -15 61 -13 15 -26 32 -28 37 -6 17 -79 22 -85 6z"/>
<path d="M6840 17485 c0 -7 7 -15 15 -19 9 -3 15 -18 15 -35 0 -16 6 -31 15
-35 8 -3 15 -12 15 -21 0 -8 9 -15 20 -15 22 0 26 20 8 38 -12 12 -4 17 36 24
31 5 30 27 -1 33 -15 4 -37 11 -47 17 -38 21 -76 28 -76 13z"/>
<path d="M7190 17475 c-13 -35 -16 -29 37 -85 53 -56 75 -62 99 -25 9 14 26
25 38 25 21 0 21 0 -1 18 -12 9 -28 32 -34 50 -10 30 -14 33 -53 31 -22 -1
-49 2 -58 6 -13 5 -20 0 -28 -20z"/>
<path d="M7794 17468 c3 -13 6 -26 6 -30 0 -9 40 -11 40 -3 0 12 -33 55 -42
55 -6 0 -8 -10 -4 -22z"/>
<path d="M4913 17473 c-62 -8 -21 -53 47 -53 25 0 32 -7 50 -46 11 -26 20 -59
20 -75 0 -31 23 -59 49 -59 23 0 71 -75 78 -120 6 -34 54 -89 80 -90 23 0 24
20 4 46 -12 15 -21 41 -21 60 0 26 -8 41 -36 66 -66 60 -91 154 -53 202 12 15
18 33 15 41 -7 19 -35 19 -42 0 -11 -27 -96 -20 -124 10 -13 14 -26 24 -29 23
-3 0 -21 -3 -38 -5z"/>
<path d="M5582 17440 c-12 -16 -22 -32 -22 -36 0 -6 119 -125 181 -179 19 -17
46 -36 60 -42 25 -11 26 -15 22 -57 -4 -36 -2 -47 11 -52 20 -8 21 -31 0 -51
-14 -15 -13 -18 8 -39 80 -81 74 -72 53 -89 -15 -12 -16 -18 -7 -22 19 -8 48
-73 55 -124 3 -25 13 -59 21 -75 8 -16 18 -42 21 -57 3 -18 15 -32 33 -39 50
-22 82 -49 82 -70 0 -42 24 -99 58 -139 34 -39 34 -41 22 -80 -16 -47 -5 -65
34 -55 24 6 26 9 20 49 -4 23 -15 56 -25 73 -11 19 -21 61 -25 112 -4 45 -10
82 -14 82 -4 0 -11 15 -14 34 -7 38 -25 57 -81 83 -27 12 -41 26 -43 41 -2 12
-14 30 -28 38 -13 9 -24 25 -24 35 0 29 45 112 69 127 28 17 27 26 -14 69 -28
30 -37 34 -49 24 -20 -17 -62 29 -71 77 -3 18 -12 32 -20 32 -21 0 -28 19 -14
36 9 11 9 20 1 37 -6 12 -13 41 -15 65 -5 42 -39 86 -103 132 -10 8 -24 29
-29 45 -10 28 -15 30 -57 30 -25 0 -50 3 -54 8 -12 12 -19 8 -42 -23z"/>
<path d="M10717 17434 c-15 -16 -6 -44 23 -66 67 -51 140 -129 140 -148 0 -11
7 -20 14 -20 8 0 27 -11 42 -25 15 -14 35 -24 43 -23 26 5 24 36 -5 63 -25 23
-26 28 -14 50 12 23 11 26 -16 47 -16 13 -44 38 -62 55 -18 18 -43 39 -55 47
-26 17 -100 30 -110 20z"/>
<path d="M5327 17423 c-14 -13 -7 -43 11 -43 27 0 43 15 36 33 -6 17 -35 23
-47 10z"/>
<path d="M7705 17398 c-3 -18 -9 -41 -11 -50 -3 -10 5 -26 20 -39 15 -13 26
-31 26 -42 0 -16 5 -18 28 -12 15 4 41 7 57 6 46 0 75 8 75 22 0 28 -115 135
-152 142 -35 7 -36 6 -43 -27z"/>
<path d="M8832 17409 c1 -12 9 -24 16 -27 9 -3 13 3 10 19 -1 12 -9 24 -16 27
-9 3 -13 -3 -10 -19z"/>
<path d="M9539 17414 c-1 -5 -1 -13 0 -18 1 -6 -1 -32 -4 -59 -6 -38 -12 -50
-30 -57 -33 -12 -39 -28 -21 -49 9 -10 16 -27 16 -39 0 -11 11 -33 25 -48 33
-36 44 -93 20 -110 -19 -14 -55 -3 -55 16 0 16 -71 90 -86 90 -7 0 -18 -9 -24
-20 -6 -11 -19 -20 -29 -20 -29 0 -32 -11 -10 -41 17 -24 27 -29 64 -29 40 0
49 -5 110 -65 36 -36 70 -65 75 -65 5 0 16 -13 24 -29 8 -15 26 -35 39 -44 21
-14 25 -26 29 -84 3 -38 1 -74 -5 -81 -7 -8 -5 -18 7 -30 9 -10 16 -25 16 -33
0 -8 11 -36 25 -64 13 -27 25 -59 25 -71 0 -13 14 -30 37 -45 51 -32 95 -126
66 -136 -9 -3 -13 6 -13 26 0 36 -24 52 -45 30 -7 -8 -15 -34 -17 -58 -3 -42
-2 -44 32 -56 23 -8 42 -9 55 -3 17 8 28 3 60 -26 37 -34 39 -35 58 -18 15 13
21 14 24 4 3 -7 12 -18 20 -25 8 -7 24 -22 35 -34 13 -13 33 -23 49 -23 18 0
32 -7 39 -20 7 -13 21 -20 40 -20 39 0 60 -9 60 -26 0 -8 7 -17 15 -20 8 -4
15 -15 15 -25 0 -12 14 -28 35 -40 19 -12 35 -27 35 -35 0 -8 4 -14 9 -14 16
0 20 -44 6 -72 -12 -26 -12 -29 8 -40 12 -6 28 -19 35 -30 7 -10 20 -18 28
-18 23 0 77 -31 93 -53 11 -15 22 -18 52 -14 31 4 42 0 60 -19 25 -27 69 -33
69 -9 0 8 -11 17 -24 21 -13 3 -36 19 -52 35 -23 24 -33 28 -59 23 -27 -5 -35
-1 -58 30 -15 19 -36 38 -48 41 -19 6 -19 8 -5 24 18 20 21 41 6 41 -21 0 -41
50 -45 113 -2 37 -7 71 -10 77 -8 13 -35 13 -35 0 0 -5 -7 -10 -15 -10 -8 0
-15 8 -15 19 0 29 -24 42 -83 47 -72 5 -139 46 -135 84 2 19 -2 26 -19 28 -30
4 -50 29 -35 44 7 7 12 15 12 19 0 10 -59 39 -78 39 -8 0 -20 7 -26 16 -9 12
-17 13 -39 5 -23 -9 -28 -7 -38 12 -7 12 -20 28 -31 35 -11 8 -18 26 -18 47 0
27 -7 40 -35 62 -19 15 -35 34 -35 42 0 8 -7 19 -15 25 -9 7 -18 36 -21 73 -5
42 -13 68 -25 79 -20 18 -26 54 -9 54 6 0 10 -5 10 -11 0 -5 13 -15 29 -20 21
-8 31 -18 33 -37 2 -16 12 -31 26 -38 13 -6 32 -21 43 -33 11 -11 26 -21 33
-21 7 0 35 -12 62 -27 26 -15 59 -27 72 -27 36 -1 51 -30 28 -55 -24 -26 -7
-57 41 -77 19 -9 37 -24 40 -35 7 -25 87 -28 97 -3 19 48 -10 114 -49 114 -8
0 -28 14 -43 31 -15 17 -38 42 -50 55 -26 25 -22 44 9 44 30 0 23 12 -41 73
-34 32 -60 65 -60 76 0 11 -4 22 -9 25 -4 3 -11 19 -14 36 -7 31 -27 42 -27
15 0 -8 -9 -23 -20 -32 -11 -10 -20 -23 -20 -30 0 -7 9 -13 20 -13 23 0 27
-18 5 -26 -26 -10 -69 11 -75 36 -5 22 -14 26 -78 35 -56 9 -76 16 -88 34 -9
12 -22 27 -31 34 -8 7 -23 20 -34 30 -10 9 -23 17 -28 17 -17 0 -23 42 -16
115 4 50 3 79 -5 92 -10 15 -8 25 8 53 19 30 22 32 27 14 12 -37 22 -49 44
-52 39 -6 22 62 -20 77 -34 12 -46 35 -29 56 10 12 7 20 -14 46 -14 17 -26 36
-26 44 0 14 -29 42 -31 29z"/>
<path d="M6166 17391 c-9 -14 4 -40 25 -52 11 -5 19 -20 19 -34 0 -31 36 -35
45 -5 11 36 8 82 -6 91 -18 11 -76 12 -83 0z"/>
<path d="M7010 17368 c0 -5 7 -8 15 -8 8 0 17 -11 21 -25 5 -21 9 -23 20 -14
11 9 19 8 34 -6 25 -23 40 -11 40 31 0 35 0 35 -65 32 -36 -2 -65 -6 -65 -10z"/>
<path d="M7410 17365 c-7 -8 -25 -15 -41 -15 -22 0 -29 -5 -29 -20 0 -25 22
-35 46 -22 22 12 76 -29 129 -96 36 -47 40 -58 26 -80 -9 -15 -69 11 -85 37
-7 11 -12 10 -26 -9 -17 -23 -17 -23 -49 -1 -17 12 -31 31 -31 40 0 26 -28 47
-42 33 -13 -13 -5 -46 22 -89 16 -27 26 -33 54 -33 28 0 35 -4 40 -25 4 -14
12 -25 20 -25 7 0 19 -12 26 -27 12 -25 14 -26 18 -9 2 11 -3 25 -13 32 -20
15 -12 54 12 54 19 0 98 -79 107 -108 6 -19 11 -20 28 -11 14 8 23 8 31 0 6
-6 19 -11 29 -11 10 0 21 -7 24 -15 10 -24 34 -18 34 9 0 25 -71 98 -106 110
-42 13 -61 90 -38 150 5 12 0 16 -20 16 -27 0 -76 59 -76 92 0 34 -67 51 -90
23z"/>
<path d="M10390 17346 c0 -27 17 -43 30 -30 10 11 -6 54 -20 54 -5 0 -10 -11
-10 -24z"/>
<path d="M6406 17335 c16 -24 44 -34 44 -17 0 13 -34 42 -49 42 -8 0 -6 -8 5
-25z"/>
<path d="M10653 17349 c-31 -11 -29 -24 7 -39 19 -8 34 -24 42 -46 12 -34 23
-40 45 -26 9 6 5 17 -17 43 -16 18 -29 39 -30 45 0 21 -24 32 -47 23z"/>
<path d="M6496 17335 c-3 -10 3 -24 18 -39 14 -12 28 -34 32 -50 3 -15 18 -35
31 -43 14 -9 34 -36 44 -60 12 -28 25 -43 36 -43 10 0 31 -16 46 -35 28 -35
28 -35 2 -45 -29 -11 -30 -18 -10 -67 20 -47 13 -63 -24 -63 -66 0 -96 30
-103 105 -2 21 -11 34 -31 43 -16 8 -31 21 -34 29 -7 19 -166 93 -198 93 -13
0 -25 -6 -27 -12 -5 -15 25 -68 52 -93 11 -10 20 -31 20 -46 0 -35 16 -46 39
-25 20 18 51 21 51 6 0 -5 11 -10 25 -10 16 0 28 -7 31 -17 11 -35 21 -47 50
-57 16 -6 45 -28 66 -48 20 -21 46 -38 57 -38 34 0 71 -29 71 -55 0 -31 45
-65 86 -65 24 0 42 -9 66 -33 18 -18 45 -38 61 -45 21 -9 27 -18 27 -42 0 -52
77 -78 148 -51 40 16 39 40 -3 54 -16 6 -43 21 -58 33 -16 13 -36 24 -46 24
-17 0 -61 39 -61 53 0 4 9 7 19 7 33 0 33 18 3 47 -16 15 -37 43 -46 61 -17
33 -30 40 -41 22 -3 -5 -13 -10 -22 -10 -9 0 -27 -10 -39 -21 -22 -21 -24 -21
-59 -5 -24 12 -35 24 -35 38 0 12 -7 30 -17 40 -15 17 -15 18 5 18 15 0 22 6
22 20 0 11 6 20 13 20 24 0 77 -31 87 -51 6 -10 20 -19 30 -19 26 0 27 48 1
81 -10 13 -21 34 -25 45 -4 12 -15 29 -26 39 -11 10 -20 23 -20 29 0 6 -15 35
-34 63 -30 45 -32 53 -19 66 21 21 9 52 -38 98 -25 24 -45 36 -55 32 -8 -3
-25 -1 -37 5 -12 6 -35 13 -52 15 -16 3 -40 8 -51 12 -15 5 -23 2 -28 -10z"/>
<path d="M11747 17323 c-14 -13 -6 -63 12 -80 10 -10 21 -36 25 -58 11 -63 16
-75 33 -75 22 0 13 102 -11 129 -9 10 -20 35 -23 55 -5 33 -20 45 -36 29z"/>
<path d="M9747 17314 c-4 -4 -7 -15 -7 -24 0 -9 -9 -27 -20 -40 -29 -33 -25
-47 21 -72 23 -13 50 -28 60 -34 30 -17 59 -46 59 -58 0 -37 23 -86 43 -92 62
-18 177 -121 177 -159 0 -5 24 -32 53 -60 32 -31 60 -71 71 -98 17 -46 32 -58
149 -124 12 -7 26 -18 32 -25 16 -21 107 -78 135 -85 14 -3 34 -13 45 -22 11
-10 32 -25 47 -34 22 -14 26 -23 26 -61 0 -59 15 -83 60 -96 20 -6 46 -17 56
-25 11 -8 25 -15 32 -15 29 0 114 -63 114 -85 0 -12 6 -41 14 -66 8 -24 17
-55 20 -69 3 -14 18 -46 35 -70 16 -25 32 -60 36 -77 6 -30 37 -63 57 -63 13
0 -4 54 -20 66 -17 12 -43 90 -34 99 25 24 83 -17 116 -82 9 -18 21 -33 26
-33 5 0 36 -27 68 -61 51 -51 63 -59 85 -54 44 11 39 31 -23 94 -52 51 -58 61
-44 72 13 10 16 9 21 -9 3 -11 18 -25 33 -31 16 -5 36 -23 45 -40 19 -38 41
-40 57 -6 12 27 1 59 -33 100 -9 11 -19 29 -21 40 -3 16 -11 19 -37 17 -20 -1
-60 9 -100 27 -36 16 -74 32 -85 35 -18 6 -18 7 -1 26 16 17 16 21 1 42 -9 12
-16 35 -16 50 0 18 -12 39 -35 62 -29 29 -32 36 -20 46 19 16 19 50 0 50 -8 0
-19 9 -25 20 -6 11 -19 20 -28 20 -28 0 -42 21 -42 62 0 29 -6 41 -25 54 -14
9 -25 25 -25 35 0 26 -12 30 -56 18 -60 -17 -63 -25 -21 -67 74 -73 88 -93 85
-121 -3 -23 -7 -26 -37 -24 -47 2 -80 29 -123 102 -48 82 -73 108 -112 115
-19 4 -41 15 -51 26 -26 29 -43 25 -47 -12 -4 -38 -23 -48 -32 -16 -3 13 -18
30 -34 39 -16 9 -42 36 -58 60 -19 29 -45 52 -77 67 -36 17 -49 29 -53 51 -3
15 -30 54 -60 86 -63 66 -64 72 -24 88 27 12 28 14 11 24 -10 6 -22 28 -25 47
-7 37 -30 48 -53 25 -7 -7 -13 -7 -17 -1 -3 6 -2 13 4 17 20 12 10 35 -15 35
-19 0 -26 7 -31 28 -8 34 -42 72 -64 72 -10 0 -34 11 -54 25 -21 14 -54 34
-74 44 -43 22 -74 54 -93 95 -14 31 -30 41 -42 30z m1287 -1205 c29 -34 34
-67 10 -76 -14 -5 -31 0 -84 27 -25 12 -24 42 1 61 33 25 43 24 73 -12z"/>
<path d="M9935 17307 c-21 -16 -13 -37 15 -37 23 0 32 13 24 34 -7 20 -15 20
-39 3z"/>
<path d="M6347 17293 c-19 -18 -6 -59 24 -75 48 -28 71 -24 63 10 -12 45 -66
86 -87 65z"/>
<path d="M6836 17288 c-24 -77 -12 -98 56 -102 30 -1 51 -9 66 -24 12 -12 28
-22 35 -22 26 0 92 -41 105 -65 7 -14 19 -25 27 -25 14 0 19 10 30 68 5 22 12
32 25 32 29 0 33 17 5 24 -13 3 -29 16 -36 27 -13 26 -68 77 -91 84 -9 3 -33
-1 -53 -10 -49 -20 -68 -19 -115 5 -46 23 -49 24 -54 8z"/>
<path d="M8170 17290 c0 -20 24 -60 37 -60 16 0 17 24 3 51 -11 19 -40 27 -40
9z"/>
<path d="M5303 17269 c-20 -20 -20 -24 -6 -45 18 -29 44 -31 66 -6 24 27 21
58 -5 66 -32 8 -31 8 -55 -15z"/>
<path d="M7994 17258 c-4 -6 1 -17 11 -24 14 -10 16 -21 11 -52 -8 -55 11 -71
58 -48 38 18 66 21 66 7 0 -14 63 -71 78 -71 14 0 17 8 26 58 5 30 4 32 -19
26 -18 -4 -30 1 -48 20 -13 14 -30 26 -36 26 -18 0 -101 50 -101 61 0 13 -38
11 -46 -3z"/>
<path d="M9270 17235 c0 -9 12 -27 27 -41 26 -24 27 -24 47 -6 16 15 31 18 60
14 26 -3 41 0 47 9 15 24 11 28 -37 35 -38 5 -48 4 -56 -10 -11 -20 -54 -21
-62 -1 -7 20 -26 19 -26 0z"/>
<path d="M7727 17233 c-20 -19 19 -83 50 -83 6 0 13 -7 17 -15 3 -8 16 -15 30
-15 14 0 28 -4 31 -10 8 -13 42 -13 51 1 11 18 -46 69 -78 69 -18 0 -31 7 -39
23 -18 33 -46 47 -62 30z"/>
<path d="M5585 17219 c-4 -6 3 -21 15 -34 14 -15 20 -30 16 -41 -6 -16 8 -33
27 -34 13 0 8 42 -10 81 -18 38 -36 49 -48 28z"/>
<path d="M8913 17204 c-8 -21 57 -78 72 -63 16 16 33 10 39 -13 10 -38 73
-100 99 -96 19 3 22 8 19 39 -2 30 1 38 18 42 11 3 20 12 20 21 0 18 -13 20
-39 6 -13 -6 -24 -5 -37 4 -11 9 -31 12 -51 9 -21 -4 -33 -1 -33 6 0 6 -14 11
-30 11 -23 0 -33 6 -40 25 -11 29 -28 33 -37 9z"/>
<path d="M11150 17203 c0 -10 5 -25 10 -33 13 -21 31 0 24 28 -7 26 -34 30
-34 5z"/>
<path d="M5460 17172 c0 -32 16 -53 36 -45 17 6 18 45 2 61 -21 21 -38 14 -38
-16z"/>
<path d="M2611 17149 c-21 -8 -23 -13 -16 -56 4 -26 15 -58 26 -71 25 -33 25
-88 0 -102 -40 -21 -31 -116 13 -133 18 -7 46 -63 46 -93 0 -19 5 -22 39 -21
39 2 39 2 34 52 -3 28 -11 56 -17 64 -6 8 -11 37 -11 65 0 43 -3 51 -20 54
-27 6 -46 22 -39 34 4 6 19 7 35 4 21 -4 29 -2 29 8 0 19 -26 67 -42 77 -10 7
-11 12 0 29 17 28 16 34 -14 69 -28 34 -28 34 -63 20z"/>
<path d="M8288 17153 c-20 -3 -28 -12 -33 -34 -9 -38 4 -52 57 -68 24 -7 50
-17 58 -22 51 -31 73 -16 48 34 -9 17 -18 39 -21 48 -5 15 -62 51 -76 48 -3
-1 -18 -4 -33 -6z"/>
<path d="M8805 17103 c4 -27 12 -54 17 -61 10 -11 8 -38 -8 -129 -5 -26 -2
-32 18 -38 12 -4 32 -19 44 -33 15 -18 31 -25 59 -26 27 -1 43 -9 59 -28 11
-14 44 -40 71 -56 28 -17 56 -40 63 -51 14 -25 47 -28 56 -6 3 9 -3 23 -14 32
-18 16 -18 18 -4 34 15 17 13 19 -20 33 -20 8 -36 21 -36 29 0 7 -13 26 -29
41 -26 25 -28 30 -17 57 10 27 8 32 -14 49 -36 28 -68 24 -41 -5 5 -6 12 -25
16 -42 6 -31 5 -33 -21 -33 -16 0 -44 14 -68 33 -23 19 -49 36 -58 40 -13 4
-16 17 -14 56 1 28 6 54 9 58 14 14 6 35 -25 64 -44 40 -51 37 -43 -18z"/>
<path d="M10751 17126 c-21 -26 21 -85 62 -86 22 0 22 1 -14 54 -34 52 -33 51
-48 32z"/>
<path d="M5682 17088 c3 -7 15 -15 27 -16 16 -3 22 1 19 10 -3 7 -15 15 -27
16 -16 3 -22 -1 -19 -10z"/>
<path d="M11277 17094 c-12 -13 51 -114 71 -114 23 0 24 24 2 71 -22 46 -52
64 -73 43z"/>
<path d="M8074 17058 c10 -51 30 -72 85 -92 29 -10 54 -16 57 -14 10 10 -9 39
-35 53 -14 8 -43 30 -64 49 -47 44 -51 44 -43 4z"/>
<path d="M10992 17068 c2 -17 11 -24 30 -26 22 -3 30 -11 39 -42 14 -47 61
-100 87 -100 11 0 25 -7 32 -15 23 -27 33 -1 16 40 -11 26 -13 42 -6 55 6 10
10 23 10 28 0 12 -126 53 -143 46 -7 -2 -22 4 -32 16 -24 26 -37 25 -33 -2z"/>
<path d="M10867 17062 c-20 -22 -8 -45 33 -62 23 -9 34 -10 42 -2 8 8 4 14
-17 22 -22 8 -26 15 -23 35 6 30 -11 33 -35 7z"/>
<path d="M7917 17063 c-16 -15 -4 -23 36 -23 28 1 37 3 27 9 -26 15 -56 22
-63 14z"/>
<path d="M6916 17052 c-3 -5 7 -28 21 -52 24 -40 27 -42 39 -25 17 23 18 57 2
73 -14 14 -54 16 -62 4z"/>
<path d="M8500 17045 c0 -19 32 -36 50 -25 11 7 11 11 1 24 -17 20 -51 21 -51
1z"/>
<path d="M9634 17046 c-7 -20 2 -46 16 -46 13 0 13 47 0 55 -6 3 -13 -1 -16
-9z"/>
<path d="M9732 17038 c-7 -7 -12 -21 -12 -32 0 -18 6 -21 45 -21 53 0 54 3 17
38 -32 31 -34 31 -50 15z"/>
<path d="M12788 16843 c-4 -197 3 -283 23 -283 5 0 10 12 11 28 0 15 3 54 5
87 4 71 4 68 -3 215 -5 126 -10 160 -23 160 -5 0 -11 -93 -13 -207z"/>
<path d="M7029 17024 c-9 -11 -8 -20 6 -40 9 -15 20 -54 23 -88 6 -68 12 -76
62 -76 21 0 50 -10 73 -25 40 -28 46 -42 22 -51 -15 -6 -21 -34 -7 -34 4 1 18
7 32 15 35 20 67 18 90 -5 11 -11 23 -20 28 -20 4 0 13 -9 20 -20 6 -11 43
-36 82 -55 38 -19 77 -46 86 -60 12 -18 25 -25 48 -25 31 0 31 0 31 73 0 72 0
72 -50 73 -65 1 -133 23 -140 45 -10 29 -33 43 -50 29 -20 -17 -35 -4 -35 30
0 23 -6 31 -24 36 -13 3 -34 17 -47 30 -12 13 -29 24 -37 24 -8 0 -39 11 -68
25 -58 27 -78 61 -54 91 17 19 5 30 -42 37 -25 4 -40 1 -49 -9z"/>
<path d="M10420 17020 c-13 -9 -11 -14 13 -35 32 -28 87 -34 87 -10 0 40 -64
68 -100 45z"/>
<path d="M5407 17013 c-24 -4 -26 -8 -20 -31 9 -40 43 -54 43 -17 0 7 7 15 15
19 18 7 20 37 3 35 -7 -1 -25 -4 -41 -6z"/>
<path d="M5544 16983 c-3 -10 -10 -26 -15 -35 -14 -26 -11 -47 12 -95 27 -56
54 -59 45 -5 -5 35 -2 42 34 80 44 45 47 52 25 52 -8 0 -15 -4 -15 -10 0 -17
-26 -11 -45 10 -22 25 -34 25 -41 3z"/>
<path d="M12064 16985 c-8 -20 4 -35 26 -35 25 0 35 17 20 35 -16 19 -39 19
-46 0z"/>
<path d="M8440 16967 c0 -8 9 -22 20 -32 11 -10 20 -24 20 -32 0 -16 36 -17
46 -1 4 6 0 16 -8 22 -9 6 -17 20 -19 31 -5 24 -59 35 -59 12z"/>
<path d="M8630 16924 c0 -17 17 -47 47 -83 26 -31 48 -57 49 -59 1 -2 10 -5
21 -6 10 -2 20 -11 22 -22 3 -17 21 -36 104 -109 10 -9 29 -20 42 -25 17 -7
25 -17 25 -34 0 -19 9 -27 40 -40 22 -9 40 -20 40 -26 0 -6 11 -15 25 -20 18
-7 25 -17 25 -35 0 -32 23 -33 38 -1 9 20 7 27 -8 41 -10 9 -23 35 -29 59 -11
46 -42 80 -81 89 -14 4 -35 15 -47 27 -12 11 -32 19 -45 17 -16 -1 -25 5 -32
27 -6 16 -28 47 -49 70 -31 33 -37 46 -32 70 5 28 4 28 -29 23 -35 -6 -86 26
-86 53 0 5 -9 10 -20 10 -15 0 -20 -7 -20 -26z"/>
<path d="M10354 16905 c5 -21 1 -27 -30 -40 -41 -17 -41 -45 2 -80 13 -12 24
-28 24 -38 0 -22 23 -22 44 2 13 14 14 24 7 45 -7 17 -7 35 0 53 8 21 7 30 -4
38 -7 5 -16 18 -20 28 -10 27 -30 21 -23 -8z"/>
<path d="M7711 16897 c-24 -24 3 -97 36 -97 8 0 28 -8 44 -17 15 -9 30 -15 31
-12 2 2 14 19 26 37 27 38 16 68 -20 56 -11 -3 -27 1 -36 9 -28 25 -68 37 -81
24z"/>
<path d="M9214 16895 c-9 -21 14 -45 43 -45 31 0 79 -25 86 -45 5 -10 20 -15
52 -15 47 0 61 -20 33 -49 -11 -10 -8 -16 15 -33 19 -13 27 -29 27 -49 0 -23
6 -31 33 -43 47 -19 72 -104 49 -171 -15 -48 -6 -75 25 -75 10 0 12 -6 8 -20
-9 -28 11 -50 46 -50 41 0 40 34 -1 49 -24 8 -30 16 -30 38 0 45 11 72 31 78
24 8 24 25 0 32 -27 7 -35 99 -11 128 25 30 15 102 -19 139 -46 50 -116 116
-124 116 -4 0 -16 -14 -26 -30 -18 -31 -18 -31 -49 -5 -16 14 -36 25 -44 25
-8 0 -23 9 -33 20 -23 25 -102 29 -111 5z m356 -248 c0 -50 -17 -45 -40 12 -9
24 -24 49 -33 56 -10 7 -17 17 -17 23 0 7 20 -3 45 -20 40 -28 45 -36 45 -71z"/>
<path d="M3350 16880 c0 -24 41 -28 59 -7 14 18 4 27 -31 27 -21 0 -28 -5 -28
-20z"/>
<path d="M3866 16883 c-3 -3 -6 -15 -6 -26 0 -12 -11 -23 -30 -30 -16 -6 -30
-15 -30 -19 0 -8 34 -28 47 -28 12 0 43 58 43 80 0 20 -13 33 -24 23z"/>
<path d="M8034 16866 c5 -19 0 -29 -16 -40 -24 -17 -18 -29 19 -40 35 -11 50
27 27 70 -22 39 -39 45 -30 10z"/>
<path d="M6327 16842 c-27 -30 -22 -81 9 -92 36 -14 37 -14 29 26 -4 25 -2 39
6 44 15 10 4 40 -14 40 -8 0 -21 -8 -30 -18z"/>
<path d="M8554 16834 c3 -9 6 -22 6 -30 0 -8 7 -14 15 -14 18 0 20 31 3 48
-17 17 -31 15 -24 -4z"/>
<path d="M12140 16836 c-18 -22 -5 -48 22 -44 17 2 23 10 23 28 0 29 -26 38
-45 16z"/>
<path d="M5314 16816 c-5 -14 33 -76 47 -76 4 0 10 -12 14 -27 11 -44 24 -53
78 -53 39 0 58 -6 84 -26 19 -14 41 -23 49 -20 53 20 -11 96 -79 94 -47 -2
-84 24 -115 80 -24 44 -66 58 -78 28z"/>
<path d="M11288 16819 c-27 -15 -22 -32 16 -53 37 -20 56 -15 56 14 0 47 -30
64 -72 39z"/>
<path d="M8116 16811 c-3 -4 19 -34 50 -66 80 -85 83 -93 45 -124 -17 -15 -31
-35 -31 -47 0 -14 -8 -24 -21 -27 -27 -7 -15 -27 17 -27 14 0 27 -7 30 -15 9
-22 -14 -45 -46 -45 -35 0 -42 -8 -29 -33 16 -29 -7 -96 -43 -125 -15 -13 -28
-29 -28 -36 0 -7 -18 -28 -40 -47 -22 -19 -40 -40 -40 -46 0 -7 -12 -20 -26
-29 -18 -12 -24 -23 -20 -38 9 -36 -7 -49 -46 -38 -26 7 -41 6 -61 -5 -33 -17
-34 -26 -5 -45 28 -19 16 -38 -26 -38 -35 0 -56 15 -56 40 0 9 -9 25 -20 35
-11 10 -20 24 -20 31 0 6 -16 26 -35 43 -31 27 -41 30 -75 25 -35 -6 -40 -4
-51 19 -12 26 -42 37 -146 52 -48 8 -62 -14 -22 -35 13 -7 19 -19 17 -34 -6
-47 128 -166 187 -166 9 0 15 -9 15 -21 0 -23 -6 -23 -99 1 -54 13 -89 8 -50
-8 15 -6 29 -20 32 -31 4 -18 10 -20 57 -14 45 5 53 3 66 -16 10 -14 26 -21
46 -21 27 0 30 2 24 25 -7 29 16 34 47 11 24 -19 21 -35 -8 -42 -31 -8 -32
-26 -1 -59 24 -26 25 -26 35 -7 17 32 105 82 132 75 19 -5 21 -3 16 15 -6 24
24 52 55 52 13 0 18 8 18 30 0 21 5 30 16 30 21 0 152 127 160 154 3 12 24 37
45 57 21 20 39 43 39 51 0 16 19 38 33 38 11 0 0 -66 -16 -91 -15 -24 0 -51
34 -59 18 -4 25 -15 30 -40 3 -19 20 -57 37 -85 17 -27 36 -60 41 -72 29 -65
108 -160 261 -313 97 -98 299 -270 316 -270 4 0 17 -9 28 -19 27 -24 183 -130
210 -142 12 -5 39 -20 61 -34 22 -13 52 -29 67 -35 14 -6 29 -17 31 -24 3 -8
18 -17 33 -20 15 -4 39 -16 52 -27 14 -10 32 -19 41 -19 9 0 30 -9 46 -20 17
-11 40 -20 53 -20 12 0 39 -9 59 -20 21 -11 50 -20 64 -20 15 0 46 -7 70 -16
24 -8 77 -19 118 -24 41 -6 79 -14 85 -19 6 -4 28 -11 49 -15 52 -10 53 -54 2
-100 -40 -37 -46 -77 -16 -98 23 -16 15 -96 -12 -126 -14 -16 -17 -46 -17
-208 0 -104 0 -207 -1 -229 0 -22 1 -96 2 -165 5 -276 -6 -967 -15 -998 -7
-20 -4 -22 29 -22 20 0 48 6 64 14 33 18 46 11 55 -31 4 -17 14 -37 22 -44 10
-8 14 -33 14 -80 0 -91 18 -91 54 -1 39 97 43 254 7 281 -21 16 -22 20 -10 39
7 12 11 22 9 24 -3 2 -19 13 -37 26 -47 32 -63 29 -63 -13 0 -19 5 -35 10 -35
6 0 10 -4 10 -10 0 -14 -33 -13 -48 2 -15 15 -16 74 -2 83 17 11 11 52 -15
101 -30 56 -31 70 -7 76 33 9 42 -2 42 -53 0 -49 0 -49 65 -79 35 -16 69 -30
75 -30 20 0 70 -64 70 -90 0 -42 14 -56 44 -42 20 9 25 19 28 54 3 41 1 44
-40 72 -23 15 -47 37 -53 47 -5 10 -19 19 -30 19 -24 0 -89 61 -89 82 0 8 -13
24 -30 36 -16 13 -30 32 -30 43 0 28 -18 59 -34 59 -17 0 -46 33 -46 53 0 27
21 30 51 8 15 -11 32 -21 36 -21 18 0 84 -56 102 -86 20 -34 20 -34 1 -34 -11
0 -20 -4 -20 -10 0 -5 12 -10 26 -10 20 0 24 -4 19 -19 -4 -14 0 -21 17 -27
24 -7 68 -36 105 -68 13 -11 26 -34 29 -53 8 -41 34 -45 34 -4 0 16 10 39 25
55 14 15 25 31 25 37 0 5 5 9 11 9 13 0 2 -53 -12 -58 -5 -2 -9 -15 -9 -29 0
-25 1 -26 58 -19 32 4 69 15 84 26 15 11 41 20 58 20 16 0 30 2 30 5 0 10 -55
54 -75 61 -11 3 -29 15 -41 25 -19 18 -22 18 -34 4 -7 -8 -20 -15 -29 -15 -16
0 -67 61 -98 114 -13 23 -62 51 -106 61 -22 4 -28 11 -25 28 3 19 11 23 58 27
52 5 55 7 58 34 3 27 2 28 -13 13 -21 -22 -27 -21 -57 2 -13 11 -37 23 -51 26
-29 8 -36 32 -15 53 9 9 6 12 -15 12 -17 0 -40 12 -59 30 -17 17 -35 30 -39
30 -5 0 -9 7 -9 15 0 8 8 15 19 15 10 0 24 -7 31 -15 13 -16 70 -21 70 -6 0 9
-64 61 -75 61 -17 0 -118 80 -151 120 -28 33 -21 60 16 60 22 0 128 -80 135
-102 7 -19 39 -33 55 -23 5 3 10 18 10 33 0 15 8 35 18 44 9 9 23 24 30 32 7
9 28 16 46 16 33 0 62 20 49 33 -3 4 -16 7 -29 7 -35 0 -54 11 -54 30 0 26
-61 46 -76 25 -28 -37 -84 0 -84 56 0 32 -27 99 -40 99 -5 0 -13 -7 -18 -16
-11 -20 -56 -15 -60 8 -2 10 5 19 18 23 19 6 20 11 14 68 -4 34 -7 67 -6 72 1
6 3 49 6 97 5 107 28 155 79 160 21 2 35 11 43 25 6 13 18 31 27 41 10 10 17
33 17 50 0 18 4 32 9 32 16 0 91 84 91 102 0 10 9 22 20 28 11 6 27 26 35 45
17 43 47 46 72 9 16 -25 84 -74 100 -74 5 1 18 9 31 20 23 19 23 19 2 40 -14
14 -20 29 -16 44 4 15 -1 25 -14 34 -12 7 -20 23 -20 38 0 14 -5 35 -11 46
-24 45 40 99 79 66 27 -24 50 -28 63 -12 18 22 53 13 57 -15 2 -13 -1 -28 -7
-34 -15 -15 -14 -57 3 -76 8 -9 17 -30 21 -48 6 -29 4 -33 -20 -39 -36 -9 -26
-28 19 -34 32 -4 42 -12 60 -45 28 -50 62 -59 72 -19 4 17 1 36 -10 54 -10 17
-16 50 -16 84 0 45 -4 57 -20 66 -11 6 -23 22 -26 35 -3 13 -12 29 -20 36 -8
6 -14 23 -14 37 0 24 -35 92 -48 92 -7 0 -38 19 -101 62 -14 10 -37 23 -51 28
-24 11 -75 62 -83 84 -3 8 -11 7 -26 -2 -32 -19 -47 -2 -55 61 -7 48 -9 51
-22 33 -8 -11 -14 -30 -14 -43 0 -12 -9 -27 -19 -33 -11 -5 -21 -20 -23 -32
-2 -12 -9 -23 -15 -26 -19 -6 -28 28 -14 51 11 18 8 24 -28 61 -30 29 -44 37
-52 29 -14 -14 5 -53 27 -53 10 0 14 -8 12 -22 -4 -31 -73 -39 -93 -11 -12 15
-17 16 -34 6 -26 -16 -31 -16 -31 1 0 8 7 16 15 20 8 3 15 16 15 29 0 14 -7
30 -15 37 -8 7 -15 19 -15 26 0 8 7 14 15 14 8 0 15 -9 15 -20 0 -22 22 -27
37 -7 6 6 10 36 10 65 1 44 -2 52 -18 52 -22 0 -31 13 -23 34 9 24 54 21 54
-4 0 -21 15 -27 25 -10 8 13 -32 58 -63 71 -17 7 -22 14 -17 29 8 25 -10 59
-46 88 -20 16 -29 33 -29 52 0 41 -16 77 -40 90 -30 16 -45 2 -24 -21 25 -28
23 -84 -3 -111 -30 -29 -62 -18 -93 32 -24 39 -27 40 -77 40 -52 0 -53 -1 -53
-29 0 -36 56 -148 82 -164 25 -16 23 -55 -4 -77 -20 -16 -21 -22 -10 -39 6
-11 12 -27 12 -36 0 -17 29 -34 55 -32 12 1 20 -4 20 -13 0 -11 -13 -16 -47
-18 -54 -3 -59 -12 -23 -36 14 -9 25 -24 25 -34 0 -45 51 -56 77 -16 13 20 14
30 5 44 -7 11 -9 38 -5 68 5 42 3 51 -15 64 -12 8 -21 23 -21 34 0 10 -4 36
-9 58 -9 34 -8 41 13 62 31 31 41 30 75 -5 36 -39 58 -135 41 -182 -9 -27 -8
-35 6 -51 11 -13 17 -37 18 -76 1 -74 28 -122 68 -122 36 0 83 -25 97 -50 6
-11 35 -34 65 -51 58 -33 71 -63 40 -89 -31 -26 -167 19 -232 77 -24 21 -53
40 -65 43 -14 4 -25 17 -30 36 -9 35 -42 74 -63 74 -25 0 -17 -30 10 -40 30
-11 32 -26 5 -42 -34 -22 -26 -65 15 -82 54 -23 48 -52 -12 -59 -77 -9 -108
15 -108 82 0 47 -3 56 -30 77 -16 13 -36 24 -42 24 -22 0 -40 52 -35 99 4 42
3 44 -13 28 -22 -22 -35 -13 -35 24 0 37 -27 49 -114 49 -39 0 -69 5 -82 15
-23 17 -60 19 -70 4 -4 -7 -22 -9 -49 -5 -42 7 -42 7 -48 -36 -7 -52 -5 -56
38 -64 45 -8 75 -58 45 -74 -32 -17 -100 15 -156 75 -34 37 -58 55 -75 55 -29
0 -87 34 -96 56 -3 8 -16 20 -29 25 -14 5 -24 17 -24 28 0 23 -16 36 -25 21
-11 -18 -25 0 -19 25 4 18 -1 28 -24 45 -17 13 -33 34 -37 49 -3 14 -19 43
-36 63 -38 48 -37 67 2 75 37 7 47 27 25 52 -9 10 -16 31 -16 48 0 17 -7 36
-15 43 -8 7 -15 21 -15 31 0 27 -15 24 -28 -5 -9 -19 -8 -27 4 -36 19 -17 18
-33 -6 -63 -13 -16 -27 -24 -36 -20 -8 3 -24 -3 -35 -13 -20 -18 -21 -18 -35
1 -8 10 -14 27 -14 36 0 20 -36 49 -61 49 -37 0 -63 63 -39 100 7 12 13 11 37
-10 15 -14 31 -29 35 -34 7 -11 78 23 78 37 0 4 -15 23 -34 41 -38 38 -50 70
-33 89 7 7 22 27 35 45 23 32 23 32 -8 38 -41 9 -51 46 -20 79 29 31 20 55
-19 55 -50 0 -72 64 -26 76 29 7 42 39 25 59 -18 22 -39 18 -50 -9 -12 -32
-49 -44 -66 -21 -18 25 -48 15 -52 -17 -3 -23 3 -30 36 -47 33 -17 41 -28 51
-65 14 -57 15 -53 -9 -59 -29 -7 -25 -27 6 -27 32 0 54 -48 54 -119 0 -44 -4
-52 -30 -71 -34 -24 -60 -15 -60 21 0 10 -4 20 -9 23 -5 3 -12 17 -15 31 -3
13 -17 41 -31 61 -18 27 -25 50 -25 85 0 49 0 49 -36 49 -34 0 -36 2 -30 25 5
18 2 25 -8 25 -26 0 -59 58 -52 91 5 28 4 29 -29 29 -41 0 -40 2 -19 -40 16
-31 16 -34 -1 -47 -48 -34 -97 5 -75 61 6 17 5 29 -5 42 -8 11 -15 28 -15 40
0 46 -103 100 -124 65z m222 -293 c7 -7 12 -30 12 -52 1 -23 8 -59 16 -81 9
-22 19 -53 23 -70 5 -16 15 -43 24 -60 9 -16 19 -37 22 -45 3 -8 17 -33 30
-55 13 -22 30 -53 38 -70 8 -16 21 -36 30 -44 10 -7 17 -19 17 -27 0 -7 6 -17
13 -21 7 -4 37 -36 65 -71 29 -35 99 -107 156 -160 187 -176 178 -168 321
-267 28 -19 67 -47 89 -62 44 -32 102 -68 131 -81 12 -6 27 -17 34 -26 7 -9
18 -16 23 -16 5 0 21 -9 35 -20 14 -11 33 -20 42 -20 9 0 28 -8 41 -17 25 -18
45 -27 130 -58 25 -9 59 -22 75 -29 17 -8 48 -17 70 -21 21 -4 52 -13 68 -21
40 -21 214 -29 322 -15 104 14 145 32 207 93 41 39 45 48 51 106 8 76 11 82
41 82 32 0 48 -22 53 -73 5 -44 -8 -72 -70 -150 -27 -34 -123 -101 -212 -147
-22 -12 -52 -28 -67 -36 -24 -13 -43 -13 -168 0 -77 8 -145 18 -151 22 -10 6
-37 14 -189 54 -19 5 -53 18 -75 30 -21 11 -47 20 -56 20 -9 0 -22 6 -28 14
-7 8 -22 17 -35 20 -23 6 -74 34 -156 86 -25 16 -51 29 -59 29 -8 1 -29 12
-47 26 -18 14 -35 25 -39 25 -3 0 -30 18 -60 40 -30 22 -58 40 -64 40 -5 0
-11 4 -13 9 -3 9 -91 82 -152 126 -68 49 -183 158 -306 291 -59 63 -161 210
-197 284 -38 78 -62 134 -69 163 -3 16 -15 34 -25 40 -16 10 -19 24 -19 97 0
113 6 130 39 130 15 0 32 -5 39 -12z m1249 -970 c29 -12 55 -30 59 -40 3 -10
14 -23 25 -28 27 -15 28 -90 0 -90 -21 0 -101 49 -101 61 0 4 -16 17 -35 29
-26 16 -35 28 -35 49 0 48 11 51 87 19z m509 -1834 c22 -51 18 -71 -13 -77
-40 -7 -43 -3 -43 63 0 54 1 58 21 53 12 -3 27 -21 35 -39z"/>
<path d="M8401 16811 c-11 -7 -4 -15 27 -35 66 -42 86 -31 31 17 -34 30 -38
31 -58 18z"/>
<path d="M11137 16813 c-13 -12 -7 -50 11 -66 34 -31 128 -1 106 34 -3 5 -15
9 -27 9 -12 0 -31 7 -41 15 -21 16 -39 19 -49 8z"/>
<path d="M6489 16803 c-10 -2 -19 -18 -22 -36 -5 -36 30 -91 64 -102 27 -9 24
-32 -6 -39 -35 -9 -32 -14 29 -68 54 -47 54 -47 60 10 9 74 9 79 -2 134 -10
53 -23 73 -63 94 -29 14 -32 15 -60 7z"/>
<path d="M7120 16771 c0 -13 27 -21 45 -15 25 10 17 24 -15 24 -16 0 -30 -4
-30 -9z"/>
<path d="M10777 16773 c-3 -5 -2 -15 3 -22 10 -17 43 -6 38 12 -6 15 -34 22
-41 10z"/>
<path d="M2438 16753 c-6 -30 3 -63 18 -63 16 0 29 43 20 65 -8 21 -34 19 -38
-2z"/>
<path d="M8606 16734 c-11 -30 -7 -36 21 -29 35 8 35 9 27 29 -8 21 -40 21
-48 0z"/>
<path d="M10432 16728 c2 -12 11 -24 21 -26 14 -3 18 1 15 20 -2 12 -11 24
-21 26 -14 3 -18 -1 -15 -20z"/>
<path d="M7705 16716 c-56 -24 -57 -36 -11 -87 26 -29 54 -49 74 -54 42 -9 60
-40 37 -65 -18 -20 -23 -11 60 -104 19 -22 35 -43 35 -47 0 -5 16 -24 35 -43
19 -20 35 -45 35 -57 0 -20 2 -21 18 -7 9 8 25 18 35 21 23 9 22 52 -2 69 -11
8 -23 27 -27 43 -4 17 -16 47 -27 68 -10 20 -22 65 -26 98 -7 58 -11 64 -57
105 -27 24 -58 44 -69 44 -11 0 -31 7 -45 15 -30 17 -28 17 -65 1z"/>
<path d="M4666 16686 c-21 -39 -11 -90 24 -121 11 -10 20 -22 20 -27 0 -15 43
-68 55 -68 16 0 35 59 35 106 0 22 5 45 11 51 9 9 8 18 -5 37 -16 25 -30 30
-69 26 -10 -1 -26 5 -36 14 -15 14 -18 12 -35 -18z m99 -26 c9 -14 -17 -70
-31 -70 -12 0 -25 58 -17 73 6 11 41 9 48 -3z"/>
<path d="M10785 16710 c-3 -6 -4 -24 0 -40 6 -26 4 -30 -14 -30 -12 0 -21 6
-21 14 0 17 -47 56 -67 56 -25 0 -27 -32 -3 -50 14 -10 25 -33 29 -56 6 -34
10 -39 33 -39 14 0 34 -10 44 -22 32 -37 58 -34 64 7 4 29 11 37 40 46 35 12
35 12 -8 24 -50 15 -59 25 -64 64 -3 31 -21 45 -33 26z"/>
<path d="M4926 16685 c-23 -36 -17 -76 14 -92 22 -11 27 -10 39 7 23 34 39 24
48 -32 7 -46 11 -53 31 -53 26 -1 47 -28 38 -51 -7 -18 -35 -18 -60 1 -32 24
-66 19 -66 -8 0 -36 33 -62 60 -47 26 14 62 -22 56 -57 -2 -17 2 -23 16 -23
12 0 23 -11 29 -29 7 -21 26 -38 60 -56 27 -14 93 -69 145 -121 53 -53 109
-100 125 -106 26 -9 29 -15 29 -51 -1 -42 -1 -42 -21 -18 -17 21 -22 22 -30
10 -19 -28 7 -121 49 -173 14 -19 22 -42 22 -68 0 -35 4 -41 45 -66 28 -17 47
-36 51 -52 3 -14 7 -31 10 -37 4 -17 76 -17 92 -1 7 7 12 25 12 40 0 39 -70
157 -93 158 -22 0 -77 40 -77 54 0 24 18 40 32 29 7 -6 24 -13 38 -15 46 -6
38 40 -17 106 -27 31 -56 77 -66 104 -12 34 -40 70 -102 132 -58 58 -89 97
-97 123 -11 36 -22 43 -68 39 -73 -6 -143 96 -109 160 12 22 -2 68 -29 100 -8
10 -12 23 -9 30 2 7 -8 28 -23 46 -25 30 -34 34 -92 38 -62 4 -66 3 -82 -21z"/>
<path d="M9227 16703 c-10 -10 -8 -41 2 -48 12 -7 91 17 91 27 0 5 -9 8 -19 8
-11 0 -23 5 -26 10 -7 11 -38 13 -48 3z"/>
<path d="M5790 16687 c0 -3 11 -25 25 -48 14 -24 25 -52 25 -61 0 -20 22 -23
51 -8 22 12 26 67 7 92 -12 14 -108 36 -108 25z"/>
<path d="M11066 16674 c-3 -9 -6 -31 -6 -50 0 -19 -4 -34 -10 -34 -5 0 -10 -4
-10 -10 0 -5 8 -10 18 -10 22 0 89 -82 97 -121 5 -20 13 -29 26 -29 11 0 24
-11 31 -26 12 -26 1 -44 -36 -57 -8 -3 -7 -11 2 -26 17 -29 15 -39 -8 -46 -26
-8 -26 -22 0 -30 23 -7 59 -83 67 -143 6 -47 22 -51 37 -10 6 18 4 35 -8 58
-21 42 -20 53 3 74 29 27 35 65 14 88 -14 15 -17 34 -16 78 2 45 -2 64 -18 84
-20 25 -20 25 1 38 30 19 29 21 -41 106 -5 6 -29 12 -53 12 -45 0 -56 10 -56
51 0 23 -25 25 -34 3z"/>
<path d="M10465 16638 c4 -18 13 -40 20 -48 6 -8 15 -23 18 -32 9 -27 27 -22
27 7 0 14 -4 25 -9 25 -6 0 -11 17 -13 38 -2 30 -7 38 -26 40 -22 3 -23 1 -17
-30z"/>
<path d="M10960 16659 c0 -19 41 -69 56 -69 23 0 16 20 -17 51 -34 32 -39 34
-39 18z"/>
<path d="M8135 16651 c-3 -6 3 -15 14 -21 21 -11 37 2 26 20 -8 13 -32 13 -40
1z"/>
<path d="M2617 16644 c-9 -10 6 -110 19 -124 22 -22 31 -1 26 62 -3 44 -8 57
-22 61 -10 3 -21 3 -23 1z"/>
<path d="M6288 16622 c-2 -16 -12 -31 -25 -37 -33 -14 -29 -27 27 -88 36 -40
51 -65 56 -95 4 -23 13 -47 20 -53 18 -15 18 -29 -2 -44 -13 -9 -14 -16 -6
-31 10 -17 11 -17 23 9 16 35 18 35 68 -19 70 -73 95 -130 81 -177 -11 -38
-11 -39 29 -76 30 -28 41 -46 41 -67 0 -17 4 -34 10 -40 5 -5 6 -24 0 -49 -23
-100 -5 -172 53 -201 17 -9 42 -25 55 -35 12 -9 41 -20 63 -24 22 -4 43 -13
46 -21 4 -11 16 -13 49 -8 37 5 46 3 68 -19 13 -13 35 -27 49 -31 14 -3 27
-15 30 -26 5 -18 13 -20 81 -20 58 0 76 3 76 14 0 7 -9 16 -21 19 -34 9 -22
51 16 55 26 2 36 -4 63 -37 18 -22 32 -49 32 -60 0 -31 17 -34 50 -11 22 15
30 30 30 51 0 31 10 36 39 18 14 -10 24 -7 50 12 41 30 35 43 -26 50 -28 4
-57 10 -64 15 -8 4 -32 8 -54 9 -30 0 -41 4 -43 18 -6 28 17 47 57 47 58 0 70
14 41 45 -24 25 -29 26 -110 23 -84 -3 -84 -3 -101 32 -10 20 -29 42 -43 49
-31 17 -53 71 -34 83 18 11 22 10 48 -12 23 -20 23 -20 48 5 25 26 24 55 -2
55 -8 0 -26 11 -40 25 -32 31 -56 33 -56 2 0 -12 -9 -40 -21 -62 -28 -53 -22
-121 14 -165 15 -17 27 -38 27 -45 0 -21 19 -28 35 -15 10 8 15 9 15 2 0 -6
-4 -14 -10 -17 -5 -3 -10 -30 -10 -60 0 -50 -2 -54 -36 -74 -19 -12 -37 -21
-39 -21 -2 0 -6 26 -10 58 -14 135 -13 131 -57 143 -22 5 -46 8 -54 5 -19 -7
-84 21 -84 37 0 7 5 18 12 25 19 19 0 27 -62 27 -69 0 -78 -6 -56 -39 20 -32
11 -59 -18 -50 -36 11 -45 27 -48 86 -2 49 1 59 22 77 30 25 49 26 97 6 19 -8
48 -15 62 -15 29 0 85 -36 113 -73 25 -33 37 -13 40 67 2 66 1 70 -29 95 -17
14 -34 36 -37 48 -6 19 -11 21 -26 13 -19 -10 -31 -1 -43 32 -5 13 -14 16 -44
11 -55 -8 -60 -18 -24 -48 34 -29 40 -59 15 -69 -29 -11 -49 -5 -83 24 -35 30
-35 30 -59 8 -23 -23 -41 -15 -42 19 0 7 -9 17 -19 23 -25 13 -37 48 -21 64 9
8 17 4 34 -16 27 -35 76 -35 115 -2 10 9 -58 72 -111 104 -53 31 -63 41 -80
87 -11 30 -27 54 -37 58 -25 8 -111 100 -111 118 0 8 -7 20 -15 27 -8 7 -15
19 -15 26 0 22 57 -10 65 -36 3 -11 10 -20 15 -20 9 0 50 62 50 77 0 17 -136
120 -167 126 -29 6 -32 4 -35 -21z"/>
<path d="M2743 16624 c-3 -9 1 -37 11 -63 9 -25 16 -61 16 -79 0 -22 8 -41 25
-58 13 -13 31 -37 39 -52 14 -27 14 -27 21 -1 4 15 0 50 -9 80 -9 29 -16 72
-16 96 0 63 -69 124 -87 77z"/>
<path d="M3666 16631 c-3 -5 2 -19 12 -32 9 -14 22 -33 28 -44 15 -27 28 -25
32 3 3 17 -6 33 -29 53 -37 33 -36 32 -43 20z"/>
<path d="M5371 16626 c-10 -11 -8 -24 10 -57 17 -34 19 -47 10 -61 -16 -25
-14 -45 5 -52 10 -4 14 -12 10 -22 -7 -18 31 -59 78 -84 16 -8 39 -33 51 -55
27 -50 79 -70 101 -40 19 26 19 26 -22 74 -35 41 -36 43 -25 86 14 55 14 112
1 120 -15 9 -40 -14 -40 -36 0 -10 -13 -32 -30 -49 -16 -17 -30 -35 -30 -40 0
-6 -4 -10 -10 -10 -5 0 -10 14 -10 30 0 17 -12 68 -26 113 -31 96 -47 114 -73
83z"/>
<path d="M12120 16622 c0 -11 12 -30 26 -41 14 -11 29 -32 33 -47 16 -62 78
-59 68 3 -8 45 -50 90 -94 99 -29 6 -33 4 -33 -14z"/>
<path d="M7190 16595 c0 -14 6 -16 33 -12 26 5 39 1 66 -23 35 -30 35 -30 10
-56 -24 -26 -24 -26 -1 -44 12 -10 22 -26 22 -35 0 -15 7 -17 41 -12 36 5 45
1 77 -26 80 -70 116 -75 125 -20 7 40 0 49 -43 59 -59 14 -150 86 -164 131
-11 36 -166 71 -166 38z"/>
<path d="M9187 16603 c-28 -27 27 -96 85 -107 21 -4 40 -11 43 -16 9 -14 -12
-48 -35 -55 -27 -8 -25 -14 11 -53 40 -43 71 -31 62 23 -5 33 13 53 21 23 2
-7 9 -30 15 -50 9 -29 9 -42 0 -59 -10 -19 -9 -24 7 -35 11 -7 24 -17 30 -21
5 -4 19 -13 30 -19 15 -9 19 -22 19 -68 0 -31 3 -56 8 -56 5 0 7 -14 5 -31 -4
-25 1 -35 28 -56 18 -13 36 -33 39 -44 4 -13 19 -21 45 -25 43 -7 54 -16 63
-54 4 -14 24 -46 46 -73 22 -26 42 -53 44 -60 4 -9 8 -8 16 3 16 23 13 38 -9
50 -12 6 -20 21 -20 35 0 13 -7 45 -16 71 -15 44 -15 48 1 56 37 21 38 59 3
126 -18 36 -42 68 -53 72 -12 4 -27 15 -34 24 -15 17 -61 22 -61 6 0 -5 -11
-12 -25 -16 -37 -9 -31 -25 25 -68 40 -30 50 -44 50 -67 0 -34 -4 -35 -53 -10
-62 32 -82 65 -68 112 11 38 10 44 -22 102 -31 56 -34 68 -30 122 5 60 5 60
-41 98 -56 46 -60 67 -11 67 35 0 47 13 21 23 -7 3 -43 3 -80 1 -53 -3 -75 0
-106 16 -44 22 -44 23 -53 13z"/>
<path d="M6665 16544 c-17 -55 -17 -55 11 -87 16 -18 38 -40 49 -49 22 -19 9
-30 -30 -25 -29 3 -30 -28 0 -41 14 -6 25 -17 25 -23 0 -7 7 -20 16 -30 9 -10
19 -33 23 -50 9 -44 31 -50 31 -10 0 33 27 53 61 44 20 -6 39 -44 39 -78 0
-28 32 -65 56 -65 22 0 75 -39 72 -54 -3 -11 40 -73 45 -65 2 2 11 16 20 32
17 27 59 38 72 18 3 -5 22 -15 42 -22 44 -14 72 -45 73 -79 0 -34 -8 -43 -62
-69 -54 -25 -58 -39 -25 -74 31 -33 54 -39 94 -26 36 12 46 46 18 69 -31 26
-12 50 41 50 21 0 24 -4 24 -39 0 -22 -4 -43 -10 -46 -17 -10 -11 -25 10 -25
13 0 20 7 20 20 0 13 10 24 25 30 33 12 32 24 -5 50 -16 12 -30 27 -30 34 0 8
-6 19 -14 25 -8 7 -12 20 -9 31 3 12 -2 22 -16 29 -15 9 -21 22 -22 49 -2 84
-30 110 -120 111 -20 1 -42 8 -49 16 -7 8 -21 15 -31 15 -10 0 -30 11 -45 25
-32 30 -41 31 -69 5 -16 -15 -29 -18 -58 -13 -43 7 -49 29 -12 43 29 11 31 27
11 73 -22 47 -53 80 -71 73 -9 -3 -23 -2 -33 3 -9 5 -24 12 -33 14 -19 6 -62
84 -53 98 3 6 22 9 43 7 30 -3 36 0 36 17 0 33 -50 51 -82 29 -24 -15 -27 -15
-38 0 -18 24 -21 21 -40 -40z m170 -198 c38 -31 23 -58 -20 -38 -14 7 -35 12
-45 12 -25 0 -26 25 -2 39 25 15 34 13 67 -13z"/>
<path d="M11745 16556 c-10 -15 -14 -33 -9 -50 4 -17 0 -45 -11 -72 -21 -56
-13 -274 11 -308 8 -11 14 -35 14 -54 0 -18 9 -50 20 -70 10 -20 22 -46 25
-57 6 -18 8 -18 18 -4 20 27 9 487 -12 527 -5 9 -12 38 -16 65 -8 53 -17 58
-40 23z"/>
<path d="M13198 16563 c12 -8 22 -22 22 -30 0 -8 25 -39 55 -70 35 -36 55 -65
55 -79 0 -18 10 -28 38 -41 20 -9 40 -19 45 -21 4 -2 7 6 7 17 0 12 5 30 12
40 16 26 -34 86 -78 95 -16 3 -46 22 -65 42 -34 35 -82 64 -103 63 -6 0 -1 -7
12 -16z"/>
<path d="M9880 16540 c-11 -21 -14 -60 -4 -60 32 0 84 26 84 42 0 10 -1 18 -3
18 -1 0 -17 4 -35 9 -27 8 -34 7 -42 -9z"/>
<path d="M5734 16506 c-7 -29 -56 -78 -74 -74 -7 2 -15 -3 -17 -9 -3 -8 5 -13
20 -13 16 0 34 -10 47 -27 18 -23 27 -26 65 -24 51 2 81 -10 111 -47 14 -17
27 -23 37 -19 25 10 20 42 -8 55 -14 6 -25 16 -25 22 0 5 -13 10 -29 10 -34 0
-73 42 -69 74 2 22 -28 76 -43 76 -5 0 -11 -11 -15 -24z"/>
<path d="M4871 16492 c-13 -24 -3 -80 14 -85 13 -3 18 53 7 83 -9 24 -9 24
-21 2z"/>
<path d="M8774 16495 c-4 -9 -2 -21 4 -27 16 -16 47 -5 47 17 0 26 -42 34 -51
10z"/>
<path d="M6500 16491 c0 -5 7 -12 16 -15 28 -11 54 -6 54 9 0 10 -11 15 -35
15 -19 0 -35 -4 -35 -9z"/>
<path d="M5258 16469 c-10 -6 -18 -14 -18 -19 0 -14 37 -12 46 1 10 17 -9 29
-28 18z"/>
<path d="M10970 16456 c0 -26 24 -51 40 -41 14 8 13 38 -2 53 -19 19 -38 14
-38 -12z"/>
<path d="M9190 16452 c0 -19 18 -42 32 -42 12 0 9 35 -4 48 -17 17 -28 15 -28
-6z"/>
<path d="M10310 16446 c0 -9 6 -16 13 -16 18 0 86 -52 87 -66 0 -6 -10 -18
-22 -27 -35 -23 -10 -47 28 -27 25 14 27 13 55 -20 36 -44 36 -63 2 -77 -28
-10 -28 -10 5 -23 31 -12 42 -33 22 -45 -18 -11 -11 -45 15 -69 26 -24 32 -50
15 -61 -18 -11 -11 -23 20 -34 17 -5 30 -15 30 -20 0 -6 9 -11 20 -11 21 0 28
24 10 35 -16 10 -12 22 11 28 27 7 81 -16 97 -42 7 -12 18 -21 25 -21 7 0 27
-16 46 -35 51 -55 54 -51 35 71 -4 32 -44 84 -64 84 -17 0 -11 -47 7 -54 13
-5 14 -9 4 -19 -10 -9 -15 -8 -25 6 -7 9 -17 17 -21 17 -4 0 -23 14 -42 30
-18 17 -45 30 -58 30 -15 0 -25 6 -25 14 0 8 -10 18 -22 22 -20 6 -20 8 -5 19
33 24 20 68 -50 174 -24 35 -43 68 -43 72 0 5 -7 9 -16 9 -8 0 -32 13 -52 29
-45 36 -102 51 -102 27z"/>
<path d="M8996 16366 c-6 -90 10 -146 44 -146 9 0 23 -9 33 -20 21 -25 59 -26
81 -1 23 26 17 65 -10 69 -15 2 -27 17 -39 50 -17 46 -79 132 -94 132 -5 0
-11 -38 -15 -84z"/>
<path d="M7677 16433 c-16 -15 -5 -39 23 -50 27 -10 30 -9 30 9 0 28 -37 57
-53 41z"/>
<path d="M4667 16423 c-14 -14 -6 -53 14 -67 19 -13 21 -21 15 -57 -6 -35 -4
-40 9 -35 15 5 25 -10 49 -74 3 -8 19 -37 35 -65 27 -48 30 -50 71 -50 35 0
44 -4 51 -22 8 -21 59 -35 59 -17 0 8 -48 46 -74 59 -12 6 -25 24 -30 40 -4
17 -12 37 -17 45 -5 8 -15 30 -23 48 -8 17 -20 32 -26 32 -12 0 -54 91 -65
139 -5 26 -11 31 -34 31 -15 0 -31 -3 -34 -7z"/>
<path d="M9941 16416 c-8 -10 -6 -17 8 -30 21 -19 41 -14 41 9 0 22 -36 37
-49 21z"/>
<path d="M5926 16411 c-9 -14 18 -61 35 -61 16 0 33 46 22 62 -6 11 -51 10
-57 -1z"/>
<path d="M7130 16406 c0 -8 7 -16 15 -20 10 -3 14 -16 13 -37 -4 -46 16 -46
32 0 10 33 11 43 0 56 -16 19 -60 20 -60 1z"/>
<path d="M11116 16394 c-10 -26 -7 -34 14 -34 15 0 20 7 20 25 0 28 -24 34
-34 9z"/>
<path d="M4358 16267 c-4 -171 -2 -180 48 -192 21 -5 41 -12 44 -15 3 -3 24
-6 47 -8 34 -2 43 1 48 18 9 29 -2 40 -41 40 -41 0 -43 13 -12 87 13 32 30 55
42 59 22 7 55 43 56 60 0 12 -45 24 -91 24 -16 0 -53 13 -83 30 -55 29 -55 29
-58 -103z"/>
<path d="M11550 16365 c-33 -18 -60 -25 -102 -25 -51 0 -59 -3 -77 -29 -24
-33 -21 -48 16 -75 25 -18 28 -19 55 -3 62 36 118 10 104 -47 -7 -30 11 -192
25 -220 6 -11 27 -36 46 -54 35 -33 35 -33 29 -145 -3 -62 -5 -150 -4 -197 3
-89 0 -344 -5 -515 -6 -194 -4 -184 -33 -196 -27 -10 -27 -10 10 -46 35 -35
36 -39 36 -110 0 -57 -3 -73 -14 -73 -8 0 -18 5 -21 11 -5 7 -15 4 -29 -9 -28
-26 -105 -36 -113 -15 -3 8 -26 35 -50 60 -23 25 -43 51 -43 59 0 22 29 28 49
10 9 -9 31 -21 48 -27 18 -6 39 -21 48 -35 18 -27 65 -34 65 -9 0 18 -44 90
-60 100 -6 4 -44 7 -83 7 -96 0 -107 3 -107 38 0 22 -6 30 -31 39 -45 15 -120
97 -149 161 -13 30 -32 64 -42 76 -10 11 -18 25 -18 31 0 13 -76 83 -91 83 -5
0 -17 16 -24 35 -8 19 -23 39 -33 44 -26 14 -47 78 -32 96 17 20 49 19 72 -2
12 -11 32 -16 54 -14 25 2 46 -6 79 -28 46 -31 69 -32 80 -3 5 12 -8 31 -44
64 -28 26 -51 55 -51 66 0 14 -8 21 -28 24 -37 5 -52 0 -52 -18 0 -23 -51 -18
-57 6 -9 32 -28 17 -25 -19 3 -29 1 -32 -20 -29 -21 3 -24 10 -29 68 -3 36 -8
72 -10 80 -3 12 5 14 44 12 58 -5 60 7 11 51 -21 17 -43 46 -50 63 -7 17 -20
36 -28 43 -10 8 -14 22 -10 35 4 16 -6 30 -40 59 -40 33 -51 37 -99 37 -41 0
-56 -4 -61 -16 -12 -30 -6 -44 18 -44 17 0 26 -7 30 -25 4 -14 11 -25 17 -25
6 0 8 -9 4 -21 -5 -14 -1 -27 13 -39 11 -11 22 -25 25 -32 4 -10 9 -9 17 5 15
23 37 22 45 -4 5 -14 0 -30 -12 -48 -16 -21 -18 -31 -10 -49 8 -17 7 -29 -1
-42 -22 -36 -26 -95 -7 -123 9 -14 14 -31 10 -36 -3 -6 4 -16 15 -23 12 -7 35
-42 53 -78 17 -36 53 -87 80 -113 45 -46 52 -67 21 -67 -10 0 -14 -14 -14 -55
0 -52 1 -55 25 -55 32 0 72 -38 81 -77 4 -15 12 -35 19 -43 6 -8 15 -23 18
-32 4 -10 15 -18 25 -18 29 0 94 -30 109 -49 10 -13 15 -14 32 -3 18 10 21 10
21 -2 0 -8 -4 -18 -10 -21 -20 -12 -9 -36 23 -50 18 -7 41 -23 51 -34 10 -11
39 -32 62 -46 35 -21 44 -31 44 -53 0 -16 12 -44 26 -63 14 -19 34 -51 45 -71
11 -21 26 -38 34 -38 22 0 18 21 -5 27 -16 4 -20 14 -20 47 0 56 21 86 49 69
11 -7 27 -10 36 -7 12 5 15 -3 15 -48 0 -61 -26 -126 -59 -146 -14 -8 -21 -23
-21 -42 0 -26 -3 -30 -29 -30 -23 0 -30 5 -33 23 -2 17 -10 22 -31 22 -23 0
-31 7 -42 32 -13 30 -28 41 -79 57 -18 6 -18 7 2 29 22 23 22 23 -13 57 -28
27 -34 40 -30 60 5 22 -1 29 -50 57 -54 31 -56 32 -68 13 -7 -12 -23 -20 -40
-20 -35 0 -32 -23 4 -30 40 -8 86 -38 92 -60 3 -11 13 -20 25 -20 35 0 45 -24
37 -90 -5 -41 -4 -60 4 -60 16 0 13 -46 -4 -60 -24 -20 -38 -1 -31 42 7 44 -7
78 -32 78 -9 0 -30 9 -47 20 -18 12 -38 17 -52 13 -33 -8 -125 83 -116 115 3
13 -1 30 -9 40 -8 9 -19 29 -26 45 -12 29 -46 47 -88 47 -29 0 -42 24 -24 45
10 13 9 19 -5 35 -23 25 -9 25 48 1 74 -32 77 -8 9 65 -47 52 -47 52 -99 47
-44 -5 -53 -3 -53 10 0 22 -16 30 -39 17 -13 -7 -22 -7 -26 0 -10 15 -36 12
-50 -7 -16 -21 -35 -9 -35 23 0 28 -7 30 -38 8 -34 -23 -28 -87 8 -92 14 -2
30 -8 37 -14 8 -6 30 0 69 18 57 27 57 27 75 3 10 -13 16 -31 12 -39 -31 -76
-24 -138 18 -161 11 -5 19 -17 19 -27 1 -40 17 -47 50 -19 44 38 60 32 73 -23
3 -14 22 -43 42 -64 43 -47 43 -55 5 -91 -35 -33 -56 -24 -66 31 -3 19 -8 34
-10 34 -12 0 -53 -33 -58 -46 -9 -24 45 -126 90 -170 14 -13 25 -40 30 -70 11
-80 19 -92 50 -86 26 5 27 4 20 -30 -6 -32 -3 -38 39 -77 45 -41 85 -54 85
-27 0 8 -4 18 -10 21 -5 3 -10 15 -10 26 0 15 7 19 34 19 45 0 60 -19 39 -49
-14 -21 -14 -24 0 -39 13 -12 19 -13 31 -3 16 13 28 6 109 -64 21 -19 37 -12
37 16 0 25 -70 130 -105 157 -14 11 -34 18 -44 15 -10 -3 -28 0 -40 6 -15 9
-27 9 -41 1 -14 -7 -20 -8 -20 0 0 6 -11 15 -24 21 -22 10 -86 96 -86 115 0 4
-6 15 -14 23 -7 9 -16 35 -19 58 -5 41 -5 41 32 47 20 3 52 8 72 11 25 5 39 2
48 -9 23 -27 7 -46 -33 -39 -41 6 -42 4 -20 -39 16 -30 16 -30 43 3 29 34 51
33 51 -2 0 -31 36 -59 75 -59 30 0 37 -5 55 -39 11 -22 26 -44 33 -48 18 -11
47 -59 47 -78 0 -8 9 -24 21 -36 11 -11 23 -36 26 -55 4 -23 18 -45 42 -66 59
-51 101 -117 101 -158 0 -24 7 -43 20 -55 28 -26 30 -195 3 -195 -35 0 -98 44
-101 70 -2 14 -11 34 -21 45 -9 11 -22 32 -29 48 -6 15 -18 27 -26 27 -26 0
-27 -17 -1 -34 33 -22 42 -61 20 -86 -26 -29 -30 -26 -61 34 -18 35 -36 57
-50 60 -15 4 -26 19 -35 52 -8 26 -24 54 -36 64 -20 16 -33 60 -18 60 28 0
112 -78 117 -108 5 -35 20 -27 35 18 16 46 12 57 -40 113 -35 37 -93 38 -127
2 -24 -26 -24 -26 -6 -60 11 -19 20 -57 21 -84 1 -39 8 -57 35 -90 32 -42 32
-42 -19 -35 -48 6 -51 5 -51 -15 0 -15 11 -26 38 -39 20 -9 57 -31 81 -49 24
-18 60 -35 80 -39 20 -3 46 -12 58 -20 29 -18 49 -18 57 1 8 21 26 19 59 -8
28 -22 28 -22 30 -157 0 -74 -3 -150 -7 -168 -5 -19 -4 -37 1 -45 14 -17 24
-93 17 -122 -8 -32 -23 -31 -53 0 -19 21 -30 24 -56 19 -19 -3 -35 -1 -39 5
-4 6 -23 11 -42 11 -20 0 -34 5 -35 13 -2 52 -10 77 -35 115 -15 23 -31 42
-35 42 -4 0 -10 12 -13 27 -7 27 -54 101 -87 139 -19 20 -18 21 11 42 17 13
30 26 30 30 0 18 -113 122 -133 122 -11 0 -28 6 -36 13 -38 32 -165 97 -189
97 -48 0 -56 -12 -41 -56 20 -59 26 -64 83 -63 111 1 110 1 130 -36 11 -19 23
-35 27 -35 11 0 89 -72 89 -83 0 -19 -67 -36 -101 -27 -19 6 -54 10 -79 10
-44 0 -44 0 -22 -16 14 -10 22 -24 20 -37 -1 -12 1 -28 5 -34 10 -15 63 -17
72 -3 21 34 135 -45 135 -93 0 -13 9 -32 20 -42 11 -10 20 -28 20 -41 0 -38
11 -54 47 -69 39 -17 42 -44 5 -60 -33 -15 -21 -30 29 -33 24 -2 47 -8 50 -14
4 -7 13 -7 27 1 41 22 89 13 124 -22 19 -18 41 -36 51 -40 21 -8 24 -83 3
-112 -21 -32 -28 -112 -11 -138 16 -24 39 -237 30 -268 -4 -11 -11 -19 -16
-19 -5 0 -9 -8 -9 -19 0 -17 -6 -18 -65 -13 -54 4 -66 2 -71 -12 -3 -9 -10
-13 -16 -10 -5 4 -3 13 6 22 12 15 13 21 1 50 -18 43 -43 51 -64 23 -9 -12
-20 -19 -24 -15 -11 11 -8 62 3 69 15 9 12 25 -5 25 -8 0 -15 -4 -15 -10 0 -5
-18 -10 -40 -10 -38 0 -40 2 -40 30 0 17 -3 30 -7 31 -5 0 -33 2 -63 3 -63 3
-84 10 -123 43 -37 30 -51 29 -76 -6 -26 -35 -69 -46 -93 -23 -24 25 -28 121
-5 134 12 6 15 16 11 34 -5 19 1 31 26 54 34 32 31 62 -9 75 -22 7 -31 32 -24
69 13 64 60 56 123 -21 24 -30 54 -60 67 -66 12 -5 25 -23 28 -38 5 -23 12
-29 32 -29 24 0 75 -42 85 -70 3 -9 15 -14 30 -13 18 2 31 -5 41 -20 8 -13 33
-29 55 -35 22 -7 43 -19 46 -27 8 -21 75 -20 83 1 3 8 -4 25 -15 37 -14 15
-19 30 -15 45 5 21 3 22 -34 16 -35 -5 -42 -3 -61 21 -30 37 -28 63 4 75 26
10 26 10 1 34 -31 29 -41 60 -28 84 15 29 -10 62 -33 43 -18 -15 -22 -56 -6
-66 13 -8 13 -62 0 -70 -22 -14 -137 52 -166 95 -17 26 -47 52 -73 65 -24 12
-47 28 -51 35 -6 9 -15 7 -38 -10 -34 -25 -56 -19 -92 27 -12 16 -34 30 -48
33 -22 4 -28 11 -30 37 -2 22 -16 43 -47 72 -51 47 -70 77 -55 86 41 25 -57
63 -118 45 -37 -10 -118 -64 -130 -86 -5 -8 -26 -18 -48 -21 -32 -4 -43 -11
-53 -35 -14 -32 -13 -35 21 -52 13 -7 23 -18 23 -25 0 -15 -7 -20 -73 -47 -37
-15 -102 -86 -102 -111 0 -4 -7 -15 -17 -25 -15 -17 -15 -18 0 -18 10 0 17 4
17 9 0 5 13 11 29 14 16 4 38 15 48 26 10 11 32 23 48 26 17 4 39 13 50 20 35
22 88 24 115 5 43 -30 65 -32 91 -10 24 21 24 21 -5 17 -17 -3 -36 -3 -43 0
-14 6 -18 43 -5 43 5 0 14 12 20 26 15 31 51 30 68 -3 16 -33 24 -18 24 44 0
49 2 53 24 53 30 0 40 -26 31 -80 -5 -33 -3 -40 14 -50 24 -12 27 -42 6 -60
-8 -7 -34 -10 -62 -8 -71 5 -67 -18 15 -69 57 -36 75 -43 120 -43 48 0 52 -2
52 -24 0 -31 -2 -32 -81 -40 -67 -7 -67 -7 -134 53 -70 62 -110 80 -142 63
-12 -7 -25 -7 -36 0 -40 22 -236 -38 -299 -91 -64 -54 -109 -104 -106 -118 4
-24 28 -28 34 -7 6 22 123 94 152 94 11 0 31 9 46 21 43 34 96 36 129 5 20
-19 26 -32 22 -49 -4 -15 -1 -28 9 -36 18 -15 21 -47 5 -56 -12 -8 -69 14 -69
26 0 5 -16 15 -36 24 -33 14 -38 13 -82 -9 -26 -13 -74 -27 -105 -31 -35 -5
-61 -13 -64 -21 -3 -8 -14 -14 -26 -14 -11 0 -33 -14 -47 -32 -26 -30 -28 -31
-37 -13 -8 15 -5 43 12 110 46 185 49 214 28 270 -16 44 -22 50 -50 53 -39 4
-73 -26 -73 -65 0 -16 6 -71 13 -123 8 -56 13 -183 12 -309 -1 -213 -1 -213
22 -224 29 -13 30 -47 3 -70 -22 -19 -28 -77 -7 -77 6 0 32 -18 55 -39 83 -75
205 -62 147 15 -8 10 -15 25 -15 33 0 8 -7 23 -17 33 -40 45 29 33 83 -14 35
-31 36 -34 32 -85 -3 -30 -12 -61 -21 -71 -20 -22 -80 -42 -125 -42 -19 0 -35
-7 -41 -17 -9 -17 -11 -17 -26 2 -9 11 -23 36 -32 55 -8 19 -25 44 -38 56 -12
11 -24 27 -27 35 -4 11 -8 11 -18 2 -11 -10 -10 -24 1 -75 7 -35 13 -120 13
-189 0 -126 0 -126 32 -147 21 -14 35 -33 39 -54 4 -18 20 -48 36 -66 31 -36
35 -46 44 -142 16 -164 16 -168 0 -174 -12 -4 -14 -14 -10 -38 3 -18 7 -57 9
-85 1 -29 5 -56 9 -59 14 -14 27 10 27 48 0 23 6 49 14 57 14 17 36 144 36
213 0 51 -18 117 -40 143 -18 22 -50 102 -50 126 0 9 -7 30 -16 47 -21 43 -15
67 16 67 24 0 25 -3 28 -72 2 -40 7 -73 11 -73 4 0 20 -11 35 -25 15 -14 30
-25 35 -25 4 0 18 -24 30 -52 20 -46 23 -64 18 -136 -4 -71 -2 -85 15 -107 19
-25 58 -34 58 -14 0 5 15 16 33 24 19 8 39 21 46 29 7 9 28 18 47 22 19 3 37
10 40 15 10 17 31 9 42 -17 7 -14 28 -32 47 -40 52 -21 39 -54 -22 -54 -31 0
-33 -2 -33 -35 0 -34 -23 -49 -44 -28 -4 4 -26 15 -50 24 -55 20 -105 7 -176
-47 -73 -55 -66 -99 8 -54 34 21 63 26 76 13 4 -5 24 -13 44 -18 33 -9 37 -15
40 -46 2 -26 -2 -38 -12 -42 -19 -7 -46 1 -46 14 0 14 -26 11 -39 -5 -9 -10
-20 -11 -49 -3 -41 11 -69 -5 -167 -96 -22 -20 -42 -37 -45 -37 -10 0 -50 80
-50 100 0 12 6 36 14 53 14 31 28 143 28 217 0 19 -8 55 -17 80 -10 25 -20 88
-24 140 -5 84 -8 95 -26 98 -11 2 -26 11 -32 20 -11 13 -13 8 -13 -31 0 -26
-5 -66 -12 -90 -9 -37 -9 -51 5 -86 9 -23 17 -63 17 -90 0 -35 5 -53 20 -66
21 -19 17 -40 -6 -31 -8 3 -21 -5 -31 -20 -15 -24 -15 -28 1 -61 15 -32 16
-44 5 -99 -10 -51 -10 -71 1 -102 9 -31 10 -51 2 -88 -15 -66 -13 -361 2 -373
15 -13 11 -353 -4 -381 -6 -11 -8 -31 -4 -46 5 -21 11 -24 30 -20 19 5 24 2
24 -13 0 -11 -7 -24 -16 -29 -13 -7 -15 -20 -10 -68 3 -32 6 -70 7 -84 0 -14
7 -32 14 -40 8 -8 18 -33 23 -55 6 -22 21 -60 36 -85 14 -25 34 -61 45 -81 41
-74 140 -169 227 -217 13 -7 24 -22 24 -32 0 -30 18 -33 42 -5 15 17 32 25 53
25 38 0 87 35 83 59 -2 11 -21 19 -63 26 -53 9 -60 13 -63 35 -5 50 -13 70
-31 87 -11 11 -21 35 -23 58 -3 34 -8 42 -38 57 -20 9 -47 14 -62 11 -23 -4
-28 -1 -33 20 -9 35 11 70 36 62 11 -4 19 -2 19 4 0 6 -6 11 -14 11 -18 0 -28
25 -20 54 6 25 -8 40 -47 49 -14 4 -40 24 -57 46 -32 40 -32 40 -15 78 17 35
22 38 63 41 77 5 113 -46 63 -92 -25 -24 -26 -27 -11 -42 14 -14 19 -14 41 -3
124 69 126 69 151 57 14 -6 28 -18 31 -27 6 -20 110 -91 132 -91 21 0 111 -69
118 -91 7 -21 52 -52 64 -44 5 3 7 23 4 45 -5 35 -3 41 18 50 23 10 23 10 -3
5 -36 -7 -110 31 -218 112 -25 19 -55 33 -71 33 -37 0 -53 30 -45 84 4 22 10
47 14 53 9 15 49 19 73 9 9 -4 25 1 38 11 19 16 21 22 10 51 -14 42 -7 60 31
73 27 10 30 15 30 54 0 37 -5 47 -29 64 -37 27 -39 26 -33 -4 12 -63 -30 -105
-103 -105 -35 0 -36 1 -33 32 2 27 9 34 35 41 36 11 54 47 46 90 -3 16 1 37
10 51 9 13 17 41 19 62 3 35 6 39 34 42 29 3 33 -1 53 -48 23 -53 43 -61 49
-19 6 37 21 49 65 49 33 0 46 -6 73 -36 33 -34 54 -38 54 -9 0 8 5 25 12 39
13 29 50 27 80 -5 10 -10 38 -21 63 -25 52 -7 68 -25 91 -101 8 -26 28 -61 44
-78 40 -40 75 -86 83 -108 9 -24 -33 -63 -74 -69 -27 -4 -31 -1 -49 40 -21 47
-28 49 -97 27 -17 -6 -24 -3 -29 11 -4 11 -18 28 -32 40 -26 21 -26 21 -4 40
32 27 29 60 -7 72 -16 6 -35 23 -43 38 -19 40 -38 42 -38 4 0 -23 5 -33 20
-37 11 -3 20 -12 20 -20 0 -13 -8 -14 -42 -9 -24 4 -62 10 -85 13 -35 5 -46
12 -62 39 -11 19 -24 34 -30 34 -26 0 -22 -84 6 -129 8 -12 12 -32 10 -43 -4
-14 7 -34 37 -67 24 -25 48 -56 55 -68 10 -20 51 -33 51 -16 0 13 -62 138 -77
155 -18 20 -9 38 19 38 23 0 88 -37 88 -50 0 -5 8 -17 19 -27 10 -10 21 -31
25 -46 9 -39 41 -71 62 -63 10 4 14 13 11 26 -15 59 52 55 77 -5 15 -36 15
-36 68 -29 29 4 59 11 65 16 13 10 33 -26 33 -58 0 -27 19 -52 51 -68 44 -22
58 -20 70 8 16 35 3 75 -31 94 -24 14 -29 24 -33 67 -2 27 -8 60 -12 72 -5 15
-1 27 14 42 26 26 61 27 94 1 33 -26 88 -26 112 0 24 26 12 52 -22 49 -32 -2
-53 4 -105 31 -26 14 -44 17 -60 12 -35 -13 -88 4 -88 29 0 18 5 20 71 17 51
-2 73 1 76 10 3 8 -5 12 -24 12 -21 0 -41 12 -69 40 -21 22 -46 40 -55 40 -9
0 -24 9 -35 21 -16 18 -25 19 -80 14 -37 -4 -69 -3 -80 3 -12 7 -25 7 -37 1
-14 -8 -25 -4 -48 15 -20 17 -43 26 -66 26 -42 0 -64 23 -57 60 11 53 -21 70
-131 73 -60 2 -60 2 -57 60 2 53 0 58 -24 69 -25 12 -25 12 -3 29 30 23 11 49
-36 49 -28 0 -33 -4 -39 -32 -3 -17 -11 -37 -17 -45 -17 -19 -63 -16 -84 7
-10 11 -28 20 -40 20 -13 0 -28 7 -35 16 -25 29 11 49 87 49 68 1 86 11 58 35
-27 22 -16 53 36 98 42 36 56 42 94 42 46 0 64 -13 46 -33 -12 -16 -2 -32 25
-41 14 -4 24 -18 28 -38 6 -31 6 -31 59 -24 28 4 66 9 83 12 25 5 32 1 42 -20
14 -32 24 -33 37 -4 10 22 86 51 111 41 7 -2 22 -19 33 -36 11 -18 28 -42 37
-55 15 -20 16 -28 5 -58 -11 -31 -11 -38 5 -55 17 -19 17 -20 -4 -35 -29 -20
-28 -42 3 -54 14 -5 25 -14 25 -20 0 -11 -39 -23 -60 -18 -8 2 -19 -7 -25 -19
-12 -28 -31 -29 -45 -3 -6 11 -17 20 -25 20 -8 0 -21 10 -29 21 -10 15 -20 19
-33 14 -15 -6 -11 -13 30 -51 51 -46 79 -54 103 -29 19 19 61 19 94 0 41 -23
110 -17 110 10 0 6 -9 20 -21 31 -13 12 -18 26 -15 40 4 13 0 27 -9 34 -8 6
-19 28 -26 48 -6 20 -16 42 -21 49 -15 19 0 33 36 33 32 0 106 -56 106 -80 0
-6 18 -21 40 -35 25 -16 40 -33 40 -46 0 -19 -1 -19 -33 5 -19 15 -39 26 -45
26 -20 0 -26 -49 -8 -69 21 -23 21 -67 -1 -75 -13 -6 -7 -16 35 -56 61 -58 74
-62 66 -20 -8 36 18 80 46 80 24 0 26 22 5 40 -18 15 -20 61 -3 78 20 20 -7
86 -53 123 -22 19 -59 52 -82 73 -107 101 -229 206 -240 207 -7 1 -24 0 -40
-1 -23 -1 -30 4 -42 34 -8 19 -15 46 -15 60 0 38 -101 150 -162 179 -48 24
-92 62 -85 74 4 6 20 13 37 16 39 8 38 23 -3 31 -18 3 -37 14 -42 24 -47 85
-70 101 -81 58 -7 -30 -49 -43 -73 -23 -9 8 -24 17 -33 20 -31 11 -52 55 -40
81 6 13 8 33 5 44 -2 11 0 23 6 26 16 10 13 42 -4 56 -9 8 -13 21 -9 32 8 28
-67 128 -96 128 -20 0 -9 30 15 43 26 13 26 13 5 32 -11 10 -20 23 -20 28 0
24 -47 80 -83 98 -66 34 -59 64 23 103 35 16 46 27 48 49 3 26 10 31 67 39 29
5 25 30 -7 46 -22 10 -28 22 -33 60 -4 26 -9 54 -11 64 -6 22 4 27 68 30 50 2
60 -1 94 -30 75 -63 101 -93 111 -127 19 -60 74 -135 92 -126 11 6 24 3 40
-10 26 -22 61 -25 79 -7 17 17 15 28 -5 28 -47 0 -123 80 -110 115 10 24 -29
191 -50 218 -19 25 -21 26 -26 7 -8 -29 -40 -24 -60 9 -27 47 8 95 53 71 11
-6 20 -7 20 -1 0 12 27 22 44 15 7 -3 18 -16 24 -30 9 -18 19 -24 43 -24 30 0
31 -1 17 -17 -24 -28 -22 -180 3 -193 24 -13 72 -13 86 1 17 17 54 4 93 -35
68 -67 80 -82 80 -100 0 -10 15 -33 33 -50 18 -17 36 -39 40 -48 11 -30 27
-20 27 16 0 33 21 66 41 66 5 0 9 5 9 10 0 6 -16 10 -35 10 -20 0 -37 5 -39
13 -1 6 -11 35 -20 62 -31 90 -31 85 1 85 30 0 43 -17 77 -102 14 -34 18 -37
45 -32 23 5 31 2 40 -15 7 -12 21 -21 31 -21 15 0 20 -7 20 -28 0 -26 41 -82
60 -82 5 0 13 8 19 18 9 16 11 16 38 0 15 -10 42 -24 60 -33 18 -8 37 -24 43
-34 16 -31 13 -184 -5 -207 -8 -10 -15 -28 -15 -39 0 -12 -5 -26 -12 -33 -10
-10 -8 -15 8 -27 16 -11 22 -29 27 -81 8 -81 0 -96 -46 -83 -48 14 -50 12 -43
-36 8 -49 1 -59 -14 -20 -7 18 -17 25 -36 25 -14 0 -24 -3 -22 -7 3 -5 10 -23
17 -40 7 -18 17 -33 22 -33 4 0 22 -14 39 -30 17 -16 35 -30 39 -30 30 0 50
-260 25 -320 -4 -8 -7 -38 -8 -65 -1 -41 -7 -59 -33 -92 -37 -46 -46 -101 -15
-84 24 13 42 -4 42 -37 0 -14 7 -30 16 -37 14 -10 16 -39 15 -220 -1 -114 -6
-216 -11 -226 -14 -25 -12 -97 2 -101 13 -5 15 -108 3 -128 -3 -5 -21 -10 -39
-10 -19 0 -39 -7 -46 -15 -7 -8 -18 -15 -24 -15 -7 0 -20 -6 -30 -13 -17 -13
-16 -15 20 -36 32 -19 42 -21 58 -11 52 33 91 -123 50 -202 -10 -20 -14 -42
-10 -62 26 -127 36 -246 27 -318 -2 -14 -27 -8 -72 15 -24 13 -56 27 -70 30
-15 4 -36 22 -48 39 -11 18 -27 42 -36 54 -8 11 -22 45 -30 75 -8 30 -17 64
-21 76 -8 29 36 54 61 33 30 -25 14 1 -24 39 -22 22 -48 41 -59 43 -25 4 -108
-60 -123 -95 -9 -22 -18 -28 -38 -26 -14 2 -36 -2 -47 -9 -18 -9 -24 -8 -38 7
-15 16 -15 19 4 36 29 26 23 60 -10 60 -19 0 -27 -7 -35 -32 -6 -18 -20 -45
-31 -60 -21 -28 -21 -28 2 -65 20 -31 21 -38 9 -48 -20 -17 -19 -28 9 -61 13
-15 27 -34 29 -41 4 -10 9 -8 17 5 7 11 23 17 45 17 19 0 37 5 41 11 7 11 -13
87 -27 103 -8 9 92 56 117 56 14 0 24 -32 24 -76 0 -17 9 -43 20 -57 23 -29
26 -53 7 -60 -26 -10 -8 -68 24 -79 16 -5 29 -14 29 -19 0 -5 18 -12 40 -15
22 -4 43 -11 46 -15 10 -16 24 -9 24 11 0 31 21 33 77 5 56 -26 67 -40 77 -95
9 -54 9 -461 -1 -471 -16 -16 -53 3 -60 30 -3 14 -23 45 -44 68 -35 39 -39 48
-39 97 0 55 0 55 35 62 19 3 35 9 35 13 0 15 -47 51 -93 71 -33 15 -47 27 -47
41 0 11 -6 22 -14 25 -7 3 -27 24 -45 47 -30 40 -123 89 -139 73 -8 -9 16 -56
29 -56 20 0 99 -85 99 -107 0 -12 9 -27 19 -32 10 -6 23 -28 28 -48 7 -28 14
-37 26 -35 23 4 39 -40 31 -88 -5 -32 -2 -45 17 -69 13 -17 34 -44 47 -61 13
-16 28 -30 33 -30 5 0 28 -18 51 -39 35 -34 42 -47 46 -90 2 -27 1 -62 -2 -76
-6 -25 -10 -26 -41 -21 -31 6 -35 4 -35 -13 0 -11 11 -28 25 -37 14 -9 25 -25
25 -36 0 -10 7 -30 16 -43 13 -20 14 -33 6 -65 -5 -22 -8 -48 -6 -58 3 -9 -4
-35 -15 -57 -19 -39 -19 -40 -1 -55 22 -18 32 -148 14 -171 -6 -8 -14 -34 -18
-58 -7 -48 -49 -126 -71 -135 -11 -4 -15 -21 -15 -60 0 -45 -3 -56 -19 -61
-11 -3 -22 -12 -25 -20 -7 -20 -29 -19 -73 5 -39 21 -83 27 -83 11 0 -22 58
-48 118 -54 46 -4 74 -12 102 -32 53 -36 70 -28 70 31 0 26 5 62 12 80 9 26 8
38 -5 67 -23 48 -21 66 7 77 33 12 56 48 56 87 0 52 19 84 49 81 32 -4 41 -55
17 -90 -9 -12 -16 -43 -16 -68 0 -27 -7 -56 -17 -70 -35 -50 -33 -253 3 -305
8 -11 14 -29 14 -40 0 -11 14 -33 31 -49 36 -34 49 -64 49 -111 0 -40 15 -53
29 -26 16 30 13 68 -9 111 -15 30 -20 60 -21 132 0 51 -4 136 -8 188 -4 60 -2
136 6 205 13 105 13 110 -7 137 -11 15 -25 39 -30 53 -5 14 -15 25 -22 25 -21
0 -70 59 -70 83 1 23 10 4528 10 4562 -1 37 -1 760 0 780 0 11 -1 520 -3 1132
-1 611 1 1117 5 1123 24 39 56 -59 40 -121 -6 -22 -8 -59 -5 -82 3 -23 8 -334
11 -692 5 -729 5 -677 -1 -805 -3 -52 -5 -111 -4 -130 2 -31 2 -74 -1 -182 -1
-18 -1 -71 -1 -118 0 -47 0 -101 0 -120 0 -19 2 -197 3 -395 2 -198 0 -367 -4
-377 -4 -9 -1 -34 7 -57 16 -47 11 -460 -6 -493 -6 -11 -7 -27 -3 -36 8 -18
11 -79 16 -332 2 -91 0 -177 -3 -192 -4 -15 -2 -46 5 -70 11 -36 11 -48 -2
-75 -11 -23 -13 -41 -6 -70 5 -21 7 -105 4 -186 -4 -111 -2 -154 8 -173 9 -17
10 -29 4 -37 -15 -17 -27 -260 -15 -282 7 -12 7 -27 0 -46 -8 -20 -7 -42 1
-80 11 -45 10 -54 -4 -70 -11 -12 -14 -24 -8 -36 6 -14 17 -438 15 -603 -2
-190 1 -430 6 -448 3 -12 0 -28 -6 -36 -7 -8 -9 -53 -6 -132 6 -154 6 -123 -1
-539 -7 -530 -7 -540 22 -582 13 -20 24 -42 24 -50 0 -8 6 -13 13 -10 13 4 15
558 16 3052 0 583 0 1069 0 1080 1 58 -4 1939 -8 3335 -1 165 -1 165 -36 215
-19 28 -39 62 -45 77 -6 14 -17 29 -24 31 -8 3 -17 22 -20 42 -7 34 -9 36 -37
30 -25 -6 -29 -4 -29 15 0 11 7 32 16 45 17 26 12 99 -8 111 -5 4 -8 39 -6 83
3 90 -7 97 -82 56z m-494 -1280 c4 -8 1 -22 -6 -30 -14 -17 -60 -21 -60 -5 0
6 4 10 9 10 5 0 11 9 14 20 6 23 35 27 43 5z m428 -830 c39 -26 62 -32 68 -15
2 7 15 6 37 -2 27 -10 35 -10 38 0 3 6 9 12 15 12 7 0 6 -5 -1 -14 -15 -18
-17 -84 -3 -98 25 -25 14 -64 -26 -91 -54 -38 -98 -45 -107 -18 -3 12 -15 26
-26 31 -13 7 -19 21 -19 45 0 18 -5 37 -11 41 -6 3 -20 27 -31 51 -19 42 -19
46 -2 64 22 24 24 24 68 -6z m140 -285 c21 -8 26 -16 26 -44 0 -42 -19 -58
-62 -54 -31 3 -33 6 -36 44 -3 39 4 48 45 63 1 1 13 -3 27 -9z m-1023 -1249
c16 -16 29 -33 29 -38 0 -5 9 -16 20 -26 26 -22 25 -30 -5 -63 -14 -15 -25
-31 -25 -35 0 -5 -9 -9 -20 -9 -18 0 -20 5 -14 39 8 49 -11 107 -36 114 -12 3
-20 14 -20 26 0 31 36 27 71 -8z m-263 -232 c71 -32 101 -72 102 -136 0 -38
-5 -57 -17 -68 -86 -76 -114 -81 -174 -33 -41 33 -49 61 -26 92 13 17 15 17
46 -2 18 -11 39 -29 47 -41 15 -20 15 -20 39 1 14 12 25 29 25 37 -1 26 -52
75 -97 95 -41 18 -45 18 -105 1 -35 -9 -71 -24 -81 -33 -13 -11 -20 -13 -28
-5 -8 8 -6 15 10 25 11 7 21 18 21 25 0 6 10 15 23 19 12 3 29 12 37 19 14 12
46 19 108 23 13 1 44 -8 70 -19z m-168 -158 c0 -5 -9 -13 -20 -16 -24 -8 -27
-25 -3 -25 44 0 69 -65 40 -104 -19 -26 -52 -13 -64 27 -5 17 -15 31 -21 30
-25 -6 -11 43 19 70 32 28 49 34 49 18z m166 -296 c3 -14 19 -35 36 -46 25
-18 29 -26 26 -62 -4 -51 -26 -60 -63 -23 -22 22 -25 34 -25 91 0 65 14 87 26
40z m-66 -220 c7 -8 17 -15 23 -15 5 0 25 -16 44 -36 33 -35 35 -36 53 -19 11
10 22 26 25 35 3 10 12 21 20 24 46 17 62 -42 19 -70 -24 -17 -25 -20 -19 -78
4 -34 14 -70 21 -81 21 -30 18 -112 -6 -142 -11 -14 -20 -35 -20 -46 0 -23
-50 -127 -62 -127 -4 0 -14 -13 -23 -30 -22 -42 -35 -37 -35 14 0 62 17 105
46 112 13 4 27 16 30 28 6 25 -11 76 -25 76 -5 0 -12 9 -16 20 -8 26 -75 100
-90 100 -22 0 -36 25 -23 38 22 22 54 12 96 -28 35 -34 43 -38 49 -24 7 20
-43 117 -67 130 -10 5 -46 28 -81 52 -39 26 -70 40 -81 36 -19 -6 -58 11 -58
26 0 8 28 12 136 18 18 1 37 -5 44 -13z m308 -427 c5 -7 12 -24 14 -38 2 -19
12 -26 48 -35 35 -9 46 -16 48 -34 3 -18 8 -22 25 -17 99 28 146 11 150 -54 4
-69 82 -150 142 -150 32 0 33 -26 3 -36 -13 -4 -34 -15 -47 -25 -13 -11 -39
-19 -59 -19 -20 0 -40 -7 -47 -16 -8 -12 -20 -15 -44 -9 -28 6 -32 11 -29 33
2 22 9 28 36 30 17 2 32 5 32 8 0 10 -34 59 -51 74 -19 17 -15 80 5 80 23 0
42 19 28 28 -23 15 -64 0 -81 -29 -9 -16 -21 -29 -27 -29 -30 0 -97 52 -133
101 -21 30 -53 62 -70 72 -29 17 -42 53 -24 70 11 12 70 8 81 -5z m-257 -631
c-6 -6 -11 -20 -11 -30 0 -17 5 -19 33 -14 17 3 40 8 50 12 13 5 17 2 17 -14
0 -11 13 -30 30 -42 16 -12 50 -49 75 -81 45 -57 46 -61 43 -121 -3 -54 -5
-62 -23 -62 -15 0 -22 10 -30 40 -14 58 -135 179 -188 189 -25 5 -44 3 -53 -5
-21 -17 -12 -33 21 -39 29 -5 55 -34 42 -47 -5 -4 -28 -6 -52 -5 -54 2 -61
-18 -13 -36 32 -12 32 -12 -2 -47 -42 -43 -84 -52 -148 -32 -26 9 -59 13 -74
10 -26 -5 -26 -5 -16 34 5 22 23 54 40 72 27 29 35 32 65 26 29 -5 38 -2 63
26 37 39 37 50 0 77 -46 34 -105 30 -125 -8 -9 -16 -22 -30 -30 -30 -7 0 -15
-12 -17 -27 -2 -14 -9 -28 -15 -31 -18 -5 -17 45 1 55 7 4 19 32 26 61 14 62
17 64 83 64 95 0 95 0 127 -47 17 -25 35 -45 40 -45 16 0 11 30 -5 36 -25 10
-17 41 18 73 25 25 33 28 35 15 2 -9 -1 -21 -7 -27z m379 -200 c1 -15 68 -47
98 -47 16 0 22 -6 22 -21 0 -19 -4 -21 -31 -15 -17 3 -44 6 -60 6 -25 0 -29 4
-29 26 0 15 -7 32 -17 39 -9 7 -13 17 -9 24 9 13 26 5 26 -12z m-329 -147 c32
-18 98 -130 90 -154 -19 -50 -93 -45 -99 6 -2 15 -14 33 -27 42 -28 18 -41 67
-25 95 12 23 31 26 61 11z m-100 -111 c79 -34 63 -92 -22 -82 -32 4 -38 9 -48
44 -19 64 -7 71 70 38z m-105 -135 c64 -15 89 -12 98 12 7 18 30 18 46 -1 12
-14 15 -14 31 1 29 26 54 14 52 -26 -4 -48 5 -80 21 -80 8 0 16 9 19 20 3 11
10 20 16 20 17 0 13 -28 -6 -38 -12 -7 -14 -17 -10 -41 6 -26 3 -31 -13 -31
-10 0 -22 5 -25 10 -3 6 -13 10 -21 10 -8 0 -33 19 -54 41 -40 42 -40 42 -101
36 -65 -6 -91 -19 -72 -38 14 -14 -27 -59 -53 -59 -26 0 -64 28 -64 46 0 8 14
20 30 25 36 13 36 11 5 57 -45 66 -38 69 101 36z m215 -180 c10 -5 18 -56 12
-71 -8 -20 -41 -16 -53 7 -6 11 -17 20 -24 20 -14 0 -26 21 -26 47 0 12 8 13
43 8 23 -4 45 -9 48 -11z m-283 -226 c-2 -18 -8 -22 -28 -20 -52 7 -51 42 1
42 26 0 30 -3 27 -22z m242 -352 c0 -31 -16 -42 -28 -19 -12 22 -5 43 14 43 8
0 14 -10 14 -24z"/>
<path d="M10160 16336 c0 -24 29 -80 58 -113 24 -27 37 -33 87 -39 33 -4 65
-11 72 -16 7 -6 18 -8 25 -5 8 4 5 8 -9 12 -12 4 -25 15 -28 24 -3 10 -34 39
-69 66 -36 27 -67 57 -69 67 -6 22 -67 26 -67 4z"/>
<path d="M5980 16322 c0 -13 12 -29 28 -38 15 -10 39 -31 53 -47 15 -17 31
-27 37 -23 15 9 16 66 2 66 -5 0 -10 9 -10 19 0 25 -8 30 -64 37 -42 6 -46 5
-46 -14z"/>
<path d="M7236 16301 c-8 -12 50 -51 77 -51 20 0 23 23 4 39 -21 17 -74 25
-81 12z"/>
<path d="M7748 16288 c-4 -32 -57 -37 -83 -8 -10 11 -31 20 -47 20 -29 0 -29
0 -1 -36 27 -34 30 -35 76 -30 43 5 49 3 56 -17 5 -13 29 -45 54 -72 36 -40
48 -48 58 -38 10 10 8 18 -12 40 -13 16 -28 30 -33 32 -32 13 -57 57 -51 87 3
18 1 35 -4 38 -5 4 -11 -4 -13 -16z"/>
<path d="M5713 16264 c-6 -16 2 -83 12 -92 9 -9 13 1 20 49 6 38 4 47 -9 52
-10 4 -19 1 -23 -9z"/>
<path d="M4968 16243 c-37 -9 -14 -61 63 -144 15 -16 32 -29 38 -29 6 0 22
-17 35 -38 13 -21 37 -47 52 -57 16 -10 41 -31 56 -47 29 -31 48 -36 48 -13 0
9 11 26 25 39 29 27 22 66 -15 86 -11 6 -20 17 -20 25 0 8 -9 15 -20 15 -23 0
-95 34 -105 50 -3 5 -17 10 -30 10 -25 0 -45 25 -45 57 0 15 -49 56 -62 52 -1
-1 -11 -3 -20 -6z"/>
<path d="M5816 16241 c-10 -16 5 -42 23 -39 21 4 21 42 -1 46 -9 2 -19 -1 -22
-7z"/>
<path d="M5945 16229 c-10 -16 4 -59 19 -59 19 0 28 28 16 51 -12 21 -25 25
-35 8z"/>
<path d="M2603 16213 c-4 -11 3 -23 20 -37 15 -12 27 -28 27 -36 0 -22 38 -80
52 -80 36 1 40 16 20 73 -10 32 -27 66 -37 77 -22 25 -73 27 -82 3z"/>
<path d="M13390 16191 c-14 -27 -13 -31 9 -31 17 0 31 18 31 41 0 17 -29 9
-40 -10z"/>
<path d="M6295 16189 c-7 -11 13 -69 24 -69 4 0 15 -6 25 -13 15 -11 17 -17 7
-35 -14 -27 -56 -29 -83 -5 -17 15 -18 15 -18 -3 0 -10 9 -30 19 -44 19 -24
20 -24 39 -7 22 20 26 17 36 -25 11 -49 33 -33 40 28 2 16 4 32 5 35 0 4 10 9
21 12 25 6 27 37 2 37 -20 0 -72 49 -72 68 0 17 -37 35 -45 21z"/>
<path d="M9000 16176 c0 -13 56 -75 111 -122 39 -34 52 1 22 55 -10 17 -21 31
-25 31 -5 0 -17 9 -28 20 -28 28 -80 38 -80 16z"/>
<path d="M8192 16138 c-7 -7 -12 -16 -12 -21 0 -4 -14 -22 -31 -40 -16 -18
-39 -48 -49 -67 -10 -19 -37 -55 -59 -80 -52 -56 -51 -62 7 -58 42 3 47 6 50
28 6 56 13 70 32 70 22 0 40 -28 40 -63 0 -13 9 -36 20 -49 11 -14 24 -38 30
-53 9 -24 14 -27 40 -21 23 4 32 1 41 -15 8 -17 17 -20 40 -15 26 5 29 3 35
-29 10 -54 0 -71 -31 -51 -34 22 -58 20 -101 -9 -20 -14 -40 -25 -45 -25 -15
0 -61 105 -61 137 2 43 -10 48 -52 19 -23 -15 -44 -22 -60 -19 -21 4 -26 1
-26 -14 0 -14 12 -22 45 -32 48 -14 56 -31 30 -65 -8 -11 -15 -27 -15 -37 0
-20 -48 -35 -63 -20 -6 6 -25 11 -41 11 -30 -1 -30 -1 -11 -15 39 -28 45 -36
45 -60 0 -15 -7 -26 -20 -30 -15 -5 -20 -15 -20 -44 0 -52 44 -85 100 -76 23
4 41 2 45 -4 12 -20 55 -13 55 9 0 27 -29 72 -42 64 -32 -20 -101 49 -76 74 9
9 16 8 29 -4 26 -23 42 -8 37 35 -6 45 9 101 26 101 7 0 39 -35 70 -77 50 -67
57 -82 53 -111 -6 -35 21 -95 48 -106 8 -3 15 -15 15 -26 0 -26 52 -80 76 -80
15 0 16 7 9 63 -8 70 -8 67 1 124 5 36 10 42 33 45 38 4 34 32 -6 36 -25 2
-33 -1 -33 -13 0 -28 -30 -29 -56 -1 -14 14 -31 26 -39 26 -17 0 -30 39 -18
51 12 12 62 -12 69 -33 7 -22 34 -24 34 -3 0 7 -7 18 -17 23 -29 17 -8 42 35
42 51 0 112 -53 112 -98 0 -29 29 -63 63 -75 9 -3 9 -10 1 -28 -10 -21 -6 -29
25 -66 40 -49 66 -54 83 -18 8 19 8 28 -2 40 -9 11 -10 19 -3 26 8 8 14 5 22
-9 6 -11 22 -22 35 -26 28 -7 44 -42 27 -59 -17 -17 -13 -45 9 -57 28 -15 14
-40 -24 -40 -28 -1 -29 -2 -11 -12 11 -7 34 -11 52 -10 34 3 53 -18 53 -57 0
-17 6 -21 30 -21 23 0 33 -6 42 -25 6 -13 19 -27 30 -30 15 -5 17 -13 12 -44
-5 -33 -3 -40 20 -54 31 -21 33 -52 7 -87 -16 -20 -22 -22 -35 -11 -40 33 -48
-21 -9 -63 27 -29 27 -29 41 -8 30 45 106 25 134 -34 16 -36 27 -46 60 -56 21
-6 43 -19 48 -27 11 -23 15 -109 6 -153 -4 -20 -5 -51 -1 -68 6 -29 9 -31 38
-25 63 13 101 38 109 73 10 36 21 39 66 16 27 -13 32 -21 32 -51 0 -45 33 -93
66 -93 19 0 24 5 24 25 0 14 -7 28 -16 32 -9 3 -14 13 -11 24 3 10 -5 27 -19
40 -12 12 -26 34 -29 49 -6 28 -77 94 -89 83 -3 -4 -6 -14 -6 -24 0 -20 -35
-43 -53 -36 -7 2 -20 29 -31 59 -18 54 -18 54 15 102 33 46 34 47 84 44 43 -3
50 -6 53 -26 2 -14 15 -27 36 -36 19 -8 37 -19 40 -25 10 -15 26 -4 26 18 0
10 -11 23 -25 29 -18 9 -25 19 -25 41 0 37 -8 42 -90 61 -65 15 -65 15 -65 60
0 45 0 45 38 48 31 3 37 0 37 -15 0 -11 6 -28 14 -38 13 -18 14 -18 25 3 14
27 37 28 50 4 5 -10 35 -38 66 -62 54 -43 56 -46 51 -83 -6 -33 -4 -38 19 -47
14 -5 25 -13 25 -17 0 -5 11 -21 24 -38 32 -40 56 -23 49 35 -5 38 -4 40 20
40 28 0 57 32 57 62 0 10 7 18 15 18 8 0 15 8 15 18 0 28 -42 62 -77 62 -17 0
-41 8 -54 18 -13 11 -44 22 -69 25 -25 3 -59 13 -75 22 -19 10 -51 15 -86 14
-43 -2 -61 2 -77 17 -12 10 -30 26 -39 34 -10 8 -27 27 -38 40 -26 33 -107 80
-137 80 -23 0 -57 19 -94 53 -52 48 -78 67 -90 67 -8 0 -14 4 -14 10 0 5 -15
16 -34 25 -35 17 -91 62 -129 103 -11 12 -28 22 -37 22 -8 0 -23 8 -32 18 -9
9 -37 35 -63 57 -81 70 -225 212 -225 221 0 5 -8 17 -17 26 -10 9 -36 38 -58
63 -22 26 -51 60 -65 76 -14 16 -36 43 -49 61 -13 18 -41 47 -62 63 -47 37
-53 75 -13 75 21 0 25 3 19 18 -4 9 -10 25 -12 35 -6 20 -24 22 -41 5z m773
-952 c17 -19 58 -49 93 -67 34 -18 62 -36 62 -40 0 -5 18 -13 39 -19 25 -6 42
-18 46 -30 3 -11 16 -27 29 -37 37 -30 76 -96 76 -128 0 -21 -9 -40 -29 -59
-30 -29 -30 -29 -63 -9 -26 15 -34 26 -36 56 -5 54 -48 88 -99 76 -55 -13 -63
-11 -63 11 0 11 -9 28 -20 37 -23 20 -27 72 -7 92 10 10 8 15 -10 29 -11 9
-24 32 -28 50 -6 29 -10 32 -45 32 -41 0 -55 11 -46 37 10 26 66 8 101 -31z"/>
<path d="M4608 16113 c-23 -11 -40 -43 -24 -43 2 0 11 -3 19 -6 10 -3 20 6 31
27 23 46 21 47 -26 22z"/>
<path d="M9291 16109 c-22 -18 -23 -21 -7 -37 9 -10 16 -35 16 -56 0 -30 4
-39 20 -43 11 -3 23 -16 26 -29 10 -41 94 -29 94 13 0 7 -9 13 -20 13 -14 0
-22 10 -30 39 -6 22 -21 46 -35 55 -16 10 -25 26 -25 41 0 30 -7 31 -39 4z"/>
<path d="M5780 16090 c0 -35 121 -103 150 -85 14 9 12 55 -2 59 -7 2 -29 9
-48 16 -54 19 -100 24 -100 10z"/>
<path d="M4286 16041 c-4 -5 -9 -30 -12 -55 -6 -38 -4 -46 9 -46 9 0 19 -6 24
-12 4 -7 9 -195 10 -418 2 -223 4 -430 6 -460 2 -31 -4 -76 -12 -102 -14 -43
-14 -50 2 -83 15 -31 16 -48 7 -125 -13 -116 -10 -474 5 -503 14 -28 43 -34
52 -10 3 10 17 32 30 49 27 36 29 59 8 68 -20 7 -20 46 0 46 9 0 26 -11 39
-25 13 -14 28 -25 33 -25 6 0 16 -7 23 -15 8 -9 29 -15 56 -15 56 0 110 -32
135 -81 19 -38 47 -54 85 -48 23 4 70 -20 107 -55 15 -14 33 -26 39 -26 6 0
16 -7 23 -17 7 -9 17 -13 22 -10 14 9 -24 87 -42 87 -23 0 -84 44 -85 60 0 9
-20 33 -45 53 -25 21 -51 53 -59 71 -14 33 -14 33 -70 28 -52 -4 -58 -3 -63
17 -6 25 -7 25 -33 9 -17 -11 -27 -9 -63 10 -24 13 -48 22 -53 21 -23 -4 -33
5 -58 52 -32 63 -34 105 -5 114 19 6 20 8 4 26 -14 14 -16 28 -11 63 6 38 4
47 -19 71 -40 44 -34 65 18 65 33 0 55 -8 85 -30 23 -16 46 -30 50 -30 5 0 17
-9 27 -20 9 -10 37 -22 61 -26 23 -3 58 -17 75 -30 18 -13 39 -24 46 -24 8 0
16 -7 19 -15 4 -9 19 -15 38 -15 38 0 76 -43 76 -86 0 -33 56 -122 83 -130 18
-6 66 -52 67 -64 0 -3 -14 -13 -30 -22 -17 -9 -30 -25 -30 -34 0 -30 43 -83
70 -86 19 -2 25 -9 25 -27 0 -23 28 -51 40 -40 3 4 6 34 8 68 2 60 1 62 -37
94 -35 30 -37 34 -22 46 14 12 16 26 10 81 -6 60 -4 69 13 81 37 26 40 119 4
119 -25 0 -130 79 -146 111 -9 16 -19 29 -24 29 -4 0 -8 19 -9 42 -2 48 -10
60 -23 37 -4 -9 -20 -24 -35 -33 -24 -17 -27 -17 -45 0 -14 12 -33 17 -62 16
-23 -2 -55 4 -71 13 -39 21 -63 19 -71 -5 -9 -29 -31 -25 -45 9 -12 29 -71 63
-115 66 -38 3 -42 5 -60 38 -12 23 -16 43 -11 62 6 25 10 27 46 23 46 -4 46
-5 21 36 -22 35 -32 127 -15 133 6 2 26 -10 44 -27 17 -16 36 -30 40 -30 4 0
22 -18 40 -39 28 -32 37 -37 51 -28 13 8 27 3 68 -26 36 -26 62 -37 86 -37 19
0 35 -5 35 -11 0 -5 15 -16 33 -24 39 -16 52 -30 61 -67 7 -32 14 -34 41 -14
19 14 18 15 -12 32 -41 24 -54 54 -47 108 7 49 -17 76 -68 76 -41 0 -79 18
-85 40 -3 11 -9 20 -13 20 -5 0 -12 9 -15 20 -7 24 -37 26 -55 5 -16 -20 -64
-19 -81 1 -7 9 -23 20 -36 25 -39 15 -29 41 12 33 60 -11 43 40 -32 93 -34 24
-43 21 -43 -14 0 -13 -7 -26 -16 -30 -31 -12 -47 53 -19 77 14 12 14 15 0 30
-11 12 -13 29 -9 62 9 67 16 73 76 72 65 0 117 -19 100 -36 -33 -33 1 -89 61
-98 25 -4 33 -10 35 -30 4 -34 61 -73 94 -65 19 5 29 1 42 -20 9 -14 28 -31
41 -37 14 -6 49 -43 80 -82 30 -39 60 -77 66 -83 17 -21 46 -15 84 18 43 38
45 53 5 46 -40 -8 -60 20 -53 74 6 39 4 42 -64 107 -38 37 -87 93 -108 125
-67 102 -182 174 -219 137 -15 -15 -56 -12 -62 5 -9 22 -90 20 -103 -2 -5 -10
-13 -15 -17 -11 -4 4 -1 14 5 22 10 12 7 19 -15 38 -75 62 -74 60 -74 153 0
85 0 85 38 85 61 0 80 9 87 42 7 29 -4 55 -12 31 -7 -20 -27 -15 -53 12 -13
14 -32 25 -42 25 -10 0 -23 9 -30 20 -13 20 -52 27 -62 11z m471 -563 c16 -17
38 -40 51 -51 12 -12 22 -24 22 -29 0 -14 -29 -9 -48 10 -10 9 -35 31 -55 49
-20 17 -37 36 -37 42 0 22 41 10 67 -21z m250 -933 c42 -74 24 -117 -27 -65
-32 32 -46 70 -36 96 10 26 39 11 63 -31z"/>
<path d="M6055 16030 c-21 -23 -13 -50 14 -50 11 0 22 -9 26 -20 7 -22 25 -26
42 -9 15 15 7 37 -25 72 -31 32 -34 33 -57 7z"/>
<path d="M11400 15998 c1 -24 36 -60 56 -56 30 5 29 42 -1 56 -34 15 -55 15
-55 0z"/>
<path d="M5825 15980 c-18 -19 -18 -21 1 -41 18 -20 18 -21 -4 -38 -22 -16
-22 -18 -7 -49 26 -51 49 -43 40 14 -6 40 -3 49 16 70 18 20 21 29 13 42 -16
25 -38 26 -59 2z"/>
<path d="M4624 15965 c-7 -18 21 -60 40 -60 8 0 25 -16 38 -35 13 -19 33 -37
43 -39 27 -5 45 -20 45 -40 0 -15 20 -38 77 -90 12 -11 24 -31 27 -43 17 -93
21 -102 50 -111 31 -10 85 -64 86 -85 0 -7 18 -35 40 -61 38 -45 62 -111 61
-166 -1 -31 20 -78 43 -97 17 -14 18 -19 7 -32 -12 -14 -10 -16 12 -16 24 0
25 2 20 38 -3 20 -17 66 -31 102 -35 92 -34 113 3 120 17 3 29 9 28 13 -2 4
-3 12 -3 17 0 6 -11 8 -25 4 -20 -5 -26 -1 -34 19 -6 14 -19 28 -31 32 -11 4
-32 25 -46 47 -24 37 -25 42 -9 57 15 15 17 14 35 -9 17 -23 20 -23 37 -9 10
9 26 19 36 22 9 4 17 13 17 20 0 15 -69 80 -140 131 -31 22 -50 45 -61 76 -38
102 -92 138 -87 58 3 -43 3 -43 -34 -46 -35 -3 -37 -1 -44 32 -8 46 -1 64 31
76 52 20 7 70 -62 70 -17 0 -35 5 -38 10 -10 16 -55 12 -55 -5 0 -8 -7 -15
-15 -15 -9 0 -18 7 -21 15 -8 19 -33 19 -40 0z"/>
<path d="M9025 15970 c-10 -16 6 -52 36 -83 31 -31 38 -57 15 -57 -32 0 -24
-20 15 -39 30 -15 53 -19 79 -15 22 4 47 1 60 -6 12 -6 24 -9 27 -6 11 11 -15
61 -33 65 -10 2 -33 15 -50 30 -17 14 -40 33 -50 42 -10 9 -30 30 -44 48 -25
32 -44 39 -55 21z"/>
<path d="M5333 15955 c-3 -9 -3 -18 0 -22 10 -10 37 6 37 22 0 20 -29 20 -37
0z"/>
<path d="M6305 15920 c-3 -5 -17 -10 -31 -10 -16 0 -24 -6 -24 -18 0 -27 20
-42 56 -42 19 0 34 -6 38 -15 8 -23 74 -51 87 -38 7 7 2 14 -20 21 -17 6 -31
18 -31 27 0 17 -50 85 -62 85 -4 0 -10 -4 -13 -10z"/>
<path d="M3188 15898 c-3 -7 -2 -22 2 -33 4 -11 3 -28 -1 -37 -6 -10 -5 -34 0
-58 19 -85 33 -57 29 55 -3 72 -17 107 -30 73z"/>
<path d="M5970 15890 c0 -9 31 -30 44 -30 3 0 6 9 6 20 0 15 -7 20 -25 20 -14
0 -25 -4 -25 -10z"/>
<path d="M4501 15839 c-14 -40 -8 -49 35 -49 41 0 46 25 11 58 -30 28 -33 28
-46 -9z"/>
<path d="M9277 15864 c-3 -4 0 -16 8 -28 8 -11 15 -28 15 -38 0 -9 9 -19 19
-23 11 -3 23 -15 26 -26 7 -20 39 -26 50 -8 4 6 -3 21 -15 34 -16 17 -21 31
-16 48 5 21 2 26 -22 31 -15 4 -34 9 -43 12 -8 2 -18 1 -22 -2z"/>
<path d="M10595 15860 c-9 -15 22 -60 40 -60 19 0 19 14 0 30 -8 7 -15 19 -15
26 0 16 -16 19 -25 4z"/>
<path d="M5238 15854 c-5 -4 -8 -17 -8 -30 0 -12 -7 -24 -15 -28 -19 -7 -20
-36 0 -36 8 0 19 9 25 20 12 23 10 87 -2 74z"/>
<path d="M9537 15822 c-15 -15 -27 -31 -27 -36 0 -9 53 -76 61 -76 3 0 5 31 5
70 -1 38 -4 70 -7 70 -3 0 -17 -13 -32 -28z"/>
<path d="M7941 15810 c-13 -11 -33 -20 -46 -20 -15 0 -31 -13 -49 -39 -15 -22
-34 -42 -42 -45 -8 -3 -14 -11 -14 -17 0 -14 -135 -149 -149 -149 -5 0 -16
-11 -25 -25 -9 -14 -23 -25 -31 -25 -8 0 -43 -22 -79 -50 -36 -27 -87 -61
-113 -76 -67 -39 -167 -107 -175 -120 -4 -7 -20 -15 -34 -18 -15 -4 -47 -23
-72 -42 -25 -18 -54 -34 -65 -34 -11 0 -28 -6 -36 -14 -9 -8 -52 -28 -96 -46
-44 -17 -87 -37 -95 -45 -8 -7 -29 -16 -46 -19 -17 -4 -67 -21 -110 -38 -43
-16 -102 -34 -131 -38 -29 -5 -62 -15 -75 -24 -12 -9 -40 -16 -61 -16 -21 0
-57 -8 -80 -19 -23 -10 -93 -24 -154 -31 -76 -9 -113 -18 -113 -26 0 -7 21
-36 46 -66 53 -62 94 -139 94 -176 0 -15 9 -45 21 -66 20 -38 21 -48 18 -610
-2 -680 -2 -526 0 -1188 1 -302 6 -548 11 -548 5 0 14 26 21 58 7 31 16 61 20
66 11 13 39 -49 50 -112 6 -37 16 -62 29 -72 28 -21 33 -93 6 -98 -12 -3 -26
5 -36 18 -20 27 -40 19 -40 -16 0 -21 8 -29 40 -41 31 -12 42 -23 48 -47 7
-28 13 -32 57 -37 37 -4 53 -12 73 -35 62 -74 74 -85 90 -82 22 4 29 38 8 38
-9 0 -16 4 -16 9 0 14 -62 71 -77 71 -6 0 -14 9 -18 19 -3 11 -12 22 -20 25
-8 3 -15 12 -15 19 0 8 -7 20 -15 27 -17 14 -21 115 -5 125 13 8 60 -5 60 -17
0 -17 62 -69 76 -64 10 4 12 15 7 38 -11 61 -17 65 -77 60 -51 -4 -56 -3 -65
19 -5 13 -21 35 -35 48 -14 14 -26 34 -26 45 0 11 -8 29 -18 40 -14 16 -22 49
-29 127 -6 58 -16 115 -23 126 -18 28 -6 53 25 53 31 0 49 -36 60 -120 3 -30
10 -68 15 -85 5 -16 14 -56 20 -87 13 -65 26 -73 42 -27 9 27 12 29 20 14 6
-9 7 -31 4 -49 -6 -33 21 -76 37 -59 14 14 7 213 -8 243 -25 48 -23 122 3 148
14 14 22 34 22 55 0 22 7 36 21 45 16 10 18 17 10 25 -8 8 -16 6 -30 -7 -25
-22 -41 -13 -41 23 0 21 -16 43 -67 93 -116 112 -173 201 -173 268 0 69 55 49
81 -28 15 -45 44 -97 84 -147 17 -22 34 -48 38 -58 4 -10 11 -15 17 -12 15 9
12 51 -5 65 -20 16 -20 87 1 107 17 18 15 64 -3 71 -9 2 -13 -9 -13 -38 0 -53
-29 -53 -44 0 -5 19 -15 38 -22 43 -7 4 -15 21 -19 38 -4 19 -16 34 -31 39
-13 5 -24 17 -24 27 0 10 -9 32 -21 48 -35 52 -38 69 -40 267 -2 155 1 204 15
248 12 43 14 67 7 105 -6 30 -5 73 1 114 5 36 11 82 13 101 2 19 8 71 13 115
7 65 5 94 -9 153 -10 43 -15 82 -10 94 7 19 -17 96 -42 136 -5 7 -10 42 -12
78 -4 62 -3 65 17 62 33 -5 46 -33 25 -56 -22 -24 -22 -52 1 -53 9 0 45 -2 79
-4 76 -5 80 2 57 107 -20 93 -46 121 -82 88 -13 -12 -18 -27 -15 -40 3 -11 0
-20 -6 -20 -6 0 -11 4 -11 9 0 13 -62 20 -82 10 -19 -10 -38 14 -38 50 0 26
25 33 114 30 59 -3 79 0 94 14 24 22 144 63 212 72 62 9 129 35 149 59 8 10
28 16 51 16 50 0 146 36 190 72 19 15 45 28 58 28 12 0 33 7 46 16 20 12 26
13 32 2 5 -7 8 -128 7 -268 -5 -866 -3 -2639 3 -2653 3 -9 10 -17 15 -17 4 0
23 -13 41 -30 51 -46 59 -52 138 -104 41 -27 80 -55 85 -60 6 -6 43 -34 83
-61 124 -86 212 -152 237 -179 14 -15 134 -96 143 -96 19 -1 62 -52 62 -74 0
-43 -82 -78 -96 -41 -3 8 -14 17 -25 20 -11 4 -23 22 -29 44 -11 41 -28 60
-78 85 -18 9 -45 28 -60 41 -118 105 -168 145 -177 145 -5 0 -42 22 -80 50
-184 131 -201 141 -245 134 -38 -6 -40 -5 -40 19 0 14 -4 29 -10 32 -5 3 -25
39 -45 80 -19 41 -40 75 -45 75 -6 0 -10 10 -10 23 0 12 -14 35 -29 50 -44 43
-59 86 -37 103 14 10 24 10 43 1 19 -9 26 -8 34 4 14 23 4 34 -32 34 -19 0
-45 4 -57 9 -19 6 -27 3 -38 -13 -12 -16 -26 -21 -60 -21 -65 0 -100 21 -111
67 -6 28 -15 39 -30 41 -33 5 -45 25 -33 56 14 37 54 50 105 36 41 -12 41 -12
38 -68 -5 -70 1 -79 55 -88 38 -6 42 -5 42 14 0 12 -13 30 -30 42 -40 28 -41
63 -2 54 15 -4 34 -13 44 -21 26 -23 30 2 5 38 -13 19 -26 42 -30 51 -3 10
-19 20 -34 24 -31 7 -63 31 -63 47 0 6 -8 29 -19 51 -10 23 -24 56 -31 74 -7
17 -15 32 -19 32 -9 0 -48 -77 -61 -122 -6 -20 -18 -42 -26 -48 -10 -9 -14
-35 -14 -91 0 -43 -4 -81 -10 -84 -20 -12 -10 -44 20 -65 21 -15 28 -26 21
-33 -32 -40 -67 -241 -44 -255 18 -12 33 -50 33 -81 0 -27 4 -31 26 -31 24 0
26 -3 20 -33 -5 -29 -2 -36 24 -55 16 -12 36 -22 44 -22 8 0 24 -10 36 -22 20
-22 20 -22 36 0 29 42 84 23 84 -30 0 -28 13 -37 25 -18 3 6 15 10 26 10 22 0
26 -28 4 -36 -29 -12 -17 -37 15 -32 23 4 30 1 30 -12 0 -9 15 -30 33 -47 69
-67 79 -81 80 -114 2 -31 0 -33 -39 -41 -54 -11 -94 4 -94 35 0 13 5 28 11 34
18 18 6 58 -19 61 -12 2 -30 16 -39 30 -25 41 -43 52 -83 52 -20 0 -41 5 -48
12 -9 9 -12 9 -12 0 0 -7 5 -12 11 -12 6 0 9 -15 7 -36 -2 -29 3 -41 23 -58
13 -11 37 -46 52 -77 31 -63 90 -109 139 -109 16 0 41 -9 55 -20 32 -25 52
-25 60 -2 4 9 11 22 15 27 5 6 15 19 22 30 13 19 16 19 63 4 42 -14 53 -14 68
-3 17 13 17 15 2 32 -18 20 -22 48 -8 56 19 12 70 -18 76 -46 7 -31 26 -36 45
-14 16 20 -25 76 -55 76 -35 0 -62 26 -49 47 19 31 156 21 162 -12 2 -11 13
-30 24 -42 26 -28 17 -52 -22 -59 -32 -7 -51 -25 -32 -32 6 -2 33 -23 59 -48
52 -50 63 -46 63 24 0 35 3 42 19 42 11 0 23 -5 27 -11 3 -6 17 -9 31 -6 20 4
28 -3 48 -44 14 -26 32 -52 41 -57 11 -6 14 -14 8 -23 -5 -8 -10 -30 -11 -49
-3 -60 -14 -97 -36 -118 -12 -11 -37 -34 -54 -50 -33 -31 -40 -55 -24 -81 8
-12 12 -12 26 2 9 10 20 17 24 17 5 0 20 19 36 43 15 23 49 59 76 80 28 21 54
48 58 60 5 13 27 35 49 50 23 14 59 46 82 69 37 39 41 47 36 79 -6 36 -5 37
32 44 40 7 111 44 132 69 7 9 38 28 70 42 34 15 76 45 103 74 26 27 61 57 79
66 62 32 157 96 162 110 3 8 11 14 17 14 7 0 21 7 31 17 21 19 52 38 90 55 14
6 31 22 37 35 18 40 56 30 77 -19 18 -41 19 -105 21 -1538 1 -822 4 -1516 8
-1542 5 -42 3 -48 -21 -67 -15 -12 -34 -21 -43 -21 -9 -1 -33 -7 -55 -15 -55
-19 -86 -4 -216 107 -8 7 -44 35 -80 62 -36 27 -72 55 -80 63 -35 33 -278 183
-298 183 -5 0 -15 6 -21 14 -7 8 -25 18 -41 21 -16 3 -34 13 -40 20 -7 8 -28
17 -49 21 -20 4 -47 13 -61 20 -37 20 -107 44 -171 59 -30 7 -65 17 -76 23
-27 15 -176 35 -273 38 -41 1 -86 3 -98 3 -15 1 -26 9 -29 21 -6 23 -18 26
-30 7 -8 -12 -106 -47 -134 -47 -8 0 -31 -9 -52 -20 -20 -11 -45 -20 -56 -20
-22 0 -144 -44 -183 -65 -14 -8 -33 -15 -41 -15 -8 0 -20 -7 -27 -15 -6 -8
-42 -29 -78 -46 -37 -18 -69 -35 -72 -38 -3 -4 -34 -21 -70 -40 -36 -18 -87
-54 -115 -78 -27 -25 -67 -61 -87 -79 -21 -19 -38 -40 -38 -47 0 -7 -22 -30
-50 -51 -34 -26 -57 -55 -75 -92 -14 -29 -39 -64 -55 -76 -32 -23 -42 -68 -15
-68 8 0 35 16 61 35 34 26 56 35 84 35 21 0 43 6 50 15 21 25 98 65 125 65 15
0 44 -10 65 -21 54 -31 72 -21 64 33 -14 88 -68 126 -113 79 -30 -32 -175
-114 -184 -104 -12 11 -8 42 6 50 7 4 23 25 36 46 12 20 28 37 34 37 6 0 27
16 47 35 36 35 72 44 117 30 17 -6 22 -2 27 23 4 16 17 39 29 50 12 12 27 26
32 32 22 23 85 58 116 65 19 4 50 20 70 36 25 19 48 29 72 29 26 0 36 5 40 20
3 11 13 22 24 26 10 3 46 16 81 30 42 16 83 24 125 24 38 0 71 6 83 14 57 41
391 12 567 -48 26 -9 55 -16 65 -16 10 0 34 -9 55 -20 20 -11 43 -20 51 -20 7
0 19 -6 25 -14 7 -8 27 -17 45 -20 19 -4 39 -13 45 -20 7 -8 24 -17 38 -21 15
-3 38 -15 51 -26 14 -10 28 -19 33 -19 9 0 219 -140 264 -177 17 -13 40 -32
52 -41 13 -9 33 -26 46 -37 13 -11 58 -48 101 -83 85 -70 94 -95 37 -100 -23
-2 -44 4 -69 22 -43 28 -159 139 -188 177 -11 15 -46 41 -77 59 -31 17 -71 45
-88 61 -17 16 -42 32 -55 35 -13 4 -28 11 -32 18 -4 6 -29 22 -57 35 -27 14
-59 32 -70 42 -11 9 -36 20 -55 24 -19 4 -51 16 -70 26 -63 34 -79 25 -56 -32
12 -29 -19 -49 -54 -36 -35 13 -49 4 -66 -46 -14 -41 -54 -48 -95 -18 -16 12
-33 21 -39 21 -5 0 -10 5 -10 11 0 18 -64 89 -82 89 -9 0 -21 13 -26 29 -6 17
-24 37 -41 45 -17 9 -35 26 -42 37 -9 18 -16 20 -42 13 -18 -4 -69 -8 -114 -9
-46 -1 -86 -4 -89 -8 -4 -3 7 -23 23 -44 16 -21 42 -63 58 -93 15 -30 34 -66
42 -80 7 -14 13 -36 13 -50 0 -16 12 -34 34 -52 19 -15 40 -43 46 -63 10 -29
16 -35 41 -35 29 0 38 13 18 25 -5 4 -14 18 -19 31 -5 13 -15 24 -22 24 -8 0
-18 23 -25 60 -7 38 -21 72 -38 92 -22 26 -26 38 -21 69 5 34 4 38 -16 41 -30
4 -30 32 0 36 12 2 22 -1 22 -7 0 -6 16 -17 35 -25 19 -8 35 -19 35 -25 0 -5
12 -16 27 -23 19 -9 28 -21 28 -38 0 -19 9 -28 40 -40 71 -28 115 -60 115 -84
0 -30 -29 -88 -52 -104 -10 -7 -18 -19 -18 -26 0 -8 -10 -16 -21 -19 -18 -5
-20 -11 -14 -34 3 -15 12 -35 19 -43 7 -8 16 -23 19 -33 4 -9 22 -24 40 -33
32 -15 36 -15 61 1 30 20 35 45 8 45 -11 0 -27 9 -36 19 -10 11 -28 21 -40 23
-33 5 -35 48 -2 48 13 0 36 4 51 10 19 7 34 6 56 -5 29 -16 29 -16 29 23 0 21
-5 43 -11 49 -7 7 -9 18 -6 26 7 18 112 30 155 18 22 -7 36 -5 51 6 46 32 111
-15 111 -79 0 -12 16 -40 35 -64 19 -23 35 -45 35 -49 0 -12 95 -105 107 -105
8 0 9 9 2 32 -5 18 -9 47 -9 63 0 17 -6 37 -12 44 -19 19 18 43 54 36 27 -6
68 8 68 25 0 5 -17 10 -37 12 -33 3 -38 7 -41 31 -5 39 19 43 72 12 48 -28 66
-68 51 -114 -11 -36 22 -72 59 -66 25 5 36 2 51 -15 11 -12 30 -26 43 -31 16
-6 22 -17 22 -40 0 -18 7 -40 16 -50 24 -27 11 -84 -24 -106 -15 -10 -45 -31
-67 -48 -22 -16 -49 -35 -60 -41 -12 -7 -20 -22 -21 -40 -1 -51 -3 -54 -54
-103 -27 -26 -50 -55 -50 -63 0 -21 -31 -82 -47 -91 -14 -9 -18 -77 -5 -77 24
0 90 72 96 105 4 19 15 40 26 48 10 7 22 26 26 42 7 27 171 209 234 259 14 11
46 41 71 67 25 26 56 50 68 54 11 3 21 10 21 15 0 5 18 19 40 30 23 12 58 36
78 54 20 18 62 49 92 69 30 20 75 50 100 67 84 57 185 120 194 120 5 0 59 25
120 55 103 50 246 105 275 105 7 0 31 8 54 19 26 11 79 21 142 26 54 3 107 11
116 16 10 5 42 9 71 9 44 -1 59 -6 88 -31 47 -40 36 -45 -123 -52 -96 -4 -148
-11 -189 -26 -32 -12 -67 -21 -78 -21 -12 0 -30 -5 -40 -10 -11 -6 -43 -15
-72 -20 -28 -6 -59 -16 -67 -24 -9 -8 -32 -18 -51 -24 -19 -5 -55 -22 -80 -36
-25 -14 -56 -30 -70 -36 -14 -5 -32 -15 -40 -20 -8 -6 -33 -19 -55 -30 -122
-61 -220 -128 -294 -199 -34 -35 -70 -61 -82 -61 -30 0 -59 -18 -105 -64 -22
-22 -56 -54 -75 -71 -19 -16 -59 -52 -90 -80 -31 -27 -83 -81 -114 -120 -32
-38 -67 -77 -78 -86 -27 -22 -13 -41 26 -37 30 3 32 1 29 -27 -3 -30 -51 -85
-75 -85 -11 0 -47 -72 -47 -94 0 -5 -6 -17 -14 -25 -39 -45 -132 -252 -146
-328 -16 -90 -14 -104 14 -97 13 3 27 1 30 -5 11 -17 43 -13 50 5 4 9 0 24 -9
34 -10 11 -15 37 -15 78 0 61 0 62 45 94 32 24 44 40 45 59 0 14 10 41 23 60
12 19 42 73 65 122 24 48 54 94 67 103 38 25 112 9 186 -39 34 -22 78 -43 97
-46 30 -5 37 -11 44 -39 10 -37 42 -45 51 -11 10 36 -9 66 -50 79 -21 7 -52
25 -69 40 -17 15 -52 37 -78 50 -66 31 -82 59 -61 100 22 43 56 57 86 36 13
-9 32 -16 42 -16 25 0 76 -43 98 -83 43 -76 59 -114 59 -139 0 -48 66 -64 113
-28 14 11 37 41 51 66 23 40 24 48 11 61 -8 8 -15 21 -15 29 0 9 -13 29 -30
45 -29 30 -29 30 -36 5 -8 -33 16 -79 46 -87 28 -8 26 -10 -10 -15 -79 -12
-85 -10 -88 19 -2 16 -16 47 -32 70 -25 37 -27 44 -14 58 14 15 11 19 -29 38
-24 11 -60 21 -80 21 -27 0 -39 6 -47 21 -14 25 2 45 68 91 47 33 69 31 74 -4
2 -17 12 -25 40 -32 46 -11 57 -3 33 24 -11 12 -15 28 -12 42 4 14 0 29 -10
40 -9 10 -13 21 -9 25 10 11 79 33 102 33 12 0 33 9 47 20 42 33 155 17 218
-32 20 -15 42 -28 48 -28 5 0 15 -9 21 -20 13 -24 -3 -60 -25 -60 -30 0 -14
-18 21 -25 32 -6 34 -8 19 -19 -26 -18 -12 -33 38 -40 62 -9 81 -1 62 28 -14
21 -10 66 6 66 5 0 15 -14 24 -30 19 -37 23 -37 36 -3 29 76 -32 153 -174 220
-27 13 -67 23 -88 23 -44 0 -139 45 -139 65 0 15 22 25 54 25 12 0 30 10 40
21 17 20 25 21 94 15 85 -7 106 2 92 38 -11 30 2 49 31 44 19 -2 25 -10 27
-36 2 -24 10 -36 28 -44 36 -17 24 -32 -32 -39 -27 -4 -60 -10 -72 -13 -23 -8
-23 -8 2 -27 19 -15 40 -19 106 -19 78 0 145 -14 217 -46 36 -16 44 -31 31
-58 -9 -16 -17 -17 -66 -11 -32 4 -70 13 -86 21 -16 8 -42 14 -57 14 -28 0
-28 0 16 -46 25 -25 66 -57 92 -71 27 -14 52 -31 56 -39 4 -8 13 -14 19 -14
19 0 68 -52 68 -72 0 -10 11 -24 25 -30 14 -6 25 -18 25 -27 0 -17 73 -19 145
-5 57 11 57 12 34 44 -25 33 -59 39 -79 15 -17 -20 -22 -19 -69 12 -52 34 -62
66 -30 92 23 18 23 18 1 30 -44 24 -24 51 43 61 26 4 39 11 37 19 -1 7 4 24
13 37 8 13 15 35 15 48 0 20 7 27 31 33 24 7 34 17 44 46 7 21 20 46 29 56 9
10 16 22 16 28 0 18 69 73 91 73 11 0 31 -11 45 -25 18 -18 36 -25 63 -25 33
0 40 -4 45 -25 3 -13 22 -40 41 -59 19 -20 35 -42 35 -51 0 -8 4 -15 9 -15 17
0 30 26 24 48 -4 16 1 28 13 38 15 12 16 17 6 21 -8 3 -36 25 -63 49 -27 24
-56 44 -65 44 -13 0 -34 37 -34 60 0 5 12 23 28 40 15 16 39 44 55 60 38 44
36 67 -10 80 -21 6 -47 17 -57 25 -11 8 -29 15 -40 15 -37 1 -94 45 -144 111
-55 72 -132 211 -132 237 0 9 -8 31 -17 47 -9 17 -20 62 -24 100 -4 39 -12 99
-18 135 -5 36 -10 232 -11 435 -2 436 -2 431 0 470 3 53 3 739 -1 1038 -1 138
2 232 8 238 6 6 6 32 1 67 -12 85 -12 852 1 883 5 15 7 30 3 34 -8 8 -9 94
-11 840 0 458 2 547 17 655 16 111 20 125 37 125 16 0 21 -8 23 -35 4 -36 21
-66 23 -40 3 39 -4 77 -17 91 -19 21 -18 83 1 99 8 7 15 18 15 25 0 7 10 24
21 39 42 53 -11 60 -71 9 -25 -20 -30 -32 -30 -68 0 -23 -9 -62 -20 -86 -11
-24 -20 -58 -20 -74 0 -17 -9 -58 -21 -90 -21 -60 -21 -66 -21 -1185 0 -619 1
-1224 2 -1345 1 -180 -6 -1501 -9 -1570 -2 -46 9 -477 13 -557 3 -47 12 -106
20 -130 8 -23 18 -61 22 -83 4 -22 13 -49 20 -60 8 -11 14 -27 14 -36 0 -9 8
-27 19 -40 10 -13 22 -39 25 -56 4 -18 12 -35 17 -38 11 -7 12 -45 1 -45 -10
0 -61 50 -88 87 -12 15 -31 60 -44 98 -13 39 -29 79 -36 90 -8 11 -14 29 -14
41 0 11 -10 36 -23 55 -23 34 -23 34 -4 60 15 22 17 31 8 48 -14 25 -41 27
-87 5 -35 -17 -35 -17 -64 16 -53 60 -31 110 33 75 20 -10 48 -15 72 -13 39 3
40 4 43 44 3 41 3 41 -52 46 -30 2 -61 10 -69 17 -20 16 -10 50 20 64 20 9 28
6 58 -23 34 -33 35 -33 35 -10 0 36 -39 110 -58 110 -37 0 -61 -13 -66 -36 -7
-28 -36 -33 -36 -6 0 22 11 37 33 45 25 9 17 41 -11 45 -12 2 -26 11 -32 21
-5 11 -26 21 -50 25 -43 7 -51 28 -14 34 80 12 87 33 17 52 -27 7 -56 20 -65
28 -22 19 -52 8 -43 -16 3 -9 9 -29 12 -44 3 -15 14 -30 24 -33 25 -8 25 -51
1 -64 -20 -11 -42 2 -42 25 0 14 -54 29 -70 19 -5 -3 -10 -13 -10 -21 0 -18
-24 -18 -40 1 -18 22 -23 19 -44 -20 -16 -30 -17 -38 -6 -67 20 -49 29 -58 65
-58 19 0 39 -8 50 -20 10 -11 24 -20 32 -20 16 0 17 -47 1 -52 -8 -3 -13 -30
-15 -74 -1 -38 -3 -82 -5 -99 -2 -22 2 -32 20 -41 55 -27 41 -64 -23 -64 -29
0 -34 4 -40 30 -3 16 -15 32 -25 35 -11 4 -27 27 -38 58 -13 34 -26 53 -38 55
-53 8 -91 35 -110 75 -27 60 -56 63 -52 5 3 -41 5 -43 36 -46 31 -3 33 -6 30
-35 -2 -26 -7 -32 -27 -32 -29 0 -50 -61 -58 -161 -7 -93 40 -157 131 -180 16
-4 26 -13 26 -24 0 -10 7 -20 15 -23 8 -4 21 -21 28 -40 22 -52 135 -81 191
-49 13 7 -16 22 -45 22 -15 0 -32 6 -39 14 -6 8 -21 16 -33 18 -30 4 -48 75
-23 94 9 6 25 10 36 7 10 -3 27 4 39 16 22 22 85 29 96 11 3 -5 14 -10 23 -10
20 0 86 -59 126 -112 28 -38 72 -58 127 -58 37 0 47 -29 19 -52 -23 -19 -53
-22 -205 -23 -90 0 -90 0 -110 -40 -22 -42 -43 -52 -108 -54 -21 -1 -50 -9
-65 -19 -86 -59 -111 -72 -139 -72 -25 0 -36 -7 -52 -34 -23 -37 -61 -66 -86
-66 -27 0 -34 44 -33 192 0 79 -3 170 -6 203 -8 73 -1 87 39 77 24 -7 31 -15
35 -43 6 -43 52 -71 77 -46 22 22 10 43 -26 50 -17 4 -34 15 -38 24 -3 10 -21
35 -40 56 -23 26 -33 47 -33 70 0 17 -4 48 -10 67 -8 27 -6 42 8 71 18 35 18
37 -1 60 -15 19 -18 32 -12 69 4 25 8 74 9 110 1 65 1 65 36 71 35 5 35 5 3
25 -37 22 -43 55 -17 92 13 19 13 23 0 28 -11 4 -14 25 -14 97 1 51 -3 109 -7
130 -5 25 -3 46 5 62 8 15 11 67 10 161 -3 135 -5 398 -5 595 1 63 5 106 14
123 11 20 12 28 2 40 -7 8 -10 24 -6 36 4 12 2 26 -3 33 -24 32 -35 110 -28
210 4 56 7 114 6 130 -7 196 1 316 22 323 41 13 81 -30 48 -51 -17 -11 -11
-35 9 -35 21 0 36 82 20 112 -5 9 -9 28 -9 42 0 16 -8 30 -22 37 -13 6 -25 13
-27 15 -6 5 -32 150 -37 209 -3 28 0 70 6 95 11 41 23 154 20 190 0 8 -3 69
-5 135 -3 66 -8 140 -12 165 -5 25 -8 138 -8 251 0 180 3 210 19 247 18 40 18
44 1 81 -16 37 -22 177 -14 346 1 22 1 103 -1 180 -3 158 5 234 28 252 14 12
13 15 -6 33 -28 26 -29 74 -2 118 27 43 25 66 -5 86 -27 18 -45 14 -45 -10 0
-36 -141 0 -208 54 -30 23 -61 42 -70 42 -30 0 -126 41 -152 65 -32 29 -63 45
-88 45 -11 0 -48 30 -85 70 -36 39 -71 70 -77 70 -25 0 -103 76 -122 119 -33
77 -97 139 -194 185 -43 21 -51 34 -56 95 -5 48 -10 59 -48 94 -27 25 -38 43
-32 49 6 6 6 20 -1 38 -12 32 11 70 43 70 23 0 86 68 105 113 8 20 22 37 30
37 8 0 15 7 15 15 0 19 0 19 -29 -5z m-271 -345 c0 -14 8 -29 20 -35 11 -6 20
-15 20 -21 0 -13 31 -54 83 -110 20 -22 37 -43 37 -45 0 -14 228 -248 297
-304 48 -40 73 -59 128 -100 22 -16 45 -34 51 -39 6 -5 37 -24 68 -41 31 -18
56 -36 56 -40 0 -5 15 -12 33 -15 17 -4 40 -16 50 -26 10 -11 26 -19 36 -19
10 0 24 -6 30 -14 7 -8 28 -17 47 -21 19 -3 37 -12 40 -20 3 -8 22 -17 42 -21
21 -4 44 -12 52 -19 8 -8 29 -17 45 -21 67 -16 62 84 64 -1171 1 -1113 2
-1138 21 -1178 30 -62 27 -69 -22 -61 -86 15 -130 4 -160 -40 -13 -19 -31 -37
-41 -40 -9 -3 -22 -14 -27 -25 -6 -10 -17 -19 -24 -19 -8 0 -19 -6 -25 -14 -6
-7 -26 -16 -44 -20 -17 -4 -48 -20 -69 -36 -20 -17 -42 -30 -48 -30 -6 0 -21
-10 -33 -23 -32 -31 -67 -53 -102 -61 -16 -4 -43 -23 -60 -41 -34 -38 -208
-125 -249 -125 -40 0 -101 35 -208 119 -53 42 -122 94 -153 116 -30 22 -66 50
-81 63 -14 12 -29 22 -33 22 -5 0 -42 26 -84 58 -42 31 -101 72 -131 91 -30
18 -61 40 -68 48 -14 17 -24 141 -20 263 1 30 1 498 0 1040 0 542 0 1112 1
1268 2 239 0 290 -14 332 -17 50 -13 90 8 90 12 0 90 51 95 63 2 4 18 15 35
24 18 8 50 30 72 47 40 32 61 45 105 68 14 7 33 21 42 31 10 9 22 17 26 17 4
0 13 14 19 30 15 41 73 45 73 5z m-1322 -2665 c12 -18 41 -42 63 -52 27 -12
44 -28 52 -48 6 -16 20 -33 30 -36 16 -5 18 -13 14 -47 -3 -23 -13 -46 -21
-53 -9 -6 -16 -19 -16 -28 0 -20 -27 -33 -41 -19 -7 7 -7 29 0 68 9 47 8 59
-4 72 -8 8 -15 19 -15 24 0 5 -7 9 -15 9 -11 0 -15 -11 -15 -35 0 -40 -17 -52
-49 -35 -14 7 -21 21 -21 43 -1 18 -7 43 -15 57 -17 30 -19 59 -5 95 12 33 28
29 58 -15z m539 -468 c57 -29 65 -48 32 -78 -11 -10 -18 -26 -16 -35 3 -9 -4
-24 -15 -33 -20 -17 -20 -37 -1 -43 6 -2 24 8 41 22 34 28 47 21 38 -23 -3
-15 -2 -34 3 -41 6 -9 6 -22 0 -33 -12 -22 -29 -24 -29 -4 0 22 -17 28 -40 16
-18 -10 -22 -7 -31 19 -8 23 -17 31 -34 31 -58 0 -105 45 -105 100 0 13 -9 24
-25 30 -32 12 -34 61 -5 90 27 27 115 18 187 -18z m-171 -198 c9 -35 -18 -63
-40 -44 -16 13 -22 51 -9 63 16 16 43 6 49 -19z m390 -126 c36 -18 45 -27 50
-57 10 -61 14 -70 37 -77 54 -17 108 -100 78 -119 -16 -9 -41 -66 -41 -92 0
-17 -6 -23 -25 -24 -14 -1 -30 -2 -37 -3 -21 -2 -19 21 2 27 27 7 20 39 -18
80 -20 21 -23 30 -14 39 19 19 15 76 -7 87 -10 6 -24 25 -30 42 -16 46 -46 36
-46 -15 0 -25 -5 -41 -14 -44 -11 -4 -13 5 -9 43 6 45 4 48 -23 58 -32 13 -38
37 -13 61 21 22 59 20 110 -6z m2232 -1832 c5 -24 -10 -38 -31 -30 -20 7 -22
25 -5 42 16 16 32 10 36 -12z m136 -1 c8 -8 18 -25 22 -38 4 -12 14 -27 22
-33 25 -19 -6 -104 -39 -104 -38 0 -98 162 -67 181 20 13 45 11 62 -6z m17
-212 c17 -44 22 -108 10 -131 -9 -17 -17 -19 -53 -15 -52 7 -81 29 -58 43 8 5
25 7 36 4 31 -8 39 14 15 40 -20 21 -28 65 -14 79 17 18 54 6 64 -20z m-330
-155 c11 -18 22 -45 25 -59 5 -21 14 -28 50 -36 25 -6 47 -6 50 -2 3 5 39 9
80 9 68 0 77 -2 99 -26 31 -33 53 -26 48 13 -3 19 1 34 11 42 9 8 16 24 16 37
0 32 26 31 65 -2 30 -25 30 -25 8 -41 -30 -20 -29 -48 2 -85 14 -16 25 -35 25
-41 0 -13 22 -38 84 -92 45 -41 43 -65 -6 -65 -36 0 -80 38 -98 84 -5 14 -14
26 -19 26 -6 0 -17 14 -26 30 -14 28 -19 30 -54 24 -33 -5 -42 -3 -53 15 -11
18 -22 21 -89 21 -53 0 -80 4 -88 14 -11 13 -37 5 -100 -31 -2 -1 7 -11 20
-22 18 -14 21 -23 13 -31 -13 -13 -58 -4 -75 16 -6 8 -21 14 -33 14 -11 0 -26
4 -32 8 -14 9 -25 150 -12 158 5 3 13 17 18 30 14 35 46 31 71 -8z m-1205
-660 c22 -13 51 -21 71 -20 23 2 33 -2 33 -11 0 -8 3 -28 6 -45 6 -28 4 -31
-31 -41 -54 -15 -100 10 -126 68 -31 71 -17 87 47 49z m2089 -78 c3 -5 1 -28
-5 -51 -14 -51 -68 -105 -122 -121 -50 -15 -60 -34 -52 -100 6 -53 6 -53 -29
-71 -19 -10 -43 -17 -53 -16 -11 2 -29 -3 -42 -9 -35 -20 -76 4 -80 46 -3 31
-24 44 -37 22 -15 -25 -54 -10 -76 30 -14 24 -30 40 -41 40 -12 0 -18 7 -18
24 0 13 -7 29 -15 36 -20 17 -19 69 1 77 21 8 75 -46 103 -103 27 -53 57 -58
54 -9 -8 99 -7 105 9 117 9 7 18 24 20 38 4 34 35 39 43 7 4 -14 2 -34 -4 -46
-9 -17 -8 -22 9 -31 17 -9 50 -58 50 -75 0 -3 -20 -5 -44 -5 -55 0 -68 -17
-33 -42 15 -11 27 -26 27 -33 0 -19 19 -29 25 -13 26 74 24 71 49 55 20 -14
26 -14 42 -2 18 12 17 14 -13 31 -30 18 -32 21 -35 94 -4 93 -1 110 23 110 20
0 39 -28 39 -58 0 -11 9 -30 19 -43 17 -21 22 -22 38 -11 10 7 30 20 45 30 16
10 30 30 34 47 9 41 52 63 69 35z"/>
<path d="M7543 15342 c-75 -69 -159 -128 -223 -158 -8 -4 -27 -18 -43 -32 -27
-26 -27 -26 14 -68 42 -43 42 -43 50 -156 5 -62 15 -135 23 -163 8 -27 18 -75
22 -105 3 -30 15 -66 25 -79 11 -13 19 -29 19 -35 0 -21 59 -63 97 -69 21 -4
52 -9 69 -13 41 -8 64 15 64 65 0 39 -20 66 -67 90 -27 14 -30 43 -7 62 12 10
20 10 35 1 25 -16 29 -15 29 6 0 22 -38 65 -51 57 -5 -4 -9 -15 -9 -25 0 -28
-18 -34 -45 -16 -15 10 -25 26 -25 40 0 14 -12 38 -26 56 -20 23 -25 38 -21
60 4 18 -2 52 -14 87 -11 32 -20 66 -20 77 0 16 59 76 98 99 16 10 71 -47 110
-113 14 -25 35 -55 45 -67 40 -43 -2 -58 -50 -18 -32 27 -120 39 -94 13 7 -7
12 -19 12 -28 0 -8 8 -23 19 -32 10 -8 21 -22 23 -29 3 -8 27 -15 59 -19 54
-5 54 -5 50 -136 -3 -110 -1 -133 13 -146 9 -9 16 -28 16 -43 0 -18 7 -28 24
-35 32 -12 40 -28 25 -46 -16 -19 -78 -11 -96 13 -12 15 -14 15 -31 0 -14 -13
-38 -17 -95 -17 -42 0 -78 -4 -81 -8 -6 -11 77 -102 92 -102 7 0 12 13 12 29
0 33 16 49 32 33 15 -15 1 -62 -18 -62 -19 0 -12 -58 9 -75 7 -5 18 -22 24
-37 9 -20 19 -27 35 -25 20 2 23 -4 34 -86 6 -48 18 -96 27 -105 8 -9 18 -27
21 -39 4 -11 13 -27 21 -33 8 -7 15 -20 15 -30 0 -9 11 -29 25 -44 14 -15 25
-31 25 -37 0 -5 8 -9 18 -9 21 0 42 -19 42 -37 0 -16 -94 -113 -108 -113 -5 0
-13 -10 -17 -22 -4 -14 -8 -18 -11 -11 -3 7 3 25 14 40 29 43 32 60 17 90 -7
16 -19 41 -27 57 -45 100 -56 92 -56 -43 0 -123 -8 -171 -27 -171 -21 0 -25
25 -25 178 -1 157 -7 182 -49 182 -11 0 -21 4 -21 9 0 11 -87 61 -106 61 -8 0
-14 -6 -14 -14 0 -22 -24 -38 -38 -24 -19 19 -14 37 15 69 46 48 92 37 174
-45 29 -28 29 -28 29 -3 0 14 -4 28 -9 31 -5 3 -14 25 -20 49 -6 25 -17 50
-26 57 -8 7 -15 20 -15 30 0 9 -9 29 -20 43 -11 14 -20 28 -20 31 0 4 -18 29
-40 57 -22 28 -40 55 -40 59 0 5 -6 15 -13 22 -7 7 -25 38 -41 68 -41 81 -53
90 -66 54 -7 -17 -9 -49 -5 -78 3 -27 8 -245 11 -485 2 -279 8 -446 15 -462 8
-21 7 -34 -5 -57 -24 -47 -21 -332 4 -332 13 0 30 111 30 199 0 88 9 119 29
106 9 -5 11 -58 8 -192 -3 -167 -2 -187 14 -202 26 -24 41 -129 27 -197 -17
-83 -32 -62 -38 52 -7 131 -39 200 -80 174 -12 -7 -15 -29 -13 -97 1 -48 3
-218 5 -377 5 -327 -7 -290 118 -374 30 -20 61 -42 68 -49 7 -7 17 -13 21 -13
4 0 25 -16 47 -35 34 -32 75 -61 164 -122 14 -9 43 -33 65 -53 22 -19 65 -52
96 -73 55 -38 57 -38 87 -23 16 8 32 21 35 29 8 21 -32 130 -54 147 -11 9 -27
27 -37 42 -81 123 -117 168 -157 203 -119 100 -147 140 -115 160 13 8 13 65 0
65 -5 0 -14 -9 -20 -19 -17 -32 -80 -7 -80 31 0 11 -9 31 -20 45 -15 20 -17
29 -9 45 9 17 8 19 -10 13 -25 -8 -41 37 -22 66 14 23 15 62 1 54 -5 -3 -10
-17 -10 -31 0 -46 -33 -25 -42 26 -7 38 -5 47 11 60 18 14 19 25 11 170 -4 85
-3 168 1 185 5 16 9 47 9 68 0 21 7 54 15 74 8 19 15 48 15 63 0 15 9 35 20
45 16 14 20 30 19 69 -1 28 2 70 6 93 10 56 1 86 -30 103 -23 12 -28 12 -35 0
-14 -21 -12 -30 5 -30 18 0 38 -47 30 -68 -8 -21 -28 -9 -38 24 -6 16 -27 55
-49 87 -59 90 -46 154 22 113 16 -9 35 -16 43 -16 21 0 77 -48 77 -66 0 -8 5
-14 10 -14 12 0 21 -21 45 -102 20 -67 25 -70 50 -25 15 28 21 32 50 29 24 -3
39 2 54 17 34 34 63 40 144 32 82 -7 87 -10 91 -38 2 -10 11 -22 22 -28 11 -5
29 -19 41 -30 12 -11 33 -29 48 -40 69 -53 87 -74 83 -97 -5 -37 -35 -33 -94
13 -49 38 -99 69 -110 69 -2 0 -4 -6 -4 -14 0 -30 -24 -36 -81 -20 -76 23 -83
28 -89 60 -7 38 -57 46 -96 15 -15 -12 -33 -21 -40 -21 -8 0 -14 -9 -14 -19 0
-13 -8 -21 -22 -23 -23 -3 -39 -49 -38 -107 0 -14 -13 -38 -28 -55 -38 -41
-60 -118 -42 -151 11 -20 10 -27 -9 -51 -28 -36 -31 -240 -4 -289 9 -16 19
-52 22 -80 4 -35 10 -50 21 -50 10 0 17 15 21 50 10 74 34 140 53 143 21 4 22
-61 2 -115 -12 -31 -36 -131 -36 -148 0 -3 11 0 25 7 17 8 27 23 33 52 5 26
13 41 22 41 22 0 24 -40 4 -94 -16 -45 -16 -50 0 -72 9 -13 16 -36 16 -50 0
-56 23 -79 34 -34 7 29 32 33 40 8 3 -10 5 -38 4 -63 -2 -89 33 -121 39 -35 1
19 7 43 13 55 11 21 30 27 30 10 0 -13 61 -1 81 17 9 7 47 16 84 20 68 6 69 6
96 -27 34 -40 59 -35 59 10 0 48 -47 90 -102 92 -115 4 -160 -11 -191 -64 -9
-16 -21 -26 -27 -23 -16 10 -12 30 12 60 20 25 20 31 10 88 -9 48 -9 63 1 69
24 16 54 8 65 -17 8 -16 20 -25 35 -25 13 0 32 -7 43 -15 12 -9 43 -14 87 -15
55 0 69 -3 74 -17 4 -10 15 -24 26 -32 16 -11 18 -21 12 -62 -7 -51 2 -63 22
-30 8 13 29 22 60 26 26 4 68 13 92 21 51 16 67 8 57 -30 -5 -20 -13 -26 -32
-26 -23 0 -25 -3 -20 -24 3 -14 1 -28 -5 -31 -6 -4 -13 2 -16 13 -4 19 -11 20
-57 15 -28 -3 -55 -9 -60 -14 -12 -11 44 -58 70 -59 12 0 24 -7 28 -15 9 -25
40 -16 66 20 36 50 56 53 94 16 38 -38 28 -63 -28 -72 -33 -5 -64 -24 -92 -56
-8 -10 -18 -7 -45 12 -18 14 -51 30 -72 36 -24 6 -41 18 -44 28 -3 10 -16 24
-29 31 -21 12 -27 11 -48 -9 -24 -23 -24 -23 -40 8 -17 32 -60 51 -77 34 -14
-14 13 -63 38 -69 28 -8 36 -30 17 -49 -20 -20 -29 -19 -51 4 -10 11 -30 24
-45 30 -19 7 -30 21 -36 43 -7 29 -12 33 -41 33 -19 1 -38 8 -46 18 -18 25
-23 21 -31 -18 -9 -51 4 -103 32 -127 13 -12 24 -28 24 -35 0 -8 7 -16 15 -19
8 -4 15 -13 15 -20 0 -8 7 -17 15 -20 8 -4 20 -26 26 -50 14 -54 26 -64 35
-27 22 100 94 183 158 183 40 0 118 -39 124 -62 3 -15 14 -18 58 -18 30 0 54
-4 54 -9 0 -5 13 -12 29 -16 24 -5 38 1 76 29 54 42 89 53 110 36 12 -10 15
-9 15 8 0 26 25 46 50 39 43 -11 43 -15 41 811 -1 433 -1 937 -1 1120 0 309
-1 333 -17 338 -55 18 -130 50 -143 60 -8 6 -29 15 -47 19 -17 3 -37 13 -44
21 -6 8 -17 14 -24 14 -7 0 -24 9 -38 20 -14 11 -32 20 -41 20 -9 0 -24 9 -33
20 -10 11 -21 20 -26 20 -14 0 -107 62 -107 72 0 4 -5 8 -11 8 -6 0 -23 9 -37
21 -15 11 -54 41 -87 66 -33 25 -76 61 -96 82 -19 20 -60 59 -90 87 -81 76
-185 193 -223 252 -38 59 -89 112 -108 112 -7 0 -36 -22 -65 -48z m-129 -472
c-4 -16 -10 -27 -15 -24 -11 6 -12 55 -2 80 10 27 24 -19 17 -56z m438 -60
c29 -28 82 -67 116 -86 44 -25 67 -45 73 -63 6 -15 28 -41 50 -57 23 -16 48
-37 57 -46 9 -10 21 -18 28 -18 6 0 49 -20 95 -45 46 -25 103 -54 126 -65 23
-12 45 -25 48 -30 8 -13 100 -60 118 -60 8 0 22 -9 33 -21 17 -19 19 -36 17
-158 0 -75 -2 -246 -3 -381 -2 -350 -7 -408 -37 -436 -24 -22 -24 -23 -5 -33
27 -14 45 -64 39 -108 -2 -21 0 -59 6 -86 8 -34 7 -69 -1 -125 -16 -99 -16
-143 -2 -217 11 -60 11 -60 -20 -87 -16 -16 -36 -28 -44 -28 -20 0 -84 28 -91
40 -8 13 -51 13 -76 0 -31 -17 -22 -26 20 -22 31 3 44 -1 57 -17 10 -12 30
-21 45 -21 22 0 30 -7 43 -40 9 -22 16 -47 16 -56 0 -11 4 -12 19 -4 35 18 51
2 51 -49 0 -67 -13 -75 -66 -39 -25 17 -44 37 -44 48 0 29 -42 50 -100 47 -48
-2 -53 0 -80 33 -22 28 -26 38 -18 54 9 17 7 18 -17 12 -18 -5 -43 0 -72 11
-40 16 -44 21 -39 46 5 24 3 27 -23 27 -32 0 -46 -13 -56 -53 -9 -32 -36 -49
-72 -45 -36 4 -41 26 -9 38 27 10 35 35 14 43 -50 18 116 133 177 123 75 -12
213 -57 282 -93 18 -10 35 -15 38 -11 18 18 -51 108 -83 108 -11 0 -22 7 -25
15 -4 8 -29 26 -56 40 -28 14 -58 37 -68 53 -20 32 -53 61 -70 62 -22 0 -14
-25 17 -55 17 -16 30 -34 30 -41 0 -17 -88 -28 -106 -13 -8 6 -15 10 -17 8 -1
-2 -7 -13 -13 -24 -8 -14 -23 -21 -50 -23 -46 -3 -154 -51 -154 -68 0 -27 -89
-85 -132 -87 -41 -2 -44 0 -62 37 -26 54 -32 118 -12 135 26 22 76 5 83 -30 7
-35 10 -36 58 -3 21 14 50 30 63 35 34 13 18 27 -42 38 -26 5 -58 18 -70 30
-13 12 -39 24 -59 28 -33 5 -37 3 -43 -21 -7 -30 -14 -32 -55 -11 -25 13 -28
19 -19 35 6 11 8 31 4 44 -10 42 35 92 49 54 2 -7 8 -10 12 -5 5 4 3 17 -3 30
-6 12 -13 40 -14 62 -3 40 -3 40 62 37 60 -3 68 -1 104 27 32 26 45 30 73 25
18 -3 39 -2 46 4 21 17 185 36 201 23 11 -9 19 -6 36 16 25 32 70 53 111 53
34 0 38 19 9 38 -12 7 -20 23 -20 41 0 20 -8 34 -25 45 -29 19 -55 75 -55 120
0 54 -24 76 -81 76 -33 0 -49 4 -49 13 0 15 47 67 60 67 15 0 11 32 -5 54 -8
11 -15 29 -15 41 0 12 -5 26 -10 31 -7 7 -6 21 3 42 11 27 15 30 28 17 7 -7
26 -17 42 -20 25 -7 27 -5 27 26 0 36 -23 72 -52 82 -9 3 -18 16 -20 29 -4 29
-68 49 -99 30 -34 -22 -59 -15 -65 18 -6 27 -24 43 -24 21 0 -19 -124 -93
-140 -83 -26 16 -24 59 4 83 14 13 26 30 26 39 0 9 9 25 20 35 14 13 20 31 20
63 0 43 1 44 18 29 10 -10 31 -17 45 -17 40 0 39 2 -37 84 -39 42 -45 73 -20
111 34 52 22 60 -126 83 -40 6 -45 10 -48 37 -5 39 19 55 83 55 42 0 56 -5 75
-25 12 -13 27 -22 31 -19 13 8 -1 33 -22 39 -10 4 -19 12 -19 19 0 7 -21 33
-47 58 -50 48 -93 109 -93 134 0 29 41 13 92 -36z m-420 -513 c93 -111 104
-134 82 -158 -29 -32 -28 -32 -96 103 -43 88 -36 115 14 55z m427 -1 c35 -37
26 -80 -18 -84 -18 -2 -46 2 -62 8 -22 9 -32 10 -43 1 -21 -18 -28 13 -13 60
12 39 12 39 63 39 40 0 55 -5 73 -24z m221 -264 c18 -15 20 -21 11 -45 -6 -16
-11 -39 -11 -52 0 -13 -10 -31 -21 -39 -19 -13 -22 -27 -25 -97 -4 -98 -13
-112 -48 -75 -13 15 -37 31 -53 35 -17 4 -29 15 -30 27 -1 10 -5 30 -8 44 -4
14 -1 38 5 54 9 25 14 28 40 22 25 -5 31 -2 36 19 3 13 12 26 20 29 8 3 14 17
14 31 0 59 30 79 70 47z m-565 -212 c0 -38 -39 -35 -43 3 -3 25 0 28 20 25 17
-2 23 -9 23 -28z m318 -425 c30 -28 37 -40 31 -58 -9 -30 -9 -30 -32 -18 -28
15 -132 30 -138 20 -3 -5 -11 -9 -17 -9 -7 0 -4 7 6 14 9 7 17 22 17 32 0 30
13 42 50 47 19 2 37 4 40 5 3 1 22 -14 43 -33z m-335 -994 c32 -60 40 -95 23
-105 -17 -11 -101 107 -101 141 0 72 27 59 78 -36z"/>
<path d="M8084 14405 c-18 -79 9 -115 86 -115 33 0 39 -4 49 -30 5 -16 15 -30
21 -30 6 0 15 -11 20 -25 9 -24 29 -32 43 -18 4 3 -4 21 -18 39 -14 18 -25 37
-25 43 0 5 -11 22 -25 37 -14 15 -25 31 -25 36 0 18 -83 108 -99 108 -11 0
-20 -15 -27 -45z"/>
<path d="M8432 14089 c1 -12 9 -24 16 -27 9 -3 13 3 10 19 -1 12 -9 24 -16 27
-9 3 -13 -3 -10 -19z"/>
<path d="M8305 14056 c-18 -13 -18 -14 4 -21 28 -9 48 7 28 23 -10 9 -18 8
-32 -2z"/>
<path d="M8304 13786 c-6 -17 12 -56 27 -56 5 0 17 -16 26 -35 21 -44 26 -44
42 0 12 33 11 38 -14 70 -27 37 -71 48 -81 21z"/>
<path d="M8415 13370 c-3 -11 -11 -20 -16 -20 -23 0 -5 -32 27 -47 31 -16 38
-16 61 -3 37 21 39 35 9 65 -31 31 -72 33 -81 5z"/>
<path d="M8270 13291 c0 -10 7 -21 15 -25 18 -7 20 -36 3 -36 -37 -1 -41 -17
-18 -64 22 -47 45 -57 45 -20 0 12 8 20 23 22 23 4 32 45 12 57 -5 3 -10 19
-10 34 0 33 -16 51 -47 51 -16 0 -23 -6 -23 -19z"/>
<path d="M7867 13059 c-26 -15 -20 -29 12 -29 23 0 34 -8 50 -35 14 -25 27
-35 44 -35 14 0 36 -9 50 -20 55 -44 106 -11 88 57 -7 25 -12 28 -53 30 -26 1
-58 9 -71 18 -21 13 -29 14 -46 4 -16 -11 -23 -10 -38 3 -13 12 -23 14 -36 7z"/>
<path d="M8191 12143 c-35 -7 -81 -59 -81 -92 0 -15 -7 -36 -15 -47 -41 -54
10 -164 58 -124 47 40 95 72 133 91 25 12 55 31 67 43 12 12 35 31 51 43 35
28 29 53 -13 53 -17 0 -34 6 -38 14 -8 14 -119 27 -162 19z m149 -56 c0 -7 -7
-23 -16 -35 -13 -19 -24 -22 -90 -22 -84 0 -94 11 -41 48 37 26 147 33 147 9z"/>
<path d="M7577 15813 c-4 -3 -7 -15 -7 -25 0 -10 -5 -18 -11 -18 -6 0 -8 -7
-5 -16 7 -19 -10 -54 -27 -54 -7 0 -33 18 -57 40 -54 49 -75 51 -84 9 -9 -45
-8 -49 10 -49 8 0 20 -13 25 -30 6 -16 19 -32 30 -35 12 -4 19 -15 19 -31 0
-43 34 -27 131 61 52 47 95 89 97 94 2 5 -9 21 -23 35 -25 25 -82 36 -98 19z"/>
<path d="M6040 15771 c0 -11 5 -23 11 -27 6 -3 9 -28 7 -58 -3 -45 -1 -51 17
-54 33 -4 49 12 36 36 -6 11 -11 36 -11 56 0 36 -21 66 -46 66 -8 0 -14 -9
-14 -19z"/>
<path d="M6306 15783 c-10 -10 -7 -51 5 -58 6 -4 8 -22 4 -46 -9 -50 1 -78 31
-89 29 -12 30 -20 4 -48 -28 -29 -34 -28 -67 13 -49 61 -64 49 -78 -56 -7 -56
-34 -86 -63 -70 -15 8 -24 6 -42 -14 -26 -27 -25 -36 14 -138 26 -69 26 -69
-4 -95 -16 -15 -30 -32 -30 -40 0 -7 -11 -24 -24 -37 -13 -13 -23 -32 -22 -42
3 -44 -114 -2 -123 43 -5 26 -19 34 -63 34 -42 0 -46 -5 -21 -32 14 -15 14
-22 4 -42 -11 -19 -23 -25 -67 -28 -67 -6 -85 -20 -61 -46 15 -17 23 -18 57
-8 31 8 48 7 73 -3 54 -22 230 -25 322 -6 44 9 99 16 122 16 24 -1 68 9 105
24 38 16 72 23 87 20 14 -4 30 0 40 8 9 8 29 17 44 21 34 8 46 34 24 51 -15
11 -14 14 8 35 25 23 25 23 25 -12 0 -24 5 -38 16 -42 27 -10 93 13 110 39 21
32 8 50 -53 76 -47 20 -51 29 -26 54 20 21 69 13 95 -15 25 -27 34 -25 41 9 4
20 19 36 49 54 24 14 44 24 46 22 2 -2 -19 -27 -47 -57 -51 -54 -60 -75 -40
-95 15 -15 62 -1 97 29 16 13 43 30 62 39 80 38 128 59 135 59 18 0 112 50
128 68 25 27 -1 51 -36 33 -12 -6 -44 -11 -72 -10 -70 3 -161 -15 -183 -34
-16 -15 -20 -15 -33 -2 -24 24 -116 21 -166 -4 -27 -15 -56 -21 -85 -20 -44 2
-105 -27 -137 -65 -16 -20 -40 -21 -47 -2 -3 8 -30 16 -76 20 -48 4 -83 14
-114 32 -51 30 -51 31 -23 78 28 48 51 46 101 -9 26 -29 49 -45 65 -45 30 0
29 4 -7 50 -39 50 -43 110 -6 110 17 0 26 -7 30 -24 3 -13 23 -39 45 -59 35
-31 45 -35 98 -36 34 0 70 6 87 14 16 8 40 15 55 15 15 0 35 6 45 13 18 13 18
16 -9 60 -15 26 -32 47 -39 47 -7 0 -27 11 -46 25 -34 25 -34 25 -60 0 -29
-27 -50 -32 -50 -12 0 21 -41 53 -85 67 -55 18 -135 59 -135 70 0 5 4 11 9 14
4 3 3 21 -3 41 -10 34 -28 50 -40 38z m-6 -543 c7 -13 21 -20 40 -20 36 0 36
3 6 -64 -15 -34 -32 -57 -46 -61 -29 -9 -34 -2 -35 48 0 54 -32 67 -42 17 -3
-17 -12 -34 -20 -37 -8 -3 -19 -16 -24 -29 -4 -13 -13 -24 -19 -24 -13 0 -13
37 0 45 6 3 10 19 10 35 0 33 21 57 56 66 13 4 29 15 35 25 13 24 26 24 39 -1z
m280 1 c0 -5 -7 -14 -15 -21 -8 -7 -15 -18 -15 -25 0 -18 -25 -26 -39 -12 -18
18 -13 35 17 50 32 17 52 20 52 8z m-127 -83 c-4 -30 -11 -48 -19 -48 -21 0
-24 15 -12 51 6 19 13 40 15 48 9 33 21 -7 16 -51z"/>
<path d="M4614 15769 c-4 -6 5 -23 20 -38 15 -14 33 -35 41 -46 18 -25 36 -6
27 29 -11 44 -71 82 -88 55z"/>
<path d="M6194 15756 c-9 -23 0 -51 16 -51 10 0 15 10 15 29 0 32 -21 47 -31
22z"/>
<path d="M9632 15735 c-6 -14 -18 -25 -27 -25 -8 0 -15 -9 -15 -20 0 -11 5
-20 11 -20 18 0 59 49 59 71 0 27 -15 24 -28 -6z"/>
<path d="M11110 15698 c0 -24 58 -74 71 -61 19 19 -11 67 -44 71 -18 2 -27 -1
-27 -10z"/>
<path d="M11385 15702 c-11 -2 -24 -8 -29 -12 -12 -11 32 -67 71 -90 33 -19
45 -50 20 -50 -7 0 -22 7 -33 15 -10 8 -32 15 -47 15 -25 0 -27 -3 -20 -22 4
-13 7 -35 7 -50 -1 -27 0 -27 45 -21 25 3 50 10 55 14 6 5 22 9 37 9 33 0 45
15 28 36 -9 11 -8 18 6 34 18 20 18 21 -10 50 -16 16 -38 33 -49 36 -12 3 -30
14 -41 23 -11 10 -29 16 -40 13z"/>
<path d="M5955 15680 c-7 -23 2 -43 16 -35 12 8 12 42 0 50 -5 3 -12 -4 -16
-15z"/>
<path d="M7990 15686 c0 -21 21 -31 31 -15 14 22 11 29 -11 29 -11 0 -20 -6
-20 -14z"/>
<path d="M5280 15630 c0 -33 36 -65 64 -54 23 9 20 27 -12 57 -36 35 -52 34
-52 -3z"/>
<path d="M6186 15651 c-9 -15 23 -36 36 -23 5 5 7 15 4 21 -9 13 -33 14 -40 2z"/>
<path d="M11295 15621 c-9 -16 3 -31 26 -31 14 0 19 6 17 17 -4 20 -33 29 -43
14z"/>
<path d="M12945 15469 c7 -170 9 -179 38 -222 31 -45 64 -75 127 -112 29 -17
53 -40 56 -52 8 -29 20 -29 27 -2 6 20 6 20 26 0 12 -12 26 -21 32 -21 7 0 9
-11 5 -31 -7 -38 13 -87 49 -118 29 -24 29 -24 5 -43 -29 -24 -17 -34 48 -44
50 -7 60 -1 78 51 11 32 9 41 -16 93 -15 31 -33 74 -39 95 -7 20 -16 37 -21
37 -8 0 -38 46 -72 110 -18 35 -17 83 3 95 5 4 9 17 9 30 0 18 -7 25 -31 30
-35 8 -65 62 -55 100 4 15 -1 28 -15 41 -13 12 -18 26 -15 40 3 12 3 30 -1 40
-6 16 -7 16 -19 0 -12 -17 -61 -14 -192 10 -32 6 -32 6 -27 -127z m164 -3 c6
-8 25 -19 41 -26 21 -9 30 -19 30 -36 0 -24 -37 -53 -49 -37 -3 4 -21 25 -40
45 -21 23 -31 43 -28 52 8 20 31 21 46 2z m73 -268 c-16 -16 -37 4 -28 28 6
16 8 16 23 1 13 -13 15 -19 5 -29z"/>
<path d="M5220 15545 c-15 -19 1 -67 37 -106 12 -14 23 -30 23 -37 0 -7 5 -12
10 -12 6 0 10 15 10 34 0 52 24 56 49 9 13 -25 81 -48 117 -39 14 4 26 1 31
-8 4 -8 25 -21 47 -30 38 -16 38 -16 21 -43 -17 -25 -17 -27 1 -40 13 -9 18
-27 19 -62 1 -55 26 -101 54 -101 24 0 36 29 16 36 -19 8 -19 24 0 24 8 0 15
-4 15 -10 0 -5 6 -10 14 -10 7 0 21 -10 29 -22 16 -23 16 -23 16 -2 1 11 -8
29 -19 39 -11 10 -20 24 -20 31 0 7 -9 18 -19 24 -11 5 -26 33 -35 62 -9 29
-22 69 -28 88 -18 57 -71 95 -135 95 -50 0 -56 3 -86 38 -29 34 -82 54 -153
57 -1 0 -7 -7 -14 -15z"/>
<path d="M5770 15545 c-11 -13 -9 -19 9 -39 17 -18 21 -31 16 -46 -5 -15 -2
-26 6 -31 24 -15 28 -10 28 34 -1 23 1 53 3 67 2 21 -2 26 -23 28 -14 2 -31
-4 -39 -13z"/>
<path d="M5900 15531 c0 -22 37 -38 52 -23 17 17 1 42 -27 42 -18 0 -25 -5
-25 -19z"/>
<path d="M3190 15486 c6 -59 16 -79 25 -54 12 30 1 103 -16 106 -13 2 -14 -6
-9 -52z"/>
<path d="M3760 15528 c-3 -12 -12 -109 -13 -133 -2 -27 1 -30 28 -28 37 3 74
30 98 73 25 46 17 60 -38 60 -31 0 -47 5 -51 15 -5 12 -23 22 -24 13z"/>
<path d="M6853 15503 c-24 -9 -14 -51 16 -72 34 -24 60 -26 86 -7 18 13 18 14
-1 39 -10 14 -32 31 -48 37 -31 11 -35 11 -53 3z"/>
<path d="M11252 15491 c-17 -11 52 -151 74 -151 8 0 14 -9 14 -20 0 -24 -22
-26 -40 -4 -17 20 -64 14 -68 -8 -2 -10 12 -33 31 -52 20 -19 38 -50 42 -68 4
-18 15 -49 25 -68 10 -19 21 -43 24 -52 3 -12 16 -18 35 -18 26 0 51 -21 51
-44 0 -14 -35 -36 -57 -36 -43 0 -20 -22 27 -25 25 -2 49 -10 56 -19 6 -9 16
-16 23 -16 14 0 15 -36 1 -45 -32 -20 24 -44 59 -25 30 15 26 45 -9 70 -34 24
-80 107 -80 143 0 14 9 31 22 39 27 18 19 59 -17 78 -40 22 -79 78 -65 95 13
15 -6 61 -34 84 -9 8 -16 24 -16 37 0 12 -9 29 -19 36 -11 8 -21 27 -23 43 -3
31 -30 44 -56 26z"/>
<path d="M5951 15421 c-19 -12 -5 -31 24 -31 21 0 43 16 34 24 -12 10 -46 14
-58 7z"/>
<path d="M13340 15375 c-15 -19 3 -45 31 -45 19 0 35 33 24 50 -9 15 -41 12
-55 -5z"/>
<path d="M8184 15345 c-4 -9 -1 -29 6 -45 6 -16 11 -53 10 -82 -3 -73 -3 -75
20 -81 22 -6 27 12 11 41 -5 9 -6 44 -2 77 5 44 3 66 -7 83 -17 26 -30 28 -38
7z"/>
<path d="M5306 15324 c-18 -48 8 -128 46 -137 23 -6 24 -37 1 -37 -10 0 -25
-13 -35 -29 -13 -23 -24 -30 -55 -33 -25 -2 -39 -8 -41 -19 -4 -22 57 -88 88
-94 13 -3 28 -12 33 -21 6 -11 17 -14 33 -10 30 8 129 -52 139 -83 8 -25 13
-26 53 -5 46 23 40 47 -28 113 -33 32 -60 63 -60 69 0 6 -12 22 -27 36 -27 25
-27 25 0 63 37 53 34 66 -20 106 -27 20 -61 49 -77 66 -34 35 -41 38 -50 15z"/>
<path d="M8502 15269 c-12 -18 -20 -20 -58 -14 -49 7 -49 7 -33 -29 16 -35 40
-41 59 -16 12 16 22 19 46 14 23 -4 33 -2 37 10 4 9 11 16 17 16 8 0 8 -6 0
-20 -8 -16 -8 -20 4 -20 8 0 24 -10 35 -22 17 -17 23 -19 36 -8 24 20 18 32
-34 73 -55 42 -90 47 -109 16z"/>
<path d="M5742 15258 c3 -7 22 -14 44 -16 39 -2 39 -2 14 13 -31 18 -63 19
-58 3z"/>
<path d="M3238 15255 c-8 -9 2 -76 14 -92 5 -6 20 -53 34 -105 29 -106 45
-135 80 -148 13 -5 24 -14 24 -20 0 -5 7 -10 15 -10 8 0 24 -9 34 -19 10 -10
32 -25 47 -33 41 -19 37 -42 -6 -46 -25 -2 -43 3 -59 18 -13 11 -30 20 -38 20
-7 0 -21 9 -30 20 -30 35 -43 25 -43 -33 0 -53 26 -97 57 -97 6 0 16 -6 22
-14 7 -8 25 -18 41 -21 16 -3 34 -13 41 -21 12 -15 58 -18 132 -8 55 8 73 36
38 60 -27 19 -27 60 -1 74 24 13 26 56 5 84 -8 11 -12 28 -9 39 9 29 -48 19
-61 -10 -11 -25 -37 -30 -52 -10 -6 6 -16 37 -23 67 -26 112 -36 134 -66 145
-33 12 -82 56 -98 87 -6 12 -25 26 -43 31 -17 5 -35 18 -40 29 -4 11 -11 16
-15 13z m380 -448 c2 -15 -1 -27 -5 -27 -15 0 -33 23 -33 43 0 30 34 16 38
-16z"/>
<path d="M11112 15243 c4 -21 33 -25 33 -3 0 8 -8 16 -18 18 -14 3 -18 -1 -15
-15z"/>
<path d="M3893 15234 c-39 -17 -42 -30 -8 -46 14 -6 25 -17 25 -25 0 -7 7 -13
15 -13 11 0 15 12 15 44 0 53 -5 57 -47 40z"/>
<path d="M2653 15218 c-21 -27 -23 -51 -8 -75 12 -17 14 -36 10 -66 -4 -30 -2
-48 9 -62 15 -20 15 -20 42 6 35 36 68 132 54 159 -20 38 -88 62 -107 38z"/>
<path d="M5865 15220 c-11 -17 3 -28 42 -32 21 -3 46 -8 56 -12 13 -6 17 -3
17 12 0 30 -99 57 -115 32z"/>
<path d="M8320 15170 c0 -16 7 -20 30 -20 34 0 39 14 11 30 -29 15 -41 12 -41
-10z"/>
<path d="M12894 15156 c-8 -20 16 -239 27 -250 5 -6 16 -3 28 8 16 15 22 15
40 4 18 -11 23 -10 36 10 19 26 76 30 95 7 7 -8 21 -15 31 -15 10 0 23 -9 29
-19 10 -19 66 -38 78 -27 3 4 -4 13 -16 22 -18 12 -22 25 -22 66 0 44 -2 49
-17 43 -33 -13 -48 -10 -51 11 -2 13 -17 28 -40 38 -53 24 -101 52 -121 70
-10 9 -22 16 -28 16 -6 0 -16 7 -23 15 -16 19 -39 19 -46 1z"/>
<path d="M10920 15135 c-14 -16 -5 -35 16 -35 15 0 20 35 5 44 -5 3 -14 -1
-21 -9z"/>
<path d="M8538 15106 c-15 -21 -15 -24 -1 -39 13 -13 14 -21 5 -41 -9 -21 -8
-25 9 -29 11 -3 23 -15 26 -26 10 -39 45 -34 56 8 4 17 -1 29 -18 45 -23 21
-23 24 -7 40 14 15 14 19 3 23 -7 3 -21 14 -29 24 -21 24 -23 24 -44 -5z"/>
<path d="M3756 15101 c-27 -29 6 -111 45 -111 20 0 20 24 -1 40 -18 14 -22 24
-18 54 5 41 -1 45 -26 17z"/>
<path d="M4957 15060 c-19 -12 -12 -33 21 -70 37 -41 48 -55 59 -82 14 -32 20
-33 47 -13 11 8 28 15 39 15 17 0 18 -5 12 -50 -7 -48 -6 -51 30 -85 26 -24
47 -35 68 -35 17 0 45 -11 64 -26 30 -23 33 -24 33 -6 0 11 -7 25 -16 33 -11
9 -14 22 -10 41 4 23 -1 35 -24 60 -17 17 -30 34 -30 39 0 4 -12 11 -27 16
-20 7 -31 21 -42 58 -23 70 -73 108 -149 112 -31 2 -65 -1 -75 -7z"/>
<path d="M8467 15063 c-14 -13 -6 -33 13 -33 13 0 20 7 20 20 0 19 -20 27 -33
13z"/>
<path d="M2474 15034 c-7 -27 7 -50 25 -40 6 4 11 20 11 37 0 37 -27 40 -36 3z"/>
<path d="M6900 14935 c-18 -43 -21 -45 -59 -45 -42 0 -61 -13 -38 -27 7 -4 19
-23 27 -42 13 -32 15 -33 58 -27 50 7 82 -11 82 -45 0 -31 -37 -43 -57 -19
-10 11 -23 20 -30 20 -30 0 -5 -84 48 -160 31 -46 59 -100 59 -116 0 -8 -13
-20 -30 -25 -40 -14 -39 -47 3 -62 17 -6 26 -67 9 -67 -10 0 -52 43 -52 54 0
19 -60 66 -84 66 -30 0 -31 3 -10 35 13 20 14 30 4 60 -7 20 -9 42 -7 50 10
24 -21 40 -41 22 -11 -10 -27 -14 -40 -10 -32 8 -40 -22 -13 -51 24 -26 27
-58 7 -75 -10 -9 -19 -4 -40 23 -14 19 -26 42 -26 51 0 21 -30 31 -41 14 -16
-26 -11 -59 10 -59 11 0 21 -9 25 -22 9 -34 77 -78 120 -78 42 0 60 -25 33
-45 -26 -19 -21 -32 19 -51 20 -9 39 -27 44 -38 4 -12 15 -28 24 -35 9 -7 16
-26 16 -42 0 -16 3 -29 8 -30 50 -5 76 -21 69 -44 -2 -5 -30 -11 -63 -13 -36
-2 -65 -9 -77 -19 -22 -20 -50 -2 -29 19 17 17 15 45 -6 98 -22 58 -57 94
-105 110 -55 17 -123 -18 -142 -73 -7 -21 -9 -40 -4 -43 5 -3 9 1 9 8 0 8 15
19 33 26 65 23 127 9 127 -28 0 -18 -7 -20 -69 -20 -67 0 -69 -1 -95 -35 -15
-19 -34 -35 -42 -35 -38 0 0 -104 53 -142 48 -35 49 -64 2 -54 -40 8 -50 -10
-40 -72 4 -29 11 -56 15 -59 10 -10 26 17 26 45 0 29 32 30 52 1 14 -21 15
-20 69 39 35 39 72 68 102 81 30 13 51 29 57 45 6 16 21 28 42 34 44 12 55 6
68 -34 8 -22 20 -36 35 -40 40 -10 50 -1 47 43 -2 23 1 44 7 48 16 9 13 41 -5
56 -9 8 -13 21 -9 33 3 12 7 56 10 98 3 66 1 80 -17 103 -30 39 -30 99 0 103
21 3 21 5 7 25 -8 12 -15 38 -15 58 0 31 4 38 25 43 33 9 33 42 -2 78 -15 16
-28 42 -29 60 -2 18 -5 44 -6 58 -3 20 2 25 27 30 37 6 47 50 18 82 -17 20
-17 21 4 35 27 18 15 54 -15 46 -10 -2 -24 3 -31 11 -9 11 -30 16 -63 16 -48
0 -49 0 -68 -45z m-180 -820 c0 -7 -6 -15 -12 -18 -7 -2 1 -8 17 -12 55 -13
56 -14 53 -47 -3 -30 -8 -34 -48 -46 -25 -7 -53 -17 -62 -23 -29 -15 -39 -11
-26 11 10 16 10 22 1 28 -12 7 -63 79 -63 88 0 6 47 25 85 34 36 8 55 3 55
-15z"/>
<path d="M5727 14943 c-4 -3 -7 -18 -7 -33 0 -14 -7 -35 -15 -46 -15 -20 -20
-82 -7 -99 4 -5 29 -21 56 -35 51 -26 56 -31 81 -90 9 -19 21 -44 27 -55 51
-83 53 -85 86 -85 22 0 32 -5 32 -15 0 -8 -4 -15 -10 -15 -5 0 -10 -7 -10 -15
0 -8 -11 -22 -25 -31 -14 -9 -25 -21 -25 -28 -1 -16 -42 -62 -62 -69 -31 -11
-20 -162 11 -172 10 -3 28 -23 40 -45 26 -47 41 -44 41 9 0 20 5 42 12 49 9 9
8 12 -8 12 -15 0 -27 14 -42 48 -27 60 -27 73 -2 105 36 46 84 10 82 -62 -1
-24 5 -41 19 -54 15 -14 19 -26 14 -41 -14 -41 -17 -171 -5 -216 20 -74 23
-116 10 -140 -9 -18 -9 -25 5 -40 19 -21 7 -160 -18 -188 -10 -11 -17 -52 -21
-122 -7 -97 -5 -109 17 -160 36 -82 49 -232 23 -258 -15 -15 -11 -29 29 -118
19 -40 17 -285 -2 -291 -7 -3 -18 8 -25 24 -7 15 -21 37 -30 47 -10 11 -18 23
-18 28 0 4 -9 17 -21 29 -25 25 -18 49 14 49 44 0 55 26 29 71 -12 21 -22 44
-22 51 0 7 -21 35 -46 62 -43 47 -49 50 -105 54 -34 3 -72 -1 -89 -8 -28 -12
-30 -16 -30 -69 0 -78 9 -88 60 -74 33 8 44 8 56 -4 18 -19 18 -77 -1 -93 -26
-22 -93 -6 -131 31 -32 31 -34 36 -34 105 0 52 -4 75 -15 84 -11 9 -14 22 -10
41 7 31 3 33 -85 43 -24 2 -46 8 -47 13 -13 34 -21 37 -66 19 -70 -27 -89 -66
-32 -66 14 0 29 -9 35 -20 6 -11 16 -20 23 -20 7 0 23 -9 37 -20 14 -11 37
-20 52 -20 36 0 43 -14 40 -86 -3 -47 1 -64 13 -74 10 -8 21 -24 26 -37 6 -17
17 -23 37 -23 20 0 44 -15 83 -50 54 -50 54 -50 32 -66 -26 -19 -31 -54 -7
-54 34 0 64 55 64 117 0 25 7 43 26 59 33 31 34 31 34 -15 0 -25 12 -63 33
-104 30 -57 35 -76 40 -168 3 -57 11 -119 18 -138 19 -53 -3 -182 -41 -241
-16 -26 -30 -53 -30 -60 0 -7 -18 -30 -40 -52 -22 -22 -40 -48 -40 -57 0 -9
-9 -34 -20 -56 -21 -40 -27 -85 -11 -85 25 0 161 132 187 182 8 15 19 28 24
28 5 0 21 39 36 88 27 87 27 87 41 55 7 -18 17 -33 22 -33 10 0 21 34 21 68 0
12 7 25 15 28 22 9 23 2176 1 2229 -8 19 -18 56 -22 82 -3 26 -12 55 -19 63
-7 8 -16 26 -20 39 -7 23 -49 91 -63 101 -13 9 -47 64 -52 85 -4 12 -21 25
-45 33 -22 7 -54 19 -72 27 -17 8 -36 15 -41 15 -6 0 -23 11 -38 25 -27 25
-45 31 -57 18z"/>
<path d="M4754 14895 c-9 -22 9 -37 37 -33 16 2 24 10 24 23 0 26 -52 35 -61
10z"/>
<path d="M2492 14888 c-5 -7 -15 -29 -22 -49 -13 -35 -11 -41 28 -121 26 -52
42 -98 42 -120 0 -29 11 -50 60 -110 45 -55 60 -81 60 -105 0 -42 16 -83 33
-83 28 0 87 -77 87 -113 0 -41 21 -65 39 -43 16 19 -46 149 -74 155 -37 7 -47
63 -20 111 39 67 7 156 -72 201 -42 24 -53 36 -53 55 0 71 -33 139 -79 163
-18 10 -21 18 -16 42 7 31 3 36 -13 17z"/>
<path d="M2677 14893 c-20 -20 -5 -64 35 -103 23 -22 46 -40 51 -40 16 0 -2
64 -23 80 -10 8 -24 27 -29 43 -10 27 -21 33 -34 20z"/>
<path d="M8794 14848 c4 -18 8 -42 10 -54 4 -30 15 -44 37 -44 23 0 27 38 4
46 -11 5 -12 10 -2 26 10 16 8 22 -12 39 -34 28 -44 24 -37 -13z"/>
<path d="M5072 14853 c2 -10 10 -18 18 -18 22 0 18 29 -3 33 -14 3 -18 -1 -15
-15z"/>
<path d="M10400 14847 c0 -8 3 -17 8 -21 4 -4 12 -24 17 -44 17 -58 56 -48 41
11 -6 27 -66 75 -66 54z"/>
<path d="M5620 14835 c-7 -8 -19 -15 -27 -15 -11 0 -13 -6 -8 -22 3 -13 10
-34 13 -49 10 -35 46 -79 67 -79 13 0 15 5 9 23 -4 12 -8 51 -8 87 -1 68 -18
89 -46 55z"/>
<path d="M6672 14838 c-18 -18 -15 -48 6 -55 9 -4 31 -17 48 -30 43 -32 54
-29 54 13 0 61 -72 108 -108 72z"/>
<path d="M5026 14795 c-9 -37 18 -85 49 -85 30 0 32 11 5 28 -14 8 -20 23 -20
47 0 42 -24 49 -34 10z"/>
<path d="M6586 14796 c-9 -15 -22 -23 -33 -20 -26 6 -47 -11 -39 -31 4 -11 15
-15 33 -13 16 2 28 -2 31 -11 3 -10 -3 -12 -27 -6 -29 6 -31 5 -31 -22 0 -31
22 -61 62 -86 26 -16 28 -16 42 4 11 16 22 20 42 16 15 -3 34 -3 41 0 18 7 16
42 -2 50 -9 3 -22 20 -30 38 -9 22 -21 35 -37 37 -19 2 -23 8 -20 36 4 38 -9
41 -32 8z"/>
<path d="M13221 14806 c-9 -10 -9 -16 -1 -21 12 -7 40 11 40 26 0 14 -26 10
-39 -5z"/>
<path d="M3731 14784 c-22 -22 -22 -24 -5 -24 23 1 54 23 54 39 0 18 -23 11
-49 -15z"/>
<path d="M10702 14791 c-25 -16 -10 -46 23 -46 25 0 30 4 30 25 0 27 -28 38
-53 21z"/>
<path d="M12836 14764 c-10 -27 -7 -44 9 -44 9 0 15 9 15 24 0 30 -15 42 -24
20z"/>
<path d="M10232 14719 c-30 -11 -25 -37 9 -58 71 -43 89 -56 89 -67 0 -6 11
-23 25 -38 26 -28 32 -46 15 -46 -5 0 -10 -7 -10 -15 0 -8 5 -15 10 -15 6 0
10 7 10 15 0 21 29 19 37 -2 9 -24 51 -65 91 -88 17 -11 32 -25 32 -31 0 -26
70 -65 128 -71 32 -3 66 -13 77 -22 11 -10 32 -25 48 -34 33 -21 35 -46 4 -75
-31 -30 -42 -28 -78 13 -20 22 -40 35 -55 35 -29 0 -41 -24 -24 -45 21 -26 3
-29 -29 -5 -35 24 -39 47 -13 66 16 12 15 13 -8 22 -17 6 -28 5 -38 -4 -7 -8
-17 -14 -21 -14 -4 0 -14 -18 -21 -40 -27 -82 22 -130 98 -96 34 15 42 16 61
4 19 -11 23 -11 32 5 13 22 32 22 52 -1 29 -32 22 -52 -17 -45 -30 5 -34 2
-40 -23 -9 -34 17 -58 52 -49 39 10 92 -6 137 -40 24 -19 53 -35 65 -37 12 -2
27 -14 34 -28 8 -14 23 -43 34 -65 14 -28 28 -41 45 -43 22 -3 25 -9 29 -58 7
-81 64 -149 93 -111 11 16 11 26 0 65 -8 26 -15 60 -17 76 -2 16 -11 33 -20
37 -10 5 -26 13 -35 18 -12 5 -18 20 -18 43 0 26 -8 41 -33 63 -18 17 -55 50
-81 75 -26 25 -66 62 -89 83 -41 38 -59 86 -27 73 21 -8 19 6 -5 27 -11 9 -20
26 -20 38 0 24 -29 120 -41 133 -5 5 -15 4 -24 -4 -13 -11 -19 -10 -33 4 -16
17 -16 19 2 29 25 15 66 57 66 68 0 14 -29 10 -54 -6 -27 -18 -48 -13 -61 17
-11 23 -64 54 -107 63 -16 3 -29 14 -34 27 -12 38 -60 75 -104 81 -29 4 -58
19 -103 56 -64 52 -75 56 -115 40z"/>
<path d="M10514 14716 c-9 -22 4 -66 19 -66 29 1 42 18 31 47 -11 31 -41 43
-50 19z"/>
<path d="M11030 14686 c0 -19 26 -48 57 -65 32 -16 40 -14 47 13 3 13 9 31 12
40 5 12 -2 15 -38 14 -23 -1 -51 1 -60 6 -13 6 -18 4 -18 -8z"/>
<path d="M4450 14678 c0 -7 7 -22 15 -32 19 -25 40 -8 30 23 -7 22 -45 30 -45
9z"/>
<path d="M5554 14675 c-8 -20 3 -48 16 -40 13 8 13 55 0 55 -6 0 -13 -7 -16
-15z"/>
<path d="M9090 14646 c0 -8 16 -16 42 -19 48 -6 53 -4 45 18 -8 20 -87 21 -87
1z"/>
<path d="M12800 14622 c0 -26 4 -41 10 -37 13 8 13 45 0 65 -7 11 -10 3 -10
-28z"/>
<path d="M13556 14639 c-4 -8 -3 -26 3 -40 8 -21 10 -22 16 -6 4 10 3 28 -3
40 -8 18 -11 19 -16 6z"/>
<path d="M5677 14633 c-15 -15 -6 -43 13 -43 11 0 20 6 20 14 0 17 -24 38 -33
29z"/>
<path d="M5160 14580 c0 -23 -7 -54 -15 -71 -9 -16 -13 -35 -8 -41 4 -7 10
-28 13 -48 5 -32 9 -35 36 -33 23 2 38 -5 60 -28 16 -17 43 -37 59 -45 17 -7
42 -24 58 -36 24 -19 31 -21 58 -11 24 9 31 9 35 -2 9 -22 -6 -37 -32 -32 -34
6 -46 -13 -32 -49 13 -35 4 -112 -17 -140 -13 -18 -14 -18 -32 -2 -67 63 -104
90 -118 84 -21 -8 1 -53 42 -87 16 -13 41 -46 57 -73 24 -42 26 -50 14 -62
-22 -22 -68 -2 -68 29 0 29 -49 78 -93 92 -29 9 -32 14 -35 58 -2 34 -7 47
-18 47 -10 0 -13 -6 -9 -19 8 -26 -4 -51 -28 -60 -21 -8 -20 -9 6 -34 16 -17
37 -27 55 -27 28 0 82 -44 82 -67 0 -6 6 -16 14 -22 7 -6 19 -33 26 -59 16
-58 36 -82 67 -82 13 0 36 8 50 18 21 13 45 16 105 15 43 -1 78 0 78 3 0 3 -9
18 -21 32 -87 114 -81 96 -76 207 3 98 20 202 38 237 13 26 12 27 -25 21 -43
-7 -95 22 -102 57 -11 51 -24 69 -86 121 -64 53 -78 69 -59 69 12 0 15 62 4
73 -3 4 -12 2 -20 -5 -10 -8 -17 -8 -25 0 -24 24 -38 13 -38 -28z"/>
<path d="M5320 14604 c0 -22 58 -91 81 -97 15 -4 19 -13 17 -33 -4 -34 24 -44
51 -20 16 15 19 14 29 -9 6 -14 16 -25 22 -25 5 0 10 -22 10 -50 0 -44 3 -50
20 -50 12 0 24 10 30 24 4 13 20 32 34 44 38 29 32 42 -19 42 -43 0 -45 1 -55
39 -5 21 -20 51 -31 65 -21 27 -21 27 -43 7 -29 -28 -35 -26 -47 8 -6 17 -22
34 -40 41 -16 7 -29 16 -29 21 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -16z"/>
<path d="M9600 14591 c0 -18 7 -39 15 -47 9 -10 13 -24 9 -40 -5 -19 -1 -26
19 -33 14 -6 28 -19 32 -30 7 -22 14 -25 39 -15 17 7 22 39 7 48 -5 4 -5 20 1
40 15 48 6 62 -42 69 -23 3 -50 13 -61 23 -18 17 -19 16 -19 -15z"/>
<path d="M9056 14583 c3 -16 8 -35 10 -43 3 -8 -5 -21 -16 -30 -22 -17 -22
-17 10 -48 40 -40 97 -47 85 -9 -4 12 -10 41 -14 64 -5 27 -18 52 -35 68 -35
32 -48 32 -40 -2z"/>
<path d="M4528 14579 c-29 -17 -22 -39 12 -39 34 0 52 26 29 41 -17 11 -20 11
-41 -2z"/>
<path d="M4600 14532 c0 -5 11 -19 26 -32 21 -21 27 -22 35 -10 16 26 5 45
-29 48 -17 2 -32 -1 -32 -6z"/>
<path d="M6356 14531 c-4 -5 3 -19 15 -30 18 -16 20 -23 10 -35 -19 -23 23
-43 45 -22 12 13 19 13 34 4 36 -23 33 2 -6 41 -40 41 -87 61 -98 42z"/>
<path d="M4739 14499 c-12 -7 -11 -11 3 -25 17 -17 38 -12 38 11 0 17 -23 25
-41 14z"/>
<path d="M6867 14494 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27
-31 17z"/>
<path d="M10162 14488 c7 -20 48 -23 48 -4 0 11 -9 16 -26 16 -16 0 -24 -5
-22 -12z"/>
<path d="M10110 14420 c-18 -34 -12 -60 13 -60 57 0 77 57 24 71 -21 6 -29 3
-37 -11z"/>
<path d="M10255 14403 c3 -15 7 -32 8 -38 1 -5 -13 -10 -32 -10 -37 0 -50 -17
-31 -40 7 -9 20 -30 29 -48 9 -17 25 -34 36 -36 11 -2 24 -9 28 -17 4 -8 14
-14 21 -14 8 0 19 -7 26 -15 7 -8 16 -12 21 -9 16 10 9 29 -13 39 -27 12 -46
69 -47 141 -1 50 -13 74 -39 74 -10 0 -12 -7 -7 -27z"/>
<path d="M6557 14404 c-4 -4 -7 -20 -7 -36 0 -28 2 -29 33 -23 17 4 41 12 51
17 19 10 19 11 1 24 -10 8 -24 14 -31 14 -7 0 -19 2 -26 5 -8 3 -17 2 -21 -1z"/>
<path d="M9170 14403 c0 -3 8 -11 17 -18 27 -20 2 -69 -30 -59 -54 18 -72 12
-75 -28 -3 -38 13 -53 24 -23 10 25 26 19 74 -29 24 -23 40 -13 40 26 0 31 13
34 61 14 11 -5 19 -1 23 10 9 23 -50 84 -81 84 -13 0 -23 4 -23 9 0 5 -7 11
-15 15 -8 3 -15 3 -15 -1z"/>
<path d="M2497 14388 c-2 -7 2 -30 9 -52 8 -21 14 -53 14 -70 1 -19 11 -42 26
-60 26 -29 26 -29 52 -3 24 24 25 28 10 44 -9 10 -23 32 -31 49 -15 29 -15 32
5 52 21 21 21 21 -17 36 -45 19 -62 20 -68 4z"/>
<path d="M13155 14392 c-10 -10 -5 -36 11 -53 18 -20 20 -18 -54 -44 -26 -9
-5 -30 32 -33 31 -3 38 0 43 18 5 17 11 19 39 14 31 -6 34 -4 34 19 0 33 -37
72 -72 79 -15 3 -30 3 -33 0z"/>
<path d="M6406 14380 c-14 -40 -10 -75 10 -95 12 -11 15 -26 11 -50 -4 -25 0
-40 15 -57 11 -13 24 -33 29 -45 10 -26 49 -32 49 -8 0 43 -27 109 -55 134
-23 20 -31 36 -32 63 -1 44 -19 81 -27 58z"/>
<path d="M9403 14350 c-3 -12 -18 -27 -34 -36 -39 -20 -36 -31 9 -43 20 -6 43
-20 50 -31 9 -15 23 -20 56 -20 25 0 48 -5 51 -10 4 -6 24 -18 46 -27 21 -8
39 -19 39 -23 0 -6 52 -30 66 -30 9 0 3 42 -8 60 -10 15 -10 27 0 55 14 37 10
55 -14 55 -8 0 -14 4 -14 10 0 9 -62 40 -81 40 -5 0 -12 -13 -15 -30 -7 -33
-19 -37 -50 -16 -11 8 -33 16 -49 18 -24 2 -30 7 -28 26 3 28 -17 29 -24 2z"/>
<path d="M5621 14305 c-17 -20 -31 -43 -31 -52 0 -9 -8 -25 -17 -36 -23 -25
-22 -230 0 -256 8 -9 17 -30 20 -48 4 -18 16 -42 27 -53 11 -11 20 -27 20 -35
0 -38 16 -10 18 31 2 52 7 64 27 64 26 0 33 -32 22 -101 -14 -94 1 -123 67
-127 49 -3 49 -3 43 -47 -4 -25 -2 -47 3 -50 6 -3 10 -15 10 -26 0 -11 6 -22
14 -25 8 -3 19 -19 25 -35 5 -16 17 -29 26 -29 15 0 16 10 10 78 -3 42 -8 87
-11 99 -5 26 -88 93 -115 93 -26 0 -28 10 -17 65 5 28 12 60 14 72 6 31 67 43
94 18 23 -21 13 -42 -22 -47 -12 -2 -23 -8 -25 -15 -4 -10 31 -55 66 -86 53
-48 59 -57 65 -102 6 -34 10 -44 17 -34 13 20 11 84 -3 114 -11 24 -9 29 11
44 19 15 21 21 12 45 -6 15 -11 38 -11 50 0 13 -9 31 -20 41 -11 10 -20 25
-20 33 0 20 -48 63 -81 72 -22 7 -30 4 -42 -13 -8 -12 -18 -17 -25 -13 -9 5
-5 16 13 38 31 37 31 42 -2 66 -27 19 -28 25 -31 114 -4 97 -15 131 -25 79
-10 -47 -39 -42 -35 7 3 35 1 37 -28 40 -25 2 -37 -4 -63 -33z"/>
<path d="M6470 14331 c0 -17 49 -63 59 -56 16 9 13 35 -3 35 -7 0 -19 7 -26
15 -14 17 -30 20 -30 6z"/>
<path d="M4450 14215 c-13 -14 -31 -25 -41 -25 -47 0 -34 -55 22 -95 23 -17
55 -42 70 -57 36 -37 43 -36 63 17 13 32 23 45 37 45 22 0 25 28 6 55 -19 25
-35 12 -29 -24 4 -26 0 -31 -22 -37 -35 -9 -39 -4 -44 64 -7 84 -23 99 -62 57z"/>
<path d="M5240 14233 c1 -24 24 -37 60 -34 11 1 9 7 -9 21 -23 20 -51 27 -51
13z"/>
<path d="M9280 14204 c-31 -36 -33 -36 -70 -25 -57 17 -81 14 -112 -16 -53
-51 -29 -77 37 -39 48 29 92 33 109 12 6 -8 40 -16 77 -20 59 -6 68 -4 85 15
19 21 19 22 -1 33 -11 6 -34 26 -52 44 -17 17 -34 32 -36 32 -3 0 -19 -16 -37
-36z"/>
<path d="M9018 14223 c-24 -6 -22 -15 7 -36 28 -20 45 -15 45 13 0 14 -24 35
-33 29 -1 -1 -10 -3 -19 -6z"/>
<path d="M13263 14193 c-40 -20 -40 -21 -3 -81 17 -27 30 -57 30 -68 0 -14 3
-15 12 -6 8 8 8 15 -2 27 -11 13 -10 19 9 38 23 25 28 76 9 95 -15 15 -15 15
-55 -5z"/>
<path d="M12830 14090 c0 -77 11 -103 25 -58 9 27 9 113 1 127 -17 28 -26 5
-26 -69z"/>
<path d="M6382 14108 c-11 -36 -10 -353 1 -364 11 -12 8 -49 -6 -68 -12 -16
-14 -16 -26 -2 -15 18 -41 22 -41 6 0 -5 9 -34 21 -65 20 -55 49 -75 49 -34 0
36 50 111 69 103 9 -3 26 -9 39 -11 17 -4 22 -12 22 -35 0 -28 -2 -30 -27 -23
-54 14 -58 12 -57 -25 1 -21 16 -59 37 -93 50 -81 56 -88 82 -81 19 5 25 0 34
-29 6 -19 23 -45 37 -58 15 -13 37 -41 50 -61 31 -49 83 -55 103 -12 13 30 11
34 -50 99 -66 70 -99 111 -99 123 0 5 -19 33 -41 61 -41 52 -45 76 -9 53 11
-7 27 -12 35 -12 22 0 18 33 -5 48 -11 7 -20 23 -20 37 0 18 -7 26 -24 31 -35
8 -55 44 -62 111 -4 33 -14 63 -22 69 -13 10 -35 113 -26 123 2 2 10 -2 18 -8
10 -9 16 -9 21 -1 13 21 -5 60 -34 75 -19 9 -32 26 -36 45 -9 39 -21 38 -33
-2z"/>
<path d="M10350 14132 c0 -21 45 -41 63 -27 16 12 16 13 -5 18 -13 2 -31 8
-40 12 -10 4 -18 3 -18 -3z"/>
<path d="M4704 14095 c-14 -21 -22 -25 -44 -20 -19 4 -29 2 -33 -9 -6 -15 16
-46 32 -46 29 0 151 -151 151 -187 0 -9 9 -36 21 -60 12 -24 18 -50 15 -58 -6
-18 -36 -9 -54 17 -19 26 -42 23 -42 -7 0 -27 25 -45 63 -45 29 0 34 -6 72
-90 16 -36 35 -70 43 -77 8 -6 19 -38 26 -70 11 -58 11 -58 51 -61 49 -4 52
-9 60 -102 4 -41 15 -93 25 -115 15 -32 18 -65 18 -167 0 -115 2 -128 21 -147
12 -12 21 -30 21 -41 0 -27 20 -25 47 4 21 21 22 30 17 87 -4 35 -13 71 -21
80 -22 26 -14 103 12 106 41 6 68 -30 73 -93 3 -38 11 -66 23 -79 63 -70 58
-206 -13 -303 -44 -59 -43 -68 7 -78 20 -3 38 -10 41 -15 11 -18 35 -8 68 27
38 41 60 41 88 3 18 -24 19 -28 4 -64 -21 -50 -20 -55 8 -55 19 0 27 8 36 35
6 19 9 39 6 44 -9 14 21 33 46 29 17 -2 23 -10 24 -28 3 -60 5 -70 22 -86 9
-10 22 -31 27 -48 14 -42 54 -44 68 -3 7 23 5 33 -11 50 -32 36 -36 64 -13
103 27 46 28 44 -20 114 -43 62 -56 71 -65 45 -4 -8 -12 -15 -20 -15 -16 0
-19 26 -4 35 6 4 3 16 -10 32 -11 14 -20 41 -20 60 0 57 -41 101 -98 105 -46
3 -47 4 -45 35 2 24 -5 39 -27 62 -17 16 -30 36 -30 45 0 21 -18 30 -34 16
-38 -31 -83 14 -116 115 -7 22 -24 62 -36 90 -13 27 -24 62 -24 76 0 14 -11
36 -25 49 -14 13 -25 31 -25 39 0 29 -140 183 -196 217 -13 8 -19 23 -19 50 0
29 -5 41 -21 49 -20 10 -21 13 -8 35 17 31 18 148 1 175 -7 11 -38 45 -69 74
-32 30 -58 60 -58 67 0 25 -19 24 -36 -1z m761 -1285 c3 -5 19 -10 35 -10 33
0 62 -24 54 -45 -3 -8 -21 -23 -39 -34 -21 -12 -35 -30 -40 -49 -9 -42 -28
-57 -45 -36 -16 19 -15 151 1 171 14 16 26 17 34 3z"/>
<path d="M9528 14109 c-46 -26 -5 -86 50 -74 27 5 74 -26 84 -56 6 -18 38 -3
38 17 0 10 -8 26 -17 36 -13 14 -14 21 -5 30 14 14 16 48 3 48 -5 0 -11 -7
-15 -15 -8 -21 -39 -19 -69 5 -28 22 -44 24 -69 9z"/>
<path d="M4326 14081 c-5 -7 -8 -202 -9 -433 0 -444 -1 -437 45 -438 35 0 104
-38 115 -63 7 -14 32 -38 57 -52 26 -15 46 -30 46 -35 0 -4 25 -34 56 -66 33
-34 69 -85 86 -121 21 -46 38 -67 61 -79 54 -28 131 -106 131 -134 1 -15 8
-26 19 -28 15 -3 17 6 17 75 0 73 -2 81 -30 112 -21 22 -36 31 -47 26 -10 -3
-31 1 -48 9 -16 8 -38 17 -48 20 -15 5 -16 9 -5 25 17 27 -13 81 -72 129 -70
57 -90 80 -90 101 0 29 37 37 63 13 22 -20 38 -28 159 -76 40 -17 85 -45 113
-72 45 -42 75 -56 75 -34 0 24 -52 90 -75 96 -13 3 -41 24 -60 46 -20 22 -50
44 -66 50 -17 6 -34 21 -39 34 -6 15 -18 24 -30 24 -19 0 -20 5 -18 79 3 79
-4 103 -22 85 -6 -6 -6 -23 1 -47 6 -21 9 -52 7 -70 -4 -44 -51 -50 -96 -13
-58 50 -96 23 -61 -43 12 -23 18 -45 14 -49 -4 -4 -10 -1 -13 7 -9 27 -43 51
-88 63 -53 15 -128 77 -122 104 2 10 21 24 48 33 35 12 40 16 23 19 -13 2 -23
10 -23 18 0 19 36 18 44 -1 3 -8 17 -15 30 -15 15 0 38 -13 56 -30 34 -33 86
-41 96 -15 11 28 -21 89 -51 97 -32 8 -78 58 -100 105 -7 18 -25 38 -39 45
-31 13 -34 38 -6 45 26 7 26 8 -16 51 -36 37 -36 37 -30 107 4 38 10 73 15 78
19 19 59 -16 85 -75 26 -58 27 -59 64 -56 36 3 37 4 40 45 2 25 -4 55 -13 73
-10 20 -14 42 -10 61 8 34 -3 37 -38 9 -31 -25 -49 -25 -71 -1 -9 10 -34 21
-55 25 -42 6 -51 18 -52 74 -1 48 -13 80 -23 63z m214 -274 c0 -14 -20 -37
-32 -37 -10 0 -11 34 -1 43 11 12 33 8 33 -6z"/>
<path d="M9120 14045 c-5 -14 -10 -31 -10 -36 0 -5 -9 -27 -19 -48 -19 -37
-19 -38 -1 -68 13 -21 18 -47 17 -83 -2 -51 -5 -56 -45 -77 -8 -3 10 -44 26
-59 9 -10 22 -31 28 -48 6 -16 24 -37 39 -46 16 -9 32 -27 35 -40 9 -38 30
-37 30 2 0 42 9 55 43 63 41 11 34 38 -22 86 -27 24 -47 48 -44 55 3 8 -6 19
-21 25 -33 16 -42 44 -22 74 14 21 24 25 64 25 26 0 56 -7 66 -15 21 -16 56
-20 56 -7 0 5 -12 14 -26 21 -36 16 -28 45 13 49 49 5 76 -14 68 -46 -3 -15
-13 -32 -21 -39 -17 -13 -16 -44 2 -50 6 -2 23 15 38 37 31 48 59 52 96 14 14
-14 41 -35 60 -47 35 -22 79 -94 80 -131 0 -18 -1 -18 -18 -3 -21 19 -72 23
-72 6 0 -6 8 -18 18 -27 10 -10 24 -29 30 -44 14 -34 -13 -58 -65 -58 -40 0
-49 -13 -29 -42 9 -12 16 -41 16 -63 0 -48 23 -85 52 -85 20 0 20 0 1 -47 -3
-8 3 -13 16 -13 11 0 36 -8 56 -17 31 -15 37 -15 46 -3 20 31 21 61 5 79 -11
13 -15 27 -11 44 5 19 0 35 -21 62 -28 37 -28 37 -6 53 30 24 46 262 18 290
-26 27 -66 91 -66 107 0 8 9 19 20 25 20 11 20 11 -6 35 -32 30 -25 29 -68 8
-29 -13 -40 -14 -62 -5 -20 10 -35 10 -65 1 -30 -9 -45 -9 -65 -1 -38 18 -52
15 -66 -15 -20 -42 -62 -43 -99 -2 -31 35 -31 35 -33 89 -1 46 -40 57 -56 15z"/>
<path d="M9415 14059 c-9 -13 12 -29 38 -29 26 0 17 34 -10 38 -11 2 -24 -2
-28 -9z"/>
<path d="M2670 14031 c-20 -39 -12 -98 17 -120 29 -23 70 -37 80 -27 8 7 -24
115 -40 134 -22 28 -46 33 -57 13z"/>
<path d="M3187 13948 c-10 -126 -8 -172 7 -194 14 -18 15 -18 25 9 6 16 11 70
11 122 0 154 -33 201 -43 63z"/>
<path d="M10474 14015 c-8 -21 10 -39 30 -32 22 9 20 24 -4 37 -16 9 -22 8
-26 -5z"/>
<path d="M4950 13997 c0 -7 13 -31 30 -53 33 -43 38 -78 14 -92 -27 -15 -11
-46 36 -69 57 -28 58 -28 72 2 9 20 8 28 -5 43 -10 10 -17 26 -17 36 0 24 -19
58 -42 74 -10 7 -18 20 -18 27 0 8 -13 21 -30 30 -36 18 -40 19 -40 2z"/>
<path d="M10332 13960 c-25 -24 -29 -71 -8 -92 13 -14 22 -29 69 -113 18 -33
28 -41 57 -43 41 -4 63 -20 55 -40 -9 -23 14 -140 35 -180 11 -20 20 -42 20
-49 0 -26 21 -12 27 18 3 17 17 37 30 46 22 15 26 15 51 -4 15 -11 32 -30 38
-41 6 -12 18 -30 27 -40 10 -10 17 -29 17 -42 0 -21 19 -65 67 -153 13 -25 19
-28 48 -23 30 6 36 2 68 -36 31 -37 37 -40 43 -25 4 10 2 29 -5 43 -6 14 -11
34 -11 44 0 24 -34 43 -61 35 -26 -9 -48 10 -42 36 4 14 -6 30 -36 58 -22 21
-41 45 -41 53 0 9 -7 18 -15 22 -21 8 -19 32 6 55 37 34 -12 111 -71 111 -16
0 -30 3 -30 8 0 4 -10 12 -22 17 -30 14 -35 35 -8 35 13 0 24 -8 27 -19 4 -18
30 -31 60 -31 18 0 53 41 53 63 0 15 -5 18 -24 13 -14 -3 -37 0 -53 8 -15 8
-41 18 -58 23 -16 5 -39 22 -50 39 -13 20 -33 35 -55 40 -25 7 -36 15 -38 32
-4 28 18 29 42 3 10 -11 41 -25 68 -33 28 -7 56 -20 62 -30 10 -17 46 -24 59
-12 3 3 1 17 -6 31 -8 19 -7 30 7 54 16 27 16 30 0 36 -11 4 -23 -2 -35 -18
-18 -24 -18 -24 -43 0 -14 13 -26 33 -28 45 -4 25 -38 35 -38 11 0 -8 -6 -18
-14 -21 -17 -6 -76 22 -76 36 0 6 -9 10 -20 10 -12 0 -38 9 -60 20 -49 25 -61
25 -88 0z"/>
<path d="M6878 13913 c-35 -40 -39 -60 -21 -97 13 -28 23 -36 43 -36 44 0 65
-42 40 -80 -9 -13 -15 -9 -38 19 -36 42 -66 40 -70 -7 -2 -20 -9 -32 -18 -32
-8 0 -14 -9 -14 -20 0 -11 6 -20 14 -20 7 0 19 -7 26 -15 9 -11 16 -12 25 -5
20 17 100 0 129 -27 31 -29 31 -28 6 -60 -32 -41 -27 -94 11 -115 17 -10 37
-18 45 -18 19 0 37 49 29 80 -3 14 -7 46 -9 72 -1 33 -9 55 -24 71 -20 21 -20
24 -6 39 28 28 -1 118 -58 176 -25 26 -48 57 -52 70 -9 26 -37 29 -58 5z"/>
<path d="M10800 13815 c0 -14 9 -30 20 -37 27 -17 25 -32 -6 -47 -26 -12 -26
-12 -1 -31 16 -12 40 -20 65 -20 31 0 42 -5 47 -18 6 -22 54 -47 66 -35 11 11
-1 26 -33 40 -16 7 -28 19 -28 28 0 11 -10 15 -35 15 -41 0 -49 24 -10 34 25
6 37 46 14 46 -6 0 -25 11 -43 25 -42 32 -56 32 -56 0z"/>
<path d="M2637 13813 c-12 -11 -8 -23 7 -23 21 0 30 -20 17 -33 -12 -12 -64
12 -90 42 -12 14 -13 14 -6 -4 4 -11 11 -36 16 -55 4 -19 13 -36 19 -38 6 -2
17 -17 26 -34 14 -26 14 -32 1 -46 -8 -10 -18 -38 -21 -63 -7 -45 1 -59 33
-59 12 0 31 48 31 79 0 16 7 35 16 42 21 17 15 176 -7 190 -17 10 -33 11 -42
2z"/>
<path d="M13351 13798 c-19 -5 -46 -18 -59 -29 -14 -10 -31 -19 -38 -19 -21 0
-17 -28 9 -55 29 -31 114 -45 123 -21 8 20 23 20 45 0 26 -23 49 -11 49 26 0
20 -11 43 -36 70 -39 43 -41 43 -93 28z"/>
<path d="M4647 13778 c3 -10 -1 -26 -10 -36 -13 -15 -14 -22 -2 -56 8 -22 11
-52 8 -68 -3 -18 -1 -28 6 -28 13 0 51 -78 61 -125 5 -25 11 -31 38 -33 27 -3
33 -8 42 -43 11 -39 37 -52 65 -31 12 8 16 92 5 92 -4 0 -23 12 -43 28 -19 15
-43 32 -53 38 -18 11 -18 12 -1 49 18 37 18 37 -30 92 -70 80 -70 81 -50 95
16 12 15 14 -12 29 -27 16 -28 16 -24 -3z"/>
<path d="M2421 13766 c-21 -23 -40 -78 -41 -119 0 -14 6 -18 28 -15 23 3 27 8
30 40 2 27 9 39 24 44 14 4 17 9 9 17 -6 6 -11 19 -11 28 0 28 -15 30 -39 5z"/>
<path d="M10932 13763 c4 -22 43 -25 43 -3 0 8 -11 16 -23 18 -19 3 -23 0 -20
-15z"/>
<path d="M6634 13733 c-11 -59 27 -93 66 -58 13 12 27 15 55 9 30 -5 37 -4 33
7 -3 9 -23 15 -51 17 -41 3 -49 7 -62 33 -21 39 -33 37 -41 -8z"/>
<path d="M5034 13744 c-11 -5 -11 -125 1 -144 8 -12 55 -14 55 -1 0 5 -10 15
-22 23 -21 14 -22 16 -6 40 26 39 6 96 -28 82z"/>
<path d="M9462 13741 c-23 -14 -10 -46 21 -49 26 -3 28 -1 25 25 -3 29 -23 39
-46 24z"/>
<path d="M5265 13728 c-14 -44 -19 -132 -9 -175 7 -38 55 -73 98 -73 29 0 31
-2 148 -129 68 -73 119 -101 183 -101 30 0 48 -23 49 -63 1 -31 3 -32 51 -38
69 -7 154 -40 161 -61 3 -10 15 -18 26 -18 16 0 19 4 13 23 -3 12 -10 38 -15
57 -13 53 -40 123 -54 140 -7 8 -16 23 -19 32 -3 9 -40 44 -83 77 -88 70 -121
77 -157 35 -20 -22 -25 -24 -50 -15 -25 10 -28 15 -22 40 5 26 3 29 -26 35
-17 3 -42 6 -55 6 -45 0 -76 69 -38 84 37 14 253 -31 284 -59 9 -8 22 -15 28
-15 6 0 15 -7 20 -16 6 -10 12 -12 15 -6 4 5 -2 21 -13 35 -11 14 -20 28 -20
32 0 13 -96 102 -117 109 -11 4 -28 15 -38 26 -10 11 -30 20 -44 20 -14 0 -35
7 -45 15 -11 8 -39 15 -62 15 -57 0 -71 -22 -42 -68 17 -27 19 -38 9 -58 -16
-35 -37 -30 -71 19 -35 49 -87 107 -95 107 -3 0 -7 -6 -10 -12z m452 -356 c19
-12 5 -82 -16 -82 -23 0 -41 20 -41 45 0 36 29 55 57 37z"/>
<path d="M9350 13655 c0 -8 -9 -23 -20 -33 -18 -17 -19 -20 -5 -32 8 -7 15
-23 15 -36 0 -14 6 -24 14 -24 22 0 39 28 32 54 -5 19 -1 28 14 36 25 14 26
30 1 30 -11 0 -23 5 -26 10 -9 15 -25 12 -25 -5z"/>
<path d="M2545 13620 c-7 -12 12 -50 26 -50 16 0 22 29 9 45 -14 17 -26 19
-35 5z"/>
<path d="M3195 13600 c-8 -25 3 -62 16 -55 5 4 9 19 9 35 0 35 -16 48 -25 20z"/>
<path d="M6688 13601 c-8 -10 -22 -21 -29 -23 -25 -9 51 -118 144 -209 20 -20
37 -40 37 -45 0 -32 37 -125 52 -130 10 -3 18 -8 18 -12 0 -4 5 -14 10 -22 9
-13 13 -12 28 8 34 44 99 -10 78 -64 -4 -11 -12 -14 -24 -9 -37 15 -48 15 -67
1 -20 -16 -19 -16 13 -43 31 -27 62 -74 62 -95 0 -6 -11 -7 -27 -4 -31 8 -43
-5 -43 -51 0 -17 -5 -35 -10 -38 -6 -4 -8 -22 -5 -43 6 -33 5 -35 -8 -19 -14
17 -48 23 -60 10 -10 -10 13 -33 33 -33 11 0 20 -10 24 -26 5 -20 10 -24 19
-15 15 15 87 15 87 -1 0 -6 -7 -19 -15 -27 -9 -11 -16 -46 -18 -99 -5 -82 -5
-83 21 -93 15 -6 30 -16 34 -22 5 -8 8 -5 8 8 0 11 -7 30 -15 41 -12 18 -12
24 0 40 13 19 14 19 29 -1 15 -19 15 -19 16 13 0 23 -8 40 -26 57 -25 24 -25
24 -14 100 10 66 9 81 -6 120 -17 45 -17 45 11 70 19 18 25 32 22 48 -19 77
-19 118 -2 137 16 17 17 25 6 59 -6 21 -18 42 -26 45 -8 3 -15 17 -15 31 0 18
-5 25 -19 25 -23 0 -71 61 -71 89 0 11 -10 26 -22 32 -65 35 -88 63 -88 107 0
35 -4 44 -22 51 -13 5 -32 18 -42 30 -24 26 -56 27 -78 2z"/>
<path d="M13377 13613 c-4 -3 -28 -11 -54 -18 -56 -14 -63 -36 -14 -46 19 -4
51 -24 76 -49 39 -39 47 -42 79 -36 45 9 56 25 28 44 -12 8 -22 22 -22 31 0
31 -39 81 -63 81 -13 0 -27 -3 -30 -7z"/>
<path d="M5100 13578 c0 -26 18 -44 31 -31 9 9 9 16 -1 28 -15 18 -30 20 -30
3z"/>
<path d="M10420 13572 c0 -5 6 -16 13 -26 13 -18 14 -18 20 -2 4 10 5 22 1 27
-7 11 -34 12 -34 1z"/>
<path d="M4537 13534 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27
-31 17z"/>
<path d="M9430 13510 c0 -18 -7 -33 -19 -39 -16 -9 -18 -19 -14 -83 4 -69 7
-75 40 -104 58 -51 44 -70 -47 -66 -81 3 -84 4 -94 45 -5 22 -1 32 19 51 35
32 32 67 -9 110 -44 47 -60 32 -50 -44 6 -49 5 -53 -21 -74 -24 -20 -26 -25
-15 -43 11 -16 11 -32 1 -81 -8 -39 -9 -68 -3 -79 14 -27 42 -174 42 -221 0
-33 5 -44 23 -53 22 -12 37 -28 37 -41 0 -14 -47 -8 -60 7 -7 8 -19 15 -26 15
-20 0 -17 -37 5 -59 37 -37 42 -56 26 -95 -8 -19 -15 -45 -15 -57 0 -38 43
-111 96 -163 28 -28 53 -58 57 -66 5 -13 8 -12 22 5 32 39 -7 147 -82 222 -42
43 -52 66 -34 78 11 6 58 -12 83 -33 26 -22 34 9 12 46 -18 31 -13 67 9 59 6
-2 12 -15 12 -29 1 -16 13 -36 33 -53 17 -14 37 -38 44 -53 12 -24 22 -28 86
-37 68 -9 73 -12 90 -44 18 -37 46 -60 58 -48 4 4 -3 32 -15 62 -19 45 -22 70
-20 147 3 130 -7 183 -49 243 -19 27 -41 54 -49 58 -7 4 -13 14 -13 22 0 16
-54 48 -64 38 -3 -4 -6 -19 -6 -33 0 -36 -24 -57 -45 -40 -8 7 -15 22 -15 34
0 12 -7 31 -15 44 -12 16 -14 34 -9 72 8 57 20 73 30 35 5 -19 13 -25 32 -25
14 0 33 -6 41 -13 9 -8 36 -22 60 -31 76 -29 80 6 10 94 -21 27 -39 56 -39 64
0 18 -14 27 -54 35 -17 4 -36 16 -41 28 -6 11 -16 27 -23 35 -6 8 -9 17 -6 20
3 4 12 39 20 79 13 59 13 73 2 80 -25 16 -38 9 -38 -21z m-82 -385 c8 -27 21
-57 29 -67 8 -9 18 -40 22 -70 9 -59 34 -119 69 -162 26 -33 31 -30 52 27 19
51 53 59 58 14 2 -15 14 -34 26 -42 31 -20 47 -57 34 -78 -14 -25 -47 -21 -60
8 -18 40 -38 24 -38 -30 0 -13 -3 -31 -6 -40 -6 -14 -8 -13 -21 5 -8 11 -20
20 -26 20 -7 0 -18 9 -25 20 -7 11 -18 20 -25 20 -7 0 -26 13 -43 28 -32 29
-54 108 -54 189 0 17 -9 42 -20 56 -11 14 -20 35 -20 47 0 11 -7 35 -16 51
-20 40 -12 61 23 57 24 -3 29 -10 41 -53z"/>
<path d="M9014 13515 c-4 -9 -1 -28 4 -43 6 -15 12 -38 14 -51 4 -34 24 -37
44 -6 15 23 15 27 1 43 -9 9 -20 29 -26 45 -12 30 -28 35 -37 12z"/>
<path d="M6312 13508 c-16 -16 -15 -43 3 -58 8 -7 15 -20 15 -29 1 -29 39
-101 54 -101 22 0 46 -29 46 -56 0 -30 23 -40 57 -25 39 18 27 72 -27 118 -22
19 -40 43 -40 53 0 21 -17 36 -45 42 -11 2 -21 13 -23 25 -4 30 -25 46 -40 31z"/>
<path d="M2713 13448 c-34 -21 -41 -36 -22 -55 19 -19 6 -48 -26 -53 -19 -3
-31 -12 -33 -24 -4 -17 1 -18 58 -12 34 4 73 12 86 18 18 8 31 8 50 -1 14 -6
30 -9 35 -6 16 10 10 51 -10 69 -11 10 -22 29 -26 44 -12 47 -56 55 -112 20z"/>
<path d="M13315 13418 c-3 -7 -4 -26 -2 -43 2 -30 2 -30 -43 -27 -30 3 -49 10
-58 23 -17 24 -38 24 -59 -1 -10 -11 -27 -20 -38 -20 -14 0 -25 -11 -35 -32
-7 -18 -15 -36 -17 -40 -2 -3 12 -12 32 -18 46 -15 59 -4 60 48 0 34 2 37 33
40 25 3 32 0 32 -15 1 -20 43 -73 60 -73 6 0 15 -11 20 -25 8 -21 16 -25 42
-24 47 3 98 -26 98 -55 0 -41 -58 -116 -89 -116 -39 0 -88 -26 -94 -50 -7 -26
17 -50 51 -50 15 0 40 -11 56 -24 30 -23 30 -23 12 -59 -16 -36 -16 -37 12
-94 30 -62 57 -78 79 -47 19 26 16 56 -12 141 -23 68 -24 77 -10 93 8 9 15 23
15 31 0 8 6 26 14 41 22 42 30 87 27 158 -2 61 -5 68 -42 106 -37 37 -40 46
-38 84 3 35 0 45 -16 51 -32 12 -85 10 -90 -3z"/>
<path d="M3155 13390 c-17 -28 -17 -107 0 -124 20 -19 34 -78 35 -143 0 -31 4
-43 15 -43 25 0 21 199 -5 250 -11 22 -20 46 -20 55 0 17 -16 20 -25 5z"/>
<path d="M3730 13380 c-26 -26 -18 -41 20 -33 25 5 30 2 30 -15 0 -27 26 -86
44 -101 19 -16 46 -7 46 14 0 23 -58 105 -75 105 -7 0 -15 10 -17 22 -4 30
-23 33 -48 8z"/>
<path d="M9110 13380 c0 -25 39 -80 56 -80 24 0 24 18 3 59 -23 45 -59 57 -59
21z"/>
<path d="M13503 13374 c-8 -23 20 -47 46 -39 24 7 51 32 51 46 0 17 -90 11
-97 -7z"/>
<path d="M11383 13293 c-32 -12 -12 -33 32 -33 25 0 45 -4 45 -10 0 -5 7 -10
15 -10 21 0 19 13 -8 38 -22 21 -56 27 -84 15z"/>
<path d="M2620 13225 c0 -35 -41 -93 -70 -99 -39 -7 -43 -58 -7 -78 21 -12 21
-13 -13 -19 -31 -6 -33 -7 -13 -14 12 -4 25 -17 29 -29 4 -11 17 -30 29 -42
12 -11 24 -26 27 -34 3 -9 13 -11 31 -6 41 10 49 43 33 123 -15 71 -13 87 16
119 30 33 1 93 -44 94 -10 0 -18 -7 -18 -15z"/>
<path d="M4877 13225 c-4 -8 -2 -17 4 -21 11 -6 39 13 39 27 0 15 -37 10 -43
-6z"/>
<path d="M6517 13223 c-15 -15 -7 -91 13 -116 11 -14 20 -37 20 -52 0 -15 5
-46 12 -68 11 -35 10 -41 -6 -53 -21 -15 -15 -77 9 -104 7 -8 17 -31 22 -50 5
-20 16 -35 24 -35 12 0 14 29 15 165 0 101 5 176 12 193 21 51 10 114 -13 77
-11 -18 -44 -11 -56 13 -17 32 -38 44 -52 30z"/>
<path d="M11390 13200 c0 -32 23 -53 72 -64 35 -8 45 10 21 37 -11 12 -23 30
-26 40 -4 11 -17 17 -37 17 -27 0 -30 -3 -30 -30z"/>
<path d="M6741 13185 c-31 -32 -34 -40 -35 -102 -1 -38 -8 -82 -16 -99 -7 -17
-10 -39 -6 -49 6 -16 8 -17 24 -1 10 9 24 16 31 16 9 0 10 7 4 23 -13 35 -5
108 13 128 18 21 49 25 59 9 8 -13 65 -13 65 0 0 6 -11 16 -25 22 -26 12 -28
16 -25 61 2 41 -44 37 -89 -8z"/>
<path d="M4317 13133 c-3 -27 -1 -97 4 -156 5 -60 7 -113 4 -118 -3 -5 -1 -18
5 -29 9 -16 8 -24 -5 -36 -18 -18 -19 -44 -4 -98 8 -28 14 -35 22 -27 19 19
25 13 91 -88 55 -84 74 -105 125 -136 68 -42 81 -70 55 -115 -16 -26 -16 -31
-2 -60 15 -32 14 -65 -3 -76 -15 -9 -10 -58 7 -82 19 -28 36 -24 44 9 5 20 12
24 45 24 40 0 52 13 39 43 -4 9 -8 32 -9 50 -1 18 -9 40 -18 50 -23 26 -32 78
-17 97 18 21 -30 136 -63 150 -28 13 -35 54 -11 72 26 19 -1 106 -34 111 -26
4 -27 -4 -6 -67 11 -36 12 -54 4 -75 -13 -34 -34 -29 -38 10 -2 16 -14 40 -27
54 -13 14 -35 51 -49 83 -14 31 -31 57 -38 57 -7 0 -22 7 -32 15 -16 12 -17
17 -6 30 11 13 11 21 2 36 -7 11 -10 24 -7 29 8 12 116 -38 133 -62 12 -17 21
-19 60 -13 53 8 72 14 72 25 0 10 -56 30 -86 30 -13 0 -27 6 -31 14 -4 7 -18
18 -30 25 -17 9 -23 21 -23 47 0 20 -6 37 -14 40 -8 3 -12 13 -9 24 3 12 -3
23 -20 32 -27 14 -97 99 -97 117 0 6 -6 11 -14 11 -9 0 -15 -17 -19 -47z"/>
<path d="M5670 13135 c0 -16 9 -19 34 -9 25 9 19 24 -9 24 -16 0 -25 -6 -25
-15z"/>
<path d="M3622 13125 c-36 -16 -51 -40 -34 -57 8 -8 19 -8 38 1 19 8 30 9 38
1 19 -19 27 -10 24 27 -3 43 -17 49 -66 28z"/>
<path d="M13544 13096 c-9 -24 15 -56 41 -56 24 0 24 0 4 35 -22 37 -36 44
-45 21z"/>
<path d="M3795 13060 c-15 -24 53 -86 72 -67 6 7 -46 77 -58 77 -4 0 -11 -5
-14 -10z"/>
<path d="M3231 13015 c0 -28 4 -70 8 -95 7 -45 7 -45 15 3 9 53 3 114 -14 131
-7 7 -10 -5 -9 -39z"/>
<path d="M11100 13011 c0 -28 22 -61 40 -61 4 0 10 -9 13 -20 5 -20 47 -29 47
-10 0 35 -61 120 -87 120 -8 0 -13 -12 -13 -29z"/>
<path d="M9629 13014 c-15 -18 -11 -22 26 -26 20 -2 30 1 30 11 0 21 -41 33
-56 15z"/>
<path d="M2769 12996 c-13 -28 8 -63 53 -90 57 -34 64 -6 18 67 -33 52 -55 59
-71 23z"/>
<path d="M3577 12982 c-25 -26 -29 -62 -8 -62 4 0 23 -13 41 -30 33 -30 73
-39 85 -20 13 21 -16 90 -49 115 -40 31 -37 31 -69 -3z"/>
<path d="M6834 12988 c-4 -14 -1 -25 8 -32 8 -6 18 -23 22 -38 7 -31 40 -39
50 -12 8 21 -11 44 -35 44 -21 0 -24 12 -9 41 9 16 7 19 -9 19 -11 0 -23 -9
-27 -22z"/>
<path d="M3710 12776 c0 -23 16 -36 46 -36 22 0 17 27 -8 44 -31 22 -38 20
-38 -8z"/>
<path d="M9110 12775 c0 -14 25 -55 36 -59 17 -7 18 2 2 37 -11 22 -38 39 -38
22z"/>
<path d="M5140 12735 c0 -25 -38 -38 -70 -25 -28 12 -70 1 -70 -19 0 -12 35
-41 51 -41 28 0 38 -16 58 -92 20 -73 20 -79 4 -110 -9 -18 -19 -40 -23 -48
-4 -9 -21 -15 -40 -15 -43 0 -49 -20 -11 -33 38 -13 53 -43 53 -101 0 -85 46
-108 113 -57 50 39 44 66 -17 81 -55 14 -57 46 -6 117 10 14 8 20 -13 37 -22
20 -23 22 -6 35 12 10 17 28 17 67 0 30 5 74 11 99 6 29 7 51 0 65 -5 11 -12
28 -15 38 -7 21 -36 23 -36 2z"/>
<path d="M10105 12730 c-9 -15 5 -52 18 -47 19 6 21 57 3 57 -8 0 -18 -5 -21
-10z"/>
<path d="M3880 12700 c-13 -9 -11 -13 10 -30 31 -25 64 -22 68 6 4 29 -47 45
-78 24z"/>
<path d="M2507 12664 c-12 -12 6 -34 29 -34 26 0 30 10 12 28 -13 13 -31 16
-41 6z"/>
<path d="M10995 12595 c-29 -28 -31 -47 -9 -69 19 -20 29 -20 47 -2 7 8 24 16
37 18 33 4 35 23 6 53 -31 31 -50 32 -81 0z"/>
<path d="M9031 12591 c-8 -14 -7 -31 4 -62 9 -23 13 -51 9 -61 -6 -20 23 -38
35 -21 3 6 16 15 29 22 29 15 28 31 -3 31 -28 0 -45 25 -45 69 0 37 -15 48
-29 22z"/>
<path d="M12835 12570 c-7 -11 1 -159 9 -168 3 -3 6 8 6 25 0 16 3 58 6 92 6
57 -3 80 -21 51z"/>
<path d="M4740 12521 c-14 -27 -1 -47 24 -38 20 8 20 18 2 42 -13 18 -14 18
-26 -4z"/>
<path d="M4954 12514 c-14 -53 58 -126 91 -93 15 15 13 20 -24 60 -22 24 -41
47 -41 52 0 18 -20 4 -26 -19z"/>
<path d="M2350 12501 c0 -32 14 -49 25 -31 9 15 -3 60 -15 60 -6 0 -10 -13
-10 -29z"/>
<path d="M4319 12448 c-5 -239 -3 -706 2 -793 3 -56 0 -152 -7 -220 -16 -153
-2 -245 37 -245 24 0 24 -18 2 -81 -17 -48 -17 -48 6 -73 29 -31 25 -61 -9
-61 -33 -1 -32 44 -33 -860 -2 -770 3 -931 30 -904 10 10 20 9 48 -4 19 -9 35
-20 35 -24 0 -5 14 -23 31 -40 25 -28 37 -33 75 -33 53 0 134 34 134 55 0 9
12 20 26 25 14 6 22 15 19 21 -8 13 -143 79 -162 79 -18 0 -17 -16 2 -24 21
-8 19 -33 -4 -46 -31 -16 -77 10 -121 69 -22 29 -43 64 -46 77 -3 13 -10 24
-15 24 -5 0 -9 9 -9 20 0 14 7 20 22 20 19 0 20 2 6 18 -9 9 -19 40 -22 67 -4
28 -10 67 -13 88 -4 28 0 43 12 57 10 11 15 28 12 40 -6 24 13 82 31 93 17 11
9 46 -22 96 -13 21 -24 48 -25 62 0 13 -3 40 -7 60 -7 46 6 55 38 26 22 -20
57 -38 134 -67 18 -6 42 -21 54 -32 17 -16 38 -21 88 -24 46 -2 70 -7 78 -18
15 -21 32 -20 36 2 8 34 -14 60 -74 86 -81 35 -168 94 -178 120 -4 12 -16 28
-25 36 -14 11 -16 25 -10 79 6 62 5 68 -18 90 -14 13 -30 20 -36 16 -16 -10
-13 -76 4 -95 18 -20 29 -80 18 -96 -4 -7 -19 -14 -33 -15 -23 -4 -25 -1 -22
29 1 17 -2 32 -8 32 -5 0 -10 -7 -10 -15 0 -17 -25 -20 -35 -5 -3 5 -1 19 5
31 14 25 22 437 9 445 -19 11 -9 54 16 70 14 9 25 24 23 33 -1 9 2 23 7 31 10
15 14 82 14 197 0 34 6 75 14 90 8 15 17 51 20 78 4 28 9 60 13 72 4 16 -4 31
-31 60 -71 74 -83 100 -91 201 -3 50 -3 92 1 92 17 0 101 -55 135 -88 33 -32
38 -33 83 -28 74 10 107 -16 70 -56 -15 -17 -15 -22 12 -81 16 -34 35 -67 42
-73 7 -6 13 -16 13 -21 0 -5 11 -20 25 -33 14 -13 25 -28 25 -33 0 -5 15 -24
34 -41 18 -18 38 -42 45 -54 7 -13 21 -22 35 -22 25 0 36 -17 36 -52 0 -25 58
-115 100 -155 16 -15 30 -34 30 -41 0 -20 29 -72 41 -72 19 0 22 34 5 63 -15
27 -15 31 -1 47 25 28 18 46 -49 113 -56 57 -95 121 -81 135 2 3 -2 14 -10 26
-8 11 -15 34 -15 51 0 16 -5 37 -10 45 -6 10 -4 20 7 32 20 23 15 28 -36 35
-47 6 -71 -8 -71 -43 0 -56 -39 -38 -49 23 -5 28 -11 37 -24 35 -22 -4 -21 6
3 45 11 18 31 35 45 39 30 8 31 14 4 42 -16 18 -27 21 -54 16 -32 -6 -35 -4
-50 32 -9 22 -14 47 -11 56 5 21 -5 23 -22 6 -9 -9 -17 -6 -37 12 -23 22 -26
22 -43 7 -43 -39 -78 -18 -97 57 -20 77 -42 116 -64 116 -11 0 -28 14 -39 33
-19 33 -44 145 -35 160 9 14 31 7 36 -13 6 -24 37 -27 37 -4 0 9 -9 23 -20 32
-11 10 -23 34 -27 55 -5 36 -5 37 25 37 30 0 89 -44 141 -103 9 -11 26 -23 39
-28 24 -9 27 -24 12 -63 -14 -37 6 -33 25 4 9 17 13 36 8 42 -4 7 -9 28 -12
47 -5 27 -12 36 -33 42 -24 6 -69 36 -150 99 -27 20 -27 20 -46 0 -20 -21 -20
-21 -31 11 -8 24 -8 42 1 70 13 45 10 44 62 21 65 -29 106 -41 106 -31 0 5 -4
9 -9 9 -39 0 -107 193 -81 226 7 7 7 20 1 37 -5 14 -7 28 -4 31 11 11 -31 76
-49 76 -10 0 -23 9 -30 20 -22 35 -28 22 -29 -62z m299 -3279 c3 -22 -2 -28
-23 -33 -30 -8 -55 8 -55 34 0 25 11 31 45 28 24 -2 31 -8 33 -29z"/>
<path d="M9500 12495 c-10 -12 -10 -18 0 -30 9 -11 8 -19 -4 -37 -18 -25 -21
-68 -6 -68 23 0 69 31 75 49 3 11 15 23 26 26 19 6 45 43 36 52 -7 6 -76 22
-98 23 -9 0 -22 -7 -29 -15z"/>
<path d="M2458 12425 c-16 -18 -28 -39 -28 -47 0 -8 -7 -23 -15 -34 -20 -27
-18 -58 5 -79 17 -16 20 -31 20 -107 0 -60 5 -99 15 -118 12 -22 13 -35 4 -53
-7 -16 -8 -39 -2 -68 8 -38 12 -44 35 -44 29 -1 58 -21 58 -40 0 -7 17 -35 38
-62 22 -27 44 -58 51 -71 6 -12 21 -22 33 -22 17 0 19 4 14 28 -4 15 -10 41
-13 57 -3 17 -16 43 -29 58 -30 36 -38 67 -30 117 6 36 3 42 -39 83 -63 63
-68 82 -42 154 12 33 28 67 35 76 24 29 -5 179 -38 197 -29 16 -43 11 -72 -25z"/>
<path d="M4797 12453 c-16 -15 -7 -53 12 -53 20 0 37 32 26 50 -7 11 -28 13
-38 3z"/>
<path d="M9080 12372 c0 -65 -2 -62 64 -77 19 -4 34 -1 45 9 13 12 23 13 55 3
50 -16 88 -72 84 -125 -3 -35 -5 -37 -35 -34 -39 4 -42 -9 -13 -53 22 -33 25
-61 10 -85 -7 -12 -12 -12 -22 -2 -6 6 -18 12 -25 12 -18 0 -16 -37 2 -44 8
-3 15 -15 15 -26 0 -12 6 -31 13 -43 6 -12 17 -40 22 -62 10 -35 14 -40 40
-40 24 0 34 7 50 37 20 37 20 37 -1 57 -31 28 -39 99 -18 148 11 27 17 70 18
145 1 95 -1 109 -20 130 -12 13 -24 30 -27 39 -4 12 -23 19 -59 24 -58 8 -153
29 -180 40 -16 6 -18 0 -18 -53z"/>
<path d="M5224 12408 c-4 -6 2 -19 15 -29 12 -10 17 -20 11 -24 -17 -10 -11
-25 10 -25 23 0 23 2 9 53 -10 36 -31 48 -45 25z"/>
<path d="M9655 12400 c-10 -11 -26 -22 -37 -26 -19 -6 -19 -7 -2 -25 21 -23
86 -44 108 -36 12 5 15 14 11 32 -3 14 -7 36 -10 50 -7 31 -44 34 -70 5z"/>
<path d="M5776 12345 c-8 -23 1 -38 40 -63 60 -38 75 -6 21 46 -36 35 -52 40
-61 17z"/>
<path d="M9510 12335 c0 -8 6 -25 13 -36 10 -17 10 -23 0 -26 -18 -6 -16 -38
2 -53 35 -29 -8 -67 -61 -54 -25 6 -25 5 -24 -47 1 -30 -2 -75 -6 -101 -5 -38
-3 -53 15 -82 14 -23 21 -47 19 -68 -3 -29 0 -33 22 -36 37 -3 57 12 41 32
-16 19 -17 67 -4 130 8 34 8 58 0 79 -12 35 4 53 60 63 50 9 58 -6 27 -51 -24
-36 -25 -43 -19 -119 4 -45 14 -90 21 -101 8 -11 14 -40 14 -65 0 -60 15 -108
41 -136 13 -14 25 -45 30 -75 9 -59 25 -82 39 -59 12 20 5 206 -10 244 -6 16
-10 50 -9 75 0 25 -4 79 -11 118 -8 51 -8 84 -1 110 6 20 8 48 4 61 -3 13 0
34 7 46 22 42 10 61 -35 58 -22 -2 -44 -8 -49 -13 -16 -14 -46 -11 -53 7 -3 8
-1 20 6 27 17 17 14 31 -14 61 -26 28 -65 35 -65 11z"/>
<path d="M3196 12253 c9 -78 14 -79 14 -5 0 38 -4 62 -11 62 -7 0 -8 -19 -3
-57z"/>
<path d="M9447 12293 c-4 -3 -7 -20 -7 -37 0 -31 0 -31 19 -1 21 35 13 63 -12
38z"/>
<path d="M4814 12267 c-3 -8 -1 -32 5 -54 6 -21 11 -51 11 -67 0 -30 35 -96
51 -96 18 0 22 33 6 45 -38 28 -14 55 47 55 19 0 45 9 61 22 27 21 27 21 4 39
-13 10 -31 19 -40 19 -9 0 -28 9 -42 21 -36 27 -95 37 -103 16z"/>
<path d="M5327 12262 c-27 -30 -22 -87 9 -111 29 -23 54 -14 54 19 0 10 7 23
15 30 24 20 17 47 -17 64 -39 20 -41 20 -61 -2z"/>
<path d="M5480 12203 c1 -10 7 -29 15 -43 7 -14 11 -37 8 -52 -3 -14 -1 -34 5
-44 6 -11 7 -27 2 -40 -7 -16 -4 -28 11 -45 11 -12 22 -34 26 -48 3 -14 13
-36 20 -48 11 -16 13 -37 8 -77 -9 -67 12 -112 46 -101 11 4 34 1 50 -5 33
-14 38 -47 14 -94 -8 -15 -15 -42 -15 -58 0 -30 1 -30 38 -22 43 10 96 9 133
-1 20 -5 33 0 58 20 32 27 32 27 86 4 83 -36 89 -94 12 -113 -41 -11 -47 -21
-17 -31 11 -3 20 -13 20 -21 0 -8 8 -17 18 -21 31 -11 82 -71 82 -96 0 -14 7
-30 15 -37 8 -7 15 -21 15 -31 0 -27 -55 -26 -70 1 -6 11 -16 20 -23 20 -7 0
-18 9 -25 20 -7 11 -18 20 -26 20 -20 0 -40 28 -51 73 -6 22 -16 42 -23 45
-15 5 -46 -64 -63 -142 -12 -57 -12 -60 9 -74 12 -8 22 -20 22 -28 0 -7 9 -19
19 -26 26 -18 62 -117 70 -188 6 -55 6 -55 52 -55 57 0 79 -17 79 -61 0 -39
23 -47 40 -14 24 45 65 7 53 -50 -4 -20 -15 -36 -30 -43 -32 -14 -28 -51 7
-55 19 -1 31 7 50 32 25 35 43 47 93 66 27 10 37 30 15 30 -18 0 -78 58 -78
76 0 21 -18 17 -30 -6 -18 -33 -40 -25 -40 15 0 26 9 45 36 75 20 22 34 44 30
48 -4 4 -49 7 -99 8 -92 0 -92 0 -89 31 3 27 -3 34 -52 67 -66 44 -85 71 -64
93 15 14 48 9 48 -8 0 -5 6 -9 13 -9 6 0 38 -18 70 -40 53 -37 68 -42 164 -56
95 -13 108 -13 130 1 27 18 22 35 -11 35 -13 0 -35 9 -49 20 -14 11 -30 20
-35 20 -18 0 -92 97 -92 121 0 12 -6 30 -14 38 -27 29 -47 145 -36 203 17 88
53 94 64 10 16 -123 67 -205 74 -119 2 23 8 37 17 37 27 0 35 -73 10 -106 -8
-10 -15 -27 -15 -36 0 -10 -9 -22 -20 -28 -18 -10 -16 -14 29 -60 47 -48 82
-62 96 -39 4 5 -6 15 -23 21 -27 10 -30 17 -35 67 -7 65 -4 71 33 71 31 0 43
-19 34 -56 -6 -25 28 -73 53 -74 7 0 16 -7 21 -16 19 -34 109 -53 251 -54 131
0 135 -1 187 -31 30 -17 54 -36 54 -43 0 -14 -62 -26 -133 -26 -44 0 -103 -33
-113 -62 -3 -10 -12 -18 -19 -18 -21 0 -28 -19 -10 -26 10 -4 24 2 36 15 24
25 93 30 103 6 7 -19 -41 -75 -64 -75 -10 0 -21 -4 -25 -9 -9 -15 50 -51 83
-51 29 0 30 3 37 51 4 28 18 67 31 87 13 19 24 38 24 41 0 4 14 12 31 18 29
11 33 10 51 -12 10 -14 37 -29 58 -35 22 -6 42 -15 45 -20 8 -12 -33 -38 -74
-46 -27 -6 -33 -4 -38 15 -7 26 -7 26 -36 -1 -15 -15 -26 -39 -30 -67 -3 -25
-12 -48 -21 -53 -18 -10 -22 -38 -5 -38 15 0 50 19 80 45 15 12 48 25 75 29
57 7 74 -2 154 -82 58 -59 62 -64 125 -160 21 -33 48 -65 60 -70 33 -14 103 6
122 34 15 24 15 26 -13 55 -25 26 -29 38 -29 87 0 31 3 72 7 90 7 30 5 34 -22
44 -17 5 -30 14 -30 19 0 8 -29 43 -121 145 -15 16 -46 40 -68 54 -23 13 -50
39 -61 57 -11 18 -32 39 -47 46 -15 6 -35 18 -43 25 -8 7 -43 35 -78 63 -44
36 -65 59 -69 81 -3 16 -11 31 -17 33 -67 17 -99 32 -117 51 -31 33 -49 31
-49 -6 0 -25 -6 -33 -35 -47 -47 -23 -53 -12 -26 52 30 71 23 88 -52 125 -34
17 -67 37 -72 44 -6 8 -25 17 -43 20 -17 4 -32 11 -32 16 0 5 -30 23 -67 41
-38 18 -71 38 -75 45 -4 6 -25 15 -45 19 -21 4 -45 13 -53 20 -8 7 -41 18 -72
25 -32 6 -60 16 -63 21 -4 5 -28 9 -55 9 -27 0 -61 5 -75 12 -22 10 -29 8 -53
-15 -16 -15 -31 -27 -35 -27 -4 0 -20 -9 -35 -20 -15 -11 -47 -23 -72 -26 -45
-6 -45 -6 -63 34 -10 22 -29 47 -42 56 -16 10 -25 26 -25 42 0 14 -5 35 -12
47 -6 12 -15 64 -19 114 -9 100 -27 136 -90 179 -16 10 -32 27 -35 37 -3 9
-10 17 -15 17 -5 0 -9 -8 -9 -17z m936 -825 c8 -13 -22 -38 -48 -38 -18 0 -25
29 -11 43 11 11 51 8 59 -5z m433 -74 c15 -33 7 -44 -33 -44 -46 0 -65 24 -41
50 26 28 59 26 74 -6z m-254 -44 c33 -53 32 -70 -4 -70 -33 0 -46 13 -56 57
-13 65 23 72 60 13z m-85 -7 c0 -37 -17 -49 -39 -29 -30 27 -26 46 9 46 22 0
30 -5 30 -17z m748 -361 c2 -14 -2 -22 -12 -22 -19 0 -28 14 -20 35 9 21 28
14 32 -13z"/>
<path d="M5724 12176 c-11 -28 37 -96 68 -96 21 0 24 30 7 79 -9 25 -16 31
-40 31 -16 0 -32 -6 -35 -14z"/>
<path d="M11004 12155 c25 -19 46 -19 46 0 0 10 -10 15 -32 15 -31 -1 -32 -1
-14 -15z"/>
<path d="M6196 12144 c-3 -9 -6 -25 -6 -37 0 -12 -9 -35 -20 -52 -20 -31 -27
-65 -12 -65 29 0 82 94 82 146 0 28 -34 34 -44 8z"/>
<path d="M10690 12140 c-6 -11 -8 -31 -4 -45 6 -22 11 -25 55 -25 66 0 67 23
2 68 -38 27 -40 27 -53 2z"/>
<path d="M10555 12130 c-3 -6 -3 -19 0 -30 5 -15 0 -21 -20 -26 -36 -9 -29
-38 10 -42 17 -2 38 -10 47 -19 12 -11 21 -12 36 -4 13 7 22 7 30 -1 6 -6 21
-16 34 -22 12 -6 24 -22 26 -34 4 -27 14 -28 35 -4 23 25 22 27 -18 52 -19 12
-38 33 -41 46 -4 17 -13 24 -30 24 -15 0 -30 10 -41 28 -27 42 -54 55 -68 32z"/>
<path d="M13511 12131 c-34 -6 -34 -6 -3 -38 32 -36 56 -42 66 -18 6 17 -10
66 -21 64 -5 -1 -23 -4 -42 -8z"/>
<path d="M3190 12085 c-20 -24 3 -185 24 -165 2 3 6 43 8 89 3 86 -6 107 -32
76z"/>
<path d="M10837 12086 c-2 -6 5 -36 15 -66 17 -48 17 -60 6 -94 -11 -36 -10
-40 6 -50 11 -6 27 -19 37 -28 10 -9 45 -24 79 -32 58 -15 112 -44 135 -73 17
-21 86 6 79 32 -7 20 -67 85 -79 85 -9 0 -113 115 -136 150 -8 13 -12 11 -29
-10 -20 -24 -21 -25 -35 -6 -8 11 -15 26 -15 34 0 19 -58 72 -63 58z"/>
<path d="M11128 12078 c-3 -44 2 -60 28 -94 28 -36 61 -45 70 -19 4 9 19 15
35 15 35 0 48 23 25 45 -21 22 -20 32 4 40 11 3 20 11 20 16 0 16 -31 23 -50
11 -13 -8 -29 -8 -52 -2 -55 16 -78 13 -80 -12z"/>
<path d="M13354 12089 c-3 -6 0 -17 7 -25 18 -17 44 -2 36 20 -7 18 -33 21
-43 5z"/>
<path d="M13430 12047 c-46 -21 -48 -57 -4 -57 27 0 33 -24 9 -34 -16 -6 -21
-61 -7 -70 17 -10 141 35 157 56 18 26 9 38 -38 54 -18 6 -38 22 -45 37 -14
29 -32 32 -72 14z"/>
<path d="M6470 12020 c0 -11 5 -20 11 -20 6 0 26 -12 44 -27 18 -16 52 -41 74
-56 33 -23 40 -33 35 -49 -9 -30 50 -77 98 -78 42 0 55 12 33 30 -8 7 -15 26
-15 42 0 18 -6 31 -17 35 -10 4 -31 17 -46 30 -16 13 -34 23 -42 23 -7 0 -18
7 -25 15 -7 8 -23 15 -36 15 -12 0 -30 8 -40 17 -15 16 -60 43 -70 43 -2 0 -4
-9 -4 -20z"/>
<path d="M9058 12029 c-26 -14 -22 -29 7 -29 18 0 25 5 25 20 0 22 -7 24 -32
9z"/>
<path d="M5181 12021 c-19 -12 -6 -28 30 -36 27 -6 30 -10 24 -33 -7 -27 8
-44 32 -35 21 8 16 51 -7 58 -11 3 -20 10 -20 15 0 10 -29 40 -38 40 -4 0 -13
-4 -21 -9z"/>
<path d="M8648 11942 c-148 -120 -248 -195 -272 -207 -12 -5 -25 -15 -29 -22
-4 -7 -13 -13 -18 -13 -6 0 -34 -23 -62 -51 -29 -28 -67 -58 -84 -65 -18 -8
-33 -18 -33 -22 0 -4 -25 -34 -55 -66 -30 -33 -55 -66 -55 -73 0 -7 -9 -13
-19 -13 -10 0 -40 -20 -67 -45 -26 -25 -51 -45 -55 -45 -4 0 -24 -24 -43 -52
-19 -29 -58 -75 -86 -102 -30 -30 -50 -58 -50 -71 0 -14 -11 -30 -27 -41 -62
-40 -103 -94 -103 -134 0 -24 5 -40 15 -44 19 -7 20 -44 1 -65 -28 -33 -61
-181 -40 -181 3 0 15 11 26 25 11 14 26 25 33 25 7 0 16 13 20 29 3 16 13 35
21 42 8 6 14 17 14 24 0 21 43 105 84 168 43 63 62 70 119 41 51 -25 67 -52
60 -100 -6 -48 7 -62 32 -34 10 11 23 20 30 20 18 0 53 54 61 95 4 24 13 39
25 42 13 4 19 14 19 34 0 36 -17 37 -66 4 -48 -32 -82 -32 -123 3 -41 34 -37
66 10 76 24 4 34 15 50 52 15 33 29 49 50 56 16 5 34 19 40 29 5 10 25 25 43
33 24 10 36 23 40 43 7 30 38 73 53 73 5 0 14 -17 19 -37 10 -38 10 -38 27 -6
9 18 36 47 58 65 23 18 54 58 70 88 33 65 92 125 114 116 10 -3 15 -18 15 -42
0 -44 24 -42 28 2 6 73 21 104 51 104 21 0 30 -6 35 -22 10 -38 6 -72 -9 -92
-8 -11 -15 -28 -15 -38 0 -22 -63 -88 -83 -88 -48 0 -247 -155 -247 -192 0 -8
-7 -23 -15 -34 -8 -10 -15 -28 -15 -38 0 -18 1 -18 18 -3 10 10 23 17 29 17
14 0 63 -86 63 -109 0 -19 53 -63 85 -71 11 -3 21 -16 23 -28 3 -20 -1 -22
-38 -22 -58 0 -113 35 -139 87 -12 24 -21 49 -21 56 -1 28 -16 38 -43 28 -32
-13 -36 -45 -8 -75 30 -34 34 -72 10 -95 -21 -19 -21 -19 3 -53 69 -98 112
-132 123 -97 7 21 53 26 85 9 29 -15 70 23 70 66 0 19 -4 34 -9 34 -5 0 -12 7
-15 16 -5 14 0 15 41 9 27 -3 59 -13 71 -22 24 -15 25 -20 11 -108 -1 -5 4
-98 11 -206 11 -178 11 -198 -4 -228 -9 -17 -14 -36 -10 -42 4 -6 8 -47 11
-90 4 -79 4 -79 -22 -79 -39 0 -62 -16 -74 -51 -6 -17 -20 -33 -31 -36 -11 -3
-20 -11 -20 -18 0 -22 27 -25 46 -4 12 13 30 19 60 19 51 0 64 -23 40 -72 -9
-17 -16 -43 -16 -58 0 -14 -5 -31 -12 -38 -8 -8 -8 -15 3 -28 9 -11 15 -46 16
-103 1 -47 7 -108 13 -136 11 -50 7 -235 -5 -255 -12 -20 -55 -11 -64 13 -10
24 -98 117 -113 117 -4 0 -8 6 -8 14 0 22 -19 30 -26 11 -4 -9 1 -22 12 -31
17 -13 14 -14 -31 -8 -74 9 -82 12 -105 45 -12 16 -27 29 -35 29 -7 0 -27 12
-44 26 -31 26 -31 26 -49 4 -18 -22 -18 -22 -78 -5 -87 25 -110 50 -78 86 14
16 14 21 -6 58 -11 23 -27 41 -35 41 -20 0 -38 47 -32 85 4 23 -4 42 -29 80
-19 28 -50 73 -69 102 -19 29 -44 57 -56 63 -14 8 -19 19 -17 37 2 21 -2 28
-22 34 -56 16 -135 66 -138 86 -4 30 -36 55 -64 51 -21 -3 -23 -7 -20 -47 4
-58 14 -69 69 -73 44 -3 47 -5 77 -58 29 -53 41 -70 94 -128 12 -14 22 -29 22
-33 0 -14 84 -131 97 -136 8 -3 13 -22 13 -44 0 -21 4 -39 9 -39 12 0 34 -67
26 -80 -9 -15 -26 -12 -40 7 -13 17 -14 17 -32 0 -31 -27 -62 -21 -99 21 -19
20 -45 49 -59 63 -14 15 -25 32 -25 38 0 6 -5 20 -12 31 -14 22 -3 39 14 22
26 -26 38 -13 38 42 0 58 -8 70 -55 81 -17 4 -37 15 -45 24 -26 29 -67 42 -80
25 -16 -18 5 -51 55 -90 41 -31 46 -68 15 -102 -38 -40 -80 -19 -80 40 0 13
-7 37 -16 53 -8 17 -18 53 -21 80 -6 51 -31 84 -79 105 -15 6 -23 20 -27 49
-11 85 -120 168 -166 127 -20 -18 -41 -5 -41 26 0 21 -24 23 -66 8 -43 -17
-84 -3 -96 31 -14 41 -54 60 -102 49 -52 -12 -64 -25 -43 -48 9 -10 17 -23 17
-29 0 -5 20 -20 45 -32 45 -22 45 -22 45 -77 0 -31 -5 -64 -11 -76 -15 -28 -6
-31 24 -7 18 13 29 34 33 59 6 36 35 80 52 80 4 0 33 -9 65 -20 47 -16 62 -17
78 -7 16 10 21 9 29 -3 13 -20 13 -57 0 -65 -5 -3 -7 -19 -3 -35 7 -37 -2 -38
-80 -6 -58 24 -58 24 -66 3 -15 -37 -67 -69 -109 -65 -37 3 -37 3 -42 -47 -5
-48 -6 -50 -35 -48 -32 3 -39 3 -97 1 -71 -2 -91 9 -85 45 28 177 28 177 54
177 13 0 26 -7 30 -17 10 -28 43 -73 54 -73 5 0 14 12 20 28 7 15 16 37 21 48
8 17 5 28 -13 53 -27 36 -39 38 -65 10 -14 -16 -29 -20 -64 -18 -39 2 -91 -6
-112 -18 -4 -2 0 -22 8 -45 20 -56 18 -83 -8 -112 -24 -25 -103 -41 -129 -25
-7 4 -19 3 -26 -2 -14 -12 41 -94 70 -104 19 -7 36 -20 80 -61 12 -11 30 -23
40 -27 9 -3 17 -11 17 -17 0 -6 11 -15 25 -20 14 -5 31 -25 40 -45 33 -79 78
-15 55 79 -18 76 -12 89 34 68 23 -10 36 -23 37 -37 3 -67 4 -70 26 -73 12 -2
27 5 35 17 15 22 57 41 89 41 35 0 26 -59 -11 -71 -38 -14 -42 -54 -7 -65 12
-3 29 -12 37 -19 8 -7 27 -15 42 -19 15 -3 30 -15 33 -26 10 -31 42 -44 61
-25 8 8 20 15 25 15 5 0 9 6 9 13 0 7 11 28 24 45 72 99 49 215 -59 287 -50
34 -64 36 -112 14 -69 -31 -84 -17 -33 32 53 52 132 66 164 30 11 -11 27 -21
36 -21 18 0 80 -54 80 -69 0 -4 9 -20 20 -33 28 -37 56 -151 46 -190 -3 -13
-37 -56 -76 -95 -68 -70 -86 -103 -56 -103 16 0 37 18 61 52 12 18 18 20 37
11 13 -7 79 -14 148 -18 78 -4 144 -13 180 -25 30 -10 71 -22 90 -26 19 -3 44
-13 55 -20 11 -8 30 -14 43 -14 14 0 41 -8 61 -19 66 -34 131 -61 146 -61 7 0
20 -6 28 -14 8 -8 29 -22 48 -30 82 -38 192 -106 264 -162 22 -17 50 -35 63
-39 33 -10 150 -129 154 -157 2 -18 10 -24 37 -26 19 -2 50 -14 70 -28 65 -44
111 -24 74 32 -17 27 -18 93 -20 1496 -1 808 -5 1473 -8 1478 -10 16 -14 13
-127 -78z m-32 -477 c7 -28 1 -132 -8 -141 -10 -10 -54 25 -67 52 -14 31 3 81
31 90 10 3 18 10 18 15 0 20 20 8 26 -16z m-113 -110 c-3 -27 16 -72 33 -79
22 -9 16 -38 -13 -62 -30 -23 -27 -52 7 -61 15 -4 20 -14 20 -38 0 -29 4 -34
30 -40 24 -5 31 -13 36 -41 10 -52 -6 -61 -58 -35 -25 11 -49 21 -54 21 -5 1
-25 26 -44 57 -19 31 -44 66 -55 77 -10 11 -22 41 -26 66 -4 25 -9 54 -11 65
-2 14 3 21 19 23 12 2 25 12 28 23 16 49 93 70 88 24z"/>
<path d="M8430 11226 c0 -36 15 -55 31 -39 10 10 -10 73 -23 73 -4 0 -8 -15
-8 -34z"/>
<path d="M11363 12023 c-18 -7 -16 -24 4 -38 18 -13 10 -35 -13 -35 -8 0 -14
-6 -14 -13 0 -18 73 -87 92 -87 25 0 29 26 7 51 -21 24 -24 55 -9 79 14 23 46
-1 42 -32 -1 -15 6 -32 18 -43 14 -13 20 -31 20 -62 0 -38 3 -45 26 -53 34
-13 47 -4 41 29 -3 14 -1 33 4 42 6 12 1 25 -19 47 -38 43 -48 55 -61 79 -7
14 -25 23 -53 28 -24 3 -50 8 -58 10 -8 2 -21 1 -27 -2z"/>
<path d="M5070 11994 c0 -14 -4 -33 -10 -43 -10 -20 -59 -44 -80 -39 -7 2 -15
-3 -17 -9 -3 -7 3 -13 11 -13 9 0 31 -20 48 -44 28 -41 34 -44 62 -38 17 3 41
6 54 7 29 0 29 30 1 46 -19 10 -21 17 -15 60 5 37 3 55 -10 74 -21 33 -44 32
-44 -1z"/>
<path d="M2715 11984 c-15 -15 -14 -19 11 -45 15 -16 34 -29 41 -29 18 0 17
55 -3 74 -20 20 -29 20 -49 0z"/>
<path d="M13260 11975 c0 -35 23 -65 52 -65 39 0 41 51 3 68 -35 16 -55 15
-55 -3z"/>
<path d="M9113 11943 c-49 -17 -51 -22 -20 -50 21 -21 38 -27 65 -24 13 1 18
77 5 84 -5 2 -27 -2 -50 -10z"/>
<path d="M6062 11890 c-12 -16 -22 -33 -22 -38 0 -13 36 -22 85 -22 22 0 52
-6 66 -14 14 -7 43 -16 65 -20 21 -4 46 -13 54 -21 8 -7 27 -15 42 -19 27 -6
89 -43 118 -69 8 -8 51 -31 94 -52 44 -21 91 -49 105 -61 48 -43 116 -93 151
-113 19 -10 48 -33 64 -50 17 -17 36 -31 44 -31 21 0 105 -78 118 -110 9 -21
23 -32 51 -39 21 -6 56 -28 78 -48 22 -21 64 -59 93 -85 29 -25 52 -49 52 -52
0 -6 67 -73 110 -110 46 -38 66 -34 90 18 11 25 20 49 20 55 0 6 9 15 20 21
11 6 20 17 20 24 0 7 9 21 20 31 22 19 28 69 8 63 -6 -2 -15 -12 -20 -21 -4
-9 -13 -25 -18 -34 -6 -10 -16 -30 -22 -44 -18 -42 -88 -63 -88 -25 0 28 -60
107 -78 102 -9 -2 -26 -7 -38 -10 -37 -11 -59 83 -35 148 12 29 1 40 -47 51
-25 5 -33 3 -39 -11 -4 -10 -2 -19 5 -22 7 -2 19 -11 28 -19 18 -18 2 -43 -28
-43 -22 0 -88 50 -88 66 0 6 -7 17 -15 24 -10 8 -15 31 -15 71 0 51 -4 61 -27
84 -15 14 -33 25 -40 25 -18 0 -16 -55 2 -70 8 -7 15 -19 15 -26 0 -21 -28
-17 -35 6 -3 11 -15 20 -25 20 -23 0 -47 36 -56 85 -7 37 -7 37 -58 32 -50 -6
-52 -5 -83 33 -18 21 -33 50 -33 64 0 21 -5 25 -37 28 -36 3 -38 5 -37 36 2
38 -30 53 -72 33 -18 -8 -31 -8 -45 0 -11 6 -27 8 -34 5 -8 -3 -24 12 -39 35
-15 21 -31 39 -37 39 -5 0 -23 14 -39 32 -28 30 -30 31 -49 14 -18 -16 -23
-16 -97 4 -44 12 -98 30 -122 41 -58 26 -74 24 -100 -11z"/>
<path d="M5350 11890 c0 -13 9 -22 25 -26 35 -9 42 1 20 26 -23 26 -45 26 -45
0z"/>
<path d="M10560 11893 c1 -16 39 -53 54 -53 16 0 23 35 9 43 -18 10 -63 17
-63 10z"/>
<path d="M4840 11851 c0 -5 9 -13 20 -16 14 -4 20 -15 20 -35 0 -19 7 -33 19
-40 40 -21 42 -3 6 44 -14 18 -25 38 -25 44 0 7 -9 12 -20 12 -11 0 -20 -4
-20 -9z"/>
<path d="M5187 11854 c-11 -12 3 -24 29 -24 27 0 32 15 8 24 -20 8 -29 8 -37
0z"/>
<path d="M4694 11835 c-4 -8 4 -36 15 -61 18 -38 24 -44 36 -34 16 13 45 7 45
-10 0 -5 -9 -10 -20 -10 -28 0 -34 -21 -24 -78 8 -40 13 -48 34 -50 31 -5 50
-20 50 -40 0 -17 39 -78 82 -130 15 -18 28 -39 28 -47 0 -20 26 -19 34 1 4 9
0 27 -9 40 -8 13 -15 30 -15 39 0 19 29 20 36 0 4 -8 10 -15 15 -15 15 0 10
32 -8 52 -10 11 -22 34 -28 51 -6 21 -18 33 -31 35 -12 2 -36 19 -55 38 -29
30 -32 37 -21 54 8 13 8 21 1 26 -6 4 -8 20 -4 40 5 29 3 34 -14 34 -11 0 -25
8 -30 19 -10 18 -81 61 -102 61 -5 0 -12 -7 -15 -15z"/>
<path d="M5417 11830 c8 -30 31 -46 39 -26 9 24 -3 46 -25 46 -14 0 -18 -5
-14 -20z"/>
<path d="M12045 11794 c-33 -80 -7 -137 70 -148 41 -7 46 -11 64 -51 34 -77
104 -90 127 -23 11 33 10 38 -7 54 -15 13 -19 31 -19 80 0 85 -28 146 -44 96
-4 -10 -21 -25 -39 -34 -29 -14 -35 -14 -65 0 -18 9 -35 26 -38 39 -9 34 -32
28 -49 -13z"/>
<path d="M9022 11803 c2 -10 10 -18 18 -18 22 0 18 29 -3 33 -14 3 -18 -1 -15
-15z"/>
<path d="M9257 11783 c-4 -3 -7 -39 -7 -79 0 -84 29 -151 59 -138 37 15 54 16
75 4 29 -15 66 -10 79 12 8 12 4 29 -16 68 -47 91 -28 132 34 71 16 -16 29
-32 29 -35 0 -3 15 -29 33 -58 18 -29 38 -65 45 -80 6 -16 16 -28 21 -28 5 0
13 -21 17 -47 3 -27 13 -56 21 -65 20 -23 29 -103 13 -113 -18 -11 -31 8 -37
54 -5 38 -9 43 -54 62 -27 12 -54 27 -60 35 -6 8 -21 14 -33 14 -11 0 -41 14
-66 31 -56 38 -74 35 -78 -14 -3 -36 -1 -38 42 -57 33 -14 46 -25 46 -40 0
-18 5 -20 41 -18 38 3 43 0 52 -25 13 -39 -1 -51 -52 -42 -31 5 -41 11 -41 25
0 26 -15 33 -30 15 -10 -13 -10 -19 4 -33 29 -33 -9 -45 -44 -14 -11 9 -31 27
-43 38 -15 15 -31 20 -52 17 -16 -2 -43 1 -60 8 -43 17 -119 15 -123 -3 -5
-24 22 -38 79 -44 71 -7 95 -20 109 -58 7 -17 18 -43 26 -58 10 -19 11 -29 3
-33 -6 -4 -19 -20 -28 -36 -18 -30 -18 -30 -35 -4 -17 26 -46 34 -46 12 0 -27
32 -56 68 -63 20 -4 47 -13 59 -21 16 -11 46 -14 112 -11 88 3 90 2 122 -27
60 -56 98 -100 99 -112 0 -7 4 -13 10 -13 5 0 16 -16 24 -35 8 -19 20 -35 25
-35 19 0 23 44 15 176 -3 71 -7 197 -8 279 -2 115 -6 157 -18 180 -8 17 -19
46 -23 65 -8 38 -39 106 -60 130 -7 8 -16 26 -20 40 -12 41 -55 98 -78 103
-26 6 -123 -13 -154 -31 -32 -18 -42 -15 -53 13 -9 24 -29 32 -43 18z m118
-93 c8 -13 -5 -60 -17 -60 -15 0 -59 50 -53 60 8 13 62 13 70 0z m73 -471 c18
-10 42 -19 52 -19 10 0 32 -11 48 -25 17 -14 37 -25 45 -25 23 0 36 -23 43
-71 8 -57 -14 -83 -46 -54 -11 10 -20 24 -20 31 0 9 -10 11 -35 7 -27 -4 -41
0 -67 21 -32 26 -41 33 -100 77 -28 20 -34 42 -22 74 8 20 52 13 102 -16z"/>
<path d="M2400 11756 c0 -14 7 -43 15 -63 10 -24 14 -52 10 -77 -4 -29 -1 -50
12 -73 86 -151 98 -188 68 -213 -13 -11 -19 -10 -38 7 -35 30 -102 73 -115 73
-23 0 -12 -18 17 -28 17 -6 41 -28 55 -49 49 -74 65 -90 76 -73 5 8 10 21 10
28 0 20 24 13 44 -15 22 -30 31 -83 28 -171 -1 -51 3 -73 23 -110 14 -26 25
-60 25 -77 -1 -42 -17 -107 -29 -114 -5 -4 -15 -19 -20 -35 -6 -15 -20 -30
-31 -33 -21 -6 -28 -23 -9 -23 14 0 5 -56 -12 -77 -6 -7 -22 -13 -35 -13 -30
0 -30 -11 0 -59 15 -24 21 -42 15 -48 -5 -5 -6 -31 -3 -57 7 -47 7 -47 45 -10
23 23 39 48 39 61 0 13 5 23 10 23 6 0 10 -14 10 -31 0 -21 9 -39 31 -58 25
-23 29 -33 23 -55 -5 -22 0 -33 30 -63 40 -40 44 -54 21 -73 -12 -10 -21 -10
-41 -1 -35 16 -44 7 -44 -45 0 -69 52 -75 75 -8 20 60 52 59 92 -3 17 -27 33
-59 35 -72 5 -38 26 -36 45 4 15 31 15 40 4 68 -8 18 -16 48 -18 69 -3 22 -16
46 -33 63 -26 24 -28 33 -24 74 6 53 4 56 -54 95 -102 69 -132 104 -132 152 0
25 9 69 19 100 11 30 23 74 26 97 6 41 44 97 65 97 11 0 13 -8 10 -66 -1 -23
6 -59 16 -80 9 -22 16 -50 15 -64 -1 -14 5 -43 14 -64 15 -35 19 -38 47 -32
40 8 42 10 28 35 -6 12 -8 26 -5 32 4 5 -7 25 -24 45 -21 23 -31 45 -31 67 0
51 -36 203 -54 228 -9 13 -16 43 -16 68 0 43 -11 88 -33 141 -6 14 -12 51 -13
82 -1 53 -5 61 -53 116 -28 33 -51 64 -51 69 0 5 -13 19 -29 30 -23 17 -30 32
-35 75 -9 63 -27 95 -58 100 -12 2 -28 13 -34 26 -17 35 -24 38 -24 8z"/>
<path d="M5195 11771 c-3 -6 4 -15 15 -21 23 -12 25 -20 8 -43 -12 -15 -17
-15 -57 -1 -24 8 -53 21 -65 29 -27 19 -50 19 -67 -1 -21 -26 40 -73 91 -71
41 1 110 -30 110 -50 0 -20 17 -23 46 -8 37 19 123 19 148 0 22 -17 72 -20 81
-5 3 5 -1 23 -9 39 -14 27 -22 30 -83 37 -42 4 -77 14 -92 25 -13 11 -29 19
-36 19 -6 0 -25 13 -41 30 -31 32 -40 35 -49 21z"/>
<path d="M10674 11749 c3 -17 1 -39 -5 -50 -8 -16 -4 -29 18 -64 29 -45 57
-57 81 -33 15 15 16 48 1 48 -5 0 -17 17 -26 38 -33 81 -82 123 -69 61z"/>
<path d="M11310 11740 c0 -13 10 -24 25 -30 14 -5 25 -16 25 -23 0 -21 32 -46
68 -53 37 -8 45 13 12 34 -11 7 -20 19 -20 27 0 10 -10 15 -30 15 -16 0 -30 4
-30 9 0 5 -7 17 -16 25 -21 22 -34 20 -34 -4z"/>
<path d="M11173 11703 c-7 -2 -13 -14 -13 -25 0 -16 5 -19 29 -13 24 5 30 2
36 -15 7 -23 42 -40 84 -40 15 0 32 -5 39 -12 18 -18 24 -4 16 37 -7 37 -7 37
-50 30 -37 -5 -49 -2 -77 19 -34 26 -42 29 -64 19z"/>
<path d="M9077 11694 c-2 -3 4 -23 15 -45 23 -48 18 -69 -17 -69 -30 0 -31 -9
-5 -60 13 -25 27 -40 39 -40 10 0 26 -11 35 -25 9 -14 25 -25 35 -25 10 0 29
-8 42 -19 13 -10 34 -21 46 -25 28 -9 42 13 19 30 -24 17 -55 81 -63 126 -4
28 -17 48 -47 74 -22 20 -53 47 -67 60 -15 13 -29 21 -32 18z"/>
<path d="M2595 11630 c-14 -23 50 -90 87 -90 36 0 33 31 -5 67 -36 33 -70 42
-82 23z"/>
<path d="M10865 11620 c-16 -25 43 -54 86 -43 29 8 23 30 -12 42 -40 14 -66
14 -74 1z"/>
<path d="M5082 11603 c-30 -58 4 -161 58 -178 13 -4 32 -18 42 -30 11 -15 37
-26 75 -34 39 -7 62 -18 71 -31 15 -25 49 -26 76 -2 41 36 144 73 187 66 32
-5 39 -4 39 10 0 46 -99 90 -114 51 -3 -8 -26 -24 -51 -36 -42 -20 -48 -20
-78 -6 -17 8 -50 18 -71 22 -22 3 -49 13 -60 21 -11 8 -37 14 -57 14 -33 0
-38 4 -62 53 -15 29 -27 60 -27 69 0 25 -18 31 -28 11z"/>
<path d="M8956 11612 c-3 -5 12 -14 35 -20 35 -9 40 -8 37 6 -3 19 -62 30 -72
14z"/>
<path d="M11112 11588 c2 -12 11 -24 21 -26 14 -3 18 1 15 20 -2 12 -11 24
-21 26 -14 3 -18 -1 -15 -20z"/>
<path d="M11357 11535 c-21 -20 -37 -39 -36 -43 1 -12 73 -69 97 -76 29 -10
30 25 2 72 -13 21 -18 41 -14 57 9 34 -7 31 -49 -10z"/>
<path d="M9460 11536 c0 -8 16 -20 36 -26 19 -7 38 -18 41 -26 7 -18 43 -18
43 0 0 30 -46 66 -84 66 -24 0 -36 -5 -36 -14z"/>
<path d="M7203 11511 c-51 -13 -53 -15 -53 -47 0 -33 1 -34 41 -34 38 0 41 -2
60 -45 24 -54 43 -57 59 -10 13 38 32 44 88 24 36 -12 44 -28 35 -70 -6 -30
-7 -31 -49 -24 -40 6 -44 4 -44 -15 0 -12 10 -25 25 -32 28 -13 30 -19 13 -36
-9 -9 -9 -16 4 -28 22 -22 39 -9 32 24 -4 20 0 33 15 46 21 19 22 19 49 -7 45
-44 128 -32 88 12 -9 10 -16 22 -16 28 0 6 -7 16 -15 23 -8 7 -15 23 -15 37 0
21 2 22 21 13 26 -14 49 -6 49 18 0 26 -20 42 -51 42 -15 0 -31 5 -35 11 -3 6
-17 8 -31 4 -14 -3 -31 -1 -40 7 -8 7 -25 17 -37 23 -13 7 -20 19 -19 33 3 21
0 22 -60 20 -34 -2 -86 -9 -114 -17z"/>
<path d="M11040 11495 c0 -21 5 -25 28 -25 15 0 34 4 42 10 14 9 10 11 -57 35
-8 3 -13 -5 -13 -20z"/>
<path d="M10951 11457 c-17 -21 -2 -87 23 -97 12 -4 30 -17 40 -29 11 -11 24
-21 31 -21 6 0 29 -18 50 -40 45 -46 95 -53 173 -23 48 18 76 7 53 -20 -16
-21 3 -67 28 -67 12 0 21 -9 25 -24 3 -14 14 -27 25 -31 10 -3 26 -14 36 -25
24 -27 65 -27 65 -1 0 11 -5 23 -11 26 -6 4 -8 22 -4 46 7 40 -8 56 -18 19 -8
-30 -34 -14 -40 23 -2 18 -11 47 -18 65 -16 38 -5 52 44 52 32 0 35 15 7 30
-14 8 -25 7 -41 -2 -18 -11 -23 -10 -36 10 -20 29 -33 28 -33 -2 0 -27 -10
-37 -43 -40 -12 -2 -31 -6 -42 -9 -11 -4 -25 -3 -31 1 -16 10 -44 68 -44 90 0
34 -23 44 -61 28 -35 -14 -64 -19 -111 -17 -21 1 -28 7 -33 31 -8 36 -19 44
-34 27z"/>
<path d="M11235 11420 c-8 -13 3 -30 20 -30 7 0 17 -9 20 -21 8 -26 29 -20 33
10 5 35 -55 69 -73 41z"/>
<path d="M4495 11340 c-9 -15 4 -30 27 -30 14 0 18 5 14 16 -3 9 -6 18 -6 20
0 8 -29 4 -35 -6z"/>
<path d="M4874 11339 c-3 -6 0 -17 7 -25 18 -17 44 -2 36 20 -7 18 -33 21 -43
5z"/>
<path d="M4552 11272 c4 -28 1 -36 -19 -45 -28 -12 -25 -31 5 -35 24 -4 52
-37 52 -62 0 -9 14 -29 30 -45 17 -16 30 -34 30 -41 0 -14 71 -25 84 -13 6 5
2 18 -10 31 -11 13 -33 43 -50 68 -16 25 -37 51 -46 58 -10 7 -18 21 -18 32 0
10 -14 33 -31 51 -32 34 -32 34 -27 1z"/>
<path d="M5060 11282 c0 -5 11 -18 25 -30 19 -17 25 -32 25 -62 0 -33 4 -40
19 -40 11 0 21 -9 25 -22 4 -19 7 -20 18 -9 10 11 10 14 1 18 -21 8 -15 41 9
49 16 5 27 1 39 -15 20 -25 35 -27 43 -5 13 33 5 50 -40 87 -50 40 -71 46 -80
22 -4 -8 -12 -15 -19 -15 -7 0 -18 7 -25 15 -13 16 -40 21 -40 7z"/>
<path d="M4992 11258 c-16 -16 -15 -38 2 -38 13 0 26 20 26 41 0 13 -14 11
-28 -3z"/>
<path d="M8066 11212 c-8 -15 -23 -36 -35 -46 -35 -32 -27 -46 27 -46 56 0 73
11 97 62 21 46 14 58 -35 58 -33 0 -42 -5 -54 -28z"/>
<path d="M5360 11211 c0 -5 7 -11 15 -15 9 -3 20 -16 25 -28 7 -19 9 -19 9 -5
1 26 -17 57 -34 57 -8 0 -15 -4 -15 -9z"/>
<path d="M10234 11146 c-6 -26 1 -46 16 -46 12 0 22 34 14 54 -9 23 -23 20
-30 -8z"/>
<path d="M12110 11146 c0 -13 -7 -29 -15 -36 -20 -17 -19 -43 3 -63 37 -33
163 -65 190 -48 24 14 9 45 -23 51 -24 4 -32 13 -41 40 -9 26 -20 38 -45 46
-18 6 -35 16 -37 23 -7 21 -32 11 -32 -13z"/>
<path d="M3705 11136 c-11 -8 -16 -19 -12 -30 9 -22 41 -17 45 8 6 27 -11 38
-33 22z"/>
<path d="M12350 11131 c0 -23 14 -41 31 -41 21 0 25 20 7 38 -14 14 -38 16
-38 3z"/>
<path d="M5224 11055 c-16 -24 -18 -25 -41 -9 -23 14 -26 14 -44 -2 -10 -9
-19 -23 -19 -31 0 -19 84 -18 100 2 7 8 19 15 26 15 16 0 19 36 4 45 -5 3 -17
-6 -26 -20z"/>
<path d="M11254 11066 c-10 -26 24 -76 51 -76 16 0 25 6 25 15 0 8 -3 15 -7
15 -5 0 -16 14 -25 30 -18 32 -35 38 -44 16z"/>
<path d="M4591 11052 c-6 -11 -24 -25 -41 -31 -28 -9 -31 -14 -28 -43 3 -30 6
-33 38 -35 19 -1 48 -3 64 -5 46 -5 54 21 25 78 -28 54 -43 64 -58 36z"/>
<path d="M5544 11057 c-3 -9 -4 -28 -2 -44 4 -40 48 -40 62 0 11 30 4 41 -32
52 -15 4 -24 2 -28 -8z"/>
<path d="M5317 11054 c-9 -9 43 -74 58 -74 16 0 26 25 18 46 -8 22 -62 42 -76
28z"/>
<path d="M6555 11049 c-73 -10 -154 -32 -163 -45 -4 -5 -26 -22 -49 -38 -51
-34 -57 -66 -18 -92 14 -9 28 -28 32 -43 3 -14 19 -38 35 -53 34 -32 36 -63 6
-119 -20 -38 -20 -44 -7 -68 25 -44 50 -38 115 28 35 37 68 61 80 61 20 0 61
-49 77 -92 10 -28 27 -21 43 18 12 28 19 34 32 28 9 -4 32 -7 50 -6 21 1 35
-3 38 -13 7 -16 34 -21 34 -5 0 5 -7 13 -16 18 -14 8 -13 12 5 43 31 50 27 59
-23 59 -38 0 -48 4 -66 30 -18 25 -28 30 -61 30 -21 0 -39 5 -39 10 0 34 -66
-23 -76 -66 -10 -42 -13 -45 -32 -35 -13 7 -17 24 -17 62 0 53 0 53 -38 62
-25 6 -42 18 -51 36 -8 14 -23 35 -35 45 -36 33 -11 47 79 44 75 -2 79 -1 121
33 24 19 57 40 72 47 65 28 1 39 -128 21z"/>
<path d="M12457 11054 c-16 -16 -6 -35 16 -32 12 2 22 10 22 18 0 16 -26 25
-38 14z"/>
<path d="M3221 11032 c-8 -14 -8 -29 -1 -47 14 -37 12 -78 -5 -101 -16 -21
-21 -129 -6 -120 17 11 51 144 51 198 0 30 -6 63 -14 73 -13 18 -14 18 -25 -3z"/>
<path d="M3573 11031 c-27 -22 -29 -31 -8 -31 8 0 15 4 15 9 0 5 9 11 21 14
12 3 18 10 14 16 -9 15 -16 13 -42 -8z"/>
<path d="M9088 11043 c-13 -3 -18 -15 -18 -43 0 -34 3 -39 30 -45 37 -8 80
-58 80 -94 0 -15 16 -59 35 -99 26 -52 34 -78 29 -98 -7 -26 -7 -26 34 -5 40
20 40 20 27 58 -7 21 -20 52 -29 68 -9 17 -16 49 -16 73 0 57 27 57 83 -2 46
-49 126 -96 164 -96 39 0 61 -18 88 -70 25 -49 32 -104 17 -128 -6 -9 -12 -1
-20 25 -7 21 -27 55 -45 76 -29 33 -39 39 -87 43 -66 6 -96 -8 -66 -31 11 -8
28 -15 38 -15 22 0 58 -34 58 -55 0 -9 -11 -20 -25 -25 -29 -11 -32 -25 -7
-34 44 -17 62 -32 62 -53 0 -17 -6 -23 -22 -23 -13 0 -33 -3 -44 -6 -18 -5
-22 0 -28 28 -3 18 -14 41 -24 50 -9 9 -26 29 -37 43 -33 44 -49 48 -79 20
-33 -30 -56 -32 -63 -5 -6 23 -43 27 -43 5 0 -15 75 -69 112 -81 23 -7 23 -26
-3 -103 -22 -68 -19 -115 8 -126 27 -10 41 17 47 90 3 39 5 71 6 73 1 7 40 0
45 -9 4 -6 13 -8 20 -5 8 3 27 0 44 -7 24 -9 36 -9 51 1 25 15 64 -1 79 -34
10 -24 36 -31 57 -16 35 23 35 341 1 381 -8 9 -18 27 -22 41 -9 29 -64 90 -82
90 -7 0 -31 16 -52 36 -35 31 -47 36 -109 41 -64 5 -71 4 -81 -16 -10 -17 -21
-21 -59 -21 -54 1 -99 32 -111 77 -8 28 -16 33 -43 26z"/>
<path d="M11477 11033 c-13 -13 -7 -31 13 -36 13 -3 20 -14 20 -30 0 -28 26
-61 41 -52 17 11 9 54 -14 72 -13 10 -26 26 -30 36 -7 18 -19 22 -30 10z"/>
<path d="M5723 11015 c-7 -19 13 -36 37 -32 8 1 15 11 15 22 0 26 -42 34 -52
10z"/>
<path d="M3630 11003 c1 -25 95 -100 105 -83 3 5 -1 12 -8 17 -8 4 -20 22 -28
38 -13 28 -70 51 -69 28z"/>
<path d="M5656 10968 c-22 -31 -20 -41 10 -69 25 -24 26 -24 40 -5 17 23 17
36 4 70 -12 32 -34 33 -54 4z"/>
<path d="M4750 10965 c-9 -11 -11 -34 -7 -74 6 -50 4 -61 -13 -76 -30 -27 -24
-46 30 -90 27 -22 54 -52 59 -66 6 -18 21 -31 45 -39 20 -6 41 -21 47 -32 11
-21 11 -21 29 2 17 23 17 23 61 -20 24 -23 58 -48 75 -56 36 -15 60 -64 41
-83 -16 -16 -45 -13 -55 6 -8 13 -28 18 -77 21 -56 4 -68 8 -72 23 -8 29 -41
24 -49 -7 -5 -18 -19 -31 -51 -45 -70 -30 -113 -21 -113 22 0 10 -8 31 -17 48
-18 30 -18 31 5 46 12 9 22 25 22 37 0 11 -10 34 -22 51 -17 24 -24 51 -28
107 -5 74 -5 74 -43 83 -25 6 -46 21 -63 43 -15 19 -30 32 -34 29 -5 -3 -6
-41 -3 -85 5 -68 3 -83 -12 -100 -14 -15 -19 -38 -20 -93 -1 -39 -7 -95 -15
-123 -17 -66 -5 -108 33 -112 26 -3 26 -3 24 92 -1 66 2 99 11 108 17 17 46
-1 50 -33 2 -13 11 -32 20 -42 11 -13 16 -35 15 -74 -1 -51 2 -60 35 -99 38
-46 59 -52 106 -35 16 7 26 19 28 38 2 22 11 30 51 44 26 9 56 15 66 12 10 -3
22 0 25 6 14 23 46 9 83 -34 22 -27 43 -43 51 -40 18 6 58 -30 77 -70 8 -16
20 -38 27 -47 10 -14 9 -23 -3 -50 -19 -43 -14 -73 16 -86 26 -12 78 -83 90
-122 4 -14 13 -32 20 -40 7 -8 25 -38 40 -66 19 -35 44 -60 80 -83 29 -19 58
-44 64 -57 6 -14 25 -28 51 -35 38 -12 42 -11 68 14 36 34 52 34 52 0 0 -16 7
-37 15 -47 8 -11 15 -30 15 -43 0 -13 6 -23 14 -23 18 0 25 20 19 53 -8 42 2
60 27 47 16 -9 25 -8 36 1 22 18 16 47 -14 63 -15 8 -35 23 -45 34 -25 27
-123 28 -130 1 -8 -30 -67 -25 -90 6 -22 31 -15 45 24 45 16 0 29 5 29 10 0 6
-4 10 -8 10 -15 0 -92 64 -92 76 0 6 -7 17 -15 24 -8 7 -15 21 -15 33 0 11
-10 36 -22 55 -16 26 -23 54 -24 97 -1 33 -2 63 -3 67 -3 18 -36 38 -61 38
-34 0 -76 40 -85 81 -4 15 -13 30 -21 33 -12 5 -14 16 -8 51 5 35 2 51 -12 73
-11 15 -24 39 -31 55 -23 52 -115 146 -160 163 -33 13 -45 24 -53 50 -8 22
-18 34 -33 36 -16 2 -23 11 -25 33 -2 17 -8 34 -13 40 -5 5 -9 17 -9 27 0 9
-9 22 -19 28 -11 5 -22 18 -26 27 -3 10 -16 26 -29 35 -21 15 -25 16 -36 3z
m588 -819 c6 -30 -17 -45 -34 -22 -8 11 -14 26 -14 34 0 21 44 10 48 -12z"/>
<path d="M13530 10917 c0 -26 27 -44 43 -28 15 15 3 46 -21 49 -18 3 -22 -1
-22 -21z"/>
<path d="M8111 10903 c-6 -12 -7 -61 -2 -131 6 -97 10 -115 29 -132 12 -12 22
-25 22 -30 0 -19 68 -32 104 -19 56 20 94 -26 44 -52 -33 -17 -38 -28 -38 -82
0 -61 13 -85 56 -103 19 -8 34 -18 34 -23 0 -13 53 -20 68 -9 17 15 15 38 -4
38 -12 0 -15 6 -10 24 7 28 -2 40 -20 25 -19 -15 -52 -3 -36 13 7 7 12 25 12
41 0 25 2 28 15 17 22 -19 25 -10 18 51 -5 40 -13 61 -32 79 -15 14 -42 45
-61 69 -31 40 -32 45 -17 56 30 22 14 45 -32 45 -23 0 -74 47 -94 86 -24 47
-43 60 -56 37z"/>
<path d="M6527 10893 c-12 -11 -8 -21 13 -28 21 -7 60 10 60 25 0 11 -63 14
-73 3z"/>
<path d="M12140 10882 c0 -10 6 -26 13 -35 11 -14 15 -14 42 9 25 20 28 26 15
34 -27 17 -70 12 -70 -8z"/>
<path d="M3590 10881 c0 -16 19 -23 40 -16 30 10 24 25 -10 25 -16 0 -30 -4
-30 -9z"/>
<path d="M5233 10823 c-22 -8 -14 -42 12 -59 14 -9 25 -24 25 -34 0 -20 26
-45 33 -33 3 4 0 36 -6 71 -10 63 -21 73 -64 55z"/>
<path d="M5615 10816 c-22 -16 -15 -29 23 -41 21 -6 23 -4 20 21 -4 33 -17 39
-43 20z"/>
<path d="M10760 10795 c-13 -16 -7 -45 9 -45 5 0 13 9 16 20 3 11 11 20 16 20
5 0 9 5 9 10 0 15 -36 12 -50 -5z"/>
<path d="M13536 10786 c-28 -23 -28 -23 4 -34 23 -8 38 -9 52 -1 20 11 20 11
-3 35 -12 13 -23 24 -23 24 -1 -1 -14 -11 -30 -24z"/>
<path d="M7897 10779 c-19 -11 -77 -122 -77 -147 0 -29 -51 -156 -75 -183 -35
-42 -32 -53 22 -83 46 -26 46 -26 70 -4 12 12 23 27 23 33 0 23 42 65 65 65
28 0 40 -14 57 -66 12 -36 17 -39 55 -45 24 -3 44 -7 46 -10 2 -2 19 -28 37
-56 25 -40 43 -56 75 -69 36 -13 41 -19 37 -40 -2 -14 0 -24 7 -24 6 0 11 12
11 26 0 27 0 27 69 20 63 -6 71 -5 80 13 18 32 13 39 -31 46 -23 4 -55 17 -71
29 -41 29 -87 73 -87 81 0 4 -13 27 -30 52 -30 44 -39 83 -20 83 20 0 9 27
-15 38 -35 16 -35 17 -35 -25 0 -47 -12 -66 -36 -61 -21 4 -32 35 -33 94 -1
46 6 59 26 43 8 -7 13 -8 13 -1 0 5 -7 15 -15 22 -8 7 -15 28 -15 46 0 54 -18
40 -61 -46 -10 -19 -36 -53 -58 -74 -38 -37 -42 -39 -68 -27 -27 12 -27 13 -8
27 10 8 24 14 30 14 7 0 17 12 24 27 12 25 10 29 -13 48 -33 26 -33 31 1 40
15 3 35 13 43 20 83 74 85 81 38 87 -18 3 -40 8 -48 11 -8 4 -23 2 -33 -4z"/>
<path d="M5647 10743 c-31 -16 -35 -48 -8 -62 10 -6 63 -22 117 -36 54 -14
105 -32 113 -39 9 -8 25 -16 36 -18 13 -2 25 -18 35 -47 20 -58 37 -63 45 -14
4 21 9 45 11 54 5 20 -21 49 -43 49 -9 0 -25 8 -36 17 -14 13 -37 18 -86 19
-66 0 -68 1 -112 46 -44 44 -46 45 -72 31z"/>
<path d="M6064 10743 c-4 -10 -15 -37 -26 -61 -32 -69 -21 -163 25 -209 14
-14 18 -14 43 6 14 11 34 21 43 21 10 0 22 5 29 12 12 12 -17 46 -59 69 -18 9
-20 17 -15 57 10 79 -22 160 -40 105z"/>
<path d="M5346 10701 c-16 -18 -16 -20 5 -35 27 -18 42 -8 37 25 -4 30 -20 34
-42 10z"/>
<path d="M9107 10676 c-7 -18 1 -26 25 -26 16 0 17 3 8 20 -13 23 -26 26 -33
6z"/>
<path d="M5415 10650 c-9 -15 43 -36 56 -23 6 6 8 16 5 22 -9 14 -53 14 -61 1z"/>
<path d="M9075 10560 c-9 -15 5 -52 18 -47 15 5 16 49 0 54 -6 2 -14 -1 -18
-7z"/>
<path d="M5544 10519 c-3 -6 -15 -8 -26 -6 -48 13 -64 -20 -23 -47 36 -24 31
-46 -22 -94 -48 -43 -48 -43 -22 -65 27 -22 42 -55 43 -92 1 -12 13 -26 33
-35 17 -8 43 -31 57 -50 14 -19 33 -45 42 -57 8 -12 13 -27 9 -33 -17 -27 -77
7 -95 54 -8 23 -13 25 -30 16 -29 -15 -25 -25 26 -72 56 -51 69 -66 93 -97 14
-19 21 -22 37 -13 13 7 25 7 35 1 7 -5 26 -6 41 -3 20 4 29 0 38 -15 13 -25
42 -27 61 -5 10 13 10 20 -4 44 -9 15 -17 38 -17 49 0 26 -21 27 -38 1 -7 -11
-18 -17 -27 -14 -24 9 -18 31 11 38 36 9 25 30 -20 36 -40 5 -76 46 -76 87 0
13 -11 30 -25 39 -24 16 -25 18 -9 35 21 23 14 53 -13 57 -14 2 -28 17 -41 45
-30 65 -33 77 -21 99 8 15 8 27 0 46 -8 17 -9 28 -1 36 5 5 10 14 10 18 0 12
-18 10 -26 -3z"/>
<path d="M6240 10497 c0 -14 40 -57 53 -57 21 0 3 41 -23 55 -24 13 -30 13
-30 2z"/>
<path d="M7000 10496 c0 -20 27 -39 45 -32 20 7 19 32 -1 40 -26 10 -44 7 -44
-8z"/>
<path d="M5704 10454 c-6 -35 -4 -40 31 -68 22 -17 48 -36 59 -41 12 -6 27
-25 35 -42 8 -18 27 -37 44 -44 16 -7 42 -23 58 -36 16 -14 33 -22 39 -18 16
10 11 43 -7 49 -18 6 -45 45 -69 98 -8 17 -23 28 -46 33 -18 4 -42 15 -53 25
-11 9 -29 22 -40 28 -11 6 -20 18 -20 28 0 34 -24 25 -31 -12z"/>
<path d="M2407 10422 c-16 -17 -15 -20 7 -41 24 -23 24 -23 41 3 31 47 -11 79
-48 38z"/>
<path d="M6130 10405 c0 -2 5 -16 12 -30 16 -35 38 -32 38 5 0 25 -4 30 -25
30 -14 0 -25 -2 -25 -5z"/>
<path d="M9115 10380 c-8 -13 3 -30 19 -30 8 0 16 -9 19 -20 3 -11 12 -20 21
-20 21 0 20 16 -2 32 -10 7 -21 21 -25 31 -7 19 -22 22 -32 7z"/>
<path d="M9628 10331 c-47 -47 -47 -47 -18 -79 17 -19 39 -32 53 -32 24 0 42
23 32 41 -5 8 7 67 22 105 12 32 -43 10 -89 -35z"/>
<path d="M3197 10334 c-11 -11 -8 -257 3 -274 20 -31 29 14 28 133 -2 110 -13
159 -31 141z"/>
<path d="M6537 10334 c-9 -10 12 -34 30 -34 19 0 12 34 -8 38 -8 1 -18 0 -22
-4z"/>
<path d="M6280 10297 c0 -13 5 -28 11 -34 6 -6 8 -17 4 -23 -6 -9 -10 -8 -17
4 -11 20 -47 21 -54 2 -9 -23 15 -56 40 -56 13 0 31 -9 41 -20 25 -28 40 -25
82 13 36 34 39 63 5 53 -26 -8 -50 10 -34 26 6 6 12 19 12 28 0 11 -6 8 -19
-9 -23 -30 -51 -22 -51 14 0 14 -4 25 -10 25 -5 0 -10 -10 -10 -23z"/>
<path d="M4664 10249 c-4 -6 -19 -9 -36 -5 -48 10 -48 -20 1 -62 23 -21 45
-50 50 -67 5 -21 14 -31 32 -33 13 -2 52 -17 87 -33 34 -16 68 -29 75 -29 8 0
24 -11 37 -25 31 -33 46 -32 65 5 9 17 20 30 25 30 5 0 15 20 21 45 6 24 17
50 25 56 21 17 17 32 -13 61 -36 33 -73 45 -84 27 -14 -22 -11 -27 26 -39 60
-20 40 -59 -31 -60 -12 0 -25 -10 -32 -25 -14 -30 -26 -32 -44 -6 -8 11 -35
29 -61 42 -51 25 -56 33 -30 47 21 12 10 42 -16 42 -11 0 -25 9 -31 20 -12 22
-54 27 -66 9z"/>
<path d="M8260 10101 c0 -19 6 -34 15 -38 23 -8 30 4 19 34 -13 39 -34 41 -34
4z"/>
<path d="M5900 10088 c0 -25 9 -42 38 -69 38 -35 38 -35 55 -13 20 27 21 40 4
51 -7 4 -20 20 -30 36 -26 41 -67 38 -67 -5z"/>
<path d="M6400 10090 c0 -20 5 -30 15 -30 16 0 19 17 9 44 -10 26 -24 18 -24
-14z"/>
<path d="M6767 10103 c-13 -12 15 -33 44 -33 31 0 40 23 13 34 -21 8 -49 8
-57 -1z"/>
<path d="M13504 10095 c-4 -9 4 -25 20 -40 32 -30 33 -48 4 -68 -29 -19 -12
-43 25 -33 22 5 24 10 22 69 0 34 -4 68 -9 75 -10 17 -55 15 -62 -3z"/>
<path d="M6267 10093 c-12 -12 -7 -50 8 -63 12 -10 15 -7 21 14 10 40 -8 70
-29 49z"/>
<path d="M8007 10089 c-24 -14 -14 -25 28 -33 29 -6 37 -13 41 -35 6 -28 6
-28 50 -13 51 17 55 28 17 44 -16 7 -35 17 -43 24 -22 17 -73 24 -93 13z"/>
<path d="M9102 10043 c4 -33 27 -40 69 -23 39 16 37 25 -10 38 -56 17 -63 16
-59 -15z"/>
<path d="M10669 10044 c-8 -23 -6 -33 11 -57 12 -15 19 -35 16 -43 -8 -21 11
-54 50 -87 18 -15 36 -37 39 -48 6 -17 12 -19 49 -14 32 5 45 3 55 -9 19 -23
78 -21 86 3 9 28 -5 51 -31 51 -33 0 -30 9 14 49 37 34 37 34 -6 27 -33 -5
-44 -3 -48 9 -10 24 -24 17 -24 -11 0 -31 -36 -31 -54 1 -18 33 -107 135 -127
146 -16 8 -21 5 -30 -17z"/>
<path d="M5071 10021 c-15 -27 -13 -52 4 -75 8 -11 15 -34 15 -52 0 -17 9 -43
21 -58 20 -25 20 -28 5 -45 -21 -23 -12 -111 12 -111 17 0 125 -69 131 -84 2
-5 14 -19 26 -30 12 -12 42 -54 66 -95 47 -79 108 -134 144 -129 31 5 32 45 2
77 -14 14 -28 37 -32 51 -6 27 -78 110 -94 110 -6 0 -18 23 -28 50 -12 34 -23
50 -35 50 -10 0 -18 8 -18 18 0 9 -9 28 -20 42 -11 14 -20 31 -20 37 0 7 -9
18 -21 25 -29 18 -59 80 -59 125 -1 35 -27 83 -46 83 -4 0 -15 7 -25 16 -16
14 -18 14 -28 -5z"/>
<path d="M6310 9977 c0 -14 7 -27 15 -31 24 -9 17 -42 -16 -76 -35 -35 -60
-33 -86 6 -14 22 -83 64 -105 64 -4 0 -8 -15 -8 -33 0 -40 34 -77 71 -77 53 0
65 -51 24 -96 -14 -15 -25 -33 -25 -40 0 -24 -54 -114 -72 -120 -11 -3 -18
-15 -18 -30 0 -24 -14 -32 -25 -14 -13 22 -25 8 -25 -29 0 -40 0 -40 -47 -43
-47 -3 -48 -4 -45 -33 8 -89 30 -106 145 -108 82 -2 82 -2 89 58 8 57 7 61
-17 78 -19 14 -25 28 -25 58 0 37 1 39 33 39 18 0 43 -7 55 -16 22 -15 24 -14
54 15 18 17 42 31 54 31 12 0 27 7 34 15 15 18 78 31 91 18 14 -14 -16 -43
-43 -43 -15 0 -19 -5 -15 -20 5 -21 -8 -29 -15 -9 -15 45 -169 -79 -160 -128
6 -26 52 -103 63 -103 5 0 9 27 9 60 0 45 5 64 19 77 10 10 22 28 26 41 4 15
13 22 23 20 22 -5 19 -51 -5 -95 -13 -25 -15 -38 -7 -60 12 -33 37 -33 74 2
14 12 56 38 93 56 140 70 137 68 137 94 0 14 -4 25 -9 25 -6 0 -22 11 -37 25
-15 14 -34 25 -43 25 -8 0 -31 16 -51 35 -33 33 -40 35 -154 49 -125 15 -148
25 -130 54 8 12 28 18 73 20 72 3 90 23 51 54 -16 13 -23 30 -24 56 -1 35 1
37 31 40 29 3 34 -1 53 -42 35 -78 60 -98 135 -103 74 -6 78 -13 34 -54 -39
-36 -27 -59 32 -59 45 0 55 20 46 97 -4 38 -13 54 -58 99 -30 30 -61 54 -69
53 -8 -1 -28 3 -43 9 -16 7 -37 12 -47 12 -10 0 -32 11 -48 25 -17 14 -35 25
-40 25 -6 0 -12 10 -14 22 -4 33 -38 37 -38 5z"/>
<path d="M12062 9977 c-25 -32 -32 -119 -12 -156 6 -12 21 -21 35 -21 46 0 74
-19 109 -75 39 -60 43 -62 85 -40 43 22 57 72 31 107 -11 15 -22 51 -26 85
-11 95 -19 102 -63 59 -20 -20 -43 -36 -50 -36 -21 0 -81 49 -81 65 0 20 -16
27 -28 12z"/>
<path d="M8293 9943 c-18 -7 -16 -20 9 -53 26 -35 38 -30 38 15 0 26 -18 51
-33 44 -1 0 -8 -3 -14 -6z"/>
<path d="M12910 9940 c-6 -64 -4 -192 3 -213 12 -35 72 -97 93 -97 20 0 74
-54 74 -74 0 -19 31 -21 48 -4 17 17 15 58 -4 79 -13 15 -14 24 -5 50 14 42
14 49 -4 49 -8 0 -15 -4 -15 -8 0 -5 -12 -14 -26 -21 -22 -10 -31 -9 -50 4
-35 23 -30 33 21 41 49 7 59 26 25 44 -28 15 -16 30 25 30 39 0 53 24 30 50
-8 9 -15 24 -15 33 0 9 -8 20 -17 26 -19 9 -183 20 -183 11z"/>
<path d="M11128 9929 c-26 -15 -22 -46 9 -72 14 -12 33 -30 42 -39 8 -10 19
-18 24 -18 12 0 -1 74 -20 110 -15 32 -27 36 -55 19z"/>
<path d="M12359 9938 c0 -2 -2 -25 -3 -53 -2 -27 -6 -62 -10 -77 -10 -33 15
-39 45 -12 10 9 36 17 58 18 22 0 37 4 34 9 -3 5 3 29 12 53 20 53 18 58 -23
43 -25 -9 -38 -8 -63 5 -30 15 -48 20 -50 14z"/>
<path d="M4892 9894 c-29 -13 -31 -17 -21 -35 8 -16 17 -19 35 -15 30 8 72
-18 76 -47 2 -12 11 -23 21 -25 30 -6 22 50 -13 86 -16 18 -30 36 -30 42 0 14
-28 11 -68 -6z"/>
<path d="M5974 9860 c-41 -16 -37 -70 6 -70 27 0 56 38 44 57 -13 21 -24 24
-50 13z"/>
<path d="M13291 9861 c-7 -5 -10 -14 -7 -20 9 -15 81 -51 101 -51 23 0 18 19
-9 29 -13 5 -26 19 -29 30 -5 22 -32 27 -56 12z"/>
<path d="M8090 9833 c0 -15 23 -43 35 -43 26 0 17 37 -10 42 -14 3 -25 3 -25
1z"/>
<path d="M4714 9816 c-9 -23 4 -36 35 -36 32 0 63 27 40 34 -48 15 -70 16 -75
2z"/>
<path d="M4594 9805 c-4 -10 -20 -15 -45 -15 -36 0 -39 -2 -30 -19 9 -16 73
-61 88 -61 3 0 2 15 -1 34 -4 20 -2 37 4 41 13 8 13 35 0 35 -6 0 -13 -7 -16
-15z"/>
<path d="M6845 9770 c-7 -11 34 -23 66 -18 12 2 24 9 27 16 5 15 -84 17 -93 2z"/>
<path d="M8323 9743 c-21 -8 -14 -29 14 -42 25 -12 42 -3 43 21 0 7 -34 29
-42 27 -2 0 -9 -3 -15 -6z"/>
<path d="M4750 9724 c0 -9 9 -18 19 -21 19 -5 35 -39 25 -55 -3 -4 -16 -8 -30
-8 -71 0 -12 -77 81 -105 97 -29 163 -97 148 -154 -3 -14 -1 -21 8 -22 8 0 25
-2 39 -3 14 -1 47 -3 73 -4 36 -2 54 -8 73 -27 14 -14 34 -24 46 -22 14 1 23
-4 26 -15 2 -13 -3 -18 -17 -18 -31 0 -34 -16 -15 -73 9 -29 18 -58 20 -64 2
-7 12 -13 23 -13 13 0 28 -16 46 -49 15 -27 35 -52 44 -55 28 -11 76 -39 82
-48 3 -5 34 -11 69 -12 62 -3 62 -3 57 50 -3 28 -1 56 4 61 14 14 -47 55 -71
48 -13 -4 -23 1 -32 14 -21 34 -38 25 -38 -18 0 -22 5 -43 10 -46 6 -3 10 -13
10 -21 0 -11 -4 -12 -19 -4 -35 18 -51 41 -51 71 0 34 -36 76 -82 96 -32 14
-37 47 -11 61 19 11 14 49 -16 118 -22 49 -61 68 -87 42 -11 -10 -28 -12 -68
-8 -46 5 -61 12 -103 50 -30 28 -47 53 -46 65 5 66 -45 116 -77 76 -12 -15
-20 -17 -38 -10 -28 11 -20 29 14 29 34 0 31 26 -5 38 -16 6 -39 24 -52 41
-24 33 -59 42 -59 15z"/>
<path d="M2627 9700 c-14 -11 -27 -30 -29 -43 -2 -12 -13 -26 -25 -32 -13 -5
-23 -13 -23 -16 0 -17 60 -69 80 -69 22 0 59 -35 60 -57 0 -7 -10 -18 -22 -24
-19 -10 -25 -8 -50 20 -15 17 -33 31 -40 31 -7 0 -26 9 -43 20 -28 18 -85 28
-85 14 0 -3 9 -17 20 -31 13 -16 18 -34 14 -48 -5 -20 2 -27 45 -49 28 -14 58
-23 66 -20 8 4 31 3 51 0 42 -8 64 -49 64 -121 0 -43 2 -45 28 -45 35 0 96 33
100 54 2 9 -13 46 -33 82 -26 46 -35 73 -31 89 5 19 0 28 -19 41 -21 14 -25
24 -25 65 0 48 -21 107 -49 142 -18 22 -23 21 -54 -3z"/>
<path d="M12810 9664 c-20 -46 -25 -115 -14 -173 8 -39 22 -40 35 -2 12 35 33
45 52 26 18 -18 31 -195 28 -377 -3 -138 -3 -138 25 -148 24 -10 89 -6 136 6
35 10 28 35 -27 93 -30 32 -55 62 -55 68 0 5 -9 18 -20 28 -14 13 -20 29 -18
49 3 29 6 31 43 32 48 1 85 -14 85 -34 0 -8 11 -30 26 -49 14 -18 30 -46 35
-62 7 -20 29 -41 66 -63 34 -20 60 -44 68 -63 12 -28 13 -28 20 -10 20 51 45
53 71 3 8 -16 29 -37 45 -47 17 -11 46 -42 65 -70 26 -38 41 -51 59 -51 26 0
33 22 16 49 -7 10 -2 20 15 33 45 36 28 105 -24 93 -25 -5 -33 -2 -44 15 -7
12 -28 28 -45 35 -22 9 -33 21 -33 34 0 28 -17 35 -25 11 -10 -32 -45 -26 -45
9 0 19 -8 34 -24 44 -21 14 -131 121 -201 197 -13 14 -39 53 -59 87 -32 58
-33 63 -15 68 29 10 23 35 -11 41 -16 4 -35 13 -41 20 -6 8 -30 19 -52 25 -61
16 -87 37 -87 69 0 71 -23 78 -50 14z"/>
<path d="M3870 9686 c0 -8 5 -18 11 -21 5 -4 8 -19 4 -33 -4 -22 -1 -29 17
-37 33 -15 28 -36 -11 -50 -46 -15 -48 -27 -11 -61 18 -18 30 -39 30 -55 0
-15 7 -32 15 -39 23 -19 29 9 22 107 -3 54 -1 93 6 104 8 14 5 26 -16 58 -27
41 -67 56 -67 27z"/>
<path d="M4716 9691 c-7 -11 3 -41 14 -41 8 0 20 24 20 41 0 12 -27 12 -34 0z"/>
<path d="M6746 9676 c-45 -25 -60 -55 -51 -108 9 -49 29 -66 53 -45 9 8 31 19
47 23 17 4 45 15 64 25 18 10 39 15 46 12 8 -2 48 6 89 18 74 22 96 43 59 55
-10 3 -39 14 -65 25 -67 27 -189 25 -242 -5z"/>
<path d="M8080 9690 c0 -11 48 -25 56 -17 4 3 3 10 -1 16 -8 14 -55 14 -55 1z"/>
<path d="M10430 9661 c0 -21 5 -31 16 -31 11 0 14 8 12 27 -4 39 -28 42 -28 4z"/>
<path d="M10840 9656 c0 -7 7 -19 16 -27 9 -8 14 -22 11 -37 -3 -16 6 -38 31
-70 35 -46 35 -46 12 -64 -14 -12 -31 -16 -49 -12 -22 4 -23 4 -8 -6 24 -15
21 -43 -7 -77 -18 -21 -22 -33 -15 -44 8 -12 13 -10 26 9 21 30 37 28 74 -13
19 -20 49 -40 70 -45 43 -12 51 -20 58 -69 6 -36 14 -43 77 -61 87 -26 112 31
47 105 -49 55 -75 88 -89 111 -6 11 -20 19 -32 19 -11 0 -28 7 -38 16 -11 9
-32 23 -49 30 -34 16 -45 48 -21 61 24 13 20 36 -14 75 -19 21 -30 45 -30 64
0 22 -6 32 -26 39 -34 13 -44 13 -44 -4z"/>
<path d="M5870 9582 c0 -20 -9 -35 -31 -51 -29 -22 -31 -26 -25 -70 9 -68 -2
-111 -31 -122 -20 -7 -22 -12 -13 -29 13 -24 -2 -60 -25 -60 -8 0 -19 -9 -25
-19 -12 -24 -13 -71 -1 -71 5 0 34 -26 64 -57 48 -49 57 -55 71 -44 9 8 16 24
16 37 0 51 103 72 154 31 36 -29 30 -52 -16 -62 -55 -12 -120 -55 -112 -74 13
-28 6 -71 -16 -98 -11 -14 -20 -32 -20 -39 0 -8 -9 -19 -20 -26 -11 -7 -20
-18 -20 -24 0 -6 -9 -19 -20 -29 -11 -10 -30 -45 -42 -78 -12 -32 -30 -64 -40
-70 -13 -9 -18 -24 -18 -57 0 -28 -8 -56 -20 -75 -11 -16 -20 -36 -20 -44 0
-8 -7 -22 -15 -31 -19 -21 -26 -141 -15 -245 21 -190 68 -337 113 -354 25 -10
69 -55 87 -90 7 -14 42 -37 93 -61 96 -44 136 -43 226 6 29 16 69 37 87 47 29
14 34 23 34 52 0 37 -10 44 -30 20 -22 -27 -158 -20 -213 10 -87 49 -207 187
-207 238 0 9 -9 43 -20 74 -26 76 -29 273 -4 294 13 11 15 29 10 111 -6 97 3
127 23 76 13 -33 22 -5 19 56 -2 32 1 50 10 53 7 3 12 -4 12 -18 0 -18 3 -20
12 -11 9 9 9 15 0 24 -16 16 -15 60 2 84 14 18 15 18 21 -9 12 -47 28 -31 22
22 -4 38 -2 51 9 55 8 3 14 14 14 25 0 27 45 92 73 105 12 6 30 28 41 50 13
26 31 44 58 56 40 18 108 83 108 104 0 6 -12 23 -27 37 -27 25 -33 26 -139 25
-73 -1 -116 -6 -126 -14 -23 -19 -35 3 -48 85 -10 61 -9 76 5 103 10 19 15 49
13 78 -3 47 -3 47 47 50 93 6 81 36 -17 45 -68 6 -68 6 -68 -21z"/>
<path d="M5026 9574 c-13 -34 -6 -62 17 -67 12 -3 32 -9 45 -12 20 -7 22 -4
22 25 0 50 -68 95 -84 54z"/>
<path d="M10406 9582 c-18 -30 94 -142 156 -156 15 -3 38 -18 51 -32 30 -32
58 -28 68 10 5 16 12 32 17 35 5 3 7 25 4 49 -4 39 -6 42 -33 42 -29 0 -40
-22 -19 -35 18 -11 -1 -26 -23 -19 -38 11 -67 45 -61 69 5 20 1 23 -53 28 -32
3 -68 9 -79 12 -12 4 -25 2 -28 -3z"/>
<path d="M5566 9533 c-12 -13 -5 -39 24 -85 34 -55 79 -67 100 -28 17 32 3 63
-26 57 -17 -3 -25 1 -29 15 -7 20 -59 51 -69 41z"/>
<path d="M12032 9494 c4 -24 58 -33 58 -10 0 9 -6 16 -14 16 -8 0 -22 3 -31 6
-13 5 -16 2 -13 -12z"/>
<path d="M4728 9456 c-35 -13 -35 -17 3 -61 37 -41 49 -38 49 14 0 47 -15 61
-52 47z"/>
<path d="M13575 9436 c-25 -37 -16 -79 18 -90 22 -8 30 -7 37 4 16 25 11 76
-8 93 -24 22 -29 21 -47 -7z"/>
<path d="M2345 9363 c6 -69 14 -117 37 -230 9 -50 17 -64 37 -73 25 -11 25
-11 -2 -36 -28 -26 -35 -58 -15 -70 6 -4 17 1 25 11 10 15 16 16 25 7 9 -9 7
-16 -6 -31 -10 -11 -18 -30 -17 -43 1 -22 16 -137 22 -168 6 -27 -21 -100 -41
-113 -25 -15 -27 -69 -4 -112 14 -27 14 -33 -3 -68 -19 -43 -18 -45 46 -87 15
-10 28 -35 37 -70 17 -66 36 -89 58 -71 13 11 19 8 39 -15 22 -25 27 -27 51
-16 42 19 27 92 -19 92 -8 0 -19 8 -24 19 -6 10 -25 27 -43 38 -42 25 -64 94
-48 153 7 26 7 53 0 82 -17 75 -13 96 20 113 39 20 47 56 26 114 -20 58 -20
90 0 112 15 17 15 21 0 59 -9 22 -16 59 -16 81 0 30 -8 51 -29 78 -43 54 -81
152 -81 208 0 38 -6 54 -25 76 -45 48 -58 37 -50 -40z"/>
<path d="M3650 9424 c0 -18 34 -104 41 -104 13 0 11 84 -3 98 -12 12 -38 17
-38 6z"/>
<path d="M7433 9378 c24 -31 28 -33 83 -30 66 4 74 -3 67 -59 -10 -69 33 -91
80 -41 33 35 34 55 3 76 -14 8 -28 25 -31 37 -7 20 -12 21 -64 16 -46 -5 -63
-3 -89 13 -18 11 -42 20 -54 20 -20 0 -20 -1 5 -32z"/>
<path d="M12292 9390 c-12 -10 -18 -21 -12 -25 11 -7 60 23 60 36 0 15 -24 10
-48 -11z"/>
<path d="M10696 9381 c-8 -12 31 -44 43 -36 22 13 12 45 -13 45 -14 0 -27 -4
-30 -9z"/>
<path d="M2565 9349 c-13 -19 4 -59 25 -59 15 0 20 7 20 25 0 27 -34 53 -45
34z"/>
<path d="M4665 9299 c10 -46 9 -46 49 -41 60 7 46 58 -18 69 -38 6 -38 6 -31
-28z"/>
<path d="M12103 9310 c4 -14 7 -40 7 -57 0 -40 26 -45 40 -8 11 30 24 32 43 5
14 -21 97 -40 97 -22 0 12 -24 22 -50 22 -11 0 -24 9 -30 20 -6 11 -21 20 -34
20 -13 0 -36 10 -51 22 -28 22 -28 22 -22 -2z"/>
<path d="M6806 9298 c-2 -7 -8 -29 -15 -49 -23 -74 -3 -119 55 -119 20 0 44
-5 56 -11 16 -9 24 -7 41 9 41 38 73 38 107 1 16 -19 30 -39 30 -46 0 -7 5
-13 10 -13 30 0 -19 106 -55 120 -44 17 -18 56 29 44 16 -4 26 -2 26 5 0 6 -8
11 -17 11 -10 0 -27 7 -37 15 -11 8 -36 15 -57 15 -20 0 -53 7 -72 15 -44 18
-96 20 -101 3z"/>
<path d="M4826 9261 c-9 -14 5 -41 21 -41 8 0 17 -9 20 -20 6 -23 31 -27 39
-6 13 34 -62 96 -80 67z"/>
<path d="M10573 9245 c-3 -9 2 -22 13 -30 19 -15 19 -15 0 -30 -11 -8 -30 -15
-42 -15 -43 0 -54 -10 -54 -50 0 -22 5 -42 10 -45 6 -3 10 -20 10 -37 0 -57
101 -123 108 -70 2 12 -1 22 -7 22 -6 0 -11 9 -11 20 0 11 7 20 15 20 8 0 15
5 15 10 0 6 -7 13 -15 16 -18 7 -18 17 -4 67 11 40 36 50 59 22 7 -8 21 -15
32 -15 10 0 32 -14 47 -31 20 -21 31 -27 36 -19 8 13 51 9 128 -11 73 -19 83
-1 29 54 -23 23 -42 50 -42 58 0 25 -12 30 -32 13 -25 -23 -110 -12 -157 20
-66 46 -127 59 -138 31z"/>
<path d="M10757 9254 c-20 -20 43 -34 71 -15 10 6 8 10 -10 14 -30 9 -53 9
-61 1z"/>
<path d="M3560 9220 c0 -10 9 -24 20 -30 32 -17 27 -67 -10 -88 -35 -20 -38
-44 -10 -72 43 -43 72 -16 64 57 -6 48 -5 50 20 57 22 5 27 12 24 33 -2 14
-10 29 -18 33 -8 4 -25 12 -37 18 -33 18 -53 15 -53 -8z"/>
<path d="M6635 9210 c-7 -12 3 -50 13 -50 16 1 53 40 47 50 -8 13 -52 13 -60
0z"/>
<path d="M2570 9160 c0 -12 19 -39 41 -61 39 -39 44 -40 85 -34 62 9 66 35 5
35 -9 0 -36 18 -59 40 -45 44 -72 51 -72 20z"/>
<path d="M4821 9128 c-37 -39 -37 -42 -9 -62 16 -12 36 -14 75 -9 57 6 63 0
42 -40 -23 -43 -46 -47 -59 -12 -13 33 -27 32 -35 -4 -5 -22 -1 -35 17 -53 13
-14 31 -34 40 -46 10 -12 30 -24 45 -28 49 -12 103 -76 103 -123 0 -11 -11
-33 -25 -49 -15 -19 -21 -33 -15 -37 12 -8 13 -65 1 -65 -5 0 -14 15 -21 33
-12 32 -12 32 -23 9 -8 -18 -8 -28 1 -40 7 -10 16 -27 21 -39 14 -30 25 -34
59 -22 56 19 81 91 45 131 -23 25 -22 197 2 231 26 37 19 64 -22 87 -35 20
-81 78 -96 123 -7 17 -40 34 -88 44 -21 4 -33 -2 -58 -29z"/>
<path d="M4670 9131 c0 -5 -9 -13 -20 -16 -23 -7 -27 -43 -6 -51 18 -7 76 26
76 43 0 7 -9 17 -19 23 -24 12 -31 13 -31 1z"/>
<path d="M4323 9090 c-14 -43 -10 -315 5 -350 6 -14 11 -20 11 -14 2 25 30 21
62 -7 36 -32 64 -37 73 -13 8 20 0 33 -28 44 -29 11 -57 97 -36 110 20 12 1
31 -24 24 -24 -6 -26 -2 -38 71 -4 25 40 32 94 14 32 -10 41 -9 63 5 36 24 32
29 -37 50 -111 33 -118 36 -126 70 -9 31 -9 31 -19 -4z"/>
<path d="M6593 9076 c-4 -8 -17 -15 -28 -18 -17 -3 -20 -12 -23 -62 -3 -81 3
-86 107 -86 48 0 111 -6 141 -14 30 -8 82 -17 115 -21 33 -4 67 -13 75 -20 8
-6 35 -19 60 -27 71 -25 112 -40 156 -60 22 -10 46 -18 52 -18 7 0 15 -6 18
-14 3 -8 18 -20 32 -26 34 -14 76 -38 131 -75 24 -17 51 -34 60 -40 9 -5 18
-13 21 -17 3 -3 23 -21 45 -38 51 -41 143 -129 175 -170 14 -17 42 -50 63 -73
20 -22 37 -46 37 -51 0 -6 18 -28 39 -51 21 -22 51 -63 66 -92 14 -28 33 -57
41 -64 8 -6 14 -17 14 -23 1 -6 16 -28 35 -49 34 -39 34 -39 49 14 21 70 19
128 -5 113 -17 -10 -49 18 -73 64 -14 26 -49 73 -79 105 -29 32 -64 76 -78 99
-13 23 -40 57 -61 75 -20 19 -42 47 -48 63 -6 15 -40 51 -74 79 -42 34 -66 61
-72 83 -9 29 -16 34 -69 48 -68 18 -210 116 -225 154 -4 12 -19 30 -33 39 -24
15 -26 15 -39 -4 -12 -19 -17 -20 -63 -8 -28 6 -54 16 -59 20 -6 5 -20 9 -33
9 -16 0 -27 8 -33 25 -5 14 -14 25 -19 25 -6 0 -24 14 -41 30 -43 42 -110 36
-110 -10 0 -10 -4 -22 -10 -25 -14 -9 -153 43 -163 61 -10 18 -28 18 -21 0 3
-8 0 -17 -7 -21 -16 -10 -52 36 -38 50 14 14 11 35 -6 35 -7 0 -18 -6 -22 -14z"/>
<path d="M11050 9053 c0 -7 14 -19 30 -28 51 -26 39 -48 -22 -43 -29 3 -54 10
-55 15 -14 40 -28 45 -86 33 -60 -12 -67 -28 -21 -48 16 -8 24 -20 24 -38 0
-22 4 -25 21 -21 12 3 29 1 39 -5 12 -8 29 -8 56 -1 33 8 45 6 79 -13 22 -13
50 -28 63 -35 26 -14 29 -44 5 -58 -32 -18 36 -142 95 -172 53 -26 82 -51 82
-68 0 -23 50 -70 75 -70 11 0 29 -1 40 -3 16 -2 20 3 20 22 0 20 -6 26 -29 28
-28 4 -29 4 -22 57 4 32 2 56 -4 60 -22 14 -10 35 20 35 25 0 30 4 30 25 0 20
-5 25 -25 25 -17 0 -29 9 -39 28 -19 36 -69 73 -86 62 -14 -9 -40 -3 -40 10 0
4 9 10 20 13 13 3 20 14 20 30 0 31 -18 46 -63 54 -34 5 -79 49 -84 82 -3 23
-16 29 -80 33 -47 3 -63 1 -63 -9z m228 -176 c2 -11 -3 -17 -17 -17 -23 0 -35
15 -26 31 10 15 39 6 43 -14z"/>
<path d="M5622 9043 c2 -11 14 -19 31 -21 29 -4 35 6 15 26 -19 19 -50 15 -46
-5z"/>
<path d="M5135 9029 c-4 -5 -1 -23 5 -39 7 -16 10 -37 6 -45 -17 -44 47 -203
77 -192 15 5 67 -20 67 -33 0 -5 -13 -16 -30 -25 -17 -9 -30 -24 -30 -34 0
-11 -3 -27 -6 -36 -5 -11 0 -18 15 -22 12 -3 28 -18 37 -34 17 -34 25 -36 49
-9 25 27 45 25 71 -7 22 -27 24 -27 40 -11 17 17 17 19 -4 41 -20 21 -21 27
-11 51 10 20 10 29 1 38 -7 7 -12 24 -12 39 0 34 -15 45 -37 28 -13 -11 -19
-9 -39 16 -13 17 -40 47 -59 67 -28 29 -35 45 -35 76 0 24 -8 49 -20 64 -11
14 -24 37 -30 52 -10 27 -43 36 -55 15z"/>
<path d="M4581 9003 c-11 -21 25 -60 61 -65 16 -2 30 -18 48 -54 14 -28 31
-58 38 -67 12 -14 10 -21 -14 -51 -28 -35 -28 -35 -56 -5 -31 32 -62 38 -72
13 -9 -25 -7 -34 9 -34 8 0 19 -9 25 -20 6 -11 17 -20 25 -20 22 0 18 -15 -6
-32 -18 -12 -20 -17 -10 -35 6 -12 11 -31 11 -43 0 -12 14 -49 31 -83 27 -55
29 -63 14 -73 -13 -10 -15 -22 -9 -63 6 -45 9 -51 30 -51 17 0 29 -11 44 -40
12 -23 32 -46 45 -52 14 -6 25 -21 27 -36 4 -30 53 -71 68 -56 7 7 2 21 -15
44 -14 19 -25 40 -25 47 0 7 -13 19 -30 28 -39 20 -38 40 5 81 35 33 35 33 13
45 -13 7 -39 25 -60 41 -38 29 -38 32 -51 168 -2 19 -7 50 -11 68 -5 20 -4 32
2 32 6 0 13 14 17 31 4 17 14 33 23 36 32 12 47 73 18 73 -16 0 -27 36 -20 66
9 37 -49 94 -97 94 -28 0 -39 4 -39 15 0 20 -27 19 -39 -2z"/>
<path d="M13153 8959 c-6 -6 -29 -15 -52 -20 -23 -5 -63 -25 -90 -43 -27 -19
-59 -36 -72 -38 -28 -4 -34 -24 -20 -61 7 -17 18 -27 30 -27 11 0 25 -10 32
-22 11 -22 138 -147 150 -148 3 0 11 12 18 26 14 31 6 64 -20 82 -11 7 -19 24
-19 38 0 28 7 30 31 8 16 -14 23 -15 49 -4 46 19 46 28 0 75 -25 26 -40 49
-37 58 11 29 97 26 97 -4 0 -5 16 -25 35 -45 42 -41 43 -56 10 -100 -14 -18
-25 -42 -25 -53 0 -27 47 -51 100 -51 35 0 48 -6 81 -40 22 -22 45 -40 50 -40
6 0 18 -9 27 -19 10 -11 34 -23 55 -27 51 -9 50 17 -3 84 -22 27 -40 58 -40
68 -1 27 -54 83 -96 100 -18 8 -34 21 -34 28 0 16 -51 62 -78 71 -11 3 -24 17
-30 31 -7 14 -30 32 -56 43 -24 11 -47 24 -50 30 -9 14 -29 14 -43 0z"/>
<path d="M7750 8950 c-8 -5 -24 -10 -35 -10 -33 -1 -52 -17 -37 -32 6 -6 12
-28 12 -47 0 -45 8 -57 43 -70 61 -24 109 -4 70 28 -30 23 -46 59 -39 87 9 33
48 32 66 -1 17 -32 30 -32 30 0 0 16 -7 28 -17 31 -10 3 -26 10 -35 15 -22 11
-39 11 -58 -1z"/>
<path d="M5640 8911 c-5 -11 -10 -40 -10 -65 0 -40 3 -46 25 -52 48 -12 58 0
50 64 -4 31 -9 60 -12 65 -9 14 -42 7 -53 -12z"/>
<path d="M12066 8922 c-13 -22 8 -52 41 -58 54 -10 62 9 17 40 -42 28 -50 31
-58 18z"/>
<path d="M5293 8903 c-20 -7 -15 -21 12 -39 28 -18 75 -12 75 10 0 23 -56 42
-87 29z"/>
<path d="M10421 8856 c-11 -13 -9 -18 19 -33 17 -10 58 -38 90 -63 114 -88
130 -95 166 -75 20 11 48 16 75 13 39 -3 44 -1 47 19 2 15 -6 32 -24 48 -15
14 -32 35 -38 48 -14 28 -52 34 -76 12 -25 -23 -96 -12 -103 16 -4 14 -14 19
-39 19 -18 0 -49 3 -68 6 -26 4 -40 2 -49 -10z"/>
<path d="M5445 8837 c-17 -13 -15 -17 36 -66 57 -55 83 -67 124 -57 24 6 25 7
10 36 -8 16 -25 30 -37 32 -18 2 -24 11 -26 36 -3 31 -5 32 -46 32 -23 0 -50
-6 -61 -13z"/>
<path d="M6507 8836 c-4 -9 -39 -16 -108 -21 -61 -4 -112 -13 -123 -21 -11 -8
-27 -14 -34 -14 -8 0 -27 -11 -44 -25 -16 -14 -40 -25 -53 -25 -12 0 -28 -7
-35 -15 -7 -8 -18 -15 -24 -16 -10 0 -26 -16 -127 -129 -37 -42 -40 -48 -34
-88 4 -24 2 -49 -3 -55 -43 -54 -24 -374 26 -444 29 -40 101 -103 119 -103 8
0 31 -8 50 -17 31 -14 42 -15 82 -4 78 21 76 30 -24 106 -59 44 -115 103 -115
120 0 12 13 15 58 15 60 -1 87 -13 106 -52 9 -17 20 -22 40 -21 19 1 35 -6 48
-20 19 -22 19 -22 34 1 20 27 30 28 37 2 6 -23 37 -27 37 -5 0 9 -8 19 -17 22
-10 4 -23 13 -29 21 -8 11 -13 12 -18 4 -14 -24 -43 -10 -111 53 -51 47 -78
65 -98 65 -22 0 -30 6 -38 30 -13 35 -24 38 -39 10 -14 -27 -29 -25 -40 4 -5
13 -14 27 -19 31 -6 3 -11 22 -11 42 0 31 3 35 21 30 27 -7 35 17 15 48 -21
32 -10 58 46 111 45 44 141 81 177 69 12 -4 24 2 34 18 13 20 27 25 89 32 40
4 82 7 93 6 11 -1 40 -3 65 -5 25 -2 98 -7 163 -12 114 -7 119 -8 142 -36 14
-16 25 -36 25 -44 0 -17 26 -19 36 -3 9 15 72 4 147 -26 33 -14 74 -25 90 -25
23 0 41 -13 82 -57 30 -31 73 -66 97 -77 25 -13 49 -33 57 -50 7 -15 22 -37
32 -47 10 -10 19 -23 19 -28 0 -5 25 -21 56 -36 31 -15 59 -37 64 -49 4 -11
25 -39 46 -61 22 -21 47 -56 56 -78 10 -21 33 -57 51 -80 37 -44 67 -98 67
-118 0 -6 11 -24 25 -41 14 -16 25 -40 25 -52 0 -13 9 -34 19 -48 11 -13 27
-50 36 -82 22 -76 47 -89 111 -57 38 20 45 27 39 45 -25 84 -31 119 -27 146 3
22 -2 40 -17 60 -27 37 -26 44 3 58 39 18 38 46 -3 99 -21 27 -48 69 -60 94
-12 26 -33 59 -46 73 -14 15 -25 33 -25 41 0 8 -9 19 -20 25 -11 6 -20 16 -20
23 0 7 -18 32 -40 56 -22 23 -40 46 -40 49 0 4 -19 28 -42 53 -24 26 -62 67
-85 93 -23 25 -45 46 -48 46 -6 0 -86 62 -143 110 -13 11 -28 20 -32 20 -5 0
-28 13 -52 29 -24 16 -60 36 -80 44 -21 9 -38 20 -38 25 0 6 -15 13 -34 16
-19 4 -39 13 -46 21 -7 8 -28 17 -48 21 -19 4 -47 13 -61 20 -14 8 -35 14 -46
14 -11 0 -38 9 -60 19 -22 10 -74 21 -115 25 -41 4 -88 11 -105 16 -56 16
-183 20 -188 6z"/>
<path d="M10987 8837 c-2 -7 -2 -30 2 -52 6 -36 9 -40 39 -43 17 -2 32 -7 32
-13 0 -5 7 -9 15 -9 11 0 14 7 9 24 -4 19 -1 26 15 31 32 10 25 22 -30 49 -57
29 -75 32 -82 13z"/>
<path d="M13574 8839 c-9 -15 11 -33 30 -26 9 4 13 13 10 22 -7 17 -30 20 -40
4z"/>
<path d="M4885 8769 c-4 -6 -5 -11 -4 -13 2 -1 19 -14 37 -29 37 -30 52 -34
52 -13 0 40 -68 84 -85 55z"/>
<path d="M8274 8755 c-13 -20 -20 -23 -34 -15 -52 28 -63 2 -27 -60 20 -36 21
-40 6 -56 -13 -12 -21 -14 -37 -5 -27 15 -47 -8 -29 -33 10 -13 24 -17 62 -14
50 3 50 3 53 70 3 61 6 69 33 92 30 25 31 46 4 46 -8 0 -22 -11 -31 -25z"/>
<path d="M2674 8754 c3 -9 6 -20 6 -25 0 -5 7 -9 15 -9 18 0 18 5 5 31 -13 23
-35 26 -26 3z"/>
<path d="M10140 8760 c0 -5 -13 -10 -30 -10 -30 0 -30 0 -8 -44 32 -67 59 -77
106 -39 20 17 38 37 40 46 4 21 -37 27 -65 9 -22 -14 -43 -9 -43 9 0 5 9 9 20
9 11 0 20 7 20 15 0 8 -9 15 -20 15 -11 0 -20 -4 -20 -10z"/>
<path d="M7790 8715 c-12 -31 0 -59 30 -75 11 -6 20 -17 20 -25 0 -8 3 -15 8
-16 4 0 26 -3 49 -5 36 -4 44 -2 54 17 14 28 -12 52 -47 43 -44 -11 -65 4 -62
44 3 32 0 37 -19 40 -17 3 -26 -3 -33 -23z"/>
<path d="M10440 8711 c0 -16 38 -56 46 -49 11 12 -13 58 -31 58 -8 0 -15 -4
-15 -9z"/>
<path d="M10322 8693 c2 -11 14 -19 31 -21 31 -4 36 12 8 28 -29 15 -43 12
-39 -7z"/>
<path d="M4319 8669 c-21 -53 -8 -286 17 -296 20 -7 54 16 54 37 0 25 57 27
120 5 42 -15 44 -14 67 7 41 38 26 72 -38 85 -19 3 -47 15 -64 25 -16 10 -43
18 -58 18 -32 0 -57 45 -57 104 0 45 -24 54 -41 15z"/>
<path d="M8040 8669 c0 -33 16 -36 34 -6 8 13 7 20 -4 27 -24 16 -30 12 -30
-21z"/>
<path d="M11093 8671 c-27 -22 -29 -31 -8 -31 8 0 19 -9 25 -20 6 -11 17 -20
25 -20 17 0 20 26 5 35 -5 3 -10 17 -10 31 0 29 -7 30 -37 5z"/>
<path d="M5514 8649 c-4 -7 1 -16 10 -21 9 -5 16 -15 16 -22 0 -13 99 -96 113
-96 30 0 -42 100 -94 132 -35 21 -36 21 -45 7z"/>
<path d="M12953 8644 c-3 -8 -3 -43 0 -76 7 -83 23 -97 116 -105 69 -6 74 -8
83 -35 14 -39 38 -37 37 5 0 17 -3 40 -7 49 -9 21 -91 78 -115 78 -10 0 -30
21 -48 50 -31 51 -55 63 -66 34z"/>
<path d="M10304 8565 c-21 -32 -14 -50 31 -71 23 -11 41 -28 47 -46 6 -15 17
-28 25 -28 8 0 17 -9 20 -19 6 -25 40 -33 80 -19 28 10 35 9 53 -7 16 -15 34
-19 72 -17 58 2 80 16 76 46 -3 18 -10 21 -58 21 -36 0 -63 6 -80 18 -30 21
-47 22 -67 2 -29 -30 -109 20 -99 61 4 17 -3 30 -29 53 -43 37 -50 38 -71 6z"/>
<path d="M10530 8575 c-7 -9 -11 -17 -9 -19 49 -42 116 -64 153 -50 30 11 16
24 -26 24 -50 0 -63 7 -72 38 -8 26 -28 29 -46 7z"/>
<path d="M10155 8558 c-4 -9 -25 -28 -47 -43 -41 -27 -41 -27 -15 -50 14 -13
27 -30 30 -37 3 -10 9 -10 23 -2 24 14 84 -1 84 -21 0 -8 5 -15 10 -15 13 0
13 13 -2 45 -6 14 -18 25 -27 25 -9 0 -23 5 -31 10 -13 9 -11 13 9 31 25 20
25 20 -2 46 -22 23 -27 24 -32 11z"/>
<path d="M10880 8560 c0 -5 6 -13 13 -17 6 -4 19 -21 28 -37 10 -17 31 -34 54
-42 21 -7 43 -20 47 -28 5 -9 20 -28 32 -43 21 -25 26 -26 50 -15 15 7 36 12
46 12 30 0 25 9 -39 78 -62 66 -79 72 -127 47 -28 -15 -30 -14 -59 20 -31 35
-45 43 -45 25z"/>
<path d="M13253 8558 c-13 -6 -23 -18 -23 -26 0 -27 48 -87 96 -122 49 -35 48
-33 28 -112 -6 -25 -4 -28 21 -28 38 0 80 27 92 61 10 25 17 29 48 29 29 0 38
-5 42 -20 7 -25 27 -21 31 6 3 23 -47 49 -77 39 -27 -8 -61 15 -61 41 0 18
-15 57 -39 103 -4 8 -32 21 -62 27 -65 16 -68 16 -96 2z"/>
<path d="M5403 8505 c-3 -9 2 -24 11 -34 9 -10 16 -30 16 -45 0 -32 39 -52 71
-36 23 13 23 14 0 48 -10 15 -26 39 -35 55 -18 29 -53 36 -63 12z"/>
<path d="M5007 8504 c-17 -17 -6 -34 23 -34 18 0 33 -7 39 -17 9 -17 71 -53
114 -67 11 -3 21 -15 24 -25 3 -12 15 -21 32 -23 20 -2 27 -9 29 -31 4 -30
-21 -48 -41 -28 -14 14 -129 14 -160 0 -22 -10 -29 -7 -68 30 -42 42 -88 53
-80 21 2 -8 5 -32 8 -52 6 -38 28 -57 47 -38 17 17 35 11 92 -31 52 -40 55
-41 73 -24 24 21 55 13 77 -20 9 -13 30 -29 48 -35 17 -5 56 -34 86 -64 41
-41 58 -52 67 -44 18 14 16 45 -2 52 -10 4 -15 20 -15 50 0 38 -4 47 -27 61
-50 30 -85 85 -78 123 9 50 -35 122 -75 122 -23 0 -31 5 -36 25 -6 23 -10 25
-41 19 -24 -5 -39 -2 -52 10 -20 18 -73 31 -84 20z"/>
<path d="M2625 8490 c-11 -18 5 -30 41 -30 22 0 34 5 34 14 0 24 -62 37 -75
16z"/>
<path d="M8037 8493 c-4 -3 -7 -19 -7 -35 0 -16 -6 -31 -15 -34 -22 -9 -18
-24 5 -24 11 0 39 -18 61 -40 23 -22 45 -40 50 -40 12 0 11 17 -1 25 -5 3 -10
22 -10 42 0 50 -61 128 -83 106z"/>
<path d="M9509 8488 c-1 -2 -2 -19 -4 -38 -3 -42 -59 -94 -130 -124 -43 -17
-48 -17 -83 -2 -66 30 -67 31 -70 80 -3 43 -5 46 -31 46 -16 0 -34 -7 -41 -15
-18 -21 -6 -92 19 -119 12 -12 21 -29 21 -38 0 -17 -41 -48 -62 -48 -16 0 -62
57 -72 88 -4 12 -14 22 -22 22 -23 0 -7 -87 23 -126 29 -39 105 -55 134 -28
16 15 21 15 50 0 33 -17 49 -14 49 9 0 16 30 35 56 35 9 0 38 13 63 29 34 22
64 32 112 37 65 6 67 6 99 -25 30 -28 35 -30 54 -17 31 20 30 48 -3 98 -34 50
-155 152 -162 136z"/>
<path d="M9956 8465 c9 -13 24 -27 33 -30 20 -6 51 3 51 15 0 14 -49 40 -75
40 -25 0 -25 -1 -9 -25z"/>
<path d="M9022 8457 c-27 -29 -28 -53 -2 -67 42 -22 73 48 36 80 -9 7 -19 3
-34 -13z"/>
<path d="M11453 8474 c-21 -9 -14 -27 23 -58 39 -32 80 -31 51 2 -8 9 -17 26
-19 37 -3 20 -31 29 -55 19z"/>
<path d="M6425 8439 c-13 -21 6 -57 47 -91 55 -44 111 -78 129 -78 8 0 22 -9
32 -20 9 -11 26 -20 37 -20 23 0 90 -56 90 -76 0 -9 8 -12 28 -8 21 4 36 -1
58 -18 42 -34 79 -48 130 -48 38 0 46 -4 56 -25 24 -52 86 -37 72 18 -5 23
-11 27 -44 27 -21 0 -43 7 -50 15 -7 8 -18 15 -26 15 -7 0 -43 26 -81 58 -126
107 -167 124 -289 122 -55 -1 -64 8 -64 68 0 12 -5 22 -11 22 -5 0 -27 11 -47
25 -40 27 -57 31 -67 14z"/>
<path d="M2583 8424 c-3 -8 1 -23 10 -32 15 -14 17 -14 23 1 8 21 -1 47 -16
47 -6 0 -13 -7 -17 -16z"/>
<path d="M3157 8434 c-10 -10 -8 -46 3 -64 9 -13 11 -13 20 0 5 8 10 20 10 26
0 17 -25 46 -33 38z"/>
<path d="M12910 8375 c0 -29 29 -85 44 -85 27 0 39 -67 33 -182 -7 -134 -1
-155 62 -216 50 -49 71 -102 35 -88 -9 3 -22 6 -29 6 -8 0 -23 9 -33 20 -11
12 -32 22 -48 23 -29 2 -29 2 -26 -78 2 -44 5 -97 8 -117 5 -34 3 -38 -15 -38
-36 0 -29 -54 9 -70 33 -14 54 -4 65 31 8 24 20 24 52 -1 15 -11 41 -20 61
-20 58 0 80 -49 42 -97 -25 -32 -25 -63 -2 -111 10 -20 17 -44 15 -54 -6 -23
57 -42 121 -35 29 3 60 1 70 -5 17 -9 17 -11 0 -29 -17 -19 -16 -21 9 -47 15
-15 32 -43 38 -62 7 -19 18 -43 27 -52 21 -25 8 -48 -28 -48 -20 0 -30 -5 -30
-15 0 -9 9 -15 23 -15 13 0 32 -6 42 -14 19 -14 19 -15 1 -35 -18 -20 -18 -22
-1 -41 10 -11 23 -30 29 -43 18 -35 70 -31 74 6 2 15 8 27 13 27 15 0 10 46
-6 60 -11 9 -12 17 -5 30 16 31 12 48 -30 112 -22 34 -40 66 -40 71 0 5 -10
26 -22 46 -18 28 -22 48 -20 87 4 59 -14 102 -52 128 -24 15 -26 22 -26 96 0
67 3 81 19 89 21 12 38 -3 65 -56 9 -18 25 -37 35 -42 13 -8 20 -27 25 -71 8
-68 26 -87 70 -70 22 8 26 16 26 48 0 21 -6 44 -12 50 -10 10 -10 17 0 33 14
22 11 27 -44 87 -24 24 -107 72 -128 72 -17 0 -39 26 -65 75 -31 61 -74 97
-105 89 -17 -4 -26 -2 -26 5 0 6 -11 16 -24 22 -13 6 -29 22 -35 36 -7 15 -17
23 -25 20 -16 -6 -36 11 -36 30 0 10 9 12 35 7 22 -4 41 -2 49 5 12 10 15 7
21 -16 16 -73 58 -80 46 -8 -5 31 -11 41 -29 43 -12 2 -22 9 -22 16 0 7 -11
22 -26 35 -17 15 -23 28 -19 41 3 10 -3 47 -15 81 -12 39 -20 89 -20 134 0 93
-16 111 -87 100 -55 -9 -94 -7 -107 6 -15 14 -26 11 -26 -6z m352 -600 c14
-31 0 -50 -31 -40 -23 7 -28 34 -9 53 18 18 27 15 40 -13z m-136 -90 c30 -29
35 -37 24 -50 -7 -8 -18 -15 -25 -15 -21 0 -75 50 -75 69 0 42 28 41 76 -4z
m154 -16 c9 -31 18 -43 41 -51 27 -9 29 -12 23 -51 -9 -67 -10 -67 -38 -54
-15 7 -31 26 -36 44 -6 17 -18 37 -26 43 -18 16 -19 106 -1 113 19 7 26 -1 37
-44z m-21 -229 c20 -39 27 -70 15 -70 -35 0 -74 71 -53 96 15 19 14 19 38 -26z"/>
<path d="M11200 8372 c0 -17 26 -62 38 -67 17 -6 28 24 16 43 -11 17 -54 36
-54 24z"/>
<path d="M10910 8370 c-12 -65 -7 -91 22 -115 20 -17 37 -24 50 -19 29 9 77
-15 84 -42 7 -27 64 -62 64 -39 0 8 10 21 22 30 20 13 21 18 10 36 -11 18 -11
24 2 38 9 10 16 20 16 23 0 11 -57 21 -133 22 -75 2 -78 3 -107 37 -16 18 -30
32 -30 29z"/>
<path d="M4312 8344 c-5 -9 -7 -37 -4 -63 3 -35 0 -50 -12 -60 -19 -16 -21
-47 -3 -54 10 -4 10 -7 0 -18 -11 -11 -13 -10 -13 4 0 12 -8 17 -26 17 -24 0
-25 -2 -19 -32 9 -44 21 -54 41 -38 14 13 16 11 13 -15 -5 -53 31 -150 63
-169 33 -20 34 -31 10 -69 -16 -23 -18 -42 -14 -110 2 -45 9 -88 15 -95 12
-15 42 -7 68 19 17 17 31 19 87 17 64 -3 67 -4 67 -28 0 -22 -5 -25 -52 -32
-53 -8 -104 -36 -158 -87 -61 -57 -65 -66 -75 -152 -11 -90 -3 -134 31 -178
11 -13 19 -40 19 -60 0 -66 36 -89 110 -71 27 6 64 10 82 8 27 -2 34 1 36 18
3 22 -57 84 -82 84 -8 0 -19 7 -26 15 -7 8 -25 15 -40 15 -51 0 -97 111 -52
127 9 3 29 20 44 37 30 36 37 32 71 -35 18 -36 28 -45 57 -50 19 -3 40 -7 45
-9 22 -6 25 1 11 22 -11 15 -12 26 -5 40 18 34 5 47 -40 41 -27 -4 -41 -2 -41
6 0 6 -9 20 -19 30 -20 20 -45 61 -39 65 2 1 14 8 28 14 72 37 93 50 102 65 5
9 20 17 34 17 25 0 35 -6 80 -47 36 -33 74 -35 74 -4 0 36 -12 51 -41 51 -21
0 -32 7 -43 28 -16 30 -84 97 -133 131 -18 12 -36 33 -39 47 -4 16 -19 30 -41
39 -29 12 -33 17 -24 34 7 13 7 29 0 50 -18 50 -8 60 58 59 32 -1 64 -6 71
-11 7 -5 16 -7 20 -3 4 4 -1 13 -11 20 -9 7 -17 16 -17 20 0 12 -57 66 -69 66
-6 0 -15 -9 -21 -20 -6 -11 -19 -20 -28 -20 -10 0 -23 -5 -30 -12 -9 -9 -20
-4 -47 22 -32 31 -36 40 -33 80 3 45 3 45 62 42 59 -3 59 -3 52 30 -7 36 -58
95 -94 109 -14 5 -25 20 -28 39 -7 33 -18 38 -32 14z"/>
<path d="M13197 8353 c-4 -6 0 -35 8 -66 9 -36 11 -65 6 -85 -8 -26 -4 -36 30
-77 21 -26 39 -54 39 -62 0 -10 17 -1 48 26 26 23 53 47 60 52 20 16 15 25
-38 65 -27 21 -52 46 -55 56 -4 9 -21 26 -39 37 -18 12 -37 31 -43 43 -5 13
-12 17 -16 11z"/>
<path d="M10492 8329 c2 -13 13 -29 25 -35 34 -16 62 -44 69 -68 4 -11 13 -28
20 -36 8 -8 30 -32 49 -54 34 -38 65 -44 65 -11 0 17 27 20 50 5 13 -9 13 -12
-4 -25 -10 -7 -15 -18 -11 -24 13 -22 32 -10 54 35 22 47 22 47 -3 73 -15 15
-26 32 -26 39 0 15 -22 15 -54 1 -32 -15 -78 2 -101 37 -8 13 -25 24 -38 24
-29 0 -44 11 -48 35 -3 12 -14 21 -27 23 -20 3 -23 0 -20 -19z"/>
<path d="M10310 8322 c0 -10 9 -27 20 -37 11 -10 20 -24 20 -32 0 -17 15 -17
30 2 7 8 21 15 31 15 47 0 -4 56 -58 65 -38 6 -43 5 -43 -13z"/>
<path d="M9990 8321 c0 -7 -11 -16 -25 -21 -27 -10 -34 -30 -11 -30 7 0 25 -9
39 -20 14 -11 32 -20 40 -20 8 0 20 -7 27 -15 14 -17 40 -20 40 -4 0 6 -14 24
-32 41 -18 16 -37 39 -43 51 -11 23 -35 35 -35 18z"/>
<path d="M6062 8278 c2 -15 10 -23 23 -23 30 0 27 39 -3 43 -20 3 -23 0 -20
-20z"/>
<path d="M3186 8264 c-7 -19 12 -47 25 -38 5 3 9 16 9 30 0 27 -24 33 -34 8z"/>
<path d="M9843 8254 c-28 -12 -33 -19 -33 -49 0 -39 9 -46 88 -66 46 -11 54
-11 68 3 14 14 14 19 -1 49 -18 35 -63 79 -80 78 -5 0 -25 -7 -42 -15z"/>
<path d="M10187 8264 c-11 -11 13 -34 35 -34 13 0 18 6 16 18 -3 17 -38 29
-51 16z"/>
<path d="M4600 8245 c-10 -12 -9 -16 3 -21 17 -6 37 2 37 16 0 15 -29 19 -40
5z"/>
<path d="M2730 8207 c0 -24 30 -44 41 -26 13 20 6 34 -19 37 -14 2 -22 -2 -22
-11z"/>
<path d="M6326 8186 c4 -23 2 -42 -6 -51 -10 -12 -8 -16 15 -25 14 -5 37 -10
49 -10 14 0 41 -16 64 -39 31 -31 45 -38 67 -34 21 5 32 -1 55 -28 34 -39 36
-52 15 -69 -11 -9 -13 -16 -6 -23 7 -7 18 -4 35 12 28 26 49 20 44 -12 -6 -53
26 -61 46 -12 15 35 29 44 41 25 11 -18 24 -11 40 21 22 42 6 59 -53 59 -32 0
-58 8 -94 30 -26 17 -52 30 -58 30 -5 0 -15 8 -22 19 -7 10 -23 21 -35 25 -11
4 -28 18 -37 31 -11 16 -26 25 -43 25 -15 0 -38 11 -52 24 -15 13 -36 27 -49
31 -22 6 -23 5 -16 -29z"/>
<path d="M11385 8190 c-3 -5 -22 -10 -41 -10 -27 0 -34 -4 -34 -20 0 -11 -7
-20 -15 -20 -8 0 -15 -7 -15 -15 0 -8 4 -15 9 -15 5 0 11 7 15 15 7 20 60 19
76 -1 8 -8 16 -32 20 -52 4 -28 10 -37 25 -35 10 1 24 -6 31 -14 19 -27 44 -8
44 32 0 29 -5 38 -26 47 -16 8 -34 29 -45 55 -18 42 -32 53 -44 33z"/>
<path d="M10027 8183 c-14 -13 -6 -33 13 -33 13 0 20 7 20 20 0 19 -20 27 -33
13z"/>
<path d="M8243 8173 c-7 -2 -13 -18 -13 -34 0 -37 31 -40 49 -5 20 36 2 55
-36 39z"/>
<path d="M10946 8164 c-3 -9 -6 -24 -6 -34 0 -10 -10 -20 -24 -24 -23 -6 -23
-6 -8 -40 18 -41 64 -65 86 -47 18 15 16 122 -3 145 -17 20 -37 21 -45 0z"/>
<path d="M5427 8163 c-11 -10 -8 -51 4 -58 16 -10 59 4 59 19 0 26 -47 56 -63
39z"/>
<path d="M7211 8136 c-18 -22 3 -55 46 -72 59 -25 85 15 38 61 -27 28 -66 33
-84 11z"/>
<path d="M10450 8132 c0 -12 9 -23 20 -27 11 -3 20 -9 20 -13 0 -4 -9 -13 -20
-20 -27 -16 -25 -31 5 -42 17 -7 25 -17 25 -34 0 -45 18 -76 43 -76 16 0 28
-9 35 -25 6 -14 17 -25 24 -25 20 1 59 70 53 91 -8 24 -52 25 -77 2 -14 -13
-21 -14 -30 -5 -9 9 -9 12 0 12 17 0 15 40 -4 61 -12 13 -13 22 -5 36 13 25
-22 69 -61 79 -24 5 -28 3 -28 -14z"/>
<path d="M4666 8132 c-9 -14 4 -21 47 -24 35 -2 56 6 44 18 -11 11 -84 16 -91
6z"/>
<path d="M4139 8108 c-2 -45 3 -73 17 -89 8 -9 19 -55 24 -102 6 -47 15 -98
20 -112 14 -36 13 -151 -1 -177 -12 -23 -15 -114 -4 -148 8 -24 37 -26 56 -4
53 64 52 356 -2 389 -6 4 -9 24 -8 44 3 41 -24 109 -47 118 -8 3 -14 17 -14
32 0 41 -11 71 -26 71 -8 0 -14 -10 -15 -22z"/>
<path d="M2550 8105 c-17 -20 -5 -62 21 -76 27 -14 69 3 69 29 0 49 -62 81
-90 47z"/>
<path d="M4940 8105 c0 -19 46 -49 65 -41 24 9 18 23 -17 40 -39 20 -48 20
-48 1z"/>
<path d="M10208 8109 c-24 -13 -23 -34 4 -70 19 -25 20 -33 10 -49 -10 -17 -8
-21 18 -35 40 -21 70 -19 70 3 0 34 33 53 79 46 49 -8 54 6 14 41 -35 31 -39
31 -55 -1 -17 -35 -64 -62 -79 -47 -8 8 -8 17 0 30 8 16 5 27 -15 56 -14 21
-26 37 -27 37 -1 0 -10 -5 -19 -11z"/>
<path d="M9468 8064 c-40 -21 -37 -52 5 -56 26 -2 33 -8 35 -28 5 -32 20 -50
43 -50 10 0 22 -6 26 -14 12 -20 48 -36 82 -36 41 0 39 13 -9 47 -36 26 -40
32 -40 75 0 42 -3 49 -30 63 -36 19 -77 19 -112 -1z"/>
<path d="M9851 8041 c-6 -10 -23 -23 -38 -29 -37 -13 -75 -50 -67 -64 4 -6 6
-35 5 -65 -3 -68 23 -84 88 -52 48 23 51 35 16 64 -16 12 -28 34 -31 57 -6 33
-4 38 26 53 32 16 33 16 61 -11 16 -16 32 -43 35 -63 10 -53 49 -91 96 -91 29
0 41 -6 54 -25 11 -17 25 -25 45 -25 39 0 40 -40 2 -70 -32 -25 -23 -38 33
-47 21 -3 54 -14 73 -24 37 -20 57 -16 28 5 -21 16 -23 64 -3 72 8 3 17 12 20
20 6 16 -14 27 -82 44 -36 9 -42 14 -37 30 8 25 -33 52 -71 48 -24 -3 -28 1
-37 32 -9 37 -23 51 -41 44 -7 -3 -29 16 -50 41 -21 25 -44 45 -51 45 -7 0
-15 7 -19 15 -8 21 -43 19 -55 -4z"/>
<path d="M2406 8024 c-3 -8 1 -25 8 -37 8 -12 20 -43 27 -70 10 -40 15 -47 30
-42 14 5 21 0 28 -17 5 -13 16 -30 25 -37 8 -7 18 -29 22 -50 3 -20 12 -57 20
-83 14 -44 14 -50 -5 -94 -12 -26 -21 -54 -21 -62 0 -9 -16 -39 -36 -68 -37
-53 -37 -53 -20 -94 9 -22 16 -56 16 -75 0 -27 4 -35 18 -35 25 0 42 19 42 47
0 28 16 30 23 3 3 -11 10 -20 16 -20 18 0 25 29 13 53 -6 12 -13 63 -17 113
-5 91 -5 91 21 109 27 17 27 17 20 121 -10 154 -32 194 -116 211 -38 7 -45 13
-48 33 -3 28 -43 110 -53 110 -4 0 -10 -7 -13 -16z"/>
<path d="M4781 8014 c-28 -35 -29 -30 37 -106 49 -57 85 -104 110 -143 4 -6
29 -24 55 -39 32 -18 52 -38 59 -57 7 -20 17 -29 32 -29 28 0 52 -25 62 -63 3
-16 13 -31 20 -34 7 -3 29 -28 48 -56 57 -86 88 -110 133 -104 21 2 58 13 83
22 65 25 158 25 176 0 10 -13 17 -16 24 -9 8 8 6 15 -5 24 -8 7 -15 18 -15 25
0 42 -145 72 -183 37 -48 -43 -147 -7 -147 53 0 12 -7 29 -16 36 -9 8 -25 32
-36 54 -50 104 -51 105 -77 105 -19 1 -41 18 -80 60 -30 33 -60 60 -67 60 -35
0 -83 37 -103 80 -18 40 -73 110 -85 110 -3 0 -14 -12 -25 -26z"/>
<path d="M11231 8031 c-21 -14 -5 -43 21 -39 15 2 23 10 23 23 0 22 -22 30
-44 16z"/>
<path d="M10816 8012 c-3 -10 -22 -24 -41 -30 -33 -13 -40 -42 -10 -42 19 0
75 49 75 65 0 22 -18 27 -24 7z"/>
<path d="M2680 8007 c0 -20 39 -97 49 -97 18 0 19 30 2 52 -10 13 -20 31 -24
41 -7 20 -27 23 -27 4z"/>
<path d="M5457 7964 c-15 -45 -15 -45 12 -57 53 -23 74 -55 66 -104 -6 -39 -3
-47 20 -71 14 -15 42 -45 60 -67 33 -37 35 -38 35 -15 0 26 -22 95 -33 106 -4
4 -7 19 -7 34 0 15 -11 43 -25 63 -13 20 -29 54 -35 76 -9 35 -49 81 -70 81
-4 0 -14 -21 -23 -46z"/>
<path d="M9180 7985 c0 -13 10 -34 23 -45 23 -22 116 -70 135 -70 46 0 -12 71
-92 114 -60 32 -66 32 -66 1z"/>
<path d="M5105 7986 c-17 -12 -14 -16 30 -57 26 -24 53 -47 60 -52 19 -10 65
9 65 28 0 13 -25 71 -36 83 -1 2 -19 -2 -39 -9 -33 -12 -38 -12 -49 3 -11 15
-16 16 -31 4z"/>
<path d="M8533 7979 c14 -23 47 -33 77 -24 32 10 6 31 -47 38 -39 5 -41 4 -30
-14z"/>
<path d="M8913 7983 c-20 -8 -16 -19 27 -68 22 -25 40 -53 40 -61 0 -7 20 -33
44 -56 121 -116 129 -121 154 -96 20 20 14 39 -28 84 -46 50 -50 71 -15 80 14
3 25 12 25 20 0 16 3 15 -65 18 -50 2 -119 38 -138 72 -8 14 -22 17 -44 7z"/>
<path d="M11307 7984 c-11 -11 5 -34 24 -34 22 0 24 11 7 28 -13 13 -22 15
-31 6z"/>
<path d="M12868 7866 c-3 -102 -7 -129 -22 -144 -11 -13 -16 -32 -14 -54 4
-41 22 -44 26 -3 2 16 15 42 28 59 21 24 24 36 19 67 -4 25 -1 56 10 89 19 58
7 110 -25 110 -16 0 -18 -14 -22 -124z"/>
<path d="M13310 7980 c-11 -7 -11 -16 -1 -50 12 -40 14 -42 44 -36 50 10 66
32 42 54 -29 26 -70 42 -85 32z"/>
<path d="M6944 7932 c10 -11 32 -24 49 -28 18 -4 42 -13 54 -21 12 -8 32 -13
45 -11 22 4 22 5 3 13 -11 4 -31 18 -45 31 -16 15 -44 26 -75 30 -50 7 -50 7
-31 -14z"/>
<path d="M8708 7898 c-2 -27 -9 -34 -35 -42 -43 -12 -42 -20 10 -45 54 -26 55
-26 67 4 5 14 16 25 25 25 19 0 19 23 0 60 -23 44 -63 42 -67 -2z"/>
<path d="M11064 7915 c-5 -11 -15 -14 -38 -10 -39 7 -69 -10 -46 -25 34 -22
125 6 113 35 -7 19 -22 19 -29 0z"/>
<path d="M11384 7904 c1 -13 -10 -20 -36 -27 -45 -11 -53 -41 -13 -51 57 -14
94 17 83 71 -4 24 -36 30 -34 7z"/>
<path d="M3095 7896 c-12 -9 -21 -31 -24 -62 -7 -57 -26 -64 -51 -19 -10 17
-24 28 -31 26 -8 -2 -34 -9 -59 -16 -65 -17 -76 -53 -30 -91 48 -41 80 -116
80 -191 0 -64 -22 -169 -40 -187 -14 -14 -12 -52 3 -64 7 -6 45 -16 84 -23 59
-10 73 -16 82 -36 16 -35 14 -58 -8 -84 -19 -24 -19 -24 -43 -3 -12 11 -34 26
-48 32 -14 7 -36 19 -50 27 -38 22 -87 19 -101 -6 -16 -30 6 -101 49 -157 40
-53 52 -105 29 -130 -9 -10 -18 -29 -19 -43 -4 -33 30 -37 85 -10 24 12 48 21
53 21 20 0 55 -60 52 -88 -3 -25 -6 -27 -43 -23 -22 3 -71 5 -110 5 -69 1 -69
1 -78 -43 -13 -65 -3 -86 49 -113 61 -30 100 -77 109 -128 11 -62 -36 -101
-84 -71 -19 12 -101 -54 -101 -80 0 -29 164 -28 220 1 22 11 46 20 53 20 19 0
67 -49 67 -68 0 -9 7 -23 16 -33 23 -25 8 -45 -17 -23 -16 14 -31 16 -96 10
-168 -16 -175 -18 -229 -64 -36 -31 -43 -43 -44 -73 0 -54 27 -83 63 -70 63
24 160 0 173 -43 4 -12 22 -39 40 -61 29 -36 33 -48 35 -110 2 -78 -29 -170
-62 -180 -9 -3 -29 -21 -43 -40 -22 -29 -25 -37 -15 -59 10 -21 8 -31 -13 -68
-36 -60 -80 -187 -73 -209 6 -17 -16 -102 -36 -144 -53 -108 -69 -123 -141
-131 -60 -7 -98 -31 -98 -61 0 -19 123 -18 139 1 6 8 32 17 58 21 25 4 53 11
62 16 9 5 27 13 41 19 14 5 33 15 42 22 22 16 44 -3 77 -67 22 -42 23 -47 9
-62 -18 -18 -128 -32 -258 -32 -99 -1 -126 -14 -185 -85 -34 -42 -37 -49 -26
-70 15 -28 198 -95 273 -101 55 -4 124 -51 134 -92 20 -80 -25 -197 -117 -301
-36 -41 -48 -64 -52 -95 -2 -23 -12 -68 -21 -100 -9 -32 -16 -66 -16 -76 0
-10 -7 -24 -15 -31 -17 -14 -20 -50 -5 -50 6 0 15 11 19 24 5 13 16 26 23 28
8 3 25 23 39 44 14 22 44 67 66 100 23 34 44 72 48 85 4 13 13 31 20 39 7 8
25 47 40 85 15 39 34 87 42 107 9 20 13 48 9 61 -8 35 11 52 79 70 121 31 113
31 120 -7 4 -19 17 -43 30 -54 12 -11 28 -36 35 -56 11 -35 49 -56 103 -56 15
0 17 -11 17 -88 0 -109 -7 -120 -80 -129 -30 -3 -71 -14 -90 -25 -19 -10 -41
-18 -48 -18 -7 0 -25 -8 -40 -18 -45 -30 -64 -40 -150 -83 -57 -28 -86 -49
-92 -65 -5 -13 -14 -24 -20 -24 -12 0 -127 -93 -148 -119 -11 -14 -14 -14 -32
8 -11 13 -20 36 -20 53 0 33 -30 97 -55 118 -12 10 -38 13 -85 12 -61 -3 -70
-1 -80 17 -23 44 -102 13 -84 -32 9 -25 72 -53 86 -39 17 17 77 15 84 -2 9
-23 -15 -56 -39 -56 -38 0 -47 -17 -29 -61 18 -45 31 -48 67 -15 15 14 40 28
56 31 16 4 29 11 29 16 0 5 7 9 15 9 20 0 19 -17 -1 -28 -13 -7 -14 -12 -4
-29 17 -27 6 -65 -30 -107 -20 -22 -30 -44 -30 -65 0 -45 27 -52 56 -15 73 92
72 91 125 98 35 5 57 14 69 28 17 21 17 21 39 -1 27 -27 22 -32 61 52 32 69
38 75 57 56 21 -21 48 1 75 61 21 45 32 58 44 53 8 -3 36 -6 62 -7 44 -1 46 1
54 32 6 23 14 32 29 32 16 0 20 -5 16 -20 -3 -10 1 -27 8 -37 13 -17 16 -17
62 7 31 16 54 37 65 59 9 18 26 43 37 55 12 12 21 30 21 39 0 20 38 47 56 40
14 -5 30 -58 33 -106 0 -15 9 -55 20 -90 11 -34 22 -93 26 -131 6 -71 27 -136
44 -136 5 0 16 -3 24 -6 10 -3 17 3 21 21 4 14 18 31 32 37 25 12 26 13 21
103 -3 49 -11 109 -18 131 -11 38 -11 44 9 69 12 15 22 36 22 46 0 10 10 30
23 45 24 27 24 27 66 -11 41 -38 42 -40 36 -84 -4 -25 -13 -56 -21 -69 -28
-43 -15 -73 40 -92 37 -12 51 -23 61 -47 12 -29 16 -31 53 -26 36 5 42 2 79
-37 24 -26 45 -40 51 -36 26 16 10 46 -47 93 -111 90 -103 153 18 153 22 0 48
8 62 19 13 10 60 28 104 40 44 12 94 28 110 35 85 38 98 39 122 9 18 -22 23
-24 23 -11 0 10 17 28 38 42 20 13 44 31 51 40 35 42 142 59 173 28 17 -17 23
-15 36 14 18 39 28 22 30 -51 2 -60 0 -67 -18 -72 -28 -7 -20 -27 13 -31 43
-5 51 -25 49 -123 -2 -71 0 -89 11 -89 8 0 20 6 26 14 7 8 23 17 36 20 30 8
41 41 24 73 -10 18 -10 31 -1 56 6 18 19 81 28 141 19 119 29 136 79 136 38 0
56 -22 57 -68 0 -28 -65 -176 -82 -187 -13 -8 -13 -52 -1 -59 5 -4 33 14 62
39 63 54 115 73 156 57 15 -5 53 -15 83 -22 86 -19 120 -55 120 -130 0 -58 14
-80 51 -80 42 0 115 35 122 59 7 30 59 35 156 15 47 -9 100 -24 116 -32 17 -8
61 -23 100 -33 70 -18 70 -18 102 4 18 12 33 26 33 30 0 29 -176 175 -234 194
-16 5 -34 18 -40 28 -6 11 -18 25 -26 32 -13 10 -13 14 4 26 19 14 19 14 0 25
-10 5 -39 13 -64 17 -25 4 -64 13 -88 21 -23 8 -69 14 -102 14 -33 0 -77 6
-97 14 -21 8 -54 17 -74 20 -21 4 -48 15 -62 26 -32 25 -53 25 -67 0 -13 -24
-62 -27 -79 -6 -9 11 -6 18 14 34 21 16 22 21 9 26 -25 10 -92 7 -99 -4 -4 -6
-20 1 -40 16 -34 26 -35 26 -79 9 -36 -14 -48 -15 -67 -5 -33 17 -89 71 -89
87 0 7 -19 17 -42 23 -24 6 -56 17 -73 24 -16 8 -55 24 -85 36 -30 13 -84 37
-118 54 -35 17 -76 37 -90 44 -15 7 -34 17 -42 23 -8 5 -29 16 -46 24 -17 7
-36 21 -44 29 -7 9 -19 16 -28 16 -22 0 -82 40 -118 77 -17 18 -41 33 -53 33
-12 0 -41 18 -65 40 -24 22 -46 40 -50 40 -14 0 -66 58 -66 73 0 8 7 20 15 27
8 7 15 19 15 26 0 21 46 28 83 13 17 -7 60 -41 93 -76 43 -44 67 -61 78 -57
18 7 21 20 6 29 -14 9 -13 78 2 93 9 9 9 15 0 24 -7 7 -12 35 -12 64 0 45 -3
53 -22 57 -13 4 -31 12 -42 20 -18 13 -18 15 5 55 13 23 32 44 41 47 9 3 22
21 28 39 6 19 26 55 45 82 19 27 35 52 35 56 0 20 -34 4 -72 -35 -94 -95 -284
-300 -292 -315 -14 -24 -48 -51 -74 -58 -12 -4 -37 -27 -54 -53 -18 -25 -76
-91 -130 -145 -54 -55 -98 -102 -98 -104 0 -2 -24 -26 -52 -53 -29 -27 -70
-65 -90 -84 -46 -44 -52 -44 -84 6 -18 29 -29 38 -36 31 -8 -8 -5 -19 8 -39
10 -15 21 -37 24 -48 8 -30 61 -31 118 -3 26 13 49 26 50 31 17 37 70 49 93
21 11 -14 9 -20 -18 -43 -17 -14 -38 -40 -47 -58 -16 -32 -16 -32 -146 -31
-82 0 -133 5 -139 12 -5 6 -12 33 -16 60 -3 27 -12 58 -18 68 -14 22 11 48 45
48 10 0 25 11 34 25 9 14 27 28 40 31 15 4 35 24 50 51 24 39 25 49 17 92 -11
57 -1 94 24 89 15 -3 18 -14 18 -63 0 -82 8 -91 53 -63 71 43 89 81 48 99 -13
6 -29 22 -35 35 -6 14 -19 24 -31 24 -16 0 -19 5 -15 28 2 15 7 52 10 84 7 66
29 84 48 40 25 -54 72 -122 89 -128 12 -3 30 8 56 35 22 23 46 41 55 41 30 0
21 53 -14 86 -17 16 -60 65 -95 109 -35 44 -68 85 -73 91 -4 5 -14 21 -21 35
-7 13 -18 29 -25 34 -6 6 -30 33 -52 60 -67 83 -87 137 -62 162 8 8 8 13 0 17
-6 4 -11 20 -11 36 0 41 -10 60 -31 60 -13 0 -19 7 -19 23 0 35 -17 56 -30 37
-5 -8 -11 -19 -13 -24 -6 -18 -25 4 -31 37 -3 18 -15 40 -26 50 -11 9 -20 25
-20 36 0 10 -7 24 -15 31 -8 6 -17 22 -21 33 -3 12 -22 45 -40 74 -35 52 -44
93 -21 93 22 -1 52 -30 63 -63 14 -41 28 -37 32 9 2 26 -3 46 -17 65 -11 15
-24 49 -28 75 -7 39 -13 49 -32 54 -18 4 -27 16 -35 47 -11 41 -56 103 -76
103 -5 0 -13 18 -16 40 -4 22 -11 43 -15 46 -9 5 -13 44 -4 44 13 0 75 -73 75
-90 0 -17 34 -50 52 -50 11 0 10 48 -1 86 -8 28 -23 49 -81 110 -11 12 -20 26
-20 32 0 6 -7 15 -16 20 -27 15 -13 47 19 44 27 -3 27 -2 27 60 0 42 -5 71
-16 86 -13 19 -14 28 -5 51 14 32 21 250 9 257 -11 7 -10 82 1 89 14 8 31 -28
31 -67 1 -55 26 -9 34 63 6 54 5 64 -21 104 -20 32 -34 44 -48 42 -18 -2 -20
-8 -16 -61 2 -46 0 -57 -10 -54 -10 3 -15 26 -17 69 -2 35 -5 103 -8 152 -5
82 -4 87 15 87 15 0 22 -9 28 -41 4 -22 13 -42 18 -42 19 -4 17 104 -4 171
-13 39 -21 93 -21 133 0 97 -8 112 -45 85z m295 -2172 c0 -7 9 -15 19 -19 10
-3 21 -13 25 -23 3 -9 11 -25 18 -34 9 -13 10 -20 1 -29 -13 -13 -38 -2 -85
41 -37 34 -54 37 -78 15 -27 -24 -83 -30 -103 -11 -21 21 -11 46 18 46 22 0
81 40 98 67 9 14 87 -33 87 -53z m-242 -86 c6 -7 12 -62 15 -123 7 -140 19
-210 48 -274 22 -46 27 -51 57 -51 42 0 50 -20 24 -62 -38 -63 -37 -70 21
-131 29 -31 58 -57 64 -57 6 0 16 -7 23 -15 6 -7 32 -17 57 -21 24 -3 47 -13
50 -20 14 -37 -94 -136 -165 -150 -25 -5 -36 0 -68 31 -22 20 -63 52 -92 72
-65 44 -66 45 -47 89 20 48 19 67 -5 115 -23 45 -52 300 -46 404 2 33 4 93 5
133 1 69 2 72 25 72 13 0 28 -6 34 -12z m370 -194 c30 -31 33 -39 27 -70 -6
-33 -8 -35 -36 -29 -29 7 -30 6 -118 -62 -33 -26 -79 -30 -88 -8 -3 10 9 29
36 54 22 21 41 41 41 46 0 4 11 20 25 37 14 16 25 41 25 55 0 22 3 24 27 18
15 -3 43 -22 61 -41z m-20 -331 c4 -39 -13 -43 -49 -14 -20 16 -22 21 -10 35
23 28 56 16 59 -21z m454 -372 c18 -11 54 -23 80 -26 26 -4 54 -15 64 -26 10
-11 30 -19 49 -19 54 0 61 -22 20 -63 -40 -40 -60 -39 -68 2 -5 25 -10 28 -45
28 -114 0 -175 14 -209 48 -39 39 -41 52 -10 65 37 15 84 11 119 -9z m-77
-130 c6 -11 -47 -51 -68 -51 -15 0 -27 20 -27 46 0 16 85 21 95 5z m566 -40
c35 -35 37 -60 7 -88 -13 -11 -43 -43 -68 -70 -53 -59 -87 -80 -103 -64 -8 8
-7 19 6 40 9 16 17 34 17 41 0 7 11 25 24 41 13 15 27 48 31 71 11 66 39 76
86 29z m-555 -93 c56 -83 88 -118 130 -143 52 -31 83 -32 118 -4 34 27 59 12
37 -22 -16 -27 -10 -33 64 -58 45 -16 84 -21 162 -21 130 0 155 -9 151 -52 -3
-33 -3 -33 -228 -33 -198 0 -228 2 -250 18 -19 13 -45 17 -125 17 -101 0 -101
0 -133 42 -18 23 -32 46 -32 52 0 16 -52 66 -70 66 -9 0 -25 7 -36 15 -18 14
-17 17 34 65 28 27 52 54 52 60 0 5 9 10 19 10 10 0 29 9 42 19 29 23 28 23
65 -31z m876 -85 c45 -20 47 -34 13 -75 -14 -16 -25 -36 -25 -44 0 -8 -8 -27
-18 -42 -10 -15 -23 -36 -28 -47 -14 -26 -52 -32 -60 -10 -7 16 23 152 45 208
12 32 21 33 73 10z m-1103 -192 c35 -44 37 -51 16 -51 -8 0 -15 4 -15 10 0 5
-18 13 -41 16 -44 7 -59 25 -39 49 21 25 47 17 79 -24z m2135 -97 c25 -24 19
-49 -26 -130 -24 -42 -48 -85 -55 -97 -16 -29 -62 -52 -76 -38 -10 10 -7 22
39 129 8 18 14 52 14 77 0 51 19 75 60 75 16 0 36 -7 44 -16z m-2016 -84 c3
-30 2 -32 -12 -21 -19 16 -22 65 -3 59 6 -3 13 -20 15 -38z"/>
<path d="M11173 7871 c-37 -18 -42 -31 -14 -38 12 -3 25 -21 33 -46 22 -71 98
-76 98 -7 0 15 -9 35 -21 46 -12 10 -25 29 -30 42 -10 25 -21 26 -66 3z"/>
<path d="M10303 7854 c-7 -19 27 -68 51 -72 20 -4 21 20 1 58 -17 33 -42 39
-52 14z"/>
<path d="M10623 7840 c6 -27 2 -37 -28 -67 -35 -36 -45 -68 -23 -75 18 -6 0
-26 -42 -48 -52 -27 -64 -25 -93 10 -30 35 -43 38 -52 10 -9 -27 -3 -34 60
-70 35 -20 57 -40 61 -55 3 -12 18 -35 33 -49 25 -24 31 -26 54 -15 35 16 39
32 21 79 -22 54 -13 74 29 66 37 -8 44 -8 114 -2 41 3 58 0 77 -15 13 -10 32
-19 41 -19 9 0 25 -5 36 -10 41 -22 41 3 0 40 -37 34 -41 42 -41 87 0 27 -4
53 -9 59 -5 5 -20 31 -34 57 -24 48 -24 48 -49 27 -15 -11 -31 -20 -36 -20
-40 0 -5 -54 50 -77 53 -23 50 -103 -4 -103 -29 0 -98 56 -98 80 0 5 -9 12
-21 15 -18 6 -20 12 -15 43 13 75 12 77 -13 80 -22 3 -23 1 -18 -28z"/>
<path d="M3420 7831 c0 -24 15 -35 36 -27 12 4 13 10 4 26 -14 26 -40 26 -40
1z"/>
<path d="M7295 7828 c-43 -24 -46 -56 -10 -92 14 -14 25 -33 25 -43 0 -30 44
-77 65 -70 14 6 16 14 10 45 -4 20 -8 51 -9 67 -1 17 -10 40 -21 51 -11 11
-24 28 -30 37 -8 13 -14 14 -30 5z"/>
<path d="M6746 7821 c-8 -12 26 -71 41 -71 20 0 25 20 13 51 -12 28 -42 39
-54 20z"/>
<path d="M9474 7814 c3 -9 6 -18 6 -20 0 -2 9 -4 20 -4 25 0 26 16 1 30 -27
14 -34 13 -27 -6z"/>
<path d="M8820 7806 c0 -26 50 -76 77 -76 32 0 29 39 -5 56 -13 6 -29 17 -35
23 -16 16 -37 14 -37 -3z"/>
<path d="M5312 7768 c2 -15 10 -23 23 -23 30 0 27 39 -3 43 -20 3 -23 0 -20
-20z"/>
<path d="M3485 7751 c-4 -17 -16 -36 -28 -42 -12 -7 -44 -32 -70 -56 -42 -39
-51 -44 -80 -38 -18 4 -33 11 -35 15 -1 4 -9 16 -17 26 -13 18 -14 18 -20 1
-13 -31 4 -68 35 -79 35 -12 43 -60 13 -76 -21 -12 -10 -42 16 -42 38 0 54
-28 46 -86 -11 -93 -2 -115 75 -173 38 -28 73 -51 78 -51 5 0 15 -7 22 -15 7
-8 20 -15 29 -15 9 0 27 -7 41 -15 14 -8 40 -21 58 -30 17 -8 32 -23 32 -33 1
-9 14 -33 31 -52 29 -35 29 -35 54 -5 28 35 31 66 10 126 -9 24 -13 56 -9 72
4 18 0 37 -10 52 -9 13 -16 30 -16 38 0 7 -6 21 -13 31 -13 18 -16 17 -55 -8
-23 -14 -42 -33 -42 -41 0 -25 -17 -25 -63 1 -42 23 -97 95 -97 126 0 5 -9 21
-20 35 -11 14 -20 32 -20 39 0 8 -9 34 -21 59 -28 60 -23 80 21 80 34 0 35 -1
38 -41 3 -46 58 -111 85 -101 22 8 27 57 9 85 -15 23 -14 25 7 41 23 18 23 18
-20 62 -36 36 -43 50 -44 87 -3 53 -11 63 -20 23z"/>
<path d="M6565 7769 c-4 -5 1 -19 10 -29 13 -14 14 -23 6 -38 -12 -23 -6 -72
15 -119 17 -38 22 -40 40 -16 20 28 30 5 11 -26 -19 -32 -23 -71 -7 -71 6 0
24 -10 40 -22 39 -28 65 -11 35 22 -14 15 -19 37 -20 76 0 41 -5 59 -18 69 -9
6 -17 19 -17 27 0 9 -7 21 -15 28 -9 8 -13 21 -9 32 4 14 -3 29 -22 49 -30 31
-39 35 -49 18z"/>
<path d="M8432 7768 c3 -7 15 -15 27 -16 16 -3 22 1 19 10 -3 7 -15 15 -27 16
-16 3 -22 -1 -19 -10z"/>
<path d="M9505 7741 c-9 -16 3 -31 26 -31 14 0 19 6 17 17 -4 20 -33 29 -43
14z"/>
<path d="M11000 7710 c0 -17 7 -42 16 -56 11 -17 15 -36 11 -61 -5 -30 -2 -40
19 -60 14 -13 31 -23 39 -23 8 0 19 -9 26 -21 7 -15 14 -18 21 -11 17 17 -10
100 -36 114 -29 15 -36 28 -36 68 0 39 -23 80 -46 80 -9 0 -14 -11 -14 -30z"/>
<path d="M8480 7696 c0 -9 14 -25 30 -34 17 -9 28 -22 26 -29 -6 -14 44 -59
76 -68 13 -4 34 -18 48 -30 14 -13 37 -27 52 -30 24 -6 27 -4 30 22 5 46 42
43 70 -6 19 -34 28 -41 54 -41 16 0 34 4 40 10 12 12 114 -36 114 -53 0 -29
25 -49 53 -42 26 7 27 9 12 24 -8 10 -15 23 -15 29 0 6 -8 27 -17 47 -14 30
-15 38 -3 60 17 32 40 32 40 1 0 -16 7 -27 20 -31 11 -3 20 -15 20 -25 0 -27
34 -44 61 -30 19 11 19 13 5 28 -8 10 -19 37 -25 61 -5 24 -15 48 -23 52 -16
10 -98 0 -116 -14 -19 -15 -102 -44 -150 -52 -29 -5 -43 -2 -55 9 -8 9 -35 18
-59 22 -23 4 -49 11 -55 17 -15 11 -17 53 -3 62 6 3 10 13 10 21 0 24 -87 19
-100 -6 -16 -30 -58 -19 -72 20 -1 5 -18 12 -35 16 -27 5 -33 3 -33 -10z"/>
<path d="M9660 7689 c-38 -21 -65 -24 -75 -9 -15 25 -35 9 -35 -27 0 -60 12
-70 53 -44 19 11 46 21 60 21 13 0 27 7 31 15 3 8 12 15 20 15 19 0 28 14 20
34 -8 21 -31 19 -74 -5z"/>
<path d="M9840 7695 c0 -8 11 -17 25 -21 13 -3 29 -12 36 -20 13 -16 54 -19
44 -4 -3 6 -14 10 -24 10 -10 0 -26 11 -35 25 -18 27 -46 34 -46 10z"/>
<path d="M6390 7680 c0 -22 20 -26 38 -8 19 19 14 28 -13 28 -18 0 -25 -5 -25
-20z"/>
<path d="M11227 7674 c-18 -25 -18 -26 0 -39 23 -18 28 -18 42 -1 10 12 9 20
-4 40 -20 31 -16 31 -38 0z"/>
<path d="M6270 7679 c0 -6 5 -20 11 -32 12 -21 12 -21 21 2 4 12 6 27 2 32 -7
13 -34 11 -34 -2z"/>
<path d="M9320 7660 c0 -15 7 -20 24 -20 35 0 40 15 10 29 -33 15 -34 14 -34
-9z"/>
<path d="M7423 7623 c-18 -38 -16 -42 15 -34 20 5 28 15 30 34 4 37 -28 37
-45 0z"/>
<path d="M11324 7635 c13 -10 17 -22 13 -41 -8 -41 2 -54 39 -54 38 0 101 -35
130 -73 11 -13 37 -60 58 -105 35 -71 38 -84 27 -104 -6 -13 -10 -39 -9 -58 3
-34 2 -35 -32 -35 -19 0 -46 -7 -60 -15 -14 -9 -34 -20 -45 -26 -11 -6 -20
-20 -20 -30 0 -16 6 -19 47 -16 35 3 57 -2 82 -17 51 -32 62 -27 93 39 15 33
31 60 35 60 27 0 29 -78 2 -101 -27 -22 -18 -135 14 -185 15 -24 31 -42 36
-41 5 2 17 36 28 77 24 90 26 241 4 293 -7 19 -17 54 -21 78 -4 24 -15 58 -25
74 -10 17 -21 54 -25 83 -6 46 -12 57 -53 91 -25 22 -57 43 -71 46 -13 3 -36
15 -49 26 -18 14 -41 19 -87 19 -43 0 -66 5 -75 15 -7 8 -22 15 -34 15 -20 -1
-20 -1 -2 -15z"/>
<path d="M12344 7636 c-15 -12 -17 -18 -8 -33 16 -26 47 -27 68 -4 36 40 -14
71 -60 37z"/>
<path d="M9960 7600 c0 -47 15 -60 69 -57 37 1 47 -3 60 -23 30 -47 94 -110
110 -110 30 0 60 29 63 63 2 27 7 32 28 32 22 0 25 -4 25 -37 1 -21 6 -43 12
-49 9 -9 7 -16 -9 -28 -18 -15 -18 -18 -4 -30 19 -16 36 -6 36 20 0 27 18 24
32 -6 9 -21 48 -37 48 -20 0 9 -46 78 -69 104 -26 30 -27 41 -1 48 29 8 24 23
-7 23 -16 0 -37 7 -48 16 -18 13 -21 13 -36 -7 -14 -18 -19 -20 -38 -9 -13 6
-33 9 -46 6 -15 -4 -25 -1 -29 9 -3 8 -12 15 -20 15 -21 0 -84 42 -91 60 -3
10 -19 16 -45 16 -40 1 -40 1 -40 -36z"/>
<path d="M7540 7600 c0 -17 9 -37 21 -49 27 -25 21 -50 -18 -77 -37 -25 -33
-34 13 -34 30 0 34 -4 44 -39 12 -46 7 -65 -23 -79 -20 -10 -20 -11 11 -11 21
-1 32 -6 32 -16 0 -24 71 -65 103 -58 30 6 31 6 18 31 -5 9 -12 25 -15 35 -4
13 -17 17 -53 17 -42 1 -46 2 -30 14 24 18 22 30 -13 68 -41 45 -40 68 4 68
25 0 38 6 50 25 26 40 21 55 -21 55 -38 0 -93 39 -93 67 0 7 -7 13 -15 13 -10
0 -15 -10 -15 -30z"/>
<path d="M9690 7595 c0 -27 26 -35 48 -13 21 21 13 38 -18 38 -25 0 -30 -4
-30 -25z"/>
<path d="M4826 7568 c8 -50 11 -55 25 -41 17 17 7 77 -14 81 -15 3 -17 -2 -11
-40z"/>
<path d="M6442 7590 c-13 -12 -22 -33 -22 -50 0 -16 -4 -32 -10 -35 -19 -12
-10 -33 19 -45 41 -16 52 -6 45 39 -4 26 -1 48 10 69 9 17 16 33 16 37 0 13
-38 3 -58 -15z"/>
<path d="M6957 7588 c-7 -31 7 -113 23 -132 17 -22 37 -20 45 4 3 11 15 25 26
30 25 14 24 21 -12 74 -35 52 -73 63 -82 24z"/>
<path d="M9827 7603 c-13 -13 -7 -50 11 -66 34 -31 82 -18 82 22 0 7 -71 51
-82 51 -3 0 -8 -3 -11 -7z"/>
<path d="M5410 7571 c0 -29 14 -42 38 -33 21 7 13 38 -13 50 -24 11 -25 10
-25 -17z"/>
<path d="M8371 7565 c-16 -14 -31 -36 -33 -48 -2 -18 -8 -21 -35 -19 -42 4
-44 -17 -3 -40 29 -17 31 -17 50 2 24 24 39 25 85 3 39 -18 49 -14 59 29 4 16
1 32 -7 40 -8 7 -19 23 -26 36 -16 30 -52 28 -90 -3z"/>
<path d="M7180 7570 c0 -11 25 -36 64 -63 18 -12 26 -27 26 -47 0 -19 8 -35
23 -45 110 -78 167 -98 175 -61 4 19 -41 66 -63 66 -13 0 -71 42 -118 85 -15
14 -34 25 -43 25 -8 0 -19 11 -24 25 -9 24 -40 36 -40 15z"/>
<path d="M11277 7573 c-12 -12 -7 -50 8 -63 12 -10 16 -10 19 1 18 51 0 90
-27 62z"/>
<path d="M6766 7531 c-7 -10 37 -113 65 -152 10 -14 32 -29 48 -32 23 -5 31
-13 36 -37 4 -17 12 -29 18 -27 21 7 19 35 -3 57 -12 12 -25 40 -28 62 -3 26
-12 44 -28 54 -12 8 -30 31 -39 50 -16 33 -55 48 -69 25z"/>
<path d="M6270 7516 c0 -24 12 -46 21 -40 15 9 10 54 -6 54 -8 0 -15 -6 -15
-14z"/>
<path d="M9663 7495 c-3 -9 -4 -17 -2 -18 2 -1 18 -12 35 -24 34 -24 44 -21
44 11 0 13 -11 26 -27 34 -35 16 -42 15 -50 -3z"/>
<path d="M10688 7497 c-16 -6 -28 -14 -28 -18 0 -14 44 -39 67 -39 12 0 25 -4
28 -10 11 -17 25 -11 35 15 5 14 14 25 20 25 5 0 10 5 10 10 0 6 -15 10 -34
10 -19 0 -38 5 -41 10 -7 12 -21 11 -57 -3z"/>
<path d="M12924 7502 c-7 -4 -15 -54 -19 -114 -8 -123 -7 -125 70 -114 53 8
55 17 15 58 -16 16 -30 38 -30 49 0 23 -2 23 55 4 78 -27 86 -2 23 74 -43 50
-81 65 -114 43z"/>
<path d="M5695 7490 c-3 -5 8 -16 25 -25 16 -8 30 -19 30 -24 0 -4 11 -13 24
-19 14 -6 26 -21 28 -34 4 -33 39 -34 68 -3 26 27 18 44 -21 45 -9 0 -32 16
-52 35 -36 35 -88 48 -102 25z"/>
<path d="M10853 7476 c-77 -77 -36 -129 47 -59 32 26 38 51 18 71 -17 17 -40
13 -65 -12z"/>
<path d="M12838 7480 c-19 -43 -23 -148 -11 -287 8 -96 7 -94 67 -135 6 -4 12
-40 14 -80 4 -69 6 -75 40 -105 24 -23 46 -33 67 -33 32 0 55 -15 55 -37 0
-14 -60 -33 -107 -33 -68 0 -83 -31 -63 -139 10 -58 10 -65 -8 -85 -11 -11
-23 -39 -27 -61 -4 -22 -13 -47 -21 -56 -29 -33 64 -102 152 -114 27 -4 63
-13 79 -20 17 -8 42 -17 58 -20 20 -4 27 -11 27 -29 0 -40 -41 -45 -155 -20
-38 9 -101 21 -139 28 -52 10 -73 18 -87 37 -13 18 -21 21 -29 13 -16 -16 6
-120 31 -153 32 -40 23 -101 -16 -101 -26 0 -55 29 -55 56 -1 69 -33 85 -50
24 -6 -22 -15 -40 -20 -40 -6 0 -10 -22 -10 -50 0 -60 24 -71 34 -15 8 43 25
54 42 29 7 -10 18 -24 24 -31 14 -17 13 -30 -11 -82 -25 -55 -29 -61 -52 -94
-18 -26 -18 -26 40 -81 31 -31 65 -56 74 -56 24 0 31 -27 12 -46 -20 -19 -76
-13 -103 11 -29 27 -110 8 -110 -26 0 -14 -52 -69 -66 -69 -6 0 -53 -41 -104
-91 -90 -86 -94 -92 -75 -105 55 -37 58 -53 17 -83 -16 -11 -34 -38 -42 -60
-9 -28 -23 -46 -43 -56 -38 -19 -39 -19 -35 3 2 11 -8 22 -29 31 -21 9 -33 23
-37 43 -4 18 -15 32 -31 38 -27 10 -30 21 -15 51 15 27 -26 42 -115 39 -141
-3 -155 -2 -179 14 -27 17 -62 21 -70 8 -6 -10 44 -58 75 -72 13 -6 42 -22 64
-35 22 -14 50 -25 62 -25 16 0 27 -11 41 -42 22 -49 152 -181 225 -229 62 -41
77 -30 84 65 4 41 10 66 18 66 25 0 56 -48 64 -100 18 -113 132 -167 223 -105
48 32 55 32 72 -9 11 -26 22 -35 52 -43 56 -13 55 -35 -7 -93 -59 -56 -70 -59
-116 -31 -17 11 -48 23 -67 27 -20 3 -39 10 -42 15 -3 5 -14 9 -25 9 -30 0
-23 -34 16 -86 19 -25 35 -49 35 -54 0 -4 20 -21 45 -37 30 -18 49 -39 56 -60
9 -30 14 -33 49 -33 21 0 41 -4 44 -9 3 -5 36 -14 73 -21 96 -16 121 -43 88
-94 -14 -21 -14 -24 0 -36 8 -7 15 -17 15 -23 0 -20 90 -204 130 -267 16 -25
34 -54 39 -65 5 -12 16 -27 25 -34 9 -7 16 -19 16 -25 0 -6 18 -36 39 -66 82
-113 95 -140 78 -158 -24 -24 -73 1 -87 44 -7 19 -18 34 -26 34 -8 0 -14 4
-14 9 0 5 -27 42 -61 82 -34 41 -77 94 -97 118 -21 25 -71 81 -113 125 -42 45
-87 94 -100 109 -13 16 -43 48 -66 72 -24 23 -43 52 -43 62 0 20 -65 93 -83
93 -9 0 -142 131 -223 221 -17 19 -53 55 -80 80 -27 25 -119 119 -204 208
-136 143 -395 403 -545 547 -28 27 -72 65 -98 84 -52 39 -68 73 -45 96 13 13
19 13 51 -6 19 -11 38 -27 41 -35 3 -8 11 -15 17 -15 7 0 19 -7 28 -15 37 -35
81 -63 163 -104 121 -61 139 -50 85 54 -31 62 -36 191 -8 245 26 51 27 77 0
98 -26 22 -37 94 -19 127 23 43 100 81 100 50 0 -9 -9 -19 -20 -22 -12 -3 -20
-14 -20 -27 0 -11 -3 -30 -5 -41 -14 -54 41 -52 67 3 19 38 32 30 40 -24 7
-45 5 -49 -31 -85 -32 -32 -39 -48 -49 -106 -22 -131 -24 -171 -7 -202 8 -17
15 -45 16 -63 1 -57 72 -95 182 -97 76 -2 120 126 62 177 -14 12 -25 28 -25
36 0 7 -7 19 -15 26 -13 11 -16 8 -21 -18 -6 -31 -23 -45 -40 -34 -20 14 -94
156 -89 170 7 19 30 0 51 -40 20 -39 41 -35 53 10 16 54 14 68 -14 120 -14 26
-25 59 -25 73 0 15 -6 44 -14 65 -9 28 -11 55 -5 94 4 30 8 107 8 171 1 64 6
141 13 170 14 68 14 92 -2 149 -14 50 -34 72 -58 63 -13 -5 -14 -1 -8 28 14
69 19 196 8 203 -7 4 -14 -4 -17 -21 -3 -15 -15 -51 -26 -78 -27 -70 -26 -135
2 -142 29 -8 21 -57 -21 -125 -29 -47 -30 -51 -14 -69 12 -13 15 -28 10 -53
-6 -31 -4 -35 25 -45 40 -14 35 -42 -11 -57 -103 -33 -125 -56 -58 -62 29 -3
36 1 41 18 4 17 12 21 34 18 37 -4 44 -35 8 -44 -14 -3 -30 -14 -35 -24 -5 -9
-22 -20 -38 -23 -19 -4 -47 -27 -81 -66 -29 -33 -61 -63 -72 -66 -18 -6 -19
-16 -18 -138 0 -73 4 -169 7 -214 7 -76 6 -83 -11 -83 -10 0 -21 8 -24 18 -9
24 -56 82 -67 82 -5 0 -18 7 -28 17 -17 15 -19 15 -36 0 -23 -21 -32 -21 -32
-3 0 14 -21 26 -46 26 -19 0 -117 93 -151 144 -34 50 -103 126 -114 126 -8 0
-159 119 -187 147 -7 7 -17 13 -22 13 -5 0 -11 9 -15 19 -3 10 -15 21 -25 24
-14 3 -20 14 -20 31 0 37 -17 32 -34 -9 -14 -32 -18 -35 -43 -30 -27 6 -27 6
-9 -9 11 -9 22 -16 25 -16 6 0 23 -32 86 -165 20 -44 41 -88 46 -97 12 -23 11
-52 -1 -64 -7 -7 -3 -30 12 -71 17 -48 20 -68 13 -89 -19 -52 -27 -45 -83 65
-13 24 -69 61 -93 61 -6 0 -19 10 -28 21 -13 16 -30 22 -62 24 -78 3 -152 63
-129 104 14 27 4 45 -35 67 -42 22 -69 8 -47 -26 14 -24 -11 -55 -37 -45 -9 4
-31 9 -48 12 -43 7 -57 -21 -23 -47 28 -21 18 -42 -17 -38 -14 2 -28 -3 -30
-9 -4 -10 19 -13 91 -13 85 0 96 -2 106 -20 6 -11 16 -20 22 -20 5 0 26 -13
45 -30 18 -16 38 -30 43 -30 6 0 10 -7 10 -15 0 -24 20 -17 30 10 5 14 17 25
28 25 10 0 23 5 30 12 19 19 24 3 12 -39 -11 -37 -10 -41 17 -69 30 -32 102
-61 127 -51 21 8 29 -8 16 -32 -10 -19 8 -51 28 -51 18 0 53 33 51 48 -6 43
58 103 135 127 24 7 12 19 -36 35 -48 15 -51 21 -33 58 26 51 56 51 112 -1 32
-30 32 -30 7 -60 -25 -30 -25 -30 6 -48 16 -10 30 -25 30 -32 0 -26 -156 -157
-187 -157 -6 0 -16 -6 -22 -14 -6 -7 -25 -16 -41 -20 -18 -3 -30 -12 -30 -21
0 -18 25 -19 90 -4 25 6 67 14 94 17 45 6 50 10 60 40 6 18 18 37 26 42 23 15
76 12 90 -5 7 -8 30 -18 51 -21 99 -16 88 -54 -17 -54 -64 0 -74 -2 -74 -18 0
-28 39 -46 115 -52 53 -5 80 -13 110 -34 64 -44 54 -51 -80 -53 -120 -3 -120
-3 -149 37 -37 50 -37 50 -137 39 -155 -17 -166 -16 -181 16 -15 33 -22 32
-77 -13 -25 -21 -54 -42 -63 -45 -22 -8 -23 -26 -3 -33 8 -4 15 -12 15 -20 0
-16 -26 -19 -35 -4 -11 19 -45 11 -45 -10 0 -16 -5 -19 -27 -14 -18 3 -43 -3
-68 -16 -21 -11 -54 -20 -72 -20 -18 0 -50 -9 -70 -20 -29 -16 -57 -20 -124
-20 -114 0 -149 -7 -149 -31 0 -12 -7 -19 -20 -19 -22 0 -27 28 -10 61 11 20
12 19 -60 45 -20 7 -24 3 -24 -26 -1 -16 -10 -29 -26 -37 -14 -7 -24 -19 -22
-27 4 -22 -69 -24 -823 -22 -674 1 -691 1 -719 21 -16 11 -38 25 -50 32 -11 7
-25 18 -31 25 -31 40 -81 46 -391 41 -302 -5 -326 -8 -352 -45 -7 -10 -22 -18
-32 -18 -10 0 -25 -8 -32 -18 -29 -42 -49 -44 -337 -42 -152 1 -490 4 -751 6
-261 1 -478 3 -481 3 -13 2 -61 80 -54 90 3 6 19 11 36 11 22 0 29 -5 29 -20
0 -19 7 -20 199 -20 164 0 202 3 215 15 18 19 30 19 45 1 9 -11 101 -14 517
-15 483 -1 507 0 542 18 20 11 46 23 56 26 66 20 -45 25 -568 25 -535 1 -569
0 -581 -17 -11 -14 -16 -16 -26 -5 -7 6 -22 12 -34 12 -29 0 -105 58 -105 80
0 29 -13 31 -50 8 -34 -20 -34 -20 -9 -39 24 -19 24 -19 -31 -18 -30 0 -75 -4
-100 -10 -25 -5 -61 -7 -80 -5 -28 5 -39 1 -54 -15 -11 -12 -37 -24 -58 -27
-43 -7 -47 -14 -17 -32 27 -17 22 -56 -8 -60 -12 -2 -30 6 -42 20 -19 20 -34
23 -130 28 -60 3 -115 11 -123 17 -8 7 -34 15 -58 19 -25 4 -59 15 -76 25 -17
11 -40 19 -51 19 -10 0 -24 5 -31 12 -7 7 -31 11 -54 10 -34 -2 -39 0 -25 8
27 17 21 47 -13 59 -17 5 -30 15 -30 20 0 6 -12 14 -27 17 -29 8 -69 33 -112
73 -14 13 -48 38 -76 57 -126 84 -176 154 -111 154 15 0 30 8 36 20 6 11 17
20 24 20 22 0 65 -39 82 -76 9 -19 26 -40 38 -46 11 -6 27 -19 34 -30 7 -10
18 -18 24 -18 6 0 16 -7 23 -17 7 -9 17 -13 23 -9 19 11 14 26 -8 26 -11 0
-20 6 -20 14 0 7 -11 21 -24 30 -23 14 -25 22 -24 93 1 101 4 111 36 115 16 2
28 10 30 21 3 14 -4 17 -37 17 -48 0 -50 9 -15 56 23 30 26 41 21 84 -7 61 17
100 57 93 67 -13 102 31 56 70 -12 10 -20 29 -20 46 0 49 -15 45 -82 -21 -35
-35 -84 -79 -109 -99 -41 -34 -43 -38 -29 -55 8 -11 23 -33 33 -51 17 -31 17
-32 -2 -43 -45 -23 -131 -5 -131 29 0 29 -18 36 -41 15 -20 -18 -21 -18 -32 1
-35 59 -26 109 22 120 16 3 35 13 42 21 6 8 19 14 28 14 43 1 171 91 171 121
0 4 10 9 22 11 33 5 33 24 -1 36 -16 6 -34 19 -40 30 -6 11 -24 22 -41 25 -35
7 -51 38 -43 80 9 49 52 55 197 32 65 -11 83 -11 100 0 12 7 43 15 70 19 84
10 171 -61 144 -119 -9 -21 -8 -32 5 -61 10 -19 15 -45 11 -58 -4 -18 3 -32
29 -58 45 -45 60 -74 52 -99 -5 -14 2 -29 22 -49 79 -83 98 -100 111 -100 8 0
27 -14 43 -31 18 -19 29 -25 29 -17 0 8 9 23 20 33 17 16 24 16 65 5 25 -7 48
-17 51 -21 7 -12 54 -11 54 0 0 27 -19 44 -85 76 -40 19 -88 49 -107 67 -20
18 -72 64 -116 101 -68 57 -82 74 -88 105 -3 20 -14 48 -23 62 -35 50 -40 66
-31 103 9 41 -15 121 -41 138 -26 16 -99 10 -126 -11 -29 -22 -140 -28 -188
-10 -20 8 -39 6 -73 -6 -76 -25 -260 11 -301 60 -7 9 -19 16 -27 16 -7 0 -27
14 -44 30 -26 25 -39 30 -80 30 -41 0 -55 5 -85 31 -27 24 -42 30 -66 27 -38
-6 -62 30 -38 58 12 15 14 14 25 -1 15 -20 34 -12 34 15 0 10 9 39 20 65 11
26 20 58 20 72 0 29 -20 28 -100 -8 -66 -30 -73 -34 -81 -50 -33 -62 -50 -115
-60 -183 -9 -63 -14 -75 -22 -60 -21 39 -47 39 -47 0 0 -27 18 -46 36 -39 9 3
14 -2 14 -14 0 -31 31 -116 50 -138 10 -11 21 -33 24 -50 9 -35 43 -75 64 -75
23 0 8 120 -17 140 -10 8 -21 26 -24 40 -3 14 -13 45 -23 70 -20 53 -14 100
14 100 20 -1 62 -63 62 -93 0 -44 11 -49 95 -38 42 5 82 14 88 20 20 20 97 11
97 -11 0 -17 -56 -67 -83 -73 -15 -4 -31 -13 -38 -21 -13 -16 -80 -19 -95 -5
-5 6 -9 -6 -9 -32 -1 -23 -8 -57 -18 -76 -18 -35 -15 -51 8 -51 8 0 26 -17 39
-37 68 -107 141 -126 182 -48 13 26 27 40 40 40 18 0 19 -7 16 -85 -3 -74 -7
-91 -33 -130 -16 -24 -27 -50 -24 -58 3 -7 5 -18 5 -23 0 -4 14 -16 31 -24 17
-9 35 -28 40 -43 6 -15 24 -38 41 -51 31 -25 31 -25 49 -3 9 12 31 25 48 28
27 6 31 3 45 -31 9 -21 16 -39 16 -40 0 -14 -93 -43 -130 -40 -65 3 -80 11
-125 62 -22 25 -70 75 -106 112 -36 36 -79 89 -95 116 -15 28 -45 70 -65 95
-20 25 -55 78 -79 118 -23 39 -46 72 -51 72 -5 0 -15 15 -22 33 -8 17 -21 38
-30 46 -10 7 -17 19 -17 26 0 6 -9 20 -20 30 -11 10 -20 28 -20 41 0 29 -16
39 -28 18 -5 -9 -14 -14 -21 -10 -16 10 -14 41 4 56 20 17 21 100 1 100 -17 0
-26 -22 -26 -61 0 -18 -5 -29 -14 -29 -15 0 -26 30 -26 70 0 14 -9 33 -20 43
-11 9 -20 29 -20 44 0 16 -7 41 -15 57 -8 15 -15 36 -15 46 0 9 -11 29 -25 44
-14 15 -25 33 -25 41 0 7 -9 24 -20 37 -11 12 -27 32 -34 43 -24 33 -31 8 -31
-103 0 -107 0 -107 -34 -110 -18 -2 -38 1 -44 7 -17 17 -27 13 -27 -13 0 -24
16 -36 51 -36 11 0 22 -6 25 -14 3 -7 28 -28 56 -46 44 -29 54 -32 79 -23 21
8 32 8 45 -2 17 -12 17 -14 1 -38 -22 -33 -23 -164 -2 -222 8 -22 15 -51 15
-65 1 -55 10 -70 46 -70 37 0 48 -11 39 -40 -5 -15 -14 -19 -38 -17 -32 2 -32
2 -31 -59 1 -44 7 -71 22 -96 12 -20 22 -43 22 -52 0 -9 4 -16 10 -16 5 0 16
-14 25 -30 13 -26 20 -29 42 -24 24 6 26 5 20 -22 -6 -29 21 -124 35 -124 10
0 12 26 8 108 -2 56 0 62 18 62 28 0 32 -18 32 -126 0 -66 -5 -104 -15 -125
-9 -16 -20 -52 -25 -81 -6 -29 -19 -61 -30 -73 -23 -24 -26 -60 -7 -68 7 -3
36 6 63 19 27 13 63 28 80 34 16 6 61 37 98 71 87 77 118 79 126 9 3 -25 9
-51 13 -57 10 -15 83 -17 92 -3 10 16 58 11 93 -10 24 -15 32 -27 32 -49 0
-29 1 -29 68 -36 136 -12 147 -16 157 -58 6 -22 4 -27 -12 -27 -10 0 -24 5
-30 11 -25 25 -232 8 -241 -19 -2 -7 9 -18 26 -24 18 -7 33 -21 36 -34 11 -41
97 -75 204 -80 69 -3 76 5 48 58 -8 15 -12 29 -10 31 8 8 74 -27 74 -38 0 -14
43 -55 94 -89 44 -29 83 -33 112 -11 20 15 64 20 64 7 0 -5 -13 -18 -30 -30
-36 -27 -39 -52 -7 -52 13 0 32 -9 42 -20 10 -11 26 -20 37 -20 10 0 27 -9 38
-20 11 -11 24 -20 30 -20 5 0 15 -9 22 -20 7 -11 20 -20 29 -20 20 0 59 -53
59 -80 0 -29 34 -22 38 8 2 14 -7 31 -26 49 -39 37 -47 65 -25 85 24 22 217
22 330 2 44 -8 92 -12 106 -9 39 10 67 -10 67 -48 0 -39 -54 -97 -112 -122
-21 -8 -38 -20 -38 -25 0 -6 -11 -16 -25 -22 -15 -7 -25 -20 -25 -32 0 -12 -6
-30 -13 -41 -8 -11 -26 -63 -41 -115 -34 -117 -28 -144 31 -153 21 -4 53 -16
72 -28 33 -20 33 -22 28 -71 -8 -68 -16 -74 -68 -51 -57 25 -73 46 -66 82 5
23 1 32 -25 51 -35 26 -48 17 -48 -35 0 -17 -5 -46 -10 -65 -16 -53 -4 -84 43
-115 41 -28 48 -29 212 -37 197 -9 393 -1 450 18 22 7 57 16 77 19 21 4 49 18
64 32 25 23 26 28 21 95 -3 38 -2 81 4 94 14 38 41 27 54 -21 5 -22 15 -49 21
-60 6 -11 14 -33 18 -48 4 -16 17 -33 33 -40 23 -10 28 -9 41 11 8 13 25 22
39 22 13 0 26 7 30 18 4 9 15 23 25 30 26 19 22 47 -8 67 -20 13 -24 22 -20
41 5 17 2 24 -9 24 -8 0 -15 -9 -15 -20 0 -27 -23 -35 -52 -17 -13 8 -34 17
-48 21 -14 3 -38 18 -54 32 -26 23 -28 29 -22 67 16 97 16 123 4 143 -49 77
-61 92 -78 97 -13 3 -23 17 -26 37 -5 21 -20 42 -50 63 -55 41 -73 76 -48 94
22 16 68 17 96 2 16 -8 33 -6 79 10 53 20 67 21 156 12 54 -6 150 -7 213 -3
134 8 279 7 333 -3 27 -5 43 -3 55 7 9 8 28 20 42 26 14 7 39 21 55 32 61 40
82 49 140 59 33 6 97 10 141 10 82 0 82 0 56 -52 -14 -29 -29 -76 -33 -106 -6
-42 -14 -60 -39 -82 -32 -29 -64 -37 -75 -19 -10 16 -55 12 -62 -6 -3 -8 -1
-20 6 -27 20 -20 12 -37 -39 -86 -34 -33 -48 -53 -44 -67 3 -10 -4 -46 -16
-78 -26 -77 -25 -89 9 -128 15 -18 30 -40 33 -48 2 -8 25 -22 49 -30 44 -16
44 -16 47 -80 2 -57 5 -68 30 -87 15 -13 39 -23 54 -23 20 0 35 -12 63 -50 20
-28 48 -53 61 -56 35 -9 57 13 50 50 -34 184 -30 240 20 273 25 16 28 15 69
-7 43 -23 45 -23 64 -6 28 26 75 10 79 -27 3 -21 -4 -31 -30 -47 -35 -21 -83
-27 -93 -10 -3 6 -16 10 -28 10 -20 0 -22 -4 -19 -38 3 -26 -3 -52 -17 -78
-39 -72 -14 -92 50 -39 22 19 46 35 51 35 6 0 40 26 76 57 64 57 64 57 59 105
-5 40 -3 52 14 69 11 11 24 31 29 44 5 13 32 41 59 62 49 37 50 39 44 80 -7
54 19 71 48 32 22 -29 33 -20 24 20 -7 33 -30 51 -64 51 -12 0 -21 5 -21 10 0
6 -11 15 -24 20 -13 5 -27 18 -31 29 -3 11 -31 34 -61 51 -41 24 -54 37 -54
55 0 13 -4 26 -10 30 -5 3 -18 35 -29 71 -11 38 -29 72 -42 83 -23 18 -23 18
9 35 63 33 108 15 230 -89 50 -42 56 -45 115 -46 34 -1 67 0 72 1 30 7 228 5
278 -4 43 -6 65 -6 78 2 23 15 125 16 134 2 4 -7 13 -6 27 1 11 6 29 8 40 6
11 -3 32 -1 47 4 29 10 358 -12 380 -25 19 -12 12 -44 -17 -78 -16 -18 -38
-47 -50 -65 -12 -17 -42 -41 -66 -52 -45 -22 -96 -83 -96 -115 0 -11 -12 -54
-26 -98 -17 -51 -24 -88 -20 -106 4 -15 10 -64 15 -108 12 -123 67 -172 218
-194 32 -4 79 -14 105 -20 40 -10 53 -10 80 3 33 15 428 30 428 16 0 -3 6 -13
13 -23 12 -16 19 -17 48 -8 19 6 53 16 77 22 38 10 59 30 31 30 -35 0 -81 36
-104 82 -14 27 -25 56 -25 64 0 8 -11 24 -25 36 -17 15 -25 32 -25 55 0 18 -4
33 -10 33 -12 0 -30 -34 -30 -58 0 -11 -10 -31 -21 -46 -21 -26 -22 -26 -41
-9 -26 23 -45 72 -40 99 4 23 52 76 100 112 29 22 31 27 25 69 -5 40 -3 48 18
64 13 10 18 19 12 19 -20 0 -84 62 -128 123 -35 48 -44 56 -70 54 -37 -2 -50
37 -16 48 17 5 19 9 8 25 -17 28 0 41 65 51 69 11 84 -2 69 -57 -10 -35 -8
-42 22 -86 45 -67 57 -63 57 20 0 56 -4 72 -20 87 -37 33 -26 46 38 44 31 -1
96 1 143 6 83 7 87 7 102 -16 15 -21 20 -22 50 -11 18 7 43 12 55 12 19 0 22
6 22 38 0 20 -7 50 -15 66 -27 52 24 62 105 21 49 -25 49 -25 102 11 44 30 54
42 58 71 3 24 14 43 32 56 32 24 38 20 47 -25 8 -38 35 -46 154 -47 38 -1 77
-6 87 -11 13 -7 21 -7 25 1 4 5 18 14 31 19 32 12 31 30 -2 30 -21 0 -25 4
-22 23 2 17 10 22 33 22 28 0 30 -2 37 -54 7 -45 5 -56 -9 -67 -17 -12 -16
-15 12 -38 17 -14 37 -25 45 -26 8 0 21 -9 28 -20 8 -13 23 -20 42 -20 35 0
38 10 10 35 -46 42 11 87 70 55 33 -18 73 -91 81 -148 4 -30 10 -56 13 -59 12
-12 104 -15 110 -4 4 6 18 11 31 11 38 0 43 -36 20 -146 -10 -45 15 -50 56
-12 57 51 76 60 109 53 21 -5 30 -12 30 -26 0 -11 7 -30 15 -42 8 -12 11 -27
7 -34 -11 -18 -140 -103 -156 -103 -9 0 -20 -9 -26 -20 -6 -11 -15 -20 -21
-20 -12 0 -91 -34 -131 -55 -14 -8 -35 -15 -46 -15 -11 0 -44 -19 -74 -43 -71
-57 -136 -86 -262 -118 -21 -5 -48 -16 -60 -24 -32 -23 -46 -18 -96 35 -35 38
-54 50 -76 50 -16 0 -40 7 -54 15 -14 8 -39 21 -56 29 -17 8 -36 22 -44 30 -7
10 -28 16 -52 16 -39 0 -39 0 -36 48 3 40 6 47 25 50 14 2 26 -4 33 -17 6 -12
19 -21 29 -21 10 0 30 -9 44 -20 14 -11 40 -20 60 -20 20 0 46 -9 61 -21 39
-31 134 -37 188 -13 37 17 84 21 143 15 39 -5 133 16 150 32 9 9 23 17 31 17
8 0 14 5 14 11 0 5 14 15 30 20 17 6 30 15 30 20 0 12 -37 11 -45 -1 -4 -6
-22 -17 -42 -25 -30 -13 -38 -13 -63 0 -29 15 -108 103 -129 143 -6 12 -18 22
-26 22 -10 0 -15 10 -15 29 0 17 -4 33 -10 36 -5 3 -10 14 -10 23 0 9 -10 35
-22 58 -13 25 -19 48 -14 59 10 27 97 -60 99 -100 1 -18 20 -46 57 -85 79 -84
99 -94 164 -86 46 6 58 4 73 -11 17 -17 20 -18 48 -3 17 8 31 16 33 17 2 1 -4
13 -13 27 -14 22 -15 29 -4 42 9 12 10 17 1 23 -6 4 -18 25 -25 46 -14 40 -15
40 -68 42 -42 1 -57 6 -68 22 -20 30 -34 26 -29 -9 6 -42 -14 -57 -46 -36 -35
22 -43 56 -19 76 21 17 38 96 22 106 -5 3 -9 -4 -9 -15 0 -32 -35 -61 -74 -61
-41 0 -78 28 -111 85 -18 30 -31 42 -43 38 -9 -2 -37 3 -61 12 -80 28 -175 20
-261 -23 -56 -28 -76 -43 -78 -59 -4 -30 -13 -29 -47 7 -35 37 -48 38 -63 5
-8 -18 -20 -25 -39 -25 -18 0 -43 -14 -70 -38 -78 -68 -120 -92 -190 -109 -32
-7 -30 -41 3 -53 27 -11 60 -4 131 27 17 7 35 13 40 13 23 0 193 92 203 110 9
17 18 20 38 15 16 -3 53 3 87 13 111 35 254 -5 272 -77 3 -14 17 -39 31 -56
30 -36 64 -113 56 -126 -3 -5 -12 -9 -20 -9 -8 0 -14 -10 -14 -24 0 -27 -14
-41 -52 -50 -21 -5 -28 -3 -28 8 0 27 -41 46 -82 40 -44 -8 -68 7 -68 42 0 34
-36 51 -61 28 -21 -19 -17 -34 12 -34 27 0 24 -15 -6 -28 -28 -13 -33 -39 -10
-48 8 -4 15 -10 15 -15 0 -15 -27 -10 -74 11 -34 17 -51 19 -82 12 -22 -5 -48
-6 -59 -2 -11 4 -23 6 -27 3 -12 -6 -10 -53 2 -53 6 0 10 -12 10 -27 0 -14 7
-34 16 -44 19 -21 12 -49 -12 -49 -9 0 -29 11 -46 25 -29 25 -85 33 -122 19
-22 -8 -20 -24 2 -24 30 0 62 -38 62 -73 1 -22 12 -45 35 -72 33 -39 33 -39
127 -41 75 -1 101 2 132 19 34 16 43 17 60 6 12 -7 38 -11 59 -10 48 2 77 -6
77 -23 0 -8 7 -19 15 -26 23 -19 19 -26 -25 -49 -48 -25 -87 -27 -126 -6 -31
16 -62 19 -88 9 -22 -9 -20 -31 4 -39 25 -8 16 -25 -13 -25 -12 0 -33 -7 -47
-15 -49 -28 -75 -36 -97 -30 -51 12 -16 45 50 45 32 0 35 15 7 30 -21 11 -63
5 -95 -16 -11 -6 -31 -15 -45 -19 -14 -4 -35 -17 -48 -29 -29 -26 -113 -44
-259 -55 -61 -5 -116 -12 -123 -16 -6 -4 -61 -11 -123 -16 -62 -5 -136 -12
-164 -15 -45 -6 -53 -4 -53 9 0 9 -9 21 -19 27 -11 5 -23 19 -26 30 -4 13 -15
20 -31 20 -27 0 -31 -12 -9 -30 8 -7 15 -24 15 -37 0 -25 0 -25 -67 -18 -37 4
-83 16 -102 26 -20 10 -47 19 -61 19 -14 0 -36 7 -49 16 -13 9 -41 21 -63 26
-40 8 -81 33 -129 76 -22 19 -31 22 -47 13 -33 -18 -87 -13 -107 9 -10 11 -28
20 -40 20 -12 0 -33 8 -46 18 -13 10 -37 24 -53 32 -16 8 -35 25 -44 38 -14
21 -16 22 -33 6 -18 -16 -21 -16 -45 7 -14 13 -30 34 -35 47 -10 26 -31 28
-53 6 -22 -21 -20 -51 3 -57 10 -2 21 -17 25 -33 4 -16 16 -37 27 -47 10 -10
19 -26 19 -36 0 -32 22 -39 145 -46 70 -4 129 -13 141 -20 12 -8 39 -17 60
-21 21 -4 57 -17 80 -30 32 -19 56 -24 107 -24 36 0 68 -4 72 -9 9 -16 -37
-41 -75 -41 -59 -1 -11 -19 56 -21 108 -4 124 -33 23 -42 -57 -5 -64 -9 -100
-48 -21 -24 -42 -51 -45 -61 -3 -10 -9 -18 -14 -18 -5 0 -15 -12 -22 -26 -7
-14 -25 -33 -40 -42 -25 -15 -28 -15 -46 1 -24 22 -32 13 -32 -38 0 -33 -5
-46 -22 -58 -19 -13 -20 -16 -6 -16 33 -1 84 -100 60 -115 -11 -6 -82 25 -82
36 0 5 -24 33 -52 64 -52 55 -53 56 -100 50 -47 -5 -47 -5 -54 30 -3 19 -4 38
-1 41 10 9 -12 43 -28 43 -17 0 -20 -35 -5 -45 6 -3 10 -18 10 -33 0 -38 25
-69 68 -87 38 -16 99 -59 160 -111 40 -34 83 -62 150 -95 52 -26 72 -15 72 41
0 58 -7 68 -81 116 -49 31 -69 50 -69 65 0 34 18 57 52 64 18 4 49 20 68 35
113 88 292 125 396 80 29 -12 34 -11 83 21 44 29 51 38 49 62 -4 36 14 47 82
47 32 0 63 7 74 15 29 22 98 20 94 -2 -2 -10 -12 -19 -23 -21 -11 -2 -29 -12
-40 -21 -11 -9 -31 -23 -45 -30 -63 -31 -90 -48 -118 -73 -58 -51 -115 -88
-138 -88 -26 0 -76 -54 -68 -74 13 -33 64 -26 110 15 11 10 40 23 65 27 26 5
64 24 92 45 99 75 196 72 211 -8 8 -40 49 -73 101 -82 61 -10 114 61 66 86
-13 7 -22 30 -30 72 -6 34 -17 69 -25 78 -19 22 -28 73 -16 91 12 19 85 19
105 0 12 -13 13 -22 3 -51 -15 -52 -2 -130 23 -136 11 -3 22 -16 25 -30 6 -24
6 -24 25 7 15 24 17 34 7 49 -18 29 -3 48 57 70 88 33 165 29 210 -11 62 -54
92 -132 60 -158 -43 -35 0 -66 76 -54 38 6 43 4 82 -34 42 -41 42 -41 71 -17
33 26 27 45 -13 45 -20 0 -34 8 -45 25 -9 14 -22 25 -29 25 -8 0 -12 21 -12
68 0 45 -6 75 -17 92 -9 14 -19 50 -23 80 -4 30 -14 63 -22 72 -9 10 -16 35
-17 55 -1 37 0 38 35 41 73 6 86 -7 93 -95 3 -43 10 -108 14 -145 12 -105 31
-107 44 -5 21 155 22 158 100 178 45 12 48 12 88 -17 63 -45 122 -73 157 -73
21 -1 37 -8 47 -22 8 -12 24 -27 35 -33 90 -50 103 -56 119 -48 25 11 91 8
135 -7 46 -15 134 -30 202 -34 33 -1 61 -10 83 -26 33 -23 33 -23 12 -56 -11
-18 -20 -41 -20 -52 0 -24 50 -103 66 -103 6 0 19 -9 29 -20 27 -30 41 -25 71
25 23 40 25 52 19 101 -8 63 -34 129 -59 147 -9 7 -19 29 -23 49 -8 52 10 72
58 65 35 -5 39 -3 48 26 16 45 13 75 -7 81 -33 11 -208 -3 -246 -19 -44 -18
-431 -24 -448 -7 -17 17 -4 56 22 68 14 7 70 14 126 17 56 2 110 10 122 16 11
6 39 11 61 11 81 0 88 16 36 77 -19 22 -31 43 -28 47 12 12 54 6 59 -9 4 -8
11 -15 16 -15 6 0 25 -7 44 -16 37 -18 113 -7 151 21 10 8 30 15 46 15 33 0
34 7 6 37 -18 18 -20 25 -9 38 7 8 18 15 24 15 7 0 23 11 36 25 23 24 23 24
-9 51 -43 36 -41 78 4 82 43 3 56 -9 57 -59 2 -51 17 -79 76 -135 53 -51 57
-90 13 -105 -32 -11 -79 -89 -66 -109 3 -5 24 -10 46 -10 33 0 46 6 67 30 30
34 48 38 57 12 3 -11 17 -24 32 -31 24 -11 25 -13 10 -28 -15 -15 -18 -15 -35
0 -37 34 -43 28 -131 -126 -13 -23 -30 -73 -38 -112 -8 -38 -19 -89 -24 -112
-9 -48 -4 -73 17 -73 15 0 17 10 14 78 -2 43 13 55 37 31 16 -16 43 -4 43 19
0 11 9 31 20 45 11 14 20 33 20 44 0 10 9 32 20 48 11 17 20 37 20 45 0 23 88
100 114 100 13 0 29 7 36 15 21 25 42 17 114 -40 38 -30 71 -55 75 -55 3 0 14
-14 23 -30 14 -24 14 -30 3 -30 -8 0 -17 5 -20 10 -3 6 -16 10 -28 10 -12 0
-39 9 -60 20 -20 11 -50 20 -65 20 -16 0 -37 9 -47 20 -20 22 -35 18 -35 -9 0
-26 100 -123 134 -130 40 -9 66 -48 69 -101 2 -48 -25 -71 -36 -30 -6 23 -27
27 -27 5 0 -19 96 -111 132 -126 22 -9 31 -7 57 12 37 27 41 37 46 118 3 35 6
65 8 67 9 9 74 -45 105 -86 19 -25 43 -48 53 -52 10 -4 36 -26 58 -49 39 -39
43 -41 111 -44 63 -3 70 -2 66 13 -9 27 6 38 56 45 42 6 54 3 95 -24 40 -25
49 -27 51 -14 4 18 -25 55 -43 55 -6 0 -21 11 -33 25 -19 22 -28 25 -56 19
-31 -5 -36 -3 -60 32 -34 50 -34 87 0 113 15 12 33 21 40 21 21 0 44 29 44 56
0 18 -5 24 -21 24 -37 0 -86 47 -93 90 -6 37 -22 56 -72 86 -17 10 -17 13 -4
29 8 10 13 31 11 48 -3 28 -1 29 29 25 36 -5 45 4 30 32 -9 16 -21 20 -60 20
-50 0 -50 0 -50 81 0 69 -4 87 -26 125 -30 51 -24 86 18 104 57 25 128 91 128
119 0 23 -48 31 -235 39 -149 6 -198 11 -205 21 -14 24 0 253 18 281 26 40 19
363 -8 398 -37 47 -15 141 27 116 10 -6 19 -20 21 -31 2 -12 12 -29 23 -39 14
-12 19 -30 19 -65 0 -26 7 -74 15 -106 19 -73 35 -308 24 -347 -8 -26 -4 -33
29 -62 20 -18 60 -42 87 -54 28 -12 63 -28 78 -36 16 -8 57 -14 91 -14 84 0
110 -32 70 -89 -22 -31 -13 -92 19 -130 14 -17 27 -49 31 -76 4 -25 14 -49 22
-52 8 -3 14 -16 14 -29 0 -27 17 -33 22 -8 2 9 19 22 38 28 41 13 49 38 20 63
-20 17 -60 87 -60 105 0 17 34 7 71 -23 21 -17 43 -28 49 -24 20 13 10 45 -20
60 -32 17 -36 29 -20 71 15 38 -3 56 -54 52 -49 -4 -55 13 -36 102 12 55 12
56 -24 110 -20 30 -36 60 -36 67 0 26 -64 74 -91 69 -18 -3 -32 1 -44 14 -25
28 -37 25 -29 -7 8 -34 30 -61 66 -79 35 -18 78 -144 58 -169 -19 -23 -30 -18
-46 22 -9 20 -26 45 -39 54 -12 10 -28 39 -34 63 -11 45 -11 45 -53 43 -42 -2
-43 -1 -46 31 -3 27 1 34 25 44 22 9 24 12 10 15 -28 7 -56 73 -50 120 5 37 3
41 -26 53 -17 7 -31 18 -31 26 0 27 20 64 35 64 9 0 13 5 10 10 -3 6 -15 10
-25 10 -10 0 -28 14 -40 30 -12 17 -28 30 -35 30 -22 0 -28 20 -11 38 9 10 13
27 10 39 -4 14 1 25 16 36 31 21 50 11 50 -27 1 -44 52 -105 73 -87 11 8 13
19 8 34 -17 49 10 74 42 39 21 -23 21 -36 2 -52 -23 -19 -18 -47 13 -68 32
-23 102 -157 102 -195 0 -17 5 -27 15 -27 25 0 31 55 14 120 -3 10 4 15 21 15
22 0 26 -5 32 -50 4 -27 5 -62 3 -76 -4 -17 0 -31 15 -44 11 -10 20 -23 20
-30 0 -6 13 -24 29 -39 15 -15 41 -52 56 -82 34 -67 36 -68 80 -50 33 14 35
17 23 38 -6 13 -13 39 -14 58 -2 40 -31 128 -49 150 -24 29 -55 109 -55 143 0
19 -9 46 -20 60 -11 14 -20 30 -20 36 0 6 -4 11 -10 11 -5 0 -10 -6 -10 -14 0
-28 -41 -67 -67 -64 -21 2 -29 14 -49 67 -13 35 -24 69 -24 76 0 7 -29 43 -65
80 -48 51 -65 75 -65 96 0 48 -54 66 -70 24 -7 -17 -17 -25 -34 -25 -34 0 -98
-57 -91 -80 10 -32 -12 -31 -40 2 -22 26 -26 39 -21 66 4 29 1 39 -24 62 -30
28 -38 65 -24 117 10 37 67 63 137 63 64 0 147 -29 147 -50 0 -6 10 -10 23 -8
17 2 22 10 22 32 0 34 -37 51 -91 41 -29 -5 -32 -3 -44 35 -16 49 -14 51 35
38 88 -23 112 -22 129 5 9 13 14 32 10 41 -4 10 1 29 12 44 26 36 22 155 -4
150 -13 -3 -16 -12 -14 -36 4 -41 -18 -43 -59 -5 -31 30 -38 53 -15 53 21 0
30 20 17 33 -9 9 -17 6 -31 -13 -16 -21 -20 -22 -25 -8 -4 9 -6 22 -4 29 7 52
-19 67 -39 24 -6 -14 -16 -25 -21 -25 -15 0 -61 60 -61 80 0 26 21 36 32 16
12 -22 31 -20 46 4 7 11 21 20 32 20 27 0 25 11 -10 55 -37 47 -37 47 5 102
19 25 35 51 35 58 0 21 31 27 55 11 13 -9 44 -20 68 -27 25 -6 53 -20 63 -30
9 -10 27 -19 39 -19 71 0 128 -61 70 -76 -22 -5 -44 -39 -32 -50 3 -3 24 4 48
15 53 26 71 26 94 1 23 -26 10 -60 -34 -86 -31 -18 -38 -38 -22 -62 7 -11 9
-11 14 2 8 21 60 21 92 0 14 -9 25 -15 26 -13 0 2 2 45 5 94 3 50 7 104 10
120 4 25 -1 36 -31 64 -37 35 -37 35 -54 13 -23 -31 -74 -20 -107 23 -38 50
-99 89 -128 81 -20 -5 -29 -1 -42 19 -9 14 -24 25 -34 25 -10 0 -36 21 -56 48
-21 26 -43 52 -49 57 -22 20 -57 92 -53 111 6 35 42 28 72 -15 15 -22 34 -42
42 -45 8 -3 14 -17 14 -31 0 -20 8 -29 33 -40 17 -7 41 -28 51 -47 22 -37 36
-49 48 -42 15 10 8 25 -17 34 -14 5 -25 17 -25 26 0 9 -11 29 -25 46 -34 40
-35 93 -2 85 12 -4 29 -2 37 3 21 13 1 44 -31 48 -53 8 -106 83 -89 127 14 37
12 55 -5 55 -9 0 -15 -9 -15 -25 0 -28 -25 -45 -68 -45 -16 0 -42 -10 -57 -22
-16 -12 -47 -23 -75 -26 -59 -5 -81 17 -71 76 8 45 -2 253 -11 232z m-7956
-927 c18 -9 40 -19 48 -23 22 -10 24 -50 4 -87 -15 -28 -15 -37 -4 -57 11 -21
10 -28 -9 -55 -31 -44 -57 -38 -116 25 -28 29 -35 32 -73 27 -38 -5 -42 -4
-42 15 0 25 29 43 57 36 17 -5 22 0 28 25 4 17 14 35 23 40 11 6 16 20 14 40
-3 37 17 41 70 14z m-622 -163 c0 -12 79 -140 106 -173 13 -16 24 -33 24 -39
0 -6 7 -20 17 -30 9 -10 21 -28 28 -41 7 -13 18 -21 29 -19 17 3 18 -3 12 -90
-11 -146 -15 -168 -36 -168 -29 0 -41 88 -21 158 8 27 6 36 -9 50 -25 23 -66
85 -75 111 -3 12 -12 21 -19 21 -8 0 -20 7 -27 17 -8 9 -29 22 -46 30 -39 16
-42 36 -8 51 49 23 33 38 -73 68 -28 8 -6 39 38 55 45 16 60 16 60 -1z m6779
-359 c32 -24 19 -41 -30 -41 -46 0 -64 24 -34 46 25 18 35 17 64 -5z m626
-132 c0 -113 -8 -150 -27 -131 -17 17 -23 193 -8 221 24 46 35 17 35 -90z
m-6985 -24 c6 -8 10 -22 8 -31 -4 -22 -28 -31 -28 -10 0 18 -16 30 -24 17 -4
-5 1 -17 10 -26 19 -19 4 -68 -18 -63 -7 1 -24 -2 -37 -6 -15 -5 -32 -3 -47 5
-21 11 -27 10 -49 -11 -14 -13 -25 -31 -25 -41 0 -10 -16 -35 -35 -56 -29 -32
-35 -35 -41 -19 -4 9 -2 22 5 29 6 6 11 25 11 42 0 30 66 115 89 115 6 0 22
11 37 25 15 14 39 25 55 25 15 0 31 5 34 10 9 15 41 12 55 -5z m7870 -382 c19
-52 43 -88 97 -141 62 -63 66 -85 21 -103 -30 -11 -31 -13 -10 -16 12 -3 27
-13 32 -24 6 -10 19 -19 29 -19 25 0 42 -22 44 -57 3 -42 -19 -37 -93 25 -37
30 -36 30 -56 -33 -17 -54 -18 -55 -55 -55 -29 0 -42 6 -58 26 -22 28 -28 74
-11 74 6 0 24 13 41 30 17 16 44 35 60 42 16 7 29 17 29 23 0 12 -109 115
-121 115 -16 0 -49 40 -49 59 0 22 57 81 78 81 7 0 17 -12 22 -27z m-890 -330
c0 -23 -37 -14 -48 12 -21 45 -14 55 18 27 17 -15 30 -32 30 -39z m-3622 -7
c2 -22 10 -49 18 -60 8 -11 14 -28 14 -37 0 -9 9 -27 21 -40 29 -33 22 -138
-10 -173 -12 -12 -21 -28 -21 -36 0 -7 -6 -21 -14 -29 -7 -9 -16 -42 -18 -74
-5 -57 -5 -57 35 -69 43 -13 56 -31 37 -53 -18 -21 -172 -21 -190 0 -17 20 2
42 44 53 30 8 31 11 37 73 3 35 0 132 -8 214 -14 171 -16 258 -6 269 4 4 19 6
33 4 21 -3 25 -9 28 -42z m-1685 -51 c6 -16 14 -32 18 -35 20 -14 59 -108 59
-144 0 -36 -40 -127 -66 -151 -7 -5 -14 -36 -17 -68 -6 -57 -6 -57 27 -71 46
-19 54 -36 28 -57 -27 -21 -20 -47 16 -60 20 -8 29 -6 48 12 22 21 22 21 43 0
12 -12 21 -32 21 -45 0 -39 -22 -49 -95 -41 -66 7 -66 7 -59 -19 4 -19 0 -36
-17 -61 -36 -53 -50 -46 -69 33 -10 43 5 100 36 133 33 34 32 35 -32 42 -68 7
-81 17 -67 49 25 57 -60 138 -129 123 -32 -7 -34 -19 -12 -63 8 -17 18 -47 21
-67 5 -32 4 -35 -18 -34 -35 0 -68 49 -79 114 -5 30 -12 59 -15 64 -11 19 15
61 54 86 39 27 39 27 83 7 46 -20 98 -62 98 -79 0 -5 9 -18 20 -28 14 -13 20
-31 20 -62 0 -37 3 -44 18 -41 24 5 35 148 17 238 -22 109 -29 228 -14 246 19
23 51 13 62 -21z m3381 29 c9 -3 16 -13 16 -21 0 -8 18 -51 40 -96 42 -84 45
-112 16 -147 -38 -46 -59 -97 -57 -142 1 -25 -3 -49 -8 -52 -18 -12 -32 34
-30 97 1 34 -5 96 -14 137 -38 178 -26 248 37 224z m-201 -285 c79 -40 144
-128 133 -180 -5 -29 -5 -29 52 -29 32 0 63 -5 70 -12 16 -16 15 -47 -2 -54
-12 -5 -13 -11 -4 -30 6 -13 15 -24 19 -24 4 0 14 -2 21 -5 8 -3 25 3 38 15
13 11 26 20 30 20 30 0 43 -93 14 -104 -24 -9 -70 -7 -100 4 -40 16 -56 7 -44
-24 7 -18 5 -35 -6 -61 -26 -63 -60 -37 -71 53 -5 44 -2 51 31 91 20 23 36 47
36 52 0 5 -24 9 -54 9 -63 0 -85 17 -69 53 13 28 3 50 -40 89 -29 26 -97 46
-117 33 -15 -9 -2 -74 22 -108 37 -54 3 -76 -44 -29 -22 23 -67 132 -68 165 0
13 84 97 98 97 7 0 32 -10 55 -21z m-2933 -18 c36 -27 63 -107 47 -143 -22
-50 -59 -45 -70 10 -4 20 -18 34 -50 50 -41 21 -47 21 -80 7 -44 -18 -47 -18
-47 -2 1 19 41 62 80 86 40 25 80 22 120 -8z m1233 17 c30 -17 87 -70 87 -81
0 -4 7 -15 16 -24 19 -19 15 -77 -6 -81 -8 -1 -23 11 -32 27 -19 35 -91 75
-118 66 -36 -11 -45 -33 -23 -58 25 -27 37 -85 22 -103 -15 -18 -79 32 -79 62
0 12 -7 38 -16 59 -19 47 -12 80 28 117 33 31 82 37 121 16z m436 -7 c42 -22
61 -56 63 -115 2 -65 -49 -88 -65 -30 -11 40 -94 82 -125 65 -54 -29 -54 25 0
72 38 32 74 34 127 8z m1688 7 c48 -21 76 -58 81 -109 8 -81 -36 -122 -58 -54
-15 44 -76 80 -121 70 -16 -4 -31 -11 -34 -16 -10 -15 -32 -10 -39 8 -10 26
87 113 126 113 9 0 30 -5 45 -12z m3507 -38 c6 -6 -1 -13 -16 -19 -14 -5 -28
-18 -32 -28 -7 -17 -8 -17 -18 0 -5 10 -7 30 -3 44 5 21 10 24 33 18 15 -3 31
-10 36 -15z m-1322 -83 c34 -53 -68 -111 -173 -100 -44 5 -48 4 -60 -23 -21
-44 -53 -43 -99 4 -22 22 -40 49 -40 60 0 23 34 39 53 24 26 -21 64 -22 81 -3
12 13 38 21 83 26 37 4 73 14 81 22 16 16 61 10 74 -10z m716 -25 c2 -13 -7
-35 -21 -52 -14 -16 -27 -35 -29 -41 -10 -31 -30 5 -25 45 9 63 67 101 75 48z
m-1202 -138 c1 -66 15 -113 45 -150 53 -67 24 -132 -31 -71 -41 44 -47 53 -76
102 -16 27 -37 58 -46 67 -37 37 -19 71 48 87 54 12 59 10 60 -35z m1390 -10
c15 -25 38 -50 51 -55 16 -6 23 -15 20 -27 -17 -60 -17 -73 -2 -78 26 -10 7
-74 -22 -74 -11 0 -73 92 -73 110 0 6 -11 30 -24 53 -21 36 -31 79 -27 110 1
4 12 7 26 7 18 0 31 -11 51 -46z m-3500 -15 c12 -11 40 -23 63 -26 49 -7 55
-31 15 -62 -33 -26 -53 -26 -93 -3 -35 19 -52 72 -31 97 16 19 19 19 46 -6z
m-3371 -13 c20 -14 43 -22 55 -19 34 9 37 -26 4 -53 -35 -28 -65 -30 -102 -7
-35 23 -42 33 -42 64 0 47 30 52 85 15z m1678 4 c14 -11 37 -20 51 -20 36 0
43 -25 15 -55 -43 -44 -120 -20 -141 45 -15 45 32 64 75 30z m1597 -39 c0 -36
-18 -51 -47 -40 -15 5 -23 17 -23 33 0 24 10 29 58 35 7 0 12 -11 12 -28z
m2979 -3 c26 -10 26 -10 -13 -30 -32 -16 -43 -18 -67 -8 -101 42 -25 79 80 38z
m-1079 -72 c0 -13 -7 -29 -15 -36 -22 -18 -19 -82 7 -134 18 -38 20 -49 10
-71 -6 -14 -15 -25 -20 -25 -17 0 -72 60 -72 80 0 38 -49 110 -75 110 -30 0
-55 10 -55 21 0 19 143 76 198 78 17 1 22 -5 22 -23z m-1366 -8 c14 -23 -9
-48 -46 -48 -26 0 -29 3 -23 23 13 44 49 57 69 25z m3163 -194 c3 -8 1 -20 -6
-27 -14 -14 -47 15 -37 32 10 16 36 13 43 -5z m-2537 -48 c0 -16 -34 -31 -50
-21 -22 14 -10 35 20 35 19 0 30 -5 30 -14z"/>
<path d="M9472 7467 c-43 -13 -36 -30 18 -39 51 -9 60 -5 60 28 0 27 -20 30
-78 11z"/>
<path d="M7107 7464 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27 -31
17z"/>
<path d="M12216 7434 c-28 -25 -25 -43 7 -44 5 0 21 -13 35 -28 33 -35 103
-50 122 -27 7 8 26 15 42 15 51 0 26 25 -28 28 -59 4 -76 16 -68 48 7 26 -5
31 -24 12 -9 -9 -16 -8 -30 5 -23 21 -21 21 -56 -9z"/>
<path d="M9787 7409 c-45 -48 -38 -75 10 -43 15 10 48 21 73 24 44 6 44 7 19
17 -15 7 -29 19 -32 27 -10 25 -29 18 -70 -25z"/>
<path d="M3740 7415 c0 -16 6 -25 16 -25 9 0 27 -9 41 -20 31 -24 95 -43 117
-34 10 4 16 18 16 35 0 25 -3 29 -22 24 -14 -4 -42 4 -73 20 -66 33 -95 33
-95 0z"/>
<path d="M11186 7424 c-8 -22 -9 -20 19 -50 14 -15 25 -35 25 -45 0 -25 26
-24 33 1 3 11 14 20 25 20 11 0 27 11 36 25 20 30 20 35 1 35 -8 0 -15 -4 -15
-8 0 -11 -46 -32 -70 -32 -12 0 -21 10 -25 30 -8 35 -21 46 -29 24z"/>
<path d="M4736 7399 c-25 -29 -25 -32 -10 -57 38 -65 61 -85 88 -78 32 8 45
49 24 74 -8 9 -19 29 -26 44 -19 47 -46 53 -76 17z"/>
<path d="M5954 7416 c-9 -24 0 -50 22 -61 12 -6 32 -23 46 -39 24 -28 48 -29
48 -2 0 7 12 18 26 25 35 16 15 41 -32 41 -24 0 -34 5 -34 15 0 27 -67 45 -76
21z"/>
<path d="M8059 7420 c-9 -5 -22 -23 -29 -39 -10 -26 -9 -33 12 -61 54 -74 138
-82 138 -14 0 24 5 34 20 39 14 5 20 15 20 37 0 30 0 30 -46 23 -33 -5 -52 -2
-69 9 -28 18 -25 18 -46 6z"/>
<path d="M9962 7410 c-17 -14 -22 -25 -17 -40 7 -22 7 -22 77 -22 63 0 71 7
53 41 -23 46 -73 55 -113 21z"/>
<path d="M10538 7413 c-11 -3 -18 -14 -18 -29 0 -29 11 -31 28 -4 7 11 19 20
28 20 8 0 12 5 9 10 -6 10 -17 11 -47 3z"/>
<path d="M4160 7383 c0 -9 -7 -24 -16 -34 -15 -16 -15 -21 2 -59 15 -33 20
-38 25 -23 11 28 10 133 -1 133 -5 0 -10 -8 -10 -17z"/>
<path d="M7029 7373 c-12 -14 -12 -17 0 -21 7 -2 21 -13 29 -23 21 -25 42 -24
42 1 0 11 -4 20 -9 20 -5 0 -13 9 -16 20 -8 24 -28 26 -46 3z"/>
<path d="M12006 7365 c-4 -14 -11 -25 -17 -25 -16 0 -79 -54 -79 -67 0 -7 -15
-16 -32 -21 -44 -11 -47 -37 -10 -70 16 -15 35 -46 41 -69 14 -49 31 -54 60
-17 30 38 34 60 16 87 -14 23 -14 26 0 41 20 20 25 20 61 1 20 -10 43 -13 71
-9 43 6 57 -1 136 -64 42 -32 50 -18 23 37 -27 52 -62 81 -99 81 -12 0 -29 6
-35 12 -10 10 -17 10 -32 0 -11 -6 -29 -12 -41 -12 -19 0 -20 4 -14 49 6 43 4
51 -14 60 -27 15 -28 14 -35 -14z"/>
<path d="M6635 7349 c-4 -18 -3 -35 4 -42 17 -17 13 -41 -10 -71 -20 -25 -20
-28 -5 -45 9 -10 16 -32 16 -49 0 -21 5 -32 14 -32 11 0 14 11 13 43 -2 42 -2
42 35 41 53 -2 64 51 17 84 -11 7 -19 22 -19 33 0 10 -5 19 -10 19 -6 0 -15
11 -20 25 -13 34 -27 31 -35 -6z"/>
<path d="M7152 7352 c-6 -15 -12 -36 -14 -47 -2 -12 -15 -23 -36 -29 -40 -11
-40 -17 3 -61 62 -61 106 -40 118 56 7 49 -7 80 -42 99 -16 8 -21 5 -29 -18z"/>
<path d="M3936 7325 c-5 -23 -2 -45 9 -64 8 -17 15 -39 15 -49 0 -36 21 -80
41 -85 10 -3 22 -13 25 -24 4 -10 16 -28 26 -40 11 -11 22 -40 25 -63 4 -31
12 -44 28 -50 25 -10 30 -26 40 -122 11 -100 44 -88 45 16 0 52 -28 157 -48
180 -13 14 -17 38 -17 103 -1 89 -3 94 -123 219 -26 28 -59 17 -66 -21z"/>
<path d="M8545 7340 c-10 -11 -24 -20 -32 -20 -26 0 -11 -45 16 -48 29 -5 112
-62 165 -114 42 -42 74 -48 122 -23 36 18 63 19 83 2 44 -36 91 -40 91 -7 0
20 -19 30 -60 30 -16 0 -32 4 -35 10 -3 5 -25 7 -50 3 -43 -5 -45 -4 -66 31
-11 20 -26 36 -31 36 -6 0 -20 9 -32 20 -61 59 -89 80 -106 80 -10 0 -22 5
-25 10 -9 15 -20 12 -40 -10z"/>
<path d="M8907 7330 c8 -31 27 -42 48 -26 18 13 17 14 -13 30 -39 20 -41 20
-35 -4z"/>
<path d="M9250 7335 c-16 -20 12 -65 40 -65 32 0 50 48 25 66 -25 18 -49 18
-65 -1z"/>
<path d="M5025 7309 c-4 -18 -16 -35 -30 -41 -21 -9 -21 -12 -8 -28 12 -13 26
-16 64 -12 41 4 52 1 64 -14 7 -11 17 -16 21 -12 11 11 -23 55 -53 70 -19 9
-29 22 -31 41 -4 36 -19 34 -27 -4z"/>
<path d="M9076 7323 c-4 -11 -1 -22 8 -29 9 -6 16 -19 16 -28 0 -9 10 -21 23
-25 12 -5 37 -23 55 -40 32 -30 32 -30 32 2 0 38 -48 97 -79 97 -11 0 -22 9
-26 20 -8 25 -21 26 -29 3z"/>
<path d="M10847 7334 c-25 -25 27 -104 68 -104 8 0 17 -10 21 -22 4 -13 22
-41 40 -62 20 -23 34 -51 34 -66 0 -36 27 -70 54 -70 35 0 45 19 48 87 3 72
-16 108 -63 118 -20 5 -53 28 -86 61 -50 51 -98 75 -116 58z"/>
<path d="M6996 7312 c-17 -17 -3 -32 29 -32 19 0 35 4 35 8 0 10 -57 32 -64
24z"/>
<path d="M7797 7314 c-10 -11 6 -44 22 -44 28 0 42 -20 30 -42 -13 -25 -4 -35
16 -18 22 18 48 5 40 -21 -5 -14 0 -27 14 -40 26 -25 27 -39 1 -46 -11 -3 -20
-7 -20 -10 0 -14 43 -63 55 -63 8 0 20 -8 27 -18 7 -10 28 -29 46 -43 39 -27
62 -67 62 -103 0 -34 56 -86 93 -86 17 0 30 -7 34 -17 4 -10 14 -23 22 -30 23
-16 7 -27 -18 -12 -27 17 -37 5 -22 -27 10 -23 15 -25 47 -19 38 7 114 -7 175
-32 41 -17 129 -104 129 -128 0 -9 9 -15 25 -15 30 0 31 11 4 67 -12 24 -19
46 -16 49 13 13 46 -9 61 -41 9 -19 21 -37 26 -40 6 -3 10 -15 10 -25 0 -23
41 -56 80 -65 16 -4 51 -27 77 -51 26 -25 58 -47 72 -50 14 -4 37 -13 51 -22
14 -9 41 -18 60 -22 20 -3 39 -13 45 -25 8 -16 18 -19 52 -17 31 2 50 -3 72
-19 16 -12 34 -18 40 -15 13 8 -86 116 -106 116 -7 0 -24 16 -39 35 -28 37
-43 42 -73 23 -31 -19 -79 8 -116 66 -39 61 -61 81 -98 90 -15 4 -55 31 -87
61 -33 30 -66 55 -73 55 -7 0 -30 9 -52 20 -45 23 -77 25 -104 8 -17 -10 -24
-7 -49 20 -17 18 -50 41 -74 53 -24 11 -50 23 -58 28 -8 5 -28 14 -43 20 -25
10 -27 15 -22 44 7 37 -31 83 -75 89 -20 2 -26 9 -28 35 -3 26 -11 37 -43 55
-21 12 -39 25 -39 30 0 4 -11 18 -25 30 -23 20 -24 23 -10 44 8 13 15 29 15
37 0 20 -56 71 -64 58 -12 -19 -36 -12 -36 9 0 14 -12 25 -37 36 -21 9 -45 20
-54 25 -9 4 -19 6 -22 3z"/>
<path d="M4239 7298 c0 -7 -3 -33 -7 -58 -15 -96 -7 -262 15 -310 11 -25 23
-54 27 -65 7 -18 10 -17 36 15 31 37 36 55 20 65 -5 3 -10 21 -10 40 0 18 -12
57 -27 86 -27 52 -35 135 -21 214 2 12 -3 21 -14 23 -10 2 -18 -2 -19 -10z"/>
<path d="M5605 7292 c-32 -22 -55 -68 -55 -108 0 -53 12 -62 37 -28 18 24 21
25 35 10 15 -14 18 -13 33 10 22 35 63 27 112 -21 19 -19 44 -37 54 -40 11 -4
19 -15 19 -26 0 -15 6 -19 30 -17 22 2 35 -4 46 -20 9 -13 22 -28 31 -35 8 -7
29 -25 46 -40 38 -34 58 -32 76 11 17 38 46 45 37 9 -7 -31 49 -97 83 -97 18
0 22 -4 16 -17 -11 -29 -11 -35 3 -40 6 -3 12 2 12 11 0 9 11 16 27 18 40 4
42 33 4 46 -17 6 -31 16 -31 21 0 6 -16 11 -35 11 -35 0 -49 20 -24 35 25 16
-1 38 -76 65 -147 51 -145 50 -161 88 -31 75 -76 106 -180 122 -38 6 -76 18
-85 26 -17 15 -38 18 -54 6z"/>
<path d="M10190 7286 c0 -8 -10 -18 -22 -21 -29 -9 -68 -44 -68 -62 0 -7 8
-21 18 -31 9 -10 24 -28 32 -40 9 -14 25 -22 42 -22 16 0 37 -6 48 -12 29 -18
39 -1 46 73 6 65 6 65 -30 97 -39 34 -66 41 -66 18z"/>
<path d="M8972 7278 c-19 -19 -15 -48 6 -48 23 0 82 29 82 40 0 19 -70 26 -88
8z"/>
<path d="M11250 7256 c0 -31 21 -67 43 -75 12 -5 29 -17 37 -26 13 -15 11 -20
-19 -44 -29 -24 -32 -30 -22 -49 6 -11 11 -30 11 -42 0 -12 14 -44 32 -71 27
-42 36 -49 63 -49 48 0 123 -98 111 -146 -7 -25 -21 -30 -46 -14 -10 6 -20 4
-32 -7 -15 -13 -19 -13 -39 0 -26 19 -48 12 -60 -20 -5 -13 -14 -25 -21 -27
-7 -2 -32 -9 -54 -15 -42 -11 -42 -11 -40 -99 1 -73 5 -96 29 -143 15 -31 27
-59 27 -62 0 -9 -35 -9 -44 0 -11 12 -120 12 -133 1 -17 -14 -61 15 -74 49 -9
25 -10 25 -30 7 -20 -18 -21 -18 -40 6 -11 14 -28 41 -39 61 -27 52 -87 69
-97 29 -4 -16 -14 -20 -49 -20 -33 0 -46 5 -54 20 -14 26 -40 26 -40 0 0 -14
14 -26 47 -41 42 -19 51 -20 85 -8 54 17 94 -5 90 -49 -2 -17 3 -34 12 -42 27
-21 18 -30 -29 -30 -25 0 -45 -4 -45 -10 0 -5 9 -10 21 -10 11 0 40 -20 64
-45 25 -24 56 -47 70 -51 14 -3 27 -10 30 -14 3 -5 30 -16 60 -25 67 -19 100
-62 110 -142 8 -60 16 -69 45 -53 17 9 24 7 41 -12 14 -16 22 -19 26 -10 2 7
12 19 20 28 74 73 123 200 91 232 -10 10 -5 11 20 6 27 -6 32 -4 32 13 0 11 9
28 20 38 15 13 20 31 20 65 0 45 -3 50 -50 91 -28 24 -62 54 -76 67 -14 12
-31 22 -39 22 -16 0 -95 50 -95 61 0 42 72 56 104 20 11 -12 36 -21 69 -24 29
-3 66 -8 83 -12 29 -6 32 -5 38 25 3 18 6 47 6 65 0 39 22 52 46 28 26 -26 12
-118 -27 -184 -30 -52 -30 -52 -13 -91 19 -42 30 -47 39 -19 3 10 14 26 25 36
11 10 20 25 20 34 0 9 7 30 16 46 17 34 84 227 84 244 0 7 -9 9 -23 6 -20 -5
-28 2 -58 50 -19 31 -41 64 -49 73 -8 8 -19 25 -25 36 -6 12 -24 28 -41 36
-17 9 -43 26 -59 38 -15 12 -33 22 -40 22 -7 0 -27 13 -46 29 -33 29 -33 30
-15 50 18 20 18 21 -8 32 -19 9 -26 20 -26 41 0 39 -38 88 -67 88 -13 0 -23
-6 -23 -14z m27 -981 c37 -30 64 -45 84 -45 56 0 27 -47 -60 -95 -24 -14 -45
-25 -46 -25 -1 0 -10 21 -20 48 -9 26 -26 66 -38 89 -39 82 -3 95 80 28z"/>
<path d="M6372 7253 c-21 -8 -43 -58 -30 -71 13 -13 38 -4 38 14 0 7 9 20 21
28 32 22 10 45 -29 29z"/>
<path d="M7440 7231 c0 -35 46 -73 61 -50 15 24 8 35 -33 62 -28 17 -28 17
-28 -12z"/>
<path d="M9871 7246 c-7 -8 -22 -17 -35 -20 -42 -10 -40 -45 7 -97 59 -65 102
-121 110 -141 9 -26 22 -22 41 15 22 40 18 93 -6 89 -20 -3 -78 24 -78 37 0 5
-3 16 -6 24 -3 9 3 16 15 20 28 7 26 37 -3 65 -28 26 -30 26 -45 8z"/>
<path d="M10730 7245 c-7 -8 -20 -15 -29 -15 -38 -1 -47 -17 -23 -43 17 -18
21 -31 16 -54 -4 -21 0 -41 12 -62 21 -35 26 -37 43 -17 7 8 26 18 43 21 30 7
30 7 10 28 -14 15 -19 30 -15 48 3 15 0 30 -6 33 -6 4 -11 23 -11 42 0 37 -18
45 -40 19z"/>
<path d="M3266 7234 c-20 -51 2 -144 33 -144 48 0 66 -78 29 -125 -20 -26 -21
-31 -9 -89 6 -33 16 -110 22 -171 11 -117 18 -136 44 -115 50 42 82 183 54
243 -17 37 4 71 39 63 114 -23 127 -24 145 -8 27 24 6 122 -27 122 -7 0 -21 9
-31 20 -10 11 -28 20 -40 20 -12 0 -33 8 -46 19 -13 10 -35 22 -49 26 -54 17
-128 85 -136 125 -7 33 -18 39 -28 14z"/>
<path d="M5207 7243 c-4 -3 -7 -26 -7 -49 0 -24 -4 -46 -10 -49 -15 -9 -12
-25 5 -31 26 -10 70 47 72 95 1 38 -1 41 -26 41 -15 0 -31 -3 -34 -7z"/>
<path d="M9502 7238 c-18 -18 -15 -26 25 -79 44 -58 53 -60 53 -15 0 48 26 68
49 37 15 -19 21 -21 37 -12 10 6 41 14 68 18 26 5 49 13 50 18 1 13 -106 26
-118 14 -16 -15 -42 -10 -61 11 -20 23 -83 28 -103 8z"/>
<path d="M9994 7227 c-3 -9 -3 -25 0 -34 6 -15 8 -15 24 0 15 16 15 18 0 34
-16 15 -18 15 -24 0z"/>
<path d="M6425 7201 c-3 -11 7 -42 25 -76 16 -31 30 -62 30 -69 1 -6 11 -24
24 -40 23 -27 24 -28 34 -10 12 22 1 142 -14 152 -5 4 -17 19 -27 35 -21 32
-62 37 -72 8z"/>
<path d="M5017 7170 c-3 -11 -20 -25 -38 -32 -32 -11 -32 -11 -7 -24 39 -20
58 -58 58 -112 0 -69 25 -90 35 -30 4 24 11 51 16 60 9 16 -10 122 -26 147
-10 18 -32 12 -38 -9z"/>
<path d="M6060 7175 c-30 -36 49 -80 128 -70 74 9 82 13 82 41 0 31 -24 41
-56 24 -20 -12 -33 -11 -78 3 -64 21 -61 20 -76 2z"/>
<path d="M5980 7171 c0 -20 29 -34 45 -21 8 7 12 16 9 21 -7 12 -54 12 -54 0z"/>
<path d="M6878 7173 c-26 -6 -23 -12 29 -68 40 -43 47 -56 49 -94 1 -25 8 -49
16 -55 8 -6 23 -29 34 -51 17 -33 26 -40 50 -40 26 0 29 4 36 43 4 24 4 69 0
100 -6 52 -10 58 -50 85 -32 22 -47 26 -55 18 -19 -19 -37 -12 -37 13 0 52
-17 64 -72 49z"/>
<path d="M7284 7138 c9 -53 14 -59 65 -68 46 -8 51 -6 51 25 0 25 -33 59 -73
74 -46 18 -50 15 -43 -31z"/>
<path d="M8270 7170 c0 -15 51 -32 77 -25 32 8 29 21 -8 29 -46 9 -69 7 -69
-4z"/>
<path d="M12070 7175 c0 -18 33 -65 45 -65 21 0 18 15 -9 44 -22 25 -36 32
-36 21z"/>
<path d="M2468 7148 c-32 -61 -7 -163 68 -269 19 -27 34 -53 34 -58 0 -5 15
-22 33 -38 18 -15 44 -45 56 -66 26 -42 41 -43 55 -5 13 36 0 91 -29 122 -14
15 -25 34 -25 42 0 24 -42 74 -81 96 -47 26 -65 58 -50 86 15 29 14 64 -5 90
-19 28 -40 28 -56 0z"/>
<path d="M7586 7148 c-21 -30 -20 -51 4 -73 11 -10 23 -36 27 -58 5 -32 59
-107 77 -107 10 0 2 147 -9 160 -7 8 -15 24 -19 36 -3 11 -19 30 -36 42 -29
22 -29 22 -44 0z"/>
<path d="M10511 7156 c-18 -21 -8 -44 21 -48 12 -2 24 -10 26 -20 4 -20 -55
-42 -91 -33 -14 4 -30 4 -36 1 -19 -12 1 -36 29 -36 20 0 34 -10 54 -38 32
-46 32 -56 4 -76 -21 -15 -21 -15 5 -42 15 -15 27 -30 27 -35 0 -5 14 -16 31
-24 28 -15 32 -15 49 0 41 37 95 -11 56 -50 -20 -21 -11 -40 25 -55 16 -7 44
-26 61 -42 17 -16 38 -28 47 -26 24 5 25 35 2 43 -11 3 -23 15 -26 25 -3 11
-19 29 -36 41 -16 11 -27 25 -24 30 8 13 49 11 62 -2 7 -7 27 -13 45 -14 22
-2 40 -12 55 -31 20 -26 24 -27 38 -13 32 31 -15 70 -81 67 -37 -1 -54 8 -54
29 0 19 -73 91 -105 103 -21 8 -27 5 -41 -15 -31 -47 -84 -40 -84 11 0 27 29
47 51 33 51 -32 51 14 0 64 -27 26 -41 50 -45 77 -3 21 -16 51 -29 66 -20 23
-24 24 -36 10z"/>
<path d="M10423 7144 c-8 -20 13 -42 27 -28 12 12 3 44 -11 44 -5 0 -12 -7
-16 -16z"/>
<path d="M8030 7131 c0 -13 10 -20 32 -25 40 -8 46 -1 23 24 -23 26 -55 26
-55 1z"/>
<path d="M8464 7115 c-7 -28 7 -52 25 -41 16 10 14 41 -4 56 -12 10 -15 7 -21
-15z"/>
<path d="M9232 7108 c3 -29 7 -33 36 -36 25 -3 38 -12 57 -43 16 -24 33 -39
45 -39 11 0 29 -9 39 -19 10 -10 29 -22 41 -26 12 -4 20 -13 18 -23 -4 -23
-61 -28 -78 -8 -14 17 -50 22 -50 7 0 -19 54 -51 84 -51 24 0 38 -8 54 -29 26
-35 40 -105 23 -115 -14 -9 -71 37 -89 70 -17 32 -53 39 -90 20 -52 -27 -74
-20 -136 40 -42 40 -72 59 -109 71 -29 8 -71 24 -93 34 -30 14 -61 19 -108 18
-67 -2 -67 -2 -45 -25 22 -23 22 -24 4 -44 -20 -22 -18 -23 39 -24 39 -1 39
-1 40 -45 1 -62 26 -68 26 -7 0 52 22 63 54 27 26 -29 57 -34 63 -10 7 26 20
24 54 -10 35 -35 36 -44 7 -63 -28 -19 -17 -35 30 -43 26 -4 42 -14 53 -33 31
-54 130 -59 143 -6 8 30 17 30 53 1 15 -13 36 -26 46 -30 9 -4 42 -25 72 -48
55 -42 85 -46 85 -12 0 15 9 18 50 19 28 0 50 -4 50 -9 0 -34 91 -83 113 -60
8 7 -31 53 -46 53 -5 0 -29 14 -54 30 -24 17 -53 30 -64 30 -14 0 -19 7 -19
29 0 23 -8 34 -35 51 -40 25 -55 48 -55 84 0 14 -4 27 -9 30 -5 3 -16 36 -25
73 -15 61 -21 70 -55 90 -27 16 -37 28 -37 45 1 17 -4 23 -20 23 -12 0 -31 11
-42 25 -18 22 -23 23 -42 12 -14 -9 -26 -10 -40 -2 -32 17 -41 12 -38 -22z"/>
<path d="M4664 7105 c-4 -17 -1 -32 9 -43 8 -9 22 -34 31 -55 22 -54 52 -48
49 8 -4 64 -10 79 -42 98 -38 22 -39 22 -47 -8z"/>
<path d="M7155 7108 c-5 -15 -2 -26 13 -37 19 -15 23 -25 36 -83 3 -15 23 -39
48 -57 49 -37 54 -37 61 -11 3 11 10 20 16 20 17 0 13 -30 -4 -36 -8 -4 -15
-19 -15 -34 0 -25 4 -29 32 -32 29 -3 33 -7 39 -40 6 -36 24 -68 39 -68 5 0 6
8 3 18 -2 10 5 26 16 36 29 26 27 32 -18 49 -44 18 -55 36 -41 73 19 49 -37
94 -116 94 -34 0 -34 0 -34 49 0 40 -4 53 -22 65 -31 22 -45 20 -53 -6z"/>
<path d="M5631 7096 c-8 -20 -17 -26 -41 -26 -35 0 -38 -12 -10 -40 11 -11 20
-33 20 -50 0 -16 4 -30 10 -30 21 0 58 44 65 76 5 28 10 34 31 34 33 0 27 24
-7 28 -13 2 -32 11 -41 19 -16 14 -18 13 -27 -11z"/>
<path d="M12040 7075 c-5 -14 -15 -25 -22 -25 -7 0 -19 -9 -25 -19 -8 -13 -26
-21 -50 -23 -46 -4 -58 -38 -23 -66 20 -17 21 -18 4 -57 -23 -55 -14 -111 23
-141 45 -37 91 -24 122 34 15 28 64 29 91 2 19 -19 20 -19 20 -2 0 35 -38 57
-99 57 -43 0 -56 3 -56 15 0 10 10 15 32 15 46 0 49 10 15 45 -17 17 -34 40
-37 51 -9 28 2 84 20 99 17 14 20 40 5 40 -6 0 -15 -11 -20 -25z"/>
<path d="M2396 7071 c-4 -6 -11 -50 -17 -98 -5 -48 -12 -96 -15 -105 -3 -10 5
-32 19 -50 14 -18 30 -52 36 -75 21 -77 96 -111 96 -44 0 31 -6 39 -53 70 -54
36 -54 36 -46 121 12 115 11 167 -3 181 -7 7 -13 8 -17 0z"/>
<path d="M10832 7058 c5 -32 28 -35 28 -4 0 17 -5 26 -16 26 -10 0 -14 -7 -12
-22z"/>
<path d="M13304 7065 c-9 -22 4 -35 37 -35 35 0 37 12 4 34 -30 20 -34 20 -41
1z"/>
<path d="M6748 7040 c-33 -31 -33 -31 -10 -47 12 -8 22 -24 22 -35 0 -16 5
-19 24 -14 19 5 29 0 40 -16 36 -51 43 47 7 105 -28 45 -41 46 -83 7z"/>
<path d="M10213 7063 c-20 -7 -15 -31 7 -38 18 -6 19 -12 14 -59 -10 -85 42
-129 79 -66 14 22 15 34 7 49 -5 11 -10 31 -10 45 0 17 -6 26 -15 26 -9 0 -21
11 -27 25 -11 24 -28 29 -55 18z"/>
<path d="M7796 7033 c-6 -22 0 -33 33 -67 22 -23 41 -53 43 -69 5 -44 23 -36
26 11 3 34 -2 49 -22 73 -14 17 -26 39 -26 49 0 16 -18 30 -40 30 -4 0 -11
-12 -14 -27z"/>
<path d="M10900 7045 c0 -17 39 -55 57 -55 18 0 17 19 -2 26 -8 3 -17 14 -20
25 -7 22 -35 26 -35 4z"/>
<path d="M4909 7019 c-7 -14 -8 -24 -1 -31 17 -17 42 -1 42 27 0 31 -25 34
-41 4z"/>
<path d="M9180 7011 c0 -17 5 -33 10 -36 6 -3 10 -15 10 -26 0 -14 7 -19 25
-19 30 0 31 13 5 68 -24 50 -50 56 -50 13z"/>
<path d="M9661 7016 c-16 -19 12 -40 44 -32 28 7 33 31 9 40 -25 9 -41 7 -53
-8z"/>
<path d="M6413 6983 c-33 -6 -50 -31 -27 -40 30 -11 74 -46 74 -59 0 -6 -7
-17 -15 -24 -14 -12 -13 -15 5 -35 40 -43 23 -85 -34 -85 -47 0 -66 -13 -66
-46 0 -27 57 -61 74 -44 7 7 3 10 -12 10 -23 0 -32 33 -12 45 15 9 40 -13 40
-34 0 -10 11 -28 25 -41 14 -13 28 -39 31 -58 4 -19 20 -54 35 -78 36 -52 36
-50 -3 -70 -32 -17 -32 -17 -6 -38 14 -11 28 -30 32 -41 3 -11 24 -40 46 -65
22 -25 40 -48 40 -52 0 -4 33 -17 73 -29 39 -11 93 -29 119 -40 57 -23 99 -24
139 -3 28 14 34 13 82 -4 46 -17 52 -23 55 -50 2 -22 10 -33 25 -38 12 -4 58
-42 102 -84 74 -72 84 -78 132 -83 59 -7 76 5 71 50 -3 26 -8 29 -61 39 -32 7
-59 14 -61 15 -1 2 -7 16 -14 31 -6 16 -36 44 -67 63 -30 20 -55 39 -55 43 0
4 -13 13 -30 19 -33 12 -40 42 -15 63 22 18 14 32 -26 45 -28 10 -34 17 -31
37 3 29 -30 48 -84 48 -28 0 -44 8 -75 40 -22 22 -44 40 -49 40 -5 0 -12 9
-15 21 -8 24 -73 99 -86 99 -17 0 -148 137 -174 183 -15 26 -31 47 -36 47 -14
0 -41 61 -36 82 8 30 -53 130 -77 127 -6 -1 -21 -4 -33 -6z m167 -309 c0 -13
9 -29 20 -36 11 -7 27 -34 36 -60 11 -34 24 -52 50 -67 19 -11 34 -24 34 -29
0 -5 13 -12 28 -15 18 -4 33 -16 41 -33 13 -29 7 -40 -24 -46 -34 -6 -22 -31
22 -45 23 -8 53 -25 68 -39 15 -14 38 -30 52 -35 21 -8 50 -56 40 -66 -2 -2
-17 3 -33 12 -16 8 -38 15 -49 15 -12 0 -38 9 -60 20 -22 11 -49 20 -62 20
-31 0 -59 33 -95 110 -16 36 -36 78 -44 93 -8 16 -14 42 -14 58 0 17 -6 42
-14 57 -16 32 -28 106 -19 115 11 11 23 -4 23 -29z"/>
<path d="M8464 6976 c-4 -10 -18 -16 -39 -16 -39 0 -64 -24 -49 -48 18 -29 95
-62 145 -62 56 0 97 -14 115 -38 10 -14 16 -15 32 -5 11 6 29 9 40 6 11 -2 23
0 26 6 4 6 20 11 37 11 25 0 29 4 29 29 0 16 -6 33 -12 39 -28 22 -179 81
-205 80 -15 -1 -47 2 -70 7 -35 6 -44 5 -49 -9z"/>
<path d="M6295 6960 c-8 -14 13 -50 30 -50 19 0 27 16 20 40 -7 21 -39 27 -50
10z"/>
<path d="M4910 6922 c0 -15 8 -39 18 -52 9 -14 17 -36 17 -49 0 -18 7 -26 29
-32 16 -5 33 -6 38 -3 13 8 9 41 -6 47 -7 3 -26 31 -42 61 -31 61 -54 73 -54
28z"/>
<path d="M12836 6914 c-12 -32 -7 -84 9 -84 11 0 15 12 15 44 0 46 -13 68 -24
40z"/>
<path d="M5070 6884 c0 -52 42 -104 85 -104 42 0 65 9 65 24 0 19 -52 63 -82
70 -15 3 -32 15 -38 26 -17 31 -30 24 -30 -16z"/>
<path d="M5277 6903 c-13 -12 -7 -34 18 -68 43 -55 115 -72 115 -26 0 12 9 21
25 25 36 9 34 40 -2 33 -18 -3 -38 3 -62 19 -34 23 -80 31 -94 17z"/>
<path d="M9755 6899 c-8 -12 51 -69 71 -69 26 0 24 20 -4 34 -16 8 -32 22 -35
31 -7 17 -23 20 -32 4z"/>
<path d="M7500 6881 c-18 -34 -11 -46 54 -104 73 -64 76 -65 122 -36 43 26 43
35 -2 49 -19 7 -40 22 -45 34 -6 12 -24 27 -40 33 -16 6 -29 18 -29 27 0 23
-47 21 -60 -3z"/>
<path d="M10905 6890 c-7 -11 12 -50 24 -50 23 0 71 24 71 35 0 20 -84 33 -95
15z"/>
<path d="M11042 6892 c-9 -6 -6 -12 13 -20 14 -6 33 -25 43 -41 21 -34 70 -76
79 -67 3 3 1 11 -4 18 -6 7 -14 28 -18 46 -5 23 -12 32 -27 32 -11 0 -22 8
-25 20 -6 21 -37 27 -61 12z"/>
<path d="M3236 6807 c-9 -97 6 -205 31 -214 31 -12 42 53 15 85 -15 17 -22 44
-27 100 -10 121 -11 122 -19 29z"/>
<path d="M6710 6870 c0 -11 7 -23 15 -27 21 -8 28 1 20 26 -8 27 -35 27 -35 1z"/>
<path d="M10073 6864 c-9 -23 9 -48 37 -52 32 -5 43 10 31 41 -12 31 -57 38
-68 11z"/>
<path d="M10184 6849 c-23 -26 -8 -76 22 -71 10 2 33 6 50 9 20 3 36 -1 47
-11 15 -16 37 -22 37 -11 0 14 -55 55 -72 55 -10 0 -30 11 -43 24 -23 24 -24
24 -41 5z"/>
<path d="M4680 6846 c0 -19 14 -28 34 -20 25 10 19 34 -9 34 -15 0 -25 -6 -25
-14z"/>
<path d="M5955 6830 c-10 -16 3 -29 44 -41 60 -18 113 -72 109 -112 -2 -25 2
-34 20 -42 35 -15 31 -79 -5 -99 -25 -14 -26 -15 -7 -16 33 0 47 -24 39 -69
-5 -33 -3 -41 14 -50 50 -27 81 -2 41 34 -22 20 -27 60 -9 71 18 10 123 -100
115 -121 -5 -14 -13 -16 -42 -10 -28 5 -35 3 -32 -7 3 -7 20 -14 38 -16 51 -5
90 -37 90 -73 0 -22 6 -32 25 -39 28 -11 34 -44 10 -54 -19 -7 -20 -26 -2 -26
29 0 49 36 42 76 -8 46 -72 184 -85 184 -5 0 -14 18 -20 41 -12 42 -41 79 -63
79 -28 0 -55 55 -60 121 -4 62 -5 64 -32 62 -23 -2 -29 4 -46 42 -12 28 -31
51 -49 60 -33 17 -126 20 -135 5z"/>
<path d="M3791 6811 c-11 -7 -11 -14 3 -42 10 -20 14 -44 10 -63 -4 -23 1 -41
18 -66 66 -98 71 -111 73 -207 4 -107 6 -113 46 -113 17 0 39 -5 50 -10 28
-16 33 7 21 103 -11 93 -29 156 -57 207 -24 42 -114 130 -133 130 -11 0 -13 8
-8 35 7 36 2 42 -23 26z"/>
<path d="M6815 6811 c-8 -15 35 -35 47 -23 6 6 7 15 4 21 -9 14 -43 14 -51 2z"/>
<path d="M7875 6810 c-4 -6 9 -28 28 -49 52 -58 60 -76 41 -95 -8 -9 -20 -16
-25 -16 -18 0 -21 -50 -4 -76 13 -21 19 -23 31 -13 13 10 20 6 47 -27 73 -90
90 -99 122 -64 20 22 20 22 -53 100 -18 19 -42 45 -53 56 -11 13 -17 28 -13
38 3 9 1 23 -6 31 -7 9 -10 25 -6 41 8 29 -5 44 -38 44 -11 0 -30 9 -42 21
-15 14 -24 17 -29 9z"/>
<path d="M5830 6795 c0 -8 5 -15 10 -15 14 0 12 -33 -2 -53 -7 -9 -29 -18 -48
-19 -31 -3 -36 1 -53 35 -24 52 -46 46 -62 -16 -12 -47 -12 -49 12 -58 13 -5
37 -9 53 -9 47 0 61 -9 47 -31 -18 -29 6 -48 32 -25 24 21 48 16 110 -26 37
-25 48 -28 68 -19 28 13 29 40 3 74 -11 14 -20 30 -20 36 0 6 -16 19 -35 28
-28 13 -35 22 -35 45 0 21 -7 32 -25 40 -14 6 -25 15 -25 20 0 4 -7 8 -15 8
-8 0 -15 -7 -15 -15z"/>
<path d="M6906 6783 c-4 -11 -1 -22 8 -29 22 -16 20 -44 -3 -44 -20 0 -37 -17
-28 -27 4 -3 21 -8 39 -12 30 -6 33 -10 33 -43 1 -47 9 -54 40 -40 38 17 63
15 77 -8 23 -36 118 -21 118 18 0 26 -62 72 -83 61 -23 -13 -93 28 -108 63 -9
23 -68 78 -82 78 -3 0 -8 -8 -11 -17z"/>
<path d="M9992 6788 c-18 -18 -14 -34 13 -52 17 -11 25 -26 25 -46 0 -26 7
-33 50 -55 64 -32 70 -32 70 8 0 34 -64 117 -91 117 -7 0 -22 9 -34 20 -16 15
-24 17 -33 8z"/>
<path d="M7185 6780 c-8 -13 3 -30 19 -30 8 0 19 -7 26 -15 14 -17 80 -21 80
-5 0 6 -11 15 -24 19 -13 5 -26 17 -29 25 -7 18 -62 22 -72 6z"/>
<path d="M7734 6756 c-7 -30 27 -68 58 -64 12 2 23 -3 25 -9 3 -7 0 -13 -6
-13 -6 0 -11 -5 -11 -11 0 -13 39 -2 59 16 15 14 1 31 -67 83 -38 28 -50 28
-58 -2z"/>
<path d="M3532 6758 c-6 -6 -12 -31 -12 -54 0 -24 -10 -59 -23 -85 -31 -57
-51 -118 -42 -127 4 -4 34 -9 68 -12 58 -5 62 -7 62 -30 0 -22 -5 -25 -65 -35
-105 -18 -125 -32 -124 -85 1 -45 27 -127 58 -185 9 -16 16 -36 16 -44 0 -18
47 -61 66 -61 26 0 72 29 79 50 3 11 11 20 16 20 5 0 19 11 31 25 12 14 28 25
35 25 7 0 13 5 13 11 0 19 -73 98 -97 103 -24 7 -30 20 -13 31 6 3 10 28 10
54 0 36 5 53 21 67 18 16 20 26 14 73 -4 31 -13 60 -20 66 -20 16 -28 81 -13
105 11 18 10 23 -4 34 -9 6 -18 23 -20 36 -3 28 -36 38 -56 18z"/>
<path d="M8750 6730 c0 -5 10 -28 22 -51 17 -33 23 -38 30 -25 5 9 22 16 38
16 46 0 37 28 -16 50 -50 22 -74 25 -74 10z"/>
<path d="M12116 6715 c-3 -8 -12 -15 -19 -15 -22 0 -64 -70 -72 -120 -4 -25
-14 -54 -21 -65 -8 -11 -14 -38 -14 -60 0 -22 -4 -55 -9 -73 -15 -52 -6 -62
54 -62 73 0 86 17 52 68 -13 20 -28 51 -31 67 -4 17 -9 37 -12 46 -3 11 3 18
16 22 14 4 20 13 20 33 0 25 50 84 72 84 9 0 11 51 2 74 -8 20 -30 21 -38 1z"/>
<path d="M8986 6701 c-17 -19 -17 -20 3 -30 11 -6 28 -11 39 -11 13 0 22 -9
26 -24 3 -13 22 -33 41 -45 32 -18 35 -23 25 -42 -11 -19 -4 -29 64 -97 71
-71 76 -78 70 -109 -5 -28 -3 -33 12 -33 40 0 50 -17 23 -39 -19 -15 -21 -21
-9 -24 62 -19 93 -24 110 -20 20 5 50 -12 50 -28 0 -5 -14 -23 -30 -41 -31
-32 -31 -32 -5 -55 14 -13 25 -34 25 -46 0 -42 16 -54 37 -28 16 19 24 21 49
14 32 -8 113 -96 167 -179 16 -24 35 -44 43 -44 20 0 18 69 -2 92 -14 15 -15
20 -3 34 15 18 13 61 -3 81 -5 6 -27 14 -48 18 -22 4 -50 15 -62 24 -13 10
-47 31 -76 47 -42 23 -53 35 -58 61 -11 56 -3 59 104 37 18 -3 37 -15 43 -25
6 -12 21 -19 39 -19 24 0 30 -4 30 -21 0 -14 10 -24 30 -32 18 -7 33 -22 39
-39 6 -16 24 -36 41 -46 27 -15 30 -21 28 -57 -3 -32 -7 -40 -28 -46 -23 -7
-23 -7 -3 -8 25 -1 43 -28 43 -63 0 -13 5 -29 11 -35 6 -6 14 -26 18 -45 6
-28 13 -35 49 -47 24 -7 45 -11 48 -9 5 6 -24 66 -37 73 -5 4 -9 15 -9 27 0
11 -14 36 -31 56 -23 26 -30 41 -26 61 3 14 -1 41 -9 60 -18 43 -18 102 1 127
22 29 18 53 -10 66 -18 8 -24 17 -19 30 6 21 -24 26 -44 6 -11 -11 -86 40
-123 85 -20 25 -44 14 -29 -13 13 -25 -1 -33 -41 -25 -19 4 -33 15 -36 26 -3
10 -13 19 -23 19 -10 0 -23 7 -30 15 -16 19 -30 19 -30 1 0 -8 9 -18 20 -21
11 -3 20 -15 20 -25 0 -35 -22 -33 -57 5 -34 37 -35 37 -88 31 -53 -6 -55 -6
-61 21 -3 16 -8 35 -10 43 -2 8 1 22 6 30 6 9 3 24 -8 43 -16 27 -16 29 1 38
20 12 23 29 4 29 -7 0 -36 18 -65 39 -30 23 -69 42 -92 46 -23 4 -44 13 -47
21 -2 7 -13 16 -23 19 -10 3 -20 19 -24 35 -7 35 -34 40 -60 11z"/>
<path d="M10462 6688 c-8 -31 -7 -33 21 -38 22 -4 34 -15 50 -49 22 -44 23
-45 75 -47 58 -3 69 11 22 29 -23 9 -30 17 -28 36 2 18 -3 26 -25 33 -15 5
-40 23 -56 39 -38 37 -48 37 -59 -3z"/>
<path d="M7310 6673 c0 -20 -6 -44 -14 -52 -22 -25 20 -72 65 -74 41 -2 57 36
19 46 -16 4 -20 11 -16 25 7 21 -28 92 -45 92 -5 0 -9 -17 -9 -37z"/>
<path d="M5554 6659 c-8 -14 16 -31 34 -24 8 3 21 5 30 5 9 1 2 7 -17 15 -40
18 -38 18 -47 4z"/>
<path d="M7451 6640 c-20 -28 -21 -31 -4 -36 49 -15 60 -26 91 -87 27 -53 36
-64 52 -60 16 4 23 -2 31 -26 6 -17 14 -31 18 -31 11 0 101 -117 101 -131 0
-16 63 -69 83 -69 9 0 20 7 23 15 4 10 20 15 48 15 35 0 48 -6 76 -35 34 -35
77 -49 67 -21 -17 43 -18 83 -3 95 27 22 21 52 -9 46 -14 -3 -37 -7 -52 -10
-16 -3 -43 -13 -62 -23 -32 -17 -33 -17 -48 6 -12 17 -25 22 -57 22 -55 0 -96
39 -96 92 0 19 -7 41 -15 48 -29 24 -19 50 20 50 31 0 35 3 35 25 0 28 -25 34
-61 14 -21 -11 -129 25 -129 42 0 8 -75 89 -82 89 -2 0 -14 -14 -27 -30z"/>
<path d="M10246 6638 c-22 -31 -21 -35 19 -73 29 -27 35 -38 29 -59 -6 -25 -4
-26 34 -26 23 0 44 -4 47 -10 3 -5 15 -10 26 -10 17 0 20 -6 17 -29 -4 -39 17
-61 58 -61 42 0 47 29 10 53 -16 11 -25 28 -29 56 -3 22 -14 52 -25 66 -22 28
-87 75 -102 75 -6 0 -15 9 -22 20 -17 26 -43 25 -62 -2z"/>
<path d="M11954 6646 c-8 -21 3 -49 16 -41 5 3 10 15 10 25 0 25 -18 36 -26
16z"/>
<path d="M11104 6615 c-12 -9 -31 -12 -50 -9 -21 4 -42 -1 -67 -16 -45 -27
-45 -27 -4 -46 17 -8 40 -20 50 -27 15 -10 21 -8 40 15 12 15 34 32 50 37 29
11 35 32 14 50 -10 8 -19 7 -33 -4z"/>
<path d="M8348 6593 c-14 -14 -22 -15 -43 -5 -42 19 -65 14 -83 -18 -11 -19
-25 -30 -39 -30 -14 0 -23 -6 -23 -16 0 -11 6 -14 21 -9 13 4 27 0 40 -11 18
-16 20 -16 39 1 17 15 25 16 65 6 59 -15 65 -10 61 47 -4 52 -13 60 -38 35z"/>
<path d="M2356 6528 c4 -35 11 -73 15 -86 5 -13 9 -36 9 -52 0 -16 5 -32 11
-36 6 -3 8 -17 4 -31 -3 -15 0 -34 8 -47 8 -11 17 -39 21 -60 4 -21 14 -49 23
-62 9 -15 13 -34 9 -49 -10 -41 27 -32 58 15 25 38 26 42 16 111 -6 40 -8 74
-6 76 2 3 -9 32 -25 66 -16 34 -29 72 -29 84 0 25 -87 131 -108 132 -10 1 -11
-13 -6 -61z"/>
<path d="M2598 6573 c-16 -2 -28 -7 -28 -9 0 -16 24 -100 30 -108 12 -12 32
32 25 53 -3 11 1 26 10 35 15 15 13 38 -3 35 -4 -1 -19 -4 -34 -6z"/>
<path d="M9622 6568 c6 -16 36 -34 44 -26 3 4 4 14 1 23 -7 17 -51 21 -45 3z"/>
<path d="M3310 6475 c0 -78 3 -97 16 -102 27 -10 39 15 39 80 -1 85 -11 117
-35 117 -19 0 -20 -7 -20 -95z"/>
<path d="M9418 6546 c-16 -12 -16 -15 0 -49 18 -39 24 -42 87 -52 37 -6 39 -5
21 9 -11 9 -26 16 -33 16 -7 0 -13 8 -13 19 0 10 -7 24 -15 31 -8 7 -15 19
-15 26 0 17 -10 17 -32 0z"/>
<path d="M5766 6506 c-11 -18 -13 -27 -4 -32 13 -8 51 33 42 47 -9 15 -21 10
-38 -15z"/>
<path d="M7795 6521 c-3 -5 0 -13 5 -16 15 -9 60 3 60 15 0 13 -57 13 -65 1z"/>
<path d="M12133 6524 c-22 -9 -14 -44 12 -56 30 -13 32 -12 37 27 3 30 -17 42
-49 29z"/>
<path d="M10068 6493 c2 -16 13 -37 22 -48 10 -11 22 -35 27 -53 8 -32 11 -34
59 -38 41 -3 54 0 68 15 21 23 14 41 -15 41 -11 0 -22 7 -25 15 -4 8 -12 15
-20 15 -8 0 -14 10 -14 23 0 17 -10 26 -43 40 -57 23 -65 22 -59 -10z"/>
<path d="M13102 6498 c2 -12 9 -23 15 -26 19 -6 29 28 12 39 -23 14 -31 10
-27 -13z"/>
<path d="M7245 6477 c-34 -49 -5 -82 63 -71 41 6 47 3 128 -76 20 -19 22 -19
38 -2 24 28 21 80 -6 93 -13 5 -38 21 -57 34 -19 14 -46 25 -60 25 -14 0 -41
4 -59 9 -27 8 -34 7 -47 -12z"/>
<path d="M10595 6490 c-3 -6 6 -15 20 -20 35 -13 45 -13 45 4 0 23 -53 36 -65
16z"/>
<path d="M13184 6486 c-3 -8 0 -27 8 -43 12 -25 19 -28 58 -28 43 0 45 1 48
33 4 35 1 37 -66 46 -32 5 -44 3 -48 -8z"/>
<path d="M9935 6463 c14 -52 12 -58 -20 -58 -22 0 -34 8 -50 32 -24 39 -31 41
-38 7 -7 -37 3 -64 23 -64 9 0 25 -9 35 -20 10 -11 26 -22 37 -26 15 -4 18
-12 14 -29 -5 -18 2 -30 29 -54 37 -32 60 -32 68 -1 5 19 7 19 52 3 54 -18 83
-4 71 35 -9 27 -24 31 -77 22 -41 -8 -46 -6 -71 23 -33 36 -32 29 -13 73 13
32 13 38 -3 60 -9 13 -28 24 -41 24 -20 0 -22 -3 -16 -27z"/>
<path d="M11704 6457 c-17 -17 -42 -39 -55 -48 -16 -11 -37 -48 -62 -112 -36
-93 -43 -130 -31 -174 7 -24 24 -32 24 -11 0 6 10 22 21 34 13 14 23 41 26 68
4 32 12 50 28 60 15 10 24 28 28 58 4 30 14 49 32 64 21 17 26 28 23 57 -3 37
-3 37 -34 4z"/>
<path d="M5820 6469 c0 -19 67 -79 88 -79 26 0 105 -93 121 -142 17 -50 51
-76 68 -51 7 10 18 24 24 32 9 10 6 18 -14 35 -14 11 -28 35 -32 51 -19 91
-26 107 -42 101 -10 -4 -26 3 -40 15 -18 18 -34 22 -77 21 -39 -1 -56 3 -60
13 -6 17 -36 20 -36 4z"/>
<path d="M2266 6463 c-9 -10 -7 -121 3 -127 13 -9 21 19 21 74 0 46 -9 67 -24
53z"/>
<path d="M8504 6445 c-7 -18 3 -35 21 -35 7 0 26 -15 42 -34 15 -18 43 -41 62
-51 18 -9 35 -25 38 -35 3 -10 11 -21 19 -24 12 -4 14 -22 10 -81 -5 -76 -5
-76 24 -82 42 -8 107 -67 115 -104 5 -22 15 -34 35 -40 31 -11 40 -33 40 -96
0 -44 16 -65 31 -42 5 8 9 29 9 47 0 17 4 32 10 32 14 0 31 37 24 54 -7 18
-39 22 -49 6 -11 -18 -38 -12 -30 8 20 46 17 62 -19 106 -20 25 -36 49 -36 55
0 6 -11 13 -24 17 -25 6 -56 43 -56 65 0 7 8 17 17 24 22 17 4 42 -47 63 -19
8 -49 29 -66 48 -18 19 -40 34 -51 34 -11 0 -34 18 -52 40 -33 41 -58 51 -67
25z"/>
<path d="M5359 6449 c-1 -2 -3 -15 -5 -29 -1 -14 -6 -37 -9 -51 -8 -33 16 -45
39 -21 13 15 13 23 2 55 -11 34 -24 56 -27 46z"/>
<path d="M8267 6443 c-15 -15 -5 -44 18 -55 14 -6 28 -22 31 -35 8 -28 44 -31
68 -5 15 18 14 21 -26 60 -38 38 -74 52 -91 35z"/>
<path d="M9630 6435 c-69 -18 -59 -39 20 -43 82 -3 104 8 69 37 -27 23 -27 23
-89 6z"/>
<path d="M3677 6356 c-7 -18 3 -56 14 -56 5 0 9 16 9 35 0 35 -13 47 -23 21z"/>
<path d="M8186 6341 c-3 -5 -21 -12 -40 -15 -33 -6 -55 -32 -39 -46 108 -96
155 -116 186 -82 30 33 10 82 -34 82 -30 0 -53 15 -45 28 7 12 -3 42 -14 42
-5 0 -11 -4 -14 -9z"/>
<path d="M10432 6313 c-17 -38 -9 -68 24 -89 28 -19 54 -12 54 15 0 12 -11 23
-29 29 -24 8 -30 17 -33 44 -3 33 -3 33 -16 1z"/>
<path d="M13327 6333 c-16 -4 -17 -12 -12 -57 6 -49 5 -54 -20 -70 -47 -31
-51 -62 -10 -107 19 -22 35 -45 35 -53 0 -16 -55 -66 -73 -66 -19 -1 -107 -87
-107 -104 0 -28 62 -20 108 14 23 17 46 30 51 30 6 0 16 12 23 27 11 24 35 42
73 57 6 2 -2 17 -17 33 -32 33 -35 63 -12 99 16 24 16 26 -7 50 -24 25 -24 25
1 44 27 21 60 26 60 10 0 -5 -7 -13 -16 -18 -32 -18 -12 -47 33 -47 44 0 66
-11 39 -20 -9 -3 -23 -7 -32 -10 -15 -5 -15 -7 1 -25 10 -11 23 -20 30 -20 26
0 32 -21 22 -82 -8 -58 -8 -62 15 -80 23 -18 23 -18 1 -24 -29 -8 -32 -61 -5
-94 18 -22 18 -22 60 -1 46 24 50 36 26 84 -14 27 -16 52 -10 160 6 127 6 129
-19 160 -45 57 -58 67 -99 77 -23 6 -56 17 -74 25 -34 16 -35 16 -65 8z"/>
<path d="M2266 6310 c-2 -8 -6 -48 -8 -88 -2 -44 -9 -76 -16 -81 -17 -10 -33
-1168 -22 -1569 3 -120 5 -134 23 -144 21 -11 36 2 37 32 0 8 5 56 10 105 18
168 10 1709 -9 1742 -8 15 -10 16 -15 3z"/>
<path d="M10660 6295 c-15 -18 -5 -35 21 -35 20 0 23 8 13 34 -8 20 -18 20
-34 1z"/>
<path d="M3820 6267 c0 -27 11 -45 57 -92 52 -53 57 -63 60 -108 3 -59 51
-187 70 -187 8 0 13 13 13 38 0 20 7 64 15 97 12 54 12 108 -1 172 -3 18 -14
24 -45 29 -24 4 -44 14 -50 25 -5 11 -18 19 -28 19 -10 0 -30 9 -44 20 -36 28
-47 25 -47 -13z"/>
<path d="M7184 6259 c-14 -17 -16 -23 -6 -27 8 -2 27 -17 43 -33 29 -28 74
-47 86 -35 7 6 -43 84 -66 104 -21 17 -35 15 -57 -9z"/>
<path d="M7563 6270 c-32 -13 -28 -28 12 -47 28 -13 39 -14 60 -5 63 29 -6 78
-72 52z"/>
<path d="M5433 6257 c-17 -23 -6 -125 16 -153 12 -15 21 -31 21 -37 0 -6 10
-21 21 -33 17 -18 20 -30 15 -57 -8 -41 -19 -52 -65 -61 -29 -5 -39 -2 -64 21
-28 28 -28 28 -55 -3 -15 -17 -35 -34 -44 -37 -10 -4 -18 -15 -18 -26 0 -23
-22 -41 -28 -23 -5 16 -40 15 -56 0 -24 -25 -45 -79 -37 -96 4 -9 14 -30 22
-46 9 -18 26 -33 44 -38 27 -8 34 -4 73 38 42 46 51 67 32 79 -32 20 3 84 37
66 10 -5 26 -12 36 -15 21 -7 22 -36 2 -113 -16 -63 -30 -78 -88 -95 -56 -17
-68 -45 -31 -75 39 -32 122 -71 159 -75 21 -2 34 -11 42 -29 8 -17 24 -29 43
-32 33 -7 41 -27 11 -27 -25 0 -51 -10 -51 -20 0 -13 131 -23 143 -11 6 6 22
11 34 11 21 0 22 -2 13 -21 -7 -11 -10 -22 -8 -23 9 -8 136 -14 147 -7 22 14
-9 50 -49 57 -19 3 -42 9 -50 15 -8 5 -30 16 -49 25 -65 30 -134 100 -167 170
-41 87 -28 262 22 281 9 3 20 16 25 29 7 21 15 24 62 24 52 0 55 -2 82 -40 15
-22 25 -46 21 -55 -7 -19 -46 -19 -72 0 -10 8 -31 15 -47 15 -39 0 -51 -36
-38 -115 5 -33 12 -78 15 -99 4 -31 17 -52 58 -93 29 -29 58 -53 64 -53 7 0
25 -11 41 -24 36 -30 103 -45 103 -23 0 8 -10 21 -21 29 -15 9 -24 29 -29 63
-10 68 0 99 33 103 27 3 27 3 27 -62 0 -66 14 -96 45 -96 8 0 33 -10 55 -21
35 -18 50 -20 108 -14 37 4 74 12 82 19 8 7 35 18 59 25 50 14 91 51 91 80 0
19 -47 62 -82 74 -9 3 -18 18 -20 34 -2 23 -9 29 -33 31 -40 5 -58 21 -51 46
4 14 -2 26 -16 38 -19 14 -21 19 -10 42 19 42 -2 73 -28 41 -7 -9 -29 -15 -52
-15 -35 0 -39 -2 -36 -22 2 -16 15 -27 46 -38 49 -18 78 -65 88 -143 4 -27 13
-51 20 -54 36 -14 4 -66 -34 -56 -17 4 -24 -1 -32 -21 -5 -14 -14 -26 -19 -26
-14 0 -31 34 -31 59 0 12 -4 21 -10 21 -5 0 -17 16 -25 36 -11 28 -19 35 -34
31 -32 -8 -61 20 -61 58 0 18 -5 46 -11 62 -6 15 -14 46 -18 68 -5 32 -12 41
-31 45 -14 3 -44 17 -67 33 -24 15 -52 27 -63 27 -13 0 -43 23 -76 57 -44 47
-58 71 -79 134 -14 43 -25 89 -25 103 0 30 -33 53 -47 33z m313 -445 c6 -4 14
-23 17 -42 3 -19 9 -49 12 -66 8 -37 5 -39 -57 -48 -40 -6 -48 -5 -48 8 0 9
-11 26 -25 38 -34 30 -32 44 15 73 22 14 40 30 40 35 0 12 30 13 46 2z"/>
<path d="M8560 6254 c0 -8 7 -23 16 -32 15 -15 15 -17 -5 -30 -27 -18 -27 -42
-1 -42 11 0 20 7 20 15 0 9 7 18 15 21 19 8 20 33 1 40 -8 3 -16 14 -19 25 -6
23 -27 26 -27 3z"/>
<path d="M10347 6263 c-13 -12 -7 -31 12 -36 26 -6 45 7 38 27 -6 16 -38 22
-50 9z"/>
<path d="M12081 6259 c-25 -5 -49 -13 -55 -19 -5 -5 -22 -10 -37 -10 -32 0
-44 -42 -33 -118 9 -67 20 -83 32 -52 5 14 14 37 20 52 7 16 24 31 46 39 23 8
36 19 36 31 0 11 10 20 25 24 27 7 45 31 38 52 -5 13 -9 14 -72 1z"/>
<path d="M6170 6209 c0 -19 70 -42 87 -28 13 11 13 14 -3 26 -21 16 -84 17
-84 2z"/>
<path d="M9080 6203 c0 -37 55 -126 92 -151 22 -14 38 -33 38 -43 0 -16 8 -19
42 -19 41 0 47 -4 102 -57 13 -13 28 -23 35 -23 39 0 -50 102 -109 125 -40 16
-51 25 -56 49 -7 31 -59 86 -81 86 -8 0 -19 11 -25 25 -13 29 -38 34 -38 8z"/>
<path d="M8360 6187 c0 -8 11 -36 26 -62 17 -34 22 -51 15 -58 -18 -18 -13
-23 54 -58 71 -36 75 -42 45 -61 -31 -20 -24 -36 20 -43 22 -4 42 -11 46 -16
3 -5 20 -15 38 -23 20 -8 38 -25 45 -45 14 -32 26 -37 51 -21 13 9 13 12 -2
21 -10 5 -18 20 -18 32 0 12 -7 35 -15 51 -10 20 -12 33 -5 41 11 13 -19 48
-36 43 -11 -4 -84 75 -84 90 0 26 -33 43 -71 37 -35 -6 -39 -5 -45 19 -7 30
-64 77 -64 53z"/>
<path d="M8895 6190 c-3 -5 -1 -19 5 -30 17 -31 54 -23 58 13 3 24 0 27 -27
27 -16 0 -33 -4 -36 -10z"/>
<path d="M10110 6186 c-11 -15 -10 -21 9 -47 28 -37 25 -73 -7 -77 -33 -5 -52
-50 -29 -67 9 -7 17 -17 17 -23 0 -7 12 -19 28 -29 15 -10 32 -24 38 -32 12
-16 54 -6 54 12 0 22 -50 67 -75 67 -35 0 -42 20 -14 41 18 13 34 16 66 12 43
-6 43 -6 40 37 -2 39 -5 44 -32 52 -16 4 -41 22 -56 39 -23 28 -26 29 -39 15z"/>
<path d="M8975 6170 c-7 -24 18 -76 45 -90 11 -6 20 -17 20 -25 0 -8 5 -15 11
-15 14 0 3 49 -17 71 -8 8 -14 24 -14 35 0 38 -34 57 -45 24z"/>
<path d="M5938 6155 c-15 -34 2 -50 65 -60 32 -6 51 -19 96 -68 31 -33 71 -66
89 -74 32 -13 48 -39 58 -93 6 -32 -25 -73 -49 -64 -22 8 -12 24 14 24 14 0
19 6 17 17 -5 24 -37 29 -45 6 -3 -10 -12 -22 -20 -26 -30 -18 -13 -46 43 -74
30 -15 60 -35 65 -45 5 -10 14 -18 20 -18 18 0 65 -54 72 -82 6 -22 0 -35 -33
-73 -43 -50 -52 -85 -22 -85 10 0 33 -11 51 -24 29 -22 43 -25 112 -24 79 1
79 1 79 39 0 20 6 40 13 42 26 11 -15 25 -44 15 -22 -7 -33 -6 -51 6 -12 9
-30 16 -40 16 -28 0 -51 44 -44 84 6 33 6 33 79 28 40 -2 79 -11 88 -18 16
-14 51 -19 62 -8 3 3 -11 24 -31 45 -84 88 -137 139 -144 139 -12 0 -67 26
-103 49 -21 12 -29 25 -28 40 2 14 -10 34 -31 56 -19 18 -39 50 -46 69 -6 19
-19 38 -29 41 -10 3 -23 16 -29 30 -6 13 -31 38 -54 55 -37 27 -49 31 -82 25
-32 -5 -43 -2 -62 16 -23 22 -23 22 -36 -6z"/>
<path d="M6545 6170 c-9 -14 10 -45 41 -64 26 -18 26 -18 5 -40 -30 -32 -15
-76 27 -76 15 0 38 -7 51 -17 18 -12 28 -14 42 -5 24 15 119 -67 119 -104 0
-13 8 -28 18 -33 10 -5 51 -48 92 -95 99 -113 129 -114 130 -5 0 56 -77 149
-123 149 -8 0 -22 11 -31 24 -8 14 -24 27 -35 31 -11 3 -23 16 -27 28 -11 37
-35 57 -69 57 -19 0 -39 8 -50 20 -10 11 -30 20 -44 20 -31 1 -61 21 -61 43 0
16 -55 77 -70 77 -5 0 -12 -4 -15 -10z"/>
<path d="M2643 6124 c-43 -67 -19 -127 41 -104 33 12 40 45 23 95 -18 51 -36
54 -64 9z"/>
<path d="M7340 6140 c0 -24 42 -70 65 -70 8 0 15 -6 15 -14 0 -12 100 -96 115
-96 11 0 4 59 -9 73 -8 8 -35 21 -60 28 -31 9 -46 19 -46 30 0 9 -9 28 -21 43
-25 32 -59 35 -59 6z"/>
<path d="M7663 6149 c-36 -11 -41 -20 -18 -39 18 -15 20 -41 4 -57 -8 -8 -3
-15 19 -27 16 -8 48 -38 72 -66 23 -28 50 -50 61 -50 10 0 24 -9 31 -20 14
-22 38 -27 38 -9 0 7 -18 31 -40 55 -41 44 -50 77 -30 113 15 29 -56 112 -95
110 -5 -1 -25 -5 -42 -10z"/>
<path d="M4615 6140 c-12 -19 29 -75 58 -78 23 -3 27 0 27 23 0 42 -17 65 -50
65 -16 0 -32 -5 -35 -10z"/>
<path d="M8265 6131 c-8 -15 14 -53 28 -48 18 6 15 51 -5 55 -9 2 -19 -2 -23
-7z"/>
<path d="M11453 6098 c-15 -23 -54 -68 -87 -100 -61 -60 -68 -88 -23 -88 14 0
30 -6 36 -14 7 -8 27 -17 46 -20 21 -4 36 -14 40 -25 3 -11 12 -22 21 -25 8
-3 19 -17 24 -31 12 -32 27 -32 41 -1 10 21 7 32 -16 73 -23 41 -28 63 -32
156 -3 59 -9 110 -14 112 -4 3 -20 -14 -36 -37z"/>
<path d="M3680 6048 c-30 -33 -61 -66 -69 -75 -19 -21 -123 -14 -149 10 -39
36 -72 4 -72 -68 0 -43 13 -45 30 -5 25 60 95 30 89 -38 -2 -15 1 -37 5 -50
11 -32 50 -26 54 8 7 49 45 68 57 29 9 -28 45 -39 102 -31 71 10 113 4 113
-17 0 -21 -19 -41 -40 -41 -25 0 -150 -41 -150 -49 0 -19 33 -101 40 -101 5 0
14 -16 20 -35 6 -19 15 -35 20 -35 4 0 13 -13 18 -30 12 -32 17 -39 79 -109
24 -27 46 -62 49 -80 6 -31 6 -32 -20 -25 -20 5 -26 2 -26 -9 0 -20 54 -47 81
-40 28 8 43 -16 23 -38 -12 -13 -13 -19 -3 -25 7 -4 15 -2 17 4 2 7 14 12 26
12 26 0 46 15 69 51 15 26 163 119 188 119 7 0 27 16 46 35 34 35 26 48 -15
25 -9 -5 -44 -16 -77 -25 -33 -9 -76 -20 -95 -25 -74 -20 -123 -13 -158 23
-17 18 -34 47 -38 65 -4 17 -13 37 -20 43 -19 15 -18 74 1 93 8 8 15 29 15 46
0 21 9 39 26 55 27 25 27 25 -14 64 -22 22 -49 52 -59 68 -9 15 -23 32 -30 36
-7 4 -13 17 -13 28 0 11 -4 29 -10 39 -7 13 -6 19 5 24 27 10 17 53 -23 93
-37 40 -37 40 -92 -19z"/>
<path d="M8067 6095 c-10 -9 -34 -15 -61 -15 -25 0 -46 -2 -46 -5 0 -18 33
-65 46 -65 8 0 19 -11 24 -25 19 -51 36 -28 31 43 -2 27 2 35 18 39 21 5 28
27 12 38 -5 3 -16 -2 -24 -10z"/>
<path d="M6403 6063 c-4 -10 2 -23 16 -35 26 -20 41 -16 41 11 0 36 -45 56
-57 24z"/>
<path d="M6943 6042 c-25 -34 -21 -42 19 -42 17 0 31 -6 35 -16 9 -24 52 -64
69 -64 11 0 4 14 -21 45 -42 51 -38 70 12 62 25 -4 36 -2 40 9 8 20 7 21 -67
28 -64 7 -66 7 -87 -22z"/>
<path d="M10648 6063 c-33 -8 -20 -32 19 -35 35 -3 38 -6 51 -50 14 -51 34
-62 52 -28 15 28 4 58 -29 74 -15 8 -33 22 -40 30 -14 16 -22 17 -53 9z"/>
<path d="M4055 6040 c-3 -5 -2 -34 4 -64 10 -55 6 -91 -13 -115 -13 -17 17
-41 51 -41 28 0 43 -32 43 -95 0 -72 -14 -97 -52 -93 -28 3 -33 7 -36 33 -5
44 -36 61 -47 26 -3 -11 -14 -22 -23 -26 -45 -14 -45 -162 0 -186 35 -19 131
-12 174 12 75 43 74 40 74 168 -1 133 -10 192 -34 216 -9 9 -16 23 -16 30 0 8
-8 20 -18 27 -10 7 -33 37 -52 66 -34 52 -44 60 -55 42z"/>
<path d="M5278 6023 c-8 -32 3 -43 43 -43 41 0 57 25 22 36 -10 3 -26 10 -35
15 -24 12 -25 12 -30 -8z"/>
<path d="M9915 6022 c-13 -13 -2 -31 25 -42 39 -16 65 -7 51 19 -10 17 -65 34
-76 23z"/>
<path d="M2476 6002 c-8 -14 19 -57 38 -60 17 -4 35 12 36 30 0 7 -53 38 -64
38 -3 0 -7 -4 -10 -8z"/>
<path d="M8223 5975 c-6 -17 43 -74 65 -75 26 0 24 31 -4 61 -31 32 -52 37
-61 14z"/>
<path d="M9117 5984 c-26 -27 20 -94 64 -94 15 0 19 8 19 39 0 22 -3 42 -7 44
-17 10 -69 17 -76 11z"/>
<path d="M6446 5941 c-11 -17 6 -43 25 -38 10 3 25 -4 35 -14 22 -25 67 -26
62 -2 -7 37 -106 81 -122 54z"/>
<path d="M12592 5925 c2 -14 8 -26 13 -26 6 0 11 12 13 26 2 18 -1 25 -13 25
-12 0 -15 -7 -13 -25z"/>
<path d="M2370 5930 c0 -6 20 -30 45 -53 50 -48 56 -73 24 -101 -18 -15 -20
-25 -15 -63 3 -24 8 -49 12 -54 11 -18 24 2 24 36 0 38 35 141 56 166 31 35
18 52 -36 47 -42 -4 -52 -2 -61 13 -10 20 -49 26 -49 9z"/>
<path d="M9017 5914 c-10 -11 -8 -52 3 -59 6 -4 5 -13 -3 -26 -10 -17 -9 -22
7 -35 11 -8 25 -14 32 -14 7 0 16 -9 19 -21 5 -15 13 -19 29 -15 28 7 43 -4
47 -33 7 -46 29 -36 29 13 0 41 -2 46 -23 46 -35 0 -66 26 -60 50 3 11 -1 27
-8 36 -7 9 -18 26 -24 37 -11 23 -36 33 -48 21z"/>
<path d="M2705 5899 c-8 -12 54 -79 73 -79 8 0 25 -9 39 -20 33 -26 43 -25 43
4 0 25 -30 51 -74 62 -15 3 -31 15 -37 25 -11 21 -34 25 -44 8z"/>
<path d="M7553 5899 c-13 -13 -1 -53 22 -79 7 -8 15 -33 17 -54 2 -33 8 -41
31 -49 40 -13 44 -3 18 44 -27 48 -23 65 21 77 33 9 33 9 8 20 -14 5 -34 19
-44 31 -21 23 -55 28 -73 10z"/>
<path d="M9417 5893 c3 -10 29 -39 56 -65 42 -40 57 -48 89 -48 61 0 42 52
-20 54 -20 1 -28 7 -30 23 -4 29 -38 53 -74 53 -22 0 -26 -4 -21 -17z"/>
<path d="M8070 5895 c0 -3 9 -14 21 -26 11 -11 19 -30 17 -42 -3 -19 -10 -22
-48 -23 -25 -1 -58 3 -74 9 -25 9 -31 8 -47 -11 -25 -31 -55 -28 -74 7 -20 40
-51 48 -79 22 -14 -13 -29 -18 -44 -14 -13 3 -22 1 -22 -6 0 -14 53 -41 80
-41 11 0 20 -4 20 -10 0 -5 6 -10 14 -10 7 0 21 -11 30 -25 19 -28 41 -33 50
-10 4 12 15 14 44 9 27 -4 49 -1 70 10 17 9 48 16 69 16 54 0 70 13 56 42 -6
13 -11 34 -11 47 -1 29 -29 61 -54 61 -10 0 -18 -2 -18 -5z"/>
<path d="M9340 5857 c0 -14 20 -37 32 -37 4 0 8 11 8 25 0 18 -5 25 -20 25
-11 0 -20 -6 -20 -13z"/>
<path d="M10200 5850 c0 -23 25 -27 33 -6 7 16 -1 26 -20 26 -7 0 -13 -9 -13
-20z"/>
<path d="M10255 5859 c-4 -5 0 -18 8 -27 8 -9 18 -27 21 -39 4 -13 14 -23 21
-23 48 0 93 -103 63 -142 -18 -23 -106 -8 -128 22 -46 62 -46 63 -71 57 -14
-4 -36 -25 -52 -52 -33 -52 -73 -62 -98 -24 -11 16 -26 21 -71 23 -34 2 -65 9
-75 18 -10 8 -25 18 -35 21 -9 3 -22 18 -30 34 -15 33 -66 44 -87 19 -17 -20
-7 -33 28 -41 38 -8 53 -27 49 -62 -3 -27 -5 -28 -50 -25 -56 4 -64 -14 -23
-52 14 -13 25 -28 25 -33 0 -12 71 -63 87 -63 6 0 16 -6 22 -14 10 -12 120
-27 226 -30 22 0 45 -8 52 -16 10 -13 13 -13 30 1 10 9 28 20 41 24 27 8 24
26 -6 40 -15 6 -22 19 -22 37 0 14 -11 40 -25 56 -35 42 -33 72 4 72 31 0 81
-47 81 -76 0 -8 11 -20 25 -26 14 -6 25 -19 25 -28 0 -16 18 -40 31 -40 15 0
90 68 113 102 49 73 55 226 10 247 -13 6 -24 15 -24 20 0 24 -152 43 -165 20z
m-387 -292 c3 -15 -2 -18 -30 -15 -22 2 -34 9 -36 21 -3 15 2 18 30 15 22 -2
34 -9 36 -21z"/>
<path d="M6623 5853 c-7 -2 -13 -15 -13 -28 0 -14 -7 -25 -20 -28 -31 -8 -24
-25 28 -73 53 -50 66 -51 90 -11 16 26 16 29 0 38 -12 7 -15 18 -11 49 5 36 3
40 -21 50 -29 11 -34 11 -53 3z"/>
<path d="M6755 5798 c-8 -32 4 -48 37 -48 28 0 28 14 -2 47 -29 32 -29 32 -35
1z"/>
<path d="M10010 5823 c0 -20 26 -73 36 -73 17 0 27 49 13 66 -12 14 -49 20
-49 7z"/>
<path d="M12595 5789 c-5 -30 -13 -43 -32 -50 -13 -5 -21 -13 -18 -19 14 -22
32 -7 58 45 31 64 31 65 13 65 -9 0 -17 -16 -21 -41z"/>
<path d="M7197 5814 c-4 -4 -7 -17 -7 -29 0 -13 -7 -28 -15 -35 -8 -7 -15 -15
-15 -19 0 -9 59 -41 76 -41 7 0 29 -9 49 -20 50 -28 56 -25 35 17 -17 35 -17
38 -1 50 15 12 14 15 -6 29 -13 9 -23 23 -23 30 0 8 -6 14 -14 14 -7 0 -26 3
-42 6 -16 3 -32 2 -37 -2z"/>
<path d="M13344 5762 c-52 -62 -52 -76 0 -102 46 -22 66 -20 66 6 0 8 9 23 21
35 18 18 19 23 6 37 -8 9 -18 27 -21 40 -11 32 -37 27 -72 -16z"/>
<path d="M7402 5753 c-13 -28 -14 -37 -4 -41 7 -2 21 -12 30 -22 35 -36 93
-52 107 -30 4 6 -13 34 -37 63 -66 81 -71 82 -96 30z"/>
<path d="M8553 5770 c-6 -24 -26 -26 -43 -5 -13 15 -51 20 -63 9 -11 -11 32
-61 58 -68 32 -8 119 -64 198 -128 26 -21 28 -21 44 -5 27 26 5 52 -41 51 -20
-1 -36 2 -36 7 0 5 -10 17 -21 28 -44 41 7 63 53 23 21 -18 53 -8 44 14 -3 9
-6 19 -6 24 0 11 -58 40 -80 40 -10 0 -31 7 -46 15 -39 20 -55 19 -61 -5z m56
-36 c8 -7 -12 -24 -30 -24 -13 0 -19 7 -19 21 0 16 4 19 23 13 12 -3 24 -8 26
-10z"/>
<path d="M9440 5767 c0 -31 28 -59 85 -87 54 -26 87 -72 83 -115 -3 -29 -4
-30 -50 -28 -41 2 -48 0 -48 -15 0 -10 3 -22 8 -26 4 -4 7 -26 7 -49 0 -40 1
-41 44 -54 41 -12 45 -11 73 12 38 32 41 32 82 -10 40 -40 39 -42 -35 -50 -30
-4 -64 -11 -76 -17 -16 -8 -39 -8 -75 -1 -43 8 -769 11 -853 3 -11 -1 -82 1
-157 5 -88 5 -138 4 -138 -3 0 -5 15 -12 34 -15 19 -3 48 -15 64 -27 26 -19
38 -21 103 -16 41 3 81 5 89 5 8 0 287 -2 619 -5 331 -2 618 -8 636 -13 39
-11 45 -7 45 29 0 36 -13 45 -96 71 -38 12 -77 30 -87 40 -10 10 -22 19 -28
19 -15 0 -61 49 -88 93 -25 40 -25 75 -1 133 17 40 7 64 -24 64 -15 0 -30 8
-36 19 -7 15 -26 21 -75 26 -35 4 -70 14 -76 21 -17 21 -29 17 -29 -9z"/>
<path d="M12136 5764 c-3 -9 -6 -27 -6 -41 0 -22 -2 -24 -15 -13 -13 10 -18
11 -28 1 -9 -10 -7 -17 12 -32 23 -19 24 -22 18 -134 -5 -105 -4 -116 13 -125
30 -16 50 -12 59 13 9 24 129 147 143 147 5 0 8 22 8 50 0 59 -22 85 -104 124
-63 30 -91 33 -100 10z"/>
<path d="M10528 5748 c7 -9 15 -38 19 -66 7 -63 -34 -142 -104 -199 -41 -34
-43 -38 -27 -50 40 -29 98 -8 88 33 -8 34 9 48 41 32 24 -13 34 -13 86 1 32 9
64 22 71 29 6 6 17 12 23 12 7 0 20 9 29 19 10 11 28 22 42 25 13 4 24 10 24
15 0 13 -58 34 -76 27 -20 -8 -94 14 -94 27 0 31 -43 97 -63 97 -12 0 -33 3
-47 7 -22 6 -23 4 -12 -9z"/>
<path d="M13542 5715 c-29 -30 -29 -55 1 -55 29 0 47 18 47 46 0 31 -22 36
-48 9z"/>
<path d="M8230 5712 c0 -43 93 -152 129 -152 24 0 42 -29 35 -57 -4 -14 2 -25
20 -37 22 -14 24 -19 14 -36 -7 -10 -9 -23 -4 -27 9 -10 1026 -11 1032 -2 2 4
-8 14 -22 24 -21 13 -24 21 -19 46 4 17 2 29 -3 29 -6 0 -23 11 -39 24 -15 13
-43 27 -61 31 -37 8 -56 36 -48 71 10 38 -19 41 -55 5 -27 -27 -28 -31 -10
-31 22 0 35 -28 25 -53 -4 -11 -17 -16 -42 -14 -33 2 -37 -1 -42 -28 -4 -24
-10 -30 -32 -30 -14 -1 -33 -7 -42 -14 -17 -14 -37 -9 -76 20 -12 9 -24 6 -54
-15 -50 -33 -88 -33 -121 0 -20 20 -23 29 -15 39 28 34 -27 48 -59 16 -29 -29
-168 -24 -189 7 -8 12 -20 22 -26 22 -6 0 -23 11 -36 26 -14 14 -36 37 -50 51
-36 37 -94 74 -132 83 -18 5 -43 12 -55 15 -19 6 -23 3 -23 -13z"/>
<path d="M8943 5653 c-19 -7 -37 -73 -24 -86 8 -8 16 -9 28 -1 13 8 25 5 51
-12 36 -25 62 -22 62 6 0 11 -10 20 -25 24 -14 4 -25 12 -25 19 0 22 -47 57
-67 50z"/>
<path d="M9040 5656 c0 -3 11 -17 24 -31 24 -26 25 -26 36 -5 6 11 8 25 5 30
-6 10 -65 15 -65 6z"/>
<path d="M4600 5625 c-7 -8 -16 -15 -21 -15 -23 0 -132 -134 -127 -157 4 -22
31 -22 108 1 30 9 90 16 132 16 71 0 78 2 97 26 11 15 18 31 15 36 -6 9 -83 7
-159 -4 -18 -3 -20 2 -17 55 2 58 -5 69 -28 42z"/>
<path d="M2350 5620 c-6 -4 -10 -22 -8 -41 3 -30 7 -34 33 -37 17 -1 39 -7 50
-12 11 -5 31 -10 45 -12 16 -2 29 -13 38 -33 27 -58 63 -105 80 -105 10 0 35
-16 56 -35 37 -34 56 -37 56 -11 0 8 7 19 15 26 21 17 19 59 -2 66 -44 14 -66
31 -105 82 -45 57 -36 55 -123 40 -14 -2 -24 6 -34 29 -14 33 -75 59 -101 43z"/>
<path d="M6680 5610 c0 -14 7 -20 24 -20 19 0 29 -11 49 -52 47 -99 47 -98
-23 -98 -56 0 -61 2 -70 26 -6 15 -15 23 -23 20 -6 -3 -20 -9 -29 -12 -23 -8
-23 -21 1 -29 10 -3 22 -17 25 -30 6 -24 9 -25 85 -22 44 2 86 8 93 14 26 20
74 23 99 5 22 -16 84 -17 734 -18 391 -1 718 1 728 3 62 16 -64 90 -157 92
-28 1 -45 8 -62 26 -45 49 -102 23 -73 -33 7 -15 15 -30 17 -34 2 -5 -10 -8
-26 -8 -41 0 -118 34 -126 55 -5 13 -14 16 -37 11 -21 -4 -47 2 -89 23 -46 22
-62 25 -70 16 -15 -18 -1 -45 26 -56 14 -5 24 -17 24 -29 0 -33 -46 -26 -87
15 -41 41 -69 45 -85 10 -8 -18 -19 -25 -39 -25 -15 0 -31 -4 -34 -10 -16 -27
-160 -2 -180 31 -10 16 -32 10 -63 -16 -64 -53 -203 -23 -171 37 11 21 4 38
-16 38 -21 0 -48 -47 -42 -71 4 -15 2 -19 -10 -15 -8 3 -33 9 -56 13 -23 3
-58 14 -77 25 -19 10 -40 18 -46 18 -6 0 -38 27 -72 60 -54 54 -64 60 -101 60
-34 0 -41 -3 -41 -20z"/>
<path d="M6903 5614 c-6 -16 12 -34 35 -34 17 0 15 15 -4 34 -19 20 -23 20
-31 0z"/>
<path d="M9430 5565 c0 -10 11 -15 35 -15 36 0 47 13 19 24 -28 11 -54 6 -54
-9z"/>
<path d="M3630 5546 c0 -24 16 -43 27 -32 8 8 -6 56 -17 56 -6 0 -10 -11 -10
-24z"/>
<path d="M7234 5545 c-10 -24 3 -44 32 -51 39 -10 57 22 28 50 -20 20 -53 21
-60 1z"/>
<path d="M3670 5487 c0 -23 11 -47 22 -47 14 0 5 53 -9 58 -7 2 -13 -3 -13
-11z"/>
<path d="M5392 5413 c-19 -7 -4 -23 24 -23 27 0 32 15 8 24 -9 3 -16 6 -17 5
-1 0 -8 -3 -15 -6z"/>
<path d="M5827 5414 c-11 -12 3 -24 29 -24 27 0 32 15 8 24 -20 8 -29 8 -37 0z"/>
<path d="M10274 5406 c-3 -8 -25 -20 -49 -27 -78 -23 -70 -62 11 -57 47 3 49
4 46 31 -3 23 0 27 21 27 14 0 30 -7 37 -15 17 -21 158 -21 186 0 10 8 28 15
39 15 11 0 27 5 35 10 13 9 13 11 0 20 -22 14 -66 12 -79 -4 -22 -26 -85 -29
-134 -7 -53 24 -105 27 -113 7z"/>
<path d="M4534 5381 c-70 -7 -99 -27 -109 -75 -4 -17 -14 -42 -23 -56 -11 -18
-15 -45 -14 -95 3 -87 34 -125 102 -125 33 0 40 -3 40 -20 0 -25 -35 -40 -92
-40 -38 0 -40 -1 -34 -26 5 -19 1 -33 -13 -48 -24 -25 -21 -31 44 -76 45 -31
57 -35 114 -35 64 0 64 0 107 55 24 30 52 64 64 76 32 34 22 66 -23 75 -26 5
-24 22 4 36 23 12 23 12 -5 22 -40 16 -45 14 -76 -19 -36 -38 -70 -40 -70 -5
0 30 -31 95 -54 114 -21 17 -20 37 0 45 12 4 14 13 10 32 -9 34 18 78 42 69 9
-4 44 -11 76 -15 47 -7 65 -15 87 -39 32 -36 59 -39 84 -11 18 20 18 21 -3 36
-29 20 -28 42 3 50 32 8 32 22 1 34 -13 5 -27 13 -30 19 -6 9 -51 18 -136 25
-19 2 -63 1 -96 -3z"/>
<path d="M2343 5333 c-16 -6 -17 -45 -1 -61 21 -21 88 -12 88 12 0 6 -15 20
-33 31 -40 25 -40 24 -54 18z"/>
<path d="M2437 5333 c-24 -23 4 -42 33 -23 13 9 13 11 0 20 -18 12 -24 12 -33
3z"/>
<path d="M13110 5325 c0 -10 10 -15 29 -15 37 0 49 16 18 24 -35 9 -47 7 -47
-9z"/>
<path d="M2520 5294 c0 -3 9 -17 20 -31 11 -14 20 -32 20 -39 0 -8 6 -14 13
-14 7 0 13 17 15 45 2 45 2 45 -33 45 -19 0 -35 -3 -35 -6z"/>
<path d="M4919 5190 c-81 -10 -98 -18 -138 -69 -55 -69 -46 -72 105 -40 113
24 134 22 297 -19 21 -6 61 -30 90 -54 54 -46 73 -55 172 -83 33 -9 70 -21 83
-26 31 -12 99 -12 123 1 23 13 25 30 2 30 -15 0 -61 30 -95 62 -26 25 -94 68
-109 68 -7 1 -32 14 -54 30 -53 40 -98 60 -132 60 -15 0 -50 11 -78 25 -54 26
-130 31 -266 15z"/>
<path d="M7616 5081 c-14 -26 -14 -30 3 -45 26 -24 111 -20 111 5 0 15 -64 68
-82 69 -10 0 -24 -13 -32 -29z"/>
<path d="M2458 5020 c35 -32 72 -40 72 -15 0 9 -9 15 -24 15 -13 0 -29 7 -36
15 -7 8 -20 15 -29 15 -11 -1 -6 -9 17 -30z"/>
<path d="M6684 5026 c-18 -14 -17 -16 28 -60 25 -26 48 -52 50 -58 3 -8 14 -7
40 2 35 13 36 15 23 39 -15 30 -87 91 -108 91 -7 0 -22 -6 -33 -14z"/>
<path d="M10784 5015 c-13 -33 25 -65 77 -65 26 0 24 10 -12 48 -32 35 -56 41
-65 17z"/>
<path d="M4896 4984 c-7 -19 20 -54 41 -54 16 0 17 24 3 51 -13 23 -36 25 -44
3z"/>
<path d="M7250 4994 c0 -18 24 -44 40 -44 25 0 25 12 2 33 -18 17 -42 23 -42
11z"/>
<path d="M7407 4986 c-8 -22 17 -72 42 -86 11 -5 23 -19 26 -30 10 -31 44 -25
56 10 6 17 17 30 24 30 56 0 -32 77 -98 86 -36 5 -45 3 -50 -10z"/>
<path d="M5870 4940 c-40 -10 -38 -39 2 -37 18 0 41 -3 51 -8 16 -6 18 -4 15
15 -4 27 -32 39 -68 30z"/>
<path d="M12345 4930 c-10 -11 -28 -20 -41 -20 -56 0 -23 -57 59 -104 74 -41
98 -8 47 65 -11 15 -22 39 -26 53 -7 31 -15 32 -39 6z"/>
<path d="M8500 4894 c0 -55 56 -92 99 -65 23 15 5 80 -25 91 -54 21 -74 13
-74 -26z"/>
<path d="M2400 4894 c0 -13 42 -74 50 -74 13 0 22 37 15 60 -6 19 -65 31 -65
14z"/>
<path d="M2512 4883 c2 -12 12 -18 28 -18 16 0 26 6 28 18 3 13 -3 17 -28 17
-25 0 -31 -4 -28 -17z"/>
<path d="M6996 4891 c-4 -5 -2 -12 4 -16 18 -11 50 -93 50 -127 0 -37 31 -85
49 -74 15 9 14 128 -1 161 -6 14 -23 28 -37 32 -14 3 -33 12 -43 20 -10 9 -18
11 -22 4z"/>
<path d="M7300 4880 c0 -11 5 -20 12 -20 6 0 22 -10 35 -22 27 -25 30 -11 8
32 -18 35 -55 41 -55 10z"/>
<path d="M5030 4865 c0 -28 25 -44 42 -27 9 9 7 17 -7 32 -24 27 -35 25 -35
-5z"/>
<path d="M4743 4833 c-64 -100 -65 -124 -13 -173 58 -54 81 -63 169 -68 73 -3
93 -1 155 23 39 15 78 31 86 36 8 5 29 16 47 24 17 8 34 19 38 25 14 23 44 10
55 -25 15 -45 1 -65 -46 -65 -18 0 -36 -5 -39 -10 -4 -6 -21 -17 -38 -25 -18
-9 -43 -22 -57 -30 -16 -10 -54 -15 -109 -15 -84 0 -84 0 -59 -25 35 -34 81
-50 107 -35 12 6 21 15 21 20 0 16 19 11 40 -10 11 -11 30 -20 43 -20 13 0 32
-7 43 -15 10 -8 35 -15 54 -15 20 0 44 -6 55 -14 28 -19 71 -27 100 -20 60 15
82 162 28 187 -26 12 -73 96 -73 132 0 23 -17 35 -51 35 -13 0 -24 10 -30 30
-6 16 -19 32 -29 35 -22 7 -69 -10 -74 -27 -18 -64 -31 -100 -37 -103 -7 -5
-60 14 -105 36 -16 8 -27 7 -42 -2 -18 -11 -24 -11 -40 4 -10 9 -24 17 -31 17
-6 0 -17 12 -23 28 -17 39 -38 62 -58 62 -9 0 -22 11 -28 25 -16 35 -24 32
-59 -22z m620 -237 c22 -17 22 -33 -3 -41 -35 -11 -76 25 -53 48 10 11 36 8
56 -7z"/>
<path d="M6757 4864 c-21 -22 13 -64 52 -64 12 0 20 35 12 48 -8 14 -55 25
-64 16z"/>
<path d="M10197 4854 c-11 -12 3 -24 29 -24 16 0 24 5 22 13 -5 13 -40 22 -51
11z"/>
<path d="M8904 4785 c-18 -13 -18 -14 0 -34 22 -25 42 -27 50 -6 13 36 -20 63
-50 40z"/>
<path d="M7360 4778 c0 -7 16 -30 35 -52 20 -21 35 -46 33 -55 -7 -52 44 -187
75 -195 16 -4 18 -10 12 -33 -15 -62 -8 -90 21 -79 15 6 16 17 10 84 -4 42
-13 84 -20 92 -8 8 -17 26 -21 40 -4 14 -16 34 -27 44 -17 16 -19 27 -14 63 5
39 3 46 -14 50 -11 3 -20 9 -20 13 0 16 -31 40 -51 40 -10 0 -19 -6 -19 -12z"/>
<path d="M10180 4771 c0 -5 5 -22 10 -37 14 -35 36 -17 26 20 -6 24 -36 38
-36 17z"/>
<path d="M4541 4741 c-10 -7 -11 -16 -4 -37 8 -25 15 -29 51 -32 50 -4 55 11
17 52 -25 27 -41 32 -64 17z"/>
<path d="M6794 4736 c-9 -24 12 -44 28 -28 10 10 8 16 -5 29 -15 15 -17 15
-23 -1z"/>
<path d="M7206 4732 c-8 -13 6 -91 18 -102 7 -5 28 -11 47 -12 53 -5 52 31 -1
82 -42 40 -55 47 -64 32z"/>
<path d="M6910 4686 c0 -18 49 -58 64 -53 23 8 15 33 -15 50 -37 21 -49 22
-49 3z"/>
<path d="M10260 4654 c-13 -33 -13 -32 13 -36 14 -2 22 -10 22 -22 0 -26 -23
-32 -32 -9 -9 25 -34 53 -48 53 -12 0 -75 -55 -75 -65 0 -3 7 -5 16 -5 21 0
72 -58 79 -90 3 -15 27 -50 53 -77 45 -49 49 -51 115 -57 37 -4 83 -14 101
-23 19 -9 41 -13 50 -10 17 7 22 47 6 47 -8 0 -40 60 -69 133 -6 17 -18 27
-31 27 -32 0 -100 31 -110 51 -6 10 -10 29 -10 43 0 16 -10 32 -29 45 -37 27
-39 26 -51 -5z"/>
<path d="M8538 4638 c7 -7 12 -32 12 -56 0 -36 7 -51 40 -91 40 -48 40 -48 25
-84 -14 -34 -17 -36 -39 -25 -14 6 -30 24 -37 40 -13 33 -32 32 -37 -1 -2 -14
6 -34 20 -50 13 -14 29 -38 35 -52 10 -24 9 -28 -13 -38 -14 -6 -27 -18 -30
-26 -4 -10 -20 -15 -48 -15 -23 0 -46 -4 -51 -9 -6 -5 -21 -11 -35 -13 -19 -2
-26 -10 -28 -30 -4 -33 12 -37 30 -8 10 16 24 20 64 20 34 0 56 5 64 15 7 8
25 15 41 15 23 0 30 6 35 26 7 26 8 27 73 20 36 -3 75 -9 86 -12 11 -3 29 2
40 10 19 14 19 15 -18 49 -20 20 -37 44 -37 55 0 20 -24 45 -54 56 -15 5 -18
13 -13 48 4 32 1 47 -14 66 -10 14 -19 30 -19 37 0 17 -64 65 -86 65 -14 0
-15 -3 -6 -12z"/>
<path d="M5680 4602 c0 -10 5 -23 11 -29 21 -21 6 -58 -25 -61 -33 -4 -114 32
-123 54 -9 25 -25 15 -19 -11 7 -27 -16 -118 -35 -141 -16 -20 -1 -53 29 -61
14 -3 55 -7 91 -7 74 -1 89 -16 40 -41 -50 -26 -20 -48 65 -46 35 1 67 -3 71
-9 10 -17 25 -11 25 9 0 11 -21 37 -46 58 -44 38 -45 40 -33 69 7 16 19 37 27
46 8 10 15 41 16 70 1 52 1 53 34 56 41 4 38 21 -9 43 -39 20 -52 16 -43 -13
5 -17 2 -19 -23 -16 -20 2 -29 9 -31 26 -4 26 -22 30 -22 4z"/>
<path d="M8995 4611 c-3 -6 6 -13 20 -17 17 -4 25 -12 23 -23 -4 -22 -39 -27
-54 -6 -20 26 -49 15 -50 -20 -1 -17 -5 -39 -9 -51 -6 -18 -3 -20 27 -16 25 3
38 -2 52 -17 11 -12 24 -21 31 -21 7 0 20 -9 29 -19 10 -11 30 -22 44 -26 15
-3 34 -15 42 -25 8 -10 31 -20 50 -22 33 -3 35 -1 38 29 3 34 -11 98 -28 123
-9 13 -12 13 -24 -2 -17 -23 -23 -22 -71 2 -30 15 -41 28 -45 51 -5 32 -63 79
-75 60z"/>
<path d="M7225 4570 c-8 -13 13 -40 31 -40 19 0 18 36 -2 44 -21 8 -22 8 -29
-4z"/>
<path d="M7140 4478 c0 -40 -18 -56 -26 -25 -8 36 -28 29 -32 -11 -2 -22 -9
-32 -20 -32 -9 0 -26 -7 -36 -15 -11 -8 -32 -15 -47 -15 -14 0 -32 -7 -39 -15
-7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -10 -13 -7 -17 24 -30 55 -23 240
-42 275 -28 22 8 42 7 80 -3 28 -7 65 -10 83 -8 27 5 42 -1 78 -29 28 -21 62
-37 89 -41 24 -4 53 -13 64 -21 12 -8 31 -15 44 -15 12 0 28 -8 35 -18 22 -31
45 -33 62 -7 23 35 20 45 -14 45 -49 0 -80 20 -80 51 0 17 -8 34 -22 43 -13 9
-22 27 -23 43 0 14 -6 28 -12 30 -9 3 -13 -6 -13 -26 0 -27 -4 -31 -26 -31
-35 0 -59 14 -84 50 -15 22 -19 34 -12 43 7 8 4 19 -9 36 -18 22 -19 22 -19 3
0 -25 -25 -46 -42 -36 -7 4 -33 12 -58 16 -25 5 -58 12 -75 15 -42 8 -55 21
-55 54 0 19 -5 29 -15 29 -9 0 -15 -9 -15 -22z m116 -139 c9 -16 -12 -33 -31
-25 -14 5 -15 9 -5 21 15 18 26 19 36 4z"/>
<path d="M13500 4481 c-12 -24 -40 -28 -40 -6 0 8 -4 15 -10 15 -13 0 -13 -13
0 -26 7 -7 4 -16 -10 -29 -23 -21 -27 -55 -6 -55 25 0 66 -41 66 -66 0 -13 9
-33 21 -45 22 -22 19 -49 -7 -49 -8 0 -14 -6 -11 -12 2 -8 23 -13 50 -14 47
-1 47 -1 47 64 0 44 -5 71 -15 82 -8 9 -26 47 -38 83 -28 80 -32 85 -47 58z"/>
<path d="M13320 4460 c0 -11 7 -20 15 -20 9 0 20 -11 25 -25 5 -14 14 -25 20
-25 13 0 -31 78 -47 85 -8 2 -13 -4 -13 -15z"/>
<path d="M2354 4446 c-13 -33 1 -71 35 -93 72 -48 109 -146 65 -171 -21 -11
-10 -32 16 -32 11 0 27 -12 37 -27 30 -49 65 -82 94 -88 15 -4 31 -15 34 -26
4 -10 11 -19 16 -19 6 0 5 8 -1 20 -8 16 -8 36 1 76 12 51 11 57 -9 82 -38 47
-71 118 -66 139 9 34 -41 103 -74 103 -42 0 -103 20 -109 36 -7 18 -32 18 -39
0z"/>
<path d="M2267 4373 c-11 -10 -8 -63 3 -63 6 0 10 16 10 35 0 36 -2 40 -13 28z"/>
<path d="M10957 4374 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28
15z"/>
<path d="M13368 4349 c-30 -17 -25 -123 7 -161 14 -16 25 -41 25 -54 0 -14 15
-44 32 -67 18 -23 34 -44 36 -47 6 -8 42 41 42 56 0 7 -11 16 -25 20 -48 12
-64 47 -58 123 5 59 3 70 -15 87 -11 10 -21 27 -23 36 -3 13 -8 15 -21 7z"/>
<path d="M3250 4304 c0 -30 -13 -57 -52 -104 -68 -84 5 -84 97 1 17 15 39 29
50 31 27 4 32 53 9 79 -12 13 -30 19 -61 19 -40 0 -43 -2 -43 -26z"/>
<path d="M6688 4274 c-27 -13 -48 -28 -48 -33 0 -5 -21 -11 -47 -15 -89 -12
-96 -32 -17 -47 54 -10 64 -6 64 27 0 24 0 24 124 24 69 0 127 4 130 9 3 5
-11 20 -32 35 -50 34 -109 34 -174 0z"/>
<path d="M2242 4260 c-21 -19 -22 -30 -22 -155 0 -105 3 -137 15 -149 17 -16
21 -91 5 -101 -16 -10 -12 -41 11 -79 11 -20 22 -48 23 -63 3 -42 34 -104 63
-126 17 -14 23 -26 19 -41 -7 -30 194 -236 230 -236 13 0 29 -9 36 -20 8 -12
24 -20 40 -20 17 0 33 -8 40 -20 10 -15 24 -20 60 -20 34 0 50 -5 60 -18 12
-17 35 -19 260 -25 246 -6 246 -6 262 18 9 13 16 27 16 30 0 9 -49 5 -55 -5
-11 -18 -103 -12 -114 8 -8 15 -27 17 -159 17 -142 0 -152 1 -174 23 -13 12
-37 22 -52 22 -31 0 -183 76 -223 112 -63 56 -73 69 -167 208 -12 19 -38 69
-55 110 -18 41 -39 89 -46 106 -15 32 -24 143 -28 328 -3 116 -9 129 -45 96z"/>
<path d="M6740 4171 c-85 -6 -85 -6 -48 -25 23 -12 34 -24 31 -33 -3 -7 1 -21
10 -31 8 -9 18 -36 22 -60 9 -55 49 -87 71 -57 8 10 14 22 14 26 0 18 68 29
135 20 84 -10 95 -4 95 56 0 55 22 55 31 0 3 -21 9 -41 13 -45 4 -4 85 -8 179
-8 132 -2 181 -6 209 -18 21 -9 47 -16 58 -16 22 0 29 -35 8 -43 -10 -3 -10
-9 1 -30 7 -14 11 -33 8 -41 -9 -22 31 -46 65 -39 15 3 30 14 33 24 4 10 11
19 16 19 27 0 5 51 -38 90 -43 37 -48 47 -48 83 0 37 -3 42 -30 50 -16 5 -43
15 -60 23 -16 8 -52 18 -80 23 -27 5 -63 15 -80 22 -34 13 -470 21 -615 10z"/>
<path d="M7877 4174 c-17 -18 -6 -35 21 -32 16 2 27 9 27 18 0 16 -36 26 -48
14z"/>
<path d="M8608 4159 c-18 -9 -56 -19 -85 -23 -28 -4 -68 -13 -87 -21 -19 -8
-55 -15 -79 -15 -36 0 -47 -5 -65 -29 -21 -29 -21 -29 4 -46 18 -12 36 -15 58
-11 86 18 153 18 180 1 22 -14 37 -16 84 -10 133 17 165 16 194 -5 38 -28 46
-26 58 20 13 47 17 49 31 14 9 -26 12 -27 73 -22 38 3 74 1 92 -7 16 -6 34
-10 40 -8 14 5 52 -42 60 -74 7 -25 28 -31 41 -10 4 6 16 37 26 67 10 29 29
67 43 83 31 37 30 55 -3 63 -16 4 -45 16 -66 27 -54 28 -255 38 -279 13 -21
-20 -42 -21 -58 -1 -18 21 -217 17 -262 -6z"/>
<path d="M6012 4122 c-49 -43 -21 -58 118 -64 55 -3 55 -3 60 -38 4 -30 14
-41 67 -75 37 -24 64 -49 68 -64 7 -28 22 -18 27 18 2 19 13 28 47 39 56 19
111 4 140 -37 14 -19 36 -32 64 -40 53 -13 71 -32 64 -68 -3 -15 -1 -36 5 -46
14 -26 -7 -47 -48 -47 -19 0 -34 -4 -34 -10 0 -5 -14 -17 -31 -26 -38 -19 -86
-12 -125 18 -37 30 -197 40 -207 14 -8 -20 27 -36 77 -36 37 0 60 -21 77 -67
13 -40 55 -59 92 -42 21 9 30 9 41 0 13 -11 20 -9 42 8 29 22 59 27 69 11 12
-19 38 -11 32 10 -3 13 2 25 14 33 12 9 21 32 26 67 8 51 10 55 41 61 18 4 39
15 46 25 20 27 81 8 81 -26 0 -37 36 -38 57 -3 9 16 16 37 15 48 -2 15 5 21
26 23 33 4 45 -18 28 -55 -11 -24 -8 -29 51 -84 35 -33 66 -59 70 -59 4 0 10
-11 14 -25 3 -14 10 -25 15 -25 17 0 58 -77 52 -99 -4 -16 -1 -21 16 -21 12 0
21 6 21 15 0 21 13 19 28 -5 8 -13 23 -20 42 -20 16 0 48 -7 70 -16 29 -12 47
-14 67 -6 29 10 73 0 73 -17 0 -5 10 -13 22 -16 11 -4 32 -19 45 -33 20 -22
26 -24 46 -13 18 10 30 9 59 -4 21 -8 54 -15 74 -15 58 0 214 -23 214 -31 0
-4 -4 -11 -10 -14 -19 -12 -9 -40 23 -60 30 -19 48 -20 330 -19 297 2 297 2
327 33 29 30 40 61 21 61 -17 0 -60 -27 -79 -50 -19 -23 -19 -23 -38 -3 -12
14 -38 23 -74 28 -85 10 -89 12 -92 53 -3 35 -5 37 -38 36 -72 -2 -256 -5
-277 -4 -13 0 -41 0 -62 -1 -30 -1 -48 5 -73 26 -30 25 -37 27 -93 21 -59 -6
-62 -5 -99 29 -43 39 -49 41 -66 20 -19 -23 -45 -18 -58 10 -8 16 -20 25 -35
25 -13 0 -29 6 -35 12 -7 7 -38 18 -70 26 -31 7 -78 18 -104 23 -64 15 -115
67 -97 98 11 16 11 23 1 33 -6 6 -12 26 -12 44 0 17 -6 37 -14 43 -7 6 -16 29
-20 51 -7 42 -19 48 -49 26 -13 -10 -29 -11 -63 -5 -26 5 -50 6 -55 3 -5 -3
-23 5 -41 17 -18 13 -46 31 -61 42 -19 12 -42 18 -70 16 -24 -2 -49 1 -56 5
-17 11 -29 -3 -33 -39 -6 -56 -37 -39 -79 44 -21 41 -49 86 -62 100 -14 14
-29 40 -34 56 -7 21 -17 31 -34 33 -13 2 -32 11 -43 20 -19 18 -82 20 -311 13
-55 -2 -123 0 -150 4 -42 5 -54 3 -73 -13z m1180 -359 c43 -41 35 -128 -8 -93
-8 7 -29 20 -47 29 -42 21 -50 66 -15 80 35 14 40 13 70 -16z m1156 -485 c3
-14 -3 -18 -30 -18 -39 0 -63 13 -53 29 11 19 79 9 83 -11z m-264 -14 c9 -3
16 -14 16 -24 0 -30 -66 -43 -76 -15 -14 36 17 56 60 39z"/>
<path d="M13550 4102 c-23 -19 -23 -19 1 -41 33 -31 53 -23 57 22 4 43 -19 51
-58 19z"/>
<path d="M7777 4033 c-29 -28 30 -92 89 -96 35 -2 39 0 39 22 0 14 -9 28 -20
35 -11 5 -32 18 -47 28 -28 19 -50 23 -61 11z"/>
<path d="M12393 4013 c-9 -22 44 -64 77 -61 26 3 42 38 18 38 -7 0 -21 9 -31
20 -20 24 -55 26 -64 3z"/>
<path d="M7973 3946 c-30 -14 -28 -26 8 -55 31 -24 31 -24 57 3 27 27 27 27 2
46 -28 22 -35 22 -67 6z"/>
<path d="M12542 3913 c2 -20 9 -29 26 -31 20 -3 23 0 20 25 -2 20 -9 29 -26
31 -20 3 -23 0 -20 -25z"/>
<path d="M11063 3903 c-45 -17 27 -123 84 -123 32 0 73 -37 73 -66 0 -8 15
-20 34 -28 27 -11 36 -22 41 -48 8 -44 70 -107 88 -89 9 10 7 16 -12 32 -17
14 -22 25 -17 44 6 23 -23 65 -45 65 -4 0 -12 14 -18 30 -8 24 -16 30 -40 30
-26 0 -31 4 -31 25 0 18 -7 28 -27 36 -14 5 -44 30 -65 54 -40 46 -43 47 -65
38z"/>
<path d="M8232 3848 c3 -7 16 -14 31 -16 16 -2 29 -11 32 -24 8 -24 79 -58
106 -51 19 5 19 6 2 27 -61 74 -64 76 -121 76 -38 0 -53 -4 -50 -12z"/>
<path d="M11540 3820 c-14 -52 -7 -62 29 -44 21 11 36 12 55 4 26 -9 76 4 76
20 0 8 -69 30 -92 30 -9 0 -21 7 -28 15 -20 24 -28 18 -40 -25z"/>
<path d="M7850 3829 c-14 -26 3 -49 36 -49 26 0 31 18 14 51 -14 25 -36 24
-50 -2z"/>
<path d="M7670 3819 c0 -19 52 -61 62 -51 5 5 3 14 -7 22 -8 7 -15 19 -15 26
0 8 -9 14 -20 14 -11 0 -20 -5 -20 -11z"/>
<path d="M8018 3784 c-35 -18 -35 -22 -1 -35 31 -12 58 7 47 34 -7 20 -11 20
-46 1z"/>
<path d="M3181 3766 c-17 -44 41 -196 75 -196 9 0 57 -14 106 -31 83 -28 91
-29 107 -15 16 15 19 15 31 1 16 -19 40 -20 40 -1 0 28 -182 136 -230 136 -34
0 -73 46 -67 79 10 49 -45 73 -62 27z"/>
<path d="M4947 3762 c-25 -28 -21 -42 14 -42 27 0 30 3 24 23 -11 34 -20 39
-38 19z"/>
<path d="M8800 3764 c0 -10 7 -14 22 -12 32 5 35 28 4 28 -17 0 -26 -5 -26
-16z"/>
<path d="M10598 3754 c-16 -8 -28 -19 -28 -24 0 -13 34 -30 59 -30 11 0 24 -6
28 -12 4 -7 23 -24 41 -37 55 -38 60 -13 11 58 -45 66 -62 72 -111 45z"/>
<path d="M5522 3738 c4 -28 52 -48 70 -30 16 16 -17 52 -49 52 -20 0 -24 -5
-21 -22z"/>
<path d="M4354 3738 c-7 -12 14 -33 95 -91 27 -19 49 -45 55 -65 14 -40 62
-102 80 -102 7 0 17 10 23 22 19 42 -70 208 -112 208 -5 0 -27 9 -48 20 -41
22 -82 26 -93 8z"/>
<path d="M11565 3742 c-23 -24 20 -82 60 -82 14 0 29 -8 35 -19 5 -11 19 -22
29 -26 15 -5 21 -17 23 -53 2 -36 6 -46 18 -43 8 3 36 7 63 9 26 2 47 8 47 12
0 18 -13 40 -24 40 -6 1 -28 16 -50 35 -39 34 -39 34 -12 44 16 7 26 18 26 30
0 26 -15 34 -37 20 -15 -9 -28 -7 -63 9 -45 20 -106 33 -115 24z"/>
<path d="M12458 3740 c-61 -8 -108 -31 -108 -54 0 -24 72 -37 85 -16 8 14 95
1 125 -19 14 -9 43 -18 65 -21 50 -6 54 -31 7 -41 -47 -10 -49 -15 -16 -49 32
-32 79 -40 117 -18 12 7 47 20 77 28 48 13 55 18 55 40 0 24 -3 25 -65 28 -38
2 -71 9 -80 17 -9 8 -31 18 -49 21 -17 4 -36 15 -41 24 -10 18 -92 71 -107 69
-4 -1 -34 -5 -65 -9z"/>
<path d="M3892 3704 c4 -20 34 -41 45 -31 10 11 -11 41 -31 45 -12 3 -17 -2
-14 -14z"/>
<path d="M5317 3713 c-13 -12 -7 -43 8 -43 9 0 15 9 15 25 0 24 -10 32 -23 18z"/>
<path d="M8204 3706 c-3 -9 23 -44 68 -89 40 -42 84 -88 98 -104 14 -15 40
-36 59 -46 30 -16 33 -21 29 -57 -3 -31 0 -40 12 -40 16 0 103 42 126 61 9 7
29 9 53 5 26 -4 49 -1 67 9 37 19 58 19 74 0 24 -29 37 -17 36 35 -1 46 -4 52
-36 71 -39 24 -84 16 -127 -23 -11 -11 -38 -22 -60 -24 -36 -4 -42 -1 -108 61
-38 36 -90 75 -115 87 -25 12 -55 32 -67 45 -26 27 -100 33 -109 9z"/>
<path d="M5185 3680 c3 -5 13 -10 21 -10 8 0 14 -7 14 -15 0 -10 10 -15 34
-15 50 0 53 17 6 25 -22 4 -42 11 -46 16 -3 5 -12 9 -20 9 -8 0 -12 -4 -9 -10z"/>
<path d="M9404 3675 c-8 -21 0 -30 62 -61 31 -15 64 -39 74 -51 20 -25 93 -33
130 -13 15 8 27 1 67 -36 55 -52 116 -94 136 -94 8 0 24 -9 37 -20 13 -11 31
-20 40 -20 10 0 23 -7 30 -15 7 -8 16 -15 21 -15 15 0 10 38 -5 47 -8 4 -16
19 -18 33 -2 20 -9 25 -31 25 -16 0 -32 7 -38 17 -8 14 -4 19 23 26 53 13 87
3 105 -32 10 -17 16 -35 15 -41 -1 -5 6 -20 16 -33 17 -22 19 -22 67 -7 61 18
60 18 46 2 -16 -20 -3 -27 47 -27 29 0 52 6 64 17 11 10 32 16 52 15 37 -3 60
17 50 41 -7 19 -19 23 -99 32 -33 4 -77 16 -97 26 -20 10 -53 19 -71 19 -20 0
-46 9 -61 21 -20 16 -34 19 -54 14 -60 -17 -108 -9 -168 28 -42 26 -84 41
-144 53 -60 12 -93 24 -111 40 -22 21 -35 24 -102 24 -59 0 -79 -4 -83 -15z"/>
<path d="M5685 3660 c-18 -29 61 -115 99 -108 20 4 38 -5 77 -38 32 -28 60
-44 77 -44 26 0 26 0 -11 34 -21 19 -40 47 -43 66 -4 18 -17 38 -33 48 -14 9
-34 24 -44 34 -19 20 -111 26 -122 8z"/>
<path d="M13083 3663 c-7 -2 -13 -11 -13 -19 0 -18 -24 -18 -40 1 -17 20 -36
19 -76 -6 -59 -36 -35 -69 49 -69 40 0 46 3 57 30 14 35 18 35 67 15 37 -16
61 -11 30 6 -9 6 -17 19 -17 29 0 20 -27 26 -57 13z"/>
<path d="M10376 3635 c-10 -8 -23 -16 -29 -18 -19 -6 13 -47 36 -47 13 0 27
-4 33 -9 5 -5 48 -12 97 -16 77 -7 87 -5 87 9 0 18 -52 54 -90 62 -14 2 -38
11 -53 19 -36 19 -57 18 -81 0z"/>
<path d="M5122 3600 c-30 -15 -59 -33 -65 -39 -6 -6 -20 -11 -32 -11 -12 0
-30 -7 -41 -15 -10 -8 -36 -20 -58 -26 -24 -6 -40 -18 -43 -30 -3 -10 -11 -19
-18 -19 -7 0 -18 -6 -24 -14 -15 -18 -125 -56 -161 -56 -16 0 -29 -8 -35 -22
-16 -36 -69 -46 -105 -20 -34 26 -48 27 -74 7 -11 -8 -33 -15 -49 -15 -16 0
-47 -5 -69 -12 -42 -12 -64 -8 -157 34 -24 11 -70 21 -102 23 -32 2 -68 10
-80 19 -33 23 -82 20 -105 -5 -14 -15 -27 -19 -49 -16 -16 3 -50 0 -73 -5 -42
-10 -44 -12 -38 -41 8 -41 9 -42 59 -28 42 12 80 12 302 -4 44 -3 99 -5 122
-5 34 0 43 -4 48 -21 7 -20 12 -21 69 -14 33 3 65 11 70 16 13 12 93 12 101
-1 3 -5 19 -10 36 -10 16 0 29 5 29 10 0 6 25 10 56 10 30 0 65 5 76 11 50 27
202 26 306 -2 50 -13 52 -15 47 -41 -13 -57 -1 -68 74 -68 69 0 131 -15 131
-31 0 -5 52 -9 115 -9 63 0 115 4 115 9 0 22 73 31 266 31 192 0 204 -1 217
-20 14 -20 24 -20 622 -21 541 0 609 2 617 15 5 9 22 16 39 16 18 0 32 6 36
16 3 8 16 20 29 25 13 4 24 13 24 19 0 21 -31 22 -53 3 -36 -32 -46 -35 -74
-20 -59 31 -114 38 -366 41 -180 3 -262 7 -272 16 -11 9 -19 9 -35 -3 -24 -17
-102 -13 -173 10 -36 11 -55 12 -75 4 -15 -5 -56 -10 -91 -9 -54 1 -61 3 -46
14 21 15 12 34 -17 34 -11 0 -33 14 -49 31 -29 31 -29 31 -29 -12 0 -54 -7
-65 -46 -73 -22 -5 -35 -2 -44 9 -7 8 -19 15 -27 15 -8 0 -31 9 -51 20 -75 39
-106 50 -147 50 -48 0 -95 -30 -95 -60 0 -14 -11 -20 -42 -26 -76 -13 -201
-11 -225 3 -19 11 -33 11 -88 -3 -57 -14 -68 -15 -83 -2 -27 22 -90 48 -118
48 -14 0 -42 11 -62 25 -20 14 -41 25 -45 25 -14 0 -107 62 -107 72 0 4 16 8
35 8 23 0 41 8 57 24 28 29 110 34 245 15 90 -13 113 -9 113 20 0 19 -18 31
-46 31 -19 0 -74 50 -74 67 0 20 -40 14 -98 -17z m668 -319 c0 -17 -16 -21
-69 -14 -70 8 -64 23 9 23 33 0 60 -4 60 -9z"/>
<path d="M11860 3615 c-15 -18 -6 -45 15 -45 44 0 73 41 39 54 -25 10 -41 7
-54 -9z"/>
<path d="M6066 3595 c-11 -8 -28 -15 -39 -15 -41 0 -7 -25 42 -31 53 -7 127
-47 138 -74 3 -8 10 -15 16 -15 6 0 20 -9 32 -20 12 -11 62 -32 111 -46 49
-14 96 -30 106 -35 22 -12 48 -1 48 20 0 21 -39 41 -79 41 -15 0 -38 9 -51 20
-13 11 -27 20 -31 20 -5 0 -15 16 -23 35 -13 31 -19 35 -67 41 -37 5 -60 14
-75 32 -13 13 -36 25 -51 27 -15 1 -35 5 -43 8 -8 4 -24 0 -34 -8z"/>
<path d="M7920 3591 c0 -22 25 -51 43 -51 7 0 28 -10 47 -22 22 -13 54 -22 85
-23 28 -1 59 -4 70 -6 29 -6 30 23 0 67 -14 21 -28 40 -30 42 -2 2 -51 6 -109
9 -100 4 -106 3 -106 -16z"/>
<path d="M11213 3599 c-17 -17 2 -49 28 -49 16 0 20 5 17 27 -3 30 -26 41 -45
22z"/>
<path d="M3778 3578 c-16 -12 -16 -14 0 -34 26 -31 51 -41 103 -42 26 0 61 -8
78 -17 26 -13 39 -14 65 -5 18 6 40 8 48 5 22 -9 30 8 15 29 -16 21 -160 41
-188 25 -25 -13 -54 -4 -82 27 -19 20 -25 22 -39 12z"/>
<path d="M11982 3557 c-12 -13 -22 -28 -22 -34 0 -17 69 -73 90 -73 76 0 65
77 -17 119 -28 14 -26 15 -51 -12z"/>
<path d="M12163 3549 c-20 -20 -3 -39 33 -39 39 0 43 12 12 34 -27 19 -31 19
-45 5z"/>
<path d="M4190 3527 c0 -24 28 -56 67 -76 30 -15 193 -27 193 -14 0 23 -69 71
-111 77 -24 4 -62 13 -84 21 -55 20 -65 18 -65 -8z"/>
<path d="M13030 3522 c0 -39 18 -52 66 -50 24 1 51 -6 68 -17 16 -11 50 -29
77 -41 48 -23 49 -23 59 -4 6 11 16 20 23 20 31 1 78 68 50 71 -101 9 -137 12
-181 11 -30 -1 -63 4 -75 12 -12 8 -37 17 -54 21 -31 6 -33 5 -33 -23z"/>
<path d="M11060 3511 c0 -37 71 -63 78 -28 2 10 -3 17 -11 17 -8 0 -20 7 -27
15 -17 21 -40 19 -40 -4z"/>
<path d="M5485 3500 c-10 -16 5 -57 30 -80 22 -21 24 -21 54 -6 41 22 39 40
-6 71 -39 26 -68 32 -78 15z"/>
<path d="M9096 3495 c-18 -13 -18 -16 -3 -54 18 -43 5 -69 -18 -38 -15 20 -63
39 -77 31 -6 -4 -31 -6 -55 -5 -38 1 -45 -2 -53 -25 -9 -23 -15 -26 -48 -22
-53 7 -122 -26 -122 -59 0 -20 37 -15 59 8 14 15 27 20 44 15 13 -3 47 0 74 7
34 9 90 12 168 9 86 -3 116 -2 111 7 -4 6 -13 11 -21 11 -18 0 -26 25 -12 39
17 17 65 13 76 -6 5 -10 24 -22 43 -29 25 -8 33 -17 33 -35 0 -17 6 -25 23
-27 18 -3 22 1 22 22 0 31 35 37 55 9 7 -9 17 -13 23 -9 19 11 14 56 -5 62
-10 3 -36 14 -58 25 -27 13 -61 19 -103 19 -58 0 -67 3 -92 30 -32 34 -37 35
-64 15z"/>
<path d="M10540 3490 c0 -11 -7 -23 -15 -26 -29 -11 -15 -25 19 -19 20 4 36 2
40 -4 8 -13 26 -14 44 -2 10 6 6 15 -17 39 -34 37 -71 43 -71 12z"/>
<path d="M10724 3489 c-8 -13 13 -29 38 -29 9 0 23 -3 32 -6 21 -8 21 10 0 30
-18 18 -60 21 -70 5z"/>
<path d="M3090 3482 c0 -20 44 -52 80 -58 21 -4 47 -15 56 -25 9 -11 28 -19
40 -19 16 0 29 -10 39 -30 17 -33 22 -35 60 -20 22 8 34 6 60 -10 42 -26 65
-25 93 4 28 30 28 37 -4 67 -24 22 -32 24 -112 21 -87 -3 -87 -3 -121 32 -32
33 -36 34 -86 29 -33 -4 -55 -1 -59 6 -8 13 -46 15 -46 3z"/>
<path d="M10890 3472 c0 -20 28 -43 54 -45 40 -3 44 19 7 37 -33 17 -61 21
-61 8z"/>
<path d="M12532 3458 c6 -16 36 -34 44 -26 3 4 4 14 1 23 -7 17 -51 21 -45 3z"/>
<path d="M6767 3428 c21 -36 73 -67 116 -68 61 -1 23 52 -57 80 -78 26 -81 26
-59 -12z"/>
<path d="M11224 3446 c-13 -34 58 -104 77 -75 13 20 12 24 -17 58 -28 33 -51
40 -60 17z"/>
<path d="M12057 3433 c-13 -12 -7 -28 15 -42 19 -12 23 -11 35 5 21 29 16 44
-15 44 -16 0 -32 -3 -35 -7z"/>
<path d="M2898 3395 c-14 -31 -11 -34 54 -52 100 -28 95 -28 99 9 8 65 5 68
-72 68 -64 0 -70 -2 -81 -25z"/>
<path d="M3550 3315 c0 -11 11 -15 39 -15 42 0 62 14 35 24 -31 12 -74 7 -74
-9z"/>
<path d="M4960 3250 c-11 -7 -8 -11 14 -20 31 -11 54 -1 42 19 -9 13 -36 14
-56 1z"/>
<path d="M8862 3238 c7 -20 48 -23 48 -4 0 11 -9 16 -26 16 -16 0 -24 -5 -22
-12z"/>
<path d="M8987 3243 c-19 -18 4 -23 117 -23 115 0 159 9 120 24 -21 8 -229 8
-237 -1z"/>
</g>
</svg>`;

const BACK_SVG = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1284.000000pt" height="1800.000000pt" viewBox="0 0 1284.000000 1800.000000"
 preserveAspectRatio="xMidYMid meet">
<defs>
  <linearGradient id="metalSkull" x1="0%" y1="0%" x2="100%" y2="20%" gradientUnits="objectBoundingBox">
    <stop offset="0%" stop-color="#D3D5D8"/>
    <stop offset="22%" stop-color="#8A8F99"/>
    <stop offset="48%" stop-color="#E9EBEE"/>
    <stop offset="68%" stop-color="#6E737C"/>
    <stop offset="85%" stop-color="#B8BDC5"/>
    <stop offset="100%" stop-color="#7A7F8A"/>
  </linearGradient>
</defs>

<g transform="translate(-40,-900)">
  <g transform="translate(0.000000,1800.000000) scale(0.040000,-0.040000)">
    
    <path d="m17450 18278 c186 2 380 2 431 0 177 -5 257 -5 732 -3 1111 5
1072 7 1132 -62 59 -68 110 -62 249 32 65 43 148 45 1706 32 l1638 -14 215
-107 c118 -58 224 -106 234 -106 11 0 119 -67 240 -150 121 -82 226 -150 233
-150 7 0 63 -34 124 -75 61 -41 118 -75 128 -75 16 0 275 -193 344 -257 18
-17 62 -47 98 -68 37 -21 109 -74 162 -118 88 -73 292 -230 489 -375 77 -57
152 -125 678 -617 163 -152 340 -302 394 -335 54 -32 98 -67 98 -79 0 -11 71
-98 158 -192 278 -301 331 -367 482 -596 81 -124 155 -242 165 -263 10 -21 74
-116 142 -212 69 -97 187 -267 264 -378 76 -111 181 -252 234 -313 128 -148
255 -313 255 -331 0 -8 43 -86 97 -173 53 -87 123 -213 156 -281 54 -111 120
-226 216 -375 17 -27 41 -73 54 -102 13 -29 69 -127 125 -219 56 -92 102 -193
102 -226 0 -32 15 -97 34 -143 18 -47 47 -169 63 -272 16 -103 51 -283 79
-400 27 -117 49 -263 50 -325 0 -62 12 -186 26 -275 41 -255 68 -487 97 -825
27 -324 80 -606 141 -741 19 -44 35 -101 35 -128 0 -28 17 -64 38 -81 20 -17
37 -48 37 -68 0 -20 51 -138 113 -262 61 -125 112 -237 112 -249 0 -12 32 -92
72 -178 157 -338 218 -694 174 -1014 -16 -119 -43 -233 -60 -254 -16 -21 -35
-90 -42 -154 -7 -64 -38 -152 -69 -196 -59 -84 -51 -207 29 -437 14 -42 35
-115 47 -163 12 -48 35 -138 51 -200 16 -62 44 -169 62 -237 106 -412 102
-1141 -8 -1388 -42 -94 -356 -525 -383 -525 -9 0 -88 -74 -176 -165 -181 -186
-304 -260 -436 -260 -77 0 -89 7 -73 44 10 24 24 69 31 100 6 31 22 63 34 70
12 8 22 58 22 111 0 103 -6 98 189 148 72 19 127 57 185 129 59 73 89 95 109
75 41 -41 67 -33 67 20 0 26 17 61 38 78 47 40 47 87 -2 161 -29 44 -31 64 -9
78 17 10 40 0 53 -23 88 -158 295 148 295 438 0 196 -38 271 -137 271 -87 0
-169 92 -137 153 15 27 43 56 61 63 56 21 97 431 48 482 -29 30 -110 -90 -110
-162 0 -173 -58 -204 -186 -99 -63 51 -68 65 -40 100 28 33 25 48 -20 97 -63
66 -70 116 -17 116 60 0 138 81 138 143 0 32 23 77 50 100 27 24 50 73 50 110
0 45 16 70 50 79 42 11 50 34 50 141 0 133 -37 166 -100 90 -17 -21 -45 -38
-63 -38 -17 0 -39 -39 -48 -86 -8 -47 -24 -89 -35 -93 -65 -28 -209 -226 -183
-252 43 -43 35 -161 -15 -237 -24 -37 -55 -123 -68 -191 -29 -142 -88 -189
-88 -70 0 102 -38 119 -73 34 -16 -39 -61 -82 -103 -98 -104 -39 -92 -82 22
-82 53 0 102 -7 110 -15 16 -16 -51 -190 -81 -210 -10 -7 -40 -52 -66 -100
-25 -48 -69 -121 -97 -163 -27 -41 -78 -129 -112 -196 -34 -67 -87 -131 -117
-142 -57 -22 -111 -91 -181 -232 -72 -145 -142 -120 -162 57 -19 167 -92 215
-139 91 -30 -78 -73 -91 -160 -47 -64 33 -69 44 -54 128 10 50 30 96 45 101
15 6 55 38 88 71 56 56 69 58 184 34 159 -35 171 -34 171 9 0 67 49 67 111 1
62 -67 114 -65 114 4 0 20 28 74 62 119 l63 82 -59 27 c-47 21 -57 44 -55 118
4 115 74 168 126 97 42 -57 52 -47 73 72 15 82 11 94 -31 94 -43 0 -49 19 -50
144 -2 118 -12 152 -59 190 -57 47 -58 47 -81 -18 -25 -70 -62 -83 -106 -39
-17 17 -33 18 -42 3 -9 -13 1 -38 22 -55 20 -17 37 -50 37 -73 0 -22 23 -60
50 -84 82 -70 37 -190 -57 -154 -21 8 -45 2 -55 -12 -9 -15 1 -34 23 -42 60
-23 47 -97 -34 -182 -88 -95 -121 -98 -152 -14 -21 55 -32 59 -77 35 -42 -22
-62 -19 -101 16 -65 59 -59 272 7 273 84 0 233 285 178 340 -31 31 -232 -13
-260 -57 -16 -26 -28 -22 -58 17 -37 49 -37 49 -38 -8 -1 -31 27 -88 62 -125
83 -89 70 -135 -49 -169 -59 -16 -108 -49 -122 -82 -14 -29 -41 -54 -62 -54
-20 0 -63 -28 -95 -62 -93 -102 -154 -76 -136 58 2 18 -10 49 -26 69 -25 30
-18 50 39 109 77 81 71 151 -12 151 -42 0 -48 11 -35 63 12 47 6 62 -25 62
-39 0 -215 167 -215 204 0 9 21 24 48 33 26 8 53 30 61 49 7 19 50 42 96 52
161 35 191 101 57 126 l-88 17 49 84 c59 99 32 127 -72 73 -73 -37 -76 -37
-76 11 0 38 -16 51 -62 51 -43 0 -73 22 -99 72 -20 40 -65 79 -100 88 -34 9
-75 38 -89 65 -31 59 -131 66 -174 13 -37 -44 -232 -27 -319 28 -50 31 -52 42
-25 101 24 52 23 69 -1 77 -20 7 -31 64 -31 165 0 91 -14 175 -34 204 -40 58
-81 312 -50 312 12 -1 38 -11 59 -24 39 -25 149 55 151 110 0 14 27 58 58 97
51 62 61 65 90 31 18 -22 58 -39 90 -39 32 0 65 -11 74 -25 41 -68 92 -24 76
65 -13 69 -7 97 26 121 26 20 35 44 23 64 -16 25 -28 22 -54 -13 -33 -45 -35
-45 -72 2 -124 157 -133 218 -35 249 64 21 60 57 -18 173 l-67 98 -58 -73
c-71 -89 -74 -135 -13 -214 33 -43 42 -89 35 -166 -12 -109 -47 -140 -71 -62
-32 104 -111 256 -134 256 -19 0 -101 -219 -101 -270 0 -6 24 -4 54 3 33 9 78
-4 116 -34 61 -49 56 -59 -25 -50 -60 5 -150 -46 -131 -76 27 -43 -14 -161
-68 -195 -46 -29 -61 -23 -136 50 -47 45 -85 102 -85 128 0 74 -67 78 -142 9
-69 -64 -183 -89 -183 -40 0 40 -93 29 -109 -12 -18 -47 -82 -49 -109 -4 -11
18 -45 47 -76 63 -31 16 -56 51 -56 77 0 26 -23 55 -51 64 -63 20 -22 87 53
87 70 0 178 105 151 147 -31 48 -155 14 -171 -47 -10 -37 -27 -45 -82 -34 -56
11 -73 4 -87 -38 -20 -63 -52 -68 -83 -12 -13 23 -36 33 -52 24 -46 -29 -32
-136 22 -165 28 -15 50 -41 50 -59 0 -39 263 -316 299 -316 14 0 26 36 26 80
0 62 7 73 30 50 16 -16 55 -30 85 -30 53 0 85 -43 85 -115 0 -22 -26 -35 -69
-35 -81 0 -138 -72 -156 -200 -10 -70 -25 -89 -75 -96 -82 -11 -150 -86 -150
-164 0 -91 -41 -101 -114 -28 -56 55 -63 79 -49 161 10 59 6 103 -10 113 -42
26 -32 114 13 114 22 0 59 -24 83 -54 28 -34 59 -49 86 -38 62 23 49 89 -20
106 -34 9 -75 32 -91 51 -19 23 -82 35 -187 35 -131 0 -170 10 -228 61 l-70
60 65 25 c36 14 72 43 80 65 9 21 31 39 51 39 31 0 166 151 166 186 0 8 -22
14 -49 14 -68 0 -89 47 -37 85 24 18 36 45 26 61 -26 42 -157 36 -174 -8 -17
-46 -66 -50 -66 -7 0 43 -137 169 -183 169 -20 0 -43 17 -51 38 -8 20 -43 37
-79 37 -45 0 -77 22 -107 75 -42 75 -127 93 -108 24 6 -20 12 -64 13 -97 1
-33 17 -65 34 -71 51 -17 35 -83 -32 -136 -83 -65 -44 -120 85 -120 90 -1 90
-1 28 -33 -58 -30 -78 -123 -35 -165 19 -20 110 95 110 138 0 46 38 44 113 -5
77 -51 77 -66 1 -149 -109 -117 -314 -45 -314 111 0 28 -22 57 -51 66 -36 11
-47 30 -36 62 21 67 -85 97 -129 37 -37 -50 -24 -87 30 -87 53 0 44 -101 -15
-164 l-51 -54 65 -42 c38 -25 85 -36 115 -27 31 10 68 1 96 -24 56 -52 301
-30 301 27 0 19 11 34 25 34 14 0 25 21 25 47 0 26 15 54 34 61 19 7 41 48 49
90 14 70 21 75 65 48 56 -36 109 -139 88 -173 -7 -13 -75 -52 -149 -87 -140
-66 -177 -121 -151 -225 19 -79 -17 -78 -123 3 -54 41 -89 54 -100 36 -21 -34
9 -227 43 -268 17 -22 12 -36 -17 -47 -28 -11 -56 3 -81 38 -31 45 -58 54
-142 48 -96 -7 -104 -3 -111 61 -8 65 -62 92 -91 45 -8 -12 -36 -17 -63 -9
-27 7 -67 -6 -89 -28 -56 -55 -70 -51 -121 35 -55 95 -91 96 -91 3 0 -78 59
-149 87 -104 31 51 213 -130 213 -213 0 -34 -136 -31 -161 4 -23 31 -36 34
-50 13 -10 -17 -5 -47 12 -67 25 -30 19 -36 -35 -36 -85 0 -86 -59 -3 -135 89
-84 80 -154 -26 -205 -96 -45 -137 -33 -89 26 54 64 22 146 -64 169 -85 22
-130 92 -80 123 45 27 -23 147 -83 147 -57 0 -59 44 -5 103 49 55 28 122 -38
122 -26 0 -55 18 -63 40 -10 26 -34 36 -66 28 -27 -8 -65 2 -85 21 -29 30 -36
29 -49 -4 -39 -103 1 -210 91 -242 50 -17 -54 -118 -122 -118 -36 0 -59 -15
-59 -37 0 -42 -39 -51 -62 -15 -7 13 -59 23 -113 22 -127 -1 -225 61 -225 143
0 34 -8 63 -19 64 -10 0 -103 7 -205 14 -107 7 -217 30 -256 54 -52 30 -77 33
-98 12 -42 -42 -140 30 -160 118 -8 39 -31 85 -51 101 -49 41 -45 83 13 135
47 43 51 42 117 -9 37 -30 84 -76 102 -103 21 -29 64 -49 107 -49 73 0 130
-41 176 -127 23 -43 45 -47 174 -35 l149 14 36 -89 c21 -48 54 -88 74 -88 62
0 116 29 116 61 0 17 24 30 53 28 99 -3 117 75 36 159 -85 89 -114 80 -114
-37 0 -47 -12 -86 -26 -86 -35 0 -78 122 -62 174 9 27 -19 77 -78 137 -86 89
-95 92 -125 50 -41 -55 -305 -55 -347 0 -15 19 -91 42 -169 52 -154 19 -195
81 -100 150 52 38 6 112 -70 112 -51 0 -216 140 -193 164 9 8 44 -4 79 -27 72
-47 116 -32 116 39 0 35 -17 49 -59 49 -100 0 -134 68 -53 105 60 27 73 25
113 -25 51 -63 124 -73 124 -17 0 46 75 48 135 4 64 -46 42 -129 -33 -130 -76
-1 -124 -93 -78 -148 23 -28 65 -35 164 -25 78 7 140 1 149 -14 26 -42 63 -28
87 31 13 31 24 42 24 25 1 -17 31 -31 66 -31 48 0 70 -18 89 -73 14 -41 67
-105 117 -143 50 -39 112 -91 137 -116 43 -43 51 -44 107 -7 55 36 69 36 154
1 87 -36 96 -36 125 4 48 65 40 134 -15 134 -26 0 -61 17 -78 38 -17 20 -58
37 -92 37 -132 0 -347 220 -252 258 17 7 -15 14 -72 15 -62 1 -116 18 -136 42
-62 75 -131 85 -179 26 l-44 -53 -50 62 c-124 155 -152 221 -99 238 28 9 76
-5 117 -34 100 -70 255 -90 240 -30 -7 25 5 50 27 59 47 18 51 79 13 188 l-27
78 -63 -75 c-72 -86 -145 -101 -121 -25 26 80 -29 151 -116 151 -70 0 -75 -5
-60 -67 10 -37 35 -80 57 -96 67 -49 -12 -72 -84 -24 -46 30 -91 37 -156 26
-275 -49 -295 -47 -395 31 -102 79 -250 88 -308 17 -17 -20 -62 -28 -120 -21
-86 11 -97 4 -154 -90 -63 -104 -101 -128 -101 -64 0 20 -31 45 -69 54 -38 9
-99 40 -135 69 -37 29 -113 86 -169 126 -56 40 -102 85 -103 100 0 15 -17 48
-36 74 -34 45 -42 41 -152 -81 l-116 -129 -75 69 c-202 184 -246 257 -195 318
23 28 18 42 -23 68 -29 17 -52 56 -52 86 0 36 -23 63 -69 80 -170 65 -245 194
-165 283 39 43 39 46 -1 46 -24 0 -65 -12 -93 -26 -64 -35 -138 -10 -154 51
-7 26 -64 73 -126 103 -82 40 -116 73 -126 123 -20 101 -216 284 -216 202 0
-12 17 -36 37 -53 23 -18 32 -53 23 -87 -10 -41 6 -72 63 -120 42 -36 77 -72
77 -82 0 -9 34 -59 75 -111 98 -123 98 -175 1 -175 -41 0 -119 -18 -173 -39
-54 -22 -113 -36 -132 -32 -18 3 -59 -8 -90 -25 -66 -36 -78 11 -26 95 44 70
12 86 -110 55 -72 -18 -110 -19 -116 -2 -23 67 -139 145 -181 122 -30 -16 -52
-11 -75 16 -25 30 -58 36 -132 24 -68 -11 -106 -6 -119 16 -39 63 -49 -3 -11
-76 21 -42 39 -99 39 -126 0 -73 37 -84 88 -27 57 63 104 63 125 -1 18 -59 75
-66 96 -12 20 53 66 46 66 -10 0 -26 15 -54 34 -61 41 -16 72 -117 35 -117
-14 0 -39 -18 -54 -39 -16 -21 -47 -41 -69 -45 -23 -3 -57 -19 -77 -36 -54
-45 -173 6 -223 94 -39 67 -49 72 -123 51 -46 -14 -97 -14 -119 -2 -29 16 -47
8 -66 -32 -15 -30 -55 -57 -91 -61 -54 -6 -63 -18 -53 -68 18 -93 -57 -108
-132 -26 -62 67 -112 67 -112 0 0 -20 -13 -36 -28 -36 -16 0 -41 -17 -57 -37
-17 -24 -48 -32 -85 -22 -69 19 -59 68 16 79 30 5 54 26 54 47 0 32 -7 33 -37
8 -63 -52 -129 16 -74 76 37 41 36 46 -10 60 -90 29 -135 126 -80 175 30 28
52 33 62 16 36 -57 89 -27 89 50 0 65 8 75 56 68 44 -6 57 -24 57 -82 0 -58
-11 -74 -44 -68 -32 5 -44 -10 -44 -55 0 -45 15 -64 56 -70 36 -5 59 -28 64
-64 10 -70 81 -74 141 -7 24 26 73 52 108 56 96 11 102 70 8 70 -84 0 -98 26
-38 76 26 22 30 40 12 58 -38 38 -32 130 12 166 30 25 37 24 37 -7 0 -40 167
-159 191 -136 7 7 1 34 -12 59 -14 26 -32 66 -39 91 -8 24 -48 51 -89 59 -42
8 -76 31 -76 50 0 19 -17 34 -37 34 -21 0 -38 11 -38 25 0 14 20 25 44 25 24
0 58 32 76 73 19 43 66 86 112 105 44 17 86 34 93 38 7 4 40 -36 73 -90 65
-106 120 -133 190 -94 37 21 42 17 31 -22 -32 -114 -30 -122 22 -130 80 -12
147 89 96 146 -47 52 -47 74 2 74 44 0 159 -121 160 -169 1 -18 29 -43 64 -56
38 -15 62 -43 62 -75 0 -28 17 -58 37 -66 43 -16 113 46 113 102 0 21 12 39
26 39 47 0 149 -80 149 -117 0 -21 12 -33 27 -28 35 11 34 20 -14 184 -30 104
-55 144 -101 161 -34 13 -62 27 -61 31 24 146 75 256 117 251 35 -3 48 10 46
50 -1 39 15 58 55 63 41 6 56 -4 56 -38 0 -66 49 -107 128 -107 101 0 148 -25
173 -91 25 -65 117 -81 170 -28 22 22 36 23 49 4 10 -15 51 -40 93 -54 41 -15
56 -28 34 -29 -79 -4 -107 -70 -61 -141 63 -97 154 -76 145 33 -7 91 45 132
104 83 34 -28 115 -13 115 23 0 10 -16 32 -35 48 -19 16 -29 50 -22 76 9 38
-9 54 -92 79 -117 35 -180 112 -112 139 23 8 50 0 62 -19 33 -53 57 -9 26 48
-31 59 -35 104 -8 104 36 -1 281 -247 281 -283 0 -20 17 -50 38 -67 20 -17 37
-52 37 -77 0 -27 33 -64 75 -85 94 -49 94 -54 -12 -270 -102 -207 -104 -218
-38 -218 33 0 50 17 50 49 0 68 46 88 97 41 25 -22 58 -40 74 -40 16 0 29 -15
29 -33 0 -19 -25 -33 -56 -31 -40 1 -56 -13 -56 -48 0 -37 14 -49 52 -43 58 8
155 -111 119 -145 -27 -25 -134 15 -134 49 0 31 -67 35 -85 5 -25 -41 222
-282 256 -248 24 24 41 24 81 -1 27 -18 61 -25 74 -17 13 8 24 -2 24 -22 0
-47 96 -80 130 -46 18 18 49 2 97 -47 89 -91 98 -91 98 1 0 59 -17 82 -81 112
-57 27 -99 76 -139 164 -63 136 -55 186 26 161 43 -14 48 -9 31 30 -46 108
-41 203 17 309 105 192 117 208 203 288 85 77 87 77 142 33 31 -26 74 -46 96
-46 55 0 130 -74 130 -129 0 -25 -17 -46 -38 -46 -114 0 -89 -210 36 -302 41
-31 69 -65 62 -77 -25 -41 -114 -20 -203 47 l-89 68 19 -62 c10 -34 36 -76 58
-93 34 -26 34 -31 2 -31 -20 0 -48 10 -61 22 -13 13 -59 30 -101 39 -76 16
-79 13 -95 -86 -20 -129 106 -280 243 -291 44 -3 113 -18 151 -33 164 -62 489
135 569 345 14 36 38 54 66 49 27 -6 60 17 86 60 42 66 46 67 125 34 60 -25
86 -55 98 -112 9 -42 29 -93 46 -113 16 -20 26 -62 22 -94 -8 -53 -13 -49 -64
36 -41 69 -72 94 -119 94 -79 0 -80 -27 -3 -103 63 -64 90 -186 54 -245 -15
-23 -6 -46 24 -68 70 -51 112 -41 112 25 0 45 17 63 69 74 38 7 88 21 112 30
37 15 44 3 44 -73 0 -73 9 -90 50 -90 28 0 50 10 50 21 0 12 27 53 61 92 l61
71 30 -67 c41 -88 48 -86 180 49 100 104 110 124 87 175 -31 68 -51 70 -210
28 -76 -20 -120 -23 -126 -6 -4 13 -31 62 -60 109 l-51 84 -49 -53 c-28 -29
-58 -53 -68 -53 -45 1 -176 171 -184 238 -9 81 -62 93 -240 56 -74 -16 -81
-13 -81 44 0 46 13 62 51 62 51 0 242 132 281 194 57 89 191 -38 151 -143 -22
-59 -20 -92 12 -162 54 -120 117 -121 94 -1 -14 76 -10 87 33 87 88 0 85 50
-8 138 -81 76 -87 91 -59 136 79 126 197 76 284 -118 52 -117 67 -131 135
-131 42 0 76 11 76 25 0 14 -16 25 -36 25 -20 0 -43 23 -52 50 -8 27 -32 50
-53 50 -27 0 -35 22 -29 81 9 97 74 120 148 54 47 -43 50 -43 63 10 16 58 46
71 72 30 32 -52 88 -25 88 44 1 38 2 99 3 137 2 114 -22 156 -69 117 -22 -18
-85 -36 -139 -38 -55 -3 -122 -25 -149 -50 -45 -41 -51 -42 -91 -2 -56 57 16
146 78 95 29 -24 41 -15 65 52 25 73 32 78 60 41 17 -22 58 -45 92 -50 53 -7
62 1 63 67 1 68 8 74 80 68 57 -4 90 10 127 57 104 133 202 12 154 -190 -23
-94 -24 -134 -3 -155 43 -43 34 -96 -27 -161 -49 -51 -51 -67 -25 -139 35 -98
-2 -385 -58 -441 -29 -30 -41 -30 -76 -1 -37 31 -49 26 -97 -35 -39 -48 -74
-67 -116 -61 -33 4 -63 -4 -67 -17 -4 -15 59 -29 142 -33 167 -8 179 -18 236
-197 47 -148 50 -204 17 -258 -21 -32 -29 -30 -62 13 -35 46 -37 42 -38 -74
-1 -111 3 -119 33 -77 33 45 36 45 65 -10 28 -52 27 -93 -5 -373 -7 -62 -81
-120 -105 -82 -29 48 -268 29 -282 -22 -7 -26 -36 -51 -66 -55 -70 -10 -89
-114 -24 -134 90 -28 221 -99 250 -136 42 -54 68 -15 30 46 -46 73 6 179 87
179 61 0 108 -62 67 -87 -25 -15 -16 -268 11 -312 10 -16 -11 -55 -47 -89
-106 -98 -76 -222 50 -208 66 8 73 18 80 117 6 85 16 105 46 94 21 -8 48 -15
59 -15 12 0 29 -23 38 -50 8 -27 26 -50 39 -50 13 0 23 23 23 50 0 64 19 63
73 -3 46 -58 136 -50 161 15 19 49 -149 171 -213 155 -28 -8 -67 -8 -86 0 -55
21 -41 78 21 90 48 10 47 12 -12 15 -73 3 -95 67 -41 121 20 20 18 51 -5 116
-35 98 -9 157 36 83 62 -100 81 -117 154 -131 56 -11 93 -1 138 36 l62 50 -59
42 c-42 30 -51 49 -31 69 15 15 27 42 27 60 0 52 -74 68 -107 24 -17 -22 -61
-47 -98 -56 -88 -21 -127 98 -81 252 l29 100 146 5 c102 4 159 -6 189 -33 61
-55 306 -39 317 21 5 27 -7 44 -31 44 -21 0 -39 11 -39 25 0 35 19 32 105 -19
66 -39 73 -54 62 -136 -13 -102 27 -138 108 -95 72 39 118 30 132 -25 8 -29
34 -50 63 -50 63 0 46 101 -20 118 -23 6 -61 49 -83 96 -23 48 -61 87 -85 88
-25 1 -11 12 30 25 65 19 83 12 144 -54 84 -93 119 -77 119 56 0 96 4 101 63
86 51 -13 62 -7 62 35 0 27 -11 50 -25 50 -34 0 -32 68 2 89 15 9 62 -8 104
-39 68 -51 78 -52 99 -16 27 49 95 55 95 8 0 -18 -39 -52 -87 -74 -49 -23 -88
-59 -88 -80 0 -24 -23 -38 -62 -38 -44 0 -57 -10 -47 -37 17 -44 100 -51 114
-11 5 16 65 32 133 37 69 6 154 17 191 25 49 10 80 -1 120 -44 54 -57 55 -57
92 -7 35 46 36 43 20 -45 -14 -81 -11 -91 25 -78 55 21 164 -81 164 -154 0
-71 145 -255 217 -275 89 -25 124 14 58 64 -69 52 -50 98 34 82 81 -16 216 57
216 117 0 76 -37 81 -198 27 -180 -61 -186 -61 -168 -13 23 60 -30 176 -65
141 -52 -52 -109 -37 -60 17 22 25 41 69 41 98 0 29 11 60 24 68 73 45 -114
213 -237 213 -132 0 -68 97 68 102 57 3 56 3 -5 20 -87 25 -99 103 -16 103 75
0 80 8 102 138 22 135 -23 200 -116 165 -46 -18 -69 -47 -74 -95 -5 -40 -31
-80 -62 -96 -30 -15 -72 -41 -93 -60 -34 -27 -57 -25 -142 18 -56 28 -90 58
-75 67 39 24 32 82 -21 158 -27 37 -55 99 -64 137 -14 63 -10 68 45 54 49 -12
62 -3 76 50 20 82 65 83 65 2 0 -39 14 -63 38 -63 20 0 37 22 37 50 0 53 36
67 63 25 20 -34 112 -32 112 2 0 15 -23 34 -50 41 -28 7 -50 28 -50 47 0 47
-66 45 -84 -2 -21 -55 -55 -47 -103 27 -51 78 2 160 103 160 42 0 59 14 59 50
0 81 63 58 139 -52 39 -56 91 -116 117 -134 47 -33 144 -265 144 -345 0 -25
29 -91 64 -146 49 -78 57 -110 36 -135 -32 -39 16 -138 68 -138 78 0 114 242
45 300 -21 17 -38 45 -38 62 0 17 -23 60 -50 95 -27 35 -50 81 -50 102 0 20
-20 44 -44 52 -32 10 -43 38 -41 107 3 112 65 131 85 27 7 -38 38 -99 70 -138
293 -356 333 -418 317 -503 -17 -92 17 -134 144 -183 48 -18 69 -44 69 -84 0
-97 27 -137 125 -187 52 -26 123 -82 158 -124 35 -42 77 -76 93 -76 16 0 61
-23 101 -52 73 -52 69 -125 -9 -176 -14 -10 -15 -31 -3 -50 11 -19 45 -104 75
-188 57 -165 46 -245 -26 -185 -47 39 -52 35 -73 -54 -20 -84 29 -120 77 -55
42 58 101 49 159 -23 23 -30 66 -82 95 -115 29 -33 53 -73 53 -89 0 -48 103
-128 255 -199 167 -78 281 -198 324 -342 17 -58 67 -139 110 -182 136 -134
181 -297 99 -364 -31 -27 -30 -39 12 -97 26 -37 54 -111 61 -166 8 -55 7 -86
-1 -69 -20 42 -75 39 -149 -10 -48 -31 -97 -37 -203 -26 -131 13 -144 10 -203
-58 -113 -129 -136 -214 -65 -247 33 -15 60 -39 60 -54 0 -55 137 -14 145 43
8 56 130 156 130 107 0 -16 38 -24 94 -19 91 7 94 10 94 108 0 136 54 130 130
-13 83 -157 97 -167 163 -111 84 72 162 111 222 111 48 0 52 9 37 100 -13 84
-9 100 28 100 77 0 157 -122 157 -241 0 -133 39 -141 148 -32 86 86 95 127 37
175 -23 19 -34 57 -28 90 6 32 3 58 -7 58 -10 0 -54 34 -97 76 -84 80 -159 83
-219 8 -24 -31 -30 -30 -43 3 -23 61 -166 50 -166 -13 0 -63 -63 -90 -114 -48
-65 55 -38 210 39 220 130 17 209 232 98 267 -61 20 -98 -5 -41 -27 57 -22 23
-86 -45 -86 -110 0 -137 25 -137 128 0 53 11 97 25 97 14 0 25 28 25 61 0 34
18 71 40 84 90 50 33 156 -114 207 -75 26 -162 48 -194 48 -49 0 -57 13 -57
89 0 81 -5 88 -56 72 -50 -16 -52 -14 -22 23 27 33 28 48 3 79 -43 52 -118 46
-168 -13 -24 -27 -61 -50 -84 -50 -22 0 -66 23 -98 50 -32 27 -67 50 -79 50
-11 0 -28 46 -37 102 -11 71 -37 117 -87 154 -45 34 -63 62 -49 80 12 14 30
91 40 171 10 79 28 150 40 157 12 8 22 54 22 103 l0 90 103 -14 c84 -11 122
-2 199 49 52 34 108 55 123 45 29 -17 175 32 175 60 1 8 10 31 22 49 22 35
116 1 157 -57 10 -13 45 -4 82 20 l66 43 -53 74 c-29 41 -69 74 -88 74 -23 0
-36 26 -36 70 0 44 -23 91 -61 124 l-62 54 -106 -112 c-59 -62 -125 -109 -148
-105 -22 3 -58 -8 -80 -27 -58 -48 -129 -26 -139 42 -8 60 -67 63 -238 13 -40
-12 -44 -4 -29 64 15 66 8 80 -41 99 -74 28 -95 16 -78 -47 7 -28 -1 -67 -18
-87 -17 -21 -24 -64 -15 -99 24 -95 -59 -129 -137 -57 -32 31 -77 67 -99 81
-184 115 -229 149 -252 193 -41 77 22 129 114 94 81 -30 139 2 139 78 0 37 19
47 88 47 61 0 87 11 87 38 0 20 -18 37 -40 37 -40 0 -38 47 6 162 11 28 -1 45
-38 55 -62 16 -69 47 -15 67 24 9 37 48 37 113 0 55 17 116 38 137 20 21 37
47 37 58 0 26 147 143 209 166 34 13 43 33 32 74 -9 30 -15 70 -16 87 0 37
-115 42 -137 6 -9 -14 -44 -25 -79 -25 -56 0 -61 -8 -47 -71 12 -58 4 -75 -48
-99 -55 -25 -64 -45 -64 -140 0 -148 -37 -243 -87 -224 -21 8 -38 2 -38 -13 0
-16 10 -28 23 -28 35 0 55 -129 32 -212 -12 -42 -37 -75 -57 -75 -22 0 -37 28
-39 75 -3 41 -5 87 -7 102 -1 15 -30 40 -64 55 -71 33 -83 121 -36 277 34 114
-5 236 -71 223 -24 -4 -47 -33 -51 -64 -10 -64 -43 -74 -64 -18 -8 21 -43 49
-78 62 -35 13 -63 43 -63 66 0 56 -72 134 -124 134 -23 0 -80 34 -126 75 -46
41 -97 75 -113 75 -16 0 -28 25 -26 56 2 62 -103 69 -143 10 -13 -20 -27 -15
-45 15 -14 24 -38 44 -54 44 -15 0 -47 18 -72 40 -24 22 -86 42 -139 45 -125
6 -190 45 -179 105 9 50 121 84 121 37 0 -15 17 -27 38 -27 20 0 37 13 37 29
0 50 -80 121 -137 121 -38 0 -66 28 -96 96 -53 122 -53 146 2 100 86 -72 178
-98 231 -65 71 44 142 -27 102 -101 -15 -29 -27 -81 -27 -117 0 -60 8 -65 81
-58 76 7 83 1 97 -80 8 -48 17 -74 19 -58 2 16 39 37 84 47 84 18 244 151 244
202 0 18 29 29 69 26 52 -3 70 8 76 48 7 52 -16 67 -180 121 -90 29 -2 67 138
59 131 -7 135 -9 135 -82 0 -59 12 -77 55 -83 71 -11 102 -103 48 -143 -45
-33 -55 -87 -17 -87 13 0 35 20 48 44 22 39 27 36 51 -25 22 -59 40 -69 124
-69 64 0 103 -13 112 -37 19 -50 91 -49 91 0 0 21 -24 48 -54 59 -36 13 -45
26 -25 38 16 10 29 44 29 76 0 67 42 89 166 89 101 0 114 -81 16 -95 -66 -10
-103 -102 -53 -133 56 -36 196 -26 212 16 18 46 109 49 109 3 0 -18 -23 -54
-50 -78 -71 -65 -62 -131 25 -175 45 -24 75 -59 75 -89 0 -36 22 -55 76 -65
41 -9 81 -25 88 -36 21 -34 -16 -145 -51 -153 -45 -10 -238 -271 -238 -321 0
-22 -17 -61 -37 -88 -52 -69 -46 -106 18 -116 44 -6 56 -22 52 -75 -3 -47 10
-72 42 -82 25 -9 69 -54 97 -102 54 -91 203 -129 203 -52 0 19 7 70 16 113
l15 78 -129 0 c-140 0 -195 51 -116 108 37 27 38 41 11 101 -26 58 -26 73 4
92 75 47 143 27 170 -51 31 -87 66 -96 104 -25 22 41 37 46 76 24 63 -33 63
-75 -1 -92 -27 -7 -50 -23 -50 -36 0 -13 21 -11 48 3 71 38 102 32 102 -19 0
-25 15 -67 34 -92 33 -45 36 -44 71 22 l36 69 45 -100 c46 -103 38 -154 -25
-154 -42 0 -48 -40 -10 -63 80 -50 290 97 263 183 -10 30 -32 55 -50 55 -84 0
-92 70 -15 124 61 44 76 73 76 145 0 71 7 84 30 61 16 -16 54 -30 83 -30 82 0
133 -111 79 -170 -53 -58 -53 -126 -3 -182 42 -46 14 -148 -40 -148 -13 0 -57
-67 -96 -148 l-72 -148 74 -80 c49 -54 70 -101 65 -144 -8 -67 90 -205 144
-205 15 0 43 45 61 101 31 92 29 104 -16 146 -27 25 -64 112 -82 192 l-33 146
78 70 c43 38 78 86 78 106 0 48 127 175 147 146 79 -115 104 -137 139 -124 47
18 52 67 8 68 -17 0 -59 23 -92 51 -57 47 -59 57 -29 138 57 159 -97 280 -157
123 -32 -83 -94 -42 -86 56 6 77 18 95 67 102 52 7 57 18 45 92 -9 55 -1 94
21 112 47 40 73 174 40 207 -16 16 -28 51 -29 79 -2 82 -167 176 -241 137 -32
-17 -58 -45 -58 -62 0 -90 38 -192 91 -245 61 -61 54 -160 -14 -203 -15 -9
-27 -38 -27 -64 0 -63 -21 -62 -90 3 -55 52 -160 35 -160 -27 0 -13 -23 -36
-51 -51 -79 -42 -193 90 -180 206 7 57 -3 96 -29 118 -65 54 -47 109 71 220
76 72 117 134 128 195 10 50 33 97 52 104 19 7 34 27 34 43 0 69 68 127 108
94 44 -37 12 -170 -53 -218 -23 -18 -30 -47 -19 -82 23 -71 53 -68 104 9 60
91 202 154 263 116 39 -24 51 -23 63 8 27 71 -10 116 -81 98 -62 -16 -65 -13
-49 59 15 66 9 77 -47 91 -73 18 -88 100 -24 125 40 15 40 73 -1 168 -29 69
105 87 172 23 30 -28 74 -51 97 -51 67 0 49 83 -31 136 -77 52 -152 183 -152
266 0 27 -25 83 -55 124 l-55 74 54 112 c48 99 51 118 20 177 -26 50 -28 82
-9 125 27 58 9 224 -27 246 -49 31 -132 -25 -190 -129 -71 -126 -64 -199 19
-211 52 -7 55 -19 51 -203 -3 -139 -16 -209 -44 -240 -49 -54 -52 -177 -4
-177 19 0 41 -17 49 -37 17 -46 -5 -113 -38 -113 -14 0 -15 -16 0 -41 14 -26
11 -86 -10 -165 -18 -68 -27 -138 -20 -156 15 -39 -30 -73 -67 -50 -18 11 -18
26 0 49 45 54 -40 338 -101 338 -49 0 -73 -96 -35 -134 44 -45 27 -221 -29
-303 -19 -27 -34 -64 -34 -83 0 -19 -38 -92 -84 -163 -47 -71 -96 -152 -111
-179 -26 -49 -27 -49 -45 -3 -10 25 -5 67 11 93 38 61 37 64 -21 79 -55 15
-67 91 -21 137 23 23 22 53 -4 131 -27 80 -27 112 -2 158 53 99 26 250 -48
267 -45 10 -65 34 -70 82 -6 48 -23 68 -57 68 -55 0 -69 -190 -23 -311 24 -64
24 -65 -46 -29 -39 20 -85 54 -102 76 -45 53 -77 26 -77 -65 0 -116 -61 -73
-70 50 -7 86 -18 106 -69 119 -43 11 -61 33 -61 75 0 50 -13 60 -75 60 -73 0
-74 1 -59 113 11 76 7 112 -13 112 -48 0 -31 41 49 119 69 68 73 81 44 128
-44 70 -91 67 -125 -8 -38 -83 -121 -44 -120 56 1 130 202 209 219 86 5 -33
26 -56 51 -56 70 0 229 -155 229 -223 0 -109 148 -220 210 -158 33 33 212 24
226 -11 17 -46 82 -41 110 8 14 25 39 36 63 26 33 -12 41 2 41 71 0 48 11 87
24 87 13 0 36 46 51 101 25 93 22 108 -36 177 -35 42 -64 86 -64 99 0 45 -99
22 -126 -28 -44 -84 -154 -57 -183 45 -13 46 -40 81 -61 81 -70 0 -255 218
-255 300 0 49 -13 75 -37 75 -49 0 -96 -94 -73 -146 24 -52 37 -120 43 -219 2
-42 19 -95 38 -117 18 -23 29 -59 25 -82 -10 -49 -157 73 -158 131 0 19 -29
49 -63 66 -34 17 -66 56 -70 86 -10 64 -50 74 -71 19 -8 -21 -41 -38 -74 -38
-37 0 -60 -15 -60 -37 0 -21 16 -38 36 -38 66 0 68 -49 3 -79 -37 -17 -64 -50
-64 -77 0 -28 -22 -54 -52 -62 -43 -11 -51 -29 -42 -92 15 -104 70 -315 99
-378 14 -33 13 -77 -4 -121 l-26 -70 -98 102 c-111 115 -149 124 -216 50 -49
-54 -48 -57 70 -125 35 -20 41 -45 28 -124 -18 -116 38 -136 146 -50 36 28 83
43 112 35 35 -9 63 7 92 52 56 85 83 81 144 -23 29 -49 68 -88 87 -88 53 0 42
-77 -19 -142 -77 -82 -93 -73 -78 42 l14 100 -116 0 c-80 0 -116 -10 -116 -33
0 -19 -29 -47 -64 -63 -57 -26 -64 -42 -58 -141 9 -143 -15 -165 -71 -67 -24
43 -60 79 -79 79 -25 0 -29 22 -17 86 21 113 -40 264 -106 264 -26 0 -100 46
-165 103 -95 84 -123 97 -153 72 -42 -35 -49 -115 -12 -137 51 -32 27 -138
-36 -162 -60 -23 -104 -140 -85 -226 12 -51 -89 -61 -128 -14 -18 22 -45 39
-60 39 -16 0 -58 36 -95 80 -51 62 -89 83 -162 87 -53 4 -140 14 -193 23 -66
11 -103 6 -116 -15 -31 -49 -75 -4 -75 76 0 50 -19 86 -62 114 -35 22 -63 63
-63 90 0 28 -19 82 -42 120 -71 121 3 310 126 320 50 5 91 17 91 29 0 51 76
42 147 -17 90 -74 99 -107 28 -107 -47 0 -61 -24 -52 -92 2 -16 -8 -36 -22
-45 -35 -21 -33 -88 1 -88 71 0 173 104 159 161 -12 46 -3 61 45 73 76 19 235
-24 252 -68 7 -19 48 -41 90 -49 52 -11 86 -37 102 -79 30 -80 83 -80 135 0
29 44 64 62 118 62 72 0 77 5 61 69 -10 38 -19 102 -22 144 -3 51 -22 82 -61
99 -57 25 -85 188 -33 188 79 0 147 -50 135 -99 -16 -60 6 -66 58 -13 21 20
64 37 97 37 76 0 106 49 53 88 -58 42 -51 57 27 67 64 7 82 29 157 195 9 21
47 52 83 70 42 20 74 65 91 125 34 121 33 130 -11 130 -24 0 -38 -24 -38 -62
0 -70 -8 -74 -76 -37 -30 15 -65 17 -92 2 -134 -68 -183 -83 -221 -68 -23 9
-57 4 -75 -11 -25 -21 -41 -13 -68 31 -19 31 -54 88 -76 125 -68 110 -53 198
47 293 79 75 96 81 151 55 35 -15 89 -22 121 -14 43 11 60 3 70 -35 9 -35 43
-56 110 -68 53 -10 125 -46 160 -80 35 -35 134 -84 219 -110 l154 -48 78 82
77 83 -15 -70 c-22 -100 48 -119 126 -35 33 36 60 77 60 91 0 33 117 34 138 1
30 -49 129 -24 200 50 80 84 116 92 162 38 17 -21 47 -38 66 -38 47 0 44 135
-3 175 -21 17 -38 53 -38 80 0 62 -60 45 -70 -20 -20 -120 -32 -124 -105 -35
-90 109 -156 78 -107 -51 24 -64 21 -78 -18 -99 -59 -32 -125 -7 -125 47 0 23
-19 69 -42 101 -40 58 -39 60 10 47 40 -11 48 -4 38 33 -6 26 1 62 16 81 15
18 20 41 11 50 -25 25 -133 19 -133 -7 0 -13 -22 -31 -50 -39 -60 -20 -92
-125 -52 -174 34 -40 20 -52 -91 -75 -44 -10 -109 -41 -145 -69 -85 -67 -184
-21 -387 182 -137 137 -144 141 -367 181 -125 23 -234 42 -242 42 -8 0 -54
-35 -103 -78 -73 -64 -88 -94 -88 -176 0 -55 -13 -124 -29 -153 -43 -80 -221
-302 -261 -325 -19 -11 -35 -32 -35 -46 0 -14 -14 -41 -31 -60 -17 -18 -64
-79 -105 -135 -139 -192 -324 -196 -274 -6 19 69 17 119 -5 181 -35 96 -44
296 -16 337 10 15 38 34 62 43 50 18 59 106 15 133 -16 10 -48 -6 -73 -36 -45
-55 -98 -72 -98 -31 0 13 -30 58 -66 101 -36 43 -91 165 -122 271 -36 124 -97
253 -172 363 -64 94 -123 206 -131 250 -14 74 -59 189 -152 384 -21 43 -30 91
-20 107 10 16 -30 71 -91 128 -60 55 -137 127 -171 159 -34 32 -128 145 -208
250 -81 106 -165 199 -188 207 -56 20 -227 151 -304 232 -34 36 -121 109 -192
162 -72 53 -143 127 -159 165 -15 38 -126 157 -245 265 -118 107 -260 240
-315 295 l-99 100 66 23 c49 18 70 47 82 113 12 65 48 116 131 185 112 94 117
96 266 80 84 -9 223 -45 309 -81 131 -54 167 -60 220 -36 88 40 168 36 265
-13 46 -23 113 -57 150 -75 36 -18 89 -33 118 -33 78 0 404 -145 435 -194 11
-17 32 -31 47 -31 14 0 76 -34 137 -75 61 -41 125 -75 142 -76 16 0 51 -17 78
-37 27 -20 91 -37 144 -37 52 0 95 -10 95 -22 0 -12 34 -36 75 -53 41 -17 75
-42 75 -56 0 -15 36 -20 87 -11 83 13 159 -30 92 -53 -16 -5 -48 -28 -70 -50
-32 -32 -85 -39 -256 -34 -204 6 -219 10 -280 80 -69 80 -119 92 -170 43 -25
-25 -36 -23 -56 12 -16 28 -55 44 -109 44 -47 0 -92 11 -100 25 -9 14 -44 25
-78 25 -44 0 -69 19 -87 69 -41 107 -124 181 -203 181 -41 0 -131 41 -217 100
-158 108 -203 122 -203 63 0 -21 11 -38 25 -38 14 0 25 -22 25 -50 0 -66 -91
-67 -112 -2 -20 64 -198 157 -233 122 -41 -41 14 -166 78 -175 43 -6 56 -27
62 -103 9 -103 68 -118 68 -17 0 32 14 63 31 69 20 6 31 -15 31 -59 0 -38 24
-95 54 -127 52 -55 52 -59 10 -106 -62 -69 -31 -99 86 -84 83 11 100 6 100
-29 0 -24 14 -38 31 -32 17 6 29 35 26 65 -8 63 20 66 119 15 88 -45 94 -92
20 -142 -34 -22 -49 -51 -40 -75 21 -54 136 -29 152 32 7 28 34 48 65 48 67 0
67 -40 -1 -77 -44 -23 -50 -43 -37 -124 8 -52 3 -126 -11 -164 -32 -83 5 -117
106 -99 38 7 75 1 83 -12 45 -73 80 -17 76 124 -3 124 -13 156 -64 197 -53 43
-57 57 -32 112 67 147 432 52 432 -112 0 -58 17 -78 100 -113 91 -40 100 -52
100 -138 0 -89 -49 -131 -85 -72 -8 12 -41 16 -73 10 -45 -9 -63 1 -74 41 -18
71 -54 65 -91 -15 -27 -60 -24 -72 22 -107 38 -29 45 -47 25 -67 -20 -20 -20
-43 -3 -75 14 -25 32 -68 40 -94 14 -44 18 -45 63 -4 39 36 43 55 21 117 -32
91 -30 92 126 134 106 27 132 27 155 0 32 -39 -37 -87 -124 -87 -33 0 -56 -21
-66 -61 -22 -84 7 -121 81 -103 54 14 58 11 34 -35 -37 -68 -105 -101 -209
-101 -81 0 -87 -6 -97 -91 -9 -72 -1 -94 35 -103 25 -6 45 -25 45 -42 0 -16
34 -55 75 -85 93 -69 96 -143 13 -293 -59 -106 -60 -114 -20 -161 24 -28 69
-50 101 -50 44 0 61 -18 72 -76 19 -91 43 -108 123 -88 65 16 85 89 25 89 -20
0 -52 22 -71 50 -19 27 -79 69 -133 93 l-97 43 78 9 c59 6 83 23 94 68 9 33
46 75 84 93 146 72 42 251 -131 228 -103 -14 -106 -13 -122 66 -29 147 -27
150 122 150 105 0 137 -9 137 -37 0 -24 20 -35 56 -31 44 4 67 -17 106 -101
52 -111 139 -145 181 -70 26 48 232 24 232 -27 0 -20 35 -42 77 -51 95 -19
111 -56 78 -185 -16 -62 -17 -131 -4 -178 40 -137 -54 -220 -150 -133 -68 61
-366 18 -356 -53 5 -36 -9 -57 -44 -66 -67 -18 -65 -78 5 -124 79 -51 251 -78
463 -72 188 5 190 4 189 -111 -1 -14 30 -22 68 -16 37 5 76 -3 85 -18 22 -35
106 -35 129 1 9 16 -1 39 -24 52 -23 12 -41 36 -42 52 -1 48 -118 168 -163
168 -27 0 -36 13 -26 39 8 22 -2 57 -23 77 -89 89 20 359 145 359 66 0 69 -72
5 -136 -69 -69 -81 -139 -24 -139 21 0 88 -24 150 -53 88 -41 120 -46 148 -23
19 16 55 26 80 21 31 -5 51 17 70 80 15 48 36 102 48 121 14 22 0 56 -44 101
-49 52 -65 94 -65 174 0 58 -17 146 -38 195 -46 113 -47 161 0 100 22 -30 54
-43 86 -34 28 7 63 -3 79 -22 16 -19 49 -35 74 -35 33 0 49 -27 62 -106 17
-107 101 -229 141 -204 38 24 22 185 -29 284 -56 112 -136 176 -217 176 -105
0 -183 58 -260 195 -74 131 -72 178 6 180 36 0 71 157 43 191 -50 60 -147 43
-147 -26 0 -33 -19 -67 -42 -76 -42 -16 -82 22 -83 80 0 59 -74 31 -91 -35
-12 -48 -4 -76 25 -97 22 -16 41 -55 41 -86 0 -31 23 -84 50 -119 27 -35 50
-87 50 -115 0 -48 34 -171 77 -279 72 -182 82 -235 49 -274 -47 -57 -115 -48
-161 24 -23 34 -57 62 -76 62 -22 0 -30 18 -21 51 9 35 30 49 66 44 82 -11 88
96 8 133 -52 23 -70 19 -115 -26 -64 -64 -115 -47 -70 24 16 27 39 49 49 49
10 0 19 11 19 25 0 14 -17 25 -37 25 -21 0 -38 -11 -38 -25 0 -14 -23 -25 -50
-25 -27 0 -50 11 -50 24 0 13 23 36 50 51 61 33 64 71 7 93 -63 24 -199 166
-218 228 -38 118 -87 59 -94 -115 l-7 -168 -138 0 c-130 0 -137 3 -137 62 0
54 12 64 96 70 85 7 94 15 81 63 -8 30 -14 81 -15 112 0 95 -159 69 -171 -28
-8 -74 -46 -79 -89 -11 -28 45 40 144 100 144 49 0 68 48 34 89 -44 52 -72 45
-99 -26 -36 -95 -75 -76 -75 36 0 54 -12 105 -26 114 -15 9 -25 41 -22 71 3
29 -7 85 -23 124 -36 86 -20 117 59 117 95 0 200 -106 200 -204 0 -63 11 -85
50 -92 27 -5 79 -42 114 -82 74 -82 136 -91 204 -29 46 41 50 40 94 -17 50
-67 125 -39 125 47 0 78 -176 252 -255 252 -41 0 -78 16 -86 38 -8 22 -54 55
-101 75 -77 32 -85 45 -78 118 9 97 90 124 162 52 42 -42 52 -42 126 -8 126
59 138 150 20 150 -148 0 -376 80 -434 153 -70 88 -194 158 -217 122 -23 -38
-108 -30 -196 19 -43 24 -82 45 -86 47 -5 2 6 28 25 58 29 48 25 60 -33 111
-37 32 -79 81 -95 110 -15 29 -68 72 -118 96 -58 27 -105 75 -131 132 -47 101
-157 227 -200 227 -56 0 -31 -188 34 -265 35 -40 63 -80 63 -88 0 -9 41 -24
90 -33 53 -10 95 -35 102 -59 7 -24 56 -73 110 -111 102 -71 126 -119 60 -119
-42 0 -159 66 -199 112 -52 58 -358 188 -444 188 -56 0 -94 14 -103 38 -8 20
-41 37 -74 37 -60 0 -320 126 -394 190 -22 19 -62 35 -89 35 -28 0 -77 28
-109 63 -32 34 -69 62 -82 62 -13 0 -118 97 -233 216 -199 206 -270 332 -226
403 19 32 -45 118 -137 183 l-78 55 18 -78 c21 -96 4 -97 -122 -9 -142 97
-143 130 -5 130 121 0 135 14 84 81 -45 59 -97 61 -175 9 -107 -71 -288 -38
-299 55 -6 58 -24 71 -120 92 -62 14 -163 51 -226 81 -62 31 -152 62 -200 70
-47 8 -129 27 -181 43 -115 34 -157 3 -97 -71 29 -35 84 -57 170 -67 130 -15
405 -145 441 -208 11 -19 54 -35 94 -35 71 0 174 -74 174 -125 0 -14 24 -25
54 -25 30 0 91 -28 136 -62 45 -35 109 -63 143 -63 72 0 131 -114 108 -207
-15 -60 28 -118 163 -218 93 -70 203 -264 183 -326 -24 -76 -89 -99 -210 -72
-59 14 -126 20 -149 14 -22 -6 -73 -19 -113 -28 l-72 -16 55 -38 c81 -57 61
-156 -45 -215 -60 -33 -93 -39 -112 -20 -14 14 -57 26 -94 26 -92 0 -286 86
-305 135 -9 22 -35 40 -60 41 -24 0 -89 22 -144 49 -55 27 -115 49 -132 49
-17 1 -90 29 -161 64 -87 42 -138 54 -155 37 -31 -31 -132 -33 -151 -2 -8 12
-59 30 -114 39 -118 20 -278 94 -324 149 -24 29 -56 36 -118 24 -53 -10 -125
-1 -190 23 -58 21 -143 46 -188 55 -76 15 -82 23 -67 89 9 43 6 73 -9 73 -14
0 -26 20 -26 44 0 24 -8 74 -17 112 -16 65 -11 69 67 72 54 2 66 7 35 15 -28
7 -70 30 -95 51 -34 31 -51 33 -74 10 -64 -64 -244 40 -244 143 0 48 -86 136
-158 162 -56 19 -32 66 34 66 27 0 49 11 49 25 0 29 -113 61 -146 40 -13 -8
-37 2 -54 23 -40 47 -127 47 -189 0 -77 -58 -154 -44 -235 40 -48 50 -89 72
-115 62 -23 -8 -68 7 -104 35 -83 65 -318 71 -353 9 -22 -40 -57 -39 -160 3
-68 28 -56 -67 18 -136 69 -65 138 -39 138 52 0 64 125 63 180 -2 23 -26 85
-55 137 -63 269 -42 293 -50 307 -106 9 -38 24 -49 46 -35 56 34 161 1 293
-94 68 -49 128 -96 131 -104 22 -47 234 -249 262 -249 52 0 113 -87 113 -161
0 -123 -195 -144 -348 -36 -50 35 -114 47 -262 50 -108 1 -225 17 -259 34 -34
17 -122 46 -196 65 -77 19 -143 52 -157 79 -16 30 -47 43 -90 38 -53 -5 -81
16 -146 106 -96 133 -260 300 -297 301 -15 1 -82 51 -150 112 -116 104 -120
111 -68 130 51 19 52 24 15 76 -45 65 -126 71 -227 19 -79 -41 -335 -51 -373
-15 -62 61 -296 74 -408 23 -59 -27 -149 -47 -200 -44 -162 9 -177 0 -306
-177 -87 -118 -145 -175 -179 -175 -29 0 -69 -15 -91 -34 -22 -19 -109 -40
-194 -48 -192 -16 -290 54 -237 171 26 57 20 75 -50 162 -88 110 -109 117
-175 58 -38 -35 -56 -36 -121 -9 -116 48 -118 12 -2 -54 113 -65 122 -83 57
-118 -48 -26 -274 10 -316 50 -13 12 -59 22 -101 22 -43 0 -90 12 -105 27 -19
19 -55 18 -127 -3 -126 -38 -314 14 -326 91 -17 106 -24 111 -98 80 -128 -55
-136 -69 -82 -145 28 -39 50 -81 50 -95 0 -31 -275 -55 -327 -28 -53 27 -98
-19 -98 -99 0 -71 -40 -45 -54 35 -5 27 -26 50 -46 50 -30 0 -37 -37 -37 -175
0 -159 -5 -175 -50 -175 -68 0 -91 307 -27 343 123 69 -17 163 -176 118 -123
-34 -142 -85 -47 -129 98 -45 79 -99 -32 -90 -74 6 -93 18 -93 58 0 36 -20 52
-71 58 -38 4 -76 23 -83 42 -50 130 -217 122 -246 -13 -21 -91 -97 -67 -124
39 -12 50 -26 61 -59 47 -76 -34 -309 -29 -323 7 -16 42 -80 41 -192 -6 -82
-34 -98 -34 -167 2 -84 43 -176 40 -191 -6 -6 -18 22 -33 71 -38 89 -8 122
-55 57 -80 -57 -22 -254 77 -273 137 -37 115 -237 132 -237 20 0 -28 -18 -47
-44 -47 -90 -1 -120 -41 -82 -110 46 -86 1 -139 -112 -132 -110 8 -123 24 -62
79 27 25 50 67 50 92 0 25 11 46 25 46 14 0 25 28 25 63 0 73 4 73 -97 22 -59
-29 -76 -52 -65 -85 17 -57 -12 -77 -85 -58 -52 14 -53 17 -13 61 41 45 39 47
-71 47 -73 0 -134 16 -170 46 -56 45 -58 45 -123 -28 l-66 -74 -86 44 c-48 25
-139 48 -204 51 -117 6 -117 6 -92 -59 14 -36 38 -81 54 -101 23 -27 11 -49
-58 -106 -115 -96 -136 -82 -137 88 -1 187 -11 192 -417 181 -330 -9 -333 -9
-341 -69 -5 -33 -25 -69 -44 -80 -40 -24 -47 -108 -10 -130 48 -30 25 -55 -51
-58 -90 -2 -126 57 -63 103 52 38 42 234 -13 269 -57 36 -166 27 -182 -16 -11
-27 -44 -36 -115 -32 -173 10 -175 -49 -3 -72 114 -15 131 -46 46 -83 -31 -13
-75 -37 -97 -53 -59 -42 -115 -10 -134 77 -13 60 -30 77 -77 77 -43 0 -64 18
-76 63 -11 44 -32 62 -75 62 -47 0 -60 -13 -60 -62 0 -35 -11 -65 -25 -67 -14
-2 -37 -5 -51 -6 -14 -1 -40 26 -57 60 -71 145 -341 64 -342 -102 0 -103 -70
-151 -162 -111 -77 33 -64 50 50 68 64 10 69 140 7 179 -47 30 -170 -61 -170
-126 0 -18 -22 -33 -50 -33 -28 0 -50 15 -50 33 0 34 -163 117 -231 117 -42 0
-69 -50 -69 -127 0 -31 17 -48 49 -48 62 0 90 -46 52 -83 -23 -23 -40 -16 -76
27 -34 41 -72 56 -148 56 -120 0 -145 65 -33 89 117 26 131 33 131 70 0 77
-64 94 -175 44 -97 -44 -115 -45 -213 -11 -59 20 -161 32 -228 28 l-121 -7 7
-94 c5 -61 -3 -94 -23 -94 -39 0 -122 75 -122 110 0 28 -135 115 -177 115 -38
0 -26 -101 14 -116 21 -8 31 -24 24 -37 -22 -35 -90 -26 -140 19 -43 39 -49
39 -92 0 -68 -62 -124 -51 -134 25 -12 102 -113 129 -150 40 -27 -64 -29 -65
-38 -14 -15 85 -69 117 -117 70 -57 -57 -51 -155 10 -174 79 -26 70 -163 -11
-163 -34 0 -68 11 -76 25 -25 40 -58 29 -76 -25 -24 -78 -69 -29 -55 59 27
164 -185 304 -339 225 -54 -28 -91 -31 -151 -12 -167 52 -282 58 -316 17 -18
-21 -58 -39 -90 -39 -69 0 -106 -47 -59 -76 20 -13 61 -4 103 20 79 47 139 16
110 -58 -12 -32 -34 -38 -90 -27 -58 11 -80 4 -101 -35 -21 -40 -35 -45 -76
-23 -27 15 -43 36 -36 49 27 43 -43 55 -152 24 -127 -35 -152 -61 -109 -112
36 -44 10 -170 -33 -156 -17 6 -34 46 -38 90 -7 64 -19 79 -66 79 -65 0 -89
-42 -89 -154 0 -64 -7 -72 -52 -58 -44 14 -51 7 -44 -42 7 -49 21 -57 87 -51
95 9 134 -34 53 -59 -31 -9 -92 -44 -136 -76 -44 -33 -96 -60 -116 -60 -64 0
-98 -203 -41 -238 15 -10 20 -48 11 -88 -8 -39 -2 -96 14 -126 26 -48 22 -62
-24 -97 l-55 -41 52 -46 c74 -67 64 -129 -24 -160 -101 -35 -113 -81 -52 -182
67 -109 67 -212 2 -247 -55 -30 -72 -193 -24 -241 18 -18 14 -36 -12 -58 -71
-59 -45 -143 86 -274 128 -128 163 -232 88 -261 -27 -10 -38 -51 -38 -138 0
-159 -16 -197 -100 -241 -70 -35 -70 -36 -56 -248 9 -154 4 -224 -19 -252 -57
-68 4 -92 125 -49 139 48 160 27 137 -140 l-18 -132 -45 60 c-39 52 -52 56
-109 30 -71 -33 -88 -117 -27 -140 27 -11 37 -54 37 -165 l0 -151 87 0 c60 0
94 -15 112 -48 39 -73 35 -77 -74 -77 -89 0 -103 -9 -133 -81 -36 -87 -40
-512 -5 -568 11 -18 8 -39 -6 -48 -53 -34 -104 -565 -58 -611 15 -15 27 -83
27 -152 0 -100 13 -138 65 -192 62 -65 63 -70 25 -144 -22 -42 -51 -83 -65
-91 -14 -9 -25 -81 -25 -160 0 -87 -14 -162 -37 -192 -55 -73 -46 -103 34
-119 66 -13 74 -26 82 -130 10 -121 -38 -208 -69 -127 -21 55 -60 51 -60 -7 0
-47 247 -278 298 -278 37 0 35 -12 -23 -125 -27 -54 -50 -114 -50 -133 0 -20
-25 -53 -56 -73 -48 -32 -51 -43 -23 -77 38 -45 19 -92 -37 -92 -29 0 -34 -17
-22 -73 12 -56 3 -87 -38 -128 l-54 -54 90 -74 c98 -82 131 -212 46 -186 -119
37 -115 -109 5 -209 54 -45 49 -101 -10 -101 -66 0 -85 -40 -38 -80 98 -82
114 -104 102 -134 -7 -18 -20 -98 -29 -178 -14 -128 -10 -151 36 -193 95 -85
97 -211 7 -282 -76 -60 -78 -63 -41 -135 21 -40 55 -73 75 -73 22 0 37 -24 37
-60 0 -34 7 -79 15 -100 9 -24 2 -40 -17 -40 -49 0 -148 103 -148 153 0 46
-82 86 -125 60 -42 -26 -28 -139 25 -206 61 -78 63 -129 7 -171 -39 -28 -34
-33 47 -49 73 -13 93 -30 102 -83 6 -37 16 -83 22 -104 6 -26 -10 -37 -53 -37
-46 0 -65 15 -70 56 -6 37 -26 56 -58 56 -43 0 -49 -14 -42 -106 7 -97 19
-114 133 -188 68 -44 138 -92 155 -106 43 -36 96 -31 132 13 46 55 83 45 66
-19 -9 -36 3 -74 38 -111 45 -47 50 -79 42 -231 -9 -165 -16 -183 -105 -274
-123 -126 -115 -182 34 -239 21 -7 54 -24 75 -37 79 -49 145 -58 375 -53 299
6 363 38 339 172 -32 175 -1 482 51 511 49 28 44 52 -29 161 -81 118 -123 143
-248 144 -113 1 -150 72 -77 146 51 51 49 75 -12 130 -63 58 -56 150 12 150
36 0 54 23 66 83 10 46 47 114 83 151 79 83 80 100 12 216 -42 70 -47 97 -24
120 37 36 152 -83 152 -156 0 -25 17 -60 37 -77 20 -16 36 -54 34 -84 -1 -29
15 -94 37 -143 64 -146 107 -601 71 -744 -18 -69 -24 -164 -14 -225 13 -81 7
-116 -26 -152 -40 -45 -40 -49 0 -71 48 -27 51 -76 31 -566 -11 -279 -19 -327
-60 -357 -45 -34 -45 -35 6 -48 93 -25 107 -543 16 -578 -98 -38 -113 63 -104
693 3 202 -92 400 -191 400 -33 0 -66 -12 -75 -26 -10 -16 -60 -20 -130 -9
-122 18 -131 -1 -70 -146 13 -31 7 -44 -22 -44 -22 0 -40 15 -40 34 0 18 -22
54 -50 79 -27 24 -50 71 -50 103 0 41 -14 59 -48 59 -57 0 -96 -167 -57 -242
13 -25 30 -192 36 -370 l13 -325 -85 -99 c-91 -106 -81 -138 46 -139 131 0
207 -100 208 -273 0 -173 -25 -202 -45 -50 -8 56 -20 108 -27 116 -22 21 -134
-15 -177 -57 -50 -51 -93 -24 -75 47 10 42 -5 70 -63 112 -67 50 -72 62 -45
109 25 42 25 55 0 64 -47 17 -37 52 19 70 35 11 50 37 50 89 0 69 -6 73 -100
73 -108 0 -130 32 -50 75 34 18 65 19 96 2 32 -17 55 -16 75 4 44 44 35 87
-21 101 -42 11 -50 34 -50 142 0 71 -12 152 -27 181 -23 41 -17 66 29 128 33
45 58 115 59 166 1 49 10 102 21 118 11 18 0 35 -32 45 -27 9 -50 27 -50 40 0
13 -28 35 -62 48 -67 25 -83 95 -33 145 23 23 23 37 0 60 -44 44 -82 -4 -105
-132 -15 -79 -11 -116 15 -142 48 -47 71 -150 42 -188 -39 -51 -9 -264 39
-275 32 -8 27 -16 -21 -36 -51 -21 -71 -17 -109 23 -36 38 -53 42 -75 19 -21
-23 -21 -33 3 -42 48 -17 231 -187 231 -214 0 -14 -54 -17 -135 -7 -168 21
-206 -18 -101 -102 55 -44 65 -65 44 -86 -22 -22 -22 -41 -1 -75 22 -35 21
-67 -3 -134 -28 -76 -26 -98 10 -160 41 -70 41 -75 -17 -153 -89 -120 -78
-411 19 -496 l65 -58 70 66 c58 56 77 62 121 38 114 -60 39 -130 -145 -136
-47 -1 -90 -15 -95 -31 -9 -27 135 -91 184 -82 56 10 109 -5 109 -30 0 -18
-30 -24 -85 -15 -100 16 -229 -90 -201 -165 10 -26 1 -47 -22 -56 -62 -24 -68
-79 -26 -230 64 -230 67 -268 24 -304 -60 -50 -49 -140 23 -187 43 -29 62 -64
62 -116 0 -49 13 -74 38 -74 20 0 37 -11 37 -25 0 -37 -48 -30 -92 14 -50 50
-90 35 -118 -44 -31 -88 -4 -145 69 -145 86 0 104 -70 40 -156 -65 -88 -42
-124 125 -204 78 -37 114 -69 114 -103 0 -27 9 -64 20 -81 11 -17 13 -42 5
-56 -29 -46 -263 -20 -263 30 0 45 -106 270 -128 270 -44 0 -106 -126 -76
-156 16 -16 29 -59 29 -95 0 -36 26 -90 59 -120 47 -45 57 -76 50 -161 -16
-194 -39 -318 -62 -332 -51 -32 -22 -111 41 -111 83 0 88 -93 6 -105 -52 -7
-56 -20 -56 -174 0 -92 8 -175 18 -185 29 -30 90 38 99 109 5 42 25 70 55 76
40 8 44 -1 28 -62 -54 -203 -43 -255 63 -309 114 -59 124 -90 39 -128 -49 -23
-72 -18 -133 27 -112 83 -244 64 -244 -34 0 -55 18 -84 73 -114 86 -48 109
-95 55 -115 -49 -19 16 -104 107 -139 76 -30 45 -64 -84 -91 -192 -39 -179
-196 14 -165 l97 15 0 -115 c0 -66 12 -116 27 -116 15 0 20 -21 10 -52 -11
-33 -1 -69 27 -99 57 -63 10 -124 -94 -124 -74 0 -75 1 -66 126 10 149 -50
168 -91 29 -21 -72 -33 -81 -100 -75 -91 9 -82 -84 -87 933 -11 2214 -6 2456
51 2509 52 48 34 153 -25 153 -42 0 -33 6448 9 6587 29 97 31 131 7 159 -24
28 -30 836 -29 3552 l1 3515 57 149 c31 83 70 166 86 185 16 19 63 97 105 174
74 138 126 182 447 385 60 38 128 69 151 69 23 0 67 14 97 31 86 50 1142 57
7030 50 2969 -3 5551 -4 5737 -3z m8450 -41 c76 -24 155 -60 177 -78 22 -19
58 -34 81 -34 79 0 401 -360 504 -564 l97 -191 27 -466 c29 -508 24 -804 -15
-804 -13 0 -62 83 -108 185 -46 102 -96 192 -111 201 -15 9 -27 91 -27 181 0
117 -14 187 -47 243 -26 42 -55 115 -65 160 -17 78 -14 81 45 66 68 -17 117
40 117 136 0 68 -38 86 -100 48 -47 -29 -60 -24 -123 53 -40 49 -81 77 -98 67
-36 -22 -39 -140 -4 -140 14 0 25 -10 25 -21 0 -50 -258 3 -311 64 -44 51 -76
61 -214 65 -155 4 -163 7 -170 70 -13 112 115 197 299 197 131 0 148 -6 136
-44 -60 -202 -55 -207 123 -131 64 28 138 50 164 50 58 0 58 -2 8 98 -48 97
-107 126 -139 68 -34 -61 -93 -50 -126 23 -24 52 -23 69 6 86 70 44 -4 58 -89
17 -75 -35 -87 -36 -87 -4 0 20 18 37 39 37 28 0 37 20 31 69 -6 59 -18 68
-82 64 -297 -20 -534 5 -628 66 -112 72 -187 -44 -85 -131 58 -49 66 -118 15
-118 -64 0 -115 30 -115 67 0 20 -30 75 -66 123 -62 81 -69 84 -111 45 -33
-29 -66 -36 -116 -22 -38 10 -118 22 -178 25 -60 3 -161 29 -225 57 -64 29
-159 59 -212 67 -58 10 -91 28 -85 46 23 71 1625 76 1843 4z m-8225 -149 c36
-21 132 -37 226 -37 90 -1 175 -11 188 -24 13 -12 94 -58 180 -101 138 -70
156 -88 156 -153 0 -55 -15 -80 -60 -97 -33 -13 -68 -35 -77 -49 -29 -48 -90
-29 -154 48 -35 41 -81 75 -103 75 -22 0 -64 22 -93 49 -77 72 -173 77 -183
10 -4 -30 -30 -60 -56 -67 -27 -7 -49 -25 -49 -40 0 -35 82 -35 118 1 40 40
186 1 200 -54 6 -25 44 -57 84 -72 40 -15 107 -40 149 -55 63 -24 83 -21 125
16 44 40 53 41 93 6 29 -26 72 -34 129 -25 98 15 216 -40 283 -132 44 -59 44
-60 -67 -136 -61 -42 -125 -76 -144 -76 -18 0 -47 -23 -65 -51 -28 -46 -48
-49 -181 -34 -98 11 -174 6 -224 -15 -57 -24 -83 -24 -110 -2 -28 23 -49 17
-97 -28 -35 -32 -88 -75 -120 -97 -37 -26 -51 -54 -41 -81 20 -52 246 -59 297
-10 175 166 421 153 421 -22 0 -86 -108 -300 -190 -377 -51 -47 -71 -51 -147
-30 -111 31 -138 14 -138 -82 0 -55 -14 -79 -50 -89 -54 -14 -69 -57 -21 -57
16 0 48 -17 71 -38 55 -50 226 5 262 84 14 30 43 54 66 54 23 0 60 28 82 63
44 67 112 80 160 32 24 -24 39 -22 70 9 35 35 34 48 -13 136 -63 117 -65 155
-12 213 25 27 40 87 39 150 -1 133 55 247 123 247 28 0 90 30 138 66 l86 66
140 -97 c317 -220 340 -233 381 -212 136 69 378 43 378 -41 0 -49 121 -66 225
-32 123 41 348 -5 453 -93 19 -15 67 -36 106 -46 45 -11 101 -59 149 -127 42
-60 87 -109 100 -109 13 0 18 -56 11 -127 -7 -75 -1 -138 16 -156 15 -16 41
-67 57 -113 28 -78 25 -88 -37 -146 l-67 -62 -57 71 c-31 39 -68 84 -82 101
-13 16 -24 39 -24 50 0 11 -23 64 -52 117 -44 82 -47 102 -17 131 29 30 18 52
-73 150 -60 64 -108 124 -108 134 0 40 -174 111 -202 83 -21 -21 -16 -35 21
-55 27 -14 62 -58 78 -96 16 -38 62 -92 103 -120 72 -48 78 -65 86 -237 2 -34
13 -94 24 -132 14 -45 10 -81 -10 -106 -17 -20 -21 -37 -9 -37 77 -2 95 -52
35 -98 l-62 -48 68 -31 c66 -30 68 -38 68 -226 0 -170 8 -203 61 -264 73 -85
152 -50 95 42 -38 61 -40 191 -3 214 15 10 21 48 13 90 -11 53 -2 83 34 115
28 23 50 58 50 77 0 48 177 20 206 -33 24 -43 108 -51 132 -13 8 14 -8 58 -36
98 -29 40 -52 90 -52 112 0 21 -32 98 -71 171 -39 72 -79 174 -89 227 -10 52
-34 101 -54 108 -20 8 -36 30 -36 50 0 64 69 64 179 -2 189 -112 357 -189 415
-189 46 0 52 -8 33 -44 -13 -24 -30 -60 -38 -81 -7 -21 -27 -57 -44 -80 -25
-34 -22 -51 12 -89 24 -26 43 -60 43 -75 0 -45 114 -156 160 -156 76 0 78 79
4 138 -56 45 -64 64 -43 102 15 26 33 90 41 141 14 88 21 94 108 98 173 7 242
-8 355 -77 62 -38 156 -76 209 -84 65 -11 133 -50 212 -124 64 -60 153 -131
198 -157 44 -26 81 -55 81 -64 0 -46 187 -251 261 -286 82 -39 294 -251 456
-454 53 -68 142 -130 275 -195 226 -110 343 -216 366 -332 18 -93 157 -318
241 -393 71 -63 115 -150 136 -268 19 -106 148 -330 284 -491 136 -163 147
-182 167 -290 15 -82 205 -419 261 -464 46 -37 114 -204 133 -325 67 -433 50
-551 -82 -597 -40 -14 -73 -38 -73 -53 0 -15 -51 -48 -112 -75 -65 -28 -113
-65 -113 -87 0 -22 -26 -49 -58 -61 -32 -12 -94 -64 -138 -114 -93 -106 -144
-102 -187 12 -20 54 -44 75 -88 75 -47 0 -56 -9 -41 -44 10 -24 23 -63 30 -87
12 -42 25 -49 107 -54 77 -5 61 -172 -24 -247 -42 -38 -76 -80 -76 -93 0 -33
-142 -32 -162 0 -22 34 -113 32 -113 -3 0 -16 18 -42 40 -58 37 -27 36 -40
-12 -146 -29 -63 -53 -133 -53 -154 0 -50 -106 -75 -193 -46 -38 13 -98 15
-132 5 -34 -10 -100 -19 -145 -21 -77 -2 -173 -54 -297 -161 -61 -52 -140 -39
-118 18 7 20 -15 98 -49 173 -36 78 -57 160 -49 190 8 29 2 67 -12 84 -14 17
-33 74 -43 125 -18 95 -25 101 -137 105 -49 1 -64 16 -70 70 -8 62 -1 69 68
69 50 0 77 12 77 36 0 57 -39 67 -176 49 -118 -16 -128 -22 -117 -76 27 -144
-125 -133 -219 16 -144 228 -311 327 -490 291 -83 -17 -248 105 -176 129 19 6
43 -4 54 -22 21 -34 204 -55 282 -32 95 28 42 143 -76 166 -103 20 -207 111
-207 181 0 34 -162 187 -198 187 -12 0 -27 24 -35 53 -23 88 -74 27 -58 -71
13 -84 12 -85 -40 -51 -30 20 -75 77 -101 127 -35 66 -64 92 -107 92 -35 0
-77 26 -104 65 -24 37 -70 91 -100 122 -71 71 -53 88 95 88 75 0 134 15 159
39 52 53 50 62 -37 146 -87 86 -91 117 -26 176 40 36 44 56 24 110 -34 89
-171 229 -225 229 -112 0 -86 -161 29 -184 43 -9 70 -27 62 -41 -24 -37 -102
-30 -138 13 -17 20 -56 37 -86 37 -30 0 -87 34 -126 75 -40 41 -93 75 -118 75
-26 0 -53 17 -61 38 -10 26 -51 37 -137 37 -134 0 -143 10 -78 82 41 46 40 50
-16 95 -78 64 -193 63 -228 -3 -37 -68 -68 -46 -231 164 l-136 175 73 69 c39
37 64 81 55 96 -10 15 -5 35 10 45 18 11 22 63 13 146 -15 126 -19 131 -106
147 -102 19 -228 102 -228 150 0 18 39 34 93 39 81 6 94 16 94 70 0 57 9 62
94 55 86 -7 94 -2 94 56 0 87 53 80 106 -13 78 -137 191 -46 117 94 -39 72 11
179 100 212 47 17 52 10 52 -69 0 -93 37 -185 74 -185 12 0 21 52 20 115 -1
68 11 123 30 134 65 40 373 -33 413 -99 9 -14 38 -25 64 -25 27 0 49 -11 49
-25 0 -14 -65 -25 -144 -26 -134 -1 -151 -8 -262 -110 -66 -60 -119 -127 -119
-149 0 -52 98 -74 185 -41 85 32 140 -1 140 -84 0 -30 19 -80 41 -113 38 -54
38 -60 0 -81 -60 -34 -52 -54 68 -183 68 -74 125 -114 154 -109 49 9 96 -126
69 -196 -42 -111 275 -135 423 -31 73 51 122 23 69 -40 -46 -56 17 -67 164
-29 107 28 128 43 148 112 26 84 74 105 98 43 23 -61 62 -44 71 31 5 50 23 71
65 77 70 10 60 63 -14 74 -29 5 -66 24 -82 44 -17 20 -62 36 -100 36 -70 0
-70 1 -57 131 l13 132 -152 3 c-84 2 -153 1 -153 -2 0 -70 91 -238 141 -261
43 -19 59 -42 49 -68 -8 -22 -15 -59 -15 -83 0 -50 -106 -108 -160 -87 -20 8
-48 46 -61 86 -20 57 -45 74 -121 86 -136 22 -258 81 -258 124 0 21 -34 55
-75 77 -53 27 -75 57 -75 100 0 52 12 62 75 62 56 0 75 12 75 46 0 63 -27 84
-65 52 -18 -15 -44 -20 -57 -12 -34 20 -22 180 16 218 24 24 22 40 -9 74 -47
51 -27 97 41 97 26 0 68 23 95 51 39 42 75 50 210 46 89 -2 176 4 192 14 62
39 203 -14 304 -113 103 -101 258 -198 316 -198 131 0 388 -254 418 -412 10
-55 40 -148 67 -207 54 -118 36 -190 -52 -218 -27 -9 -93 -66 -147 -127 -110
-125 -115 -126 -225 -72 -83 41 -105 86 -43 86 64 0 69 50 10 100 -79 65 -100
62 -81 -12 14 -57 8 -63 -63 -63 -109 0 -128 -65 -40 -135 109 -87 10 -215
-196 -254 -122 -22 -129 -42 -50 -136 55 -65 61 -84 32 -102 -58 -36 -121 -26
-166 27 -24 28 -63 50 -88 50 -60 0 -80 58 -44 124 19 37 43 49 76 38 76 -24
109 11 61 64 -58 64 -25 104 73 85 69 -13 84 -6 110 50 34 75 -4 88 -84 27
-64 -48 -203 -48 -230 0 -17 31 -32 32 -86 6 -99 -47 -117 -280 -27 -366 65
-63 47 -102 -49 -103 -53 0 -58 -57 -9 -98 19 -16 29 -52 21 -80 -10 -41 -3
-50 34 -43 30 6 47 31 47 71 0 47 13 61 49 58 27 -2 69 6 94 19 51 28 145 -19
145 -73 0 -39 89 -121 169 -154 31 -13 56 -46 56 -73 0 -62 45 -92 82 -55 21
21 43 11 83 -40 48 -60 61 -65 117 -39 55 25 69 22 99 -24 59 -89 86 -32 77
161 l-8 183 113 59 c98 52 152 128 91 128 -18 0 -79 107 -79 139 0 6 22 11 49
11 49 0 85 -86 106 -250 6 -47 24 -64 76 -70 81 -10 91 -45 19 -67 -65 -21
-64 -92 1 -133 34 -21 47 -48 37 -78 -8 -25 2 -59 23 -76 33 -27 34 -38 2 -83
-25 -36 -29 -64 -11 -97 33 -61 103 -58 144 7 23 37 50 49 93 41 72 -14 83 19
13 38 -26 7 -52 39 -56 71 -5 34 -37 72 -75 91 -65 31 -66 34 -29 108 31 61
32 89 8 147 -21 52 -22 85 -2 122 15 28 27 79 27 114 0 59 60 115 122 115 32
0 73 -147 86 -312 8 -91 29 -145 76 -197 36 -40 66 -85 67 -100 1 -46 91 -141
133 -141 29 0 37 -25 33 -104 -3 -64 7 -107 27 -114 18 -7 31 10 31 39 0 68
38 88 82 43 56 -55 50 -365 -9 -487 -31 -64 -42 -125 -33 -172 9 -43 3 -81
-12 -91 -48 -29 -30 -80 38 -111 87 -40 103 -13 106 169 1 77 13 144 27 149
15 5 26 95 26 217 0 241 22 269 125 166 85 -85 91 -110 38 -154 -21 -17 -38
-41 -38 -53 0 -34 94 -26 107 9 19 53 49 1 31 -54 -11 -36 -37 -52 -86 -52
-67 0 -146 -98 -109 -135 28 -28 82 -15 82 20 0 46 119 68 135 24 20 -52 65
-40 65 16 0 28 -11 50 -25 50 -14 0 -25 17 -25 38 0 56 33 45 113 -38 78 -82
139 -95 187 -38 27 33 37 33 83 0 99 -69 284 -31 221 46 -17 20 -51 32 -75 25
-25 -6 -60 6 -78 28 -17 21 -53 39 -78 39 -53 0 -95 55 -52 69 16 6 29 26 29
46 0 66 74 68 125 3 82 -104 147 -105 124 -2 -20 90 -4 102 79 57 36 -19 60
-19 84 2 26 21 40 17 59 -17 35 -63 49 -39 58 105 l9 125 -75 -9 c-99 -12
-123 -29 -90 -62 34 -34 35 -92 2 -92 -14 0 -25 23 -25 50 0 28 -16 50 -35 50
-19 0 -67 17 -106 37 -75 39 -116 10 -62 -44 39 -39 35 -93 -7 -93 -54 0 -115
114 -115 215 0 81 -6 89 -54 77 -58 -15 -170 68 -171 127 -1 109 66 235 132
248 94 19 104 45 30 79 -34 15 -62 39 -62 53 0 15 -34 26 -75 26 -74 0 -105
54 -50 88 14 8 25 36 25 62 0 26 29 78 63 116 84 90 72 144 -35 155 -71 6 -82
1 -68 -35 23 -61 -10 -213 -50 -228 -19 -7 -52 5 -74 27 -22 22 -49 40 -60 40
-21 0 -56 86 -61 152 -1 21 -22 59 -46 83 -24 24 -44 61 -44 83 0 42 -69 105
-117 106 -63 2 -63 -100 0 -164 70 -69 65 -149 -11 -173 -74 -24 -57 -71 78
-214 69 -74 125 -145 125 -160 0 -14 23 -69 50 -120 45 -83 46 -96 12 -109
-45 -18 -117 -145 -94 -168 34 -35 104 -12 142 47 23 34 52 62 66 62 13 0 24
-28 24 -62 0 -48 13 -63 53 -63 47 0 52 -11 40 -85 -8 -51 -1 -103 19 -131 27
-40 66 -334 43 -334 -69 0 -239 222 -216 282 7 18 -20 44 -64 60 -50 19 -89
59 -113 118 -42 100 -73 110 -143 47 -45 -40 -51 -38 -133 52 -78 85 -125 243
-61 204 14 -9 25 2 25 24 0 21 -28 52 -62 68 -76 34 -81 70 -13 88 61 16 64
51 9 111 -58 64 -105 57 -124 -16 -23 -94 -49 -76 -49 35 0 104 -79 199 -167
201 -24 1 -44 10 -44 21 0 11 -14 40 -32 64 -38 52 -142 11 -242 -96 -69 -73
-107 -79 -153 -23 -37 45 12 95 181 185 50 27 128 82 173 124 77 70 91 73 229
59 135 -14 148 -11 161 38 9 36 34 54 72 54 31 0 77 20 101 43 24 24 69 40
102 36 60 -8 84 52 33 84 -14 8 -25 31 -25 51 0 30 9 31 48 7 49 -31 177 25
177 78 0 32 -73 101 -108 102 -44 1 -142 90 -142 128 0 60 -125 221 -172 221
-25 0 -58 -29 -74 -64 -38 -83 -37 -86 21 -86 28 0 50 -17 50 -37 0 -21 -11
-38 -25 -38 -14 0 -25 -17 -25 -37 0 -25 25 -38 74 -38 76 0 144 -76 113 -126
-22 -36 -80 -29 -95 12 -8 19 -46 39 -84 43 -47 6 -73 25 -79 59 -15 82 -47
97 -115 53 -78 -51 -87 -141 -14 -141 33 0 50 -17 50 -50 0 -36 17 -50 59 -50
83 0 129 -58 79 -100 -51 -42 -205 -16 -273 46 -29 27 -90 57 -136 66 -81 17
-82 16 -53 -39 17 -31 63 -84 103 -118 l72 -61 -64 -59 c-36 -33 -74 -60 -85
-60 -12 0 -35 -17 -52 -37 -17 -21 -63 -38 -103 -38 -68 0 -72 6 -72 109 0 71
17 131 50 173 66 83 64 103 -25 247 -136 220 -77 473 75 321 29 -29 72 -49 95
-45 64 12 64 83 0 114 l-57 28 63 1 c39 1 88 31 125 76 62 74 165 100 213 52
28 -28 202 -43 225 -20 31 31 -18 69 -88 69 -39 0 -77 16 -85 37 -8 20 -60 44
-115 53 -56 9 -101 25 -101 35 0 11 -20 24 -45 31 -26 7 -57 53 -74 109 -27
88 -43 102 -177 151 -92 33 -161 45 -182 32 -55 -35 7 -106 118 -138 121 -34
132 -98 16 -97 -61 0 -81 -11 -81 -44 0 -48 38 -59 63 -19 27 44 106 27 187
-41 98 -83 59 -141 -102 -149 -67 -4 -120 -24 -151 -58 -68 -72 -73 -70 -245
98 -84 83 -175 150 -203 150 -27 0 -92 39 -146 88 -53 48 -108 87 -122 87 -14
0 -40 18 -59 41 -27 33 -68 38 -226 27 -160 -11 -209 -5 -282 34 -109 59 -159
60 -217 7 -98 -88 -261 -90 -411 -6 -114 64 -152 74 -236 60 -96 -17 -100 -14
-100 48 0 67 -76 123 -94 69 -18 -54 -290 -165 -401 -164 -67 1 -103 -9 -97
-26 5 -15 45 -26 88 -24 53 3 79 -8 79 -31 0 -19 -20 -35 -45 -35 -56 0 -159
-134 -141 -183 18 -47 -95 -69 -198 -39 -66 19 -84 13 -128 -41 -28 -35 -84
-72 -125 -83 -42 -11 -87 -43 -101 -72 -15 -28 -41 -69 -59 -91 -47 -57 -13
-191 49 -191 26 0 48 10 48 22 0 68 104 42 172 -42 56 -71 80 -85 106 -63 38
30 147 1 147 -39 0 -14 -39 -66 -87 -117 -99 -105 -105 -124 -48 -146 33 -13
35 -23 10 -53 -28 -33 -41 -31 -113 13 -44 28 -102 48 -128 45 -71 -9 -284
108 -284 157 0 23 -17 56 -37 73 -21 17 -38 50 -38 72 0 86 -74 153 -168 153
-152 0 -407 98 -407 156 0 33 12 45 37 35 20 -7 43 -3 51 10 8 13 54 24 101
24 60 0 86 11 86 38 0 37 -25 46 -103 39 -46 -5 -77 100 -45 152 15 23 -15 41
-109 65 -205 52 -302 134 -198 167 38 12 45 41 44 170 l-1 157 87 -9 c85 -9
86 -7 44 39 -24 27 -44 66 -44 88 0 22 -42 60 -94 86 -111 54 -123 117 -25
128 38 5 69 -2 69 -15 0 -13 63 -30 141 -38 179 -18 198 -39 192 -207 -4 -100
5 -141 31 -151 20 -8 36 -47 36 -87 0 -72 -1 -73 -62 -32 -39 25 -86 35 -125
25 -76 -19 -80 -54 -13 -96 28 -17 50 -51 50 -75 0 -109 291 -195 318 -94 15
58 19 59 84 24 57 -30 65 -124 11 -124 -24 0 -38 -24 -38 -62 0 -85 61 -81
152 10 87 87 92 140 18 180 -54 28 -87 53 -158 118 -21 18 -37 66 -37 106 0
40 -1 81 -2 91 -1 9 21 25 48 36 87 31 454 -183 454 -265 0 -28 214 -140 266
-139 16 0 36 19 45 41 20 54 -60 149 -242 289 -38 29 -69 62 -69 74 0 32 69
25 81 -8 6 -19 27 -23 58 -10 108 44 221 26 236 -38 23 -96 112 -81 113 19 1
44 22 103 48 131 26 29 42 55 37 58 -6 4 -47 32 -91 63 -44 31 -97 56 -118 56
-22 0 -39 11 -39 25 0 14 16 25 36 25 20 0 44 13 54 28 12 20 -8 25 -67 16
-64 -9 -93 0 -126 41 -64 78 -109 23 -84 -102 44 -211 16 -242 -176 -192 -187
48 -207 65 -207 174 0 104 51 135 119 73 57 -51 111 -29 79 32 -11 23 -16 57
-9 76 6 18 -11 49 -38 68 -34 24 -46 53 -37 97 17 93 -79 125 -184 61 -43 -26
-100 -47 -127 -47 -83 0 -250 276 -218 360 15 40 -104 150 -139 128 -21 -13
-21 -26 -1 -50 38 -46 -6 -69 -93 -47 -58 14 -65 11 -42 -18 16 -20 28 -73 27
-118 0 -56 17 -94 54 -120 30 -21 54 -53 54 -71 0 -54 78 -70 112 -23 28 38
37 36 109 -17 43 -32 79 -72 79 -89 0 -16 17 -36 38 -44 20 -8 37 -33 37 -55
0 -22 23 -69 50 -104 63 -80 64 -148 2 -181 -63 -34 -127 -8 -127 51 0 30 -37
62 -110 95 -79 34 -113 65 -119 107 -6 44 -27 61 -83 67 -42 4 -94 25 -117 46
-33 29 -53 31 -94 9 -29 -16 -64 -22 -78 -13 -37 23 -28 112 14 128 48 18 47
52 -3 102 -27 28 -35 64 -24 120 11 60 5 85 -24 96 -41 16 -70 -29 -58 -88 3
-18 -8 -60 -26 -92 -25 -46 -26 -74 -3 -130 38 -92 16 -124 -83 -123 -103 1
-268 133 -222 179 16 16 30 55 30 86 0 31 20 68 44 81 36 21 38 31 11 58 -28
27 -39 26 -63 -7 -16 -21 -66 -60 -111 -86 -70 -42 -79 -58 -67 -124 8 -47 0
-94 -23 -125 -32 -44 -30 -56 25 -122 44 -51 54 -81 35 -100 -46 -46 -28 -80
57 -111 117 -42 124 -39 112 46 -7 42 -2 82 9 89 12 7 21 -22 21 -65 0 -70 7
-78 69 -74 104 7 110 3 82 -50 -22 -39 -17 -54 23 -76 80 -42 113 -124 68
-168 -33 -34 -40 -32 -64 13 -26 47 -166 100 -194 73 -6 -7 17 -43 52 -81 100
-108 61 -187 -91 -187 -68 0 -138 92 -99 131 29 29 -61 169 -109 169 -15 0
-62 39 -105 87 -42 47 -106 100 -141 116 -126 58 -114 158 28 235 78 42 94 64
94 129 0 43 8 87 18 97 27 27 23 61 -6 61 -14 0 -25 -17 -25 -37 0 -45 -42
-47 -183 -11 -84 22 -119 51 -179 144 -59 91 -111 134 -236 194 -88 42 -182
104 -209 137 -47 59 -47 60 5 94 70 47 66 99 -10 134 -104 47 -79 98 43 91 59
-3 172 -4 253 -1 l147 5 -17 89 c-22 117 2 184 76 212 61 23 83 107 35 137
-49 30 -24 78 60 118 81 39 86 39 98 -7 14 -55 111 -99 217 -99 49 0 77 -15
87 -48 24 -76 88 -87 88 -15 0 69 -141 153 -223 131 -33 -8 -52 3 -60 37 -8
27 -36 55 -64 62 -28 7 -68 40 -90 73 -46 70 -125 78 -160 16 -26 -46 -28 -43
-67 88 -5 17 -31 31 -57 31 -26 0 -96 37 -157 83 -77 59 -138 84 -206 85 -121
3 -161 39 -85 76 124 61 235 103 311 118 44 9 93 32 109 52 37 45 69 44 149
-1z m-6270 -176 c15 -34 19 -71 8 -81 -11 -10 -25 -4 -31 13 -6 17 -36 31 -67
31 -55 0 -115 42 -115 80 0 11 40 20 88 20 70 0 94 -13 117 -63z m4770 25 c0
-40 -66 -79 -92 -54 -8 8 -8 32 1 53 19 50 91 51 91 1z m9309 -36 c75 -77 71
-126 -10 -126 -36 0 -49 17 -49 63 0 35 -17 70 -37 78 -21 8 -31 24 -24 37 22
35 44 26 120 -52z m-16821 23 c22 -35 -7 -149 -38 -149 -13 0 -31 27 -39 61
-16 64 1 114 39 114 12 0 29 -12 38 -26z m-2244 -65 c36 -9 42 -178 8 -231
-33 -53 -69 -14 -87 96 -8 56 -30 101 -47 101 -50 1 -101 43 -84 70 11 17 42
17 97 -1 45 -15 96 -30 113 -35z m5766 -24 c24 -63 18 -81 -34 -97 -56 -18
-115 -192 -88 -259 14 -36 22 -34 55 15 70 104 138 61 79 -50 -36 -66 59 -152
147 -131 61 14 85 -74 25 -94 -17 -6 -31 -35 -31 -64 -1 -87 -47 -75 -66 17
-31 155 -234 265 -234 128 0 -82 -50 -81 -52 0 -1 34 -16 106 -34 159 -37 110
-6 203 76 224 31 8 42 26 32 53 -9 23 3 62 28 90 54 59 77 62 97 9z m2829 -7
c42 -12 121 -14 175 -5 68 12 129 5 199 -24 159 -66 323 -83 361 -37 18 21 48
38 67 38 53 0 242 -146 279 -214 17 -34 42 -61 56 -61 13 0 24 -15 24 -33 0
-18 40 -69 90 -112 108 -96 100 -141 -24 -146 -50 -2 -108 -10 -127 -18 -44
-16 -94 41 -76 88 26 68 -47 131 -108 93 -43 -27 -60 -27 -85 -2 -25 25 -21
35 24 46 80 21 69 66 -29 119 -100 53 -140 38 -140 -54 0 -77 -136 -231 -205
-231 -85 0 -47 -69 48 -87 93 -17 156 22 188 117 16 49 69 -4 69 -70 0 -44 19
-69 69 -87 102 -39 12 -81 -174 -81 -80 0 -145 -10 -145 -21 0 -12 -20 -21
-45 -21 -25 0 -67 -17 -94 -37 -99 -75 -119 -51 -103 124 20 218 47 263 155
263 103 0 121 63 28 99 -33 12 -88 58 -122 102 -68 87 -119 82 -119 -12 0 -32
-14 -69 -31 -83 -27 -22 -241 -44 -338 -34 -51 5 -35 71 21 86 77 20 52 103
-33 112 -56 7 -69 -2 -69 -43 0 -31 -16 -52 -39 -52 -57 0 -136 47 -136 81 0
43 103 144 148 145 22 0 61 17 88 37 57 43 55 43 153 15z m-2022 -128 c16 -32
47 -68 69 -80 47 -27 52 -120 6 -120 -18 0 -52 39 -74 88 -50 103 -84 110
-123 25 -33 -74 -52 -78 -97 -23 -29 35 -23 51 49 114 92 83 127 82 170 -4z
m252 0 c26 -42 49 -48 128 -35 l97 15 12 -96 c15 -115 -19 -167 -67 -102 -18
25 -58 41 -92 37 -44 -5 -61 7 -67 48 -4 30 -24 68 -44 84 -38 32 -49 99 -17
99 10 0 33 -23 50 -50z m1284 -89 c10 -55 42 -142 72 -193 l55 -93 -64 0 c-74
0 -215 244 -161 278 15 9 21 41 13 71 -11 41 -4 52 27 46 26 -5 47 -44 58
-109z m2610 89 c8 -14 49 -25 91 -25 55 0 79 -14 89 -50 7 -28 52 -69 99 -91
107 -51 101 -113 -13 -137 -122 -25 -139 -54 -68 -120 l61 -58 67 53 c120 94
150 54 56 -73 -42 -58 -48 -81 -25 -104 73 -73 35 -102 -107 -86 -91 11 -155
6 -186 -14 -102 -63 -176 91 -75 158 41 28 47 47 29 94 -21 57 -34 60 -258 65
-129 3 -266 12 -304 22 -38 9 -97 22 -131 29 -99 20 -81 102 36 161 54 28 116
51 137 51 20 0 74 16 119 36 206 90 360 126 383 89z m-10400 -75 c0 -39 -17
-65 -44 -70 -34 -7 -44 9 -44 70 0 61 10 77 44 70 27 -5 44 -31 44 -70z m1833
8 c-13 -62 -71 -71 -71 -10 0 31 16 52 39 52 24 0 36 -17 32 -42z m5500 -65
c-1 -154 -31 -188 -48 -55 -9 68 -11 133 -5 144 22 40 54 -12 53 -89z m-7876
-111 c-4 -25 -30 -44 -57 -44 -54 0 -106 130 -79 200 21 55 149 -92 136 -156z
m3130 118 c0 -51 -12 -75 -38 -75 -45 0 -73 59 -53 113 27 69 91 42 91 -38z
m-4690 -7 c20 -31 17 -52 -10 -79 -53 -53 -98 -15 -82 68 14 75 49 79 92 11z
m2935 -40 c-5 -22 -33 -44 -64 -49 -52 -7 -54 -2 -28 55 31 68 105 63 92 -6z
m679 48 c38 -24 32 -28 -93 -65 -17 -5 -31 -38 -31 -73 0 -35 -10 -63 -22 -63
-25 0 -57 173 -38 204 17 28 138 26 184 -3z m2451 -91 c0 -41 -79 -46 -117 -8
-15 15 -22 48 -15 74 11 43 17 44 72 7 33 -21 60 -54 60 -73z m-665 50 c19
-49 -2 -85 -47 -85 -52 0 -71 47 -37 89 39 47 65 46 84 -4z m-4630 -29 c20
-24 51 -80 69 -125 18 -45 51 -93 73 -106 36 -21 36 -27 3 -49 -56 -38 -75
-31 -75 25 0 28 -17 57 -37 65 -40 15 -113 145 -113 200 0 47 35 42 80 -10z
m1792 -133 c-31 -24 -49 -57 -41 -78 31 -80 -22 -95 -76 -21 l-55 74 53 90 53
90 61 -57 60 -57 -55 -41z m4129 88 c23 -27 24 -46 5 -65 -40 -40 -106 -6
-106 53 0 60 56 67 101 12z m1330 -39 c-4 -33 -12 -82 -17 -109 -5 -28 -11
-60 -12 -71 -1 -11 -13 -13 -27 -4 -28 17 -34 219 -8 246 34 33 70 -2 64 -62z
m244 -25 c0 -12 -22 -22 -50 -22 -48 0 -68 49 -34 83 19 19 84 -28 84 -61z
m-3356 -1 c-38 -14 -69 -35 -69 -48 0 -13 -19 -23 -42 -23 -23 0 -63 -19 -89
-43 -41 -37 -50 -37 -70 -6 -38 60 -13 86 96 101 57 7 112 21 121 31 10 9 41
16 69 15 44 -2 41 -6 -16 -27z m-4644 -60 c0 -40 -89 -50 -112 -13 -16 27 63
79 93 61 10 -7 19 -28 19 -48z m-262 -92 c16 -85 12 -95 -49 -119 -88 -33
-106 -32 -69 5 17 17 30 71 30 121 0 161 58 156 88 -7z m2753 92 c9 -21 9 -44
2 -52 -19 -18 -118 37 -118 67 0 40 100 27 116 -15z m2473 -47 c68 -68 73 -94
35 -166 -38 -72 -99 -60 -99 19 0 37 -18 86 -40 111 -86 94 11 128 104 36z
m-3639 -44 c0 -12 -12 -16 -27 -7 -14 10 -48 -3 -75 -27 -61 -56 -67 1 -7 68
42 46 109 25 109 -34z m7381 -39 c123 -127 139 -204 61 -295 -52 -61 -70 -68
-118 -46 l-57 26 79 56 c97 69 100 110 11 151 -37 17 -83 53 -102 80 -22 31
-51 44 -80 34 -50 -15 -87 23 -62 63 37 61 176 25 268 -69z m-2264 22 c25 -39
20 -56 -28 -102 -70 -65 -100 -35 -76 75 18 85 61 96 104 27z m3670 -33 c148
-72 158 -163 26 -234 -49 -26 -88 -54 -88 -62 0 -38 68 -74 140 -74 73 0 80
-8 90 -89 6 -49 3 -93 -5 -99 -23 -14 -275 135 -275 163 0 13 -39 49 -86 82
-63 43 -80 67 -63 94 12 20 16 80 7 133 -24 152 60 180 254 86z m-9962 -9 c0
-24 -17 -36 -42 -32 -62 13 -71 71 -10 71 31 0 52 -16 52 -39z m6725 15 c0
-12 -12 -30 -26 -39 -37 -23 -105 7 -87 38 20 32 113 33 113 1z m-3325 -160
c0 -58 -44 -51 -63 10 -21 66 -97 54 -107 -17 -6 -40 11 -60 71 -81 61 -21 76
-37 62 -71 -48 -126 43 -324 120 -260 25 20 46 18 82 -9 41 -32 42 -40 10 -62
-48 -32 -93 -33 -113 -1 -17 29 -62 10 -62 -25 0 -37 161 -56 253 -31 46 13
152 15 235 5 109 -12 160 -8 188 16 58 50 108 4 94 -87 -22 -151 22 -163 718
-180 41 -1 288 5 550 13 261 9 992 14 1625 12 1970 -5 1913 -1 1875 -120 -15
-49 -21 -50 -84 -17 -93 48 -1257 44 -1273 -5 -6 -18 11 -31 40 -31 96 0 129
-28 129 -110 0 -65 19 -95 100 -154 119 -87 130 -120 120 -359 -9 -215 -53
-273 -145 -189 -45 40 -56 42 -76 11 -33 -52 -30 -70 28 -151 58 -83 99 -90
185 -34 42 28 73 33 105 16 25 -13 95 -31 156 -40 100 -15 107 -13 75 24 -29
36 -27 48 19 84 68 56 36 125 -51 109 -54 -11 -63 -1 -76 84 -21 131 2 461 34
493 38 38 32 66 -16 66 -23 0 -61 17 -84 38 -37 34 -45 34 -73 0 -46 -55 -105
-46 -172 25 -70 74 -20 114 83 67 42 -19 80 -19 130 -1 113 43 392 -3 404 -66
5 -28 25 -59 44 -70 47 -27 45 -116 -2 -134 -21 -8 -38 -38 -38 -68 -1 -98
-45 -135 -63 -52 -27 124 -34 136 -76 136 -35 0 -38 -20 -23 -131 19 -144 99
-344 138 -344 31 0 32 -92 0 -112 -29 -18 19 -163 55 -163 14 0 40 19 56 42
18 24 48 35 72 25 49 -19 50 -40 6 -99 -43 -56 -962 -117 -1091 -71 -53 18
-93 18 -134 0 -39 -18 -134 -19 -306 -1 -155 15 -295 16 -371 2 -68 -13 -146
-16 -174 -7 -28 9 -308 15 -622 13 -588 -4 -667 7 -667 95 0 31 -24 52 -71 63
-40 8 -87 43 -105 77 -18 33 -53 61 -78 61 -55 0 -146 74 -146 118 0 18 20 32
45 32 49 0 155 -86 155 -126 0 -13 22 -24 49 -24 42 0 47 12 35 75 -18 90 70
110 116 26 15 -29 41 -43 63 -35 55 21 75 -61 28 -113 -23 -24 -41 -52 -41
-61 0 -35 153 -92 248 -92 l100 0 -64 64 c-45 45 -61 82 -53 125 9 47 1 61
-34 61 -69 0 -57 72 18 106 55 25 70 23 96 -12 45 -62 220 -84 262 -34 18 22
52 40 75 40 23 0 53 10 66 23 13 13 94 31 180 41 l156 17 0 -66 c0 -54 -14
-69 -76 -81 -42 -9 -92 -39 -112 -67 -36 -51 -37 -52 -72 -4 -32 43 -41 45
-101 13 -76 -41 -108 -135 -64 -189 42 -50 259 -49 337 3 54 35 70 35 132 4
112 -56 242 19 137 78 -34 20 -38 35 -16 70 30 49 135 77 135 37 0 -38 73
-104 114 -104 63 0 41 99 -27 125 -35 13 -70 41 -78 62 -8 21 -41 38 -73 38
-32 0 -76 25 -97 56 -36 51 -35 59 13 106 l52 51 68 -82 c67 -79 159 -106 190
-56 25 39 -108 307 -176 357 -33 25 -61 34 -61 20 0 -17 -22 -16 -64 3 -53 25
-62 43 -56 118 7 87 10 90 122 97 122 8 260 -31 237 -67 -7 -12 3 -36 24 -53
20 -17 37 -55 38 -84 0 -30 16 -74 36 -100 47 -62 25 -391 -29 -433 -51 -40
-23 -118 55 -154 35 -16 74 -57 87 -92 31 -81 103 -51 150 63 28 68 26 83 -19
132 -46 51 -60 316 -27 533 2 15 -28 69 -69 119 -61 77 -83 89 -141 77 -42 -9
-69 -4 -69 12 0 15 14 28 31 29 17 1 54 8 82 16 71 20 195 19 248 -1 42 -16
42 -22 7 -61 -64 -71 -79 -172 -30 -200 37 -20 42 -65 39 -316 -4 -260 2 -300
49 -366 59 -83 182 -104 209 -35 10 26 32 34 63 24 79 -25 93 48 82 440 -9
363 -10 366 -82 445 -40 44 -73 91 -73 104 0 12 -20 24 -44 25 -221 12 -636
28 -706 28 -48 -1 -374 0 -725 0 -351 1 -921 0 -1267 -1 -601 -3 -631 -1 -645
45 -9 26 -53 81 -100 122 -80 70 -96 74 -305 74 -121 -1 -238 -10 -260 -22
-66 -34 -147 1 -141 60 3 33 -11 56 -38 62 -66 13 -54 -72 18 -141 34 -32 72
-52 84 -44 13 8 76 -2 140 -21 65 -19 156 -29 203 -21 110 17 110 -19 0 -78
-102 -55 -230 -33 -417 71 -181 101 -288 294 -141 255 46 -12 49 -4 34 89 -13
76 -6 113 24 146 37 42 36 47 -12 73 -29 15 -52 46 -52 68 0 22 -19 54 -42 70
-53 39 -26 113 41 113 28 0 63 21 79 46 27 43 31 43 88 -9 32 -31 59 -74 59
-96z m-4056 70 c13 -96 -35 -127 -91 -60 -47 57 -47 64 -9 93 53 41 92 28 100
-33z m6537 6 c37 -59 18 -92 -53 -92 -83 0 -141 56 -118 115 17 45 137 29 171
-23z m3719 -64 c0 -52 8 -103 19 -113 10 -11 19 -49 20 -86 2 -36 7 -83 13
-104 9 -30 -33 -38 -247 -43 l-257 -6 -25 66 c-54 142 15 200 112 96 57 -62
63 -63 89 -21 18 28 34 35 41 18 41 -95 74 -114 142 -83 79 36 101 205 31 232
-45 17 -50 94 -9 135 45 45 71 12 71 -91z m-1905 10 c61 -18 63 -71 3 -81 -48
-8 -180 112 -159 145 11 17 30 14 57 -10 23 -20 67 -44 99 -54z m583 -150 c1
-14 4 -48 6 -75 3 -43 22 -50 139 -50 92 0 139 -11 147 -35 18 -56 -34 -69
-238 -59 -215 10 -261 11 -488 10 -86 0 -286 1 -444 4 l-287 5 6 65 c6 58 -4
68 -83 83 -108 20 -102 73 10 84 53 6 84 -4 94 -30 10 -27 35 -34 87 -23 72
14 106 -26 42 -49 -55 -20 4 -52 87 -48 45 2 137 5 205 6 128 3 250 50 272
105 8 21 32 8 71 -39 53 -63 69 -68 165 -53 140 23 155 54 59 128 -73 58 -103
150 -61 192 19 19 206 -179 211 -221z m12897 156 c75 -122 63 -150 -36 -87
-109 70 -117 137 -20 166 4 1 29 -35 56 -79z m-21120 26 c-36 -36 -39 -70 -6
-70 29 0 246 -145 305 -204 24 -24 90 -68 147 -96 81 -42 97 -60 75 -87 -50
-60 138 -333 192 -279 20 21 -64 231 -107 267 -81 68 38 121 153 69 61 -28 65
-39 51 -144 -14 -111 -11 -117 124 -260 147 -155 157 -192 59 -219 -36 -10
-43 -18 -19 -20 23 -1 76 -36 117 -77 58 -58 98 -75 172 -75 116 0 157 -35
157 -132 0 -78 209 -342 271 -343 45 0 179 -129 163 -156 -8 -12 -41 -32 -74
-45 -58 -22 -84 -74 -37 -74 13 0 68 -46 123 -102 l99 -101 17 76 c20 89 50
98 94 27 21 -33 58 -50 112 -50 59 0 92 -17 122 -62 93 -142 153 -63 167 220
11 207 42 301 86 257 11 -10 23 -128 28 -261 5 -133 18 -252 31 -265 55 -57
-130 -127 -187 -70 -41 41 -340 22 -340 -21 0 -41 115 -173 151 -173 54 0 299
-232 299 -284 0 -31 10 -67 22 -80 36 -39 108 -283 91 -310 -26 -43 -212 -32
-230 13 -23 62 27 96 92 61 145 -78 78 36 -175 297 -151 156 -275 304 -275
330 0 25 -25 59 -56 75 -67 35 -354 326 -436 443 -32 45 -58 115 -58 154 0 52
-15 77 -53 89 -65 21 -172 112 -173 148 -2 62 -98 146 -134 116 -41 -34 -53
-20 -77 92 -13 60 -34 85 -84 97 -85 20 -241 178 -263 267 -11 42 -43 78 -83
94 -61 23 -255 209 -362 348 -27 34 -108 124 -180 200 -180 188 -228 268 -190
314 17 20 48 36 70 36 30 0 32 -7 9 -30z m2795 -46 c0 -42 22 -118 48 -170 67
-132 40 -163 -139 -157 -80 3 -157 16 -170 29 -27 27 -13 31 102 25 102 -6
130 40 48 78 -53 24 -72 21 -114 -17 -49 -44 -52 -44 -99 6 -54 59 -43 82 39
82 32 0 69 20 82 44 21 37 33 39 76 12 73 -44 77 -41 77 57 0 48 11 87 25 87
14 0 25 -34 25 -76z m1042 12 c8 -22 -3 -57 -24 -79 -49 -48 -118 -25 -118 40
0 76 115 108 142 39z m2727 -44 c68 -61 71 -92 10 -92 -57 0 -165 112 -142
149 19 30 50 17 132 -57z m4950 -5 c219 -76 304 -155 305 -285 1 -89 -57 -177
-115 -177 -19 0 -34 -16 -34 -36 0 -48 -36 -68 -87 -48 -29 11 -39 36 -31 75
15 79 -42 77 -112 -3 -30 -35 -69 -63 -88 -63 -18 0 -55 -37 -82 -81 -68 -115
-267 -237 -322 -198 -126 91 -236 97 -248 14 -15 -103 115 -139 382 -104 40 5
53 -12 63 -81 11 -79 20 -87 88 -82 41 3 101 7 133 9 86 6 105 -29 84 -152
-18 -109 -20 -111 -118 -113 -55 -1 -116 -7 -137 -13 -26 -8 -40 10 -45 57
-10 84 -73 91 -104 13 -20 -49 -23 -45 -24 36 -1 51 9 99 23 108 31 18 -13
109 -61 127 -56 22 -176 -107 -141 -150 23 -28 19 -46 -24 -86 -50 -46 -51
-57 -20 -142 18 -52 50 -100 71 -107 21 -8 50 -31 65 -51 24 -32 32 -31 55 11
27 47 28 47 63 -2 40 -53 117 -19 117 53 0 59 75 37 106 -32 27 -60 23 -71
-47 -131 -92 -78 -133 -213 -72 -237 23 -9 46 0 54 22 8 21 46 37 85 37 78 0
174 123 174 222 0 73 62 92 137 43 34 -22 74 -40 89 -40 40 0 122 -104 123
-156 1 -50 51 -61 51 -11 0 54 49 85 114 73 50 -10 58 -22 46 -71 -13 -49 -6
-60 36 -60 68 0 88 37 40 76 -31 26 -32 36 -6 53 67 42 101 24 84 -44 -10 -42
-2 -87 24 -126 22 -34 44 -124 50 -201 12 -171 -8 -155 218 -174 200 -17 219
-34 219 -200 0 -47 -76 -43 -112 7 -20 27 -47 35 -84 23 -56 -18 -72 -75 -29
-101 37 -23 30 -63 -10 -63 -20 0 -68 34 -107 75 -38 41 -95 75 -125 75 -68 0
-136 91 -119 161 14 58 -141 239 -205 239 -24 0 -34 19 -29 56 7 51 -6 57
-141 75 -179 22 -223 -4 -144 -89 58 -61 74 -142 28 -142 -15 0 -22 -14 -17
-31 6 -17 38 -31 71 -31 88 0 77 -79 -19 -140 l-79 -51 -64 94 c-60 88 -61 97
-23 139 51 56 16 136 -95 218 l-73 54 -61 -70 c-69 -79 -75 -97 -35 -121 19
-12 17 -24 -7 -39 -55 -35 -142 -25 -166 19 -34 60 -75 21 -61 -56 10 -49 4
-63 -22 -55 -19 7 -34 33 -34 60 0 26 -10 62 -21 79 -11 17 -13 54 -4 82 12
40 0 56 -59 76 -41 15 -81 43 -89 64 -13 32 -27 29 -90 -16 -44 -31 -94 -47
-121 -39 -27 9 -60 -1 -77 -21 -26 -32 -46 -28 -145 24 -89 48 -159 63 -311
67 -196 7 -243 35 -173 108 13 13 26 57 29 99 11 144 2 162 -77 162 -50 0 -75
13 -75 38 0 24 -24 37 -69 37 -38 0 -99 16 -136 35 -36 20 -101 43 -143 52
-42 9 -77 26 -77 36 0 31 79 186 118 231 24 28 27 46 9 57 -36 22 -77 -5 -77
-50 0 -20 -17 -36 -38 -36 -21 0 -45 -17 -53 -37 -8 -21 -27 -38 -43 -38 -16
0 -43 -22 -60 -50 -17 -27 -52 -50 -78 -50 -26 0 -61 -17 -78 -37 -41 -50 -65
-48 -125 12 -72 72 -109 64 -92 -21 15 -73 -58 -229 -108 -229 -14 0 -25 -22
-25 -49 0 -51 -67 -101 -136 -101 -37 0 -37 7 -1 75 21 41 54 75 74 75 30 0
30 10 -1 69 -49 94 -46 106 27 106 65 0 82 45 34 93 -38 38 -10 107 43 107 23
0 74 34 114 75 39 41 86 75 104 75 17 0 45 13 62 30 23 23 37 23 60 0 47 -47
94 -35 124 31 17 38 58 68 104 78 68 15 72 21 34 48 -23 17 -42 44 -42 60 0
42 74 34 91 -9 18 -48 52 -48 146 1 49 26 105 33 166 23 57 -10 111 -3 143 16
43 27 59 25 103 -14 97 -88 18 -277 -105 -250 -42 9 -69 4 -69 -12 0 -15 11
-27 25 -27 14 0 25 -11 25 -25 0 -14 -23 -25 -51 -25 -28 0 -61 -24 -75 -56
-13 -31 -38 -76 -55 -100 -42 -58 10 -117 64 -73 20 17 54 23 76 14 28 -10 56
12 92 74 29 49 72 94 95 101 78 22 251 -3 316 -45 l63 -41 -55 -76 c-55 -74
-56 -74 -76 -20 -15 39 -28 48 -47 29 -19 -19 -18 -43 3 -82 22 -42 22 -71 0
-125 -16 -39 -26 -90 -21 -113 8 -41 166 -111 253 -112 25 0 51 -16 58 -36 35
-89 233 -22 237 81 1 32 8 28 29 -14 35 -73 65 -62 108 39 37 88 8 107 -87 56
-35 -18 -57 -12 -90 25 -25 27 -68 49 -97 49 -91 1 -110 33 -118 205 -13 245
71 298 129 83 9 -33 39 -53 84 -59 94 -11 123 22 92 102 -18 48 -16 72 8 92
18 15 28 55 21 90 -16 85 -231 96 -231 11 0 -63 -63 -90 -113 -49 -23 20 -79
27 -150 19 -127 -15 -138 6 -69 126 53 93 19 146 -107 169 -118 23 -188 136
-83 136 45 0 197 130 197 168 0 27 18 34 61 26 52 -10 67 3 98 78 40 100 161
187 214 154 26 -16 24 -25 -12 -45 -62 -35 -6 -170 96 -231 67 -41 69 -47 27
-71 -37 -21 -40 -32 -15 -57 24 -25 38 -25 61 -2 39 39 70 38 70 -1 1 -63 45
-98 150 -122 95 -21 114 -18 165 31 64 60 56 107 -14 85 -24 -8 -58 3 -76 24
-18 22 -72 38 -128 38 -80 0 -97 9 -97 50 0 57 10 60 76 25 52 -28 99 28 99
119 0 27 23 69 50 94 110 99 -15 123 -171 33 -66 -38 -114 -49 -162 -37 -81
20 -83 39 -14 113 51 55 65 57 344 45 227 -10 301 -5 339 22 59 44 52 44 183
-2z m-5521 -59 c44 -62 46 -75 14 -87 -64 -25 -40 -63 51 -80 94 -18 107 -38
53 -83 -25 -20 -55 -22 -100 -4 -36 13 -102 23 -147 22 -446 -12 -1919 -4
-1934 11 -55 54 54 72 406 67 1237 -18 1486 -13 1525 30 30 33 32 53 10 94
-61 115 44 140 122 30z m-4738 7 c8 -21 15 -64 15 -95 0 -30 13 -68 29 -84 21
-21 20 -48 -4 -106 -40 -96 42 -205 149 -199 165 11 245 -27 126 -58 -28 -7
-50 -31 -50 -53 0 -48 10 -49 115 -11 99 36 160 -1 160 -97 0 -51 10 -60 50
-50 27 7 56 3 64 -9 8 -13 80 -23 161 -23 81 0 154 -11 163 -25 9 -15 -21 -25
-73 -25 -111 0 -120 -17 -75 -148 45 -130 126 -206 203 -189 38 9 63 -3 83
-39 53 -100 99 -13 99 187 0 120 12 196 37 228 58 75 86 5 84 -205 -3 -211 8
-234 107 -234 62 0 81 15 113 93 37 88 41 90 74 45 19 -26 35 -56 35 -66 0
-10 34 -25 75 -34 91 -20 97 -73 15 -126 -54 -35 -75 -36 -182 -5 -84 24 -155
28 -233 13 -62 -11 -157 -14 -211 -5 -121 20 -551 18 -616 -3 -45 -14 -66 2
-210 163 -25 28 -29 75 -17 175 17 131 21 137 86 130 73 -7 95 47 37 93 -17
13 -79 65 -136 115 -153 131 -271 120 -269 -25 1 -55 11 -120 22 -144 16 -36
7 -44 -46 -44 -70 0 -74 20 -77 450 -1 76 -11 191 -22 256 -16 86 -13 130 9
157 40 48 91 47 110 -3z m19476 18 c16 -27 -56 -92 -77 -70 -21 21 9 92 39 92
13 0 30 -10 38 -22z m-11911 -67 c0 -20 13 -58 29 -83 46 -73 9 -128 -86 -128
-87 0 -143 37 -143 93 0 23 20 28 65 17 60 -16 62 -13 32 36 -29 46 -27 57 16
89 54 40 87 31 87 -24z m-3850 14 c43 -29 -3 -74 -75 -74 -72 0 -118 45 -75
74 21 13 54 24 75 24 21 0 54 -11 75 -24z m-5305 -203 c9 -123 5 -151 -23
-141 -24 8 -32 46 -27 121 5 82 -4 118 -38 142 -38 29 -39 36 -7 56 58 36 83
-10 95 -178z m7101 131 c37 -25 92 -54 124 -64 32 -10 53 -31 48 -47 -10 -30
-530 -49 -674 -25 -67 12 -68 13 -25 72 51 70 98 76 160 20 41 -37 51 -37 132
1 48 23 94 52 102 66 22 36 59 30 133 -23z m-6971 -75 c0 -26 7 -82 16 -125
12 -61 7 -78 -24 -78 -43 0 -83 147 -58 212 20 54 66 47 66 -9z m4020 17 c17
-16 30 -38 30 -49 0 -36 -164 -49 -238 -19 l-74 30 100 32 c129 41 146 42 182
6z m-2073 -30 l60 -33 -65 -12 c-35 -7 -107 -5 -159 3 -87 15 -91 19 -45 46
65 38 135 37 209 -4z m641 0 c45 -33 39 -37 -71 -53 -192 -29 -488 22 -378 66
87 33 398 25 449 -13z m-3038 -27 c34 -41 19 -46 -69 -22 -31 8 -56 25 -56 37
0 36 91 25 125 -15z m3377 -138 c114 0 114 0 112 -86 -1 -79 -10 -88 -105
-115 -57 -16 -138 -22 -179 -13 -71 16 -75 23 -67 122 4 57 8 109 10 114 1 5
27 2 58 -6 31 -9 108 -15 171 -16z m6945 9 c65 -13 73 -22 49 -51 -41 -50
-240 -9 -207 44 16 27 51 29 158 7z m-7322 -124 c0 -73 -41 -85 -290 -85 -220
0 -261 21 -225 114 12 32 57 38 265 32 238 -7 250 -10 250 -61z m4134 38 c359
1 715 8 791 16 76 8 226 4 335 -10 127 -16 278 -17 423 -2 142 15 256 15 312
-1 48 -13 99 -17 112 -9 32 19 866 18 885 -1 77 -77 -266 -131 -558 -87 -134
20 -193 20 -217 -1 -54 -44 -4368 -29 -4385 16 -24 60 13 64 646 72 346 4 635
14 644 23 8 9 92 8 187 -1 94 -9 465 -16 825 -15z m5406 -17 c8 -24 30 -73 49
-110 20 -36 36 -84 36 -106 0 -30 26 -40 107 -40 142 0 227 -59 210 -147 -34
-168 -35 -165 63 -173 51 -4 114 3 140 17 39 21 57 13 100 -45 52 -71 52 -72
4 -167 -27 -53 -49 -110 -49 -128 0 -42 -29 -41 -89 5 -27 20 -69 37 -94 37
-25 1 -63 19 -85 40 -27 28 -47 31 -65 13 -80 -80 -156 9 -184 214 -8 60 -26
109 -39 109 -15 0 -18 -44 -8 -112 14 -91 10 -113 -20 -113 -60 0 -116 28
-116 58 0 74 -116 315 -156 326 -75 19 -81 9 -86 -134 -2 -76 -14 -194 -26
-262 l-22 -125 -17 93 c-10 52 -25 134 -33 183 -14 78 -24 88 -82 83 -74 -8
-203 67 -203 117 0 60 53 68 121 19 91 -67 149 -86 168 -55 9 14 -3 40 -27 57
-43 31 -16 144 32 137 94 -14 231 86 231 168 0 92 114 125 140 41z m-12441
-43 c25 -29 18 -47 -34 -96 -43 -40 -65 -86 -65 -137 0 -42 -11 -84 -25 -92
-14 -9 -25 -46 -25 -83 -1 -87 -36 -147 -62 -106 -25 41 9 252 51 319 20 30
36 66 36 79 0 48 49 153 71 153 13 0 37 -16 53 -37z m-436 -14 c18 -28 -30
-99 -66 -99 -12 0 -22 28 -22 63 0 63 57 86 88 36z m968 -44 c58 -50 56 -161
-4 -216 -46 -41 -49 -41 -79 15 -18 32 -39 92 -47 134 -12 58 -30 76 -83 82
-37 5 -68 19 -68 31 0 35 232 -3 281 -46z m-358 -68 c22 -21 67 -59 101 -84
53 -41 57 -53 28 -88 -68 -82 -197 -19 -170 85 7 27 3 56 -9 64 -27 16 -31 61
-6 61 9 0 34 -17 56 -38z m3278 -50 c17 -22 55 -36 84 -32 43 6 52 -5 48 -61
-5 -77 110 -180 174 -155 20 8 74 -2 121 -21 l85 -35 -125 -19 c-69 -10 -140
-31 -158 -45 -22 -19 -63 -17 -137 5 -58 18 -116 34 -128 37 -13 2 -26 32 -30
65 -4 34 -15 98 -24 142 -28 136 22 201 90 119z m985 -73 c-51 -79 -10 -150
75 -129 65 16 127 -19 102 -59 -11 -17 8 -58 44 -97 70 -74 111 -215 70 -240
-14 -9 -66 23 -115 72 -49 49 -105 89 -126 89 -20 0 -47 25 -60 56 -69 174
-86 319 -38 319 17 0 39 25 48 56 10 32 23 43 30 27 7 -17 -7 -59 -30 -94z
m-3522 25 c46 -70 30 -114 -40 -114 -50 0 -92 100 -62 149 26 42 59 31 102
-35z m-383 -296 c11 -113 -35 -218 -96 -218 -40 0 -47 40 -10 63 14 8 25 83
25 167 0 180 62 171 81 -12z m4528 48 c34 -148 -74 -200 -113 -54 -10 39 -32
79 -48 89 -48 30 2 77 72 69 54 -6 70 -26 89 -104z m2901 88 c22 -36 -15 -129
-51 -129 -43 0 -70 61 -50 113 15 40 80 50 101 16z m-2103 -45 c99 -51 120
-81 102 -151 -23 -91 63 -205 178 -237 182 -49 27 -66 -425 -46 -456 20 -502
29 -567 110 -35 43 -48 47 -75 20 -27 -28 -24 -39 14 -68 25 -18 39 -46 30
-60 -19 -31 -89 -37 -89 -8 0 10 -34 38 -75 61 -53 30 -75 62 -75 106 0 77 64
87 88 14 18 -58 87 -68 87 -12 0 20 10 37 23 37 13 0 47 39 77 88 63 102 125
115 125 26 0 -81 40 -103 59 -33 12 45 21 49 46 24 25 -25 25 -42 -2 -84 -45
-73 -17 -84 213 -83 192 0 196 1 220 71 26 73 21 82 -98 154 -26 15 -35 40
-25 68 22 55 67 56 169 3z m293 16 c31 -17 52 -17 62 0 20 32 113 33 113 1 0
-13 -24 -40 -52 -60 -86 -60 -52 -130 60 -123 88 5 92 3 76 -60 -15 -59 -11
-64 40 -51 33 9 82 -1 116 -24 68 -44 135 -29 135 30 0 22 11 33 25 25 14 -9
25 -36 25 -61 0 -25 25 -62 56 -83 53 -35 51 -37 -66 -55 -177 -26 -435 29
-445 95 -5 31 -35 57 -78 69 -121 32 -151 71 -99 129 28 32 34 54 17 60 -64
22 -116 77 -100 104 22 36 54 37 115 4z m737 -25 c27 -84 -9 -103 -87 -46 -82
60 -77 96 12 96 38 0 65 -18 75 -50z m2325 -50 c-8 -14 -26 -25 -38 -25 -28 0
-32 83 -7 109 24 24 65 -53 45 -84z m-8285 -160 c58 -9 116 -7 128 5 33 33
169 4 194 -43 48 -89 -4 -107 -311 -104 -344 3 -338 1 -338 127 0 132 60 167
153 89 37 -31 115 -65 174 -74z m5718 66 c10 -67 -2 -69 -83 -16 -82 54 -79
90 7 80 49 -5 71 -23 76 -64z m13221 7 c64 -32 184 -162 184 -199 0 -25 -122
-15 -137 11 -9 14 -49 25 -89 25 -77 0 -121 81 -90 162 18 47 39 47 132 1z
m-14229 -37 c20 -32 -74 -79 -123 -61 -73 28 -39 85 51 85 31 0 64 -11 72 -24z
m-5787 -77 c0 -31 -17 -49 -46 -49 -69 0 -80 24 -33 73 49 52 79 43 79 -24z
m4114 35 c39 -25 88 -35 134 -26 48 10 83 2 103 -22 17 -20 52 -36 79 -36 77
0 145 -48 145 -102 0 -46 11 -49 107 -35 125 19 239 -47 210 -122 -27 -70
-160 -52 -246 34 -41 41 -96 75 -121 75 -26 0 -63 17 -84 38 -45 44 -115 47
-242 9 -115 -35 -249 40 -249 138 0 100 59 118 164 49z m4036 -271 c0 -145 -9
-263 -20 -263 -51 0 -76 58 -51 122 13 36 17 129 8 208 -9 78 -9 154 0 169 45
72 63 3 63 -236z m-7665 130 c84 -62 28 -168 -88 -168 -107 0 -123 29 -46 83
31 22 44 50 34 76 -19 50 36 55 100 9z m12187 -78 c33 -25 86 -33 316 -47 105
-6 181 -50 412 -242 76 -63 171 -133 213 -156 55 -31 80 -68 94 -141 22 -110
80 -142 185 -102 101 38 130 28 192 -71 33 -52 101 -117 152 -144 84 -45 91
-56 74 -124 -30 -124 -20 -211 30 -266 44 -49 44 -53 3 -83 -53 -39 -55 -73
-7 -113 47 -39 147 -9 129 39 -17 45 35 45 123 0 39 -21 102 -30 150 -23 81
14 84 10 160 -153 42 -92 77 -177 77 -190 0 -12 19 -32 43 -46 28 -15 41 -49
37 -97 -7 -103 77 -179 149 -134 42 26 58 25 94 -8 67 -60 102 -47 102 39 0
46 18 93 44 112 63 48 81 43 81 -23 0 -35 35 -91 88 -139 79 -72 98 -106 90
-159 -2 -11 18 -19 44 -19 40 0 46 -17 40 -126 -5 -114 -1 -124 43 -110 37 12
48 5 44 -30 -9 -85 1 -99 89 -131 153 -55 88 -197 -78 -170 -65 10 -123 3
-170 -21 -92 -48 -98 -47 -83 13 10 37 1 50 -35 50 -27 0 -55 17 -63 38 -16
41 -84 51 -84 12 0 -14 -34 -25 -75 -25 -50 0 -75 -12 -75 -37 0 -21 9 -38 21
-38 11 0 34 -26 51 -58 18 -32 65 -68 107 -81 91 -28 96 -70 11 -81 -80 -10
-190 -114 -190 -179 0 -85 -171 -55 -274 48 -94 94 -68 145 80 156 72 6 157
-1 188 -14 55 -24 105 -7 73 25 -16 17 -78 26 -214 31 l-85 3 16 116 c20 146
56 192 135 172 48 -12 58 -6 52 30 -6 29 -36 47 -87 52 -53 5 -86 26 -105 69
-32 70 -104 82 -105 17 0 -24 -17 -65 -37 -92 -53 -70 -46 -122 27 -190 65
-61 74 -149 17 -168 -19 -6 -38 21 -47 67 -20 100 -35 107 -121 62 -40 -20
-90 -34 -111 -30 -22 3 -55 -4 -74 -15 -57 -36 -126 78 -111 184 7 49 3 77 -9
62 -11 -15 -40 -34 -64 -43 -24 -9 -44 -39 -44 -67 0 -28 -11 -51 -25 -51 -14
0 -25 33 -25 73 0 102 -44 208 -81 195 -18 -5 -28 -35 -23 -66 4 -30 -5 -70
-20 -89 -20 -23 -20 -39 -2 -50 47 -29 27 -82 -36 -94 -71 -14 -138 65 -138
162 0 39 -46 99 -144 184 -193 168 -201 172 -258 121 -57 -52 -61 -105 -11
-160 53 -59 22 -151 -52 -151 -40 0 -71 -24 -97 -75 -22 -41 -50 -75 -63 -75
-13 0 -17 -34 -9 -75 14 -70 10 -75 -61 -75 -56 0 -93 -21 -140 -81 l-63 -81
-52 56 c-64 69 -128 71 -187 7 -44 -49 -46 -49 -139 25 -51 40 -101 102 -109
136 -14 55 -30 63 -122 62 l-105 0 62 -49 63 -48 -83 -17 c-112 -23 -87 -70
45 -85 134 -15 153 -59 50 -113 -61 -31 -86 -34 -114 -11 -20 17 -58 24 -85
17 -33 -9 -54 2 -64 33 -17 54 -271 187 -310 163 -14 -9 -69 -8 -120 1 l-94
18 68 23 c87 29 88 59 2 80 -36 10 -125 75 -196 147 -231 232 -366 302 -413
215 -32 -60 -71 -60 -143 1 -73 61 -71 121 4 140 33 8 66 37 73 63 7 28 34 48
65 48 30 0 57 14 62 31 56 210 116 241 379 196 166 -29 236 -18 236 38 0 59
44 39 60 -27 9 -35 32 -63 52 -63 56 0 71 -49 29 -96 -26 -29 -31 -54 -15 -80
33 -53 29 -143 -7 -156 -25 -9 -25 -18 0 -45 25 -27 31 -26 31 9 0 24 11 43
24 43 40 0 103 145 96 219 -6 59 3 70 64 77 70 8 71 7 54 -94 -17 -102 30
-148 76 -74 12 19 25 16 41 -12 27 -49 95 -55 95 -8 0 18 -39 70 -87 117 -97
93 -113 150 -43 150 25 0 59 14 76 31 25 25 35 24 52 -4 13 -20 44 -28 75 -20
38 10 79 -11 146 -75 52 -48 119 -105 150 -125 79 -53 75 -168 -6 -222 -71
-46 -82 -85 -25 -85 20 0 37 16 37 36 0 54 97 75 146 31 23 -20 63 -41 89 -46
52 -9 84 -157 40 -184 -14 -8 -25 -43 -25 -77 0 -65 -77 -117 -95 -64 -6 20
-38 25 -93 15 -175 -33 -271 157 -188 374 26 69 21 75 -79 99 -53 13 -70 6
-83 -35 -13 -42 -30 -49 -89 -36 -100 22 -137 -6 -84 -65 38 -42 39 -49 3 -62
-74 -29 -129 0 -143 77 -16 90 -108 94 -172 7 -139 -191 -142 -266 -13 -325
58 -26 65 -42 54 -119 l-12 -88 108 -3 c126 -3 175 81 97 166 -45 50 -32 125
30 177 33 28 49 21 105 -48 37 -44 80 -80 96 -80 16 0 37 -22 46 -50 9 -29 37
-50 67 -50 28 0 97 -13 151 -30 90 -27 104 -25 137 19 21 27 42 37 48 24 32
-81 53 -93 108 -63 35 18 51 46 44 73 -6 26 9 57 37 74 30 19 42 47 33 75 -8
27 6 62 35 89 46 42 50 41 93 -9 55 -64 84 -66 84 -7 0 25 10 56 23 69 53 54
0 154 -99 186 -53 18 -102 47 -109 66 -8 19 -38 34 -67 34 -45 0 -49 6 -23 38
37 44 104 48 144 8 39 -39 206 -95 206 -70 0 12 -12 28 -26 37 -16 10 -20 58
-10 123 14 94 10 109 -37 121 -68 17 -67 60 2 82 l54 17 -60 46 c-75 58 -127
62 -106 8 17 -44 -30 -84 -98 -85 -31 0 -48 27 -59 97 -21 132 -98 175 -212
118 -103 -51 -102 -51 -84 19 12 47 -1 71 -60 113 -87 62 -104 65 -104 19 0
-19 -17 -49 -37 -66 -47 -39 -23 -82 36 -63 59 19 93 -31 88 -132 -5 -103 -46
-150 -95 -109 -20 17 -53 23 -74 15 -21 -8 -47 0 -57 17 -11 18 -7 36 10 41
16 6 28 35 27 64 -1 54 -2 54 -29 -4 -24 -48 -42 -56 -103 -43 -94 18 -108 32
-71 69 17 17 30 46 30 65 0 19 28 69 63 110 68 81 63 120 -17 120 -39 0 -47
10 -33 44 10 24 23 63 30 87 18 63 77 54 87 -12 4 -32 29 -60 57 -65 27 -6 62
-27 77 -48 22 -30 38 -32 82 -8 30 16 74 26 98 22 32 -6 44 10 44 55 0 71 -90
100 -151 50 -19 -16 -45 -23 -58 -15 -37 23 -50 137 -18 164 37 30 211 20 234
-14 33 -48 197 -160 212 -144 33 33 146 -20 168 -79 13 -35 44 -62 69 -62 25
0 59 -13 75 -29 23 -23 50 -18 118 18 101 54 108 74 38 111 -27 15 -50 49 -50
77 0 27 -17 56 -37 64 -53 20 -48 132 6 151 24 8 80 42 124 75 l81 60 39 -94
c33 -78 34 -99 6 -120 -44 -33 -44 -473 -1 -516 41 -41 54 -1 64 191 4 82 18
152 32 154 13 3 21 -17 18 -44 -8 -65 27 -61 106 13 36 34 91 65 120 69 30 4
55 24 55 45 0 21 -17 35 -38 32 -54 -7 -262 178 -240 214 26 42 90 36 90 -8 0
-21 11 -38 25 -38 37 0 31 41 -12 84 -21 21 -38 50 -38 65 0 15 -28 40 -62 56
-35 15 -63 49 -63 74 0 25 -17 46 -37 46 -21 0 -38 -22 -38 -50 0 -27 -10 -50
-23 -50 -13 0 -31 -23 -40 -51 -22 -70 -145 -59 -158 14 -5 27 -25 67 -44 89
-24 27 -27 46 -8 65 19 19 19 42 2 74 -14 25 -31 66 -39 90 -7 24 -36 44 -64
44 -54 0 -68 -36 -26 -63 45 -27 -2 -65 -58 -47 -67 21 -91 55 -92 129 0 32
-15 56 -36 56 -19 0 -57 28 -85 63 -27 34 -67 62 -89 62 -22 0 -40 20 -40 46
0 25 -22 67 -50 92 -27 24 -50 60 -50 78 0 41 -30 44 -68 6 -17 -17 -48 -21
-74 -9 -25 10 -91 22 -146 27 -137 10 -237 51 -237 97 0 25 24 38 74 38 40 0
80 11 88 24 16 26 79 10 135 -34z m-8972 -176 c0 -8 22 -36 50 -64 28 -27 50
-67 50 -87 0 -57 121 -78 159 -27 33 47 209 48 197 2 -11 -42 -235 -97 -387
-95 -187 2 -195 -57 -32 -217 106 -104 114 -108 158 -68 26 23 65 42 88 42 50
0 52 10 13 72 -40 65 -11 132 48 109 154 -62 243 -205 172 -276 -36 -35 -93
-42 -334 -42 -334 0 -347 -10 -220 -162 84 -101 114 -207 66 -237 -12 -7 -30
-77 -40 -155 -10 -78 -23 -157 -30 -175 -20 -50 -102 -41 -132 14 -33 62 -34
405 -1 576 14 72 16 144 6 160 -28 43 -29 724 0 759 22 28 169 -83 169 -129z
m-917 47 c33 -103 83 -153 170 -170 55 -11 73 -28 67 -60 -7 -36 -30 -42 -133
-35 -176 13 -212 38 -212 149 1 201 60 264 108 116z m-1464 33 c85 -36 217
-182 195 -216 -8 -13 -57 -31 -108 -40 -143 -24 -168 -45 -127 -110 21 -34 47
-48 71 -37 135 58 259 8 178 -73 -42 -42 -34 -87 24 -145 46 -46 50 -70 34
-246 -11 -130 -7 -212 12 -248 41 -77 -14 -251 -90 -286 -32 -14 -58 -36 -58
-49 0 -43 52 -119 82 -119 17 -1 56 -28 88 -61 l57 -61 -107 -8 c-100 -7 -107
-12 -103 -76 3 -38 -6 -69 -20 -69 -14 0 -22 -25 -17 -56 9 -64 95 -95 95 -33
0 21 16 39 36 39 46 0 73 -42 39 -62 -14 -9 -25 -55 -25 -103 0 -54 -14 -92
-37 -101 -21 -8 -38 -40 -38 -71 0 -31 17 -71 38 -88 42 -35 49 -114 13 -137
-15 -9 -24 -185 -24 -427 1 -226 -6 -421 -13 -434 -8 -13 -4 -30 10 -39 14 -9
18 -62 10 -123 -8 -60 -3 -130 11 -155 17 -31 18 -62 1 -93 -19 -34 -14 -58
17 -92 32 -36 35 -57 13 -98 -38 -71 -59 -66 -173 38 -83 77 -95 101 -80 157
14 49 12 1515 -2 1666 -1 13 6 103 16 200 29 300 20 696 -21 856 -28 111 -32
174 -14 238 20 75 14 106 -40 209 -47 87 -61 143 -51 199 11 57 2 88 -36 122
-63 58 -63 91 0 145 28 23 50 59 50 80 0 46 0 46 94 7z m-375 -99 c35 -57 36
-76 8 -129 -22 -41 -27 -95 -16 -157 10 -52 4 -250 -13 -441 -30 -324 -29
-353 14 -433 25 -47 56 -85 68 -85 108 0 180 -222 118 -362 l-44 -100 -2 97
c-3 132 -94 306 -194 368 -46 28 -83 59 -83 68 -11 401 -4 1202 10 1225 29 47
88 25 134 -51z m9326 9 c7 -43 -4 -54 -56 -54 -83 0 -81 -29 10 -120 l73 -73
-62 -29 c-34 -15 -90 -28 -124 -28 -70 0 -78 -44 -32 -175 24 -70 22 -85 -14
-105 -39 -22 -36 -30 23 -85 46 -43 61 -75 48 -105 -10 -23 -17 -71 -15 -105
3 -84 -181 -219 -236 -173 -19 16 -35 43 -35 61 0 17 -17 45 -37 62 -32 26
-45 12 -87 -85 -78 -182 -217 -129 -195 75 11 92 5 108 -47 132 -69 31 -74 60
-20 114 54 54 104 49 137 -13 17 -32 43 -46 66 -37 23 9 57 -10 87 -48 75 -96
126 -78 188 62 49 111 51 129 17 162 -48 48 -109 49 -109 1 0 -55 -95 -94
-188 -77 -104 19 -155 75 -114 124 16 20 27 79 24 132 -6 95 46 207 128 278
28 25 30 36 6 46 -52 22 -35 59 28 59 33 0 74 -17 91 -37 17 -21 52 -38 78
-38 26 0 47 -17 47 -37 0 -60 68 -44 118 27 116 167 186 199 202 89z m-10162
-31 c-32 -32 -170 -21 -170 14 0 33 143 60 173 34 15 -13 14 -31 -3 -48z
m5057 22 c8 -13 -5 -38 -29 -55 -25 -19 -36 -45 -25 -62 13 -22 27 -23 51 -3
42 34 153 9 247 -57 42 -30 111 -50 170 -50 85 0 98 -7 88 -46 -8 -32 1 -47
29 -48 52 -1 139 -65 111 -82 -110 -68 -508 47 -625 181 -44 50 -62 57 -86 33
-61 -61 -84 -32 -79 100 3 72 6 133 7 134 5 13 130 -26 141 -45z m4405 4 c43
-70 16 -106 -53 -71 -73 38 -70 34 -52 81 21 56 66 52 105 -10z m-7845 0 c0
-14 30 -37 67 -51 62 -23 64 -28 26 -66 -38 -38 -46 -36 -105 27 -72 78 -80
116 -25 116 20 0 37 -12 37 -26z m2650 -15 c62 -8 123 -24 136 -36 13 -13 43
-23 67 -23 62 0 156 -166 105 -186 -69 -26 -100 -14 -129 49 -22 50 -41 60
-88 48 -71 -18 -266 30 -266 66 0 13 -28 35 -62 48 -100 38 -78 83 31 64 51
-9 144 -23 206 -30z m-3858 -90 c11 -17 21 -82 23 -144 1 -62 5 -191 8 -287 3
-102 -8 -211 -27 -259 -32 -79 -30 -86 35 -139 38 -30 69 -76 69 -103 -1 -40
-5 -42 -23 -14 -19 30 -30 31 -63 4 -48 -41 -50 -87 -4 -159 19 -31 34 -108
35 -172 0 -65 14 -156 31 -202 37 -101 5 -281 -50 -281 -43 0 -105 288 -87
411 13 91 -41 177 -152 240 -62 36 -69 66 -29 121 29 40 40 42 86 13 70 -44
77 -34 84 117 7 152 -10 184 -98 187 -67 1 -67 2 -11 29 34 16 56 49 56 85 0
59 -7 62 -161 70 -104 6 -60 58 66 79 l133 23 -7 175 c-6 186 3 237 42 237 13
0 33 -14 44 -31z m-634 -36 c19 -18 -53 -108 -87 -108 -11 0 -21 28 -21 63 0
60 66 88 108 45z m291 -91 c36 -65 35 -72 -9 -105 -56 -42 -85 -29 -116 53
-52 136 55 181 125 52z m21590 -90 c-18 -29 -139 -38 -139 -10 0 9 19 37 42
63 37 40 47 42 78 11 20 -20 28 -49 19 -64z m-19893 -14 c27 -35 61 -63 76
-63 16 0 28 -39 28 -86 0 -64 13 -90 50 -101 62 -20 64 -80 6 -146 -32 -36
-35 -52 -12 -60 17 -6 31 -33 31 -59 0 -27 14 -71 31 -98 39 -63 1 -134 -77
-145 -84 -13 -63 -63 50 -117 130 -63 134 -93 15 -121 -52 -12 -94 -30 -94
-40 0 -40 157 -164 208 -164 38 0 57 -18 63 -58 6 -46 21 -56 73 -50 91 11 94
49 7 134 -46 46 -75 100 -75 142 -1 78 40 90 89 25 30 -40 33 -38 34 23 1 36
-16 72 -36 80 -44 17 -51 105 -10 130 17 11 22 53 13 108 -16 98 49 311 90
297 14 -5 52 -95 85 -201 34 -106 72 -193 85 -193 13 0 24 -39 24 -87 0 -49
-11 -88 -25 -88 -14 0 -25 21 -25 47 0 60 -63 113 -113 94 -31 -12 -34 -26
-11 -67 15 -29 30 -167 33 -307 3 -153 18 -278 37 -313 28 -49 27 -65 -7 -102
-47 -52 -49 -87 -9 -150 23 -37 22 -69 -3 -146 -30 -91 -30 -153 2 -656 3 -34
0 -216 -4 -403 -9 -316 -5 -345 44 -408 53 -67 54 -67 85 -16 32 50 34 49 71
-30 49 -103 85 -103 95 1 5 44 19 81 32 81 23 0 32 -35 25 -94 -2 -17 5 -31
16 -31 26 0 133 233 115 249 -8 8 -20 -1 -26 -18 -18 -51 -98 -35 -182 36 -71
59 -78 76 -62 156 22 117 22 344 0 443 -11 49 -7 85 10 95 37 23 120 -79 141
-173 9 -42 31 -92 48 -113 48 -56 69 -144 39 -162 -46 -28 -28 -124 36 -192
53 -58 59 -83 47 -188 -8 -66 3 -208 23 -316 37 -194 37 -195 -17 -216 -103
-39 -202 -249 -145 -306 36 -36 40 -261 5 -282 -14 -9 -25 -34 -25 -55 0 -32
7 -34 38 -7 49 40 57 30 128 -144 69 -170 67 -157 28 -157 -18 0 -68 40 -113
88 -54 59 -81 75 -81 49 0 -54 49 -145 91 -169 19 -11 34 -41 34 -66 0 -25 17
-60 38 -77 42 -35 49 -114 12 -137 -55 -34 -20 -125 88 -229 133 -130 137
-145 33 -124 -108 21 -142 55 -212 208 -33 73 -73 132 -88 132 -55 0 31 -462
99 -530 16 -16 30 -50 30 -74 0 -24 15 -53 33 -64 59 -35 292 -363 292 -411 0
-79 -65 -51 -140 60 -39 59 -96 130 -126 160 -30 29 -58 79 -63 112 -6 40 -25
60 -58 60 -72 0 -78 -108 -12 -246 30 -65 47 -135 38 -163 -9 -27 4 -89 27
-139 39 -82 40 -93 4 -121 -71 -57 -73 -173 -3 -238 49 -45 58 -72 46 -130
-14 -64 -10 -71 37 -58 37 9 76 -8 126 -57 110 -105 95 -123 -102 -125 -96 -1
-188 -15 -203 -30 -33 -33 5 -161 65 -221 22 -21 39 -69 40 -106 0 -50 24 -81
99 -127 143 -89 158 -193 35 -249 l-62 -28 55 -73 c29 -41 47 -91 39 -113 -20
-50 -126 -51 -167 -1 -50 60 -94 43 -123 -46 -35 -104 23 -242 102 -242 59 0
121 -56 121 -110 0 -21 25 -51 55 -67 50 -27 51 -32 12 -60 -55 -40 -53 -54 8
-70 47 -13 69 -91 35 -125 -18 -17 -130 27 -187 74 -53 44 -98 42 -98 -4 0
-21 11 -38 25 -38 14 0 25 -29 25 -65 0 -35 21 -91 46 -123 38 -49 44 -97 39
-304 -6 -245 -6 -246 -72 -254 -80 -9 -102 -56 -62 -132 29 -54 32 -54 65 -10
40 56 33 66 106 -147 39 -111 62 -239 66 -362 7 -256 7 -253 52 -253 21 0 35
-14 29 -30 -6 -20 -56 -28 -143 -23 -118 6 -140 -1 -191 -60 -32 -37 -50 -83
-42 -105 12 -32 21 -29 55 15 l40 53 93 -63 c52 -35 96 -80 98 -100 2 -21 5
-51 6 -68 2 -19 -41 -36 -110 -44 -109 -12 -113 -15 -120 -104 -7 -78 4 -101
69 -149 56 -41 76 -77 76 -132 0 -52 21 -93 69 -131 52 -42 61 -62 40 -84 -32
-33 -134 6 -134 51 0 13 -39 24 -87 24 -96 0 -117 -45 -49 -101 151 -125 158
-524 9 -524 -65 0 -77 -39 -54 -174 17 -97 29 -113 100 -131 92 -24 115 -124
38 -167 -38 -21 -39 -31 -8 -89 25 -47 27 -73 8 -92 -48 -48 -88 3 -71 90 11
58 4 91 -25 114 -36 30 -40 25 -33 -40 4 -40 -2 -116 -13 -167 -30 -139 1
-277 59 -262 30 8 56 -8 77 -46 38 -72 16 -136 -48 -136 -70 0 -111 -155 -55
-214 57 -60 78 -222 33 -256 -52 -38 -74 -466 -27 -523 20 -23 18 -42 -4 -69
-17 -21 -24 -64 -16 -96 17 -68 -40 -167 -69 -120 -13 21 -25 4903 -16 6428 1
34 -5 662 -12 1394 -8 787 -4 1350 10 1375 14 26 14 99 1 181 -27 165 -34
1233 -10 1331 17 68 16 69 -108 69 -100 0 -136 12 -184 62 -32 34 -72 62 -88
63 -51 0 -59 121 -59 950 0 447 0 849 0 893 -1 155 -143 307 -286 307 -114 0
-274 234 -194 284 12 7 15 79 6 158 -9 80 -14 258 -11 396 5 242 3 252 -69
343 -72 92 -75 144 -8 144 19 0 56 -28 84 -62z m2992 9 c109 -65 83 -111 -49
-86 -73 13 -89 27 -89 78 0 75 22 76 138 8z m5711 17 c16 -20 76 -40 133 -44
94 -7 104 -15 125 -95 31 -121 61 -150 156 -150 75 0 82 -7 92 -89 11 -96 -17
-141 -41 -65 -18 57 -130 113 -153 77 -8 -14 -2 -41 13 -60 24 -28 15 -36 -41
-42 -102 -12 -103 -130 -2 -141 91 -11 99 -105 9 -105 -43 0 -64 -18 -76 -64
-17 -70 -64 -60 -64 14 0 63 -38 83 -79 42 -27 -27 -48 -27 -109 -3 -43 18
-91 22 -113 10 -60 -32 -104 11 -95 91 10 87 84 112 108 36 15 -45 21 -47 54
-14 48 48 84 48 153 -1 83 -58 113 -22 100 117 -11 116 -144 309 -144 210 0
-56 -55 -74 -88 -29 -46 62 -83 50 -140 -46 -103 -175 -230 -43 -143 148 28
61 110 108 139 80 25 -26 107 35 107 81 0 81 49 102 99 42z m-6145 -89 c30
-41 75 -81 101 -89 25 -8 45 -31 45 -50 0 -20 29 -61 64 -92 52 -45 62 -71 50
-135 -14 -70 -7 -81 58 -104 41 -14 99 -51 130 -82 52 -52 58 -53 88 -12 17
24 44 36 60 27 20 -13 16 -32 -13 -64 -23 -25 -35 -58 -25 -72 23 -39 88 -33
88 8 0 100 411 223 463 139 38 -61 -58 -147 -148 -132 -71 11 -103 0 -189 -69
l-104 -83 58 -45 c32 -24 94 -51 139 -60 47 -9 81 -31 81 -52 0 -24 -16 -31
-47 -21 -30 9 -52 0 -62 -24 -9 -25 -48 -38 -113 -38 -84 0 -102 10 -123 69
-28 78 -374 437 -513 531 -89 61 -118 131 -67 163 35 21 -16 112 -63 112 -21
0 -37 17 -37 39 0 21 -29 65 -65 98 -73 68 -62 113 28 113 38 0 81 -28 116
-75z m6942 -24 c5 -34 27 -75 49 -91 36 -26 36 -33 -3 -71 -23 -24 -42 -56
-43 -72 0 -16 -23 -2 -51 31 -29 35 -47 88 -43 125 6 54 -6 68 -74 88 -114 34
-101 52 38 52 107 0 119 -7 127 -62z m1793 37 c48 -38 48 -38 0 -75 -70 -55
-114 -47 -114 20 0 97 36 115 114 55z m1721 -50 c-48 -74 -85 -81 -85 -17 0
58 21 79 80 79 44 0 44 -4 5 -62z m-15013 -36 c42 -26 19 -102 -31 -102 -40 0
-74 67 -52 102 17 29 39 29 83 0z m5609 -73 c14 -14 17 -37 8 -52 -25 -40 -81
-33 -99 14 -14 36 -21 37 -59 4 -29 -24 -78 -33 -143 -25 -55 6 -147 12 -205
14 -113 4 -147 22 -121 66 22 34 583 15 619 -21z m601 21 c234 0 284 -28 223
-126 -22 -36 -18 -46 21 -57 120 -31 40 -67 -145 -65 -192 2 -193 2 -110 39
103 44 69 110 -55 107 -108 -2 -411 38 -430 58 -45 45 28 74 149 60 70 -9 226
-16 347 -16z m664 -13 c30 -30 -36 -49 -160 -48 -88 1 -139 -10 -147 -31 -19
-51 -64 -39 -64 17 0 31 21 54 56 61 31 7 79 17 107 24 53 12 188 -3 208 -23z
m-1926 -43 c10 -52 -68 -61 -115 -14 -49 49 -34 74 39 65 41 -4 71 -25 76 -51z
m3201 17 c107 -54 101 -59 -58 -53 -144 5 -158 12 -108 62 40 40 72 38 166 -9z
m273 10 c-17 -53 -90 -85 -121 -54 -16 16 -21 41 -12 56 23 37 146 35 133 -2z
m404 -6 c41 -50 -5 -74 -106 -55 -44 8 -95 4 -114 -7 -45 -29 -128 -6 -128 36
0 63 298 86 348 26z m3314 -106 c11 -61 34 -93 79 -110 79 -30 65 -84 -24 -94
-76 -9 -91 -74 -23 -95 24 -8 63 -24 87 -37 24 -13 82 -23 130 -23 61 0 98
-16 125 -56 60 -85 48 -102 -61 -84 -99 15 -100 15 -100 -63 0 -54 22 -98 71
-143 l71 -65 -65 -93 c-73 -106 -129 -119 -202 -46 l-51 51 61 23 c82 31 89
50 49 145 l-34 82 -102 -52 c-133 -68 -219 -48 -163 39 34 52 35 67 2 129 -46
89 -46 108 1 108 107 0 54 162 -61 187 -90 20 -117 78 -51 113 58 32 64 96 12
116 -64 24 -42 55 43 64 151 14 188 -3 206 -96z m-10874 -221 c10 -249 -9
-363 -59 -363 -25 0 -30 205 -13 471 19 290 60 228 72 -108z m8121 267 c7 -11
0 -47 -17 -80 -32 -65 -199 -96 -256 -48 -16 13 -48 17 -70 8 -23 -8 -41 -4
-41 9 0 44 71 86 119 70 25 -8 68 2 95 23 53 40 151 50 170 18z m2304 -44 c0
-26 -20 -52 -44 -56 -44 -9 -64 67 -27 104 30 29 71 1 71 -48z m1086 39 c11 0
28 -41 38 -91 16 -86 10 -98 -104 -200 -141 -127 -151 -129 -184 -45 -39 103
-29 131 51 149 65 14 75 27 75 97 0 93 20 122 69 103 20 -7 44 -13 55 -13z
m-5899 -51 c0 -11 7 -38 15 -59 12 -33 -4 -40 -86 -40 -108 0 -138 22 -114 84
22 58 185 72 185 15z m752 -26 c41 -41 39 -44 -36 -55 -43 -6 -106 1 -139 16
-46 21 -63 20 -71 -3 -6 -17 -38 -31 -73 -31 -39 0 -58 12 -51 31 6 17 35 29
65 25 30 -3 61 11 69 31 19 50 181 41 236 -14z m1868 -17 c10 -65 -56 -79 -80
-16 -25 66 -17 89 29 80 24 -4 47 -33 51 -64z m-2326 -25 c7 -20 -16 -31 -67
-31 -53 0 -77 12 -77 39 0 48 128 41 144 -8z m4371 -12 c65 -62 78 -119 28
-119 -80 0 -222 -129 -208 -188 9 -33 4 -66 -10 -74 -31 -20 -28 -35 -40 191
-10 190 -9 192 59 217 98 36 105 35 171 -27z m-2727 6 c9 -16 -50 -25 -162
-25 -101 0 -176 11 -176 25 0 14 70 25 161 25 89 0 168 -11 177 -25z m-8659
-125 c-53 -53 -92 -70 -156 -67 -101 5 -94 44 13 81 42 14 99 39 126 54 83 47
93 8 17 -68z m4044 -73 c63 -87 66 -142 10 -173 -37 -21 -38 -33 -8 -104 30
-73 29 -85 -10 -114 -65 -47 -73 -377 -10 -366 31 5 47 -17 59 -79 8 -47 48
-117 88 -156 79 -75 95 -135 37 -135 -43 0 -363 324 -364 368 0 52 -148 115
-189 81 -52 -44 -111 -10 -111 64 0 78 70 112 113 54 49 -68 106 -50 125 39
18 83 96 229 155 290 22 23 27 73 16 168 -18 156 9 175 89 63z m2939 49 c8
-13 32 -17 54 -9 32 13 36 4 22 -42 -17 -51 -12 -55 44 -41 41 10 73 3 93 -22
25 -30 24 -37 -6 -37 -21 0 -66 -22 -101 -50 -35 -27 -85 -50 -111 -50 -26 0
-85 -28 -132 -62 -123 -91 -208 -83 -275 25 -54 87 -108 110 -139 60 -11 -18
-49 -21 -108 -9 -350 74 -529 -24 -309 -169 112 -75 223 -99 264 -59 36 35
252 37 262 2 4 -14 -18 -29 -48 -34 -31 -5 -82 -25 -113 -46 -87 -57 -378 -55
-468 4 -92 61 -111 120 -93 288 l15 138 115 13 c64 7 135 28 157 47 25 21 69
28 117 18 42 -9 96 -6 119 6 59 31 149 -10 183 -83 38 -84 166 -113 216 -48
33 43 35 42 20 -22 -15 -64 15 -96 45 -48 7 11 44 17 83 12 81 -11 146 24 121
64 -9 15 -38 28 -65 28 -45 0 -99 67 -99 123 0 33 117 36 137 3z m849 2 c8
-13 84 -19 170 -14 137 9 148 6 88 -19 -39 -17 -69 -49 -69 -75 0 -59 134 -61
338 -4 82 23 178 44 212 46 34 3 87 18 117 34 30 16 90 29 134 29 l80 0 -18
-119 c-10 -65 -19 -120 -22 -123 -10 -10 -260 59 -308 86 -92 52 -108 37 -108
-95 0 -140 -43 -181 -132 -125 -44 27 -57 24 -94 -25 -25 -33 -54 -49 -72 -38
-17 11 -44 0 -63 -25 -55 -76 -118 -29 -85 64 22 63 19 86 -13 120 -22 23 -75
85 -118 136 -84 101 -145 115 -248 57 -134 -77 -430 -28 -395 65 16 41 581 64
606 25z m3864 -15 c0 -21 -22 -38 -50 -38 -50 0 -65 27 -33 58 30 31 83 18 83
-20z m10190 -7 c48 -62 44 -75 -39 -118 -46 -24 -79 -29 -89 -13 -8 14 3 25
26 25 33 0 38 15 25 75 -19 86 23 103 77 31z m-12629 -75 c-3 -51 -7 -114 -8
-139 -2 -34 -16 -41 -53 -29 -60 19 -72 -56 -12 -79 23 -9 37 -48 37 -105 1
-134 35 -179 93 -122 31 31 36 50 16 63 -16 9 54 20 155 24 197 7 243 -18 175
-93 -29 -32 -36 -66 -24 -117 25 -105 36 -117 71 -69 47 64 94 18 84 -84 -7
-78 1 -92 63 -113 90 -30 133 5 95 77 -34 63 7 102 129 121 95 16 193 -24 193
-78 0 -37 -86 -75 -121 -53 -46 28 -126 -62 -134 -152 -9 -112 -71 -160 -147
-113 -97 61 -160 -38 -80 -126 23 -26 43 -83 44 -127 0 -52 13 -79 36 -79 56
-1 88 -159 43 -209 -19 -23 -40 -64 -45 -91 -16 -85 -150 -68 -196 25 -66 130
-79 143 -106 116 -30 -30 -194 89 -194 140 0 17 -26 31 -59 31 -97 0 -201 48
-251 117 -97 133 76 166 285 55 48 -26 101 -47 118 -47 41 0 41 -31 1 -71 -38
-38 12 -78 99 -79 139 -1 156 242 26 351 -29 24 -40 55 -30 81 20 53 100 56
120 6 16 -43 91 -52 91 -12 0 58 -95 129 -150 112 -97 -31 -168 4 -185 93 -11
57 -43 100 -109 143 -101 67 -144 68 -212 8 -35 -32 -50 -33 -81 -7 -50 41
-49 179 3 481 l43 244 91 0 c91 0 92 -1 86 -94z m2254 7 c30 -123 -45 -192
-89 -82 -14 34 -23 41 -24 18 -3 -61 71 -148 155 -182 67 -28 79 -46 82 -125
3 -96 -46 -125 -107 -64 -15 15 -54 41 -86 57 -32 16 -62 51 -67 78 -5 27 -32
75 -61 106 -57 61 -30 181 41 181 19 0 49 17 66 38 45 53 72 46 90 -25z
m-7042 -23 c42 -50 79 -190 50 -190 -13 0 -23 13 -23 28 0 16 -28 55 -62 87
-35 32 -63 69 -63 84 0 38 64 32 98 -9z m8902 -14 c47 -36 55 -55 34 -77 -22
-22 -42 -16 -81 24 -29 28 -69 52 -89 52 -20 0 -43 11 -51 25 -28 45 122 25
187 -24z m3471 -34 c4 -24 -8 -42 -30 -42 -47 0 -75 41 -53 76 23 37 73 16 83
-34z m-11169 -65 c-28 -28 -78 -58 -112 -66 -34 -9 -81 -37 -105 -63 -52 -58
-75 -60 -94 -10 -10 26 6 47 47 62 34 13 62 41 62 61 0 21 31 45 69 53 38 8
91 24 119 34 68 28 76 -9 14 -71z m4478 14 c-4 -44 5 -66 28 -66 20 0 50 -17
67 -37 34 -42 175 -52 175 -14 0 13 -23 36 -51 51 -28 15 -44 38 -36 51 24 38
112 28 128 -15 9 -21 60 -61 115 -89 l99 -51 65 58 c36 32 83 79 104 104 38
44 42 44 112 -12 40 -31 96 -57 125 -58 40 0 53 -19 60 -88 4 -48 22 -104 40
-125 18 -21 39 -68 48 -105 11 -44 35 -69 72 -75 101 -14 86 -107 -21 -134
-118 -30 -160 -90 -102 -148 64 -63 51 -122 -36 -160 -43 -19 -84 -56 -91 -82
-15 -57 -18 -57 -156 11 -146 72 -148 128 -5 138 93 7 107 15 100 60 -9 66
-52 89 -199 107 -73 10 -141 38 -182 77 -37 33 -94 61 -127 61 -46 0 -65 17
-77 69 -9 38 -31 85 -49 106 -18 21 -44 69 -59 107 -18 46 -50 74 -98 83 -39
8 -104 41 -144 73 l-72 58 61 65 c73 78 116 70 106 -20z m-7306 -135 c0 -31
40 -99 87 -151 153 -170 133 -306 -28 -192 -74 51 -86 -18 -69 -375 8 -152 14
-298 13 -325 -1 -64 74 -263 98 -263 11 0 27 25 38 56 13 42 24 13 42 -116 34
-242 1 -313 -82 -183 -48 74 -72 91 -116 81 -48 -12 -60 2 -92 111 -46 157
-57 522 -17 596 19 37 27 185 24 449 -3 216 4 422 15 456 l21 63 32 -75 c18
-42 33 -101 34 -132z m5800 25 c1 -35 -5 -37 -59 -16 -40 15 -54 87 -24 118
20 19 82 -57 83 -102z m-8624 -58 c0 -41 21 -91 47 -114 63 -54 40 -134 -37
-134 -50 0 -60 13 -60 77 0 42 -12 98 -26 125 -18 33 -18 63 1 99 36 67 75 39
75 -53z m4437 -117 c27 -31 68 -56 91 -56 77 0 128 -117 109 -251 -11 -85 -26
-117 -49 -108 -38 14 -113 -121 -113 -205 0 -80 81 -214 120 -199 18 7 63 -9
100 -35 128 -91 176 -90 185 3 10 109 120 140 120 33 0 -36 27 -93 61 -126 95
-95 111 -137 84 -217 -31 -89 -6 -123 147 -194 93 -44 127 -49 190 -27 90 31
143 33 143 6 0 -31 -168 -105 -239 -105 -80 0 -110 -71 -46 -109 26 -16 74
-28 107 -28 62 -1 198 -198 201 -294 1 -24 15 -44 30 -44 20 0 23 52 11 177
-15 149 -11 185 25 225 52 57 86 41 86 -39 0 -93 26 -137 101 -176 69 -36 149
-28 149 14 0 11 37 20 81 20 45 -1 110 6 144 14 34 9 79 5 100 -8 53 -35 -42
-106 -117 -89 -36 8 -96 -15 -171 -66 -87 -58 -133 -74 -186 -63 -113 22 -113
-44 -1 -118 53 -35 127 -120 166 -188 38 -69 78 -119 89 -112 29 17 24 109 -5
109 -37 0 -30 133 9 187 22 30 49 40 78 29 36 -14 38 -23 12 -55 -24 -29 -25
-45 -3 -67 16 -16 29 -65 29 -110 0 -45 10 -87 22 -95 12 -7 28 -44 36 -82 8
-39 47 -91 88 -118 41 -27 93 -82 117 -122 94 -159 187 -204 187 -91 0 61 3
61 114 -2 l91 -51 59 64 c44 47 49 63 21 63 -21 0 -31 12 -22 26 9 15 52 19
101 9 66 -12 86 -7 86 21 0 20 18 72 39 115 23 45 32 101 23 131 -35 111 104
186 194 105 46 -41 49 -41 72 0 48 84 101 52 83 -51 -18 -109 -85 -308 -115
-342 -11 -13 12 -42 52 -67 150 -91 277 -358 277 -582 0 -92 38 -137 80 -95
16 16 27 324 29 832 2 512 13 809 29 814 13 5 45 -62 70 -147 25 -86 61 -190
81 -231 20 -42 34 -118 32 -170 -2 -52 9 -108 25 -124 44 -44 35 -94 -16 -94
-101 0 -139 -147 -75 -288 24 -53 22 -78 -15 -139 -53 -90 -86 -432 -44 -458
15 -9 44 16 67 60 21 42 50 70 64 62 13 -9 64 -2 114 14 108 36 193 -17 136
-86 -17 -20 -27 -74 -22 -119 7 -72 17 -82 80 -83 62 0 83 -21 156 -159 116
-218 109 -351 -14 -274 -40 25 -57 25 -81 1 -49 -49 -281 -39 -326 13 -103
119 -157 331 -85 331 40 0 149 -121 202 -225 60 -116 188 -125 188 -14 0 157
-88 259 -206 242 -56 -8 -57 37 -3 67 89 50 5 76 -223 68 -271 -9 -329 10
-290 96 55 122 -123 404 -303 479 -62 26 -135 71 -162 101 -28 30 -71 62 -96
70 -64 22 -185 -118 -205 -236 -9 -52 -38 -137 -64 -189 -55 -109 -65 -246
-17 -228 121 46 138 44 179 -18 52 -80 186 -87 253 -13 44 50 44 53 -21 121
-94 98 -86 129 35 129 79 0 118 -16 175 -73 89 -89 91 -126 11 -202 -77 -72
-78 -112 -7 -273 58 -131 144 -177 144 -78 0 27 23 61 50 76 41 22 50 19 50
-19 0 -61 -69 -156 -114 -156 -20 0 -56 -23 -79 -50 -97 -113 -264 -49 -333
128 -24 60 -60 113 -81 117 -53 11 -143 -187 -143 -314 0 -81 -11 -106 -50
-118 -27 -9 -50 -30 -50 -47 0 -55 -212 -188 -259 -162 -81 46 -30 161 90 204
56 20 60 173 7 217 -21 17 -38 51 -38 76 0 25 17 62 38 83 64 65 46 156 -38
191 -87 36 -95 65 -25 88 55 17 65 50 23 75 -108 68 -64 225 56 199 69 -16 99
18 46 51 -14 8 -25 34 -25 57 0 24 -64 99 -142 168 -79 68 -214 195 -300 281
-86 86 -162 156 -168 156 -36 0 -307 318 -349 409 -42 90 -67 112 -152 135
-104 28 -589 460 -589 525 0 16 -22 41 -50 56 -27 15 -50 50 -50 79 0 40 -7
46 -33 25 -26 -22 -59 8 -152 134 -77 105 -143 168 -186 179 -101 25 -279 205
-279 283 0 36 -9 76 -21 89 -55 61 -134 316 -120 385 8 41 3 81 -10 89 -39 24
-27 236 18 312 l42 71 64 -79 c35 -44 87 -105 114 -136z m3299 180 c67 -68 49
-124 -41 -124 -64 0 -83 -12 -94 -61 -9 -37 -38 -67 -72 -75 -31 -7 -56 -22
-55 -32 0 -11 1 -29 1 -41 0 -35 193 -128 264 -128 43 0 69 19 86 63 49 129
117 60 105 -107 -11 -142 -49 -169 -109 -78 -34 50 -42 52 -130 20 -114 -41
-173 -13 -191 92 -9 51 -29 75 -69 80 -30 5 -70 28 -87 53 -31 44 -269 99
-269 62 0 -10 18 -38 40 -63 49 -54 26 -97 -52 -97 -115 0 -213 215 -135 293
21 21 44 21 90 0 52 -24 68 -20 103 23 36 45 65 50 236 43 186 -7 196 -4 223
54 32 71 98 80 156 23z m-6515 -114 c-5 -33 -20 -57 -33 -55 -33 7 -47 74 -27
126 23 59 70 2 60 -71z m7518 -9 c47 -112 46 -119 -14 -100 -96 30 -146 -8
-164 -127 -23 -155 -86 -152 -86 4 0 91 16 136 77 213 95 120 140 122 187 10z
m-7886 -163 c13 -129 11 -1558 -2 -1762 -2 -28 10 -199 27 -381 28 -310 27
-335 -15 -382 -101 -111 -189 -42 -129 101 26 60 29 99 12 132 -15 28 -19 135
-9 263 9 119 16 233 16 254 0 21 -4 468 -9 995 -9 954 -9 957 42 950 44 -6 54
-31 67 -170z m7414 -31 c4 -75 -7 -125 -31 -145 -20 -17 -36 -57 -36 -90 0
-75 -66 -104 -117 -53 -30 31 -32 49 -9 93 23 42 22 63 -2 92 -27 32 -23 46
20 80 29 23 65 67 82 99 45 88 88 52 93 -76z m-2563 65 c76 -69 58 -108 -41
-92 -71 12 -88 7 -88 -27 0 -35 16 -39 89 -26 89 17 90 17 82 -67 -10 -98 -82
-130 -108 -48 -11 35 -38 51 -84 51 -88 0 -179 64 -179 126 0 97 246 158 329
83z m-5908 -85 c-11 -73 -71 -96 -71 -28 0 27 7 68 16 91 22 58 65 8 55 -63z
m5107 -18 c31 -80 0 -259 -47 -275 -23 -7 -31 36 -31 167 0 186 31 229 78 108z
m6589 -17 c-9 -21 -33 -39 -54 -39 -45 0 -47 12 -11 79 32 60 89 24 65 -40z
m-6132 -83 c21 -17 55 -31 76 -31 66 0 43 -46 -27 -55 -74 -8 -123 -110 -138
-286 -8 -89 -3 -97 60 -104 75 -9 93 -65 29 -90 -63 -24 -81 -18 -97 35 -9 28
-38 50 -66 50 -36 0 -47 13 -38 44 42 149 44 256 6 256 -30 0 -39 -21 -34 -81
6 -70 -2 -83 -55 -90 -34 -5 -74 -26 -90 -48 -35 -48 -86 -20 -86 48 0 33 25
60 73 78 66 25 75 42 90 173 16 136 21 144 75 130 44 -11 61 -2 75 40 16 53
18 53 63 8 26 -25 64 -60 84 -77z m1035 48 c5 -30 -2 -54 -15 -54 -39 0 -86
70 -67 100 25 42 74 15 82 -46z m366 47 c41 -16 64 -44 64 -78 0 -50 -9 -52
-119 -36 -126 18 -198 65 -170 111 21 34 139 35 225 3z m-4850 -57 c5 -17 17
-62 25 -100 8 -38 27 -69 41 -69 36 0 148 -125 148 -166 0 -19 -24 -34 -54
-34 -125 0 -174 -108 -108 -235 43 -82 48 -815 6 -898 -29 -58 48 -463 100
-522 61 -71 23 -120 -80 -103 -82 13 -89 10 -89 -49 0 -34 17 -69 38 -77 47
-18 49 -91 2 -91 -45 0 -69 -63 -45 -119 83 -193 175 -254 236 -156 45 73 60
62 49 -35 -8 -67 1 -92 43 -114 28 -15 52 -41 52 -57 0 -15 24 -53 52 -84 68
-71 45 -160 -39 -160 -62 0 -141 88 -186 207 -20 52 -51 69 -166 93 l-142 30
17 141 c22 171 22 17 1 1254 -10 571 -17 1057 -15 1081 1 24 3 58 4 75 2 17
-5 55 -14 84 -10 33 -1 68 25 94 49 49 86 53 99 10z m4103 -19 c73 0 90 -94
36 -200 -34 -66 -57 -174 -67 -307 -16 -219 -36 -268 -111 -268 -51 0 -63 37
-20 64 39 24 18 619 -23 669 -34 40 40 72 117 51 18 -5 49 -9 68 -9z m1251
-32 c96 -56 185 -137 185 -169 0 -22 -14 -19 -46 10 -25 22 -73 41 -107 41
-73 0 -122 42 -122 105 0 52 18 55 90 13z m-4121 -83 c87 -137 66 -185 -80
-185 -85 0 -117 52 -90 145 45 160 87 170 170 40z m519 -10 c0 -46 -16 -65
-57 -70 -48 -7 -56 3 -56 70 0 67 8 77 56 70 41 -5 57 -24 57 -70z m4762 37
c0 -21 -22 -57 -50 -80 -27 -24 -50 -57 -50 -75 0 -18 -11 -32 -25 -32 -14 0
-25 23 -25 50 0 28 11 50 25 50 13 0 31 28 40 63 17 67 85 87 85 24z m283 -64
c117 -117 107 -185 -29 -185 -47 0 -90 -19 -113 -50 -30 -41 -42 -44 -76 -15
-59 49 -49 99 23 117 75 19 76 29 11 99 -48 50 -49 58 -11 95 59 59 82 52 195
-61z m3453 46 c55 -78 49 -98 -30 -89 -54 6 -70 22 -76 76 -10 86 50 94 106
13z m-1646 -62 l122 -68 -110 -22 c-100 -20 -115 -16 -155 36 -31 42 -36 67
-17 90 33 40 18 43 160 -36z m-1215 -1 c1 -24 7 -68 15 -97 13 -47 1 -56 -88
-71 -63 -11 -102 -31 -102 -53 0 -20 -25 -35 -58 -35 -79 0 -95 21 -60 77 22
36 22 54 -1 77 -82 82 -11 152 96 95 37 -20 63 -17 104 12 71 50 94 49 94 -5z
m-2614 -68 c-1 -28 -11 -76 -21 -107 -23 -70 43 -104 115 -58 43 26 48 24 41
-15 -6 -27 -38 -50 -81 -58 -46 -8 -80 -34 -94 -72 -22 -59 -21 -60 110 -47
72 8 160 5 194 -4 l63 -18 -57 -19 c-70 -23 -49 -65 32 -65 122 0 277 -220
206 -292 -49 -48 -119 -27 -119 37 0 112 -290 230 -563 230 -150 0 -250 54
-302 163 -82 173 2 390 128 332 37 -17 78 -13 139 14 118 52 211 43 209 -21z
m-1107 -33 c17 6 58 -18 91 -53 l59 -63 -52 -42 c-99 -81 -273 40 -241 167 16
64 18 65 64 24 26 -24 61 -38 79 -33z m12965 26 c6 -18 -11 -31 -42 -31 -31 0
-52 16 -52 39 0 46 78 40 94 -8z m-11594 -42 c0 -51 -52 -77 -76 -37 -11 18
-15 42 -8 53 21 34 84 22 84 -16z m-3207 -273 c-5 -15 -35 -33 -67 -41 -78
-18 -96 -174 -23 -193 60 -16 60 -72 -2 -193 -43 -83 -45 -110 -20 -204 25
-93 23 -114 -14 -155 -56 -62 -53 -89 8 -73 27 7 56 3 64 -9 8 -13 -5 -23 -28
-23 -34 0 -39 -15 -27 -77 9 -45 1 -104 -19 -144 -48 -95 -66 -379 -23 -379
18 0 33 17 33 38 0 65 44 40 73 -42 22 -63 20 -91 -11 -137 -20 -32 -37 -106
-36 -165 1 -58 -5 -147 -14 -196 -23 -123 28 -307 80 -287 31 12 35 2 23 -48
-12 -47 -6 -63 22 -63 43 0 54 -137 13 -162 -32 -20 -143 62 -158 118 -7 24
-24 44 -38 44 -34 0 -12 -511 27 -619 26 -73 24 -85 -24 -119 -85 -59 -29
-337 67 -337 34 0 51 -16 51 -49 0 -56 -39 -89 -62 -51 -19 29 -105 34 -122 6
-14 -23 41 -242 87 -340 31 -67 28 -76 -35 -126 -82 -65 -87 -141 -16 -255 55
-90 47 -185 -16 -185 -54 0 -43 -44 14 -62 72 -23 70 -213 -3 -312 -51 -69
-52 -73 -8 -146 24 -42 71 -88 103 -102 85 -39 72 -70 -54 -125 -155 -69 -148
-115 22 -153 69 -16 72 -20 28 -38 -28 -12 -59 -36 -70 -54 -45 -74 -143 -2
-205 152 -25 62 -25 107 0 228 21 101 25 218 12 362 -11 117 -16 219 -10 228
23 39 12 692 -13 757 -23 58 -19 99 18 212 41 121 44 181 28 434 -10 162 -11
424 -2 583 9 159 14 437 11 619 -10 641 -3 1328 14 1358 9 18 9 142 0 276 -14
186 -10 264 16 321 19 41 41 95 49 121 12 40 30 33 140 -60 69 -58 122 -118
117 -133z m3994 181 c34 -33 -18 -109 -74 -109 -57 0 -101 67 -80 123 17 43
100 36 154 -14z m-7337 2 c0 -14 29 -36 64 -50 42 -15 62 -40 56 -68 -11 -61
-156 -71 -239 -17 l-65 43 68 59 c73 63 116 75 116 33z m696 -30 c52 -101 40
-1084 -14 -1181 -64 -114 -68 -78 -62 668 5 555 16 629 76 513z m2839 41 c22
-9 40 -42 40 -75 0 -68 73 -151 163 -185 108 -41 80 -116 -38 -104 -89 8 -100
3 -100 -45 0 -77 -61 -50 -70 30 -4 36 -24 79 -44 95 -23 19 -36 78 -36 165 0
133 10 148 85 119z m6176 -172 c26 -62 56 -113 67 -113 28 0 80 -101 61 -119
-8 -8 -39 -3 -70 12 -31 14 -88 38 -126 54 -85 34 -110 90 -65 145 19 22 31
61 27 87 -16 91 61 44 106 -66z m388 41 c15 -65 180 -138 257 -114 24 7 44 1
44 -13 0 -15 -16 -27 -35 -27 -19 0 -41 -17 -49 -37 -8 -21 -36 -38 -62 -38
-26 0 -62 17 -79 38 -17 20 -63 37 -101 37 -80 0 -114 64 -88 166 20 78 94 70
113 -12z m7680 15 c144 -75 227 -161 210 -216 -10 -29 -38 -53 -64 -53 -31 0
-51 -24 -62 -74 -9 -41 -38 -80 -65 -89 -26 -8 -48 -24 -48 -35 0 -35 -115
-72 -183 -59 -37 7 -67 28 -67 47 0 19 -23 35 -52 35 -40 0 -48 11 -35 51 9
29 2 69 -17 92 -27 33 -28 42 -1 51 51 17 130 111 130 154 0 39 109 120 166
125 16 1 55 -12 88 -29z m-9808 -111 c56 -40 65 -38 186 24 140 71 168 69 168
-16 0 -31 14 -70 31 -88 26 -26 12 -31 -68 -24 -99 8 -101 7 -108 -79 -12
-139 40 -189 156 -150 123 40 137 18 120 -196 -15 -186 -82 -285 -215 -318
-78 -20 -79 15 -2 167 25 48 26 72 5 93 -34 34 -5 70 67 83 83 15 44 57 -78
84 -116 24 -277 187 -281 283 -1 24 -21 30 -63 19 -33 -8 -92 1 -131 21 -39
19 -95 44 -125 56 -76 28 -19 106 97 132 82 19 92 15 241 -91z m-5141 -10 c22
-100 15 -1148 -7 -1162 -24 -14 -41 253 -46 727 -3 233 -12 451 -20 484 -10
43 -5 56 20 48 19 -6 43 -50 53 -97z m12842 65 c32 -3 69 -22 81 -44 14 -25
41 -34 75 -26 44 12 50 6 36 -38 -12 -37 -2 -59 33 -78 69 -37 70 -37 87 50
11 56 28 74 59 68 60 -11 72 -97 20 -135 -34 -25 -39 -53 -25 -137 16 -97 14
-104 -29 -86 -26 11 -84 18 -130 15 -106 -5 -179 18 -179 56 0 16 -34 62 -76
101 -144 136 -179 330 -49 274 21 -8 64 -18 97 -20z m-8243 -125 c33 -123 -55
-148 -125 -36 -25 41 -25 60 -1 89 45 55 103 31 126 -53z m-7428 -39 c53 -74
53 -78 9 -127 -45 -50 -45 -50 -89 8 -38 50 -51 53 -95 26 -72 -45 -101 -38
-101 22 0 41 11 50 51 39 38 -9 59 3 79 47 37 81 80 77 146 -15z m5080 -15
c62 -21 55 -84 -10 -84 -62 0 -146 67 -146 116 0 24 14 26 56 8 31 -14 76 -32
100 -40z m3595 -93 c46 -104 52 -153 44 -372 -2 -51 13 -113 34 -137 26 -31
34 -83 27 -175 -13 -155 -55 -202 -144 -161 -34 15 -78 21 -99 13 -44 -17
-102 93 -80 152 13 32 26 34 78 10 103 -47 138 4 123 175 -7 78 -15 170 -18
204 -2 34 -11 74 -19 88 -25 40 -51 260 -35 287 26 42 39 30 89 -84z m-9055
-47 c115 -30 99 -104 -25 -114 -90 -8 -91 -7 -102 100 -13 121 9 189 31 96 10
-42 39 -67 96 -82z m6049 -77 c9 -103 10 -102 -87 -64 l-70 27 57 22 c45 18
55 35 42 76 -13 38 -8 50 17 42 18 -6 37 -53 41 -103z m10736 67 c10 -7 19
-44 19 -83 0 -40 12 -76 26 -81 37 -12 1 -95 -41 -95 -19 0 -35 15 -35 34 0
54 -59 92 -101 65 -32 -20 -31 -33 7 -101 61 -107 56 -148 -18 -148 -51 0 -74
-26 -134 -154 -83 -177 -80 -244 10 -227 45 9 66 -3 87 -48 28 -62 159 -152
185 -127 48 49 -68 206 -152 206 -47 0 -42 99 7 154 51 56 159 62 159 8 0 -21
26 -48 58 -60 119 -46 195 -252 92 -252 -33 0 -50 -17 -50 -50 0 -60 21 -63
94 -11 82 57 113 24 92 -97 -33 -196 -136 -289 -136 -123 0 114 -70 174 -152
130 -41 -22 -45 -35 -22 -63 17 -20 24 -58 17 -86 -7 -27 -3 -50 10 -50 30 0
77 -122 58 -152 -8 -14 -33 -13 -61 2 -31 17 -52 17 -62 0 -9 -14 -38 -25 -65
-25 -28 0 -58 -24 -70 -55 -31 -84 155 -177 210 -104 38 50 45 36 38 -74 -3
-39 8 -126 24 -194 33 -134 35 -134 235 -71 106 34 133 29 147 -27 9 -34 34
-50 78 -50 73 0 80 -33 28 -125 -47 -81 -47 -125 0 -125 20 0 57 -20 82 -45
110 -110 222 -173 310 -176 120 -3 141 34 60 109 -36 33 -65 82 -65 110 0 37
-22 54 -87 66 -77 15 -88 26 -88 92 0 79 -7 78 156 27 100 -31 34 41 -105 115
-82 43 -156 90 -164 103 -10 15 -34 14 -65 -3 -39 -21 -65 -16 -117 19 -37 25
-82 51 -99 58 -24 10 -22 26 8 69 32 46 62 56 173 56 88 0 148 13 173 39 64
64 304 -2 342 -95 16 -38 36 -69 45 -69 8 0 56 -37 106 -81 98 -88 154 -129
240 -173 74 -38 98 -116 47 -154 -54 -40 -24 -139 47 -157 42 -10 53 -27 44
-72 -13 -71 94 -138 221 -138 84 0 146 -55 147 -131 1 -65 -69 -54 -79 12 -12
89 -109 77 -103 -12 6 -80 -30 -93 -49 -19 -9 33 -34 50 -76 50 -82 0 -65 -76
36 -161 75 -63 94 -114 42 -114 -17 0 -67 -35 -111 -79 -80 -77 -83 -78 -148
-35 -55 37 -64 56 -51 122 8 44 19 113 25 155 6 41 19 105 28 143 12 45 8 69
-10 69 -15 0 -28 39 -28 86 0 73 -17 98 -109 164 -100 72 -107 84 -81 139 30
67 65 76 110 31 23 -23 30 -21 30 9 0 67 -74 114 -109 70 -61 -76 -131 -98
-174 -55 -37 37 -42 36 -56 -2 -24 -62 4 -115 76 -142 76 -29 82 -90 12 -113
-31 -10 -49 -33 -44 -58 11 -58 117 -68 156 -15 22 30 37 35 49 15 10 -16 -20
-66 -68 -114 -97 -96 -343 -137 -424 -70 -22 18 -54 31 -72 29 -167 -23 -232
39 -226 214 3 89 -8 108 -106 187 -60 48 -113 110 -118 138 -14 82 -58 45 -67
-56 -13 -153 -89 -201 -183 -116 -60 54 -58 100 4 116 98 26 56 75 -52 61
-238 -32 -619 233 -559 389 11 30 -3 51 -51 72 -53 24 -63 42 -51 89 14 57 10
59 -112 54 -165 -8 -198 25 -143 140 48 101 86 113 98 32 4 -31 27 -60 51 -64
36 -7 41 4 28 68 -18 89 18 102 70 25 24 -37 70 -57 156 -67 l122 -13 -18 72
c-9 40 -51 99 -91 131 -41 32 -93 100 -116 150 -23 50 -46 99 -51 109 -5 9 25
35 67 57 43 21 77 55 77 75 0 20 34 75 75 122 99 112 95 126 -37 177 -62 24
-113 59 -113 79 0 47 48 45 66 -2 26 -68 134 -47 134 25 0 71 63 109 107 65
41 -41 60 -35 76 26 18 66 -22 146 -71 146 -54 0 -45 38 19 84 52 37 190 37
250 0z m-11287 -28 c7 -21 -19 -31 -79 -31 -50 0 -90 10 -90 23 0 55 151 62
169 8z m2102 -56 c5 -34 30 -91 55 -127 44 -62 30 -123 -29 -123 -35 0 -122
180 -122 253 0 95 83 92 96 -3z m3200 53 c27 -17 25 -24 -6 -36 -47 -18 -115
3 -115 36 0 28 77 28 121 0z m-543 -84 c22 -41 43 -47 122 -34 58 9 136 0 203
-24 84 -29 121 -32 162 -10 38 21 79 21 150 1 130 -36 127 -36 145 36 20 80
89 79 147 -1 45 -61 45 -62 -17 -62 -74 0 -105 -39 -67 -85 15 -18 20 -67 12
-111 -15 -74 -10 -81 93 -125 83 -36 117 -68 140 -133 39 -105 186 -159 309
-113 75 29 192 -11 303 -103 27 -23 77 -31 138 -24 52 6 166 3 254 -8 108 -13
175 -10 206 10 97 60 109 -19 22 -146 l-81 -117 -166 15 c-91 8 -210 19 -265
24 -55 4 -140 21 -188 36 -48 16 -118 34 -156 42 -53 11 -69 28 -69 75 0 36
-21 73 -52 89 -72 39 -132 11 -115 -54 31 -118 -72 -163 -191 -85 -47 30 -72
32 -135 8 -141 -53 -336 41 -254 123 20 20 5 39 -56 70 -124 63 -172 113 -172
177 0 80 34 92 139 48 149 -62 193 18 63 114 -62 46 -71 67 -59 138 10 64 3
88 -28 100 -56 22 -67 7 -83 -113 -13 -101 -14 -102 -120 -102 -61 0 -118 15
-136 36 -50 61 -173 74 -228 25 -64 -58 -61 -104 8 -125 188 -60 150 -258 -50
-261 -47 0 -37 92 12 111 34 13 36 21 10 37 -21 13 -63 5 -107 -20 -65 -36
-77 -36 -104 -3 -17 21 -53 50 -80 66 -35 20 -48 51 -43 105 3 42 -5 83 -19
92 -37 23 -30 112 10 127 19 7 41 35 48 62 9 36 34 48 102 48 57 0 90 12 90
33 0 94 105 102 153 11z m-2839 -49 c13 -61 7 -86 -28 -112 -75 -55 -91 -39
-73 73 28 171 68 187 101 39z m493 17 c-29 -22 -35 -52 -22 -122 30 -160 -6
-315 -73 -315 -108 0 -134 169 -31 206 10 4 25 63 33 132 23 186 26 193 84
158 43 -27 44 -34 9 -59z m-1256 38 c36 -20 44 -43 33 -99 -10 -51 -2 -87 27
-116 46 -46 44 -138 -4 -154 -17 -5 -37 21 -45 61 -8 39 -26 90 -39 114 -12
24 -23 60 -23 81 0 47 -10 47 -101 0 -97 -50 -94 -71 32 -188 106 -98 106 -98
38 -99 -45 0 -82 21 -109 63 -22 34 -53 62 -68 62 -14 0 -52 24 -83 53 l-56
53 -74 -53 c-76 -54 -179 -71 -179 -29 0 12 11 30 25 39 14 8 25 36 25 61 0
44 67 77 188 91 27 3 106 22 175 43 155 47 179 48 238 17z m1655 -69 c7 -51 7
-99 2 -105 -20 -23 -57 62 -58 130 0 103 43 83 56 -25z m1057 69 c8 -14 43
-25 78 -25 53 0 61 -10 54 -69 -7 -65 -13 -68 -120 -60 -133 10 -121 1 -140
100 -15 72 -11 79 48 79 35 0 71 -11 80 -25z m-5334 -41 c42 -38 50 -38 90 -2
36 32 51 34 87 7 75 -55 50 -64 -149 -58 -162 5 -195 14 -202 50 -11 59 111
60 174 3z m7496 -20 c0 -20 24 -53 52 -73 84 -58 37 -173 -49 -119 -49 32 -82
228 -37 228 19 0 34 -16 34 -36z m-4557 -30 c5 -15 -10 -35 -33 -44 -47 -18
-117 29 -95 64 19 31 116 16 128 -20z m6873 4 c21 -21 59 -38 86 -38 26 0 48
-11 48 -25 0 -14 11 -25 25 -25 14 0 25 18 25 39 0 47 96 27 140 -29 16 -19
66 -35 113 -35 46 -1 101 -11 121 -24 25 -16 50 -12 75 10 57 50 196 21 216
-45 9 -29 33 -72 53 -96 55 -62 18 -95 -105 -95 -105 0 -110 3 -119 81 -7 68
-12 74 -30 34 -13 -28 -12 -63 4 -87 24 -39 1 -153 -30 -153 -8 0 -55 17 -104
38 -113 46 -109 47 -109 -13 0 -27 11 -50 23 -50 13 0 32 -51 41 -113 11 -71
34 -122 62 -138 25 -13 49 -49 54 -80 4 -30 34 -68 66 -84 32 -16 71 -42 86
-57 15 -15 49 -28 74 -28 51 0 194 -142 194 -192 0 -67 -59 -61 -117 13 -66
84 -125 76 -204 -28 -18 -25 -56 -66 -83 -92 -41 -37 -45 -56 -23 -97 40 -75
39 -75 -117 -36 -79 21 -183 43 -231 49 -99 15 -150 66 -150 152 0 33 -11 52
-25 44 -41 -26 -29 -156 15 -173 28 -11 37 -36 29 -78 -7 -34 -3 -62 8 -62 12
0 85 -52 163 -116 213 -173 311 -234 376 -234 32 0 59 -12 59 -26 0 -63 207
-249 278 -249 86 0 89 -16 18 -92 -63 -67 -126 -74 -171 -20 -17 20 -56 37
-88 37 -31 0 -97 17 -148 38 -50 21 -102 32 -115 24 -13 -8 -86 52 -162 134
-135 146 -246 205 -293 158 -16 -16 -5 -35 29 -53 29 -16 47 -39 39 -52 -41
-66 -94 3 -122 157 -16 86 -12 97 50 120 64 24 65 27 22 74 -34 38 -37 57 -15
84 23 28 19 38 -20 48 -35 9 -53 43 -65 125 -32 210 63 324 179 215 49 -46 92
-58 221 -62 l161 -5 29 90 30 89 -164 156 c-90 86 -183 190 -208 232 -24 42
-67 79 -95 83 -28 4 -64 32 -79 63 -24 48 -32 50 -63 19 -61 -61 -183 113
-166 238 8 64 1 107 -24 131 -33 33 -29 44 31 91 80 62 150 68 202 16z
m-13349 -69 c0 -45 9 -156 20 -247 15 -126 12 -170 -13 -185 -21 -13 -38 -8
-44 11 -6 18 -32 51 -58 73 -26 22 -47 65 -47 95 0 36 -31 74 -88 109 -102 63
-154 143 -117 180 16 16 42 15 75 -2 53 -29 196 -12 219 25 29 46 52 19 53
-59z m-879 -77 c23 -151 7 -254 -38 -254 -43 0 -63 147 -38 280 21 114 57 102
76 -26z m16462 -47 c0 -24 23 -59 50 -76 99 -62 41 -259 -97 -330 -84 -43
-180 5 -326 162 -111 119 -117 139 -67 205 38 51 92 57 134 15 22 -22 38 -22
65 1 25 21 42 22 53 4 9 -14 44 -26 77 -26 54 0 58 6 32 47 -16 25 -21 68 -11
93 18 46 20 46 54 -1 20 -27 36 -69 36 -94z m-16211 78 c26 -42 -32 -90 -67
-55 -29 29 -11 82 28 82 12 0 30 -12 39 -27z m4368 -13 c8 -9 2 -37 -15 -63
-24 -39 -22 -53 8 -72 21 -13 39 -64 41 -118 2 -52 12 -125 22 -163 22 -85
-42 -120 -110 -60 -68 63 -241 54 -289 -14 -42 -60 -50 -58 -73 19 -11 34 5
80 46 136 35 47 63 95 63 107 0 79 261 273 307 228z m3185 -104 c67 -42 115
-93 123 -131 33 -148 110 -271 110 -175 0 14 11 25 25 25 39 0 29 -142 -12
-184 -21 -21 -38 -71 -38 -113 0 -41 -11 -82 -25 -90 -15 -10 -25 20 -25 72 0
62 -15 96 -48 114 -64 34 -84 104 -54 184 29 75 -5 113 -59 68 -40 -33 -71 1
-50 55 8 22 -22 63 -77 105 -84 64 -87 71 -45 103 59 45 48 47 175 -33z m2275
4 c8 -21 0 -65 -17 -97 -33 -63 -68 -56 -180 34 -67 53 -109 19 -113 -92 -3
-81 5 -102 47 -113 32 -9 44 -25 32 -44 -11 -18 4 -47 37 -72 65 -48 39 -141
-55 -199 -47 -30 -58 -26 -104 30 -28 35 -72 67 -97 72 -72 14 -48 59 32 59
99 0 145 46 100 100 -18 22 -53 35 -79 29 -53 -14 -55 0 -10 81 19 35 29 100
22 150 l-12 90 191 5 c153 5 194 -1 206 -33z m3760 -36 c26 -14 48 -47 48 -72
0 -25 17 -79 37 -118 63 -120 50 -230 -28 -250 -48 -12 -76 -4 -97 25 -16 22
-37 41 -46 41 -33 0 -14 -54 53 -144 58 -80 81 -92 150 -86 66 7 81 -1 81 -39
0 -72 -21 -79 -103 -38 -99 49 -108 34 -73 -123 16 -73 34 -158 40 -189 9 -44
25 -54 68 -44 59 14 119 -48 154 -156 14 -44 4 -61 -47 -85 -35 -16 -64 -50
-64 -75 0 -26 -18 -46 -41 -46 -34 0 -35 6 -7 40 29 34 26 46 -14 75 -27 20
-49 66 -49 104 -1 64 -9 69 -106 69 -108 0 -148 21 -162 86 -5 22 11 37 42 37
67 2 63 75 -5 84 -39 6 -60 31 -71 88 -9 44 -33 106 -54 137 -27 44 -29 67 -8
92 16 19 18 40 5 48 -27 16 -23 266 4 310 28 45 87 36 172 -24 47 -34 70 -41
60 -19 -9 20 -23 55 -31 79 -9 24 -26 44 -38 44 -40 0 -23 122 22 148 55 32
50 32 108 1z m-1827 -100 c0 -86 -46 -97 -110 -27 -41 46 -40 50 12 87 71 49
98 33 98 -60z m225 50 c0 -45 163 -98 256 -83 106 17 145 -26 78 -87 -79 -71
-296 -66 -355 10 -27 33 -67 61 -89 61 -54 0 -51 66 4 98 57 33 106 34 106 1z
m-7105 -80 c7 -59 17 -67 69 -54 68 17 88 -53 32 -109 -22 -22 -13 -35 37 -54
73 -28 74 -30 52 -87 -23 -59 -136 -49 -270 23 -65 34 -133 62 -152 62 -81 0
-43 115 89 270 48 57 135 26 143 -51z m8225 -15 c8 -81 7 -82 -85 -74 -170 14
-189 158 -19 157 91 0 97 -5 104 -83z m-6238 -82 c-18 -18 -38 -9 -67 31 -66
95 -48 137 27 62 46 -47 59 -74 40 -93z m8745 110 c82 -48 86 -62 42 -133 -21
-33 -23 -57 -6 -69 13 -9 25 -40 25 -67 0 -36 19 -53 68 -58 49 -6 69 -23 69
-57 0 -26 17 -48 38 -48 46 0 49 65 4 93 -18 11 -41 39 -49 63 -9 24 -34 44
-56 44 -31 0 -33 10 -12 49 25 47 28 48 73 7 26 -24 76 -68 112 -98 74 -62 85
-151 24 -195 -31 -23 -35 -41 -15 -76 29 -53 -20 -185 -104 -281 -61 -70 -31
-193 48 -195 136 -4 362 -97 362 -149 0 -55 -170 -117 -334 -124 -139 -5 -149
-1 -194 72 -26 43 -47 103 -47 135 0 31 -19 86 -42 121 -30 46 -35 75 -17 103
18 30 4 70 -58 163 -61 91 -83 151 -83 228 0 87 -15 120 -87 190 -95 91 -107
128 -55 171 24 20 41 20 63 -2 22 -22 29 -16 29 25 0 29 25 71 56 92 68 48 59
48 146 -4z m-2779 -68 c65 -69 51 -114 -35 -114 -114 0 -135 21 -105 102 34
89 66 92 140 12z m2188 -25 c47 -64 48 -72 10 -96 -37 -25 -38 -34 -2 -109 57
-119 11 -222 -88 -197 -106 26 -122 58 -44 88 63 24 66 30 32 69 -21 24 -43
60 -49 81 -8 26 -24 13 -53 -41 -68 -131 -167 -122 -249 21 -56 96 -37 117 55
62 40 -23 79 -42 87 -42 32 0 13 77 -22 91 -64 24 -42 59 36 59 49 0 83 -17
101 -50 43 -80 75 -58 75 52 0 117 31 120 111 12z m-4336 -25 c0 -78 -30 -96
-88 -54 -57 41 -33 115 37 115 37 0 51 -16 51 -61z m11596 -65 c61 0 164 -87
144 -121 -10 -15 -48 -28 -85 -28 -88 -1 -121 -24 -153 -107 -28 -73 -77 -92
-77 -30 0 20 -12 37 -28 37 -15 0 -20 -18 -12 -40 9 -24 -6 -56 -38 -83 l-54
-43 93 -76 92 -76 -77 -32 c-66 -27 -84 -26 -120 7 -27 25 -58 32 -81 19 -54
-29 -140 11 -191 88 -43 66 -43 68 35 133 43 36 81 94 86 128 6 48 24 64 78
71 59 6 69 17 58 62 -15 63 42 141 134 183 55 25 68 21 108 -31 26 -33 65 -60
88 -61z m-12369 25 c26 -14 48 -52 48 -83 0 -76 105 -128 179 -89 28 15 78 20
111 12 42 -10 66 -3 76 23 23 60 234 23 234 -41 0 -43 45 -19 58 31 15 58 89
53 258 -18 110 -45 106 -88 -15 -168 -108 -72 -188 -82 -287 -37 -48 22 -71
21 -101 -3 -32 -27 -38 -24 -38 21 0 29 -10 53 -22 53 -12 0 -60 8 -106 17
-71 14 -80 11 -56 -19 15 -20 36 -62 46 -94 17 -57 14 -59 -79 -43 -80 14
-106 7 -144 -35 -56 -62 -63 -56 124 -103 110 -28 178 -31 256 -14 115 25 243
-10 226 -62 -14 -42 -246 -122 -355 -122 -118 0 -260 82 -280 163 -8 32 -30
64 -50 72 -19 7 -35 34 -35 60 0 25 -28 70 -62 100 -42 37 -63 81 -63 133 0
45 -18 92 -42 110 -40 29 -40 35 0 96 49 75 52 76 119 40z m-4455 -149 c17 0
28 -20 23 -44 -7 -31 -29 -41 -77 -36 -37 4 -100 -10 -139 -31 -91 -46 -109
-30 -64 57 19 36 35 90 35 119 0 87 30 90 112 10 43 -41 92 -75 110 -75z
m4688 135 c47 -18 54 -110 9 -109 -51 1 -125 69 -108 97 19 31 43 33 99 12z
m2490 -22 c0 -24 -24 -38 -62 -38 -66 0 -86 37 -32 58 60 24 94 17 94 -20z
m500 -34 c-1 -9 -11 -33 -24 -54 -31 -48 -89 4 -68 60 14 37 93 31 92 -6z
m-12479 -82 c-9 -66 -46 -71 -82 -14 -16 26 -12 51 10 78 43 52 83 16 72 -64z
m3229 29 c0 -79 -40 -121 -78 -83 -29 29 14 157 52 157 14 0 26 -33 26 -74z
m11367 -17 c105 -114 104 -140 -4 -174 -110 -34 -113 -30 -113 132 0 158 9
161 117 42z m-14028 -175 c3 -246 12 -273 107 -292 46 -9 81 -35 92 -67 11
-38 29 -48 64 -37 50 16 56 7 84 -120 9 -41 39 -79 74 -92 68 -26 161 -265
119 -307 -36 -36 -69 -7 -166 145 -48 75 -104 136 -125 136 -20 0 -53 37 -72
81 -34 80 -188 255 -239 273 -31 10 -44 359 -17 441 39 118 77 40 79 -161z
m2897 -53 c-7 -326 -98 -359 -98 -35 0 188 3 204 50 204 47 0 51 -15 48 -169z
m1574 65 c-18 -29 -79 -26 -98 5 -9 14 -2 44 16 65 29 35 35 34 64 -5 17 -24
25 -53 18 -65z m3603 79 c8 -14 42 -25 76 -25 71 0 73 -8 25 -82 -20 -31 -39
-89 -44 -130 -7 -74 -7 -75 155 -93 228 -26 356 -109 238 -154 -53 -20 -47
-51 27 -139 82 -98 101 -97 145 7 47 114 77 127 124 56 89 -136 84 -312 -6
-230 -45 41 -128 32 -128 -14 0 -12 18 -50 40 -84 l40 -62 73 52 c91 65 130
44 83 -46 -20 -38 -36 -79 -36 -92 0 -36 -79 -114 -116 -114 -19 0 -34 26 -34
57 0 35 -40 95 -99 151 -54 51 -105 114 -113 139 -7 25 -42 58 -75 73 -34 16
-75 50 -91 76 -29 46 -32 46 -128 -5 -99 -53 -107 -79 -57 -197 13 -32 2 -50
-47 -68 -39 -15 -65 -44 -65 -73 0 -54 -65 -90 -90 -50 -8 15 -4 38 10 52 53
53 2 95 -114 95 -63 0 -106 8 -95 19 10 10 48 19 85 19 58 0 66 8 59 71 -9 82
46 155 134 177 74 18 78 72 11 157 -27 35 -50 89 -50 120 0 31 -17 70 -37 87
-24 20 -38 75 -38 153 0 113 5 122 61 122 34 0 68 -11 77 -25z m-5970 -294
c-5 -51 -10 -9 -10 94 0 103 5 145 10 94 6 -52 6 -136 0 -188z m1366 217 c85
-67 96 -255 18 -297 -68 -36 -75 -34 -102 37 -13 34 -41 62 -62 62 -50 0 -49
-91 1 -119 28 -16 37 -52 31 -131 -9 -135 -57 -155 -103 -45 -41 96 -155 217
-236 247 -106 41 -23 175 132 212 41 10 97 34 124 52 68 47 120 42 197 -18z
m2191 -9 c0 -67 -37 -105 -62 -64 -21 33 8 125 39 125 13 0 23 -27 23 -61z
m6242 7 c69 -65 75 -134 14 -168 -40 -23 -39 -29 13 -84 31 -33 56 -90 56
-127 0 -37 10 -67 21 -67 32 0 110 -188 100 -241 -16 -83 -81 -50 -146 74 -35
67 -84 132 -107 145 -24 14 -43 46 -43 73 0 32 -17 49 -50 49 -27 0 -50 -10
-50 -23 0 -13 -23 -31 -51 -40 -50 -16 -49 -17 8 -62 33 -26 89 -54 126 -64
80 -20 88 -84 19 -147 -57 -52 -89 -38 -141 63 -25 49 -64 80 -112 89 -89 18
-99 88 -21 143 44 31 50 53 37 124 -12 63 -7 90 19 100 47 18 66 -3 66 -73 0
-122 44 -76 58 61 26 244 68 284 184 175z m4483 -45 c14 -54 37 -106 51 -114
30 -19 32 -62 2 -62 -12 0 -28 23 -35 50 -9 34 -34 50 -79 50 -80 0 -109 -61
-56 -120 74 -83 78 -172 8 -241 -105 -105 -208 -72 -175 56 8 27 -3 80 -22
118 -32 61 -31 79 10 164 25 53 46 113 46 134 0 47 53 51 98 8 26 -25 38 -23
61 12 42 66 61 54 91 -55z m5825 -24 c0 -13 24 -31 53 -40 34 -11 44 -25 27
-42 -16 -16 -42 -13 -77 9 -54 34 -73 96 -28 96 14 0 25 -10 25 -23z m-23600
-77 c20 -37 52 -50 126 -50 103 0 117 -20 73 -102 -16 -30 -52 -48 -95 -48
-38 0 -82 -13 -97 -28 -50 -50 -82 4 -82 142 0 140 28 173 75 86z m5590 -14
c47 -9 55 -32 66 -204 17 -258 5 -278 -160 -262 -147 14 -181 38 -234 166
-108 258 8 365 328 300z m5785 -67 c0 -30 -20 -44 -62 -44 -59 0 -63 -8 -63
-125 0 -94 9 -125 38 -125 20 0 37 11 37 25 0 48 121 27 137 -25 19 -59 -2
-100 -51 -100 -25 0 -34 -24 -30 -81 5 -62 -2 -79 -31 -71 -21 6 -80 15 -131
21 -99 12 -121 53 -56 106 41 34 50 100 14 100 -36 0 -102 74 -102 114 0 20
22 36 49 36 63 0 88 43 50 88 -24 29 -21 40 11 52 22 8 40 29 40 45 0 17 13
43 28 58 38 38 122 -13 122 -74z m4038 56 c-9 -27 -6 -50 7 -50 45 0 155 -123
155 -174 0 -56 -67 -69 -144 -28 -24 13 -63 29 -87 37 -79 24 -21 261 64 264
11 1 13 -21 5 -49z m-9428 -37 c32 -35 79 -64 105 -66 43 -3 44 -4 3 -14 -25
-7 -72 -39 -105 -72 -85 -85 -104 -77 -122 54 -24 174 17 208 119 98z m-5362
-28 c63 -59 67 -74 49 -181 -10 -64 -20 -131 -21 -148 0 -17 -20 -31 -42 -31
-36 0 -39 23 -27 173 14 167 13 173 -46 188 -34 8 -61 26 -61 39 0 47 79 25
148 -40z m11387 3 c49 -75 58 -69 -104 -75 -96 -4 -131 3 -131 28 0 19 26 34
60 34 33 0 66 17 74 38 21 54 55 46 101 -25z m2040 -54 c0 -40 -89 -46 -113
-8 -9 14 -3 43 14 63 35 42 99 6 99 -55z m-11388 -50 c23 -9 38 -46 38 -96 0
-45 16 -95 35 -111 19 -16 42 -57 51 -91 25 -102 85 -74 96 45 7 87 10 78 14
-46 l4 -152 -84 15 c-53 9 -110 45 -152 96 -38 44 -84 81 -104 81 -47 0 -44
25 6 62 38 28 38 36 -2 103 -35 60 -38 85 -13 148 29 73 30 74 51 18 12 -32
39 -64 60 -72z m21196 40 c7 -29 47 -65 88 -80 107 -41 147 -135 64 -151 -42
-8 -73 4 -96 37 -21 31 -40 39 -50 22 -57 -92 -189 56 -152 171 22 70 127 70
146 1z m-6483 -77 c0 -9 -25 -23 -56 -31 -50 -13 -52 -18 -15 -46 83 -67 92
-122 36 -210 -70 -110 -90 -106 -92 21 -1 59 -10 129 -21 155 -30 78 45 191
103 155 25 -15 45 -35 45 -44z m-4889 -26 c21 -43 39 -122 39 -176 0 -63 13
-102 38 -111 20 -8 37 -37 37 -64 0 -27 51 -115 113 -195 61 -80 112 -157 112
-170 0 -42 103 -156 128 -141 13 8 21 50 18 94 -8 112 69 224 139 200 123 -41
178 -25 170 51 -7 68 -4 70 75 53 115 -25 120 -30 120 -122 0 -73 19 -108 126
-234 45 -54 78 -6 70 101 -6 65 3 105 23 112 18 6 31 -11 31 -39 0 -27 17 -89
38 -139 20 -50 35 -99 32 -109 -13 -49 38 -132 80 -132 26 0 55 -12 64 -27 9
-15 66 -48 126 -74 193 -83 115 -234 -93 -181 -54 14 -56 12 -24 -28 43 -52 5
-89 -94 -90 -50 0 -57 -10 -45 -58 16 -62 -42 -167 -92 -167 -16 -1 -78 -51
-138 -113 -126 -131 -135 -133 -192 -46 -32 50 -40 97 -29 185 14 118 -45 224
-124 224 -42 0 -91 -128 -60 -159 47 -47 33 -149 -18 -127 -24 10 -70 18 -101
18 -40 -1 -68 19 -87 64 -36 80 -64 103 -132 104 -81 0 -118 51 -66 92 39 32
39 34 -7 31 -219 -16 -313 52 -213 152 29 29 45 63 37 76 -25 41 -102 27 -151
-27 -59 -66 -145 -48 -250 53 -42 40 -100 73 -129 73 -30 0 -61 12 -70 27 -9
14 -45 37 -80 50 -35 14 -58 30 -51 38 26 25 525 14 552 -13 15 -15 49 -27 76
-27 27 0 86 -28 131 -62 45 -35 93 -63 107 -63 14 0 28 -37 33 -81 6 -63 21
-83 64 -89 31 -5 56 -18 56 -30 0 -12 23 -29 50 -37 28 -9 50 -36 50 -60 0
-56 48 -103 105 -103 123 0 14 198 -136 248 -50 16 -98 51 -106 76 -8 26 -31
53 -51 60 -24 9 -37 49 -37 112 0 59 -19 122 -50 161 -27 35 -50 75 -50 90 0
81 -251 108 -305 32 -73 -103 -261 -138 -356 -66 -27 20 -78 37 -114 37 -36 0
-87 17 -114 37 -56 42 -200 50 -224 13 -8 -14 -57 -18 -114 -9 -65 10 -98 6
-98 -13 0 -15 28 -28 63 -28 86 0 78 -43 -13 -62 -41 -9 -81 -27 -89 -40 -8
-13 -33 -23 -57 -23 -24 0 -62 -22 -86 -50 -50 -58 -113 -65 -153 -15 -15 18
-57 41 -94 49 -77 18 -121 -65 -105 -197 15 -114 -140 -262 -235 -226 -24 10
-66 -10 -107 -50 -42 -39 -75 -55 -85 -39 -23 38 41 128 92 128 24 0 44 15 44
33 0 59 -28 64 -77 15 -61 -61 -86 -60 -150 4 -41 41 -49 71 -37 134 11 62 3
91 -36 126 -101 92 -54 167 92 144 61 -9 86 0 112 41 39 62 92 68 160 16 51
-38 228 -50 278 -19 16 11 37 50 46 88 10 38 28 75 40 82 12 8 22 37 22 65 0
29 21 56 49 63 26 7 53 32 59 54 8 31 12 29 14 -10 2 -28 -11 -65 -28 -82 -25
-25 -19 -41 31 -79 34 -25 68 -40 75 -32 7 7 -2 19 -19 25 -17 6 -31 31 -31
56 0 50 66 75 198 76 92 0 252 92 252 144 0 17 -11 31 -25 31 -14 0 -25 15
-25 32 0 19 29 32 68 31 45 0 71 14 77 43 5 26 -6 44 -28 44 -20 0 -54 28 -77
62 -49 76 -49 79 -1 98 58 22 127 -24 172 -114 39 -78 38 -82 -28 -151 -66
-69 -66 -71 -19 -109 152 -121 293 -138 352 -42 22 38 60 97 84 131 24 35 52
91 62 125 26 85 87 150 139 150 24 0 50 17 58 38 24 62 85 42 127 -42z
m-12115 -32 c14 -72 -39 -107 -88 -58 -34 35 -36 48 -8 81 39 48 84 37 96 -23z
m4004 -64 c0 -26 -11 -54 -25 -62 -14 -9 -25 -42 -25 -74 0 -32 -17 -72 -37
-89 -21 -17 -38 -45 -38 -63 0 -29 -52 -62 -97 -62 -10 0 -38 40 -61 88 -49
104 -11 140 97 91 88 -40 142 57 63 112 -48 34 -71 132 -38 165 28 27 161 -60
161 -106z m17969 53 c8 -22 27 -48 41 -58 14 -9 19 -25 10 -34 -22 -21 -198
114 -182 139 19 32 115 -3 131 -47z m-17159 26 c20 -32 -21 -162 -55 -173 -38
-13 -91 103 -72 155 16 41 105 54 127 18z m9846 -14 c24 -18 44 -51 44 -73 0
-21 10 -45 22 -52 12 -8 16 -42 9 -77 -13 -67 15 -82 63 -34 77 77 69 -220 -8
-306 -50 -55 -80 -59 -178 -21 l-70 27 62 34 c34 20 89 36 121 36 80 1 62 86
-21 97 -124 17 -186 118 -112 179 34 28 32 36 -12 67 -77 54 -62 147 24 155 7
1 32 -14 56 -32z m-8963 -152 c84 -36 113 -39 142 -15 72 60 214 -69 238 -216
11 -71 29 -96 75 -107 99 -23 125 -94 56 -151 l-59 -48 71 -28 c69 -26 70 -28
23 -62 -27 -20 -68 -36 -91 -36 -55 0 -110 65 -74 87 47 29 27 59 -50 76 -48
10 -85 39 -99 74 -29 76 -174 163 -272 163 -73 0 -78 -6 -72 -81 6 -81 6 -81
-106 -81 -138 0 -157 48 -65 169 57 75 77 157 89 377 0 12 21 0 45 -27 24 -27
91 -69 149 -94z m4902 19 c7 -66 -2 -78 -62 -89 -39 -7 -96 -21 -127 -31 -81
-26 -70 20 30 126 100 105 148 104 159 -6z m-6036 6 c8 -22 -6 -48 -35 -63
-27 -15 -49 -49 -49 -76 0 -27 -13 -49 -29 -49 -15 0 -77 -40 -136 -88 -115
-94 -166 -83 -85 20 28 35 50 77 50 94 0 19 24 25 64 18 65 -13 78 2 121 137
16 54 79 58 99 7z m-4095 -127 c-62 -46 -47 -126 30 -159 56 -24 178 -196 151
-213 -4 -2 -66 0 -138 6 -197 15 -286 189 -169 330 17 21 39 64 49 96 17 56
19 56 67 13 44 -40 45 -48 10 -73z m20189 88 c39 -21 46 -43 33 -108 -10 -58
-3 -91 25 -114 21 -18 39 -59 39 -90 0 -32 9 -62 20 -66 25 -10 180 -318 180
-356 0 -29 -113 -90 -167 -90 -18 0 -33 23 -33 51 0 45 -11 49 -87 35 -79 -15
-90 -10 -113 51 -25 66 -28 67 -86 29 -118 -78 -389 -84 -389 -9 0 17 39 62
88 100 48 39 110 115 138 169 38 75 65 99 112 99 55 0 59 6 33 48 -26 40 -18
61 49 138 44 50 80 102 80 115 0 31 17 30 78 -2z m-12072 -98 c56 -62 70 -100
64 -169 -13 -150 -69 -156 -208 -23 -66 64 -139 116 -160 116 -90 1 -113 41
-66 113 65 100 266 80 370 -37z m-5514 -44 c68 13 97 -51 70 -153 -17 -66 -18
-66 -39 -10 -12 31 -38 56 -59 56 -59 0 -121 113 -99 180 19 57 20 57 45 -13
20 -55 38 -68 82 -60z m-2247 31 c35 -77 94 -82 113 -10 8 30 25 45 41 35 16
-10 21 -40 12 -67 -17 -55 72 -171 131 -171 18 0 33 -12 33 -26 0 -14 28 -36
63 -49 68 -26 88 -125 25 -125 -21 0 -38 11 -38 25 0 14 -12 25 -27 25 -42 0
-15 -104 35 -135 36 -22 52 -18 79 18 30 41 36 38 63 -47 17 -50 52 -113 78
-139 52 -52 58 -91 23 -146 -13 -21 -13 -53 0 -77 16 -31 6 -58 -39 -100 -89
-83 -78 -120 38 -129 108 -8 138 -52 46 -66 -31 -5 -69 -26 -85 -48 -26 -35
-35 -34 -93 9 -68 50 -75 198 -15 323 39 81 -37 237 -116 237 -34 0 -62 13
-62 30 0 16 -49 104 -110 194 -60 90 -114 191 -119 225 -6 46 -28 66 -86 77
-154 32 -268 162 -141 162 28 0 60 8 70 18 32 32 52 22 81 -43z m12534 -61
c10 -96 -40 -135 -67 -52 -21 67 8 190 37 160 12 -12 26 -61 30 -108z m1787
53 c82 -70 109 -169 75 -272 l-18 -55 -110 67 c-60 37 -116 90 -123 118 -24
86 -16 182 16 195 57 23 81 16 160 -53z m-10024 -116 c-9 -21 -27 -39 -42 -39
-37 0 -59 66 -39 117 14 38 19 39 56 2 22 -22 33 -58 25 -80z m5033 51 c0 -62
-38 -91 -94 -71 -33 12 -42 86 -14 114 41 42 108 15 108 -43z m-5485 -28 c33
-50 35 -69 10 -100 -37 -45 23 -128 119 -164 57 -22 99 -88 73 -114 -21 -21
-202 43 -223 79 -11 19 -111 38 -256 49 -224 17 -337 63 -154 63 47 0 99 17
116 38 17 20 58 37 90 37 40 0 78 28 116 87 68 104 58 102 109 25z m9006 -281
c3 -151 -22 -224 -68 -195 -31 19 -39 369 -10 399 37 36 76 -65 78 -204z
m2450 180 c81 -41 98 -71 54 -98 -46 -29 -25 -60 63 -91 104 -38 113 -98 25
-168 -35 -27 -63 -61 -63 -76 0 -42 78 -33 130 14 26 24 89 45 140 47 51 2
113 13 138 23 32 14 61 5 95 -29 56 -56 22 -180 -76 -269 -29 -26 -52 -63 -52
-83 0 -53 -81 -181 -115 -181 -16 0 -36 17 -44 38 -8 20 -31 37 -51 37 -52 0
-140 121 -140 191 0 43 -14 59 -52 59 -29 0 -88 40 -131 89 -44 50 -122 114
-174 143 -106 59 -193 181 -193 268 0 54 7 56 135 43 113 -12 143 -6 179 34
52 57 37 56 132 9z m-7213 -27 c9 -9 4 -32 -12 -51 -41 -50 13 -158 79 -158
62 0 229 -82 271 -133 46 -55 190 -73 305 -39 155 47 180 -2 59 -114 -54 -49
-106 -89 -116 -89 -11 0 -42 -23 -71 -52 -34 -34 -66 -46 -94 -33 -23 10 -81
20 -129 21 -95 2 -148 58 -149 159 -1 41 -22 65 -76 84 -41 14 -75 35 -75 47
0 11 -31 24 -69 29 -48 5 -71 24 -76 61 -8 54 -8 54 -69 -7 -34 -34 -61 -77
-61 -96 0 -34 -93 -79 -116 -56 -6 7 24 65 67 129 47 69 74 136 67 164 -20 77
207 192 265 134z m-2402 -69 c29 -44 22 -136 -13 -158 -18 -11 -45 -48 -61
-82 -28 -61 -29 -61 -30 25 -1 48 -24 123 -50 166 -27 44 -42 85 -35 93 21 21
168 -13 189 -44z m-4988 -81 c66 -78 82 -186 20 -134 -21 17 -38 42 -38 55 0
13 -17 40 -37 61 -40 40 -50 84 -20 84 10 0 44 -30 75 -66z m13358 0 c100 -15
134 -55 107 -124 -17 -45 -189 -35 -284 16 -88 47 -47 164 47 134 18 -5 77
-17 130 -26z m-12343 -288 c-3 -156 -6 -316 -7 -356 0 -41 -7 -67 -14 -60 -17
17 -34 689 -18 706 35 35 44 -31 39 -290z m-652 218 c-7 -39 8 -86 41 -129 83
-105 72 -170 -26 -151 -43 9 -92 5 -109 -10 -39 -32 -187 85 -187 147 0 25 48
69 113 104 61 34 112 70 112 81 0 10 15 19 34 19 23 0 30 -21 22 -61z m-1202
-43 c74 -74 56 -86 -131 -84 -190 3 -262 48 -198 125 40 49 268 20 329 -41z
m1653 -27 c34 -26 42 -89 46 -377 3 -189 15 -350 26 -357 34 -21 24 -147 -16
-199 -45 -60 -87 -15 -88 94 0 45 -33 102 -98 168 -148 151 -199 452 -76 452
35 0 50 -26 63 -114 10 -63 33 -121 52 -128 19 -7 34 -35 34 -61 0 -26 11 -47
25 -47 34 0 32 168 -3 189 -17 11 -23 57 -14 121 15 107 -28 195 -108 222 -28
9 -21 19 25 39 82 34 84 34 132 -2z m1513 -62 c5 -30 -8 -92 -29 -137 -74
-164 -76 -200 -15 -246 l57 -43 -54 -17 c-77 -25 -72 -123 9 -159 75 -35 82
-119 12 -137 -33 -9 -50 -34 -50 -74 0 -34 23 -82 50 -106 49 -44 50 -44 50 8
0 77 62 67 123 -19 133 -186 -74 -329 -238 -164 -34 34 -85 62 -113 62 -34 0
-44 10 -30 31 11 17 22 99 23 182 4 207 36 387 70 387 16 1 14 10 -6 22 -32
21 -10 284 36 436 19 61 96 42 105 -26z m809 2 c62 -56 58 -76 -20 -95 -81
-21 -192 75 -131 113 52 33 101 27 151 -18z m10762 4 c111 -55 224 -183 192
-215 -46 -46 -145 -17 -153 46 -11 71 -39 71 -86 1 -36 -56 -37 -55 -81 38
-43 90 -27 140 52 166 1 1 35 -15 76 -36z m8040 -90 c10 -47 12 -151 4 -232
-14 -134 -22 -148 -94 -179 -104 -44 -157 -11 -192 117 -31 116 -11 146 87
127 65 -12 127 108 88 171 -24 39 19 104 60 91 15 -5 36 -48 47 -95z m-19179
52 c35 0 28 -65 -10 -96 -41 -35 -92 9 -92 79 0 33 12 43 40 32 21 -8 49 -15
62 -15z m12894 -87 c4 -55 19 -114 33 -130 14 -17 19 -42 10 -55 -26 -42 40
-149 102 -164 32 -8 59 -32 59 -53 0 -20 28 -50 63 -66 71 -32 88 -167 26
-219 -64 -53 -314 129 -353 257 -9 30 -31 71 -49 92 -18 21 -52 97 -75 169
-24 73 -52 138 -64 145 -12 7 -8 41 8 76 24 54 42 61 130 55 99 -7 102 -10
110 -107z m5938 49 c9 -23 -1 -45 -23 -54 -49 -18 -71 4 -52 53 19 50 56 50
75 1z m-2674 -84 c57 3 167 -14 246 -37 112 -33 156 -36 197 -14 109 58 291
-128 258 -263 -19 -76 -9 -74 -109 -24 -49 25 -90 32 -104 18 -14 -14 35 -52
121 -97 185 -95 302 -224 187 -208 -79 12 -156 -30 -171 -93 -12 -45 -28 -58
-60 -48 -27 9 -50 -1 -59 -24 -8 -21 -39 -38 -69 -38 -56 0 -147 -65 -147
-104 0 -30 94 -26 113 4 20 32 105 32 125 0 8 -14 -14 -36 -49 -49 -35 -14
-64 -41 -64 -61 0 -121 -217 -132 -326 -16 -35 37 -86 82 -113 99 -43 27 -40
29 29 18 71 -12 77 -8 66 47 -10 52 -3 59 60 55 55 -4 73 6 79 47 10 69 -63
134 -85 75 -10 -27 -46 -40 -110 -40 -51 0 -107 -16 -123 -35 -15 -19 -70 -35
-122 -35 -51 -1 -126 -14 -166 -29 -85 -33 -123 2 -101 93 7 31 2 56 -11 56
-13 0 -27 -24 -32 -54 -12 -88 -63 -80 -98 15 -20 56 -48 89 -76 89 -120 0
-162 49 -189 221 -15 92 -34 185 -43 207 -23 57 76 79 182 41 70 -26 94 -24
158 13 41 24 97 43 123 43 41 0 44 7 20 46 -24 38 -20 56 24 100 73 73 102 68
120 -21 16 -78 45 -91 109 -50 25 16 27 24 6 25 -48 0 -37 95 13 106 24 5 54
-11 66 -37 18 -35 48 -45 125 -41z m-19710 -24 c0 -53 8 -104 18 -113 9 -10
18 -135 18 -279 2 -272 -4 -287 -113 -287 -26 0 -62 -23 -79 -50 -31 -50 -94
-69 -94 -29 0 12 23 42 52 68 41 37 49 66 38 135 -32 194 -31 302 2 330 18 15
33 47 33 71 0 24 17 58 38 75 20 17 37 63 37 103 0 40 11 72 25 72 14 0 25
-43 25 -96z m4895 -24 c10 -102 -73 -112 -135 -18 -57 88 -32 139 57 116 56
-15 72 -35 78 -98z m5005 70 c0 -43 17 -50 125 -50 69 0 125 -5 125 -10 0 -45
-42 -98 -102 -129 -46 -23 -66 -50 -57 -74 20 -51 -7 -46 -66 13 -27 27 -50
74 -50 102 0 32 -20 58 -50 66 -48 12 -68 81 -33 115 37 38 108 16 108 -33z
m726 12 c17 -21 25 -44 17 -52 -19 -19 -118 36 -118 66 0 37 65 28 101 -14z
m3836 -27 c32 -49 38 -93 26 -184 -15 -107 -11 -121 35 -133 64 -17 92 -82 54
-128 -31 -38 -124 -26 -164 20 -14 15 -57 48 -96 73 -59 38 -68 57 -54 119 20
92 -37 121 -125 63 -88 -58 -238 -54 -238 6 0 71 161 150 225 110 73 -46 100
-38 100 29 0 109 170 127 237 25z m-14152 -41 c30 -189 32 -289 11 -412 -16
-90 -15 -147 5 -183 15 -29 21 -72 12 -94 -9 -23 -19 -515 -24 -1092 -4 -578
-8 -1073 -10 -1100 -2 -28 3 -114 11 -193 20 -194 -21 -269 -76 -140 -47 111
-50 224 -9 265 23 23 23 50 2 111 -18 53 -29 405 -31 1013 -3 853 1 939 42
1008 42 72 42 79 1 151 -45 78 -67 690 -27 730 39 40 82 11 93 -64z m13151 52
c72 -33 77 -47 33 -93 -25 -25 -23 -38 12 -64 54 -40 55 -60 4 -117 -38 -42
-35 -52 50 -150 89 -105 113 -169 65 -176 -73 -11 -86 -3 -100 54 -12 51 -30
63 -95 63 -92 0 -111 -39 -35 -75 61 -28 83 -90 50 -147 -17 -32 -34 -35 -70
-16 -26 14 -76 25 -112 25 -39 0 -70 17 -79 44 -36 114 -71 159 -114 147 -103
-27 -25 219 82 256 40 14 73 38 73 54 0 18 26 22 72 12 64 -14 73 -8 85 54 9
45 0 86 -25 114 -49 55 1 62 104 15z m-14186 -58 c0 -69 -44 -81 -128 -36 -64
34 -20 98 69 98 46 0 59 -13 59 -62z m11126 -4 c116 -78 199 -168 199 -216 0
-42 12 -46 88 -32 111 21 118 -29 14 -105 -64 -48 -76 -50 -104 -16 -21 26
-70 36 -160 32 -71 -3 -143 3 -159 13 -48 30 -33 65 29 65 100 0 97 31 -14
143 -87 90 -100 113 -69 133 55 34 106 29 176 -17z m4612 -9 c19 -31 210 -125
254 -125 18 0 33 -16 33 -35 0 -19 21 -40 46 -46 80 -21 83 -114 7 -199 l-69
-77 -92 112 c-51 62 -92 125 -92 140 0 16 -40 68 -89 117 -49 49 -82 100 -73
113 19 32 55 32 75 0z m-7834 -267 c38 -192 39 -226 7 -303 -20 -47 -36 -130
-36 -183 0 -53 -9 -97 -20 -97 -28 0 -87 600 -67 689 43 193 58 179 116 -106z
m-6109 136 c14 -17 29 -60 34 -94 5 -35 33 -73 65 -87 73 -32 71 -57 -6 -93
-53 -24 -63 -45 -63 -137 0 -108 18 -130 65 -83 33 33 135 -60 135 -122 0 -68
29 -82 77 -39 28 26 49 30 59 13 22 -36 -5 -77 -50 -77 -55 0 -43 -69 15 -88
33 -10 47 -31 39 -58 -7 -23 -13 -131 -13 -241 -1 -600 -6 -951 -14 -958 -5
-5 -28 32 -52 83 -24 50 -59 97 -77 104 -19 8 -34 32 -33 54 0 35 6 34 37 -7
75 -99 110 54 72 317 -19 138 -60 160 -60 33 0 -59 -20 -107 -61 -148 -78 -77
-89 -64 -72 83 15 128 -17 178 -79 126 -48 -39 -88 -11 -88 62 0 96 27 138 88
138 34 0 80 29 110 69 47 62 54 65 78 25 67 -112 157 -26 94 89 -16 30 -26 94
-23 142 6 71 1 82 -25 56 -87 -84 -347 14 -347 131 0 35 22 85 49 112 48 48
48 51 3 75 -39 21 -152 180 -152 215 0 6 22 11 48 11 60 0 85 71 63 185 -23
123 23 182 84 109z m2262 -41 c-6 -45 6 -53 83 -53 77 0 87 -7 80 -56 -8 -57
-13 -58 -170 -34 -34 5 -82 11 -106 12 -61 4 -55 72 12 143 66 69 109 64 101
-12z m5649 -36 c7 -43 1 -97 -13 -119 -41 -66 -1 -164 80 -197 40 -17 93 -52
116 -78 41 -44 39 -50 -39 -123 -85 -79 -149 -70 -151 22 -1 71 -70 142 -104
108 -54 -54 -245 -31 -245 30 0 17 -39 68 -87 115 -49 47 -88 104 -88 128 0
25 -25 62 -55 83 -38 26 -47 47 -30 64 18 18 44 6 85 -37 68 -73 113 -80 145
-22 23 41 138 40 236 -2 35 -16 44 -7 44 42 0 123 88 112 106 -14z m4839 30
c8 -70 -41 -107 -107 -81 -46 17 -51 125 -7 143 63 26 107 2 114 -62z m-5779
16 c28 -74 -6 -89 -65 -27 l-60 64 55 0 c31 0 62 -17 70 -37z m-4266 -100 c23
-28 25 -48 7 -66 -62 -62 -181 29 -149 113 18 47 81 26 142 -47z m6066 50 c8
-21 26 -38 40 -38 14 0 40 -19 57 -43 26 -35 38 -37 70 -11 40 34 46 29 110
-91 65 -122 -56 -184 -133 -67 -62 94 -187 80 -128 -15 24 -38 21 -53 -12 -79
-22 -17 -45 -54 -49 -81 -18 -101 -83 -55 -104 75 -12 68 -32 145 -46 171 -22
41 -16 44 59 30 66 -13 74 -11 39 11 -43 27 -60 126 -27 158 30 31 109 18 124
-20z m7134 4 c0 -53 -28 -67 -78 -40 -66 35 -58 73 16 73 35 0 62 -14 62 -33z
m366 -32 c41 -53 13 -142 -38 -121 -22 9 -63 23 -90 30 -69 18 -138 81 -138
125 0 49 225 19 266 -34z m3393 -105 c36 -52 66 -109 66 -125 0 -37 67 -40 80
-4 11 35 214 2 253 -41 16 -18 56 -67 89 -107 49 -61 68 -69 104 -46 37 22 56
14 109 -50 36 -42 93 -84 127 -92 80 -20 81 -81 5 -193 -81 -118 -147 -103
-323 72 -78 79 -143 153 -143 164 -1 11 -18 37 -38 58 -21 21 -38 59 -38 84 0
72 -44 83 -104 26 -75 -69 -84 -66 -150 51 -32 57 -89 119 -127 139 -47 24
-69 55 -69 97 0 95 82 78 159 -33z m-4692 -17 c8 -100 47 -132 111 -92 39 25
59 25 86 2 53 -43 44 -79 -15 -60 -28 9 -67 3 -86 -13 -27 -22 -52 -16 -112
28 -72 54 -102 122 -53 122 12 0 16 24 8 53 -10 39 -4 50 21 42 19 -6 37 -43
40 -82z m-11839 -120 c-43 -43 -61 45 -24 111 l33 59 9 -72 c4 -40 -4 -84 -18
-98z m18672 7 c-30 -55 -175 -110 -207 -78 -15 15 3 57 46 111 66 83 73 85
127 50 45 -30 53 -48 34 -83z m-7261 72 c10 -15 67 -49 127 -76 130 -58 139
-108 27 -155 -77 -32 -82 -41 -73 -135 19 -197 -95 -272 -199 -131 -30 41 -70
75 -88 75 -64 0 -32 44 42 59 89 18 95 54 20 133 -42 45 -48 65 -25 88 17 17
30 48 30 70 0 80 102 133 139 72z m-12004 -49 c14 -13 5 -28 -20 -38 -53 -20
-174 31 -152 65 16 27 134 8 172 -27z m4782 -89 c48 -98 295 -257 399 -258 57
-1 134 -180 134 -311 0 -57 -7 -62 -75 -49 -58 12 -84 3 -121 -42 -62 -76
-111 -54 -204 93 -90 141 -95 184 -19 176 103 -10 66 67 -40 84 -106 18 -140
53 -141 150 0 35 -23 89 -52 120 -60 64 -48 128 24 128 31 0 65 -33 95 -91z
m8862 49 c109 -21 115 -117 16 -233 -97 -113 -106 -115 -177 -49 -30 29 -103
76 -162 105 -150 75 -121 169 53 169 35 0 71 12 80 27 9 15 40 20 70 10 29 -9
84 -22 120 -29z m-17938 -72 c111 -91 145 -186 67 -186 -23 0 -68 -24 -100
-54 l-58 -55 0 62 c0 34 -13 75 -30 92 -38 38 -50 230 -14 230 15 0 75 -40
135 -89z m2505 -323 c-6 -312 -28 -427 -57 -295 -10 44 -12 90 -5 101 7 12 4
133 -7 270 -12 158 -10 267 6 299 43 84 68 -66 63 -375z m6099 319 c5 -50 -7
-89 -34 -111 -210 -167 -267 -308 -125 -308 58 0 77 13 89 60 7 34 28 65 44
71 39 13 40 -25 2 -63 -23 -23 -20 -41 12 -76 56 -62 53 -77 -21 -105 -74 -28
-113 -104 -62 -121 19 -6 57 -36 86 -66 28 -31 96 -70 152 -87 55 -18 119 -42
142 -54 70 -35 81 26 20 108 -37 50 -47 83 -30 100 17 17 9 41 -24 74 -62 62
-50 134 21 134 29 0 62 8 72 18 38 38 61 17 61 -54 0 -40 20 -108 44 -150 38
-68 39 -81 7 -101 -57 -36 -26 -48 140 -56 159 -8 202 -47 268 -250 7 -24 50
-52 95 -64 56 -15 86 -40 96 -80 17 -71 79 -115 134 -93 51 19 28 85 -37 105
-64 21 -35 62 43 62 37 0 67 -18 75 -44 8 -24 25 -64 39 -90 19 -36 13 -57
-27 -95 -29 -26 -52 -59 -52 -72 0 -44 -87 -25 -119 26 -23 36 -58 50 -130 50
-114 0 -154 48 -133 159 12 63 8 70 -38 55 -38 -12 -55 -3 -67 34 -47 150
-213 181 -409 76 -49 -27 -95 -39 -103 -29 -7 11 -53 39 -102 61 -49 23 -111
66 -138 96 -27 30 -85 70 -129 89 -51 22 -76 47 -67 69 7 19 1 42 -13 51 -15
10 -27 45 -27 80 0 35 -25 84 -56 110 -49 39 -52 53 -25 97 46 75 38 102 -28
102 -61 0 -161 88 -132 117 28 28 199 82 260 83 38 0 67 23 87 69 57 129 127
136 139 13z m2943 41 c26 -83 287 -170 287 -96 0 45 136 14 145 -33 5 -25 -6
-44 -26 -44 -18 0 -76 -55 -128 -123 -61 -81 -119 -129 -167 -140 -95 -21
-299 -190 -352 -292 -34 -66 -58 -82 -134 -87 -100 -6 -163 -44 -163 -99 0
-46 -49 -43 -104 7 -62 57 -60 134 4 134 28 0 50 11 50 24 0 13 -22 36 -50 51
-27 15 -50 50 -50 78 0 48 10 50 126 34 88 -12 137 -7 164 15 32 26 43 26 60
-2 17 -27 39 -20 109 33 48 37 97 67 108 68 11 0 48 24 83 52 l62 52 -56 45
c-31 25 -56 62 -56 82 0 53 -62 97 -109 78 -27 -10 -46 1 -55 31 -8 26 -25 66
-38 90 -33 61 -31 64 46 76 174 26 227 19 244 -34z m-5862 -75 c7 -33 37 -111
65 -173 28 -62 60 -156 69 -209 10 -54 28 -115 39 -138 70 -140 126 -276 126
-304 0 -67 -112 -199 -168 -199 -67 0 -101 -99 -64 -182 13 -29 15 -82 4 -117
-75 -246 -120 -514 -90 -543 46 -47 150 -12 135 45 -8 29 5 51 36 60 26 9 47
26 47 38 0 47 148 102 200 74 97 -52 104 -111 24 -189 -101 -97 -97 -151 15
-169 143 -23 186 3 397 243 35 40 64 82 64 94 0 31 119 26 139 -7 10 -16 52
-22 99 -14 68 11 89 1 134 -59 94 -127 39 -188 -97 -108 -76 45 -79 45 -175
-10 -53 -30 -113 -49 -133 -42 -20 8 -44 2 -54 -12 -9 -15 1 -34 23 -42 51
-20 50 -107 -2 -164 -54 -59 -75 -58 -91 4 -16 60 -66 64 -132 11 -41 -33 -42
-42 -11 -54 80 -31 200 -186 200 -257 0 -91 153 -199 212 -150 47 39 79 16
138 -100 54 -106 45 -244 -17 -268 -19 -7 -32 -36 -28 -64 12 -83 -49 -77 -93
9 -36 68 -37 90 -9 145 18 36 36 74 41 84 5 11 -19 19 -53 19 -49 0 -59 -10
-48 -50 13 -51 -28 -70 -55 -25 -9 14 -49 25 -89 25 -83 0 -89 15 -36 86 64
84 48 186 -32 203 -122 27 -136 36 -122 74 27 71 -58 236 -118 230 -44 -4 -54
8 -54 68 -2 79 -55 116 -90 61 -16 -26 -21 -20 -22 22 0 62 6 61 -242 56 -231
-4 -414 41 -351 86 61 45 24 219 -82 381 -87 134 -184 206 -311 232 -56 11
-79 31 -85 75 -5 33 -23 83 -41 112 -59 95 -67 239 -13 239 26 0 55 12 64 27
9 15 50 23 90 17 82 -12 91 8 102 218 7 131 75 192 111 99 16 -42 -54 -294
-98 -353 -12 -17 -11 -35 5 -45 46 -29 28 -63 -34 -63 -82 0 -143 -25 -126
-53 8 -12 35 -22 61 -22 192 0 450 -412 450 -719 0 -71 11 -106 33 -106 60 0
118 702 69 832 -23 64 -35 1060 -13 1096 25 40 72 10 87 -55z m-4301 -138 c0
-7 -25 -10 -56 -5 -50 7 -56 -3 -56 -84 0 -51 -19 -112 -44 -139 -45 -50 -36
-82 23 -82 18 0 33 27 33 61 0 64 35 102 72 79 33 -21 2 -140 -37 -140 -19 0
-35 -23 -35 -51 0 -28 -17 -57 -37 -65 -48 -18 -46 -246 3 -287 53 -44 40 -96
-28 -122 -78 -29 -82 -103 -13 -232 39 -71 45 -106 25 -142 -40 -75 -29 -172
25 -226 60 -60 63 -90 13 -109 -39 -15 -48 -88 -23 -182 13 -50 100 -88 210
-94 59 -4 61 -146 3 -217 -48 -59 -50 -59 -68 -10 -78 213 -194 224 -170 16
23 -202 33 -229 85 -229 64 0 66 -76 2 -92 -73 -19 -180 -482 -137 -593 21
-55 60 -24 60 47 0 121 89 192 138 112 10 -15 48 -20 88 -11 112 24 179 -58
159 -195 -9 -58 -26 -116 -37 -128 -20 -22 -168 86 -206 151 -15 27 -36 21
-101 -31 l-82 -65 -8 -454 c-4 -249 -10 -555 -14 -678 -5 -192 -10 -1195 -6
-1388 1 -34 -1 -209 -4 -387 -3 -179 1 -342 9 -363 7 -21 4 -144 -9 -275 -19
-201 -16 -258 22 -369 36 -109 38 -136 10 -159 -26 -21 -34 -117 -34 -386 0
-448 -38 -492 -57 -66 -30 650 -8 5575 25 5608 23 23 24 39 2 65 -19 24 -30
324 -35 992 -4 527 -11 973 -15 993 -5 25 14 32 71 27 63 -6 80 3 92 49 14 53
19 51 78 -38 35 -51 64 -99 64 -106z m8725 167 c0 -33 -146 -79 -163 -51 -8
13 -8 35 1 49 19 31 162 33 162 2z m-2619 -114 c13 -42 55 -143 94 -225 92
-194 112 -404 38 -393 -69 11 -113 75 -113 162 0 47 -11 68 -31 62 -17 -6 -28
-35 -24 -65 5 -30 -4 -54 -18 -54 -15 0 -27 20 -27 45 0 67 -50 107 -101 80
-36 -20 -41 -50 -30 -199 11 -150 7 -176 -27 -176 -51 0 -86 65 -107 199 -18
112 -19 112 -179 63 -50 -16 -56 -9 -56 58 0 53 -20 91 -69 128 -64 48 -66 54
-25 86 24 19 44 52 44 74 0 61 45 74 62 17 20 -62 125 -92 176 -50 56 47 45
72 -44 94 -64 17 -83 36 -90 91 -7 67 -4 69 75 52 46 -10 99 -26 119 -37 20
-11 79 1 137 28 131 60 168 52 196 -40z m-3306 42 c0 -11 -15 -41 -34 -67 -38
-51 -81 -13 -56 51 14 38 90 51 90 16z m4575 0 c0 -33 -59 -97 -105 -113 -63
-22 -79 24 -27 80 45 49 132 71 132 33z m14863 -61 c-10 -45 -17 -129 -17
-188 3 -195 -93 -124 -110 82 -11 144 7 187 81 187 59 0 62 -6 46 -81z
m-17262 18 c24 -29 25 -53 3 -100 -50 -111 -119 -63 -91 64 18 83 41 92 88 36z
m1702 -18 c1 -17 0 -61 -2 -97 -2 -36 14 -84 37 -106 22 -23 37 -65 32 -95 -9
-64 -70 -94 -70 -36 0 55 -43 50 -74 -8 -38 -71 -34 -77 48 -77 40 0 81 -13
91 -29 29 -46 -66 -96 -182 -96 l-108 0 0 126 c0 135 80 396 131 428 47 30 94
25 97 -10z m1948 -33 c18 -22 52 -34 76 -28 28 7 53 -11 71 -50 20 -46 40 -57
77 -45 61 19 62 4 8 -79 -34 -53 -36 -73 -11 -113 36 -58 -61 -171 -147 -171
-59 0 -78 -29 -50 -75 26 -41 -13 -125 -58 -125 -17 0 -50 -23 -74 -50 -40
-48 -49 -48 -134 -13 -49 21 -94 38 -100 38 -24 0 -5 72 22 81 18 6 32 53 32
108 0 77 10 99 50 107 27 5 66 24 87 42 31 28 46 27 86 -2 65 -48 214 -48 214
0 0 20 -20 42 -45 50 -25 8 -55 50 -69 95 -13 44 -49 93 -80 109 -83 40 -88
50 -57 108 33 62 59 65 102 13z m9617 23 c31 -8 50 -25 43 -37 -18 -28 -211
-29 -211 -1 0 53 62 67 168 38z m-7446 -43 c16 -19 71 -42 122 -50 160 -27
170 -42 131 -201 -23 -98 -45 -140 -73 -140 -75 1 -106 41 -98 127 7 67 -1 86
-40 94 -93 18 -238 127 -223 166 18 48 143 50 181 4z m466 9 c8 -14 41 -25 74
-25 90 0 138 -26 138 -75 0 -75 -67 -76 -171 0 -116 84 -147 125 -94 125 20 0
44 -11 53 -25z m-10289 -162 c0 -90 -34 -192 -54 -162 -4 6 -28 35 -52 64 -39
47 -40 61 -8 137 66 159 114 142 114 -39z m2396 71 c10 -100 -168 -270 -199
-190 -27 67 -24 156 5 156 14 0 36 29 50 64 36 96 134 76 144 -30z m12541 68
c8 -13 52 -18 98 -10 55 9 95 1 121 -25 21 -21 76 -42 123 -46 55 -6 85 -22
85 -46 0 -40 -32 -42 -144 -13 -59 16 -69 11 -69 -34 0 -36 16 -53 49 -53 65
0 78 -29 38 -84 -25 -35 -52 -42 -109 -29 -66 14 -80 7 -116 -64 l-42 -79 91
16 c49 10 101 11 115 2 38 -23 -131 -211 -190 -212 -69 0 -172 110 -152 163 9
22 -7 84 -35 139 -38 74 -44 110 -25 147 14 26 19 65 11 87 -32 82 108 212
151 141z m-16553 -64 c-2 -28 -15 -115 -27 -195 -18 -111 -15 -155 12 -194 52
-74 18 -154 -61 -144 -98 12 -134 90 -63 138 55 38 77 141 34 167 -16 11 -18
170 -4 285 5 40 113 -17 109 -57z m4542 -69 c0 -89 -64 -92 -86 -4 -19 77 31
158 65 105 11 -18 20 -63 21 -101z m5865 29 c54 -43 98 -91 98 -106 0 -49
-128 -48 -177 0 -25 25 -68 46 -97 47 -136 6 -164 14 -164 46 0 38 102 85 190
88 29 1 97 -33 150 -75z m8523 24 c27 1 82 5 122 8 94 10 114 -47 28 -80 -53
-20 -63 -36 -49 -79 15 -49 10 -52 -72 -39 -49 8 -112 8 -140 1 -53 -14 -72
-93 -29 -119 35 -22 1 -192 -53 -270 -40 -57 -57 -64 -97 -43 -63 34 -62 100
2 117 46 12 49 26 34 141 -26 198 -25 203 35 211 54 8 81 55 31 55 -29 0 -34
83 -7 110 11 10 47 11 82 2 34 -9 85 -16 113 -15z m-18163 -46 c0 -44 -7 -47
-62 -21 -35 15 -63 37 -63 49 0 12 28 21 63 21 45 0 62 -13 62 -49z m18662 0
c25 -29 39 -71 31 -100 -11 -41 2 -52 78 -64 50 -8 108 -26 129 -39 21 -13 57
-31 81 -39 50 -17 53 -31 20 -83 -43 -69 26 -114 75 -49 51 67 98 45 101 -47
1 -37 8 -53 15 -36 6 17 28 31 48 31 20 0 43 17 51 38 27 69 76 41 64 -37 -14
-96 -67 -143 -115 -103 -52 43 -240 -37 -240 -103 0 -28 -13 -45 -31 -38 -17
6 -28 41 -24 77 4 43 -5 66 -28 66 -21 0 -41 35 -49 84 -24 146 -111 215 -243
191 -136 -25 -140 -22 -160 84 -34 182 89 286 197 167z m-9456 -12 c46 -10 69
-31 69 -62 0 -58 -42 -75 -125 -52 -34 10 -85 9 -112 -2 -105 -41 -163 -27
-163 40 0 48 13 62 56 62 31 1 73 12 94 25 21 13 54 20 75 14 21 -5 68 -16
106 -25z m-10356 -25 l62 -35 -93 -17 c-123 -23 -186 -1 -144 51 38 46 93 46
175 1z m4000 -6 c0 -25 -80 -108 -104 -108 -11 0 -21 28 -21 63 0 50 13 62 63
62 34 0 62 -8 62 -17z m-2535 -121 c37 -34 63 -65 58 -69 -6 -3 -46 -31 -89
-61 l-79 -55 -41 61 c-22 34 -57 62 -77 62 -21 0 -37 23 -37 52 0 39 11 48 48
36 26 -8 55 -3 64 11 26 43 81 30 153 -37z m2035 1 c13 -35 43 -63 66 -63 23
0 88 -37 144 -83 56 -46 122 -90 146 -99 92 -34 25 -183 -74 -163 -31 6 -45
32 -45 83 -1 60 -13 76 -63 83 -34 4 -72 19 -85 31 -13 13 -49 23 -80 23 -45
0 -60 18 -73 87 -27 143 20 216 64 101z m8124 1 c22 -20 85 -51 139 -69 129
-43 143 -142 25 -174 -65 -18 -82 -11 -125 48 -27 38 -80 98 -119 135 -38 36
-69 73 -69 81 0 30 110 14 149 -21z m-9635 -150 c9 -33 4 -81 -10 -105 -23
-41 -28 -39 -55 21 -32 70 -19 145 25 145 14 0 32 -27 40 -61z m9432 1 c8 -40
-1 -44 -62 -29 -92 23 -104 36 -58 65 53 35 110 18 120 -36z m8362 -85 c144
-84 145 -85 130 -178 -12 -69 -6 -102 23 -126 21 -18 39 -53 39 -79 0 -28 24
-52 63 -62 66 -16 78 -59 37 -134 -16 -31 -42 -42 -75 -33 -28 7 -66 0 -84
-15 -26 -22 -42 -19 -66 9 -35 43 -114 50 -137 13 -25 -39 -58 -29 -75 23 -18
57 -65 78 -136 60 -67 -18 -66 -68 1 -131 75 -69 47 -137 -40 -98 -34 16 -63
44 -63 61 0 68 -111 157 -160 130 -48 -27 -89 7 -90 74 0 17 -21 31 -47 31
-46 0 -89 87 -63 129 22 35 60 23 60 -18 0 -84 87 -25 96 64 11 124 67 180
144 144 42 -19 60 -47 60 -97 0 -38 11 -76 25 -84 14 -9 25 -38 25 -64 0 -53
84 -70 113 -23 9 14 39 19 66 10 29 -9 67 0 92 22 23 20 63 41 89 46 66 12 80
67 23 89 -70 26 -268 163 -290 199 -11 18 -48 33 -82 33 -37 0 -61 14 -61 36
0 20 -20 49 -44 64 -37 24 -34 26 19 15 35 -7 79 -3 98 9 40 25 101 1 310
-119z m2183 108 c8 -21 29 -38 48 -38 50 0 62 -34 73 -200 12 -178 -30 -199
-149 -75 -40 41 -84 75 -99 75 -27 0 -46 218 -23 255 21 35 135 21 150 -17z
m-7243 -32 c103 -59 85 -92 -56 -101 -123 -8 -160 42 -87 115 39 39 52 38 143
-14z m-4622 -45 c18 -22 66 -57 107 -78 80 -41 351 -307 333 -326 -7 -6 -61
-17 -120 -24 -60 -6 -133 -24 -164 -39 -42 -20 -65 -18 -96 8 -23 18 -65 45
-95 60 -33 16 -57 55 -62 101 -4 41 -18 85 -31 98 -37 38 -27 143 18 193 51
56 69 57 110 7z m2010 -30 c25 -64 -75 -139 -139 -105 -54 29 -89 -21 -63 -88
16 -42 141 -53 141 -13 0 14 18 25 39 25 52 0 38 -111 -14 -116 -21 -2 -52 -5
-69 -6 -64 -6 -34 -103 32 -103 87 0 86 -104 -3 -162 -49 -32 -61 -56 -50
-101 12 -44 3 -62 -35 -74 -27 -9 -50 -37 -50 -62 0 -66 -61 -106 -181 -118
-151 -15 -188 16 -150 124 41 111 39 143 -11 198 -40 44 -39 50 10 99 82 82
142 45 123 -77 -15 -94 -13 -98 78 -134 109 -44 131 -37 131 45 0 33 13 88 28
122 23 50 21 80 -12 149 -23 47 -41 102 -41 122 0 22 -29 37 -81 39 -215 9
-256 18 -256 55 0 23 23 38 62 38 99 1 248 62 275 112 14 27 61 51 106 57 45
5 89 12 98 14 8 2 23 -16 32 -40z m1814 -56 c-48 -30 -87 9 -65 65 16 41 19
41 60 1 37 -37 38 -46 5 -66z m-2517 -167 c84 -68 85 -143 5 -218 -35 -32 -63
-74 -64 -93 0 -19 -20 -4 -43 34 -52 84 -178 98 -198 22 -14 -52 -118 -137
-201 -163 -39 -13 -84 1 -150 46 -59 41 -128 64 -188 64 -106 0 -123 41 -46
111 30 27 67 38 99 27 42 -13 55 -1 72 65 19 76 29 81 140 88 131 7 165 -62
45 -90 l-59 -14 53 -47 c48 -45 55 -45 98 -6 25 22 59 41 75 41 43 0 35 24
-24 73 -71 57 -45 134 72 214 l91 62 78 -81 c44 -44 109 -105 145 -135z
m-4239 144 c44 -17 81 -47 81 -65 0 -60 -47 -65 -99 -13 -28 28 -62 51 -76 51
-14 0 -25 18 -25 40 0 21 8 35 19 29 10 -5 55 -24 100 -42z m-7819 -39 c0 -41
-23 -47 -85 -23 -51 20 -26 60 36 60 27 0 49 -17 49 -37z m735 22 c65 -25 45
-60 -33 -60 -93 0 -156 24 -138 53 16 25 113 29 171 7z m7776 -8 c21 -34 -12
-102 -48 -102 -31 0 -63 52 -63 102 0 30 93 30 111 0z m6527 -42 c68 -44 61
-85 -14 -85 -49 0 -110 81 -81 109 22 22 26 21 95 -24z m-14569 -31 c-6 -29
-31 -40 -81 -36 -169 12 -180 67 -14 73 84 3 102 -4 95 -37z m3694 21 c8 -14
38 -25 65 -25 41 0 47 -11 33 -56 -21 -68 -8 -57 -98 -89 l-75 -26 71 -2 c47
-1 75 -18 83 -50 7 -26 35 -53 62 -60 43 -12 45 -19 16 -66 -27 -44 -27 -56 4
-75 28 -18 30 -35 9 -81 -15 -31 -39 -87 -53 -123 -28 -70 -145 -117 -186 -76
-31 31 16 119 82 154 49 27 71 150 26 150 -12 0 -16 23 -9 50 11 43 1 50 -78
50 l-90 0 0 160 c0 157 13 183 92 188 17 1 37 -9 46 -23z m13259 -9 c42 -50
-32 -110 -82 -68 -28 23 -41 21 -59 -12 -18 -32 -34 -35 -71 -15 -26 14 -67
31 -91 39 -99 30 -43 71 81 59 69 -6 125 -2 125 10 0 33 66 25 97 -13z m1278
-31 c0 -24 -31 -35 -100 -35 -90 0 -131 36 -88 78 27 27 188 -10 188 -43z
m-3205 -29 c9 -63 -62 -79 -115 -26 -54 54 -35 99 39 90 49 -5 71 -23 76 -64z
m-12849 -924 c4 -799 -7 -940 -62 -851 -27 43 -24 1750 4 1794 44 72 55 -97
58 -943z m18574 872 c102 -91 100 -103 -14 -97 -86 5 -94 12 -101 87 -10 99
13 102 115 10z m-13557 -16 c0 -26 -15 -51 -32 -57 -20 -6 -31 14 -31 57 0 42
11 62 31 56 17 -6 32 -31 32 -56z m7112 39 c0 -13 20 -30 44 -38 24 -8 69 -52
100 -98 79 -115 158 -154 250 -122 142 50 234 -116 94 -169 -75 -28 -90 -159
-23 -185 31 -12 37 -35 24 -103 -15 -80 -11 -87 45 -87 74 0 99 -55 61 -138
-22 -49 -20 -71 10 -106 20 -24 44 -63 53 -87 12 -36 27 -39 81 -19 77 30 111
15 111 -50 0 -26 12 -54 26 -63 18 -11 13 -27 -12 -46 -46 -33 -19 -164 47
-230 45 -46 51 -125 11 -150 -15 -10 -54 15 -86 55 -48 59 -65 67 -103 44 -64
-39 -70 -103 -11 -122 28 -8 58 -38 66 -66 15 -47 20 -48 61 -10 25 22 60 37
78 33 22 -5 40 37 55 130 22 135 68 230 68 141 0 -26 30 -54 73 -69 115 -40
203 -291 126 -361 -44 -40 -55 -40 -175 -1 -115 38 -134 38 -204 4 -95 -48
-95 -48 -95 -1 0 20 -11 37 -25 37 -14 0 -25 -23 -25 -51 0 -28 -17 -57 -37
-65 -75 -28 -36 -75 89 -107 94 -24 132 -48 149 -92 25 -65 37 -68 182 -44 72
12 103 32 123 81 l26 66 26 -68 c14 -37 48 -71 76 -75 27 -4 54 -22 60 -39 15
-45 -81 -39 -120 8 -47 57 -83 5 -65 -94 16 -83 18 -84 151 -84 77 0 152 -15
176 -34 33 -29 51 -29 101 -2 35 19 97 26 149 18 76 -13 89 -8 89 34 0 35 -17
48 -63 48 -35 0 -120 42 -189 94 -118 88 -125 99 -118 193 7 95 11 100 83 93
112 -10 138 -24 122 -65 -12 -30 -24 -32 -61 -9 -55 35 -87 13 -64 -45 9 -24
31 -35 54 -26 24 9 81 -26 156 -98 64 -62 125 -112 136 -112 28 0 23 -95 -7
-113 -14 -9 11 -40 56 -71 48 -32 86 -81 91 -117 5 -34 28 -84 51 -111 122
-143 123 -149 9 -91 -69 35 -106 71 -106 102 0 79 -171 230 -226 200 -25 -13
-68 -24 -94 -24 -102 0 -109 -61 -17 -151 48 -46 87 -94 87 -106 0 -12 39 -58
88 -104 68 -65 87 -102 87 -173 0 -109 -18 -113 -90 -22 -53 65 -57 66 -103
25 -27 -24 -72 -44 -100 -44 -30 0 -57 -20 -64 -50 -14 -52 -103 -70 -130 -25
-9 14 -41 25 -72 25 -67 0 -116 44 -116 102 0 24 -19 50 -42 59 -24 9 -32 24
-18 37 19 18 199 6 476 -33 76 -11 77 -9 53 57 -29 75 -127 135 -163 99 -25
-25 -106 -2 -106 30 0 11 23 28 50 37 84 26 45 138 -83 238 l-70 55 -14 -53
c-21 -81 -76 -63 -108 35 -31 94 -95 115 -150 50 -26 -32 -21 -38 34 -38 54 0
66 -12 66 -62 0 -57 10 -63 108 -63 127 0 176 -36 140 -104 -14 -26 -18 -58
-10 -72 24 -39 -48 -53 -126 -24 -59 23 -75 20 -94 -13 -16 -29 -42 -36 -83
-26 -78 19 -114 -53 -50 -100 29 -21 34 -37 15 -48 -15 -10 -43 -4 -63 12 -29
24 -41 18 -65 -35 -17 -36 -39 -65 -51 -65 -35 0 -24 -55 20 -104 28 -31 77
-46 150 -46 60 0 109 -11 109 -25 0 -59 102 -129 141 -97 25 21 43 23 55 5 9
-14 69 -25 134 -25 109 0 119 6 134 72 13 59 22 67 51 43 43 -36 46 -172 4
-182 -17 -5 -70 -21 -116 -36 -47 -16 -98 -21 -113 -11 -46 29 -198 30 -232 2
-24 -20 -36 -16 -48 14 -24 64 -85 48 -85 -22 0 -35 -11 -63 -25 -63 -14 0
-25 17 -25 38 0 21 -20 46 -44 55 -24 9 -55 32 -70 51 -22 30 -31 30 -59 -4
-116 -139 -271 38 -286 326 -5 116 -50 184 -119 184 -64 0 -59 69 8 124 l55
45 -107 128 c-103 122 -113 128 -230 128 -68 0 -123 10 -123 22 0 12 -33 35
-73 52 -40 17 -78 54 -86 82 -18 70 9 111 44 67 66 -84 107 -101 175 -70 76
35 81 57 21 102 -95 71 -137 216 -103 355 17 70 41 141 53 157 26 35 -19 68
-69 49 -41 -16 -77 84 -52 148 8 22 4 32 -10 23 -14 -8 -25 14 -25 51 0 37
-22 95 -50 130 -27 35 -50 88 -50 118 0 66 -143 258 -207 279 -62 19 -44 100
20 90 27 -4 134 -10 237 -13 177 -4 188 -8 220 -73 19 -41 53 -69 82 -69 27 0
57 -20 65 -44 9 -24 48 -84 87 -134 70 -90 70 -92 20 -125 -47 -32 -48 -38
-11 -91 60 -84 137 -74 137 18 0 40 11 80 25 89 50 31 24 108 -47 140 -44 19
-67 45 -60 65 7 19 -7 56 -31 82 -33 37 -37 57 -17 82 21 25 9 47 -50 94 -43
34 -102 85 -130 114 -55 55 -121 55 -100 -1 10 -24 -31 -41 -145 -59 -175 -29
-399 -5 -416 45 -6 17 -33 54 -61 82 -39 39 -44 60 -24 93 15 23 18 56 7 74
-11 17 -8 63 7 103 23 61 19 83 -31 151 l-59 79 60 46 c124 96 259 147 391
147 72 0 131 -10 131 -23z m-6800 -80 c0 -16 20 -43 44 -61 24 -18 36 -39 28
-47 -23 -23 -199 87 -183 113 20 33 111 28 111 -5z m750 -47 c0 -57 -63 -68
-83 -15 -16 41 3 65 50 65 18 0 33 -23 33 -50z m-6925 -90 c0 -113 -59 -104
-70 11 -6 58 2 79 31 79 28 0 39 -25 39 -90z m4961 -15 c2 -4 29 -40 59 -80
68 -88 69 -142 7 -218 l-48 -59 -80 81 c-44 44 -90 81 -103 81 -89 0 -179 207
-117 269 24 24 257 -37 282 -74z m14789 95 c0 -45 -38 -90 -76 -90 -53 0 -84
38 -61 75 14 24 137 37 137 15z m-16533 -80 c14 -37 1 -53 -88 -107 -74 -44
-102 -293 -57 -507 29 -136 27 -144 -34 -210 -61 -66 -63 -66 -63 -14 0 30
-22 99 -50 153 -27 54 -50 115 -50 137 0 21 -17 38 -37 38 -25 0 -38 -25 -38
-74 0 -40 -11 -80 -25 -88 -42 -26 -29 203 17 299 48 100 47 100 139 52 85
-44 103 -20 54 74 -40 77 -17 177 58 252 48 47 155 44 174 -5z m3246 13 c19
-30 -56 -123 -98 -123 -58 0 -93 96 -46 123 57 33 124 34 144 0z m2249 -23
c18 -28 -80 -107 -110 -88 -28 17 -37 95 -13 119 17 17 108 -5 123 -31z m5163
-36 c0 -101 29 -127 96 -85 55 33 190 -74 208 -165 4 -26 31 -59 58 -74 27
-15 94 -64 148 -109 104 -85 161 -100 209 -52 22 22 38 21 67 -3 57 -47 50
-108 -10 -89 -43 14 -51 0 -66 -111 -15 -112 -23 -126 -77 -126 -45 0 -67 -20
-87 -76 -15 -42 -38 -72 -52 -68 -27 9 -121 159 -179 286 -40 88 -184 231
-234 232 -44 1 -131 93 -131 139 0 20 -18 37 -40 37 -28 0 -37 -15 -28 -47 25
-99 -24 -115 -105 -34 -102 102 -103 166 -2 151 89 -13 97 21 25 112 -56 71
-67 155 -19 137 117 -44 145 -46 159 -8 27 68 60 42 60 -47z m-6243 46 c8 -9
3 -35 -12 -59 -41 -65 -5 -176 57 -176 30 0 68 -30 93 -75 36 -64 56 -74 130
-69 85 6 88 4 95 -91 13 -155 -91 -176 -193 -38 -72 98 -152 98 -152 0 0 -84
57 -152 127 -152 26 0 48 -17 48 -37 0 -54 -57 -47 -139 18 -39 30 -122 61
-185 68 l-113 14 -16 128 c-9 71 -40 160 -71 202 -69 94 -62 216 13 227 39 5
65 -20 108 -106 62 -125 90 -141 110 -64 9 34 -3 59 -34 76 -47 25 -64 99 -31
132 21 21 144 22 165 2z m3836 -82 c79 -93 74 -153 -12 -153 -138 0 -307 166
-239 234 35 35 197 -17 251 -81z m868 55 c9 -23 0 -58 -20 -77 -46 -47 -141 0
-141 70 0 64 137 70 161 7z m-12050 -62 c43 -86 19 -146 -59 -146 -98 0 -142
149 -58 198 65 38 74 34 117 -52z m6789 35 c-1 -24 -11 -60 -24 -81 -34 -53
-86 5 -64 72 20 64 88 71 88 9z m4750 -31 c15 -27 44 -50 66 -50 27 0 34 -13
22 -44 -30 -79 -26 -93 27 -93 28 0 72 -17 96 -37 39 -33 48 -31 79 11 19 26
35 57 35 68 0 42 99 18 134 -33 62 -88 -23 -172 -171 -172 -33 0 -67 -12 -76
-26 -20 -32 101 -149 154 -149 25 0 35 -19 29 -56 -6 -45 -26 -58 -101 -64
l-94 -8 0 114 c0 107 -6 118 -89 157 -70 33 -86 54 -76 94 10 38 -16 78 -104
158 -114 104 -116 110 -70 144 66 49 107 45 139 -14z m-5830 -5 c36 -36 40
-161 5 -183 -14 -8 -35 12 -48 46 -13 33 -41 67 -63 75 -21 9 -39 33 -39 54 0
46 101 52 145 8z m2790 -35 c45 -17 55 -148 14 -173 -17 -11 -10 -29 18 -50
43 -31 43 -35 -2 -85 -69 -76 -98 -64 -80 32 15 78 10 86 -53 98 -38 8 -83 3
-99 -11 -20 -17 -38 -9 -56 26 -31 56 -3 86 58 63 26 -10 40 -2 40 24 0 62 87
104 160 76z m1492 -17 c-1 -10 -2 -47 -2 -82 0 -36 -11 -57 -25 -48 -34 20
-32 169 2 157 15 -5 26 -17 25 -27z m-3481 -15 c48 -30 -5 -124 -78 -139 -197
-40 -235 -39 -277 7 -24 26 -35 65 -26 88 19 50 20 50 107 5 63 -33 73 -32
111 13 44 51 108 61 163 26z m-5828 -209 c-5 -45 -10 -14 -10 69 0 82 4 119
10 81 6 -37 6 -105 0 -150z m5346 112 c-19 -81 -19 -81 -8 -252 9 -141 -19
-198 -45 -93 -9 35 -31 64 -48 64 -69 0 -94 68 -53 142 21 39 51 101 66 139
16 38 46 69 67 69 29 0 34 -17 21 -69z m-1039 0 c-1 -73 -40 -118 -59 -69 -26
69 -18 113 22 113 20 0 37 -20 37 -44z m575 11 c0 -61 -62 -120 -107 -103 -59
22 -55 86 6 86 26 0 55 11 64 25 21 35 37 31 37 -8z m1229 -107 c24 -188 57
-246 186 -332 95 -63 136 -75 201 -63 118 22 149 -8 82 -80 -64 -68 -115 -74
-182 -23 -89 67 -303 75 -442 15 -92 -40 -137 -47 -168 -29 -39 23 -38 26 11
26 77 1 96 45 44 103 -41 45 -41 51 -2 94 52 58 52 66 -12 153 -71 96 -47 146
80 167 73 11 108 31 117 64 22 83 68 32 85 -95z m2282 84 c43 -61 52 -158 16
-180 -12 -8 -16 -60 -8 -117 13 -98 11 -102 -43 -85 -31 10 -107 4 -168 -13
-111 -31 -112 -32 -95 -121 21 -116 30 -128 88 -128 38 0 49 17 49 74 0 79 24
108 67 81 32 -21 133 -227 133 -272 0 -60 -121 -37 -166 32 -34 52 -56 62
-113 50 -60 -11 -73 -4 -86 48 -8 34 -31 62 -50 62 -37 0 -44 24 -36 121 3 35
-16 73 -47 95 -53 38 -71 109 -28 109 52 0 119 102 107 163 -10 53 -1 64 67
78 43 8 84 25 91 37 29 47 182 23 222 -34z m-11025 -7 c26 -20 41 -44 32 -53
-24 -23 -170 43 -154 69 20 32 66 26 122 -16z m11805 1 c29 -76 -8 -115 -78
-84 -92 42 -82 121 17 121 26 0 53 -17 61 -37z m-10202 -115 c2 -101 -11 -148
-40 -148 -12 0 -21 57 -20 126 1 144 58 164 60 22z m355 87 c56 -11 72 -26 63
-60 -14 -56 38 -92 58 -39 24 60 60 46 60 -23 0 -35 11 -63 25 -63 14 0 25
-16 25 -36 0 -20 16 -46 36 -57 27 -15 36 -94 41 -344 5 -319 4 -325 -48 -320
-39 5 -54 -7 -54 -43 0 -34 17 -50 51 -50 60 0 77 -36 86 -181 3 -58 15 -135
26 -169 l21 -62 -67 62 c-36 34 -66 87 -67 117 0 30 -57 116 -131 195 -368
395 -350 368 -269 419 34 21 50 58 50 116 l0 84 105 -16 c59 -10 127 -40 152
-67 60 -65 96 -39 83 60 -18 134 -41 165 -160 218 -142 63 -205 127 -205 210
0 69 6 72 119 49z m15372 -83 c17 -33 48 -70 70 -83 61 -34 20 -74 -42 -41
-43 23 -59 20 -86 -17 -18 -25 -33 -33 -33 -19 0 15 -39 35 -87 44 -49 9 -88
27 -88 40 0 13 39 24 88 24 91 0 113 38 56 97 -26 26 -20 31 30 24 35 -5 75
-35 92 -69z m6047 21 c10 -14 -1 -46 -23 -70 -22 -25 -40 -62 -40 -83 0 -103
-157 -117 -188 -18 -21 65 32 128 90 110 30 -10 54 3 72 37 30 56 64 65 89 24z
m-10794 -46 c56 -30 184 -62 225 -55 37 6 38 -1 7 -83 -14 -35 -42 -64 -63
-64 -24 0 -38 -23 -38 -62 0 -95 -118 -91 -130 5 -5 48 -25 72 -68 82 -79 18
-94 66 -28 87 52 17 71 63 26 63 -14 0 -25 11 -25 25 0 31 38 32 94 2z
m-12198 -66 c33 -72 38 -161 9 -161 -10 0 -32 34 -47 75 -16 41 -39 75 -52 75
-29 0 -55 -202 -56 -417 0 -201 -14 -233 -103 -233 -86 0 -127 69 -63 104 22
13 41 39 41 58 0 18 14 39 31 44 21 7 32 69 33 185 3 254 136 427 207 270z
m4816 2 c33 8 79 -15 133 -64 79 -72 81 -80 51 -150 -39 -86 -84 -96 -104 -22
-11 41 -23 47 -57 28 -99 -55 -235 47 -235 177 0 83 18 94 95 54 36 -19 89
-29 117 -23z m4870 25 c38 -20 89 -29 113 -21 32 12 29 2 -13 -38 -89 -87
-207 -57 -207 51 0 54 17 56 107 8z m1228 -3 c51 -20 26 -60 -36 -60 -27 0
-49 17 -49 38 0 40 23 46 85 22z m1858 -19 c27 -46 117 -91 181 -91 29 0 59
-17 67 -37 8 -21 34 -38 58 -38 101 0 200 -226 113 -259 -31 -12 -38 -33 -26
-81 9 -36 4 -80 -12 -98 -35 -43 -101 -20 -82 28 24 63 -11 116 -60 89 -70
-40 -132 10 -132 107 0 168 -80 232 -109 87 -23 -117 -101 -90 -112 38 -6 79
4 108 50 144 54 42 55 48 15 72 -24 14 -44 36 -44 49 0 36 70 29 93 -10z
m-9186 -85 c25 -23 38 -58 30 -84 -15 -45 101 -247 141 -247 12 0 22 -17 22
-37 0 -44 -89 -50 -185 -14 -45 17 -70 53 -90 131 -16 59 -51 139 -79 178 -95
133 31 190 161 73z m11543 6 c43 -45 52 -70 32 -90 -47 -47 -205 70 -170 127
26 43 76 30 138 -37z m7200 27 c0 -30 -60 -139 -76 -139 -22 0 -47 119 -29
137 16 16 105 17 105 2z m-5546 -95 c42 -25 55 -25 64 0 8 24 19 23 45 -4 19
-19 62 -28 98 -21 52 10 64 2 64 -41 0 -29 -16 -53 -35 -53 -74 0 -87 -140
-15 -163 64 -20 40 -62 -35 -62 -31 0 -65 -8 -76 -19 -10 -10 -43 -18 -73 -18
-45 0 -53 -15 -53 -88 0 -71 -11 -89 -56 -95 -53 -8 -78 6 -178 95 -97 87
-203 150 -252 150 -30 0 -52 16 -52 38 0 59 -127 48 -143 -13 -8 -31 -34 -50
-69 -50 -36 0 -62 -19 -70 -50 -7 -27 -31 -50 -53 -50 -22 0 -40 -9 -40 -21 0
-44 33 -50 85 -16 52 34 224 36 257 3 9 -9 36 -16 61 -16 60 0 83 -44 46 -89
-25 -29 -21 -36 21 -36 28 0 55 12 60 26 5 17 41 13 101 -12 51 -22 116 -39
145 -39 37 0 50 -13 44 -44 -6 -28 -29 -41 -65 -38 -40 5 -55 -7 -55 -43 0
-28 11 -50 25 -50 14 0 25 -29 25 -65 0 -68 -15 -70 -136 -21 -39 16 -45 12
-30 -26 11 -28 1 -63 -25 -92 -40 -44 -38 -46 23 -46 36 0 77 -20 90 -44 21
-35 34 -38 72 -15 58 36 243 -121 285 -241 19 -55 42 -75 85 -75 71 0 113 -68
85 -140 -30 -79 -94 -92 -174 -35 -91 65 -124 63 -106 -4 13 -51 8 -53 -106
-37 -150 20 -248 106 -225 198 9 35 4 70 -11 80 -39 23 -8 63 49 63 112 0 -14
135 -151 162 -148 29 -250 86 -250 140 0 63 67 90 128 52 71 -45 136 -39 97 9
-17 20 -46 37 -64 37 -18 0 -50 24 -70 53 -25 35 -52 48 -80 37 -78 -29 -136
8 -136 87 0 60 -10 73 -59 73 -158 0 -136 231 37 388 98 88 248 121 285 62 26
-43 66 -27 51 20 -10 31 8 57 59 87 94 56 134 55 116 -3 -26 -80 205 -189 330
-156 82 21 109 118 40 144 -66 25 -134 90 -134 126 0 40 36 41 104 1z m-7294
-56 c37 -35 98 -63 135 -63 121 0 380 -147 380 -216 0 -41 20 -68 63 -84 35
-13 62 -44 62 -70 0 -51 142 -130 235 -130 67 0 215 -48 215 -70 0 -30 -135
-155 -167 -155 -19 0 -33 28 -33 63 0 38 -14 62 -37 62 -27 0 -38 -26 -38 -87
0 -49 -7 -88 -16 -88 -56 0 -190 145 -244 264 -60 132 -68 139 -136 124 -74
-16 -148 36 -118 84 25 41 -41 154 -97 165 -79 16 -216 39 -320 55 -82 11 -94
22 -94 81 0 134 101 166 210 65z m1854 39 c13 -12 52 -27 86 -31 46 -6 64 -26
70 -74 15 -132 -140 -198 -170 -72 -23 100 -138 100 -194 0 -85 -153 -97 -164
-140 -128 -26 22 -72 27 -136 16 -74 -12 -105 -6 -131 26 -60 72 130 217 264
202 64 -7 135 5 200 35 120 55 121 55 151 26z m-9581 -104 c-34 -34 -113 -22
-126 19 -5 16 16 33 48 39 72 11 115 -21 78 -58z m10103 54 c8 -13 54 -17 102
-10 71 12 105 0 198 -70 147 -111 147 -148 2 -223 -66 -34 -75 -52 -75 -148
l0 -110 -125 -29 c-69 -17 -154 -42 -189 -56 -47 -19 -85 -17 -144 8 -138 58
-78 161 93 161 106 0 97 28 -35 111 -115 73 -148 152 -75 180 23 9 33 32 24
59 -25 82 181 198 224 127z m11024 2 c7 -12 -14 -34 -48 -50 -49 -22 -62 -21
-62 5 0 61 80 93 110 45z m-20216 -98 c6 -18 -11 -31 -42 -31 -31 0 -52 16
-52 39 0 46 78 40 94 -8z m1483 -117 c37 -39 27 -64 -27 -64 -56 0 -58 8 -32
128 16 76 19 78 27 22 5 -34 20 -73 32 -86z m588 75 c17 -43 -63 -162 -109
-163 -17 -1 -31 -12 -31 -24 0 -13 39 -17 88 -10 76 13 87 8 87 -37 0 -73 45
-93 54 -24 11 71 131 95 155 31 19 -50 -51 -311 -96 -358 -37 -39 -175 -19
-206 29 -10 16 -24 86 -32 155 -12 119 -16 124 -83 119 -131 -9 -149 -45 -137
-279 14 -263 50 -303 269 -303 113 0 164 14 238 64 112 76 130 67 77 -35 -46
-91 -49 -154 -11 -239 16 -34 23 -77 16 -95 -25 -64 -18 -81 35 -82 59 -1 125
-162 123 -304 0 -44 16 -93 36 -110 21 -16 37 -71 37 -121 l-1 -90 -64 112
c-36 62 -71 150 -79 197 l-14 84 -41 -55 c-60 -79 -97 -23 -117 177 -17 182
-69 246 -201 246 -44 1 -87 13 -96 27 -35 56 -216 151 -261 137 -34 -11 -66
10 -117 80 -39 52 -113 146 -165 209 -52 62 -94 126 -94 141 0 36 127 64 204
44 44 -11 79 2 128 48 96 88 89 140 -18 140 -47 0 -93 12 -102 27 -25 39 62
123 126 123 38 0 66 23 86 74 26 62 47 75 135 83 57 5 118 11 136 14 17 2 38
-12 45 -32z m2399 9 c26 -42 -32 -90 -67 -55 -29 29 -11 82 28 82 12 0 30 -12
39 -27z m6511 -22 c0 -26 -11 -55 -25 -63 -46 -29 -29 -95 19 -75 136 58 381
-130 381 -293 0 -16 19 -49 41 -74 50 -55 19 -58 -94 -11 -60 25 -83 51 -84
93 -1 76 -78 93 -100 23 -14 -42 -25 -46 -66 -24 -34 18 -45 41 -34 74 11 37
-2 56 -55 80 -108 48 -186 143 -168 204 31 108 185 162 185 66z m-13950 -49
c0 -52 -133 -177 -188 -177 -54 0 -172 113 -152 146 28 45 100 34 134 -21 39
-62 78 -64 98 -6 37 104 108 142 108 58z m9463 -98 c55 -53 125 -109 156 -126
32 -17 51 -40 44 -52 -20 -33 -246 -19 -284 17 -18 18 -58 32 -89 32 -123 0
-183 178 -70 208 101 27 148 11 243 -79z m-6069 15 c14 -17 31 -54 38 -81 12
-48 12 -48 15 3 7 122 158 81 189 -51 21 -89 -16 -118 -122 -97 -69 14 -73 11
-42 -26 19 -23 55 -42 81 -42 64 0 60 -41 -6 -58 -97 -26 -36 -79 90 -80 136
0 183 -54 153 -174 -18 -72 -84 -70 -170 5 -23 20 -55 29 -71 19 -40 -25 -142
34 -157 91 -22 84 -67 50 -67 -50 0 -64 13 -103 38 -112 60 -23 49 -166 -13
-166 -40 0 -50 17 -50 86 0 47 -11 93 -25 102 -27 16 -35 169 -9 194 8 9 18
87 22 173 10 255 44 340 106 264z m843 6 c28 -44 -15 -200 -55 -200 -24 0 -32
14 -22 41 9 22 3 56 -12 74 -16 19 -22 51 -14 72 16 43 80 51 103 13z m7299
-79 c85 -171 39 -212 -116 -105 -109 75 -109 77 -54 138 62 68 125 56 170 -33z
m-5824 23 c6 -17 40 -130 75 -249 45 -149 93 -251 152 -321 132 -158 116 -196
-55 -131 -64 23 -100 -151 -45 -218 49 -60 67 -190 34 -244 -40 -64 -11 -174
52 -194 32 -10 50 -37 50 -75 0 -35 21 -72 50 -87 29 -16 50 -52 50 -89 0 -56
-5 -59 -53 -30 -43 25 -56 25 -65 0 -17 -47 -119 -37 -167 16 -40 44 -51 153
-44 450 1 46 -15 117 -35 156 -28 53 -31 85 -12 121 19 34 16 93 -11 206 -43
183 -52 720 -12 720 14 0 30 -14 36 -31z m278 -8 c-17 -45 79 -186 128 -186
18 0 44 -27 56 -60 13 -33 35 -68 49 -77 56 -34 24 -63 -69 -63 -107 0 -165
49 -251 212 -79 149 -71 213 25 213 60 0 74 -9 62 -39z m2135 -24 c38 -45 76
-201 92 -382 16 -165 2 -205 -67 -187 -38 10 -48 25 -34 54 11 22 20 97 20
166 1 118 -2 124 -60 118 -33 -4 -79 -24 -102 -44 -103 -94 -124 -31 -45 136
88 188 131 218 196 139z m3637 4 c50 -37 33 -91 -30 -91 -44 0 -132 70 -132
104 0 33 111 25 162 -13z m5597 -22 c34 -53 2 -90 -85 -100 -53 -6 -63 5 -69
77 -8 77 -4 82 60 75 37 -5 80 -28 94 -52z m-11859 -42 c0 -65 -26 -127 -53
-127 -25 0 -29 77 -7 135 21 55 60 50 60 -8z m3105 -23 c40 -39 40 -53 -8
-228 -28 -103 -62 -202 -76 -219 -40 -48 -7 -102 86 -141 216 -90 241 -263 61
-420 -188 -164 -184 -164 -433 -46 -189 88 -234 122 -300 221 -42 64 -98 120
-125 124 -77 13 -210 80 -210 106 0 38 158 28 218 -14 29 -20 82 -40 118 -43
41 -3 93 -40 140 -99 42 -52 93 -95 113 -95 20 0 36 -11 36 -25 0 -14 23 -25
50 -25 37 0 50 -17 50 -62 0 -81 56 -81 185 -2 l97 60 -91 38 c-98 41 -120
111 -53 166 20 17 37 51 37 75 0 25 -17 51 -37 59 -21 8 -38 41 -38 74 0 32
-8 66 -17 76 -10 9 -21 76 -25 148 -3 72 -13 167 -21 212 -23 128 133 166 243
60z m519 -78 c49 -31 55 -299 8 -355 -41 -48 30 -86 112 -60 25 7 82 3 127
-10 93 -26 148 35 70 78 -29 17 -41 58 -41 147 0 120 30 163 59 87 8 -21 43
-38 79 -38 54 0 63 -10 57 -65 -15 -137 124 -144 200 -11 23 42 60 76 82 76
39 0 112 -135 129 -237 6 -41 27 -50 107 -50 155 0 157 -96 4 -161 -124 -53
-161 -120 -115 -205 29 -56 29 -56 67 17 52 100 141 155 128 80 -8 -42 55
-169 83 -169 47 0 -14 -56 -98 -91 -77 -33 -93 -32 -149 4 -45 30 -70 33 -94
13 -24 -20 -51 -19 -99 2 -63 29 -91 97 -40 97 14 0 25 11 25 25 0 14 -22 25
-50 25 -60 0 -60 -2 -11 96 47 93 31 129 -56 129 -36 0 -78 18 -93 39 -23 31
-90 40 -319 44 -261 5 -298 12 -381 68 -151 102 -230 316 -104 285 52 -13 61
-6 68 55 7 56 24 75 84 87 110 24 121 23 161 -2z m3876 -59 c0 -75 24 -99 65
-65 38 32 92 7 78 -36 -5 -15 -48 -28 -95 -28 -77 0 -86 -8 -93 -77 -5 -52
-29 -89 -75 -116 -87 -49 -126 -34 -111 43 13 70 -10 77 -80 24 -74 -56 -214
-49 -214 11 0 68 26 127 55 127 14 0 59 28 100 63 51 43 104 62 170 62 54 0
104 11 113 25 29 48 87 26 87 -33z m-5987 -32 c66 -43 82 -85 33 -85 -35 0
-121 74 -121 104 0 30 19 26 88 -19z m4262 -12 c0 -61 -58 -52 -71 10 -4 25 8
42 32 42 23 0 39 -21 39 -52z m529 -50 c22 -104 -11 -146 -79 -104 -78 49
-131 40 -112 -19 19 -62 -32 -68 -75 -9 -26 35 -43 37 -113 13 -115 -40 -192
-36 -210 11 -26 69 10 91 125 73 116 -17 145 15 79 85 -26 27 -7 30 106 17 78
-9 154 -5 175 9 57 38 84 18 104 -76z m5557 10 c10 -26 1 -51 -22 -64 -38 -21
-13 -105 45 -147 11 -8 34 -42 50 -75 16 -32 52 -63 79 -68 27 -5 68 -25 90
-45 37 -33 47 -29 92 27 66 85 93 81 121 -17 23 -80 193 -203 242 -175 12 6
70 16 130 22 99 9 113 3 146 -59 35 -67 44 -69 233 -69 l196 0 3 -208 c5 -241
-11 -259 -159 -184 -65 34 -110 43 -134 28 -70 -45 -116 -26 -133 55 -19 100
-8 111 64 61 75 -52 111 -50 169 8 113 113 110 144 -15 161 -197 27 -226 22
-243 -46 -10 -41 -39 -68 -84 -78 -38 -9 -103 -49 -146 -90 -77 -73 -130 -78
-260 -26 -21 8 -80 16 -131 17 -85 1 -93 -4 -88 -61 5 -48 -5 -62 -43 -62 -36
0 -53 19 -58 68 -9 72 -8 73 264 185 123 51 128 63 44 129 -53 42 -75 45 -164
21 -99 -26 -147 -6 -149 65 0 32 70 21 82 -12 27 -77 43 12 19 103 -27 101
-30 103 -139 103 -105 0 -112 4 -115 69 -6 135 -10 144 -76 151 -90 11 -167
120 -99 142 26 8 67 36 91 64 55 60 77 62 98 7z m-9626 -44 c19 -77 2 -119
-64 -161 -96 -60 -114 73 -23 174 54 60 69 58 87 -13z m3290 -29 c102 -93 126
-174 69 -231 -23 -23 -24 -36 -2 -49 16 -10 37 -49 46 -86 14 -54 26 -63 60
-45 57 31 89 6 135 -105 22 -52 48 -94 59 -93 45 2 158 125 158 173 0 28 8 52
19 53 109 14 254 27 299 28 70 1 105 92 47 125 -100 56 -22 128 118 107 100
-15 116 -26 130 -90 19 -87 105 -98 175 -22 61 68 73 64 173 -44 103 -110 104
-116 40 -180 -85 -85 -217 -69 -286 36 -57 87 -115 82 -115 -9 0 -53 15 -77
56 -90 51 -16 52 -20 10 -30 -25 -7 -59 0 -74 15 -15 15 -46 27 -69 27 -24 0
-49 17 -57 38 -15 39 -91 52 -91 15 0 -12 17 -36 38 -53 20 -17 37 -40 37 -51
0 -36 -236 -43 -310 -8 -93 43 -87 45 -116 -32 -23 -59 -35 -64 -131 -53 -101
12 -318 130 -318 173 0 39 -70 21 -86 -21 -12 -31 -23 -34 -45 -12 -50 50 -72
32 -64 -52 11 -115 -53 -116 -166 -3 -73 73 -89 105 -77 154 12 47 23 55 44
34 42 -42 94 -36 94 10 0 22 28 76 63 121 34 45 62 101 62 124 0 23 -28 53
-62 66 -74 28 -80 69 -19 115 24 18 46 34 50 34 3 1 51 -40 106 -89z m10725
28 c17 -21 45 -38 63 -38 17 0 45 17 62 38 43 51 82 46 120 -15 26 -40 26 -60
3 -88 -24 -28 -21 -45 11 -81 23 -25 41 -66 41 -91 0 -26 16 -64 35 -86 48
-54 62 -231 20 -246 -19 -6 -39 12 -47 41 -17 66 -35 66 -117 1 -81 -63 -85
-104 -10 -93 43 6 58 -6 64 -49 9 -61 53 -73 100 -26 34 34 36 24 31 -121 -4
-83 11 -121 72 -191 115 -131 98 -228 -32 -178 -28 10 -35 35 -24 89 l15 74
-147 -8 c-131 -7 -148 -14 -155 -64 -9 -59 -41 -74 -67 -31 -23 37 -70 31
-200 -25 l-117 -50 81 -81 c45 -45 127 -99 183 -120 87 -32 104 -50 110 -116
10 -103 93 -128 174 -52 l57 54 -74 58 c-79 62 -103 248 -35 275 59 22 157
-77 174 -176 9 -53 31 -102 50 -109 19 -7 34 -29 34 -48 0 -51 215 -48 234 3
8 20 37 37 64 37 82 0 80 40 -8 126 -131 128 -50 239 126 173 60 -23 75 -19
114 31 38 49 44 51 44 13 1 -59 -68 -193 -100 -193 -13 0 -24 -17 -24 -37 0
-23 23 -38 57 -38 53 0 160 -91 135 -116 -6 -6 -75 -16 -153 -21 -187 -14
-240 -33 -296 -104 -26 -32 -68 -59 -93 -59 -26 0 -54 -11 -62 -25 -9 -14 -34
-25 -57 -25 -35 0 -34 5 6 34 28 21 40 50 30 75 -20 53 -35 51 -152 -16 -132
-75 -159 -123 -105 -183 84 -93 158 -228 175 -320 15 -77 26 -90 66 -77 28 9
49 4 49 -12 0 -15 28 -38 63 -51 79 -30 78 -62 -3 -138 -62 -57 -68 -58 -127
-19 -38 25 -57 57 -50 84 18 71 -152 93 -200 25 -46 -67 -158 -67 -234 -1 -32
28 -74 45 -93 37 -19 -7 -56 -1 -83 13 -38 20 -52 17 -64 -12 -14 -39 -84 -56
-84 -20 3 137 245 179 377 65 51 -44 97 -43 194 5 98 49 99 73 3 153 -62 52
-70 70 -45 100 29 36 -4 81 -60 83 -11 0 -19 27 -19 59 0 33 -7 95 -16 137
l-15 78 -72 -51 c-78 -56 -122 -46 -122 27 0 68 -51 89 -67 28 -19 -75 -83
-67 -83 10 0 34 -11 62 -24 62 -14 0 -43 35 -65 77 -36 70 -48 76 -123 62 -55
-10 -87 -5 -93 15 -16 46 -74 -3 -59 -50 7 -23 3 -58 -10 -77 -15 -25 -7 -56
26 -98 38 -48 45 -87 35 -187 -14 -143 -35 -176 -95 -153 -52 20 -55 126 -4
145 48 19 47 52 -3 102 -43 44 -192 32 -257 -20 -26 -20 -45 -13 -81 32 -60
74 -31 115 98 136 52 8 116 31 143 51 48 35 48 37 2 87 -53 59 -90 49 -90 -24
0 -77 -56 -81 -190 -12 -168 88 -207 121 -202 178 4 38 -11 49 -70 49 -69 0
-76 -8 -83 -96 -6 -73 -17 -93 -45 -82 -20 8 -59 1 -85 -16 -26 -16 -55 -22
-64 -13 -27 27 40 193 89 219 26 14 54 48 63 77 15 47 21 48 59 14 29 -27 53
-31 79 -14 32 21 31 28 -7 57 -66 51 -54 77 53 124 105 46 235 24 222 -39 -4
-20 25 -32 83 -34 48 -2 122 -21 162 -43 40 -23 92 -48 114 -56 22 -8 55 -51
75 -94 41 -94 86 -107 200 -59 l85 36 -69 27 c-87 35 -94 102 -9 86 58 -12
151 38 283 152 56 49 120 89 232 146 89 45 105 78 57 114 -70 52 -158 36 -232
-44 -42 -45 -95 -75 -134 -75 -34 0 -70 -11 -78 -25 -39 -63 -88 -23 -88 72 0
56 -16 110 -37 128 -21 17 -38 47 -38 66 0 19 -17 34 -37 34 -21 0 -38 21 -38
47 0 53 56 84 112 62 22 -8 44 3 53 26 16 43 85 56 85 16 0 -39 116 -151 156
-151 21 0 52 17 69 38 17 20 53 37 80 37 42 0 195 124 195 158 0 6 -24 17 -53
25 -50 13 -50 17 -13 55 47 47 49 61 16 112 -27 40 -74 -1 -75 -66 0 -16 -30
-36 -67 -45 -37 -10 -79 -32 -94 -51 -68 -85 -236 -50 -201 42 12 31 36 38
101 27 71 -11 86 -6 86 31 0 36 -15 41 -87 29 -81 -13 -88 -9 -88 49 0 78 116
234 175 234 24 0 58 -17 75 -37z m-21223 -28 c28 -34 27 -45 -9 -72 -24 -17
-43 -56 -43 -86 0 -46 -12 -54 -69 -47 -61 7 -68 16 -62 93 12 144 108 202
183 112z m6723 3 c17 -21 53 -38 79 -38 26 0 54 -17 62 -37 8 -21 40 -38 71
-38 33 0 74 -26 98 -62 53 -81 51 -88 -21 -88 -105 0 -94 -42 48 -179 76 -73
138 -150 138 -171 1 -31 5 -31 22 -4 17 27 26 27 41 4 10 -17 3 -40 -16 -52
-27 -16 -27 -28 -4 -51 24 -24 34 -21 46 11 23 58 54 52 75 -14 10 -31 35 -69
56 -84 50 -37 17 -85 -59 -85 -86 0 -76 -48 14 -66 92 -19 98 -73 11 -95 -65
-16 -236 110 -236 174 0 14 -62 150 -137 300 -76 151 -138 289 -138 306 0 17
-8 31 -19 32 -41 1 -260 223 -244 248 23 37 77 32 113 -11z m-5404 -51 c5 -27
25 -58 44 -69 19 -11 35 -43 35 -71 0 -29 11 -43 26 -34 105 65 198 -86 146
-236 -21 -61 -19 -84 13 -116 50 -50 52 -151 3 -170 -43 -16 -88 53 -88 136 0
30 -39 91 -87 137 -49 46 -88 100 -88 121 0 21 -22 50 -50 65 -27 15 -50 48
-50 74 0 27 -11 55 -25 64 -35 21 -31 96 6 133 43 43 104 25 115 -34z m18805
-37 c13 0 24 -20 24 -45 0 -25 14 -58 30 -75 42 -42 -7 -87 -83 -76 -46 7 -58
22 -51 67 4 32 -10 78 -32 103 -23 25 -33 62 -24 86 15 39 21 38 64 -9 26 -28
59 -51 72 -51z m-20476 -39 c0 -60 -11 -86 -37 -86 -39 0 -56 149 -22 183 32
32 59 -13 59 -97z m13551 38 c86 -88 89 -109 33 -240 l-41 -96 -23 66 c-12 36
-46 72 -75 79 -40 11 -48 27 -36 72 8 32 15 88 16 126 0 89 34 87 126 -7z
m2451 -149 c-35 -34 -87 -62 -114 -62 -40 0 -52 -20 -58 -94 -10 -117 -69
-126 -87 -13 -10 62 -1 91 36 121 45 35 46 42 10 71 -65 55 -47 124 42 161 78
32 85 30 159 -44 l77 -77 -65 -63z m-13607 -162 c0 -124 -8 -287 -19 -363
l-19 -137 -5 125 c-2 68 -10 192 -18 275 -17 196 16 510 42 400 10 -42 18
-177 19 -300z m9865 259 c-21 -35 -135 -25 -135 11 0 66 56 94 104 51 25 -22
39 -50 31 -62z m2007 13 c68 -62 69 -65 22 -100 -73 -53 -122 -46 -90 12 18
35 15 56 -12 78 -20 17 -30 41 -23 53 20 32 26 29 103 -43z m-923 -116 c-1
-186 -10 -209 -65 -161 -68 59 -154 77 -154 31 0 -48 -23 -48 -86 -1 -27 20
-75 37 -107 37 -68 0 -49 57 57 171 53 57 62 59 115 25 114 -73 146 -74 171
-8 41 107 70 68 69 -94z m3684 42 c86 -45 83 -102 -6 -92 -98 11 -122 27 -122
80 0 61 28 64 128 12z m-16135 -713 c6 -706 -6 -820 -73 -753 -22 22 -32 104
-30 262 2 127 3 326 3 443 0 425 10 733 25 758 6 11 25 15 41 10 20 -7 30
-208 34 -720z m9707 677 c0 -34 -72 -80 -99 -63 -36 22 -33 82 5 95 39 13 94
-5 94 -32z m800 13 c27 -32 20 -38 -47 -38 -74 0 -98 22 -61 58 28 28 75 19
108 -20z m-7625 -26 c0 -40 -66 -79 -92 -54 -8 8 -8 32 1 53 19 50 91 51 91 1z
m6488 -16 c67 -8 74 -16 68 -90 -5 -71 5 -87 78 -122 63 -30 93 -66 114 -136
16 -56 59 -118 103 -148 83 -60 105 -190 35 -217 -61 -23 -161 34 -161 92 0
90 -65 211 -133 248 -36 19 -78 72 -93 118 -15 46 -42 92 -60 103 -18 10 -40
64 -49 119 -9 55 -8 86 3 71 11 -16 53 -33 95 -38z m-3988 -33 c0 -20 23 -48
50 -63 52 -28 67 -87 27 -111 -35 -22 -102 12 -102 51 0 59 -99 40 -123 -23
-15 -38 -59 -69 -131 -92 -142 -45 -171 -69 -171 -142 0 -34 -11 -54 -24 -46
-40 24 1 171 67 242 43 46 57 82 46 117 -17 53 -20 52 211 88 125 19 150 15
150 -21z m1804 -78 c18 -107 -4 -150 -65 -126 -29 11 -36 33 -24 79 13 53 6
68 -38 79 l-55 15 58 31 c83 46 105 32 124 -78z m-7791 65 c19 -32 -51 -60
-102 -40 -50 19 -23 65 39 65 26 0 54 -11 63 -25z m3887 -50 c0 -41 -12 -75
-26 -75 -34 0 -58 66 -40 113 25 64 66 41 66 -38z m2813 50 c29 -49 -15 -125
-73 -125 -86 0 -96 28 -36 92 60 64 85 71 109 33z m-3072 -89 c38 -58 38 -68
3 -102 -58 -59 -144 -4 -144 92 0 96 81 102 141 10z m16618 -37 c38 -1 141
-88 141 -119 0 -93 -211 -17 -267 95 -44 88 11 156 63 78 19 -29 48 -53 63
-54z m-18293 -1507 c-8 -827 -14 -1547 -15 -1598 -1 -52 -13 -94 -27 -94 -17
0 -26 193 -27 569 -4 2860 -6 2785 59 2670 14 -26 18 -615 10 -1547z m6834
1460 c0 -85 -66 -143 -124 -108 -28 18 -79 25 -114 16 -79 -20 -87 65 -14 138
60 60 252 25 252 -46z m425 20 c0 -32 -43 -48 -85 -32 -22 8 -40 36 -40 62 0
41 8 43 63 18 34 -15 62 -37 62 -48z m6921 26 c95 -33 102 -89 16 -128 -54
-24 -71 -20 -125 30 -115 109 -62 157 109 98z m3493 0 c9 -15 4 -40 -11 -55
-62 -62 -33 -123 50 -105 54 12 85 7 100 -17 37 -58 25 -121 -24 -121 -70 0
-84 -29 -38 -79 38 -42 38 -46 0 -61 -45 -17 -59 -160 -16 -160 36 0 29 -130
-10 -182 -27 -36 -55 -41 -137 -28 -120 19 -151 -48 -41 -90 58 -22 59 -27 25
-93 -23 -43 -31 -101 -22 -151 10 -52 6 -81 -12 -81 -37 0 -36 -132 2 -170 47
-47 95 -35 95 23 0 40 10 48 44 34 24 -10 69 -24 99 -31 71 -15 49 -56 -30
-56 -93 0 -99 -46 -7 -55 72 -7 82 -16 82 -82 l0 -75 -171 -8 c-145 -6 -169
-14 -162 -50 10 -45 46 -49 209 -22 71 11 117 5 150 -18 44 -33 42 -37 -40
-71 -47 -20 -121 -66 -163 -101 -42 -36 -107 -72 -144 -82 -37 -9 -74 -27 -81
-39 -61 -98 -83 99 -23 203 64 113 19 132 -149 61 -51 -21 -113 -32 -139 -24
-25 8 -53 3 -62 -11 -54 -87 -155 74 -142 227 8 99 20 116 120 178 62 38 138
69 170 69 32 0 72 17 89 38 17 20 52 37 77 37 72 0 142 149 88 188 -22 17 -40
40 -41 52 -1 35 -92 135 -122 135 -15 0 -27 24 -27 53 0 43 -12 51 -61 41 -58
-11 -114 68 -114 160 0 36 69 23 84 -16 16 -41 154 -53 177 -16 7 12 -21 36
-62 53 -57 24 -72 43 -61 78 11 34 -2 55 -48 75 -99 46 -48 77 111 68 133 -8
149 -3 198 60 l54 69 -64 29 c-42 19 -64 49 -64 86 0 32 -20 68 -44 82 -23 13
-34 34 -22 45 11 11 34 1 52 -23 43 -59 131 -56 164 6 29 54 87 66 114 23z
m4010 -33 c35 -91 6 -165 -64 -165 -60 0 -80 34 -37 61 13 8 31 48 40 89 19
91 31 94 61 15z m-10489 20 c51 -20 26 -60 -36 -60 -27 0 -49 17 -49 38 0 40
23 46 85 22z m-576 -38 l71 4 -64 -77 -65 -77 -303 -5 c-166 -3 -307 2 -313
12 -24 38 73 64 151 40 70 -22 89 -16 149 39 67 63 189 96 265 72 21 -6 70
-10 109 -8z m-12617 -22 c49 0 60 -11 53 -56 -7 -52 -22 -57 -204 -64 -182 -7
-353 41 -308 86 23 23 255 55 326 44 40 -5 100 -10 133 -10z m2996 -31 c11
-31 17 -89 13 -129 -5 -70 -3 -72 94 -59 148 20 185 -16 93 -92 -91 -75 -209
-82 -280 -16 -64 59 -100 264 -57 316 45 54 116 43 137 -20z m425 -2 c0 -65
-50 -61 -59 5 -6 40 2 55 25 47 18 -6 34 -29 34 -52z m15790 -31 c41 -21 71
-52 66 -67 -18 -55 -60 -44 -115 31 -63 86 -57 91 49 36z m-15992 -10 c86 -33
81 -76 -10 -76 -76 0 -115 32 -88 75 18 31 19 31 98 1z m3685 -39 c28 -27 -22
-41 -94 -25 -104 23 -101 74 2 53 44 -8 85 -21 92 -28z m6764 -18 c6 -31 23
-119 39 -196 27 -137 6 -273 -43 -273 -77 0 -143 350 -91 485 23 59 82 48 95
-16z m-9045 -57 c77 -101 65 -137 -26 -78 -89 58 -114 51 -114 -31 0 -45 16
-79 42 -89 30 -11 34 -23 14 -43 -46 -46 -206 95 -206 180 0 82 45 122 79 71
19 -28 31 -24 63 22 52 75 69 71 148 -32z m14005 -1 c-10 -83 -3 -94 85 -138
100 -52 120 -90 58 -114 -48 -18 -50 -84 -2 -84 19 0 51 -15 70 -34 18 -19 57
-42 86 -51 29 -9 66 -50 83 -91 17 -41 41 -74 53 -74 29 0 28 -158 -1 -189
-12 -13 -27 -52 -31 -86 -7 -51 -28 -67 -115 -85 -88 -18 -106 -32 -106 -81 0
-94 -36 -70 -145 98 -113 175 -123 322 -27 408 90 81 60 112 -90 94 -111 -13
-138 -9 -138 20 0 51 51 96 111 97 48 1 49 3 8 34 -54 40 -58 129 -6 149 20 8
37 42 37 76 0 79 24 140 55 140 14 0 21 -39 15 -89z m1930 65 c0 -30 -83 -76
-136 -76 -34 0 -33 6 5 48 46 51 131 69 131 28z m-11638 -26 c94 -36 54 -75
-76 -75 -94 0 -111 8 -111 50 0 57 77 67 187 25z m4009 -33 c7 -38 -6 -44 -75
-37 -57 5 -86 22 -92 53 -7 38 6 44 75 37 57 -5 86 -22 92 -53z m-6521 8 c33
-22 33 -28 0 -50 -55 -37 -136 -19 -145 31 -10 50 80 61 145 19z m13819 -18
c5 -17 -19 -37 -55 -46 -74 -19 -79 -32 -24 -72 36 -27 36 -32 0 -62 -29 -24
-40 -25 -40 -4 0 16 -42 47 -93 69 l-94 38 75 61 c79 63 212 73 231 16z
m-11411 -107 c32 0 66 -7 75 -16 29 -30 -37 -84 -102 -84 -35 0 -89 -28 -121
-62 -65 -71 -83 -73 -308 -31 -146 28 -243 93 -137 93 24 0 64 18 88 41 55 49
122 28 122 -38 0 -53 55 -84 113 -62 43 17 48 49 12 72 -27 16 -35 169 -10
194 9 8 59 -12 112 -46 53 -34 123 -61 156 -61z m12056 89 c36 -26 41 -43 21
-64 -21 -21 -39 -18 -69 13 -78 77 -41 117 48 51z m-19401 -39 c24 -27 68 -50
97 -50 124 -1 126 -13 129 -568 3 -584 2 -590 -138 -734 -87 -90 -106 -100
-141 -71 -34 28 -45 27 -72 -9 -17 -24 -49 -43 -71 -43 -76 0 -125 -115 -109
-251 15 -124 -23 -179 -51 -73 -10 39 -30 50 -79 44 l-65 -7 6 -645 c5 -428
-2 -662 -20 -696 -18 -33 -19 -60 -3 -80 30 -37 46 -208 22 -232 -22 -22 -24
-117 -3 -170 19 -50 94 -52 135 -2 42 50 67 47 82 -10 8 -33 44 -53 115 -65
65 -11 103 -31 103 -54 0 -28 -10 -30 -52 -8 -35 19 -74 20 -123 3 -39 -14
-114 -19 -168 -12 -84 12 -100 5 -123 -46 -54 -121 -65 149 -52 1317 8 748 17
840 80 788 24 -20 36 -17 47 11 8 21 32 38 53 38 55 0 48 108 -10 161 -65 58
-102 30 -102 -76 0 -163 -45 -62 -60 134 -40 529 -39 532 143 391 135 -105
154 -185 55 -230 -78 -36 -81 -90 -7 -141 112 -79 233 0 248 161 8 85 12 87
105 82 74 -5 93 2 82 29 -7 19 3 49 23 65 66 55 38 112 -89 188 -146 87 -162
155 -56 251 176 162 170 143 57 180 -120 41 -111 74 26 96 121 19 116 46 -29
148 -118 83 -146 141 -97 200 40 48 58 46 112 -14z m5296 -31 l63 -80 60 55
c32 31 65 56 74 56 35 0 115 -217 102 -279 -10 -51 0 -73 41 -95 41 -22 49
-42 35 -84 -10 -30 -32 -105 -48 -167 -25 -90 -34 -102 -48 -62 -9 27 -28 70
-42 96 -18 34 -14 57 15 89 21 24 39 51 39 60 0 31 -121 18 -133 -14 -7 -17
-14 -2 -15 35 -3 99 -149 268 -233 270 -61 1 -69 10 -69 84 0 144 64 158 159
36z m-875 1 c16 -63 6 -82 -32 -59 -32 20 -36 114 -5 114 12 0 29 -25 37 -55z
m7153 -29 c31 -137 25 -202 -17 -210 -62 -13 -132 160 -97 237 31 67 97 52
114 -27z m3308 -35 c18 -17 46 -31 61 -31 51 0 144 -108 144 -167 0 -33 15
-58 35 -58 19 0 40 -24 48 -52 10 -40 26 -48 65 -36 28 9 65 8 82 -3 17 -10
54 -20 82 -22 139 -8 163 -15 163 -45 0 -19 28 -47 63 -62 83 -39 78 -69 -17
-103 -109 -37 -165 -36 -126 3 47 47 36 70 -32 70 -35 0 -63 -11 -63 -25 0
-13 -28 -31 -62 -40 -110 -27 -288 168 -288 316 0 30 -25 51 -75 62 -41 9 -75
26 -75 39 0 13 -40 67 -90 122 -49 55 -81 112 -72 127 16 26 45 9 157 -95z
m-15171 20 c79 -79 108 -373 39 -391 -66 -18 -150 150 -150 295 0 158 26 181
111 96z m8092 -56 c86 8 143 -42 119 -104 -29 -76 -210 -44 -210 37 0 26 -11
47 -25 47 -29 0 -34 83 -6 110 10 11 25 -7 32 -39 12 -48 29 -57 90 -51z m499
-163 c-3 -279 -45 -320 -178 -171 -48 54 -87 112 -87 130 0 50 55 70 85 29 15
-20 42 -32 60 -26 26 9 26 18 0 50 -37 44 -45 186 -13 208 12 9 47 11 78 5 54
-11 57 -22 55 -225z m235 181 c0 -38 -14 -63 -36 -63 -53 0 -73 47 -38 89 45
54 74 44 74 -26z m1711 -17 c51 -102 49 -121 -9 -121 -63 0 -213 137 -191 173
38 61 159 30 200 -52z m951 38 c60 -59 22 -234 -51 -234 -43 0 -45 23 -10 115
21 56 19 74 -12 91 -22 12 -39 32 -39 45 0 38 68 28 112 -17z m8013 -23 c0
-20 12 -36 28 -36 15 0 20 -18 11 -42 -10 -26 10 -69 54 -118 38 -43 53 -63
33 -46 -20 17 -56 31 -81 31 -25 0 -45 17 -45 38 0 42 -22 46 -74 13 -23 -15
-49 -13 -69 3 -50 42 -9 75 70 58 82 -18 100 25 32 75 -23 17 -34 44 -24 60
23 36 65 13 65 -36z m-9839 12 c77 -20 123 -20 158 -1 40 21 59 16 94 -23 44
-48 43 -52 -6 -106 -29 -30 -69 -95 -89 -143 -42 -100 -264 -209 -468 -231
l-113 -11 -62 133 c-34 73 -82 140 -106 148 -72 23 -51 68 25 54 38 -7 113
-21 169 -31 55 -10 129 -46 165 -80 86 -79 230 -74 242 10 5 37 -11 64 -50 84
-93 48 -170 129 -170 178 0 54 53 58 211 19z m546 -23 c7 -27 34 -58 59 -67
134 -52 144 -148 28 -275 -38 -42 -46 -76 -35 -138 16 -86 6 -111 -64 -165
-64 -51 -107 44 -71 155 35 104 12 165 -61 165 -61 0 -103 63 -60 89 14 9 64
9 111 0 75 -14 86 -10 86 35 0 32 -23 61 -60 75 -83 32 -94 59 -50 122 47 68
100 69 117 4z m-8441 -39 c23 -35 74 -80 113 -100 89 -46 90 -80 4 -113 -36
-14 -81 -44 -98 -68 -28 -39 -34 -37 -57 24 -14 36 -37 74 -51 83 -15 9 -27
66 -27 127 0 130 49 149 116 47z m4829 7 c9 -46 -36 -56 -92 -20 -19 12 -26
35 -16 51 25 41 98 21 108 -31z m4541 18 c21 -22 46 -67 54 -100 9 -34 25 -61
36 -61 50 0 89 -74 80 -154 -14 -120 -254 -227 -291 -130 -9 23 1 60 22 83 80
89 27 150 -131 151 -81 0 -73 87 17 177 81 81 154 93 213 34z m1938 -136 c-35
-22 -15 -100 25 -100 14 0 26 17 26 38 0 20 17 37 38 37 20 0 37 -10 37 -22 0
-12 -17 -36 -37 -53 -21 -17 -38 -58 -38 -91 0 -80 -15 -75 -129 42 -103 106
-106 149 -10 149 32 0 67 20 77 44 13 33 21 35 30 9 7 -18 -1 -43 -19 -53z
m3489 51 c44 -18 45 -22 7 -38 -56 -23 -126 -8 -139 31 -11 35 55 38 132 7z
m-269 -40 c79 -55 70 -79 -38 -92 -160 -20 -242 54 -112 102 92 34 88 34 150
-10z m632 -62 c40 -43 77 -64 86 -50 38 62 63 17 52 -93 -12 -129 42 -272 112
-294 78 -25 181 -161 229 -301 26 -78 69 -171 95 -207 50 -70 57 -125 53 -436
-3 -222 -26 -247 -172 -194 -77 28 -91 27 -111 -9 -12 -22 -50 -40 -83 -40
-54 0 -414 -173 -473 -228 -13 -12 -43 -22 -66 -22 -23 0 -55 -16 -72 -36 -16
-20 -71 -49 -122 -65 -50 -16 -150 -58 -221 -94 -114 -58 -136 -62 -190 -33
-55 29 -67 26 -126 -32 -65 -65 -176 -87 -204 -40 -31 49 -92 28 -75 -25 12
-40 4 -50 -44 -50 -73 0 -119 43 -119 113 0 28 -11 63 -25 77 -16 16 -15 56 2
117 25 91 26 92 85 53 33 -21 64 -63 68 -93 8 -61 108 -89 154 -43 20 20 14
31 -23 41 -130 34 -113 272 22 317 72 24 118 128 99 226 -14 76 26 88 101 31
31 -24 68 -28 116 -14 86 25 126 -8 126 -105 0 -59 11 -70 65 -70 54 0 73 21
117 126 40 93 63 121 92 109 92 -38 118 -34 195 30 68 56 109 135 71 135 -45
0 -90 -38 -90 -77 0 -39 -13 -44 -81 -31 -110 21 -109 16 -28 143 69 107 76
111 178 102 59 -5 129 -16 157 -25 68 -21 98 59 38 102 -48 36 -29 97 25 77
18 -8 66 -4 107 8 58 16 96 8 181 -41 173 -98 286 -44 164 78 -32 33 -65 75
-73 95 -16 42 -220 144 -287 144 -25 0 -65 24 -90 53 -35 40 -63 49 -121 37
-42 -8 -98 -15 -125 -15 -33 0 -46 -14 -40 -43 5 -27 31 -44 68 -44 33 0 65
-16 72 -35 13 -38 -43 -33 -242 24 -96 27 -112 26 -132 -11 -13 -22 -46 -41
-75 -41 -30 0 -56 -21 -64 -50 -18 -68 -68 -63 -117 13 -55 82 -140 84 -140 1
0 -37 17 -64 44 -70 24 -5 -16 -9 -89 -8 -87 2 -140 15 -155 39 -12 20 -77 48
-145 64 l-123 27 -58 -85 c-60 -87 -67 -88 -216 -28 -71 28 -87 26 -130 -13
-48 -43 -118 -35 -90 11 23 38 197 111 243 103 90 -15 78 71 -22 159 -80 71
-90 90 -59 110 24 16 46 16 61 1 13 -13 48 -24 78 -24 30 0 68 -16 84 -35 49
-59 201 -75 238 -26 43 60 133 8 144 -83 4 -39 25 -71 49 -76 35 -7 39 8 28
92 -21 159 5 199 82 126 55 -51 70 -54 114 -27 41 26 58 26 90 0 64 -54 430
-48 486 8 57 57 94 58 134 3 26 -35 38 -37 70 -10 45 36 32 91 -41 172 -37 41
-51 94 -54 200 -5 212 20 231 138 105z m-18050 -14 c27 -72 14 -110 -39 -110
-39 0 -87 75 -87 136 0 66 99 46 126 -26z m8081 15 c35 -27 88 -50 117 -50 30
0 47 -11 39 -24 -8 -13 -30 -18 -49 -10 -19 7 -58 1 -85 -14 -65 -34 -120 -13
-138 54 -27 102 19 120 116 44z m8924 -19 c23 -21 37 -47 29 -59 -21 -34 -60
-26 -60 13 0 45 -55 65 -177 65 -54 0 -98 12 -98 26 0 38 253 1 306 -45z
m-14928 -393 l-15 -250 -15 275 c-8 151 -9 308 -1 350 27 149 48 -110 31 -375z
m5835 262 c17 -21 38 -61 47 -90 21 -69 134 -187 231 -241 102 -57 125 -55
142 8 10 39 26 48 63 37 39 -13 52 -3 58 41 8 50 25 58 140 65 150 9 172 -26
50 -80 -78 -34 -219 -144 -219 -171 0 -29 420 -47 466 -21 173 100 367 150
396 103 48 -78 -49 -133 -299 -168 -56 -7 -116 -26 -136 -42 -19 -16 -55 -25
-79 -21 -25 4 -57 -15 -73 -45 -32 -60 -136 -108 -222 -103 -58 3 -327 254
-394 367 -29 48 -30 48 -67 -1 -37 -49 -38 -49 -55 17 -9 37 -33 81 -52 97
-19 16 -35 51 -35 78 0 27 -22 78 -50 113 -57 73 -62 113 -21 190 29 53 30 53
53 -21 14 -41 39 -91 56 -112z m-3570 109 c5 -15 -14 -34 -43 -41 -40 -11 -51
-30 -45 -82 4 -41 -6 -73 -26 -80 -33 -11 -22 167 14 227 16 27 88 11 100 -24z
m4494 -61 c-12 -57 -7 -73 24 -73 21 0 39 -17 39 -38 0 -40 -20 -42 -286 -37
-142 3 -164 12 -164 70 0 57 134 130 238 130 46 0 91 11 100 25 30 49 65 -5
49 -77z m-7950 28 c9 -27 43 -71 77 -98 68 -53 78 -108 27 -150 -18 -15 -53
-72 -78 -127 -66 -146 -88 -103 -88 175 0 232 26 315 62 200z m11978 -115
c-15 -41 -90 -49 -90 -10 0 14 20 56 44 93 43 67 44 67 52 10 4 -32 2 -74 -6
-93z m505 95 c-7 -32 -30 -42 -90 -37 -67 5 -85 -5 -106 -58 -17 -47 -39 -62
-78 -56 -153 22 2 195 174 195 90 0 107 -7 100 -44z m-4060 -31 c29 -29 -86
-75 -185 -75 -86 0 -116 38 -72 91 34 41 211 30 257 -16z m2690 -12 c0 -40
-88 -53 -110 -16 -19 29 10 53 64 53 25 0 46 -17 46 -37z m5316 0 c21 -21 69
-38 108 -38 38 0 84 17 101 38 17 20 47 37 66 37 58 0 38 -87 -36 -158 -72
-69 -130 -87 -130 -41 0 15 -62 55 -137 90 -76 34 -138 73 -138 86 0 37 125
26 166 -14z m-12700 -26 c-10 -26 18 -53 95 -89 156 -73 199 -128 178 -228 -9
-45 -16 -119 -16 -164 2 -69 -7 -81 -57 -81 -111 0 -219 52 -211 102 5 28 -26
74 -77 117 -73 61 -81 78 -56 120 45 77 86 196 81 230 -3 17 13 31 36 31 27 0
36 -13 27 -38z m1359 -25 c39 -41 75 -57 106 -48 57 19 119 -29 119 -92 0 -56
-44 -59 -111 -9 -27 20 -72 37 -101 37 -69 0 -113 46 -113 118 0 74 27 72 100
-6z m1605 7 c4 -35 28 -59 61 -64 39 -6 61 -37 84 -119 25 -89 39 -106 65 -84
55 45 91 16 50 -40 -33 -45 -43 -47 -119 -15 -46 18 -114 39 -152 46 -38 7
-69 21 -69 32 0 41 -203 69 -294 40 -42 -14 -56 -8 -56 21 0 22 21 39 50 39
28 0 50 12 50 27 0 15 23 60 52 100 69 98 264 109 278 17z m-7843 7 c8 -13 16
-131 17 -261 3 -258 16 -299 86 -286 40 8 47 34 50 171 7 277 6 275 60 275 46
0 50 -17 50 -208 0 -138 -12 -223 -35 -255 -42 -57 -25 -112 34 -112 24 0 64
-23 89 -50 24 -27 76 -50 114 -50 103 0 152 -60 120 -145 -14 -37 -23 -112
-20 -167 8 -170 -1 -313 -21 -313 -28 1 -120 153 -140 231 -17 69 -51 89 -77
47 -7 -12 -50 -14 -95 -5 l-81 17 -1 195 c0 178 -6 199 -62 243 -169 131 -168
129 -171 378 -3 286 25 388 83 295z m10263 -25 c0 -93 -204 -143 -236 -58 -22
58 48 107 153 107 66 0 83 -10 83 -49z m12528 -7 c17 -31 48 -70 70 -86 38
-28 -120 -24 -217 6 -55 17 -36 107 25 118 31 6 65 13 74 15 10 1 32 -22 48
-53z m-16064 4 c25 -41 -5 -56 -76 -38 -36 9 -58 27 -50 41 20 32 105 31 126
-3z m1761 -138 c0 -65 -98 -37 -137 39 -60 116 -45 134 50 62 48 -37 87 -82
87 -101z m-5225 71 c0 -25 -17 -69 -38 -99 -42 -60 -34 -69 82 -94 44 -9 81
-32 81 -50 0 -48 -246 -127 -282 -91 -16 16 -57 28 -92 28 -81 1 -137 36 -115
72 9 15 44 28 77 28 49 0 65 18 86 96 33 125 201 216 201 110z m20850 -17 c0
-78 -40 -104 -70 -46 -29 56 -12 107 35 107 20 0 35 -25 35 -61z m-19675 22
c0 -33 -85 -175 -116 -193 -19 -11 -34 -41 -34 -65 0 -78 -28 -77 -134 4 -57
44 -108 83 -114 86 -5 4 11 30 37 59 37 40 65 48 129 36 51 -10 82 -5 82 12 0
14 25 37 56 49 68 27 94 31 94 12z m1490 -75 c46 -110 30 -136 -79 -136 -93 0
-115 45 -48 100 20 17 37 52 37 78 0 77 50 54 90 -42z m5457 15 c55 -47 79
-86 70 -112 -20 -50 -132 -51 -151 -1 -32 83 -109 40 -142 -79 -28 -101 -46
-122 -141 -163 -59 -27 -108 -64 -108 -83 0 -19 -25 -65 -57 -101 -77 -90
-391 -107 -454 -24 -65 86 -57 95 119 124 52 9 119 40 149 71 94 93 216 166
255 151 22 -8 44 3 53 26 8 22 34 40 57 40 71 0 146 69 162 149 19 97 76 97
188 2z m6578 51 c0 -13 23 -31 50 -39 28 -9 50 -27 50 -40 0 -13 -22 -23 -50
-23 -27 0 -50 11 -50 25 0 14 -17 25 -37 25 -21 0 -38 17 -38 38 0 20 17 37
38 37 20 0 37 -10 37 -23z m-10812 -129 c0 -78 6 -85 68 -81 68 5 92 -25 44
-54 -14 -9 -25 -35 -25 -59 0 -24 -23 -63 -52 -87 -29 -25 -46 -60 -39 -79 7
-19 -3 -48 -23 -64 -20 -17 -36 -57 -36 -90 0 -58 -34 -80 -61 -37 -7 12 -55
30 -106 40 -51 9 -116 33 -144 53 -27 19 -70 35 -95 35 -25 0 -56 28 -69 63
-16 42 -43 62 -84 62 -135 0 -247 203 -122 220 34 5 62 -7 71 -31 9 -21 42
-39 75 -39 33 0 60 -11 60 -24 0 -43 150 -179 178 -162 37 23 7 161 -44 198
-32 23 -34 35 -10 50 18 11 59 -2 97 -30 47 -35 93 -46 160 -38 97 12 122 40
57 65 -52 20 -48 133 6 164 67 39 94 18 94 -75z m2400 52 c0 -24 -43 -46 -125
-64 -130 -28 -213 -21 -213 17 0 12 -3 30 -6 41 -9 26 125 52 244 47 70 -2
100 -15 100 -41z m5062 -13 c17 -44 15 -78 -6 -112 -40 -64 1 -100 45 -40 29
40 41 42 74 14 22 -18 82 -34 132 -35 l93 -1 0 -115 c0 -95 15 -134 95 -231
100 -123 135 -137 219 -86 45 28 57 23 102 -37 30 -42 74 -69 110 -69 45 0 64
17 76 69 22 90 56 131 111 131 32 0 41 -14 31 -50 -16 -61 11 -64 72 -9 39 35
57 37 113 12 57 -27 73 -24 116 19 40 40 58 44 96 20 35 -22 58 -22 96 2 58
36 225 42 225 8 0 -13 -42 -27 -94 -32 -151 -12 -124 -81 36 -90 74 -4 142
-23 159 -44 19 -22 76 -36 148 -36 184 0 365 -72 312 -123 -14 -15 -75 -10
-158 12 -137 36 -428 24 -428 -17 0 -42 191 -105 344 -113 222 -12 289 -61
267 -194 -24 -150 -52 -165 -127 -69 -41 52 -79 77 -103 68 -20 -8 -53 -2 -71
13 -44 36 -110 12 -110 -41 0 -43 -136 -31 -186 17 -40 37 -85 25 -101 -28
-18 -56 -78 -67 -95 -19 -6 17 -9 -14 -6 -69 7 -143 54 -220 121 -202 30 8 69
14 86 15 17 0 31 29 31 64 0 56 9 64 71 57 39 -4 100 12 137 36 85 56 108 54
125 -9 10 -40 26 -49 66 -36 48 15 49 12 21 -50 -28 -61 -40 -66 -137 -55 -68
7 -123 -1 -151 -22 -25 -18 -68 -34 -97 -34 -29 -1 -73 -24 -97 -51 -25 -27
-67 -50 -93 -50 -26 0 -89 -40 -139 -89 l-92 -90 61 -46 c79 -60 49 -88 -87
-83 -157 6 -375 132 -505 291 -17 20 -41 41 -55 46 -14 5 -40 65 -58 133 -34
130 -160 288 -229 288 -21 0 -45 12 -54 26 -9 15 -47 23 -83 19 -57 -6 -68 3
-75 68 -5 41 -20 88 -33 105 -14 16 -18 51 -10 77 21 66 -71 148 -121 107 -21
-17 -42 -20 -50 -6 -25 40 -140 51 -140 13 0 -43 -99 -45 -103 -3 -6 71 -11
84 -56 150 -29 43 -69 69 -106 69 -33 0 -60 12 -60 28 0 16 24 21 60 12 47
-11 62 -3 73 40 20 75 -3 102 -73 84 -69 -17 -68 -20 -33 82 29 82 89 103 142
50 22 -22 36 -13 57 35 31 67 -24 193 -85 195 -28 1 103 68 141 72 11 1 30
-26 43 -61z m1922 -28 c23 -51 23 -71 2 -85 -17 -10 -22 -40 -12 -71 28 -89
-7 -153 -84 -153 -136 0 -169 111 -65 215 35 35 56 74 49 87 -8 12 -8 34 1 48
28 45 78 26 109 -41z m-3852 -40 c7 -33 -8 -44 -56 -44 -48 0 -64 13 -64 52 0
65 108 58 120 -8z m-700 -34 c12 -86 -58 -124 -105 -56 -61 86 -51 126 29 116
47 -5 71 -24 76 -60z m1299 28 c4 -3 -21 -35 -54 -71 -34 -36 -65 -84 -69
-108 -5 -23 -23 -47 -40 -53 -48 -16 -37 88 13 116 37 21 39 33 12 76 -17 28
-31 57 -31 64 0 10 152 -11 169 -24z m-3033 -17 c82 -37 91 -159 13 -184 -80
-25 -174 50 -174 139 0 83 48 96 161 45z m3266 -10 c41 -21 68 -49 60 -62 -21
-34 -112 -30 -112 4 0 16 -20 44 -44 62 -62 47 3 45 96 -4z m-12113 -84 c-25
-40 -88 -33 -106 13 -21 56 45 92 89 49 19 -19 26 -47 17 -62z m6283 39 c16
-19 63 -42 105 -50 42 -9 69 -27 61 -41 -19 -30 -113 -32 -157 -4 -18 11 -88
13 -156 4 -133 -17 -179 26 -69 63 31 11 79 28 107 38 73 28 78 27 109 -10z
m4702 -14 c37 -70 34 -77 -43 -77 -91 1 -142 36 -123 85 22 56 135 51 166 -8z
m7692 -14 c41 -42 26 -88 -30 -88 -22 0 -36 25 -36 63 0 72 14 77 66 25z
m-8503 -154 c0 -71 -128 -79 -150 -9 -10 29 -4 69 14 89 39 48 136 -8 136 -80z
m612 28 c0 -113 -43 -129 -159 -61 -77 46 -103 50 -169 27 -85 -30 -122 -19
-122 36 0 40 6 41 200 38 76 -2 154 8 175 22 62 41 75 30 75 -62z m-8040 48
c22 -9 40 -31 40 -51 0 -20 16 -42 36 -49 56 -22 67 -83 26 -160 -33 -65 -46
-70 -128 -57 -115 19 -108 -43 9 -77 90 -25 126 -138 82 -253 -17 -45 -18 -98
-2 -153 14 -51 14 -90 0 -99 -13 -8 -23 5 -23 27 0 35 -26 40 -169 34 -177 -8
-231 7 -231 67 0 43 212 52 238 11 26 -43 62 -1 62 73 0 63 -11 72 -100 87
-105 16 -117 36 -73 118 20 39 17 65 -13 111 -47 72 -82 75 -202 18 -78 -37
-87 -50 -73 -112 15 -68 -24 -102 -45 -39 -19 58 38 194 81 194 23 0 63 23 89
52 47 51 35 75 -50 105 -48 17 17 68 86 68 40 0 79 11 87 25 29 46 207 85 273
60z m575 0 c63 -24 47 -85 -21 -85 -66 0 -101 35 -76 75 17 29 42 31 97 10z
m7854 -13 c10 -16 53 -22 104 -13 l87 14 -17 -89 c-27 -149 -59 -208 -126
-239 -99 -45 -159 25 -117 136 27 73 25 85 -23 122 -30 22 -46 53 -37 69 23
36 107 36 129 0z m-4539 -47 c15 -27 42 -50 61 -50 18 0 40 -17 48 -37 8 -21
32 -38 53 -38 21 0 38 -11 38 -25 0 -42 -54 -28 -140 37 -45 35 -111 74 -147
88 -36 14 -59 36 -51 50 27 43 110 28 138 -25z m14951 -26 c112 -60 -1 -198
-135 -165 -80 20 -150 -5 -120 -43 12 -16 33 -73 47 -128 14 -55 34 -120 44
-144 13 -32 7 -44 -23 -44 -22 0 -47 20 -55 44 -58 177 -231 371 -272 304 -10
-14 2 -40 25 -57 38 -28 37 -36 -16 -103 -31 -39 -57 -95 -58 -124 -1 -77
-139 -83 -237 -11 -67 49 -75 68 -63 146 11 73 9 79 -12 32 -30 -69 -66 -72
-100 -8 -51 95 -2 142 148 140 70 0 88 -12 100 -61 l15 -60 79 79 c43 44 82
105 87 135 6 47 27 59 125 70 65 7 127 23 138 34 24 24 216 0 283 -36z
m-15150 -100 c75 -75 114 -97 152 -86 64 21 172 -49 172 -112 0 -66 -68 -80
-268 -55 -17 2 -53 46 -79 98 -26 51 -83 119 -126 151 -43 32 -72 68 -64 81
31 51 116 20 213 -77z m1885 62 c21 -22 39 -50 39 -63 0 -13 17 -23 38 -23 20
0 37 -22 37 -50 0 -59 -45 -67 -66 -12 -11 30 -23 32 -49 10 -27 -22 -45 -21
-75 4 -59 49 -135 -52 -135 -180 0 -111 13 -117 90 -44 67 62 110 44 110 -46
0 -71 -63 -157 -115 -157 -75 0 -50 -46 52 -97 72 -36 106 -67 97 -90 -18 -47
-161 -96 -193 -64 -15 15 -41 14 -73 -3 -28 -15 -83 -36 -123 -47 -107 -31
-84 46 37 124 112 72 117 120 22 211 -40 38 -87 114 -105 169 -32 96 -30 102
34 162 37 34 67 80 67 103 0 116 221 182 311 93z m8302 -1 c73 -48 79 -80 18
-103 -24 -9 -77 -40 -118 -70 -42 -30 -118 -73 -171 -97 -113 -52 -166 -145
-122 -216 18 -29 20 -52 4 -62 -13 -8 -24 2 -24 24 0 21 -29 45 -64 54 -43 11
-59 28 -50 53 8 20 14 62 14 94 0 37 18 62 53 71 39 10 50 28 40 65 -7 29 -3
58 9 66 13 8 23 -3 23 -24 0 -49 48 -77 79 -46 17 17 17 42 -1 74 -32 61 6
107 88 107 31 0 63 11 72 25 22 37 80 31 150 -15z m-14750 -35 c8 -14 36 -25
62 -25 39 0 45 -14 33 -84 -7 -46 0 -109 17 -140 57 -107 -14 -120 -111 -20
-47 49 -118 100 -157 112 -101 34 -98 138 6 160 114 24 133 24 150 -3z m10545
-56 c-3 -37 -24 -107 -47 -157 -36 -74 -38 -107 -16 -180 28 -90 5 -182 -44
-182 -44 0 -52 47 -28 155 15 65 16 147 2 206 -17 77 -13 114 20 170 52 88
119 81 113 -12z m-8925 -31 c101 -102 136 -107 229 -34 73 57 112 36 113 -61
0 -34 17 -43 69 -38 54 6 70 -4 76 -47 5 -30 24 -68 44 -84 65 -54 46 -174
-27 -174 -38 0 -69 17 -78 44 -68 201 -88 225 -203 240 -141 20 -156 10 -156
-110 0 -94 -4 -99 -79 -99 -84 0 -171 60 -171 116 0 19 20 34 44 34 100 1 114
37 61 157 -42 95 -47 143 -16 143 3 0 45 -39 94 -87z m1536 56 c14 -17 33 -96
42 -175 10 -79 28 -150 41 -158 36 -22 27 -102 -16 -137 -25 -21 -34 -54 -25
-90 12 -47 2 -61 -48 -74 -146 -36 -56 -110 135 -110 117 0 120 -2 148 -97 43
-144 38 -178 -30 -178 -33 0 -74 17 -91 38 -17 20 -48 37 -68 37 -38 0 -182
139 -182 176 0 12 -18 31 -39 43 -51 29 -67 195 -23 232 19 15 65 36 104 46
103 27 108 114 9 149 -86 30 -104 134 -45 261 35 76 51 82 88 37z m1081 6 c74
-40 211 -172 195 -188 -8 -8 -76 -21 -151 -29 -123 -13 -141 -9 -178 44 -57
82 -51 145 15 172 74 30 65 30 119 1z m9625 -38 c13 -34 52 -76 87 -91 41 -19
63 -49 63 -86 0 -78 -33 -92 -83 -34 -23 27 -63 49 -89 49 -57 0 -83 83 -52
165 29 76 44 76 74 -3z m-7111 -125 l-64 -84 106 -12 c59 -7 139 -11 178 -8
96 6 145 -65 86 -123 -41 -42 -270 -54 -375 -21 -102 32 -69 236 53 328 71 53
80 5 16 -80z m6961 39 c0 -64 -29 -79 -120 -61 -70 14 -72 18 -34 61 58 63
154 63 154 0z m-12414 -5 c72 -33 77 -48 34 -91 -44 -44 -106 -37 -156 18 -78
86 -4 130 122 73z m7289 -34 c23 -20 83 -37 133 -37 116 0 122 -53 17 -141
-41 -35 -75 -79 -75 -98 0 -56 -88 -89 -161 -62 -81 31 -81 59 2 125 84 66 62
87 -95 93 -161 5 -170 17 -82 110 80 83 177 87 261 10z m-11006 -735 c6 -755
-1 -844 -66 -804 -45 28 -70 1448 -27 1529 73 137 86 36 93 -725z m10228 721
c61 -13 138 -47 172 -74 35 -27 89 -49 122 -49 68 0 85 -92 22 -116 -21 -8
-38 -30 -38 -49 0 -19 -12 -35 -26 -35 -52 0 -199 73 -199 100 0 15 -53 50
-118 77 -128 55 -160 87 -140 139 16 40 57 42 205 7z m-9189 -372 c-3 -507
-42 -695 -132 -639 -48 30 -30 113 26 113 52 0 49 92 -5 126 -12 8 -38 69 -58
137 -38 124 -26 161 52 162 66 1 65 134 -2 182 -77 56 -83 107 -14 125 33 9
50 34 50 74 0 74 25 104 60 69 14 -14 24 -160 23 -349z m5405 318 c0 -48 -13
-51 -132 -29 -135 26 -99 75 53 73 58 0 79 -12 79 -44z m-4088 -43 c0 -42 17
-83 41 -97 32 -17 38 -44 26 -116 -17 -108 3 -238 38 -238 13 0 43 45 66 100
56 134 73 126 83 -38 11 -175 4 -192 -57 -155 -41 25 -54 23 -75 -13 -13 -24
-46 -44 -72 -44 -26 0 -54 -11 -62 -25 -40 -63 -88 -22 -88 74 0 54 -13 106
-28 116 -38 23 -6 464 36 490 60 38 92 19 92 -54z m3500 30 c2 -56 47 -89 83
-60 29 25 45 23 77 -9 52 -52 53 -104 1 -61 -52 44 -92 0 -82 -92 11 -89 96
-99 133 -15 14 31 33 56 44 56 36 0 19 -159 -22 -204 -34 -38 -36 -51 -8 -85
31 -37 36 -35 53 12 41 110 76 54 67 -107 -4 -91 4 -174 20 -194 15 -19 41
-76 57 -126 16 -51 46 -106 66 -122 39 -33 51 -249 14 -249 -27 0 -128 186
-128 235 0 19 -17 48 -37 65 -21 17 -38 52 -38 77 0 25 -29 88 -64 141 -36 52
-71 125 -78 163 -8 38 -24 69 -35 69 -11 0 -40 65 -64 144 -24 79 -58 156 -76
171 -38 33 -45 210 -8 210 14 0 25 -8 25 -19z m2475 -33 c0 -29 19 -84 41
-123 25 -42 34 -88 23 -116 -16 -42 -22 -40 -54 22 -20 38 -55 69 -78 69 -43
0 -207 143 -207 180 0 11 62 20 138 20 122 0 137 -6 137 -52z m3820 -67 c7
-46 -4 -56 -56 -56 -45 0 -64 13 -64 46 0 97 107 106 120 10z m312 29 c33 -34
-17 -85 -85 -85 -68 0 -96 43 -55 83 20 21 119 22 140 2z m-5970 -179 c-16
-67 -5 -68 160 -15 94 31 128 54 128 89 0 59 64 85 113 45 53 -44 47 -190 -9
-230 -25 -18 -62 -66 -81 -107 -64 -135 -287 -83 -350 81 -12 31 -41 56 -64
56 -63 0 -134 75 -134 141 0 33 11 59 25 59 14 0 25 -11 25 -25 0 -49 70 -24
85 31 l15 57 50 -63 c31 -39 45 -84 37 -119z m1542 101 c48 -37 108 -113 134
-169 110 -235 231 -354 383 -377 126 -20 175 -94 110 -167 -41 -46 -8 -119 55
-119 90 0 97 -105 11 -152 -70 -37 -177 83 -167 187 7 67 -1 78 -67 89 -69 13
-221 177 -510 552 -68 88 -141 66 -84 -26 24 -38 23 -52 -4 -68 -19 -11 -52
-62 -74 -113 -47 -114 -102 -121 -138 -16 -34 97 -19 122 73 122 83 0 89 15
36 86 -51 67 -46 106 15 122 28 7 58 37 65 65 18 69 58 65 162 -16z m4597 2
c39 -101 19 -116 -58 -45 -70 65 -71 111 -3 111 20 0 48 -30 61 -66z m3851 41
c13 0 23 -17 23 -37 0 -21 17 -38 38 -38 69 0 37 -44 -44 -60 -121 -24 -161
-22 -235 15 -89 44 -88 81 4 91 41 4 85 18 99 31 13 13 39 18 58 11 19 -7 44
-13 57 -13z m-12127 -19 c0 -11 -18 -45 -39 -75 -46 -66 -186 -80 -186 -18 0
22 23 37 59 37 33 0 74 17 91 38 33 40 75 50 75 18z m17875 -36 c0 -59 92 -93
254 -94 127 -1 169 -10 181 -40 11 -29 41 -38 109 -32 70 6 94 -1 94 -29 0
-26 -27 -37 -84 -37 -88 0 -154 -61 -154 -143 0 -25 -3 -45 -6 -45 -4 0 -62
17 -129 38 -68 20 -158 37 -200 37 -52 0 -89 17 -110 52 -31 49 -37 49 -93 12
-65 -42 -180 -51 -233 -17 -30 19 7 140 62 201 5 5 48 -11 95 -37 92 -49 157
-29 83 25 -52 38 -58 89 -10 89 19 0 49 17 66 37 32 39 75 29 75 -17z m-20736
-899 c5 -500 0 -948 -12 -996 -29 -116 -57 1587 -31 1832 24 217 34 24 43
-836z m12027 848 c11 -17 21 -52 23 -79 3 -51 75 -115 128 -115 50 0 40 -49
-29 -140 -35 -45 -63 -95 -63 -111 0 -19 -22 -24 -64 -13 -50 12 -76 0 -127
-60 -88 -105 -145 -102 -124 5 9 45 23 164 32 265 14 162 22 186 74 205 33 13
59 34 59 48 0 36 68 32 91 -5z m6105 9 c28 -18 26 -31 -12 -75 -56 -65 -134
-70 -134 -8 0 84 76 127 146 83z m-12246 -40 c0 -21 -22 -60 -49 -87 -43 -43
-45 -54 -13 -86 34 -34 27 -115 -10 -115 -44 0 -128 83 -128 126 0 27 9 49 20
49 10 0 32 34 47 75 30 80 133 109 133 38z m4325 -49 c0 -54 104 -68 141 -19
30 40 36 40 110 -1 96 -54 121 -55 177 -4 24 22 56 33 70 23 43 -26 31 -109
-17 -118 -51 -10 -72 -166 -51 -382 7 -69 0 -76 -74 -83 -72 -7 -79 -15 -66
-69 15 -61 -22 -86 -52 -36 -9 14 -35 25 -58 25 -23 1 -59 12 -80 25 -50 33 7
74 102 75 133 0 161 398 32 456 -49 23 -68 17 -124 -40 -37 -36 -76 -66 -87
-66 -11 0 -26 -20 -34 -44 -22 -71 -233 -288 -262 -270 -76 47 -8 202 98 223
91 18 120 75 65 130 -61 61 -52 183 16 209 65 24 94 14 94 -34z m9999 -25
c-13 -13 -24 -56 -24 -94 0 -46 -13 -70 -37 -70 -28 0 -38 29 -38 108 0 129
14 149 77 110 30 -19 38 -38 22 -54z m-22755 22 c66 -46 70 -100 16 -208 -32
-64 -47 -74 -74 -51 -26 21 -28 41 -9 76 19 35 15 62 -13 103 -77 110 -29 157
80 80z m21242 -25 c34 -52 36 -72 12 -101 -62 -75 15 -92 98 -22 61 51 79 57
79 27 0 -22 -11 -40 -25 -40 -13 0 -31 -29 -40 -64 -11 -45 -24 -57 -42 -39
-15 15 -72 20 -133 11 -132 -18 -240 16 -125 40 95 19 110 67 29 87 -77 19
-80 49 -14 115 67 67 111 63 161 -14z m-16523 -11 c0 -37 -173 -134 -215 -120
-12 4 7 45 43 90 67 86 172 104 172 30z m3900 0 c0 -22 -29 -41 -69 -45 -74
-9 -88 16 -38 66 40 40 107 26 107 -21z m3081 29 c43 43 106 4 106 -64 0 -78
-40 -104 -92 -61 -23 18 -60 30 -85 26 -52 -9 -83 33 -63 85 11 28 26 31 61
12 31 -17 55 -16 73 2z m5620 -31 c26 -42 -32 -90 -67 -55 -29 29 -11 82 28
82 12 0 30 -12 39 -27z m-6382 -48 c35 -27 80 -50 100 -50 20 0 52 -19 71 -42
57 -69 253 -183 314 -183 42 0 58 -14 58 -53 0 -44 10 -50 65 -36 111 28 385
-141 385 -238 0 -54 -105 -48 -175 11 -104 87 -170 104 -223 56 -67 -61 -269
-54 -289 10 -9 27 -43 57 -75 65 -33 8 -66 31 -73 51 -10 26 -27 30 -56 14
-49 -28 -184 39 -184 91 0 19 -23 40 -52 47 -41 11 -48 27 -36 76 13 53 8 61
-32 50 -29 -7 -58 5 -75 33 -24 37 -16 52 52 94 104 64 147 65 225 4z m-5821
-30 c34 -50 47 -52 120 -27 84 30 209 18 233 -21 8 -12 -7 -22 -33 -22 -77 0
-106 -53 -106 -193 0 -118 7 -136 63 -162 69 -31 84 -121 27 -168 -39 -32 -53
-19 -106 98 -30 66 -34 62 -73 -69 -11 -37 -261 -43 -261 -6 0 14 32 25 70 25
123 0 140 49 51 142 -77 79 -78 85 -49 183 28 95 27 106 -25 147 -35 29 -50
60 -39 87 22 58 82 51 128 -14z m999 14 c18 -47 -25 -109 -76 -109 -35 0 -48
102 -17 133 30 30 77 18 93 -24z m4340 8 c64 -22 88 -44 88 -84 0 -29 8 -62
18 -72 11 -11 19 -47 19 -81 0 -64 47 -115 144 -155 66 -28 75 -100 12 -100
-24 0 -100 40 -169 89 -109 78 -137 87 -227 74 -94 -14 -296 14 -327 46 -7 7
-4 27 7 45 11 18 17 73 13 122 -5 73 5 95 52 118 76 36 261 36 370 -2z m10438
-42 c0 -52 -14 -64 -82 -70 -76 -8 -81 -3 -81 70 0 73 5 78 81 70 68 -6 82
-18 82 -70z m-8874 23 c26 -42 -32 -90 -67 -55 -29 29 -11 82 28 82 12 0 30
-12 39 -27z m13261 -10 c53 -64 -17 -128 -78 -72 -36 32 -40 50 -19 75 36 44
59 43 97 -3z m-12800 -27 c0 -42 -114 -184 -157 -195 -93 -25 -156 96 -82 158
65 54 239 81 239 37z m9861 -9 c16 -26 -8 -102 -32 -102 -57 2 -87 48 -56 86
37 44 67 50 88 16z m-18011 -83 c0 -10 -23 -19 -51 -19 -40 0 -99 -80 -99
-135 0 -3 32 -42 72 -86 70 -79 103 -203 103 -390 0 -75 8 -82 126 -112 188
-48 339 -294 212 -343 -53 -20 -47 -73 13 -129 31 -29 44 -64 34 -89 -17 -46
-49 -53 -72 -16 -9 14 -42 25 -74 25 -72 0 -189 90 -189 146 0 23 -28 84 -63
135 -59 87 -62 107 -47 291 30 360 -35 482 -207 390 -75 -41 -155 -34 -93 8
145 99 147 101 101 151 -24 26 -40 61 -36 78 4 17 -15 44 -42 60 -28 15 -56
32 -62 36 -36 24 75 53 153 41 52 -8 98 -3 107 12 17 28 114 -18 114 -54z
m18250 7 c0 -51 17 -84 55 -104 l55 -29 -61 -49 -60 -48 52 -42 c28 -23 59
-62 68 -88 16 -44 20 -44 81 -4 48 31 73 35 93 15 46 -46 -63 -131 -179 -140
-100 -8 -103 -6 -118 84 -26 156 -38 181 -101 210 -77 35 -76 82 3 134 34 22
62 62 62 88 0 26 11 47 25 47 14 0 25 -33 25 -74z m-14017 33 c19 -19 -28 -84
-61 -84 -12 0 -22 23 -22 50 0 48 49 68 83 34z m-1071 -106 c23 -77 29 -80
119 -65 109 19 118 1 33 -66 -44 -35 -63 -78 -69 -154 -7 -96 -14 -106 -80
-114 l-72 -8 13 210 c7 121 2 230 -12 256 -19 34 -17 42 9 33 19 -6 45 -47 59
-92z m-7115 9 c65 -62 15 -116 -90 -98 -107 19 -197 91 -170 135 23 37 211 10
260 -37z m21829 -12 c16 -66 -58 -174 -120 -175 -45 0 -38 44 13 72 37 22 39
33 11 78 -17 28 -25 63 -16 77 27 45 96 13 112 -52z m-6976 13 c17 -21 57 -38
89 -38 126 0 167 -64 120 -189 -15 -37 -21 -36 -59 14 -41 54 -44 54 -123 13
-74 -38 -85 -38 -125 -2 -62 56 -115 48 -162 -24 l-41 -62 -72 52 c-85 63
-138 163 -99 187 29 18 170 35 289 35 44 0 86 11 95 25 22 36 52 32 88 -11z
m-10406 -95 c83 -76 70 -93 -69 -93 -95 0 -125 -9 -125 -38 0 -33 -8 -33 -62
3 -65 42 -66 148 -3 191 44 30 198 -8 259 -63z m15863 53 c50 -27 46 -31 -58
-62 -141 -42 -174 -42 -174 0 0 69 145 109 232 62z m-20073 -99 c121 -128 94
-176 -84 -150 -110 16 -112 18 -106 104 14 184 52 193 190 46z m3286 59 c-6
-28 -27 -40 -58 -35 -63 11 -71 19 -51 52 29 47 119 32 109 -17z m4871 -80
c72 -114 77 -135 60 -256 -14 -103 -22 -121 -38 -82 -31 75 -218 248 -308 285
-102 42 -101 83 1 132 149 71 198 57 285 -79z m300 31 c83 -96 87 -132 13
-132 -55 0 -204 135 -204 186 0 73 107 42 191 -54z m3085 17 c19 -36 42 -47
76 -36 81 26 59 -71 -25 -108 -88 -39 -170 -2 -193 87 -27 109 89 156 142 57z
m9223 -75 c-37 -71 -80 -16 -57 74 13 49 19 51 51 19 30 -29 31 -47 6 -93z
m-15314 36 c40 -15 56 -82 21 -89 -159 -30 -237 -1 -180 68 32 38 93 46 159
21z m-5949 -84 c66 -68 75 -151 17 -151 -42 0 -151 150 -137 188 20 53 40 47
120 -37z m23386 40 c21 -25 17 -43 -19 -75 -54 -49 -121 1 -94 71 18 47 76 49
113 4z m-2686 -6 c34 -13 30 -25 -23 -74 -71 -66 -81 -124 -25 -145 54 -21 45
-66 -13 -66 -30 0 -50 17 -50 41 0 39 -235 40 -487 4 -32 -5 -52 9 -58 43 -6
27 -27 68 -48 92 -46 53 -22 95 55 95 43 0 62 -16 68 -56 14 -101 320 -81 320
21 0 29 15 37 56 26 32 -8 74 -3 94 10 45 28 58 29 111 9z m-17476 -81 c20
-38 54 -85 76 -103 62 -51 49 -126 -22 -126 -70 0 -139 114 -139 229 0 91 38
91 85 0z m408 22 c-7 -27 3 -62 22 -78 87 -72 -11 -204 -112 -150 -87 47 -107
177 -28 177 33 0 50 17 50 50 0 29 17 50 40 50 28 0 37 -15 28 -49z m2829 17
c-22 -17 -48 -56 -58 -87 -21 -68 -89 -75 -89 -9 0 50 89 125 150 126 32 0 31
-4 -3 -30z m8214 -81 c17 -89 4 -137 -37 -137 -39 0 -79 102 -63 165 22 89 81
73 100 -28z m7610 30 c4 -25 -8 -42 -32 -42 -21 0 -39 -11 -39 -25 0 -14 21
-25 47 -25 26 0 80 -17 119 -37 62 -33 65 -38 18 -38 -63 0 -97 -65 -49 -93
64 -37 72 -124 13 -140 -46 -12 -52 -26 -38 -98 25 -136 -36 -277 -128 -296
-42 -9 -110 -40 -152 -69 -86 -62 -141 -66 -280 -23 -125 39 -126 59 -6 75
111 15 256 132 256 208 0 34 40 81 113 133 167 121 146 241 -61 352 -73 39
-65 76 17 76 43 0 81 20 101 52 37 58 88 53 101 -10z m-15381 -11 c48 -62 43
-79 -29 -107 -112 -42 -207 45 -131 121 44 44 122 37 160 -14z m16231 -16 c10
-50 -33 -89 -100 -90 -53 0 -80 72 -42 117 40 48 131 31 142 -27z m-10471 18
c0 -9 -18 -37 -41 -62 -22 -24 -42 -90 -43 -145 -3 -100 -66 -152 -66 -55 0
46 -93 104 -166 104 -59 0 -26 59 55 98 41 19 77 44 82 56 10 25 179 29 179 4z
m1708 -72 c46 63 131 40 123 -32 -7 -69 107 -177 189 -178 48 -1 57 -13 50
-68 -10 -86 -58 -102 -83 -28 -17 50 -21 45 -30 -39 -7 -64 3 -110 29 -139 21
-24 39 -60 39 -80 0 -20 12 -49 27 -64 15 -15 23 -59 19 -99 -8 -63 -17 -71
-83 -63 -112 12 -146 60 -151 211 -5 163 -16 184 -126 230 -57 23 -86 52 -86
85 0 92 -29 128 -103 128 -55 0 -72 -12 -72 -50 0 -27 -8 -50 -19 -50 -15 0
-23 234 -10 308 2 11 60 -11 129 -48 119 -65 128 -66 158 -24z m10692 54 c0
-111 -54 -142 -129 -74 -73 67 -57 109 42 109 58 0 87 -12 87 -35z m-14575
-15 c39 -21 43 -38 24 -105 -44 -153 -85 -166 -185 -57 -122 133 -119 187 13
187 56 0 122 -11 148 -25z m13105 -44 c51 -104 -35 -249 -92 -156 -9 14 -36
25 -59 25 -106 0 -123 162 -20 183 114 22 138 15 171 -52z m-14555 -120 c0
-62 -45 -111 -102 -111 -41 0 -133 214 -109 253 23 37 211 -90 211 -142z
m11989 109 c43 -135 107 -153 395 -114 29 4 55 -15 68 -50 34 -90 -111 -166
-310 -162 -67 1 -114 -16 -159 -59 -77 -71 -97 -74 -118 -19 -21 55 25 104
106 114 64 7 119 120 58 120 -13 0 -35 31 -49 69 -14 38 -33 88 -43 112 -10
25 -6 44 9 44 14 0 33 -25 43 -55z m-12567 -82 c108 -117 141 -265 73 -333
-16 -16 -21 -38 -10 -48 10 -11 35 2 54 28 31 43 36 44 50 6 31 -80 -7 -116
-123 -116 -75 0 -115 -12 -125 -37 -8 -21 -30 -38 -50 -38 -20 0 -42 17 -50
38 -16 42 -85 48 -140 13 -29 -18 -22 -29 37 -53 l75 -30 -63 -16 c-110 -29
-76 -89 56 -97 119 -8 158 -44 75 -70 -24 -8 -63 -24 -86 -36 -49 -26 -193 26
-244 87 -60 72 -76 40 -76 -151 0 -189 1 -191 62 -179 42 8 86 -10 143 -59 46
-38 108 -70 140 -71 32 -1 93 -21 137 -45 l81 -43 -110 -8 c-90 -7 -122 3
-176 56 -113 108 -212 46 -186 -116 20 -125 102 -148 140 -40 l26 77 33 -60
c45 -80 43 -89 -15 -104 -61 -16 -66 -99 -9 -156 48 -48 83 -14 84 82 0 31 15
56 34 56 109 0 121 -215 16 -267 -48 -24 -65 -55 -75 -138 -22 -193 -90 -144
-163 118 -40 143 -67 210 -155 375 -78 145 -84 166 -85 270 -1 57 -2 161 -4
230 -1 68 1 181 4 250 3 68 4 217 2 330 -3 234 20 354 53 270 11 -28 20 -117
21 -199 1 -100 15 -162 43 -193 33 -36 35 -52 10 -82 -17 -21 -25 -52 -18 -69
8 -21 14 -16 15 11 1 27 22 44 53 44 28 0 58 20 67 44 24 67 59 80 172 64 184
-25 169 128 -16 158 -86 13 -99 24 -99 81 0 39 -21 79 -50 97 -27 17 -50 49
-50 69 0 53 68 74 114 36 32 -27 48 -23 93 22 75 75 97 69 215 -58z m6731 84
c46 -16 113 -55 148 -88 35 -32 87 -59 115 -59 29 0 88 -35 132 -77 44 -42
114 -89 156 -103 53 -19 67 -34 48 -53 -15 -15 -27 -58 -27 -96 0 -37 -10 -74
-22 -81 -12 -8 -16 -42 -9 -77 14 -76 -46 -85 -160 -25 -47 25 -104 33 -165
23 -83 -14 -94 -9 -94 35 0 29 22 58 50 67 28 8 50 26 50 39 0 13 26 23 58 23
122 0 158 122 56 189 -77 50 -111 32 -95 -51 7 -36 0 -63 -15 -63 -63 0 -151
61 -165 114 -12 50 -25 56 -101 44 -96 -16 -138 42 -138 194 0 83 36 92 178
45z m-11247 -116 c-6 -85 -94 -231 -181 -301 -80 -65 -178 -503 -127 -565 16
-20 22 -62 14 -95 -12 -49 6 -80 99 -166 63 -58 114 -116 114 -130 0 -58 -121
-16 -223 77 -136 125 -235 115 -242 -23 -2 -44 -22 -100 -45 -125 -22 -24 -40
-69 -40 -98 0 -30 -28 -72 -62 -95 -81 -53 -80 -80 6 -90 41 -4 69 -23 69 -45
0 -22 -28 -41 -69 -45 -48 -6 -69 3 -69 29 0 21 -31 53 -68 71 -83 40 -108
120 -38 120 68 0 104 93 71 182 -25 66 -20 79 57 147 61 55 76 83 56 103 -53
53 -31 138 47 184 87 52 110 106 87 210 -12 55 -6 78 24 89 78 30 23 170 -74
189 -65 12 -77 88 -24 147 25 27 38 69 30 98 -7 28 -4 56 7 63 40 25 76 -60
70 -165 -9 -137 57 -166 122 -53 44 76 117 119 252 146 87 17 115 99 44 126
-79 30 -28 113 62 100 26 -4 36 -30 31 -85z m7135 31 c-51 -37 -38 -123 22
-146 65 -25 40 -80 -68 -151 -86 -56 -115 -64 -162 -42 -81 37 -78 144 4 181
48 22 56 37 35 62 -43 52 -14 91 92 122 113 33 144 23 77 -26z m-8016 27 c0
-51 -56 -135 -98 -146 -77 -20 -90 28 -25 96 49 53 123 83 123 50z m20777 -15
c74 -39 60 -99 -23 -99 -89 0 -109 19 -77 78 29 54 35 56 100 21z m-21877
-104 c0 -56 -10 -72 -43 -65 -47 9 -70 75 -48 134 24 61 91 11 91 -69z m-2325
58 c0 -12 -16 -35 -35 -51 -39 -33 -80 4 -52 48 19 31 87 33 87 3z m5688 -29
c36 -39 39 -57 16 -80 -24 -24 -34 -18 -45 25 -8 31 -25 56 -37 56 -12 0 -22
11 -22 25 0 40 39 29 88 -26z m4811 15 c48 -58 5 -100 -51 -49 -27 23 -48 52
-48 64 0 34 66 24 99 -15z m1628 -1 c0 -14 -23 -29 -51 -33 -50 -8 -68 20 -33
54 24 25 85 9 84 -21z m7992 -7 c6 -18 -11 -31 -40 -31 -55 0 -88 33 -61 60
25 25 89 7 101 -29z m5073 5 c6 -16 -32 -25 -98 -22 -128 5 -126 4 -106 37 21
34 193 21 204 -15z m-24255 -60 c44 -86 50 -201 10 -201 -27 0 -23 -42 16
-169 11 -35 7 -56 -10 -56 -15 0 -28 17 -28 38 0 20 -22 37 -50 37 -28 0 -50
-17 -50 -37 0 -21 -11 -38 -25 -38 -40 0 -29 -54 19 -90 60 -46 106 -43 106 8
0 33 7 35 30 12 23 -23 23 -37 0 -60 -45 -45 -36 -95 16 -95 70 0 80 -24 43
-112 -23 -55 -25 -93 -8 -124 18 -33 13 -55 -19 -85 -35 -34 -45 -35 -56 -7
-7 19 -35 57 -62 84 -39 39 -47 72 -37 147 7 53 4 97 -8 97 -12 0 -52 40 -89
88 -76 100 -56 212 37 212 59 0 77 64 78 269 0 170 28 197 87 82z m8804 -70
c-2 -79 5 -192 16 -252 26 -147 -19 -129 -113 44 -114 212 -88 323 84 350 9 1
15 -63 13 -142z m5522 93 c32 -35 38 -58 19 -77 -57 -57 4 -134 143 -181 28
-9 23 -17 -19 -30 -64 -19 -64 -21 -33 -80 13 -24 31 -75 39 -113 22 -106 124
-143 191 -70 35 37 61 48 78 31 31 -31 3 -79 -45 -79 -57 0 -42 -40 48 -129
140 -139 173 -158 278 -163 55 -3 148 -13 207 -22 120 -18 157 46 49 87 -46
17 -58 42 -61 124 -5 124 18 142 100 78 84 -66 93 -63 93 23 0 41 11 104 25
141 24 62 29 64 82 30 30 -21 59 -61 63 -91 6 -34 27 -53 60 -53 46 0 49 10
33 119 -10 65 -33 136 -53 158 -55 62 -44 145 22 161 32 8 68 39 82 70 17 37
43 52 83 48 33 -4 72 4 88 16 54 44 233 58 294 24 130 -74 129 -163 -4 -302
-55 -57 -100 -114 -100 -125 0 -12 -37 -37 -81 -57 -45 -19 -110 -75 -144
-123 -34 -48 -81 -88 -103 -88 -23 -1 -60 -29 -82 -63 -45 -68 -132 -82 -219
-36 -36 19 -59 20 -78 1 -18 -18 -4 -34 47 -54 l73 -28 -60 -48 c-32 -26 -74
-48 -93 -48 -19 0 -35 -17 -35 -38 0 -21 -16 -45 -37 -53 -20 -7 -43 -35 -51
-62 -9 -27 -66 -72 -127 -101 -61 -28 -117 -62 -124 -74 -29 -47 -61 -19 -61
53 0 41 -11 75 -25 75 -23 0 -28 -18 -35 -127 -1 -22 -39 -72 -84 -110 -76
-63 -94 -67 -219 -51 -81 10 -137 7 -137 -7 0 -13 -44 -54 -98 -91 -90 -62
-105 -65 -167 -35 -92 45 -103 91 -29 119 33 12 93 57 133 100 45 47 98 77
138 77 45 0 74 19 93 63 29 62 113 85 143 37 30 -49 59 -24 67 56 6 68 17 80
64 76 66 -8 73 38 20 141 -28 53 -51 68 -94 60 -43 -8 -91 22 -188 116 -71 69
-153 126 -181 126 -72 0 -64 46 12 65 80 20 78 48 -15 184 -44 66 -73 139 -70
175 3 35 -2 89 -13 120 -34 104 24 138 98 55z m4537 40 c0 -32 -117 -130 -144
-121 -50 18 -36 52 38 90 74 39 106 49 106 31z m3750 -51 c0 -35 -13 -63 -30
-63 -16 0 -55 -24 -86 -53 -33 -32 -103 -58 -172 -66 -76 -8 -126 -29 -145
-59 -36 -58 -67 -60 -67 -5 0 23 -24 68 -54 99 -52 56 -52 58 -6 75 26 9 63
29 82 44 39 31 273 82 397 87 71 3 81 -5 81 -59z m-21675 -28 c0 -49 -71 -74
-108 -37 -23 24 -19 38 18 65 53 39 90 28 90 -28z m5369 26 c31 -21 56 -55 56
-76 0 -20 17 -43 38 -51 20 -8 37 -28 37 -44 0 -17 34 -63 75 -102 51 -49 75
-97 75 -149 1 -42 10 -92 22 -110 27 -43 -25 -323 -76 -404 -22 -34 -55 -133
-73 -219 -36 -168 -63 -196 -87 -87 -14 62 -55 166 -115 287 -42 86 -26 176
29 162 54 -14 92 19 50 44 -41 26 -28 63 22 63 34 0 52 -24 64 -87 24 -129 80
-111 99 33 21 165 -23 297 -83 243 -53 -48 -250 -118 -280 -100 -12 8 -22 37
-22 64 0 28 -12 72 -26 99 -20 37 -15 63 19 110 55 76 68 77 101 7 l28 -56 1
54 c1 30 13 62 27 71 46 28 26 137 -37 191 -94 82 -47 130 56 57z m-544 -8 c0
-13 -18 -30 -40 -38 -49 -19 -28 -134 33 -178 28 -21 31 -35 11 -47 -16 -10
-68 23 -120 75 -88 88 -90 93 -45 125 27 18 60 44 74 58 31 31 87 34 87 5z
m-6363 -154 c-33 -53 -62 -19 -61 70 l1 94 38 -70 c20 -38 30 -80 22 -94z
m6634 105 l59 -45 -66 -43 c-115 -76 -244 18 -132 96 67 47 67 47 139 -8z
m5073 -3 c88 -4 -95 -226 -187 -226 -17 0 -38 -31 -46 -69 -27 -122 -34 -131
-98 -131 -46 0 -63 13 -63 50 0 34 -17 50 -51 50 -74 0 -80 47 -27 188 45 117
54 125 137 125 49 1 95 7 103 15 7 8 56 11 107 7 51 -4 108 -8 125 -9z m1319
-51 c0 -50 -15 -64 -69 -70 -78 -9 -78 -8 -44 83 32 85 113 76 113 -13z
m10705 47 c40 -40 -33 -147 -99 -147 -39 0 -47 12 -35 56 9 31 15 71 16 88 0
39 80 41 118 3z m-23893 -58 c0 -71 -29 -96 -85 -74 -40 15 -54 87 -23 118 42
42 108 15 108 -44z m7938 35 c8 -14 -12 -58 -46 -98 -69 -82 -103 -221 -80
-326 9 -40 4 -77 -11 -87 -18 -11 -18 -31 0 -65 31 -59 8 -155 -34 -141 -16 5
-33 41 -38 81 -4 39 -42 102 -83 141 -73 68 -89 166 -26 152 17 -3 43 -9 58
-12 53 -12 53 59 0 73 -98 26 -53 183 53 183 25 0 56 27 69 63 24 63 108 85
138 36z m4337 0 c0 -19 -76 -152 -143 -247 -4 -5 -35 3 -69 18 -52 24 -63 47
-63 128 0 93 5 99 81 109 156 19 194 18 194 -8z m1985 -14 c10 -26 34 -36 64
-28 27 7 63 -4 80 -25 17 -20 58 -47 90 -60 68 -25 49 -83 -20 -64 -77 20
-149 -51 -149 -146 0 -46 -15 -94 -33 -105 -19 -11 -33 -53 -32 -94 3 -85 -77
-121 -115 -53 -13 23 -55 40 -96 40 -65 0 -74 -9 -74 -74 0 -40 -11 -80 -25
-88 -77 -48 13 -91 211 -101 69 -4 129 -20 135 -36 5 -16 32 -50 60 -77 43
-39 46 -54 20 -86 -66 -78 -185 -36 -253 90 -14 28 -39 46 -55 41 -39 -13 -24
-252 21 -339 46 -87 45 -141 -2 -181 -21 -17 -42 -27 -46 -21 -4 5 -32 51 -63
102 -30 51 -77 99 -104 108 -26 8 -46 23 -43 32 7 28 -56 130 -80 130 -45 0
-58 -106 -16 -130 37 -21 37 -28 3 -77 -48 -69 -50 -168 -2 -168 20 0 51 -21
69 -46 47 -65 193 -112 237 -76 39 33 133 -35 133 -97 0 -27 25 -34 100 -27
55 6 100 6 100 2 0 -5 -17 -41 -37 -81 -35 -67 -34 -75 11 -106 48 -34 48 -35
-6 -82 -92 -80 -211 -73 -256 14 -21 41 -47 74 -57 74 -11 0 -39 34 -64 75
-24 41 -62 75 -84 75 -22 0 -80 31 -129 68 -51 39 -114 65 -146 61 -34 -5 -63
8 -72 32 -24 61 -52 46 -69 -37 -11 -56 -1 -96 37 -147 57 -77 54 -172 -4
-153 -20 7 -84 10 -143 8 -124 -5 -146 54 -51 142 43 41 48 58 24 82 -24 24
-34 19 -45 -25 -8 -31 -26 -56 -40 -56 -13 0 -47 -29 -75 -65 -33 -41 -67 -60
-98 -52 -45 12 -96 -45 -96 -108 0 -41 200 -124 302 -124 152 -1 310 -243 212
-325 -44 -36 -125 0 -164 75 -15 27 -49 49 -77 49 -84 0 -198 72 -198 126 0
74 -40 59 -76 -28 -28 -69 -40 -76 -111 -62 -98 18 -126 -6 -73 -64 63 -69 21
-102 -76 -62 -96 40 -139 16 -139 -78 0 -44 -14 -57 -61 -57 -81 0 -102 -40
-57 -107 33 -50 58 -55 254 -55 208 0 220 -4 267 -68 42 -57 62 -66 127 -53
73 15 77 12 59 -44 -10 -33 -25 -92 -32 -131 -18 -94 -116 -86 -127 11 -8 69
-123 122 -268 122 -38 0 -83 19 -99 41 -38 52 -88 24 -88 -50 0 -97 -46 -118
-141 -64 -112 63 -130 61 -220 -24 -103 -97 -264 -87 -264 17 0 76 65 155 127
155 58 0 121 90 106 149 -25 94 195 351 300 351 59 0 192 169 192 243 0 83
227 307 311 307 34 0 96 43 155 106 55 59 121 119 147 134 26 15 66 60 88 100
22 40 81 95 132 123 51 27 99 72 107 100 9 27 41 78 72 112 31 34 64 93 73
131 8 37 39 90 68 117 43 40 50 66 36 139 -22 116 77 341 200 453 56 52 86
102 86 145 0 76 108 96 135 25z m-5075 -140 c10 -51 3 -92 -20 -118 -31 -34
-30 -52 13 -139 27 -55 44 -122 37 -148 -7 -27 -2 -68 11 -93 18 -33 14 -50
-16 -67 -22 -12 -48 -60 -57 -107 -42 -205 -84 -42 -118 456 -22 317 -6 386
75 333 33 -21 66 -74 75 -117z m-3469 18 c60 -62 113 -113 120 -113 6 0 48
-34 94 -76 45 -42 107 -82 138 -90 30 -8 62 -35 70 -61 11 -34 40 -48 95 -50
73 -1 75 -3 23 -24 -31 -12 -56 -40 -56 -62 0 -44 117 -162 160 -162 57 0 240
-114 240 -150 -2 -133 -252 -37 -469 181 -369 368 -616 657 -594 693 29 47 70
27 179 -86z m13809 51 c0 -67 -69 -96 -98 -42 -22 40 -19 55 16 75 50 27 82
15 82 -33z m420 -35 c6 -41 -4 -54 -43 -54 -34 0 -52 16 -52 46 0 95 82 102
95 8z m1055 58 c0 -21 -110 -58 -132 -45 -35 21 10 58 71 58 34 0 61 -6 61
-13z m-20595 -56 c66 -76 78 -206 19 -206 -30 0 -49 17 -50 44 0 24 -17 65
-37 92 -75 99 -12 163 68 70z m1385 4 c-8 -21 -15 -67 -15 -100 0 -73 -65
-106 -111 -57 -49 51 17 197 89 197 37 0 48 -11 37 -40z m8329 -53 l62 -81
-67 -26 c-54 -20 -66 -39 -59 -94 9 -82 83 -106 102 -32 15 58 105 70 126 16
18 -46 -4 -65 -72 -65 -40 0 -64 -22 -82 -75 -23 -64 -39 -75 -115 -75 -78 0
-89 -8 -89 -62 0 -75 39 -84 57 -13 20 75 87 60 142 -30 27 -44 47 -82 44 -84
-3 -3 -90 6 -193 20 -183 23 -301 85 -299 155 1 48 122 166 199 193 91 32 95
69 13 146 -82 76 -80 134 6 168 104 42 156 27 225 -61z m11451 38 c35 -35 40
-136 7 -156 -48 -30 -152 34 -152 94 0 94 79 128 145 62z m-8152 -37 c14 -43
-91 -95 -125 -61 -18 18 -16 38 7 66 36 43 103 41 118 -5z m10132 19 c0 -13
19 -43 43 -66 49 -49 74 -199 105 -611 22 -300 62 -519 113 -625 17 -34 45
-127 62 -206 30 -140 169 -385 242 -426 19 -11 35 -32 35 -45 0 -40 173 -273
202 -273 9 0 23 58 31 129 9 71 34 204 56 296 40 162 39 170 -12 270 -68 135
-66 155 19 155 86 0 112 22 77 65 -20 24 -11 54 37 117 72 94 85 220 29 267
-25 20 -35 71 -32 155 5 121 7 124 73 111 55 -11 65 -6 52 27 -14 37 49 108
95 108 83 0 174 -440 101 -485 -12 -8 -29 -70 -38 -138 -9 -69 -26 -131 -38
-138 -12 -8 -29 -45 -38 -83 -23 -95 -290 -744 -363 -882 -32 -61 38 -196 169
-327 239 -238 630 -753 630 -830 0 -14 15 -43 34 -65 33 -38 116 -335 116
-414 0 -22 -24 -73 -54 -113 -66 -89 -132 -60 -110 48 16 78 -94 179 -143 130
-42 -42 -68 -34 -68 22 0 28 10 50 22 50 64 0 27 217 -44 261 -38 23 -400 -16
-444 -48 -34 -25 -35 -37 -7 -82 28 -46 27 -60 -9 -100 -24 -26 -43 -56 -43
-67 0 -11 -29 -42 -64 -70 -36 -28 -93 -108 -127 -179 -34 -70 -89 -178 -121
-240 -33 -62 -66 -129 -74 -150 -7 -21 -24 -54 -36 -75 -13 -21 -38 -88 -55
-150 -18 -62 -58 -163 -90 -225 -32 -62 -58 -126 -58 -143 0 -16 -24 -43 -54
-59 -61 -33 -121 20 -121 105 0 24 -11 51 -25 60 -14 8 -25 34 -25 58 0 38
-317 301 -406 337 -55 23 35 66 136 67 108 0 128 21 82 85 -25 33 -52 42 -97
30 -34 -8 -69 -3 -78 11 -10 16 -28 18 -45 4 -16 -12 -75 -23 -131 -24 -164
-5 -175 49 -97 483 6 29 39 66 74 82 35 16 73 54 84 84 13 37 42 57 80 57 72
1 95 75 30 98 -156 56 -307 186 -307 265 0 40 -11 79 -25 88 -51 31 -22 59 69
67 88 7 160 95 78 95 -48 0 -147 103 -147 153 0 24 -21 59 -47 77 -26 18 -51
53 -56 78 -6 29 -68 69 -167 109 -146 58 -162 60 -202 23 -43 -39 -128 -55
-128 -25 0 55 91 158 129 146 28 -9 53 6 71 40 25 45 21 55 -23 66 -58 15 -59
19 -37 128 22 109 77 119 168 30 42 -41 98 -75 123 -75 123 0 260 -174 191
-243 -52 -52 72 -282 152 -282 36 0 82 -98 66 -140 -8 -21 0 -60 17 -87 26
-43 23 -55 -13 -76 -24 -13 -44 -45 -44 -70 0 -51 58 -111 83 -85 9 9 37 -3
63 -26 58 -52 83 -29 52 51 -62 163 -10 226 109 133 35 -27 75 -50 89 -50 29
0 46 -54 50 -162 2 -47 28 -97 66 -131 71 -61 82 -107 26 -107 -21 0 -38 17
-38 38 0 45 -67 48 -158 6 -84 -39 -77 -95 15 -126 51 -17 92 -12 154 17 46
22 99 40 118 40 37 0 110 -258 84 -299 -19 -31 119 -102 192 -98 51 2 52 4 8
15 -79 19 -93 44 -74 141 16 90 57 122 217 175 68 22 52 77 -30 108 -112 42
-138 211 -38 249 23 9 53 -3 72 -29 48 -67 163 12 146 101 -14 75 -45 79 -81
12 -39 -72 -75 -61 -75 22 0 40 -16 79 -36 86 -21 9 -30 34 -22 65 16 59 35
65 78 22 17 -17 31 -25 32 -19 1 6 5 40 9 74 4 34 23 100 42 145 29 71 29 85
-3 105 -55 34 -128 -43 -109 -116 9 -35 3 -59 -13 -59 -16 0 -28 25 -29 56 0
31 -31 87 -69 124 -38 37 -97 124 -131 193 -59 121 -104 155 -136 103 -29 -46
-81 1 -69 63 9 46 1 61 -31 61 -33 0 -41 -15 -32 -62 11 -59 -37 -92 -64 -44
-44 79 -41 161 7 173 61 16 67 71 11 93 -33 13 -35 23 -9 53 25 31 24 46 -7
81 -22 24 -60 87 -85 141 -52 109 -133 174 -152 121 -18 -49 -57 -36 -57 19 0
28 11 50 25 50 41 0 29 150 -12 166 -24 9 -38 47 -38 99 0 79 -6 85 -100 100
-73 12 -100 28 -100 61 0 24 -42 78 -94 120 l-93 75 71 28 c61 23 77 20 105
-17 17 -25 41 -36 51 -25 11 10 6 32 -9 47 -18 18 -20 44 -7 69 15 28 7 61
-26 103 -46 58 -51 59 -82 18 -44 -57 -83 -56 -116 5 -15 29 -41 43 -64 35
-31 -13 -35 2 -21 88 16 98 13 103 -47 103 -145 0 -109 123 59 199 69 31 143
83 164 116 26 40 63 60 110 60 47 0 91 25 136 79 105 125 363 230 363 148z
m-23841 -174 c-28 -81 -66 -65 -77 34 -13 120 12 157 60 89 30 -43 34 -74 17
-123z m11179 146 c9 -14 34 -22 56 -18 27 4 46 -18 56 -68 26 -122 70 -183
162 -227 94 -44 138 -33 138 37 0 60 69 118 101 86 32 -32 -98 -207 -154 -208
-23 -1 -55 -18 -73 -40 -53 -63 -133 -34 -164 61 -34 106 -87 137 -169 100
-79 -36 -141 -13 -141 52 0 32 22 55 60 65 59 15 59 18 25 101 -35 83 -34 85
26 85 33 0 68 -12 77 -26z m-8738 -99 c0 -90 -55 -100 -111 -20 -42 60 -18 94
67 95 32 0 44 -20 44 -75z m12475 -13 c0 -48 -60 -73 -119 -50 -38 15 -36 21
19 51 81 46 100 45 100 -1z m5370 -129 c-33 -53 -71 -117 -85 -144 -46 -86
-489 -142 -503 -64 -12 64 36 117 72 81 62 -62 99 -37 82 54 -26 142 138 200
185 65 15 -41 32 -75 38 -75 37 0 91 34 91 58 0 15 37 65 81 111 102 105 124
54 39 -86z m1327 144 c46 -29 17 -102 -40 -102 -88 1 -125 47 -71 88 56 43 64
44 111 14z m3228 -38 c0 -86 -48 -202 -72 -174 -56 63 -86 190 -51 212 68 43
123 26 123 -38z m-18230 -21 c10 -51 -62 -86 -100 -48 -38 38 -3 110 48 100
24 -4 48 -28 52 -52z m14403 9 c27 -27 52 -74 56 -106 8 -55 1 -58 -104 -50
-213 16 -253 82 -99 160 105 53 89 54 147 -4z m-20562 -40 c26 -20 42 -43 34
-50 -20 -20 -145 33 -145 62 0 37 54 31 111 -12z m12424 -2 c20 -53 -2 -85
-60 -85 -56 0 -85 39 -65 89 18 48 106 46 125 -4z m-3760 -19 c0 -47 -66 -99
-99 -79 -54 33 -29 113 37 113 36 0 62 -14 62 -34z m3010 -31 c7 -19 2 -35
-12 -35 -47 0 -125 52 -111 74 19 30 107 3 123 -39z m6872 -35 c36 0 88 23
114 52 33 35 54 43 66 24 38 -61 -10 -101 -119 -101 -60 0 -130 -17 -157 -37
-27 -20 -86 -37 -131 -37 -76 -1 -83 5 -75 67 11 101 114 146 184 81 28 -27
81 -49 118 -49z m6056 50 c0 -54 -73 -46 -84 9 -6 33 4 43 37 37 26 -5 47 -26
47 -46z m-18283 -80 c-23 -23 -37 -23 -61 1 -25 25 -24 36 6 54 50 31 96 -14
55 -55z m5695 42 c25 -30 25 -67 -2 -187 -37 -166 -40 -168 -177 -108 -87 39
-96 51 -96 138 0 70 10 95 40 95 22 0 68 23 103 50 76 60 91 61 132 12z m2377
13 c32 0 48 -17 48 -52 0 -46 -10 -50 -81 -35 -108 24 -119 32 -102 77 8 21
31 32 51 24 20 -8 58 -14 84 -14z m-12394 -56 c19 -85 -17 -383 -45 -374 -14
4 -22 29 -18 55 4 26 -16 71 -45 100 -42 42 -50 70 -36 133 30 142 118 195
144 86z m1317 -85 c0 -70 -35 -93 -112 -74 l-59 15 51 105 c48 98 53 102 85
58 19 -26 35 -73 35 -104z m828 89 c40 -29 90 -92 110 -141 42 -101 146 -207
202 -207 21 0 64 29 97 64 50 54 68 60 112 37 89 -48 -7 -157 -126 -142 -134
15 -168 -14 -150 -127 17 -100 63 -117 193 -73 49 16 54 9 54 -71 0 -48 -3
-88 -6 -88 -3 0 -73 22 -154 49 -81 28 -166 50 -188 50 -62 1 -176 102 -167
148 5 24 33 41 70 41 84 0 100 112 26 181 -31 28 -49 73 -45 108 6 53 -8 64
-100 84 -111 25 -136 69 -62 112 57 33 50 35 134 -25z m6243 25 c83 -29 111
-125 48 -164 -76 -47 -319 31 -319 103 0 79 133 109 271 61z m-3744 -165 c11
-52 32 -140 47 -195 14 -55 38 -182 53 -282 28 -181 73 -247 73 -106 0 41 11
75 25 75 14 0 25 -24 25 -52 0 -32 20 -58 51 -66 69 -18 52 -95 -21 -93 -66 3
-69 -10 -11 -55 38 -29 39 -36 6 -58 -51 -34 -65 -32 -109 12 -46 45 -108 48
-123 6 -25 -69 -218 170 -218 269 0 32 16 38 75 25 l75 -17 0 138 c0 76 -11
145 -24 153 -16 10 -14 34 6 66 26 42 23 54 -16 76 -37 21 -42 44 -29 117 31
165 77 160 115 -13z m6236 58 c51 -73 46 -91 -24 -91 -34 0 -68 -11 -76 -25
-9 -14 -34 -25 -57 -25 -32 0 -34 7 -11 30 17 17 30 66 30 110 0 94 73 94 138
1z m-11915 -447 c0 -279 -7 -605 -15 -726 -14 -217 -36 -269 -47 -112 -3 45
-14 166 -25 269 -10 103 -16 227 -13 275 7 106 5 166 -13 484 -15 277 -8 316
64 316 48 0 50 -16 49 -506z m1345 -181 c-6 -262 -3 -644 6 -850 11 -248 7
-416 -12 -500 l-29 -125 -19 112 c-28 158 -31 1899 -4 1975 45 128 70 -127 58
-612z m18907 618 c0 -55 -91 -206 -125 -206 -41 0 -29 76 27 166 57 92 98 109
98 40z m-8631 -26 c7 -19 -20 -30 -73 -29 -79 1 -81 2 -35 38 54 40 93 37 108
-9z m2283 19 c48 -26 68 -124 25 -124 -13 0 -39 -6 -58 -13 -19 -8 -66 13
-104 47 l-71 60 72 26 c39 14 75 27 79 28 5 1 30 -10 57 -24z m5379 -53 c80
-39 91 -96 19 -96 -27 0 -50 16 -50 36 0 20 -22 43 -50 52 -27 8 -50 27 -50
41 0 27 13 24 131 -33z m-11615 -89 c120 -130 128 -151 69 -174 -106 -40 -292
148 -251 254 24 63 69 44 182 -80z m12884 66 c0 -79 -43 -141 -109 -157 -33
-9 -79 -44 -102 -79 -50 -78 -89 -60 -89 42 0 74 78 168 141 170 15 1 42 18
59 39 45 53 100 46 100 -15z m-20025 -23 c0 -27 -10 -50 -22 -50 -33 0 -80 65
-61 84 34 34 83 14 83 -34z m16421 -9 c15 -80 -36 -101 -96 -41 -45 45 -49 60
-22 78 51 33 108 15 118 -37z m-10483 15 c15 -10 28 -49 31 -87 3 -38 7 -108
10 -156 7 -98 -31 -152 -90 -130 -29 11 -39 50 -39 147 1 207 26 271 88 226z
m1834 -3 c45 -29 -15 -161 -78 -173 -36 -7 -44 10 -44 93 0 105 40 131 122 80z
m11640 -2 c24 -40 -172 -150 -237 -134 -84 20 -125 55 -125 106 0 35 29 42
175 45 96 1 180 -6 187 -17z m-15489 -36 c36 -20 100 -29 154 -22 92 13 95 11
156 -121 34 -74 69 -185 78 -246 9 -62 33 -130 53 -152 20 -22 38 -73 41 -113
3 -41 26 -88 50 -106 47 -34 63 -155 20 -155 -14 0 -18 -45 -9 -112 18 -127
-4 -148 -44 -44 -25 64 -29 65 -56 22 -71 -116 -109 -149 -153 -132 -34 13
-41 34 -28 95 8 43 4 92 -10 108 -14 17 -30 114 -36 216 -6 101 -15 213 -21
247 -6 34 -12 134 -14 222 l-4 159 -123 -16 c-109 -14 -128 -10 -163 40 -86
123 -25 184 109 110z m5759 -51 c25 9 43 5 43 -11 0 -16 -15 -28 -33 -28 -61
0 -105 -119 -74 -201 15 -40 22 -96 14 -124 -14 -54 75 -75 106 -25 22 37 55
30 72 -15 9 -23 -6 -63 -35 -94 -28 -29 -66 -76 -86 -103 -29 -41 -42 -44 -67
-19 -25 24 -25 38 -2 61 42 42 37 73 -11 65 -66 -12 -112 160 -95 353 21 233
30 252 82 182 29 -38 58 -52 86 -41z m364 -1 c5 -42 24 -84 44 -95 48 -28 44
-76 -12 -146 -65 -80 -128 -28 -128 105 0 52 -11 102 -25 111 -14 8 -25 38
-25 65 0 91 135 53 146 -40z m-739 47 c24 -24 -9 -85 -47 -85 -19 0 -35 23
-35 50 0 47 49 68 82 35z m1837 -31 c41 -26 131 -202 131 -256 0 -85 -71 -111
-136 -49 -75 70 -124 45 -105 -52 18 -90 -44 -98 -143 -20 -95 74 -70 248 36
248 13 0 23 26 23 58 0 32 8 66 17 75 23 23 139 21 177 -4z m1801 -54 c82 0
156 -84 113 -127 -48 -48 -206 6 -245 84 -51 102 -48 135 8 84 25 -22 81 -41
124 -41z m-10436 -25 c34 -32 -6 -75 -70 -75 -67 0 -126 60 -101 101 18 29
132 12 171 -26z m3681 -78 c2 -48 15 -109 29 -136 19 -36 18 -66 -5 -109 l-32
-59 -37 75 c-24 47 -30 90 -17 114 15 25 9 42 -16 52 -45 17 -49 94 -7 136 49
49 82 20 85 -73z m12433 67 c53 -48 244 -111 297 -99 62 15 124 -31 89 -66
-51 -51 -233 -48 -261 4 -18 34 -53 47 -125 47 -103 0 -142 39 -114 113 18 47
63 47 114 1z m2177 -114 c0 -117 -8 -150 -37 -150 -21 0 -38 -22 -38 -51 0
-62 -101 -105 -224 -94 -88 7 -89 6 -96 -99 -6 -83 1 -106 32 -106 42 0 88
-94 88 -182 0 -29 30 -84 66 -121 72 -76 66 -143 -16 -165 -66 -17 -38 -57 39
-57 72 0 87 -98 22 -151 -23 -19 -34 -54 -26 -84 7 -29 -5 -71 -29 -97 -40
-44 -40 -49 0 -71 32 -18 39 -43 27 -104 -20 -102 -47 -119 -137 -88 -74 26
-79 37 -72 152 4 48 -19 94 -72 149 -96 98 -97 119 -2 119 85 0 93 25 35 113
-53 81 -100 78 -129 -7 l-23 -68 -38 72 -38 72 -18 -72 c-35 -140 -164 -205
-164 -83 0 26 -33 71 -73 100 -40 30 -93 95 -118 145 -87 171 -184 205 -184
63 0 -108 -54 -105 -76 5 -9 40 -36 105 -61 143 -42 65 -47 66 -91 26 -45 -40
-47 -38 -47 28 0 57 9 67 50 56 65 -17 94 31 41 70 -22 16 -41 42 -41 57 0 32
268 162 425 205 62 17 135 40 163 52 136 59 195 73 221 51 16 -13 74 -27 129
-32 93 -8 100 -4 107 60 8 62 18 69 104 69 62 0 101 -13 110 -37 8 -21 32 -38
53 -38 55 0 47 42 -12 57 -27 7 -50 32 -50 56 0 23 23 48 50 55 32 8 50 34 50
72 0 43 14 60 50 60 44 0 50 -17 50 -150z m-12741 34 c42 -88 42 -92 -10 -148
-55 -58 -132 -95 -255 -122 -38 -8 -69 -32 -69 -52 0 -20 -17 -37 -37 -37 -46
0 -50 65 -7 93 50 31 119 180 119 255 0 90 15 102 125 102 80 0 96 -11 134
-91z m3579 66 c27 -45 -65 -58 -108 -16 -38 38 -36 41 26 41 36 0 73 -11 82
-25z m-13338 -48 c0 -13 -22 -30 -48 -39 -61 -19 -181 10 -163 40 19 29 211
28 211 -1z m20066 -33 c-9 -31 -15 -76 -16 -100 0 -24 -17 -44 -37 -44 -39 0
-51 86 -23 160 25 65 94 50 76 -16z m-9447 -19 c116 -71 281 -95 281 -41 0 55
146 57 167 2 19 -52 -72 -173 -132 -176 -93 -5 -107 -11 -184 -76 -91 -76
-113 -68 -77 27 36 94 -5 164 -97 164 -75 0 -111 47 -86 113 19 48 30 47 128
-13z m-5523 -60 c10 -87 -33 -120 -112 -84 -121 55 -103 177 25 164 66 -6 80
-19 87 -80z m10065 56 c69 -31 86 -107 29 -129 -61 -24 -133 10 -167 79 l-34
67 -9 -88 c-11 -108 -35 -135 -102 -113 -57 18 -74 113 -21 113 18 0 51 23 75
50 48 56 135 64 229 21z m-14356 -158 c53 -62 55 -110 7 -174 -20 -27 -37 -89
-38 -138 -1 -98 -100 -244 -146 -215 -38 23 -34 114 10 189 19 34 36 87 36
118 1 30 19 65 42 77 61 35 26 145 -53 165 -46 12 -63 33 -63 79 l0 62 80 -57
c45 -31 100 -79 125 -106z m20155 85 c-40 -45 -110 -66 -110 -33 0 27 112 106
133 93 11 -7 1 -34 -23 -60z m-12049 10 c18 -48 -24 -82 -103 -83 -79 0 -93
40 -28 86 72 50 111 49 131 -3z m8389 -48 c18 -103 78 -179 158 -199 38 -9 66
-25 62 -35 -18 -44 -276 -251 -313 -251 -22 0 -60 -18 -84 -39 -33 -30 -71
-36 -159 -22 -149 22 -122 59 113 151 192 75 254 125 188 150 -51 20 -60 346
-9 329 17 -6 37 -43 44 -84z m-15100 -59 c0 -124 -30 -178 -67 -120 -28 44
-28 175 0 213 45 60 67 30 67 -93z m15686 93 c5 -17 17 -62 25 -99 9 -42 27
-63 47 -56 40 15 217 -56 217 -88 0 -26 -236 -60 -327 -47 -49 7 -62 25 -69
96 -4 48 -26 108 -49 133 -35 39 -36 48 -4 68 53 34 149 29 160 -7z m-7586
-31 c0 -21 -22 -38 -49 -38 -26 0 -55 -11 -63 -25 -27 -43 -88 -27 -88 23 0
54 32 72 131 75 46 1 69 -11 69 -35z m10950 13 c0 -37 -227 -201 -279 -201
-60 0 -60 67 0 86 25 8 72 43 104 77 57 60 175 86 175 38z m-14921 -36 c89
-38 189 -131 165 -154 -55 -56 -313 78 -286 148 19 50 16 49 121 6z m1071 -34
c-1 -98 -42 -156 -75 -106 -45 70 -30 175 25 175 38 0 50 -17 50 -69z m2555 3
c52 -36 95 -86 95 -111 0 -26 25 -69 55 -97 46 -43 48 -51 12 -51 -23 0 -42
11 -42 25 0 14 -27 25 -59 25 -33 0 -74 17 -91 38 -36 43 -75 49 -75 11 0 -14
25 -35 56 -47 31 -12 90 -62 131 -112 82 -98 124 -112 148 -49 15 38 19 38 61
0 77 -70 100 -51 71 57 -26 96 1 177 59 177 44 0 102 -85 90 -130 -8 -32 13
-70 63 -115 68 -61 73 -75 58 -184 l-16 -118 80 30 c47 17 106 70 142 126 74
117 150 111 276 -22 101 -107 102 -147 5 -187 -68 -28 -82 -26 -133 22 -67 62
-130 68 -160 14 -12 -21 -62 -41 -113 -44 -51 -3 -106 -20 -123 -37 -24 -24
-42 -16 -84 36 -42 54 -76 68 -169 72 -122 5 -181 37 -204 110 -26 83 -122
104 -223 50 -129 -69 -165 -63 -165 28 0 45 -10 71 -25 61 -14 -8 -19 -41 -11
-72 22 -88 -47 -132 -126 -80 -79 51 -79 71 0 155 34 37 62 95 62 128 0 39 17
66 47 74 26 7 78 73 115 148 80 157 71 154 193 69z m4760 22 c15 -10 34 -78
43 -150 13 -120 10 -131 -37 -131 -127 0 -259 186 -191 269 28 34 141 41 185
12z m4919 -8 c78 -22 93 -36 83 -76 -10 -37 4 -56 53 -75 62 -24 205 -162 205
-198 0 -10 -17 -32 -38 -49 -32 -27 -58 -15 -163 73 -88 75 -124 93 -124 64 0
-56 -109 -39 -120 19 -6 31 7 44 43 44 77 0 63 39 -35 97 -162 95 -103 156 96
101z m-7359 -72 c0 -93 -27 -109 -98 -60 -52 37 -53 41 -12 87 64 70 110 59
110 -27z m-8365 9 c20 -53 -3 -85 -61 -85 -49 0 -110 81 -81 109 31 31 127 15
142 -24z m3692 14 c86 -46 30 -159 -121 -243 -74 -41 -81 -40 -81 19 0 39 17
50 75 50 74 0 99 32 50 63 -33 20 -32 137 2 137 14 0 48 -12 75 -26z m6779
-34 c75 -17 92 -76 29 -100 -63 -24 -104 -18 -143 22 -44 43 -27 152 17 117
16 -12 59 -29 97 -39z m-9263 -98 c-25 -75 -92 -77 -167 -5 -81 77 -76 103 24
119 65 10 159 -65 143 -114z m3745 83 c27 -45 -15 -125 -65 -125 -55 0 -86 55
-64 113 16 42 105 50 129 12z m-8317 -41 c-13 -62 -88 -102 -124 -66 -23 23
-23 39 2 68 44 53 132 51 122 -2z m11529 27 c0 -55 -59 -112 -102 -98 -39 13
-51 1 -64 -61 -21 -108 -95 -100 -156 17 -43 81 -13 111 104 102 64 -5 106 4
112 23 10 30 106 45 106 17z m-10475 -61 c0 -33 -17 -50 -49 -50 -67 0 -86 42
-33 73 65 38 82 33 82 -23z m6173 15 c37 -45 123 -67 142 -36 18 30 85 -23 85
-68 0 -49 -47 -69 -85 -38 -41 34 -115 9 -115 -38 0 -23 29 -35 88 -35 61 0
87 -11 87 -37 0 -24 -23 -38 -61 -38 -75 0 -109 -45 -47 -64 195 -59 215 -111
70 -184 -63 -31 -110 -69 -105 -85 12 -37 163 -69 247 -52 67 13 120 -56 85
-112 -27 -45 -137 -48 -151 -3 -10 31 -43 43 -125 44 -60 1 -125 14 -143 30
-140 122 -306 201 -424 201 -83 0 -158 19 -229 58 -57 33 -120 54 -139 47 -46
-15 -77 41 -78 141 0 104 83 105 95 0 6 -50 19 -63 54 -54 25 7 53 0 62 -15
28 -44 84 -31 102 24 13 42 23 46 53 21 25 -21 28 -38 10 -56 -44 -44 -29 -66
48 -66 40 0 83 16 94 36 16 30 39 31 120 10 245 -64 262 -61 262 37 0 62 -16
100 -52 125 -35 25 -43 42 -23 55 19 11 24 49 14 102 -17 88 9 110 59 50z
m1272 16 c-6 -10 -30 -63 -55 -118 -25 -55 -54 -106 -64 -113 -10 -7 -31 -35
-46 -62 l-28 -50 -1 50 c-1 91 51 237 85 237 19 0 40 17 48 38 8 20 27 37 42
37 16 0 24 -8 19 -19z m-7019 -96 c27 -81 37 -89 101 -76 93 19 107 -10 70
-140 -19 -65 -34 -90 -41 -63 -11 52 -34 56 -78 13 -25 -25 -41 -19 -79 31
-26 34 -69 91 -95 126 -44 56 -65 125 -57 180 2 11 36 19 76 19 62 0 78 -14
103 -90z m3227 8 c-40 -40 -36 -52 51 -143 75 -79 77 -84 31 -115 -26 -18 -65
-50 -87 -71 -54 -53 -160 -62 -160 -14 0 22 27 41 68 45 38 5 69 24 69 42 0
63 -30 113 -68 113 -24 0 -32 14 -22 40 8 21 15 66 15 98 0 42 16 61 56 67 65
9 88 -21 47 -62z m13847 20 c0 -39 -14 -63 -37 -63 -41 0 -47 23 -23 85 24 61
60 47 60 -22z m-9726 1 c48 -58 5 -100 -51 -50 -26 24 -41 52 -33 64 19 32 50
27 84 -14z m9925 -12 c33 -62 34 -302 1 -302 -25 0 -35 34 -27 95 3 18 -18 70
-47 115 -28 46 -51 96 -51 112 0 47 96 31 124 -20z m1576 -8 c0 -89 -132 -228
-197 -208 -29 10 -53 38 -53 64 0 26 -11 54 -25 63 -83 51 32 131 194 135 68
2 81 -7 81 -54z m-18232 -275 c-5 -59 -9 -11 -9 106 0 117 4 165 9 106 6 -58
6 -154 0 -212z m19706 258 c36 -68 6 -127 -64 -127 -62 0 -70 22 -44 119 18
69 73 73 108 8z m-18279 -22 c37 -24 88 -56 114 -69 28 -15 75 -109 118 -237
87 -256 87 -254 17 -244 -47 6 -58 25 -64 115 -6 74 -21 112 -50 123 -23 8
-69 38 -101 67 -54 49 -59 49 -82 8 -25 -44 -130 -39 -183 10 -36 33 -88 26
-131 -17 -45 -44 -95 -36 -95 16 0 20 25 39 56 43 36 6 56 26 56 58 0 26 20
54 44 61 24 8 83 35 131 61 108 59 90 58 170 5z m-3118 -69 c10 -41 24 -134
32 -207 14 -134 14 -134 -41 -97 -88 58 -122 415 -37 387 16 -6 37 -43 46 -83z
m3623 52 c17 -21 45 -38 63 -38 17 0 58 -22 90 -49 l60 -48 -82 -75 c-77 -71
-110 -178 -56 -178 14 0 25 11 25 24 0 34 146 107 176 88 59 -36 23 -107 -63
-123 -51 -9 -88 -31 -88 -51 0 -59 -53 -71 -67 -16 -11 42 -33 53 -111 53
-109 0 -113 9 -57 123 38 76 37 143 -3 271 -21 67 61 81 113 19z m1975 -93 c0
-33 19 -45 75 -45 91 0 103 -72 25 -150 -64 -64 -84 -63 -156 6 -115 112 -176
253 -129 301 29 29 185 -65 185 -112z m13912 51 c80 -15 106 -153 41 -218 -30
-30 -53 -85 -53 -128 0 -41 -4 -75 -9 -75 -5 0 -44 12 -88 28 -60 21 -88 20
-117 -4 -30 -25 -44 -25 -68 -1 -24 24 -20 39 20 69 47 36 45 37 -29 21 -100
-20 -124 16 -68 101 35 53 38 80 16 137 -32 86 -22 99 78 99 43 1 94 11 114
24 25 16 50 12 75 -10 21 -19 61 -38 88 -43z m-19992 -52 c9 -73 -21 -85 -139
-53 -108 29 -24 143 94 126 21 -3 41 -36 45 -73z m6813 44 c-8 -51 -83 -78
-107 -39 -13 20 -17 46 -9 57 18 30 122 13 116 -18z m4929 -5 c107 -51 116
-121 19 -141 -38 -8 -91 -31 -118 -51 l-50 -38 50 -37 c47 -36 47 -40 7 -81
-41 -42 -44 -41 -61 4 -10 27 -35 65 -54 84 -31 31 -30 40 5 66 51 37 50 51
-10 136 -74 104 46 137 212 58z m-10437 -172 c0 -60 19 -108 60 -148 70 -70
59 -93 -32 -72 -103 25 -132 59 -115 136 12 53 4 76 -33 96 -63 33 -91 105
-51 129 65 41 171 -47 171 -141z m7463 138 c18 -29 -49 -187 -89 -212 -49 -30
-68 14 -40 94 49 140 92 179 129 118z m10472 -14 c18 -48 -4 -92 -37 -71 -29
18 -30 111 -1 111 13 0 30 -18 38 -40z m-3433 -125 l61 -64 -75 8 c-56 6 -78
23 -83 65 -11 74 22 71 97 -9z m3195 -69 c43 -126 14 -157 -107 -113 -108 39
-110 54 -21 159 77 91 83 89 128 -46z m3011 36 c36 -54 97 -113 135 -132 38
-18 73 -55 77 -83 4 -27 44 -75 90 -107 63 -43 80 -70 72 -115 -7 -33 1 -67
16 -76 41 -26 32 -107 -14 -124 -52 -20 -109 27 -109 91 0 27 -32 90 -71 140
-40 51 -84 115 -99 143 -14 28 -66 72 -114 98 -64 35 -91 69 -103 131 -30 158
27 174 120 34z m-5677 31 c32 -19 21 -77 -22 -120 -48 -49 -298 -30 -358 27
-42 40 -45 38 99 89 99 36 225 37 281 4z m-5493 -33 c0 -54 -98 -47 -109 8 -6
36 5 44 50 38 32 -5 59 -25 59 -46z m3717 -75 c-4 -59 -28 -138 -55 -175 -39
-54 -52 -130 -65 -378 -11 -216 -28 -322 -53 -351 -44 -52 -47 -1217 -4 -1383
15 -55 30 -170 33 -256 6 -146 39 -245 208 -631 79 -180 537 -726 609 -726 11
0 65 -42 119 -94 144 -136 270 -233 370 -287 49 -26 118 -76 154 -111 102 -98
251 -158 322 -131 33 13 85 22 115 21 l55 -1 -57 -28 c-96 -46 -39 -93 114
-94 80 0 249 91 265 143 11 35 42 45 147 45 72 0 148 14 169 31 20 17 63 52
96 77 l60 45 -56 52 -56 52 59 128 c42 91 69 123 98 114 22 -7 61 11 88 41 47
52 47 53 -9 91 -70 46 -75 131 -7 131 26 0 56 -12 65 -27 47 -76 286 39 286
137 0 84 89 207 164 226 90 22 211 -28 211 -88 0 -48 82 -108 109 -80 9 8 16
41 16 73 0 32 21 72 47 88 37 23 44 50 35 120 -9 64 0 100 28 124 61 50 49
108 -49 236 -128 168 -117 278 27 280 190 3 213 10 242 74 65 142 146 -1 84
-150 -21 -52 -46 -172 -55 -266 -9 -95 -25 -172 -37 -172 -30 0 -84 -201 -75
-283 9 -93 -56 -141 -165 -124 -91 15 -102 -4 -42 -70 24 -28 33 -64 23 -96
-19 -60 -83 -69 -104 -14 -22 57 -65 44 -46 -14 17 -54 -24 -124 -72 -124 -96
2 -108 108 -16 132 33 9 43 28 33 66 -18 69 -119 94 -172 42 -22 -22 -55 -40
-74 -40 -38 0 -137 -96 -137 -132 0 -14 41 -16 94 -6 76 14 88 11 62 -15 -52
-53 -35 -79 42 -64 76 16 102 -13 102 -109 0 -33 -12 -43 -39 -33 -31 12 -35
2 -22 -52 17 -64 13 -67 -67 -60 -71 7 -84 18 -79 65 4 31 -5 56 -18 56 -14 0
-48 23 -77 52 -60 60 -123 47 -123 -25 0 -27 -11 -56 -25 -64 -40 -25 -29 -88
16 -88 22 0 79 -24 126 -53 79 -48 82 -56 47 -96 -44 -48 -29 -76 40 -76 71 0
55 -37 -49 -109 -119 -83 -145 -83 -189 1 -31 61 -30 75 13 133 58 79 40 140
-47 162 -84 21 -98 3 -129 -162 -20 -112 -18 -143 11 -165 62 -48 40 -72 -65
-72 -137 0 -213 -103 -138 -187 93 -102 422 -52 489 74 32 59 50 62 113 15 40
-29 43 -41 14 -75 -71 -85 90 -44 184 48 65 63 113 87 171 87 93 1 156 33 134
69 -26 42 -220 54 -322 19 -102 -35 -97 1 12 82 24 18 51 77 59 130 18 109 88
189 147 166 51 -19 48 -47 -12 -116 -56 -64 -67 -175 -18 -175 64 0 143 78
143 141 0 43 17 68 50 77 62 16 71 132 10 132 -29 0 -35 12 -21 44 11 24 21
75 24 113 2 38 33 100 68 137 35 38 68 91 73 118 5 28 26 53 46 57 30 6 38
-25 38 -160 0 -112 10 -171 31 -178 17 -5 31 -49 31 -97 0 -116 32 -171 124
-209 94 -39 97 -69 7 -89 -110 -24 -313 -135 -384 -210 -36 -38 -95 -76 -133
-86 -88 -22 -68 -79 25 -72 70 5 110 -26 111 -85 0 -38 -178 -207 -218 -208
-17 0 -41 -20 -54 -44 -20 -38 -72 -45 -407 -51 -396 -9 -482 -29 -356 -85 40
-17 81 -43 90 -57 10 -14 47 -25 81 -25 113 0 79 -49 -47 -67 -131 -19 -214 7
-214 67 0 75 -38 34 -44 -48 -3 -50 9 -97 32 -115 40 -34 50 -114 16 -135 -49
-31 -133 136 -126 252 8 131 -77 233 -194 233 -35 0 -99 25 -143 56 -79 57
-378 85 -407 38 -25 -40 -118 -17 -174 44 -72 78 -135 81 -135 6 -1 -63 -49
-158 -50 -97 0 44 -109 146 -168 158 -29 6 -42 29 -39 64 7 62 -68 114 -129
91 -28 -11 -47 6 -67 62 -17 50 -49 84 -88 94 -77 19 -113 83 -80 143 33 58 8
82 -42 41 -30 -25 -46 -26 -68 -4 -16 16 -53 29 -83 29 -30 0 -69 17 -86 38
-17 20 -49 37 -72 37 -22 1 -68 29 -101 64 l-60 64 69 -17 c47 -12 76 -7 91
17 35 54 28 71 -39 97 -35 13 -63 36 -63 50 0 15 -26 9 -59 -12 -103 -68 -283
41 -309 187 -4 21 -23 122 -43 225 -21 103 -37 190 -38 194 -5 32 -51 -6 -51
-42 0 -33 -29 -59 -87 -80 -59 -21 -80 -40 -63 -57 29 -29 34 -90 6 -89 -10 0
-52 29 -93 63 -70 58 -72 65 -32 96 87 66 4 156 -115 126 -46 -11 -81 4 -145
63 l-83 79 106 -16 c100 -15 144 12 81 51 -48 29 -24 62 47 62 59 0 81 -19
131 -112 66 -125 106 -140 149 -59 25 46 22 60 -18 86 -100 67 -268 202 -362
291 -54 52 -114 94 -133 94 -19 0 -69 41 -113 90 -43 50 -86 84 -94 76 -7 -8
-58 20 -112 63 -87 69 -101 73 -140 40 -75 -66 -168 -74 -218 -19 -25 28 -67
50 -93 50 -28 0 -54 22 -62 50 -21 80 -57 58 -57 -36 0 -67 12 -90 56 -103 78
-25 120 -88 92 -140 -18 -33 -7 -47 52 -67 41 -15 75 -38 75 -53 0 -14 34 -26
75 -26 86 0 92 15 34 79 -34 37 -35 46 -6 46 55 0 227 -152 212 -189 -24 -63
43 -186 102 -186 30 0 62 -11 71 -25 28 -46 64 -26 91 50 16 47 43 75 72 75
73 0 83 -48 16 -73 -38 -15 -78 -64 -106 -132 l-45 -109 -54 54 c-30 30 -62
73 -70 95 -26 67 -63 45 -72 -41 -8 -86 -41 -99 -82 -34 -18 28 -13 51 16 80
59 59 -85 272 -158 233 -28 -15 -63 -16 -90 -2 -24 12 -73 29 -109 38 -59 14
-64 9 -53 -47 13 -68 -33 -83 -118 -37 -33 17 -67 14 -118 -13 -39 -20 -87
-37 -108 -38 -21 0 -59 -17 -86 -37 -61 -47 -139 -48 -139 -3 0 19 -17 49 -37
66 -21 17 -38 41 -38 53 0 30 143 28 163 -3 24 -40 55 -29 69 26 11 39 -5 58
-72 86 -78 33 -107 82 -70 120 16 16 117 -34 243 -118 57 -38 75 -41 92 -15
13 22 46 28 97 18 88 -18 114 10 92 97 -11 44 -32 61 -77 61 -63 0 -83 34 -37
62 28 18 -126 181 -232 247 -55 34 -67 56 -54 99 27 89 45 94 169 52 146 -50
258 -2 228 98 -23 79 -83 167 -113 167 -49 0 -119 89 -127 163 -7 64 -21 76
-94 87 -96 14 -130 66 -60 91 82 30 111 63 83 97 -18 21 -18 52 -1 98 32 82
82 60 60 -27 -12 -49 -4 -65 38 -76 38 -10 53 -34 53 -82 0 -52 47 -119 189
-266 104 -109 195 -228 203 -265 7 -37 34 -86 60 -109 32 -29 41 -62 32 -111
-19 -93 21 -111 103 -46 l67 53 64 -68 c39 -42 80 -64 108 -56 32 8 50 -7 61
-52 20 -81 109 -154 188 -155 60 -1 59 2 -31 82 -155 138 -89 168 95 44 87
-59 113 -67 135 -40 34 40 -120 202 -230 242 -93 35 -95 108 -3 85 75 -19 110
15 91 89 -9 33 -35 47 -87 47 -54 0 -78 14 -88 50 -8 30 -34 50 -66 50 -78 1
-122 37 -112 90 10 52 121 82 121 33 0 -32 72 -96 109 -97 12 -1 8 16 -8 36
-25 29 -21 49 22 103 28 37 52 91 52 120 0 29 23 67 50 84 44 28 50 25 50 -25
1 -80 38 -129 85 -111 44 17 32 358 -17 453 -18 35 -15 55 14 75 33 25 32 35
-11 88 -51 62 -50 81 10 296 28 97 37 106 92 92 53 -13 56 -10 29 24 -21 25
-27 69 -17 124 14 72 6 97 -49 152 -48 47 -62 82 -51 124 9 36 0 70 -23 89
-95 79 67 286 212 271 81 -9 126 20 126 79 0 49 69 104 113 90 13 -4 21 -56
17 -115z m3025 99 c80 2 116 -43 53 -66 -25 -9 -55 -32 -66 -52 -18 -28 -27
-27 -54 10 -32 43 -38 43 -145 -10 -127 -64 -200 -71 -239 -23 -33 39 102 155
156 134 18 -7 48 -2 67 11 20 13 64 17 98 9 34 -8 93 -14 130 -13z m2725 -63
c23 -50 23 -69 -1 -84 -28 -17 -34 -98 -32 -389 1 -42 8 -121 17 -177 18 -119
-28 -181 -106 -139 -25 13 -65 30 -89 38 -24 7 -44 36 -44 64 0 28 -10 51 -23
51 -26 0 -92 172 -112 293 -13 79 -12 80 67 65 l81 -16 -50 56 c-33 38 -40 60
-20 73 15 9 36 49 46 87 14 59 27 68 76 56 42 -10 65 -1 85 36 36 68 70 63
105 -14z m-11355 1 c0 -21 27 -49 60 -61 34 -13 68 -47 78 -77 9 -29 52 -68
96 -87 103 -43 210 -158 220 -237 12 -90 109 -100 131 -14 17 68 62 82 109 35
21 -21 32 -12 44 37 20 79 137 168 137 104 0 -88 -73 -176 -184 -222 -81 -33
-120 -67 -138 -118 -16 -46 -43 -72 -74 -72 -26 0 -62 -17 -79 -37 -51 -62
-112 -44 -191 56 -101 126 -115 174 -83 271 32 97 -2 185 -71 185 -67 -1 -256
-73 -297 -113 -20 -20 -70 -37 -110 -37 -101 0 -95 65 10 109 82 34 217 144
217 176 0 31 80 140 103 140 12 0 22 -17 22 -38z m-7944 -82 c-6 -85 23 -114
118 -116 39 -1 66 -18 71 -45 7 -36 -4 -41 -63 -29 -144 29 -173 -148 -43
-261 84 -73 87 -211 5 -199 -33 4 -70 38 -91 83 -20 41 -47 82 -61 91 -26 17
-27 445 -2 529 23 72 73 32 66 -53z m2315 36 c13 -69 -31 -101 -93 -67 -59 31
-70 90 -22 110 56 23 106 4 115 -43z m18971 19 c18 -46 -43 -94 -76 -61 -28
28 -3 101 34 101 15 0 33 -18 42 -40z m-13957 -6 c25 -40 -16 -129 -60 -129
-49 0 -75 -48 -75 -138 0 -66 -38 -102 -63 -61 -9 15 -44 37 -77 50 -81 31
-76 56 30 162 111 112 217 162 245 116z m-8142 -326 c-19 -22 -54 -82 -77
-133 -41 -90 -41 -93 22 -160 125 -136 99 -260 -56 -260 -32 0 -65 -16 -72
-36 -15 -38 -171 -28 -226 15 -15 12 -46 15 -68 6 -28 -10 -41 -2 -41 25 0 23
-28 52 -62 65 -118 45 -63 64 185 63 136 0 254 6 262 14 8 8 2 79 -14 158 -21
107 -21 150 0 171 34 34 39 119 7 119 -12 0 -28 32 -36 72 -9 44 -34 77 -66
85 -28 7 -51 26 -51 41 0 48 132 29 192 -27 l58 -54 31 85 32 86 7 -147 c5
-98 -4 -160 -27 -188z m2542 307 c40 -15 57 -86 21 -84 -26 1 -106 64 -106 83
0 20 34 20 85 1z m-3188 -62 c75 -36 103 -62 93 -89 -8 -21 -15 -48 -15 -61 0
-81 -154 39 -186 146 -21 68 -23 68 108 4z m11741 12 c63 -41 83 -119 38 -147
-13 -8 -39 8 -56 36 -36 58 -95 68 -95 16 0 -19 -20 -59 -44 -88 -41 -50 -47
-51 -100 -14 -108 76 -63 197 82 219 41 6 83 12 94 14 11 2 47 -14 81 -36z
m6512 -59 c0 -58 -32 -81 -85 -61 -67 26 -50 110 23 110 45 0 62 -13 62 -49z
m-16064 -22 c17 -52 -5 -129 -36 -129 -31 0 -103 124 -87 151 26 41 108 26
123 -22z m3264 12 c0 -19 -17 -49 -39 -67 -47 -39 -100 3 -78 62 19 48 117 52
117 5z m-4475 -27 c0 -61 56 -164 89 -164 37 0 111 -109 111 -164 0 -34 -16
-39 -87 -25 -82 15 -88 12 -88 -48 0 -77 62 -108 131 -65 56 35 51 39 93 -68
20 -50 49 -80 73 -77 61 7 128 -29 128 -68 0 -19 -12 -35 -27 -35 -15 0 -23
-27 -19 -59 4 -32 -6 -76 -24 -97 -26 -32 -19 -49 46 -103 85 -72 79 -116 -16
-116 -70 0 -235 161 -235 229 0 23 -38 74 -85 113 -83 69 -140 202 -140 327 0
31 -23 79 -51 107 -37 37 -46 67 -34 107 19 55 29 120 33 198 2 53 102 61 102
8z m5715 7 c11 -18 -12 -56 -56 -94 -40 -36 -93 -96 -117 -134 -51 -81 -92
-69 -92 27 0 112 218 277 265 201z m12470 -10 c10 -28 41 -38 102 -32 97 8
152 -30 130 -90 -32 -83 -289 21 -291 117 -1 55 38 58 59 5z m485 -7 c7 -23
-10 -30 -59 -25 -38 5 -75 23 -81 42 -7 23 10 30 59 25 38 -5 75 -23 81 -42z
m-12460 -99 c25 -51 85 -171 131 -267 118 -243 122 -249 168 -259 62 -12 80
70 33 152 -46 81 -56 194 -17 194 14 0 25 -11 25 -24 0 -14 35 -43 78 -65 72
-37 77 -47 62 -137 -8 -55 -4 -103 10 -111 32 -21 33 -155 0 -175 -30 -19
-314 81 -347 121 -12 16 -39 79 -60 141 -22 66 -60 124 -93 141 -82 42 -99 81
-100 224 0 188 36 210 110 65z m4104 68 c9 -15 -1 -46 -24 -68 -37 -38 -40
-35 -40 27 0 69 33 90 64 41z m2474 -53 c0 -36 8 -74 18 -84 35 -35 20 -86
-25 -86 -24 0 -71 41 -105 90 -60 89 -60 91 -13 126 70 51 125 32 125 -46z
m5016 39 c25 -23 46 -56 46 -73 0 -52 -79 -65 -129 -20 -53 48 -60 99 -15 117
48 20 50 20 98 -24z m4303 -72 c52 -59 92 -83 121 -73 69 21 148 -110 87 -144
-40 -23 -41 -28 -3 -70 27 -30 32 -51 15 -61 -58 -36 -30 -191 48 -264 52 -48
75 -94 75 -147 0 -86 71 -141 151 -115 37 12 49 4 49 -33 0 -28 22 -55 50 -62
27 -7 50 -31 50 -53 0 -22 -23 -62 -50 -90 -27 -27 -39 -50 -25 -50 14 0 25
-17 25 -37 0 -60 -116 -46 -162 18 -21 31 -63 57 -91 57 -38 0 -74 40 -132
148 -44 81 -105 159 -135 172 -56 25 -72 117 -57 334 4 60 -7 82 -46 95 -42
13 -52 37 -52 121 0 62 -20 135 -50 180 -111 168 -5 228 132 74z m-16857 5 c0
-32 52 -127 115 -212 124 -167 139 -248 27 -144 -71 65 -200 87 -229 39 -26
-41 -109 -29 -135 19 -16 31 -13 59 12 92 19 27 35 69 35 94 0 69 46 54 55
-18 8 -71 56 -85 60 -18 1 24 4 80 6 125 4 91 54 113 54 23z m-339 11 c16 -27
-56 -92 -77 -70 -21 21 9 92 39 92 13 0 30 -10 38 -22z m11479 -54 c64 -45 96
-209 49 -248 -43 -35 -289 206 -289 284 0 26 194 -3 240 -36z m2380 -45 c6
-36 -5 -54 -31 -54 -25 0 -39 23 -39 65 0 78 59 69 70 -11z m-8746 10 c39 -48
-11 -145 -69 -134 -53 10 -69 86 -29 134 38 45 60 45 98 0z m10026 -83 c0 -31
-15 -56 -33 -56 -55 0 -64 25 -37 105 29 82 69 55 70 -49z m-16263 70 c18 -29
-65 -76 -134 -76 -56 0 -89 37 -65 75 19 32 179 33 199 1z m6836 -69 c28 -101
8 -142 -61 -128 -78 15 -101 83 -53 156 57 88 84 82 114 -28z m9661 40 c38
-44 40 -57 12 -75 -52 -33 -83 -12 -91 61 -10 81 18 86 79 14z m-14359 -12 c0
-85 103 -190 172 -177 l65 12 -59 -47 c-71 -58 -95 -59 -215 -9 -51 21 -96 35
-99 31 -3 -4 -17 -61 -31 -126 -24 -110 -22 -121 32 -156 76 -50 109 -48 171
10 99 92 168 88 255 -17 149 -181 116 -359 -59 -323 -38 8 -114 24 -169 35
-133 27 -137 92 -7 102 52 5 94 19 94 32 0 49 -85 55 -197 14 -141 -53 -178
-18 -239 227 -53 212 -51 236 42 340 90 101 244 134 244 52z m1549 -17 l55
-38 -53 -102 c-62 -122 -77 -125 -174 -34 -72 67 -86 98 -80 185 4 53 171 46
252 -11z m8014 5 c0 -20 19 -71 43 -115 l43 -79 -87 -51 c-61 -36 -87 -69 -87
-112 0 -68 -68 -108 -110 -65 -20 20 -7 45 45 90 53 46 64 70 43 91 -39 39
-35 121 12 215 39 80 97 95 98 26z m-14604 -102 c14 -68 21 -73 57 -43 38 31
40 26 24 -59 -15 -84 -12 -94 34 -94 62 0 67 -38 8 -61 -36 -14 -32 -25 32
-77 40 -33 87 -61 103 -61 38 -1 212 -102 246 -142 13 -16 47 -34 75 -38 76
-13 87 -194 12 -214 -79 -20 -53 -96 31 -87 72 7 194 -79 194 -138 0 -18 17
-40 38 -48 20 -8 37 -29 37 -48 0 -18 18 -44 41 -56 50 -28 24 -80 -40 -80
-48 0 -201 156 -201 205 0 55 -83 120 -154 120 -54 0 -71 12 -71 50 0 28 -11
50 -23 50 -13 0 -27 42 -32 94 -6 75 -17 93 -57 89 -27 -2 -91 34 -143 81 -52
47 -131 102 -176 124 -232 110 -240 119 -181 198 22 29 37 104 37 190 0 198
73 228 109 45z m3991 100 c0 -16 17 -49 38 -72 34 -37 34 -45 0 -73 -21 -18
-38 -53 -38 -79 0 -72 -95 -59 -131 18 -24 54 -23 69 11 87 22 12 47 51 55 85
16 63 65 89 65 34z m2211 -75 c67 -135 53 -213 -42 -227 -120 -18 -201 44
-187 141 7 52 -2 87 -29 108 -37 28 -37 30 3 31 24 1 44 -10 44 -23 0 -13 23
-36 50 -51 42 -23 55 -17 79 37 36 79 34 79 82 -16z m-2411 19 c0 -177 -368
-242 -725 -128 -62 20 -143 42 -181 50 -38 8 -69 25 -69 38 0 49 135 55 312
13 209 -49 540 -34 590 27 38 45 73 45 73 0z m8256 -33 c45 -41 50 -41 72 -1
18 32 37 37 80 21 31 -12 87 -16 124 -9 75 14 125 -69 116 -192 -3 -35 3 -95
14 -133 12 -45 7 -82 -15 -109 -27 -33 -26 -44 5 -68 65 -48 157 -263 128
-298 -14 -17 -29 -64 -34 -105 -6 -53 -23 -77 -58 -81 -61 -7 -179 205 -141
252 12 16 13 52 3 80 -19 49 -50 81 -231 246 -54 49 -69 85 -69 164 0 70 -11
101 -35 101 -61 0 -150 89 -132 134 20 54 113 53 173 -2z m5557 3 c71 -47 60
-85 -25 -85 -61 0 -89 39 -69 94 15 40 20 39 94 -9z m-19388 -19 c0 -50 -90
-122 -142 -112 -28 6 -48 35 -53 77 -8 65 -3 69 93 69 69 0 102 -11 102 -34z
m10320 -10 c-9 -49 -113 -73 -151 -35 -39 39 2 79 84 79 59 0 74 -10 67 -44z
m7620 8 c24 -62 -16 -97 -53 -47 -18 25 -27 54 -21 64 19 31 60 22 74 -17z
m3735 -28 c0 -76 41 -161 78 -161 14 0 76 -53 136 -119 122 -130 142 -223 65
-299 -25 -24 -64 -86 -88 -137 -23 -51 -53 -100 -67 -108 -30 -19 -32 -137 -2
-137 12 0 35 16 52 36 24 29 40 31 77 7 40 -24 66 -16 161 52 63 44 130 80
150 80 19 0 42 11 51 25 8 14 52 25 98 25 45 0 111 23 146 50 90 71 167 59 93
-15 -44 -44 -35 -346 11 -417 75 -114 -92 -122 -277 -13 -76 45 -98 48 -140
22 -43 -27 -62 -23 -122 22 -77 56 -172 37 -172 -34 0 -18 -24 -64 -54 -101
l-53 -68 -60 64 c-69 74 -103 80 -172 29 -41 -31 -44 -44 -17 -87 17 -28 31
-63 31 -78 0 -43 -128 -199 -163 -199 -47 0 -262 -327 -262 -398 0 -33 -20
-82 -44 -109 -29 -32 -42 -84 -39 -156 3 -71 -8 -113 -30 -121 -19 -7 -41 -51
-50 -98 -20 -108 -118 -168 -273 -168 -243 0 -324 -110 -128 -174 90 -30 410
-15 446 21 37 37 68 211 52 296 -10 59 0 98 38 147 29 37 53 87 53 111 0 25
34 79 75 120 41 41 75 87 75 102 0 15 29 27 65 27 78 0 69 59 -11 70 -30 5
-54 16 -54 25 0 37 240 255 281 255 31 0 50 25 61 78 11 57 37 87 98 112 109
46 133 44 119 -9 -6 -25 20 -76 61 -118 39 -42 84 -112 99 -158 28 -78 26 -82
-39 -95 -79 -16 -186 -103 -231 -188 -40 -75 -110 -125 -235 -168 -97 -34
-101 -33 -157 37 l-58 72 -49 -63 c-62 -79 -63 -141 -4 -178 30 -19 42 -49 35
-88 -8 -37 2 -64 26 -73 21 -8 45 -53 54 -100 9 -47 38 -97 65 -112 79 -42 57
-97 -60 -147 -146 -63 -189 -202 -63 -202 60 0 121 -70 159 -183 30 -86 29
-88 -44 -102 -130 -26 -164 -18 -173 41 -10 74 -136 137 -197 99 -33 -21 -51
-19 -74 9 -71 85 -125 29 -69 -72 17 -30 34 -103 38 -161 6 -90 26 -125 120
-215 87 -83 112 -125 112 -187 0 -113 -41 -104 -133 29 -20 28 -46 39 -74 28
-62 -24 -53 -84 18 -110 75 -29 122 -111 101 -177 -19 -60 -83 -61 -249 -4
-118 40 -124 47 -127 135 -2 76 7 94 56 106 68 17 70 49 10 152 -57 98 -105
94 -156 -13 -36 -77 -37 -93 -5 -128 32 -37 29 -43 -29 -57 -95 -24 -221 30
-270 116 -23 40 -65 80 -92 87 -57 15 -68 82 -14 82 55 0 114 72 114 140 0 95
-66 101 -143 13 -39 -45 -93 -78 -125 -78 -78 0 -71 -52 18 -137 41 -40 81
-109 90 -155 9 -46 34 -95 57 -108 63 -38 -32 -100 -154 -100 -84 0 -96 6 -80
44 58 138 29 194 -86 164 -57 -15 -71 -95 -21 -118 17 -8 3 -8 -31 0 -34 8
-92 35 -129 61 -64 45 -66 45 -110 -2 -24 -27 -59 -49 -77 -49 -39 0 -46 -90
-9 -112 70 -44 -47 -113 -195 -114 -75 0 -84 -5 -49 -26 62 -36 54 -73 -16
-73 -87 0 -181 -81 -136 -117 63 -53 268 -69 286 -23 8 22 35 40 60 40 24 0
58 17 75 38 40 48 100 48 100 -1 0 -21 16 -45 36 -52 48 -19 -28 -110 -92
-110 -50 0 -60 -74 -15 -119 22 -22 22 -38 -1 -65 -25 -30 -15 -41 58 -66 161
-53 100 -113 -87 -87 -116 16 -185 87 -84 87 59 0 27 61 -38 71 -36 5 -65 35
-82 83 -24 69 -34 74 -110 60 -48 -9 -103 -3 -131 14 -89 56 -351 -217 -278
-289 20 -19 47 -4 97 55 67 80 159 106 190 54 25 -39 -62 -123 -126 -123 -31
0 -71 -18 -89 -40 -30 -36 -82 -38 -198 -7 -26 6 -40 -13 -45 -60 -6 -51 -30
-78 -92 -104 -46 -19 -90 -57 -99 -84 -31 -99 -140 -97 -136 2 2 31 -5 91 -15
134 -16 69 -9 86 59 136 43 32 78 78 78 103 0 31 19 45 63 45 34 0 62 -11 62
-25 0 -14 28 -25 63 -25 68 0 84 43 25 66 -50 19 -50 172 1 214 92 77 136 132
136 172 0 23 17 56 37 73 22 18 32 53 25 84 -10 39 5 65 56 98 38 24 125 84
194 133 68 49 156 95 194 103 45 8 85 41 108 85 21 40 47 72 58 72 12 0 77 53
146 119 268 256 330 295 370 231 8 -14 31 -25 51 -25 44 0 48 103 6 145 -23
23 -23 37 0 60 17 17 30 55 30 86 0 31 11 63 25 72 14 8 25 41 25 73 0 74 50
116 117 98 78 -20 94 34 22 71 l-62 33 91 131 c65 94 92 160 95 237 4 90 22
124 118 219 106 105 115 125 132 281 10 92 11 186 2 208 -9 25 6 57 40 85 54
44 54 47 13 153 -26 65 -34 117 -20 131 33 33 77 -3 77 -63 0 -44 11 -49 78
-36 l78 16 -18 -106 c-11 -59 -18 -137 -16 -175 2 -38 -7 -69 -20 -69 -13 0
-23 -43 -23 -96 1 -53 -6 -131 -15 -173 -11 -48 -5 -101 15 -136 l31 -57 14
74 c9 49 31 78 64 84 73 13 93 40 114 159 10 59 26 130 35 158 11 36 0 56 -42
75 -45 19 -59 48 -65 131 -8 107 11 130 63 78 90 -90 139 63 61 191 -36 58
-40 85 -19 122 21 35 20 49 -4 58 -44 16 -40 157 4 157 19 0 42 -19 51 -42 31
-82 70 6 52 117 -15 88 -31 110 -103 140 -94 39 -104 63 -47 110 20 17 37 45
37 63 0 40 152 64 194 31 17 -14 31 -57 31 -97 0 -82 38 -97 57 -22 14 52 103
70 131 25 22 -37 87 -31 87 8 0 18 -28 57 -62 87 -35 30 -63 67 -63 82 0 15
-23 56 -50 91 -105 133 -46 227 144 230 71 2 81 -6 81 -62z m-12505 -114 c-4
-61 -18 -104 -32 -97 -13 7 -21 38 -17 69 5 37 -5 56 -32 56 -53 0 -50 66 5
97 63 36 85 0 76 -125z m-4745 66 c19 -51 41 -63 112 -63 86 0 88 -2 88 -102
0 -56 13 -125 28 -153 15 -29 27 -99 26 -155 -1 -56 15 -127 35 -158 38 -58
49 -158 17 -156 -10 0 -51 28 -91 60 -72 59 -72 61 -40 175 29 106 28 119 -14
150 -39 28 -41 40 -14 73 29 35 24 44 -32 65 -36 14 -65 41 -65 62 0 20 -35
70 -79 110 -51 48 -73 88 -63 114 23 59 65 49 92 -22z m15475 -51 c24 -29 40
-31 66 -9 49 40 182 -73 234 -197 14 -32 44 -64 68 -73 25 -9 87 -49 138 -89
52 -40 94 -62 94 -48 0 15 -11 33 -25 42 -39 24 -29 87 13 87 88 0 44 -193
-73 -317 -28 -31 -198 -5 -297 46 -27 14 -63 12 -94 -4 -43 -23 -49 -19 -49
35 0 41 18 67 53 78 43 14 50 30 37 94 -20 98 -25 103 -86 70 -86 -46 -129
-32 -145 47 -8 41 -31 88 -50 104 -18 15 -34 60 -34 100 0 82 93 103 150 34z
m-15680 -91 c-10 -106 -55 -115 -134 -29 l-65 70 58 17 c127 35 150 26 141
-58z m4830 -51 c0 -27 21 -77 48 -110 27 -34 42 -82 34 -110 -8 -33 0 -50 23
-50 54 0 73 29 43 64 -19 24 -12 36 25 48 66 21 102 -2 102 -63 0 -57 9 -59
72 -20 54 34 137 10 122 -35 -6 -17 -35 -35 -65 -39 -81 -12 -65 -55 21 -55
98 0 191 -88 149 -139 -57 -68 -224 -19 -224 66 0 13 -41 23 -91 23 -158 0
-287 51 -280 111 3 28 -24 99 -61 157 -79 123 -86 194 -25 229 54 30 107 -8
107 -77z m-5279 -22 c4 -47 24 -103 44 -125 40 -45 23 -73 -44 -73 -36 0 -46
20 -46 94 -1 51 -8 120 -17 153 -12 45 -7 57 19 48 20 -6 39 -50 44 -97z
m7802 79 c47 -30 1 -91 -83 -112 -40 -10 -63 -38 -74 -90 -16 -83 -44 -94
-100 -37 -55 55 -222 47 -293 -14 -34 -30 -79 -47 -108 -39 -26 7 -67 2 -91
-10 -70 -38 -148 62 -92 117 33 33 48 35 78 10 49 -40 131 -14 232 74 66 57
103 69 223 70 79 1 155 14 169 28 32 32 91 33 139 3z m1639 -46 c29 -65 58
-72 79 -18 8 20 30 37 49 37 52 0 42 -78 -11 -92 -35 -9 -45 -35 -44 -109 3
-108 -43 -137 -56 -36 -4 36 -24 71 -44 79 -23 9 -31 32 -22 61 10 30 1 53
-24 62 -21 9 -39 32 -39 52 0 56 84 29 112 -36z m5003 44 c68 0 85 -10 85 -49
0 -55 -100 -49 -217 12 -59 31 -49 74 11 50 20 -7 74 -13 121 -13z m3054 -19
c6 -18 -11 -31 -42 -31 -31 0 -52 16 -52 39 0 46 78 40 94 -8z m-11124 -87 c9
-101 2 -107 -69 -70 -94 51 -87 185 8 171 42 -6 55 -28 61 -101z m-2154 -138
c3 -152 -5 -206 -28 -206 -56 0 -81 59 -96 228 -16 180 -8 203 69 192 47 -7
52 -27 55 -214z m784 83 c0 -17 23 -52 50 -76 106 -97 35 -233 -79 -153 -32
22 -82 40 -113 40 -85 0 -89 35 -19 192 l64 146 49 -60 c26 -32 48 -72 48 -89z
m9982 49 c-22 -38 -26 -38 -57 0 -29 34 -29 44 1 63 49 30 85 -11 56 -63z
m429 31 c57 -80 48 -168 -23 -234 -80 -73 -80 -118 0 -160 59 -32 60 -36 19
-82 -42 -45 -42 -49 0 -79 72 -53 55 -138 -32 -155 -41 -8 -75 -25 -75 -37 0
-12 -13 -22 -30 -22 -23 0 -23 7 0 30 45 45 38 75 -48 204 -52 79 -73 135 -63
173 8 31 4 72 -8 91 -30 49 10 141 105 242 94 100 104 102 155 29z m-14242
-24 c17 -14 31 -43 31 -64 0 -48 161 -27 224 30 51 47 76 49 77 8 0 -47 185
-169 255 -169 56 0 60 -9 56 -113 -3 -62 10 -132 28 -156 18 -24 34 -60 35
-81 2 -74 120 -160 166 -122 37 30 39 28 22 -26 -16 -52 -12 -58 34 -45 29 7
62 0 72 -17 10 -17 58 -45 106 -63 218 -80 260 -135 127 -164 -131 -29 -560
238 -610 379 -12 32 -31 58 -44 58 -13 0 -23 41 -23 90 0 90 -151 285 -220
285 -14 0 -31 14 -37 31 -9 24 -30 22 -87 -10 -56 -30 -83 -34 -104 -13 -21
21 -41 20 -78 -3 -27 -17 -49 -20 -49 -8 0 12 -32 28 -72 36 -73 15 -124 113
-89 170 18 29 130 8 180 -33z m662 13 c34 -20 20 -109 -20 -125 -52 -20 -199
118 -155 146 28 17 128 5 175 -21z m697 -10 c59 -42 81 -47 110 -22 46 37 54
-24 10 -68 -51 -51 208 -349 321 -370 51 -10 104 -25 118 -33 14 -9 75 -17
135 -17 105 0 109 -4 116 -81 5 -66 -9 -92 -80 -146 -48 -36 -90 -62 -93 -57
-4 5 -20 31 -36 59 -26 46 -28 45 -28 -16 -1 -67 -55 -135 -85 -105 -9 9 -16
61 -16 115 l0 100 -100 -14 c-99 -13 -100 -12 -100 69 0 65 -17 93 -88 141
-49 33 -95 88 -103 122 -8 34 -22 96 -32 138 -38 164 -277 64 -277 -117 0 -55
-14 -79 -50 -89 -69 -18 -63 -33 49 -126 61 -51 125 -81 171 -81 41 0 87 -16
104 -36 43 -53 -55 -98 -167 -77 -284 53 -482 345 -384 564 31 70 51 90 71 70
35 -35 81 -5 81 54 0 46 16 51 234 71 25 2 79 -20 119 -48z m7483 -65 c15 -57
35 -113 45 -123 11 -10 19 -37 19 -61 0 -23 29 -71 65 -107 35 -35 57 -76 48
-91 -49 -79 -188 39 -188 161 0 103 -137 187 -221 135 -86 -54 -116 1 -63 113
43 88 49 92 157 85 109 -7 113 -10 138 -112z m-10464 17 c61 0 61 0 29 -86
-37 -97 -140 -60 -163 58 -16 82 12 121 50 69 16 -22 54 -41 84 -41z m14753
-105 c55 -33 62 -54 59 -173 -5 -217 -6 -222 -68 -279 -59 -55 -55 -168 6
-168 14 0 28 25 33 56 5 36 28 59 64 64 50 8 56 -2 56 -93 0 -90 -7 -102 -58
-102 -32 0 -85 -28 -117 -62 -94 -100 -138 -83 -145 56 -3 65 8 145 25 177 26
48 23 71 -12 133 -56 97 -54 118 12 188 l54 58 -54 74 c-93 125 -64 278 31
168 28 -32 80 -76 114 -97z m-18130 84 c7 -23 -8 -31 -47 -25 -31 5 -62 24
-68 42 -7 23 8 31 47 25 31 -5 62 -24 68 -42z m8418 -7 c22 -69 -48 -147 -92
-103 -23 23 -23 45 -1 93 35 77 71 81 93 10z m8366 -74 c-4 -47 -17 -95 -28
-106 -34 -36 -50 20 -34 118 19 115 74 105 62 -12z m-204 26 c0 -28 -125 -83
-145 -63 -6 7 2 30 19 51 36 43 126 52 126 12z m4349 -71 c26 -96 11 -253 -24
-253 -48 0 -68 74 -56 206 14 167 43 184 80 47z m-13131 -52 c20 -31 22 -54 6
-64 -34 -21 -66 3 -81 63 -17 65 35 66 75 1z m-5189 -127 c-5 -57 -18 -94 -28
-82 -10 11 -13 70 -7 130 7 60 19 97 28 82 10 -15 13 -73 7 -130z m13469 27
c-5 -106 -38 -137 -139 -130 -120 9 -159 -30 -222 -221 -71 -213 -154 -268
-265 -177 l-59 48 87 86 c145 143 225 247 225 293 0 60 63 107 119 89 31 -10
70 10 119 62 68 70 76 73 105 33 18 -24 31 -61 30 -83z m-12817 20 c46 -54 60
-183 22 -206 -49 -31 -246 211 -214 263 24 38 141 3 192 -57z m1937 -1 c45
-44 82 -104 82 -134 0 -71 91 -155 129 -117 29 29 96 15 96 -22 0 -12 -17 -22
-37 -22 -121 0 133 -218 411 -352 l136 -66 -74 -42 c-73 -41 -72 -41 102 -30
235 17 341 39 391 82 23 20 62 35 88 32 122 -13 140 -2 124 76 -15 75 -15 75
47 35 122 -80 31 -185 -159 -185 l-110 0 16 -86 c18 -92 -12 -134 -58 -79 -24
28 -45 28 -134 -3 -87 -31 -132 -32 -255 -9 -192 37 -249 39 -540 19 -136 -9
-276 -5 -325 9 -64 18 -115 14 -205 -16 -190 -63 -1018 45 -1018 132 0 31 83
108 117 108 19 0 47 -28 63 -63 37 -82 96 -95 336 -74 108 9 263 21 344 26 82
5 165 15 185 23 20 8 63 -3 94 -23 104 -68 386 -40 386 38 0 59 88 66 120 9
12 -22 68 -46 126 -54 94 -12 104 -9 104 40 0 30 -20 61 -44 68 -206 63 -481
280 -481 380 0 20 -51 103 -112 185 -62 83 -113 160 -113 172 0 49 89 19 168
-57z m2357 60 c0 -11 40 -63 88 -116 48 -53 94 -126 101 -161 25 -118 84 -228
123 -228 25 0 38 -24 38 -72 0 -42 16 -79 38 -87 58 -23 44 -90 -25 -116 -72
-27 -83 -87 -22 -120 49 -28 25 -45 -91 -66 -111 -19 -161 12 -138 85 14 43
31 52 77 40 48 -12 65 0 99 70 38 82 38 87 -18 145 -140 144 -148 143 -131
-19 l15 -147 -51 62 c-96 118 -164 347 -118 398 50 54 51 103 3 166 -41 55
-51 186 -13 186 14 0 25 -9 25 -20z m788 -77 c-9 -29 -32 -53 -52 -53 -44 0
-47 79 -6 120 41 41 79 -2 58 -67z m2764 57 c25 -30 58 -35 137 -24 101 15
107 13 132 -61 34 -97 22 -124 -87 -194 -116 -74 -147 -71 -184 19 -20 49 -49
75 -83 75 -64 0 -167 94 -167 153 0 31 24 47 81 54 45 5 94 12 110 14 15 2 43
-14 61 -36z m12736 15 c8 -14 1 -25 -15 -25 -17 0 -45 -20 -63 -44 -28 -37
-34 -37 -34 -5 -2 71 80 125 112 74z m-23254 -52 c51 -40 66 -74 66 -147 0
-92 48 -146 100 -113 12 7 29 -10 37 -38 10 -31 38 -50 73 -50 66 0 153 84
128 124 -18 29 9 238 28 219 44 -44 54 -306 15 -373 -39 -65 -39 -77 -6 -104
21 -16 50 -52 65 -79 39 -71 123 -76 168 -10 26 36 53 49 82 38 39 -15 38 -21
-9 -72 -29 -30 -56 -89 -60 -130 -10 -88 -74 -92 -158 -11 -197 188 -283 258
-347 280 -40 14 -93 45 -117 69 -23 23 -58 48 -77 54 -29 10 -29 18 -1 53 30
35 24 54 -43 139 -130 163 -91 267 56 151z m10041 20 c0 -48 -149 -129 -180
-98 -34 34 -3 80 55 80 26 0 54 11 63 25 21 36 62 31 62 -7z m3066 -65 c-14
-87 -9 -99 41 -112 128 -32 212 -191 101 -191 -69 0 -258 230 -258 313 0 67
19 87 82 87 43 0 47 -12 34 -97z m-11796 -19 c4 -30 30 -60 56 -67 32 -8 49
-34 49 -73 0 -92 113 -188 176 -149 43 27 49 24 49 -22 0 -45 13 -51 94 -44
70 6 94 -1 94 -29 1 -21 9 -51 20 -68 27 -43 -54 -157 -111 -157 -63 0 -60
-41 6 -76 33 -18 61 -20 76 -5 15 15 58 12 116 -9 51 -18 139 -33 195 -34 64
-1 127 -20 167 -51 132 -104 153 -54 43 109 -88 131 -90 144 -27 202 54 49
102 34 102 -32 0 -49 44 -111 181 -258 52 -55 88 -111 80 -123 -19 -31 -104
-29 -124 2 -10 17 -31 17 -62 0 -64 -34 -265 -31 -323 5 -38 23 -63 23 -114 0
-91 -42 -250 -38 -288 8 -17 20 -44 37 -59 37 -39 0 -116 141 -116 211 0 32
-17 72 -37 89 -21 17 -38 51 -38 74 0 65 -82 126 -191 143 -53 8 -109 25 -124
36 -35 27 -60 2 -60 -59 0 -59 -59 -45 -71 16 -10 52 64 215 97 215 13 0 24
32 24 71 0 116 104 148 120 38z m22055 23 c64 -55 64 -107 0 -107 -27 0 -50 8
-50 19 -1 10 -7 44 -16 75 -18 67 -1 70 66 13z m-22335 -70 c69 -70 79 -91 49
-103 -108 -41 -252 78 -188 155 40 48 38 49 139 -52z m15998 37 c9 -28 3 -68
-14 -88 -28 -33 -16 -47 34 -38 32 5 192 -99 192 -126 0 -13 -28 -34 -62 -47
-35 -13 -63 -33 -63 -43 0 -11 -23 -35 -52 -52 -67 -42 -114 -7 -177 136 -27
60 -67 109 -98 117 -70 18 -48 79 29 81 106 4 119 10 136 61 20 64 54 64 75
-1z m1820 15 c18 -47 -38 -92 -81 -65 -42 25 -18 101 32 101 20 0 42 -16 49
-36z m-11302 -29 c30 -11 44 -42 44 -100 0 -107 -23 -106 -94 5 -62 98 -72
147 -25 125 17 -8 51 -22 75 -30z m4219 -73 c0 -49 -13 -62 -60 -62 -43 0 -64
-18 -75 -62 -18 -72 -52 -82 -75 -23 -19 49 2 85 49 85 23 0 36 26 36 71 0 39
7 78 16 86 32 32 109 -35 109 -95z m345 57 c45 -55 64 -169 28 -169 -54 0
-123 80 -123 141 0 64 52 79 95 28z m4255 5 c0 -14 -17 -32 -37 -40 -51 -19
-120 9 -101 41 21 33 138 32 138 -1z m-7975 -7 c0 -4 -24 -58 -54 -119 -66
-135 -70 -231 -11 -296 25 -27 38 -61 29 -75 -9 -14 -5 -48 9 -74 19 -36 17
-55 -11 -78 -47 -40 -206 116 -163 159 46 46 29 60 -93 78 -133 20 -206 52
-206 90 0 36 154 173 195 173 19 0 68 34 109 75 59 59 196 106 196 67z m14931
-93 c79 -114 84 -138 32 -158 -51 -20 -48 -83 6 -113 23 -13 36 -32 27 -41
-25 -24 -121 34 -121 74 0 18 -17 40 -37 48 -39 15 -50 131 -22 235 20 76 35
70 115 -45z m-13586 9 c86 -54 55 -97 -65 -88 l-101 8 -18 -114 c-14 -99 -25
-114 -76 -114 -33 0 -60 14 -60 31 0 17 -39 63 -88 101 -89 72 -102 105 -64
165 49 77 355 84 472 11z m9795 27 c63 -16 77 -46 35 -72 -39 -24 -30 -88 13
-88 21 0 37 -22 37 -51 0 -28 16 -57 36 -64 57 -22 109 -551 63 -638 -61 -113
-198 35 -199 216 -1 74 -37 117 -90 108 -40 -7 -49 10 -55 104 -5 61 -21 126
-36 144 -19 24 -18 73 5 176 46 208 48 212 91 195 22 -8 67 -22 100 -30z
m-11515 -18 c0 -52 -150 -152 -181 -121 -42 42 45 154 119 154 35 0 62 -15 62
-33z m2194 -10 c5 -17 -19 -37 -55 -46 -57 -15 -92 -61 -45 -61 10 0 45 -40
78 -88 33 -48 80 -87 106 -87 26 0 47 -16 47 -36 0 -24 -26 -34 -81 -32 -45 1
-110 -5 -144 -15 -81 -22 -251 119 -200 166 24 23 34 22 43 -2 12 -33 107 -44
107 -12 0 11 -22 39 -50 63 -63 54 -63 80 2 145 55 55 174 58 192 5z m9606 17
c0 -35 -107 -74 -134 -49 -12 12 -14 33 -5 48 22 34 139 36 139 1z m-18923
-49 c13 0 23 -24 23 -53 0 -30 19 -68 42 -84 61 -45 25 -121 -48 -100 -80 24
-119 83 -119 182 0 68 8 82 40 70 21 -8 49 -15 62 -15z m12035 -30 c148 -72
149 -96 7 -129 -79 -19 -169 52 -169 134 0 63 22 63 162 -5z m-4251 -22 c139
-83 108 -250 -32 -175 -42 22 -53 18 -67 -23 -27 -88 -57 -54 -66 75 -14 198
9 215 165 123z m2835 -47 c11 -117 -36 -155 -95 -77 -37 49 -53 55 -82 32 -42
-35 -94 4 -94 70 0 61 16 68 145 63 114 -5 118 -8 126 -88z m4850 57 c-13 -62
-71 -71 -71 -10 0 31 16 52 39 52 24 0 36 -17 32 -42z m1821 22 c47 -30 110
-245 118 -403 9 -188 21 -205 116 -169 116 44 142 -19 47 -114 -40 -40 -73
-94 -73 -119 0 -78 -29 -128 -89 -151 -32 -12 -61 -47 -65 -79 -9 -62 -85 -91
-128 -48 -18 18 -17 37 4 62 21 25 22 42 4 53 -39 24 -32 129 12 172 50 50 47
61 -19 71 -44 6 -59 30 -74 116 -10 60 -31 125 -47 144 -16 19 -23 63 -17 98
10 51 4 61 -31 49 -46 -14 -87 48 -61 90 19 31 104 29 124 -2 44 -71 91 -23
74 76 -22 130 28 203 105 154z m-2491 -70 l25 -65 45 57 c62 76 135 49 124
-46 -7 -62 -17 -68 -105 -68 -56 0 -103 -14 -109 -32 -5 -17 -26 -31 -46 -31
-28 0 -31 11 -12 47 14 25 22 51 17 56 -4 5 -15 40 -24 78 -23 92 50 96 85 4z
m-11349 -12 c12 -20 27 -47 34 -60 6 -14 27 -6 46 18 46 57 68 56 68 -3 0 -59
-101 -127 -215 -146 -96 -15 -103 -26 -44 -69 54 -39 23 -88 -54 -88 -56 0
-187 111 -187 158 0 11 -48 17 -106 13 -92 -6 -106 -1 -106 42 0 40 14 48 78
42 62 -6 90 8 137 69 55 72 69 76 193 68 79 -5 143 -23 156 -44z m6019 -6 c4
-25 -8 -42 -32 -42 -23 0 -39 21 -39 52 0 61 58 52 71 -10z m10053 -100 c1
-25 -10 -38 -24 -29 -14 8 -25 30 -25 48 0 18 -17 47 -37 64 -21 17 -30 42
-22 56 21 33 108 -79 108 -139z m-6637 7 c-8 -13 -31 -24 -50 -24 -19 0 -45
-18 -57 -40 -16 -29 -39 -35 -79 -23 -55 17 -54 19 28 88 80 67 199 66 158 -1z
m-14442 -28 c11 -57 -188 -188 -227 -149 -23 23 -17 33 25 44 31 8 63 38 72
68 29 92 114 117 130 37z m12825 -15 c6 -42 -4 -56 -40 -56 -59 0 -116 62 -92
100 29 48 124 17 132 -44z m4507 -13 c139 -86 248 -225 248 -315 0 -54 12 -78
39 -78 28 0 35 15 24 50 -14 41 -5 50 50 50 52 0 62 -9 51 -46 -9 -28 4 -63
36 -91 88 -80 126 -182 95 -252 -24 -51 -20 -71 23 -117 130 -143 128 -200 -6
-244 -94 -31 -108 -76 -58 -186 21 -47 21 -71 -1 -98 -16 -19 -22 -53 -13 -75
18 -47 -41 -56 -115 -16 -60 32 -100 -21 -41 -54 33 -19 35 -32 10 -72 -26
-41 -22 -54 25 -88 69 -48 71 -87 6 -143 -63 -53 -86 -54 -164 -2 -42 27 -58
55 -48 86 16 49 -156 115 -228 88 -48 -18 -44 -63 7 -83 89 -34 142 -111 112
-160 -44 -70 -37 -92 70 -227 81 -102 95 -134 75 -173 -14 -26 -33 -47 -42
-47 -31 0 -132 109 -132 143 0 48 -63 65 -123 33 -31 -17 -52 -53 -52 -89 0
-34 -11 -62 -25 -62 -14 0 -25 10 -25 22 0 12 -7 55 -15 97 -11 57 -2 86 41
126 43 41 52 68 38 122 -9 39 -23 103 -31 142 -9 42 -35 78 -61 85 -91 23 -13
106 100 106 52 0 303 227 303 274 0 15 -17 34 -37 42 -49 19 -49 144 -1 184
53 43 156 11 178 -56 l17 -56 26 56 c13 31 44 56 68 56 62 0 94 174 39 214
-22 16 -40 46 -40 67 0 53 -175 235 -246 256 -34 10 -73 53 -94 103 -41 98
-46 100 -109 41 -29 -26 -51 -87 -56 -150 -9 -133 -43 -140 -107 -23 -63 114
-15 224 104 237 79 9 133 65 133 138 0 38 -11 44 -56 30 -134 -42 -203 -44
-229 -8 -15 21 -56 37 -90 35 -108 -4 -75 69 42 91 57 12 117 37 134 58 39 46
44 45 151 -21z m-5037 -58 c-12 -32 -24 -36 -44 -16 -15 15 -20 47 -11 71 12
32 24 36 44 16 15 -15 20 -47 11 -71z m-4811 -1 c25 -23 46 -61 46 -85 0 -24
17 -84 38 -135 37 -88 37 -94 -17 -137 l-56 -45 121 -54 c66 -29 150 -53 186
-54 79 -1 262 -122 273 -181 13 -64 -53 -53 -191 32 -67 41 -143 75 -169 75
-26 0 -98 34 -160 75 -62 41 -146 75 -187 75 -42 1 -126 18 -188 40 -82 29
-181 37 -362 31 -210 -7 -250 -2 -250 29 0 27 40 42 143 55 79 10 166 30 192
44 68 36 124 32 168 -11 48 -49 159 -50 159 -2 0 19 -36 43 -79 52 l-80 18 76
32 c42 17 82 49 91 71 8 23 31 34 52 26 22 -8 51 8 69 38 40 63 65 65 125 11z
m16356 -34 c40 -41 94 -81 121 -89 35 -12 45 -31 34 -70 -8 -29 -14 -90 -15
-135 0 -44 -11 -81 -25 -81 -14 0 -25 23 -25 52 0 29 -37 91 -81 137 -150 158
-173 190 -159 225 21 55 70 42 150 -39z m-22260 -2 c0 -64 -83 -57 -95 9 -6
30 7 43 43 43 36 0 52 -16 52 -52z m275 15 c0 -24 -24 -38 -62 -38 -39 0 -63
14 -63 38 0 23 24 37 63 37 38 0 62 -14 62 -37z m10150 -29 c0 -36 19 -80 42
-96 63 -47 25 -124 -44 -87 -62 33 -123 15 -123 -36 0 -75 87 -190 144 -190
31 0 56 -11 56 -25 0 -14 37 -22 81 -19 75 6 82 0 89 -73 7 -68 -4 -86 -69
-120 -75 -39 -76 -39 -76 26 0 45 -16 70 -50 79 -27 7 -50 28 -50 47 0 49 -23
43 -73 -18 -97 -121 -225 30 -213 253 9 165 48 244 141 285 120 52 145 48 145
-26z m4419 37 c22 -22 38 -21 69 4 53 45 93 1 83 -90 -11 -98 -80 -105 -157
-18 -85 96 -81 190 5 104z m-12942 -48 c40 -28 73 -68 73 -88 0 -20 31 -48 69
-64 38 -15 125 -54 194 -87 69 -32 157 -59 196 -59 131 0 54 -62 -105 -84
-135 -18 -168 -14 -261 34 -161 83 -268 223 -268 352 0 61 13 60 102 -4z
m5962 -9 c60 -61 82 -139 39 -139 -13 0 -29 17 -37 38 -8 21 -46 37 -89 37
-87 0 -119 37 -76 89 44 52 93 45 163 -25z m3529 5 c-5 -49 8 -58 105 -69 139
-16 148 -43 49 -158 -90 -105 -140 -117 -152 -36 -5 36 -28 59 -64 64 -31 5
-56 23 -56 41 0 18 -17 47 -37 64 -56 46 -47 71 43 110 112 49 119 48 112 -16z
m5452 1 c17 -16 30 -59 30 -95 0 -36 11 -76 23 -89 13 -13 27 -68 32 -122 7
-96 5 -99 -90 -119 -127 -27 -132 -18 -41 79 102 109 100 171 -5 181 -63 6
-83 20 -90 66 -16 117 66 174 141 99z m-2157 -60 c1 -29 20 -72 44 -96 60 -59
54 -130 -12 -148 l-56 -14 56 -59 c58 -62 69 -132 30 -193 -37 -59 -100 -3
-155 138 -27 69 -76 154 -110 189 l-61 64 63 29 c35 16 63 50 63 75 0 62 25
84 86 75 33 -5 52 -27 52 -60z m-7662 -4 c0 -24 40 -82 87 -130 120 -119 116
-176 -11 -176 -91 0 -327 81 -327 112 0 8 10 33 23 57 13 24 29 63 37 87 19
61 90 56 90 -6 0 -27 11 -50 25 -50 14 0 25 34 25 75 0 78 49 108 51 31z
m-7931 -61 c23 -45 74 -111 112 -149 69 -67 69 -69 19 -95 -59 -32 -288 -10
-363 34 -161 96 -342 108 -422 27 -50 -49 -73 -47 -110 12 -26 43 -20 57 53
113 46 34 101 63 123 63 22 0 47 11 56 25 27 44 105 27 166 -37 79 -84 196
-86 196 -5 0 121 108 129 170 12z m7560 8 c9 -8 20 -49 25 -90 11 -110 -120
-129 -144 -21 -8 39 -19 83 -24 99 -17 59 84 67 143 12z m2225 -9 c-14 -18
-30 -77 -34 -132 -10 -124 -56 -121 -67 5 -6 73 5 102 50 136 63 48 94 42 51
-9z m-8555 7 c0 -13 37 -41 81 -63 45 -22 113 -66 152 -98 l71 -57 -170 -16
c-197 -19 -199 -17 -222 139 -16 110 -14 119 35 119 29 0 53 -11 53 -24z
m10797 -41 c29 -9 27 -19 -6 -56 -46 -51 -14 -104 62 -104 29 0 39 -15 30 -47
-7 -26 0 -55 15 -64 35 -22 35 -156 1 -177 -14 -9 -42 -3 -61 12 -28 24 -36
14 -43 -53 -5 -57 -22 -86 -53 -92 -61 -11 -177 96 -142 131 89 89 -35 259
-128 175 -35 -32 -56 -36 -75 -17 -33 33 -8 82 42 82 20 0 36 17 36 38 0 24
-24 37 -69 37 -98 1 -156 42 -106 75 69 45 172 29 212 -34 64 -97 160 -128
186 -60 15 39 10 69 -13 96 -73 83 -34 103 112 58z m9683 -22 c87 -74 126 -78
184 -21 23 24 97 50 164 58 119 16 123 14 186 -78 78 -112 66 -180 -41 -235
-40 -21 -73 -55 -73 -76 0 -21 -16 -44 -35 -51 -20 -8 -42 -41 -51 -74 -18
-74 -42 -77 -101 -11 -28 31 -77 50 -127 50 -137 0 -164 21 -147 111 12 64 1
97 -50 157 -69 83 -81 155 -34 202 40 40 39 40 125 -32z m-21216 -56 c136
-114 137 -131 11 -213 -101 -67 -176 -50 -175 39 1 19 9 17 23 -5 12 -20 40
-28 63 -20 53 21 -46 207 -120 226 -25 7 -39 25 -30 39 32 51 118 26 228 -66z
m501 34 c100 -85 68 -131 -107 -149 -119 -13 -151 -8 -177 26 -51 69 -37 107
41 107 42 0 79 16 87 38 21 53 78 46 156 -22z m8116 -7 c58 -8 94 -27 94 -49
0 -42 34 -38 -375 -45 -186 -3 -357 -15 -381 -25 -54 -25 -90 49 -46 93 57 57
406 70 708 26z m8519 3 c26 -31 20 -48 -37 -101 -73 -67 -154 -65 -128 4 8 21
15 54 15 73 0 28 30 46 103 59 9 2 30 -14 47 -35z m1417 -1 c20 -54 -32 -106
-70 -68 -32 32 -12 107 28 107 15 0 33 -18 42 -39z m-4192 -24 c0 -40 -66 -79
-92 -54 -8 8 -8 32 1 53 19 50 91 51 91 1z m-4573 -109 c-83 -117 -178 -137
-287 -59 -49 35 -90 73 -90 85 0 33 145 24 156 -10 7 -21 46 -11 133 34 139
71 164 57 88 -50z m5938 -66 c8 -34 34 -73 57 -86 59 -34 -58 -247 -147 -267
-34 -7 -82 -19 -106 -26 -30 -7 -44 3 -44 32 0 24 -18 63 -40 88 -37 41 -33
51 63 147 56 57 102 120 102 139 0 64 98 41 115 -27z m-1194 -56 l25 -68 2 68
c2 76 60 93 135 38 34 -25 41 -64 36 -179 -6 -144 -10 -151 -119 -230 -124
-90 -150 -100 -150 -55 0 16 -23 54 -52 85 -46 49 -48 62 -19 114 18 32 34 94
36 137 6 163 62 210 106 90z m-14196 -44 c62 -33 149 -78 194 -99 44 -21 81
-52 81 -68 0 -51 106 -145 164 -145 54 0 155 -115 126 -144 -8 -8 -57 -1 -109
14 -51 16 -116 32 -143 36 -32 4 -59 36 -74 88 -17 55 -40 81 -73 81 -27 0
-87 29 -134 65 -47 36 -92 59 -99 51 -31 -30 22 -144 78 -170 68 -31 102 -122
57 -151 -51 -32 -62 -23 -79 66 -12 65 -26 83 -55 72 -41 -16 -159 100 -159
156 0 17 -18 38 -40 46 -48 19 -3 90 56 90 20 0 42 17 50 38 18 47 24 46 159
-26z m2840 -1 c16 -20 51 -36 80 -36 73 0 90 -41 54 -127 -35 -85 -109 -97
-149 -24 -14 27 -41 43 -60 36 -19 -7 -42 -1 -52 13 -9 15 1 34 23 42 69 27
42 65 -34 48 -79 -17 -111 10 -86 74 19 51 179 32 224 -26z m1048 8 c105 -36
125 -60 87 -106 -41 -50 -114 -28 -204 62 -70 70 -68 115 3 86 21 -9 72 -28
114 -42z m1202 21 c7 -19 35 -41 62 -48 28 -7 48 -34 48 -66 0 -48 9 -52 92
-36 65 12 99 7 118 -18 15 -19 61 -50 103 -68 127 -56 335 -209 351 -259 9
-27 40 -60 69 -74 80 -37 179 -198 138 -224 -19 -11 -49 -4 -73 17 -22 21 -58
30 -80 22 -43 -16 -106 73 -80 115 8 13 -5 32 -30 41 -25 9 -67 38 -93 65 -41
43 -67 47 -188 30 -77 -10 -181 -20 -231 -21 -59 -2 -114 -25 -155 -62 -74
-71 -124 -50 -105 42 16 77 0 105 -86 148 -142 70 -389 19 -416 -86 -8 -31
-30 -69 -50 -86 -30 -25 -30 -35 -1 -69 19 -22 56 -94 82 -159 42 -105 57
-119 123 -119 41 0 100 -7 131 -16 41 -11 56 -4 56 26 0 38 112 111 136 88 5
-6 17 -40 26 -76 25 -97 -39 -146 -195 -151 -83 -2 -103 -7 -54 -14 98 -14
128 -45 88 -93 -96 -116 -460 161 -487 370 -23 177 -6 268 56 301 30 16 73 54
94 85 21 30 54 55 72 55 19 0 40 17 48 38 34 88 401 33 490 -74 47 -57 101
-48 101 19 0 74 -55 192 -90 192 -15 0 -40 28 -55 63 -16 34 -40 62 -54 62
-15 0 -26 17 -26 38 0 47 47 49 65 2z m2344 10 c47 0 54 -16 59 -125 3 -69 -4
-125 -16 -125 -45 0 -79 73 -63 135 13 50 7 65 -24 65 -22 0 -40 -20 -40 -47
0 -26 -6 -79 -14 -119 -11 -55 1 -89 51 -147 36 -41 82 -112 102 -159 36 -85
43 -87 186 -50 69 18 42 -88 -31 -123 -99 -47 -203 5 -215 108 -5 41 -24 83
-44 94 -19 11 -35 48 -35 82 0 73 -98 86 -153 20 -30 -37 -35 -35 -49 19 -8
33 -5 73 8 89 37 49 11 142 -50 172 -60 30 -50 61 20 61 24 0 58 18 76 40 22
27 56 35 106 25 40 -8 97 -15 126 -15z m1616 2 c0 -13 7 -41 15 -62 10 -26 2
-40 -22 -40 -48 0 -102 65 -81 99 20 32 88 35 88 3z m-8331 -18 c31 -8 56 -34
56 -59 0 -149 -418 -186 -446 -40 -10 50 8 49 227 0 62 -14 69 -9 69 50 0 69
6 73 94 49z m7538 0 c45 -44 -38 -109 -139 -109 -245 1 -184 105 72 122 28 1
59 -4 67 -13z m-10197 -24 c22 -9 40 -37 40 -64 0 -27 11 -69 24 -94 17 -32 9
-74 -28 -148 l-51 -104 63 -192 64 -191 -86 -100 c-83 -98 -110 -167 -64 -167
20 0 103 -149 103 -185 0 -8 -22 -15 -50 -15 -42 0 -50 -17 -50 -100 0 -72 10
-100 38 -100 20 0 37 -12 37 -27 0 -15 -21 -20 -50 -10 -35 11 -50 4 -50 -24
0 -21 20 -39 44 -39 87 0 162 -76 150 -151 -9 -63 -1 -72 73 -86 92 -17 103
-40 43 -90 -22 -19 -50 -57 -60 -85 -18 -44 -27 -35 -74 68 -60 133 -116 161
-93 46 12 -56 3 -80 -40 -109 -64 -42 -31 -105 77 -146 86 -33 28 -100 -69
-81 -83 17 -133 -37 -55 -58 84 -22 243 -358 170 -358 -51 0 -116 -96 -116
-170 0 -33 -25 -81 -56 -106 l-56 -47 56 -1 c33 -1 56 14 56 37 0 42 64 50 88
10 9 -14 43 -36 76 -48 68 -26 146 -162 125 -217 -11 -29 -37 -17 -118 53
-122 104 -154 109 -207 34 -34 -49 -34 -61 0 -113 21 -32 35 -89 31 -126 -7
-61 2 -70 80 -81 86 -12 146 -100 68 -100 -62 0 -193 -77 -193 -115 0 -28 9
-30 47 -6 79 49 128 9 128 -104 0 -82 -11 -105 -56 -123 -55 -20 -66 -149 -45
-505 1 -9 25 -22 53 -30 38 -10 48 -26 37 -62 -8 -27 -4 -79 10 -115 23 -61
18 -72 -47 -109 -82 -47 -105 -200 -99 -643 1 -110 -2 -240 -6 -288 -8 -73 -1
-89 43 -95 77 -11 227 -173 193 -207 -20 -20 -42 -20 -79 0 -74 39 -204 35
-204 -8 0 -19 27 -41 61 -50 33 -8 68 -38 77 -67 13 -41 30 -48 86 -36 82 18
120 -39 63 -96 -27 -27 -59 -31 -130 -14 -125 29 -124 29 -142 -16 -43 -112
180 -186 312 -104 70 44 125 3 121 -88 -3 -45 4 -102 15 -127 16 -40 8 -45
-64 -38 -96 10 -125 58 -48 79 30 7 47 26 38 40 -22 35 -156 35 -177 1 -9 -14
-39 -19 -67 -10 -29 9 -86 -3 -137 -30 -79 -43 -85 -53 -70 -134 21 -112 31
-126 75 -109 28 11 37 -8 39 -82 5 -277 17 -388 44 -415 16 -16 29 -73 29
-126 0 -76 16 -113 74 -167 l75 -70 -138 -137 c-139 -140 -161 -219 -58 -219
56 0 63 -46 10 -66 -42 -16 -49 -123 -22 -319 16 -116 69 -150 74 -46 11 203
84 140 85 -74 0 -155 -31 -202 -77 -117 l-29 55 -34 -60 c-20 -34 -33 -125
-32 -210 1 -83 -10 -181 -24 -219 -31 -78 -4 -271 46 -332 27 -32 23 -49 -25
-100 -55 -58 -56 -64 -17 -107 47 -52 55 -105 17 -105 -78 0 -8 -40 76 -43 56
-3 124 -11 150 -20 54 -17 67 -86 18 -89 -17 -1 -87 -4 -156 -6 l-124 -4 -7
-150 c-4 -83 -7 -175 -8 -206 0 -30 -11 -61 -24 -70 -72 -44 18 -187 116 -187
67 0 75 -20 23 -60 -20 -15 -40 -61 -44 -102 -7 -70 1 -78 115 -114 l123 -39
-66 -52 c-36 -28 -99 -65 -141 -83 -97 -40 -101 -113 -7 -138 66 -17 67 -18
15 -42 -49 -23 -55 -51 -72 -391 -21 -402 -20 -881 1 -979 10 -48 0 -68 -44
-88 -47 -20 -58 -47 -64 -159 -8 -146 20 -205 77 -158 26 22 42 21 64 -1 23
-23 41 -23 77 -1 63 39 76 20 59 -89 -15 -101 -70 -179 -125 -179 -20 0 -53
-17 -74 -39 -78 -78 -120 -34 -124 127 -3 184 -7 1246 -4 1350 4 140 2 2048
-2 2362 -7 477 -7 992 -1 1200 3 103 1 598 -3 1100 -5 502 -7 1492 -3 2200 3
708 0 1754 -7 2325 -7 571 -3 1053 8 1071 13 20 10 62 -7 100 -19 45 -26 253
-20 649 8 573 9 583 63 605 66 27 125 30 177 10z m11528 -36 c9 -28 43 -68 76
-90 66 -43 80 -130 32 -206 -41 -66 -9 -135 54 -116 65 21 66 -36 3 -115 -58
-72 -171 -46 -219 51 -16 32 -43 67 -60 78 -56 34 -98 198 -68 264 20 44 18
68 -7 99 -28 33 -27 44 3 63 66 42 168 27 186 -28z m1987 -27 c0 -12 -22 -22
-50 -22 -48 0 -68 49 -34 83 19 19 84 -28 84 -61z m-10075 16 c0 -41 -30 -46
-118 -22 -76 20 -47 59 44 59 49 0 74 -13 74 -37z m4297 1 c82 -42 353 -336
353 -382 0 -18 23 -32 50 -32 61 0 70 103 13 150 -42 35 -28 75 25 75 50 0 74
-116 40 -190 -21 -46 -20 -75 3 -117 48 -86 150 -193 183 -193 17 0 47 -42 68
-94 21 -51 61 -115 90 -141 29 -26 53 -69 53 -94 0 -27 27 -57 63 -71 35 -13
74 -52 87 -87 13 -35 35 -63 49 -63 14 0 26 -28 26 -61 0 -34 18 -71 39 -84
22 -12 53 -49 70 -82 16 -33 55 -64 87 -69 88 -12 68 -144 -21 -136 -234 18
-320 112 -287 311 13 78 8 94 -36 108 -29 9 -70 49 -90 90 -21 40 -50 73 -64
73 -43 0 -152 132 -199 241 -25 58 -68 112 -96 121 -29 9 -78 73 -113 148 -37
77 -103 163 -158 205 -52 39 -151 129 -219 199 -69 70 -145 135 -169 144 -24
8 -44 27 -44 41 0 38 116 32 197 -10z m1975 13 c28 -17 23 -28 -22 -52 -45
-24 -60 -24 -77 2 -38 63 27 96 99 50z m9216 -59 c0 -38 15 -79 34 -91 51 -32
-10 -285 -95 -387 -33 -40 -250 -58 -285 -23 -21 21 55 108 95 108 37 0 138
136 138 186 0 45 -34 50 -100 14 -69 -37 -87 13 -26 74 28 28 51 64 51 80 0
53 83 123 136 116 38 -6 52 -26 52 -77z m4462 -57 c0 -61 -11 -111 -24 -111
-30 0 -61 162 -41 214 27 71 65 10 65 -103z m-5525 65 c0 -27 -22 -61 -50 -76
-54 -29 -67 -123 -23 -167 19 -19 9 -23 -34 -15 -50 9 -65 -1 -78 -53 -9 -37
-34 -65 -58 -65 -22 0 -118 -81 -212 -180 -173 -183 -200 -248 -142 -341 33
-53 -33 -179 -94 -179 -48 0 -208 -104 -284 -184 -35 -36 -71 -65 -81 -66 -30
0 -22 68 12 105 69 75 88 131 59 176 -22 35 -16 51 29 83 31 21 56 52 57 69 1
40 72 120 155 174 77 49 87 97 32 143 -63 52 -47 103 26 85 47 -12 77 -2 113
36 57 61 61 83 13 64 -59 -23 -82 141 -25 182 59 43 93 31 109 -39 21 -88 59
-70 122 56 52 104 66 116 144 116 69 0 91 13 110 63 28 74 100 83 100 13z
m-13468 -19 c30 -17 -6 -57 -52 -57 -24 0 -57 23 -75 51 -29 47 -27 49 38 34
38 -9 78 -22 89 -28z m-3616 -7 c20 0 34 -26 34 -62 0 -71 -52 -84 -100 -25
-17 20 -52 37 -78 37 -27 0 -47 18 -47 41 0 32 16 37 78 25 43 -9 94 -16 113
-16z m3184 -26 c0 -64 48 -83 129 -52 74 28 134 -1 114 -54 -26 -67 -206 -80
-266 -20 -29 29 -62 52 -74 52 -29 0 -57 73 -39 102 29 47 136 25 136 -28z
m2217 12 c5 -15 -30 -49 -79 -75 -49 -26 -95 -67 -102 -92 -16 -48 -86 -61
-86 -16 0 113 237 275 267 183z m2743 -1 c8 -21 15 -56 15 -76 0 -21 17 -54
38 -75 23 -23 37 -84 37 -160 0 -162 79 -220 156 -115 56 77 104 87 82 18 -8
-26 -3 -55 11 -64 52 -32 24 -60 -68 -68 -89 -7 -93 -12 -93 -95 0 -73 9 -89
58 -96 48 -7 56 -19 43 -68 -18 -72 38 -265 73 -253 14 5 28 74 31 153 6 151
46 212 138 213 83 2 39 -174 -61 -245 -77 -54 -54 -256 33 -297 42 -20 71 -59
81 -107 10 -54 29 -75 65 -75 28 0 74 -22 101 -50 28 -27 68 -50 90 -50 22 0
68 -22 103 -50 35 -27 79 -50 98 -50 19 0 34 -16 34 -35 0 -20 14 -41 31 -47
82 -29 -13 -41 -121 -15 -222 53 -371 126 -469 229 -83 89 -102 98 -143 72
-41 -25 -48 -22 -48 21 0 28 -17 50 -38 50 -54 0 -74 68 -34 116 30 37 28 39
-22 23 -50 -16 -56 -9 -57 66 0 45 -28 138 -61 207 -38 76 -56 146 -47 181 8
33 -3 83 -26 119 -22 34 -40 106 -40 160 0 177 -50 234 -96 109 l-25 -68 -2
79 c-1 44 9 87 23 96 14 8 25 69 25 134 0 147 48 211 85 113z m-5899 -44 c63
-59 90 -191 38 -191 -14 0 -36 -28 -49 -62 -22 -58 -100 -90 -100 -42 0 11
-51 57 -112 101 -137 99 -161 206 -44 200 38 -2 97 8 131 23 34 15 65 28 67
28 3 1 34 -25 69 -57z m2357 -26 c78 -71 88 -91 61 -122 -26 -32 -19 -47 43
-91 96 -68 111 -66 94 17 -8 38 -8 54 0 37 7 -17 35 -31 61 -31 52 0 70 -118
24 -164 -14 -15 27 -79 110 -173 126 -141 137 -148 205 -125 86 31 98 102 15
93 -75 -8 -130 98 -81 156 19 23 51 33 79 24 36 -11 55 5 83 70 19 47 53 100
75 118 21 18 34 51 27 73 -14 48 150 163 203 142 37 -14 -24 -139 -69 -139
-11 0 -37 -31 -58 -69 -127 -232 -126 -228 -95 -313 16 -44 22 -123 14 -174
-12 -72 -6 -97 25 -109 76 -29 44 -66 -40 -49 -45 10 -149 25 -231 34 -148 17
-151 19 -158 101 -6 62 -25 90 -75 112 -37 16 -128 94 -202 173 -75 79 -143
144 -152 144 -31 0 -102 -193 -86 -234 11 -29 1 -41 -32 -41 -68 0 -124 115
-142 293 -15 150 -13 157 69 243 103 110 118 110 233 4z m324 31 c56 -53 81
-171 36 -171 -22 0 -153 177 -153 208 0 35 61 16 117 -37z m6601 -71 c43 -53
38 -123 -17 -225 -42 -78 -49 -82 -64 -37 -10 27 -34 87 -55 133 -23 54 -31
115 -20 171 16 87 16 88 70 42 30 -26 69 -63 86 -84z m-8714 59 c25 -23 46
-61 46 -84 0 -23 22 -63 50 -87 85 -78 47 -190 -47 -140 -35 19 -53 20 -53 3
0 -14 -13 -26 -28 -26 -20 0 -19 11 3 37 36 44 16 113 -33 113 -73 0 -119 85
-86 158 36 77 83 85 148 26z m-3229 -36 c0 -61 -58 -52 -71 10 -4 25 8 42 32
42 23 0 39 -21 39 -52z m12450 5 c0 -26 -22 -53 -50 -60 -50 -13 -73 51 -33
90 33 34 83 16 83 -30z m-2052 -44 c69 -88 65 -130 -15 -161 -109 -41 -177 42
-122 149 49 95 70 97 137 12z m-9759 -11 c9 -14 46 -23 82 -19 37 4 80 -2 97
-12 83 -51 -85 -157 -210 -133 -61 12 -83 -2 -170 -109 l-100 -124 -29 93
c-15 52 -53 136 -84 188 -73 124 -52 139 85 59 143 -85 201 -87 181 -7 -8 32
-8 66 1 75 26 26 129 18 147 -11z m3632 -26 c55 -89 -14 -140 -118 -86 -115
59 -104 139 20 139 39 0 78 -21 98 -53z m5454 -74 c0 -65 14 -103 44 -120 37
-22 30 -30 -52 -65 -267 -112 -458 -57 -323 95 32 36 35 52 12 60 -39 14 -41
98 -2 122 16 10 42 -1 59 -24 39 -53 67 -52 117 7 69 80 145 41 145 -75z
m3563 87 c72 -47 84 -135 18 -135 -86 0 -231 53 -231 84 0 89 113 116 213 51z
m9239 -24 c114 -58 207 -55 235 8 14 31 38 56 54 56 31 0 109 -214 109 -298 0
-75 -94 -68 -129 9 -32 71 -74 93 -121 64 -25 -16 -14 -44 49 -123 51 -65 75
-118 65 -144 -15 -39 -114 31 -225 160 -41 47 -162 84 -224 68 -35 -9 -78 4
-117 35 -53 44 -65 46 -101 14 -30 -28 -56 -30 -106 -11 -118 44 -88 76 109
115 48 9 108 39 134 65 49 53 142 47 268 -18z m-17885 -154 c9 -153 -15 -175
-131 -121 -102 49 -113 120 -31 207 93 99 153 67 162 -86z m8277 48 c30 -37
56 -76 56 -87 0 -44 -85 -48 -153 -8 -40 24 -72 34 -73 23 -1 -33 -72 101 -73
139 -2 59 179 10 243 -67z m3608 52 c81 -47 109 -107 86 -180 -10 -31 0 -57
26 -72 37 -20 38 -33 9 -114 -39 -108 -111 -141 -162 -75 -35 44 -39 43 -97
-27 -55 -66 -67 -71 -126 -44 -35 16 -71 47 -79 67 -19 49 -124 49 -143 1 -10
-27 -51 -38 -140 -38 -123 0 -126 2 -126 75 0 63 10 75 62 75 38 0 77 24 103
63 27 41 64 62 108 62 37 0 92 23 121 50 72 67 117 63 151 -12 47 -102 147
-86 160 25 12 106 3 118 -60 84 -73 -39 -144 24 -80 70 59 44 100 41 187 -10z
m8908 -44 c29 -115 -9 -923 -44 -950 -18 -14 -69 -56 -113 -94 l-80 -68 38
-130 c88 -294 46 -1332 -75 -1900 -20 -91 -36 -203 -36 -250 -1 -104 -30 -152
-81 -133 -47 18 -51 5 -107 -300 -22 -123 -56 -252 -74 -287 -18 -35 -58 -125
-89 -201 -87 -215 -200 -448 -226 -463 -12 -8 -23 -34 -23 -57 0 -42 -173
-255 -207 -255 -34 0 -18 71 46 199 48 94 60 148 48 204 -12 54 -5 89 27 123
41 45 41 49 -1 65 -83 32 -188 -231 -188 -471 0 -92 -10 -173 -21 -180 -34
-21 -122 -291 -140 -427 -27 -210 -14 -571 22 -613 78 -90 119 -208 104 -303
-10 -65 1 -140 37 -240 75 -211 203 -514 234 -557 27 -38 86 -159 148 -306 64
-151 165 -356 285 -581 186 -348 207 -415 208 -663 1 -149 13 -235 36 -266 20
-26 36 -78 36 -117 1 -38 20 -127 42 -197 33 -100 36 -135 12 -167 -16 -22
-36 -60 -44 -84 -18 -55 -59 -58 -59 -5 0 68 -128 314 -159 304 -16 -5 -51
-50 -78 -100 l-50 -91 56 -52 c30 -28 62 -79 71 -114 9 -34 35 -73 59 -86 33
-17 47 -69 60 -214 13 -162 31 -216 110 -345 l94 -153 1 -393 c2 -321 10 -411
47 -492 60 -133 38 -204 -91 -288 -309 -202 -499 -180 -382 44 49 95 49 97
-38 146 -44 25 -75 63 -75 93 0 27 -28 91 -62 142 -35 51 -63 111 -63 133 0
23 -13 55 -28 70 -16 16 -22 47 -13 69 20 52 204 -36 228 -109 8 -27 31 -55
51 -62 21 -8 37 -37 37 -65 0 -54 36 -68 63 -24 9 14 44 36 77 49 97 37 52
224 -53 224 -17 0 -45 17 -62 38 -17 20 -53 37 -80 37 -29 0 -55 21 -63 50 -7
28 -23 50 -35 50 -12 0 -22 13 -22 29 0 16 -18 49 -40 74 -22 24 -33 56 -23
70 23 39 63 33 63 -8 0 -55 244 -82 294 -32 56 56 21 112 -81 131 -60 11 -111
44 -151 98 -94 122 -79 284 17 197 71 -64 83 10 22 143 -69 152 -64 188 26
220 86 30 87 86 2 98 -41 7 -54 26 -54 82 0 90 -43 96 -65 9 -9 -35 -23 -60
-32 -55 -8 4 -46 24 -84 43 -38 19 -69 53 -69 76 0 22 -39 87 -87 143 -53 62
-88 129 -88 170 0 37 -24 100 -52 140 -29 41 -57 99 -62 129 -42 235 -56 353
-44 382 7 19 -40 87 -106 154 -181 184 -215 264 -186 445 13 82 29 296 34 475
6 178 21 352 34 386 18 44 14 79 -16 130 -33 58 -34 79 -7 121 17 29 26 62 19
73 -8 12 -3 76 9 142 39 210 28 215 -471 226 l-427 9 -175 -93 -175 -93 69
-56 c38 -31 83 -51 102 -45 44 16 122 -28 153 -87 24 -45 18 -47 -118 -33
l-143 14 46 -52 c25 -28 60 -46 77 -40 27 11 114 -86 114 -127 0 -41 -173 -9
-187 35 -9 29 -43 52 -81 57 -83 10 -102 60 -31 83 50 16 51 21 16 56 -49 48
-96 16 -143 -96 -38 -92 38 -187 225 -281 62 -31 145 -78 184 -104 67 -44 75
-44 142 -5 75 45 175 56 175 20 0 -12 -35 -49 -78 -81 -43 -33 -98 -78 -123
-101 -25 -23 -51 -36 -59 -28 -8 8 -30 0 -50 -16 -50 -42 -22 -102 47 -102 31
0 72 -19 91 -42 19 -22 82 -62 141 -88 62 -28 121 -77 143 -118 20 -39 53 -78
75 -86 21 -8 38 -27 38 -43 0 -16 37 -74 81 -131 84 -105 110 -146 183 -286
31 -61 35 -90 14 -115 -27 -33 -23 -44 126 -324 20 -36 32 -39 60 -16 30 25
36 19 36 -32 0 -35 7 -98 16 -141 12 -62 7 -78 -25 -78 -23 0 -41 11 -41 25 0
14 -46 25 -102 25 -71 0 -99 -10 -92 -31 6 -17 36 -31 66 -31 90 0 253 -202
253 -314 0 -98 56 -260 100 -286 14 -9 25 -61 25 -116 0 -55 12 -123 27 -152
26 -48 32 -45 90 52 34 57 71 98 82 91 40 -25 101 -247 101 -367 0 -117 -2
-121 -74 -121 -92 0 -116 36 -54 80 47 33 47 35 -12 88 l-60 53 0 -95 c0 -182
-160 -153 -188 34 -13 82 -32 116 -76 136 -33 15 -67 58 -77 95 -49 198 -248
377 -380 342 -67 -17 -76 75 -15 161 26 38 31 69 16 97 -16 27 -29 31 -41 12
-29 -48 -64 -31 -64 32 0 80 -145 139 -190 78 -23 -32 -32 -20 -49 68 -41 215
-34 296 30 320 65 25 72 53 33 126 -34 64 -174 68 -175 4 -1 -39 -4 -39 -37 5
-29 37 -44 42 -67 19 -22 -22 -19 -40 13 -75 56 -62 53 -137 -8 -192 -27 -25
-50 -72 -50 -105 0 -69 -65 -104 -108 -59 -23 24 -20 37 12 58 47 31 13 143
-43 143 -17 0 -59 32 -92 72 -33 39 -85 85 -115 101 -71 38 -74 114 -4 92 27
-8 73 -22 100 -30 68 -22 63 19 -12 90 -35 32 -63 85 -63 116 0 41 18 63 63
74 34 8 62 29 62 46 0 53 -140 189 -195 189 -29 0 -76 25 -105 55 -44 48 -61
52 -124 28 -40 -15 -79 -21 -87 -14 -24 24 -15 106 11 106 14 0 25 27 25 60 0
39 18 64 53 73 39 10 50 28 40 66 -35 133 126 -25 168 -166 10 -35 45 -61 95
-72 43 -9 114 -37 157 -61 49 -28 92 -37 116 -23 52 29 146 0 146 -45 0 -28
17 -33 63 -22 44 11 67 5 78 -22 22 -57 118 -46 180 20 60 64 50 92 -33 92
-74 0 -91 22 -61 78 19 36 16 47 -12 47 -21 0 -40 -29 -45 -69 -12 -105 -105
-95 -115 13 -10 96 -93 113 -166 33 -48 -54 -101 -46 -124 18 -8 24 -22 57
-30 74 -9 20 8 31 50 31 77 0 80 18 16 94 -52 63 -91 72 -108 25 -9 -25 -24
-24 -69 2 -49 30 -60 29 -79 -6 -12 -22 -33 -40 -46 -40 -39 0 -27 68 14 84
99 38 -126 291 -259 291 -72 0 -77 7 -92 119 -8 65 -17 135 -20 156 -3 21 -33
39 -67 41 -35 2 -77 5 -94 7 -17 1 -31 25 -31 53 0 76 118 115 204 66 73 -41
96 -32 96 35 0 50 -218 173 -305 172 -32 0 -93 6 -136 15 -92 19 -147 -34 -59
-57 42 -11 52 -28 43 -74 -7 -37 3 -67 29 -82 36 -20 35 -26 -4 -70 -24 -26
-43 -66 -43 -89 0 -54 -83 -55 -128 -1 -29 35 -26 46 22 78 63 41 72 93 25
142 -17 18 -48 59 -69 91 -51 78 -180 198 -213 198 -15 0 -40 -13 -56 -29 -42
-42 -96 11 -182 181 l-72 142 -113 -37 -113 -38 81 -54 c96 -65 121 -140 46
-140 -27 0 -57 11 -65 25 -9 14 -32 25 -52 25 -56 0 -42 -89 27 -170 34 -41
62 -98 62 -125 0 -37 22 -56 78 -68 42 -9 98 -38 125 -65 26 -26 64 -47 85
-47 20 0 37 -10 37 -22 0 -12 -20 -21 -44 -19 -30 2 -46 -17 -51 -62 -9 -78
29 -98 206 -112 156 -12 190 -43 114 -105 -70 -57 -46 -116 39 -94 43 10 62 2
73 -36 13 -40 40 -51 133 -54 105 -4 108 -5 26 -14 -143 -15 -264 -207 -152
-243 27 -8 60 -41 75 -72 14 -32 83 -106 152 -164 122 -102 127 -104 154 -53
42 78 83 32 68 -76 -7 -52 -1 -106 15 -122 19 -19 15 -27 -16 -27 -23 0 -42
11 -42 25 0 14 -23 25 -50 25 -27 0 -50 -10 -50 -23 0 -12 -37 -35 -81 -51
-78 -28 -79 -30 -33 -65 27 -20 68 -36 91 -36 27 0 60 -41 89 -111 31 -74 65
-116 103 -126 39 -10 62 -39 72 -89 11 -50 30 -74 62 -74 50 0 63 37 22 63
-33 20 -32 105 1 125 75 46 140 -134 96 -262 -26 -75 -36 -81 -132 -86 -70 -4
-77 -58 -10 -80 58 -20 92 -19 233 3 94 15 162 -91 98 -155 -56 -56 -43 -131
27 -163 41 -18 59 -42 50 -66 -8 -20 8 -61 35 -90 70 -74 35 -125 -56 -83 -55
25 -67 46 -61 107 9 99 -65 105 -76 5 -22 -185 -277 -169 -330 21 -41 146 -29
167 68 119 45 -21 98 -32 119 -24 55 21 47 91 -10 91 -27 0 -55 21 -64 47 -8
26 -38 54 -66 61 -32 8 -45 25 -34 43 19 30 -102 146 -154 148 -15 1 -77 52
-137 114 -60 61 -123 112 -141 112 -18 0 -43 28 -56 63 -27 71 -56 78 -100 24
-19 -22 -52 -32 -79 -23 -31 10 -46 2 -46 -25 0 -21 11 -39 25 -39 14 0 25
-17 25 -37 0 -72 -197 -50 -225 25 -16 43 -43 62 -85 62 -34 0 -69 11 -77 25
-23 36 -64 31 -57 -6 4 -21 -32 -34 -106 -39 -147 -11 -201 -123 -121 -252 41
-65 8 -137 -54 -121 -39 10 -50 1 -50 -43 0 -34 -22 -67 -56 -82 l-56 -27 65
-25 c36 -15 88 -55 116 -91 67 -84 150 -85 171 0 9 37 4 77 -12 93 -37 37 -36
68 3 67 60 -1 133 -87 169 -199 20 -62 59 -136 87 -164 51 -51 113 -168 113
-212 0 -77 -162 66 -204 180 -22 60 -30 63 -96 38 -60 -22 -81 -19 -124 19
-28 26 -52 42 -53 37 -1 -6 -7 -97 -14 -203 -10 -174 -6 -196 40 -225 53 -33
67 -130 29 -191 -39 -62 -115 -17 -190 113 -78 132 -171 208 -258 208 -27 0
-63 17 -80 38 -21 24 -77 37 -167 37 -81 0 -174 19 -233 47 -82 40 -99 42
-111 11 -10 -27 -35 -32 -87 -21 -47 10 -102 1 -152 -25 -81 -41 -150 -35
-150 14 0 14 34 38 75 53 41 14 75 37 75 51 0 42 -102 170 -135 170 -42 0 -90
108 -90 200 0 71 -143 250 -200 250 -13 0 -37 25 -53 55 -16 30 -64 90 -107
133 -43 43 -106 119 -140 169 -34 51 -81 92 -103 92 -23 1 -74 18 -113 38 -39
21 -90 38 -113 38 -22 0 -47 17 -55 38 -16 41 -66 51 -66 12 0 -14 23 -47 50
-75 28 -27 50 -64 50 -80 0 -23 -7 -23 -30 0 -16 16 -55 30 -86 30 -73 0 -91
32 -88 164 3 135 77 223 169 200 39 -10 60 -33 60 -66 0 -45 11 -50 75 -35 62
13 75 8 76 -30 0 -25 28 -78 61 -119 52 -64 65 -69 101 -38 36 29 45 28 66 -8
13 -24 39 -43 58 -43 18 0 56 -31 84 -69 59 -81 67 -76 88 63 15 97 11 109
-43 130 -32 12 -65 37 -72 56 -7 18 -45 36 -85 39 -39 4 -100 27 -134 52 -34
25 -126 76 -203 113 -145 71 -247 150 -247 192 0 42 -143 27 -160 -16 -13 -33
-22 -35 -54 -9 -47 40 -75 12 -95 -95 -14 -77 17 -115 41 -50 9 24 19 25 43 2
25 -23 21 -43 -22 -97 -60 -77 -71 -186 -19 -186 19 0 51 24 71 54 21 32 48
47 65 36 42 -25 38 -49 -19 -113 -26 -31 -53 -70 -59 -86 -8 -21 -23 -21 -57
-1 -37 22 -54 19 -77 -12 -25 -36 -39 -36 -112 -6 -115 47 -221 63 -221 35 0
-35 78 -98 145 -119 55 -16 111 -106 89 -142 -17 -29 -159 56 -159 95 0 20
-11 30 -25 22 -14 -9 -25 -42 -25 -75 0 -98 -58 -85 -131 30 -38 60 -69 115
-69 123 0 47 -159 158 -190 132 -41 -34 -75 27 -51 91 12 29 26 32 64 12 27
-14 66 -19 89 -10 22 8 62 -5 89 -29 49 -45 59 -37 50 44 -3 28 13 44 45 44
26 0 80 16 119 37 39 20 96 30 128 22 100 -25 63 40 -51 89 -60 26 -161 98
-225 162 -65 63 -131 115 -147 115 -23 0 -23 7 0 30 17 17 30 56 30 88 0 40
14 57 50 57 31 0 50 -17 50 -44 0 -64 218 -231 301 -231 39 0 74 -13 79 -28 5
-15 31 -23 58 -18 39 7 29 20 -50 60 -60 31 -116 84 -138 131 -29 60 -54 79
-107 79 -49 1 -76 18 -91 58 -12 32 -40 73 -62 91 -31 26 -34 42 -12 68 15 18
22 56 15 84 -11 41 -1 50 58 50 74 0 149 -76 149 -150 0 -21 51 -86 112 -145
100 -93 119 -102 163 -74 52 33 66 69 27 69 -13 0 -55 44 -94 99 -50 70 -92
101 -145 107 l-75 9 65 28 c98 42 113 109 36 170 -35 28 -64 65 -64 82 0 17
-34 38 -75 46 -80 16 -107 117 -47 177 39 39 8 78 -82 101 -89 23 -162 180
-120 259 13 24 24 66 24 92 0 80 148 153 338 165 41 2 99 18 129 35 68 37 114
38 236 1 109 -32 128 -71 37 -71 -103 0 -138 -26 -155 -118 -12 -62 -6 -94 18
-109 53 -34 65 -28 83 43 13 50 24 59 45 38 48 -48 94 -32 94 32 0 71 39 104
82 70 99 -78 243 -57 243 34 0 33 10 60 22 60 40 0 53 -76 22 -125 -25 -40
-21 -58 26 -107 30 -32 55 -84 55 -114 0 -31 20 -62 44 -70 122 -40 206 -90
206 -123 0 -41 -113 -50 -137 -11 -9 14 -31 25 -50 25 -42 0 10 -117 67 -153
25 -17 24 -21 -6 -22 -61 0 -149 74 -149 125 0 66 -153 136 -254 115 -43 -8
-92 -3 -110 11 -48 40 -161 2 -161 -54 0 -26 10 -47 21 -47 43 0 150 -120 158
-178 14 -97 59 -43 52 61 -9 122 67 122 99 1 21 -83 75 -119 144 -97 24 8 61
-7 86 -34 41 -46 39 -50 -37 -104 -69 -50 -86 -53 -132 -24 -86 54 -340 50
-435 -6 -84 -50 -99 -80 -56 -106 64 -40 15 -56 -65 -23 -109 46 -130 32 -83
-56 45 -84 97 -103 136 -50 33 45 162 20 162 -31 0 -13 7 -42 15 -63 9 -23 2
-40 -16 -40 -26 0 -149 -112 -149 -135 0 -5 64 -16 143 -25 78 -9 162 -35 187
-57 37 -34 50 -35 85 -6 35 29 47 26 88 -28 145 -187 247 -249 247 -149 0 48
2 48 47 6 39 -37 41 -48 10 -72 -62 -51 58 -213 142 -192 22 6 69 -21 106 -63
36 -40 80 -80 99 -89 26 -12 27 -18 2 -30 -44 -20 -39 -60 8 -60 42 0 186
-131 186 -168 0 -38 62 -157 81 -157 11 0 19 -11 19 -25 0 -43 -38 -27 -139
59 -114 97 -233 136 -264 86 -32 -50 -26 -195 8 -195 84 0 245 -107 245 -163
0 -32 38 -99 86 -150 47 -50 90 -115 94 -145 12 -85 84 -69 75 16 -9 89 78 87
90 -2 9 -59 135 -83 168 -31 53 87 256 -22 336 -181 41 -81 151 -99 151 -24 0
25 12 57 27 72 37 37 -22 129 -89 138 -37 6 -49 24 -46 73 3 48 -13 73 -59 94
-43 20 -58 42 -47 70 20 53 -33 212 -84 250 -36 26 -35 31 7 48 32 12 55 4 70
-24 19 -32 34 -36 72 -15 43 22 49 17 49 -38 0 -36 17 -71 38 -79 27 -11 31
-24 13 -46 -36 -42 -4 -185 47 -212 73 -39 118 10 86 94 -22 59 -18 91 20 169
47 97 46 161 -3 161 -14 0 -26 -28 -26 -62 0 -35 -11 -63 -25 -63 -14 0 -25
27 -25 60 0 36 -25 76 -65 102 -48 31 -61 56 -50 99 21 86 -9 94 -92 25 -71
-61 -76 -61 -123 -19 -46 42 -50 42 -73 1 -36 -63 -107 -58 -73 5 37 68 -8
172 -87 202 -35 13 -70 41 -78 62 -8 21 -41 38 -74 38 -43 0 -60 14 -60 50 0
73 108 65 187 -15 50 -49 73 -58 99 -36 39 32 12 196 -37 227 -18 10 -22 40
-12 73 12 38 4 64 -25 86 -36 26 -38 41 -14 86 35 65 98 71 119 10 9 -24 60
-86 114 -138 109 -105 117 -180 20 -181 -66 -1 -94 -58 -99 -201 -2 -81 102
-202 149 -173 38 23 28 178 -13 212 -60 50 -46 68 88 113 134 44 237 28 324
-51 37 -33 49 -29 113 38 39 41 82 75 96 75 61 0 115 81 88 131 -30 56 -149
50 -419 -20 l-139 -36 -56 69 c-31 38 -57 80 -57 95 -2 69 -72 165 -145 200
-64 30 -81 54 -81 110 0 49 -15 77 -46 87 -25 8 -60 42 -78 74 -65 122 -228
139 -190 20 14 -45 58 -70 195 -114 27 -9 44 -39 44 -78 0 -74 4 -74 -96 -24
-43 22 -101 32 -128 24 -39 -13 -57 2 -84 69 -20 46 -71 124 -114 173 -86 98
-98 133 -39 110 22 -8 60 -4 85 10 33 17 54 14 76 -13 17 -20 41 -37 53 -37
30 0 28 118 -3 138 -43 26 -27 106 24 119 43 11 45 20 19 78 -35 74 -86 84
-130 24 -20 -27 -47 -35 -84 -23 -74 24 -68 64 9 64 73 0 145 114 92 147 -40
25 -66 168 -34 188 14 9 33 -8 42 -36 23 -74 73 -46 82 47 9 92 11 92 94 38
50 -32 76 -35 123 -14 46 21 66 19 88 -7 38 -46 -38 -88 -129 -71 -51 10 -74
0 -96 -42 -41 -77 -16 -150 126 -361 127 -190 143 -235 98 -280 -27 -27 -7
-109 27 -109 32 0 98 -148 83 -186 -9 -25 10 -33 70 -30 69 3 88 -9 120 -77
30 -61 47 -75 76 -56 21 13 62 23 92 24 56 0 100 78 71 125 -9 14 -53 25 -99
25 -46 0 -96 16 -112 35 -16 19 -55 42 -88 50 -32 8 -66 33 -74 56 -22 57 4
76 42 29 46 -59 148 -77 134 -24 -6 23 -18 72 -27 110 -8 38 -26 69 -39 69
-14 0 -25 18 -25 40 0 22 -34 83 -75 135 -73 93 -113 273 -45 205 28 -28 145
-43 145 -19 0 7 -28 53 -62 104 -72 105 -79 155 -25 176 20 8 37 30 37 49 0
19 20 35 44 35 24 1 69 7 99 16 44 11 61 1 79 -45 13 -34 41 -76 63 -94 22
-18 40 -55 40 -81 0 -64 72 -171 115 -171 19 0 35 -14 35 -31 1 -22 7 -21 23
4 25 40 -62 177 -112 177 -57 0 -57 99 0 183 44 65 51 92 29 122 -49 67 -134
78 -180 24 -67 -79 -188 -27 -168 73 12 61 4 76 -51 97 -75 28 -79 45 -33 133
l32 63 98 -59 c54 -33 106 -82 117 -110 28 -76 151 -71 140 5 -5 41 -27 59
-78 65 -94 10 -83 92 13 92 103 0 107 29 6 48 -62 12 -96 34 -105 68 -7 27
-39 60 -72 72 -73 28 -78 112 -9 149 107 57 -10 200 -165 200 -85 0 -140 56
-117 120 16 44 -39 105 -95 105 -58 0 -87 -46 -51 -82 15 -15 28 -50 28 -77 0
-27 18 -70 41 -95 38 -42 38 -46 0 -61 -62 -23 -116 7 -116 65 0 29 -19 81
-42 116 -35 53 -37 73 -11 114 28 44 23 60 -37 123 -62 65 -64 72 -20 72 27 0
68 -22 92 -50 56 -66 113 -63 123 6 11 83 95 87 158 9 48 -61 58 -64 137 -36
65 22 87 22 95 0 18 -55 101 -83 158 -53 80 44 107 -4 54 -97 -37 -64 -39 -87
-14 -127 17 -28 24 -68 16 -90 -18 -48 35 -232 84 -290 18 -22 26 -59 17 -82
-12 -31 -1 -47 37 -57 60 -16 74 -108 16 -108 -48 0 -47 -24 2 -87 36 -48 40
-48 71 -7 73 99 389 34 389 -81 0 -26 23 -54 50 -62 27 -9 50 -33 50 -53 0
-53 69 -71 117 -32 23 19 65 35 93 35 35 0 55 18 60 56 9 63 -1 68 -64 29 -64
-39 -175 10 -185 82 -5 35 -40 73 -89 98 -179 89 -205 149 -57 129 81 -11 100
-6 100 27 0 26 -21 41 -59 41 -63 0 -191 155 -191 231 0 58 -47 82 -162 82
-119 0 -146 69 -32 82 57 7 69 20 69 80 0 67 -6 72 -94 67 -106 -5 -154 41
-54 53 56 7 67 24 87 137 26 147 97 186 189 103 44 -40 52 -41 88 -5 39 40 12
145 -38 145 -11 0 -50 27 -86 60 -57 54 -60 64 -26 92 34 29 33 37 -10 71 -68
55 -85 118 -42 153 51 42 45 74 -14 74 -53 0 -69 60 -24 88 18 11 14 37 -12
76 -43 65 -53 186 -15 186 13 0 38 -31 56 -69 57 -117 108 -88 108 63 0 72 3
131 7 131 3 0 48 -17 98 -38 95 -40 172 -32 144 14 -9 15 14 55 51 89 129 119
-51 170 -272 76 -125 -53 -166 -52 -166 5 0 34 -29 52 -112 71 l-113 26 0
-112 c0 -75 -14 -123 -40 -142 -33 -24 -36 -46 -14 -124 24 -85 21 -97 -22
-108 -63 -17 -63 -49 1 -69 28 -9 50 -32 50 -52 0 -61 -126 -42 -191 28 -65
70 -59 111 17 111 32 0 49 17 49 50 0 28 -9 50 -20 50 -62 0 -115 70 -82 110
21 25 27 69 18 116 -13 64 -6 79 45 99 34 12 73 46 88 74 15 28 44 51 64 51
21 0 37 9 37 21 0 12 48 36 106 55 59 18 120 43 137 56 46 34 132 -5 158 -72
24 -64 60 -77 87 -33 10 14 -3 48 -28 75 -40 45 -40 53 -6 88 35 34 46 32 115
-26 41 -35 86 -64 98 -64 27 0 119 -103 124 -137 2 -14 5 -40 6 -57 2 -17 14
-31 28 -31 34 0 32 118 -2 139 -15 9 -24 61 -18 114 7 78 1 97 -34 97 -23 0
-71 37 -106 81 -59 75 -66 78 -104 40 -60 -60 -213 37 -204 129 6 72 88 100
129 44 15 -20 70 -44 124 -54 53 -10 126 -39 162 -65 72 -51 366 -81 366 -37
0 13 -28 25 -61 25 -34 1 -66 18 -73 38 -29 87 -164 129 -224 69 -39 -39 -70
-5 -34 38 39 47 8 71 -51 40 -70 -38 -181 -18 -190 33 -6 30 7 44 40 44 28 0
57 18 65 41 20 52 266 35 385 -26 83 -43 230 -54 230 -18 0 12 -34 36 -77 54
l-76 31 79 72 c65 60 74 79 48 110 -26 31 -19 51 39 112 73 76 137 97 137 45
0 -16 19 -51 42 -76 53 -59 14 -291 -67 -400 -27 -37 -50 -97 -50 -131 0 -35
-10 -64 -23 -64 -47 0 -102 -81 -102 -151 0 -40 -20 -92 -44 -117 -24 -24 -66
-88 -93 -141 -27 -53 -74 -106 -106 -118 -34 -13 -57 -43 -57 -74 0 -28 -31
-82 -68 -119 -38 -37 -65 -86 -62 -108 4 -23 -17 -101 -46 -175 -54 -137 -97
-369 -107 -572 -2 -62 -13 -125 -23 -141 -10 -16 -2 -61 18 -100 23 -43 38
-142 38 -246 1 -158 13 -198 119 -411 65 -130 135 -244 156 -254 21 -10 66
-30 100 -45 34 -15 79 -38 100 -51 21 -13 121 -64 223 -113 102 -50 201 -103
220 -119 53 -43 514 8 657 73 166 76 174 77 338 55 127 -17 162 -13 232 28 56
33 129 49 227 49 80 0 151 6 159 14 29 29 -14 110 -65 124 -29 7 -97 27 -151
43 l-98 30 -105 -119 -104 -119 -67 87 c-36 48 -66 96 -67 107 0 11 -49 57
-108 102 -59 44 -146 136 -192 204 -87 127 -159 177 -258 177 -31 0 -78 17
-105 38 -27 20 -122 85 -211 144 -196 129 -356 279 -407 381 -21 41 -62 96
-90 122 -29 26 -53 60 -53 74 0 15 -47 68 -104 117 -167 144 -82 245 94 112
45 -35 91 -63 102 -63 11 -1 49 -31 83 -67 63 -67 361 -314 461 -383 29 -21
95 -63 144 -95 50 -32 109 -86 132 -120 32 -49 49 -57 75 -35 25 20 38 19 53
-4 10 -17 6 -35 -11 -40 -16 -6 -29 -22 -29 -36 0 -16 14 -15 36 4 48 40 89
12 89 -59 0 -31 7 -64 16 -73 34 -34 84 42 84 125 0 122 56 174 123 116 50
-43 50 -44 3 -124 l-48 -81 92 -89 c50 -49 106 -89 123 -89 18 0 63 -33 101
-74 101 -109 206 -84 206 48 0 62 17 109 50 139 57 51 65 103 19 119 -23 8
-14 44 31 130 l63 118 -57 38 c-31 21 -56 58 -56 82 0 24 -17 58 -37 75 -61
50 -44 75 49 75 61 0 97 -16 119 -50 47 -75 69 -61 69 45 0 103 36 159 91 138
41 -16 46 45 7 84 -41 41 -2 133 67 159 73 28 84 142 16 167 -64 24 -80 58
-81 176 0 58 -10 106 -22 106 -36 0 -53 70 -36 151 l15 76 46 -76 c27 -45 47
-124 47 -188 0 -128 36 -163 101 -97 93 94 89 177 -11 236 -49 29 -90 69 -90
89 0 49 68 71 111 35 52 -43 150 12 125 70 -49 114 -40 174 46 296 48 68 94
147 103 176 9 29 33 66 53 83 21 16 37 71 37 121 0 73 23 118 113 220 61 71
112 153 112 184 0 30 32 92 72 137 45 51 78 123 88 193 9 62 33 133 53 159 58
78 43 127 -57 179 -126 65 -133 122 -20 169 49 21 89 55 89 76 0 55 -69 211
-94 211 -52 0 1 179 62 207 55 25 60 39 47 123 -17 107 32 295 77 295 16 0 38
25 47 56 10 31 29 64 43 73 17 10 11 32 -15 58 -50 49 -53 96 -12 171 16 30
31 116 33 192 1 76 12 174 23 218 19 77 16 82 -83 121 -57 23 -103 51 -103 62
0 29 94 56 125 36 15 -9 57 19 94 61 81 93 120 97 141 15z m-24209 -105 c16
-77 23 -179 16 -225 -18 -108 45 -268 98 -248 45 17 77 -53 40 -90 -14 -14
-20 -42 -13 -61 31 -80 -15 -159 -92 -159 -84 0 -97 -40 -31 -91 41 -32 41
-36 0 -68 -24 -19 -44 -54 -44 -79 0 -25 -18 -66 -41 -90 -49 -55 -28 -122 37
-122 42 0 50 -26 66 -212 18 -218 0 -413 -38 -413 -47 0 -77 354 -39 481 16
55 12 69 -20 69 -22 0 -40 -10 -40 -23 0 -26 -97 -63 -116 -44 -6 6 4 49 23
96 68 163 73 218 20 204 -65 -17 -119 79 -74 133 29 35 79 34 182 -6 29 -11
40 -1 40 37 0 30 -16 53 -37 53 -32 0 -88 71 -88 111 0 8 28 8 63 -1 72 -18
79 5 21 68 -22 25 -33 62 -25 84 19 49 66 50 66 1 0 -21 17 -38 38 -38 42 0
51 64 12 88 -14 8 -25 35 -25 60 0 25 -21 72 -46 105 -26 33 -55 121 -64 195
-10 75 -29 157 -43 183 -20 37 -16 60 17 96 73 80 106 57 137 -94z m-1201 -13
c0 -49 -62 -62 -88 -19 -9 15 -9 57 0 94 16 65 18 66 53 19 19 -27 35 -69 35
-94z m2388 45 c22 -33 61 -66 88 -73 70 -18 60 -60 -25 -104 -119 -62 -169
-48 -240 64 -36 57 -61 106 -57 109 12 10 154 60 177 62 10 1 36 -25 57 -58z
m3982 4 c-4 -32 -29 -60 -56 -65 -26 -5 -64 -25 -83 -44 -49 -50 -111 -44
-101 9 6 27 27 41 60 36 35 -4 61 14 80 57 37 80 112 86 100 7z m4609 31 c57
0 8 -136 -54 -150 -80 -19 -101 -137 -33 -189 32 -24 35 -35 11 -35 -36 -1
-278 221 -278 255 0 11 42 13 94 5 88 -14 95 -10 124 65 22 58 41 76 71 65 22
-9 51 -16 65 -16z m-8034 -68 c106 -69 140 -162 81 -221 -14 -14 -28 -119 -33
-235 -5 -135 -19 -214 -38 -220 -37 -12 -40 -166 -4 -232 17 -33 16 -83 -4
-163 -22 -87 -22 -147 0 -244 21 -95 22 -168 2 -276 -34 -182 0 -291 90 -291
68 0 106 -47 61 -75 -38 -23 -125 -3 -125 29 0 13 -11 17 -25 9 -49 -31 -27
-162 38 -218 63 -55 80 -161 46 -290 -19 -70 -69 -59 -80 19 -4 31 -30 62 -56
69 -27 7 -55 41 -64 74 -19 76 9 2000 30 2074 22 78 -30 159 -102 159 -35 0
-62 15 -62 33 0 90 106 89 245 -1z m-1297 -104 c12 -22 29 -91 39 -153 26
-158 31 -161 124 -63 45 49 103 88 128 88 36 0 39 7 16 30 -40 40 -38 95 4 95
18 0 55 -24 81 -53 80 -90 201 -129 299 -96 102 33 186 12 186 -47 0 -38 -29
-43 -225 -43 -167 0 -225 8 -225 32 0 18 -17 32 -37 32 -21 0 -38 -18 -38 -40
0 -22 -34 -83 -75 -135 -88 -111 -94 -163 -25 -200 57 -30 66 -106 18 -146
-57 -47 -119 23 -223 252 -17 38 -39 69 -48 69 -52 0 -196 443 -157 482 21 20
131 -53 158 -104z m8597 30 c-11 -132 -70 -140 -70 -10 0 76 10 102 39 102 30
0 37 -22 31 -92z m5551 31 c11 -58 -27 -95 -79 -75 -49 19 -54 64 -12 106 39
39 80 25 91 -31z m-7646 -39 c0 -41 -11 -75 -25 -75 -28 0 -35 107 -8 133 28
29 33 20 33 -58z m4200 -63 c0 -57 14 -94 39 -103 28 -11 34 -35 23 -87 -12
-55 -7 -72 22 -72 21 0 48 -14 59 -31 11 -18 52 -48 91 -69 40 -20 90 -74 111
-118 43 -89 82 -103 130 -44 85 102 198 -15 199 -208 1 -157 65 -260 207 -333
52 -26 94 -58 94 -71 0 -12 25 -30 55 -40 50 -16 47 -21 -37 -54 -51 -21 -93
-47 -93 -60 0 -41 -84 -22 -141 32 -52 49 -59 50 -74 11 -11 -27 3 -61 38 -94
54 -50 62 -122 15 -126 -14 -1 -36 21 -49 50 -39 84 -131 114 -148 48 -8 -29
-1 -68 14 -87 92 -111 363 -119 352 -11 -6 50 2 53 112 39 65 -8 147 -30 181
-48 34 -19 99 -53 143 -77 68 -36 91 -38 141 -11 143 77 249 -61 244 -317 -4
-158 23 -195 90 -128 21 21 42 7 80 -56 59 -96 62 -113 27 -134 -42 -27 -28
-81 25 -95 28 -7 50 -31 50 -53 0 -23 21 -40 50 -40 60 0 68 79 13 125 -56 46
-51 161 6 137 24 -10 63 -23 87 -30 30 -9 44 -38 44 -92 0 -84 37 -140 93
-140 42 0 42 92 -1 118 -38 23 -106 289 -83 326 25 41 -54 202 -122 246 -34
22 -62 56 -62 74 0 19 -24 56 -53 83 -50 47 -47 103 5 103 13 0 73 -45 133
-100 66 -61 124 -95 146 -86 44 16 79 -67 71 -170 -6 -73 80 -103 106 -38 10
23 14 23 15 2 1 -17 -9 -37 -23 -45 -48 -30 -28 -113 27 -113 67 0 152 -46
194 -105 25 -35 52 -43 113 -32 100 19 220 -87 176 -156 -53 -84 -112 -99
-153 -38 -21 31 -60 56 -87 56 -28 0 -55 21 -62 47 -16 63 -102 99 -202 84
-112 -16 -122 -46 -32 -93 42 -22 76 -48 76 -60 0 -11 68 -72 150 -136 85 -67
150 -136 150 -162 0 -25 34 -78 75 -117 88 -85 94 -113 25 -113 -96 0 -44
-118 87 -200 73 -45 83 -62 63 -100 -34 -63 -33 -66 28 -123 50 -46 52 -127 3
-127 -11 0 -74 62 -140 138 -66 75 -129 132 -141 125 -42 -26 43 -218 133
-301 106 -98 120 -162 33 -162 -135 0 -172 -148 -45 -181 65 -17 236 86 275
165 l33 68 83 -70 c47 -38 85 -88 86 -110 3 -58 -274 -310 -299 -271 -12 20
-43 25 -90 13 -69 -17 -70 -19 -21 -53 126 -87 141 -128 73 -197 -53 -53 -111
-49 -111 6 0 25 -17 67 -37 94 -20 27 -37 85 -37 130 -1 94 -30 104 -81 26
-37 -54 -37 -54 -78 29 -50 100 -53 151 -11 152 18 0 8 20 -21 45 -78 65 -104
229 -36 229 76 0 62 45 -18 55 -38 4 -67 19 -65 33 24 153 26 150 -62 143 -94
-8 -102 51 -8 64 70 11 69 47 -2 69 -31 9 -90 42 -131 72 -91 67 -234 139
-277 139 -32 0 -73 121 -49 145 8 8 58 3 110 -11 103 -27 175 6 210 97 20 53
101 58 142 8 46 -56 7 -94 -76 -76 -63 14 -73 9 -73 -38 0 -83 44 -147 93
-134 30 8 75 -26 139 -102 109 -130 122 -134 192 -59 60 64 65 95 15 95 -43 0
-144 122 -125 153 8 12 41 22 75 22 38 0 61 14 61 38 0 25 -25 37 -76 37 -74
0 -76 3 -60 88 16 81 12 87 -49 87 -50 0 -65 13 -65 53 0 41 -11 50 -52 39
-31 -8 -56 1 -65 22 -22 58 -83 42 -83 -22 0 -85 -113 -143 -158 -82 -30 41
-34 40 -61 -20 -55 -119 -243 -118 -394 3 -136 109 -82 151 85 67 44 -22 96
-33 116 -26 40 16 52 141 14 141 -13 0 -31 23 -39 50 -9 28 -28 50 -42 50 -14
0 -59 23 -99 52 -52 37 -93 47 -144 36 -62 -14 -74 -7 -88 48 -9 36 -60 93
-116 130 -101 67 -135 133 -120 233 7 44 -10 62 -85 88 -52 18 -112 47 -134
65 -34 28 -45 27 -72 -9 -38 -53 -72 -55 -113 -6 -37 46 -75 27 -75 -37 0 -42
-9 -44 -75 -21 -41 14 -75 36 -75 48 0 11 -22 33 -50 48 -43 23 -50 19 -50
-25 0 -28 20 -59 44 -68 64 -24 106 -88 90 -140 -18 -60 81 -200 177 -251 54
-29 124 -38 239 -32 135 7 172 0 219 -42 49 -45 82 -192 42 -192 -40 0 -111
56 -111 88 0 26 -27 37 -87 37 -77 0 -88 -8 -88 -61 0 -34 -20 -73 -44 -87
-38 -23 -39 -29 -6 -51 25 -16 29 -32 12 -49 -17 -17 -70 14 -163 98 -182 165
-304 206 -371 123 -48 -60 -48 -60 12 -119 57 -58 62 -59 123 -18 62 40 67 39
125 -16 34 -32 61 -76 62 -98 0 -28 31 -46 97 -56 73 -12 118 -40 174 -110 62
-77 81 -88 108 -60 28 27 24 40 -19 76 -40 32 -50 62 -41 122 6 44 0 113 -14
154 -32 89 17 154 68 92 23 -28 23 -60 -1 -140 -26 -86 -25 -108 4 -125 45
-29 74 -8 74 51 0 51 61 67 88 24 10 -17 31 -17 62 0 58 31 82 0 70 -94 -6
-51 5 -70 42 -77 28 -6 77 -31 110 -57 33 -26 102 -54 153 -62 115 -19 131
-30 169 -116 16 -38 50 -69 74 -69 25 0 67 -33 94 -74 27 -40 75 -85 106 -99
74 -34 72 -72 -5 -102 -103 -39 -75 -107 80 -194 75 -41 82 -40 82 19 0 59 63
67 85 11 23 -60 -53 -153 -139 -170 -95 -20 -121 -4 -121 73 0 34 -22 74 -50
92 -27 17 -50 45 -50 62 0 80 -357 285 -408 234 -44 -44 -104 -31 -167 36 -32
34 -85 62 -117 62 -60 0 -78 35 -33 63 40 24 0 68 -50 55 -30 -8 -54 8 -73 49
-34 75 -77 65 -127 -28 -29 -55 -30 -73 -6 -82 17 -6 31 -30 30 -53 0 -37 -5
-36 -36 5 -46 61 -88 31 -88 -63 0 -47 29 -113 75 -171 58 -74 75 -120 75
-208 0 -101 7 -115 69 -137 l69 -24 -74 -29 c-63 -25 -83 -22 -143 22 -38 28
-87 51 -108 51 -22 0 -46 17 -54 38 -10 25 -43 36 -99 33 -46 -4 -90 1 -99 10
-33 32 20 69 99 69 50 0 100 19 127 49 42 47 41 52 -32 125 -45 44 -102 76
-139 76 -35 0 -70 12 -79 26 -9 14 -38 19 -64 11 -36 -12 -48 -3 -48 35 0 27
-11 57 -25 66 -37 23 -5 62 51 62 40 0 45 12 33 76 l-16 76 163 -17 c241 -24
254 78 14 108 -127 16 -195 47 -195 89 0 29 -76 90 -119 96 -10 1 -48 24 -85
50 -36 26 -79 47 -94 47 -34 0 -35 -42 -2 -62 27 -17 35 -120 11 -144 -28 -27
-274 125 -306 190 -18 36 -43 66 -56 66 -13 0 -24 34 -24 76 0 98 -111 161
-162 92 -50 -69 -83 -51 -151 84 -53 103 -71 121 -100 98 -34 -29 -87 -15 -87
22 0 11 28 33 63 48 38 18 62 19 62 4 0 -69 103 -16 151 77 41 81 61 98 100
86 29 -9 49 -4 49 13 0 17 42 25 113 20 140 -9 149 -55 12 -65 -106 -8 -123
-30 -62 -80 60 -50 44 -95 -32 -91 -38 2 -68 -8 -68 -21 0 -25 67 -30 135 -11
26 8 42 -24 58 -111 29 -169 169 -350 169 -220 0 70 29 83 79 38 26 -23 53
-35 61 -27 32 32 -22 116 -115 181 -101 69 -110 112 -24 112 51 0 111 86 86
126 -24 38 -80 28 -98 -18 -12 -33 -22 -35 -46 -11 -24 25 -21 36 13 56 24 13
44 42 44 64 0 42 158 295 201 321 13 8 24 59 24 112 0 72 12 100 46 111 27 9
45 37 43 71 -1 44 15 58 81 68 89 14 94 25 55 136 -20 57 -32 67 -55 44 -49
-49 -120 -34 -144 31 -13 34 -47 73 -75 88 -60 33 -67 76 -12 76 22 0 68 -34
102 -75 70 -83 152 -105 120 -31 -11 24 -18 74 -16 112 5 110 -169 199 -205
105 -9 -25 -38 -37 -82 -31 -82 9 -104 60 -34 82 63 20 65 48 5 106 -25 24
-53 63 -61 86 -9 27 -57 47 -139 58 -93 13 -127 29 -137 65 -8 32 -34 48 -77
48 -50 0 -65 13 -65 53 0 45 6 48 39 21 32 -27 46 -25 81 11 40 41 40 45 -1
76 -51 37 -58 115 -14 159 57 57 95 33 95 -58z m-11447 38 c14 0 21 -53 17
-119 -6 -101 -16 -120 -64 -126 -54 -8 -81 -55 -31 -55 14 0 25 -17 25 -37 0
-21 14 -38 31 -38 63 0 173 -111 155 -156 -30 -78 -138 -31 -172 75 -22 71
-37 70 -118 -5 -71 -66 -95 -49 -97 69 0 64 -68 153 -133 176 -70 25 -1 99 74
80 84 -21 139 8 122 64 -17 51 70 104 134 83 18 -6 44 -11 57 -11z m6411 -3
c31 -49 -47 -71 -247 -72 -227 0 -264 54 -44 65 72 3 138 13 146 21 25 25 127
15 145 -14z m-4623 -36 c9 -21 8 -45 0 -54 -25 -24 -146 40 -128 68 23 39 112
29 128 -14z m1323 12 c26 -42 -32 -90 -67 -55 -29 29 -11 82 28 82 12 0 30
-12 39 -27z m18239 -17 c78 -52 249 -231 220 -231 -10 0 -55 -52 -98 -116 -71
-106 -76 -127 -61 -250 11 -92 8 -134 -11 -134 -15 0 -28 -11 -28 -24 0 -14
17 -18 38 -10 21 8 69 2 108 -14 49 -21 90 -22 137 -4 85 33 90 88 6 67 -60
-15 -60 -13 -53 143 11 228 29 269 110 262 37 -2 81 3 97 13 16 10 36 6 44 -8
9 -14 34 -25 55 -25 34 0 109 -69 227 -210 17 -21 31 -60 31 -87 0 -28 11 -57
25 -65 14 -9 25 -50 25 -92 0 -41 20 -101 45 -133 85 -108 119 -256 71 -309
-25 -28 -35 -64 -26 -90 9 -23 5 -67 -10 -97 -14 -30 -31 -99 -38 -154 -12
-109 -131 -313 -182 -313 -79 0 -139 249 -84 352 18 33 18 48 0 48 -45 0 -126
158 -126 244 0 44 -11 81 -25 81 -14 0 -25 17 -25 38 0 20 10 37 22 37 12 0
36 -17 53 -37 17 -21 69 -38 116 -38 109 0 125 111 22 150 -42 16 -63 43 -63
81 0 32 -18 84 -40 116 -34 47 -36 69 -11 123 26 57 23 70 -29 109 -31 24 -59
36 -62 26 -63 -263 -116 -380 -171 -380 -33 0 -66 -11 -74 -25 -9 -14 -4 -25
11 -25 14 0 26 -14 26 -32 0 -17 23 -73 50 -125 27 -51 50 -127 50 -168 0 -41
10 -75 22 -75 39 0 128 -255 128 -369 0 -76 13 -123 41 -143 67 -49 26 -155
-68 -176 -42 -9 -82 -33 -90 -52 -28 -74 -183 33 -183 127 0 24 -32 54 -73 70
-65 25 -72 37 -65 129 l8 102 132 12 c139 13 175 46 110 100 -33 27 -60 27
-157 -3 -112 -35 -122 -34 -223 23 -114 63 -127 93 -74 166 32 43 35 43 51 2
10 -25 32 -37 54 -29 21 8 63 5 93 -6 92 -34 124 -9 78 61 -25 39 -64 61 -106
61 -153 1 -253 31 -253 77 0 25 11 52 25 61 14 8 25 59 25 113 0 88 7 99 61
99 34 0 68 -11 77 -25 20 -32 154 -32 175 0 20 33 -136 175 -192 175 -23 0
-74 -12 -113 -27 -78 -29 -158 36 -158 130 0 26 -12 47 -26 47 -14 0 -36 28
-49 63 -13 34 -35 62 -49 62 -42 0 -29 104 17 138 36 27 37 38 9 72 -34 42
-11 52 58 25 46 -18 53 -87 12 -128 -58 -58 -9 -81 72 -32 91 56 106 123 31
143 -27 7 -50 33 -50 58 0 25 -29 80 -64 122 -36 42 -57 87 -49 101 31 51 101
25 134 -49 36 -80 92 -105 68 -30 -8 27 6 67 37 100 61 66 69 67 152 11z
m-12239 -36 c10 -31 25 -112 33 -182 13 -103 25 -127 69 -133 30 -4 74 -30 98
-57 57 -63 24 -100 -106 -121 -92 -14 -96 -20 -103 -121 -9 -126 -55 -143 -55
-21 0 86 -31 115 -126 115 -114 0 -72 116 47 130 66 7 67 10 74 226 7 213 34
276 69 164z m10031 -1 c8 -43 -136 -269 -172 -269 -31 0 -106 252 -82 275 60
58 243 53 254 -6z m1755 39 c0 -25 -105 -133 -129 -133 -35 0 -24 56 20 104
41 45 109 63 109 29z m-18144 -108 c5 -48 -6 -64 -50 -70 -45 -7 -56 4 -56 51
0 126 92 142 106 19z m2729 85 c63 -24 47 -85 -21 -85 -66 0 -101 35 -76 75
17 29 42 31 97 10z m4236 -44 c6 -33 -4 -43 -37 -37 -25 5 -50 30 -55 55 -6
33 4 43 37 37 25 -5 50 -30 55 -55z m706 8 c51 -28 62 -89 24 -148 -29 -45
-126 31 -126 99 0 74 29 88 102 49z m520 -123 c-2 -35 5 -83 15 -107 23 -56
-66 -62 -110 -8 -28 33 -17 190 18 249 21 37 80 -65 77 -134z m870 12 c-4 -91
6 -120 52 -151 74 -52 71 -87 -6 -87 -39 0 -63 14 -63 38 0 23 -24 37 -62 37
-39 0 -63 14 -63 38 0 20 -11 37 -25 37 -61 0 -22 122 55 171 102 65 117 54
112 -83z m-12375 47 c18 -48 -35 -88 -104 -79 -31 4 -54 29 -58 63 -10 70 136
84 162 16z m3929 -82 c7 -52 1 -58 -50 -44 -32 8 -67 15 -77 16 -11 0 -19 23
-19 52 0 79 134 57 146 -24z m14380 33 c26 -32 26 -45 -3 -74 -54 -54 -148
-20 -148 53 0 71 98 85 151 21z m-13467 -38 c98 -77 86 -123 -33 -123 -54 0
-105 -11 -113 -25 -43 -70 -202 9 -173 85 12 31 25 34 67 11 50 -27 118 21
118 84 0 37 67 21 134 -32z m14067 -51 c18 -77 89 -81 79 -3 -6 40 8 63 50 78
74 28 145 -8 145 -75 0 -36 -12 -47 -44 -37 -74 23 -156 -79 -156 -194 0 -68
-107 -153 -165 -131 -52 20 -43 65 13 65 54 0 87 71 62 134 -8 23 -40 41 -70
41 -74 0 -115 46 -115 128 0 115 173 110 201 -6z m-16516 -647 l-17 -87 -22
75 c-12 41 -14 225 -4 412 l19 338 20 -325 c12 -179 13 -365 4 -413z m4660
668 c80 -64 85 -119 19 -205 -35 -47 -64 -97 -64 -112 0 -27 -137 57 -187 115
-53 60 -183 67 -218 11 -20 -32 -58 -52 -101 -52 -89 0 -87 -23 9 -102 90 -74
85 -132 -19 -207 -83 -61 -122 -24 -145 138 -14 99 -9 122 33 151 27 19 57 65
66 102 10 38 36 70 58 72 23 3 64 7 92 9 27 3 64 7 81 8 44 6 39 54 -6 54 -21
0 -38 11 -38 24 0 52 354 46 420 -6z m2351 -13 c14 -102 -36 -130 -237 -130
-148 0 -184 7 -184 38 0 49 111 92 187 72 40 -10 73 1 105 36 58 65 118 57
129 -16z m3214 55 c51 -20 51 -50 -1 -70 -45 -18 -116 29 -95 63 16 26 42 28
96 7z m-8215 -85 c4 0 1 -11 -7 -25 -21 -33 -230 -32 -251 0 -24 40 92 70 175
47 41 -12 79 -22 83 -22z m8655 -12 c17 -21 56 -38 86 -38 30 0 67 -13 83 -29
22 -22 38 -21 66 2 56 46 127 12 180 -87 34 -64 72 -94 141 -113 68 -18 94
-38 94 -74 0 -27 16 -49 35 -49 38 0 73 -67 53 -100 -7 -11 -36 -14 -64 -7
-31 8 -63 -3 -82 -28 -27 -37 -38 -34 -117 33 -62 53 -114 75 -180 76 -114 1
-139 35 -64 88 55 40 53 41 -68 35 -131 -6 -152 22 -75 101 54 55 -69 144
-150 107 -68 -31 -129 17 -104 82 19 49 126 49 166 1z m11525 15 c0 -18 -105
-55 -181 -63 -47 -6 -16 49 36 64 86 24 145 24 145 -1z m-22330 -165 c1 -167
-21 -187 -99 -86 -32 43 -73 92 -90 111 -17 18 -31 45 -31 60 0 34 42 35 63 2
26 -43 81 -27 95 28 24 93 60 27 62 -115z m8325 91 c7 -43 -4 -54 -56 -54 -68
0 -84 45 -34 95 42 42 81 24 90 -41z m1205 47 c0 -14 34 -33 75 -44 l75 -20
-59 -111 c-74 -139 -132 -180 -174 -124 -16 22 -72 48 -124 58 -90 17 -109 72
-22 63 85 -8 104 3 104 62 0 94 26 140 78 140 26 0 47 -11 47 -24z m4279 -84
c-35 -37 -45 -67 -30 -91 15 -23 6 -56 -26 -97 -26 -33 -48 -74 -48 -90 0 -84
-61 -118 -138 -78 -41 21 -94 39 -117 39 -81 0 -68 45 50 172 74 80 140 128
174 128 31 0 56 11 56 25 0 14 17 25 38 25 21 0 46 19 55 42 11 30 20 33 27
11 6 -17 -13 -56 -41 -86z m-8570 38 c7 -11 3 -35 -8 -54 -13 -20 -2 -77 26
-144 82 -191 35 -313 -104 -269 -83 26 -140 283 -73 325 14 8 25 41 25 72 0
31 8 64 17 73 23 23 102 21 117 -3z m3322 -40 c44 -33 61 -115 25 -115 -11 0
-49 34 -86 75 -71 81 -29 109 61 40z m-7360 -79 c-13 -70 -71 -74 -71 -5 0 33
8 68 17 78 27 26 64 -24 54 -73z m1104 38 c0 -80 -366 -132 -425 -61 -28 33
-28 45 -2 61 44 27 427 27 427 0z m8300 -25 c51 -95 -42 -137 -129 -58 -69 63
-57 109 28 109 49 0 83 -17 101 -51z m10450 15 c0 -20 23 -43 50 -51 57 -19
68 -88 14 -88 -43 0 -144 122 -125 153 22 35 61 26 61 -14z m-5639 -28 c46
-46 49 -77 12 -100 -14 -9 -33 8 -40 36 -8 29 -24 53 -36 53 -12 0 -22 11 -22
25 0 37 41 30 86 -14z m-16512 -35 c66 -36 111 -174 63 -192 -63 -24 -117 11
-100 64 11 34 0 57 -36 77 -29 15 -46 38 -38 51 19 31 53 30 111 0z m23318
-60 c-44 -67 -167 -88 -167 -29 0 42 146 118 182 96 12 -7 5 -37 -15 -67z
m-22375 -32 c7 -19 40 -34 73 -34 l60 0 0 -419 c-1 -292 -8 -407 -26 -381 -15
22 -23 167 -19 346 l6 309 -69 50 c-38 28 -85 82 -105 120 -34 66 -33 69 16
57 28 -8 57 -29 64 -48z m2918 51 c22 -9 40 -37 40 -64 0 -41 -15 -48 -92 -41
-142 12 -138 63 9 118 2 1 22 -5 43 -13z m1166 -49 c39 -103 29 -112 -63 -58
-93 55 -109 85 -57 105 66 27 96 15 120 -47z m15199 12 c0 -64 -83 -57 -95 9
-6 30 7 43 43 43 36 0 52 -16 52 -52z m-16575 -8 c0 -19 -17 -41 -38 -49 -21
-8 -49 -43 -62 -78 -28 -75 -144 -129 -185 -87 -20 19 5 58 90 138 117 111
195 142 195 76z m14602 9 c33 -18 48 -52 48 -110 0 -47 13 -89 28 -94 46 -16
-1 -120 -54 -120 -70 0 -181 53 -231 111 -43 51 -44 51 -81 3 -47 -62 -47 -76
7 -129 53 -52 131 -165 131 -191 0 -46 -61 -11 -143 80 -84 94 -152 114 -122
36 7 -19 -2 -35 -21 -35 -98 0 -60 178 57 267 51 37 100 82 111 100 11 18 40
33 63 34 23 0 64 17 91 37 58 44 55 44 116 11z m-13930 -25 c97 2 128 -43 128
-187 0 -147 16 -162 177 -162 88 0 98 -6 98 -62 0 -35 11 -63 25 -63 30 0 33
-149 3 -196 -12 -20 -55 -29 -106 -25 -79 8 -84 14 -84 101 0 147 -157 247
-247 158 -38 -39 -41 -35 -41 43 0 105 -68 202 -223 316 -92 69 -47 113 95 92
64 -9 142 -16 175 -15z m488 -82 c67 -26 45 -63 -51 -90 -145 -40 -183 27 -78
137 52 54 58 55 73 13 9 -25 35 -52 56 -60z m5440 59 c0 -27 23 -62 52 -77 56
-30 27 -99 -43 -99 -19 0 -34 -26 -34 -62 0 -33 -23 -83 -51 -109 -51 -47 -51
-50 -7 -215 42 -160 42 -171 1 -244 -43 -74 -43 -78 19 -184 85 -145 83 -229
-6 -264 -38 -15 -88 -37 -112 -50 -24 -12 -110 -22 -192 -22 -106 0 -156 -11
-170 -37 -37 -67 -173 -76 -206 -15 -65 121 -87 18 -34 -158 13 -44 8 -43 -64
8 -43 30 -78 71 -78 91 0 19 -29 54 -65 78 -58 37 -61 46 -25 72 49 36 50 83
2 147 -20 27 -37 72 -37 100 0 31 -30 69 -75 94 -58 33 -75 60 -75 122 0 77 2
78 94 62 100 -17 461 -59 544 -62 38 -2 61 -36 96 -146 65 -201 141 -280 141
-148 0 41 25 70 88 99 91 44 108 77 56 111 -28 17 -94 169 -94 215 0 9 24 14
53 10 79 -8 87 53 11 81 -78 30 -107 92 -70 151 21 33 16 62 -23 125 -78 129
-11 241 204 342 88 41 100 39 100 -16z m-9514 -10 c39 -28 45 -62 39 -206 -13
-304 -11 -443 10 -631 25 -220 -7 -282 -73 -143 -24 50 -64 101 -88 115 -73
39 -87 163 -26 240 46 58 74 209 39 209 -8 0 -54 -17 -104 -38 -68 -28 -98
-30 -124 -9 -45 37 -44 195 2 245 20 22 78 87 128 146 99 114 126 124 197 72z
m7001 9 c78 -29 61 -75 -26 -75 -44 0 -61 14 -61 50 0 58 1 58 87 25z m5090
-1 c26 -14 48 -48 48 -75 0 -52 49 -65 90 -24 29 29 210 -15 210 -51 0 -13 24
-24 54 -24 114 0 200 -156 102 -184 -178 -50 -199 -47 -269 45 -37 49 -78 89
-90 89 -30 0 -28 -209 2 -239 16 -16 12 -58 -8 -119 -35 -100 -78 -115 -80
-28 -2 75 -61 143 -167 192 -52 24 -94 59 -94 79 0 55 28 115 53 115 35 0 122
-96 122 -136 0 -46 42 -73 62 -40 31 50 20 258 -15 278 -89 51 -128 93 -112
119 22 36 31 36 92 3z m-13964 -63 c0 -26 -20 -52 -44 -56 -44 -9 -64 67 -27
104 30 29 71 1 71 -48z m11912 -23 c0 -39 -14 -63 -37 -63 -49 0 -48 -23 3
-79 48 -53 159 -61 205 -15 25 25 52 9 132 -75 55 -58 129 -113 163 -122 79
-20 73 -118 -8 -129 -77 -11 -212 64 -207 115 6 60 -28 155 -54 155 -12 0 -22
-27 -22 -61 0 -81 -43 -104 -100 -52 -43 40 -48 39 -73 -8 -21 -39 -41 -46
-94 -32 -95 26 -99 70 -9 90 84 19 106 71 25 58 -39 -6 -68 21 -119 110 -73
128 -63 168 30 125 48 -21 68 -19 91 9 45 54 74 44 74 -26z m1031 18 c54 -9
69 -25 69 -74 0 -58 -7 -62 -79 -47 -100 20 -146 58 -146 121 0 37 10 45 44
31 24 -11 74 -24 112 -31z m-9194 -97 c51 -121 48 -134 -24 -134 -89 0 -126
82 -73 162 52 80 52 80 97 -28z m-3402 -18 c32 -171 -77 -290 -140 -154 -23
51 -19 79 19 150 60 111 101 112 121 4z m16217 58 c103 -55 -3 -200 -184 -249
-66 -17 -125 -42 -133 -53 -23 -39 -109 -23 -161 29 -56 56 -47 149 15 149 20
0 36 9 36 19 0 11 42 16 94 11 75 -7 105 4 154 55 66 71 104 79 179 39z
m-13710 -38 c4 -13 -3 -40 -16 -61 -32 -50 -89 5 -67 63 16 42 69 41 83 -2z
m3416 -42 c-3 -50 26 -85 144 -170 81 -59 148 -117 148 -128 0 -26 -150 -28
-151 -2 0 10 -44 45 -97 78 -101 63 -179 182 -129 198 15 5 27 32 27 59 0 29
13 46 31 39 17 -6 30 -39 27 -74z m-4963 -6 c81 -68 110 -139 78 -190 -27 -44
-117 34 -128 111 -12 87 -84 67 -75 -21 22 -215 17 -275 -20 -275 -36 0 -64
362 -32 418 21 38 105 17 177 -43z m5417 39 c8 -13 -4 -34 -27 -47 -28 -15
-35 -40 -24 -76 24 -74 64 -68 64 9 0 34 11 62 25 62 14 0 25 -11 25 -25 0
-14 22 -25 49 -25 26 0 55 11 64 25 24 39 86 29 154 -24 42 -33 84 -45 132
-35 44 9 94 -2 135 -28 69 -46 171 -36 295 27 71 36 138 -3 116 -69 -26 -76
-598 -111 -686 -42 -39 31 -152 1 -169 -44 -17 -43 -69 -47 -63 -4 8 66 -3 94
-39 94 -21 0 -38 -17 -38 -37 0 -58 -36 -46 -174 56 -154 114 -161 156 -27
156 54 0 105 11 114 25 19 31 55 32 74 2z m-3312 -167 c0 -47 -17 -44 -79 14
-35 32 -47 63 -35 93 16 42 22 41 66 -14 26 -32 48 -74 48 -93z m19000 90 c0
-28 -17 -50 -37 -50 -21 0 -38 22 -38 50 0 28 17 50 38 50 20 0 37 -22 37 -50z
m-21370 -731 c-7 -783 -15 -907 -56 -843 -25 40 -33 1496 -9 1559 9 22 28 40
44 40 21 0 27 -202 21 -756z m3808 706 c0 -44 -107 -66 -144 -29 -40 40 5 83
77 74 39 -4 67 -23 67 -45z m3762 -114 c0 -67 -43 -83 -66 -23 -19 50 9 119
41 100 14 -9 25 -43 25 -77z m4663 49 c34 -23 62 -62 62 -88 0 -60 -38 -60
-80 0 -18 26 -54 51 -81 56 -26 5 -52 24 -58 41 -15 45 84 39 157 -9z m8399
16 c8 -13 -9 -36 -38 -51 -41 -22 -49 -44 -37 -98 19 -86 -41 -150 -97 -104
-23 19 -41 20 -51 5 -8 -14 42 -81 111 -150 140 -141 154 -191 63 -233 -51
-23 -71 -20 -110 14 -35 33 -71 39 -150 26 -94 -15 -103 -12 -103 37 0 42 15
53 75 53 87 0 96 32 23 83 -45 32 -47 44 -20 88 27 43 26 59 -7 96 -70 80 -82
158 -24 158 27 0 57 -11 66 -25 19 -31 63 -32 110 -2 29 19 30 31 6 60 -25 30
-24 40 1 50 56 22 166 18 182 -7z m-15500 -125 c32 -70 66 -107 111 -117 96
-23 227 -108 227 -149 0 -41 -64 -47 -89 -8 -9 15 -44 20 -77 12 -99 -25 -209
54 -193 137 10 49 -1 82 -42 119 -34 32 -49 68 -40 93 22 56 49 32 103 -87z
m1716 76 c42 -34 52 -57 33 -75 -32 -33 -136 33 -136 87 0 49 33 45 103 -12z
m13101 -39 c28 -62 31 -88 10 -88 -47 0 -89 55 -89 118 0 83 34 70 79 -30z
m-16571 26 c10 -25 -14 -40 -85 -52 -112 -19 -108 -9 -64 -174 36 -136 96
-263 173 -367 72 -97 42 -168 -46 -110 -35 23 -94 39 -131 34 -89 -10 -131
113 -138 405 -5 217 19 313 60 246 17 -27 29 -25 65 10 53 53 147 58 166 8z
m-4265 -52 c179 -162 207 -172 207 -74 0 34 13 62 29 62 20 0 24 -56 14 -194
-11 -147 -6 -205 21 -242 49 -66 45 -89 -14 -89 -50 0 -94 99 -65 147 14 21
-107 128 -143 128 -8 0 -43 11 -78 25 -58 21 -62 30 -33 76 27 44 25 56 -12
77 -44 24 -59 99 -27 130 23 24 23 24 101 -46z m11417 -81 c10 -79 34 -165 54
-192 20 -27 36 -74 36 -105 0 -72 91 -159 166 -159 66 0 90 -30 69 -86 -11
-27 -32 -35 -65 -25 -35 11 -69 -7 -120 -64 -77 -86 -138 -81 -116 9 8 30 3
71 -10 91 -18 29 -23 23 -24 -29 0 -70 -47 -104 -99 -72 -50 31 -8 176 51 176
66 0 60 36 -14 85 -78 51 -81 120 -7 153 90 39 82 116 -18 184 -48 33 -88 75
-88 94 0 19 -11 34 -25 34 -14 0 -25 11 -25 25 0 14 49 25 109 25 l110 0 16
-144z m2140 72 c0 -52 -15 -76 -51 -86 -74 -19 -22 -93 110 -157 131 -63 153
-135 42 -135 -55 0 -97 23 -149 81 -66 74 -87 82 -220 84 -136 2 -257 55 -257
113 0 34 129 41 142 6 15 -39 98 -46 121 -9 8 14 49 25 90 25 64 0 73 8 60 50
-21 64 2 100 63 100 37 0 49 -17 49 -72z m-10793 3 c7 -24 21 -64 31 -90 16
-39 11 -44 -32 -30 -69 22 -93 -22 -93 -173 0 -109 -8 -127 -54 -133 -136 -20
-118 277 25 400 93 81 106 84 123 26z m704 -20 c63 -64 48 -111 -36 -111 -85
0 -84 -1 -51 86 29 75 35 77 87 25z m1325 -33 c61 -117 -3 -139 -122 -41 l-74
61 61 24 c90 36 94 35 135 -44z m12064 -11 c0 -18 -25 -57 -56 -86 -56 -52
-57 -52 -116 -3 -59 47 -59 50 -13 84 61 46 185 49 185 5z m6604 -55 c-12
-109 -48 -132 -79 -49 -33 87 -15 144 44 132 32 -6 41 -28 35 -83z m-11514 0
c16 -20 39 -37 53 -37 14 0 54 -42 89 -94 71 -105 69 -248 -4 -275 -22 -8 -49
-30 -60 -48 -31 -50 -83 -40 -159 30 -82 77 -54 122 77 122 61 0 89 13 97 44
14 51 -56 121 -121 121 -62 0 -162 97 -162 157 0 59 143 44 190 -20z m-12205
23 c69 -27 46 -85 -34 -85 -76 0 -115 32 -88 75 17 28 64 32 122 10z m8911
-84 c25 -41 75 -98 112 -127 86 -67 90 -149 8 -149 -65 0 -241 224 -241 306 0
69 71 51 121 -30z m-4876 -14 c7 -48 -130 -210 -156 -184 -6 6 8 65 31 130 44
123 111 152 125 54z m4311 -68 c24 -27 44 -81 44 -119 0 -47 15 -73 48 -82
117 -30 98 -268 -22 -268 -55 0 -66 50 -26 124 36 69 -16 201 -80 201 -40 0
-48 -12 -37 -54 8 -30 3 -110 -12 -178 -26 -122 -26 -123 -111 -107 -80 15
-85 12 -85 -55 0 -124 -99 -176 -151 -79 -45 83 14 198 100 198 l69 0 14 237
c8 130 21 247 29 261 22 34 166 -17 220 -79z m6514 45 c19 -41 56 -67 115 -78
47 -9 92 -31 99 -49 7 -18 47 -40 89 -49 42 -9 77 -27 77 -38 0 -30 -205 -25
-242 5 -51 41 -145 13 -145 -42 0 -41 18 -51 100 -55 55 -2 118 -5 141 -6 46
-2 196 -134 196 -172 0 -17 -28 -15 -79 3 -62 23 -81 23 -89 -2 -18 -50 -52
-36 -88 38 -36 75 -138 84 -176 16 -38 -66 -174 -40 -265 51 -85 86 -87 139
-4 139 28 0 52 -24 61 -62 10 -38 40 -68 76 -77 114 -29 159 48 53 88 -81 31
-139 132 -72 125 122 -13 142 30 58 120 -66 71 -63 106 8 106 38 0 69 -22 87
-61z m-265 -26 c15 -35 37 -63 49 -63 49 0 16 -45 -41 -56 -113 -22 -203 81
-133 151 47 47 94 35 125 -32z m6672 36 c51 -27 65 -74 23 -74 -14 0 -48 23
-75 50 -54 54 -27 66 52 24z m-14203 -163 c-46 -55 -108 -43 -184 36 -76 79
-56 119 47 93 34 -9 68 -3 78 13 11 19 30 5 53 -39 27 -52 29 -75 6 -103z
m651 111 c0 -12 -17 -22 -37 -22 -21 0 -38 -22 -38 -50 0 -37 17 -50 63 -50
34 0 82 -10 106 -23 24 -13 63 -29 87 -37 30 -9 44 -39 44 -94 0 -63 -7 -74
-30 -51 -36 36 -136 40 -157 5 -34 -54 -88 -24 -88 47 0 69 -52 142 -81 114
-7 -8 -38 21 -68 63 l-54 76 58 21 c113 42 133 47 164 35 17 -6 31 -21 31 -34z
m8925 17 c102 -3 204 -85 175 -140 -46 -85 -113 -81 -207 13 -56 56 -112 88
-153 88 -63 0 -83 24 -47 59 9 10 51 10 93 0 42 -10 105 -19 139 -20z m7579
-26 c0 -13 -24 -32 -52 -42 -44 -16 -52 -10 -52 42 0 51 8 57 52 41 28 -10 52
-29 52 -41z m-16928 -1 c55 -28 74 -56 74 -108 0 -111 144 -187 185 -98 8 17
9 9 3 -18 -44 -194 -59 -382 -38 -475 27 -122 0 -247 -56 -258 -53 -10 -79
152 -57 358 15 142 11 161 -33 185 -34 18 -45 43 -36 80 10 35 0 61 -27 76
-22 13 -41 41 -41 63 0 32 -7 34 -39 7 -58 -49 -108 9 -66 77 26 42 25 53 -7
65 -56 21 -46 84 13 84 28 0 85 -17 125 -38z m2399 -5 c47 -33 115 -43 286
-44 l223 0 6 -108 c4 -73 -6 -113 -29 -121 -18 -8 -57 -53 -86 -102 l-52 -88
-60 66 c-79 85 -116 82 -274 -22 -72 -49 -138 -88 -145 -88 -8 0 -37 39 -66
88 -29 50 -71 87 -98 87 -68 0 -85 -28 -45 -73 19 -22 39 -62 44 -89 6 -35 29
-50 71 -50 50 0 64 -15 70 -69 8 -69 -48 -99 -82 -44 -9 14 -38 25 -64 25 -27
0 -71 22 -98 49 -52 52 -126 45 -126 -11 0 -18 17 -39 38 -47 40 -16 50 -80
15 -102 -53 -32 -248 64 -279 138 -37 90 -44 83 129 132 203 58 262 164 92
166 -58 0 -82 47 -34 65 21 9 39 31 39 50 0 48 72 44 175 -11 123 -65 154 -47
134 77 -25 154 85 218 216 126z m-3530 -25 c-6 -34 19 -47 117 -61 120 -18
199 -76 180 -132 -17 -52 -206 -44 -301 12 -105 62 -102 54 -53 150 43 82 68
96 57 31z m17480 -16 c0 -33 17 -74 38 -91 52 -43 46 -107 -13 -144 -61 -38
-69 -197 -13 -270 46 -61 52 -245 7 -230 -17 6 -31 35 -31 64 0 30 -26 72 -57
93 -59 42 -75 123 -28 151 15 10 21 48 12 90 -8 40 -1 94 16 121 24 38 21 56
-13 94 -43 48 -57 134 -26 164 41 42 108 15 108 -42z m-20317 0 c19 -50 -22
-100 -68 -83 -47 18 -53 83 -9 100 52 21 63 19 77 -17z m-1808 -54 c192 -4
277 -65 225 -161 -33 -63 32 -215 99 -233 31 -8 51 -34 51 -65 0 -34 21 -57
62 -68 76 -19 102 -161 66 -366 -11 -65 -53 -1 -53 81 0 101 -37 136 -59 56
-46 -169 -44 -235 9 -249 47 -12 48 -18 15 -54 -25 -27 -30 -54 -15 -78 14
-22 12 -49 -5 -69 -32 -38 -6 -72 68 -85 48 -9 49 -27 45 -476 -3 -295 -15
-484 -32 -513 -25 -40 -27 -39 -14 10 21 75 -51 337 -98 364 -55 31 -48 79 24
164 109 130 45 355 -101 355 -83 0 -104 49 -42 97 59 46 84 179 36 196 -17 6
-42 -19 -56 -55 -29 -77 -90 -71 -82 9 5 39 -7 53 -46 53 -41 0 -50 -12 -40
-51 12 -45 5 -49 -69 -35 -141 26 -222 -87 -160 -222 24 -55 42 -61 166 -58
147 4 198 -35 110 -82 -37 -19 -73 -17 -138 11 -125 52 -171 3 -161 -172 7
-128 8 -128 93 -128 47 0 90 -15 96 -32 5 -17 -1 -31 -15 -31 -14 0 -60 -29
-102 -65 -97 -81 -114 -269 -27 -292 64 -17 64 -80 -1 -126 -47 -33 -50 -58
-44 -339 7 -311 22 -348 103 -266 41 41 265 124 284 105 25 -25 -57 -120 -117
-134 -34 -8 -92 -36 -129 -62 -36 -25 -79 -46 -94 -46 -15 0 -27 -32 -27 -72
0 -40 -17 -105 -37 -144 -21 -39 -38 -91 -38 -115 0 -24 -10 -44 -21 -44 -12
0 -20 481 -17 1069 7 1358 1 1251 67 1261 82 11 83 60 4 138 l-70 70 8 462 c8
486 26 557 128 508 21 -10 89 -20 151 -21z m7191 -82 c8 -31 53 -86 99 -121
87 -67 115 -159 48 -159 -61 0 -205 156 -220 238 -8 41 -23 95 -32 121 -17 42
-13 43 36 12 30 -18 61 -59 69 -91z m5650 83 c22 -57 -9 -114 -53 -97 -50 19
-51 134 0 134 21 0 45 -17 53 -37z m-8495 -100 c5 -42 18 -87 29 -101 24 -29
18 -227 -7 -253 -10 -9 -18 -65 -18 -124 0 -143 -30 -154 -115 -41 -38 51 -80
101 -93 109 -33 23 5 122 48 122 53 0 -5 102 -67 118 -58 16 -133 157 -101
189 29 29 78 2 78 -43 0 -46 63 -66 97 -32 15 15 28 55 28 87 0 96 110 67 121
-31z m9664 -15 c52 -117 40 -143 -47 -103 -34 16 -81 21 -104 13 -34 -14 -39
-5 -26 44 9 33 16 80 17 104 0 92 112 52 160 -58z m-11738 -24 c46 -39 56 -66
45 -130 -12 -74 -1 -91 108 -181 154 -127 163 -188 28 -188 -54 0 -110 -16
-127 -36 -34 -41 -101 -25 -101 25 0 18 18 43 39 55 34 20 32 36 -23 139 -34
64 -52 117 -39 117 47 0 21 95 -39 140 -86 64 -78 87 37 106 7 1 39 -20 72
-47z m15892 14 c27 -20 85 -37 129 -37 85 -1 132 -54 132 -150 0 -45 -7 -49
-51 -26 -27 15 -59 22 -71 14 -11 -7 -42 3 -68 22 -30 22 -61 27 -88 12 -32
-17 -48 -6 -72 52 -52 125 -5 184 89 113z m-12547 -136 c37 -84 83 -278 91
-389 3 -30 -11 -50 -33 -50 -25 0 -40 30 -45 91 -4 51 -24 106 -44 122 -20 17
-36 49 -36 71 0 23 -18 67 -39 98 -53 75 -27 224 30 177 20 -17 55 -71 76
-120z m14244 110 c61 -47 39 -68 -76 -72 -73 -2 -95 9 -112 54 -19 51 -14 56
59 55 44 0 102 -17 129 -37z m-14663 -249 c23 -89 20 -104 -24 -135 -27 -19
-49 -59 -49 -90 0 -32 -16 -70 -34 -85 -56 -46 -67 51 -24 213 20 78 30 168
22 201 -9 32 -1 84 16 115 29 54 31 53 48 -32 10 -48 30 -132 45 -187z m-3489
185 c84 -65 62 -112 -29 -63 -37 20 -90 43 -117 52 -41 13 -43 20 -12 39 55
35 85 29 158 -28z m18708 -7 c71 -74 53 -166 -31 -166 -32 0 -65 11 -73 25
-27 42 -63 28 -63 -25 0 -58 -63 -68 -84 -12 -9 23 -47 37 -103 37 -129 0
-108 37 25 42 92 3 126 19 181 81 80 92 79 92 148 18z m-15396 -8 c-13 -62
-71 -71 -71 -10 0 31 16 52 39 52 24 0 36 -17 32 -42z m17463 5 c16 -41 -4
-113 -30 -113 -57 2 -83 46 -56 97 34 62 66 68 86 16z m-6289 -18 c43 -43 37
-70 -16 -70 -59 0 -79 21 -62 65 16 43 39 44 78 5z m-15228 -520 c-3 -160 -14
-260 -29 -256 -27 6 -28 60 -15 512 7 256 10 269 28 144 11 -76 18 -256 16
-400z m11579 449 c66 -84 63 -141 -8 -188 -75 -49 -188 44 -143 116 19 29 20
48 5 48 -14 0 -25 23 -25 50 0 76 102 61 171 -26z m7154 -43 c0 -17 -23 -31
-50 -31 -27 0 -50 -11 -50 -25 0 -14 21 -25 47 -25 26 0 61 -17 78 -37 44 -53
70 -47 80 18 12 85 95 90 95 6 0 -55 8 -64 44 -49 94 41 181 44 181 6 0 -20
35 -85 78 -145 89 -122 79 -170 -43 -210 -40 -14 -76 -26 -79 -28 -25 -13 36
-94 85 -112 71 -27 76 -65 11 -86 -80 -25 -168 12 -204 87 -20 40 -68 141
-109 226 -73 154 -147 214 -226 183 -25 -9 -46 8 -62 51 -29 75 -76 87 -76 18
0 -60 93 -178 140 -178 81 0 98 -245 17 -252 -111 -9 -180 -19 -225 -33 -29
-9 -60 -5 -69 9 -9 14 -51 26 -94 26 -71 0 -194 80 -194 127 0 42 175 49 236
9 177 -116 344 -77 240 56 -68 86 -296 213 -352 195 -23 -7 -73 -1 -111 13
-92 35 -138 -5 -138 -118 0 -73 -12 -91 -75 -115 -54 -20 -71 -40 -61 -70 7
-24 1 -50 -13 -59 -14 -9 -26 -45 -26 -80 0 -62 -2 -63 -62 -23 -84 55 -92 52
-160 -48 -56 -82 -68 -87 -200 -88 -77 0 -169 -17 -203 -36 -34 -20 -98 -37
-141 -37 -72 -1 -79 7 -90 93 -15 117 -21 111 137 125 72 7 147 25 167 40 19
16 59 29 87 29 45 0 53 15 53 100 0 126 96 174 165 83 44 -59 97 -44 97 28 0
25 21 51 46 57 65 17 95 145 43 183 -101 75 22 124 177 71 83 -28 122 -32 129
-13 11 35 221 37 243 3 8 -14 60 -25 115 -25 89 0 99 6 85 49 -13 39 1 57 67
84 88 36 170 11 170 -52z m-20587 39 c61 -27 65 -39 50 -136 -9 -59 -34 -143
-55 -186 -38 -76 -37 -82 11 -120 53 -41 66 -176 22 -220 -27 -28 -91 64 -91
131 0 81 -73 136 -91 68 -20 -75 -209 -149 -209 -82 0 14 11 25 25 25 14 0 25
20 25 45 0 57 47 105 102 105 32 0 45 27 52 101 12 126 2 142 -92 153 -113 13
-104 103 13 124 140 25 169 24 238 -8z m341 -295 c8 -282 7 -288 -48 -296 -56
-7 -56 -6 -47 278 14 462 82 474 95 18z m5216 279 c25 -16 21 -34 -17 -81 -44
-54 -51 -56 -66 -17 -33 85 14 141 83 98z m1522 -65 c-9 -21 -27 -39 -41 -39
-29 0 -36 82 -9 109 28 27 66 -27 50 -70z m7948 -4 c131 -87 155 -130 120
-220 -29 -77 -196 -16 -198 71 -1 48 -74 133 -123 142 -97 19 -69 78 44 94 12
2 82 -37 157 -87z m-12174 28 c10 -26 34 -33 74 -23 66 17 84 -26 20 -50 -106
-41 -235 -6 -235 63 0 58 119 67 141 10z m1204 2 c37 -20 95 -86 128 -148 72
-132 47 -192 -77 -192 -79 0 -118 56 -75 108 19 23 13 52 -22 106 -46 69 -66
161 -35 161 7 0 44 -16 81 -35z m2339 -265 c4 -35 22 -90 40 -123 30 -56 26
-66 -39 -119 -106 -85 -174 -75 -231 34 -40 76 -36 150 9 167 20 8 37 39 37
69 0 30 25 103 55 164 l55 110 33 -120 c18 -66 37 -148 41 -182z m3284 214
c30 -97 22 -114 -55 -114 -63 0 -113 44 -113 100 0 121 132 131 168 14z m2757
37 c121 -42 249 -148 250 -207 0 -11 -45 -19 -100 -19 -94 0 -100 4 -100 74
l0 73 -84 -35 c-77 -32 -89 -31 -125 10 -49 53 -53 119 -10 136 17 7 32 14 32
14 0 1 61 -20 137 -46z m11111 -65 c62 -61 86 -136 44 -136 -11 0 -57 -35
-101 -79 -90 -88 -86 -89 -124 24 -23 67 -22 84 8 94 21 6 54 16 75 23 27 8
34 30 22 75 -20 79 -4 79 76 -1z m-21859 -1576 c2 -1834 4 -1685 -26 -1685
-14 0 -24 453 -23 1187 0 746 -10 1204 -26 1233 -17 33 -16 56 5 77 20 20 27
138 23 381 -4 317 5 421 35 390 6 -6 11 -718 12 -1583z m12561 1565 c8 -14 33
-25 55 -25 62 0 132 -76 132 -141 0 -60 -35 -79 -62 -34 -9 14 -44 25 -78 25
-73 0 -188 113 -168 164 15 41 97 48 121 11z m512 -100 c57 -55 124 -100 148
-100 24 0 70 -22 102 -50 32 -27 78 -50 104 -50 43 0 171 -168 171 -225 0 -14
28 -25 61 -25 34 0 72 -18 84 -41 18 -32 38 -36 94 -17 94 32 105 77 21 87
-84 10 -106 61 -37 83 62 19 140 -19 243 -122 181 -177 172 -173 268 -138 76
27 101 26 171 -8 45 -23 102 -47 126 -54 64 -19 54 -79 -24 -151 l-68 -63 -57
54 c-39 37 -49 63 -32 80 41 41 28 90 -24 90 -27 0 -63 -25 -79 -56 -64 -121
-99 -121 -214 -4 -108 112 -183 141 -183 72 0 -21 28 -51 63 -67 34 -15 62
-43 62 -62 0 -19 -27 -33 -62 -33 -35 0 -63 11 -63 24 0 14 -45 48 -100 76
-55 28 -100 65 -100 82 0 66 -170 170 -268 164 -52 -3 -131 3 -176 14 -65 15
-81 11 -81 -21 0 -21 16 -39 36 -39 54 0 73 -48 27 -66 -25 -9 -61 6 -92 39
-58 63 -164 109 -199 88 -62 -39 -195 169 -146 227 17 21 22 66 12 110 -12 53
-3 93 29 138 59 81 61 81 183 -36z m-10900 15 c0 -63 -41 -90 -140 -90 -33 0
-60 -11 -60 -25 0 -14 18 -25 40 -25 66 0 23 -62 -50 -71 -67 -7 -68 -5 -60
113 8 129 7 128 239 154 17 2 31 -23 31 -56z m4194 35 c43 0 56 -14 56 -64 0
-35 12 -86 26 -113 15 -27 18 -63 7 -80 -12 -20 -23 -9 -33 32 -11 46 -34 65
-88 71 -98 11 -137 46 -137 122 0 53 9 60 56 48 31 -9 82 -15 113 -16z m-420
-48 c17 -31 42 -43 76 -34 38 10 50 1 50 -37 0 -52 -132 -87 -231 -61 -55 14
-57 88 -5 141 52 51 79 49 110 -9z m-4739 -23 c-1 -16 -4 -63 -6 -104 -6 -120
-99 -91 -140 44 -14 44 -5 61 41 79 69 28 108 21 105 -19z m1757 7 c8 -22 -2
-57 -24 -78 -34 -35 -40 -33 -55 14 -28 89 46 149 79 64z m1110 -12 c84 -45
55 -264 -45 -338 -30 -22 -29 -37 9 -104 44 -75 44 -80 -1 -129 -30 -33 -42
-74 -34 -116 10 -51 -1 -71 -58 -101 -103 -53 -155 -47 -135 15 9 28 3 68 -14
88 -24 29 -23 36 6 36 19 0 57 17 84 38 46 35 46 39 5 63 -26 16 -44 57 -44
100 0 92 -16 92 -122 -4 -80 -73 -78 -120 3 -122 11 0 19 -11 19 -25 0 -39
-75 -29 -91 13 -23 58 -64 43 -171 -64 -110 -110 -126 -116 -148 -60 -18 49
285 348 410 403 112 49 126 73 94 165 -42 120 106 210 233 142z m3598 -62 c0
-58 14 -94 40 -104 31 -12 37 -37 26 -106 -13 -77 -6 -94 41 -115 67 -30 83
-115 41 -218 -28 -66 -26 -80 13 -108 24 -18 37 -44 28 -59 -19 -31 29 -131
77 -159 19 -11 34 -40 34 -64 0 -24 46 -87 102 -140 79 -75 98 -109 85 -149
-60 -188 -40 -223 88 -157 100 52 213 4 294 -125 38 -59 81 -108 96 -108 15 0
58 -28 95 -62 78 -73 121 -79 167 -23 22 26 56 35 103 25 82 -16 90 9 22 70
-45 41 -49 41 -72 -1 -38 -66 -155 -8 -155 77 0 152 171 135 335 -34 l93 -94
-63 -42 c-35 -22 -75 -41 -90 -41 -15 0 -72 -46 -126 -101 -111 -114 -109
-138 24 -229 130 -88 193 -183 153 -231 -57 -69 -126 -49 -126 36 0 68 -6 74
-62 60 -47 -12 -66 -4 -78 31 -8 26 -26 70 -40 100 -14 29 -18 87 -9 128 15
67 5 83 -91 154 -129 95 -173 91 -205 -19 -22 -77 -17 -88 57 -146 64 -51 74
-70 50 -99 -30 -36 11 -105 108 -178 26 -20 37 -49 27 -75 -37 -100 -103 -94
-279 24 -103 68 -151 67 -153 -6 -1 -33 -154 -99 -230 -99 -117 0 -212 121
-174 221 51 134 59 254 18 254 -21 0 -45 -31 -54 -69 -31 -129 -118 -174 -185
-93 -17 20 -63 37 -101 37 -74 0 -157 82 -188 183 -9 30 -45 78 -80 107 -65
52 -60 110 8 110 20 0 36 22 36 49 0 26 11 55 24 63 27 17 -21 113 -56 113
-10 0 -32 -29 -48 -64 -40 -87 -130 -74 -140 20 -7 53 6 75 56 98 50 23 64 47
64 114 0 74 7 84 56 77 49 -6 55 -20 48 -103 -8 -89 -4 -96 52 -88 86 11 177
-58 230 -175 40 -90 52 -99 95 -76 32 18 58 18 74 2 38 -38 13 -113 -46 -143
-99 -49 -134 -93 -134 -165 0 -40 9 -72 19 -72 25 0 138 77 160 108 26 39 192
-6 233 -65 21 -30 38 -101 38 -158 0 -121 50 -182 100 -122 18 21 52 32 77 24
47 -15 148 64 148 116 0 42 -101 122 -154 122 -48 0 -60 28 -27 60 19 19 31
101 31 211 0 79 -142 272 -214 290 -54 13 -104 97 -89 150 14 53 -26 137 -73
152 -29 9 -62 43 -74 75 -13 33 -47 62 -80 66 -65 10 -96 96 -34 96 21 0 39
17 39 38 0 20 -17 37 -37 37 -21 0 -38 -17 -38 -37 0 -21 -17 -38 -37 -38 -50
0 -49 72 0 91 24 9 33 32 24 60 -10 31 3 55 37 73 48 26 72 101 32 101 -31 0
-78 182 -65 250 14 70 -112 217 -134 157 -29 -81 -103 -144 -134 -114 -25 24
-23 34 10 46 23 9 42 36 42 61 0 64 -86 78 -135 21 -30 -34 -58 -43 -109 -30
-142 33 -165 109 -33 109 39 0 85 17 102 38 46 54 144 47 163 -13 28 -91 162
-45 162 55 0 25 17 45 38 45 26 0 37 -26 37 -88z m5913 36 c19 -59 3 -86 -36
-62 -33 21 -36 114 -4 114 13 0 31 -23 40 -52z m6254 -27 c67 -64 73 -103 21
-146 -21 -17 -38 -63 -38 -103 0 -47 -13 -72 -37 -72 -21 0 -38 21 -38 47 0
32 -39 63 -125 101 -178 76 -165 167 19 126 67 -16 81 -11 81 24 0 89 39 96
117 23z m-14473 -70 c29 -113 19 -134 -47 -99 -67 35 -63 198 4 198 10 0 29
-44 43 -99z m-4594 45 c0 -16 18 -50 41 -74 22 -26 33 -63 24 -87 -14 -36 -24
-32 -77 24 -33 36 -81 66 -106 67 -37 0 -34 8 18 49 72 56 100 62 100 21z
m1902 3 c49 -26 64 -86 28 -108 -31 -19 -71 16 -91 78 -19 62 -8 68 63 30z
m644 -96 c10 -104 -8 -121 -133 -132 -94 -8 -100 -5 -93 54 7 70 123 177 180
168 23 -4 41 -39 46 -90z m2379 48 c0 -13 -15 -33 -32 -44 -24 -14 -30 -75
-23 -226 l10 -206 123 -110 c67 -61 122 -131 122 -156 1 -98 37 -117 125 -68
195 110 184 97 117 141 -56 37 -58 47 -33 129 33 105 65 111 153 29 73 -67
147 -309 123 -403 -8 -34 2 -94 25 -140 56 -112 52 -197 -9 -197 -68 0 -89
-47 -37 -85 31 -23 35 -38 15 -50 -17 -10 -36 -1 -44 21 -16 42 -74 53 -95 18
-25 -41 214 -256 251 -226 44 37 43 12 -4 -79 -42 -82 -148 -109 -119 -30 14
38 11 39 -25 10 -24 -20 -62 -26 -96 -16 l-55 18 56 42 56 43 -88 60 c-98 67
-266 306 -266 377 0 40 20 47 134 47 141 0 215 47 222 141 4 47 -73 184 -103
184 -43 -1 -81 -48 -74 -90 7 -37 -9 -49 -71 -55 -44 -4 -93 -24 -109 -43 -35
-43 -299 208 -299 284 0 23 -15 65 -34 92 -67 96 -93 511 -37 579 31 38 121
45 121 9z m3309 -170 c45 -36 116 -41 116 -9 0 12 -17 36 -39 54 -25 21 -30
40 -14 56 36 36 103 2 103 -54 0 -26 17 -54 38 -62 52 -20 47 -91 -7 -91 -25
0 -64 -22 -88 -50 -23 -27 -71 -50 -105 -50 -46 0 -63 -13 -63 -50 0 -27 -11
-50 -25 -50 -14 0 -25 23 -25 50 0 80 -89 150 -190 150 l-89 0 18 -106 c10
-59 38 -121 64 -139 26 -18 47 -46 47 -62 0 -42 127 -145 157 -126 15 9 8 28
-18 48 -24 17 -37 44 -28 58 28 45 109 30 149 -27 36 -52 31 -61 -130 -213
-185 -174 -185 -174 -317 -119 l-94 39 49 55 c27 30 56 73 64 96 10 27 32 38
64 29 26 -7 57 2 67 19 30 47 -58 98 -141 81 -57 -11 -72 -5 -72 29 0 33 15
41 61 32 86 -16 100 43 22 94 -65 43 -85 34 -117 -50 -25 -67 -35 16 -19 157
14 117 11 163 -14 184 -18 15 -33 50 -33 77 0 47 11 49 170 34 153 -15 175
-12 217 35 l47 51 68 -69 c37 -38 86 -84 107 -101z m5237 129 c46 -32 51 -46
25 -77 -24 -29 -24 -47 1 -88 27 -43 26 -58 -5 -89 -45 -45 -100 43 -124 200
-17 105 10 119 103 54z m-6171 -110 l110 -100 -72 0 c-83 0 -188 87 -188 154
0 67 27 57 150 -54z m6350 75 c0 -13 29 -31 64 -40 47 -12 62 -30 56 -69 -9
-62 -104 -86 -159 -40 -49 41 -48 174 2 174 20 0 37 -11 37 -25z m-8332 -50
c35 -27 79 -50 98 -50 19 0 34 23 34 50 0 34 17 50 51 50 68 0 90 -66 40 -122
-50 -54 -53 -88 -7 -70 53 20 93 -19 98 -98 8 -104 -81 -100 -132 7 -24 50
-61 84 -103 92 -69 14 -222 130 -222 168 0 40 77 25 143 -27z m9709 24 c95
-51 44 -137 -89 -153 -85 -10 -94 52 -19 135 46 52 45 52 108 18z m-13577 -92
c114 -51 110 -43 73 -128 -30 -66 -41 -72 -128 -60 -53 7 -109 0 -128 -16 -59
-48 -111 41 -98 166 l11 107 91 -15 c51 -8 131 -33 179 -54z m-4664 1 c20 -53
-20 -94 -73 -74 -32 12 -35 26 -13 66 33 61 64 64 86 8z m4159 -14 c5 -24 -19
-69 -53 -100 -91 -83 -111 -269 -30 -269 73 0 133 -91 162 -244 27 -144 -2
-219 -50 -129 -17 33 -39 66 -49 73 -10 7 -37 49 -60 94 -46 91 -121 106 -194
40 -87 -79 -158 33 -78 123 42 45 41 50 -23 96 -37 27 -62 63 -56 79 6 17 15
70 21 118 5 48 11 96 12 107 2 10 28 13 59 7 31 -7 90 3 132 23 98 46 197 38
207 -18z m1062 -25 c14 -95 9 -105 -43 -85 -39 14 -54 118 -22 149 33 34 53
15 65 -64z m3931 -44 c12 -76 28 -100 64 -100 108 0 39 -187 -78 -213 -77 -17
-79 -26 -32 -152 12 -32 -61 -99 -83 -77 -37 36 -15 409 31 533 54 148 74 150
98 9z m2849 -52 c-46 -73 -209 31 -211 134 -1 39 16 34 112 -32 62 -43 107
-89 99 -102z m-9245 81 c-17 -87 19 -129 113 -129 39 0 70 -3 70 -6 0 -4 -11
-44 -24 -89 -21 -75 -18 -84 40 -106 88 -34 61 -85 -51 -94 -79 -7 -89 -14
-63 -45 41 -49 -2 -92 -80 -81 -58 8 -60 14 -63 296 -3 298 1 325 46 325 16 0
21 -29 12 -71z m9396 21 c0 -21 -26 -41 -57 -45 -54 -8 -78 40 -38 79 29 29
95 5 95 -34z m11555 -26 c91 -42 188 -73 216 -69 103 15 75 -71 -39 -116 -147
-60 -276 -18 -361 117 -103 162 -56 179 184 68z m-23027 -23 c8 -41 34 -81 57
-88 92 -29 132 -283 65 -412 l-37 -72 -101 39 c-109 43 -117 62 -62 157 52 92
46 207 -13 244 -56 35 -66 130 -20 176 51 51 96 33 111 -44z m6609 -59 c0 -39
-102 -192 -128 -192 -51 0 -50 81 3 193 52 110 58 115 90 70 19 -26 35 -58 35
-71z m-1731 8 c5 -43 -20 -91 -76 -150 -46 -48 -91 -107 -100 -131 -9 -24 -28
-44 -42 -44 -34 0 -34 67 0 88 14 9 19 39 10 66 -20 64 106 251 162 241 22 -5
43 -36 46 -70z m9693 -1 c-23 -36 -112 -29 -112 9 0 19 7 41 16 49 23 24 113
-31 96 -58z m-10249 -26 c0 -37 -17 -63 -44 -68 -57 -11 -84 59 -43 109 43 52
87 32 87 -41z m4901 44 c7 -18 2 -63 -12 -100 -22 -58 -19 -67 22 -67 26 0 76
-11 111 -24 63 -24 63 -25 21 -100 -24 -42 -51 -76 -61 -76 -31 0 -120 108
-120 145 0 29 -7 30 -37 5 -21 -17 -54 -24 -75 -16 -49 19 -49 113 0 132 20 8
37 28 37 44 0 70 92 115 114 57z m11471 -42 c37 0 73 17 81 38 21 54 59 46 59
-13 0 -27 -13 -50 -30 -50 -23 0 -23 -7 0 -30 40 -40 38 -70 -6 -70 -20 0 -48
-20 -61 -44 -23 -41 -25 -41 -41 0 -36 92 -269 -9 -261 -113 7 -90 3 -92 -90
-53 -100 41 -155 26 -108 -31 23 -28 22 -57 -2 -132 -18 -53 -25 -108 -16
-123 9 -14 -14 -46 -50 -71 -37 -25 -97 -74 -134 -108 -51 -47 -93 -62 -172
-61 -100 2 -104 0 -104 -76 0 -151 -243 -204 -287 -63 -24 73 -97 105 -174 76
-89 -34 -194 15 -184 85 5 31 29 55 64 59 31 5 56 26 56 48 0 32 25 37 148 26
l148 -14 -14 88 -15 88 65 -42 c35 -23 69 -57 76 -75 8 -20 37 -28 74 -21 48
9 64 -1 76 -47 14 -53 19 -54 54 -20 60 61 4 209 -63 168 -58 -37 -94 -6 -58
51 50 80 152 97 210 35 28 -30 62 -55 75 -55 13 0 24 -18 24 -39 0 -21 12 -32
27 -22 14 9 24 51 20 95 -7 92 21 191 55 191 13 0 23 14 22 31 -1 38 -124 133
-124 96 0 -105 -322 -248 -410 -181 -74 56 -304 104 -387 80 -134 -39 -187 29
-59 75 63 23 181 76 287 128 24 11 80 21 125 21 45 1 96 10 115 22 33 21 142
-8 244 -66 46 -25 62 -20 113 35 50 53 75 61 152 49 51 -9 99 -4 107 10 9 14
61 25 115 25 69 0 104 13 115 41 15 38 18 38 46 0 17 -23 60 -41 97 -41z
m-17810 24 c0 -15 30 -54 66 -87 73 -68 59 -82 -91 -93 -78 -6 -88 1 -95 59
-4 36 10 84 33 106 46 47 87 53 87 15z m4046 -43 c15 -38 34 -99 43 -135 8
-37 31 -73 51 -81 19 -7 35 -37 35 -65 0 -29 18 -79 40 -113 41 -62 32 -187
-14 -187 -34 0 -126 126 -126 173 0 23 -10 53 -22 66 -11 13 -34 76 -50 141
-52 218 -21 364 43 201z m-693 13 c2 -17 1 -47 -2 -65 -5 -42 71 -129 114
-129 50 0 65 -44 35 -99 -39 -73 -88 -63 -161 32 -62 82 -76 128 -68 236 4 58
77 80 82 25z m944 -45 c21 -62 19 -79 -12 -91 -52 -20 -147 76 -127 127 27 69
110 47 139 -36z m15471 41 c5 -4 -2 -34 -13 -66 -18 -48 -42 -59 -143 -63
-137 -6 -186 -50 -189 -172 -2 -80 -9 -72 -34 42 -8 37 -38 89 -66 116 l-52
48 83 18 c46 10 112 41 146 67 55 44 229 50 268 10z m-5886 -65 c108 0 66 -68
-79 -125 -79 -32 -88 -30 -131 22 -76 95 37 214 130 136 22 -18 58 -33 80 -33z
m-5700 1 c12 -47 -48 -126 -97 -126 -49 0 -88 98 -54 137 47 53 136 47 151
-11z m6106 -1 c42 -47 42 -53 3 -96 -22 -25 -41 -59 -41 -75 0 -16 -27 -29
-59 -29 -37 0 -97 -39 -157 -100 -53 -55 -117 -100 -143 -100 -26 0 -88 -44
-138 -98 -77 -83 -383 -252 -456 -252 -36 0 -75 100 -59 152 11 36 30 46 64
35 55 -18 69 102 22 190 -27 51 32 74 63 24 17 -28 140 20 170 66 15 24 34 25
82 3 50 -23 80 -20 150 13 48 23 116 42 150 42 59 0 62 6 47 88 -16 87 -16 87
75 87 81 0 90 6 77 50 -13 41 -5 50 44 50 33 0 81 -22 106 -50z m-5675 -25
c11 -38 38 -50 107 -52 138 -2 168 -24 168 -122 0 -78 8 -88 84 -104 84 -17
127 -56 128 -116 0 -42 -76 -38 -136 7 -27 21 -69 31 -95 23 -31 -10 -69 11
-121 66 -86 92 -165 70 -103 -29 18 -27 25 -61 17 -74 -19 -31 -162 -31 -162
0 0 13 -24 46 -52 73 -36 33 -48 65 -36 101 23 72 84 65 103 -10 16 -67 60
-87 60 -28 0 20 7 54 15 75 11 29 0 40 -38 40 -30 0 -60 17 -68 38 -8 20 -36
37 -62 37 -69 0 -62 94 9 107 126 25 166 17 182 -32z m-10914 -137 c0 -127
-35 -193 -58 -109 -20 76 -20 181 0 234 25 65 58 -7 58 -125z m3591 133 c35
-56 -110 -149 -205 -131 -86 16 -102 0 -63 -61 18 -28 30 -28 76 0 49 30 60
27 104 -26 62 -76 61 -89 -14 -123 -67 -31 -87 -105 -29 -105 130 0 91 -163
-45 -189 -47 -9 -92 -32 -99 -51 -7 -19 -42 -35 -77 -35 -35 0 -63 -10 -63
-23 0 -13 -6 -40 -14 -60 -10 -26 8 -42 62 -54 85 -19 95 -56 42 -159 -48 -92
-75 -654 -32 -654 16 0 58 -35 92 -77 34 -43 88 -87 119 -100 81 -31 69 -73
-21 -73 -94 0 -237 105 -259 189 -19 76 -89 80 -153 9 -72 -80 -65 -419 10
-494 67 -67 73 -161 10 -149 -26 5 -47 35 -51 76 -5 37 -37 91 -72 118 -85 67
-89 302 -8 388 27 30 50 78 50 107 0 29 11 60 25 69 26 16 30 66 28 354 0 135
6 158 50 172 l51 16 -52 36 -52 37 55 74 c69 93 19 176 -77 125 -43 -23 -53
-22 -53 8 0 20 25 40 56 45 36 5 59 28 64 64 5 31 25 56 45 56 44 0 85 99 85
208 1 143 63 276 154 328 46 27 92 64 103 81 25 41 134 43 158 4z m10571 -46
c11 0 41 -28 68 -62 41 -52 58 -58 100 -36 54 29 146 -28 146 -90 0 -41 125
-64 180 -34 51 27 165 5 220 -42 21 -18 77 -36 125 -40 78 -8 87 -16 81 -75
-5 -49 6 -72 43 -83 74 -24 126 -84 126 -146 0 -31 28 -97 63 -147 64 -95 80
-181 39 -206 -42 -26 -238 58 -284 121 -40 55 -53 59 -107 35 -33 -15 -61 -37
-61 -48 0 -34 -350 -80 -416 -55 -51 20 -41 77 16 96 72 22 73 187 1 187 -27
0 -61 -22 -76 -50 -15 -27 -40 -50 -57 -49 -50 1 -197 148 -178 178 12 20 28
14 50 -16 53 -72 112 -30 94 67 -24 127 -55 154 -122 109 -71 -46 -164 -10
-206 81 -27 56 -25 59 26 43 146 -48 242 -7 156 66 -93 78 -188 176 -188 193
0 52 61 76 100 40 23 -20 50 -37 61 -37z m-14326 10 c23 -60 17 -243 -9 -285
-55 -86 -149 185 -98 281 29 55 87 57 107 4z m9593 -40 c18 -34 45 -46 84 -39
87 17 143 -172 68 -232 -27 -22 -54 -62 -59 -88 -14 -74 -82 -59 -91 20 -8 66
-105 153 -105 95 0 -14 -17 -26 -37 -26 -38 0 -48 37 -39 146 4 40 -11 62 -47
71 -70 18 -67 83 4 83 31 1 72 11 92 23 46 29 97 8 130 -53z m11049 9 c32 5
61 -7 68 -27 9 -25 -3 -31 -46 -20 -31 9 -77 5 -102 -8 -52 -28 -84 8 -61 68
11 30 22 32 50 9 20 -16 61 -26 91 -22z m-15138 -129 c5 -132 12 -150 60 -150
26 0 55 -11 64 -25 23 -38 105 -30 121 13 22 57 116 47 116 -13 0 -27 11 -50
25 -50 24 0 30 16 35 100 4 58 77 44 85 -17 9 -63 -75 -260 -131 -307 -22 -18
-39 -59 -39 -92 0 -70 -19 -73 -90 -13 -45 38 -51 63 -40 190 12 143 10 146
-46 132 -31 -9 -78 -4 -104 10 -36 19 -69 13 -135 -26 -137 -81 -232 -38 -121
53 125 103 135 119 119 197 -13 67 -9 77 32 69 31 -6 48 -31 49 -71z m-899
-39 c39 -82 39 -93 2 -130 -23 -22 -49 -33 -58 -23 -10 10 -5 31 11 47 47 47
36 70 -32 70 -73 0 -82 43 -19 90 24 18 46 34 49 34 2 1 24 -39 47 -88z m6198
64 c25 -40 -14 -84 -46 -52 -39 39 -92 33 -92 -10 0 -21 -11 -38 -25 -38 -57
0 -19 -99 63 -161 48 -37 87 -82 87 -102 0 -19 19 -45 42 -58 30 -17 45 -62
49 -154 7 -152 2 -145 105 -165 69 -14 79 -9 79 36 0 29 -22 64 -50 79 -67 36
-66 125 1 125 35 0 60 -25 78 -75 29 -84 31 -85 98 -49 33 18 64 17 100 -2 51
-27 51 -29 6 -80 -45 -51 -45 -51 25 -38 76 14 120 -38 73 -85 -36 -36 -113
-7 -191 71 -36 36 -74 57 -84 47 -10 -10 1 -33 26 -50 26 -20 38 -49 28 -74
-18 -47 30 -115 81 -115 19 0 67 -36 107 -81 70 -79 74 -80 122 -36 42 38 97
55 211 65 11 1 19 29 19 63 0 76 45 108 65 47 7 -25 24 -65 37 -89 41 -76 27
-215 -23 -242 -62 -33 -116 16 -74 66 21 26 19 44 -11 74 -52 52 -102 18 -83
-57 18 -71 20 -70 -95 -22 -111 46 -131 -6 -28 -73 84 -55 83 -140 -1 -140
-43 0 -72 20 -92 63 -37 82 -85 79 -83 -4 0 -37 -12 -71 -28 -76 -44 -16 -62
63 -27 120 26 45 23 57 -26 90 -31 21 -56 51 -56 67 0 16 -24 49 -52 74 -38
32 -48 62 -37 105 14 56 8 61 -72 61 -99 0 -130 -31 -76 -75 20 -17 37 -46 37
-64 0 -18 23 -40 50 -48 79 -26 68 -138 -14 -138 -115 0 -286 134 -286 225 0
26 -23 63 -51 83 -33 23 -48 59 -45 107 12 164 -7 349 -29 294 -31 -76 -77
-99 -105 -50 -12 23 -50 41 -85 41 -75 0 -99 52 -59 128 27 50 34 52 60 16 44
-60 164 -85 164 -35 0 22 -24 52 -53 68 -48 25 -49 32 -14 66 30 30 32 49 10
84 -31 50 34 148 98 148 19 0 34 11 34 25 0 14 27 25 61 25 34 0 68 -11 77
-25z m-9304 -1417 c-6 -753 -16 -1373 -22 -1380 -12 -12 -16 465 -16 1910 1
968 -2 869 26 851 14 -8 18 -587 12 -1381z m6891 1317 c54 -54 68 -175 20
-175 -45 0 -145 103 -145 150 0 87 53 97 125 25z m-2052 -40 c57 -73 47 -122
-18 -88 -59 30 -104 8 -132 -64 -13 -34 -37 -57 -54 -52 -39 13 -57 144 -20
144 14 0 51 28 81 63 68 78 79 77 143 -3z m15814 41 c9 -14 2 -49 -13 -78 -26
-48 -33 -50 -67 -15 -22 21 -32 56 -24 78 17 43 81 53 104 15z m-17183 -89
c-12 -69 -28 -79 -55 -36 -37 59 -28 103 20 94 28 -6 40 -27 35 -58z m10440
40 c24 -13 62 -29 85 -36 48 -15 60 -192 12 -190 -41 1 -116 62 -116 94 0 15
-19 38 -41 51 -25 14 -36 39 -26 63 18 47 27 49 86 18z m-15247 -1152 c2
-1193 -1 -1362 -25 -1386 -42 -42 -69 2399 -28 2506 41 108 52 -121 53 -1120z
m1866 1110 c34 -23 62 -56 62 -75 0 -40 -40 -47 -62 -10 -9 14 -37 25 -63 25
-54 0 -85 38 -62 75 21 35 54 31 125 -15z m4987 -105 c26 -68 26 -93 -1 -144
-49 -93 -86 -59 -87 79 0 210 23 227 88 65z m988 -77 c-25 -114 -88 -101 -88
18 0 114 22 143 70 95 24 -24 30 -60 18 -113z m863 52 c2 -91 135 -242 225
-255 60 -9 76 -19 53 -34 -20 -13 -27 -44 -18 -81 22 -88 -34 -75 -65 15 -29
84 -28 84 -140 52 -80 -23 -82 -22 -144 113 -68 149 -80 250 -31 267 48 17
119 -28 120 -77z m13724 55 c0 -22 -22 -45 -49 -52 -29 -8 -51 -39 -56 -77 -6
-48 -24 -66 -70 -71 -34 -3 -85 -10 -112 -14 -30 -5 -52 8 -58 35 -6 30 7 44
41 44 35 0 55 22 66 74 13 59 32 75 96 83 44 6 94 12 111 14 17 2 31 -14 31
-36z m-20775 -46 c0 -58 -40 -108 -65 -82 -19 19 18 143 43 143 12 0 22 -27
22 -61z m5013 8 c25 -78 -31 -121 -59 -45 -13 33 -18 69 -12 79 21 35 55 19
71 -34z m-337 -143 l57 -133 -84 -72 -83 -71 60 -49 c70 -56 118 -45 69 15
-28 35 -26 38 13 23 26 -9 93 -25 150 -34 81 -12 126 -40 201 -126 98 -110
277 -429 254 -452 -14 -14 -213 191 -213 220 0 10 -17 33 -37 50 -21 17 -38
57 -38 89 0 32 -25 76 -56 97 -60 42 -169 53 -169 16 0 -20 -130 -77 -178 -77
-105 0 -170 281 -72 313 60 18 66 76 11 106 -30 17 -33 36 -15 83 14 33 32 82
40 108 19 59 21 57 90 -106z m4933 84 c8 -21 41 -38 74 -38 124 0 161 -98 135
-356 -18 -180 -80 -234 -182 -158 -46 35 -45 37 33 65 83 30 101 59 55 87 -18
11 -12 27 14 47 37 27 37 36 -4 107 -38 67 -49 73 -73 39 -23 -32 -31 -20 -45
65 -15 95 -23 104 -91 104 -72 0 -94 23 -58 58 31 31 128 17 142 -20z m5109
-15 c8 -28 40 -62 73 -74 32 -13 59 -40 59 -61 0 -52 -31 -48 -110 15 -51 40
-87 48 -152 36 -108 -20 -142 27 -64 90 78 63 177 60 194 -6z m532 -26 c0 -76
-3 -78 -87 -64 -92 14 -117 -19 -59 -77 35 -35 -40 -195 -101 -219 -50 -19
-71 9 -92 121 -15 83 -11 97 36 109 60 16 72 103 22 156 -25 26 -20 26 24 -1
49 -29 62 -28 99 10 75 75 158 56 158 -35z m-15331 -22 c44 -41 81 -86 81
-100 0 -33 15 -32 75 6 34 21 57 22 75 4 36 -36 6 -105 -52 -123 -27 -9 -48
-37 -48 -64 0 -57 -63 -65 -84 -10 -19 48 -88 48 -107 -1 -8 -21 9 -132 37
-246 33 -129 47 -242 37 -299 -14 -92 45 -140 74 -61 17 47 54 -2 92 -123 29
-91 28 -117 -8 -192 -23 -47 -41 -110 -41 -139 0 -28 -11 -52 -25 -52 -14 0
-25 11 -25 25 0 14 -15 25 -34 25 -53 0 -37 -223 19 -264 38 -27 42 -54 28
-157 -22 -159 12 -229 113 -229 49 0 74 -13 74 -38 0 -30 -20 -34 -97 -22
-127 20 -140 -7 -89 -189 49 -176 39 -220 -56 -230 -57 -7 -72 -23 -79 -81 -7
-59 0 -69 35 -55 26 9 62 -1 90 -26 68 -61 56 -83 -30 -59 -57 17 -80 14 -89
-11 -21 -54 -24 -683 -4 -703 24 -24 119 61 119 105 0 39 89 46 112 10 8 -14
-2 -58 -23 -99 -21 -40 -33 -89 -25 -109 23 -61 -34 -168 -90 -168 -46 0 -49
-10 -34 -94 20 -114 25 -120 67 -85 50 41 93 -13 93 -116 0 -57 18 -99 56
-130 l57 -46 -71 -27 c-96 -37 -112 -35 -148 23 -44 70 -61 63 -79 -35 -19
-100 -78 -134 -115 -66 -40 76 -31 456 12 518 33 47 33 56 -1 84 -33 28 -38
251 -34 1859 2 1005 8 1836 15 1846 18 31 42 21 127 -56z m8137 -27 c64 -76
68 -173 8 -173 -39 0 -189 170 -189 215 0 65 115 38 181 -42z m1315 35 c-13
-62 -71 -71 -71 -10 0 31 16 52 39 52 24 0 36 -17 32 -42z m615 -52 c13 -41 7
-56 -20 -56 -52 0 -72 40 -53 103 19 58 47 39 73 -47z m-5566 -27 c9 -84 -20
-102 -69 -43 -35 43 -10 146 32 132 16 -5 33 -45 37 -89z m604 -107 c84 -135
93 -172 42 -172 -55 0 -191 202 -191 285 0 22 -11 40 -25 40 -14 0 -25 12 -25
26 0 53 127 -61 199 -179z m5836 38 c12 -27 67 -82 122 -121 88 -64 102 -67
122 -30 31 54 95 53 98 -3 1 -26 7 -31 15 -12 17 43 108 39 108 -5 0 -20 -10
-42 -22 -49 -12 -8 -16 -42 -9 -77 13 -67 -43 -86 -117 -40 -23 15 -48 9 -74
-16 -34 -35 -42 -33 -74 15 -26 39 -61 53 -134 53 -76 0 -116 17 -171 72 -39
39 -90 79 -113 88 -32 12 -35 23 -13 50 17 20 22 63 13 100 -10 41 -6 65 11
65 16 0 28 -17 28 -37 0 -21 12 -38 28 -38 17 0 21 24 11 66 l-16 65 82 -48
c45 -26 93 -70 105 -98z m-12675 71 c8 -24 8 -387 -1 -806 -8 -419 -13 -791
-10 -825 17 -194 15 -1077 -2 -1104 -39 -64 -80 23 -87 184 -13 272 -1 2549
13 2589 9 26 76 -3 87 -38z m2265 -41 c0 -34 -8 -81 -17 -105 -24 -61 -54 24
-38 107 14 76 55 75 55 -2z m3225 -8 c64 -55 69 -164 6 -152 -24 4 -47 34 -52
66 -4 31 -24 63 -43 71 -20 7 -36 23 -36 36 0 37 71 25 125 -21z m2985 3 c20
-52 -2 -85 -57 -85 -69 0 -82 29 -37 79 51 56 74 58 94 6z m9036 1 c44 -22 79
-50 79 -63 0 -31 -93 -29 -112 2 -29 46 -134 30 -123 -19 14 -56 -26 -117 -62
-95 -42 26 -34 75 24 148 60 77 87 80 194 27z m-13350 -50 c107 -54 157 -121
172 -234 11 -82 6 -102 -26 -102 -60 0 -76 -48 -32 -97 87 -97 11 -134 -156
-76 -88 31 -100 65 -37 110 36 27 28 39 -72 98 -98 57 -116 80 -130 169 -30
185 76 234 281 132z m-552 8 c-6 -17 -31 -31 -56 -31 -26 0 -51 14 -57 31 -6
20 14 31 57 31 42 0 62 -11 56 -31z m3581 -109 c62 -76 163 -167 225 -204 130
-77 81 -113 -62 -46 -109 53 -138 50 -138 -10 0 -27 16 -50 36 -50 20 0 42
-20 50 -45 8 -25 75 -73 149 -106 124 -56 133 -65 111 -121 -25 -67 -5 -108
28 -55 25 41 207 24 264 -24 21 -17 37 -73 37 -127 0 -70 11 -97 38 -97 23 0
37 24 37 63 0 48 13 62 56 62 150 -1 215 -69 140 -144 -23 -23 -20 -41 12 -76
60 -67 60 -68 -139 -165 -217 -107 -241 -95 -258 124 -14 180 -121 317 -233
296 -119 -22 -426 427 -429 627 0 28 -22 79 -49 113 -27 34 -49 77 -49 94 -2
65 66 23 174 -109z m2970 85 c34 -34 41 -120 9 -120 -47 0 -179 56 -179 76 0
58 124 90 170 44z m7557 4 c26 -14 48 -41 48 -60 0 -19 13 -39 29 -44 42 -14
98 -251 67 -282 -42 -43 -126 81 -94 140 41 78 5 147 -77 147 -85 0 -116 38
-74 89 36 43 39 43 101 10z m3963 -38 c21 -85 -18 -125 -87 -87 -59 31 -68 76
-23 121 48 48 93 35 110 -34z m-5415 -23 c46 -50 79 -62 159 -57 97 6 101 3
123 -88 40 -164 -46 -241 -106 -95 -39 94 -115 165 -137 129 -25 -39 -64 -33
-64 10 0 20 -31 44 -69 53 -144 35 -177 110 -48 110 56 0 102 -20 142 -62z
m2132 -57 c17 -154 15 -156 -139 -139 -155 17 -157 19 -178 138 l-17 92 132
10 c73 5 145 11 160 13 16 3 34 -46 42 -114z m-18704 -50 c2 -79 4 -280 6
-448 2 -167 12 -312 22 -323 28 -27 23 -160 -6 -160 -14 0 -25 -17 -25 -37 0
-21 10 -38 22 -38 31 0 54 -276 27 -326 -13 -26 -13 -75 2 -126 35 -123 -11
-161 -150 -123 -99 26 -103 31 -66 72 22 25 40 61 40 81 0 20 11 48 23 61 44
44 -28 207 -105 239 -61 25 -78 22 -127 -25 -31 -29 -78 -53 -104 -53 -63 0
-211 104 -213 150 -2 55 -250 173 -331 157 -37 -7 -87 -5 -111 4 -42 17 -42
20 3 52 46 35 47 69 1 227 -10 37 -2 58 28 70 54 21 129 -45 174 -153 88 -210
482 -307 691 -169 182 119 169 461 -14 363 -113 -60 -132 -28 -126 215 3 122
7 230 9 240 1 11 25 19 53 19 31 0 59 24 74 63 14 37 43 62 73 62 27 0 56 11
65 25 37 60 62 14 65 -119z m6072 63 c-1 -59 -70 -230 -96 -238 -46 -16 -129
44 -129 93 0 84 29 126 89 126 32 0 65 11 74 25 21 35 62 31 62 -6z m360 -16
c17 -26 -34 -333 -59 -360 -34 -37 -104 13 -118 85 -8 40 -24 72 -36 72 -44 0
-20 56 59 136 84 84 131 105 154 67z m12639 -108 c1 -61 -33 -73 -121 -42 -89
31 -92 40 -39 117 38 53 41 54 99 11 33 -24 61 -63 61 -86z m-16688 -39 c-19
-160 -48 -231 -93 -231 -114 2 -130 199 -18 225 45 10 65 34 70 82 5 38 20 68
33 68 16 0 19 -52 8 -144z m20414 85 c0 -32 -23 -79 -50 -103 -58 -53 -61 -95
-19 -252 29 -110 28 -117 -32 -162 -70 -55 -250 -67 -247 -18 2 17 11 60 21
94 l18 63 30 -57 c70 -129 144 -34 116 150 -13 87 -4 128 51 225 73 130 112
151 112 60z m-23765 -6 c22 -9 40 -37 40 -64 0 -100 47 -146 149 -146 54 0
104 -10 112 -22 23 -37 -103 -103 -198 -103 -98 0 -109 16 -44 64 41 31 41 35
-6 71 -28 21 -71 39 -95 39 -58 1 -79 59 -44 124 31 58 31 58 86 37z m9415
-21 c0 -20 -11 -43 -25 -52 -14 -8 -19 -26 -11 -39 49 -80 -67 -160 -134 -93
-45 45 -37 69 34 96 35 13 57 35 49 49 -9 14 -9 36 0 50 23 38 87 30 87 -11z
m7645 -33 c7 -44 20 -53 65 -42 43 11 62 -1 85 -51 69 -150 2 -188 -105 -61
-79 93 -224 86 -321 -16 -58 -61 -130 -79 -155 -38 -8 12 26 45 74 74 48 28
102 64 119 78 125 106 157 126 192 119 21 -4 42 -32 46 -63z m1804 -3 c18 -35
16 -56 -11 -78 -48 -40 -88 -11 -88 64 0 73 62 82 99 14z m-1339 -57 c-11 -32
-17 -77 -14 -100 10 -67 -47 -81 -102 -26 -60 60 -43 130 31 130 28 0 58 17
66 39 24 61 41 21 19 -43z m-4098 1 c53 -31 86 -67 78 -87 -7 -18 9 -39 36
-48 69 -22 62 -108 -12 -136 -34 -13 -64 -48 -68 -79 -5 -31 -23 -60 -40 -66
-43 -14 -40 97 6 185 55 105 47 130 -43 139 -68 6 -83 19 -89 76 -10 83 14 86
132 16z m4617 -150 c41 -25 69 -198 43 -267 -13 -35 -17 -96 -8 -136 10 -48 3
-87 -21 -114 -21 -24 -37 -90 -37 -150 1 -129 -9 -141 -118 -137 -47 1 -99
-14 -115 -33 -45 -54 -73 -42 -73 34 -1 118 -28 181 -79 181 -83 0 -173 74
-148 121 12 23 17 93 9 155 -15 134 73 214 169 154 82 -51 141 -41 90 16 -50
55 -31 79 63 79 55 0 71 12 71 51 0 28 18 92 41 144 l40 93 24 -88 c14 -48 36
-94 49 -103z m2327 76 c33 -58 36 -88 15 -149 -28 -80 -8 -135 27 -77 17 27
30 27 74 -1 54 -34 73 -96 28 -96 -14 0 -25 -35 -25 -77 0 -103 -60 -84 -70
23 -10 96 -121 115 -174 29 -31 -50 -106 -70 -106 -28 0 12 17 36 38 53 20 17
37 52 37 79 0 26 27 59 61 75 98 44 51 88 -93 86 -122 -2 -131 2 -138 62 -16
134 251 151 326 21z m-16601 61 c37 22 52 21 70 -9 61 -96 -22 -206 -88 -117
-16 23 -48 42 -71 42 -25 0 -41 20 -41 51 0 41 9 47 42 28 28 -16 58 -14 88 5z
m10036 -52 c37 -23 60 -26 71 -8 33 53 109 24 160 -61 47 -81 48 -88 7 -88
-24 0 -57 13 -72 28 -16 16 -48 21 -72 12 -58 -22 49 -140 128 -140 29 0 61
-7 70 -16 26 -26 -34 -84 -87 -84 -26 0 -57 -25 -69 -56 -20 -54 -23 -52 -59
34 -26 62 -62 99 -116 118 -66 23 -76 36 -64 86 11 43 -2 76 -46 119 -117 112
-3 155 149 56z m9306 23 c31 -57 -1 -111 -53 -91 -46 17 -76 80 -55 113 23 38
83 26 108 -22z m-8534 -6 c11 -18 27 -18 51 2 55 46 193 5 178 -53 -9 -37 1
-48 46 -48 89 0 171 -130 151 -238 -23 -123 68 -247 167 -227 107 21 100 -12
-64 -322 -36 -69 -76 -123 -89 -120 -61 14 -220 13 -253 -2 -25 -11 -54 9 -87
60 -64 95 -149 153 -199 134 -65 -25 -44 -96 42 -146 128 -75 139 -164 19
-164 -45 0 -225 180 -225 225 0 33 -174 196 -228 213 -186 59 38 269 232 218
79 -21 84 -28 84 -133 0 -123 67 -162 83 -48 20 140 100 164 151 44 39 -90
124 -194 159 -194 12 0 60 -29 106 -64 92 -70 139 -46 91 48 -15 29 -38 83
-51 119 -13 37 -71 99 -130 138 -65 44 -116 103 -132 152 -15 45 -39 81 -52
80 -90 -3 -117 25 -101 100 12 52 7 77 -13 77 -17 0 -23 -17 -14 -40 13 -33 0
-37 -81 -23 -85 14 -101 8 -138 -48 -36 -55 -49 -60 -92 -33 -83 52 -33 165
76 169 21 1 70 35 110 76 73 74 173 97 203 48z m-14138 -65 c0 -55 -6 -60 -37
-34 -21 17 -38 47 -38 66 0 19 17 34 38 34 23 0 37 -24 37 -66z m1755 -3 c6
-53 20 -67 61 -63 46 5 56 -12 71 -109 17 -116 -18 -205 -57 -143 -10 15 -43
35 -73 45 -65 20 -157 128 -157 185 0 40 94 154 128 154 10 0 22 -31 27 -69z
m1371 -9 c16 -29 22 -88 14 -133 -29 -150 45 -288 154 -289 66 0 76 -66 12
-84 -243 -68 -281 -31 -281 275 0 276 35 356 101 231z m1608 -24 c36 -28 66
-62 66 -75 0 -13 30 -69 66 -124 83 -126 165 -150 246 -74 65 61 113 49 113
-27 0 -27 14 -71 30 -97 39 -62 1 -103 -41 -45 -22 30 -66 44 -136 44 l-103 0
0 -114 0 -113 94 7 c112 9 151 -79 57 -130 -68 -36 -151 -9 -151 49 0 57 -54
79 -148 60 -59 -12 -80 -2 -114 50 -61 92 -41 155 44 145 63 -7 68 -1 68 79 0
56 -14 92 -39 102 -27 10 -37 40 -31 94 6 68 -2 82 -63 98 -86 24 -146 71
-128 101 24 38 101 24 170 -30z m13709 0 c8 -28 40 -62 73 -74 94 -36 65 -188
-31 -170 -35 7 -50 35 -55 109 -5 55 -19 110 -32 123 -31 32 -29 64 4 64 15 0
34 -23 41 -52z m1702 8 c-4 -24 -25 -43 -45 -43 -20 0 -41 19 -45 43 -6 31 7
44 45 44 38 0 51 -13 45 -44z m-12487 -111 c37 -50 67 -102 67 -114 0 -13 23
-44 50 -68 85 -77 61 -96 -99 -80 -127 14 -154 9 -181 -30 -49 -69 -137 -106
-208 -88 -58 14 -64 27 -57 117 9 118 57 150 81 54 15 -61 25 -66 106 -53 118
20 120 22 123 200 3 237 -6 232 118 62z m9527 90 c17 -44 -1 -85 -36 -85 -13
0 -24 28 -24 63 0 69 36 83 60 22z m-11124 -9 c92 -35 79 -76 -23 -76 -71 0
-88 10 -88 50 0 56 19 61 111 26z m389 -87 c0 -131 -31 -163 -71 -75 -50 109
-34 186 38 186 22 0 33 -35 33 -111z m814 19 c58 -75 62 -88 22 -71 -27 11
-82 26 -123 32 -105 17 -146 53 -110 97 52 62 137 39 211 -58z m-1764 -7 c0
-26 -10 -54 -22 -62 -27 -16 -59 56 -39 88 25 40 61 25 61 -26z m9994 11 c50
-22 110 -56 133 -76 36 -33 44 -33 72 1 46 55 81 47 71 -18 -5 -41 -24 -56
-70 -56 -46 0 -62 -14 -62 -50 0 -41 14 -49 73 -43 151 17 191 -10 153 -101
-42 -100 -89 -119 -89 -35 0 74 -65 103 -176 78 -87 -19 -92 -38 -26 -98 41
-37 44 -54 21 -106 -21 -46 -21 -73 -1 -107 66 -104 64 -211 -4 -274 -44 -42
-64 -87 -64 -144 0 -78 -5 -83 -86 -83 -93 0 -136 38 -93 81 20 20 32 16 43
-14 23 -59 77 -52 94 11 29 109 -53 226 -110 157 -19 -22 -59 -50 -91 -62 -56
-21 -79 -107 -35 -133 11 -8 10 -68 -3 -136 -24 -122 -25 -123 -97 -95 -55 20
-72 43 -72 94 0 106 -25 147 -90 147 -121 0 -214 165 -109 193 36 10 47 26 35
54 -44 103 -42 162 4 195 26 19 60 71 75 115 21 65 42 82 106 88 131 13 110
-102 -47 -262 -135 -136 -137 -175 -6 -120 52 22 93 65 117 123 21 49 48 89
62 89 13 0 28 25 33 56 6 47 27 59 119 69 99 11 114 21 129 88 10 41 26 100
36 131 15 50 8 56 -61 56 -53 0 -78 12 -78 38 0 23 -24 37 -62 37 -65 0 -84
-34 -36 -64 17 -10 12 -32 -16 -63 -39 -43 -40 -48 -2 -63 50 -19 54 -60 7
-60 -48 0 -88 54 -106 143 -13 64 -1 91 73 166 100 103 109 105 236 53z m3299
-12 c15 -60 53 -64 92 -12 20 27 51 34 109 22 82 -16 115 -85 41 -85 -22 0
-72 -19 -111 -42 -113 -67 -257 20 -215 130 21 53 68 46 84 -13z m-15268 -37
c0 -21 -22 -38 -50 -38 -50 0 -65 27 -33 58 30 31 83 18 83 -20z m3211 4 c56
-42 39 -101 -63 -213 -111 -122 -145 -39 -62 152 44 103 58 110 125 61z m5017
-67 c98 -93 103 -104 75 -166 -28 -62 -23 -74 63 -163 52 -53 115 -96 140 -96
25 0 56 -27 69 -62 13 -35 40 -63 61 -63 61 0 164 -114 164 -181 0 -85 -58
-128 -143 -109 -47 11 -58 9 -35 -7 53 -35 15 -163 -42 -140 -104 45 -163 44
-197 -2 -29 -40 -42 -42 -83 -17 -27 17 -71 31 -97 31 -71 0 -107 60 -98 166
6 74 -2 97 -36 104 -27 5 -44 -6 -44 -31 0 -21 -11 -39 -25 -39 -14 0 -25 11
-25 24 0 12 11 30 25 39 46 28 26 59 -44 67 -56 6 -67 18 -62 69 4 34 -8 101
-27 150 -46 115 11 231 123 253 74 15 65 25 -59 62 -65 20 -27 61 55 61 97 0
142 45 80 80 -56 31 -52 70 8 70 27 0 96 -45 154 -100z m5217 78 c21 -13 27
-43 16 -87 -22 -89 -61 -109 -61 -33 0 34 -17 68 -37 76 -21 8 -38 26 -38 40
0 31 74 34 120 4z m-10768 -43 c26 -31 26 -49 2 -88 -25 -39 -23 -51 8 -63 41
-16 52 -98 15 -120 -53 -33 -98 19 -106 121 -15 183 12 233 81 150z m-6226
-49 c23 -27 24 -46 5 -65 -40 -40 -106 -6 -106 53 0 60 56 67 101 12z m16316
24 c75 -20 90 -74 45 -162 -48 -91 -64 -91 -132 1 -100 135 -64 201 87 161z
m5981 -70 c22 -26 19 -38 -14 -50 -50 -19 -97 19 -73 58 23 37 52 34 87 -8z
m-17754 -38 c44 -17 81 -48 81 -67 0 -50 -197 -48 -216 3 -17 44 8 120 35 106
10 -5 55 -24 100 -42z m8711 4 c18 -24 63 -64 101 -88 38 -24 69 -60 69 -79 0
-19 14 -41 31 -47 17 -7 8 -14 -20 -15 -47 -2 -336 138 -336 162 0 19 86 111
104 111 10 0 33 -20 51 -44z m-9467 -95 c2 -134 -105 -253 -177 -200 -42 30
-40 36 34 74 93 48 102 95 26 145 -70 46 -39 101 50 90 60 -7 67 -18 67 -109z
m3373 68 c22 -67 -9 -129 -76 -155 -50 -19 -55 -33 -42 -117 30 -176 25 -195
-43 -187 -118 14 -163 13 -206 -6 -32 -14 -44 -8 -44 23 0 24 23 49 50 56 62
16 66 78 6 99 -73 26 -104 60 -89 97 20 53 77 44 96 -15 23 -72 87 -16 87 75
0 131 226 242 261 130z m10889 -6 c0 -28 34 -86 77 -128 52 -53 68 -85 50
-103 -18 -18 -18 -36 1 -58 62 -75 -27 -109 -96 -36 -24 26 -73 51 -107 56
-70 10 -82 117 -29 252 33 81 104 93 104 17z m-1254 -5 c49 -60 -27 -297 -79
-245 -43 43 -62 32 -79 -48 -20 -91 -44 -108 -95 -68 -52 40 22 210 87 199 62
-11 80 41 33 93 -39 44 -39 48 4 73 61 36 97 34 129 -4z m-6271 -30 c0 -40
-88 -53 -110 -16 -19 29 10 53 64 53 25 0 46 -17 46 -37z m-2298 -39 c42 -23
70 -124 34 -124 -46 0 -111 59 -111 101 0 56 10 59 77 23z m-6313 -84 c9 -47
5 -106 -9 -130 -16 -29 -17 -67 -1 -107 28 -74 8 -181 -59 -313 -48 -95 -37
-138 38 -140 11 0 13 -11 5 -25 -27 -42 -84 -28 -100 25 -9 28 -37 50 -63 50
-127 0 -164 68 -70 130 l55 37 -53 67 c-77 98 -24 221 106 245 39 8 50 31 53
109 4 136 4 137 45 137 22 0 43 -35 53 -85z m10495 48 c8 -21 31 -38 51 -38
21 0 49 -20 62 -44 23 -40 29 -39 77 13 92 97 151 59 144 -92 -6 -114 40 -169
64 -78 30 114 153 35 155 -99 0 -23 29 -41 76 -45 136 -15 217 -205 86 -205
-28 0 -45 -11 -36 -25 8 -14 43 -25 77 -25 34 0 89 -18 122 -40 35 -22 82 -32
110 -23 39 12 60 -2 90 -61 52 -100 40 -115 -125 -163 -153 -44 -183 -83 -52
-68 89 10 124 -19 131 -107 2 -28 11 -86 21 -130 17 -73 11 -84 -81 -142 -62
-39 -120 -58 -153 -49 -76 20 -69 -51 10 -102 157 -103 42 -218 -193 -193
-185 20 -228 42 -168 86 21 16 46 50 56 75 13 36 33 42 92 30 83 -19 98 17 40
93 -45 60 -77 55 -110 -18 -26 -56 -36 -59 -98 -36 -38 15 -75 26 -82 26 -7
-1 -12 22 -10 50 1 28 -24 68 -57 89 -66 44 -76 83 -20 83 20 0 37 17 37 38 0
40 -63 51 -86 14 -8 -12 -39 -17 -70 -10 -51 10 -52 8 -15 -22 46 -39 39 -131
-20 -264 -46 -102 -54 -101 -148 13 -110 134 -123 181 -59 225 35 24 44 45 27
62 -31 31 -79 3 -79 -47 0 -73 -136 -31 -145 46 -6 51 -24 69 -73 75 -176 21
-121 221 69 249 100 15 117 10 168 -50 30 -37 56 -86 56 -109 0 -66 83 -98
192 -74 104 22 122 96 54 223 -25 48 -22 62 18 94 60 45 149 38 149 -13 0 -21
-13 -35 -28 -32 -52 9 -6 -113 47 -127 104 -27 143 101 53 174 -28 22 -22 33
28 56 49 22 62 21 62 -6 0 -19 17 -48 39 -66 57 -48 99 4 61 76 -19 36 -21 64
-5 80 33 33 7 120 -35 120 -19 0 -35 -9 -35 -20 0 -10 -37 -35 -81 -54 -45
-19 -89 -39 -97 -44 -9 -5 -24 22 -33 60 -21 83 -53 107 -145 108 -69 0 -95
37 -40 56 18 5 23 28 13 55 -15 37 -24 39 -56 13 -31 -26 -48 -21 -99 27 -79
74 -79 114 1 134 98 25 15 140 -102 140 -86 0 -135 36 -80 58 66 27 164 16
178 -20z m10341 -1 c0 -51 -61 -72 -117 -41 -42 24 -40 28 17 51 87 35 100 33
100 -10z m-22525 -9 c0 -39 -61 -72 -162 -88 -114 -18 -178 11 -155 70 17 44
317 61 317 18z m16740 -78 c-16 -102 1 -124 55 -70 23 23 30 21 30 -10 0 -22
-17 -46 -37 -54 -54 -21 -47 -107 15 -168 39 -40 45 -60 23 -82 -44 -43 -101
48 -101 161 0 71 -11 95 -50 105 -59 16 -67 88 -12 109 20 8 37 36 37 62 0 26
13 47 28 47 19 0 23 -33 12 -100z m-11465 -9 c0 -142 -179 -201 -195 -65 -6
51 9 72 75 103 96 47 120 39 120 -38z m13944 -93 c153 -59 -32 -134 -230 -94
-167 34 -215 106 -137 206 l50 63 130 -77 c72 -42 156 -86 187 -98z m-13702
50 c4 -80 -47 -173 -96 -173 -38 0 -22 101 18 116 28 11 34 35 22 90 -12 57
-8 72 18 64 18 -7 35 -50 38 -97z m10663 44 c29 -45 9 -79 -51 -87 -62 -10
-64 -15 -28 -82 32 -59 -82 -119 -139 -73 -40 33 -65 125 -35 125 31 0 29 93
-2 113 -14 8 -25 27 -25 42 0 36 255 2 280 -38z m-9916 -28 c20 -80 -3 -114
-79 -114 -80 0 -103 63 -47 126 60 66 108 62 126 -12z m9536 2 c0 -131 -50
-214 -141 -231 -108 -20 -136 4 -64 54 30 22 55 55 55 75 0 20 9 36 21 36 12
0 34 28 49 63 36 78 80 80 80 3z m7131 -91 c86 -188 89 -236 13 -216 -31 9
-76 15 -100 16 -55 0 -150 181 -126 242 58 154 131 139 213 -42z m-3018 90
c55 -20 103 -54 108 -78 7 -35 27 -40 105 -27 55 8 103 4 111 -10 9 -14 -2
-25 -23 -25 -77 0 9 -138 100 -161 70 -17 77 -44 24 -89 -21 -17 -38 -47 -38
-66 0 -20 -17 -42 -37 -50 -22 -8 -38 -46 -38 -87 0 -77 -59 -123 -103 -79
-16 16 -9 51 21 102 41 73 41 80 3 110 -23 18 -46 55 -50 83 -7 37 -34 53
-106 62 -101 13 -127 40 -151 156 -8 38 -31 69 -50 69 -20 0 -67 12 -106 27
-68 26 -69 28 -22 62 61 45 124 45 252 1z m2639 9 c26 -14 48 -48 48 -75 0
-48 -3 -48 -62 -9 -98 64 -86 137 14 84z m-14902 -22 c0 -28 -264 -152 -323
-152 -23 0 -64 16 -91 36 -47 34 -46 36 22 62 39 15 103 27 144 27 40 0 73 11
73 25 0 14 39 25 88 25 48 0 87 -10 87 -23z m4387 -27 c26 -81 -11 -110 -66
-52 -27 29 -42 64 -33 77 26 42 83 28 99 -25z m-4124 -74 c0 -47 -244 -171
-299 -152 -41 15 -40 20 14 55 33 21 84 46 113 56 30 9 68 34 85 54 36 43 87
35 87 -13z m11575 -1 c24 -27 55 -50 68 -50 13 0 57 -24 98 -53 l75 -53 -69
-72 c-79 -82 -135 -93 -135 -28 0 25 -24 65 -52 90 -50 42 -54 42 -85 0 -28
-38 -32 -27 -30 86 2 145 46 172 130 80z m-16527 -31 c21 -30 39 -81 39 -113
0 -38 21 -65 63 -81 139 -53 50 -136 -117 -109 -117 19 -159 93 -133 234 27
145 79 169 148 69z m6134 -8 c59 -19 4 -61 -78 -61 -107 1 -170 40 -117 74 33
21 98 17 195 -13z m9356 -25 c13 -35 24 -89 24 -120 0 -32 45 -103 104 -164
94 -98 100 -112 63 -139 -53 -39 -55 -73 -3 -53 22 8 62 3 89 -11 36 -20 68
-17 122 10 97 48 171 -15 87 -73 -132 -92 -143 -126 -49 -161 78 -30 84 -87 6
-66 -31 9 -76 15 -100 16 -24 0 -44 17 -44 38 0 20 11 37 25 37 43 0 28 97
-19 121 -24 12 -100 31 -168 41 -151 21 -196 52 -164 111 13 25 13 57 0 78
-13 20 -17 56 -9 80 9 29 -3 51 -36 63 -77 28 -191 208 -150 234 76 48 196 25
222 -42z m-14377 -9 c34 -63 33 -69 -11 -86 -56 -21 -113 8 -113 58 0 87 82
106 124 28z m7021 -27 c4 -34 -8 -83 -26 -108 -32 -44 -36 -44 -117 0 -46 25
-111 70 -144 99 -75 67 -46 83 142 76 127 -4 138 -9 145 -67z m-4016 -12 c22
-47 21 -71 -3 -99 -40 -49 -76 -27 -76 45 0 31 -13 70 -30 86 -23 23 -18 30
26 30 34 0 66 -23 83 -62z m-7547 -96 c-84 -151 -163 -164 -149 -23 8 80 20
96 82 108 104 20 116 5 67 -85z m5706 33 c0 -99 -147 -92 -159 8 -7 66 -2 70
75 62 70 -6 84 -17 84 -70z m11318 5 c137 -41 182 -92 79 -92 -30 0 -46 -17
-44 -44 5 -59 -59 -56 -161 7 -46 27 -93 44 -105 36 -40 -24 -125 48 -125 107
0 66 99 63 356 -14z m-9243 19 c9 -15 52 -19 101 -9 156 29 104 -45 -71 -100
-41 -13 -40 -21 14 -107 69 -109 118 -134 118 -60 0 39 16 52 62 52 34 0 72
21 86 47 33 61 196 158 215 127 8 -12 -10 -79 -40 -149 -45 -103 -61 -120 -90
-97 -27 24 -49 16 -104 -37 -54 -51 -94 -66 -180 -66 -154 1 -184 26 -189 162
-2 64 -11 123 -20 131 -8 8 -15 42 -15 74 0 61 81 84 113 32z m10340 -54 c69
-56 96 -95 88 -127 -8 -31 7 -55 48 -73 91 -42 73 -72 -33 -57 -101 14 -180
-27 -173 -89 3 -20 -7 -36 -20 -36 -14 0 -21 18 -18 42 4 23 -20 85 -53 138
-33 52 -65 137 -71 189 -10 88 -7 93 60 93 44 0 112 -32 172 -80z m-12235 -28
c-17 -52 -80 -32 -89 29 -7 52 -3 55 46 29 29 -15 49 -42 43 -58z m10577 53
c17 -16 30 -55 30 -86 0 -67 79 -128 193 -149 93 -18 118 -44 96 -101 -13 -36
-21 -35 -76 1 -86 56 -125 50 -159 -24 -38 -83 -37 -86 20 -86 28 0 68 -28 91
-62 36 -55 59 -63 183 -63 196 0 266 84 151 183 -28 24 -44 54 -36 68 22 36
107 29 130 -11 11 -19 47 -39 80 -44 71 -10 94 -55 47 -93 -18 -15 -70 -57
-116 -94 l-84 -68 58 -43 c67 -51 97 -41 97 30 0 38 14 49 56 42 47 -6 57 -24
59 -107 1 -56 7 -117 13 -137 17 -65 -92 -58 -166 10 -92 85 -117 81 -109 -18
4 -44 -2 -96 -13 -113 -27 -44 0 -105 47 -105 24 0 38 23 38 63 0 129 217 31
265 -121 20 -63 125 -99 182 -63 46 29 134 17 202 -27 32 -21 31 -36 -6 -113
-45 -95 -83 -111 -128 -53 -31 40 -230 62 -224 25 38 -225 38 -261 2 -261 -20
0 -56 39 -79 88 -36 77 -48 84 -92 60 -45 -24 -50 -47 -43 -179 7 -120 0 -156
-33 -177 -52 -33 -121 17 -121 88 0 26 -13 72 -28 101 -23 43 -19 59 28 94
l55 42 -52 103 c-52 102 -52 104 -5 129 54 29 177 -5 177 -48 0 -14 34 -26 75
-26 41 0 75 11 75 25 0 14 -17 25 -38 25 -21 0 -51 28 -67 63 -27 59 -92 82
-129 44 -10 -9 -86 -19 -169 -21 -136 -4 -153 1 -172 53 -12 31 -62 88 -111
128 -62 49 -89 91 -89 137 0 54 -15 70 -75 84 -91 19 -99 62 -12 62 69 0 148
-67 174 -147 17 -54 159 -111 195 -79 37 33 -27 144 -93 161 -35 9 -64 33 -64
53 0 20 -21 37 -48 37 -33 0 -44 13 -35 45 8 31 -9 55 -53 75 -35 16 -64 47
-64 70 0 31 -15 37 -62 25 -51 -13 -68 -2 -100 60 -22 41 -44 75 -49 75 -5 0
-28 7 -49 15 -29 11 -40 0 -40 -37 0 -69 -89 -72 -107 -3 -8 31 -35 51 -72 52
l-58 1 60 25 c34 13 94 17 133 8 41 -9 86 -3 107 15 20 16 60 24 88 16 91 -23
82 50 -16 140 -113 103 -105 168 22 168 46 0 97 -13 113 -30z m-7095 -85 c12
-66 23 -73 125 -80 62 -5 124 -20 138 -35 29 -31 -262 -6 -293 25 -40 40 -55
187 -18 175 20 -6 41 -44 48 -85z m10875 6 c0 -19 17 -49 38 -66 20 -17 37
-41 37 -53 0 -32 -85 -27 -120 8 -43 43 -38 145 8 145 20 0 37 -15 37 -34z
m-17039 -14 c8 -13 3 -31 -12 -40 -37 -23 -106 7 -87 38 20 31 80 33 99 2z
m7153 -4 c29 -47 -31 -85 -75 -49 -22 18 -39 42 -39 54 0 32 94 27 114 -5z
m7318 -123 c92 0 115 -10 143 -63 44 -82 10 -117 -88 -90 -41 11 -97 10 -125
-2 -79 -35 -194 17 -175 79 9 27 3 73 -13 102 -56 105 -5 141 76 54 60 -67 90
-80 182 -80z m5224 70 c-6 -53 2 -63 39 -54 73 20 116 -146 52 -201 -26 -22
-58 -40 -72 -40 -38 0 -107 121 -91 162 8 22 -6 48 -35 63 -46 25 -47 30 -8
90 54 81 124 69 115 -20z m-23171 -7 c31 -41 72 -63 117 -63 77 0 118 -40 79
-79 -36 -36 -198 39 -218 102 -9 28 -27 52 -40 52 -13 0 -23 11 -23 25 0 43
36 27 85 -37z m1956 -148 c-18 -233 10 -278 124 -203 68 45 148 48 253 12 74
-26 75 -30 77 -207 2 -99 5 -196 8 -217 12 -89 -3 -130 -43 -115 -63 24 -86
-6 -55 -73 40 -88 14 -99 -114 -50 -111 43 -142 93 -121 194 8 40 14 41 62 7
88 -62 143 -49 143 34 0 55 -22 86 -98 136 -54 36 -128 104 -164 152 -37 48
-108 108 -159 135 -116 60 -120 87 -43 262 100 225 151 199 130 -67z m3113
139 c-14 -102 -79 -229 -117 -229 -45 0 -47 48 -7 142 28 66 35 90 42 141 2
11 23 17 47 12 29 -6 41 -27 35 -66z m440 22 c31 -25 56 -66 56 -89 0 -38 19
-41 162 -25 l162 17 -35 -69 c-20 -37 -43 -112 -52 -166 -29 -168 -212 -192
-212 -28 0 87 -70 144 -143 116 -39 -15 -82 94 -82 207 0 100 52 114 144 37z
m5733 -3 c79 -79 42 -146 -39 -69 -64 60 -83 121 -38 121 14 0 48 -23 77 -52z
m6364 -11 c21 -54 -37 -112 -112 -112 -50 0 -57 7 -34 30 17 17 30 50 30 75 0
56 95 62 116 7z m-9791 -53 c0 -22 -13 -85 -30 -140 -22 -76 -22 -109 0 -146
41 -65 37 -140 -7 -157 -21 -8 -38 -42 -38 -75 0 -33 -17 -67 -37 -75 -21 -8
-38 -41 -38 -73 0 -32 -13 -71 -28 -86 -30 -30 -81 -114 -118 -196 -36 -76
-191 -186 -265 -186 -54 0 -64 11 -64 72 0 39 -7 107 -16 150 -19 95 32 109
56 15 10 -39 39 -68 79 -78 103 -26 144 18 144 156 0 146 24 193 89 172 55
-18 70 81 20 131 -22 22 -7 35 56 51 64 17 83 35 76 71 -24 145 -11 302 31
366 51 77 90 89 90 28z m-7272 -15 c1 -17 0 -61 -2 -96 -5 -87 61 -135 184
-135 96 0 103 -6 109 -75 6 -62 -8 -86 -82 -136 l-90 -61 -112 55 c-61 30
-118 71 -126 92 -34 88 -225 15 -255 -98 -15 -58 -33 -75 -69 -69 -79 14 -97
49 -52 99 23 26 42 65 42 88 0 24 38 57 90 79 81 34 88 44 73 113 -18 81 42
113 71 38 26 -68 91 -44 91 33 0 39 8 78 17 87 28 29 108 19 111 -14z m317
-25 c-4 -31 -27 -60 -51 -64 -50 -10 -59 45 -14 90 47 47 74 36 65 -26z m1705
-15 c0 -39 7 -158 16 -263 12 -136 8 -191 -12 -191 -19 0 -29 60 -29 177 0 97
-12 199 -27 227 -29 54 -15 121 26 121 14 0 26 -32 26 -71z m6439 35 c51 -37
46 -42 -76 -71 -28 -7 -70 -20 -94 -30 -36 -15 -44 -5 -44 59 0 72 7 78 83 78
45 0 104 -16 131 -36z m6155 -20 c42 -39 88 -55 158 -53 99 3 130 -23 61 -50
-21 -8 -38 -37 -38 -65 0 -28 -12 -51 -26 -51 -14 0 -36 -29 -50 -64 -26 -70
-76 -63 -58 8 11 43 -182 231 -238 231 -54 0 -53 52 2 74 90 36 125 30 189
-30z m-5751 -1 c11 -17 51 -45 90 -62 38 -17 63 -42 55 -56 -9 -13 9 -57 38
-96 55 -75 59 -155 7 -172 -16 -5 -36 12 -44 39 -33 102 -143 184 -228 168
-84 -16 -161 2 -161 37 0 11 37 24 81 29 68 6 83 19 89 76 9 74 40 89 73 37z
m1467 -49 c81 -86 178 -128 252 -109 59 15 66 10 59 -40 -7 -50 -25 -58 -137
-65 -145 -8 -202 29 -226 148 -8 40 -24 72 -36 72 -12 0 -22 11 -22 25 0 43
54 27 110 -31z m-7192 -32 c29 -20 57 -63 62 -93 6 -47 30 -60 139 -77 202
-32 168 -79 -77 -107 -207 -24 -326 108 -241 267 31 58 47 59 117 10z m2367
-67 c10 -58 26 -117 37 -131 10 -15 40 -94 66 -176 26 -83 60 -167 75 -188 70
-98 91 -221 48 -286 -23 -35 -50 -64 -60 -64 -39 0 -152 -135 -140 -167 18
-47 -10 -108 -49 -108 -19 0 -39 20 -46 44 -12 44 -28 846 -20 1062 5 154 65
164 89 14z m1490 0 c0 -52 -46 -84 -78 -52 -15 15 -14 50 4 96 28 76 73 49 74
-44z m5451 53 c15 -29 22 -58 16 -65 -21 -20 -143 71 -128 95 25 39 83 23 112
-30z m5749 -38 c0 -30 17 -35 75 -22 83 18 98 -12 36 -74 -47 -46 -46 -46
-171 -12 -84 24 -101 21 -121 -14 -22 -39 -27 -39 -71 2 -71 64 -59 95 58 152
113 55 194 42 194 -32z m-13550 -58 c0 -76 63 -108 174 -90 99 17 103 15 139
-71 20 -49 37 -118 37 -153 0 -35 23 -85 50 -113 59 -59 64 -100 13 -100 -25
0 -38 -25 -38 -72 0 -42 -16 -79 -37 -87 -23 -9 -38 -46 -38 -93 0 -61 -9 -75
-40 -63 -21 8 -49 15 -62 15 -38 0 -26 76 15 91 26 10 31 24 14 44 -58 70 -60
234 -3 326 65 105 55 128 -61 150 -49 9 -88 27 -88 40 0 13 -16 24 -35 24 -19
0 -61 21 -93 47 -53 44 -55 53 -24 112 37 70 77 66 77 -7z m6279 32 c50 -45
62 -109 20 -109 -42 0 -173 106 -159 129 21 34 90 24 139 -20z m3264 -18 c-6
-15 5 -72 23 -125 41 -116 44 -200 8 -178 -14 9 -19 39 -10 66 12 40 6 49 -30
42 -65 -13 -71 -102 -10 -158 28 -25 51 -61 51 -79 0 -48 41 -42 61 8 12 33
22 35 46 11 24 -25 21 -37 -15 -57 -32 -18 -38 -34 -19 -56 19 -23 6 -46 -50
-88 -73 -54 -79 -54 -125 -13 -69 62 -60 110 21 114 67 4 67 4 6 15 -34 6 -73
22 -86 34 -13 13 -51 23 -85 23 -51 0 -55 6 -28 39 61 73 -113 142 -196 78
-21 -17 -41 -16 -58 1 -53 53 -8 120 128 189 76 38 141 80 146 94 4 13 27 24
50 25 23 0 63 17 89 36 51 39 99 27 83 -21z m7212 19 c113 -139 263 -260 323
-260 65 0 172 -109 172 -174 0 -38 -16 -51 -62 -51 -45 0 -63 -14 -63 -46 0
-42 -9 -44 -87 -19 -49 15 -88 41 -88 57 0 67 -60 156 -110 163 -44 6 -54 27
-60 127 -7 99 -18 125 -69 148 -66 31 -83 95 -24 95 20 0 51 -18 68 -40z
m-13947 -206 c-8 -30 -23 -54 -35 -54 -30 0 -57 166 -35 219 25 61 90 -90 70
-165z m1872 52 l8 -143 94 2 c75 3 88 -3 66 -30 -38 -45 -7 -85 66 -85 75 0
78 -41 7 -117 -73 -77 -85 -74 -156 38 -33 53 -76 112 -94 131 -99 103 -125
174 -96 262 46 137 96 109 105 -58z m5040 114 c49 -49 34 -95 -31 -95 -75 0
-103 40 -63 89 37 44 55 45 94 6z m4396 -22 c94 -58 108 -112 35 -135 -79 -25
-151 29 -151 113 0 88 7 89 116 22z m-10253 -13 c79 -52 78 -76 -2 -96 -90
-22 -66 -66 75 -136 77 -38 108 -66 89 -78 -46 -28 -121 1 -282 110 -142 96
-235 116 -405 86 -69 -12 -81 70 -13 91 29 10 67 5 85 -10 23 -19 69 -13 167
20 174 60 211 62 286 13z m8999 16 c8 -13 47 -18 85 -10 55 11 90 -3 156 -60
46 -40 118 -82 159 -92 90 -22 112 -52 112 -151 0 -109 -34 -156 -83 -115 -22
17 -51 24 -66 14 -16 -9 -49 2 -74 25 -30 27 -52 32 -62 15 -22 -35 -239 -35
-239 -1 0 16 -43 24 -104 19 -94 -7 -107 -16 -133 -94 -19 -54 -36 -75 -48
-56 -10 17 -11 52 -3 78 8 27 -2 63 -24 86 -36 35 -35 48 11 133 28 52 51 114
51 138 0 77 221 137 262 71z m-1634 -47 c12 -61 24 -189 30 -325 5 -119 17
-165 49 -183 24 -13 43 -34 43 -47 0 -33 -118 -31 -138 2 -18 29 -258 26 -276
-3 -6 -9 12 -23 39 -30 28 -7 50 -24 50 -38 0 -39 -74 -57 -125 -30 -75 40
-124 29 -153 -35 -37 -79 -157 -105 -218 -46 -25 24 -67 56 -94 72 -38 23 -41
35 -17 61 23 24 24 40 3 66 -39 46 -21 56 102 61 88 4 110 15 130 65 12 34 44
66 71 73 40 11 43 22 21 71 -62 137 27 179 111 52 58 -89 244 -145 244 -74 0
16 7 48 16 71 11 28 -1 45 -38 55 -70 18 -67 71 8 146 55 55 133 63 142 16z
m-8228 -39 c0 -44 -76 -74 -107 -43 -13 13 -16 36 -7 51 25 39 114 33 114 -8z
m7375 -51 c0 -32 -17 -72 -37 -89 -50 -41 -48 -116 2 -135 65 -25 -2 -83 -118
-103 l-101 -17 15 -116 c20 -158 -11 -205 -104 -153 -53 29 -70 59 -74 125 -2
47 -8 115 -12 149 -8 55 0 62 60 55 38 -4 69 4 69 17 0 13 6 40 14 60 9 23 -6
42 -40 50 -78 21 -54 103 32 113 50 6 69 22 69 59 0 41 12 48 56 37 32 -8 73
-4 93 8 49 31 76 9 76 -60z m-14463 27 c61 -45 33 -116 -46 -116 -71 0 -128
59 -107 112 18 47 91 49 153 4z m3907 -66 c-66 -117 -119 -130 -119 -30 0 85
41 130 118 130 l58 0 -57 -100z m6427 25 c15 -41 44 -75 66 -75 22 0 64 -22
94 -50 65 -61 53 -63 -58 -9 -118 57 -173 109 -173 163 0 71 42 54 71 -29z
m-9607 -19 c83 -66 113 -131 60 -131 -14 0 -35 -26 -47 -58 -14 -35 -57 -68
-115 -85 l-92 -29 13 80 c32 193 59 292 80 292 8 0 53 -31 101 -69z m2571 -62
c-24 -72 -17 -168 15 -206 24 -29 10 -63 -27 -63 -10 0 -42 45 -71 101 -49 94
-49 105 -12 162 53 81 121 85 95 6z m-747 -88 c22 -171 31 -203 34 -125 2 50
16 69 50 69 26 0 82 7 125 16 77 15 78 14 78 -88 0 -118 -39 -135 -77 -34 -24
61 -29 64 -51 25 -13 -24 -40 -44 -59 -44 -20 0 -46 -18 -58 -40 -37 -66 -130
-1 -130 90 0 43 -18 82 -44 97 -40 22 -38 29 17 89 83 88 97 82 115 -55z
m4606 50 c-21 -24 -45 -66 -54 -93 -27 -84 -109 -165 -189 -188 -72 -20 -106
4 -51 38 14 8 25 35 25 61 0 25 42 77 94 116 51 39 97 79 102 90 4 11 31 20
60 20 47 0 48 -4 13 -44z m-5532 -229 c19 -261 -1 -473 -40 -434 -42 42 -41
682 0 682 13 0 31 -112 40 -248z m16107 192 c-16 -48 -119 -55 -119 -8 0 25
23 39 65 39 40 0 60 -12 54 -31z m516 -25 c46 -46 53 -94 13 -94 -15 0 -43 17
-64 38 -49 48 -169 48 -210 -2 -50 -60 -135 -35 -144 43 l-8 67 186 -6 c132
-4 199 -18 227 -46z m-10535 7 c0 -12 -11 -30 -25 -38 -35 -22 -31 -88 4 -88
16 0 49 18 73 39 32 29 55 33 89 15 26 -14 66 -31 90 -39 31 -9 44 -39 44
-102 0 -93 -32 -115 -70 -48 -28 49 -114 37 -125 -18 -4 -25 15 -47 50 -58 35
-10 45 -23 26 -30 -48 -20 -37 -105 18 -139 36 -23 42 -39 22 -63 -65 -77
-196 4 -196 122 0 63 -9 71 -77 71 -69 0 -73 4 -38 38 39 40 29 112 -16 112
-15 0 -66 -40 -113 -89 -80 -83 -85 -95 -57 -157 l31 -66 38 73 39 74 47 -59
c48 -59 48 -59 -27 -137 -58 -59 -72 -91 -59 -138 18 -73 144 -201 195 -201
55 0 45 94 -13 125 -66 35 -63 93 6 151 93 78 126 63 107 -49 -13 -73 -7 -103
21 -118 62 -35 117 -227 75 -262 -62 -51 -36 -109 72 -166 59 -30 127 -58 152
-62 95 -14 49 -57 -70 -65 -120 -7 -129 -3 -215 96 -102 117 -278 168 -333 97
-51 -67 -391 -124 -389 -66 4 80 157 156 323 161 90 3 194 7 232 8 39 1 83 25
105 55 49 71 24 105 -43 58 -75 -53 -343 -53 -343 0 0 21 22 37 51 37 60 0 93
66 52 107 -15 15 -28 60 -28 98 0 41 -14 70 -33 70 -36 0 -110 78 -161 168
-57 104 -29 329 30 234 19 -30 214 66 214 105 0 37 150 166 194 167 17 1 31
-10 31 -23z m-8575 -70 c-1 -64 -49 -177 -50 -115 0 15 -7 63 -16 106 -12 62
-7 78 25 78 28 0 41 -22 41 -69z m19379 6 c-4 -27 -10 -78 -12 -112 -4 -57
-13 -62 -107 -54 -83 6 -106 -1 -115 -38 -16 -61 -235 -123 -285 -81 -87 72
31 181 135 126 70 -38 171 3 193 77 41 133 211 207 191 82z m463 -187 c20 -26
21 -47 3 -69 -36 -43 -69 -39 -88 11 -8 23 -59 85 -111 137 -148 148 -122 197
35 67 72 -59 145 -125 161 -146z m-19027 196 c47 -77 56 -234 15 -279 -39 -43
-38 -48 1 -70 34 -19 37 -35 15 -83 -20 -44 -16 -109 15 -262 45 -223 32 -618
-23 -693 -90 -124 -238 530 -152 673 20 33 15 66 -24 137 -59 110 -114 126
-225 66 -80 -43 -87 -43 -186 2 -91 41 -111 42 -175 11 l-72 -35 42 -88 c32
-68 60 -90 124 -100 45 -7 82 -21 81 -31 -1 -11 -1 -30 -1 -44 0 -14 -31 -25
-69 -26 -128 -1 -156 -47 -156 -256 0 -135 -11 -200 -37 -227 -21 -21 -38 -72
-38 -114 0 -94 -30 -98 -86 -14 -47 72 -33 112 37 112 60 0 61 21 3 225 -37
130 -57 164 -100 170 -30 5 -54 26 -54 47 0 32 7 33 37 8 30 -25 50 -23 100
10 71 47 148 181 116 201 -13 8 -29 -3 -37 -24 -19 -49 -141 -49 -141 1 0 20
12 37 26 37 49 0 55 77 10 126 -67 74 35 182 153 160 59 -11 83 -5 94 24 9 22
38 40 65 40 27 0 56 23 65 52 13 41 30 49 80 36 44 -11 72 -2 97 30 24 31 40
36 53 16 20 -28 209 -90 226 -74 31 32 -33 134 -101 160 -94 35 -70 72 57 87
48 5 101 12 117 14 17 2 38 -9 48 -25z m8410 4 c0 -43 -98 -125 -150 -125 -49
0 -73 94 -33 133 26 27 183 20 183 -8z m213 -25 c0 -47 -88 -65 -115 -22 -11
17 -14 42 -6 53 21 35 121 10 121 -31z m779 -100 c-1 -85 -12 -125 -34 -125
-34 0 -49 226 -17 258 35 34 53 -13 51 -133z m1587 109 c81 -73 17 -203 -66
-135 -28 24 -56 24 -125 1 -104 -34 -150 -10 -169 88 -16 83 -8 87 164 87 105
0 164 -13 196 -41z m8330 -71 c8 -21 43 -38 78 -38 49 0 63 -13 62 -56 -1 -75
-82 -169 -146 -169 -28 0 -61 -18 -73 -41 -18 -32 -33 -35 -70 -13 -45 27 -45
29 9 44 65 18 73 65 19 110 -46 38 -50 166 -7 183 61 25 114 16 128 -20z
m-18829 -82 c7 -144 -4 -240 -31 -267 -15 -15 -24 45 -24 168 0 195 46 278 55
99z m17015 30 c12 -22 48 -53 81 -70 44 -21 65 -59 79 -139 11 -65 39 -123 69
-144 62 -44 65 -72 7 -94 -28 -11 -58 1 -85 34 -28 35 -71 52 -131 52 -79 0
-94 10 -127 90 -25 61 -50 86 -74 77 -100 -39 -246 -68 -260 -53 -9 10 -2 23
15 29 57 20 36 87 -21 69 -44 -14 -51 -7 -44 41 12 84 209 141 276 80 44 -40
50 -39 101 12 65 65 84 68 114 16z m-6200 -92 c9 -107 -33 -141 -118 -95 -97
52 -48 211 60 196 39 -6 52 -30 58 -101z m2006 -44 c13 0 24 -28 24 -63 0 -57
5 -60 56 -31 31 17 66 46 77 64 17 27 33 25 84 -8 47 -31 107 -39 239 -33
l177 8 35 -100 c52 -149 88 -334 73 -374 -14 -37 -166 1 -166 42 0 11 -18 20
-40 20 -21 0 -35 -10 -31 -22 20 -52 196 -224 238 -232 92 -18 42 -85 -129
-176 -181 -95 -281 -114 -365 -69 -71 38 -59 67 50 123 95 48 97 53 70 125
-31 82 -79 99 -102 39 -8 -21 -43 -38 -78 -38 -56 0 -63 10 -63 96 0 114 62
184 144 163 40 -11 60 -1 73 32 9 26 32 55 50 66 47 29 41 93 -9 93 -24 0 -75
-31 -114 -68 l-71 -68 -55 68 c-40 49 -92 75 -189 93 -177 33 -259 99 -266
215 -4 63 9 104 45 137 49 46 51 45 134 -28 47 -41 96 -74 109 -74z m-12441
13 c15 -27 41 -61 57 -75 57 -50 51 -150 -11 -158 -31 -5 -56 2 -56 14 0 13
-33 55 -74 96 -104 101 -100 196 8 180 27 -4 61 -30 76 -57z m2340 37 c33 -22
33 -28 0 -50 -71 -46 -150 -11 -112 50 19 32 64 31 112 0z m5324 -24 c21 -13
32 -27 25 -31 -6 -4 -46 -32 -89 -62 -82 -57 -310 -105 -310 -66 0 41 146 133
210 133 34 0 69 11 78 25 19 31 39 31 86 1z m501 -103 c0 -66 -82 -104 -161
-74 -78 30 -81 67 -11 142 50 52 57 54 113 17 32 -21 59 -60 59 -85z m-6355
-4 c6 -66 24 -102 63 -123 116 -61 124 -155 16 -193 -69 -24 -78 -20 -99 34
-12 33 -51 79 -86 102 -52 34 -64 62 -64 147 0 125 14 144 99 134 54 -6 65
-22 71 -101z m-2041 -7 c17 -48 57 -105 89 -126 85 -55 49 -236 -47 -236 -34
0 -115 204 -131 331 -17 147 39 167 89 31z m1187 -497 c6 -359 0 -568 -16
-577 -30 -19 -28 -59 -29 425 -2 597 2 747 20 729 9 -8 20 -268 25 -577z
m2319 525 c8 -32 37 -65 65 -72 65 -17 65 -68 -1 -68 -59 0 -207 141 -186 176
29 47 107 24 122 -36z m8035 2 c65 -68 35 -117 -72 -117 -69 0 -98 38 -98 127
0 68 103 62 170 -10z m3875 -125 c4 -21 -15 -86 -44 -145 -64 -134 -64 -146 5
-149 54 -3 54 -4 -6 -23 -177 -57 -220 -10 -171 182 29 112 28 126 -14 157
-27 19 -40 50 -31 72 19 50 249 -33 261 -94z m1824 83 c84 -51 110 -125 44
-125 -21 0 -38 9 -38 21 0 11 -28 36 -62 54 -35 18 -63 48 -63 67 0 45 23 42
119 -17z m1186 19 c30 -23 35 -46 19 -88 -41 -104 -122 -47 -124 88 0 17 15
31 33 31 18 0 50 -14 72 -31z m-444 -33 c21 -22 39 -56 39 -75 0 -48 -73 -46
-91 2 -8 20 -30 37 -49 37 -39 0 -47 -76 -13 -114 11 -13 33 -71 47 -130 32
-133 -1 -161 -88 -73 -56 56 -60 69 -30 106 31 37 26 49 -33 100 -87 75 -87
131 1 150 38 9 80 19 94 24 53 18 85 11 123 -27z m249 -39 c60 -28 104 -92 79
-116 -17 -17 -189 66 -189 91 0 53 31 60 110 25z m-14960 -77 c0 -75 -3 -78
-41 -40 -22 23 -34 59 -26 81 26 68 67 43 67 -41z m3246 33 c78 -67 67 -113
-35 -150 -102 -37 -143 -19 -74 31 49 36 33 91 -26 91 -20 0 -36 17 -36 38 0
53 106 47 171 -10z m-5865 -8 c11 -34 -152 -378 -185 -391 -12 -5 -39 -41 -60
-81 -20 -40 -55 -73 -76 -73 -63 0 -185 139 -185 211 0 72 10 75 124 36 92
-32 125 -6 126 100 0 101 229 278 256 198z m13121 -10 c28 -34 27 -45 -9 -72
-24 -17 -43 -42 -43 -55 0 -13 -28 -51 -62 -83 -62 -58 -63 -58 -63 -6 0 29
11 60 25 69 17 10 17 30 2 57 -49 88 86 168 150 90z m-12074 -85 c148 -152
137 -172 -55 -109 -125 41 -188 108 -163 173 25 65 119 37 218 -64z m724 43
c16 -34 17 -79 4 -116 -29 -77 58 -177 153 -177 42 0 66 -14 66 -37 0 -21 -22
-38 -49 -38 -73 0 -176 53 -176 92 0 18 -25 58 -56 89 -75 74 -124 170 -108
211 21 56 137 39 166 -24z m3878 -34 c-4 -44 4 -87 19 -96 14 -9 26 -43 26
-75 0 -33 11 -67 25 -76 57 -35 -11 -62 -153 -62 -130 0 -150 6 -142 44 5 26
35 47 76 51 38 5 69 18 69 29 0 38 -123 101 -199 101 -69 0 -77 -9 -91 -100
-16 -96 -20 -100 -112 -100 -70 0 -105 -15 -134 -56 -59 -84 -48 -119 37 -119
45 0 71 -10 62 -25 -21 -34 -121 -32 -156 3 -18 18 -41 19 -71 3 -41 -23 -40
-27 10 -54 30 -16 54 -49 54 -74 0 -58 100 -150 190 -176 l73 -20 -66 -31
c-82 -39 -222 23 -222 98 0 65 -42 87 -180 92 -103 4 -118 -2 -125 -49 -5 -37
-22 -52 -53 -47 -31 6 -54 -16 -74 -69 -21 -54 -45 -76 -86 -76 -76 0 -72 31
18 134 41 47 75 113 75 147 0 35 17 77 38 94 20 17 37 47 37 66 0 39 65 46 88
9 27 -44 134 -27 162 25 15 28 45 50 68 50 23 0 101 62 173 138 72 75 147 137
168 137 20 0 70 28 111 62 162 136 297 146 285 22z m2258 -61 c1 -133 -28
-241 -57 -213 -18 19 -31 320 -14 347 35 56 71 -11 71 -134z m-8709 8 c15 -38
28 -130 30 -206 2 -95 13 -136 35 -131 41 8 39 -26 -6 -135 -66 -158 -18 -265
93 -206 35 19 68 -2 171 -108 121 -124 125 -132 74 -155 -43 -19 -68 -9 -134
56 -138 134 -227 80 -212 -128 7 -92 16 -106 72 -113 77 -9 132 -133 103 -230
-34 -110 -116 -223 -167 -230 -28 -4 -54 -28 -59 -54 -7 -39 3 -44 62 -31 106
22 157 -18 102 -79 -53 -58 -55 -103 -5 -122 20 -8 37 -29 37 -46 0 -18 -17
-46 -37 -63 -21 -17 -38 -57 -38 -89 0 -32 -20 -69 -44 -83 -68 -38 -13 -65
57 -28 52 28 72 28 125 0 64 -35 88 -109 27 -85 -19 7 -50 -5 -69 -28 -18 -23
-57 -66 -85 -96 -29 -29 -59 -73 -68 -97 -9 -24 -33 -44 -54 -44 -60 0 -83 75
-83 263 0 205 26 292 80 271 26 -9 47 8 64 53 32 85 13 117 -62 98 -71 -17
-84 19 -77 221 5 170 27 201 87 122 l44 -59 42 104 c39 98 39 108 -2 165 -58
80 -71 77 -108 -19 l-31 -81 -20 100 c-24 115 -28 1324 -5 1347 25 25 32 18
61 -54z m3582 46 c25 -39 -15 -103 -87 -140 -67 -35 -96 -92 -136 -273 l-16
-74 -63 80 c-44 56 -84 80 -133 80 -38 0 -84 17 -101 37 -34 42 -22 49 113 72
163 27 262 77 262 131 0 68 130 138 161 87z m499 -60 c110 -118 190 -281 190
-389 0 -51 12 -105 27 -120 15 -15 23 -49 17 -74 -11 -44 -12 -44 -30 4 -111
294 -277 447 -489 449 -141 1 -166 65 -59 153 111 90 246 81 344 -23z m1148
32 c109 -86 174 -194 156 -263 -27 -109 -182 -56 -374 128 -64 61 -127 111
-140 111 -43 0 -27 46 19 58 119 31 277 15 339 -34z m431 24 c26 -42 -32 -90
-67 -55 -29 29 -11 82 28 82 12 0 30 -12 39 -27z m2306 -18 c69 -53 56 -101
-48 -178 -61 -45 -82 -50 -112 -25 -47 39 -93 -1 -71 -60 18 -47 50 -54 74
-17 25 41 62 3 62 -63 0 -34 21 -72 48 -86 41 -22 43 -34 19 -88 -43 -91 -121
-79 -208 31 -140 177 -163 331 -49 331 15 0 42 22 58 48 17 27 56 52 87 56 37
6 56 24 54 52 -4 55 13 55 86 -1z m3955 -19 c0 -47 41 -46 59 2 21 55 116 47
116 -10 0 -57 -139 -93 -191 -50 -39 32 -47 133 -9 110 14 -9 25 -32 25 -52z
m2259 12 c75 -59 85 -110 25 -133 -61 -24 -122 3 -158 71 -60 112 21 150 133
62z m-5021 -85 c0 -55 -14 -101 -32 -107 -22 -7 -31 24 -31 107 0 82 9 113 31
106 18 -6 32 -52 32 -106z m3267 31 c6 -46 26 -58 106 -65 139 -11 245 -113
174 -166 -57 -44 -77 -46 -98 -12 -9 15 -46 24 -83 22 -118 -9 -144 1 -200 77
-52 71 -53 78 -14 137 51 78 104 81 115 7z m5816 34 c101 -64 100 -252 -2
-253 -54 0 -56 21 -5 76 35 39 33 44 -25 59 -39 10 -64 34 -64 61 0 75 35 95
96 57z m322 -60 c22 -16 24 -37 6 -71 -24 -44 -30 -44 -87 -7 -67 44 -81 99
-31 117 33 12 59 2 112 -39z m-11766 -61 c104 -98 120 -132 63 -132 -49 0
-190 137 -190 185 0 58 18 51 127 -53z m2998 23 c0 -67 -38 -130 -80 -130 -11
0 -20 45 -20 100 0 83 8 100 50 100 38 0 50 -17 50 -70z m-10561 -32 c26 -42
-32 -90 -67 -55 -29 29 -11 82 28 82 12 0 30 -12 39 -27z m565 -629 c-77 -77
-103 529 -27 622 31 36 36 0 43 -279 3 -176 -3 -330 -16 -343z m17998 540 c22
-19 46 -28 54 -20 8 8 60 -15 115 -52 88 -58 97 -73 73 -113 -23 -36 -21 -56
10 -91 73 -86 76 -108 16 -131 -60 -23 -59 -24 68 -64 52 -16 51 -188 -1 -188
-21 0 -45 17 -53 38 -8 20 -28 37 -45 37 -17 0 -52 23 -76 50 -71 78 -129 62
-179 -50 -50 -113 -60 -118 -118 -54 -39 43 -38 47 21 74 35 16 63 47 63 68 0
22 39 56 88 76 93 39 110 72 50 95 -21 8 -38 34 -39 59 -1 70 -55 124 -143
143 -67 15 -81 30 -81 87 0 111 75 126 177 36z m-16884 -65 c16 -59 36 -213
44 -344 19 -305 -9 -373 -177 -423 -170 -50 -247 -1 -247 159 0 144 32 150
117 23 65 -96 73 -101 163 -85 118 20 120 93 7 209 -76 77 -96 161 -50 207 17
17 16 73 -4 170 -24 120 -23 148 6 167 73 46 112 23 141 -83z m3618 -18 c-9
-21 -25 -112 -37 -201 -23 -181 -3 -230 76 -181 27 17 81 24 124 15 73 -15
106 19 52 53 -50 31 6 88 86 88 l81 0 0 -138 c0 -76 -10 -144 -22 -152 -11 -7
-21 -35 -21 -61 0 -27 -11 -49 -25 -49 -40 0 -29 118 13 134 20 8 37 32 37 53
0 21 -17 38 -37 38 -21 0 -38 -16 -38 -36 0 -56 -94 -75 -325 -66 -210 7 -258
27 -232 95 9 24 35 30 85 19 81 -18 77 -31 72 230 -4 215 36 321 91 244 19
-26 28 -64 20 -85z m-2340 60 c99 -50 105 -127 12 -163 -144 -55 -227 24 -159
151 33 61 46 62 147 12z m7142 -49 c0 -36 -14 -47 -50 -41 -66 11 -72 19 -54
67 22 56 104 35 104 -26z m191 -308 c-2 -145 -15 -275 -29 -289 -17 -17 -25
-5 -26 36 -1 34 -6 146 -11 249 -5 103 -3 226 5 272 27 167 64 5 61 -268z
m6628 302 c28 -31 33 -56 17 -82 -48 -76 -21 -141 114 -274 162 -160 166 -183
46 -219 -113 -35 -178 2 -290 167 -43 63 -99 129 -124 147 -26 19 -45 64 -45
106 0 67 8 74 85 74 69 0 87 11 100 63 19 73 43 78 97 18z m-7519 -31 c8 -28
44 -84 78 -125 71 -84 48 -111 -83 -96 -66 8 -71 16 -78 140 -8 137 47 191 83
81z m-7455 -910 c-12 -66 -17 -68 -40 -27 -28 51 -27 904 2 948 22 33 57 -821
38 -921z m8867 842 c0 -28 19 -32 81 -19 l82 18 -62 -66 c-51 -56 -64 -60 -82
-28 -12 21 -37 38 -56 38 -19 0 -53 19 -76 42 -40 39 -40 44 2 75 50 36 111 4
111 -60z m1959 38 c15 -23 19 -50 10 -60 -20 -19 -169 37 -169 64 0 65 118 62
159 -4z m-9519 -57 c-61 -57 -190 -88 -190 -46 0 50 92 108 170 108 l87 0 -67
-62z m12927 22 c9 -23 65 -91 124 -153 153 -157 131 -211 -57 -144 -53 19 -82
35 -64 36 59 2 23 113 -39 121 -62 9 -70 31 -27 74 22 22 19 33 -12 45 -58 23
-53 61 9 61 28 0 58 -18 66 -40z m-16242 -134 c0 -84 21 -161 71 -254 73 -140
93 -149 235 -110 84 23 95 -31 20 -98 -51 -46 -41 -85 46 -194 86 -108 -37
-376 -136 -294 -52 43 -45 71 28 104 53 25 62 43 56 118 -7 88 -10 90 -119 92
-85 2 -122 -10 -155 -50 -84 -104 -126 77 -82 356 10 68 6 119 -11 136 -30 30
-39 298 -12 326 35 35 59 -17 59 -132z m9133 113 c8 -20 -10 -66 -39 -103
l-52 -67 55 -42 c69 -52 46 -77 -73 -77 -64 0 -104 -15 -127 -49 -26 -36 -53
-45 -104 -34 -91 19 -74 68 28 78 85 9 97 27 48 78 -25 26 -22 38 18 61 28 16
84 65 125 110 84 90 102 97 121 45z m-9383 -126 c0 -106 -9 -138 -37 -138 -39
0 -57 222 -21 258 41 42 58 7 58 -120z m4148 106 c14 -17 61 -74 104 -125 81
-98 84 -169 5 -169 -49 1 -257 235 -257 290 0 44 114 47 148 4z m11465 -27 c0
-65 -50 -61 -59 5 -6 40 2 55 25 47 18 -6 34 -29 34 -52z m5443 -2 c57 -43 56
-65 -5 -65 -27 0 -61 23 -76 50 -32 60 12 68 81 15z m-15993 -31 c20 -8 37
-32 37 -53 0 -22 18 -60 41 -85 38 -42 36 -46 -25 -70 -76 -29 -92 -160 -32
-258 19 -31 36 -117 37 -192 2 -171 -41 -226 -175 -226 -120 0 -158 74 -133
256 16 112 22 120 83 113 59 -6 67 2 67 69 0 67 -9 75 -90 82 -58 5 -101 -6
-122 -31 -41 -49 -76 -50 -76 -1 0 33 29 48 80 40 10 -1 49 38 87 88 l68 90
-67 49 c-43 31 -68 72 -68 113 0 62 3 63 125 47 69 -9 142 -23 163 -31z
m14747 26 c61 -24 48 -52 -39 -83 -100 -34 -96 -35 -96 19 0 76 47 98 135 64z
m-6386 -85 c55 0 101 -5 101 -10 0 -6 7 -29 15 -51 21 -55 -302 -38 -359 19
-69 69 -21 126 67 80 41 -21 120 -38 176 -38z m-10210 -27 c57 -63 208 -129
253 -112 44 16 109 -114 91 -182 -19 -73 -50 -68 -125 22 l-65 77 -60 -57
c-73 -68 -69 -170 6 -208 29 -14 72 -45 96 -69 53 -53 99 -55 172 -8 59 39
268 27 268 -15 0 -12 -29 -15 -64 -6 -52 13 -67 6 -78 -37 -12 -47 -32 -53
-172 -53 -227 0 -277 -25 -281 -139 -2 -51 12 -128 31 -171 81 -183 92 -246
49 -293 -35 -38 -51 -41 -115 -15 -73 30 -74 32 -88 281 -7 137 -12 283 -10
325 2 41 4 218 5 393 1 331 8 354 87 267z m588 -17 c76 -72 85 -98 52 -150
-16 -25 -37 -23 -99 8 -83 41 -90 59 -64 155 19 71 23 70 111 -13z m-291 21
c8 -13 3 -31 -12 -40 -37 -23 -106 7 -87 38 20 31 80 33 99 2z m7391 -53 c58
-31 63 -88 8 -109 -81 -31 -110 -16 -110 60 0 80 23 91 102 49z m-3477 -36
c25 -31 24 -38 -7 -38 -63 0 -119 28 -104 53 21 34 76 26 111 -15z m2874 -7
c0 -24 -16 -64 -35 -88 -18 -25 -28 -67 -21 -94 14 -55 -10 -60 -104 -25 -53
21 -64 41 -64 121 0 120 10 130 129 130 75 0 96 -10 95 -44z m-2023 -32 c15
-30 20 -96 11 -159 -16 -104 -14 -109 54 -122 154 -30 259 -80 259 -124 0 -24
-5 -44 -10 -44 -6 0 -28 -6 -48 -14 -26 -10 -41 3 -46 43 -7 46 -22 57 -71 51
-34 -4 -84 -10 -110 -13 -33 -3 -56 21 -77 83 -16 48 -49 91 -71 96 -49 9 -51
33 -16 160 29 104 82 122 125 43z m-1607 -118 c6 -18 -11 -31 -40 -31 -55 0
-88 33 -61 60 25 25 89 7 101 -29z m6631 -106 c0 -91 10 -125 35 -125 48 0 63
-50 36 -122 -23 -63 33 -310 85 -373 19 -23 19 -40 -1 -60 -21 -21 -17 -36 15
-60 40 -29 39 -35 -11 -89 -83 -91 -96 -317 -22 -375 31 -25 63 -77 71 -117
22 -109 132 -273 230 -341 44 -31 45 -39 12 -72 -57 -57 -192 8 -236 114 -19
46 -85 118 -147 161 -95 68 -115 97 -136 200 -31 154 -1 801 40 878 22 40 23
70 5 104 -33 63 -34 402 -1 402 14 0 25 -56 25 -125z m5775 -17 c0 -50 -70
-39 -99 15 -53 99 -33 142 37 77 34 -32 62 -74 62 -92z m-18169 61 c19 -87 5
-1074 -16 -1138 -57 -173 -104 39 -79 354 10 125 17 250 15 278 -10 168 -6
488 7 522 22 58 60 49 73 -16z m7144 -46 c0 -61 -58 -52 -71 10 -4 25 8 42 32
42 23 0 39 -21 39 -52z m1382 -20 c38 -65 51 -183 24 -235 -5 -10 -49 38 -97
108 -70 102 -81 135 -58 163 45 54 84 44 131 -36z m-9485 13 c40 -48 67 -266
33 -266 -37 0 -105 72 -105 111 0 18 -7 68 -16 111 -17 85 33 110 88 44z
m5628 -97 c0 -89 137 -453 204 -541 59 -77 33 -117 -43 -67 -97 64 -143 51
-124 -34 21 -95 -21 -118 -72 -40 -41 62 -62 733 -24 771 31 30 59 -12 59 -89z
m275 -30 c0 -17 51 -86 113 -153 104 -114 109 -125 64 -145 -68 -31 -171 0
-236 70 -57 62 -148 307 -127 342 17 27 186 -76 186 -114z m382 82 c70 -37
139 -321 79 -321 -51 0 -114 67 -174 187 -39 76 -80 138 -91 138 -12 0 -21 12
-21 27 0 29 129 10 207 -31z m2975 -104 c15 -150 -4 -184 -82 -142 -49 26 -53
42 -38 146 31 203 99 201 120 -4z m1179 91 c18 -46 -3 -83 -47 -83 -36 0 -62
68 -46 117 13 38 74 16 93 -34z m6611 44 c19 -12 27 -34 17 -49 -22 -35 26
-54 190 -75 167 -20 195 -78 38 -78 -98 0 -113 -7 -127 -62 -27 -107 -115 -79
-209 66 -102 160 -106 221 -12 221 38 -1 84 -11 103 -23z m4866 -25 c0 -61
-131 -88 -202 -41 -88 58 -52 93 85 84 80 -5 117 -19 117 -43z m-3463 -16 c0
-43 158 -28 221 22 34 28 78 -14 79 -75 0 -47 -28 -53 -173 -34 -114 15 -142
11 -182 -29 -85 -85 -127 -10 -51 93 49 69 106 81 106 23z m-13783 -76 c8 -21
-8 -82 -36 -134 -44 -82 -47 -111 -24 -225 23 -118 21 -135 -28 -183 -61 -61
-78 -51 -102 62 -16 74 -25 82 -96 75 -72 -7 -81 0 -109 95 -26 88 -25 108 11
143 22 23 44 37 48 31 3 -7 24 -45 45 -86 47 -92 101 -106 144 -37 26 41 26
61 3 89 -23 28 -22 45 7 79 21 24 44 63 53 87 19 55 64 57 84 4z m6446 -63
c132 -122 140 -168 34 -189 -72 -14 -76 -21 -64 -99 17 -105 -76 -146 -159
-71 -79 72 -63 150 38 190 64 25 82 44 66 68 -30 47 -121 15 -141 -49 -12 -36
-29 -45 -58 -33 -23 10 -80 19 -127 21 -48 1 -90 17 -97 36 -9 27 11 31 90 17
97 -16 104 -13 145 66 42 81 103 144 142 145 10 1 69 -45 131 -102z m313 39
c23 -27 24 -46 5 -65 -36 -36 -81 -5 -81 55 0 59 32 63 76 10z m7794 -53 c63
-99 42 -170 -32 -108 -32 26 -47 25 -84 -9 -25 -23 -64 -41 -87 -41 -60 0 -52
67 11 83 77 20 32 67 -66 67 l-85 0 15 -125 c10 -81 6 -125 -11 -125 -15 0
-46 -7 -69 -16 -34 -13 -39 -6 -27 33 11 34 -4 72 -47 118 -88 95 -82 140 20
140 45 0 93 11 106 24 13 12 80 27 149 32 68 6 130 12 137 13 7 2 38 -37 70
-86z m-17141 -273 c-5 -177 -14 -331 -20 -340 -6 -10 -61 33 -123 95 -124 126
-122 199 6 215 97 11 106 70 10 70 -110 0 -118 142 -8 155 54 6 70 22 77 78 4
40 20 66 37 60 21 -7 27 -100 21 -333z m4871 316 c28 -18 30 -31 9 -52 -34
-34 -145 14 -121 52 19 30 64 30 112 0z m486 -23 c90 -53 108 -98 47 -120 -25
-9 -54 -32 -65 -50 -59 -97 -143 -19 -143 132 0 98 42 108 161 38z m2239 10
c0 -46 91 -51 107 -7 6 17 18 25 27 17 9 -8 -2 -68 -24 -133 -43 -124 -28
-183 26 -109 35 48 151 60 177 19 8 -14 8 -49 -2 -78 -15 -48 -29 -52 -141
-39 -156 19 -195 50 -195 156 0 46 -11 90 -25 99 -39 24 -29 112 13 112 20 0
37 -17 37 -37z m645 -154 c-6 -125 -18 -173 -51 -193 -68 -43 -88 6 -75 190
11 159 15 169 73 169 59 0 60 -5 53 -166z m1743 -9 c8 -28 44 -84 78 -125 34
-41 55 -87 45 -103 -13 -20 -25 -16 -41 12 -12 23 -36 41 -52 42 -52 2 -210
149 -160 149 24 0 50 17 58 38 20 52 53 46 72 -13z m-10274 -36 c93 -93 80
-139 -38 -139 -126 0 -181 75 -112 152 57 62 76 61 150 -13z m16847 13 c42
-47 36 -102 -12 -102 -32 0 -124 93 -124 125 0 43 90 27 136 -23z m-17151 -18
c9 -23 11 -47 4 -53 -23 -23 -89 18 -89 56 0 51 66 49 85 -3z m2340 -50 c0
-50 13 -134 29 -188 22 -73 22 -111 1 -153 -69 -133 -2 -353 103 -339 68 9
117 -20 117 -70 0 -27 -22 -35 -81 -29 -109 10 -137 -93 -33 -119 35 -9 64
-26 64 -37 0 -11 21 -27 46 -35 25 -8 81 -46 123 -83 43 -38 97 -80 121 -95
52 -32 27 -86 -40 -86 -59 0 -334 182 -385 254 -42 60 -44 59 -85 -16 -32 -61
-37 -49 -80 200 -26 149 -25 194 9 308 27 90 32 149 16 178 -12 24 -16 86 -8
136 9 57 2 117 -19 155 -28 54 -28 67 3 86 71 45 99 26 99 -67z m18141 10
c121 -91 131 -152 28 -164 -53 -7 -75 6 -98 56 -16 35 -38 64 -50 64 -12 0
-21 28 -21 63 0 80 11 78 141 -19z m-14154 7 c29 -33 37 -64 24 -94 -18 -40
-21 -38 -30 12 -5 31 -26 56 -45 56 -20 0 -36 17 -36 38 0 51 34 46 87 -12z
m738 -101 c-40 -75 -75 -60 -75 33 0 107 24 130 68 67 26 -37 28 -62 7 -100z
m2870 107 c-12 -66 -95 -73 -95 -9 0 36 16 52 52 52 36 0 49 -13 43 -43z
m10257 18 c56 0 73 -11 73 -50 0 -64 -113 -69 -179 -9 -56 51 -60 95 -6 74 21
-8 72 -15 112 -15z m-15227 -73 c0 -25 17 -60 38 -77 20 -17 37 -47 37 -66 0
-42 -54 -45 -95 -4 -36 36 -41 230 -5 208 14 -9 25 -36 25 -61z m2547 -2 c84
0 228 -103 228 -163 0 -59 -6 -62 -100 -47 -58 10 -100 6 -100 -7 0 -36 104
-125 169 -144 73 -23 71 -59 -4 -78 -133 -33 -371 162 -405 332 -22 108 71
207 138 147 24 -22 57 -40 74 -40z m8255 -40 c31 -37 28 -46 -21 -79 -67 -44
-74 -127 -12 -146 24 -8 60 -24 81 -37 21 -13 64 -34 96 -48 32 -14 53 -39 47
-56 -25 -76 -419 15 -469 107 -25 47 -9 124 26 124 11 0 15 20 9 44 -6 24 18
74 54 112 68 74 115 69 189 -21z m1949 27 c17 -21 44 -34 59 -29 57 21 231
-70 322 -169 112 -120 156 -189 120 -189 -14 0 -47 -24 -74 -53 -48 -51 -51
-52 -151 -8 -97 43 -101 49 -86 137 14 90 12 93 -75 109 -52 10 -110 44 -140
82 -81 103 -58 219 25 120z m-4809 -73 c-8 -116 -27 -128 -78 -51 -33 51 -36
73 -13 101 55 65 97 42 91 -50z m-11563 -92 c2 -53 5 -117 6 -141 2 -27 -19
-47 -54 -51 -59 -9 -74 -41 -31 -68 16 -10 12 -35 -12 -69 -21 -30 -38 -77
-39 -105 0 -28 -16 -70 -34 -94 -32 -43 -3 -262 44 -339 9 -13 3 -60 -12 -104
-24 -68 -21 -86 25 -135 76 -82 72 -225 -9 -296 -35 -30 -63 -80 -63 -113 0
-78 66 -232 99 -232 39 0 31 -90 -11 -125 -48 -39 -49 -140 -3 -158 19 -8 43
-48 52 -90 9 -42 27 -83 40 -91 31 -19 29 -129 -2 -149 -14 -8 -35 12 -48 46
-13 33 -41 67 -63 75 -21 9 -39 39 -39 68 0 28 -11 45 -25 37 -37 -24 -30
-153 11 -186 19 -17 47 -64 61 -105 66 -190 -132 -74 -500 292 -234 232 -298
371 -212 457 41 41 119 2 112 -56 -8 -71 12 -111 117 -227 176 -197 271 -288
300 -288 23 0 46 215 41 388 -20 688 -26 1626 -10 1712 15 82 31 111 60 106
25 -4 46 18 57 62 35 141 136 127 142 -21z m5408 79 c29 -91 -12 -230 -66
-221 -26 4 -48 16 -47 26 1 11 1 70 1 132 0 122 79 166 112 63z m3458 -18 c9
-62 163 -228 239 -257 48 -19 49 -23 10 -39 -76 -30 -161 8 -194 87 -17 41
-57 104 -90 139 -33 36 -60 82 -60 103 0 58 86 29 95 -33z m-3849 -291 c16
-39 29 -106 30 -150 0 -44 28 -124 62 -179 77 -125 78 -176 3 -245 -32 -31
-72 -81 -88 -112 -71 -133 -148 -15 -98 150 21 70 21 119 0 185 -15 50 -24
205 -21 344 8 291 45 402 68 203 8 -69 28 -157 44 -196z m-7451 203 c50 -50
34 -70 -57 -70 -49 0 -88 9 -88 20 0 29 56 80 88 80 15 0 41 -13 57 -30z
m4796 -8 c24 -63 -13 -155 -68 -170 -32 -8 -46 -25 -35 -42 10 -16 39 -24 64
-17 56 14 198 -239 198 -353 0 -37 23 -111 50 -162 l51 -94 -55 -75 c-31 -40
-64 -74 -74 -74 -36 0 -52 55 -25 82 42 42 35 168 -8 168 -20 0 -43 -11 -51
-25 -29 -46 -59 -26 -87 61 -16 47 -47 100 -69 118 -35 29 -28 35 58 46 147
19 137 100 -19 144 -90 25 -120 47 -132 96 -9 35 -54 85 -102 114 -48 28 -87
59 -87 70 0 41 94 98 200 121 160 35 175 34 191 -8z m5277 -28 c-7 -36 -3 -98
8 -138 22 -76 -1 -112 -117 -188 -32 -21 -59 -53 -59 -70 0 -18 -17 -46 -39
-64 -59 -49 -94 2 -61 88 24 63 19 80 -42 143 -69 72 -57 118 32 120 14 0 71
39 125 86 120 107 171 114 153 23z m368 42 c84 -32 81 -66 -8 -84 -87 -18
-118 -84 -66 -141 81 -90 34 -174 -56 -101 -76 61 -75 199 0 285 66 75 51 71
130 41z m-1370 -39 c17 -43 -36 -118 -69 -98 -12 8 -22 41 -22 75 0 68 67 85
91 23z m6203 15 c24 -13 64 -30 89 -38 89 -27 28 -77 -85 -69 -166 11 -265
130 -109 130 34 0 81 -10 105 -23z m315 -136 c-7 -43 -20 -95 -28 -116 -19
-50 -56 174 -38 236 23 83 82 -25 66 -120z m-9759 25 c0 -132 -43 -177 -148
-154 -87 19 -227 -67 -227 -141 0 -24 -21 -64 -47 -89 -41 -38 -47 -75 -41
-251 4 -114 -3 -213 -16 -221 -13 -8 -34 -42 -47 -75 -33 -87 -66 -74 -81 34
-19 130 13 333 64 406 24 34 43 98 43 144 0 63 14 89 63 111 34 15 62 48 62
72 0 86 33 125 147 175 63 27 132 60 153 72 65 40 75 29 75 -83z m-4429 57
c87 -31 112 -102 29 -80 -28 7 -67 -1 -88 -19 -51 -41 -72 -16 -52 62 19 74
11 72 111 37z m2548 11 c70 -19 71 -49 3 -86 -60 -31 -142 24 -111 75 19 31
30 32 108 11z m5472 -84 c40 0 43 -24 10 -111 -15 -39 -44 -64 -74 -64 -27 0
-59 -18 -71 -39 -20 -35 -33 -32 -113 19 -141 90 -99 190 69 162 85 -13 86
-12 73 66 -12 79 -12 79 29 23 23 -31 58 -56 77 -56z m6589 37 c39 -86 12
-101 -92 -52 -91 44 -110 77 -57 98 71 29 122 13 149 -46z m-13307 -51 c63
-108 47 -150 -37 -95 -41 27 -61 63 -61 112 0 97 34 91 98 -17z m5293 52 c8
-21 35 -38 60 -38 25 0 62 17 83 38 52 51 84 46 119 -18 23 -43 22 -57 -3 -66
-17 -5 -52 -31 -78 -57 -45 -45 -195 -65 -229 -31 -9 8 -4 39 11 67 21 39 21
55 0 62 -36 12 -38 80 -3 80 14 0 32 -17 40 -37z m2673 -24 c64 -65 78 -125
36 -151 -14 -9 -25 -49 -25 -89 0 -50 -19 -86 -62 -114 -35 -22 -63 -62 -63
-87 0 -44 -68 -98 -123 -98 -45 0 -30 126 23 193 38 48 50 102 50 219 0 209
46 245 164 127z m410 -31 c117 -87 139 -133 65 -133 -18 0 -47 17 -64 38 -25
29 -40 31 -67 8 -28 -23 -52 -10 -121 66 -105 114 -105 113 -11 113 48 0 120
-33 198 -92z m7593 53 c12 -37 -34 -94 -62 -77 -33 21 -7 121 28 109 14 -5 30
-19 34 -32z m-11672 -37 c61 -56 64 -70 32 -121 -31 -49 -82 -8 -63 51 10 33
0 62 -30 85 -26 19 -35 35 -20 35 15 1 51 -22 81 -50z m-5970 -22 c0 -43 -30
-102 -53 -102 -26 0 -30 84 -5 108 24 24 58 21 58 -6z m2721 -36 c16 -84 -44
-111 -98 -44 -66 80 -60 108 21 98 43 -5 71 -25 77 -54z m3017 10 c91 -12 100
-20 100 -88 0 -72 -4 -74 -125 -75 -126 -1 -263 44 -263 86 0 38 129 126 159
108 16 -10 74 -24 129 -31z m-5118 -13 c4 -4 14 -87 22 -184 13 -154 9 -180
-28 -195 -26 -9 -53 -2 -66 19 -34 53 -27 97 15 97 57 0 46 122 -18 187 -46
49 -60 52 -89 23 -19 -19 -57 -35 -85 -35 -39 0 -47 -10 -33 -44 10 -24 17
-55 15 -68 -2 -14 -9 -74 -16 -134 -11 -97 -4 -116 65 -181 l78 -72 -67 -26
c-144 -55 -175 -37 -207 117 -23 105 -23 150 -2 176 21 25 20 49 -4 95 -36 66
-2 137 64 137 19 0 43 16 54 36 38 69 243 104 302 52z m4584 -4 c46 -42 63
-109 27 -109 -40 0 -131 79 -131 114 0 48 48 46 104 -5z m7316 -138 c5 -101
-3 -147 -31 -170 -22 -18 -39 -53 -39 -79 0 -64 -18 -59 -100 28 l-70 75 60
47 c33 26 60 65 60 87 0 63 56 168 86 158 14 -4 30 -70 34 -146z m-11645 -71
c0 -117 -10 -200 -25 -200 -27 0 -34 252 -9 344 26 97 34 62 34 -144z m12588
115 c118 -42 150 -115 50 -115 -93 0 -163 43 -163 101 0 27 3 49 6 49 4 -1 52
-16 107 -35z m-11378 -67 c78 -92 80 -113 17 -147 -38 -21 -64 -13 -123 37
-104 87 -112 80 -93 -82 24 -202 82 -345 154 -377 86 -40 74 -87 -36 -149
l-96 -54 8 -257 c8 -239 13 -260 71 -307 78 -64 84 -161 11 -180 -47 -13 -51
-25 -34 -129 10 -64 21 -238 24 -388 5 -263 7 -275 71 -321 75 -55 87 -115 22
-110 -37 3 -43 -18 -40 -143 1 -81 13 -154 26 -163 39 -26 133 -194 133 -237
0 -75 -74 -42 -143 65 -169 257 -219 246 -124 -28 38 -108 61 -213 53 -235 -8
-22 13 -81 49 -135 36 -52 65 -102 65 -112 0 -9 54 -71 121 -138 67 -66 126
-135 132 -153 8 -26 26 -27 82 -6 53 20 95 20 156 0 129 -43 75 -82 -92 -67
-79 7 -155 2 -168 -11 -28 -28 -156 16 -156 53 0 33 -174 226 -203 226 -53 0
18 -227 86 -277 19 -14 92 -143 92 -162 0 -4 -67 28 -149 71 -173 92 -219 165
-174 274 24 56 24 110 1 239 -20 114 -25 345 -15 718 7 302 2 730 -13 950 -21
311 -31 1099 -22 1700 2 97 19 112 131 112 94 0 122 -12 176 -77z m11107 -39
c-11 -67 -4 -89 37 -111 47 -25 48 -32 13 -66 -52 -53 -108 -26 -123 60 -6 39
-20 89 -29 111 -21 47 50 131 90 107 14 -9 19 -54 12 -101z m2379 20 c8 -55 2
-58 -75 -41 -102 22 -101 20 -81 72 26 67 145 42 156 -31z m-6932 19 c9 -15
-9 -54 -41 -87 -53 -57 -60 -58 -102 -20 -78 71 -59 134 40 134 47 0 94 -12
103 -27z m-9452 -48 c9 -27 10 -60 2 -73 -23 -38 -276 -12 -276 27 0 22 25 31
76 26 48 -5 90 7 110 31 43 52 69 49 88 -11z m2270 -58 c19 -124 -62 -188
-132 -105 -25 30 -23 55 10 124 50 104 104 95 122 -19z m-418 -467 c-12 -851
-15 -958 -27 -945 -19 19 -34 1340 -16 1433 27 142 48 -99 43 -488z m8771 510
c23 -60 18 -110 -11 -110 -29 0 -74 103 -57 131 18 32 52 21 68 -21z m4690
-18 c0 -66 -62 -163 -88 -137 -10 10 -11 58 -1 106 18 101 89 125 89 31z
m-9512 -19 c0 -19 -20 -39 -44 -43 -43 -9 -61 45 -27 79 26 26 71 4 71 -36z
m2936 -67 c27 -69 26 -90 -9 -143 -47 -71 -85 -80 -106 -26 -11 28 -38 34
-109 23 -83 -14 -101 -7 -137 49 -59 89 -29 125 65 77 97 -50 182 -38 192 27
22 139 47 138 104 -7z m12814 83 l75 -33 -69 -27 c-103 -41 -238 19 -177 79
25 25 87 19 171 -19z m-14688 -78 c0 -67 -43 -83 -66 -23 -19 50 9 119 41 100
14 -9 25 -43 25 -77z m4022 13 c90 -122 -31 -207 -158 -111 -47 36 -47 39 23
112 87 90 67 90 135 -1z m-10568 -18 c17 -169 22 -226 23 -281 1 -93 69 -225
107 -210 18 7 47 -5 65 -26 18 -22 47 -39 65 -39 50 0 69 -48 35 -88 -24 -29
-20 -51 17 -106 59 -87 132 -235 133 -270 1 -15 29 -54 64 -86 85 -80 82 -165
-6 -187 -78 -19 -132 34 -132 131 0 96 -108 255 -349 513 -88 95 -89 97 -97
358 -5 144 -2 278 5 298 20 51 65 46 70 -7z m15206 4 c22 -9 40 -42 40 -75 0
-34 15 -60 34 -60 18 0 52 -21 75 -46 23 -25 87 -61 141 -79 139 -46 120 -111
-37 -129 -122 -14 -123 -121 -2 -121 l89 0 -9 -113 c-5 -62 -29 -135 -54 -162
-35 -39 -41 -74 -29 -168 13 -97 10 -112 -15 -82 -17 21 -65 56 -106 79 -41
22 -97 75 -124 116 -28 42 -79 89 -113 105 -60 29 -61 30 -14 65 65 47 113 44
175 -12 72 -66 164 -92 164 -46 0 48 -73 108 -156 128 -102 24 -98 149 6 203
88 45 94 84 25 144 -27 23 -50 58 -50 78 0 19 -28 42 -62 50 -60 15 -86 84
-46 123 20 21 19 21 68 2z m842 -11 c81 -43 59 -99 -39 -99 -91 0 -115 38 -58
95 36 36 36 36 97 4z m-12402 -49 c15 -27 44 -50 64 -50 21 0 44 -17 52 -38
19 -50 -60 -138 -107 -120 -53 21 -108 142 -92 204 17 67 48 69 83 4z m1575
13 c0 -21 18 -38 39 -38 56 0 34 -85 -24 -96 -37 -7 -44 2 -33 43 7 29 3 59
-9 67 -31 19 -29 61 2 61 14 0 25 -17 25 -37z m9160 22 c51 -19 52 -125 3
-144 -21 -8 -38 -37 -38 -65 0 -28 -14 -51 -31 -51 -53 1 -101 43 -84 72 10
15 5 51 -11 79 -53 100 33 158 161 109z m-14710 -66 c0 -14 20 -41 44 -59 40
-30 40 -33 2 -34 -23 -1 -46 10 -50 24 -5 14 -68 33 -139 41 -72 9 -126 23
-121 31 17 27 264 24 264 -3z m1350 -9 c0 -30 -15 -37 -56 -26 -31 9 -66 15
-77 16 -11 0 -13 11 -4 25 26 42 137 30 137 -15z m8760 -241 c-3 -283 -31
-444 -78 -444 -27 0 -31 12 -16 44 12 24 20 186 18 360 -4 292 -1 314 37 281
33 -28 41 -79 39 -241z m-860 219 c17 -21 52 -38 78 -38 26 0 47 -17 47 -38 0
-30 -21 -34 -104 -21 -101 16 -103 15 -87 -47 10 -42 3 -74 -22 -94 -46 -39
-48 -123 -3 -188 18 -27 40 -92 48 -143 20 -126 -27 -124 -157 6 -108 108
-121 143 -62 166 54 21 46 141 -15 218 l-52 66 115 49 c63 27 114 61 114 75 0
39 64 31 100 -11z m250 -2 c0 -21 39 -55 86 -74 110 -46 239 -183 239 -254 0
-30 11 -62 25 -70 14 -9 24 -74 22 -146 l-3 -129 -19 98 c-26 136 -202 301
-345 326 -95 16 -105 24 -105 89 0 39 12 78 26 87 14 9 19 38 11 64 -11 33 -3
48 24 48 21 0 39 -17 39 -39z m4890 3 c15 -39 -178 -254 -199 -220 -16 27 126
256 160 256 14 0 32 -16 39 -36z m-898 -30 c15 -39 -48 -109 -98 -109 -30 0
-52 69 -35 113 19 50 114 47 133 -4z m-7242 -88 c0 -27 37 -83 81 -124 79 -72
80 -76 33 -111 -27 -20 -55 -36 -63 -36 -7 0 -35 -45 -61 -100 -27 -55 -57
-100 -69 -100 -38 0 -24 242 17 275 85 71 7 172 -119 153 -66 -9 -53 45 16 71
33 13 68 35 77 51 25 39 88 -18 88 -79z m340 -31 c-8 -29 -14 -61 -15 -71 0
-11 -29 -19 -65 -19 -56 0 -64 8 -51 56 9 31 15 82 16 113 0 56 2 56 64 15 47
-30 61 -57 51 -94z m8660 99 c0 -49 -48 -76 -80 -44 -14 14 -18 38 -9 53 25
39 89 33 89 -9z m2437 -22 c21 -33 95 -95 163 -140 144 -93 143 -91 69 -92
-289 -2 -290 -3 -299 -104 -4 -51 -19 -88 -32 -82 -14 7 -23 25 -19 41 4 15
-10 42 -31 60 -21 17 -38 55 -38 84 0 32 -31 74 -75 104 -90 60 -97 112 -16
112 33 0 74 17 91 38 47 56 143 45 187 -21z m422 -4 c37 -28 44 -54 30 -125
l-16 -89 -62 73 c-104 124 -68 229 48 141z m-7389 -66 c124 -77 38 -152 -161
-142 -175 9 -209 66 -94 158 74 59 142 55 255 -16z m-5395 -22 c0 -26 -11 -54
-25 -63 -32 -19 -60 51 -40 102 19 50 65 23 65 -39z m11394 -6 c31 -29 56 -66
56 -81 0 -16 34 -61 75 -100 80 -77 94 -134 45 -183 -24 -24 -16 -45 36 -98
l67 -66 62 67 c35 37 80 67 101 67 22 0 39 17 39 38 0 20 -19 37 -42 37 -51 0
-158 96 -158 142 0 44 40 42 175 -11 160 -62 210 -104 273 -226 43 -86 64
-105 103 -92 56 18 138 -38 323 -219 67 -66 139 -119 161 -119 23 0 40 -21 40
-50 0 -39 17 -50 76 -50 56 0 99 -24 159 -90 101 -111 198 -113 210 -4 10 81
69 92 93 18 12 -39 -9 -73 -92 -147 l-108 -96 -88 42 c-104 51 -165 43 -183
-24 -17 -65 -51 -62 -132 14 -82 75 -124 78 -161 11 -37 -70 -161 -59 -163 14
-2 75 -36 133 -86 149 -62 20 -104 228 -64 319 14 32 -8 69 -86 144 -110 105
-173 120 -273 65 -60 -34 -60 -34 -8 -62 28 -15 59 -61 68 -103 14 -62 29 -75
90 -75 56 0 73 -11 73 -50 0 -56 -49 -66 -95 -20 -50 50 -87 -9 -56 -91 24
-62 36 -68 111 -54 75 14 86 9 100 -45 10 -42 38 -66 90 -77 41 -10 75 -33 75
-52 0 -56 -110 -68 -234 -26 -68 23 -147 33 -193 23 -51 -10 -85 -4 -98 17
-31 51 -98 11 -83 -48 19 -71 -15 -64 -111 23 -97 89 -103 125 -18 125 45 0
62 13 62 49 0 65 -42 87 -70 35 -41 -72 -112 -23 -93 64 9 41 5 79 -11 89 -14
9 -26 41 -26 71 0 30 -17 87 -38 126 -47 90 -46 91 9 91 64 0 81 24 53 77 -19
36 -13 52 26 73 47 25 48 30 10 88 -23 34 -62 62 -88 62 -50 0 -63 -37 -22
-62 55 -34 24 -88 -50 -88 -161 0 -224 68 -225 241 0 201 146 265 294 128z
m2497 18 c19 -48 -34 -112 -91 -112 -25 0 -51 -17 -59 -37 -24 -64 -85 -42
-114 41 -35 102 -36 102 25 65 46 -27 58 -24 91 25 44 64 127 74 148 18z
m-17747 -56 c6 -19 -14 -31 -53 -31 -35 0 -70 -11 -78 -25 -9 -14 -35 -25 -58
-24 -32 0 -25 16 29 64 74 64 141 71 160 16z m269 -147 c11 -37 1 -70 -31
-102 -27 -27 -56 -67 -64 -90 -21 -54 -65 -54 -85 -1 -10 25 2 55 31 76 41 30
43 41 14 87 -28 46 -27 57 7 76 22 12 40 43 40 67 0 77 36 85 54 11 10 -39 25
-95 34 -124z m12787 159 c0 -18 -13 -46 -28 -61 -21 -21 -4 -33 68 -45 155
-25 164 -32 155 -106 -16 -144 -212 -84 -284 88 -35 85 -35 95 5 124 56 41 84
41 84 0z m-14513 -17 c8 -13 33 -17 56 -8 31 12 37 5 24 -28 -9 -24 -17 -100
-17 -168 0 -122 -48 -187 -99 -132 -38 42 -49 360 -12 360 18 0 40 -11 48 -24z
m14034 -48 c52 -33 -4 -55 -93 -37 -42 8 -71 25 -64 37 18 28 113 28 157 0z
m3354 -24 c0 -70 -29 -83 -79 -38 -63 57 -58 84 17 84 43 0 62 -14 62 -46z
m-10669 -2 c97 -36 266 -280 251 -360 -17 -91 -36 -85 -148 47 -80 94 -115
117 -205 129 -134 18 -180 94 -99 163 56 49 113 55 201 21z m1665 -35 c6 -36
-5 -44 -50 -38 -32 5 -62 29 -67 54 -6 36 5 44 50 38 32 -5 62 -29 67 -54z
m-576 -6 c148 -104 141 -263 -11 -225 -90 23 -309 168 -309 206 0 62 237 77
320 19z m-8670 -64 c0 -64 -6 -73 -35 -49 -19 16 -29 51 -22 78 20 76 57 58
57 -29z m2032 28 c35 -27 82 -50 106 -50 23 0 48 -22 55 -50 7 -27 26 -50 41
-51 40 -1 141 -89 141 -122 0 -41 -95 -127 -140 -127 -30 0 -37 15 -26 57 34
135 -9 169 -290 229 -74 16 -83 40 -43 116 33 61 76 61 156 -2z m19309 6 c9
-35 33 -42 125 -35 63 5 126 -3 141 -18 16 -16 53 -28 83 -28 31 0 88 -16 127
-36 39 -20 90 -42 114 -49 27 -8 44 -38 44 -77 0 -44 37 -99 119 -176 l119
-111 -82 -1 c-63 0 -89 14 -111 63 -30 66 -174 91 -209 35 -26 -43 90 -148
165 -148 37 0 82 -17 99 -37 22 -27 43 -30 76 -13 84 45 163 -25 101 -89 -14
-14 0 -52 38 -98 l61 -75 15 58 c13 46 29 56 76 47 41 -8 68 3 86 37 55 104
217 -171 221 -375 2 -133 -66 -205 -193 -205 -163 1 -256 82 -204 178 18 34 0
56 -96 112 -65 38 -173 112 -239 165 -67 52 -148 95 -180 95 -98 0 -187 46
-211 109 -12 33 -50 88 -83 121 -33 33 -65 71 -71 84 -12 29 -162 136 -191
136 -12 0 -40 59 -64 131 -37 116 -37 135 -4 159 20 16 37 41 37 57 0 45 79
32 91 -16z m-21528 -31 c0 -20 -20 -41 -44 -45 -31 -6 -44 7 -44 45 0 38 13
51 44 45 24 -4 44 -25 44 -45z m20312 13 c17 -21 52 -38 78 -38 58 0 62 -39 6
-61 -41 -15 -159 71 -159 115 0 33 41 24 75 -16z m-5167 -36 c16 -16 2 -35
-42 -55 -36 -16 -66 -50 -66 -74 0 -53 -39 -67 -241 -84 -175 -14 -217 11
-181 108 21 55 26 57 67 20 50 -45 95 -27 109 45 15 80 284 110 354 40z m3767
-17 c131 -68 150 -95 88 -119 -42 -16 -52 -105 -14 -128 13 -8 36 9 52 38 27
51 30 51 61 8 23 -32 62 -44 135 -41 87 4 103 -3 103 -45 0 -27 17 -56 38 -64
67 -26 39 -52 -69 -67 -172 -23 -529 189 -583 345 -51 148 5 169 189 73z
m-3625 -22 c0 -74 -38 -82 -73 -16 -27 50 -13 78 40 78 19 0 33 -27 33 -62z
m-9894 -38 c36 0 69 -49 69 -102 0 -42 -40 -24 -120 55 -84 81 -114 161 -34
88 25 -22 63 -41 85 -41z m-1268 -132 c12 -70 35 -104 89 -132 40 -20 73 -47
73 -59 0 -12 23 -27 50 -34 28 -7 50 -26 50 -42 0 -16 -20 -24 -44 -17 -24 7
-94 20 -156 30 -62 9 -131 26 -153 38 -46 24 -86 263 -60 348 26 80 130 -11
151 -132z m299 166 c23 -9 52 -43 65 -75 17 -47 35 -57 80 -46 65 17 204 -92
187 -145 -26 -78 -155 -46 -288 71 -157 138 -182 248 -44 195z m4775 -84 c-8
-14 -26 -25 -38 -25 -28 0 -32 83 -7 109 24 24 65 -53 45 -84z m2717 13 c32
-70 3 -124 -80 -145 -41 -11 -49 -1 -49 67 0 134 81 184 129 78z m-2295 -19
c21 -33 18 -53 -15 -86 -51 -51 -63 -42 -85 65 -18 92 47 106 100 21z m957
-25 c23 -45 62 -96 87 -113 76 -54 28 -96 -145 -128 -177 -33 -257 -9 -164 49
27 17 44 49 38 72 -6 26 13 52 54 71 38 17 64 49 64 79 0 72 17 64 66 -30z
m-8416 6 c15 -27 60 -67 101 -88 96 -49 94 -104 -3 -125 -92 -20 -185 52 -206
159 -19 100 61 141 108 54z m9375 -12 c0 -71 -7 -74 -78 -36 -40 21 -44 34
-21 62 47 57 99 43 99 -26z m4125 -12 c0 -96 -36 -115 -99 -52 -64 64 -64 72
5 100 87 35 94 31 94 -48z m-8598 23 c26 -14 48 -42 48 -62 0 -43 -40 -49 -64
-10 -10 16 -54 20 -114 10 -77 -13 -97 -9 -97 21 0 64 137 89 227 41z m13382
7 c25 -41 -106 -135 -177 -126 -112 12 -90 84 24 77 69 -4 94 4 94 31 0 39 39
50 59 18z m-5018 -69 c18 -48 -58 -137 -117 -137 -97 0 -121 134 -28 158 85
23 131 16 145 -21z m1882 8 c40 -25 45 -50 34 -162 -10 -97 -6 -133 17 -133
20 0 26 -21 17 -58 -8 -33 0 -80 19 -106 19 -25 28 -64 20 -85 -12 -33 -9 -34
28 -4 58 47 66 33 50 -91 -19 -139 -49 -134 -209 30 -80 83 -158 139 -197 144
-60 7 -64 16 -61 123 4 132 68 247 136 247 29 0 53 24 63 63 18 71 20 72 83
32z m6086 -65 c36 -52 66 -118 66 -146 0 -28 38 -82 85 -121 76 -63 84 -82 71
-161 -20 -126 -103 -277 -153 -277 -50 0 -101 -122 -86 -205 12 -59 -72 -195
-120 -195 -14 0 -41 37 -61 81 -20 45 -50 101 -67 124 -42 59 -13 77 66 42
151 -69 168 97 25 240 -33 32 -36 53 -15 96 49 102 57 253 15 312 -22 33 -31
77 -22 106 9 28 3 68 -14 87 -46 56 -10 112 72 112 55 0 87 -22 138 -95z
m-16745 -70 c2 -153 -13 -235 -42 -235 -12 0 -22 85 -22 190 0 140 8 186 31
179 19 -7 32 -59 33 -134z m2617 94 c38 -38 9 -62 -125 -104 -58 -18 -106 -48
-106 -67 0 -33 -218 -258 -249 -258 -9 0 -29 13 -46 30 -37 37 30 120 99 120
41 0 73 39 205 256 45 73 160 85 222 23z m-7331 -68 c0 -24 -17 -36 -42 -32
-62 13 -71 71 -10 71 31 0 52 -16 52 -39z m5095 -42 c-5 -52 -21 -81 -45 -81
-48 0 -63 79 -24 126 50 59 78 41 69 -45z m-4305 -75 c1 -72 7 -164 12 -204 6
-43 -2 -77 -21 -83 -20 -7 -31 13 -31 57 0 37 -16 80 -35 96 -19 15 -42 70
-51 122 -16 90 15 130 111 141 7 1 14 -57 15 -129z m8805 64 c7 -50 -5 -54
-258 -71 -186 -13 -285 -9 -330 11 -112 51 -29 87 192 82 109 -2 225 6 256 19
84 34 131 20 140 -41z m12928 -58 c40 0 156 -272 140 -325 -22 -67 -73 -52
-84 25 -10 67 -75 178 -122 207 -34 22 -44 172 -14 203 10 10 28 -11 40 -46
12 -35 30 -64 40 -64z m-24398 -14 c0 -38 -14 -61 -37 -61 -40 0 -49 43 -23
110 21 56 60 24 60 -49z m7622 55 c28 -34 14 -116 -19 -116 -38 0 -128 80
-128 114 0 46 109 48 147 2z m892 -37 c-7 -23 -3 -58 10 -78 14 -22 13 -54 -3
-84 -18 -33 -18 -66 0 -107 16 -33 18 -64 5 -72 -13 -8 -40 -49 -62 -92 -38
-77 -38 -78 63 -179 95 -94 99 -105 58 -135 -67 -48 -145 -39 -201 24 -151
171 -180 337 -56 325 76 -8 135 50 112 110 -14 35 -43 39 -216 24 -167 -13
-203 -10 -215 22 -8 21 -33 38 -55 38 -33 0 -31 6 9 34 29 20 108 34 192 32
147 -2 206 21 147 58 -50 31 -13 101 53 101 32 1 74 11 94 24 48 30 81 7 65
-45z m5931 -4 c24 -42 63 -75 91 -75 26 0 69 -19 95 -43 64 -57 344 -67 383
-13 21 29 39 31 78 10 28 -15 58 -21 66 -13 35 35 258 -76 323 -160 95 -123
88 -147 -49 -163 -133 -15 -183 26 -207 169 -18 106 -82 107 -184 2 -97 -100
-278 -127 -341 -51 -17 20 -51 37 -76 37 -55 0 -149 113 -149 178 0 64 -110
62 -175 -3 -65 -65 -64 -141 2 -176 31 -17 46 -43 38 -65 -8 -20 8 -81 35
-134 28 -54 50 -124 50 -157 0 -32 11 -69 25 -83 71 -71 -9 -369 -103 -379
-49 -6 -72 16 -131 124 l-72 131 -47 -58 c-26 -32 -47 -72 -47 -89 0 -17 -22
-52 -50 -76 -54 -49 -69 -188 -20 -188 16 0 59 26 94 58 62 55 67 56 176 18
113 -39 113 -39 97 -136 -28 -178 -212 -230 -253 -71 -13 52 -36 81 -63 81
-83 0 -234 53 -246 86 -7 18 5 76 26 128 38 90 42 92 76 46 20 -26 37 -37 37
-24 1 12 -14 40 -32 62 -125 148 -79 414 75 431 57 7 69 19 63 65 -5 30 9 87
29 125 20 37 61 119 91 181 29 62 67 124 83 138 17 13 50 55 74 93 56 88 85
87 138 -6z m3119 48 c30 -49 -34 -88 -89 -54 -27 17 -66 31 -87 31 -21 0 -38
11 -38 25 0 34 193 32 214 -2z m-8126 -23 c8 -14 43 -25 77 -25 82 0 99 -57
49 -163 -23 -48 -38 -107 -34 -131 5 -29 -11 -46 -49 -51 -31 -5 -56 4 -56 18
0 15 11 27 25 27 57 0 -45 258 -112 284 -21 8 -38 26 -38 40 0 33 117 34 138
1z m-2217 -58 c5 -28 -9 -42 -44 -42 -29 0 -52 15 -52 33 0 77 81 84 96 9z
m554 -27 c0 -52 -14 -90 -37 -99 -24 -9 -38 -47 -38 -103 0 -55 -26 -128 -67
-190 -56 -84 -61 -106 -32 -124 22 -13 46 -12 60 2 42 42 53 27 57 -75 5 -110
-38 -141 -152 -112 -164 41 -183 309 -29 416 16 12 14 29 -6 49 -49 49 -36
116 25 135 89 29 167 95 168 142 2 84 51 44 51 -41z m4896 -7 c-37 -45 -84 -3
-62 56 14 34 23 36 54 10 29 -24 31 -39 8 -66z m3579 50 c0 -17 -12 -38 -27
-47 -38 -23 -5 -182 54 -257 96 -122 54 -204 -106 -204 -129 0 -178 42 -160
137 10 57 5 87 -17 95 -24 8 -21 29 13 89 35 61 39 89 18 129 -15 28 -21 62
-13 74 21 35 238 19 238 -16z m-10397 -40 c50 -70 84 -283 48 -305 -15 -9 -26
6 -26 36 0 28 -22 74 -50 101 -31 31 -50 83 -50 138 0 100 21 108 78 30z
m4028 -40 c34 -253 -21 -382 -177 -415 -73 -16 -82 -12 -74 28 6 26 25 43 42
40 34 -8 128 96 159 174 12 32 2 60 -32 89 -56 48 -63 107 -19 151 54 54 88
32 101 -67z m-7762 -27 c69 -122 70 -146 3 -217 l-53 -56 90 -86 c50 -47 91
-108 91 -135 0 -74 74 -207 114 -207 54 0 43 -69 -14 -87 -41 -14 -45 -25 -23
-67 25 -47 30 -47 72 -9 40 36 46 36 60 2 9 -25 46 -39 105 -39 84 0 89 -5 82
-72 -4 -39 5 -87 20 -106 15 -19 35 -68 44 -109 10 -42 23 -96 31 -120 11 -38
2 -42 -58 -28 -85 20 -157 101 -157 179 -1 38 -16 56 -49 56 -27 0 -74 37
-105 81 -31 45 -72 91 -90 102 -23 14 -29 47 -17 108 14 74 9 89 -35 100 -33
9 -56 42 -65 94 -9 45 -41 116 -72 158 -44 60 -56 106 -52 205 5 105 -3 132
-45 154 -46 25 -47 31 -11 71 22 24 40 62 40 85 0 69 34 48 94 -57z m-792 28
c4 -29 5 -165 1 -210 -2 -26 -23 -44 -53 -44 -44 0 -50 17 -50 133 0 74 7 140
15 149 17 17 84 -5 87 -28z m8965 7 c5 -14 -6 -46 -25 -71 -29 -40 -40 -42
-88 -12 -60 38 -71 86 -23 106 48 20 127 7 136 -23z m-992 -59 c0 -25 -17 -60
-37 -77 -51 -42 -78 26 -39 99 32 59 76 46 76 -22z m2659 -39 c29 -55 68 -109
85 -120 52 -34 39 -143 -17 -143 -48 0 -174 190 -214 321 -31 104 84 57 146
-58z m235 68 c6 -18 -11 -31 -40 -31 -55 0 -88 33 -61 60 25 25 89 7 101 -29z
m-8144 -18 c17 -21 48 -38 68 -38 24 0 34 -16 26 -44 -6 -25 3 -59 21 -76 19
-17 28 -45 21 -63 -7 -18 4 -66 25 -106 21 -40 39 -92 39 -115 0 -22 45 -95
100 -161 55 -67 118 -161 141 -209 23 -49 85 -140 138 -203 53 -62 96 -129 96
-147 0 -18 20 -47 44 -65 61 -44 19 -76 -52 -39 -207 111 -667 773 -667 960 0
32 -11 69 -25 83 -13 13 -32 78 -41 142 -16 122 7 151 66 81z m684 0 c17 -46
-30 -77 -64 -43 -27 27 -7 80 29 80 11 0 27 -17 35 -37z m5907 -125 c22 -59
-32 -128 -101 -125 -93 5 -206 166 -174 249 16 43 251 -62 275 -124z m5838
111 c-4 -19 12 -49 35 -66 24 -17 36 -48 27 -69 -18 -48 -116 -52 -116 -5 0
19 -7 71 -16 115 -14 71 -10 80 31 71 26 -6 44 -26 39 -46z m-15379 -32 c0
-74 -16 -90 -76 -74 -54 14 -67 96 -18 115 66 27 94 15 94 -41z m6045 24 c53
-29 54 -35 18 -65 -58 -49 -183 8 -137 62 36 44 45 45 119 3z m-3770 -40 c0
-65 -33 -81 -110 -52 -98 37 -84 101 23 101 69 0 87 -10 87 -49z m8225 -1 c0
-42 -11 -48 -62 -35 -67 17 -77 -9 -39 -102 19 -46 22 -47 38 -7 10 24 40 44
66 44 56 0 59 -24 13 -87 -56 -77 -205 -22 -198 73 9 130 182 238 182 114z
m-6187 -62 c0 -49 -14 -78 -41 -83 -49 -9 -74 45 -55 119 22 82 96 54 96 -36z
m1321 49 c10 -25 -7 -48 -48 -67 -73 -33 -122 -1 -97 63 20 53 126 55 145 4z
m4600 -87 c29 -144 239 -287 382 -260 76 14 88 10 80 -28 -8 -43 -19 -52 -147
-110 -181 -84 -567 350 -413 463 59 43 79 29 98 -65z m-6384 49 c0 -14 20 -33
44 -41 131 -47 179 -189 75 -222 -31 -10 -71 -39 -89 -65 -18 -25 -49 -46 -70
-46 -20 0 -65 -18 -99 -41 -118 -77 -447 20 -467 139 -7 35 -16 80 -22 99 -20
72 48 50 149 -46 113 -108 235 -136 264 -62 11 29 42 37 121 31 l107 -7 -8 87
c-4 48 -18 98 -31 111 -31 31 -31 89 1 89 14 0 25 -12 25 -26z m12756 -11 c-9
-37 -88 -31 -100 8 -8 23 7 31 47 25 33 -5 57 -20 53 -33z m-6646 -28 c8 -21
22 -103 31 -181 18 -157 110 -362 200 -447 78 -72 74 -111 -16 -162 -42 -24
-86 -71 -99 -104 -23 -62 -115 -111 -147 -79 -9 10 -17 228 -19 486 -1 258
-10 482 -20 498 -10 17 -3 29 18 29 20 0 43 -18 52 -40z m-9510 -101 c0 -65
-1 -66 -50 -21 -27 24 -50 54 -50 66 0 11 23 21 50 21 37 0 50 -17 50 -66z
m23250 -35 c0 -10 -23 -24 -52 -32 -57 -15 -88 33 -63 99 15 37 20 37 66 -4
27 -25 49 -53 49 -63z m-17650 51 c33 -22 33 -28 0 -50 -80 -52 -203 -15 -162
50 19 32 113 32 162 0z m1699 -69 c101 -122 93 -188 -28 -208 l-92 -14 -16
106 c-8 58 -32 119 -51 136 -48 39 -24 74 50 74 38 0 87 -34 137 -94z m1339
69 c8 -14 37 -25 63 -25 33 0 49 -17 49 -51 0 -36 21 -55 74 -65 41 -8 88 -31
104 -50 40 -48 59 -44 178 42 60 44 109 65 115 50 18 -55 -19 -97 -113 -127
-53 -17 -134 -58 -182 -90 -57 -38 -95 -50 -111 -34 -14 14 -56 25 -93 25 -98
0 -172 104 -172 241 0 106 46 150 88 84z m-2863 -75 c0 -28 -17 -50 -37 -50
-39 0 -52 53 -21 83 31 32 58 17 58 -33z m859 -136 c9 -76 35 -178 58 -226
l42 -88 -79 -78 -80 -78 0 64 c0 35 -11 71 -25 80 -35 21 -32 420 4 456 46 46
63 18 80 -130z m6791 61 c63 -68 113 -100 159 -100 68 0 91 -37 35 -57 -22 -8
-14 -30 25 -72 33 -36 56 -94 56 -139 0 -92 62 -126 126 -68 37 33 53 34 96 7
44 -27 59 -24 112 26 82 77 151 62 161 -35 4 -41 18 -103 32 -138 18 -47 15
-88 -14 -156 -21 -50 -38 -125 -38 -166 0 -62 -11 -75 -69 -82 -58 -6 -67 -17
-61 -76 5 -37 2 -78 -5 -91 -16 -26 -176 23 -221 68 -16 16 -55 29 -87 29 -86
0 -81 118 7 140 37 9 77 4 93 -12 15 -15 54 -28 85 -28 50 0 55 9 42 75 -14
69 -10 75 54 75 63 0 67 6 52 79 -27 137 -62 127 -113 -33 -39 -121 -98 -173
-130 -114 -19 33 -54 41 -158 36 -184 -8 -331 124 -189 170 74 23 61 58 -39
105 -74 36 -86 52 -74 102 8 33 2 76 -14 95 -22 27 -22 44 1 71 33 39 -31 89
-115 89 -41 0 -41 2 2 33 69 50 10 153 -76 131 -47 -12 -60 -5 -60 31 0 41 92
85 210 102 13 2 64 -42 115 -97z m-13314 -45 c14 -43 52 -97 83 -118 31 -22
56 -55 56 -73 0 -18 17 -47 38 -64 97 -81 -21 -183 -124 -107 -86 64 -130 152
-148 296 -23 180 41 225 95 66z m11402 51 c-10 -24 -24 -86 -31 -139 -8 -54
-23 -86 -36 -73 -35 35 5 256 48 256 25 0 31 -14 19 -44z m266 3 c56 -51 59
-117 8 -159 -31 -26 -39 -19 -53 47 -8 44 -25 85 -37 92 -32 20 -27 61 7 61
16 0 50 -19 75 -41z m-12136 -178 c63 -59 68 -60 99 -17 18 25 33 57 33 70 0
13 6 18 14 10 22 -22 -52 -177 -109 -228 -56 -50 -105 -37 -105 28 0 50 -97
156 -142 156 -18 0 -33 17 -33 38 0 20 15 37 34 37 19 0 50 18 68 40 29 35 35
34 54 -17 11 -31 50 -84 87 -117z m5026 130 c57 -40 81 -186 31 -186 -14 0
-25 16 -25 35 0 20 -34 64 -75 99 -41 34 -75 69 -75 77 0 28 90 13 144 -25z
m3431 -73 c34 -31 82 -63 107 -71 48 -17 102 -133 83 -182 -17 -44 -214 -29
-250 20 -16 21 -51 44 -78 49 -50 10 -56 68 -24 214 15 65 65 55 162 -30z
m-414 -6 c79 -86 80 -107 4 -107 -76 0 -164 120 -111 153 44 28 35 32 107 -46z
m6209 11 c6 -32 -8 -43 -56 -43 -61 0 -86 45 -46 84 30 30 94 5 102 -41z
m6642 23 c29 -21 40 -49 30 -77 -26 -66 -103 -37 -112 42 -9 77 13 86 82 35z
m-15037 -78 c0 -107 61 -121 87 -21 23 95 63 26 46 -79 -11 -65 2 -95 71 -169
141 -150 211 -161 403 -65 56 28 93 7 93 -51 0 -25 8 -53 19 -63 10 -10 32
-99 48 -198 17 -99 48 -253 69 -342 42 -180 21 -225 -101 -225 -111 0 -135 25
-135 140 0 113 44 152 68 60 26 -102 82 -34 82 99 0 49 -15 74 -50 83 -27 7
-50 33 -50 57 0 76 -74 138 -129 109 -58 -31 -96 -10 -96 53 0 26 -22 59 -50
74 -67 36 -223 198 -300 311 -34 51 -87 117 -118 147 -38 38 -51 72 -41 111
24 91 84 69 84 -31z m9974 10 c54 -52 97 -73 130 -65 81 22 217 -75 234 -166
28 -149 4 -329 -43 -330 -24 0 -55 -12 -70 -27 -38 -38 -3 -110 54 -110 68 0
146 -45 146 -84 0 -35 -102 -91 -166 -91 -82 0 -21 -87 73 -102 130 -21 134
-32 68 -173 -55 -118 -56 -127 -15 -172 114 -126 35 -376 -107 -340 -86 21
-91 29 -54 74 25 29 25 46 3 73 -16 19 -34 61 -40 93 -6 33 -33 76 -60 97 -27
20 -64 85 -82 144 -35 115 -74 131 -165 67 l-56 -39 51 -65 c27 -35 50 -74 50
-88 0 -44 -112 -117 -180 -118 -65 -1 -66 2 -56 129 10 114 3 138 -56 199 -65
68 -65 72 -21 120 37 42 40 57 12 89 -54 66 -126 95 -157 64 -54 -54 -141 -30
-193 54 -42 68 -48 109 -36 244 33 377 39 402 103 431 87 40 135 -11 74 -78
-72 -80 -82 -242 -18 -276 29 -16 71 -65 93 -109 51 -99 220 -268 270 -268 20
0 44 -22 52 -49 10 -31 56 -62 118 -80 95 -29 105 -27 148 27 65 80 59 148
-16 182 -92 42 -146 295 -62 295 37 0 48 74 22 148 -18 52 -52 83 -111 103
-48 15 -86 44 -86 64 0 50 -75 75 -101 33 -12 -19 -30 -25 -41 -15 -10 11 -8
28 6 37 13 10 38 48 55 86 41 93 127 90 230 -8z m-11655 21 c-6 -17 -33 -35
-61 -39 -28 -4 -64 -35 -79 -69 -17 -36 -49 -61 -80 -61 -70 0 -56 77 22 115
32 16 71 42 86 57 38 38 125 36 112 -3z m16581 -109 c0 -42 -3 -42 -86 -11
-70 27 -82 73 -33 122 35 35 119 -44 119 -111z m-19851 5 c13 -33 37 -64 54
-70 44 -15 8 -95 -43 -95 -56 0 -160 115 -160 176 0 75 120 66 149 -11z
m21779 -62 c127 -141 272 -336 272 -366 0 -11 29 -81 65 -157 132 -279 236
-933 156 -983 -26 -16 -27 -26 -2 -51 52 -52 38 -166 -25 -197 -31 -16 -82
-59 -112 -95 -110 -130 -196 23 -130 233 18 55 47 118 65 140 52 62 44 115
-11 69 -29 -25 -69 -32 -118 -21 -48 10 -90 4 -116 -18 -35 -29 -51 -25 -116
29 -74 63 -76 63 -109 14 -48 -69 -156 -42 -138 35 12 51 -110 152 -241 198
-61 22 -80 85 -40 133 68 82 234 169 311 162 43 -3 90 10 107 29 44 54 137 24
185 -59 66 -116 -14 -219 -105 -136 -57 51 -76 26 -76 -101 0 -153 172 -256
175 -105 0 11 34 19 75 19 47 0 75 13 75 35 0 19 28 42 63 50 66 17 87 90 26
90 -20 0 -43 23 -51 50 -10 31 -38 50 -74 50 -46 0 -57 14 -56 69 1 38 -7 87
-17 109 -14 29 -4 44 33 54 30 8 51 34 51 64 0 66 -114 199 -167 195 -25 -2
-48 20 -56 54 -8 32 -26 60 -39 63 -40 7 -45 -105 -8 -166 21 -34 29 -92 20
-154 -11 -88 -16 -95 -41 -53 -38 65 -119 35 -96 -35 11 -35 2 -55 -29 -67
-25 -10 -48 -4 -54 14 -8 23 -18 23 -46 0 -41 -34 -75 -9 -88 64 -5 28 -36 56
-70 64 -74 17 -120 176 -77 269 22 49 32 53 75 26 64 -40 95 -7 55 59 -28 44
-24 63 32 144 35 50 64 110 64 131 0 75 117 171 208 171 70 0 104 -21 195
-122z m-18346 32 c31 -31 -15 -85 -72 -85 -71 0 -76 20 -16 65 49 38 66 42 88
20z m11138 -39 c13 -69 -45 -187 -71 -145 -27 43 -32 158 -7 183 26 26 70 4
78 -38z m5136 -31 c83 -55 319 -78 319 -32 0 20 17 50 37 67 44 36 163 -26
163 -86 0 -19 53 -79 119 -134 92 -77 128 -130 161 -233 61 -198 104 -481 86
-571 -11 -59 -2 -97 38 -151 45 -61 51 -93 38 -217 -9 -80 -5 -196 7 -258 38
-191 -98 -318 -209 -196 -79 87 -140 189 -140 233 0 56 -51 69 -169 42 -111
-25 -156 -3 -156 76 0 56 108 60 200 8 170 -98 219 -24 100 150 -41 59 -75
121 -75 135 0 15 -11 27 -25 27 -14 0 -25 -11 -25 -25 0 -14 -11 -25 -25 -25
-14 0 -25 17 -25 38 0 20 9 37 19 37 11 0 30 24 44 53 13 30 32 49 41 44 29
-16 146 109 146 156 0 54 -137 18 -160 -42 -19 -50 -115 -46 -115 4 0 23 34
80 77 128 43 50 70 103 62 125 -42 108 -43 157 -6 157 22 0 46 -11 55 -25 8
-14 34 -25 57 -24 36 0 34 5 -7 29 -28 15 -61 45 -73 66 -19 32 -27 31 -57
-10 -34 -46 -37 -46 -146 12 -97 51 -134 57 -265 43 -149 -15 -152 -14 -138
40 10 40 -6 77 -56 131 -207 222 -134 383 103 228z m-12772 28 c42 -30 41 -36
-7 -98 -65 -82 -65 -111 -2 -127 28 -7 50 -26 50 -41 0 -37 -75 -32 -150 11
-34 19 -88 36 -119 36 -74 1 -71 26 13 105 38 36 83 83 101 106 39 48 57 50
114 8z m11299 -42 c64 -41 117 -85 117 -98 0 -13 34 -35 75 -49 83 -29 92 -66
37 -140 -20 -27 -37 -58 -37 -69 0 -37 101 -21 117 19 10 27 39 -4 95 -106 82
-148 135 -437 148 -808 3 -76 19 -235 36 -354 20 -145 22 -237 5 -280 -23 -63
-186 -166 -261 -166 -51 0 -115 98 -115 174 1 80 -73 424 -103 482 -31 61 -27
80 10 48 40 -33 84 -7 97 59 7 38 30 50 94 50 96 0 132 48 51 69 -29 8 -59 37
-66 65 -10 38 -37 52 -116 58 -73 5 -111 22 -129 58 -19 36 -46 48 -103 42
-80 -8 -152 47 -123 94 9 14 43 26 77 26 70 0 81 37 18 61 -27 10 -55 1 -73
-24 -24 -33 -40 -35 -82 -13 -61 33 -65 59 -16 100 29 24 30 43 8 91 -29 64
29 180 101 204 60 20 80 -103 24 -147 -73 -57 -38 -92 74 -74 122 20 137 85
41 174 -39 36 -91 108 -115 159 -24 52 -52 95 -62 95 -113 9 -213 25 -233 37
-34 21 -30 112 5 112 16 0 47 15 69 34 33 29 155 82 203 89 8 1 67 -32 132
-72z m-19622 -9 c35 -26 40 -45 21 -79 -23 -41 -28 -40 -66 15 -68 96 -44 129
45 64z m6264 -17 c0 -35 -35 -66 -113 -103 -62 -29 -140 -88 -174 -130 -66
-85 -83 -83 -94 10 -5 49 6 62 59 68 40 5 98 47 148 106 90 108 174 131 174
49z m-3690 10 c49 -19 52 -69 6 -107 -43 -36 -104 27 -82 84 16 43 21 44 76
23z m-1826 -121 c7 -20 45 -39 83 -43 59 -7 69 -19 62 -71 -21 -153 -70 -156
-215 -13 -103 102 -139 180 -100 219 21 20 154 -52 170 -92z m2460 67 c6 -18
-11 -31 -42 -31 -31 0 -52 16 -52 39 0 46 78 40 94 -8z m10855 -29 c38 -71 34
-77 -48 -77 -86 0 -118 37 -75 89 42 50 92 45 123 -12z m3834 20 c69 -36 167
-124 167 -151 0 -12 -28 -21 -62 -21 -63 0 -88 -57 -38 -87 14 -9 25 -38 25
-64 0 -35 15 -47 54 -42 46 4 60 -14 83 -107 28 -109 32 -112 121 -107 116 7
125 -50 17 -105 -41 -22 -75 -49 -75 -61 0 -12 -24 -27 -53 -35 -28 -7 -45
-26 -36 -40 22 -36 89 -35 89 1 0 17 21 21 56 10 31 -9 82 -17 113 -15 97 3
79 -137 -21 -157 -106 -21 -92 -100 21 -111 94 -9 99 -26 31 -112 -53 -67 -65
-118 -27 -118 12 0 19 -82 15 -181 -5 -157 -13 -185 -60 -206 -29 -14 -53 -39
-53 -56 0 -18 -18 -32 -41 -32 -33 0 -34 7 -9 37 24 30 24 39 -3 48 -19 6 -52
16 -73 22 -21 7 -59 56 -85 109 -25 53 -56 116 -68 141 -29 57 41 88 107 47
68 -42 133 -36 182 19 50 55 25 80 -77 74 -128 -7 -307 91 -324 178 -13 66
-70 125 -120 125 -8 0 -14 -33 -14 -73 0 -52 -15 -78 -50 -89 -27 -9 -50 -24
-50 -34 0 -44 81 -126 131 -134 60 -8 82 -62 47 -116 -18 -28 -37 -27 -113 9
-72 34 -98 37 -127 12 -56 -46 -160 -10 -178 63 -12 48 -32 62 -88 62 -86 0
-92 33 -16 86 77 54 94 49 94 -27 0 -60 6 -64 80 -49 126 25 140 54 76 165
-55 95 -55 97 -6 113 56 17 65 62 21 106 -22 22 -21 38 3 67 45 55 73 49 106
-23 26 -59 120 -90 120 -40 0 13 29 58 65 100 64 77 57 89 -46 78 -51 -5 -157
63 -127 82 12 7 77 16 146 20 112 7 125 3 132 -47 9 -62 10 -62 65 -41 55 21
50 78 -9 97 -27 9 -56 39 -65 67 -13 42 -31 49 -95 40 -114 -18 -141 0 -141
92 0 99 -67 168 -145 148 -43 -12 -55 -4 -55 35 0 28 -18 58 -41 66 -33 13
-23 32 52 103 100 94 256 119 372 59z m-17634 -33 c52 -63 21 -126 -62 -126
-66 0 -75 9 -82 81 -7 71 -1 81 53 81 33 0 74 -16 91 -36z m3851 -45 c21 -31
38 -68 40 -81 8 -86 49 -167 112 -223 40 -36 73 -78 73 -93 0 -45 151 -222
190 -222 19 0 35 -11 35 -25 0 -14 20 -25 44 -24 41 1 41 2 0 34 -61 46 -55
65 19 65 38 0 62 -14 62 -37 0 -21 16 -38 35 -38 22 0 31 -17 23 -47 -13 -48
46 -77 161 -78 87 0 66 -41 -45 -85 -169 -68 -267 -35 -457 152 -91 88 -171
183 -180 209 -8 27 -26 49 -39 49 -13 0 -23 14 -23 31 0 17 -34 98 -75 179
-73 142 -93 239 -58 273 27 28 44 20 83 -39z m5111 34 c7 -12 45 -30 83 -40
100 -25 289 -155 255 -176 -19 -12 -20 -26 -3 -43 31 -31 86 0 64 35 -20 32
111 144 170 145 23 1 53 21 67 45 44 78 62 9 33 -125 -60 -277 -62 -464 -6
-494 28 -15 51 -47 51 -73 0 -25 18 -61 40 -79 26 -22 35 -56 26 -101 -9 -43
-1 -79 23 -98 39 -32 50 -163 15 -184 -35 -22 -138 136 -109 165 67 67 -91
232 -201 210 -121 -24 -174 22 -167 143 4 58 -1 135 -10 173 -9 38 -22 95 -29
127 -7 34 -49 78 -100 106 -49 26 -95 67 -102 92 -10 31 -40 44 -100 44 -79 0
-86 6 -86 75 0 72 53 105 86 53z m-4515 -138 c10 -50 -42 -121 -74 -101 -26
16 -30 120 -5 145 27 27 70 4 79 -44z m6403 16 c-2 -75 -215 -287 -271 -269
-60 19 -90 -25 -82 -120 3 -40 -7 -87 -21 -105 -15 -17 -35 -81 -45 -140 -15
-88 -32 -113 -87 -133 -134 -47 -143 55 -18 199 24 27 51 83 61 125 9 41 22
103 30 137 21 97 118 275 150 275 16 0 35 17 43 38 22 58 241 52 240 -7z
m-9702 -46 c59 -68 55 -135 -8 -135 -44 0 -89 75 -89 148 0 69 29 65 97 -13z
m3716 -41 c87 -186 236 -272 317 -184 28 30 38 30 72 0 36 -32 44 -23 78 82
48 150 93 181 180 124 82 -53 83 -98 3 -141 -35 -18 -80 -60 -101 -92 -21 -32
-60 -58 -86 -58 -26 0 -55 -12 -64 -26 -9 -15 -40 -18 -70 -8 -146 48 -267 2
-267 -102 0 -77 8 -87 76 -94 107 -11 48 -83 -82 -103 l-94 -14 0 163 c0 175
-42 384 -78 384 -12 0 -22 39 -22 88 0 127 73 117 138 -19z m2893 80 c74 -21
94 -39 94 -84 0 -53 -10 -57 -164 -57 -181 0 -285 -60 -251 -147 15 -40 19
-40 61 -2 25 23 58 41 74 41 35 0 87 -93 73 -132 -5 -17 34 -50 88 -74 69 -30
95 -56 89 -87 -12 -65 -117 -71 -180 -10 -29 28 -76 72 -106 99 -29 26 -57 61
-63 77 -6 21 -28 23 -70 7 -56 -20 -60 -34 -54 -157 5 -85 21 -143 43 -155 19
-11 35 -47 35 -79 0 -51 -11 -57 -97 -55 -92 2 -99 8 -112 91 -8 48 -22 118
-31 155 -12 53 -1 81 53 131 45 41 64 80 55 112 -7 27 2 70 20 96 18 25 37 85
41 132 10 102 94 131 172 60 54 -49 137 -30 115 27 -17 44 -8 45 115 11z
m2614 -31 c6 -30 -7 -43 -43 -43 -36 0 -52 16 -52 52 0 64 83 57 95 -9z m6790
-26 c8 -30 14 -106 15 -170 0 -115 81 -247 150 -247 15 0 21 -11 13 -25 -31
-49 -85 -24 -138 63 -30 48 -64 81 -77 73 -90 -55 -169 134 -112 269 56 133
119 149 149 37z m-16284 20 c75 -39 96 -95 47 -126 -17 -10 -11 -33 17 -64 73
-80 7 -101 -81 -26 -52 43 -86 100 -97 160 -20 106 -1 116 114 56z m1259 -95
c57 -167 47 -229 -35 -230 -78 -2 -76 -126 2 -181 53 -37 71 -264 23 -293 -14
-9 -25 -41 -25 -72 0 -31 -11 -67 -24 -80 -16 -16 -14 -64 6 -137 17 -61 31
-179 31 -261 0 -139 -5 -151 -59 -159 -118 -17 -192 112 -114 199 37 40 37 49
0 101 -22 31 -40 92 -40 135 0 43 -13 114 -28 158 -22 65 -20 88 10 123 82 93
75 318 -9 300 -23 -5 -38 18 -43 61 -7 58 1 69 50 69 91 1 176 106 147 183
-13 34 -36 70 -50 79 -37 22 -34 106 4 121 83 34 110 13 154 -116z m14535 -19
c13 -115 -59 -142 -119 -44 -68 112 -65 125 30 116 67 -6 83 -19 89 -72z
m1305 53 c0 -12 -12 -30 -26 -39 -37 -23 -105 7 -87 38 20 32 113 33 113 1z
m-4216 -83 c36 -31 66 -81 66 -111 0 -74 44 -95 97 -47 57 51 228 54 228 4 0
-20 -11 -43 -25 -51 -14 -9 -25 -37 -25 -62 0 -58 -218 -201 -306 -201 -115 0
-344 331 -303 437 36 94 176 110 268 31z m-13886 -16 c26 -26 72 -55 101 -64
131 -42 230 -638 127 -769 -43 -54 -45 -82 -25 -321 25 -284 15 -1253 -14
-1404 -20 -100 -23 -98 124 -104 53 -2 85 -22 112 -70 64 -113 -6 -120 -155
-14 -53 37 -92 -6 -93 -101 0 -49 -7 -53 -50 -30 -59 32 -65 118 -12 193 31
45 33 75 10 174 -33 145 -33 1430 1 1518 14 37 12 154 -5 306 -15 136 -29 303
-30 372 -2 158 -41 226 -151 262 -86 28 -105 50 -71 83 30 30 82 18 131 -31z
m589 -32 c-36 -28 -70 -46 -76 -40 -19 20 91 121 116 106 14 -8 -4 -38 -40
-66z m10798 40 c45 -118 -4 -174 -120 -136 -86 29 -124 109 -73 159 34 34 178
17 193 -23z m3866 -12 c15 -29 22 -68 14 -88 -8 -21 -1 -59 16 -85 23 -37 24
-67 2 -123 -22 -60 -20 -90 13 -156 75 -147 128 -102 129 110 0 113 60 127
146 36 46 -49 52 -76 38 -175 -20 -145 -54 -177 -148 -142 -53 21 -74 19 -89
-5 -27 -44 15 -80 97 -84 49 -2 69 -17 70 -51 1 -26 11 -69 23 -95 25 -56 -11
-124 -73 -136 -72 -14 -164 20 -164 60 0 72 -76 186 -123 186 -58 0 -77 47
-77 188 0 60 -13 139 -29 174 -23 49 -23 94 -2 183 15 65 34 148 42 186 18 82
76 90 115 17z m5579 -39 c10 -88 118 -134 138 -59 12 46 82 73 82 31 0 -10 41
-46 91 -80 87 -60 89 -65 75 -185 -12 -100 -6 -130 28 -156 41 -30 40 -36 -13
-89 l-56 -57 63 -51 c45 -37 58 -65 46 -107 -14 -55 -84 -80 -84 -31 0 14 -17
25 -37 25 -22 0 -38 -22 -38 -51 0 -28 -17 -57 -37 -65 -87 -33 -16 -283 135
-474 72 -93 65 -115 -31 -97 -59 11 -92 5 -115 -24 -18 -21 -54 -39 -79 -39
-25 0 -52 -11 -60 -25 -24 -37 -156 -30 -239 13 -80 41 -94 74 -40 95 62 23
74 143 20 202 -26 29 -61 78 -77 109 -26 52 -23 56 41 55 79 0 166 -62 192
-136 31 -85 64 8 65 179 0 132 -8 161 -56 194 -79 56 -162 50 -182 -14 -11
-32 -26 -43 -40 -29 -35 35 1 107 53 107 24 0 62 25 83 56 27 38 46 47 60 29
143 -198 315 56 197 292 -22 44 -40 96 -40 114 0 19 -11 34 -25 34 -14 0 -25
-38 -25 -84 0 -89 -53 -157 -100 -128 -15 9 -41 5 -57 -8 -17 -14 -59 -29 -93
-34 -101 -14 -89 111 13 130 49 10 71 26 64 50 -6 20 -9 83 -8 141 1 69 -10
109 -33 118 -44 17 -47 81 -5 98 76 31 116 15 124 -49z m-17543 -8 c9 -27 45
-64 81 -82 94 -45 108 -105 21 -88 -105 20 -108 -45 -6 -144 49 -48 107 -87
128 -87 47 0 50 29 9 70 -23 23 -21 30 11 30 60 0 167 -45 210 -88 21 -20 68
-44 104 -53 98 -23 132 -58 124 -128 -7 -64 19 -89 137 -130 81 -29 90 -101
30 -222 -46 -91 -56 -95 -100 -35 -22 30 -24 53 -6 75 19 23 8 45 -42 85 -37
29 -105 92 -151 139 -65 67 -107 87 -194 94 -290 24 -443 182 -443 458 0 154
52 217 87 106z m-3987 -25 c0 -54 -39 -89 -61 -54 -18 30 9 103 39 103 12 0
22 -22 22 -49z m1521 -15 c36 -80 19 -111 -60 -111 -71 0 -80 -37 -17 -73 36
-21 30 -26 -36 -26 -43 -1 -83 -12 -87 -25 -15 -44 -121 2 -121 52 0 35 18 47
74 47 52 0 71 10 62 33 -50 131 128 229 185 103z m429 16 c0 -27 34 -73 75
-102 95 -68 95 -121 0 -154 l-75 -26 64 -76 c49 -58 60 -93 48 -142 -44 -169
-55 -946 -15 -1021 21 -39 21 -58 0 -70 -17 -11 -1 -38 44 -75 86 -69 61 -141
-56 -161 -105 -19 -122 -218 -24 -294 l63 -50 -56 -39 -55 -38 85 -73 c102
-86 94 -156 -18 -156 -155 0 -152 -18 -154 1151 -1 584 -2 1121 -3 1193 0 72
6 142 15 156 25 42 62 28 62 -23z m3250 -27 c0 -28 -17 -50 -37 -50 -21 0 -38
22 -38 50 0 28 17 50 38 50 20 0 37 -22 37 -50z m-2898 0 c13 0 23 -17 23 -37
0 -43 -113 -53 -137 -13 -24 38 12 80 54 64 20 -8 47 -14 60 -14z m9548 -40
c0 -61 -94 -91 -190 -59 -102 33 -100 81 5 100 100 18 185 0 185 -41z m9520
-43 c7 -57 -1 -67 -56 -67 -51 0 -64 12 -64 60 0 108 108 114 120 7z m-14695
-99 c-1 -123 -33 -159 -111 -123 -74 34 -85 115 -25 200 56 79 136 34 136 -77z
m456 47 c61 -46 55 -65 -18 -65 -46 0 -63 13 -63 50 0 58 20 62 81 15z m-3836
-313 c4 -182 -3 -302 -18 -302 -23 0 -50 526 -31 594 25 86 43 -20 49 -292z
m8880 223 c0 -28 -17 -50 -37 -50 -21 0 -38 22 -38 50 0 28 17 50 38 50 20 0
37 -22 37 -50z m-9685 -88 c9 -35 9 -122 0 -194 -9 -72 -5 -241 8 -375 18
-188 16 -264 -9 -325 -32 -80 -18 -409 24 -571 15 -60 9 -67 -67 -78 -101 -16
-113 -8 -70 45 27 33 27 51 -4 106 -33 59 -34 155 -8 755 16 378 31 690 33
694 17 31 80 -7 93 -57z m12585 40 c0 -30 140 -77 229 -77 109 0 89 -68 -32
-104 -97 -29 -107 -27 -150 27 -26 32 -47 73 -47 92 0 19 -11 35 -25 35 -14 0
-25 11 -25 25 0 14 11 25 25 25 14 0 25 -10 25 -23z m2773 -33 c-1 -31 -10
-78 -20 -104 -17 -42 -23 -38 -51 30 -34 83 -21 130 37 130 21 0 35 -23 34
-56z m-16330 -88 c13 -52 15 -171 5 -268 -10 -97 -7 -241 5 -322 25 -153 16
-490 -14 -538 -32 -52 12 -128 74 -128 87 0 103 -50 34 -103 -84 -65 -175 -58
-231 18 -51 71 -104 671 -67 771 10 28 14 65 9 80 -6 16 0 36 13 44 14 9 9 55
-12 116 -34 101 -23 187 16 123 23 -36 82 -7 68 34 -5 16 -31 29 -58 29 -26 0
-46 15 -45 32 1 17 4 56 6 88 4 51 74 107 145 115 15 2 39 -39 52 -91z m4707
12 c0 -18 23 -51 50 -75 28 -23 50 -64 50 -91 0 -27 11 -56 25 -64 14 -9 25
-34 25 -57 0 -22 23 -65 51 -94 31 -34 44 -70 34 -97 -14 -37 -34 -27 -127 64
-105 104 -118 109 -290 121 -201 14 -248 67 -144 162 50 45 53 45 109 -8 76
-71 167 -74 149 -4 -16 63 11 175 43 175 14 0 25 -14 25 -32z m13570 -24 c-4
-31 -24 -56 -45 -56 -21 0 -41 25 -45 56 -7 43 4 56 45 56 41 0 52 -13 45 -56z
m-18638 -70 c38 -87 40 -126 17 -281 -15 -99 -26 -209 -25 -243 14 -478 -18
-807 -66 -687 -33 81 -16 1312 17 1312 7 0 33 -45 57 -101z m-687 32 c-10 -55
-109 -70 -186 -29 -92 49 -70 73 68 73 107 0 125 -7 118 -44z m8543 19 c8 -14
43 -25 78 -25 96 0 57 -60 -43 -67 -128 -8 -155 6 -123 67 29 54 63 64 88 25z
m12637 -78 c0 -15 -23 -18 -56 -8 -73 22 -77 27 -57 59 19 32 113 -10 113 -51z
m-10459 -109 l72 -29 -110 -18 c-132 -21 -145 -11 -105 76 23 51 36 60 51 34
12 -19 53 -47 92 -63z m8579 33 c12 -64 -89 -85 -148 -30 -48 42 -48 46 -5 63
71 29 144 13 153 -33z m-15624 -153 c132 -46 164 -98 99 -163 -23 -23 -23 -30
0 -30 48 0 130 -95 130 -150 0 -38 -17 -50 -72 -50 -79 0 -142 71 -157 177 -6
40 -38 74 -97 102 -128 60 -155 101 -135 208 l17 91 43 -70 c29 -47 87 -86
172 -115z m2702 116 c53 -67 68 -195 30 -255 -25 -40 -53 16 -53 107 0 32 -24
74 -54 94 -36 24 -49 51 -39 78 23 59 56 52 116 -24z m-1568 -21 c40 -35 90
-63 109 -63 53 0 44 -42 -12 -57 -26 -7 -52 -39 -56 -71 -16 -112 -103 -75
-141 61 -54 190 -22 232 100 130z m-4655 -39 c24 -58 25 -91 4 -138 -36 -79
-74 -78 -105 4 -23 61 -32 64 -187 56 -108 -6 -162 1 -162 20 0 32 114 59 253
59 70 0 97 11 97 38 0 66 68 40 100 -39z m9791 20 c-9 -31 -16 -68 -16 -81 0
-14 -12 -9 -25 12 -38 58 -29 125 15 125 30 0 37 -15 26 -56z m-2591 18 c0
-26 -113 -186 -131 -187 -11 0 -19 17 -19 38 0 20 11 37 25 37 14 0 25 28 25
63 0 45 13 62 50 62 28 0 50 -6 50 -13z m415 -102 c-12 -32 -24 -36 -44 -16
-15 15 -20 47 -11 71 12 32 24 36 44 16 15 -15 20 -47 11 -71z m4230 -17 c10
-51 -62 -86 -100 -48 -38 38 -3 110 48 100 24 -4 48 -28 52 -52z m-1333 -21
c16 -15 -2 -45 -50 -84 -124 -102 -191 -69 -136 65 32 77 118 86 186 19z
m5755 -38 c22 -33 58 -57 80 -53 26 4 41 -11 41 -41 0 -35 -19 -49 -69 -51
-99 -4 -123 -39 -95 -137 44 -154 -58 -302 -207 -302 -65 0 -217 148 -217 211
0 98 108 189 225 189 67 0 87 55 54 149 -46 131 107 159 188 35z m-7592 7 c0
-55 -72 -104 -104 -72 -19 19 -17 38 7 65 43 49 97 52 97 7z m-3453 -118 c70
-222 132 -298 179 -221 12 19 30 26 40 16 10 -11 5 -32 -11 -48 -56 -56 -31
-76 76 -61 95 14 101 12 61 -19 -63 -49 -15 -69 78 -34 93 35 138 5 69 -46
-35 -25 -41 -43 -21 -63 38 -38 124 -5 139 54 8 29 35 49 66 49 61 0 64 -19
14 -86 -56 -74 -48 -83 94 -102 155 -21 187 -36 140 -65 -57 -36 -332 -26
-385 15 -27 20 -74 37 -104 37 -59 1 -258 112 -409 229 -79 61 -93 90 -121
245 -45 250 25 324 95 100z m13853 39 c0 -39 31 -83 88 -126 56 -44 87 -88 87
-126 0 -61 -58 -83 -87 -35 -37 59 -63 16 -63 -100 0 -128 -21 -153 -75 -88
-20 25 -24 72 -12 144 9 58 18 177 18 262 0 86 10 150 22 142 12 -7 22 -40 22
-73z m-9065 23 c26 -67 17 -110 -22 -110 -25 0 -38 25 -38 75 0 80 35 101 60
35z m12729 3 c27 -20 74 -37 106 -37 44 -1 69 -28 108 -120 51 -116 51 -122 8
-250 -49 -147 -69 -169 -167 -194 -59 -15 -74 -6 -121 73 -29 49 -63 90 -76
90 -45 0 -82 120 -49 161 17 20 24 59 16 86 -9 27 -4 56 10 65 14 9 26 49 26
89 0 84 57 99 139 37z m-4103 -77 c46 -46 51 -101 11 -125 -30 -19 -150 114
-131 145 20 31 78 21 120 -20z m-12725 -28 c20 -53 -26 -103 -62 -67 -27 27
-8 109 26 109 11 0 27 -19 36 -42z m-6020 -47 c55 20 83 -26 83 -136 0 -122
-35 -173 -71 -105 -15 28 -48 58 -72 66 -32 10 -45 42 -47 114 -2 82 4 96 31
73 19 -16 53 -21 76 -12z m4228 10 c22 -22 45 -23 90 -2 44 20 67 20 88 -1 48
-48 33 -118 -24 -118 -29 0 -81 -22 -116 -50 -35 -27 -76 -50 -92 -49 -31 0
-165 180 -165 222 0 36 182 35 219 -2z m3922 -77 c29 -59 64 -140 78 -181 14
-42 34 -96 44 -122 17 -42 13 -44 -34 -18 -30 16 -54 51 -54 78 0 28 -17 49
-40 49 -22 0 -73 24 -114 53 -66 47 -70 57 -38 93 20 23 44 67 53 98 25 80 46
70 105 -50z m10804 76 c33 -33 42 -145 11 -144 -52 1 -132 92 -117 131 19 50
63 56 106 13z m-11564 -30 c60 -45 55 -65 -16 -65 -57 0 -103 54 -72 85 22 22
39 18 88 -20z m10006 -29 c28 -36 90 -73 138 -83 71 -14 89 -31 102 -98 21
-101 0 -114 -106 -68 -156 69 -256 172 -237 247 21 82 38 83 103 2z m-12309
-38 c97 -69 68 -108 -66 -89 -85 11 -121 4 -173 -37 -36 -29 -83 -45 -104 -37
-43 17 -24 65 25 65 18 0 58 34 90 75 68 88 128 94 228 23z m12835 -38 c67
-44 83 -110 27 -110 -19 0 -40 -22 -47 -50 -9 -33 -34 -50 -77 -50 -92 0 -103
41 -16 59 84 16 105 91 26 91 -54 0 -87 38 -63 75 22 37 80 31 150 -15z
m-5688 -78 c0 -36 18 -85 40 -110 67 -74 60 -208 -12 -218 -33 -5 -69 7 -81
25 -24 39 -29 298 -7 356 22 57 60 23 60 -53z m221 51 c-13 -62 -71 -71 -71
-10 0 31 16 52 39 52 24 0 36 -17 32 -42z m-3021 -145 c0 -92 -11 -163 -25
-163 -14 0 -25 71 -25 163 0 91 11 162 25 162 14 0 25 -71 25 -162z m-4851 81
c-1 -115 -162 -241 -247 -195 -74 39 -64 104 26 183 100 88 222 94 221 12z
m6512 8 c22 -35 -12 -102 -51 -102 -19 0 -35 21 -35 46 0 71 55 107 86 56z
m826 -102 c-8 -28 2 -74 24 -105 21 -31 39 -82 39 -113 0 -52 -5 -54 -52 -26
-46 27 -58 24 -91 -25 -21 -31 -59 -56 -85 -56 -63 0 -60 43 5 63 41 13 48 30
36 87 -13 58 -6 74 37 88 39 12 52 35 49 83 -8 121 0 147 28 97 14 -24 19 -66
10 -93z m-3277 0 c8 -55 27 -100 40 -100 14 0 25 -35 25 -78 0 -70 6 -76 61
-62 34 8 68 4 77 -10 24 -39 -64 -61 -116 -29 -25 16 -69 29 -96 29 -82 0
-134 107 -115 237 23 153 100 161 124 13z m10778 48 c19 -59 3 -86 -36 -62
-33 21 -36 114 -4 114 13 0 31 -23 40 -52z m-8925 -46 c0 -20 -12 -39 -25 -43
-42 -13 -96 33 -76 65 24 39 101 22 101 -22z m-3793 -44 c12 -81 -101 -131
-245 -109 -105 16 -108 19 -44 37 38 11 69 33 69 49 0 101 206 122 220 23z
m-4170 -124 c0 -18 22 -44 50 -59 28 -15 50 -43 50 -63 0 -20 33 -66 73 -102
87 -77 121 -184 70 -222 -19 -14 -42 -56 -52 -94 -24 -99 -193 -102 -237 -5
-68 150 -15 254 83 162 64 -60 95 -41 60 37 -54 120 -117 199 -155 192 -38 -6
-51 21 -72 153 -4 24 -19 44 -32 43 -56 -3 -20 -944 38 -1014 25 -31 24 -46
-7 -81 -67 -77 -81 -344 -20 -405 28 -28 68 -51 89 -51 55 0 45 -40 -32 -122
-38 -40 -122 -129 -187 -199 -66 -69 -119 -137 -119 -151 0 -46 -110 -103
-200 -103 -76 0 -93 -11 -117 -75 -42 -111 -83 -92 -83 39 0 88 14 126 61 170
56 52 62 79 74 355 8 169 25 302 39 307 14 4 27 -1 28 -13 1 -11 6 -54 11 -95
5 -42 18 -177 29 -300 23 -250 47 -272 169 -149 34 33 73 61 88 61 14 0 26 24
26 52 0 32 20 58 50 66 65 17 63 42 -10 114 l-59 60 11 732 c12 766 21 839
114 874 61 23 169 -50 169 -114z m17113 66 c21 -41 55 -75 75 -75 96 0 22
-109 -94 -138 -187 -47 -285 65 -176 201 85 107 144 110 195 12z m-15493 20
c46 -46 36 -95 -20 -95 -37 0 -50 17 -50 63 0 68 23 79 70 32z m757 -10 c22
-26 56 -35 103 -25 58 11 72 4 85 -47 8 -34 31 -74 50 -90 19 -16 35 -50 35
-76 0 -26 11 -47 25 -47 14 0 25 -24 25 -52 0 -29 23 -81 50 -116 50 -64 68
-157 29 -157 -91 0 -379 219 -379 289 0 20 -51 73 -112 116 -131 93 -138 122
-44 192 83 63 91 63 133 13z m-1814 -87 c68 -121 113 -234 109 -272 -3 -21 4
-71 15 -111 17 -60 10 -82 -33 -117 -63 -51 -69 -104 -17 -148 50 -41 147 -14
274 74 56 40 139 79 184 89 80 16 82 14 51 -36 -18 -28 -40 -52 -47 -52 -8 0
-75 -45 -149 -100 -74 -55 -161 -100 -195 -100 -48 0 -58 -10 -48 -49 16 -63
-25 -76 -110 -33 -103 51 -124 91 -121 235 5 252 -2 332 -33 351 -33 21 -40
251 -11 329 22 55 81 28 131 -60z m575 73 c163 3 173 -12 73 -112 -89 -89 -95
-91 -179 -60 -198 71 -246 228 -57 184 34 -8 108 -13 163 -12z m1720 -87 c119
-100 167 -313 105 -463 -13 -33 -1 -44 54 -50 73 -9 101 -63 72 -139 -25 -64
-217 135 -211 218 14 197 -3 269 -90 363 -127 139 -74 193 70 71z m2937 4 c16
-35 40 -63 54 -63 15 0 26 -22 26 -50 0 -27 -10 -50 -22 -50 -12 0 -50 23 -85
50 -100 79 -151 67 -130 -31 26 -121 55 -164 138 -207 41 -21 74 -49 74 -63 0
-42 121 -26 147 20 17 31 58 44 139 47 130 3 145 -23 45 -75 -115 -61 -69
-286 60 -292 43 -2 165 -119 150 -143 -30 -49 -144 -59 -205 -20 -104 68 -140
52 -122 -55 26 -155 34 -172 99 -202 59 -27 88 -104 38 -104 -55 0 -157 118
-157 182 0 37 -16 80 -35 96 -55 45 -44 191 16 210 80 25 40 162 -47 162 -25
0 -64 21 -88 47 -23 26 -73 53 -110 61 -70 14 -141 61 -251 164 l-63 60 51 42
c29 23 60 77 69 121 11 49 43 92 85 114 92 49 92 49 124 -21z m-8281 -355
c-10 -27 -25 -29 -64 -8 -59 31 -67 120 -12 141 22 9 37 46 37 95 0 44 8 89
19 100 22 22 40 -276 20 -328z m11574 259 c0 -98 -49 -94 -59 4 -5 61 2 81 25
73 19 -6 34 -41 34 -77z m-4949 31 c9 -15 7 -37 -5 -49 -30 -30 -95 13 -73 48
22 36 56 36 78 1z m-7010 -100 c49 -27 62 -110 21 -136 -14 -8 -87 14 -161 49
-75 35 -159 64 -187 64 -32 0 -52 16 -52 41 0 46 285 32 379 -18z m9357 -21
c28 -32 38 -67 26 -102 -11 -35 -3 -64 22 -83 79 -62 61 -129 -34 -129 -72 0
-89 10 -95 56 -5 31 -30 68 -56 82 -41 22 -44 34 -18 93 60 142 88 157 155 83z
m4064 26 c0 -40 -69 -83 -87 -54 -9 14 -41 27 -71 28 -53 1 -53 2 -4 23 66 29
162 30 162 3z m-1240 -104 c41 -41 87 -74 104 -74 59 0 98 -74 59 -112 -54
-52 -191 6 -282 120 -64 79 -71 99 -40 118 57 36 81 28 159 -52z m924 27 c38
-38 -3 -101 -66 -101 -71 0 -118 43 -118 108 0 41 12 46 80 32 45 -9 91 -26
104 -39z m-8185 -42 c19 -71 115 -184 156 -184 59 0 93 -54 78 -127 -11 -56 4
-86 77 -159 66 -67 90 -112 90 -171 0 -106 149 -221 215 -166 33 27 38 27 32
-3 -4 -20 18 -86 48 -147 68 -137 69 -177 6 -177 -138 0 -557 429 -605 618
-15 58 -42 118 -61 134 -19 16 -35 38 -35 50 0 11 -28 62 -62 113 -68 100 -78
161 -36 238 31 60 79 50 97 -19z m-232 -79 c8 -24 42 -102 75 -176 50 -109 60
-165 54 -317 -5 -145 3 -194 36 -231 58 -64 57 -181 -1 -180 -85 1 -128 61
-136 188 l-7 123 -138 -6 c-464 -21 -507 -12 -451 92 24 46 49 53 150 49 78
-4 144 9 183 34 59 39 63 38 139 -51 117 -136 157 -82 123 164 -22 155 -38
193 -108 261 -61 60 -76 89 -57 113 32 38 117 0 138 -63z m3238 -32 c69 -1 74
-5 33 -23 -143 -61 -284 -5 -250 100 16 52 17 52 75 -11 40 -43 87 -65 142
-66z m4645 26 c0 -44 -16 -82 -37 -90 -21 -8 -38 -30 -38 -49 0 -19 -11 -35
-25 -35 -32 0 -31 38 1 156 32 116 99 128 99 18z m825 -26 c0 -40 13 -95 30
-121 23 -38 22 -56 -3 -87 -51 -61 -77 -48 -77 39 0 44 -19 100 -41 125 -39
43 -39 49 3 95 56 63 88 44 88 -51z m600 42 c0 -63 -41 -90 -136 -90 -32 0
-72 -17 -89 -37 -46 -55 -80 -46 -70 18 5 35 28 59 61 64 30 4 74 30 98 56 63
70 136 64 136 -11z m-12756 -71 c16 -59 37 -149 46 -201 11 -64 46 -123 112
-185 98 -93 107 -147 21 -120 -39 12 -48 3 -48 -48 0 -49 16 -68 69 -80 92
-22 109 -34 93 -62 -9 -13 -53 -7 -104 15 -49 20 -108 37 -130 37 -68 0 -113
103 -121 275 -9 215 -17 235 -80 195 -65 -40 -80 -21 -96 116 -11 104 -8 114
41 114 38 0 53 -16 53 -56 1 -31 11 -73 24 -93 29 -46 86 84 67 155 -6 24 -4
44 6 44 9 0 30 -48 47 -106z m4943 -12 c66 -132 135 -207 189 -207 23 0 58
-18 76 -40 22 -26 56 -35 103 -25 78 15 90 -12 31 -71 -54 -54 -153 -47 -284
18 -146 73 -206 160 -221 319 -16 159 27 162 106 6z m6608 88 c53 -53 34 -95
-44 -95 -82 0 -109 26 -86 85 18 47 88 52 130 10z m-2278 -159 c5 -108 -2
-136 -33 -136 -28 0 -36 22 -31 82 4 44 -2 96 -13 113 -20 34 31 117 57 91 8
-8 17 -76 20 -150z m1233 99 c0 -49 -71 -74 -108 -37 -23 24 -19 38 18 65 53
39 90 28 90 -28z m-7292 -69 c50 -41 69 -77 63 -119 -14 -95 -102 -89 -206 15
-103 103 -104 106 -49 166 44 50 69 42 192 -62z m-4972 46 c27 -20 89 -37 138
-37 296 -1 243 -128 -68 -161 -103 -11 -156 -8 -156 10 0 14 23 26 50 26 28 0
50 11 50 25 0 39 -97 29 -177 -18 -85 -50 -87 -61 -30 -152 73 -114 101 -133
168 -116 109 28 91 -125 -21 -191 -144 -85 -211 -242 -136 -317 20 -20 29
-178 29 -509 0 -436 -4 -482 -46 -513 -40 -29 -42 -41 -12 -96 36 -68 98 -80
173 -34 38 24 60 21 115 -18 38 -27 97 -68 132 -91 l64 -42 -67 -31 c-68 -30
-86 -26 -248 56 -65 33 -113 27 -169 -21 -64 -55 -64 -98 0 -114 63 -17 72
-254 13 -332 -25 -34 -37 -114 -37 -265 -1 -263 60 -349 262 -371 62 -7 110
-24 106 -37 -3 -14 -34 -22 -68 -17 -34 4 -96 1 -138 -7 -76 -14 -77 -17 -82
-177 l-5 -162 90 -37 c49 -21 99 -32 110 -25 11 7 28 1 36 -13 9 -14 -13 -36
-48 -49 -75 -29 -79 -46 -20 -91 40 -31 40 -33 -11 -34 -73 -1 -82 -22 -66
-146 11 -82 25 -105 62 -105 26 0 54 -16 61 -35 7 -19 35 -41 62 -48 26 -7 48
-33 48 -59 0 -29 29 -58 76 -76 64 -24 73 -38 60 -91 -14 -57 -6 -65 93 -92
111 -30 180 -57 246 -96 128 -76 175 -87 236 -54 49 27 91 27 212 3 245 -48
376 -7 377 117 0 76 45 71 65 -8 20 -80 108 -116 234 -96 77 13 106 5 148 -37
66 -66 120 -68 140 -5 8 26 42 66 76 87 59 39 62 38 77 -23 14 -57 27 -63 132
-59 63 3 211 -4 328 -14 127 -12 288 -9 399 7 199 28 221 20 216 -79 -2 -54
-5 -55 -615 -58 -337 -3 -716 -12 -842 -21 -208 -14 -235 -11 -279 33 -27 27
-59 40 -70 28 -29 -28 -377 -38 -479 -14 -54 13 -94 9 -119 -11 -27 -22 -45
-23 -70 -2 -19 16 -89 32 -156 37 -162 13 -273 57 -319 127 -22 33 -75 65
-121 74 -57 10 -101 43 -143 104 -33 49 -81 100 -106 113 -26 14 -46 52 -46
86 0 34 -22 85 -50 112 -27 28 -50 78 -50 112 0 34 -21 72 -47 86 -49 27 -83
138 -80 265 1 41 3 471 4 955 1 512 11 887 25 896 30 18 30 269 0 300 -33 35
-42 316 -11 374 18 32 20 110 7 225 -11 96 -24 353 -28 572 l-8 398 88 34 c48
19 104 45 125 57 50 31 55 30 111 -12z m2589 -86 c93 -81 107 -103 80 -131
-28 -27 -46 -18 -106 49 -40 44 -95 81 -122 81 -55 0 -88 38 -64 75 29 48 100
23 212 -74z m6388 37 c0 -59 -75 -80 -127 -37 -28 24 -30 39 -7 66 42 51 134
31 134 -29z m2312 -63 c0 -138 37 -216 110 -235 35 -8 77 -41 93 -72 17 -30
48 -69 70 -85 29 -22 32 -37 12 -58 -21 -21 -53 -11 -125 37 -57 39 -116 61
-146 53 -84 -22 -114 30 -114 199 0 160 39 296 79 271 11 -7 21 -57 21 -110z
m1260 110 c52 -20 51 -75 0 -95 -53 -20 -85 3 -85 61 0 51 20 59 85 34z m1104
-21 c45 -33 46 -37 5 -52 -53 -21 -169 5 -169 37 0 19 30 33 101 48 8 2 36
-13 63 -33z m1232 -47 c7 -63 15 -69 79 -54 62 13 77 5 112 -62 72 -140 -38
-179 -146 -51 -34 41 -78 75 -98 75 -50 0 -151 116 -131 150 10 15 53 24 97
20 65 -6 80 -19 87 -78z m-12896 9 c0 -69 -30 -78 -93 -27 -62 51 -51 76 35
76 41 0 58 -14 58 -49z m925 -175 c0 -27 -21 -63 -47 -81 -26 -18 -51 -54 -56
-81 -15 -73 -64 -74 -78 -1 -8 42 0 71 22 79 45 18 43 74 -3 92 -44 17 -49 74
-12 143 24 46 29 44 100 -28 41 -42 74 -97 74 -123z m4452 167 c-1 -10 -2 -70
-2 -135 0 -148 -14 -133 -33 38 -10 86 -6 130 11 124 14 -5 25 -17 24 -27z
m2944 -145 c-8 -74 -19 -86 -99 -102 -137 -28 -233 6 -242 87 -11 91 51 111
135 44 87 -68 98 -66 136 24 39 95 81 63 70 -53z m12437 8 c9 -65 16 -898 17
-1850 2 -1828 -3 -1905 -116 -2068 -19 -27 -34 -65 -34 -85 0 -60 -170 -295
-269 -371 -118 -91 -300 -207 -322 -207 -10 0 -37 -18 -61 -39 -24 -22 -109
-50 -190 -62 -188 -30 -1628 -52 -1644 -26 -7 11 -633 15 -1390 9 l-1378 -11
8 58 c8 52 20 58 115 52 77 -5 111 4 122 31 16 42 120 37 245 -11 40 -15 87
-23 104 -16 17 7 254 12 527 13 645 0 593 0 808 8 l188 7 7 93 c9 108 55 129
55 25 0 -88 61 -126 233 -146 154 -18 242 15 242 93 0 66 77 54 113 -19 57
-114 90 -134 225 -134 110 0 133 8 144 50 9 33 34 50 73 50 69 0 170 119 170
199 0 29 16 51 38 51 22 0 37 -23 37 -60 0 -74 130 -190 213 -190 32 0 66 -11
75 -25 24 -40 131 -29 237 25 54 28 112 50 128 50 53 0 122 80 122 141 0 41
18 63 63 74 69 17 137 -24 137 -83 0 -63 62 -19 70 51 10 80 53 86 112 17 91
-107 196 -43 186 114 -7 113 62 154 94 56 l19 -57 11 54 c6 30 -7 82 -29 115
-52 80 -5 122 125 114 146 -10 220 163 124 290 -28 36 -33 88 -21 215 12 129
6 187 -25 250 -82 163 -32 336 80 276 40 -21 51 -17 62 26 19 72 -6 125 -55
117 -104 -17 -110 37 -14 117 l96 80 -55 70 c-68 86 -68 100 -5 163 46 46 49
71 34 306 -19 309 -37 353 -132 332 -122 -27 -180 48 -161 206 19 157 58 168
136 37 31 -51 60 -98 64 -103 4 -6 25 4 46 21 54 45 47 145 -12 182 -63 39
-72 237 -12 260 26 10 37 52 37 148 0 111 9 139 52 162 49 26 51 42 35 202
-12 119 -8 184 12 208 22 27 22 60 -2 137 -25 84 -24 114 5 169 20 36 32 86
28 112 -5 25 2 46 15 46 13 0 30 -53 38 -119z m-4725 35 c25 -65 -19 -93 -81
-50 -45 32 -50 45 -23 62 49 31 89 27 104 -12z m-17401 -42 c34 -40 54 -45 92
-25 68 37 76 33 76 -30 -1 -91 -35 -129 -74 -83 -18 22 -67 39 -111 39 -51 0
-89 17 -110 51 -62 99 48 141 127 48z m7043 -52 c0 -12 -27 -28 -61 -36 -46
-12 -63 -35 -69 -95 -4 -43 -19 -73 -32 -66 -35 17 -20 138 27 229 37 73 40
74 87 32 26 -24 48 -53 48 -64z m-6747 34 c7 -85 -8 -269 -24 -293 -17 -26
-49 283 -34 318 15 36 55 19 58 -25z m-785 -56 c4 -21 -4 -54 -18 -75 -30 -45
-74 4 -75 83 0 55 84 48 93 -8z m1349 -46 c2 -36 12 -98 22 -137 17 -67 13
-70 -54 -63 -66 8 -72 16 -64 94 18 185 86 260 96 106z m11303 -12 c-6 -40
-23 -53 -65 -48 -81 8 -155 -36 -155 -93 0 -77 -48 -85 -75 -13 -45 118 -32
152 74 184 54 16 106 40 114 54 27 44 116 -25 107 -84z m568 -9 c75 -114 -32
-147 -179 -56 -100 62 -140 19 -76 -81 21 -32 52 -106 68 -164 34 -114 66
-115 176 -5 59 59 119 62 140 7 11 -28 -12 -67 -69 -120 -95 -87 -173 -196
-173 -242 0 -16 20 -44 44 -62 40 -30 38 -33 -23 -34 -37 -1 -85 -8 -106 -16
-54 -21 -51 38 4 83 24 19 32 40 19 46 -90 41 -95 54 -51 129 43 72 42 75 -20
142 -68 73 -85 157 -71 335 7 76 19 105 42 96 18 -7 52 2 77 20 56 41 142 8
198 -78z m3381 74 c13 -39 -115 -71 -149 -37 -14 14 -18 39 -8 54 23 37 143
23 157 -17z m-7619 -58 c31 -57 14 -99 -39 -99 -23 0 -36 26 -36 75 0 86 36
98 75 24z m1762 -34 c40 -21 56 -42 40 -51 -15 -10 -57 6 -93 34 -75 59 -47
69 53 17z m787 -13 c16 -31 17 -54 2 -64 -20 -13 -76 59 -76 98 0 33 50 10 74
-34z m-2724 -177 c0 -167 8 -208 50 -250 63 -63 63 -91 2 -124 -118 -63 -206
-13 -141 80 57 81 50 161 -17 179 -31 8 -85 38 -119 65 -58 47 -60 53 -19 84
24 19 44 53 44 76 0 42 76 86 156 88 38 2 44 -24 44 -198z m-4564 84 c49 -51
89 -101 89 -113 0 -30 -119 -26 -137 4 -9 14 -55 25 -102 25 -78 0 -86 7 -86
71 0 138 109 144 236 13z m1814 -28 c0 -59 -37 -71 -99 -32 -23 15 -49 13 -69
-3 -68 -57 -28 11 48 80 85 78 119 65 120 -45z m14812 78 c53 -52 39 -121 -25
-121 -38 0 -51 19 -57 81 -9 89 19 103 82 40z m-14162 -33 c40 -31 85 -43 129
-34 47 10 92 -5 150 -49 46 -34 99 -56 118 -49 19 7 45 -6 57 -28 27 -47 360
-216 426 -216 25 0 45 -11 45 -24 0 -42 90 -75 273 -101 98 -14 197 -34 221
-46 24 -11 91 -45 148 -75 58 -30 144 -54 191 -54 47 0 98 -15 113 -33 20 -24
100 -31 297 -28 430 8 412 5 396 57 -9 27 1 60 22 78 33 28 33 40 -2 107 -32
62 -33 79 -5 96 40 25 146 -67 146 -127 0 -23 28 -55 63 -70 92 -43 75 -80
-37 -80 -54 0 -105 -11 -113 -25 -10 -16 41 -25 136 -25 114 0 156 -10 167
-39 19 -47 4 -64 -57 -64 -714 -3 -1169 9 -1221 32 -48 22 -86 21 -164 -4 -76
-25 -108 -26 -129 -5 -22 22 -10 33 50 45 107 22 101 54 -14 73 -51 9 -150 39
-218 67 -69 29 -187 68 -263 87 -76 19 -171 44 -212 56 -80 21 -247 112 -319
172 -28 24 -69 31 -118 21 -42 -8 -76 -5 -76 7 0 55 -325 182 -475 185 -121 3
-150 11 -144 42 5 26 44 40 132 45 68 5 135 19 148 31 35 35 69 29 139 -25z
m-3850 -25 c0 -26 -13 -56 -28 -65 -34 -21 -72 35 -55 80 20 52 83 40 83 -15z
m-359 -66 c70 -74 92 -85 122 -59 51 41 47 -4 -7 -99 -24 -42 -62 -77 -84 -77
-23 0 -47 -23 -54 -50 -9 -32 -27 -45 -51 -36 -63 24 -73 89 -17 104 72 19 72
194 -1 232 -28 15 -44 38 -36 51 23 38 38 30 128 -66z m5578 45 c15 -45 -64
-65 -109 -28 -36 30 -35 35 6 51 58 23 90 15 103 -23z m7738 -4 c19 -73 -44
-115 -120 -80 -104 47 -78 129 39 129 47 0 72 -16 81 -49z m942 -70 c1 -17
-27 -31 -61 -31 -69 0 -78 26 -36 104 26 48 28 48 62 4 19 -25 35 -60 35 -77z
m-13240 45 c12 -12 15 -42 6 -65 -14 -36 -38 -40 -159 -26 -183 22 -215 53
-104 102 85 38 213 33 257 -11z m7119 18 c21 -17 56 -61 78 -97 23 -37 73 -71
115 -80 111 -22 142 -167 36 -167 -22 0 -77 28 -122 63 -57 43 -108 61 -165
56 -82 -6 -82 -6 -74 94 9 95 40 162 77 162 10 0 34 -14 55 -31z m4095 -29
c16 -20 36 -76 44 -125 8 -50 24 -90 36 -90 12 0 22 -11 22 -25 0 -14 -28 -25
-62 -25 -38 0 -77 -23 -101 -60 -37 -56 -116 -86 -261 -97 -70 -6 -122 92 -90
173 16 42 21 40 54 -22 60 -114 126 -66 196 141 60 181 96 209 162 130z
m-10516 -156 c33 -28 86 -105 117 -170 32 -65 73 -124 93 -132 19 -7 57 -56
84 -109 76 -150 62 -245 -30 -196 -35 19 -57 16 -85 -12 -51 -52 -102 -26
-135 67 -21 62 -19 85 10 115 40 40 34 46 77 -89 10 -31 21 -34 42 -13 53 53
-22 217 -112 244 -53 16 -85 47 -104 100 -50 145 -150 245 -210 213 -70 -37
-194 74 -142 127 23 22 334 -92 395 -145z m5524 22 c19 -23 13 -47 -21 -84
-26 -29 -47 -88 -47 -130 0 -84 -47 -111 -113 -66 -32 22 -31 30 12 62 42 33
45 48 21 111 -22 59 -21 80 7 103 19 16 35 49 35 74 0 64 61 76 71 14 5 -29
21 -67 35 -84z m2537 38 c42 -156 -9 -204 -102 -94 -77 92 -83 138 -22 173 74
43 95 31 124 -79z m8922 1 c2 -51 17 -127 35 -170 36 -88 12 -130 -94 -162
-52 -15 -56 -9 -56 94 0 213 29 346 72 338 28 -6 41 -37 43 -100z m-19048 49
c11 -17 20 -114 20 -215 0 -138 10 -190 40 -212 22 -16 47 -60 57 -98 15 -62
10 -69 -49 -69 -90 0 -68 -112 66 -342 97 -166 123 -258 75 -258 -13 0 -36 22
-50 48 -14 27 -48 55 -74 64 -107 34 -202 293 -155 419 15 38 13 76 -5 108
-15 27 -30 82 -33 124 -3 41 -13 140 -23 219 -21 176 65 315 131 212z m9001
-4 c11 -19 63 -52 115 -74 125 -52 125 -149 0 -161 -129 -13 -145 -55 -94
-244 26 -95 65 -178 93 -198 31 -22 50 -67 53 -130 4 -66 27 -119 76 -170 39
-42 86 -112 105 -157 26 -61 50 -81 99 -81 36 0 93 -22 128 -50 94 -74 114
-63 95 50 -15 83 -10 100 24 100 58 0 138 -46 138 -80 0 -15 27 -86 61 -157
61 -129 125 -178 299 -229 106 -31 108 -79 6 -122 -72 -30 -103 -31 -159 -7
-62 27 -276 181 -307 222 -26 35 -214 123 -262 124 -28 0 -82 33 -121 72 -39
40 -109 79 -156 88 -47 9 -86 27 -86 40 0 13 -44 24 -99 24 -129 0 -141 28
-62 147 l65 99 -52 72 c-59 78 -59 85 -40 531 7 171 13 315 13 319 0 22 51 2
68 -28z m2607 23 c0 -78 -216 -153 -274 -97 -22 21 60 58 129 59 37 0 74 11
83 25 15 26 62 35 62 13z m2200 -64 c0 -53 -37 -66 -63 -23 -23 37 7 105 38
87 14 -9 25 -38 25 -64z m-11391 -95 c22 -148 166 -249 166 -116 0 34 11 62
25 62 23 0 17 -69 -14 -170 -20 -62 62 -180 124 -180 32 0 74 -18 92 -40 24
-29 57 -35 122 -24 115 20 555 15 826 -8 117 -10 245 -12 286 -4 86 18 118 76
40 76 -60 0 -96 65 -56 105 14 14 20 42 13 61 -18 46 77 45 115 -1 17 -20 22
-63 13 -100 -15 -61 -11 -65 75 -65 50 0 120 19 155 42 62 41 66 40 107 -14
23 -31 68 -69 100 -86 140 -71 55 -80 -846 -86 -501 -3 -916 -12 -923 -19 -7
-7 1 -27 18 -44 22 -22 194 -31 648 -33 720 -2 742 -3 658 -37 -32 -13 -286
-22 -562 -20 -277 2 -580 -5 -672 -15 -187 -21 -244 2 -244 98 0 34 -37 85
-94 131 -154 125 -315 483 -270 600 23 62 81 -5 98 -113z m-3734 84 c80 -97
-49 -210 -196 -171 -61 16 -75 108 -16 108 20 0 37 -11 37 -25 0 -14 11 -25
25 -25 14 0 25 26 25 58 0 96 66 125 125 55z m15307 -100 c-51 -71 -82 -80
-82 -24 0 67 84 162 107 121 13 -21 3 -59 -25 -97z m-8280 45 c30 -81 21 -188
-17 -201 -41 -13 -93 131 -75 205 21 82 60 80 92 -4z m-6119 -58 c40 0 63 -75
23 -75 -10 -1 -42 -7 -70 -15 -39 -10 -59 3 -82 53 -38 84 -13 128 44 76 24
-21 62 -39 85 -39z m11002 53 c15 -24 -43 -356 -70 -400 -25 -40 -115 -35
-115 7 0 19 20 42 44 52 40 15 38 21 -13 63 -71 58 -79 200 -12 200 24 0 58
23 75 50 33 53 69 64 91 28z m4190 -54 c0 -27 -17 -49 -37 -49 -38 0 -53 77
-22 108 26 26 59 -7 59 -59z m-10590 36 c80 -31 47 -110 -46 -110 -119 0 -144
67 -39 107 21 8 39 15 42 16 2 1 22 -5 43 -13z m2740 -47 c0 -46 -13 -63 -50
-63 -61 0 -63 19 -9 79 54 60 59 58 59 -16z m1245 -27 c42 -21 85 -63 95 -93
21 -69 125 -168 176 -168 74 0 17 -63 -64 -71 -89 -8 -137 30 -249 195 -32 49
-75 97 -94 108 -109 64 14 90 136 29z m4999 -5 c6 -19 -14 -31 -53 -31 -65 0
-102 30 -73 60 27 26 114 6 126 -29z m-8683 -29 c41 -46 41 -49 -11 -77 -68
-36 -125 -16 -125 45 0 91 68 107 136 32z m5216 22 c62 -33 61 -79 -3 -119
-63 -39 -99 -20 -99 55 0 89 25 105 102 64z m2062 -189 c21 -131 -37 -166
-119 -72 -37 43 -69 57 -108 47 -60 -15 -108 54 -66 96 140 140 264 110 293
-71z m-10464 141 c0 -62 -65 -154 -118 -167 -87 -22 -88 -5 -2 98 76 91 120
117 120 69z m364 -32 c9 -31 46 -81 83 -111 57 -48 62 -61 34 -106 -17 -28
-31 -67 -31 -86 0 -35 150 -165 224 -194 24 -9 -5 -24 -74 -38 -114 -24 -896
-21 -921 3 -42 43 70 68 312 72 l272 4 -10 256 c-8 244 -6 256 43 256 31 0 57
-22 68 -56z m11924 31 c48 -19 63 -40 57 -81 -11 -81 -100 -85 -183 -8 -38 35
-85 64 -105 64 -19 0 -28 11 -19 25 19 32 165 32 250 0z m-2384 -41 c60 -54
58 -84 -4 -84 -27 0 -50 10 -50 23 0 13 -7 41 -15 62 -20 52 12 51 69 -1z
m3781 -21 c37 -35 78 -63 91 -63 12 0 41 -28 63 -62 34 -51 50 -57 89 -36 61
32 97 10 98 -60 1 -86 54 -135 188 -174 75 -22 127 -52 132 -77 9 -49 -72 -56
-154 -11 -30 16 -94 36 -142 44 -59 10 -90 30 -96 62 -5 26 -93 131 -194 233
-102 102 -185 190 -185 196 0 27 50 4 110 -52z m-15940 -37 c57 -77 74 -176
29 -176 -14 0 -37 30 -51 67 -32 84 -83 43 -74 -59 4 -39 8 -307 10 -595 2
-289 12 -538 22 -553 32 -50 223 -61 297 -17 62 37 73 37 129 0 74 -48 111
-166 63 -196 -52 -33 -191 -25 -213 12 -12 20 -88 40 -193 49 -95 9 -180 28
-190 43 -69 112 -45 1266 29 1389 25 42 39 85 30 94 -9 9 0 16 21 16 20 0 61
-33 91 -74z m292 -1 c21 -93 63 -123 63 -45 1 68 40 138 64 114 9 -9 4 -52
-11 -96 -15 -44 -28 -95 -28 -113 0 -44 95 -70 135 -37 25 21 41 18 65 -10 25
-31 24 -38 -7 -38 -69 0 -72 -73 -3 -90 53 -14 60 -27 48 -82 -9 -41 0 -86 23
-116 21 -27 38 -86 38 -131 1 -77 -4 -81 -93 -83 -85 -1 -89 -4 -37 -29 31
-14 56 -46 56 -70 0 -47 64 -84 104 -59 48 30 283 -92 352 -183 84 -110 85
-132 9 -215 -76 -81 -190 -116 -190 -57 0 22 17 40 38 40 74 0 34 51 -101 128
-132 74 -212 172 -212 258 0 22 -21 39 -49 39 -27 0 -79 28 -116 63 -37 34
-76 62 -87 62 -39 0 -68 168 -67 385 1 180 -7 226 -40 245 -53 29 -57 195 -5
195 19 0 42 -34 51 -75z m20155 11 c20 -54 -32 -106 -70 -68 -32 32 -12 107
28 107 15 0 33 -18 42 -39z m-21767 -10 c0 -12 -13 -31 -28 -40 -17 -11 -23
-60 -16 -126 12 -104 -24 -183 -65 -143 -34 34 -16 242 25 287 45 50 84 60 84
22z m7286 -41 c9 -36 11 -71 4 -78 -19 -19 -65 18 -65 53 0 18 -25 45 -56 59
-54 26 -53 28 22 29 65 2 82 -10 95 -63z m12914 -115 c0 -144 48 -297 164
-528 48 -94 45 -117 -11 -117 -65 0 -126 102 -144 244 -9 65 -27 132 -40 150
-30 37 -57 337 -35 393 31 82 66 7 66 -142z m-8618 89 c11 -19 42 -34 68 -34
62 0 86 -41 35 -60 -117 -45 -285 14 -285 99 0 68 142 64 182 -5z m542 6 c34
-88 68 -101 282 -104 133 -1 207 -14 237 -40 36 -31 109 -37 369 -32 179 3
344 -4 367 -16 61 -33 236 34 226 86 -4 23 4 41 17 41 13 0 43 7 66 16 32 13
40 3 33 -43 -7 -52 5 -63 98 -82 111 -24 136 -54 62 -76 -24 -7 -432 -11 -906
-9 l-862 3 -80 -79 c-91 -92 -117 -97 -163 -36 -18 24 -65 44 -107 44 -60 0
-77 12 -84 58 -8 60 5 61 140 10 17 -6 31 4 31 24 0 70 53 94 116 53 48 -31
67 -33 97 -8 38 32 51 100 18 101 -10 0 -47 22 -81 49 -53 42 -57 53 -25 74
64 43 125 29 149 -34z m-11211 -209 c-8 -31 -25 -56 -38 -56 -29 0 -34 257 -6
285 25 26 61 -160 44 -229z m14161 179 c56 -22 94 -50 87 -63 -27 -43 -128
-21 -186 41 -68 72 -41 78 99 22z m3992 -77 c-30 -30 -73 37 -54 84 17 42 20
41 45 -11 14 -31 18 -64 9 -73z m-11984 38 c29 -15 71 -50 92 -75 30 -37 70
-47 176 -45 76 1 177 3 225 4 126 1 531 -27 542 -39 16 -16 -633 -41 -879 -35
-221 6 -226 8 -229 69 -2 34 -12 82 -21 106 -21 51 15 57 94 15z m8293 -8 c0
-24 -24 -38 -62 -38 -39 0 -63 14 -63 38 0 23 24 37 63 37 38 0 62 -14 62 -37z
m255 -44 c6 -48 26 -58 137 -70 72 -7 137 -20 147 -29 17 -18 -160 -60 -201
-47 -14 4 -357 12 -762 18 -404 5 -741 16 -747 22 -7 7 80 12 193 12 124 0
239 15 293 37 78 33 98 33 159 1 54 -28 131 -33 329 -23 338 17 372 25 372 85
0 69 70 63 80 -6z m5190 -79 c-4 -27 -22 -53 -39 -59 -43 -14 -65 55 -44 138
17 67 18 67 53 19 21 -28 34 -72 30 -98z m-10557 39 c129 -40 212 -86 212
-118 0 -71 93 -189 186 -235 61 -31 110 -78 131 -128 37 -89 117 -88 215 3 56
52 93 63 93 27 0 -29 -169 -178 -201 -178 -13 0 -24 -17 -24 -37 0 -21 21 -38
46 -38 80 0 193 -122 151 -162 -61 -60 -134 -57 -142 6 -5 31 -19 56 -32 56
-13 0 -35 27 -47 60 -13 33 -53 81 -90 106 -86 60 -138 110 -336 329 -98 109
-182 180 -212 180 -28 0 -83 17 -122 38 -39 20 -92 37 -116 37 -44 0 -84 58
-58 84 18 18 254 -2 346 -30z m10687 -16 c0 -38 -14 -63 -35 -63 -40 0 -63 47
-46 94 21 57 81 33 81 -31z m-4366 0 c11 -30 50 -35 189 -26 100 7 181 1 190
-13 8 -13 6 -24 -5 -25 -77 -3 -696 -4 -806 -2 -162 4 -147 38 19 45 220 10
326 22 344 40 29 28 53 21 69 -19z m-5882 -102 c53 -65 -48 -113 -127 -60 -32
22 -31 30 11 62 61 47 75 46 116 -2z m7849 -27 c18 -46 17 -75 -4 -100 -16
-19 -23 -71 -16 -115 17 -110 0 -155 -45 -118 -21 18 -29 55 -20 98 8 38 1 95
-15 125 -24 44 -22 66 10 115 50 77 59 76 90 -5z m889 22 c46 -149 85 -203
152 -210 55 -7 77 -28 100 -96 28 -81 30 -71 32 133 1 194 6 220 44 212 51 -9
76 -90 80 -251 2 -97 13 -125 65 -159 111 -73 69 -210 -48 -156 -56 25 -79 24
-122 -2 -48 -31 -60 -25 -137 63 -46 54 -94 123 -107 154 -12 31 -40 56 -62
56 -51 0 -120 165 -101 241 17 69 84 79 104 15z m1908 3 c6 -5 -14 -35 -44
-67 -30 -32 -54 -74 -54 -94 -1 -30 -5 -29 -25 2 -28 43 -33 159 -8 184 15 15
106 -2 131 -25z m-20659 -171 c-1 -97 -12 -160 -26 -155 -14 5 -23 75 -21 157
6 174 3 160 29 160 11 0 19 -73 18 -162z m9230 98 c124 -26 46 -61 -134 -61
-138 0 -186 8 -179 31 19 56 132 66 313 30z m-2333 -9 c28 -45 -47 -61 -260
-56 -404 11 -372 70 41 76 113 2 212 -7 219 -20z m1680 -7 c17 -29 -40 -73
-71 -54 -11 6 -341 12 -733 12 -600 0 -712 5 -712 35 0 45 1488 51 1516 7z
m3859 5 c72 -1 80 -6 43 -27 -36 -21 -423 -18 -468 4 -24 11 238 41 288 32 27
-4 89 -9 137 -9z m713 -12 c0 -32 -345 -48 -463 -22 l-87 19 125 17 c178 23
425 15 425 -14z m732 12 c82 0 127 -10 118 -25 -20 -31 -530 -33 -549 -2 -23
37 40 52 174 39 68 -6 184 -12 257 -12z m693 -5 c22 -21 -53 -38 -242 -54
-105 -9 -146 -3 -155 22 -7 19 -1 38 15 43 48 16 364 7 382 -11z m533 8 c46
-29 -43 -51 -137 -34 -62 12 -65 16 -21 33 67 26 118 26 158 1z m5029 -40 c42
-51 117 -48 147 6 39 70 54 24 23 -75 -22 -74 -20 -102 10 -149 46 -71 32
-120 -35 -120 -43 0 -49 -11 -37 -73 10 -48 3 -83 -21 -103 -59 -49 -112 -9
-112 83 0 58 -20 103 -65 145 -54 50 -63 76 -52 155 19 147 81 204 142 131z
m725 -28 c0 -78 -59 -69 -70 11 -6 36 5 54 31 54 25 0 39 -23 39 -65z m-18176
-76 c33 -10 33 -14 0 -35 -44 -28 -168 -28 -236 0 -120 49 93 81 236 35z m176
-36 c0 -61 -58 -52 -71 10 -4 25 8 42 32 42 23 0 39 -21 39 -52z m375 -10 c17
-21 47 -38 66 -38 47 0 43 -41 -7 -60 -33 -13 -38 -38 -25 -132 11 -75 6 -128
-14 -152 -38 -45 33 -106 122 -106 40 0 58 -15 58 -47 0 -55 -83 -85 -123 -45
-19 19 -35 19 -57 -3 -35 -35 -7 -71 65 -84 61 -11 110 -87 77 -117 -14 -13
-271 -16 -593 -7 -312 9 -605 8 -650 -1 -103 -22 -273 28 -263 77 12 63 168
87 264 41 104 -50 130 -35 130 76 0 102 68 147 111 74 75 -126 104 -145 240
-153 227 -13 233 -8 213 189 -11 116 -8 176 11 188 42 25 46 14 54 -172 8
-175 22 -201 109 -206 27 -1 66 -7 87 -13 31 -8 38 30 41 228 2 131 5 297 6
369 3 135 23 159 78 94z m2306 -4 c38 -7 69 -23 69 -35 0 -25 -537 -20 -563 6
-69 68 205 85 494 29z m3639 -15 c20 -17 55 -31 77 -31 22 0 37 -16 33 -34
-11 -53 47 -107 97 -91 46 15 114 -142 83 -192 -26 -43 -80 -19 -95 42 -13 52
-27 60 -78 47 -49 -12 -80 4 -155 83 -52 53 -114 105 -138 114 -45 17 -58 70
-25 103 24 25 154 -2 201 -41z m6669 29 c9 -14 12 -30 7 -35 -18 -18 -246 19
-246 40 0 32 219 27 239 -5z m916 -103 c-44 -75 -87 -80 -101 -11 -10 53 101
149 126 109 9 -16 -2 -60 -25 -98z m-12777 47 c38 -85 164 -155 210 -117 44
37 200 -8 222 -64 7 -20 31 -36 52 -36 21 0 38 -17 38 -37 0 -21 12 -38 26
-38 14 0 47 -49 73 -110 26 -60 62 -116 80 -124 24 -11 23 -14 -4 -9 -85 13
-392 206 -453 284 -56 71 -70 78 -96 48 -49 -59 -151 1 -151 90 0 52 -12 71
-46 71 -63 0 -84 27 -51 66 41 49 69 42 100 -24z m399 32 c62 -33 39 -74 -41
-74 -57 0 -82 46 -44 83 22 22 28 22 85 -9z m3241 10 c71 -19 49 -59 -32 -59
-38 0 -61 14 -61 38 0 41 11 43 93 21z m5301 -9 c68 0 25 -49 -58 -64 -100
-19 -124 -6 -101 53 11 29 33 37 72 27 30 -9 70 -15 87 -16z m-9096 -40 c22
-22 -98 -110 -151 -110 -26 0 -47 -8 -47 -19 1 -34 174 -131 235 -131 82 0
143 -25 126 -53 -22 -35 -197 -25 -250 15 -27 20 -73 37 -103 37 -103 2 -133
28 -133 116 0 55 12 85 34 85 18 0 54 23 80 52 45 49 164 54 209 8z m1052 14
c0 -13 -55 -24 -122 -24 -78 0 -133 -14 -153 -37 -44 -53 -100 -47 -100 10 0
38 20 51 94 57 215 18 281 16 281 -6z m1936 -27 c-18 -29 -104 -28 -122 1 -16
26 57 48 105 32 17 -6 24 -20 17 -33z m1337 12 c6 -5 -51 -9 -125 -9 -97 1
-125 8 -98 25 33 21 194 10 223 -16z m3927 19 c0 -35 -76 -56 -135 -37 -52 16
-52 17 -2 36 69 27 137 27 137 1z m1341 -53 c53 -47 113 -75 158 -75 93 0 102
-18 60 -119 -37 -88 -101 -107 -126 -37 -19 54 -84 131 -110 131 -53 0 -131
-157 -101 -204 38 -61 58 -572 24 -613 -13 -16 -41 -24 -60 -16 -29 11 -36 79
-36 332 0 365 -26 476 -112 476 -32 0 -62 -14 -67 -31 -23 -82 -7 -872 19
-889 55 -35 88 -125 54 -147 -43 -26 -576 -26 -739 1 -87 14 -171 12 -245 -7
-145 -37 -244 4 -255 104 -10 81 42 93 110 25 42 -42 342 -68 429 -37 62 22
32 95 -50 120 -75 21 -82 33 -89 136 -6 101 2 122 81 199 61 59 89 108 89 157
0 42 11 65 25 57 14 -9 25 -38 25 -65 0 -27 13 -70 29 -96 25 -39 19 -60 -39
-129 -164 -194 70 -462 325 -373 126 44 227 284 148 350 -51 42 -49 199 2 236
37 27 34 44 -27 173 -75 160 -70 216 23 216 73 0 189 49 189 79 0 12 31 14 69
5 63 -16 66 -14 33 26 -32 38 -32 47 0 67 55 34 72 29 164 -52z m597 50 c9
-16 -43 -24 -143 -22 -125 2 -142 7 -82 22 111 28 207 28 225 0z m1483 3 c24
-15 9 -25 -50 -34 -95 -14 -152 1 -132 34 18 28 138 28 182 0z m2576 -253 c-3
-145 -15 -226 -40 -254 -66 -76 -31 -133 81 -133 96 0 100 3 107 87 12 155 35
168 65 38 l28 -125 125 -16 c68 -9 185 -5 258 8 123 21 140 19 194 -33 110
-102 35 -160 -108 -83 -84 45 -89 45 -120 2 -31 -43 -34 -43 -57 0 -21 37 -31
39 -65 11 -30 -25 -74 -27 -196 -7 -86 14 -214 22 -284 18 l-127 -8 5 204 c3
112 7 284 9 382 l3 179 63 -29 c60 -27 62 -37 59 -241z m-18747 63 c0 -106 -9
-138 -37 -138 -39 0 -57 222 -21 258 41 42 58 7 58 -120z m1490 106 c21 -17
57 -51 80 -75 23 -24 60 -44 84 -44 70 0 83 -55 24 -102 -47 -39 -67 -41 -160
-14 -101 29 -106 35 -107 130 -2 143 11 160 79 105z m1585 -14 c0 -46 106
-130 163 -130 67 0 70 -11 45 -162 -15 -89 -19 -93 -32 -38 -15 60 -24 63
-277 78 -303 18 -274 12 -274 59 0 50 95 98 133 68 16 -13 55 -32 86 -41 51
-16 56 -10 52 54 -3 39 3 85 13 101 21 35 91 42 91 11z m10381 -30 c46 -43 47
-50 11 -50 -24 0 -118 -34 -209 -75 -90 -41 -191 -75 -224 -75 -66 0 -159 80
-159 138 0 37 9 39 309 52 66 2 133 17 148 32 39 39 62 35 124 -22z m-4281
-18 c181 -18 202 -37 184 -169 -12 -88 -5 -117 38 -160 29 -29 53 -64 53 -78
0 -39 -90 -30 -125 13 -17 20 -52 37 -77 37 -26 0 -63 32 -85 73 -20 41 -60
81 -88 89 -27 9 -50 27 -50 39 0 13 -29 42 -66 66 -62 41 -67 40 -98 -3 -22
-29 -52 -41 -87 -32 -34 9 -67 -3 -94 -34 -23 -26 -53 -48 -68 -48 -44 0 -194
168 -176 198 21 34 127 35 189 2 32 -17 52 -17 64 2 9 15 54 21 107 12 50 -8
108 -3 129 10 21 14 54 19 75 11 21 -8 99 -20 175 -28z m-3798 -8 c58 -31 63
-95 9 -115 -40 -16 -109 53 -110 110 -1 38 36 40 101 5z m1362 -1 c26 -42 -1
-53 -167 -63 -160 -10 -259 26 -192 69 48 30 339 26 359 -6z m1060 -3 c37 -24
95 -24 256 -1 292 40 350 25 340 -91 -10 -119 -127 -138 -140 -22 -9 74 -48
92 -70 33 -18 -45 -496 -38 -542 8 -15 15 -54 28 -85 28 -81 0 -72 44 11 57
133 20 182 18 230 -12z m6956 -17 c10 -9 -12 -37 -50 -62 -68 -46 -68 -47 -68
-350 0 -331 -19 -441 -74 -441 -66 0 -87 208 -56 544 19 201 17 209 -44 266
-35 32 -63 64 -63 71 0 18 333 -8 355 -28z m2015 -47 c9 -88 -49 -137 -102
-84 -15 15 -64 28 -109 28 -107 0 -133 46 -36 66 42 8 89 31 106 51 53 64 133
30 141 -61z m2246 30 c47 -72 20 -122 -57 -107 -49 10 -73 75 -49 135 20 54
59 44 106 -28z m-11727 12 c26 -42 -28 -80 -86 -61 -74 23 -68 88 8 88 34 0
69 -12 78 -27z m7886 4 c0 -32 -67 -48 -199 -49 -122 0 -159 13 -137 49 18 30
336 30 336 0z m-4740 -109 c25 -39 -61 -168 -112 -168 -27 0 -53 170 -35 228
15 45 22 47 69 15 29 -19 64 -53 78 -75z m10081 35 c44 -59 17 -78 -67 -49
-83 29 -110 59 -86 97 21 33 116 4 153 -48z m-14316 15 c138 -49 154 -64 124
-120 -34 -63 -64 -61 -151 12 -39 33 -85 65 -102 70 -16 6 -22 24 -11 40 22
37 31 37 140 -2z m13153 -51 c16 -61 12 -67 -54 -67 -92 0 -115 40 -60 102 56
62 91 51 114 -35z m-13503 -4 c0 -20 -13 -43 -28 -52 -39 -25 -75 43 -43 82
31 37 71 20 71 -30z m15675 0 c0 -66 -37 -79 -100 -37 -32 22 -31 30 11 62 68
52 89 46 89 -25z m-14806 3 c17 -10 31 -35 31 -54 0 -84 189 -212 314 -212 53
0 61 -11 61 -87 0 -97 -69 -119 -183 -59 -58 31 -267 237 -267 264 0 39 -88
107 -140 107 -65 0 -101 39 -54 59 42 17 200 6 238 -18z m-1056 -25 c23 -104
96 -191 159 -191 39 0 86 -17 103 -37 36 -44 189 -51 215 -10 9 16 -1 39 -24
52 -50 28 -54 95 -5 95 19 0 87 -39 150 -87 127 -98 158 -106 199 -50 25 34
40 32 135 -13 128 -62 116 -111 -23 -93 -53 7 -102 4 -109 -6 -7 -11 -145 -17
-306 -13 -208 4 -319 -4 -379 -28 -98 -41 -218 -46 -240 -10 -9 14 -43 25 -77
25 -43 0 -61 14 -61 47 0 64 91 84 178 39 117 -60 125 -41 25 64 -103 108
-128 120 -128 63 0 -21 -17 -38 -37 -38 -43 0 -51 64 -11 88 14 9 37 45 50 79
20 54 33 60 104 45 45 -10 82 -19 82 -21z m7122 19 c22 -9 40 -26 40 -39 0
-35 -107 -14 -119 23 -11 34 18 40 79 16z m7336 -48 c60 -34 125 -62 144 -62
19 0 50 -37 69 -81 19 -45 75 -142 125 -215 50 -74 91 -137 91 -142 0 -35 170
-187 209 -187 27 0 80 -37 118 -81 67 -81 68 -81 121 -33 53 48 54 48 109 -8
55 -55 55 -56 7 -92 -32 -24 -77 -31 -132 -21 -55 10 -82 6 -82 -14 0 -40 154
-177 180 -160 37 23 91 -40 194 -228 55 -99 140 -222 188 -273 92 -97 104
-127 64 -152 -50 -30 -141 18 -201 106 -35 50 -175 204 -312 341 -307 305
-344 356 -305 418 41 66 -13 119 -72 71 -55 -46 -117 31 -95 118 21 85 -34
141 -123 123 -79 -16 -168 20 -168 67 0 17 -51 80 -112 140 -77 75 -113 130
-113 175 0 36 -23 99 -50 141 -88 133 -33 152 146 49z m-8840 -73 c38 -60 66
-135 63 -167 -7 -65 64 -92 129 -49 30 19 31 30 4 63 -28 32 -27 39 2 39 21 0
48 -49 67 -119 18 -65 43 -138 56 -163 59 -108 -135 -83 -243 32 -39 41 -90
75 -113 75 -51 0 -112 234 -86 335 22 88 41 81 121 -46z m-10709 52 c22 -26
20 -42 -8 -65 -46 -38 -89 -13 -89 50 0 57 56 65 97 15z m7284 -103 c71 -130
78 -350 13 -432 -30 -37 -219 -42 -219 -6 0 14 26 25 59 25 72 0 127 154 102
285 -13 72 -32 91 -126 127 -161 62 -137 140 40 129 47 -3 79 -34 131 -128z
m2103 75 c21 -21 54 -38 74 -38 21 0 65 -48 100 -106 34 -59 104 -144 156
-189 66 -58 86 -90 67 -109 -38 -38 -177 13 -270 101 -57 53 -88 66 -118 50
-27 -16 -46 -12 -60 13 -11 19 -49 39 -83 44 -65 9 -102 104 -58 148 42 42
133 -5 133 -69 0 -49 11 -60 56 -53 81 11 88 89 9 109 -75 19 -126 73 -103
110 22 36 53 33 97 -11z m5986 -44 c5 -38 -4 -69 -18 -69 -15 0 -27 12 -27 26
0 14 -28 36 -62 49 -90 34 -78 80 18 70 68 -6 83 -19 89 -76z m2589 -299 c-19
-31 -77 -24 -90 11 -6 17 1 108 15 202 l27 170 30 -181 c17 -100 25 -191 18
-202z m-3319 293 c-12 -45 -2 -75 35 -106 66 -57 63 -82 -11 -82 -34 0 -72
-18 -84 -41 -13 -22 -38 -35 -57 -29 -47 15 -31 218 21 276 60 67 115 57 96
-18z m1232 -54 c-38 -46 -88 -43 -107 7 -28 71 34 118 88 68 36 -32 40 -50 19
-75z m-2987 76 c46 -18 54 -99 13 -124 -39 -24 -108 52 -90 100 17 44 22 45
77 24z m2734 -29 c13 -41 -65 -70 -99 -36 -14 14 -18 38 -8 54 22 36 93 24
107 -18z m481 8 c0 -47 -43 -72 -92 -53 -31 12 -33 22 -8 52 40 47 100 48 100
1z m691 -6 c61 -40 62 -44 19 -75 -98 -72 -255 -5 -185 80 40 48 87 47 166 -5z
m-12974 -70 c112 -116 264 -163 331 -102 53 47 127 37 178 -25 45 -54 15 -70
-145 -74 -79 -2 -200 -12 -268 -22 -185 -26 -297 45 -258 165 15 45 31 97 36
114 12 48 35 38 126 -56z m12594 64 c8 -13 3 -31 -12 -40 -37 -23 -106 7 -87
38 20 31 80 33 99 2z m1240 -46 c13 -38 42 -100 63 -137 35 -63 35 -71 0 -84
-72 -28 -121 10 -103 80 12 47 4 74 -26 97 -26 18 -37 47 -27 72 23 62 65 49
93 -28z m3067 -80 c8 -58 29 -111 48 -118 19 -7 34 -42 34 -76 0 -63 0 -63
-169 -43 -93 11 -230 21 -306 23 -263 6 -318 62 -187 188 99 97 149 88 201
-37 36 -87 61 -105 95 -71 9 10 53 18 98 19 76 1 81 7 88 102 14 203 72 211
98 13z m-12664 55 c44 -111 55 -431 15 -431 -70 0 -94 62 -94 240 0 252 28
319 79 191z m291 -187 c-6 -186 -15 -231 -45 -231 -37 0 -43 297 -9 418 33
118 60 25 54 -187z m-735 162 c21 -71 2 -381 -24 -386 -44 -9 -80 301 -46 390
20 53 53 51 70 -4z m2603 -71 c123 -123 132 -168 34 -180 -70 -8 -126 43 -195
179 -81 159 2 160 161 1z m3500 -110 c0 -196 -4 -212 -50 -212 -46 0 -51 17
-54 187 -5 225 2 256 60 245 37 -7 44 -38 44 -220z m1425 190 c104 -76 -78
-159 -248 -113 -102 29 -121 73 -31 73 33 0 74 17 91 38 39 47 126 48 188 2z
m2037 4 c0 -11 -17 -27 -37 -35 -21 -8 -38 -36 -38 -63 0 -40 -8 -43 -50 -21
-89 48 -65 140 38 140 48 0 87 -9 87 -21z m-7250 -34 c0 -48 173 -235 217
-235 18 0 25 -16 17 -37 -21 -56 -137 -44 -218 22 -60 50 -67 66 -44 110 37
68 35 80 -9 80 -21 0 -38 22 -38 50 0 28 17 50 38 50 20 0 37 -18 37 -40z
m7582 -41 c17 -103 -29 -143 -137 -121 -105 21 -115 65 -21 98 42 15 83 44 92
65 24 63 52 45 66 -42z m-9698 -219 c-13 -193 -10 -219 40 -281 66 -84 140
-88 201 -13 44 55 46 55 96 10 43 -39 64 -42 129 -20 56 20 94 19 138 -1 47
-21 86 -20 162 5 117 39 115 32 48 123 -54 72 -58 178 -7 195 40 13 139 -188
121 -245 -9 -27 -26 -48 -39 -48 -13 0 -23 -28 -23 -62 0 -65 79 -91 113 -38
23 38 219 32 206 -6 -6 -17 -32 -35 -59 -39 -26 -5 -83 -25 -126 -44 -91 -41
-150 -46 -170 -13 -8 12 -79 16 -158 9 -101 -9 -172 -1 -240 27 -53 23 -106
35 -117 28 -11 -7 -146 -18 -299 -23 -307 -12 -356 11 -253 120 29 31 53 75
53 97 0 22 31 62 68 89 61 45 67 64 62 182 -7 159 15 247 47 195 12 -19 15
-130 7 -247z m894 118 c-28 -28 -153 24 -153 64 0 83 62 97 118 26 31 -38 46
-79 35 -90z m6885 116 c31 -12 16 -25 -60 -51 -104 -35 -203 -14 -203 43 0 27
198 33 263 8z m712 -59 c0 -89 -86 -108 -112 -25 -21 64 2 100 63 100 38 0 49
-17 49 -75z m-7134 -69 c9 -38 45 -113 79 -167 49 -78 56 -107 34 -142 -16
-26 -18 -51 -5 -59 12 -7 30 -2 38 12 26 41 88 28 88 -19 0 -24 -17 -76 -38
-115 -50 -97 -47 -113 28 -142 35 -13 59 -38 54 -55 -20 -61 -203 -87 -519
-76 -172 6 -363 10 -425 8 -244 -8 -810 1 -821 12 -39 39 84 50 594 52 513 3
1002 26 1002 48 0 33 -140 279 -169 296 -44 26 -158 267 -140 297 7 11 36 14
65 5 42 -14 48 -9 34 28 -10 26 -3 53 15 65 53 33 68 25 86 -48z m2174 -19
c35 -35 75 -56 89 -47 30 19 74 -39 55 -71 -7 -12 -34 -14 -59 -6 -25 7 -53 2
-62 -12 -28 -46 -74 -27 -130 53 -95 136 -11 201 107 83z m-9390 -33 c39 -39
75 -103 79 -142 7 -57 25 -76 91 -93 99 -25 140 -112 116 -251 -13 -77 -7
-103 30 -131 43 -31 43 -37 6 -75 -49 -50 -134 -17 -159 61 -8 27 -40 52 -70
57 -64 9 -89 103 -42 159 23 28 23 44 -1 73 -17 21 -25 60 -18 87 16 60 -31
102 -138 124 -72 14 -82 27 -89 109 -7 86 -3 93 58 93 39 0 95 -29 137 -71z
m14513 21 c0 -20 -20 -41 -44 -45 -31 -6 -44 7 -44 45 0 38 13 51 44 45 24 -4
44 -25 44 -45z m262 15 c0 -19 -18 -41 -40 -50 -57 -22 -60 -20 -60 35 0 33
17 50 50 50 28 0 50 -16 50 -35z m-16500 -44 c0 -12 -65 -17 -144 -11 -203 17
-209 21 -68 38 139 17 212 8 212 -27z m4354 13 c56 -51 60 -109 7 -109 -44 0
-186 99 -186 130 0 36 133 21 179 -21z m8291 -5 c56 -36 51 -166 -7 -166 -40
0 -52 19 -58 93 -8 95 6 110 65 73z m3403 -52 c26 -26 74 -52 106 -56 38 -6
61 -28 66 -65 11 -73 -33 -71 -135 7 -45 34 -98 62 -118 62 -20 0 -42 22 -49
50 -18 67 64 68 130 2z m-1510 -52 c24 -28 74 -50 109 -50 60 0 61 -3 22 -42
-40 -40 -45 -40 -89 0 -26 23 -65 42 -87 42 -48 0 -77 40 -55 75 23 37 49 31
100 -25z m-10522 -69 c22 -51 48 -110 58 -130 10 -20 79 -48 153 -63 177 -34
198 -98 46 -138 -57 -16 -133 -22 -167 -13 -42 10 -71 2 -92 -27 -17 -24 -44
-35 -60 -25 -36 22 -38 106 -4 128 14 8 25 40 24 70 0 49 -3 50 -26 11 -37
-63 -138 -54 -236 20 -69 53 -93 60 -136 37 -33 -18 -67 -20 -93 -5 -36 20
-35 25 13 40 39 13 54 37 54 91 0 40 10 73 23 73 29 0 185 -81 203 -106 8 -10
52 -26 97 -35 l84 -17 -17 92 c-23 121 24 120 76 -3z m1438 -10 c36 -39 78
-71 94 -71 15 0 27 -18 27 -39 0 -24 17 -36 42 -32 62 13 71 71 10 71 -39 0
-52 16 -52 63 0 92 68 77 118 -25 22 -49 52 -88 65 -88 13 0 38 -19 55 -43 26
-34 39 -37 69 -12 28 24 55 24 109 4 39 -16 128 -27 197 -25 180 3 190 3 297
-15 75 -12 102 -6 120 25 39 71 95 49 95 -37 0 -73 -4 -77 -81 -66 -46 7 -117
-5 -162 -26 -69 -33 -91 -34 -143 -6 -45 24 -129 30 -308 20 -261 -15 -482 21
-502 82 -14 43 -153 181 -237 236 -37 24 -61 53 -53 65 24 40 173 -10 240 -81z
m11351 42 c20 -46 48 -63 100 -63 79 0 120 -60 72 -108 -43 -43 -256 -29 -283
19 -12 22 -67 63 -123 91 -114 58 -111 73 22 99 159 31 182 26 212 -38z m1734
-27 c-17 -70 42 -112 150 -104 54 4 74 -7 81 -44 6 -28 32 -71 58 -95 26 -25
47 -56 47 -69 0 -49 48 -22 80 44 38 79 120 109 120 44 0 -48 -171 -237 -215
-237 -16 0 -64 39 -107 88 -45 51 -100 87 -133 87 -32 0 -93 22 -137 49 l-80
48 -92 -62 c-87 -59 -94 -60 -154 -21 -56 37 -61 53 -48 150 9 66 4 115 -12
125 -18 11 -18 25 -1 42 35 35 84 -2 67 -53 -26 -84 39 -126 170 -110 67 8
125 26 130 42 4 15 15 59 23 97 9 40 27 63 42 54 14 -9 19 -43 11 -75z
m-18527 40 c17 -28 -106 -66 -131 -40 -19 19 41 63 86 64 17 0 37 -11 45 -24z
m3121 -76 c27 -73 32 -75 148 -59 133 17 170 -26 45 -53 -101 -23 -122 -100
-47 -179 40 -43 77 -59 117 -51 47 9 64 -3 83 -59 22 -64 33 -69 114 -56 64
11 85 7 72 -14 -10 -16 -39 -29 -65 -29 -26 0 -54 -11 -62 -25 -9 -14 -43 -25
-77 -25 -44 0 -61 -14 -61 -50 0 -60 -41 -63 -146 -11 -61 31 -79 56 -79 111
0 54 -17 81 -69 105 -73 35 -108 153 -60 201 17 17 12 52 -14 107 -21 46 -32
100 -24 122 25 65 94 46 125 -35z m1785 23 c12 -44 27 -50 98 -36 49 9 84 5
84 -9 0 -32 -123 -128 -165 -128 -18 0 -42 -16 -53 -36 -12 -23 -81 -42 -182
-53 -161 -16 -163 -15 -206 59 -45 78 -60 205 -23 205 29 0 244 -110 290 -149
40 -33 114 -19 114 22 0 13 -22 31 -50 40 -48 15 -68 86 -33 120 36 37 113 15
126 -35z m5546 -51 c30 -57 48 -70 68 -50 45 45 118 33 194 -32 l71 -59 -55
-49 c-77 -70 -131 -84 -244 -66 -87 14 -100 25 -123 110 -17 62 -17 116 -1
159 32 83 41 82 90 -13z m-9614 -9 c0 -33 -92 -79 -114 -58 -5 6 8 35 29 66
40 57 85 52 85 -8z m9036 -1 c46 -35 108 -60 142 -56 39 4 57 -5 52 -27 -10
-48 43 -104 98 -104 58 0 65 -104 10 -150 -77 -64 -413 218 -413 348 0 66 11
65 111 -11z m5724 48 c59 -23 49 -102 -15 -119 -73 -19 -170 6 -170 44 0 72
94 110 185 75z m1828 -36 c26 -28 101 -81 167 -117 66 -36 120 -74 120 -84 0
-11 22 -27 49 -35 53 -17 276 -233 276 -267 0 -12 -79 -21 -176 -21 l-176 0
-61 131 c-34 72 -62 145 -62 161 0 30 -255 158 -316 158 -60 0 -36 64 35 93
96 37 93 38 144 -19z m-14993 -183 c-8 -58 -101 -82 -211 -55 -66 17 -73 59
-30 178 l29 79 110 -74 c81 -55 108 -88 102 -128z m3483 158 c-52 -44 -128
-66 -128 -39 0 56 41 90 109 89 l79 -1 -60 -49z m5497 -142 c0 -30 36 -69 174
-188 26 -22 150 -33 413 -35 324 -3 377 -9 384 -44 10 -49 29 -48 -471 -42
-453 6 -444 3 -637 182 -117 108 -150 223 -85 288 34 34 222 -103 222 -161z
m3725 133 c0 -39 -67 -73 -102 -51 -37 23 -27 56 21 69 75 19 81 18 81 -18z
m-12369 -108 c-4 -57 4 -110 16 -118 13 -8 17 -36 10 -64 -9 -36 5 -56 55 -75
112 -43 73 -114 -61 -107 -135 6 -174 39 -131 109 18 27 25 61 16 75 -8 14 -2
41 14 61 23 27 23 56 3 114 -31 90 -17 130 43 117 32 -6 40 -32 35 -112z
m4367 21 c59 -114 50 -128 -76 -128 -109 0 -142 35 -91 95 20 24 43 62 52 86
24 69 62 52 115 -53z m-6508 -8 c40 -31 78 -62 85 -70 7 -7 43 -27 81 -44 41
-18 69 -49 69 -79 0 -26 28 -82 63 -123 42 -50 54 -81 35 -93 -15 -9 -23 -44
-16 -76 16 -85 -32 -114 -147 -91 -125 26 -158 143 -49 170 66 17 89 61 31 61
-45 0 -146 110 -137 150 4 18 -35 43 -92 60 -99 29 -132 78 -103 154 20 52 98
44 180 -19z m-1015 -7 c0 -20 29 -44 64 -53 44 -11 56 -25 39 -42 -17 -17 -54
-11 -114 17 -88 42 -105 66 -72 98 30 31 83 18 83 -20z m17550 14 c0 -12 34
-34 75 -48 95 -33 97 -79 5 -79 -92 0 -168 56 -147 109 16 43 67 57 67 18z
m-3825 -39 c64 -34 76 -33 112 2 36 36 45 36 104 -3 52 -34 76 -37 119 -13 30
16 93 28 141 26 48 -1 349 -6 670 -10 568 -9 672 -23 596 -86 -24 -20 -72 -23
-157 -8 -155 27 -598 12 -662 -22 -34 -18 -64 -17 -102 3 -33 18 -111 24 -197
16 -78 -7 -191 -3 -252 8 -63 11 -197 9 -317 -6 -159 -21 -223 -20 -275 4
l-67 31 87 46 c108 58 111 58 200 12z m-12231 -44 c-16 -48 -94 -54 -94 -8 0
23 21 39 52 39 31 0 48 -13 42 -31z m1827 -30 c5 -24 -4 -57 -19 -72 -40 -40
-86 16 -65 82 20 62 71 56 84 -10z m2415 38 c8 -13 3 -31 -12 -40 -37 -23
-106 7 -87 38 20 31 80 33 99 2z m10146 -33 c37 -17 68 -40 68 -50 0 -28 -71
-23 -133 10 -30 16 -88 38 -129 48 -72 17 -70 18 26 20 55 2 131 -11 168 -28z
m3868 -46 c0 -96 -59 -87 -70 10 -6 48 3 67 31 67 27 0 39 -24 39 -77z m2029
-10 c6 -34 32 -53 77 -58 82 -10 101 -105 22 -105 -53 0 -203 121 -203 163 0
92 88 91 104 0z m-11986 -82 c17 -5 44 19 61 55 41 91 104 80 203 -36 47 -55
102 -100 123 -100 20 0 73 -37 116 -81 44 -45 102 -101 129 -125 75 -66 64
-119 -24 -119 -48 0 -83 17 -101 50 -36 67 -200 175 -266 175 -31 0 -77 30
-105 69 -40 53 -57 62 -81 38 -38 -37 -123 2 -123 56 0 21 -11 37 -25 37 -35
0 -31 59 6 96 25 26 34 18 44 -36 7 -38 26 -73 43 -79z m-9935 48 c-6 -25 6
-60 28 -78 21 -17 39 -47 39 -66 0 -18 31 -61 68 -96 51 -47 61 -70 40 -91
-37 -37 -83 -8 -83 53 0 35 -17 49 -59 49 -52 0 -61 14 -74 129 -9 70 -9 138
-2 150 23 37 56 -1 43 -50z m1959 -43 c17 -54 42 -145 57 -203 32 -125 83
-139 439 -118 476 28 700 13 680 -47 -7 -22 -105 -32 -333 -35 -177 -2 -457
-7 -622 -12 l-300 -8 -7 87 c-3 48 -13 153 -21 232 -24 234 47 302 107 104z
m742 78 c7 -21 51 -47 96 -58 121 -32 126 -106 7 -106 -94 0 -237 102 -237
169 0 43 117 39 134 -5z m8741 -14 c0 -14 12 -25 27 -25 37 0 173 -98 173
-124 0 -12 -50 -46 -112 -76 -61 -29 -137 -81 -168 -114 -64 -67 -157 -80
-179 -24 -9 23 13 53 60 80 90 53 93 73 12 93 -91 23 -84 106 10 127 40 9 79
32 87 52 15 41 90 50 90 11z m-6785 -61 c12 -31 235 -37 1506 -41 1750 -6
1720 -5 1742 -28 40 -40 -13 -101 -70 -82 -59 20 -927 39 -1568 34 -213 -1
-628 -1 -921 2 -480 4 -539 0 -583 -40 -37 -34 -59 -38 -91 -18 -54 33 -113
151 -92 184 22 36 61 31 77 -11z m14421 14 c23 -38 -64 -56 -184 -36 -110 17
-111 18 -39 35 111 26 207 26 223 1z m-18512 -94 c30 -52 44 -101 32 -113 -38
-38 -180 29 -196 93 -35 138 85 153 164 20z m14419 42 c671 1 1355 3 1520 4
341 2 496 -18 539 -70 47 -57 35 -58 -453 -37 -254 10 -940 18 -1524 16 -1224
-5 -1862 12 -1862 49 0 22 496 61 542 43 10 -4 567 -7 1238 -5z m-3954 -28 c9
-15 5 -39 -8 -52 -29 -29 -131 14 -131 55 0 33 118 30 139 -3z m6374 -23 c0
-28 -36 -39 -144 -45 -79 -4 -144 -2 -144 4 0 7 7 30 16 53 21 56 272 45 272
-12z m-6593 -38 c-4 -35 -19 -64 -32 -64 -14 0 -29 29 -33 64 -6 45 3 63 33
63 29 0 38 -18 32 -63z m-9783 4 c53 -39 38 -109 -30 -133 -25 -9 -64 -33 -88
-53 -49 -42 -57 -14 -21 75 13 32 29 77 37 101 16 53 40 55 102 10z m18928
-185 c16 -79 24 -201 16 -271 -15 -159 27 -198 79 -74 21 49 55 89 76 89 48 0
48 -2 2 -91 -48 -91 -48 -125 0 -143 49 -19 48 -66 -3 -66 -186 0 -385 500
-294 737 28 73 92 -21 124 -181z m-2149 157 c19 -50 94 -48 136 2 30 36 36 35
65 -5 55 -74 41 -135 -29 -135 -36 0 -76 -22 -94 -50 -39 -63 -94 -65 -94 -3
0 26 -17 61 -37 78 -50 41 -50 150 0 150 21 0 45 -17 53 -37z m1847 12 c8 -14
8 -49 -1 -77 l-17 -52 -49 52 c-51 55 -43 102 17 102 19 0 41 -11 50 -25z
m-8518 -78 c8 -46 -67 -85 -100 -52 -33 33 6 108 52 100 22 -5 43 -26 48 -48z
m9270 -62 c-12 -32 -24 -36 -44 -16 -15 15 -20 47 -11 71 12 32 24 36 44 16
15 -15 20 -47 11 -71z m-15976 -12 c9 -15 42 -21 72 -13 31 8 77 -1 102 -20
35 -25 66 -27 123 -9 42 14 257 30 477 36 516 13 311 12 2025 11 825 -1 1533
-1 1575 1 41 1 367 -6 723 -15 614 -17 760 -35 726 -90 -10 -15 -1174 -24
-3107 -23 l-3091 1 -40 -53 c-47 -63 -157 -59 -169 6 -11 57 98 109 270 130
76 10 155 28 175 41 50 31 118 30 139 -3z m7872 0 c199 4 309 -36 254 -92 -25
-24 -500 -40 -583 -19 l-69 17 70 61 c39 33 82 54 97 45 14 -9 118 -14 231
-12z m727 -3 c403 5 708 -1 961 -19 157 -12 309 -14 337 -4 61 20 2212 11
2585 -10 160 -10 288 -5 336 12 136 47 431 -16 343 -74 -68 -44 -4937 -21
-4937 24 0 53 113 105 187 86 34 -9 119 -16 188 -15z m-2051 -21 c-28 -45 12
-150 79 -213 85 -78 63 -136 -52 -136 -61 0 -95 15 -113 48 -55 104 -13 327
62 327 22 0 33 -12 24 -26z m8388 -3 c103 3 204 11 225 17 55 16 110 -27 92
-73 -18 -46 -1150 -62 -1178 -17 -40 65 150 100 436 82 131 -9 322 -13 425 -9z
m-19250 -28 c0 -62 -53 -93 -108 -64 -50 27 -50 29 -4 62 59 43 112 44 112 2z
m11748 -3 c37 -44 -13 -65 -156 -65 -117 1 -182 31 -156 72 25 41 277 35 312
-7z m10146 -34 c6 -19 -14 -31 -54 -31 -42 0 -65 14 -65 39 0 47 103 40 119
-8z m-21486 -72 c17 -100 -15 -184 -70 -184 -20 0 -46 -20 -60 -44 -34 -60
-48 -37 -55 94 -13 209 154 329 185 134z m1053 -119 c-9 -34 -37 -81 -64 -105
-46 -42 -50 -41 -103 15 -43 47 -47 62 -18 71 19 7 63 44 98 83 70 80 115 48
87 -64z m384 12 c8 -71 2 -80 -47 -73 -87 13 -122 91 -62 135 69 51 100 33
109 -62z m9391 42 c21 -30 59 -56 83 -58 24 -1 80 -4 125 -7 99 -5 108 -48 12
-59 -49 -5 -71 -23 -76 -64 -5 -31 -18 -56 -30 -56 -12 0 -25 25 -30 56 -6 44
-24 57 -83 57 -128 2 -182 82 -107 157 42 42 62 38 106 -26z m-695 -34 c36
-55 37 -68 7 -87 -75 -47 -198 -2 -198 74 0 101 128 110 191 13z m-3271 -35
c49 0 58 -7 36 -29 -29 -29 -156 -35 -537 -26 -291 7 -234 47 72 51 147 2 273
9 280 17 8 7 29 8 48 0 20 -7 65 -13 101 -13z m11068 0 c8 -14 71 -25 140 -25
211 0 362 -106 269 -190 -52 -47 -53 -47 -91 9 -32 48 -59 56 -192 56 -85 0
-167 13 -183 29 -23 23 -40 21 -74 -10 -54 -49 -232 -86 -232 -49 0 59 33 105
75 105 24 0 57 16 74 36 26 32 76 50 168 61 17 1 37 -8 46 -22z m-15987 -38
c26 -32 21 -49 -27 -100 -76 -81 -117 -78 -169 13 -23 41 -52 75 -63 75 -11 0
-13 11 -4 25 24 40 227 30 263 -13z m260 16 c7 -12 -11 -29 -41 -36 l-54 -15
61 -50 61 -50 -79 -1 c-60 -1 -82 12 -93 55 -22 81 103 164 145 97z m2314 -3
c0 -14 -67 -25 -150 -25 -83 0 -150 11 -150 25 0 14 67 25 150 25 83 0 150
-11 150 -25z m793 4 c42 -12 50 -26 32 -54 -18 -29 -29 -31 -54 -6 -19 19 -99
31 -201 31 -97 0 -170 11 -170 25 0 27 302 30 393 4z m2157 -3 c0 -12 -12 -30
-26 -39 -37 -23 -105 7 -87 38 20 32 113 33 113 1z m302 -2 c83 -45 54 -75
-58 -60 -201 27 -232 37 -193 62 49 31 191 30 251 -2z m4102 -49 c76 -76 87
-162 21 -162 -21 0 -41 25 -46 57 l-8 58 -83 -63 -83 -63 -10 71 c-26 179 80
231 209 102z m2115 39 c34 -34 -39 -64 -155 -64 -125 0 -197 -35 -187 -91 9
-48 -4 -84 -29 -84 -15 0 -23 27 -19 59 4 32 -7 77 -26 100 -30 36 -27 41 25
42 33 0 82 18 110 39 45 35 246 35 281 -1z m-13219 -54 c0 -28 -23 -36 -92
-30 -118 10 -139 64 -28 75 100 11 120 3 120 -45z m4027 39 c119 -64 21 -169
-128 -136 -88 19 -95 69 -18 123 65 46 81 47 146 13z m848 6 c0 -42 -63 -80
-130 -80 -38 0 -70 5 -70 10 0 6 -7 29 -15 50 -13 33 5 40 100 40 63 0 115 -9
115 -20z m3084 -19 c-17 -44 -87 -39 -103 8 -6 19 14 31 54 31 47 0 60 -10 49
-39z m-5109 -73 c-46 -48 -79 -91 -73 -95 6 -5 41 -27 79 -51 84 -52 89 -106
13 -126 -123 -33 -139 -22 -157 111 -14 105 -28 130 -81 151 -110 41 -14 89
193 94 l111 3 -85 -87z m3675 62 c0 -14 -45 -25 -100 -25 -55 0 -100 11 -100
25 0 14 45 25 100 25 55 0 100 -11 100 -25z m1868 -10 c36 -36 -89 -88 -210
-89 -135 -1 -173 23 -147 91 15 40 317 38 357 -2z m282 -2 c0 -27 -26 -38 -86
-38 -113 0 -138 44 -33 57 45 5 90 12 100 14 11 2 19 -13 19 -33z m7171 -16
c44 -71 5 -107 -94 -85 -52 11 -77 32 -77 63 0 84 122 100 171 22z m2514 -11
c25 -66 -11 -161 -61 -161 -63 0 -81 38 -36 75 20 17 37 52 37 78 0 57 39 62
60 8z m628 -13 c0 -19 -20 -39 -44 -43 -43 -9 -61 45 -27 79 26 26 71 4 71
-36z m-10067 -32 c8 -43 3 -43 -208 -16 -14 1 14 18 62 36 106 40 135 36 146
-20z m4548 9 c8 -46 -143 -136 -174 -105 -30 30 81 157 130 148 20 -3 40 -23
44 -43z m-11444 1 c0 -37 -37 -50 -98 -34 -42 11 -48 20 -23 36 45 29 121 28
121 -2z m3235 9 c22 -9 40 -32 40 -52 0 -51 -85 -30 -95 24 -9 47 -3 50 55 28z
m496 -22 c-9 -37 -88 -31 -100 8 -8 23 7 31 47 25 33 -5 57 -20 53 -33z m929
-3 c17 -44 -1 -85 -36 -85 -13 0 -24 28 -24 63 0 69 36 83 60 22z m3002 -84
c41 -296 -68 -298 -138 -2 -25 104 -14 126 63 126 51 0 60 -15 75 -124z m9647
69 c15 -23 21 -48 14 -56 -17 -17 -196 68 -197 94 -2 38 156 5 183 -38z
m-19734 -7 c17 -21 47 -38 66 -38 56 0 39 -48 -22 -61 -228 -47 -336 -3 -222
89 70 57 136 60 178 10z m17063 -16 c23 -70 -16 -103 -97 -83 -81 20 -83 46
-10 97 72 51 87 49 107 -14z m-10703 -131 c-108 -136 -153 -74 -58 81 47 77
55 81 90 46 35 -34 32 -47 -32 -127z m-7081 43 c67 -61 60 -113 -14 -95 -37 9
-85 -1 -124 -26 -84 -56 -203 -42 -203 23 0 34 25 55 87 71 48 12 98 32 111
45 36 35 92 28 143 -18z m20257 -32 c50 -55 33 -102 -35 -102 -78 0 -126 28
-126 74 0 89 91 105 161 28z m-13570 -15 c17 -45 -32 -112 -82 -112 -37 0 -87
98 -67 131 20 34 134 20 149 -19z m3760 -1 c39 -47 4 -173 -49 -173 -47 0 -75
88 -50 156 25 66 54 71 99 17z m-7678 -155 c2 -66 -39 -72 -103 -14 -44 40
-44 43 10 101 62 65 89 40 93 -87z m9301 96 c18 -35 18 -54 -1 -66 -36 -22
-109 51 -87 87 25 41 59 33 88 -21z m9113 -59 c30 -87 28 -97 -20 -131 -77
-54 -108 5 -96 184 6 89 79 57 116 -53z m-12188 34 c40 -75 31 -102 -33 -102
-91 0 -140 71 -79 115 63 46 81 44 112 -13z m10626 -39 c0 -57 -5 -60 -62 -33
-69 31 -80 59 -32 78 67 27 94 15 94 -45z m-8700 -57 c-1 -52 -55 -206 -74
-206 -60 0 -67 163 -7 198 52 31 81 34 81 8z m9935 -27 c19 -30 -57 -129 -99
-129 -23 0 -36 26 -36 75 0 63 10 75 61 75 34 0 67 -9 74 -21z m-15136 -77
c37 -69 33 -77 -35 -77 -69 0 -100 35 -79 89 19 51 84 45 114 -12z m6885 -58
c36 -56 -26 -132 -75 -91 -57 47 -37 160 25 140 14 -5 36 -27 50 -49z m-7159
-92 c0 -49 -78 -88 -102 -50 -26 42 -29 83 -7 105 19 20 109 -26 109 -55z
m214 -38 c33 -8 61 -29 61 -46 -1 -36 -44 -109 -55 -92 -49 75 -94 176 -92
203 2 20 7 17 14 -8 6 -23 38 -48 72 -57z m-5572 14 c7 -26 48 -57 91 -70 99
-28 105 -93 9 -104 -54 -6 -74 4 -84 44 -8 29 -32 52 -55 52 -78 1 -116 42
-80 86 45 53 104 49 119 -8z m12313 -66 c21 -46 21 -71 1 -91 -42 -42 -106 -5
-106 62 0 108 61 125 105 29z m3249 -37 c13 0 21 -31 16 -69 -10 -94 -87 -105
-120 -18 -29 77 -11 122 42 101 20 -8 48 -14 62 -14z m-9575 -128 c-6 -100 0
-116 57 -142 89 -40 80 -80 -17 -80 -96 -1 -194 -24 -194 -47 0 -19 425 -11
445 9 8 7 -6 28 -31 46 -24 18 -40 55 -35 81 11 61 115 80 136 25 19 -50 75
-51 94 -1 19 49 88 47 146 -5 73 -66 588 -71 609 -5 19 60 53 60 73 0 17 -56
191 -92 262 -53 26 14 70 25 96 25 27 0 61 15 76 33 20 24 144 34 488 39 l460
6 16 -64 c19 -77 90 -85 134 -14 17 28 48 50 69 50 20 0 51 -22 68 -50 27 -43
58 -50 224 -50 105 0 199 11 208 25 8 14 93 25 189 25 132 0 178 9 189 38 26
67 239 49 311 -27 54 -58 74 -63 185 -50 346 40 519 44 539 12 15 -24 91 -30
303 -23 156 4 340 9 408 10 149 3 175 53 88 170 -69 94 -45 122 39 44 35 -33
99 -71 142 -86 52 -17 84 -46 94 -86 12 -53 28 -60 138 -63 421 -11 416 -10
407 -69 -9 -65 -104 -97 -192 -65 -56 20 -1203 34 -1578 19 -89 -4 -632 -1
-1206 5 -929 11 -1048 17 -1089 54 -61 56 -96 53 -112 -8 -14 -53 -157 -73
-207 -29 -13 11 -108 10 -211 -2 -240 -30 -1858 -47 -2065 -22 -101 12 -174 9
-203 -8 -75 -44 -1760 -23 -1849 24 -94 49 -140 47 -251 -13 -158 -85 -425
-61 -394 35 9 29 22 83 29 120 20 104 133 124 133 23 0 -36 21 -45 113 -45 91
0 112 9 112 45 0 61 38 79 75 34 17 -20 68 -37 114 -37 46 0 90 -11 99 -25 25
-42 351 -31 387 13 42 50 84 47 138 -13 53 -59 192 -67 235 -15 23 28 16 48
-36 96 -57 53 -60 64 -27 92 42 35 90 17 90 -34 0 -47 167 -189 223 -189 26 0
55 25 65 56 18 54 19 54 30 -12 10 -65 18 -69 134 -69 88 0 129 11 139 38 20
52 59 46 59 -9 0 -62 177 -118 250 -79 42 22 46 36 24 78 -21 39 -18 65 13
112 49 75 88 57 88 -40 0 -91 14 -99 138 -78 83 14 98 26 92 70 -5 37 20 75
81 121 49 37 89 90 89 117 0 27 13 45 30 39 20 -6 28 -51 24 -122z m12162 14
c37 -57 37 -68 4 -101 -36 -37 -52 -39 -215 -28 -173 12 -151 159 26 175 59 5
115 11 125 14 10 2 37 -25 60 -60z m1588 -124 c-34 -125 -104 -112 -104 20 0
133 20 159 79 100 34 -34 40 -62 25 -120z m-14579 101 c25 -30 23 -40 -10 -53
-46 -18 -122 34 -101 68 21 34 76 26 111 -15z m4413 -39 c-57 -11 -111 -9
-124 3 -15 14 25 22 100 20 l124 -3 -100 -20z m3807 -108 c48 -82 52 -84 171
-65 71 11 141 8 168 -6 36 -19 64 -12 116 26 113 83 500 37 500 -60 0 -91 112
-29 120 68 7 84 14 92 100 103 58 7 107 -2 132 -23 45 -39 298 -47 298 -9 0
14 80 25 189 25 120 0 183 -9 174 -25 -9 -14 -77 -25 -152 -25 -107 0 -136 -8
-136 -39 0 -32 25 -38 125 -33 125 7 209 -32 161 -74 -13 -11 -153 -12 -311
-2 -239 15 -299 11 -354 -21 -58 -34 -111 -36 -412 -12 -579 46 -1010 51
-1105 12 -46 -19 -106 -25 -137 -15 -30 10 -143 15 -250 12 -180 -6 -197 -2
-209 46 -8 28 -41 58 -75 67 -121 30 -23 45 316 48 288 2 353 9 388 44 64 65
128 50 183 -42z m3018 -17 c9 -15 10 -54 1 -88 -14 -57 -25 -61 -188 -61 -95
0 -200 -11 -234 -23 -103 -39 -174 -7 -154 70 22 91 25 92 147 59 134 -36 365
-14 365 35 0 40 40 45 63 8z m-827 -53 c122 -56 49 -164 -86 -128 -55 14 -56
19 -34 101 17 64 32 67 120 27z m-12676 -61 c59 -23 22 -60 -60 -60 -72 0
-113 29 -83 59 21 20 92 21 143 1z" fill="url(#metalSkull)" stroke="none" />
  </g>
</g>
</svg>`;

const FLIP_DURATION_MS = 7200;

let overlayEl = null;
let cardEl = null;
let readyFlag = false;
let watcherInterval = null;

function buildOverlay() {
  const overlay = document.createElement('div');
  overlay.dataset.role = 'loading-screen';
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: 100000;
    display: grid;
    place-items: center;
    background:
      radial-gradient(ellipse at center, rgba(225,230,240,.09) 0%, rgba(200,210,225,.045) 20%, rgba(255,255,255,.012) 38%, transparent 62%),
      radial-gradient(ellipse at center, rgba(255,255,255,.03) 0%, rgba(255,255,255,.012) 22%, transparent 58%),
      #000;
    opacity: 1;
    transition: opacity 0.6s ease;
  `;

  const style = document.createElement('style');
  style.textContent = `
    [data-role="loading-screen"] .ls-scene {
      width: 100vw;
      height: 100vh;
      display: grid;
      place-items: center;
      perspective: 1800px;
      perspective-origin: 50% 48%;
    }
    [data-role="loading-screen"] .ls-card {
      --w: min(42vw, 46vh, 420px);
      --h: calc(var(--w) * 1.5);
      width: var(--w);
      height: var(--h);
      position: relative;
      transform-style: preserve-3d;
      will-change: transform;
      animation: lsDreadfulFlip 7200ms cubic-bezier(.42,0,.58,1) infinite;
    }
    [data-role="loading-screen"] .ls-face {
      position: absolute;
      inset: 0;
      overflow: hidden;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      transform-style: preserve-3d;
      background: transparent;
    }
    [data-role="loading-screen"] .ls-front { transform: rotateY(0deg); }
    [data-role="loading-screen"] .ls-back { transform: rotateY(180deg); }
    [data-role="loading-screen"] .ls-face svg {
      width: 100%;
      height: 100%;
      display: block;
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      background: transparent;
    }
    @keyframes lsDreadfulFlip {
      0%   { transform: translate3d(0,0,0) rotateX(8deg) rotateY(0deg) rotateZ(-1.2deg); }
      25%  { transform: translate3d(0,-6px,20px) rotateX(10deg) rotateY(90deg) rotateZ(0deg); }
      50%  { transform: translate3d(0,0,0) rotateX(8deg) rotateY(180deg) rotateZ(1.2deg); }
      75%  { transform: translate3d(0,-6px,20px) rotateX(10deg) rotateY(270deg) rotateZ(0deg); }
      100% { transform: translate3d(0,0,0) rotateX(8deg) rotateY(360deg) rotateZ(-1.2deg); }
    }
    @media (prefers-reduced-motion: reduce) {
      [data-role="loading-screen"] .ls-card {
        animation: none;
        transform: rotateX(8deg) rotateY(180deg) rotateZ(1.2deg);
      }
    }
  `;
  document.head.appendChild(style);

  const scene = document.createElement('main');
  scene.className = 'ls-scene';
  scene.setAttribute('aria-label', 'Loading');

  const card = document.createElement('div');
  card.className = 'ls-card';

  const front = document.createElement('div');
  front.className = 'ls-face ls-front';
  front.setAttribute('aria-label', '9 card face');
  front.innerHTML = FRONT_SVG;

  const back = document.createElement('div');
  back.className = 'ls-face ls-back';
  back.setAttribute('aria-label', 'skull card face');
  back.innerHTML = BACK_SVG;

  card.append(front, back);
  scene.appendChild(card);
  overlay.appendChild(scene);

  cardEl = card;
  return overlay;
}

export function showLoadingScreen() {
  if (overlayEl) return;
  readyFlag = false;

  // Lock scroll entirely while the loading screen is up - the site's
  // known jump-bug class (address-bar collapse/reflow interacting badly
  // with fixed/full-viewport elements, see Rule 87) is most reliably
  // avoided by preventing scroll outright during this window, rather
  // than trying to time/patch around the repaint.
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  overlayEl = buildOverlay();
  document.body.appendChild(overlayEl);

  watcherInterval = setInterval(() => {
    if (readyFlag) {
      finishAndHide();
    }
  }, 100);
}

function finishAndHide() {
  if (watcherInterval) {
    clearInterval(watcherInterval);
    watcherInterval = null;
  }
  if (!overlayEl) return;

  const elapsed = performance.now() % FLIP_DURATION_MS;
  const remaining = FLIP_DURATION_MS - elapsed;

  setTimeout(() => {
    if (!overlayEl) return;
    overlayEl.style.opacity = '0';
    setTimeout(() => {
      if (overlayEl && overlayEl.parentElement) {
        overlayEl.parentElement.removeChild(overlayEl);
      }
      overlayEl = null;
      cardEl = null;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }, 650);
  }, Math.min(remaining, FLIP_DURATION_MS));
}

export function resolveLoad() {
  readyFlag = true;
}
